
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6SZAm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $094447ae995aeca0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $jD5no = parcelRequire("jD5no");

var $i8pyY = parcelRequire("i8pyY");

var $hmRfM = parcelRequire("hmRfM");

var $4Pf62 = parcelRequire("4Pf62");

var $9dbF6 = parcelRequire("9dbF6");

var $38Y30 = parcelRequire("38Y30");

var $90yGq = parcelRequire("90yGq");

var $hqBSi = parcelRequire("hqBSi");

var $l8ruj = parcelRequire("l8ruj");

var $7tQej = parcelRequire("7tQej");
const $094447ae995aeca0$var$JiraSoftwareFormSubmitApp = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    const hasSoftwareLicense = licensedProducts?.[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE];
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/projects"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-software-form-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "jira-software-form-submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8pyY.FormSubmissionContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hmRfM.FormSubmissionRoot), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    })));
};
var $094447ae995aeca0$export$2e2bcd8739ae039 = $094447ae995aeca0$var$JiraSoftwareFormSubmitApp;

});
parcelRegister("i8pyY", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionContextProvider", () => $c118b8c67dae9e54$export$762da44d062c3e8b);

var $5uXOq = parcelRequire("5uXOq");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $cm8b5 = parcelRequire("cm8b5");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $aVFIE = parcelRequire("aVFIE");

var $l2N2a = parcelRequire("l2N2a");

var $iEEXl = parcelRequire("iEEXl");

var $7wwVP = parcelRequire("7wwVP");

var $6czoq = parcelRequire("6czoq");

var $lvFc8 = parcelRequire("lvFc8");

var $g2iZ7 = parcelRequire("g2iZ7");

var $kyf8b = parcelRequire("kyf8b");

var $0557y = parcelRequire("0557y");

var $lJBp3 = parcelRequire("lJBp3");
const $c118b8c67dae9e54$var$FormAccessWrapper = ({ children: children })=>{
    const [initialLoading, setInitialLoading] = (0, $5uXOq.useState)(true);
    const { data: project, loading: projectLoading } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const [{ data: data, loading: loading, error: error }] = (0, $kyf8b.useFormSubmissionStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setInitialLoading(false);
    }, [
        loading
    ]);
    const isOpenForm = data?.accessLevel === (0, $7wwVP.FormAccessLevelTypes).OPEN;
    const projectId = String(data?.projectId);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            projectId: projectId,
            isOpenForm: isOpenForm,
            projectType: (0, $2vSU6.CORE_PROJECT)
        }), [
        projectId,
        isOpenForm
    ]);
    const experienceTrackerAttributes = {
        ...(0, $lvFc8.useConditionalFieldLogicAnalyticsAttrs)(),
        ...(0, $lJBp3.usePublicFormsEnabledAnalyticsAttrs)()
    };
    if (initialLoading || projectLoading || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVFIE.ThemedLazySkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !((0, $0557y.isFormNotFoundError)(error) || (0, $0557y.isProjectNotFoundError)(error)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        error: error,
        attributes: experienceTrackerAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormUnavailableView), null));
    if ((!project || !project.permissions.viewIssues || !project.permissions.createIssues) && isOpenForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: projectId,
        containerType: "project",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessFormSubmissionContext",
        attributes: analyticsAttributes
    }, children);
    return children;
};
const $c118b8c67dae9e54$export$762da44d062c3e8b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2iZ7.FormSubmissionPreloader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c118b8c67dae9e54$var$FormAccessWrapper, null, children)));

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("iEEXl", function(module, exports) {

$parcel$export(module.exports, "URL_PARAMS", () => $8497b4ce450fc8b0$export$bcc0c92e1564488c);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8497b4ce450fc8b0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "VIEW_FORM_DIRECTORY_EXPERIENCE", () => $8497b4ce450fc8b0$export$3a0a03305bcf855e);
$parcel$export(module.exports, "DELETE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$7da90561e94f981);
$parcel$export(module.exports, "VIEW_FORM_SUBMISSION_EXPERIENCE", () => $8497b4ce450fc8b0$export$cdf9f6e9e7d621b6);
$parcel$export(module.exports, "VIEW_FORM_PUBLIC_SUBMISSION_EXPERIENCE", () => $8497b4ce450fc8b0$export$b56f5e223cd82f7f);
$parcel$export(module.exports, "SUBMIT_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$537c9533c0b9bc1);
$parcel$export(module.exports, "SUBMIT_PUBLIC_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$fc107aaa900bce6a);
$parcel$export(module.exports, "VIEW_FORM_CREATE_EXPERIENCE", () => $8497b4ce450fc8b0$export$ca4e778581db201e);
$parcel$export(module.exports, "CREATE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$a18ce17ea7fe6b60);
$parcel$export(module.exports, "VIEW_FORM_UPDATE_EXPERIENCE", () => $8497b4ce450fc8b0$export$3a8f4f9a630a8c30);
$parcel$export(module.exports, "UPDATE_FORM_EXPERIENCE", () => $8497b4ce450fc8b0$export$b60e0f4f7fb57d79);
$parcel$export(module.exports, "FORM_VALIDATION_ERROR", () => $8497b4ce450fc8b0$export$85998b62672f570a);
$parcel$export(module.exports, "BUSINESS_PREFIX", () => $8497b4ce450fc8b0$export$b8ed4f67ef69db43);
$parcel$export(module.exports, "SOFTWARE_TMP_PREFIX", () => $8497b4ce450fc8b0$export$b1dbf4e7f8828780);
$parcel$export(module.exports, "SOFTWARE_CMP_PREFIX", () => $8497b4ce450fc8b0$export$90c8d3e12aee976a);
$parcel$export(module.exports, "BUSINESS_FEEDBACK_GROUP_ID", () => $8497b4ce450fc8b0$export$8d12d5bc867b3584);
$parcel$export(module.exports, "SOFTWARE_FEEDBACK_GROUP_ID", () => $8497b4ce450fc8b0$export$446ca3d108d6e8b0);
const $8497b4ce450fc8b0$export$61b0d4a63fb97a47 = 250;
const $8497b4ce450fc8b0$export$bcc0c92e1564488c = {
    FROM: 'from',
    DIRECTORY: 'directory'
};
const $8497b4ce450fc8b0$export$b8b9d90f9e5bd72b = 'jiraBusinessForm';
const $8497b4ce450fc8b0$export$3a0a03305bcf855e = {
    experience: 'viewFormDirectory',
    experienceId: 'viewDirectory',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$7da90561e94f981 = {
    experience: 'deleteForm',
    experienceId: 'deleteForm',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$cdf9f6e9e7d621b6 = {
    experience: 'formSubmission',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$b56f5e223cd82f7f = {
    experience: 'formPublicSubmission',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$537c9533c0b9bc1 = {
    experience: 'CreateJiraBusinessIssueForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$fc107aaa900bce6a = {
    experience: 'CreateJiraIssuePublicForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$ca4e778581db201e = {
    experience: 'formCreation',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$a18ce17ea7fe6b60 = {
    experience: 'CreateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$3a8f4f9a630a8c30 = {
    experience: 'formUpdate',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$b60e0f4f7fb57d79 = {
    experience: 'UpdateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $8497b4ce450fc8b0$export$85998b62672f570a = {
    ATTACHMENT_ERROR: 'ATTACHMENT_VALIDATION_ERROR'
};
const $8497b4ce450fc8b0$export$b8ed4f67ef69db43 = '/jira/core';
const $8497b4ce450fc8b0$export$b1dbf4e7f8828780 = '/jira/software';
const $8497b4ce450fc8b0$export$90c8d3e12aee976a = '/jira/software/c';
const $8497b4ce450fc8b0$export$8d12d5bc867b3584 = 'jbus-feedback-form';
const $8497b4ce450fc8b0$export$446ca3d108d6e8b0 = 'jirasoftware-feedback-form';

});

parcelRegister("7wwVP", function(module, exports) {

$parcel$export(module.exports, "FormAccessLevelTypes", () => $731dd5b579eaba8f$export$dbc34c94c457377);
$parcel$export(module.exports, "PUBLIC_FORM_REQUIRED_RESTRICTED_FIELD_INVALID", () => $731dd5b579eaba8f$export$c5f545ca8e7b61bf);
$parcel$export(module.exports, "DEFAULT_REPORTER_INVALID", () => $731dd5b579eaba8f$export$fc4efec0ee6f405);
const $731dd5b579eaba8f$export$dbc34c94c457377 = {
    LIMITED: 'limited',
    OPEN: 'open',
    PUBLIC: 'public'
};
const $731dd5b579eaba8f$export$c5f545ca8e7b61bf = 'PUBLIC_FORM_REQUIRED_RESTRICTED_FIELD_INVALID';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $731dd5b579eaba8f$var$ISSUE_TYPE_INVALID = 'ISSUE_TYPE_INVALID';
const $731dd5b579eaba8f$export$fc4efec0ee6f405 = 'DEFAULT_REPORTER_INVALID';

});

parcelRegister("6czoq", function(module, exports) {

$parcel$export(module.exports, "SuccessView", () => $5f0f2a833fc793a6$export$be5117c66bf44cb9);
$parcel$export(module.exports, "NoPermissionView", () => $5f0f2a833fc793a6$export$be11ccfe1ded6d81);
$parcel$export(module.exports, "FormUnavailableView", () => $5f0f2a833fc793a6$export$5759d094146e3811);
$parcel$export(module.exports, "NoProjectAccessView", () => $5f0f2a833fc793a6$export$8c53a54f2f70bf31);
$parcel$export(module.exports, "IssueTypeNotAssociatedView", () => $5f0f2a833fc793a6$export$5d16b0bd7e8f5692);
$parcel$export(module.exports, "IssueTypeDeletedView", () => $5f0f2a833fc793a6$export$8e65211163568af8);
$parcel$export(module.exports, "FormContainsUnsupportedRequiredFieldsView", () => $5f0f2a833fc793a6$export$1c25efc053ce2b31);
$parcel$export(module.exports, "FormMissingSupportedRequiredFieldsView", () => $5f0f2a833fc793a6$export$e6e19199dff5fc90);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $2rqOp = parcelRequire("2rqOp");

var $hTEpF = parcelRequire("hTEpF");

var $l1N8i = parcelRequire("l1N8i");

var $29YN9 = parcelRequire("29YN9");

var $dS3PR = parcelRequire("dS3PR");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $dA80J = parcelRequire("dA80J");

var $c8ARX = parcelRequire("c8ARX");

var $c2E1P = parcelRequire("c2E1P");

var $iVgQf = parcelRequire("iVgQf");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $cSD7y = parcelRequire("cSD7y");

var $khNIP = parcelRequire("khNIP");

var $d9kln = parcelRequire("d9kln");
const $5f0f2a833fc793a6$var$contactAdminUrl = '/jira/contact-administrator';
const $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: $5f0f2a833fc793a6$var$contactAdminUrl
    }, chunks);
const $5f0f2a833fc793a6$var$WAC_LINK = 'https://www.atlassian.com/software/jira?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management%7CO:cloudpmm-jwm%7CF:discovery%7CE:cloud%7CX:expand%7C';
const $5f0f2a833fc793a6$var$SuccessViewOld = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { shouldHidePoweredBy: shouldHidePoweredBy, onSubmitAnotherFormClick: onResetClick, analyticAttributes: analyticAttributes } = props;
    const onSubmitAnotherResponse = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitAnotherResponseForForm', {
            ...analyticAttributes
        });
        onResetClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormSuccessView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SuccessWrapper, {
        shouldHidePoweredBy: shouldHidePoweredBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$Heading, null, formatMessage((0, $khNIP.messages).successSubmissionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, formatMessage((0, $khNIP.messages).successSubmissionContentExperiment)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: onSubmitAnotherResponse
    }, formatMessage((0, $khNIP.messages).formSubmitAnotherForm))), !shouldHidePoweredBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$PromoFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $khNIP.messages).formSuccessFooterSpork, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29YN9.JiraIcon), {
                    size: "small",
                    appearance: "brand"
                }), (0, $4R6GH.fg)('replace-anchor-with-link__jira-werewolves') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: $5f0f2a833fc793a6$var$WAC_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
                    }
                }, children) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: $5f0f2a833fc793a6$var$WAC_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
                    }
                }, children))
        }
    }))));
};
const $5f0f2a833fc793a6$export$be5117c66bf44cb9 = (0, $cSD7y.componentWithFG)('jira-forms-public-access', (0, $d9kln.SuccessView), $5f0f2a833fc793a6$var$SuccessViewOld);
const $5f0f2a833fc793a6$export$be11ccfe1ded6d81 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormNoPermissionView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).noPermissionHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).noPermissionContent,
            values: {
                createPermissionName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                    as: "strong"
                }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).createPermissionNameIssueTermRefresh : (0, $khNIP.messages).createPermissionName)),
                linkToContactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
                ), {
                    onClick: (event, analyticsEvent)=>{
                        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'contactAdministrator');
                    },
                    href: "/secure/ContactAdministrators!default.jspa"
                }, formatMessage((0, $khNIP.messages).noPermissionLinkToContactAdmin))
            }
        }),
        maxImageWidth: 100,
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c2E1P.default))
    }));
};
const $5f0f2a833fc793a6$export$5759d094146e3811 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "business-form.common.ui.empty-views.form-unavailable",
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: formatMessage((0, $khNIP.messages).formUnavailableContent),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$8c53a54f2f70bf31 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableWithoutProjectAccessTitle),
        headingLevel: 1,
        description: formatMessage((0, $khNIP.messages).formUnavailableWithoutProjectAccessDescription),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$5d16b0bd7e8f5692 = ({ issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeRemovedView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentForAdminsIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentForAdmins, {
            issueTypeName: issueTypeName
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContentIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeNotAssociatedContent,
            values: {
                link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$8e65211163568af8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeDeletedView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentForAdminsIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentForAdmins) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $khNIP.messages).formUnavailableIssueTypeDeletedContentIssueTermRefresh : (0, $khNIP.messages).formUnavailableIssueTypeDeletedContent,
            values: {
                link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$1c25efc053ce2b31 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const projectKey = project?.key;
    const isTeamManaged = project?.isSimplified;
    const fieldLayoutSchemesUrlCMP = '/secure/admin/ViewFieldLayoutSchemes.jspa';
    const fieldLayoutSchemesUrlTMP = `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const fieldLayoutSchemesUrl = isTeamManaged ? fieldLayoutSchemesUrlTMP : fieldLayoutSchemesUrlCMP;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormContainsUnsupportedRequiredFieldsView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).unsupportedRequiredFieldsHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).unsupportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingUnsupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? fieldLayoutSchemesUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$export$e6e19199dff5fc90 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const adminUrl = typeof window !== 'undefined' ? `${window.location.href}/builder` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormMissingSupportedRequiredFieldsView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $khNIP.messages).supportedRequiredFieldsMissingHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $khNIP.messages).supportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingSupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? adminUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $dA80J.default)) : (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
    }));
};
const $5f0f2a833fc793a6$var$illustrationHeight = 4;
const $5f0f2a833fc793a6$var$Heading = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large",
        as: "h1"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$WrapperStyleBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _eid3idpf _fntnidpf _cfu11ule _l5lo12bs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$SuccessWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $5f0f2a833fc793a6$var$WrapperStyleBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxmgjw _otyridpf _18u0mgjw _1kt976ek _1uak19ii",
            __cmplp.shouldHidePoweredBy ? "_n3tdf6fq" : "_n3tdidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$PromoFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _1e0c1txw _4cvr1h6o _1bah1h6o _19pkxy5q _otyrpxbi _ca0q1ejb _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _19pku2gc _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("dA80J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6c79cd77fad2df$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $fNlWH = parcelRequire("fNlWH");

var $dz43x = parcelRequire("dz43x");
const $ff6c79cd77fad2df$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dz43x)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fNlWH)),
    autoDark: false
});
var $ff6c79cd77fad2df$export$2e2bcd8739ae039 = $ff6c79cd77fad2df$var$Illustration;

});
parcelRegister("fNlWH", function(module, exports) {
module.exports = new URL("empty-cannot-load-item-darkmode.2b4e73cc.svg", import.meta.url).toString();

});

parcelRegister("dz43x", function(module, exports) {
module.exports = new URL("empty-cannot-load-item.cb94d607.svg", import.meta.url).toString();

});


parcelRegister("c8ARX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fefc6da4073af21$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mstqrh7gfrgxbc8ggp3w5jrj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mstqrh7gfrgxbc8ggp3w5jrj

var $dCLgq = parcelRequire("dCLgq");

var $8e77Q = parcelRequire("8e77Q");
const $2fefc6da4073af21$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8e77Q)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8e77Q))
});
var $2fefc6da4073af21$export$2e2bcd8739ae039 = $2fefc6da4073af21$var$Illustration;
// for advanced use only
const $2fefc6da4073af21$export$a179c88182cb9d56 = [
    0,
    0,
    236,
    211
];

});
parcelRegister("8e77Q", function(module, exports) {
module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();

});


parcelRegister("c2E1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12b9bc47dd929a8$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = sc7h9stshcvmkj7nt3ccks24
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/sc7h9stshcvmkj7nt3ccks24

var $dCLgq = parcelRequire("dCLgq");

var $hxsLl = parcelRequire("hxsLl");

var $1QZiI = parcelRequire("1QZiI");
const $c12b9bc47dd929a8$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1QZiI)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hxsLl))
});
var $c12b9bc47dd929a8$export$2e2bcd8739ae039 = $c12b9bc47dd929a8$var$Illustration;
// for advanced use only
const $c12b9bc47dd929a8$export$a179c88182cb9d56 = [
    0,
    0,
    169,
    222
];

});
parcelRegister("hxsLl", function(module, exports) {
module.exports = new URL("lock-red-darkmode.35f0d66e.svg", import.meta.url).toString();

});

parcelRegister("1QZiI", function(module, exports) {
module.exports = new URL("lock-red.0ce332f2.svg", import.meta.url).toString();

});


parcelRegister("khNIP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df85728e69598bad$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df85728e69598bad$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successSubmissionHeading: {
        "id": "business-form.common.empty-views.success-submission-heading",
        "defaultMessage": "We're on it!"
    },
    successSubmissionContentExperiment: {
        "id": "business-form.common.empty-views.success-submission-content-experiment",
        "defaultMessage": "Thanks for your submission."
    },
    noPermissionHeading: {
        "id": "business-form.common.empty-views.no-permission-heading",
        "defaultMessage": "You don't have access to this form"
    },
    noPermissionContent: {
        "id": "business-form.common.empty-views.no-permission-content",
        "defaultMessage": "You do not have permission to submit forms to this project. Please request for the {createPermissionName} permission by {linkToContactAdmin}"
    },
    noPermissionLinkToContactAdmin: {
        "id": "business-form.common.empty-views.no-permission-link-to-contact-admin",
        "defaultMessage": " contacting this project's administrator."
    },
    createPermissionName: {
        "id": "business-form.common.empty-views.create-permission-name",
        "defaultMessage": "\u201CCreate Issue\u201D"
    },
    formUnavailableHeading: {
        "id": "business-form.common.empty-views.form-unavailable-heading",
        "defaultMessage": "Form is unavailable"
    },
    formUnavailableContent: {
        "id": "business-form.common.empty-views.form-unavailable-content",
        "defaultMessage": "This form is no longer active. Try contacting the owner of the form if you think this is a mistake."
    },
    formUnavailableIssueTypeDeletedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content",
        "defaultMessage": "The issue type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one.  "
    },
    formUnavailableIssueTypeDeletedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins",
        "defaultMessage": "The issue type associated with this form was removed from your business project. Delete this form and create a new one with the issue types that are available."
    },
    formUnavailableIssueTypeNotAssociatedContentOld: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old",
        "defaultMessage": "The issue type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content",
        "defaultMessage": "The issue type being used for this form is not valid. <link>Contact your admin</link> to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins",
        "defaultMessage": "The issue type {issueTypeName} being used for this form is not valid. Check if this issue type is linked to the issue type scheme for this business project."
    },
    formSuccessFooterSpork: {
        "id": "business-form.common.empty-views.form-success-footer-spork",
        "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
    },
    formSubmitAnotherForm: {
        "id": "business-form.common.empty-views.form-submit-another-form",
        "defaultMessage": "Submit another form"
    },
    unsupportedRequiredFieldsHeading: {
        "id": "business-form.common.empty-views.unsupported-required-fields-heading",
        "defaultMessage": "Unsupported required fields"
    },
    unsupportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.unsupported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Update the field configuration</link> to make these fields optional, and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request changes to the field configuration}\n        }."
    },
    supportedRequiredFieldsMissingHeading: {
        "id": "business-form.common.empty-views.supported-required-fields-missing-heading",
        "defaultMessage": "Missing required fields"
    },
    supportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.supported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Complete all the required fields in the form</link> and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request any changes to required fields}\n        }."
    },
    formUnavailableWithoutProjectAccessTitle: {
        "id": "business-form.common.empty-views.form-unavailable-without-project-access-title",
        "defaultMessage": "You can't view this form without access to this Jira project"
    },
    formUnavailableWithoutProjectAccessDescription: {
        "id": "business-form.common.empty-views.form-unavailable-without-project-access-description",
        "defaultMessage": "Try contacting the owner of this form if you think this is a mistake."
    },
    createPermissionNameIssueTermRefresh: {
        "id": "business-form.common.empty-views.create-permission-name-issue-term-refresh",
        "defaultMessage": "\u201CCreate work item\u201D"
    },
    formUnavailableIssueTypeDeletedContentIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-issue-term-refresh",
        "defaultMessage": "The work type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one."
    },
    formUnavailableIssueTypeDeletedContentForAdminsIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins-issue-term-refresh",
        "defaultMessage": "The work type associated with this form was removed from your business project. Delete this form and create a new one with the work types that are available."
    },
    formUnavailableIssueTypeNotAssociatedContentOldIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old-issue-term-refresh",
        "defaultMessage": "The work type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this work type is linked to the work type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-issue-term-refresh",
        "defaultMessage": "The work type being used for this form is not valid. <link>Contact your admin</link> to check if this work type is linked to the work type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentForAdminsIssueTermRefresh: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins-issue-term-refresh",
        "defaultMessage": "The work type {issueTypeName} being used for this form is not valid. Check if this work type is linked to the work type scheme for this business project."
    }
});

});

parcelRegister("d9kln", function(module, exports) {

$parcel$export(module.exports, "SuccessView", () => $c57b2831de553a6f$export$be5117c66bf44cb9);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $7UlCP = parcelRequire("7UlCP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $5P7nx = parcelRequire("5P7nx");

var $jCEoE = parcelRequire("jCEoE");
const $c57b2831de553a6f$export$be5117c66bf44cb9 = ({ onSubmitAnotherFormClick: onSubmitAnotherFormClick, analyticAttributes: analyticAttributes, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormSuccessView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: analyticAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c57b2831de553a6f$var$successWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c57b2831de553a6f$var$illustrationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7UlCP.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large",
        as: "h1"
    }, formatMessage((0, $5P7nx.messages).successSubmissionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $5P7nx.messages).successSubmissionContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c57b2831de553a6f$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jCEoE.CTAButton), {
        onSubmitAnotherFormClick: onSubmitAnotherFormClick,
        issueKey: issueKey,
        analyticAttributes: analyticAttributes
    })))));
};
const $c57b2831de553a6f$var$successWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.negative.200',
    marginLeft: 'space.negative.200',
    textAlign: 'center'
});
const $c57b2831de553a6f$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginRight: 'space.400',
    marginLeft: 'space.400'
});
const $c57b2831de553a6f$var$illustrationStyles = (0, $8CUq3.xcss)({
    width: '84px',
    height: '84px',
    marginRight: 'auto',
    marginLeft: 'auto'
});

});
parcelRegister("7UlCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $48796305add0ec6b$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $gpuM1 = parcelRequire("gpuM1");
const $48796305add0ec6b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gpuM1)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gpuM1))
});
var $48796305add0ec6b$export$2e2bcd8739ae039 = $48796305add0ec6b$var$Illustration;
// for advanced use only
const $48796305add0ec6b$export$a179c88182cb9d56 = [
    0,
    0,
    275,
    275
];

});
parcelRegister("gpuM1", function(module, exports) {
module.exports = new URL("done-success.c2f2a83f.svg", import.meta.url).toString();

});


parcelRegister("5P7nx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8fc24f3a5039e625$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8fc24f3a5039e625$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successSubmissionHeading: {
        "id": "business-form.common.empty-views.success-submission-heading",
        "defaultMessage": "We're on it!"
    },
    successSubmissionContent: {
        "id": "business-form.common.empty-views.success-submission-content",
        "defaultMessage": "Thanks for your response."
    }
});

});

parcelRegister("jCEoE", function(module, exports) {

$parcel$export(module.exports, "CTAButton", () => $c6c9507f26aa014b$export$bd36621ef7814117);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $90yGq = parcelRequire("90yGq");

var $beNVL = parcelRequire("beNVL");
const $c6c9507f26aa014b$var$SIGN_UP_TO_JIRA_URL = 'https://www.atlassian.com/software/jira?referer=jira.com';
const $c6c9507f26aa014b$export$bd36621ef7814117 = ({ onSubmitAnotherFormClick: onSubmitAnotherFormClick, analyticAttributes: analyticAttributes, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)();
    const handleClick = (subjectId)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', subjectId, {
            ...analyticAttributes
        });
    };
    const handleButtonClick = (subjectId)=>{
        handleClick(subjectId);
        onSubmitAnotherFormClick();
    };
    if (issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "primary",
        href: `/browse/${issueKey}`,
        onClick: ()=>handleClick('formViewRequest')
    }, formatMessage((0, $beNVL.messages).formViewRequest));
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: ()=>handleButtonClick('submitAnotherResponseForForm')
    }, formatMessage((0, $beNVL.messages).formSubmitAnotherForm));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "primary",
        href: $c6c9507f26aa014b$var$SIGN_UP_TO_JIRA_URL,
        onClick: ()=>handleClick('formSignUpToJira')
    }, formatMessage((0, $beNVL.messages).formSignUpToJira));
};

});
parcelRegister("beNVL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $15b4d6a125251e05$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $15b4d6a125251e05$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formSignUpToJira: {
        "id": "business-form.common.empty-views.success-view.cta-button.form-sign-up-to-jira",
        "defaultMessage": "Sign up to Jira"
    },
    formViewRequest: {
        "id": "business-form.common.empty-views.success-view.cta-button.form-view-request",
        "defaultMessage": "View request"
    },
    formSubmitAnotherForm: {
        "id": "business-form.common.empty-views.success-view.cta-button.form-submit-another-form",
        "defaultMessage": "Submit another form"
    }
});

});




parcelRegister("lvFc8", function(module, exports) {

$parcel$export(module.exports, "useConditionalFieldLogicAnalyticsAttrs", () => $b81a4483b0ecf228$export$d1cdb18427131362);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $b81a4483b0ecf228$export$d1cdb18427131362 = ()=>(0, $5uXOq.useMemo)(()=>({
            isConditionalFieldLogicGateEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_')
        }), []);

});

parcelRegister("g2iZ7", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionPreloader", () => $818cc29cb1c3ec2d$export$bacf31e62dc24134);
$parcel$export(module.exports, "FormSubmissionPublicPreloader", () => $818cc29cb1c3ec2d$export$3a46cf508359edfa);
$parcel$export(module.exports, "useFormSubmission", () => $818cc29cb1c3ec2d$export$6a196f0d30f494f8);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $l2N2a = parcelRequire("l2N2a");

var $lODMY = parcelRequire("lODMY");
var $doZTA = parcelRequire("doZTA");

var $gak61 = parcelRequire("gak61");

var $EU5WQ = parcelRequire("EU5WQ");

var $5FLxe = parcelRequire("5FLxe");

var $jujEW = parcelRequire("jujEW");

var $kyf8b = parcelRequire("kyf8b");

var $8feUl = parcelRequire("8feUl");
const $818cc29cb1c3ec2d$export$bacf31e62dc24134 = ()=>{
    const [{ match: { params: { formId: formId } } }] = (0, $doZTA.useRouter)();
    const result = (0, $5FLxe.useGetFormWithFieldDataByFormId)(String(formId));
    const [state, { updateStore: updateStore }] = (0, $kyf8b.useFormSubmissionStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(result, state)) updateStore(result);
    }, [
        updateStore,
        result,
        state
    ]);
    return null;
};
const $818cc29cb1c3ec2d$export$e6ee57d5ccc5a2a3 = (0, $lODMY.createRouterSelector)((state)=>state.match.params.formUuid);
const $818cc29cb1c3ec2d$export$3a46cf508359edfa = ()=>{
    const formUuid = $818cc29cb1c3ec2d$export$e6ee57d5ccc5a2a3();
    const result = (0, $jujEW.useGetFormWithFieldDataByFormUuid)(String(formUuid));
    const [state, { updateStore: updateStore }] = (0, $kyf8b.useFormSubmissionStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(result, state)) updateStore(result);
    }, [
        updateStore,
        result,
        state
    ]);
    return null;
};
const $818cc29cb1c3ec2d$export$6a196f0d30f494f8 = ()=>{
    const [{ data: formWithFieldData, loading: getFormLoading, error: getFormError }] = (0, $kyf8b.useFormSubmissionStore)();
    const { data: fieldMetaData, loading: fieldMetaDataLoading, error: fieldMetaDataError } = (0, $EU5WQ.useFieldMeta)(formWithFieldData?.projectId, formWithFieldData?.issueType?.id, String(formWithFieldData?.formId), formWithFieldData?.accessLevel);
    // TODO: Remove useProject on cleanup of jsw_forms_rollout
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const projectType = (0, $gak61.useProjectType)();
    const loading = getFormLoading || fieldMetaDataLoading;
    return {
        data: loading ? undefined : {
            fieldMetaData: fieldMetaData,
            formWithFieldData: formWithFieldData,
            formSubmissionValidationData: (0, $8feUl.getFormValidationData)({
                formData: formWithFieldData,
                fieldMetaData: fieldMetaData,
                projectType: projectType ?? project?.type
            })
        },
        formId: String(formWithFieldData?.formId),
        loading: loading,
        error: getFormError || fieldMetaDataError
    };
};

});
parcelRegister("gak61", function(module, exports) {

$parcel$export(module.exports, "useIsSoftwareProject", () => $07561ff55b22087f$export$54f478d5af594f53);
$parcel$export(module.exports, "useProjectType", () => $07561ff55b22087f$export$6de29d851c914935);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");
const $07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS = [
    'classic-software',
    'software'
];
const $07561ff55b22087f$export$a1210dbe3ee59218 = (state)=>$07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS.includes(state.route.group ?? '');
const $07561ff55b22087f$export$54f478d5af594f53 = (0, $lODMY.createRouterSelector)($07561ff55b22087f$export$a1210dbe3ee59218);
const $07561ff55b22087f$export$6de29d851c914935 = ()=>{
    if (!(0, $4R6GH.fg)('jsw_forms_rollout')) return undefined;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isSoftwareProject = $07561ff55b22087f$export$54f478d5af594f53();
    return isSoftwareProject ? (0, $2vSU6.SOFTWARE_PROJECT) : (0, $2vSU6.CORE_PROJECT);
};

});

parcelRegister("EU5WQ", function(module, exports) {

$parcel$export(module.exports, "useFieldMeta", () => $bba4aa13d32bd987$export$c6fef47cfdcb6be7);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");


var $gN11a = parcelRequire("gN11a");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");

var $7wwVP = parcelRequire("7wwVP");

var $kyf8b = parcelRequire("kyf8b");

var $aFxfC = parcelRequire("aFxfC");

var $45NOA = parcelRequire("45NOA");
const $bba4aa13d32bd987$var$fetchMeta = async (formId)=>{
    // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
    const response = await (0, $7f4tk.default)(`/rest/api/2/issue/createmeta/businessform?formId=${formId}&expand=projects.issuetypes.fields`);
    return response;
};
const $bba4aa13d32bd987$var$memoizedFetchMeta = (0, $8QpSo.default)($bba4aa13d32bd987$var$fetchMeta);
const $bba4aa13d32bd987$export$c6fef47cfdcb6be7 = (projectId, issueTypeId, formId, accessLevel)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: true
    });
    const fieldMetaFromStore = (0, $kyf8b.useFieldMetaFromStore)();
    (0, $5uXOq.useEffect)(()=>{
        // TODO Inline these check variables on jira-forms-public-access cleanup
        const conditionalAccessLevelCheck = accessLevel == null && (0, $4R6GH.fg)('jira-forms-public-access');
        const conditionalIssueTypeCheck = issueTypeId == null && accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access');
        // Early exit if invalid data
        if (projectId == null || formId == null || conditionalAccessLevelCheck || conditionalIssueTypeCheck) {
            setState({
                loading: false
            });
            return;
        }
        // Public forms grabs meta data from the store, don't fetch from createmeta/businessform
        if (accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access')) {
            try {
                setState({
                    data: (0, $aFxfC.transformFieldMetaFromStore)(fieldMetaFromStore),
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setState({
                    loading: false,
                    error: e.message
                });
            }
            return;
        }
        // Limited/open forms continue to fetch
        (async ()=>{
            setState({
                loading: true
            });
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            try {
                // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
                const response = await $bba4aa13d32bd987$var$memoizedFetchMeta(formId);
                let data;
                // if there's a permission error, the response will exist but projects will be an empty array
                if (response.projects[0]?.issuetypes[0]?.fields) data = (0, $45NOA.transformFieldsMeta)((0, $45NOA.filterFieldsMeta)(response.projects[0].issuetypes[0].fields));
                setState({
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setState({
                    loading: false,
                    error: e.message
                });
            } finally{
                (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            }
        })();
    }, [
        formId,
        issueTypeId,
        projectId,
        accessLevel,
        fieldMetaFromStore
    ]);
    return state;
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("kyf8b", function(module, exports) {

$parcel$export(module.exports, "useFormSubmissionStore", () => $885876e47cc26c5a$export$bd364acc55858de);
$parcel$export(module.exports, "useFieldMetaFromStore", () => $885876e47cc26c5a$export$a4aa0819d5aaba9e);

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $885876e47cc26c5a$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $885876e47cc26c5a$var$FormSubmissionStore = (0, $iXqE5.createStore)({
    initialState: {
        data: undefined,
        loading: false,
        error: undefined
    },
    actions: $885876e47cc26c5a$var$actions,
    name: 'JWMFormSubmission'
});
const $885876e47cc26c5a$export$bd364acc55858de = (0, $3sQ5x.createHook)($885876e47cc26c5a$var$FormSubmissionStore);
const $885876e47cc26c5a$export$59c764c158c7e9d4 = (0, $6dDSs.createSelector)([
    (state)=>state?.data?.fields ?? undefined
], (issues)=>issues);
const $885876e47cc26c5a$export$a4aa0819d5aaba9e = (0, $3sQ5x.createStateHook)($885876e47cc26c5a$var$FormSubmissionStore, {
    selector: $885876e47cc26c5a$export$59c764c158c7e9d4
});

});

parcelRegister("aFxfC", function(module, exports) {

$parcel$export(module.exports, "transformPublicFormDataWithFieldData", () => $5d28492684f0ff51$export$fbc4c0af61f92a57);
$parcel$export(module.exports, "isFormNotFoundError", () => $5d28492684f0ff51$export$1227e121b71c2a43);
$parcel$export(module.exports, "isProjectNotFoundError", () => $5d28492684f0ff51$export$4084ebe6a1fddf86);
$parcel$export(module.exports, "transformFieldMetaFromStore", () => $5d28492684f0ff51$export$d9b16fd3f24a6fdd);

var $4R6GH = parcelRequire("4R6GH");

var $7wwVP = parcelRequire("7wwVP");

var $ld7hB = parcelRequire("ld7hB");

var $fOgCm = parcelRequire("fOgCm");

const $5d28492684f0ff51$export$fbc4c0af61f92a57 = ({ data: data })=>{
    if (!data || !data.jiraFormForPublicSubmission) return undefined;
    const { jiraFormForPublicSubmission: jiraFormForPublicSubmission } = data;
    const { formId: formId, uuid: uuid, projectId: projectId, title: title, description: description, bannerColor: bannerColor, enabled: enabled, fields: fields, emailRequired: emailRequired } = jiraFormForPublicSubmission;
    return {
        formId: formId,
        uuid: uuid,
        projectId: projectId,
        title: title,
        description: description ?? undefined,
        bannerColor: bannerColor ?? undefined,
        enabled: enabled,
        emailRequired: emailRequired,
        fields: fields?.filter(Boolean).filter((f)=>'fieldConfig' in f.field).map((f)=>{
            const fieldIsRequiredByIssueConfig = 'fieldConfig' in f.field && Boolean(f.field.fieldConfig?.isRequired);
            const fieldIsRequiredByFormConfig = !!f.isRequired;
            return {
                fieldId: f.fieldId,
                alias: f.alias,
                name: f.field.name,
                isRequired: fieldIsRequiredByIssueConfig,
                isRequiredByForm: fieldIsRequiredByFormConfig,
                description: f.description ?? undefined,
                type: f.field.type,
                ...(0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && {
                    parentCondition: f.parentCondition
                },
                ...'renderer' in f.field && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') && {
                    renderer: f.field.renderer ?? undefined
                },
                fieldOptions: (0, $ld7hB.getFieldOptionsForFieldComponent)(f.field) ?? undefined
            };
        }).filter((field)=>(0, $fOgCm.isFieldTypeSupportedForPublicAccessType)(field.type)) ?? [],
        accessLevel: (0, $7wwVP.FormAccessLevelTypes).PUBLIC
    };
};
const $5d28492684f0ff51$export$1227e121b71c2a43 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, $da56d43fdbe95df7$export$a5614f895fe1c5d2);
const $5d28492684f0ff51$export$4084ebe6a1fddf86 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, $da56d43fdbe95df7$export$afa01ec4f7c760a0);
const $5d28492684f0ff51$export$d9b16fd3f24a6fdd = (fields)=>{
    if (!fields) return undefined;
    return fields.reduce((acc, field)=>{
        acc[field.fieldId] = {
            name: field.name,
            required: field.isRequired,
            schema: {
                custom: field.type
            },
            allowedValues: field.fieldOptions ?? undefined
        };
        return acc;
    }, {});
};

});
parcelRegister("ld7hB", function(module, exports) {

$parcel$export(module.exports, "getFieldOptions", () => $34dcc3713a254203$export$fe2c010f38015c35);
$parcel$export(module.exports, "getFieldOptionsForFieldComponent", () => $34dcc3713a254203$export$88710e0087ec22ec);
const $34dcc3713a254203$export$fe2c010f38015c35 = (field)=>{
    if (!field) return undefined;
    switch(field.__typename){
        case 'JiraRadioSelectField':
        case 'JiraSingleSelectField':
        case 'JiraMultipleSelectField':
        case 'JiraCheckboxesField':
            return field.fieldOptions?.edges?.map((option)=>{
                if (option?.node && option.node.value != null) return {
                    label: option.node.value,
                    value: option.node.optionId
                };
                return undefined;
            }).filter(Boolean);
        case 'JiraPriorityField':
            return field.priorities?.edges?.map((option)=>option?.node && option.node.name !== null ? {
                    label: option.node.name,
                    value: option.node.priorityId,
                    icon: option.node.iconUrl
                } : undefined).filter(Boolean);
        default:
            return undefined;
    }
};
const $34dcc3713a254203$export$88710e0087ec22ec = (// eslint-disable-next-line camelcase
field)=>{
    if (!field) return undefined;
    switch(field.__typename){
        case 'JiraRadioSelectField':
        case 'JiraSingleSelectField':
        case 'JiraMultipleSelectField':
        case 'JiraCheckboxesField':
            return field.fieldOptions?.edges?.map((option)=>{
                if (option?.node && option.node.value != null) return {
                    value: option.node.value,
                    id: option.node.optionId,
                    self: ''
                };
                return undefined;
            }).filter(Boolean);
        case 'JiraPriorityField':
            return field.priorities?.edges?.map((option)=>option?.node && option.node.name !== null ? {
                    name: option.node.name,
                    id: option.node.priorityId,
                    iconUrl: option.node.iconUrl,
                    self: ''
                } : undefined).filter(Boolean);
        case 'JiraCascadingSelectField':
            return field.cascadingOptions?.edges?.map((option)=>option?.node && option.node.parentOptionValue != null && option.node.childOptionValues != null ? {
                    parentOptionValue: {
                        id: option?.node?.parentOptionValue?.optionId,
                        value: option?.node?.parentOptionValue?.value ?? '',
                        self: '',
                        __typename: 'JiraOption'
                    },
                    childOptionValues: option?.node?.childOptionValues?.map((childOption)=>({
                            id: childOption?.optionId ?? '',
                            value: childOption?.value ?? '',
                            self: '',
                            __typename: 'JiraOption'
                        }))
                } : undefined).filter(Boolean);
        default:
            return undefined;
    }
};

});

parcelRegister("fOgCm", function(module, exports) {

$parcel$export(module.exports, "isFieldTypeSupported", () => $cef62a43f25c3fdf$export$b47920a5dd99844f);
$parcel$export(module.exports, "isFieldTypeSupportedForPublicAccessType", () => $cef62a43f25c3fdf$export$a3a73ae0ebed4f88);
$parcel$export(module.exports, "getFieldTypeConfig", () => $cef62a43f25c3fdf$export$5be962d414ad6e6c);
$parcel$export(module.exports, "FORM_LABEL", () => $cef62a43f25c3fdf$export$364c27f38e7541f8);
$parcel$export(module.exports, "getFormLabelPrefix", () => $cef62a43f25c3fdf$export$1cad3815d15ba80d);
$parcel$export(module.exports, "getUniqueFormLabel", () => $cef62a43f25c3fdf$export$b0616c054785bb44);
$parcel$export(module.exports, "isProjectScopedFieldType", () => $cef62a43f25c3fdf$export$b6ad606b1df91ef5);
$parcel$export(module.exports, "isFieldImproperForForm", () => $cef62a43f25c3fdf$export$567d10980a8f2859);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $btedi = parcelRequire("btedi");

var $22Wo8 = parcelRequire("22Wo8");

var $1Zt9x = parcelRequire("1Zt9x");

var $1C9NJ = parcelRequire("1C9NJ");

var $97VNg = parcelRequire("97VNg");

var $aR835 = parcelRequire("aR835");

var $9Hxrl = parcelRequire("9Hxrl");

var $bunMY = parcelRequire("bunMY");

var $bxMnv = parcelRequire("bxMnv");

var $iNY3w = parcelRequire("iNY3w");

var $jbGY4 = parcelRequire("jbGY4");

var $awO6U = parcelRequire("awO6U");

var $3ZQGw = parcelRequire("3ZQGw");

var $kTnsH = parcelRequire("kTnsH");

var $g8kqC = parcelRequire("g8kqC");

var $iHSUu = parcelRequire("iHSUu");

var $3owst = parcelRequire("3owst");

var $dzSVK = parcelRequire("dzSVK");

var $2prZd = parcelRequire("2prZd");

var $eRVlU = parcelRequire("eRVlU");

var $cK31e = parcelRequire("cK31e");

var $9HQd3 = parcelRequire("9HQd3");

var $7lpSO = parcelRequire("7lpSO");

var $chk7J = parcelRequire("chk7J");

var $j85Ze = parcelRequire("j85Ze");

var $9TyvL = parcelRequire("9TyvL");

var $j2R7K = parcelRequire("j2R7K");

var $kfv7e = parcelRequire("kfv7e");

var $9uVge = parcelRequire("9uVge");

var $4I0dG = parcelRequire("4I0dG");

var $eFzGt = parcelRequire("eFzGt");

var $5VWF9 = parcelRequire("5VWF9");

var $1avQ5 = parcelRequire("1avQ5");
const $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.PARENT_TYPE)]: (0, $2prZd.ParentFieldTypeConfig),
    [(0, $5fc53.SPRINT_TYPE)]: (0, $chk7J.SprintFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.AFFECTS_VERSIONS_TYPE)),
    [(0, $5fc53.ASSIGNEE_TYPE)]: (0, $22Wo8.AssigneeFieldTypeConfig),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $1Zt9x.AttachmentFieldTypeConfig),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $1C9NJ.CascadingSelectFieldTypeConfig),
    [(0, $5fc53.CATEGORY_TYPE)]: (0, $97VNg.CategoryFieldTypeConfig),
    [(0, $5fc53.COMPONENTS_TYPE)]: (0, $aR835.ComponentsFieldTypeConfig),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $bunMY.DateTimeCustomFieldTypeConfig),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $9Hxrl.DateCustomFieldTypeConfig),
    [(0, $5fc53.DESCRIPTION_TYPE)]: (0, $bxMnv.DescriptionFieldTypeConfig),
    [(0, $5fc53.DUE_DATE_TYPE)]: (0, $iNY3w.DueDateFieldTypeConfig),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.FIX_VERSIONS_TYPE)),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $jbGY4.GroupCustomFieldTypeConfig),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $awO6U.LabelsCustomFieldTypeConfig),
    [(0, $5fc53.LABELS_TYPE)]: (0, $3ZQGw.LabelsFieldTypeConfig),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $kTnsH.MultiCheckboxesCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $g8kqC.MultiGroupCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: (0, $iHSUu.MultiSelectCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $3owst.MultiUserCustomFieldTypeConfig),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $1avQ5.MultiVersionsFieldTypeConfig)((0, $5fc53.MULTI_VERSION_CF_TYPE)),
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $dzSVK.NumberCustomFieldTypeConfig),
    [(0, $5fc53.PARENT_TYPE)]: (0, $2prZd.ParentFieldTypeConfig),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $eRVlU.PeopleCustomFieldType),
    [(0, $5fc53.PRIORITY_TYPE)]: (0, $cK31e.PriorityFieldTypeConfig),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $9HQd3.RadioButtonsCustomFieldTypeConfig),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $7lpSO.SelectCustomFieldTypeConfig),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $btedi.AffectedServicesCustomFieldTypeConfig),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $j85Ze.StoryPointEstimateCustomFieldTypeConfig),
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $9TyvL.SummaryFieldTypeConfig),
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: (0, $kfv7e.TeamsPlatformCustomFieldTypeConfig),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $j2R7K.TeamCustomFieldTypeConfig),
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: (0, $9uVge.TextAreaCustomFieldTypeConfig),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $4I0dG.TextCustomFieldTypeConfig),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $eFzGt.UrlCustomFieldTypeConfig),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $5VWF9.UserCustomFieldTypeConfig),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $1avQ5.VersionFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS = {
    [(0, $5fc53.SPRINT_TYPE)]: (0, $chk7J.SprintFieldTypeConfig)
};
const $cef62a43f25c3fdf$var$PUBLIC_FORM_SUPPORTED_FIELD_TYPES = [
    (0, $5fc53.CASCADING_SELECT_CF_TYPE),
    (0, $5fc53.DATETIME_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE),
    (0, $5fc53.DESCRIPTION_TYPE),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.NUMBER_CF_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $5fc53.SUMMARY_TYPE),
    (0, $5fc53.TEXT_AREA_CF_TYPE),
    (0, $5fc53.TEXT_CF_TYPE),
    (0, $5fc53.URL_CF_TYPE)
];
const $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS = {
    ...$cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS,
    ...$cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS
};
function $cef62a43f25c3fdf$export$b47920a5dd99844f(type, projectType) {
    if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS || type in $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS;
    return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS;
}
function $cef62a43f25c3fdf$export$a3a73ae0ebed4f88(type) {
    return $cef62a43f25c3fdf$var$PUBLIC_FORM_SUPPORTED_FIELD_TYPES.includes(type);
}
function $cef62a43f25c3fdf$export$5be962d414ad6e6c(fieldType, projectType) {
    return $cef62a43f25c3fdf$export$b47920a5dd99844f(fieldType, projectType) ? $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS[fieldType] : undefined;
}
const $cef62a43f25c3fdf$export$364c27f38e7541f8 = 'business-form';
const $cef62a43f25c3fdf$export$1cad3815d15ba80d = (projectType)=>{
    if ((0, $4R6GH.fg)('fix_forms_issue_create_labelling_issue')) {
        if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) return 'form';
        return 'business-form';
    }
    if (projectType != null && projectType === 'business') return 'business-form';
    return 'form';
};
const $cef62a43f25c3fdf$export$b0616c054785bb44 = (formLabelPrefix, formId)=>`${formLabelPrefix}-${formId}`;
const $cef62a43f25c3fdf$export$b6ad606b1df91ef5 = (type)=>type in $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS;
/**
 * List of fields IDs that do not make sense to be shown in form
 * This is based on https://hello.atlassian.net/wiki/spaces/JBus/pages/988271414/Forms+-+Field+support+prioritisation Quadrant 4
 */ const $cef62a43f25c3fdf$var$improperFieldIdsForForm = new Set([
    'created',
    'issuelinks',
    'issuetype',
    'project',
    'resolution',
    'security',
    'subtasks',
    'timeoriginalestimate',
    'updated',
    'updated',
    'votes',
    'watches'
]);
const $cef62a43f25c3fdf$var$improperFieldTypesForForm = new Set([
    (0, $5fc53.EPIC_TYPE),
    (0, $5fc53.EPIC_COLOR_TYPE),
    (0, $5fc53.EPIC_NAME_TYPE)
]);
const $cef62a43f25c3fdf$export$567d10980a8f2859 = ({ fieldId: fieldId, fieldName: fieldName, fieldType: fieldType })=>{
    if ($cef62a43f25c3fdf$var$improperFieldIdsForForm.has(fieldId) || $cef62a43f25c3fdf$var$improperFieldTypesForForm.has(fieldType)) return true;
    // Cases for others where fieldId and fieldType are not sufficient
    // and requires combination of both
    // e.g. for some custom field because their fieldId is different in every instance
    // Flagged field
    if (fieldName === 'Flagged' && fieldType === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return true;
    return false;
};

});
parcelRegister("btedi", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesCustomFieldTypeConfig", () => $b16b96f20af09d65$export$b379a34008ba5f5a);

var $5uXOq = parcelRequire("5uXOq");

var $ehis8 = parcelRequire("ehis8");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $2Kya6 = parcelRequire("2Kya6");

var $kShoa = parcelRequire("kShoa");
const $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent = (props)=>{
    // strip off any query strings from URL as the field component also adds them in
    const autoCompleteUrl = props.autoCompleteUrl?.split('?')[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Kya6.default), {
        ...props,
        autoCompleteUrl: autoCompleteUrl
    });
};
const $b16b96f20af09d65$export$b379a34008ba5f5a = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ehis8))),
    type: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
    Component: $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multiSelectFieldWriter)
};

});
parcelRegister("ehis8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a650f78d49c8cbb1$var$_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>/*#__PURE__*/ $a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;

});

parcelRegister("9gHYS", function(module, exports) {

$parcel$export(module.exports, "TextFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70);
$parcel$export(module.exports, "DescriptionFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$b2a65447738df397);
$parcel$export(module.exports, "AttachmentFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c);
$parcel$export(module.exports, "AssigneeFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$628ddd885c3ef19a);
$parcel$export(module.exports, "DropdownFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$6767d78d6b24ff93);
$parcel$export(module.exports, "DateFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54);
$parcel$export(module.exports, "DateTimeFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37);
$parcel$export(module.exports, "NotSupportedFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$4b127f667f36c30b);
$parcel$export(module.exports, "RestrictedFieldPlaceholder", () => $91f0bd5d2e8ed9a6$export$9afdc5f937418527);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $fVnbM = parcelRequire("fVnbM");

var $acknU = parcelRequire("acknU");

var $c8Oei = parcelRequire("c8Oei");

var $dD7Zc = parcelRequire("dD7Zc");

var $hPcwl = parcelRequire("hPcwl");

var $7FST0 = parcelRequire("7FST0");

var $3bDjY = parcelRequire("3bDjY");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bUmQV = parcelRequire("bUmQV");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $25C5e = parcelRequire("25C5e");
const $91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, formatMessage((0, $25C5e.default).fieldPlaceholder));
};
const $91f0bd5d2e8ed9a6$export$b2a65447738df397 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$DescriptionWrapper, null, formatMessage((0, $25C5e.default).fieldPlaceholder));
};
const $91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$AttachmentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
        spacing: "spacious",
        label: "upload"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).attachmentFieldPlaceholder))));
};
const $91f0bd5d2e8ed9a6$export$628ddd885c3ef19a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
        spacing: "spacious",
        label: "avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).assigneeFieldPlaceholder)))));
};
const $91f0bd5d2e8ed9a6$export$6767d78d6b24ff93 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).dropdownFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        spacing: "spacious",
        label: "openDropdown"
    }));
};
const $91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        spacing: "spacious",
        label: "calendar"
    }));
};
const $91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, formatMessage((0, $25C5e.default).timeFieldPlaceholder))));
};
const $91f0bd5d2e8ed9a6$export$4b127f667f36c30b = ({ isRequired: isRequired, onRemoveFieldClick: onRemoveFieldClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: (0, $4R6GH.fg)('jira-forms-public-access') ? 'color.text.disabled' : 'color.text.subtlest'
    }, isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $25C5e.default).notSupportedRequiredFieldPlaceholder,
        values: {
            contactAdmin: (0, $4R6GH.fg)('replace-anchor-with-link__jira-werewolves') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $25C5e.default).contactAdmin)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $25C5e.default).contactAdmin))
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $25C5e.default).notSupportedOptionalFieldPlaceholder,
        values: {
            clickHere: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                onClick: onRemoveFieldClick
            }, formatMessage((0, $25C5e.default).clickHere)))
        }
    }))));
};
const $91f0bd5d2e8ed9a6$var$styles = {
    wrapperFlex: "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6d13gt _bfhksyzs _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc"
};
const $91f0bd5d2e8ed9a6$export$9afdc5f937418527 = ({ isAttachmentField: isAttachmentField, onRemoveFieldClick: onRemoveFieldClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.300",
        xcss: $91f0bd5d2e8ed9a6$var$styles.wrapperFlex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 2,
        color: "color.text.disabled"
    }, isAttachmentField ? formatMessage((0, $25C5e.default).restrictedAttachmentsFieldPlaceholder) : formatMessage((0, $25C5e.default).restrictedFieldPlaceholder)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: "Remove field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onRemoveFieldClick()
    }, formatMessage((0, $25C5e.default).restrictedFieldPlaceholderRemoveButton))));
};
const $91f0bd5d2e8ed9a6$var$fieldHeight = (0, $8CUq3.xcss)({
    height: '2.25rem'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$FieldBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _11c82smr _189et94y _1dqonqa1 _1h6d1elr _bfhksyzs _syaz131l _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$FieldBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _11c82smr _189et94y _1dqonqa1 _1h6d13gt _bfhksyzs _syaz1lh4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $91f0bd5d2e8ed9a6$var$FieldBase = (0, $cSD7y.componentWithFG)('jira-forms-public-access', $91f0bd5d2e8ed9a6$var$FieldBaseNew, $91f0bd5d2e8ed9a6$var$FieldBaseOld); /**
                                                                                            * Expect icon in the content as the first element
                                                                                            * Vertical align the icon and gives space between icon and the content
                                                                                            */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$IconBeforeBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$TextFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i14no",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$DescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i8vuz _ca0qu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$AttachmentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1dqogq9o _4t3i14no _bfhk18uv _1bah1h6o",
            __cmplp.className
        ])
    });
}); /**
     * Expect an icon as the last child, so it will be placed in the very right
     */ 
const $91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1oc61wug",
            __cmplp.className
        ])
    });
}); /**
     * Expect the field contains 2 item where both will take 50% of the width
     */ 
const $91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _12apkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$IconBeforeBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz131l _1bsb1osq _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f0bd5d2e8ed9a6$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_17zi2smr _i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _t74oqslr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("25C5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $714c727dd5fe3e71$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $714c727dd5fe3e71$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldPlaceholder: {
        "id": "business-form.common.field-placeholders.field-placeholder",
        "defaultMessage": "Answer will be written here"
    },
    attachmentFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.attachment-field-placeholder",
        "defaultMessage": "Attachments will be uploaded here"
    },
    assigneeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.assignee-field-placeholder",
        "defaultMessage": "Unassigned"
    },
    dropdownFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.dropdown-field-placeholder",
        "defaultMessage": "Answer will be selected from dropdown"
    },
    dateFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.date-field-placeholder",
        "defaultMessage": "Date will be entered here"
    },
    timeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.time-field-placeholder",
        "defaultMessage": "Time will be entered here"
    },
    notSupportedRequiredFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-required-field-placeholder",
        "defaultMessage": "This required field is unsupported, {contactAdmin} to make this field optional"
    },
    contactAdmin: {
        "id": "business-form.common.field-placeholders.contact-admin",
        "defaultMessage": "contact admin"
    },
    notSupportedOptionalFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-optional-field-placeholder",
        "defaultMessage": "This field is unsupported, {clickHere} to remove this field. "
    },
    clickHere: {
        "id": "business-form.common.field-placeholders.click-here",
        "defaultMessage": "click here"
    },
    restrictedFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.restricted-field-placeholder",
        "defaultMessage": "This field is restricted as it may contain sensitive data. It won\u2019t be shown in a form with public access."
    },
    restrictedAttachmentsFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.restricted-attachments-field-placeholder",
        "defaultMessage": "Attachments cannot be uploaded to public forms."
    },
    restrictedFieldPlaceholderRemoveButton: {
        "id": "business-form.common.field-placeholders.restricted-field-placeholder.remove-button",
        "defaultMessage": "Remove"
    }
});

});


parcelRegister("2Kya6", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a4d6a889fba550$export$2e2bcd8739ae039);

var $hpV4g = parcelRequire("hpV4g");

var $ii6hB = parcelRequire("ii6hB");

var $aZJYe = parcelRequire("aZJYe");

var $6iZh4 = parcelRequire("6iZh4");
const $55a4d6a889fba550$var$AffectedServicesField = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aZJYe.transformDefaultAffectedServices),
    validator: (0, $6iZh4.validateRequired)
})((0, $ii6hB.AffectedServicesField));
var $55a4d6a889fba550$export$2e2bcd8739ae039 = $55a4d6a889fba550$var$AffectedServicesField;

});
parcelRegister("hpV4g", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $b3f935405140180d$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kErdU = parcelRequire("kErdU");

var $6paOF = parcelRequire("6paOF");

var $4R6GH = parcelRequire("4R6GH");

var $cyw6P = parcelRequire("cyw6P");

var $5pZ9g = parcelRequire("5pZ9g");

var $7Emtg = parcelRequire("7Emtg");

var $6cMZg = parcelRequire("6cMZg");

var $gifeQ = parcelRequire("gifeQ");

var $bPtOr = parcelRequire("bPtOr");

var $fl3Yy = parcelRequire("fl3Yy");

var $1MgIu = parcelRequire("1MgIu");

var $bCATC = parcelRequire("bCATC");
var $bv5he = parcelRequire("bv5he");
var $dIjAl = parcelRequire("dIjAl");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");


var $2eeg1 = parcelRequire("2eeg1");

var $dCm1o = parcelRequire("dCm1o");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $aBZin = parcelRequire("aBZin");

var $45JN1 = parcelRequire("45JN1");

var $iblgc = parcelRequire("iblgc");

var $86fzT = parcelRequire("86fzT");
const $b3f935405140180d$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $9svjh.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $gifeQ.isForgeCustomField)(fieldType) ? (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $5uXOq.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $6paOF.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $5uXOq.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey,
                    ariaLabelledBy: `${fieldId}-field-label`
                });
            const renderFieldMessage = (0, $5uXOq.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $5uXOq.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $6cMZg.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $5uXOq.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $gifeQ.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $7Emtg.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            let issueExtensionData;
            if ((0, $4R6GH.fg)('issue-create-new-forge-field')) issueExtensionData = (0, $5uXOq.useMemo)(()=>{
                if (!forge?.selectedProject || !forge?.selectedIssueType) return undefined;
                const { selectedProject: selectedProject, selectedIssueType: selectedIssueType } = forge;
                return {
                    project: {
                        id: selectedProject.value,
                        key: selectedProject.projectKey,
                        type: selectedProject.projectType
                    },
                    issue: {
                        type: selectedIssueType.label,
                        typeId: selectedIssueType.value
                    }
                };
            }, [
                forge
            ]);
            let isBuiltinEdit = false;
            if (extension && (0, $4R6GH.fg)('issue-create-new-forge-field')) isBuiltinEdit = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $gifeQ.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create') : !extension?.properties.edit;
            const renderFieldContent = (fieldProps, error)=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $5eGnF.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $aBZin.getValueFromEventOrValue)(value)
                        });
                    }
                };
                if (isBuiltinEdit && fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) && (0, $4R6GH.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldProps, error), renderFieldMessage(error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
                    attributes: {
                        renderContext: 'issue-create',
                        fieldType: extension?.properties.type,
                        module: extension?.type,
                        ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {},
                        renderMode: 'default'
                    }
                }));
                if (!(0, $4R6GH.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5pZ9g.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, $gifeQ.isForgeCustomField)(fieldType) && issueExtensionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyw6P.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    description: descriptionRaw,
                    issueExtensionData: issueExtensionData,
                    extension: extension ?? null,
                    renderContext: "issue-create",
                    experience: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? 'issue-create' : undefined
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $4R6GH.fg)('issue-create-new-forge-field') ? (0, $5uXOq.useCallback)(()=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return ''; // TODO Merge this condition with the one below when cleaning migrate_gic_smart_fields_jira_labs https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel || (0, $gifeQ.isForgeCustomField)(fieldType) && !isBuiltinEdit && (0, $4R6GH.fg)('issue-create-new-forge-field')) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gifeQ.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed,
                isBuiltinEdit
            ]) : (0, $5uXOq.useCallback)(()=>{
                if (isCollapsed && (0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs')) return ''; // TODO Merge this condition with the one below when cleaning migrate_gic_smart_fields_jira_labs https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gifeQ.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1MgIu.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iblgc.FieldSkeleton), null);
            if ((0, $gifeQ.isForgeCustomField)(fieldType) && !extension) return null;
            const renderField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv5he.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $86fzT.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $gifeQ.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $6paOF.fireIssueCreateErrorAnalytics)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIjAl.ErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $bPtOr.getErrorType)(err),
                            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eeg1.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCATC.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
                id: "withFormField",
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    fieldId: fieldId,
                    fieldType: fieldType
                }
            }, (0, $dCm1o.isVisualRefreshEnabled)() && fieldId === 'assignee' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $b3f935405140180d$var$fieldStyles
            }, " ", renderField, " ") : renderField);
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3f935405140180d$var$ForgeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b3f935405140180d$var$fieldStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});
parcelRegister("kErdU", function(module, exports) {

$parcel$export(module.exports, "JiraIssueCreateErrorBoundary", () => $7dd077670c812285$export$fe891cbe61d9bf7b);

var $5uXOq = parcelRequire("5uXOq");

var $hwocU = parcelRequire("hwocU");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");
const $7dd077670c812285$export$fe891cbe61d9bf7b = (props)=>{
    const { children: children, attributes: attributes, ...otherProps } = props;
    const getAttributes = (0, $5uXOq.useCallback)((error)=>{
        // TODO: add additional attributes in that we need for issue create.
        const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
        return {
            ...attributesPassed
        };
    }, [
        attributes
    ]);
    if ((0, $4R6GH.fg)('jira-issue-create-error-boundary-enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwocU.IssueCommonErrorBoundary), {
        ...otherProps,
        attributes: getAttributes
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), otherProps, children);
};

});
parcelRegister("hwocU", function(module, exports) {

$parcel$export(module.exports, "IssueCommonErrorBoundary", () => $ac927ebfa8dbb631$export$eda988af1aea453d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $2lELv = parcelRequire("2lELv");

var $90yGq = parcelRequire("90yGq");

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $ac927ebfa8dbb631$export$eda988af1aea453d = ({ children: children, fallback: fallback, fireErrorEventWhenNetworkError: fireErrorEventWhenNetworkError, getErrorAttributes: getErrorAttributes, attributes: attributes, ...otherProps })=>{
    // TODO: understand what more common attributes can be common in all of issue domain
    // TODO: understand what is more common for issue view and create and transition.
    const accountIdLoggedInUser = (0, $90yGq.useAccountId)();
    const getAttributes = (0, $5uXOq.useCallback)((error)=>{
        const attributesPassed = typeof attributes === 'function' ? attributes(error) : attributes;
        const tenantAttributes = (0, $1qgAp.getTenantAttributes)();
        const { errorAttributes: errorAttributes } = (0, $2lELv.getIssueErrorAttributes)(error, accountIdLoggedInUser);
        return {
            ...attributesPassed,
            ...tenantAttributes,
            ...errorAttributes
        };
    }, [
        attributes,
        accountIdLoggedInUser
    ]);
    const isFallbackString = typeof fallback === 'string';
    const fallbackMethod = (0, $5uXOq.useCallback)((errorProps)=>{
        const { errorAttributes: errorAttributes } = (0, $2lELv.getIssueErrorAttributes)(errorProps.error, accountIdLoggedInUser);
        if (errorAttributes.statusCode && errorAttributes.statusCode >= 400 && errorAttributes.statusCode < 500) {
            (0, $jcw0u.default)({
                error: errorProps.error,
                meta: {
                    id: 'issue.issue-view.viewIssue',
                    teamName: 'Bento'
                },
                attributes: {
                    ...attributes,
                    ...getErrorAttributes?.(errorProps.error),
                    statusCode: errorAttributes.statusCode,
                    traceId: errorAttributes.traceId || undefined
                }
            });
            return !isFallbackString && fallback?.(errorProps);
        }
    }, [
        accountIdLoggedInUser,
        attributes,
        fallback,
        getErrorAttributes,
        isFallbackString
    ]);
    const fallbackAbstracted = fireErrorEventWhenNetworkError && !isFallbackString ? fallbackMethod : fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...otherProps,
        attributes: getAttributes,
        fallback: fallbackAbstracted
    }, children);
};

});
parcelRegister("2lELv", function(module, exports) {

$parcel$export(module.exports, "statusCodesNotImpactingReliability", () => $320cd7353aa05732$export$501df64f0fda1d63);
$parcel$export(module.exports, "getIssueErrorAttributes", () => $320cd7353aa05732$export$23bbdbaa14274cfd);
$parcel$export(module.exports, "loginViaRedirectUrl", () => $320cd7353aa05732$export$796a2c2756dc1f12);
$parcel$export(module.exports, "getIssueLimitErrorField", () => $320cd7353aa05732$export$aba25149bb9fdf05);


var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");


var $79RqQ = parcelRequire("79RqQ");

var $fmm8O = parcelRequire("fmm8O");

var $7O0V2 = parcelRequire("7O0V2");
const $320cd7353aa05732$var$isIssueNetworkError = (error)=>(0, $fZneA.isClientFetchError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error) || error instanceof (0, $jJZqs.default) || error instanceof (0, $7O0V2.IssueViewFetchError);
const $320cd7353aa05732$export$d3ca0619504206aa = new Set([
    (0, $9185aee89b3755e4$export$99405616af30f11f),
    (0, $9185aee89b3755e4$export$683dbe11f74cd161),
    (0, $9185aee89b3755e4$export$4e094d34a5cb1872),
    (0, $9185aee89b3755e4$export$f10b32dfda12e96e)
]);
const $320cd7353aa05732$export$501df64f0fda1d63 = [
    (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
    (0, $3cd8a0ece36fbae5$export$4a3cb39801694eee),
    (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2),
    (0, $3cd8a0ece36fbae5$export$3b48aba8957000cd),
    (0, $3cd8a0ece36fbae5$export$6763168a631449a2)
];
const $320cd7353aa05732$var$isPreCalculatedErrorType = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $320cd7353aa05732$export$d3ca0619504206aa.has(error.message);
const $320cd7353aa05732$export$23bbdbaa14274cfd = (error, accountIdLoggedInUser)=>{
    // TODO Cleanup with JIV-14818
    if ($320cd7353aa05732$var$isPreCalculatedErrorType(error)) return {
        errorType: error.message,
        errorAttributes: error.errorAttributes
    };
    const errorType = (0, $9185aee89b3755e4$export$f10b32dfda12e96e);
    const errorAttributes = {
        errorMessage: error.message
    };
    if ($320cd7353aa05732$var$isIssueNetworkError(error)) {
        const { statusCode: statusCode, traceId: traceId } = error;
        Object.assign(errorAttributes, {
            statusCode: statusCode,
            traceId: traceId
        });
        if (!accountIdLoggedInUser || statusCode === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return {
            errorType: (0, $9185aee89b3755e4$export$99405616af30f11f),
            errorAttributes: errorAttributes
        };
        if (statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef) || statusCode === (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3)) return {
            errorType: (0, $9185aee89b3755e4$export$4e094d34a5cb1872),
            errorAttributes: errorAttributes
        };
        // Relay Error - could be mainIssueAggQuery
        if (error instanceof (0, $7O0V2.IssueViewFetchError) && error?.getIsRelayError()) {
            if ((0, $fZneA.isClientFetchError)(error) || statusCode && $320cd7353aa05732$export$501df64f0fda1d63.includes(statusCode)) return {
                errorType: (0, $9185aee89b3755e4$export$683dbe11f74cd161),
                errorAttributes: errorAttributes
            };
            Object.assign(errorAttributes, {
                userExperience: error.userExperience || 'unknownExperience'
            });
            Object.assign(errorAttributes, {
                errorMessage: `${error.message}, endpoint: ${error.endpoint || 'unknown'}`,
                endpoint: error.endpoint || 'unknown'
            });
            Object.assign(errorAttributes, {
                additionalErrors: error.additionalErrors
            });
            // If the statusCode is undefine for Relay Error we want to set it as UNKNOWN_ERROR to (taskFail)
            return {
                errorType: (0, $9185aee89b3755e4$export$f10b32dfda12e96e),
                errorAttributes: errorAttributes
            };
        }
        // Return CONNECTIVITY_ERROR if the statusCode is undefined for un-relay error
        if (!statusCode || $320cd7353aa05732$export$501df64f0fda1d63.includes(statusCode)) return {
            errorType: (0, $9185aee89b3755e4$export$683dbe11f74cd161),
            errorAttributes: errorAttributes
        };
    }
    return {
        errorType: errorType,
        errorAttributes: errorAttributes
    };
};
const $320cd7353aa05732$export$796a2c2756dc1f12 = async (loginRedirectUrl)=>{
    if (!loginRedirectUrl) return;
    const encodedRedirectUrl = encodeURIComponent(loginRedirectUrl);
    const logInUrl = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(logInUrl, '_blank');
};
const $320cd7353aa05732$export$aba25149bb9fdf05 = (error)=>{
    const errorMessagesList = error.message.split('; ');
    if (errorMessagesList.length === 0) return undefined;
    const fieldLimitErrorList = (0, $79RqQ.ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST).filter((fieldLimitErrorMessage)=>errorMessagesList.some((message)=>message.includes(fieldLimitErrorMessage)));
    // we prioritise comments/worklogs, if there are limits for both comments/worklogs and attachments.
    if (fieldLimitErrorList.includes((0, $79RqQ.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $fmm8O.COMMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $79RqQ.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $fmm8O.WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $79RqQ.ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $fmm8O.ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED;
    if (fieldLimitErrorList.includes((0, $79RqQ.REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE))) return 0, $fmm8O.ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED;
    return undefined;
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $9185aee89b3755e4$export$99405616af30f11f = 'AUTHENTICATION_ERROR';
const $9185aee89b3755e4$export$683dbe11f74cd161 = 'CONNECTIVITY_ERROR';
const $9185aee89b3755e4$export$4e094d34a5cb1872 = 'NOT_FOUND_OR_NO_PERMISSION_ERROR';
const $9185aee89b3755e4$export$f10b32dfda12e96e = 'UNKNOWN_ERROR';

parcelRegister("79RqQ", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $5fa2842a51e11b84$export$69483322ede4b803);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $5fa2842a51e11b84$export$e65b95e776ce6f27);
const $5fa2842a51e11b84$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $5fa2842a51e11b84$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $5fa2842a51e11b84$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $5fa2842a51e11b84$export$e65b95e776ce6f27 = [
    $5fa2842a51e11b84$export$dd2d62bc7ec6ce51,
    $5fa2842a51e11b84$export$db1ab2b83dc17aa9,
    $5fa2842a51e11b84$export$940ce115dba33e55,
    $5fa2842a51e11b84$export$4ec1f3604b85d553
];

});

parcelRegister("fmm8O", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $99d43d51c2dfe210$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $99d43d51c2dfe210$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $99d43d51c2dfe210$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $99d43d51c2dfe210$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $99d43d51c2dfe210$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $99d43d51c2dfe210$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $99d43d51c2dfe210$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $99d43d51c2dfe210$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $99d43d51c2dfe210$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $99d43d51c2dfe210$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $99d43d51c2dfe210$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $99d43d51c2dfe210$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $99d43d51c2dfe210$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $99d43d51c2dfe210$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $99d43d51c2dfe210$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $99d43d51c2dfe210$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $99d43d51c2dfe210$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $99d43d51c2dfe210$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $99d43d51c2dfe210$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $99d43d51c2dfe210$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $99d43d51c2dfe210$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $99d43d51c2dfe210$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $99d43d51c2dfe210$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $99d43d51c2dfe210$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $99d43d51c2dfe210$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $99d43d51c2dfe210$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $99d43d51c2dfe210$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $99d43d51c2dfe210$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $99d43d51c2dfe210$export$c0657c5ed1bbfed4);
const $99d43d51c2dfe210$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $99d43d51c2dfe210$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $99d43d51c2dfe210$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $99d43d51c2dfe210$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $99d43d51c2dfe210$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $99d43d51c2dfe210$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $99d43d51c2dfe210$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $99d43d51c2dfe210$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $99d43d51c2dfe210$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $99d43d51c2dfe210$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $99d43d51c2dfe210$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $99d43d51c2dfe210$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $99d43d51c2dfe210$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $99d43d51c2dfe210$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $99d43d51c2dfe210$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $99d43d51c2dfe210$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $99d43d51c2dfe210$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $99d43d51c2dfe210$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $99d43d51c2dfe210$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $99d43d51c2dfe210$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $99d43d51c2dfe210$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $99d43d51c2dfe210$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $99d43d51c2dfe210$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $99d43d51c2dfe210$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $99d43d51c2dfe210$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $99d43d51c2dfe210$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $99d43d51c2dfe210$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $99d43d51c2dfe210$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $99d43d51c2dfe210$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $99d43d51c2dfe210$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $99d43d51c2dfe210$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $99d43d51c2dfe210$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $99d43d51c2dfe210$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$c0657c5ed1bbfed4 = [
    $99d43d51c2dfe210$export$a2a71fb6b193e549,
    $99d43d51c2dfe210$export$3573d8ff428b4c8f
];

});

parcelRegister("7O0V2", function(module, exports) {

$parcel$export(module.exports, "IssueViewFetchError", () => $083ff05f34683b3d$export$4802e881d6c7820d);

var $ht021 = parcelRequire("ht021");

var $jJZqs = parcelRequire("jJZqs");
class $083ff05f34683b3d$export$4802e881d6c7820d extends (0, $ht021.default) {
    constructor(error, endpoint, traceId, isRelayError, userExperience, additionalErrors){
        super(error.message), this.error = error, this.endpoint = endpoint, this.traceId = traceId, this.isRelayError = isRelayError, this.userExperience = userExperience, this.additionalErrors = additionalErrors;
        this.endpoint = endpoint;
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $jJZqs.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        if (error instanceof $083ff05f34683b3d$export$4802e881d6c7820d) {
            this.error = error.error;
            this.statusCode = error.statusCode;
            this.traceId = error.traceId;
        }
        // set traceId from AGG, only if not set already
        if (!this.traceId && traceId && traceId !== '') this.traceId = traceId;
    }
    getIsRelayError() {
        return this.isRelayError === true;
    }
}

});


parcelRegister("1qgAp", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $b69c35ebd4c3a77a$export$bc31ff13a0bbe592);

var $j8DrX = parcelRequire("j8DrX");

var $c04PQ = parcelRequire("c04PQ");
const $b69c35ebd4c3a77a$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $c04PQ.isFedRamp)()
    };
};

});



parcelRegister("6paOF", function(module, exports) {

$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $5496d757147bd1bc$export$fffbd8c0e67dbb84);

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");

var $7UP1Y = parcelRequire("7UP1Y");
const $5496d757147bd1bc$export$fffbd8c0e67dbb84 = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-create-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $e3a3O.isApolloError)(error) ? {
                errorType: (0, $7UP1Y.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("fukJp", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $2a45d398159543ce$export$51f199f6846377f7);

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $2a45d398159543ce$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $jcw0u.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $1qgAp.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});

parcelRegister("7UP1Y", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $a482c5a4e339a75c$export$31b755cdc25616f2);
const $a482c5a4e339a75c$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("cyw6P", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $a82314a415a204e2$export$34a15d6027142c62);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2x3Cb = parcelRequire("2x3Cb");

var $2RhPB = parcelRequire("2RhPB");

var $7Aezm = parcelRequire("7Aezm");

var $fl3Yy = parcelRequire("fl3Yy");

var $1MgIu = parcelRequire("1MgIu");

var $lEOGs = parcelRequire("lEOGs");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $cR6FI = parcelRequire("cR6FI");

var $lXxfQ = parcelRequire("lXxfQ");

var $2G1Qa = parcelRequire("2G1Qa");
const $a82314a415a204e2$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, issueExtensionData: issueExtensionData, renderContext: renderContext, extension: extension, description: rawDescription, experience: experience })=>{
    const { onChange: onChange, value: value, error: error } = fieldProps;
    const extensionPayload = (0, $5uXOq.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $2G1Qa.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext,
            experience: experience
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext,
        experience
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            renderContext: renderContext,
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension,
        renderContext
    ]);
    if (!extension) return null;
    const { environment: environment, description: description } = (0, $1MgIu.extractEnvFromFieldDescription)(rawDescription || '');
    const renderFieldMessage = (err)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lEOGs.FieldMessage), {
            description: description,
            error: err,
            fieldName: fieldName
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('forge-fix-label-for-gic-and-tv') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: `${fieldId}-field`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a82314a415a204e2$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: environment
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a82314a415a204e2$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: environment
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR6FI.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXxfQ.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    }));
};
const $a82314a415a204e2$export$34a15d6027142c62 = (props)=>{
    const { extension: extension } = props;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: props.renderContext,
            ...extension && (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension,
        props.renderContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.075",
        xcss: $a82314a415a204e2$var$fieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a82314a415a204e2$export$4f0175d9150f8767, props)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a82314a415a204e2$var$ForgeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a82314a415a204e2$var$fieldContainerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("7Aezm", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $f6c5a5a43a090916$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $f6c5a5a43a090916$export$947ae3996b2bc000);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $f6c5a5a43a090916$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $f6c5a5a43a090916$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("1MgIu", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $91f4ce51875a932d$export$dfa36573f3bd00af);
const $91f4ce51875a932d$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $91f4ce51875a932d$var$STG_PREFIX = '(STAGING) ';
const $91f4ce51875a932d$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($91f4ce51875a932d$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv ?? ''
    };
};

});

parcelRegister("lEOGs", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $d60be20b90d8ebba$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kOFhM = parcelRequire("kOFhM");

var $qfj8c = parcelRequire("qfj8c");

var $e4yMr = parcelRequire("e4yMr");

var $f5oqj = parcelRequire("f5oqj");

var $h17zy = parcelRequire("h17zy");

var $koVbs = parcelRequire("koVbs");

var $6a30R = parcelRequire("6a30R");

var $4L2MR = parcelRequire("4L2MR");
const $d60be20b90d8ebba$var$featureFlags = {
    codeBidiWarnings: true,
    'code-bidi-warnings': true,
    'renderer-tti-tracking': true,
    'allow-windowed-code-block': true
};
const $d60be20b90d8ebba$var$FieldHelpLink = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl, onLinkClickEvent: onLinkClickEvent })=>{
    const learnMoreMessage = (0, $4L2MR.getLearnMoreMessage)(fieldHelpTextUrl);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: fieldHelpTextUrl,
        target: "_blank",
        onClick: (e)=>onLinkClickEvent(e, fieldHelpTextUrl)
    }, formatMessage(learnMoreMessage));
});
const $d60be20b90d8ebba$export$eb5013679a5d3f69 = (props)=>{
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const { error: error, fieldName: fieldName, description: description = '', fieldHelpTextUrl: fieldHelpTextUrl = '', onLinkClickEvent: onLinkClickEvent } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const eventHandlers = (0, $5uXOq.useMemo)(()=>({
            smartCard: {
                onClick: (0, $6a30R.onLinkClick)
            },
            link: {
                onClick: onLinkClickEvent || ((event, url)=>{
                    const eventTarget = event.target;
                    if ((0, $4L2MR.getLearnMoreMessage)(fieldHelpTextUrl) && url === fieldHelpTextUrl && eventTarget instanceof HTMLAnchorElement) {
                        eventTarget.target = '_blank';
                        return;
                    }
                    (0, $6a30R.onLinkClick)(event, url);
                })
            }
        }), [
        fieldHelpTextUrl,
        onLinkClickEvent
    ]);
    const document = (0, $5uXOq.useMemo)(()=>{
        if (error) return null;
         // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $4L2MR.adfDocument)({
            description: description
        });
    }, [
        description,
        error
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $4L2MR.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!document && !fieldHelpTextUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d60be20b90d8ebba$var$Description, {
        key: `${fieldName}-field-message`
    }, document && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ), {
        document: document,
        dataProviders: emojiProvider,
        schema: (0, $kOFhM.defaultSchema),
        disableHeadingIDs: true,
        featureFlags: $d60be20b90d8ebba$var$featureFlags,
        truncated: false,
        eventHandlers: eventHandlers,
        smartLinks: (0, $6a30R.smartLinksDefault)
    }), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d60be20b90d8ebba$var$FieldHelpLink, {
        fieldHelpTextUrl: fieldHelpTextUrl,
        onLinkClickEvent: eventHandlers.link.onClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d60be20b90d8ebba$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1hdcr7 _woio131l _13od1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $bfdcc8a4590754dc$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$32b1dde15f5fe85b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$171e9ff2be159af7 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$15ebf236772fa336 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$220c665c23b9541b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $1f2243de0d109562$export$171e9ff2be159af7);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$171e9ff2be159af7 = (0, $gthjq.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $aXBFx = parcelRequire("aXBFx");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "extendedBlockquote", () => $7faca2534e4894a0$export$70a64939da3e8455);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $7faca2534e4894a0$export$32b1dde15f5fe85b);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquoteWithoutNonBodiedMacros)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$70a64939da3e8455 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});
const $7faca2534e4894a0$export$32b1dde15f5fe85b = (0, $gthjq.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $87ea86de426496d8$export$220c665c23b9541b);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>(0, $gthjq.panel)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));
const $87ea86de426496d8$export$220c665c23b9541b = (allowCustomPanel)=>(0, $gthjq.panelWithoutNestedNonBodiedMacros)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $9da26af350402964$export$15ebf236772fa336);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)($9da26af350402964$var$nestedExpandFactoryOptions);
const $9da26af350402964$export$15ebf236772fa336 = (0, $gthjq.nestedExpandWithoutNonBodiedMacros)($9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");


var $3lRy2 = parcelRequire("3lRy2");

var $1SqDw = parcelRequire("1SqDw");

var $glOdv = parcelRequire("glOdv");

var $aagOn = parcelRequire("aagOn");

var $dJPoO = parcelRequire("dJPoO");

var $kjHuf = parcelRequire("kjHuf");

var $8QrLL = parcelRequire("8QrLL");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEventOld = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $5uXOq.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $gmhCD.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    // Abstract out the logic into its own function
    const serializer = (0, $kjHuf.useMemoFromPropsDerivative)((serializerProps)=>{
        // If progressive rendering is enabled, create a new serializer
        if ((0, $VSDnB.fg)('cc_complexit_fe_progressive_adf_rendering')) {
            const newSerializer = props.createSerializer?.(serializerProps);
            if (newSerializer) return newSerializer;
        }
        return new (0, $9gOVJ.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $5uXOq.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
const $3de1eca32602d427$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$export$c49fe2316038f3c2);
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext = (props)=>{
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8QrLL.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$c49fe2316038f3c2, propsWithoutPortal));
};
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext);
const $3de1eca32602d427$var$getRendererComponent = (nodeComponents)=>{
    // If nodeComponents are provided, for now we don't want to remove portal from props
    // and use context instead because at this time we cannot guarantee that existing
    // consumers of Atlaskit Renderer will update to use the new portal context.
    if (!Boolean(nodeComponents) && (0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized;
    return $3de1eca32602d427$var$RendererFunctionalComponentMemoized;
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $5uXOq.useContext)((0, $1SqDw.ValidationContext)) || {};
    const RendererComponent = $3de1eca32602d427$var$getRendererComponent(props.nodeComponents);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(RendererComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: {
            allowNestedTables: allowNestedTables
        }
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $19a4579e32968c00$export$74b525449cc7cbd1);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: (0, $aagOn.getBaseFontSize)(appearance)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $glOdv.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && (0, $VSDnB.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $d1ee541d73df1fcd$export$6fde1d0d81db98e1);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $d1ee541d73df1fcd$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $01f0a5ace820da37$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $VSDnB.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $VSDnB.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7rlXf = parcelRequire("7rlXf");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-05
    editor_ai_contextual_selection_toolbar_button: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_contextual_selection_toolbar_button'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    editor_ai_cmd_palette_remove_retry: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_cmd_palette_remove_retry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-13
    editor_ai_comment_freegen_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_comment_freegen_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    confluence_p2m_style_recalc_and_expand_joint_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_p2m_style_recalc_and_expand_joint_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-22
    editor_ai_in_editor_streaming: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_in_editor_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_hide_floating_toolbar_in_ssr: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_floating_toolbar_in_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_open_overlay_perf: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_open_overlay_perf'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("7rlXf", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $641ded07329846f0$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $641ded07329846f0$export$fb89e8a786694d1);

var $9qwvi = parcelRequire("9qwvi");
function $641ded07329846f0$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $641ded07329846f0$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $9qwvi.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});



parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d9ce436f8d702318$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d9ce436f8d702318$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $hFEwm.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5BLIh.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $5or39.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $VSDnB.fg)('platform_renderer_isPresentational') ? this.isPresentational : false
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

var $VSDnB = parcelRequire("VSDnB");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $2SZph = parcelRequire("2SZph");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8WMBu")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("kHVHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1KGZa")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4OnIJ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("clvfA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2Fwz0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hQAvz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2c01v")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hSHcF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8ugtC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5WPrU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("6tHHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8m1sA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jHdEo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bokwI")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("dmxb9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("32Gvn")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("XeDOe")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aVEPl")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $bQeYo.default) : (0, $2SZph.default);
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("blockquote", {
        children: props.children
    });
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");

var $1SqDw = parcelRequire("1SqDw");

var $VSDnB = parcelRequire("VSDnB");
const $b9e9d2beaec6b895$var$ValidationContextWrapper = ({ children: children })=>{
    // We override validation of nested tables in nested renderers as invalid ADF (but valid Prosemirror)
    // may have been introduced in the parent renderer's render and subsequent transformations.
    // For example - nested tables which are transformed from an extension node in ADF
    // to native Prosemirror nested table nodes in and this is invalid ADF.
    const validationContextValue = (0, $5uXOq.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    if (!(0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1SqDw.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YrGg.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($b9e9d2beaec6b895$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $i8Zwf.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $i8Zwf.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                    }
                })
            })
        })
    });
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $1a97cbb70a611ae8$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $1a97cbb70a611ae8$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $1a97cbb70a611ae8$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $1a97cbb70a611ae8$var$macroHeights[viewportSize];
    }
};
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    const viewportSize = $1a97cbb70a611ae8$var$getViewportSize(extensionId, extensionViewportSizes);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%',
                    minHeight: viewportSize
                },
                "data-layout": layout,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes);
        }
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children));
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $izxHQ = parcelRequire("izxHQ");
function $36d4284a17bc60a0$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            if ((0, $VSDnB.fg)('confluence_preload_extension_providers')) {
                const maybePromise = $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
                if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $izxHQ.resolveImport)(node.render()));
                else {
                    const preloaded = maybePromise?.renderSync?.();
                    // Only product implemented preloading will return sync result
                    // However the out-of-box won't handle this. Confluence uses a custom implementation
                    return preloaded ? (0, $izxHQ.resolveImportSync)(preloaded) : (0, $izxHQ.resolveImport)(maybePromise.render());
                }
            } else return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $23c4e3f9598df846$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    return $23c4e3f9598df846$export$dca2026e63034304(await importPromise);
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");

var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $1C4XH = parcelRequire("1C4XH");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");


var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $1IiUD = parcelRequire("1IiUD");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");


var $2y1kv = parcelRequire("2y1kv");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("1C4XH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11841756f48da98b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11841756f48da98b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Resize handle'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'View more elements that can be inserted'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("1IiUD", function(module, exports) {

$parcel$export(module.exports, "elementInsertSidePanel", () => $97dbccb0b0b981b3$export$276a218f93338b76);

var $7VHMR = parcelRequire("7VHMR");
const $97dbccb0b0b981b3$export$276a218f93338b76 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("2y1kv", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarMessages", () => $14d5a3715e7fc293$export$b0226831bf5c0d3e);

var $7VHMR = parcelRequire("7VHMR");
const $14d5a3715e7fc293$export$b0226831bf5c0d3e = (0, $7VHMR.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("4IfOW"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("5bwDx"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("4IfOW", function(module, exports) {

let $36e78b2683548d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36e78b2683548d65$var$load("5j2yR").then(()=>parcelRequire('hFoxV'));

});

parcelRegister("5bwDx", function(module, exports) {

let $3c674bc9dbc46d1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c674bc9dbc46d1b$var$load("5ywns").then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");

var $jw62c = parcelRequire("jw62c");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EsbE.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuusl.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8Mz83.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eka68.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && (0, $VSDnB.fg)('platform_editor_comments_api_manager')) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jw62c.AnnotationManagerProvider), {
            annotationManager: annotationProvider?.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContext", () => $1cf3b601714e6f28$export$365d1799d81a236d);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $1cf3b601714e6f28$export$153126608e00390);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $1cf3b601714e6f28$export$365d1799d81a236d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
class $1cf3b601714e6f28$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, isNestedRender: isNestedRender } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        /*
		 * If this is a nested render, we do not provide the draft context
		 * because it has already been provided higher up the component tree
		 * and we need the original context to create draft annotations on extensions.
		 */ return isNestedRender && (0, $VSDnB.fg)('confluence_frontend_fix_extension_draft_annotation') ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-testid": "context-wrapper-without-provider",
            children: children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
            value: position,
            children: children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            position: null
        }, this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        }, this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $VSDnB = parcelRequire("VSDnB");

var $jw62c = parcelRequire("jw62c");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jw62c.useAnnotationManagerState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch
    ]);
    const annotationMarkStates = (0, $5uXOq.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return annotationMarkStates;
    else return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jw62c.useAnnotationManagerState)();
    const selectedAnnotation = (0, $5uXOq.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $477334c02b9da473$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("jw62c", function(module, exports) {

$parcel$export(module.exports, "AnnotationManagerProvider", () => $dbab420736de348f$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $dbab420736de348f$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $dbab420736de348f$export$12cbbb89fb7702d0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");
const $dbab420736de348f$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $dbab420736de348f$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($dbab420736de348f$var$initState);
const $dbab420736de348f$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $dbab420736de348f$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$dbab420736de348f$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $88i6h.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $88i6h.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $88i6h.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $dbab420736de348f$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($dbab420736de348f$var$reducer, $dbab420736de348f$var$initState);
    (0, $5uXOq.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $5uXOq.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // useEffect(() => {
    // 	const setIsAnnotationSelected = (id: AnnotationId, isSelected: boolean): SelectAnnotationResult => {
    // 		if (!state.annotations?.[id]) {
    // 			return {
    // 				success: false,
    // 				reason: 'id-not-valid',
    // 			};
    // 		}
    // 		dispatch({
    // 			type: 'updateAnnotation',
    // 			data: {
    // 				id,
    // 				selected: isSelected,
    // 			},
    // 		})
    // 		return {
    // 			success: true,
    // 			isSelected,
    // 		};
    // 	};
    // 	annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
    // 	return () => {
    // 		annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
    // 	};
    // }, [state.annotations]);
    // useEffect(() => {
    // 	console.log('annotationsSelectedChanged', state.annotationsSelectedChanged);
    // 	// if (state.isDrafting && state.currentDraftId && state.draftMarkRef) {
    // 	// 	annotationManager?.emit({
    // 	// 		name: 'annotationSelectionChanged',
    // 	// 		data: {
    // 	// 			annotationId: state.currentDraftId,
    // 	// 			inlineNodeTypes: [],
    // 	// 			isSelected: true,
    // 	// 		},
    // 	// 	});
    // 	// }
    // }, [annotationManager, state.annotationsSelectedChanged]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $5uXOq.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $88i6h.AnnotationTypes).INLINE_COMMENT && !annotation.state) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $dbab420736de348f$export$654a1fb45487f838 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerStateContext);
};
const $dbab420736de348f$export$12cbbb89fb7702d0 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerDispatchContext);
};

});


parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children)
    });
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.debugAnalyticLoggingEnabled = false;
        // TODO: EDITOR-595 - This method is temporary and should be removed once the following issue
        // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
        // This is a copy of the original canApplyAnnotationOnRange. If that returns false this is run to figure out exactly why
        // the annotation cannot be applied to the range.
        this._privateWhyCannotApplyAnnotationOnRange = (pos, doc, schema)=>{
            const { from: from, to: to } = pos;
            if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return 'position invalid';
            const reasons = [];
            doc.nodesBetween(from, to, (node, _pos, parent)=>{
                // Special exception for hardBreak nodes
                if (schema.nodes.hardBreak === node.type) return false;
                // For block elements or text nodes, we want to check
                // if annotations are allowed inside this tree
                // or if we're leaf and not text
                if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                    const isAllowedInlineNode = [
                        'emoji',
                        'status',
                        'date',
                        'mention',
                        'inlineCard'
                    ].includes(node.type.name);
                    if (node.isInline && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 1 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 2 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 3 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                } else {
                    if (node.isInline && !node.isText) {
                        reasons.push(`Err 4 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText) {
                        reasons.push(`Err 5 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 6 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                }
                return true;
            });
            return reasons.join(', ');
        };
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
        if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation - Empty Text Selection`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    from: from,
                    to: to
                }
            });
            return false;
        }
        const result = (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        if (this.debugAnalyticLoggingEnabled && !result && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
            // @ts-ignore
            action: 'failed',
            // @ts-ignore
            actionSubject: 'applyAnnotation',
            // @ts-ignore
            actionSubjectId: 'inlineCommentFailureReason',
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // @ts-ignore
                reason: `Annotation canApplyAnnotationOnRange failed`,
                details: this._privateWhyCannotApplyAnnotationOnRange({
                    from: from,
                    to: to
                }, this.doc, this.schema),
                commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                from: from,
                to: to
            }
        });
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or position`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc
                }
            });
            return false;
        }
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - Missing doc, position or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - ${failed}`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')
                }
            });
            return false;
        }
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    /**
	 * This is a temporary method used for controlling when extra analytics shoulw be logged.
	 */ _setDebugLogging(enabled) {
        this.debugAnalyticLoggingEnabled = enabled;
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if ((0, $VSDnB.fg)('platform_editor_annotation_position_comment_nodes')) {
            if (prev.nodeType === Node.COMMENT_NODE) {
                // Comment nodes should not result in the position being
                // incremented, so we skip them.
                prev = prev.previousSibling;
                continue;
            }
        }
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});




parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");

var $VSDnB = parcelRequire("VSDnB");

var $2EsbE = parcelRequire("2EsbE");
const $68c25c02b6872087$export$4326475864ea264a = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children, isNestedRender: isNestedRender } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                children,
                !!hoverComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MIvG.RangeValidator), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    component: hoverComponent,
                    applyAnnotationDraftAt: applyAnnotationDraftAt,
                    clearAnnotationDraft: clearAnnotationDraft
                }),
                !!selectionComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iatcV.SelectionRangeValidator), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    selectionComponent: selectionComponent,
                    applyAnnotationDraftAt: applyAnnotationDraftAt,
                    clearAnnotationDraft: clearAnnotationDraft
                })
            ]
        });
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft,
        isNestedRender: isNestedRender,
        children: render
    });
};
const $68c25c02b6872087$export$234989777a7c1762 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MIvG.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iatcV.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) // IMPORTANT: Please make sure the AnnotationsDraftContextWrapper is not used anc cleaned up correctly.
    // This code path completely removes all reliance on that wrapper. Also the applyAnnotationDraftAt & clearAnnotationDraft
    // properties have been made optional and not used. This means when we cleanup we can also remove those properties.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($68c25c02b6872087$export$234989777a7c1762, {
        rendererRef: props.rendererRef,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender,
        children: props.children
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($68c25c02b6872087$export$4326475864ea264a, {
        rendererRef: props.rendererRef,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender,
        children: props.children
    });
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$38d3fe2fadcf735b$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    // if platform_renderer_annotation_draft_position_fix is enabled; then
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    // else;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    // end-if
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        const positionToAnnotate = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? hoverDraftDocumentPosition || documentPosition : draftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) promoteHoverToDraft(documentPosition);
        else {
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt && applyAnnotationDraftAt(documentPosition);
        }
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? hoverDraftDocumentPosition || documentPosition : draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) clearHoverDraft();
        else {
            clearAnnotationDraft && clearAnnotationDraft();
            setDraftDocumentPosition(null);
        }
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft,
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7c7af48337b91c7a$var$initialState = {
    range: null,
    draftRange: null,
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $7c7af48337b91c7a$var$reducerOld(state, action) {
    switch(action.type){
        case 'clear':
            return $7c7af48337b91c7a$var$initialState;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                ...state,
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                ...state,
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
    return state;
}
function $7c7af48337b91c7a$var$reducerNew(state, action) {
    switch(action.type){
        case 'clear':
            return $7c7af48337b91c7a$var$initialState;
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
    return state;
}
const $7c7af48337b91c7a$var$AnnotationRangeStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    // if platform_renderer_annotation_draft_position_fix is off; then
    setDraftRange: ()=>{},
    clearDraftRange: ()=>{},
    // end-if
    // if platform_renderer_annotation_draft_position_fix is on; then
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $7c7af48337b91c7a$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $5uXOq.useReducer)((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? $7c7af48337b91c7a$var$reducerNew : $7c7af48337b91c7a$var$reducerOld, $7c7af48337b91c7a$var$initialState);
    const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
        else return {
            range: range,
            draftRange: draftRange,
            type: type,
            // I've updated some refs to use the new selectionDraftRange, this is being add here to be fowards compatible
            // with the new changes coming in platform_renderer_annotation_draft_position_fix.
            selectionDraftRange: draftRange,
            hoverDraftRange: draftRange,
            selectionDraftDocumentPosition: null,
            hoverDraftDocumentPosition: null
        };
    }, [
        range,
        draftRange,
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setSelectionRange,
        setDraftRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) /*
		 * If this is a nested render, we do not provide the context
		 * because it has already been provided higher up the component tree
		 * and we need the original context to create annotations on extensions.
		 */ return isNestedRender ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
};

});


parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$d73a3647df6a8131$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");

var $VSDnB = parcelRequire("VSDnB");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearRange: clearRange, clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $2EsbE.useAnnotationRangeState)();
    const lastRangeRef = (0, $5uXOq.useRef)(null);
    const onSelectionChange = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $VSDnB.fg)('platform_renderer_triple_click_selects_paragraph')) {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    lastRangeRef.current = null; // Clear last range if selection is invalid
                    return;
                }
                let _range = sel.getRangeAt(0);
                // Skip if the selection hasn’t changed
                if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer } = _range;
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    if (isTripleClick) {
                        let p = startContainer;
                        while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                        if (p && p.nodeName === 'P' && p instanceof Element) {
                            const range = document.createRange();
                            range.selectNodeContents(p);
                            sel.removeAllRanges();
                            sel.addRange(range);
                            _range = sel.getRangeAt(0);
                        }
                    }
                    setSelectionRange(_range.cloneRange());
                    lastRangeRef.current = _range;
                }
            }, 100);
        } else {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                    const parentNode = startContainer.parentNode;
                    // ED-23493
                    // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                    // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                    // Triple clicks are the only case that can cause the endContainer to be a non-text node
                    // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                    // platform/packages/editor/renderer/src/steps/index.ts Line 180
                    // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                    if (isTripleClick && commonAncestorContainer && commonAncestorContainer.nodeType === Node.ELEMENT_NODE && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                    ) {
                        const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                        _range.setEnd(lastChild, lastChild.length || 0);
                    }
                    setSelectionRange(_range.cloneRange());
                }
            }, 250);
        }
    }, [
        rendererDOM,
        setSelectionRange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) clearSelectionRange();
            else clearRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange,
        clearRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? clearSelectionRange : clearRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    // if platform_renderer_annotation_draft_position_fix is enabled; then
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    // else;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
    // end-if
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jw62c.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? selectionDraftDocumentPosition || documentPosition : draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) {
            // TODO: EDITOR-595 - This analytic event is temporary and should be removed once the following issue
            // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
            if (createAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) createAnalyticsEvent({
                action: 'failed',
                actionSubject: 'applyAnnotation',
                actionSubjectId: 'inlineCommentFailureReason',
                attributes: {
                    reason: 'Annotation Position invalid',
                    draftDocumentPosition: (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? selectionDraftDocumentPosition : draftDocumentPosition,
                    documentPosition: documentPosition,
                    applyAnnotation: !!applyAnnotation,
                    isDraftPositionFixEnabled: (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) actions._setDebugLogging(true);
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) {
            const result = applyAnnotation(positionToAnnotate, annotation);
            actions._setDebugLogging(false);
            return result;
        } else return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) promoteSelectionToDraft(documentPosition);
        else {
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt && applyAnnotationDraftAt(documentPosition);
        }
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? selectionDraftDocumentPosition || documentPosition : draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        if ((0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix')) clearSelectionDraft();
        else {
            clearAnnotationDraft && clearAnnotationDraft();
            setDraftDocumentPosition(null);
        }
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft,
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager?.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager?.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const startDraft = ()=>{
                if (isDrafting) return {
                    success: false,
                    reason: 'draft-in-progress'
                };
                if (!actions.isValidAnnotationRange(range)) return {
                    success: false,
                    reason: 'invalid-range'
                };
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager?.hook('startDraft', startDraft);
            return ()=>{
                annotationManager?.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager?.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager?.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $88i6h.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager?.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager?.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $5uXOq.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : onCloseCallback,
        onCreate: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : applyDraftModeCallback,
        removeDraftMode: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch
    ]);
};

});


parcelRegister("1SqDw", function(module, exports) {

$parcel$export(module.exports, "ValidationContext", () => $a1d6c169ab0ab071$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $a1d6c169ab0ab071$export$5b655fe45447a548);

var $5uXOq = parcelRequire("5uXOq");
const $a1d6c169ab0ab071$export$d452675449e81987 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a1d6c169ab0ab071$export$5b655fe45447a548 = $a1d6c169ab0ab071$export$d452675449e81987.Provider;

});


parcelRegister("2SZph", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb082cddb2d59aba$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $fb082cddb2d59aba$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $fb082cddb2d59aba$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $fb082cddb2d59aba$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $fb082cddb2d59aba$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $fb082cddb2d59aba$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $fb082cddb2d59aba$export$2e2bcd8739ae039 = $fb082cddb2d59aba$var$MultiBodiedExtension;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");

var $dkSnq = parcelRequire("dkSnq");

var $e4NNv = parcelRequire("e4NNv");
function $c5dc6f3b113435da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c5dc6f3b113435da$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $e4NNv.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $dkSnq.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $f8Sb3.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        css: [
            $c5dc6f3b113435da$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("dkSnq", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ef5b9c26278248e6$export$3c7139d93ecb4f1f);

var $5uXOq = parcelRequire("5uXOq");
const $ef5b9c26278248e6$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("e4NNv", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $9b12fab9f9c859c0$export$e55394818db35473);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9S8fM = parcelRequire("9S8fM");
const $9b12fab9f9c859c0$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerPromise = (0, $9S8fM.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $gnH2s.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $adf8f8318644b4cb$var$containerCSSNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? $adf8f8318644b4cb$var$containerCSSNew : $adf8f8318644b4cb$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("br", {});
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $bFU4G = parcelRequire("bFU4G");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");

var $3rouw = parcelRequire("3rouw");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $TM1uy.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rouw.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).CLICKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                    return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $bFU4G.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(HX, {
                id: headingIdToUse,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $jOyH3 = parcelRequire("jOyH3");

var $3bDjY = parcelRequire("3bDjY");

var $1Bd5P = parcelRequire("1Bd5P");
function $b36f5408031b5508$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = {
    name: "vhh4ux",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #44546F);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "layout-section-container",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-layout-section": true,
        children: props.children
    });
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");
function $93f45378df34617d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $93f45378df34617d$var$clearNextSiblingMarginTopStyle,
            $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $EGPjg.default), {
            children: children
        })
    }));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");


var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");

var $cInAA = parcelRequire("cInAA");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$export$940095e914312886 = (node, children)=>{
    return $7478efdfea2a60bf$export$28daf78feed5098c(children) && node && node.firstChild && !$7478efdfea2a60bf$export$42f5658c8e0092da(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $7478efdfea2a60bf$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$export$100baa0f10804e6e($7478efdfea2a60bf$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles = (0, $ajc8Z.default)((0, $cInAA.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cInAA.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $19a4579e32968c00$export$12fd658e5eef0d79) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$e5ff276883773ffd = 8;
const $356bd8bd1d42bb7c$export$880976487022eb5 = $356bd8bd1d42bb7c$export$808015ab1dd6897a + $356bd8bd1d42bb7c$export$e5ff276883773ffd - $356bd8bd1d42bb7c$export$72aad729077aa0fb;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");
function $dca73d3fed5e4b1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
var $dca73d3fed5e4b1b$var$_ref = {
    name: "tagqr6",
    styles: "--ds--code--bg-color:transparent"
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;white-space:normal;", (0, $VSDnB.fg)('platform_editor_fix_code_block_bg_color_in_macro') ? /*#__PURE__*/ (0, $f8Sb3.css)() : $dca73d3fed5e4b1b$var$_ref, " .code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);

var $VSDnB = parcelRequire("VSDnB");
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: replaced with getColumnWidths, which correctly scans entire table for column widths
    if ((0, $VSDnB.fg)('platform_editor_table_row_span_fix') || (0, $VSDnB.fg)('platform_editor_table_row_span_fix_all')) {
        const firstRow = node.firstChild;
        const tableColumnWidths = [];
        if (firstRow) firstRow.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
            else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
            else tableColumnWidths.push(0);
        });
        return tableColumnWidths;
    }
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        const colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $6gEe5 = parcelRequire("6gEe5");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $6gEe5.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $2OMIu.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrpWq.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "14n17e4",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $9b3e020198447653$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $9b3e020198447653$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $9b3e020198447653$var$fixedTableDivStaticStyles,
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: (0, $VSDnB.fg)('sticky_header_in_embedded_confluence_fix') ? typeof top === 'number' ? `${top}px` : undefined : top ? `${top}px` : undefined
        }
    }, props.children);
};
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $VSDnB.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("table", {
        ...(0, $VSDnB.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3nHPA.Colgroup), {
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $iHYdz.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");

var $VSDnB = parcelRequire("VSDnB");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("cInAA", function(module, exports) {

$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $ef3de7a711c9e97e$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $fKLIs = parcelRequire("fKLIs");


var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $cWojJ = parcelRequire("cWojJ");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $ef3de7a711c9e97e$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $ef3de7a711c9e97e$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $ef3de7a711c9e97e$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $ef3de7a711c9e97e$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $ef3de7a711c9e97e$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $ef3de7a711c9e97e$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $ef3de7a711c9e97e$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $ef3de7a711c9e97e$export$940095e914312886 = (node, children)=>{
    return $ef3de7a711c9e97e$export$28daf78feed5098c(children) && node && node.firstChild && !$ef3de7a711c9e97e$export$42f5658c8e0092da(node.firstChild);
};
class $ef3de7a711c9e97e$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $iHYdz.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $fKLIs.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $ef3de7a711c9e97e$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $ef3de7a711c9e97e$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $ef3de7a711c9e97e$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $ef3de7a711c9e97e$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $ef3de7a711c9e97e$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($ef3de7a711c9e97e$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $ef3de7a711c9e97e$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $ef3de7a711c9e97e$export$100baa0f10804e6e($ef3de7a711c9e97e$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $ef3de7a711c9e97e$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("td", {
                    className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && (!(0, $VSDnB.fg)('cc_complexit_fe_improve_table_sorting') || isHeaderRow)) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if ((0, $VSDnB.fg)('platform_editor_table_column_group_width_check_3') ? this.state.colGroupWidths?.length : this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("8WMBu", function(module, exports) {

let $01ae58891255b6e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01ae58891255b6e8$var$load("7uAi5").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("kHVHQ", function(module, exports) {

let $f134960741cca6cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f134960741cca6cd$var$load("9JEXq").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("1KGZa", function(module, exports) {

let $146b6e5faaa248eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $146b6e5faaa248eb$var$load("af9eo").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("4OnIJ", function(module, exports) {

let $380e3b5a085ebc97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $380e3b5a085ebc97$var$load("eiJrL").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("clvfA", function(module, exports) {

let $8fcfafdd49347737$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fcfafdd49347737$var$load("bF2Yj").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("2Fwz0", function(module, exports) {

let $1f18ab91da841361$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f18ab91da841361$var$load("7vMvR").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("hQAvz", function(module, exports) {

let $cfe39cbeca7c95a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfe39cbeca7c95a6$var$load("7qbwG").then(()=>parcelRequire('4hMem'));

});

parcelRegister("2c01v", function(module, exports) {

let $198cb86922264390$var$load = (parcelRequire("28QjX"))(4);
module.exports = $198cb86922264390$var$load("hNOP2").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("hSHcF", function(module, exports) {

let $d048fe1c0cc67525$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d048fe1c0cc67525$var$load("76n7a"),
    $d048fe1c0cc67525$var$load("l253H"),
    $d048fe1c0cc67525$var$load("ffQaD"),
    $d048fe1c0cc67525$var$load("kvRbA"),
    $d048fe1c0cc67525$var$load("aPoGi")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("8ugtC", function(module, exports) {

let $62dde7fb2c16a4f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $62dde7fb2c16a4f8$var$load("76n7a"),
    $62dde7fb2c16a4f8$var$load("l253H"),
    $62dde7fb2c16a4f8$var$load("ffQaD"),
    $62dde7fb2c16a4f8$var$load("kvRbA"),
    $62dde7fb2c16a4f8$var$load("93KAt")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("5WPrU", function(module, exports) {

let $454a4740a2b767cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $454a4740a2b767cb$var$load("fliVL"),
    $454a4740a2b767cb$var$load("76n7a"),
    $454a4740a2b767cb$var$load("l253H"),
    $454a4740a2b767cb$var$load("ffQaD"),
    $454a4740a2b767cb$var$load("kvRbA"),
    $454a4740a2b767cb$var$load("kNFvF"),
    $454a4740a2b767cb$var$load("dhTaM")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("6tHHQ", function(module, exports) {

let $4b775aa4acac24a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4b775aa4acac24a1$var$load("fliVL"),
    $4b775aa4acac24a1$var$load("76n7a"),
    $4b775aa4acac24a1$var$load("l253H"),
    $4b775aa4acac24a1$var$load("ffQaD"),
    $4b775aa4acac24a1$var$load("kvRbA"),
    $4b775aa4acac24a1$var$load("kNFvF"),
    $4b775aa4acac24a1$var$load("gNqLi")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("8m1sA", function(module, exports) {

let $615182c0cb4d0375$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $615182c0cb4d0375$var$load("fliVL"),
    $615182c0cb4d0375$var$load("76n7a"),
    $615182c0cb4d0375$var$load("l253H"),
    $615182c0cb4d0375$var$load("ffQaD"),
    $615182c0cb4d0375$var$load("kvRbA"),
    $615182c0cb4d0375$var$load("kNFvF"),
    $615182c0cb4d0375$var$load("fig2F")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("jHdEo", function(module, exports) {

let $e56c9f2f2e5028d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e56c9f2f2e5028d1$var$load("76n7a"),
    $e56c9f2f2e5028d1$var$load("l253H"),
    $e56c9f2f2e5028d1$var$load("gguur")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("bokwI", function(module, exports) {

let $84b1dbc8c386e490$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84b1dbc8c386e490$var$load("d0X7J").then(()=>parcelRequire('ebIkR'));

});

parcelRegister("dmxb9", function(module, exports) {

let $9ba7110bdfeaeeb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ba7110bdfeaeeb3$var$load("76n7a"),
    $9ba7110bdfeaeeb3$var$load("l253H"),
    $9ba7110bdfeaeeb3$var$load("lNsfv")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("32Gvn", function(module, exports) {

let $237287a63ccdc68d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $237287a63ccdc68d$var$load("1VmC7").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("XeDOe", function(module, exports) {

let $0b20de37847b85c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0b20de37847b85c1$var$load("ffQaD"),
    $0b20de37847b85c1$var$load("kvRbA"),
    $0b20de37847b85c1$var$load("76n7a"),
    $0b20de37847b85c1$var$load("l253H"),
    $0b20de37847b85c1$var$load("kRYcQ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("aVEPl", function(module, exports) {

let $7f4ee5b0867c0347$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7f4ee5b0867c0347$var$load("ffQaD"),
    $7f4ee5b0867c0347$var$load("kvRbA"),
    $7f4ee5b0867c0347$var$load("eIR2q")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dLpur = parcelRequire("dLpur");

var $iYAgE = parcelRequire("iYAgE");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
function $3c5c154ced085d7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $3c5c154ced085d7f$var$markStyles = {
    name: "ko40kj",
    styles: "color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;border-bottom:2px solid transparent;cursor:pointer;padding:1px 0 2px;&:has(.card), &:has([data-inline-card]){padding:5px 0 3px 0;}&:has(.date-lozenger-container){padding-top:var(--ds-space-025, 2px);}background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: $3c5c154ced085d7f$var$markStyles,
        ref: markRef
    }, children);
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPositionOld = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $iYAgE.AnnotationsDraftContext));
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const nextDraftPosition = (0, $VSDnB.fg)('platform_renderer_annotation_draft_position_fix') ? selectionDraftDocumentPosition : nextDraftPositionOld;
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $jw62c = parcelRequire("jw62c");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            if (hasFocus) return;
            annotationManager?.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");

var $jw62c = parcelRequire("jw62c");
const $c95b45af50ffb058$var$markStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $c95b45af50ffb058$var$markStylesLayeringFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStyles,
                (0, $VSDnB.fg)('platform_renderer_nested_annotation_styling') && $c95b45af50ffb058$var$markStylesLayeringFix,
                (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $c95b45af50ffb058$var$markStylesWithInlineComments,
                (0, $VSDnB.fg)('confluence-frontend-comments-panel') && $c95b45af50ffb058$var$markStylesWithCommentsPanel,
                !$c95b45af50ffb058$var$isMobile() && $c95b45af50ffb058$var$accessibilityStyles,
                $c95b45af50ffb058$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");
const $4c9c981a54265bdd$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko1sit _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $bwpsq.default)([
            $4c9c981a54265bdd$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: replacedChildren
    });
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $59fdc1b7b0ae96c9$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});


parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>(0, $VSDnB.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});


parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $VSDnB = parcelRequire("VSDnB");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        if ((0, $VSDnB.fg)('do-not-show-link-mismatch-warning-for-same-origin')) {
            const currentAtlassianProductOrigin = window.location.origin;
            const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
            if (isSafeToIgnoreNonOriginDifferences) return true;
        }
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);

var $gmhCD = parcelRequire("gmhCD");
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $gmhCD.editorExperiment)('editor_text_highlight_orange_to_yellow', 'test', {
        exposure: true
    })) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $b5a4f7ad3e4ae03c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");
const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $aeGrH.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("aXBFx")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("aXBFx")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("2FIVU")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("bFtEE")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("dx5eC")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $VSDnB.fg)('cc_complexit_fe_memoValidation_redundant_calls')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $85xkt.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae2d04c26b960a03$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, $VSDnB.fg)('platform-ssr-table-resize') ? $5224f7c9e411dec4$export$92859d13f30c883e(id, true) : $5224f7c9e411dec4$export$92859d13f30c883e(id)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id, optionalFlagArg) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${optionalFlagArg ?? false});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $19a4579e32968c00$export$12fd658e5eef0d79).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript && node.classList.contains('pm-table-container')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                renderer.offsetWidth);
                else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("glOdv", function(module, exports) {

$parcel$export(module.exports, "RendererStyleContainer", () => $db1d99891a2fef87$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");



var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");

var $iHYdz = parcelRequire("iHYdz");

var $9R9Rb = parcelRequire("9R9Rb");

var $3rouw = parcelRequire("3rouw");

var $cYeQP = parcelRequire("cYeQP");
var $4E5wI = parcelRequire("4E5wI");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $gmhCD = parcelRequire("gmhCD");

var $dkc63 = parcelRequire("dkc63");


var $2o2hu = parcelRequire("2o2hu");

var $04VvC = parcelRequire("04VvC");

var $aagOn = parcelRequire("aagOn");
function $db1d99891a2fef87$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db1d99891a2fef87$var$wrappedMediaBreakoutPoint = 410;
const $db1d99891a2fef87$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $db1d99891a2fef87$var$tableShadowWidth = 32;
const $db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $db1d99891a2fef87$var$tableRowHeight = 44;
const $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded = ()=>(0, $gE8f9.browser).isGecko || (0, $gE8f9.browser).isIE || (0, $gE8f9.browser).isMac && (0, $gE8f9.browser).isChrome;
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $db1d99891a2fef87$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    }
});
const $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererFullPageStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $19a4579e32968c00$export$12fd658e5eef0d79)}px`
});
const $db1d99891a2fef87$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $db1d99891a2fef87$var$telepointerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`#${$db1d99891a2fef87$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: '0px 2px 2px 0px',
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $db1d99891a2fef87$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $db1d99891a2fef87$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $db1d99891a2fef87$var$headingsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $db1d99891a2fef87$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $db1d99891a2fef87$var$ruleSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: '1px'
    }
});
const $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $db1d99891a2fef87$var$paragraphSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $db1d99891a2fef87$var$listsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $jlYLw.listItemCounterPadding)}px)`
    },
    [`${0, $dwptW.orderedListSelector}, ${0, $kjhhp.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $db1d99891a2fef87$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $db1d99891a2fef87$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $db1d99891a2fef87$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $db1d99891a2fef87$var$shadowSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $db1d99891a2fef87$var$dateSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $db1d99891a2fef87$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $db1d99891a2fef87$var$backgroundColorStyles = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $db1d99891a2fef87$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $iHYdz.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $iHYdz.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $iHYdz.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$baseOtherStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .${0, $ceYEW.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.image-align-start,
		.${0, $ceYEW.richMediaClassName}.image-center,
		.${0, $ceYEW.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $l8Gxi.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`
        },
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $db1d99891a2fef87$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $db1d99891a2fef87$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $ceYEW.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $ceYEW.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-right, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$db1d99891a2fef87$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $db1d99891a2fef87$var$tableSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $iHYdz.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $6gEe5.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $iHYdz.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // platform_editor_renderer_table_header_styles has already been launched, so assume it's on
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $6gEe5.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $6gEe5.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`,
            zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
            width: `${$db1d99891a2fef87$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`
        }
    }
});
const $db1d99891a2fef87$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$db1d99891a2fef87$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $db1d99891a2fef87$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $6gEe5.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// TODO: ED-27229 - Cleanup with `platform_editor_tables_numbered_column_correction`
const $db1d99891a2fef87$var$rendererTableColumnStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${`var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $db1d99891a2fef87$var$stickyHeaderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $db1d99891a2fef87$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}
		> .${(0, $2o2hu.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $iHYdz.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $db1d99891a2fef87$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $db1d99891a2fef87$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $iHYdz.akEditorLineHeight)}em !important`
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $db1d99891a2fef87$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${(0, $aagOn.getBaseFontSize)(appearance)}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $04VvC.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $04VvC.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $04VvC.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $04VvC.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $04VvC.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $04VvC.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $04VvC.default)('editor.font.body')}`
        },
        css: [
            $db1d99891a2fef87$var$baseStyles,
            (0, $VSDnB.fg)('platform_hide_heading_anchor_wrapper_before_hover') && $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && $db1d99891a2fef87$var$rendererFullPageStyles,
            appearance === 'full-width' && $db1d99891a2fef87$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $dkc63.isTableResizingEnabled)(appearance) && $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing,
            $db1d99891a2fef87$var$telepointerStyles,
            $db1d99891a2fef87$var$whitespaceSharedStyles,
            $db1d99891a2fef87$var$blockquoteSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC : $db1d99891a2fef87$var$headingsSharedStyles,
            $db1d99891a2fef87$var$headingWithAlignmentStyles,
            $db1d99891a2fef87$var$ruleSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC : $db1d99891a2fef87$var$paragraphSharedStyles,
            $db1d99891a2fef87$var$listsSharedStyles,
            (0, $gE8f9.browser).gecko && $db1d99891a2fef87$var$listsSharedStylesForGekko,
            $db1d99891a2fef87$var$indentationSharedStyles,
            $db1d99891a2fef87$var$blockMarksSharedStyles,
            $db1d99891a2fef87$var$codeMarkSharedStyles,
            $db1d99891a2fef87$var$shadowSharedStyle,
            $db1d99891a2fef87$var$dateSharedStyle,
            $db1d99891a2fef87$var$textColorStyles,
            $db1d99891a2fef87$var$backgroundColorStyles,
            $db1d99891a2fef87$var$tasksAndDecisionsStyles,
            $db1d99891a2fef87$var$smartCardStyles,
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $db1d99891a2fef87$var$smartCardStylesAvatarFix,
            (0, $VSDnB.fg)('smartcard_avatar_margin_fix') && $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $db1d99891a2fef87$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') && $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix,
            $db1d99891a2fef87$var$baseOtherStyles,
            allowNestedHeaderLinks && $db1d99891a2fef87$var$alignedHeadingAnchorStyle,
            $db1d99891a2fef87$var$mediaSingleSharedStyle,
            $db1d99891a2fef87$var$tableSharedStyle,
            $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') && $db1d99891a2fef87$var$tableRendererNestedPanelStyles,
            $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded() && $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD : $db1d99891a2fef87$var$firstNodeWithNotMarginTop,
            $db1d99891a2fef87$var$rendererTableStyles,
            (0, $dkc63.isStickyScrollbarEnabled)(appearance) && $db1d99891a2fef87$var$stickyScrollbarStyles,
            $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $db1d99891a2fef87$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            (0, $VSDnB.fg)('platform_editor_tables_numbered_column_correction') ? $db1d99891a2fef87$var$rendererTableColumnStyles : $db1d99891a2fef87$var$rendererTableColumnStylesOld,
            $db1d99891a2fef87$var$stickyHeaderStyles,
            $db1d99891a2fef87$var$codeBlockAndLayoutStyles,
            $db1d99891a2fef87$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $db1d99891a2fef87$var$gridRenderForCodeBlockStyles,
            (0, $gE8f9.browser).safari && $db1d99891a2fef87$var$codeBlockInListSafariFixStyles
        ],
        "data-testid": testId
    }, children));
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);
$parcel$export(module.exports, "getSmartCardSharedStyles", () => $bc13534612fcd0a2$export$fbd9b588230965e4);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
const $bc13534612fcd0a2$export$fbd9b588230965e4 = ()=>`
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${0, $iHYdz.blockNodesVerticalMargin} 0 0;
    max-width: ${760}px;
  }

  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */
    ul, ol {
      padding-left: inherit;
    }
    /* EDM-11991: Fix list plugin add padding to ADS AvatarGroup end */
  }
`;

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $67d1fb0f1c6fc210$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");
const $67d1fb0f1c6fc210$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-border-radius, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-border-radius, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $67d1fb0f1c6fc210$var$codeBlockSharedStyles,
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path) {
    let tokens;
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-dst-jira-web-fonts') || (0, $VSDnB.fg)('confluence_typography_refreshed') || (0, $VSDnB.fg)('atlas_editor_typography_refreshed')) tokens = (0, $kqZva.editorUGCTokensRefreshed);
        else tokens = (0, $kqZva.editorUGCTokensModernized);
    } else tokens = (0, $kqZva.editorUGCTokens);
    return tokens[path];
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("aagOn", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $1723ca6d969fec09$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
const $1723ca6d969fec09$export$8e2864079bc476bd = (appearance)=>{
    return appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : 14;
};

});


parcelRegister("dJPoO", function(module, exports) {

$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $364a1dd5fa66cb46$export$c94cfc0c675062a1);
const $364a1dd5fa66cb46$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("kjHuf", function(module, exports) {

$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $d3a3005b3046eec9$export$80ffe7e3c6bf25c3);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
function $d3a3005b3046eec9$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $5uXOq.useRef)(props);
    const prevFactory = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('cc_complexit_fe_reduce_fragment_serialization')) {
            // check if the serializer is already created
            let shouldCreate = !prevFactory.current;
            // check each prop to see if value has changed and also check if the number of props has changed
            if (prev.current !== props) {
                const propsEntries = Object.entries(props);
                shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
            }
            prev.current = props;
            // If first time or any prop value has changed, create a new serializer
            if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
            return prevFactory.current;
        }
        return factory(propsDerivator(props));
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("8QrLL", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $d2ca68ebf215abf7$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $d2ca68ebf215abf7$export$b1072f43c67b540c);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $d2ca68ebf215abf7$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $d2ca68ebf215abf7$export$b1072f43c67b540c = ({ portal: portalFromProps } = {})=>{
    const portalFromContext = (0, $5uXOq.useContext)($d2ca68ebf215abf7$export$60d741e20e0aa309);
    if (portalFromProps) return portalFromProps;
    if ((0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return portalFromContext;
    return undefined;
};

});


parcelRegister("h17zy", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $502e0815e90e6f7b$export$d80cf6b7758b1c7e);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $hXRXz = parcelRequire("hXRXz");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const emojiProvider = (0, $5uXOq.useMemo)(()=>{
        const dataProviders = new (0, $dGzaM.default)();
        dataProviders.setProvider('emojiProvider', (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});

parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("4L2MR", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $0d4861c69889f89e$export$2c1e5dc35269c547);
$parcel$export(module.exports, "adfDocument", () => $0d4861c69889f89e$export$754eb30ac7b536b8);
$parcel$export(module.exports, "getErrorMessage", () => $0d4861c69889f89e$export$82f46aa4e6535a45);

var $4R6GH = parcelRequire("4R6GH");


var $4IoOR = parcelRequire("4IoOR");

var $8Xls4 = parcelRequire("8Xls4");

var $5ewBi = parcelRequire("5ewBi");
const $0d4861c69889f89e$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const LEARN_MORE = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $8Xls4.LEARN_MORE_MESSAGES) : (0, $8Xls4.LEARN_MORE_MESSAGES_OLD);
    if (urlSuffix in LEARN_MORE) return LEARN_MORE[urlSuffix];
    return (0, $5ewBi.default).fieldHelpTextLabel;
};
const $0d4861c69889f89e$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const helperMessage = $0d4861c69889f89e$export$2c1e5dc35269c547(fieldHelpTextUrl) || (0, $5ewBi.default).fieldHelpTextLabel;
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $0d4861c69889f89e$export$754eb30ac7b536b8 = ({ description: description })=>(0, $4IoOR.convertWikiToAdf)(description);
const $0d4861c69889f89e$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $dccd0dbe975cd803$export$b1c05b34d317c074:
            return formatMessage((0, $5ewBi.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $dccd0dbe975cd803$export$618e922e89e8bcae:
            return formatMessage((0, $5ewBi.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $dccd0dbe975cd803$export$fe1a70381f6491b5))
            });
        case 0, $dccd0dbe975cd803$export$d2d79153ead377fe:
            return formatMessage((0, $5ewBi.default).urlInvalidErrorMessage, {
                fieldName: fieldName
            });
        default:
            return validationError;
    }
};

});
const $dccd0dbe975cd803$export$b1c05b34d317c074 = 'REQUIRED';
const $dccd0dbe975cd803$export$618e922e89e8bcae = 'STRING_INVALID';
const $dccd0dbe975cd803$export$fe1a70381f6491b5 = 255;
const $dccd0dbe975cd803$export$d2d79153ead377fe = 'URL_INVALID';

parcelRegister("4IoOR", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $7c8efe67867622a1$export$3dfdef94497f0395);

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");

var $dN5CS = parcelRequire("dN5CS");
const $7c8efe67867622a1$var$wikiTransformer = new (0, $dN5CS.WikiMarkupTransformer)((0, $kOFhM.defaultSchema));
const $7c8efe67867622a1$var$adfTransformer = new (0, $hYNZx.JSONTransformer)();
const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
    return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("dN5CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $4011ad83704160d6$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $4011ad83704160d6$export$2e2bcd8739ae039);

var $kOFhM = parcelRequire("kOFhM");

var $lxtC7 = parcelRequire("lxtC7");

var $djcbG = parcelRequire("djcbG");

var $bOMPB = parcelRequire("bOMPB");
class $4011ad83704160d6$export$caaa00407b56b900 {
    constructor(schema = (0, $kOFhM.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $lxtC7.encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $djcbG.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $bOMPB.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;

});
parcelRegister("lxtC7", function(module, exports) {

$parcel$export(module.exports, "encode", () => $f10f1fd2bcfd2732$export$c564cdbbe6da493);

var $03QYI = parcelRequire("03QYI");

var $6ises = parcelRequire("6ises");

var $hgytR = parcelRequire("hgytR");

var $b6sEJ = parcelRequire("b6sEJ");

var $73kPn = parcelRequire("73kPn");

var $1B6CN = parcelRequire("1B6CN");

var $8UMD2 = parcelRequire("8UMD2");

var $fIzNZ = parcelRequire("fIzNZ");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");

var $h9tzi = parcelRequire("h9tzi");

var $abXFq = parcelRequire("abXFq");

var $flJtr = parcelRequire("flJtr");

var $czgKo = parcelRequire("czgKo");

var $acqkf = parcelRequire("acqkf");

var $1Nefo = parcelRequire("1Nefo");

var $69N10 = parcelRequire("69N10");

var $12A17 = parcelRequire("12A17");

var $bsbI5 = parcelRequire("bsbI5");
const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
    blockquote: $03QYI.blockquote,
    bulletList: $6ises.bulletList,
    taskList: $hgytR.taskList,
    decisionList: $b6sEJ.decisionList,
    codeBlock: $73kPn.codeBlock,
    doc: $1B6CN.doc,
    heading: $fIzNZ.heading,
    caption: $bsbI5.caption,
    mediaGroup: $eTlm6.mediaGroup,
    mediaInline: $6obXI.mediaInline,
    mediaSingle: (0, $eTlm6.mediaGroup),
    orderedList: $h9tzi.orderedList,
    panel: $abXFq.panel,
    paragraph: $flJtr.paragraph,
    rule: $czgKo.rule,
    table: $acqkf.table,
    blockCard: $69N10.blockCard,
    embedCard: $12A17.embedCard,
    expand: $8UMD2.expand
};
function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
    const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $1Nefo.unknown)(node);
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
}

});
parcelRegister("03QYI", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $f393e710d4117486$export$67dc04e652a298ca);

var $lxtC7 = parcelRequire("lxtC7");
const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("6ises", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $92e38ddcaccbcaf0$export$a140c94e5ea26bee);

var $bxtEu = parcelRequire("bxtEu");
const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("bxtEu", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b39a87ae4fdec39c$export$76c7e83ecc9cdf05);

var $lxtC7 = parcelRequire("lxtC7");

var $flJtr = parcelRequire("flJtr");

var $1Nefo = parcelRequire("1Nefo");

var $73kPn = parcelRequire("73kPn");

var $eTlm6 = parcelRequire("eTlm6");

var $6obXI = parcelRequire("6obXI");
const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $flJtr.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $lxtC7.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $73kPn.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $6obXI.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $eTlm6.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $1Nefo.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("flJtr", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3fb83d21e304518d$export$9c206ddddb32a9b);

var $bK2QZ = parcelRequire("bK2QZ");
const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("bK2QZ", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $d36b73d9ad63ab63$export$96c94bfc00b85760);

var $91ILy = parcelRequire("91ILy");

var $e34Iq = parcelRequire("e34Iq");

var $6obXI = parcelRequire("6obXI");

var $7GCbZ = parcelRequire("7GCbZ");

var $6ayzl = parcelRequire("6ayzl");

var $5IuwX = parcelRequire("5IuwX");

var $1HDja = parcelRequire("1HDja");

var $1Nefo = parcelRequire("1Nefo");

var $c08Yp = parcelRequire("c08Yp");
const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
    emoji: $91ILy.emoji,
    hardBreak: $e34Iq.hardBreak,
    mediaInline: $6obXI.mediaInline,
    mention: $7GCbZ.mention,
    text: $6ayzl.text,
    inlineCard: $5IuwX.inlineCard,
    status: $1HDja.status,
    date: $c08Yp.date
};
const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("91ILy", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $15d1256cf1644afa$export$a19185d1233fc4b2);

var $g5UJK = parcelRequire("g5UJK");

var $1Nefo = parcelRequire("1Nefo");
const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $g5UJK.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $1Nefo.unknown)(node);
};

});
parcelRegister("g5UJK", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("1Nefo", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $6e7c0aa132a04ffb$export$19282c40b967aec6);

var $hYNZx = parcelRequire("hYNZx");
const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, $hYNZx.JSONTransformer)();
const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("e34Iq", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $0b90673427e9e36d$export$371da9dd35aba193);
const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("6obXI", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $b266c76290bae2fd$export$38bab695e3f720f1);
const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("7GCbZ", function(module, exports) {

$parcel$export(module.exports, "mention", () => $276f00c4f54975e4$export$db83999c14438df4);
const $276f00c4f54975e4$var$PREFIX = 'accountid:';
const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("6ayzl", function(module, exports) {

$parcel$export(module.exports, "text", () => $774ee87c38efef1c$export$6f093cfa640b7166);

var $cG4PY = parcelRequire("cG4PY");

var $4yZSi = parcelRequire("4yZSi");

var $aDTWq = parcelRequire("aDTWq");

var $gdFeW = parcelRequire("gdFeW");

var $jo5YT = parcelRequire("jo5YT");

var $9fwgI = parcelRequire("9fwgI");

var $eKxrE = parcelRequire("eKxrE");

var $1x55I = parcelRequire("1x55I");

var $8tKGr = parcelRequire("8tKGr");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $774ee87c38efef1c$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $gdFeW.em)
    ],
    [
        'strike',
        (0, $9fwgI.strike)
    ],
    [
        'strong',
        (0, $eKxrE.strong)
    ],
    [
        'subsup',
        (0, $1x55I.subsup)
    ],
    [
        'underline',
        (0, $8tKGr.underline)
    ],
    [
        'textColor',
        (0, $aDTWq.textColor)
    ],
    [
        'link',
        (0, $jo5YT.link)
    ],
    [
        'code',
        (0, $4yZSi.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
    const pattern = [
        $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
        ...(0, $cG4PY.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
    $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("cG4PY", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $87fdd6b952f97dba$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $87fdd6b952f97dba$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $87fdd6b952f97dba$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $87fdd6b952f97dba$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $87fdd6b952f97dba$export$bcec6d03770b152c);

var $kSL4h = parcelRequire("kSL4h");

var $ayQVO = parcelRequire("ayQVO");
const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
    {
        type: (0, $kSL4h.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $kSL4h.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $kSL4h.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $kSL4h.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $kSL4h.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $kSL4h.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $kSL4h.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $87fdd6b952f97dba$var$keywordTokenMap = {
    '[': (0, $kSL4h.TokenType).LINK_FORMAT,
    http: (0, $kSL4h.TokenType).LINK_TEXT,
    ftp: (0, $kSL4h.TokenType).LINK_TEXT,
    jamfselfservice: (0, $kSL4h.TokenType).LINK_TEXT,
    irc: (0, $kSL4h.TokenType).LINK_TEXT,
    mailto: (0, $kSL4h.TokenType).LINK_TEXT,
    '\\\\': (0, $kSL4h.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $kSL4h.TokenType).HARD_BREAK,
    '\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '\r\n': (0, $kSL4h.TokenType).HARD_BREAK,
    '!': (0, $kSL4h.TokenType).MEDIA,
    '----': (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $kSL4h.TokenType).DELETED,
    '{+}': (0, $kSL4h.TokenType).INSERTED,
    '{*}': (0, $kSL4h.TokenType).STRONG,
    '{^}': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '{~}': (0, $kSL4h.TokenType).SUBSCRIPT,
    '{_}': (0, $kSL4h.TokenType).EMPHASIS,
    '{{{}': (0, $kSL4h.TokenType).MONOSPACE,
    '{??}': (0, $kSL4h.TokenType).CITATION,
    '-': (0, $kSL4h.TokenType).DELETED,
    '+': (0, $kSL4h.TokenType).INSERTED,
    '*': (0, $kSL4h.TokenType).STRONG,
    '^': (0, $kSL4h.TokenType).SUPERSCRIPT,
    '~': (0, $kSL4h.TokenType).SUBSCRIPT,
    _: (0, $kSL4h.TokenType).EMPHASIS,
    '{{': (0, $kSL4h.TokenType).MONOSPACE,
    '??': (0, $kSL4h.TokenType).CITATION
};
const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
        const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
            type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $kSL4h.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
    {
        type: (0, $kSL4h.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $kSL4h.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $kSL4h.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $kSL4h.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $ayQVO.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $kSL4h.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $87fdd6b952f97dba$export$68162fc57528b560(input) {
    for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
        const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $kSL4h.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("kSL4h", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $160d182608400c84$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $160d182608400c84$export$af8f4e8328578827);

var $4Foyv = parcelRequire("4Foyv");

var $30Un5 = parcelRequire("30Un5");

var $coK8g = parcelRequire("coK8g");

var $5RdHN = parcelRequire("5RdHN");

var $55t1E = parcelRequire("55t1E");

var $jor5q = parcelRequire("jor5q");

var $hZ14o = parcelRequire("hZ14o");

var $6xaH8 = parcelRequire("6xaH8");

var $jMpI6 = parcelRequire("jMpI6");

var $iDsRr = parcelRequire("iDsRr");

var $7tIdE = parcelRequire("7tIdE");

var $1MGc3 = parcelRequire("1MGc3");

var $ayQVO = parcelRequire("ayQVO");

var $kPrK8 = parcelRequire("kPrK8");

var $4ZFIG = parcelRequire("4ZFIG");

var $91y57 = parcelRequire("91y57");

var $1Mtv8 = parcelRequire("1Mtv8");

var $77w3e = parcelRequire("77w3e");

var $lf0Nr = parcelRequire("lf0Nr");

var $4s89q = parcelRequire("4s89q");

var $ir9MO = parcelRequire("ir9MO");

var $7E14k = parcelRequire("7E14k");

var $9MeiU = parcelRequire("9MeiU");

var $f50H1 = parcelRequire("f50H1");

var $bSil4 = parcelRequire("bSil4");

var $4Dfwq = parcelRequire("4Dfwq");

var $cjZPi = parcelRequire("cjZPi");

var $8tGpW = parcelRequire("8tGpW");

var $lyI5i = parcelRequire("lyI5i");

var $bOMPB = parcelRequire("bOMPB");
var $160d182608400c84$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $160d182608400c84$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $55t1E.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $ir9MO.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $4ZFIG.quadrupleDashSymbol),
    ["RULER"]: (0, $91y57.ruler),
    ["STRONG"]: (0, $1Mtv8.strong),
    ["MONOSPACE"]: (0, $kPrK8.monospace),
    ["SUPERSCRIPT"]: (0, $lf0Nr.superscript),
    ["SUBSCRIPT"]: (0, $77w3e.subscript),
    ["EMPHASIS"]: (0, $hZ14o.emphasis),
    ["CITATION"]: (0, $coK8g.citation),
    ["DELETED"]: (0, $5RdHN.deleted),
    ["INSERTED"]: (0, $iDsRr.inserted),
    ["HARD_BREAK"]: (0, $6xaH8.hardbreak),
    ["LINK_FORMAT"]: (0, $7tIdE.linkFormat),
    ["LINK_TEXT"]: (0, $1MGc3.linkText),
    ["HEADING"]: (0, $jMpI6.heading),
    ["MEDIA"]: (0, $4Foyv.media),
    ["LIST"]: (0, $ayQVO.list),
    ["QUOTE"]: (0, $30Un5.blockquote),
    ["TABLE"]: (0, $4s89q.table),
    ["EMOJI"]: (0, $jor5q.emoji),
    ["ADF_MACRO"]: (0, $9MeiU.adfMacro),
    ["ANCHOR_MACRO"]: (0, $f50H1.anchorMacro),
    ["CODE_MACRO"]: (0, $bSil4.codeMacro),
    ["QUOTE_MACRO"]: (0, $4Dfwq.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $8tGpW.noformatMacro),
    ["PANEL_MACRO"]: (0, $7E14k.panelMacro),
    ["COLOR_MACRO"]: (0, $cjZPi.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $lyI5i.forceLineBreak),
    ["ISSUE_KEY"]: (0, $bOMPB.issueKey)
};
function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $160d182608400c84$var$fallback(input, position);
    }
    return $160d182608400c84$var$fallback(input, position);
}
function $160d182608400c84$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Foyv", function(module, exports) {

$parcel$export(module.exports, "media", () => $8b246e16d82e8dde$export$987d49ffe1b0900f);

var $4V377 = parcelRequire("4V377");

var $4ZUg7 = parcelRequire("4ZUg7");

var $eyO0H = parcelRequire("eyO0H");
const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $4V377.default)(schema, rawContent, (0, $4ZUg7.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("4V377", function(module, exports) {

$parcel$export(module.exports, "default", () => $2106e5f40786af56$export$2e2bcd8739ae039);

var $1MGc3 = parcelRequire("1MGc3");
const $2106e5f40786af56$var$defaultWidth = 200;
const $2106e5f40786af56$var$defaultHeight = 183;
const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $1MGc3.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("1MGc3", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $49f89f13b4b7c481$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $49f89f13b4b7c481$export$cb7bcf09a05b7705);

var $iZOJ9 = parcelRequire("iZOJ9");

var $iqYHB = parcelRequire("iqYHB");
const $49f89f13b4b7c481$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
    if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
    const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $iqYHB.decode)($49f89f13b4b7c481$var$unescape(match[0]));
    if (!(0, $iZOJ9.isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $49f89f13b4b7c481$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $49f89f13b4b7c481$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $49f89f13b4b7c481$var$trimBadEndChar(input) {
    return [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("iqYHB", function(module, exports) {

$parcel$export(module.exports, "decode", () => $c6b4ec3136742c55$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("4ZUg7", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $972abf9f01734b21$export$e1a9355cfd8f6c64);
function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("eyO0H", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $dee2bdf3f1017b16$export$a71d57024d3da1c5);

var $kSL4h = parcelRequire("kSL4h");

var $7tIdE = parcelRequire("7tIdE");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $2weJO = parcelRequire("2weJO");
const $dee2bdf3f1017b16$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $dee2bdf3f1017b16$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $dee2bdf3f1017b16$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $dee2bdf3f1017b16$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $dee2bdf3f1017b16$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $dee2bdf3f1017b16$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $kSL4h.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                }
            case $dee2bdf3f1017b16$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $dee2bdf3f1017b16$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
}
function $dee2bdf3f1017b16$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("7tIdE", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $0412731f8f85cc95$export$e1f888a4b6f2ee53);

var $kSL4h = parcelRequire("kSL4h");

var $29zBb = parcelRequire("29zBb");

var $9jjzg = parcelRequire("9jjzg");

var $gGleW = parcelRequire("gGleW");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        // We want to avoid recursion
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).LINK_FORMAT
    ];
    if (!match) return $0412731f8f85cc95$var$fallback();
    const content = (0, $gGleW.parseContentLink)(match[1]);
    const resolvedLink = (0, $9jjzg.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $0412731f8f85cc95$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("29zBb", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $e7a948cf285a18ed$export$960addfb9e5a0cde);

var $04cDS = parcelRequire("04cDS");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $2weJO = parcelRequire("2weJO");

var $20lXC = parcelRequire("20lXC");
const $e7a948cf285a18ed$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $e7a948cf285a18ed$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $kSL4h.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $e7a948cf285a18ed$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $eWAZI.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $cG4PY.parseLeadingKeyword)(substring) || (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                }
            case $e7a948cf285a18ed$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $cG4PY.parseOtherKeyword)(substring);
                    else match = (0, $cG4PY.parseMacroKeyword)(substring) || (0, $cG4PY.parseOtherKeyword)(substring) || (0, $cG4PY.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $e7a948cf285a18ed$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $e7a948cf285a18ed$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $e7a948cf285a18ed$var$processState.TOKEN:
                {
                    const token = (0, $kSL4h.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $kSL4h.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $04cDS.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $kSL4h.TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                    else state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            case $e7a948cf285a18ed$var$processState.ESCAPE:
                {
                    const token = (0, $2weJO.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $e7a948cf285a18ed$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $20lXC.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $04cDS.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("04cDS", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $e67b0538295ca231$export$b2ce9ad90858ed7a);
function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("eWAZI", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $b3a19bb1e901f2d4$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $b3a19bb1e901f2d4$export$9c597b035e16623b);
function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
    const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("2weJO", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $35d0c4c2d3000f41$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("20lXC", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $50669f552f016dd9$export$e21f6b7efdaf8b5d);

var $4UJvN = parcelRequire("4UJvN");
function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $50669f552f016dd9$var$normalizeMediaGroups,
        $50669f552f016dd9$export$2cef2a4c047f9887,
        $50669f552f016dd9$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $4UJvN.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $4UJvN.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $50669f552f016dd9$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("4UJvN", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $4ae1f625ac901e34$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $4ae1f625ac901e34$export$f0eaed48ea684567);
function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("9jjzg", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $c08b1d888f635e2c$export$c2baa561eb017101);

var $30RSK = parcelRequire("30RSK");

var $lRYXZ = parcelRequire("lRYXZ");

var $b0Iw2 = parcelRequire("b0Iw2");

var $k1MiS = parcelRequire("k1MiS");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $c08b1d888f635e2c$var$linkResolverStrategies = [
    (0, $lRYXZ.attachmentLinkResolver),
    (0, $30RSK.mentionLinkResolver),
    (0, $k1MiS.issueLinkResolver),
    (0, $b0Iw2.urlLinkResolver)
];
function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("30RSK", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("lRYXZ", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $2514090e6b8dffff$export$ce918f41a76b8445);

var $4vpto = parcelRequire("4vpto");
function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4vpto.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4vpto", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a1bc635a5ad9a$export$2e2bcd8739ae039);
function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("b0Iw2", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $e20b005b86e07eab$export$b737d556d2167f9);

var $kSL4h = parcelRequire("kSL4h");

var $iZOJ9 = parcelRequire("iZOJ9");

var $29zBb = parcelRequire("29zBb");

var $gxAE9 = parcelRequire("gxAE9");
function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $iZOJ9.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $e20b005b86e07eab$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("gxAE9", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $fd57502cc274f1df$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $fd57502cc274f1df$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $fd57502cc274f1df$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $fd57502cc274f1df$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $fd57502cc274f1df$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $fd57502cc274f1df$export$83347051c3437dc9);
function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!value.match(/^\d$/);
}
function $fd57502cc274f1df$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
    return !$fd57502cc274f1df$export$7ee701e290d9865(value);
}
const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $fd57502cc274f1df$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("k1MiS", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $7a9a102a7215e3d4$export$f40ed0efa65d4e8);

var $bOMPB = parcelRequire("bOMPB");
function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Depricated should be removed in the next major release
    linkTitle === 'block-link') return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $bOMPB.getIssue)(context, originalLinkText);
    if (issue) return (0, $bOMPB.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("bOMPB", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $ce5ca7baa00e39d0$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $ce5ca7baa00e39d0$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $ce5ca7baa00e39d0$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $ce5ca7baa00e39d0$export$cd8701ad7512efee);

var $gxAE9 = parcelRequire("gxAE9");
const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $gxAE9.isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, $gxAE9.isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("gGleW", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $57e1d7866034b37b$export$3a250a08d37b0eae);

var $gxAE9 = parcelRequire("gxAE9");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $57e1d7866034b37b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $57e1d7866034b37b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
    const body = new (0, $gxAE9.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $57e1d7866034b37b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $57e1d7866034b37b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $57e1d7866034b37b$var$extractNumber(buf) {
    const digits = new (0, $gxAE9.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $gxAE9.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $gxAE9.StringBuffer)(linkText);
    const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
    const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $gxAE9.StringBuffer)(notLinkBody);
        shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $gxAE9.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $gxAE9.StringBuffer)(notLinkBody);
    if ((0, $gxAE9.isBlank)(shortcutName)) {
        spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $57e1d7866034b37b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
        anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("30Un5", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $0c863b8155c1a336$export$67dc04e652a298ca);

var $4Dfwq = parcelRequire("4Dfwq");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
    if (!match) return $0c863b8155c1a336$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $4Dfwq.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $0c863b8155c1a336$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("4Dfwq", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $0723b4b23edf777c$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $0723b4b23edf777c$export$c2a5e4612254bfa);

var $3JW2n = parcelRequire("3JW2n");

var $gxAE9 = parcelRequire("gxAE9");

var $20lXC = parcelRequire("20lXC");

var $29zBb = parcelRequire("29zBb");
const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
        context: context
    });
};
const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $0723b4b23edf777c$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $0723b4b23edf777c$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $0723b4b23edf777c$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $gxAE9.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("3JW2n", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $108725731ca4984f$export$b6a12943ac1bb1ba);
function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $108725731ca4984f$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $108725731ca4984f$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("coK8g", function(module, exports) {

$parcel$export(module.exports, "citation", () => $624cf9f0f9a0e4f4$export$258632c953c109e9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");

const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("5RdHN", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $b9ac580681c978af$export$bccbf0c716f226f4);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("55t1E", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $74a06c4540bbf40b$export$65e3ca7c95899a2d);

var $1rQjR = parcelRequire("1rQjR");
const $74a06c4540bbf40b$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $74a06c4540bbf40b$var$fallback = {
    ...$74a06c4540bbf40b$var$token,
    text: '--'
};
const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, $1rQjR.createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);

});
parcelRegister("1rQjR", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $75f433a8b52a8173$export$d43b58865d429e3c);
const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $75f433a8b52a8173$var$isSpace = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\s/.test(char);
};

});


parcelRegister("jor5q", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $487b5ddb28312972$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $487b5ddb28312972$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("hZ14o", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $5100d4ec4f1b4884$export$bef81ba411953b51);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("6xaH8", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $bc70e1090faff3e6$export$ac55bb44695749c1);

var $eWAZI = parcelRequire("eWAZI");
const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jMpI6", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ed15d3e22c065f91$export$46e4a324ac90507f);

var $29zBb = parcelRequire("29zBb");

var $kSL4h = parcelRequire("kSL4h");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
    if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $29zBb.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $ed15d3e22c065f91$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("iDsRr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $33f79eddf582429a$export$744ba74fb86b8ca7);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ayQVO", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $4813b87fbe6448cc$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $4813b87fbe6448cc$export$8837f4fc672e936d);

var $hnQWb = parcelRequire("hnQWb");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $cG4PY = parcelRequire("cG4PY");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $gxAE9 = parcelRequire("gxAE9");
const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $4813b87fbe6448cc$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE
    ];
    let index = position;
    let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $4813b87fbe6448cc$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $4813b87fbe6448cc$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $29zBb.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $hnQWb.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $hnQWb.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $4813b87fbe6448cc$var$processState.END;
                        continue;
                    }
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $4813b87fbe6448cc$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $4813b87fbe6448cc$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                    continue;
                }
            case $4813b87fbe6448cc$var$processState.END:
                if (!builder) // Something is really wrong here
                return $4813b87fbe6448cc$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $29zBb.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $4813b87fbe6448cc$var$sanitize((0, $20lXC.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $4813b87fbe6448cc$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("hnQWb", function(module, exports) {

$parcel$export(module.exports, "getType", () => $3303253e6091964c$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $3303253e6091964c$export$876cfa3161bef296);
const $3303253e6091964c$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $3303253e6091964c$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kPrK8", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).ADF_MACRO,
        (0, $kSL4h.TokenType).ANCHOR_MACRO,
        (0, $kSL4h.TokenType).CODE_MACRO,
        (0, $kSL4h.TokenType).QUOTE_MACRO,
        (0, $kSL4h.TokenType).NOFORMAT_MACRO,
        (0, $kSL4h.TokenType).PANEL_MACRO,
        (0, $kSL4h.TokenType).COLOR_MACRO,
        (0, $kSL4h.TokenType).LOREM_MACRO,
        (0, $kSL4h.TokenType).QUOTE,
        (0, $kSL4h.TokenType).STRING,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).LINK_FORMAT,
        (0, $kSL4h.TokenType).LINK_TEXT,
        (0, $kSL4h.TokenType).MEDIA,
        (0, $kSL4h.TokenType).HEADING,
        (0, $kSL4h.TokenType).LIST,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER,
        (0, $kSL4h.TokenType).HARD_BREAK,
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).STRONG,
        (0, $kSL4h.TokenType).MONOSPACE,
        (0, $kSL4h.TokenType).SUPERSCRIPT,
        (0, $kSL4h.TokenType).SUBSCRIPT,
        (0, $kSL4h.TokenType).EMPHASIS,
        (0, $kSL4h.TokenType).CITATION,
        (0, $kSL4h.TokenType).DELETED,
        (0, $kSL4h.TokenType).INSERTED,
        (0, $kSL4h.TokenType).EMOJI,
        (0, $kSL4h.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4ZFIG", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $819171e80205fd1c$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("91y57", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $cf2c039554fba6e4$export$f9adada2013e846e);

var $i8dZb = parcelRequire("i8dZb");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $i8dZb.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("i8dZb", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $d0cc271b2b6d9a56$export$4267f2e5716b018a);
const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("1Mtv8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $da489456937eda28$export$59ae2c325a998f89);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("77w3e", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $af8d85604a001a66$export$bc5390e4688d2822);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lf0Nr", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $6f4f331694cf9bb6$export$b4aab94a5fcfcead);

var $kSL4h = parcelRequire("kSL4h");

var $gxAE9 = parcelRequire("gxAE9");

var $eyO0H = parcelRequire("eyO0H");

var $29zBb = parcelRequire("29zBb");
const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).ISSUE_KEY,
        (0, $kSL4h.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $gxAE9.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $eyO0H.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4s89q", function(module, exports) {

$parcel$export(module.exports, "table", () => $8c7a9474c5649f43$export$9852986a3ec5f6a0);

var $48GZN = parcelRequire("48GZN");

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");

var $7tIdE = parcelRequire("7tIdE");

var $4Foyv = parcelRequire("4Foyv");

var $jor5q = parcelRequire("jor5q");

var $kSL4h = parcelRequire("kSL4h");

var $eWAZI = parcelRequire("eWAZI");

var $cG4PY = parcelRequire("cG4PY");

var $gxAE9 = parcelRequire("gxAE9");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8c7a9474c5649f43$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE,
        (0, $kSL4h.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $8c7a9474c5649f43$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $48GZN.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                    if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                    else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.BUFFER:
                {
                    const length = (0, $eWAZI.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else {
                            currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $8c7a9474c5649f43$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $8c7a9474c5649f43$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $8c7a9474c5649f43$var$processState.MEDIA:
                {
                    const token = (0, $4Foyv.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.EMOJI:
                {
                    const token = (0, $jor5q.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
            case $8c7a9474c5649f43$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $7tIdE.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $8c7a9474c5649f43$var$processState.MACRO:
                {
                    const match = (0, $cG4PY.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $kSL4h.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $29zBb.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $8c7a9474c5649f43$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $20lXC.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
}

});
parcelRegister("48GZN", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $75a71ab9390c3135$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $75a71ab9390c3135$var$getType(style) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $75a71ab9390c3135$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $75a71ab9390c3135$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("ir9MO", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $0a377f498827084a$export$edbcd749367de060);

var $1rQjR = parcelRequire("1rQjR");
const $0a377f498827084a$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $0a377f498827084a$var$fallback = {
    ...$0a377f498827084a$var$token,
    text: '---'
};
const $0a377f498827084a$export$edbcd749367de060 = (0, $1rQjR.createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);

});

parcelRegister("7E14k", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $fa58ef1a18570456$export$5d7bf7e31a674541);

var $3JW2n = parcelRequire("3JW2n");

var $29zBb = parcelRequire("29zBb");

var $4ZUg7 = parcelRequire("4ZUg7");

var $20lXC = parcelRequire("20lXC");

var $fQoRM = parcelRequire("fQoRM");

var $1agyv = parcelRequire("1agyv");
const $fa58ef1a18570456$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
    });
};
const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $fQoRM.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $29zBb.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $20lXC.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $1agyv.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $fa58ef1a18570456$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $fa58ef1a18570456$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("fQoRM", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $afb9d2bd4cb626dc$export$fa00fa3d6c22a747);

var $4PfBJ = parcelRequire("4PfBJ");
const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
    const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $afb9d2bd4cb626dc$var$generateRgb(color) {
    switch(true){
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $afb9d2bd4cb626dc$var$parseHex(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $afb9d2bd4cb626dc$var$parseRgb(color);
        case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $afb9d2bd4cb626dc$var$parsePrgb(color);
        default:
            return $afb9d2bd4cb626dc$var$parseColorName(color);
    }
}
function $afb9d2bd4cb626dc$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
    const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
    const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $afb9d2bd4cb626dc$var$parseColorName(color) {
    return (0, $4PfBJ.default)[color];
}

});
parcelRegister("4PfBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
const $fe6de0fe9d8acfe8$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;

});


parcelRegister("1agyv", function(module, exports) {

$parcel$export(module.exports, "title", () => $9eccd901f1df184b$export$fb184b623420d9be);
function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("9MeiU", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $39fb2727ee273b16$export$8fb4b58db8f664fb);

var $3JW2n = parcelRequire("3JW2n");
const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
    });
};
const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("f50H1", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $4b331e3d410cf176$export$e660dadc21580fa2);

var $3JW2n = parcelRequire("3JW2n");
const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
    });
};
const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("bSil4", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $38ee74463de0ec95$export$db6c131ac26c7700);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
    });
};
const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cjZPi", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $2374771f8fbda9ef$export$b557be495948d995);

var $kSL4h = parcelRequire("kSL4h");

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $29zBb = parcelRequire("29zBb");

var $7p5zM = parcelRequire("7p5zM");

var $gxAE9 = parcelRequire("gxAE9");
const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
    });
};
const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $kSL4h.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $kSL4h.TokenType).TABLE
    ];
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    const content = (0, $29zBb.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $7p5zM.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $gxAE9.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("7p5zM", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $dace0eb9654d7c1b$export$c0cfc6f23e0b7578);

var $51H8P = parcelRequire("51H8P");
function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $51H8P.normalizeHexColor)(keys[0]);
}

});


parcelRegister("8tGpW", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7fe042bf55811a5b$export$9199752eb9b2d5b4);

var $3JW2n = parcelRequire("3JW2n");

var $4ZUg7 = parcelRequire("4ZUg7");

var $1agyv = parcelRequire("1agyv");
const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $3JW2n.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
    });
};
const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $4ZUg7.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $1agyv.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("lyI5i", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $90e9f72be02de2ac$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
    }
    const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $90e9f72be02de2ac$var$fallback(input, position);
};
function $90e9f72be02de2ac$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("4yZSi", function(module, exports) {

$parcel$export(module.exports, "code", () => $e115b67b9a7c1782$export$6565f9f03506010b);
const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("aDTWq", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $ef3e88b1064ccc35$export$32f78bffcd82ff28);
const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("gdFeW", function(module, exports) {

$parcel$export(module.exports, "em", () => $e431017de2633455$export$c63c6f932822f543);

var $3ovek = parcelRequire("3ovek");
const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $3ovek.baseMarkPattern)(text.substring(2), '??');
    return (0, $3ovek.baseMarkPattern)(text, '_');
};

});
parcelRegister("3ovek", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $7f6f940a63ef31a6$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("jo5YT", function(module, exports) {

$parcel$export(module.exports, "link", () => $5614ddd827a3bd70$export$9c30223ca0a664fb);
const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("9fwgI", function(module, exports) {

$parcel$export(module.exports, "strike", () => $486b01102f007d8c$export$4899a95d70ec5056);

var $3ovek = parcelRequire("3ovek");
const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '-');
};

});

parcelRegister("eKxrE", function(module, exports) {

$parcel$export(module.exports, "strong", () => $5f94e33f4e7efc4b$export$59ae2c325a998f89);

var $3ovek = parcelRequire("3ovek");
const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '*');
};

});

parcelRegister("1x55I", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $de8ae0bb6a3c8a22$export$b3401ee80eb31041);

var $3ovek = parcelRequire("3ovek");
const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $3ovek.baseMarkPattern)(text, '~');
    else return (0, $3ovek.baseMarkPattern)(text, '^');
};

});

parcelRegister("8tKGr", function(module, exports) {

$parcel$export(module.exports, "underline", () => $bb8b641056119651$export$425327af25286e5e);

var $3ovek = parcelRequire("3ovek");
const $bb8b641056119651$export$425327af25286e5e = (text)=>{
    return (0, $3ovek.baseMarkPattern)(text, '+');
};

});


parcelRegister("5IuwX", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $c6769d560338119d$export$cbf8224b64e0d942);

var $1Nefo = parcelRequire("1Nefo");

var $bOMPB = parcelRequire("bOMPB");
const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    const match = node.attrs.url.match((0, $bOMPB.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("1HDja", function(module, exports) {

$parcel$export(module.exports, "status", () => $d0c82c4f36685012$export$471f7ae5c4103ae1);

var $aDTWq = parcelRequire("aDTWq");

const $d0c82c4f36685012$var$color = {
    grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
    purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
    blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
    red: (0, $829f609a65d26a98$export$4a7404f376229999),
    yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
    green: (0, $829f609a65d26a98$export$940e1f69e873f202)
};
const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
    else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
    return (0, $aDTWq.textColor)(text, newAttrs);
};

});

parcelRegister("c08Yp", function(module, exports) {

$parcel$export(module.exports, "date", () => $61a6161cda09885d$export$324d90190a8b822a);
const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("73kPn", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $ef6a5d3a665df695$export$7bb0d5c671655cc4);

var $bK2QZ = parcelRequire("bK2QZ");
const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            parent: node
        });
    });
    if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("eTlm6", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $b3a3fb1c58065f07$export$2855e964765eac9);

var $bsbI5 = parcelRequire("bsbI5");

var $48ot6 = parcelRequire("48ot6");

var $1Nefo = parcelRequire("1Nefo");
const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $48ot6.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $bsbI5.caption)(n, opts));
                break;
            default:
                result.push((0, $1Nefo.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("bsbI5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);

var $bK2QZ = parcelRequire("bK2QZ");
const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("48ot6", function(module, exports) {

$parcel$export(module.exports, "media", () => $df984bb2074676e8$export$987d49ffe1b0900f);
const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("hgytR", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $1fb2a139f9f264bf$export$375b6afcc5f4d291);

var $4kMeo = parcelRequire("4kMeo");
const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
        else result.push((0, $4kMeo.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
    return $1fb2a139f9f264bf$var$nestedNode(node);
};

});
parcelRegister("4kMeo", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $b96ea7b246afcc42$export$6d8b0ef52e2e6390);

var $bK2QZ = parcelRequire("bK2QZ");
const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $bK2QZ.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("b6sEJ", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $9054c6d3a6a22504$export$62d45a65fb43d95e);

var $h0oA4 = parcelRequire("h0oA4");
const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $h0oA4.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("h0oA4", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $6209b59f60b56dcd$export$6959e16eeff859b4);

var $bK2QZ = parcelRequire("bK2QZ");
const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $bK2QZ.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("1B6CN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $5ce407caf0707589$export$2a111da947c407d2);

var $lxtC7 = parcelRequire("lxtC7");
const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("8UMD2", function(module, exports) {

$parcel$export(module.exports, "expand", () => $dcda58106fc3b9ff$export$9f77e0932fb78f72);

var $lxtC7 = parcelRequire("lxtC7");
const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("fIzNZ", function(module, exports) {

$parcel$export(module.exports, "heading", () => $2a94cb79881b69b7$export$46e4a324ac90507f);

var $bK2QZ = parcelRequire("bK2QZ");
const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $bK2QZ.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("h9tzi", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $c2a8fd1ebb40e986$export$a5dc81035676e7a);

var $bxtEu = parcelRequire("bxtEu");
const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $bxtEu.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("abXFq", function(module, exports) {

$parcel$export(module.exports, "panel", () => $d8008c2d580ced87$export$21f42ab9b6679f44);

var $lxtC7 = parcelRequire("lxtC7");
const $d8008c2d580ced87$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("czgKo", function(module, exports) {

$parcel$export(module.exports, "rule", () => $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("acqkf", function(module, exports) {

$parcel$export(module.exports, "table", () => $6deed74ceb5bf80f$export$9852986a3ec5f6a0);

var $lxtC7 = parcelRequire("lxtC7");

var $1Nefo = parcelRequire("1Nefo");
const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $1Nefo.unknown)(node);
    }
};
const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
    if ($6deed74ceb5bf80f$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $lxtC7.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("69N10", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0c06383b3aca4143$export$c4c2f833baaebdb8);

var $1Nefo = parcelRequire("1Nefo");
const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("12A17", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $c9c7f4b278041854$export$be4283d9a1cb1ff6);

var $1Nefo = parcelRequire("1Nefo");
const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $1Nefo.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("djcbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f62fc9e2776603$export$2e2bcd8739ae039);

var $29zBb = parcelRequire("29zBb");

var $20lXC = parcelRequire("20lXC");
class $74f62fc9e2776603$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $29zBb.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $20lXC.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("8Xls4", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_OLD", () => $2ddd56f412c59d37$export$ed551050ae4441e4);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $2ddd56f412c59d37$export$eedb1bf75e1efb26);

var $5ewBi = parcelRequire("5ewBi");
const $2ddd56f412c59d37$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels',
    TimeTracking: '#TimeTracking',
    LogWork: '#LogWork'
};
const $2ddd56f412c59d37$export$ed551050ae4441e4 = {
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.IssueTypes]: (0, $5ewBi.default).fieldHelpIssueTypes,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $5ewBi.default).fieldHelpPriorityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $5ewBi.default).fieldHelpResolutionDefinitions,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $5ewBi.default).fieldHelpSecurityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.TimeTracking]: (0, $5ewBi.default).fieldHelpTimeTracking,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.LogWork]: (0, $5ewBi.default).fieldHelpLogWork
};
const $2ddd56f412c59d37$export$eedb1bf75e1efb26 = {
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.IssueTypes]: (0, $5ewBi.default).fieldHelpIssueTypesIssueTerminologyRefreshM4,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $5ewBi.default).fieldHelpPriorityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $5ewBi.default).fieldHelpResolutionDefinitions,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $5ewBi.default).fieldHelpSecurityLevels,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.TimeTracking]: (0, $5ewBi.default).fieldHelpTimeTracking,
    [$2ddd56f412c59d37$var$LEARN_MORE_TYPES.LogWork]: (0, $5ewBi.default).fieldHelpLogWork
};

});
parcelRegister("5ewBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ce17f573bf38ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02ce17f573bf38ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-form-field-base.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    stringInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    urlInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.url-invalid-error-message",
        "defaultMessage": "{fieldName} is not a valid URL"
    },
    fieldHelpTextLabel: {
        "id": "issue-form-field-base.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-form-field-base.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpLogWork: {
        "id": "issue-form-field-base.common.field-message.field-help-log-work",
        "defaultMessage": "Learn about logging work"
    },
    fieldHelpTimeTracking: {
        "id": "issue-form-field-base.common.field-message.field-help-time-tracking",
        "defaultMessage": "Learn about time tracking"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-form-field-base.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldContentWithHelpText: {
        "id": "issue-form-field-base.common.field-message.field-content-with-help-text",
        "defaultMessage": "{fieldDescription} {fieldHelpText}"
    },
    fieldHelpIssueTypesIssueTerminologyRefreshM4: {
        "id": "issue-form-field-base.common.field-message.field-help-issue-types-issue-terminology-refresh-m4",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("gifeQ", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $89f92c26c7f930da$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $89f92c26c7f930da$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $89f92c26c7f930da$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $89f92c26c7f930da$export$f1a0ef98758e7a8a);
$parcel$export(module.exports, "isBuiltInJiraFieldRender", () => $89f92c26c7f930da$export$2909711775a2c267);

var $k2DRb = parcelRequire("k2DRb");

var $3eEiw = parcelRequire("3eEiw");
const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $k2DRb.FORGE_FIELD_TYPE_PREFIX)));
const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $k2DRb.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $k2DRb.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};
function $89f92c26c7f930da$export$2909711775a2c267(extension, entryPoint, experience) {
    const edit = extension.properties?.edit;
    const view = 'view' in extension.properties ? extension.properties.view : undefined;
    const entry = entryPoint === 'edit' ? edit : view;
    let supportedExperience = false;
    if (entryPoint === 'edit') supportedExperience = edit && 'experience' in edit && edit.experience && (0, $3eEiw.isCustomFieldEditRenderContext)(experience) ? edit.experience.includes(experience) : false;
    else supportedExperience = view && 'experience' in view && view.experience && (0, $3eEiw.isCustomFieldViewRenderContext)(experience) ? view.experience.includes(experience) : false;
    const hasRenderFunction = entry && 'function' in entry;
    const hasSupportedResource = entry && 'resource' in entry && supportedExperience;
    const render = entry && 'render' in entry ? entry.render : null;
    return entryPoint === 'view' ? !hasRenderFunction && !(hasSupportedResource && render === 'native') : !hasRenderFunction && !hasSupportedResource;
}

});
parcelRegister("3eEiw", function(module, exports) {

$parcel$export(module.exports, "isCustomFieldEditRenderContext", () => $99ea418430558080$export$b562ffa4bbc21d4f);
$parcel$export(module.exports, "isCustomFieldViewRenderContext", () => $99ea418430558080$export$36376c9ff94a7fbd);
function $99ea418430558080$export$b562ffa4bbc21d4f(context) {
    return context === 'issue-view' || context === 'issue-create' || context === 'issue-transition';
}
function $99ea418430558080$export$36376c9ff94a7fbd(context) {
    return context === 'issue-view';
}

});


parcelRegister("cR6FI", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $9d6f926895360b65$export$5304145354a3bee9);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $2RhPB = parcelRequire("2RhPB");

var $4JpPl = parcelRequire("4JpPl");

var $7Aezm = parcelRequire("7Aezm");

var $9wJ66 = parcelRequire("9wJ66");

var $frltc = parcelRequire("frltc");

var $koVbs = parcelRequire("koVbs");

var $2G1Qa = parcelRequire("2G1Qa");

var $jhvTc = parcelRequire("jhvTc");
const $9d6f926895360b65$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
        onChange((0, $2G1Qa.transformValue)(newValue, extension));
        (0, $4JpPl.fireTrackEditedEvent)(analyticsAttributes.renderContext, analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit 1 version of 1.2.0 when inline edit is not supported
        // should be removed with removal of UI Kit 1
        const translatedError = {
            message: intl.formatMessage((0, $jhvTc.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $jhvTc.default).modalModeErrorDescription)
        };
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience with non-supported UI Kit 1', {
            extennsionId: extension.id
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frltc.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wJ66.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $9d6f926895360b65$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: (0, $2RhPB.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d6f926895360b65$export$ba588b5cce278e96, props));

});
parcelRegister("4JpPl", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $d80ee50440a72c0c$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $d80ee50440a72c0c$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $d80ee50440a72c0c$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $d80ee50440a72c0c$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $d80ee50440a72c0c$export$add44f896fb31ba3);

var $k2DRb = parcelRequire("k2DRb");

var $4R6GH = parcelRequire("4R6GH");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");
const $d80ee50440a72c0c$var$moduleEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$var$triggerEventId = (0, $9BrHy.getEventIdOld)({
    module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $d80ee50440a72c0c$export$1798d320c6527c08 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).EDITED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$fc09afa3d0d5294c = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CANCELED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$762dee9e981de3e1 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $d80ee50440a72c0c$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $d80ee50440a72c0c$export$add44f896fb31ba3 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
        }) : $d80ee50440a72c0c$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("9wJ66", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $05c72791f20b76f4$export$ca6c6772b322056d);

var $5uXOq = parcelRequire("5uXOq");

var $2G8Ll = parcelRequire("2G8Ll");

var $3oVvh = parcelRequire("3oVvh");
const $05c72791f20b76f4$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
const $05c72791f20b76f4$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
const $05c72791f20b76f4$export$980ea0297ad3a4c8 = (props)=>{
    if ($05c72791f20b76f4$var$isIssueViewProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oVvh.LazyCustomFieldInlineEditIssueView), props);
    if ($05c72791f20b76f4$var$isIssueCreateOrTransitionProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G8Ll.LazyCustomFieldInlineEditForm), props);
    return null;
};
const $05c72791f20b76f4$export$ca6c6772b322056d = $05c72791f20b76f4$export$980ea0297ad3a4c8;

});
parcelRegister("2G8Ll", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditForm", () => $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca);

var $5uXOq = parcelRequire("5uXOq");


var $6ikhl = parcelRequire("6ikhl");

var $4JpPl = parcelRequire("4JpPl");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $G8euI = parcelRequire("G8euI");

var $4R6GH = parcelRequire("4R6GH");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $3OHUI = parcelRequire("3OHUI");
const $3e8d63ebec6f951f$var$skeletonConfig = [
    {
        width: 100
    }
];
const $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $5uXOq.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $6ikhl.useInlineField)(restProps.extensionData.fieldId);
    const containerRef = (0, $5uXOq.useRef)(null);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes } = restProps;
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $3e8d63ebec6f951f$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $4R6GH.fg)('forge_missing_analytics_attributes_for_fcf') ? (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                });
                (0, $4JpPl.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    ...analyticsAttributes,
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState,
        analyticsAttributes
    ]) : (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                });
                (0, $4JpPl.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    let submit;
    if ((0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv')) // eslint-disable-next-line react-hooks/rules-of-hooks
    submit = (0, $G8euI.useForgeCustomFieldStateSync)({
        onSubmit: onSubmit,
        containerRef: containerRef,
        fieldId: restProps.extensionData.fieldId
    }).submit;
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    submit = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, (0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, (0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                if ((0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("G8euI", function(module, exports) {

$parcel$export(module.exports, "useForgeCustomFieldStateSync", () => $08aa4a1e0b0efe49$export$874dabc3a2adff36);
/* eslint-disable no-void */ 
var $5uXOq = parcelRequire("5uXOq");

var $6ikhl = parcelRequire("6ikhl");

const $08aa4a1e0b0efe49$export$874dabc3a2adff36 = ({ fieldId: fieldId, containerRef: containerRef, onSubmit: onSubmit })=>{
    const [fieldState, { setFieldState: setFieldState }] = (0, $6ikhl.useInlineField)(fieldId);
    const fieldStateRef = (0, $5uXOq.useRef)(fieldState);
    const recentSubmitIdRef = (0, $5uXOq.useRef)(Symbol('submit-id'));
    const isInFocus = (0, $5uXOq.useCallback)(()=>{
        return typeof globalThis !== 'undefined' && globalThis.document && (containerRef.current === globalThis.document.activeElement || containerRef.current?.contains(globalThis.document.activeElement));
    }, [
        containerRef
    ]);
    const syncFieldFocusState = (0, $5uXOq.useCallback)(()=>{
        if (isInFocus()) setFieldState({
            fieldId: fieldId,
            status: (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)
        });
        else if (fieldStateRef.current?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) setFieldState({
            fieldId: fieldId,
            status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
        });
    }, [
        isInFocus,
        setFieldState,
        fieldId
    ]);
    /**
	 * This function is called when the form is submitted.
	 * It is used to sync the actual state of the field with our internal storage.
	 * This is necessary because the Forge fields defined using Custom UI are rendered in the iframe and not all their focus/blur events are propagated to the parent.
	 * We also want to manually trigger the blur event on the field so attached blur handlers kick in and the field's value gets submitted.
	 */ const onFormSubmit = (0, $5uXOq.useCallback)(()=>{
        syncFieldFocusState();
        if (isInFocus()) {
            const doc = typeof globalThis !== 'undefined' ? globalThis.document : undefined;
            const activeElement = doc?.activeElement;
            if (activeElement && 'blur' in activeElement && typeof activeElement.blur === 'function') activeElement.blur();
        }
    }, [
        syncFieldFocusState,
        isInFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setFieldState({
            onFormSubmit: onFormSubmit,
            fieldId: fieldId,
            status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
        });
    }, // Keep these dependencies immutable, otherwise we are going to override the field's state.
    [
        fieldId,
        onFormSubmit,
        setFieldState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fieldStateRef.current = fieldState;
    }, [
        fieldState,
        setFieldState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        syncFieldFocusState();
        // Wait for the focus to be moved to the element.
        // In case of iframes it is not immediate so we must use a slight delay.
        const delayedFieldFocusStateSync = ()=>setTimeout(syncFieldFocusState, 100);
        if (typeof globalThis !== 'undefined' && globalThis.document) globalThis.document.addEventListener('focusout', delayedFieldFocusStateSync);
        return ()=>{
            if (typeof globalThis !== 'undefined' && globalThis.document) globalThis.document.removeEventListener('focusout', delayedFieldFocusStateSync);
        };
    }, [
        syncFieldFocusState,
        fieldId
    ]);
    /**
	 * Submit bridge method implementation.
	 * It is possible for the app to programmatically submit the field multiple times.
	 * And it may be the case that they submit a promise that takes time to resolve.
	 * Because of that we need to update the state when the last pending submit is resolved.
	 */ const submit = (0, $5uXOq.useCallback)(async ({ data: data })=>{
        try {
            recentSubmitIdRef.current = Symbol('submit-id');
            const scopedSubmitId = recentSubmitIdRef.current;
            await setFieldState({
                fieldId: fieldId,
                status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
            });
            const resolvedValue = await Promise.resolve(data);
            if (scopedSubmitId === recentSubmitIdRef.current) {
                onSubmit(resolvedValue);
                await setFieldState({
                    fieldId: fieldId,
                    status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setFieldState({
                fieldId: fieldId,
                status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
            });
        }
        return undefined;
    }, [
        fieldId,
        setFieldState,
        onSubmit
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
};

});

parcelRegister("bLCKr", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $e1da1ba1fdde315e$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 = [];
const $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1da1ba1fdde315e$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $e1da1ba1fdde315e$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $e1da1ba1fdde315e$var$layoutStyles
    }, children);
};
const $e1da1ba1fdde315e$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1da1ba1fdde315e$var$ForgeSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $lD23V.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $e1da1ba1fdde315e$var$layoutStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("69dub", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1d6031a605ad4b71$export$238f56c0891e9254);

var $5uXOq = parcelRequire("5uXOq");
const $1d6031a605ad4b71$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1d6031a605ad4b71$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d6031a605ad4b71$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("3OHUI", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", () => $e47c1fd0d3acd296$export$eef5130ba28e0f4e);
$parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", () => $e47c1fd0d3acd296$export$299b8ce8659dec8c);

var $1rTGO = parcelRequire("1rTGO");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $kxZPA = parcelRequire("kxZPA");

const $e47c1fd0d3acd296$var$getModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("9AyE2")));

const $e47c1fd0d3acd296$var$getForgeExtensionModule = ()=>(0, $8kVg1.measureInitialPageLoadAsyncResourcesTiming)((0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hBuqR.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("datQy")));
const $e47c1fd0d3acd296$export$eef5130ba28e0f4e = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $e47c1fd0d3acd296$export$299b8ce8659dec8c = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$e47c1fd0d3acd296$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));

});
parcelRegister("9AyE2", function(module, exports) {

let $6fb259976d69fb69$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6fb259976d69fb69$var$load("3yAl4"),
    $6fb259976d69fb69$var$load("iNwUw")
]).then(()=>parcelRequire('lDRdH'));

});

parcelRegister("datQy", function(module, exports) {

let $99635c7a91d089fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $99635c7a91d089fb$var$load("76n7a"),
    $99635c7a91d089fb$var$load("l253H"),
    $99635c7a91d089fb$var$load("kNFvF"),
    $99635c7a91d089fb$var$load("ffQaD"),
    $99635c7a91d089fb$var$load("kvRbA"),
    $99635c7a91d089fb$var$load("3yAl4"),
    $99635c7a91d089fb$var$load("7nLq1")
]).then(()=>parcelRequire('456zR'));

});



parcelRegister("3oVvh", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", () => $46e0705763f3c3d0$export$9929b4973c13a82f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $bLCKr = parcelRequire("bLCKr");

var $69dub = parcelRequire("69dub");

var $7IjIj = parcelRequire("7IjIj");

var $3OHUI = parcelRequire("3OHUI");
const $46e0705763f3c3d0$var$skeletonConfig = [
    {
        width: 100
    }
];
const $46e0705763f3c3d0$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const loadingComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLCKr.Skeleton), {
            skeletonConfig: $46e0705763f3c3d0$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $k2DRb.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const submit = (0, $5uXOq.useCallback)(({ data: fieldValue })=>(0, $7IjIj.onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $5uXOq.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    if ((0, $3mOWa.isNativeUiExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onCancel: onCancel,
        onLoad: onRender,
        onRender: onRender,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69dub.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OHUI.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onRender: onRender,
        onCancel: onCancel,
        bridge: bridge
    })));
};

});
parcelRegister("7IjIj", function(module, exports) {

$parcel$export(module.exports, "onCustomFieldSubmit", () => $7482280c9b50d561$export$fc8c2ed652969e74);

var $jJZqs = parcelRequire("jJZqs");

var $dGSK4 = parcelRequire("dGSK4");
const $7482280c9b50d561$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $dGSK4.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $jJZqs.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

});
parcelRegister("dGSK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60f776846cd27f9$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $eRDnE = parcelRequire("eRDnE");

var $ctOgQ = parcelRequire("ctOgQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b60f776846cd27f9$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $jJZqs.isValidationError)(error) ? (0, $ctOgQ.default)(error.errors) : (0, $eRDnE.default)();

});
parcelRegister("eRDnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e1a5ac6c28ff9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $41e1a5ac6c28ff9a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e1a5ac6c28ff9a$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $41e1a5ac6c28ff9a$var$messages.title,
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.generic-error',
        messageType: 'transactional'
    });

});

parcelRegister("ctOgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59eef974107568f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $59eef974107568f4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$59eef974107568f4$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $59eef974107568f4$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.validation-error',
        messageType: 'transactional'
    });

});





parcelRegister("frltc", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $a7cc7ee0610715db$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $lUtFZ = parcelRequire("lUtFZ");
const $a7cc7ee0610715db$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $a7cc7ee0610715db$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $5uXOq.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $lUtFZ.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$LoaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7cc7ee0610715db$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lUtFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0d2ab7d73abc3f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0c0d2ab7d73abc3f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("2G1Qa", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $aebdb8b330132ca4$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $aebdb8b330132ca4$export$b82f09291a00d8c1);

var $4R6GH = parcelRequire("4R6GH");

var $2QTbq = parcelRequire("2QTbq");

var $gifeQ = parcelRequire("gifeQ");

var $4ib94 = parcelRequire("4ib94");
const $aebdb8b330132ca4$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $2QTbq.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $aebdb8b330132ca4$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $aebdb8b330132ca4$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list' && ((0, $4R6GH.fg)('forge-custom-fields-do-not-transform-null-values') ? Array.isArray(value) : true)) // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $2QTbq.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $4ib94.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $aebdb8b330132ca4$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $aebdb8b330132ca4$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $aebdb8b330132ca4$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $aebdb8b330132ca4$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $aebdb8b330132ca4$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($aebdb8b330132ca4$export$3e406786572c35b0);
    return $aebdb8b330132ca4$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("2QTbq", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $392cb309afc1042a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $392cb309afc1042a$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelOptionsToLabelData", () => $392cb309afc1042a$export$58b6e7301c3c290b);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $392cb309afc1042a$export$37f55c1f665c1221);
const $392cb309afc1042a$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>({
            value: value,
            label: value
        }));
};
const $392cb309afc1042a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $392cb309afc1042a$export$58b6e7301c3c290b = (options)=>{
    return [
        {
            operation: 'edit',
            value: options?.map(({ label: label, color: color, __isNew__: __isNew__ })=>{
                if (color) return {
                    name: label,
                    color: color
                };
                return {
                    name: label,
                    ...__isNew__ ? {
                        color: 'GREY'
                    } : {}
                };
            })
        },
        {
            operation: 'set',
            value: options?.map((option)=>option.label)
        }
    ];
};
const $392cb309afc1042a$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label, color: color })=>({
            label: label,
            value: label,
            ...color ? {
                color: color
            } : {}
        }));
};

});

parcelRegister("4ib94", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $308c96a2eb70bd22$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $308c96a2eb70bd22$export$2de59005e10fd82 = (value)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) ? JSON.parse(value) : value;
    } catch  {
        return value;
    }
};

});


parcelRegister("jhvTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $44857d6a8561de15$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44857d6a8561de15$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalModeErrorTitle: {
        "id": "forge-field-base.form.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "forge-field-base.form.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("lXxfQ", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $0cd01fba7525b674$export$1df6b326181f4cdf);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $1hWNm = parcelRequire("1hWNm");

var $hH7yT = parcelRequire("hH7yT");
const $0cd01fba7525b674$var$ErrorView = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.050"
    }, formatMessage((0, $hH7yT.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hWNm.ForgeFieldDispatchButton), {
        fieldId: fieldId
    }));
};
const $0cd01fba7525b674$var$HelperView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), formatMessage((0, $hH7yT.default).forgeFieldPendingTextLabel));
};
const $0cd01fba7525b674$var$SuccessView = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ValidMessage), null, formatMessage((0, $hH7yT.default).forgeFieldSuccessTextLabel));
};
const $0cd01fba7525b674$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
    const { fieldId: fieldId, renderFieldMessage: renderFieldMessage, error: error } = props;
    const [fieldState] = (0, $6ikhl.useInlineField)(fieldId);
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== null) return renderFieldMessage(error);
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage != null) switch(fieldState?.status){
            case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$ErrorView, {
                    fieldId: fieldId
                });
            case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$SuccessView, null);
            case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
            case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$HelperView, null);
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd01fba7525b674$var$ErrorView, {
            fieldId: fieldId
        });
    }
    return renderDefaultErrorMessage();
};

});
parcelRegister("1hWNm", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $1a4012e60992863b$export$59e3aafda495153);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $cYbH1 = parcelRequire("cYbH1");
const $1a4012e60992863b$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6ikhl.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, formatMessage((0, $cYbH1.default).forgeRetryButton));
        return null;
    };
    return renderRetryButton();
};

});
parcelRegister("cYbH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $556cb06afa89f1be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $556cb06afa89f1be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeRetryButton: {
        "id": "forge-field-base.form.field-message.field-dispatch-button.forge-retry-button",
        "defaultMessage": "Try again?"
    }
});

});


parcelRegister("hH7yT", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fc581ff13e86c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44fc581ff13e86c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});



parcelRegister("5pZ9g", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $297a009f70430225$export$34a15d6027142c62);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");

var $7Aezm = parcelRequire("7Aezm");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $gifeQ = parcelRequire("gifeQ");

var $ELVDL = parcelRequire("ELVDL");

var $j5sSv = parcelRequire("j5sSv");

var $7fjFA = parcelRequire("7fjFA");


var $6cMZg = parcelRequire("6cMZg");
const $297a009f70430225$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $5uXOq.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $6cMZg.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $5uXOq.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create',
            ...(0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: 'issue-create'
            }
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $g5X3G.toIssueTypeId)(selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $g5X3G.toProjectId)(selectedProject.value),
                key: (0, $g5X3G.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if ((0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
        if ((0, $gifeQ.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create')) return renderDefaultView();
    } else if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ELVDL.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $297a009f70430225$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5sSv.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($297a009f70430225$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7fjFA.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("ELVDL", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $ed405e89d26d258c$export$5304145354a3bee9);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $2RhPB = parcelRequire("2RhPB");

var $4JpPl = parcelRequire("4JpPl");

var $7Aezm = parcelRequire("7Aezm");

var $9wJ66 = parcelRequire("9wJ66");

var $frltc = parcelRequire("frltc");

var $koVbs = parcelRequire("koVbs");

var $6cMZg = parcelRequire("6cMZg");

var $gb8Pv = parcelRequire("gb8Pv");
const $ed405e89d26d258c$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
    const intl = (0, $koVbs.default)();
    const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
        onChange((0, $6cMZg.transformValue)(newValue, extension));
        (0, $4JpPl.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $gb8Pv.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $gb8Pv.default).modalModeErrorDescription)
        };
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frltc.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wJ66.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $ed405e89d26d258c$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Aezm.EditAnalyticsWrapper), {
        attributes: (0, $2RhPB.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed405e89d26d258c$export$ba588b5cce278e96, props));

});
parcelRegister("6cMZg", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $856789955d192c4b$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $856789955d192c4b$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $856789955d192c4b$export$78d71f9ed5534abe);

var $2QTbq = parcelRequire("2QTbq");

var $4R6GH = parcelRequire("4R6GH");

var $gifeQ = parcelRequire("gifeQ");

var $2pEv1 = parcelRequire("2pEv1");
const $856789955d192c4b$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $2QTbq.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            if ((0, $4R6GH.fg)('custom_field_null_object_transform')) {
                if (value != null) return JSON.stringify(value);
                return value;
            }
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $856789955d192c4b$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $856789955d192c4b$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list' && ((0, $4R6GH.fg)('forge-custom-fields-do-not-transform-null-values') ? Array.isArray(value) : true)) // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $2QTbq.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $2pEv1.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $856789955d192c4b$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $856789955d192c4b$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $856789955d192c4b$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $856789955d192c4b$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $856789955d192c4b$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($856789955d192c4b$export$3e406786572c35b0);
    return $856789955d192c4b$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("2pEv1", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $ff7dce57394b1eb3$export$2de59005e10fd82);

var $agVdz = parcelRequire("agVdz");
const $ff7dce57394b1eb3$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});


parcelRegister("gb8Pv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c94c49b5b89ee482$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c94c49b5b89ee482$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("j5sSv", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b);
/* FieldContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $lD23V.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7fjFA", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $111a3dd21aa999b8$export$1df6b326181f4cdf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $qfj8c = parcelRequire("qfj8c");

var $eZJjh = parcelRequire("eZJjh");


var $6ikhl = parcelRequire("6ikhl");

var $koVbs = parcelRequire("koVbs");

var $jcuk9 = parcelRequire("jcuk9");

var $3EMIO = parcelRequire("3EMIO");
const $111a3dd21aa999b8$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $6ikhl.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, formatMessage((0, $3EMIO.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcuk9.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ValidMessage), null, formatMessage((0, $3EMIO.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })), formatMessage((0, $3EMIO.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
            case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};
// For now, it only gives some space between the spinner and the message
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $111a3dd21aa999b8$var$MessagePartsSeparationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jcuk9", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $354a8a5375650812$export$59e3aafda495153);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");


var $6ikhl = parcelRequire("6ikhl");
const $354a8a5375650812$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6ikhl.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("3EMIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $477739caf5b64c43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $477739caf5b64c43$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});


// itsm practices - copied from src/packages/issue-create/issue-create-common-types/src/common/types/index.tsx
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$SERVICE_REQUEST = 'SERVICE_REQUEST';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$PROBLEM_MANAGEMENT = 'PROBLEM_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$CHANGE_MANAGEMENT = 'CHANGE_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$POST_INCIDENT_REVIEW = 'POST_INCIDENT_REVIEW';
// cs practice
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$DEVELOPER_ESCALATION = 'DEVELOPER_ESCALATION';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$UNASSIGNED_REQUEST_TYPE = 'UNASSIGNED_REQUEST_TYPE';
const $5363dcf42759d41f$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $5363dcf42759d41f$var$ISSUE_TYPE = 'ISSUE_TYPE';


parcelRegister("7Emtg", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $6c61c34a1b63244f$export$e95b9e5003024a9c);

var $4JpPl = parcelRequire("4JpPl");

var $gifeQ = parcelRequire("gifeQ");
const $6c61c34a1b63244f$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $gifeQ.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gifeQ.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $4JpPl.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("bCATC", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $8f20301774b6a173$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $8f20301774b6a173$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $8f20301774b6a173$export$775be62266860b86);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $8f20301774b6a173$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8f20301774b6a173$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8f20301774b6a173$var$ErrorBoundaryBypassApiContext.Provider, {
            value: api,
            children: children
        })
    });
};
class $8f20301774b6a173$export$36798a6d5688c318 extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) this.context.swallowError(error);
    }
    static{
        this.contextType = $8f20301774b6a173$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $8f20301774b6a173$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $5uXOq.useContext)($8f20301774b6a173$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("bv5he", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $88ca25f0a40fdec1$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4eKbI = parcelRequire("4eKbI");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $3WXbV = parcelRequire("3WXbV");
const $88ca25f0a40fdec1$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadingMessage = formatMessage((0, $3WXbV.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($88ca25f0a40fdec1$export$4e31364808fb7483, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4eKbI.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    testId: indicatorId,
                    size: "small"
                })
            })
        })
    });
});
$88ca25f0a40fdec1$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $88ca25f0a40fdec1$export$4e31364808fb7483 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4eKbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3e682addb0cb4a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wxJn.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}

});

parcelRegister("3WXbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ef3198f799e6a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0ef3198f799e6a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});

});


parcelRegister("dIjAl", function(module, exports) {

$parcel$export(module.exports, "ErrorHandler", () => $95320a69efc876f6$export$f42bc933f51d0006);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1YewZ = parcelRequire("1YewZ");
const $95320a69efc876f6$export$f42bc933f51d0006 = ()=>{
    (0, $gKZoD.di)((0, $1YewZ.useIssueAdjustmentsActions));
    const { setError: setError, resetError: resetError } = (0, $1YewZ.useIssueAdjustmentsActions)();
    (0, $5uXOq.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});

parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


const $380826ec5efdda82$export$e615b7e9b8fb4715 = 'GIC';

parcelRegister("2eeg1", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $58ac5136636efa9f$export$24545fc29fe55980);

var $5uXOq = parcelRequire("5uXOq");

var $gL80q = parcelRequire("gL80q");
var $jrwZp = parcelRequire("jrwZp");


var $62s0B = parcelRequire("62s0B");
const $58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $gL80q.isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62s0B.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $58ac5136636efa9f$export$24545fc29fe55980 = /*#__PURE__*/ (0, $5uXOq.memo)($58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("62s0B", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $f47b896eac91b738$export$9d96bb1f53295b76);

var $1YewZ = parcelRequire("1YewZ");

var $9QJ7Z = parcelRequire("9QJ7Z");
const $f47b896eac91b738$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $9QJ7Z.useFormApi)();
    const { processChange: processChange } = (0, $1YewZ.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("9QJ7Z", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $33387961dd1f98b9$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $33387961dd1f98b9$export$4607062597b2b4df);

var $5uXOq = parcelRequire("5uXOq");
const $33387961dd1f98b9$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $33387961dd1f98b9$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $5uXOq.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $5uXOq.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $5uXOq.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId],
            getAllFieldValue: ()=>getFormStateRef.current().values
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33387961dd1f98b9$var$Context.Provider, {
        value: value
    }, children);
};
const $33387961dd1f98b9$export$4607062597b2b4df = ()=>{
    const context = (0, $5uXOq.useContext)($33387961dd1f98b9$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("aBZin", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $56aa95be299fa4e4$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $56aa95be299fa4e4$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $56aa95be299fa4e4$export$a59801673b41acfd(eventOrValue) {
    if ($56aa95be299fa4e4$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("45JN1", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $f046862319512079$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $kOFhM = parcelRequire("kOFhM");

var $qfj8c = parcelRequire("qfj8c");

var $e4yMr = parcelRequire("e4yMr");

var $f5oqj = parcelRequire("f5oqj");

var $3bDjY = parcelRequire("3bDjY");

var $h17zy = parcelRequire("h17zy");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6a30R = parcelRequire("6a30R");

var $4IoOR = parcelRequire("4IoOR");

var $aQb3V = parcelRequire("aQb3V");
const $f046862319512079$var$FieldHelpLink = /*#__PURE__*/ (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
    const learnMoreMessage = (0, $aQb3V.getLearnMoreMessage)(fieldHelpTextUrl ?? '');
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: fieldHelpTextUrl,
        target: "_blank"
    }, formatMessage(learnMoreMessage));
});
const $f046862319512079$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $h17zy.useEmojiProvider)();
    const adfDocument = (0, $5uXOq.useMemo)(()=>{
        if (error) return null;
        return (0, $4IoOR.convertWikiToAdf)(description);
    }, [
        description,
        error
    ]);
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $aQb3V.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!adfDocument && !fieldHelpTextUrl) return null;
    const getRenderer = (isTruncated = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $kOFhM.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $4R6GH.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $6a30R.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $6a30R.onLinkClick)
                }
            },
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldHelpLink, {
            fieldHelpTextUrl: fieldHelpTextUrl
        })));
    if (isMini) {
        if (adfDocument?.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$TooltipContentContainer, null, getRenderer()),
            position: "bottom"
        }, getRenderedDescription(true));
        return null;
    }
    return getRenderedDescription();
};
const $f046862319512079$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $f046862319512079$var$TooltipContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1h1vhk _woio15cr _13odidpf _9j7z1j89",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $f046862319512079$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $lD23V.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f1hdcr7 _woio131l _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aQb3V", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $8cc68cbdef3ac4a4$export$2c1e5dc35269c547);
$parcel$export(module.exports, "getErrorMessage", () => $8cc68cbdef3ac4a4$export$82f46aa4e6535a45);

var $6s1PB = parcelRequire("6s1PB");

var $bGrWH = parcelRequire("bGrWH");


var $7vNya = parcelRequire("7vNya");

var $dOrZq = parcelRequire("dOrZq");
const $8cc68cbdef3ac4a4$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const learnMoreMessages = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7vNya.LEARN_MORE_MESSAGES_WITH_ISSUE_TERM) : (0, $7vNya.LEARN_MORE_MESSAGES);
    if (urlSuffix in learnMoreMessages) return learnMoreMessages[urlSuffix];
    return (0, $dOrZq.default).fieldHelpTextLabel;
};
const $8cc68cbdef3ac4a4$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    const helperMessage = $8cc68cbdef3ac4a4$export$2c1e5dc35269c547(fieldHelpTextUrl);
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $8cc68cbdef3ac4a4$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $bGrWH.REQUIRED:
            return formatMessage((0, $dOrZq.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca:
            return formatMessage((0, $dOrZq.default).labelsMaxErrorMessage, {
                MAX_ALLOWED_LABELS: formatNumber((0, $d46ffa3990e23a4d$export$1fdf850c93de8bae))
            });
        case 0, $d46ffa3990e23a4d$export$e77d629cc732976d:
            return formatMessage((0, $dOrZq.default).labelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        case 0, $d46ffa3990e23a4d$export$618e922e89e8bcae:
            return formatMessage((0, $dOrZq.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$fe1a70381f6491b5))
            });
        case 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f:
            return formatMessage((0, $dOrZq.default).forgeLabelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
            });
        default:
            return validationError;
    }
};

});
const $d46ffa3990e23a4d$export$9151073f92820ff8 = 255;
const $d46ffa3990e23a4d$export$fe1a70381f6491b5 = 255;
const $d46ffa3990e23a4d$export$1fdf850c93de8bae = 55;
const $d46ffa3990e23a4d$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $d46ffa3990e23a4d$export$e77d629cc732976d = 'LABELS INVALID';
const $d46ffa3990e23a4d$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $d46ffa3990e23a4d$export$618e922e89e8bcae = 'STRING_INVALID';

parcelRegister("7vNya", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", () => $6a6781d11d912198$export$1b2b0fc2cd5817de);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $6a6781d11d912198$export$eedb1bf75e1efb26);

var $dOrZq = parcelRequire("dOrZq");
const $6a6781d11d912198$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $6a6781d11d912198$export$1b2b0fc2cd5817de = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypesIssueTermRefresh,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};
const $6a6781d11d912198$export$eedb1bf75e1efb26 = {
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, $dOrZq.default).fieldHelpIssueTypes,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $dOrZq.default).fieldHelpPriorityLevels,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $dOrZq.default).fieldHelpResolutionDefinitions,
    [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $dOrZq.default).fieldHelpSecurityLevels
};

});
parcelRegister("dOrZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5d9a42d37b19ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c5d9a42d37b19ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldHelpIssueTypesIssueTermRefresh: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("iblgc", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $20aa6a3390c971a5$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $20aa6a3390c971a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");

var $YSJPS = parcelRequire("YSJPS");
const $20aa6a3390c971a5$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Description, null));
const $20aa6a3390c971a5$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $20aa6a3390c971a5$export$2e2bcd8739ae039 = $20aa6a3390c971a5$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20aa6a3390c971a5$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$20aa6a3390c971a5$var$Description.displayName = 'DescriptionSkeleton';

});
parcelRegister("YSJPS", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $f113eb09b8933f94$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1wbtX = parcelRequire("1wbtX");
const $f113eb09b8933f94$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1wbtX.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$f113eb09b8933f94$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});


parcelRegister("86fzT", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $81f27e245685507d$export$920d96e4692b3d51);
const $81f27e245685507d$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("ii6hB", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesField", () => $387f926e9d9168ff$export$dbde2fdac14e77d6);
$parcel$export(module.exports, "default", () => $387f926e9d9168ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $f0bro = parcelRequire("f0bro");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $aZJYe = parcelRequire("aZJYe");

const $387f926e9d9168ff$export$dbde2fdac14e77d6 = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
    const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, $aZJYe.useFetchAffectedServicesName)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
            const ids = defaultValue.map((service) => service.serviceId);
            Simply extracting serviceId above causes Flow error as 'service'
            is of type (JiraAffectedService | AffectedServiceOption).
            See TURTLE-89 for more details.
             */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ids = defaultValue.reduce((serviceIds, service)=>// @ts-expect-error - TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'. | TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'.
                service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
            if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAffectedServicesName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAffectedServicesEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0bro.default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getAffectedServicesEdit()) : getAffectedServicesEdit());
};
var $387f926e9d9168ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aZJYe.transformDefaultAffectedServices)
})($387f926e9d9168ff$export$dbde2fdac14e77d6);

});
parcelRegister("f0bro", function(module, exports) {

$parcel$export(module.exports, "default", () => $64bb95b3ef8c5394$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $kEqrP = parcelRequire("kEqrP");

var $2WZSx = parcelRequire("2WZSx");

var $2ngL6 = parcelRequire("2ngL6");
const $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $64bb95b3ef8c5394$var$AffectedServicesPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const searchAffectedServices = async (query = '')=>{
        setLastFetchFailed(false);
        try {
            (0, $kEqrP.fetchAffectedServicesExperience).start();
            const affectedServices = await (0, $2ngL6.fetchAffectedServices)(query, autoCompleteUrl);
            (0, $kEqrP.fetchAffectedServicesExperience).success();
            return affectedServices;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLastFetchFailed(true);
            (0, $kEqrP.fetchAffectedServicesExperience).failure();
            return [];
        }
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAffectedServices();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $FtZX9.default)(searchAffectedServices, $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $2WZSx.default).failedFetch : (0, $2WZSx.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...fieldProps,
        classNamePrefix: "affected-services-picker",
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(value: AffectedServiceOption[]) => void' is not assignable to type '(value: OptionsType<AffectedServiceOption>, action: ActionMeta<AffectedServiceOption>) => void'.
        onChange: onChange,
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        "data-testid": "issue-field-affected-services.ui.edit.async-select"
    });
};
var $64bb95b3ef8c5394$export$2e2bcd8739ae039 = $64bb95b3ef8c5394$var$AffectedServicesPickerEdit;

});
parcelRegister("FtZX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb46637e8f856b8$export$2e2bcd8739ae039);
const $ebb46637e8f856b8$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $ebb46637e8f856b8$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;

});

parcelRegister("kEqrP", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $92ce1ce82a42bb8a$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $92ce1ce82a42bb8a$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $92ce1ce82a42bb8a$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $92ce1ce82a42bb8a$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $92ce1ce82a42bb8a$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $92ce1ce82a42bb8a$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $92ce1ce82a42bb8a$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $92ce1ce82a42bb8a$export$3f1da23c065671d2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, $duUGa.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });
const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2WZSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a56352311f156b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9a56352311f156b3$var$messages = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-affected-services.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-affected-services.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});
var $9a56352311f156b3$export$2e2bcd8739ae039 = $9a56352311f156b3$var$messages;

});

parcelRegister("2ngL6", function(module, exports) {

$parcel$export(module.exports, "mapServiceEntitiesToOptions", () => $ee273b75b82219a4$export$23b96a30f377b741);
$parcel$export(module.exports, "mapOptionsToServiceEntities", () => $ee273b75b82219a4$export$7dcfc49587479fac);
$parcel$export(module.exports, "fetchAffectedServices", () => $ee273b75b82219a4$export$66d34216c85d32cb);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $ee273b75b82219a4$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $ee273b75b82219a4$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));
const $ee273b75b82219a4$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: inputValue
    });
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$ee273b75b82219a4$export$23b96a30f377b741(response.services)).catch((error)=>{
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchAffectedServices',
            packageName: 'jiraIssueFieldAffectedServices',
            logToSentry: !(0, $jJZqs.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorMessage: error.message
            }
        });
        throw error;
    });
};

});


parcelRegister("7C5S0", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $17c5ea94a7a7a600$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $17c5ea94a7a7a600$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c0dQj = parcelRequire("c0dQj");
const $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ebfkjq": (0, $lD23V.default)((()=>{
                return typeof (__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350);
            })()),
            "--_1glwpqj": (0, $lD23V.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $lD23V.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbhi17 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$393edc798c47379d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$446eebadefe1123b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _1bsb1osq _bfhkmuej _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $17c5ea94a7a7a600$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gLdtQ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $60f472fd3d28277e$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $60f472fd3d28277e$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $60f472fd3d28277e$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $60f472fd3d28277e$var$MENU_CLOSE_SELECTORS = [
    $60f472fd3d28277e$export$7c7171667037b275
];
const $60f472fd3d28277e$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($60f472fd3d28277e$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("aZJYe", function(module, exports) {

$parcel$export(module.exports, "mutateAffectedServicesField", () => $3cf4650743fd53da$export$c5ca3c9d905a51f0);
$parcel$export(module.exports, "transformDefaultAffectedServices", () => $3cf4650743fd53da$export$6f4e94c57a16128c);
$parcel$export(module.exports, "useFetchAffectedServicesName", () => $3cf4650743fd53da$export$9abe2f602f72a411);

var $5uXOq = parcelRequire("5uXOq");

var $6paOF = parcelRequire("6paOF");

var $7f4tk = parcelRequire("7f4tk");

var $2ngL6 = parcelRequire("2ngL6");
const $3cf4650743fd53da$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
        affectedServicesField: {
            fieldId: fieldId,
            affectedServices: selectedAffectedServices.map(({ value: value })=>({
                    serviceId: value
                }))
        }
    });
const $3cf4650743fd53da$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
            value: service.serviceId
        }));
const $3cf4650743fd53da$export$9abe2f602f72a411 = ()=>{
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const baseUrl = '';
    const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        (0, $7f4tk.default)(`${baseUrl}/rest/service-registry-api/service`, {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $2ngL6.mapServiceEntitiesToOptions)(response.services));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $6paOF.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchAffectedServicesName',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("6iZh4", function(module, exports) {

$parcel$export(module.exports, "validateRequired", () => $2a21f21632a09b2e$export$2e85a6f149681784);

var $bGrWH = parcelRequire("bGrWH");
const $2a21f21632a09b2e$export$2e85a6f149681784 = (value, isRequired, _)=>{
    if (isRequired) {
        if (!value || Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("kShoa", function(module, exports) {

$parcel$export(module.exports, "toLabelsField", () => $e44b536616936050$export$7a0cc61c6cdac523);
$parcel$export(module.exports, "textFieldWriter", () => $e44b536616936050$export$3f2b7c786f4381f3);
$parcel$export(module.exports, "selectFieldWriter", () => $e44b536616936050$export$9ed21ff1d3f239ed);
$parcel$export(module.exports, "checkboxSelectFieldWriter", () => $e44b536616936050$export$6372f460d19ccf04);
$parcel$export(module.exports, "textAreaFieldWriter", () => $e44b536616936050$export$daf547ed9d724058);
$parcel$export(module.exports, "dateFieldWriter", () => $e44b536616936050$export$ab1ac718ca53b3a2);
$parcel$export(module.exports, "labelsFieldWriter", () => $e44b536616936050$export$ad0f5c4a81b9b717);
$parcel$export(module.exports, "priorityFieldWriter", () => $e44b536616936050$export$255f6ed818b27fe9);
$parcel$export(module.exports, "numberFieldWriter", () => $e44b536616936050$export$f187c825de05664b);
$parcel$export(module.exports, "dateTimeFieldWriter", () => $e44b536616936050$export$aa8970635118882c);
$parcel$export(module.exports, "urlFieldWriter", () => $e44b536616936050$export$823b946bef17fbde);
$parcel$export(module.exports, "multiUserPickerFieldWriter", () => $e44b536616936050$export$f56da03febf03bbe);
$parcel$export(module.exports, "cascadingSelectFieldWriter", () => $e44b536616936050$export$dd0315e6bb70be50);
$parcel$export(module.exports, "singleUserPickerFieldWriter", () => $e44b536616936050$export$44ca38ec8bc1b849);
$parcel$export(module.exports, "radioSelectFieldWriter", () => $e44b536616936050$export$3930624833f8c678);
$parcel$export(module.exports, "multiSelectFieldWriter", () => $e44b536616936050$export$550c89601caa8cb);
$parcel$export(module.exports, "attachmentFieldWriter", () => $e44b536616936050$export$a751298e00103db5);
$parcel$export(module.exports, "descriptionFieldWriter", () => $e44b536616936050$export$8545d310869fe805);
$parcel$export(module.exports, "singleGroupPickerFieldWriter", () => $e44b536616936050$export$8b286e49fa801799);
$parcel$export(module.exports, "multipleGroupPickerFieldWriter", () => $e44b536616936050$export$ada212938d86109a);
$parcel$export(module.exports, "teamFieldWriter", () => $e44b536616936050$export$77028ba2835a8f1c);
$parcel$export(module.exports, "assigneeFieldWriter", () => $e44b536616936050$export$1c1d0a4431d22b72);

var $5kDIl = parcelRequire("5kDIl");

var $bWtQ8 = parcelRequire("bWtQ8");

var $em1U0 = parcelRequire("em1U0");

var $hx8g7 = parcelRequire("hx8g7");

var $2QTbq = parcelRequire("2QTbq");

var $4IxfP = parcelRequire("4IxfP");

var $aSk8p = parcelRequire("aSk8p");

var $5pHXe = parcelRequire("5pHXe");

var $1K3Xb = parcelRequire("1K3Xb");

var $4R6GH = parcelRequire("4R6GH");
const $e44b536616936050$var$toMultipleSelectField = (id, ids)=>{
    const toOptionInput = (optionId)=>({
            id: optionId
        });
    return {
        fieldId: id,
        options: ids.map(toOptionInput)
    };
};
const $e44b536616936050$var$toStringField = (id, value)=>({
        fieldId: id,
        value: value
    });
const $e44b536616936050$export$7a0cc61c6cdac523 = (id, labels)=>({
        fieldId: id,
        values: {
            values: labels
        }
    });
const $e44b536616936050$var$toPriorityField = (priorityId)=>({
        priorityId: priorityId
    });
const $e44b536616936050$export$f27a949cf2ef9fc6 = (id, accountId)=>({
        fieldId: id,
        user: {
            accountId: accountId
        }
    });
const $e44b536616936050$var$toADFField = (id, adf)=>{
    const { version: version } = adf;
    return {
        fieldId: id,
        adf: {
            version: version,
            jsonValue: adf
        }
    };
};
const $e44b536616936050$var$toGroupInput = (pickerOption)=>({
        groupName: pickerOption.name
    });
const $e44b536616936050$export$3f2b7c786f4381f3 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$9ed21ff1d3f239ed = (id, value, fields)=>{
    if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, String((0, $5pHXe.mapSelectOptionsToData)(value).id)));
};
const $e44b536616936050$export$6372f460d19ccf04 = (id, value, fields)=>{
    fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, (0, $hx8g7.mapOptionsToData)(value).map((o)=>o.id)));
};
const $e44b536616936050$export$daf547ed9d724058 = (id, value, fields)=>{
    if (value instanceof Object && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return;
    // @ts-expect-error Remove this typecheck suppression on forms_multiline_text_wiki_renderer cleanup ts(2345)
    fields.adfFields.push($e44b536616936050$var$toADFField(id, (0, $1K3Xb.convertTextToAdf)(value)));
};
const $e44b536616936050$export$ab1ac718ca53b3a2 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$ad0f5c4a81b9b717 = (id, value, fields)=>{
    fields.labels.push($e44b536616936050$export$7a0cc61c6cdac523(id, (0, $2QTbq.mapLabelOptionsToData)(value)));
};
const $e44b536616936050$export$255f6ed818b27fe9 = (_id, value, fields)=>{
    // eslint-disable-next-line no-param-reassign
    fields.priority = $e44b536616936050$var$toPriorityField((0, $4IxfP.mapOptionToData)(value).id);
};
const $e44b536616936050$export$f187c825de05664b = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$aa8970635118882c = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$823b946bef17fbde = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
};
const $e44b536616936050$export$f56da03febf03bbe = (id, value, fields)=>{
    const accountIds = (0, $5kDIl.mapUserOptionsToAccountIds)(value);
    fields.multipleSelectUserPickerFields.push({
        fieldId: id,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        users: accountIds
    });
};
const $e44b536616936050$export$dd0315e6bb70be50 = (id, value, fields)=>{
    const option = (0, $em1U0.transformToServerValue)(value);
    if (option !== null) {
        fields.stringFields.push($e44b536616936050$var$toStringField(id, option.id));
        if (option.child) fields.stringFields.push($e44b536616936050$var$toStringField(`${id}:1`, option.child.id));
    }
};
const $e44b536616936050$export$44ca38ec8bc1b849 = (id, value, fields)=>{
    if (!value) return;
    const result = (0, $5kDIl.mapUserOptionsToIds)(value);
    if (!Array.isArray(result)) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, result.id));
};
const $e44b536616936050$export$3930624833f8c678 = (id, value, fields)=>{
    fields.stringFields.push($e44b536616936050$var$toStringField(id, (0, $aSk8p.mapOptionToData)(value).id));
};
const $e44b536616936050$export$550c89601caa8cb = (id, value, fields)=>{
    fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, value.map((o)=>o.value).filter((selectedValue)=>typeof selectedValue === 'string' || typeof selectedValue === 'number').map((o)=>String(o))));
};
const $e44b536616936050$export$a751298e00103db5 = (_id, value, fields)=>{
    if (Array.isArray(value) && value.length >= 1) {
        const ids = (0, $bWtQ8.getFileIdsFromFiles)(value);
        fields.stringFields.push($e44b536616936050$var$toStringField('attachment', ids.join(',')));
    }
};
const $e44b536616936050$export$8545d310869fe805 = (id, value, fields)=>{
    if (!value) return;
    if (typeof value === 'string' && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) // On forms_multiline_text_wiki_renderer cleanup, merge this early exit with one above:
    // I.e. if (!value || typeof value === 'string')
    return;
    // @ts-expect-error Remove this typecheck suppression on forms_multiline_text_wiki_renderer cleanup ts(2345)
    fields.adfFields.push($e44b536616936050$var$toADFField(id, value));
};
const $e44b536616936050$export$8b286e49fa801799 = (id, value, fields)=>{
    const group = $e44b536616936050$var$toGroupInput(value);
    fields.singleGroupPickerFields.push({
        fieldId: id,
        group: group
    });
};
const $e44b536616936050$export$ada212938d86109a = (id, value, fields)=>{
    const groups = value.map($e44b536616936050$var$toGroupInput);
    fields.multipleGroupPickerFields.push({
        fieldId: id,
        groups: groups
    });
};
const $e44b536616936050$export$77028ba2835a8f1c = (id, value, fields)=>{
    if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, value.value));
};
const $e44b536616936050$export$1c1d0a4431d22b72 = (id, value, fields)=>{
    if (value?.accountId) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, value.accountId));
};

});
parcelRegister("5kDIl", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $5870d9a04b0eab40$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $5870d9a04b0eab40$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $5870d9a04b0eab40$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $5870d9a04b0eab40$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $5870d9a04b0eab40$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $5870d9a04b0eab40$export$53e350638c0acebc);

const $5870d9a04b0eab40$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $5870d9a04b0eab40$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($5870d9a04b0eab40$export$3e406786572c35b0);
    return $5870d9a04b0eab40$export$3e406786572c35b0(defaultValue);
};
const $5870d9a04b0eab40$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $5870d9a04b0eab40$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $5870d9a04b0eab40$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $5870d9a04b0eab40$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});
const $2b6d45687558f2b0$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $2b6d45687558f2b0$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';


parcelRegister("bWtQ8", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $7bad3ba374b5e258$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $7bad3ba374b5e258$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $7bad3ba374b5e258$export$2fab292eea84487a);

var $bGrWH = parcelRequire("bGrWH");
const $7bad3ba374b5e258$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $7bad3ba374b5e258$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $7bad3ba374b5e258$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("em1U0", function(module, exports) {

$parcel$export(module.exports, "transformToServerValue", () => $657085c715b654ca$export$6f0c6eec5b71d787);

var $gJBT6 = parcelRequire("gJBT6");
const $657085c715b654ca$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $657085c715b654ca$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $657085c715b654ca$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $657085c715b654ca$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $657085c715b654ca$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("hx8g7", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $551084a6b97f85f9$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $551084a6b97f85f9$export$ffef3a401aef987b);
const $551084a6b97f85f9$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $551084a6b97f85f9$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));

});

parcelRegister("4IxfP", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ae732ed1951f68ed$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ae732ed1951f68ed$export$fc800909123977f3);
const $ae732ed1951f68ed$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $ae732ed1951f68ed$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("aSk8p", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $08634f5a5ba1d218$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $08634f5a5ba1d218$export$fc800909123977f3);
const $08634f5a5ba1d218$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $08634f5a5ba1d218$export$fc800909123977f3 = ({ label: label, value: value })=>({
        id: value,
        value: label
    });

});

parcelRegister("5pHXe", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $aeaea2f472af8476$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $aeaea2f472af8476$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $aeaea2f472af8476$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $aeaea2f472af8476$export$dc22cde66e28d4af);
const $aeaea2f472af8476$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $aeaea2f472af8476$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $aeaea2f472af8476$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $aeaea2f472af8476$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$aeaea2f472af8476$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("1K3Xb", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $903ba9c436cc186a$export$c10cf32c4acc1d57);

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $kz2lw = parcelRequire("kz2lw");
const $903ba9c436cc186a$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $kz2lw.getEmptyADF)();
    return (0, $bPWvi.doc)((0, $50sdg.paragraph)(text));
};

});
parcelRegister("bPWvi", function(module, exports) {

$parcel$export(module.exports, "doc", () => $c17b5e301ceeeae8$export$2a111da947c407d2);
const $c17b5e301ceeeae8$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("50sdg", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $b5360ede7330200d$export$9c206ddddb32a9b);

var $3lRhe = parcelRequire("3lRhe");
const $b5360ede7330200d$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $3lRhe.createTextNodes)(content)
    });

});
parcelRegister("3lRhe", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4fbd120aea0a69b1$export$3a269a5941b62f04);

var $gBTcG = parcelRequire("gBTcG");
function $4fbd120aea0a69b1$export$3a269a5941b62f04(nodes) {
    return nodes.map($4fbd120aea0a69b1$export$72b9432ea0656b50);
}
function $4fbd120aea0a69b1$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $gBTcG.text)(str) : str;
}

});
parcelRegister("gBTcG", function(module, exports) {

$parcel$export(module.exports, "text", () => $9654feec8f8dd4ec$export$6f093cfa640b7166);
const $9654feec8f8dd4ec$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});






parcelRegister("22Wo8", function(module, exports) {

$parcel$export(module.exports, "AssigneeFieldTypeConfig", () => $818cad83f092a8b9$export$760aa32e02dd931e);

var $5uXOq = parcelRequire("5uXOq");

var $bdVbi = parcelRequire("bdVbi");

var $5FwUN = parcelRequire("5FwUN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $818cad83f092a8b9$var$AssigneeFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FwUN.default), props);
const $818cad83f092a8b9$export$760aa32e02dd931e = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))),
    type: (0, $5fc53.ASSIGNEE_TYPE),
    Component: $818cad83f092a8b9$var$AssigneeFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.assigneeFieldWriter)
};

});
parcelRegister("5FwUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $489f100aee3a6307$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $89S0t = parcelRequire("89S0t");

var $leRCk = parcelRequire("leRCk");

var $dCm1o = parcelRequire("dCm1o");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $bfnma = parcelRequire("bfnma");

var $5rYSU = parcelRequire("5rYSU");
const $489f100aee3a6307$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, $dCm1o.isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    const assignToMeButton = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button",
        xcss: $489f100aee3a6307$var$assignToMeStyles
    }, formatMessage((0, $bfnma.default).assignToMe)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $bfnma.default).assignToMe));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($489f100aee3a6307$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89S0t.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && assignToMeButton);
};
var $489f100aee3a6307$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateAssigneeField),
    transformDefaultValue: (0, $5rYSU.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($489f100aee3a6307$export$7c52097ee36bd91);
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $7C5S0.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
            __cmplp.className
        ])
    });
});
const $489f100aee3a6307$var$assignToMeStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    color: 'color.link',
    cursor: 'pointer',
    marginTop: 'space.050',
    padding: 'space.0',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $489f100aee3a6307$var$FieldContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn, $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff);

});
parcelRegister("89S0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7ac4b7108cf6a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $aWse0 = parcelRequire("aWse0");

var $ecbCU = parcelRequire("ecbCU");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $6s1PB = parcelRequire("6s1PB");

var $itmJb = parcelRequire("itmJb");

var $jq9TF = parcelRequire("jq9TF");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");

var $h36wX = parcelRequire("h36wX");

var $kt8K4 = parcelRequire("kt8K4");
const $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $duUGa.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $3a7ac4b7108cf6a7$var$isImproveInviteViaAssigneeEnabled = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_improve_invite_via_assignee');
    return config.get('isEnabled', false);
};
const $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, isRequired: isRequired, styles: styles, menuPortalTarget: menuPortalTarget, components: components, ...fieldProps })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const self = (0, $5uXOq.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $kt8K4.default)(autoCompleteUrl || '');
    const isEligibleForInviteOnOpen = (0, $jq9TF.useIsEligibleForInviteOnOpen)();
    const shouldShowInviteOnOpen = isEligibleForInviteOnOpen && enablePeopleInvite && $3a7ac4b7108cf6a7$var$isImproveInviteViaAssigneeEnabled();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const [assigneeValue, assigneeOptions, { userOptionsCount: userOptionsCount }] = (0, $h36wX.useAssigneeOptions)({
        value: value,
        users: users,
        intl: intl,
        shouldPreloadAssignToMe: shouldPreloadAssignToMe,
        search: self.previousQuery,
        enablePeopleInvite: enablePeopleInvite,
        enableAutomaticOption: enableAutomaticOption,
        shouldHideUnassigned: isRequired,
        shouldShowInviteOnOpen: shouldShowInviteOnOpen
    });
    const [, { openDrawer: openDrawer }] = (0, $ecbCU.useInvitePeopleDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        // Exposure is fired here for jira_improve_invite_via_assignee because it is when the Assignee Field is opened
        if (isEligibleForInviteOnOpen && enablePeopleInvite) {
            if ((0, $6s1PB.expVal)('jira_improve_invite_via_assignee', 'isEnabled', false)) (0, $h36wX.fireInviteItemRendererEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptionsCount,
                isAdmin: isAdmin
            });
        }
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'inlineAssigneePickerEdit opened', {
            isAdmin: isAdmin,
            enablePeopleInvite: enablePeopleInvite,
            shouldShowInviteOnOpen: shouldShowInviteOnOpen
        });
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        enablePeopleInvite,
        users,
        createAnalyticsEvent,
        isAdmin,
        isEligibleForInviteOnOpen,
        shouldShowInviteOnOpen,
        userOptionsCount,
        fetchUsers
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) || updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $fhSLy.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openDrawer,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        inputId: inputId,
        fieldId: (0, $5fc53.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $7lGt2.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ariaLabel: ariaLabel,
        menuPortalTarget: menuPortalTarget,
        styles: styles,
        components: components,
        ...controlProps
    });
};
var $3a7ac4b7108cf6a7$export$2e2bcd8739ae039 = $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit;

});
parcelRegister("ecbCU", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleDrawer", () => $6f07668563b12d68$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $6f07668563b12d68$export$b7dab610045052db);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $2fX5x = parcelRequire("2fX5x");
const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
const $6f07668563b12d68$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $6f07668563b12d68$var$Store = (0, $iXqE5.createStore)({
    name: $6f07668563b12d68$var$CONTROLLER_NAME,
    initialState: $6f07668563b12d68$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $2fX5x.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $2fX5x.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
    }
});
const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, $3sQ5x.createHook)($6f07668563b12d68$var$Store);
const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, $gg7kZ.createContainer)($6f07668563b12d68$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, $51nlc.createSubscriber)($6f07668563b12d68$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
    (0, $bKpgX.defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("2fX5x", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $b69ddc7a728288ef$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $b69ddc7a728288ef$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $b69ddc7a728288ef$export$21b810258e82d438);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $d3xqi = parcelRequire("d3xqi");
const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $5uXOq.useRef)((0, $fjcgS.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $lhVtI.getEvent)(analyticsEvent)));
        }
    };
};
const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $d3xqi.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("d3xqi", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $1b54655f5f68975f$export$c35cd18e9d0123e3);
const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("jq9TF", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForInviteOnOpen", () => $10e3b4d6fb18a81c$export$68fb0ef7a3be1bd);

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $DgoP6 = parcelRequire("DgoP6");
const $10e3b4d6fb18a81c$export$68fb0ef7a3be1bd = ()=>{
    const { isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware } = (0, $DgoP6.useIsCurrentProjectJiraSoftware)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    return isCurrentProjectJiraSoftware && (isAdmin || isSiteAdmin);
};

});
parcelRegister("DgoP6", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentProjectJiraSoftware", () => $9b91e5ab0a1f0062$export$7c1f0cb7cb50b335);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $9b91e5ab0a1f0062$export$7c1f0cb7cb50b335 = ()=>{
    const { data: projectContextData, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isCurrentProjectJiraSoftware = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return {
        loading: loading,
        isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware
    };
};

});


const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $gRwYv = parcelRequire("gRwYv");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($gRwYv)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("gRwYv", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});


parcelRegister("h36wX", function(module, exports) {

$parcel$export(module.exports, "fireInviteItemRendererEvent", () => $92b31ca8d85d4433$export$85383b532f48700a);
$parcel$export(module.exports, "useAssigneeOptions", () => $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);

var $3OKtJ = parcelRequire("3OKtJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $leRCk = parcelRequire("leRCk");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $92b31ca8d85d4433$export$85383b532f48700a = ({ createAnalyticsEvent: createAnalyticsEvent, suggestionsCount: suggestionsCount, isAdmin: isAdmin, isInviteAndAssignFromBoard: isInviteAndAssignFromBoard = false })=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = ({ value: value, users: users, intl: intl, shouldPreloadAssignToMe: shouldPreloadAssignToMe, search: search, enablePeopleInvite: enablePeopleInvite, enableAutomaticOption: enableAutomaticOption, suggestedEmailDomain: suggestedEmailDomain, isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, shouldHideUnassigned: shouldHideUnassigned, shouldShowInviteOnOpen: shouldShowInviteOnOpen })=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const automaticOption = (0, $fhSLy.getAutomaticUserOption)(intl);
    const valueOption = (0, $fhSLy.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $fhSLy.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $7lGt2.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !shouldHideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $fhSLy.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && shouldShowInviteOnOpen) {
        if (isEligibleForInviteAndAssign && search) invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
        else invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
    } else if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin,
                isInviteAndAssignFromBoard: true
            });
        } else {
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin
            });
            invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $fhSLy.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $fhSLy.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options,
        {
            userOptionsCount: userOptions.length
        }
    ];
};

});
parcelRegister("3OKtJ", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $d369cb9a3149539e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $d369cb9a3149539e$export$34e0d98131b0b98a);

var $M0UM1 = parcelRequire("M0UM1");

var $ePvDo = parcelRequire("ePvDo");


var $eXneb = parcelRequire("eXneb");
const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $a56e5eac5897104f$export$18d36911c7f94286),
        (0, $a56e5eac5897104f$export$da1c529049028734)
    ].includes((0, $M0UM1.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $M0UM1.isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ePvDo))),
        byline: formatMessage((0, $eXneb.default).inviteAndAssign),
        isDisabled: (0, $M0UM1.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("ePvDo", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("eXneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $31de51ead46cb5cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("kt8K4", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a5b059c2a0fff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchUsers = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers(query) : (0, $7f4tk.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;

});


parcelRegister("jGVMX", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $e5b3b607ab8affce$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $e5b3b607ab8affce$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $e5b3b607ab8affce$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $e5b3b607ab8affce$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $e5b3b607ab8affce$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $e5b3b607ab8affce$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $e5b3b607ab8affce$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $e5b3b607ab8affce$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $e5b3b607ab8affce$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $e5b3b607ab8affce$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $e5b3b607ab8affce$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $e5b3b607ab8affce$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $e5b3b607ab8affce$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $e5b3b607ab8affce$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $e5b3b607ab8affce$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $e5b3b607ab8affce$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $e5b3b607ab8affce$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $e5b3b607ab8affce$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $bGrWH = parcelRequire("bGrWH");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $bGrWH.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $d46ffa3990e23a4d$export$fe1a70381f6491b5)) return 0, $d46ffa3990e23a4d$export$618e922e89e8bcae;
    return undefined;
};
const $e5b3b607ab8affce$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
        if (!value.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e5b3b607ab8affce$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $bGrWH.REQUIRED;
    return undefined;
};
const $e5b3b607ab8affce$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $e5b3b607ab8affce$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$e77d629cc732976d;
    return undefined;
};
const $e5b3b607ab8affce$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $bGrWH.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $bGrWH.REQUIRED;
    }
    if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f;
    return undefined;
};

});

parcelRegister("bfnma", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd95939e2e05e754$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd95939e2e05e754$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("5rYSU", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $b31c169a5b4e6cfd$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $b31c169a5b4e6cfd$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $b31c169a5b4e6cfd$export$a6706b2f4762043b);


const $b31c169a5b4e6cfd$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $b31c169a5b4e6cfd$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $b31c169a5b4e6cfd$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});



parcelRegister("1Zt9x", function(module, exports) {

$parcel$export(module.exports, "AttachmentFieldTypeConfig", () => $4f864de41952e13f$export$ada1e5fc2d37745a);

var $5uXOq = parcelRequire("5uXOq");

var $dP8up = parcelRequire("dP8up");

var $azL7v = parcelRequire("azL7v");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $4f864de41952e13f$var$AttachmentFieldTypeComponent = (props)=>props.mediaUploadContexts.attachmentUploadContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azL7v.default), {
        ...props,
        mediaUploadContext: props.mediaUploadContexts.attachmentUploadContext
    }) : null;
const $4f864de41952e13f$export$ada1e5fc2d37745a = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dP8up))),
    type: (0, $5fc53.ATTACHMENT_TYPE),
    Component: $4f864de41952e13f$var$AttachmentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AttachmentFieldPlaceholder), null),
    writer: (0, $kShoa.attachmentFieldWriter)
};

});
parcelRegister("dP8up", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174ee51c60633f76b0dbf1c968e4afc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1069f9774dbd57c$var$_react = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1069f9774dbd57c$var$_baseNew = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a1069f9774dbd57c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1069f9774dbd57c$var$AttachmentIcon = (props)=>/*#__PURE__*/ $a1069f9774dbd57c$var$_react.default.createElement($a1069f9774dbd57c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$a1069f9774dbd57c$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $a1069f9774dbd57c$var$_default = module.exports.default = $a1069f9774dbd57c$var$AttachmentIcon;

});

parcelRegister("azL7v", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $e446c7b6c6df08e3$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $e446c7b6c6df08e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k9tnV = parcelRequire("k9tnV");

var $eCeGD = parcelRequire("eCeGD");

var $hPcwl = parcelRequire("hPcwl");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $bGrWH = parcelRequire("bGrWH");

var $3F8e9 = parcelRequire("3F8e9");

var $lySs6 = parcelRequire("lySs6");

var $6UFK0 = parcelRequire("6UFK0");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

var $hpV4g = parcelRequire("hpV4g");

var $c431P = parcelRequire("c431P");

var $bWtQ8 = parcelRequire("bWtQ8");
const $e446c7b6c6df08e3$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $lySs6.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $5uXOq.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    if ((0, $4R6GH.fg)('gic-attachment-field-with-react18-concurrent-mode')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const fieldElement = document.getElementById((0, $bWtQ8.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $k9tnV.default)(fieldElement, (0, $bGrWH.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$FieldDropzoneContainer, {
        id: (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $c431P.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UFK0.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $bWtQ8.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e446c7b6c6df08e3$var$browseButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: ()=>setIsBrowserOpen(true),
            "aria-label": formatMessage((0, $c431P.default).browseAriaLabel)
        }, formatMessage((0, $c431P.default).browse)))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e446c7b6c6df08e3$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3F8e9.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $e446c7b6c6df08e3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $hpV4g.withFormField)({
    validator: (0, $bWtQ8.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($e446c7b6c6df08e3$export$f7c49e57ef98664f);
const $e446c7b6c6df08e3$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqogq9o _1h6dmuej _1e0c1txw _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz131l",
            __cmplp.className
        ])
    });
});
const $e446c7b6c6df08e3$var$mediaContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
const $e446c7b6c6df08e3$var$browseButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e446c7b6c6df08e3$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3F8e9", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $eb0c63a29297e8e6$export$85605b8f3b532b83);

var $kxZPA = parcelRequire("kxZPA");

const $eb0c63a29297e8e6$export$85605b8f3b532b83 = (0, $kxZPA.lazy)(()=>(parcelRequire("464wE")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("464wE", function(module, exports) {

let $2fbb3ba6cb3272eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2fbb3ba6cb3272eb$var$load("4NTvA").then(()=>parcelRequire('4MZE8'));

});


parcelRegister("lySs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25872ff6af438731$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $f4KvR = parcelRequire("f4KvR");
const $25872ff6af438731$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $5uXOq.useState)([]);
    const [files, setFiles] = (0, $5uXOq.useState)([]);
    const [isUploading, setUploading] = (0, $5uXOq.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $5uXOq.useState)(false);
    const stateRef = (0, $5uXOq.useRef)();
    stateRef.current = files;
    (0, $5uXOq.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext
    ]);
    const uploadConfig = (0, $5uXOq.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $5uXOq.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $f4KvR.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $5uXOq.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $5uXOq.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId)) await (0, $f4KvR.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId)) await (0, $f4KvR.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $25872ff6af438731$export$2e2bcd8739ae039 = $25872ff6af438731$var$useAttachments;

});
parcelRegister("f4KvR", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $ac4c15282d67ab83$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $ac4c15282d67ab83$export$ed1597b81cfdb5f6);

var $eusud = parcelRequire("eusud");
const $ac4c15282d67ab83$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $ac4c15282d67ab83$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $ac4c15282d67ab83$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $eusud.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $ac4c15282d67ab83$export$a7455b0d8bb5c44e(id) : $ac4c15282d67ab83$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $ac4c15282d67ab83$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("6UFK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c958c4e419db9df$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ayrxQ = parcelRequire("ayrxQ");
var $lU1w9 = parcelRequire("lU1w9");

var $495Tz = parcelRequire("495Tz");
const $2c958c4e419db9df$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $5uXOq.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayrxQ.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lU1w9.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $495Tz.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $2c958c4e419db9df$export$2e2bcd8739ae039 = $2c958c4e419db9df$var$AttachmentsUpload;

});
parcelRegister("ayrxQ", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $91b264e5a1a03fda$export$3ce634ac4a869e2c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $91b264e5a1a03fda$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("jU413")),
                (parcelRequire("hGp4f"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Browser, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("jU413", function(module, exports) {

let $e7d65ccbd02ed6b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7d65ccbd02ed6b5$var$load("43LVx").then(()=>parcelRequire('7b5A1'));

});

parcelRegister("hGp4f", function(module, exports) {

let $cdf9cdcfe0c2c027$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cdf9cdcfe0c2c027$var$load("76n7a"),
    $cdf9cdcfe0c2c027$var$load("l253H"),
    $cdf9cdcfe0c2c027$var$load("ffQaD"),
    $cdf9cdcfe0c2c027$var$load("kvRbA"),
    $cdf9cdcfe0c2c027$var$load("48RmA")
]).then(()=>parcelRequire('fr527'));

});


parcelRegister("lU1w9", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $5f5f884766c60e4b$export$66201d263cd6342);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");



class $5f5f884766c60e4b$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("jU413")),
                (parcelRequire("1keZH")),
                (parcelRequire("a27tU"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $5f5f884766c60e4b$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaPickerErrorBoundary, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Dropzone, {
                ...this.props
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("1keZH", function(module, exports) {

let $0f734a3af261c948$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0f734a3af261c948$var$load("76n7a"),
    $0f734a3af261c948$var$load("l253H"),
    $0f734a3af261c948$var$load("ffQaD"),
    $0f734a3af261c948$var$load("kvRbA"),
    $0f734a3af261c948$var$load("255Pc")
]).then(()=>parcelRequire('cw5oc'));

});

parcelRegister("a27tU", function(module, exports) {

let $74dfe4ea4cc6a431$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74dfe4ea4cc6a431$var$load("kNFvF"),
    $74dfe4ea4cc6a431$var$load("hTZXe")
]).then(()=>parcelRequire('quJ0B'));

});


parcelRegister("495Tz", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $a204c5b4c1d898fb$export$8b44c43c7d8f0830);

var $5uXOq = parcelRequire("5uXOq");

var $2AN6s = parcelRequire("2AN6s");

var $46dC9 = parcelRequire("46dC9");
const $a204c5b4c1d898fb$export$7b1ba4955557a858 = ()=>null;
const $a204c5b4c1d898fb$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $46dC9.useClipboardContextBoundary)();
    const onPaste = (0, $5uXOq.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a204c5b4c1d898fb$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2AN6s.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("2AN6s", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $943d05c2815ce49d$export$d7936799bf32b554);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


class $943d05c2815ce49d$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("jU413")),
                (parcelRequire("cmkGh"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $943d05c2815ce49d$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(this.state.Clipboard, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("cmkGh", function(module, exports) {

let $8ff794ec8d364b01$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ff794ec8d364b01$var$load("jjoMI").then(()=>parcelRequire('h0DlA'));

});


parcelRegister("46dC9", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $315b0e877a12fb17$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $315b0e877a12fb17$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $315b0e877a12fb17$export$37046969a30ae0a0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $315b0e877a12fb17$var$ClipboardStore = (0, $iXqE5.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $315b0e877a12fb17$export$c4bc9440a978eec1 = (0, $gg7kZ.createContainer)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$export$a3e41c5b3d4c30b7 = (0, $3sQ5x.createActionsHook)($315b0e877a12fb17$var$ClipboardStore);
const $315b0e877a12fb17$var$useClipboardContextBoundarySelector = (0, $3sQ5x.createHook)($315b0e877a12fb17$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $315b0e877a12fb17$export$37046969a30ae0a0 = ()=>$315b0e877a12fb17$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("c431P", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a51dc4ce208a9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $23a51dc4ce208a9a$var$messages = (0, $7VHMR.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "Browse"
    },
    browseAriaLabel: {
        "id": "issue-create-commons.attachments-field.browse-aria-label",
        "defaultMessage": "Browse attachment"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $23a51dc4ce208a9a$export$2e2bcd8739ae039 = $23a51dc4ce208a9a$var$messages;

});



parcelRegister("1C9NJ", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectFieldTypeConfig", () => $19ee995e12970e69$export$b1cccbe22677a87b);

var $5uXOq = parcelRequire("5uXOq");

var $4xPlE = parcelRequire("4xPlE");

var $gbo8w = parcelRequire("gbo8w");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $19ee995e12970e69$var$CascadingSelectFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gbo8w.default), props);
const $19ee995e12970e69$export$b1cccbe22677a87b = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
    type: (0, $5fc53.CASCADING_SELECT_CF_TYPE),
    Component: $19ee995e12970e69$var$CascadingSelectFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.cascadingSelectFieldWriter)
};

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("gbo8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $094c2ce3abc8686f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4zFcG = parcelRequire("4zFcG");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $j0pqC = parcelRequire("j0pqC");

const $094c2ce3abc8686f$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $5uXOq.useMemo)(()=>(0, $j0pqC.transformToCascadingSelectOptions)(cascadingSelectOptions), [
        cascadingSelectOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zFcG.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: !isReadOnly && isEditable
    }));
};
var $094c2ce3abc8686f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCascadingSelectField),
    transformDefaultValue: $j0pqC.transformDefaultValue
})($094c2ce3abc8686f$var$CascadingSelectField);

});
parcelRegister("4zFcG", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $0a411cf33e78ceb6$export$7db21897d0716698);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kmnNN = parcelRequire("kmnNN");
const $0a411cf33e78ceb6$var$EMPTY_OBJECT = {};
const $0a411cf33e78ceb6$export$7db21897d0716698 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kmnNN.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $0a411cf33e78ceb6$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("kmnNN", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $8f41019f840ae33a$export$336a3a4bd9539e41);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8f41019f840ae33a$export$336a3a4bd9539e41 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bWN5R")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bWN5R", function(module, exports) {

let $8b2b3173766e3fc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b2b3173766e3fc0$var$load("fpfl8").then(()=>parcelRequire('aKsI4'));

});



parcelRegister("j0pqC", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $c7fead76ffb795b3$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $c7fead76ffb795b3$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $c7fead76ffb795b3$export$f402e35d933d11b5);

const $c7fead76ffb795b3$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $c7fead76ffb795b3$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($c7fead76ffb795b3$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $c7fead76ffb795b3$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $c7fead76ffb795b3$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $c7fead76ffb795b3$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $4a7dfdb992f68644$export$31fd86f8f183952c)
    });

});
const $4a7dfdb992f68644$export$31fd86f8f183952c = 'cascadingSelectFields';




parcelRegister("97VNg", function(module, exports) {

$parcel$export(module.exports, "CategoryFieldTypeConfig", () => $8500d0c5b0bf9983$export$3e2ea7bfd7261cb5);

var $5uXOq = parcelRequire("5uXOq");

var $3fDjf = parcelRequire("3fDjf");

var $k4tyx = parcelRequire("k4tyx");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $8500d0c5b0bf9983$var$CategoryFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4tyx.default), {
        ...props,
        defaultValue: undefined
    });
const $8500d0c5b0bf9983$export$3e2ea7bfd7261cb5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))),
    type: (0, $5fc53.CATEGORY_TYPE),
    Component: $8500d0c5b0bf9983$var$CategoryFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("k4tyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $108361897c01a8f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $108361897c01a8f5$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: false,
        closeMenuOnSelect: true
    });
var $108361897c01a8f5$export$2e2bcd8739ae039 = $108361897c01a8f5$var$SingleSelectField;

});
parcelRegister("d3RWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $da96ee86c52df1e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cOyAh = parcelRequire("cOyAh");

var $5pHXe = parcelRequire("5pHXe");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $90YqS = parcelRequire("90YqS");
const $da96ee86c52df1e6$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, closeMenuOnSelect: closeMenuOnSelect = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOyAh.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $5pHXe.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $90YqS.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id,
        closeMenuOnSelect: closeMenuOnSelect
    }));
};
var $da96ee86c52df1e6$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $90YqS.transformDefaultSelectValues),
    validator: (0, $jGVMX.validateSelectField)
})($da96ee86c52df1e6$var$SelectField);

});
parcelRegister("cOyAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ff8480905da065$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $lElIo = parcelRequire("lElIo");

var $4R6GH = parcelRequire("4R6GH");
const $45ff8480905da065$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, closeMenuOnSelect: closeMenuOnSelect = false, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, defaultMenuIsOpen: defaultMenuIsOpen } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        closeMenuOnSelect: closeMenuOnSelect,
        ...(0, $4R6GH.fg)('bulk_ops_ktlo_fixes') && {
            defaultMenuIsOpen: defaultMenuIsOpen
        }
    });
};
var $45ff8480905da065$export$2e2bcd8739ae039 = $45ff8480905da065$var$SelectEdit;

});

parcelRegister("90YqS", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $3a49366a4ffd7ccc$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $3a49366a4ffd7ccc$export$5fde4483c43b93b);

var $5pHXe = parcelRequire("5pHXe");
const $3a49366a4ffd7ccc$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $5pHXe.mapDataToSelectOptions)(defaultValue);
    return (0, $5pHXe.mapDataToSelectOption)(defaultValue);
};
const $3a49366a4ffd7ccc$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});




parcelRegister("aR835", function(module, exports) {

$parcel$export(module.exports, "ComponentsFieldTypeConfig", () => $004c360808306af4$export$75a450cecebc09fa);

var $5uXOq = parcelRequire("5uXOq");

var $ehis8 = parcelRequire("ehis8");

var $776me = parcelRequire("776me");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $004c360808306af4$var$ComponentsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $776me.default), props);
// Effectively the same as `multiSelectFieldWriter`. For some reason, the type of the field value of
// `ComponentsField` (`Options`) has a nullable value type. This function just pre-processes the value
// to strip away any `null` value options before passing it to `multiSelectFieldWriter`.
const $004c360808306af4$var$componentsFieldWriter = (id, value, fields)=>{
    const filteredValues = value.filter((option)=>option.value !== null);
    (0, $kShoa.multiSelectFieldWriter)(id, filteredValues, fields);
};
const $004c360808306af4$export$75a450cecebc09fa = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ehis8))),
    type: (0, $5fc53.COMPONENTS_TYPE),
    Component: $004c360808306af4$var$ComponentsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: $004c360808306af4$var$componentsFieldWriter
};

});
parcelRegister("776me", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c3a95c2efe6aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $hFon0 = parcelRequire("hFon0");

var $koVbs = parcelRequire("koVbs");

var $as9La = parcelRequire("as9La");

var $6Fkzt = parcelRequire("6Fkzt");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $YSJPS = parcelRequire("YSJPS");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $b399U = parcelRequire("b399U");

const $f6c3a95c2efe6aba$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $6Fkzt.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $hFon0.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YSJPS.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as9La.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $b399U.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $b399U.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $f6c3a95c2efe6aba$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $6Fkzt.mapDataToOptions),
    validator: (0, $jGVMX.validateComponentField),
    shouldRenderFieldMessage: false
})($f6c3a95c2efe6aba$var$ComponentsField);

});
parcelRegister("hFon0", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $e88d764a116eddca$export$a070f388fcd93df0);

var $5uXOq = parcelRequire("5uXOq");

var $do78Z = parcelRequire("do78Z");

var $feQhf = parcelRequire("feQhf");
function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $feQhf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $feQhf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $do78Z.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("do78Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b15e5e3de311da0$export$2e2bcd8739ae039);

var $c3jsi = parcelRequire("c3jsi");

var $1AJVB = parcelRequire("1AJVB");
var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, $c3jsi.default)((0, $1AJVB.props));

});
parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $2YZCu = parcelRequire("2YZCu");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';



parcelRegister("1AJVB", function(module, exports) {

$parcel$export(module.exports, "props", () => $68c0e7b1e3ad3adb$export$8128bb6492cf3de7);

const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
    size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
    cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
};

});


parcelRegister("feQhf", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $f3ade48088ec15c3$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $f3ade48088ec15c3$export$71702a5b14caff65);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $eusud.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("as9La", function(module, exports) {

$parcel$export(module.exports, "default", () => $974a261702eec2af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iOwNT = parcelRequire("iOwNT");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $2Icx9 = parcelRequire("2Icx9");

var $lMeVa = parcelRequire("lMeVa");
const $974a261702eec2af$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getNewInlineComponentCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $lMeVa.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $lMeVa.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Icx9.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $974a261702eec2af$export$2e2bcd8739ae039 = $974a261702eec2af$var$ComponentsSelectEdit;

});
parcelRegister("2Icx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b255b0441ea615$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $99M5v = parcelRequire("99M5v");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $dyW5a = parcelRequire("dyW5a");
const $b5b255b0441ea615$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, restProps, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: "componentFooterAddIcon",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$var$LinkText, null, footerLabel ?? formatMessage((0, $dyW5a.default).componentLabel))))));
};
var $b5b255b0441ea615$export$2e2bcd8739ae039 = $b5b255b0441ea615$var$MenuWithFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5b255b0441ea615$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$fd9000017733fabf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _1e0c1txw _2lx2vrvc _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _1bsb1osq _irr3166n",
            __cmplp.className
        ])
    });
});
const $b5b255b0441ea615$export$e0513c91be1318ca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyW5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ca6088d964e72a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86ca6088d964e72a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("lMeVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb020ac6d54b422f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb020ac6d54b422f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("6Fkzt", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $4d2c67350b914b81$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $4d2c67350b914b81$export$ffef3a401aef987b);
const $4d2c67350b914b81$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $4d2c67350b914b81$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("b399U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31bbe63abb7b51a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $f31bbe63abb7b51a$var$messages = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $f31bbe63abb7b51a$export$2e2bcd8739ae039 = $f31bbe63abb7b51a$var$messages;

});



parcelRegister("9Hxrl", function(module, exports) {

$parcel$export(module.exports, "DateCustomFieldTypeConfig", () => $bdb941f53f9415a4$export$a7f793e7c226ca61);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $iY8FG = parcelRequire("iY8FG");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $bdb941f53f9415a4$var$DateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY8FG.default), props);
const $bdb941f53f9415a4$export$a7f793e7c226ca61 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DATE_CF_TYPE),
    Component: $bdb941f53f9415a4$var$DateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateFieldPlaceholder), null),
    writer: (0, $kShoa.dateFieldWriter)
};

});
parcelRegister("iY8FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f022abefd67c0e3c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $cHapz = parcelRequire("cHapz");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $6yeNV = parcelRequire("6yeNV");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $eVzdP = parcelRequire("eVzdP");

const $f022abefd67c0e3c$export$845e1054649a85c2 = 0;
const $f022abefd67c0e3c$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const locale = (0, $DVljb.useLocale)();
    const standardisedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const weekStartDay = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $1p96B.getLocale)(locale), 'options.weekStartsOn', $f022abefd67c0e3c$export$845e1054649a85c2);
    const safeValue = value === null ? undefined : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        value: safeValue,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: standardisedLocale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
      	Temporary fix to prevent form submit on enter press on an open calendar.
      	Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
      	There is no way to know if the calendar is open in the current implementation
      		Side Effect: Form will not submit on enter keyPress even when calendar is not open.
      */ onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
        },
        weekStartDay: weekStartDay,
        label: formatMessage((0, $eVzdP.default).ariaLabel),
        "aria-describedby": `${id}-helper`,
        id: id,
        placeholder: formatMessage((0, $eVzdP.default).placeholder),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $eVzdP.default).ariaLabel)
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$f022abefd67c0e3c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})($f022abefd67c0e3c$var$DateField);

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4694b4334ad7c5c52e5a3aa3cac3904d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.31 6 3.97-3.97L5.22.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06zm4.75 0 3.97-3.97L9.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb038f49280a8a959174d8021780f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("9FL4D", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $ee02e7651d6a8221$export$9d2267fe165de4b6);
const $ee02e7651d6a8221$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("eVzdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $049ff715c3e8bf03$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $049ff715c3e8bf03$var$messages = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    },
    ariaLabel: {
        "id": "issue-create-commons.date-field.aria-label",
        "defaultMessage": "Enter a Date"
    }
});
var $049ff715c3e8bf03$export$2e2bcd8739ae039 = $049ff715c3e8bf03$var$messages;

});



parcelRegister("bunMY", function(module, exports) {

$parcel$export(module.exports, "DateTimeCustomFieldTypeConfig", () => $f1af920deed83f57$export$f2143df7edd6483d);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $fpis9 = parcelRequire("fpis9");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpis9.default), props);
const $f1af920deed83f57$export$f2143df7edd6483d = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DATETIME_CF_TYPE),
    Component: $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateTimeFieldPlaceholder), null),
    writer: (0, $kShoa.dateTimeFieldWriter)
};

});
parcelRegister("fpis9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d01bc814484554$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cHu6v = parcelRequire("cHu6v");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $9FL4D = parcelRequire("9FL4D");

var $jGVMX = parcelRequire("jGVMX");

var $lkRXf = parcelRequire("lkRXf");

const $a9d01bc814484554$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHu6v.AsyncDateTimeFieldEditView), {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerProps: {
            selectProps: {
                onKeyDown: (0, $9FL4D.preventFormSubmitOnEnterKeyPress)
            },
            placeholder: formatMessage((0, $lkRXf.default).datePickerPlaceholder)
        },
        timePickerProps: {
            placeholder: formatMessage((0, $lkRXf.default).timePickerPlaceholder)
        }
    })));
};
var $a9d01bc814484554$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$a9d01bc814484554$export$ae1ced156568f0b0);

});
parcelRegister("cHu6v", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $f165d6e156b4ac02$export$657a1b8545a979b8);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $fwbTL = parcelRequire("fwbTL");
const $f165d6e156b4ac02$var$EMPTY_OBJECT = {};
const $f165d6e156b4ac02$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fwbTL.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $f165d6e156b4ac02$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("fwbTL", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $d8c60609c3da1617$export$971e82244ad6d423);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d8c60609c3da1617$export$971e82244ad6d423 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("epo4c")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("epo4c", function(module, exports) {

let $a7d6119dced9fd66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7d6119dced9fd66$var$load("6wqeS").then(()=>parcelRequire('7p4p7'));

});



parcelRegister("bGEod", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $6a1003bb52c05df4$export$dbd27b551621740c);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");
const $6a1003bb52c05df4$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("lkRXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6bff0fa93541ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bb6bff0fa93541ec$var$messages = (0, $7VHMR.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $bb6bff0fa93541ec$export$2e2bcd8739ae039 = $bb6bff0fa93541ec$var$messages;

});



parcelRegister("bxMnv", function(module, exports) {

$parcel$export(module.exports, "DescriptionFieldTypeConfig", () => $72a9f72b3b249b64$export$efd98ef2e1e5f7e9);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $hDpqy = parcelRequire("hDpqy");

var $kShoa = parcelRequire("kShoa");
const $72a9f72b3b249b64$var$DescriptionFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDpqy.default), {
        ...props,
        defaultValue: undefined,
        fieldWrapperElement: null,
        mediaUploadContext: props.mediaUploadContexts.uploadContext
    });
const $72a9f72b3b249b64$export$efd98ef2e1e5f7e9 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.DESCRIPTION_TYPE),
    Component: $72a9f72b3b249b64$var$DescriptionFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DescriptionFieldPlaceholder), null),
    writer: (0, $kShoa.descriptionFieldWriter)
};

});
parcelRegister("5Hpaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c514376430cef925ef724f6e20a216ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42647e07473269d7$var$_react = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42647e07473269d7$var$_baseNew = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $42647e07473269d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42647e07473269d7$var$TextIcon = (props)=>/*#__PURE__*/ $42647e07473269d7$var$_react.default.createElement($42647e07473269d7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$42647e07473269d7$var$TextIcon.displayName = 'TextIcon';
var $42647e07473269d7$var$_default = module.exports.default = $42647e07473269d7$var$TextIcon;

});

parcelRegister("hDpqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef1b91f5985cb5ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $h0fZ7 = parcelRequire("h0fZ7");

var $4R6GH = parcelRequire("4R6GH");

var $9GobK = parcelRequire("9GobK");

var $7wwVP = parcelRequire("7wwVP");

var $b0zez = parcelRequire("b0zez");
const $ef1b91f5985cb5ff$export$336230c809f2ec53 = (props)=>{
    const editorKey = (0, $5uXOq.useRef)(Date.now());
    const { fieldProps: { value: value, onChange: onChange }, mediaUploadContext: mediaUploadContext, accessLevel: accessLevel } = props;
    if (accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b0zez.PublicDescriptionEdit), {
        key: editorKey.current,
        onChange: onChange,
        defaultValue: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9GobK.DescriptionEdit), {
        key: editorKey.current,
        onChange: onChange,
        defaultValue: value,
        mediaContext: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2740 - Type '{}' is missing the following properties from type 'ViewContext': clientId, serviceHost, token, tokenLifespanInMs, and 3 more
            viewContext: mediaUploadContext || {},
            uploadContext: mediaUploadContext,
            userAuth: null
        }
    }));
};
const $ef1b91f5985cb5ff$var$DescriptionFormField = (0, $hpV4g.withFormField)({
    validator: (0, $h0fZ7.validateDescriptionField)
})($ef1b91f5985cb5ff$export$336230c809f2ec53);
var $ef1b91f5985cb5ff$export$2e2bcd8739ae039 = $ef1b91f5985cb5ff$var$DescriptionFormField;

});
parcelRegister("h0fZ7", function(module, exports) {

$parcel$export(module.exports, "sanitizeADFField", () => $e0781922eb7ae616$export$28941b736a01da7b);
$parcel$export(module.exports, "mutateADFField", () => $e0781922eb7ae616$export$82a40b3982cf31c4);
$parcel$export(module.exports, "validateDescriptionField", () => $e0781922eb7ae616$export$78b1417f15a51a4f);

var $fr1K2 = parcelRequire("fr1K2");

var $kz2lw = parcelRequire("kz2lw");

var $6paOF = parcelRequire("6paOF");

var $bGrWH = parcelRequire("bGrWH");

const $e0781922eb7ae616$var$emptyADFString = JSON.stringify((0, $kz2lw.getEmptyADF)());
const $e0781922eb7ae616$export$28941b736a01da7b = (adfValue)=>{
    // @ts-expect-error extra properties are not a part of ADF
    if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, $6paOF.fireIssueCreateErrorAnalytics)({
        meta: {
            id: 'adfObjectTypeErrorIssueCreate',
            packageName: 'jiraIssueCreateModal',
            teamName: 'gryffindor'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sanitizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(adfValue, [
        'overrideRequired',
        'resetRequired'
    ]);
    return sanitizedValue;
};
const $e0781922eb7ae616$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
    // stringify to compare with emptyADF
    const adfValueString = JSON.stringify(adfValue);
    // emptyADF is special case where input retention should not happen
    return $e0781922eb7ae616$var$emptyADFString === adfValueString ? null : {
        fieldId: fieldId,
        mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
        richText: {
            adfValue: adfValue
        }
    };
};
const $e0781922eb7ae616$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
    if (!isRequired) return undefined;
    const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, $kz2lw.getEmptyADF)());
    if (isAdfEmptyOrUndefined) return 0, $bGrWH.REQUIRED;
    const hardBreakNodeType = 'hardBreak';
    // Users can bypass the required field validation for the description field by pressing shift + enter. shift + enter creates a 'hardBreak' block inside the value. If only hardBreaks exist then treat the description field as empty
    let isAnythingThereApartFromHardBreaks = false;
    if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
        const block = adfValue.content[i];
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'BlockContent | LayoutSectionDefinition | CodeBlockWithMarksDefinition | ExpandWithBreakoutDefinition | ParagraphWithIndentationDefinition'.
        const blockContent = block.content;
        isAnythingThereApartFromHardBreaks = blockContent?.some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blockItem)=>blockItem.type !== hardBreakNodeType);
        if (isAnythingThereApartFromHardBreaks) break;
    }
    if (isAnythingThereApartFromHardBreaks) return undefined;
    return 0, $bGrWH.REQUIRED;
};

});
const $6aa4505c49fca768$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("9GobK", function(module, exports) {

$parcel$export(module.exports, "DescriptionEdit", () => $91ea1cf50c5539fa$export$cd5df8eea6a360e2);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $9ah8z = parcelRequire("9ah8z");

var $lfTZh = parcelRequire("lfTZh");
const $91ea1cf50c5539fa$export$cd5df8eea6a360e2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "smart-card-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
            height: "150px",
            width: "auto"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ah8z.AsyncRichTextEditView), props));

});
parcelRegister("9ah8z", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $5d9d583311ca074a$export$ba962c8a1ae57ac);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $30zeq = parcelRequire("30zeq");
const $5d9d583311ca074a$var$EMPTY_OBJECT = {};
const $5d9d583311ca074a$export$ba962c8a1ae57ac = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $30zeq.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $5d9d583311ca074a$var$EMPTY_OBJECT);
    if ((0, $4R6GH.fg)('fix-create-another-bug-in-react18-concurrent-mode')) // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    else // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("30zeq", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $33d1c4c4e757e553$export$153c0381975152a7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $33d1c4c4e757e553$export$153c0381975152a7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("92ITL")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("92ITL", function(module, exports) {

let $695720d76d98989c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $695720d76d98989c$var$load("fliVL"),
    $695720d76d98989c$var$load("ffQaD"),
    $695720d76d98989c$var$load("kvRbA"),
    $695720d76d98989c$var$load("76n7a"),
    $695720d76d98989c$var$load("l253H"),
    $695720d76d98989c$var$load("dMKmD")
]).then(()=>parcelRequire('dhLv0'));

});




parcelRegister("b0zez", function(module, exports) {

$parcel$export(module.exports, "PublicDescriptionEdit", () => $ddcc2f373e9b5f97$export$16e6b5c02994b47c);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("fxvTQ");
var $exvYd = parcelRequire("exvYd");
parcelRequire("aboEQ");
var $2hnN6 = parcelRequire("2hnN6");

var $kjU5q = parcelRequire("kjU5q");
parcelRequire("gXAdO");
var $cKx1R = parcelRequire("cKx1R");
parcelRequire("at6Ig");
var $kiLfG = parcelRequire("kiLfG");
parcelRequire("cVzPm");
var $9UHJN = parcelRequire("9UHJN");
parcelRequire("oFSWG");
var $kd7KX = parcelRequire("kd7KX");

var $5Xe3v = parcelRequire("5Xe3v");
parcelRequire("g36b0");
var $lsZ2i = parcelRequire("lsZ2i");
parcelRequire("ceDVv");
var $izJY1 = parcelRequire("izJY1");
parcelRequire("cAUAO");
var $eeKOR = parcelRequire("eeKOR");
parcelRequire("98yYt");
var $3LITD = parcelRequire("3LITD");
parcelRequire("gmJvQ");
var $jnbcS = parcelRequire("jnbcS");
parcelRequire("6FArF");
var $lNW3b = parcelRequire("lNW3b");
parcelRequire("3wlyh");
var $IBShN = parcelRequire("IBShN");
parcelRequire("6mXgW");
var $2U5eR = parcelRequire("2U5eR");
parcelRequire("2fcyF");
var $1bV4T = parcelRequire("1bV4T");
parcelRequire("7bJco");
var $4y8T6 = parcelRequire("4y8T6");
parcelRequire("2DIrX");
var $5kxA9 = parcelRequire("5kxA9");
parcelRequire("gha0X");
var $6cMFS = parcelRequire("6cMFS");
parcelRequire("ewWTS");
var $54Pnl = parcelRequire("54Pnl");
parcelRequire("7o36A");
var $8OUh9 = parcelRequire("8OUh9");
parcelRequire("3HDda");
var $7helP = parcelRequire("7helP");
parcelRequire("ai1SC");
var $blumq = parcelRequire("blumq");
parcelRequire("644sF");
var $4R0EL = parcelRequire("4R0EL");
parcelRequire("l4YXu");
var $9lnYw = parcelRequire("9lnYw");
parcelRequire("h0erq");
var $6cRwj = parcelRequire("6cRwj");
parcelRequire("kzUMS");
var $9ttYc = parcelRequire("9ttYc");
parcelRequire("gYYLA");
var $04dn4 = parcelRequire("04dn4");
parcelRequire("V5Jck");
var $5qc2Z = parcelRequire("5qc2Z");
parcelRequire("kMiBI");
var $bTGGC = parcelRequire("bTGGC");

var $4R6GH = parcelRequire("4R6GH");
const $ddcc2f373e9b5f97$export$16e6b5c02994b47c = ({ defaultValue: defaultValue, onChange: onChange })=>{
    const { editorApi: editorApi, preset: preset } = (0, $5Xe3v.usePreset)((builder)=>builder.add([
            (0, $lsZ2i.analyticsPlugin),
            {}
        ]).add((0, $kiLfG.betterTypeHistoryPlugin)).add([
            (0, $54Pnl.pastePlugin),
            {
                isFullPage: false
            }
        ]).add((0, $kd7KX.default)).add((0, $4y8T6.focusPlugin)).add((0, $izJY1.compositionPlugin)).add((0, $3LITD.contextIdentifierPlugin)).add((0, $exvYd.default)).add((0, $IBShN.decorationsPlugin)).add((0, $cKx1R.typeAheadPlugin)).add((0, $5kxA9.default)).add((0, $7helP.primaryToolbarPlugin)).add((0, $04dn4.undoRedoPlugin)).add((0, $2hnN6.blockTypePlugin)).add((0, $9UHJN.clearMarksOnEmptyDocPlugin)).add((0, $9ttYc.textFormattingPlugin)).add((0, $bTGGC.widthPlugin)).add((0, $8OUh9.placeholderPlugin)).add((0, $5qc2Z.unsupportedContentPlugin)).add((0, $2U5eR.editorDisabledPlugin)).add((0, $9lnYw.submitEditorPlugin)).add((0, $jnbcS.copyButtonPlugin)).add((0, $1bV4T.floatingToolbarPlugin)).add((0, $4R0EL.selectionPlugin)).add((0, $eeKOR.contentInsertionPlugin)).add((0, $lNW3b.default)).add([
            (0, $blumq.quickInsertPlugin),
            {
                disableDefaultItems: true,
                headless: false
            }
        ]).add([
            (0, $6cMFS.insertBlockPlugin),
            {
                allowTables: true,
                allowExpand: false,
                horizontalRuleEnabled: true,
                showElementBrowserLink: false,
                appearance: 'full-page'
            }
        ]).add([
            (0, $6cRwj.default),
            {
                tableOptions: {
                    advanced: true
                }
            }
        ]));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjU5q.ComposableEditor), {
        defaultValue: defaultValue,
        onChange: ()=>// Casting to the stricter DocNode type
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            editorApi?.core?.actions.requestDocument((newADF)=>onChange(newADF)),
        preset: preset,
        ...(0, $4R6GH.fg)('jira-forms-public-description-field-appearance-fix') ? {
            appearance: 'comment'
        } : {}
    });
};

});
parcelRegister("fxvTQ", function(module, exports) {

$parcel$export(module.exports, "basePlugin", () => (parcelRequire("exvYd")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $exvYd = parcelRequire("exvYd");

});
parcelRegister("exvYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e879347a52d164e4$export$2e2bcd8739ae039);

var $xjCuM = parcelRequire("xjCuM");
var $abme3 = parcelRequire("abme3");
var $3DR6L = parcelRequire("3DR6L");

var $6cqU9 = parcelRequire("6cqU9");

var $2RHbH = parcelRequire("2RHbH");

var $fZzhT = parcelRequire("fZzhT");

var $gmhCD = parcelRequire("gmhCD");

var $ba7Ek = parcelRequire("ba7Ek");

var $jhGvF = parcelRequire("jhGvF");

var $f6qgr = parcelRequire("f6qgr");

var $hzDkr = parcelRequire("hzDkr");

var $djY8Z = parcelRequire("djY8Z");

var $7Y3BJ = parcelRequire("7Y3BJ");

var $6qtBk = parcelRequire("6qtBk");

var $cpAC0 = parcelRequire("cpAC0");

var $ifnBN = parcelRequire("ifnBN");

var $63wcB = parcelRequire("63wcB");
function $e879347a52d164e4$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $e879347a52d164e4$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $e879347a52d164e4$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($e879347a52d164e4$var$SMART_TO_ASCII).join('')}]`, 'g');
const $e879347a52d164e4$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($e879347a52d164e4$var$FIND_SMART_CHAR, (match)=>$e879347a52d164e4$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                keyboardHeight: (0, $ifnBN.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $ba7Ek.setKeyboardHeight,
            resolveMarks: (from, to, tr)=>$e879347a52d164e4$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $f6qgr.default)(dispatchAnalyticsEvent)
                }
            ];
            if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                exposure: true
            })) plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $7Y3BJ.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $djY8Z.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $6qtBk.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $hzDkr.default)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $63wcB.inputTracking), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $fZzhT.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $6cqU9.keymap)({
                        ...(0, $2RHbH.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $cpAC0.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $jhGvF.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $xjCuM.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $abme3.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $3DR6L.text)
                }
            ];
        }
    };
};
var $e879347a52d164e4$export$2e2bcd8739ae039 = $e879347a52d164e4$var$basePlugin;

});
parcelRegister("6cqU9", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $22bfd21edb49568b$export$5043418e2ef368d5);

var $1SLCf = parcelRequire("1SLCf");

var $vWFRY = parcelRequire("vWFRY");

var $5KWxh = parcelRequire("5KWxh");
function $22bfd21edb49568b$export$5043418e2ef368d5(bindings) {
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $1SLCf.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $1SLCf.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $vWFRY.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("1SLCf", function(module, exports) {

$parcel$export(module.exports, "base", () => $15efc51ab78bc228$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $15efc51ab78bc228$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $15efc51ab78bc228$export$fb33aafd75404f4c);
var $15efc51ab78bc228$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $15efc51ab78bc228$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $15efc51ab78bc228$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $15efc51ab78bc228$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $15efc51ab78bc228$var$i = 0; $15efc51ab78bc228$var$i < 10; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[48 + $15efc51ab78bc228$var$i] = $15efc51ab78bc228$export$e2253033e6e1df16[96 + $15efc51ab78bc228$var$i] = String($15efc51ab78bc228$var$i);
// The function keys
for(var $15efc51ab78bc228$var$i = 1; $15efc51ab78bc228$var$i <= 24; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i + 111] = "F" + $15efc51ab78bc228$var$i;
// And the alphabetic keys
for(var $15efc51ab78bc228$var$i = 65; $15efc51ab78bc228$var$i <= 90; $15efc51ab78bc228$var$i++){
    $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i + 32);
    $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $15efc51ab78bc228$var$code in $15efc51ab78bc228$export$e2253033e6e1df16)if (!$15efc51ab78bc228$export$fba63a578e423eb.hasOwnProperty($15efc51ab78bc228$var$code)) $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$code] = $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$code];
function $15efc51ab78bc228$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $15efc51ab78bc228$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $15efc51ab78bc228$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $15efc51ab78bc228$export$fba63a578e423eb : $15efc51ab78bc228$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("vWFRY", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $060068dc8add2821$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $060068dc8add2821$export$53f558754f8b9fd1);

var $1SLCf = parcelRequire("1SLCf");

var $gZGBX = parcelRequire("gZGBX");
const $060068dc8add2821$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $060068dc8add2821$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($060068dc8add2821$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $060068dc8add2821$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$060068dc8add2821$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $060068dc8add2821$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $060068dc8add2821$export$5043418e2ef368d5(bindings) {
    return new (0, $gZGBX.Plugin)({
        props: {
            handleKeyDown: $060068dc8add2821$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $060068dc8add2821$export$53f558754f8b9fd1(bindings) {
    let map = $060068dc8add2821$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $1SLCf.keyName)(event), baseName, direct = map[$060068dc8add2821$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$060068dc8add2821$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1SLCf.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$060068dc8add2821$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});

parcelRegister("5KWxh", function(module, exports) {

$parcel$export(module.exports, "SafePlugin", () => $11ce3f4f5d2ca62c$export$1d44e2741b8f180d);

var $gZGBX = parcelRequire("gZGBX");

var $2RN5d = parcelRequire("2RN5d");
const $11ce3f4f5d2ca62c$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom })=>{
    const metadata = (0, $2RN5d.createProseMirrorMetadata)(nodeOrMark);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
    });
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $11ce3f4f5d2ca62c$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                        return;
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement) $11ce3f4f5d2ca62c$export$286bb6e3f51916b5({
                        nodeOrMark: node,
                        dom: result.dom
                    });
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $11ce3f4f5d2ca62c$export$1d44e2741b8f180d extends (0, $gZGBX.Plugin) {
    constructor(spec){
        super($11ce3f4f5d2ca62c$var$wrapGetPosExceptions(spec));
    }
}

});
parcelRegister("2RN5d", function(module, exports) {

$parcel$export(module.exports, "createProseMirrorMetadata", () => $d7292b4ed800dccb$export$3d8be158d19aadd1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kCV8T = parcelRequire("kCV8T");
const $d7292b4ed800dccb$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $kCV8T.Node) || Array.isArray(nodeOrMark.marks);
};
const $d7292b4ed800dccb$export$3d8be158d19aadd1 = (nodeOrMark)=>{
    const name = nodeOrMark.type.name;
    const isNode = $d7292b4ed800dccb$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    return commonAttributes;
};

});



parcelRegister("2RHbH", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $2162082cf5257878$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $2162082cf5257878$export$52b8a4af68d19794);
$parcel$export(module.exports, "createParagraphNear", () => $2162082cf5257878$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $2162082cf5257878$export$e99155638ff4dff0);
$parcel$export(module.exports, "toggleMark", () => $2162082cf5257878$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $2162082cf5257878$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $2162082cf5257878$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $2162082cf5257878$export$4a0c2b85b1f0a889);

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
/**
Delete the selection, if there is one.
*/ const $2162082cf5257878$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $2162082cf5257878$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $2162082cf5257878$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $eS2Dn.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(before, "end") || (0, $gZGBX.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $eS2Dn.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $kCV8T.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($2162082cf5257878$var$textblockAt(before, "end") ? (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $gZGBX.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $2162082cf5257878$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutBefore($cursor);
    return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $2162082cf5257878$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutAfter($cursor);
    return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $eS2Dn.replaceStep)(state.doc, beforePos, afterPos, (0, $kCV8T.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $eS2Dn.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $2162082cf5257878$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $2162082cf5257878$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $2162082cf5257878$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $gZGBX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $2162082cf5257878$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $2162082cf5257878$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $2162082cf5257878$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $2162082cf5257878$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(after, "start") || (0, $gZGBX.NodeSelection).isSelectable(after))) {
        let delStep = (0, $eS2Dn.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $kCV8T.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($2162082cf5257878$var$textblockAt(after, "start") ? (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $gZGBX.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $2162082cf5257878$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $2162082cf5257878$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $gZGBX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $2162082cf5257878$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $2162082cf5257878$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $gZGBX.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $eS2Dn.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $eS2Dn.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $2162082cf5257878$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $gZGBX.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $eS2Dn.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $eS2Dn.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $2162082cf5257878$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $2162082cf5257878$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $2162082cf5257878$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $2162082cf5257878$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $2162082cf5257878$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $2162082cf5257878$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $gZGBX.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $2162082cf5257878$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $2162082cf5257878$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $eS2Dn.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $2162082cf5257878$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $eS2Dn.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $2162082cf5257878$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $gZGBX.TextSelection) || state.selection instanceof (0, $gZGBX.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $eS2Dn.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $eS2Dn.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $2162082cf5257878$export$e99155638ff4dff0 = $2162082cf5257878$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $2162082cf5257878$export$eeb429476568b72b = (state, dispatch)=>{
    return $2162082cf5257878$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $2162082cf5257878$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $2162082cf5257878$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $gZGBX.AllSelection)(state.doc)));
    return true;
};
function $2162082cf5257878$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $eS2Dn.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $2162082cf5257878$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $kCV8T.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $kCV8T.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $kCV8T.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $eS2Dn.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $kCV8T.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $eS2Dn.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $gZGBX.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $eS2Dn.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $2162082cf5257878$var$textblockAt(after, "start", true) && $2162082cf5257878$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $kCV8T.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $kCV8T.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $eS2Dn.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $kCV8T.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $2162082cf5257878$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $2162082cf5257878$export$c3a64f3c9604a1b1 = $2162082cf5257878$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $2162082cf5257878$export$a66c1876556415e5 = $2162082cf5257878$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $2162082cf5257878$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $eS2Dn.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $2162082cf5257878$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $2162082cf5257878$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $2162082cf5257878$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $gZGBX.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $gZGBX.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $2162082cf5257878$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$2162082cf5257878$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $2162082cf5257878$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $2162082cf5257878$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $eS2Dn.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $2162082cf5257878$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $2162082cf5257878$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $2162082cf5257878$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $2162082cf5257878$var$backspace = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$979097b097459299, $2162082cf5257878$export$52b8a4af68d19794);
let $2162082cf5257878$var$del = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$bf432e340007f9ef, $2162082cf5257878$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $2162082cf5257878$export$eb36e8971b04df36 = {
    "Enter": $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$a5d02b4b65e94f91, $2162082cf5257878$export$d0f80ac1b4510888, $2162082cf5257878$export$a3574cc681852c08, $2162082cf5257878$export$e99155638ff4dff0),
    "Mod-Enter": $2162082cf5257878$export$634b78845598ff5b,
    "Backspace": $2162082cf5257878$var$backspace,
    "Mod-Backspace": $2162082cf5257878$var$backspace,
    "Shift-Backspace": $2162082cf5257878$var$backspace,
    "Delete": $2162082cf5257878$var$del,
    "Mod-Delete": $2162082cf5257878$var$del,
    "Mod-a": $2162082cf5257878$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $2162082cf5257878$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $2162082cf5257878$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $2162082cf5257878$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $2162082cf5257878$export$c3a64f3c9604a1b1,
    "Ctrl-e": $2162082cf5257878$export$a66c1876556415e5
};
for(let key in $2162082cf5257878$export$eb36e8971b04df36)$2162082cf5257878$export$f292ad8dbd5063c8[key] = $2162082cf5257878$export$eb36e8971b04df36[key];
const $2162082cf5257878$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $2162082cf5257878$export$4a0c2b85b1f0a889 = $2162082cf5257878$var$mac ? $2162082cf5257878$export$f292ad8dbd5063c8 : $2162082cf5257878$export$eb36e8971b04df36;

});

parcelRegister("fZzhT", function(module, exports) {

$parcel$export(module.exports, "closeHistory", () => $ba47ece1f7bbc51a$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $ba47ece1f7bbc51a$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $ba47ece1f7bbc51a$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $ba47ece1f7bbc51a$export$1688e416fee0a49e);

var $4h9Gl = parcelRequire("4h9Gl");

var $eS2Dn = parcelRequire("eS2Dn");

var $gZGBX = parcelRequire("gZGBX");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $ba47ece1f7bbc51a$var$max_empty_items = 500;
class $ba47ece1f7bbc51a$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $ba47ece1f7bbc51a$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $ba47ece1f7bbc51a$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $ba47ece1f7bbc51a$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $ba47ece1f7bbc51a$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW) {
            oldItems = $ba47ece1f7bbc51a$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $ba47ece1f7bbc51a$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $eS2Dn.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $ba47ece1f7bbc51a$var$Branch(this.items.append(array.map((map)=>new $ba47ece1f7bbc51a$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map, step, selection));
            } else rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $ba47ece1f7bbc51a$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $ba47ece1f7bbc51a$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $ba47ece1f7bbc51a$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $ba47ece1f7bbc51a$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $ba47ece1f7bbc51a$var$Branch((0, $4h9Gl.default).from(items.reverse()), events);
    }
}
$ba47ece1f7bbc51a$var$Branch.empty = new $ba47ece1f7bbc51a$var$Branch((0, $4h9Gl.default).empty, 0);
function $ba47ece1f7bbc51a$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $ba47ece1f7bbc51a$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $ba47ece1f7bbc51a$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $ba47ece1f7bbc51a$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $ba47ece1f7bbc51a$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($ba47ece1f7bbc51a$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($ba47ece1f7bbc51a$var$closeHistoryKey)) history = new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($ba47ece1f7bbc51a$var$historyKey)) {
        if (appended.getMeta($ba47ece1f7bbc51a$var$historyKey).redo) return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), history.undone, $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$ba47ece1f7bbc51a$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping) : $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps);
        return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), $ba47ece1f7bbc51a$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $ba47ece1f7bbc51a$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $ba47ece1f7bbc51a$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $ba47ece1f7bbc51a$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $ba47ece1f7bbc51a$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $ba47ece1f7bbc51a$var$histTransaction(history, state, redo) {
    let preserveItems = $ba47ece1f7bbc51a$var$mustPreserveItems(state);
    let histOptions = $ba47ece1f7bbc51a$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $ba47ece1f7bbc51a$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($ba47ece1f7bbc51a$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $ba47ece1f7bbc51a$var$cachedPreserveItems = false, $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $ba47ece1f7bbc51a$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins != plugins) {
        $ba47ece1f7bbc51a$var$cachedPreserveItems = false;
        $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $ba47ece1f7bbc51a$var$cachedPreserveItems = true;
            break;
        }
    }
    return $ba47ece1f7bbc51a$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $ba47ece1f7bbc51a$export$181a649d919c589e(tr) {
    return tr.setMeta($ba47ece1f7bbc51a$var$closeHistoryKey, true);
}
const $ba47ece1f7bbc51a$var$historyKey = new (0, $gZGBX.PluginKey)("history");
const $ba47ece1f7bbc51a$var$closeHistoryKey = new (0, $gZGBX.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $ba47ece1f7bbc51a$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $gZGBX.Plugin)({
        key: $ba47ece1f7bbc51a$var$historyKey,
        state: {
            init () {
                return new $ba47ece1f7bbc51a$var$HistoryState($ba47ece1f7bbc51a$var$Branch.empty, $ba47ece1f7bbc51a$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $ba47ece1f7bbc51a$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $ba47ece1f7bbc51a$export$21f930c44940fd98 : inputType == "historyRedo" ? $ba47ece1f7bbc51a$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $ba47ece1f7bbc51a$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $ba47ece1f7bbc51a$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $ba47ece1f7bbc51a$export$21f930c44940fd98 = $ba47ece1f7bbc51a$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $ba47ece1f7bbc51a$export$1688e416fee0a49e = $ba47ece1f7bbc51a$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $ba47ece1f7bbc51a$export$24b5d280435f3a3f = $ba47ece1f7bbc51a$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $ba47ece1f7bbc51a$export$3774e54bae7be19b = $ba47ece1f7bbc51a$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $ba47ece1f7bbc51a$export$f8a176c2b9a10bdb(state) {
    let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $ba47ece1f7bbc51a$export$3ffe6b288e7d941b(state) {
    let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("4h9Gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $31d0429bb13bd60b$export$2e2bcd8739ae039);
var $31d0429bb13bd60b$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $31d0429bb13bd60b$var$RopeSequence = function RopeSequence() {};
$31d0429bb13bd60b$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $31d0429bb13bd60b$var$RopeSequence.from(other);
    return !this.length && other || other.length < $31d0429bb13bd60b$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $31d0429bb13bd60b$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $31d0429bb13bd60b$var$RopeSequence.from(other).append(this);
};
$31d0429bb13bd60b$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $31d0429bb13bd60b$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $31d0429bb13bd60b$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$31d0429bb13bd60b$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$31d0429bb13bd60b$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$31d0429bb13bd60b$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$31d0429bb13bd60b$var$RopeSequence.from = function from(values) {
    if (values instanceof $31d0429bb13bd60b$var$RopeSequence) return values;
    return values && values.length ? new $31d0429bb13bd60b$var$Leaf(values) : $31d0429bb13bd60b$var$RopeSequence.empty;
};
var $31d0429bb13bd60b$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $31d0429bb13bd60b$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $31d0429bb13bd60b$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($31d0429bb13bd60b$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$31d0429bb13bd60b$var$RopeSequence.empty = new $31d0429bb13bd60b$var$Leaf([]);
var $31d0429bb13bd60b$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($31d0429bb13bd60b$var$RopeSequence);
var $31d0429bb13bd60b$export$2e2bcd8739ae039 = $31d0429bb13bd60b$var$RopeSequence;

});


parcelRegister("ba7Ek", function(module, exports) {

$parcel$export(module.exports, "setKeyboardHeight", () => $6c7eced9f1689a9a$export$b8c3ea160300668d);

var $6OgMR = parcelRequire("6OgMR");
const $6c7eced9f1689a9a$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $6OgMR.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("6OgMR", function(module, exports) {

$parcel$export(module.exports, "scrollGutterPluginKey", () => $418a73e08450538e$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $418a73e08450538e$export$a237783470abe542);

var $gZGBX = parcelRequire("gZGBX");
const $418a73e08450538e$export$54fdd3c2782161ea = new (0, $gZGBX.PluginKey)('scrollGutter');
const $418a73e08450538e$export$a237783470abe542 = (state)=>{
    if (state) return $418a73e08450538e$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("jhGvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcaf55d45289964b$export$2e2bcd8739ae039);

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
function $fcaf55d45289964b$var$getCurrentBrowserAndVersion() {
    switch(true){
        case (0, $gE8f9.browser).chrome === true:
            return {
                browser: 'chrome',
                version: (0, $gE8f9.browser).chrome_version
            };
        case (0, $gE8f9.browser).ie === true:
            return {
                browser: 'ie',
                version: (0, $gE8f9.browser).ie_version
            };
        case (0, $gE8f9.browser).gecko === true:
            return {
                browser: 'gecko',
                version: (0, $gE8f9.browser).gecko_version
            };
        case (0, $gE8f9.browser).safari === true:
            return {
                browser: 'safari',
                version: (0, $gE8f9.browser).safari_version
            };
    }
    return undefined;
}
var $fcaf55d45289964b$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $5KWxh.SafePlugin)({
        key: new (0, $gZGBX.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const userCurrentBrowserAndVersion = $fcaf55d45289964b$var$getCurrentBrowserAndVersion();
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !(0, $gE8f9.browser)[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : (0, $gE8f9.browser)[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("f6qgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $70f314a94b71d913$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $J5Axj = parcelRequire("J5Axj");

var $5KWxh = parcelRequire("5KWxh");
const $70f314a94b71d913$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $70f314a94b71d913$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $5KWxh.SafePlugin)({
        filterTransaction (transaction) {
            if ($70f314a94b71d913$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $J5Axj.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});
parcelRegister("J5Axj", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $6668461c370cf056$export$d9985be1ece4b7ee);

var $8aY84 = parcelRequire("8aY84");
function $6668461c370cf056$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $8aY84.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("8aY84", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $5f3de64f68283b50$export$cc33374693c7fb23);

var $eHiP8 = parcelRequire("eHiP8");

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");
const $5f3de64f68283b50$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $5f3de64f68283b50$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $5f3de64f68283b50$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($5f3de64f68283b50$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $5f3de64f68283b50$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $5f3de64f68283b50$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID ? $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID : $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID
        }
    });
function $5f3de64f68283b50$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID || event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID;
}
class $5f3de64f68283b50$export$cc33374693c7fb23 extends (0, $eS2Dn.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $eHiP8.default)(this, "analyticsEvents", []);
        (0, $eHiP8.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($5f3de64f68283b50$var$isHistoryAnalyticsEvent(analyticsEvent)) return $5f3de64f68283b50$var$toggleEventAction(analyticsEvent);
            else return $5f3de64f68283b50$var$createUndoEvent(analyticsEvent);
        });
        return new $5f3de64f68283b50$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $5f3de64f68283b50$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $eS2Dn.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $eS2Dn.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $5f3de64f68283b50$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $5f3de64f68283b50$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $5f3de64f68283b50$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($5f3de64f68283b50$export$9126078e8b0f76e4, $5f3de64f68283b50$export$cc33374693c7fb23);

});



parcelRegister("hzDkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf75182aad6c615$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $hETfp = parcelRequire("hETfp");

var $k4HYa = parcelRequire("k4HYa");

var $b7gJe = parcelRequire("b7gJe");

var $5KWxh = parcelRequire("5KWxh");

var $4NUlu = parcelRequire("4NUlu");

var $gZGBX = parcelRequire("gZGBX");

var $cOJEB = parcelRequire("cOJEB");

var $jkVhk = parcelRequire("jkVhk");
const $dcf75182aad6c615$export$70246689264eff75 = new (0, $gZGBX.PluginKey)('frozenEditor');
const $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD = 300;
const $dcf75182aad6c615$export$c8d5b833abcf8e80 = 600;
const $dcf75182aad6c615$export$47b2879ca9bbf67a = 2000;
const $dcf75182aad6c615$export$1b622068be977101 = 3000;
const $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $dcf75182aad6c615$export$5705ac5f923a65e7 = 100;
const $dcf75182aad6c615$export$1c6feb3429832c55 = 500;
const $dcf75182aad6c615$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    };
var $dcf75182aad6c615$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $dcf75182aad6c615$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $k4HYa.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $dcf75182aad6c615$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $dcf75182aad6c615$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $5KWxh.SafePlugin)({
            key: $dcf75182aad6c615$export$70246689264eff75,
            props: (0, $b7gJe.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $cOJEB.setInteractionType)((0, $hETfp.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $b7gJe.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $jkVhk.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $gkwXh.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $gkwXh.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $gkwXh.ACTION).SLOW_INPUT,
                            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $dcf75182aad6c615$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $4NUlu.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("hETfp", function(module, exports) {

$parcel$export(module.exports, "PLATFORMS", () => $64702af428f72834$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $64702af428f72834$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $64702af428f72834$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $64702af428f72834$export$60a219cfaef9722);
var $64702af428f72834$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $64702af428f72834$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $64702af428f72834$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $64702af428f72834$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("k4HYa", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $550dac80d474b87c$export$1daf15cbaf649dad);
function $550dac80d474b87c$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("cOJEB", function(module, exports) {

$parcel$export(module.exports, "setInteractionType", () => $1385fb4dd77fadaa$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $1385fb4dd77fadaa$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("jkVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0f8dc490d52d26f$export$2e2bcd8739ae039);

var $4NUlu = parcelRequire("4NUlu");

var $4TYuJ = parcelRequire("4TYuJ");
class $b0f8dc490d52d26f$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $4TYuJ.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $4NUlu.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("4TYuJ", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $20eb0060210a6f48$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $20eb0060210a6f48$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("djY8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ccc9e8b26cedb9$export$2e2bcd8739ae039);

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $594Yf = parcelRequire("594Yf");


var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");
const $66ccc9e8b26cedb9$export$8836bfc6be4cb708 = new (0, $gZGBX.PluginKey)('inlineCursorTargetPlugin');
const $66ccc9e8b26cedb9$var$isInlineNodeView = (node)=>{
    /**
	 * If inlineNodeView is a hardbreak we don't want to add decorations
	 * as it breaks soft line breaks for Japanese/Chinese keyboards.
	 */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $66ccc9e8b26cedb9$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $66ccc9e8b26cedb9$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708);
                if (selection && (0, $594Yf.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $etG8M.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                if ($66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $etG8M.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    if ((0, $gE8f9.browser).safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    const tr = view.state.tr;
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    tr.insertText(content);
    view.dispatch(tr);
}

});
parcelRegister("594Yf", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $91477cc465a54c49$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $91477cc465a54c49$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $91477cc465a54c49$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $91477cc465a54c49$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $91477cc465a54c49$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $91477cc465a54c49$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $91477cc465a54c49$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $91477cc465a54c49$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $91477cc465a54c49$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $91477cc465a54c49$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $91477cc465a54c49$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $91477cc465a54c49$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $91477cc465a54c49$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $91477cc465a54c49$export$fba8af3b998832b9);

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");

var $eQcNy = parcelRequire("eQcNy");
function $91477cc465a54c49$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $91477cc465a54c49$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $91477cc465a54c49$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$91477cc465a54c49$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $91477cc465a54c49$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $eS2Dn.ReplaceStep)) && !(step instanceof (0, $eS2Dn.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $91477cc465a54c49$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $gZGBX.TextSelection);
const $91477cc465a54c49$export$5588122b9eea7733 = (element)=>{
    if ((0, $VSDnB.fg)('platform_editor_nested_tables_column_drag_fix')) return (0, $eQcNy.closest)(element, 'td, th');
    else return (0, $eQcNy.closest)(element, 'td') || (0, $eQcNy.closest)(element, 'th');
};
const $91477cc465a54c49$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $91477cc465a54c49$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $91477cc465a54c49$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $91477cc465a54c49$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $gZGBX.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $91477cc465a54c49$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $hFEwm.CellSelection).create(state.doc, anchor, head)));
}
function $91477cc465a54c49$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $91477cc465a54c49$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $91477cc465a54c49$export$2de06a6e688827fd = (state)=>{
    return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $91477cc465a54c49$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $91477cc465a54c49$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($91477cc465a54c49$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $91477cc465a54c49$var$not = (fn)=>(arg)=>!fn(arg);

});

const $0f804702eb36dd5e$export$15a09f5ef055bcfa = '\u200b';
const $0f804702eb36dd5e$export$2b4d00c13dcd3c1f = '\u200d';

parcelRegister("etG8M", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $a8a4766474a1e455$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $a8a4766474a1e455$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $a8a4766474a1e455$export$eece2fccabbb77c5);

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $a8a4766474a1e455$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $a8a4766474a1e455$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $a8a4766474a1e455$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $a8a4766474a1e455$var$textRange = function(node, from, to) {
    let range = $a8a4766474a1e455$var$reusedRange || ($a8a4766474a1e455$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $a8a4766474a1e455$var$clearReusedRange = function() {
    $a8a4766474a1e455$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $a8a4766474a1e455$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, -1) || $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $a8a4766474a1e455$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $a8a4766474a1e455$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $a8a4766474a1e455$var$hasBlockDesc(node) || $a8a4766474a1e455$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $a8a4766474a1e455$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $a8a4766474a1e455$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $a8a4766474a1e455$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a8a4766474a1e455$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $a8a4766474a1e455$var$nodeSize(node);
        } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
            offset = $a8a4766474a1e455$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $a8a4766474a1e455$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
            offset = $a8a4766474a1e455$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $a8a4766474a1e455$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $a8a4766474a1e455$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $a8a4766474a1e455$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $a8a4766474a1e455$var$nodeSize(node);
    }
}
function $a8a4766474a1e455$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $a8a4766474a1e455$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $a8a4766474a1e455$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $a8a4766474a1e455$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $a8a4766474a1e455$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($a8a4766474a1e455$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($a8a4766474a1e455$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $a8a4766474a1e455$var$nav = typeof navigator != "undefined" ? navigator : null;
const $a8a4766474a1e455$var$doc = typeof document != "undefined" ? document : null;
const $a8a4766474a1e455$var$agent = $a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.userAgent || "";
const $a8a4766474a1e455$var$ie_edge = /Edge\/(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie_upto10 = /MSIE \d/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$ie = !!($a8a4766474a1e455$var$ie_upto10 || $a8a4766474a1e455$var$ie_11up || $a8a4766474a1e455$var$ie_edge);
const $a8a4766474a1e455$var$ie_version = $a8a4766474a1e455$var$ie_upto10 ? document.documentMode : $a8a4766474a1e455$var$ie_11up ? +$a8a4766474a1e455$var$ie_11up[1] : $a8a4766474a1e455$var$ie_edge ? +$a8a4766474a1e455$var$ie_edge[1] : 0;
const $a8a4766474a1e455$var$gecko = !$a8a4766474a1e455$var$ie && /gecko\/(\d+)/i.test($a8a4766474a1e455$var$agent);
$a8a4766474a1e455$var$gecko && (/Firefox\/(\d+)/.exec($a8a4766474a1e455$var$agent) || [
    0,
    0
])[1];
const $a8a4766474a1e455$var$_chrome = !$a8a4766474a1e455$var$ie && /Chrome\/(\d+)/.exec($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$chrome = !!$a8a4766474a1e455$var$_chrome;
const $a8a4766474a1e455$var$chrome_version = $a8a4766474a1e455$var$_chrome ? +$a8a4766474a1e455$var$_chrome[1] : 0;
const $a8a4766474a1e455$var$safari = !$a8a4766474a1e455$var$ie && !!$a8a4766474a1e455$var$nav && /Apple Computer/.test($a8a4766474a1e455$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $a8a4766474a1e455$var$ios = $a8a4766474a1e455$var$safari && (/Mobile\/\w+/.test($a8a4766474a1e455$var$agent) || !!$a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.maxTouchPoints > 2);
const $a8a4766474a1e455$var$mac = $a8a4766474a1e455$var$ios || ($a8a4766474a1e455$var$nav ? /Mac/.test($a8a4766474a1e455$var$nav.platform) : false);
const $a8a4766474a1e455$var$windows = $a8a4766474a1e455$var$nav ? /Win/.test($a8a4766474a1e455$var$nav.platform) : false;
const $a8a4766474a1e455$var$android = /Android \d/.test($a8a4766474a1e455$var$agent);
const $a8a4766474a1e455$var$webkit = !!$a8a4766474a1e455$var$doc && "webkitFontSmoothing" in $a8a4766474a1e455$var$doc.documentElement.style;
const $a8a4766474a1e455$var$webkit_version = $a8a4766474a1e455$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $a8a4766474a1e455$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $a8a4766474a1e455$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $a8a4766474a1e455$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $a8a4766474a1e455$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $a8a4766474a1e455$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $a8a4766474a1e455$var$windowRect(doc) : $a8a4766474a1e455$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $a8a4766474a1e455$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $a8a4766474a1e455$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $a8a4766474a1e455$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $a8a4766474a1e455$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $a8a4766474a1e455$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $a8a4766474a1e455$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $a8a4766474a1e455$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $a8a4766474a1e455$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $a8a4766474a1e455$var$scrollStack(view.dom)
    };
}
function $a8a4766474a1e455$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $a8a4766474a1e455$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $a8a4766474a1e455$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $a8a4766474a1e455$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $a8a4766474a1e455$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $a8a4766474a1e455$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $a8a4766474a1e455$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($a8a4766474a1e455$var$preventScrollSupported) return dom.focus($a8a4766474a1e455$var$preventScrollSupported);
    let stored = $a8a4766474a1e455$var$scrollStack(dom);
    dom.focus($a8a4766474a1e455$var$preventScrollSupported == null ? {
        get preventScroll () {
            $a8a4766474a1e455$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$a8a4766474a1e455$var$preventScrollSupported) {
        $a8a4766474a1e455$var$preventScrollSupported = false;
        $a8a4766474a1e455$var$restoreScrollStack(stored, 0);
    }
}
function $a8a4766474a1e455$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $a8a4766474a1e455$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $a8a4766474a1e455$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $a8a4766474a1e455$var$findOffsetInNode(closest, coordsClosest);
}
function $a8a4766474a1e455$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $a8a4766474a1e455$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($a8a4766474a1e455$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $a8a4766474a1e455$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $a8a4766474a1e455$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $a8a4766474a1e455$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $a8a4766474a1e455$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $a8a4766474a1e455$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($a8a4766474a1e455$var$inRect(coords, rect)) return $a8a4766474a1e455$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $a8a4766474a1e455$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $a8a4766474a1e455$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$a8a4766474a1e455$var$inRect(coords, box)) return null;
        elt = $a8a4766474a1e455$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($a8a4766474a1e455$var$safari) {
        for(let p = elt; node && p; p = $a8a4766474a1e455$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $a8a4766474a1e455$var$targetKludge(elt, coords);
    if (node) {
        if ($a8a4766474a1e455$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($a8a4766474a1e455$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $a8a4766474a1e455$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $a8a4766474a1e455$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $a8a4766474a1e455$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($a8a4766474a1e455$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $a8a4766474a1e455$var$nonZero) || target.getBoundingClientRect();
}
const $a8a4766474a1e455$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $a8a4766474a1e455$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $a8a4766474a1e455$var$webkit || $a8a4766474a1e455$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($a8a4766474a1e455$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($a8a4766474a1e455$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $a8a4766474a1e455$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $a8a4766474a1e455$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $a8a4766474a1e455$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $a8a4766474a1e455$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $a8a4766474a1e455$var$textRange(before, $a8a4766474a1e455$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $a8a4766474a1e455$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(node.nodeType == 3 ? $a8a4766474a1e455$var$textRange(node) : node, -side), side >= 0);
}
function $a8a4766474a1e455$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $a8a4766474a1e455$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $a8a4766474a1e455$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $a8a4766474a1e455$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $a8a4766474a1e455$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $a8a4766474a1e455$var$maybeRTL = /[\u0590-\u08ac]/;
function $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$a8a4766474a1e455$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $a8a4766474a1e455$var$cachedState = null;
let $a8a4766474a1e455$var$cachedDir = null;
let $a8a4766474a1e455$var$cachedResult = false;
function $a8a4766474a1e455$var$endOfTextblock(view, state, dir) {
    if ($a8a4766474a1e455$var$cachedState == state && $a8a4766474a1e455$var$cachedDir == dir) return $a8a4766474a1e455$var$cachedResult;
    $a8a4766474a1e455$var$cachedState = state;
    $a8a4766474a1e455$var$cachedDir = dir;
    return $a8a4766474a1e455$var$cachedResult = dir == "up" || dir == "down" ? $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) : $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $a8a4766474a1e455$var$NOT_DIRTY = 0, $a8a4766474a1e455$var$CHILD_DIRTY = 1, $a8a4766474a1e455$var$CONTENT_DIRTY = 2, $a8a4766474a1e455$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $a8a4766474a1e455$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $a8a4766474a1e455$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $a8a4766474a1e455$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $a8a4766474a1e455$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $a8a4766474a1e455$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $a8a4766474a1e455$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $a8a4766474a1e455$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($a8a4766474a1e455$var$gecko || $a8a4766474a1e455$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $a8a4766474a1e455$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($a8a4766474a1e455$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $a8a4766474a1e455$var$safari) && $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $a8a4766474a1e455$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $a8a4766474a1e455$var$WidgetViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $a8a4766474a1e455$var$CompositionViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $a8a4766474a1e455$var$MarkViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $kCV8T.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $a8a4766474a1e455$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $a8a4766474a1e455$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $a8a4766474a1e455$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $a8a4766474a1e455$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $a8a4766474a1e455$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $a8a4766474a1e455$var$NodeViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $kCV8T.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $a8a4766474a1e455$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $a8a4766474a1e455$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $a8a4766474a1e455$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $kCV8T.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && node.eq(this.node) && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $a8a4766474a1e455$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $a8a4766474a1e455$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $kCV8T.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $a8a4766474a1e455$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $a8a4766474a1e455$var$renderDescs(this.contentDOM, this.children, view);
            if ($a8a4766474a1e455$var$ios) $a8a4766474a1e455$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $gZGBX.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $a8a4766474a1e455$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $a8a4766474a1e455$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $a8a4766474a1e455$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $a8a4766474a1e455$var$patchOuterDeco(this.dom, this.nodeDOM, $a8a4766474a1e455$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $a8a4766474a1e455$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $a8a4766474a1e455$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $a8a4766474a1e455$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $a8a4766474a1e455$var$TextViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || this.dirty != $a8a4766474a1e455$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $a8a4766474a1e455$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $a8a4766474a1e455$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $a8a4766474a1e455$var$TrailingHackViewDesc extends $a8a4766474a1e455$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $a8a4766474a1e455$var$CustomNodeViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $a8a4766474a1e455$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $a8a4766474a1e455$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $a8a4766474a1e455$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $a8a4766474a1e455$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $a8a4766474a1e455$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $a8a4766474a1e455$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$a8a4766474a1e455$var$OuterDecoLevel.prototype = Object.create(null);
const $a8a4766474a1e455$var$noDeco = [
    new $a8a4766474a1e455$var$OuterDecoLevel
];
function $a8a4766474a1e455$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $a8a4766474a1e455$var$noDeco;
    let top = needsWrap ? $a8a4766474a1e455$var$noDeco[0] : new $a8a4766474a1e455$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $a8a4766474a1e455$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $a8a4766474a1e455$var$noDeco && curComputed == $a8a4766474a1e455$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $a8a4766474a1e455$var$noDeco[0];
                curDOM = parent;
            }
        }
        $a8a4766474a1e455$var$patchAttributes(curDOM, prev || $a8a4766474a1e455$var$noDeco[0], deco);
    }
    return curDOM;
}
function $a8a4766474a1e455$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $a8a4766474a1e455$var$applyOuterDeco(dom, deco, node) {
    return $a8a4766474a1e455$var$patchOuterDeco(dom, dom, $a8a4766474a1e455$var$noDeco, $a8a4766474a1e455$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $a8a4766474a1e455$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $a8a4766474a1e455$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $a8a4766474a1e455$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $a8a4766474a1e455$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $a8a4766474a1e455$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $a8a4766474a1e455$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $a8a4766474a1e455$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $a8a4766474a1e455$var$NODE_DIRTY && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$a8a4766474a1e455$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $a8a4766474a1e455$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $a8a4766474a1e455$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $a8a4766474a1e455$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $a8a4766474a1e455$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $a8a4766474a1e455$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $a8a4766474a1e455$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $a8a4766474a1e455$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $a8a4766474a1e455$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($a8a4766474a1e455$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $a8a4766474a1e455$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $a8a4766474a1e455$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $a8a4766474a1e455$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $a8a4766474a1e455$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($a8a4766474a1e455$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $gZGBX.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $a8a4766474a1e455$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $gZGBX.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $a8a4766474a1e455$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $a8a4766474a1e455$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $a8a4766474a1e455$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $a8a4766474a1e455$var$syncNodeSelection(view, sel);
    if (!$a8a4766474a1e455$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $a8a4766474a1e455$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $a8a4766474a1e455$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $gZGBX.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $a8a4766474a1e455$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $a8a4766474a1e455$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $a8a4766474a1e455$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $a8a4766474a1e455$var$brokenSelectBetweenUneditable = $a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$chrome_version < 63;
function $a8a4766474a1e455$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($a8a4766474a1e455$var$safari && after && after.contentEditable == "false") return $a8a4766474a1e455$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $a8a4766474a1e455$var$setEditable(after);
        else if (before) return $a8a4766474a1e455$var$setEditable(before);
    }
}
function $a8a4766474a1e455$var$setEditable(element) {
    element.contentEditable = "true";
    if ($a8a4766474a1e455$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $a8a4766474a1e455$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $a8a4766474a1e455$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$a8a4766474a1e455$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $a8a4766474a1e455$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $a8a4766474a1e455$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $a8a4766474a1e455$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $gZGBX.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $a8a4766474a1e455$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $a8a4766474a1e455$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $a8a4766474a1e455$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $gZGBX.TextSelection).between($anchor, $head, bias);
}
function $a8a4766474a1e455$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $a8a4766474a1e455$var$hasSelection(view);
}
function $a8a4766474a1e455$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $a8a4766474a1e455$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $a8a4766474a1e455$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $gZGBX.Selection).findFrom($start, dir);
}
function $a8a4766474a1e455$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $gZGBX.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $gZGBX.NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
            return false;
        } else if (!($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $gZGBX.NodeSelection).isSelectable(node)) return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($a8a4766474a1e455$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $gZGBX.NodeSelection) && sel.node.isInline) return $a8a4766474a1e455$var$apply(view, new (0, $gZGBX.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
        if (next) return $a8a4766474a1e455$var$apply(view, next);
        return false;
    }
}
function $a8a4766474a1e455$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a8a4766474a1e455$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $a8a4766474a1e455$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) : $a8a4766474a1e455$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($a8a4766474a1e455$var$gecko && node.nodeType == 1 && offset < $a8a4766474a1e455$var$nodeLen(node) && $a8a4766474a1e455$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($a8a4766474a1e455$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $a8a4766474a1e455$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $a8a4766474a1e455$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $a8a4766474a1e455$var$nodeLen(node);
            }
        }
    }
    if (force) $a8a4766474a1e455$var$setSelFocus(view, node, offset);
    else if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $a8a4766474a1e455$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $a8a4766474a1e455$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($a8a4766474a1e455$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $a8a4766474a1e455$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $a8a4766474a1e455$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $a8a4766474a1e455$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
}
function $a8a4766474a1e455$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $a8a4766474a1e455$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$a8a4766474a1e455$var$hasBlockDesc(node)){
        offset = $a8a4766474a1e455$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $a8a4766474a1e455$var$textNodeBefore(node, offset) {
    while(node && !offset && !$a8a4766474a1e455$var$hasBlockDesc(node)){
        offset = $a8a4766474a1e455$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $a8a4766474a1e455$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $a8a4766474a1e455$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $a8a4766474a1e455$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($a8a4766474a1e455$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $a8a4766474a1e455$var$selectionToDOM(view);
    }, 50);
}
function $a8a4766474a1e455$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $a8a4766474a1e455$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $gZGBX.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $gZGBX.NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $gZGBX.AllSelection) ? (0, $gZGBX.Selection).near(side, dir) : (0, $gZGBX.Selection).findFrom(side, dir);
        return beyond ? $a8a4766474a1e455$var$apply(view, beyond) : false;
    }
    return false;
}
function $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $gZGBX.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $a8a4766474a1e455$var$safariDownArrowBug(view) {
    if (!$a8a4766474a1e455$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $a8a4766474a1e455$var$switchEditable(view, child, "true");
        setTimeout(()=>$a8a4766474a1e455$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $a8a4766474a1e455$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $a8a4766474a1e455$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $a8a4766474a1e455$var$getMods(event);
    if (code == 8 || $a8a4766474a1e455$var$mac && code == 72 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, -1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $a8a4766474a1e455$var$mac && code == 68 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, 1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $a8a4766474a1e455$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $a8a4766474a1e455$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $a8a4766474a1e455$var$mac && code == 80 && mods == "c") return $a8a4766474a1e455$var$selectVertically(view, -1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $a8a4766474a1e455$var$mac && code == 78 && mods == "c") return $a8a4766474a1e455$var$safariDownArrowBug(view) || $a8a4766474a1e455$var$selectVertically(view, 1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
    else if (mods == ($a8a4766474a1e455$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $a8a4766474a1e455$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $kCV8T.DOMSerializer).fromSchema(view.state.schema);
    let doc = $a8a4766474a1e455$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $a8a4766474a1e455$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $a8a4766474a1e455$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $kCV8T.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $kCV8T.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $a8a4766474a1e455$var$readHTML(html);
        if ($a8a4766474a1e455$var$webkit) $a8a4766474a1e455$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $kCV8T.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$a8a4766474a1e455$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $a8a4766474a1e455$var$addContext($a8a4766474a1e455$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $kCV8T.Slice).maxOpen($a8a4766474a1e455$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $a8a4766474a1e455$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $a8a4766474a1e455$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $a8a4766474a1e455$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $a8a4766474a1e455$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $kCV8T.Fragment).from(result);
    }
    return fragment;
}
function $a8a4766474a1e455$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $kCV8T.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $kCV8T.Fragment).from($a8a4766474a1e455$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $a8a4766474a1e455$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $a8a4766474a1e455$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $kCV8T.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $a8a4766474a1e455$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $a8a4766474a1e455$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $kCV8T.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $kCV8T.Slice)($a8a4766474a1e455$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $kCV8T.Slice)($a8a4766474a1e455$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $a8a4766474a1e455$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $a8a4766474a1e455$var$_detachedDoc = null;
function $a8a4766474a1e455$var$detachedDoc() {
    return $a8a4766474a1e455$var$_detachedDoc || ($a8a4766474a1e455$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $a8a4766474a1e455$var$_policy = null;
function $a8a4766474a1e455$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$a8a4766474a1e455$var$_policy) $a8a4766474a1e455$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $a8a4766474a1e455$var$_policy.createHTML(html);
}
function $a8a4766474a1e455$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $a8a4766474a1e455$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $a8a4766474a1e455$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $a8a4766474a1e455$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $a8a4766474a1e455$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($a8a4766474a1e455$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $a8a4766474a1e455$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $kCV8T.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $kCV8T.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $a8a4766474a1e455$var$handlers = {};
const $a8a4766474a1e455$var$editHandlers = {};
const $a8a4766474a1e455$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $a8a4766474a1e455$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $a8a4766474a1e455$var$initInput(view) {
    for(let event in $a8a4766474a1e455$var$handlers){
        let handler = $a8a4766474a1e455$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($a8a4766474a1e455$var$eventBelongsToView(view, event) && !$a8a4766474a1e455$var$runCustomHandler(view, event) && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) handler(view, event);
        }, $a8a4766474a1e455$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($a8a4766474a1e455$var$safari) view.dom.addEventListener("input", ()=>null);
    $a8a4766474a1e455$var$ensureListeners(view);
}
function $a8a4766474a1e455$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $a8a4766474a1e455$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $a8a4766474a1e455$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$a8a4766474a1e455$var$runCustomHandler(view, event));
    });
}
function $a8a4766474a1e455$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $a8a4766474a1e455$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $a8a4766474a1e455$var$dispatchEvent(view, event) {
    if (!$a8a4766474a1e455$var$runCustomHandler(view, event) && $a8a4766474a1e455$var$handlers[event.type] && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) $a8a4766474a1e455$var$handlers[event.type](view, event);
}
$a8a4766474a1e455$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($a8a4766474a1e455$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($a8a4766474a1e455$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $a8a4766474a1e455$var$captureKeyDown(view, event)) event.preventDefault();
    else $a8a4766474a1e455$var$setSelectionOrigin(view, "key");
};
$a8a4766474a1e455$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$a8a4766474a1e455$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($a8a4766474a1e455$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $a8a4766474a1e455$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $gZGBX.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $a8a4766474a1e455$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $a8a4766474a1e455$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $a8a4766474a1e455$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $a8a4766474a1e455$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $a8a4766474a1e455$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $gZGBX.NodeSelection).isSelectable(node)) {
        $a8a4766474a1e455$var$updateSelection(view, new (0, $gZGBX.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $gZGBX.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $gZGBX.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $a8a4766474a1e455$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $a8a4766474a1e455$var$selectClickedNode(view, inside) : $a8a4766474a1e455$var$selectClickedLeaf(view, inside));
}
function $a8a4766474a1e455$var$handleDoubleClick(view, pos, inside, event) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $a8a4766474a1e455$var$handleTripleClick(view, pos, inside, event) {
    return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $a8a4766474a1e455$var$defaultTripleClick(view, inside, event);
}
function $a8a4766474a1e455$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $gZGBX.NodeSelection).isSelectable(node)) $a8a4766474a1e455$var$updateSelection(view, (0, $gZGBX.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $a8a4766474a1e455$var$forceDOMFlush(view) {
    return $a8a4766474a1e455$var$endComposition(view);
}
const $a8a4766474a1e455$var$selectNodeModifier = $a8a4766474a1e455$var$mac ? "metaKey" : "ctrlKey";
$a8a4766474a1e455$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $a8a4766474a1e455$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $a8a4766474a1e455$var$isNear(event, view.input.lastClick) && !event[$a8a4766474a1e455$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $a8a4766474a1e455$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $a8a4766474a1e455$var$handleDoubleClick : $a8a4766474a1e455$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
class $a8a4766474a1e455$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$a8a4766474a1e455$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $gZGBX.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $a8a4766474a1e455$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
        else if ($a8a4766474a1e455$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $a8a4766474a1e455$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $a8a4766474a1e455$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $a8a4766474a1e455$var$updateSelection(this.view, (0, $gZGBX.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$a8a4766474a1e455$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $a8a4766474a1e455$var$forceDOMFlush(view);
    $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
$a8a4766474a1e455$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
};
$a8a4766474a1e455$var$handlers.contextmenu = (view)=>$a8a4766474a1e455$var$forceDOMFlush(view);
function $a8a4766474a1e455$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($a8a4766474a1e455$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $a8a4766474a1e455$var$timeoutComposition = $a8a4766474a1e455$var$android ? 5000 : -1;
$a8a4766474a1e455$var$editHandlers.compositionstart = $a8a4766474a1e455$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $gZGBX.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $a8a4766474a1e455$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $a8a4766474a1e455$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($a8a4766474a1e455$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $a8a4766474a1e455$var$scheduleComposeEnd(view, $a8a4766474a1e455$var$timeoutComposition);
};
$a8a4766474a1e455$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $a8a4766474a1e455$var$scheduleComposeEnd(view, 20);
    }
};
function $a8a4766474a1e455$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$a8a4766474a1e455$var$endComposition(view), delay);
}
function $a8a4766474a1e455$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $a8a4766474a1e455$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $a8a4766474a1e455$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $a8a4766474a1e455$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $a8a4766474a1e455$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $a8a4766474a1e455$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $a8a4766474a1e455$var$endComposition(view, restarting = false) {
    if ($a8a4766474a1e455$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $a8a4766474a1e455$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $a8a4766474a1e455$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $a8a4766474a1e455$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $a8a4766474a1e455$var$brokenClipboardAPI = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version < 15 || $a8a4766474a1e455$var$ios && $a8a4766474a1e455$var$webkit_version < 604;
$a8a4766474a1e455$var$handlers.copy = $a8a4766474a1e455$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $a8a4766474a1e455$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $a8a4766474a1e455$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $a8a4766474a1e455$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $a8a4766474a1e455$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $a8a4766474a1e455$var$doPaste(view, target.value, null, plain, event);
        else $a8a4766474a1e455$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $a8a4766474a1e455$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $a8a4766474a1e455$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $kCV8T.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $a8a4766474a1e455$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $a8a4766474a1e455$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$a8a4766474a1e455$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$a8a4766474a1e455$var$android) return;
    let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $a8a4766474a1e455$var$doPaste(view, $a8a4766474a1e455$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $a8a4766474a1e455$var$capturePaste(view, event);
};
class $a8a4766474a1e455$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $a8a4766474a1e455$var$dragCopyModifier = $a8a4766474a1e455$var$mac ? "altKey" : "ctrlKey";
$a8a4766474a1e455$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $gZGBX.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $gZGBX.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $gZGBX.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $a8a4766474a1e455$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($a8a4766474a1e455$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$a8a4766474a1e455$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $a8a4766474a1e455$var$Dragging(slice, !event[$a8a4766474a1e455$var$dragCopyModifier], node);
};
$a8a4766474a1e455$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$a8a4766474a1e455$var$editHandlers.dragover = $a8a4766474a1e455$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$a8a4766474a1e455$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $a8a4766474a1e455$var$parseFromClipboard(view, $a8a4766474a1e455$var$getText(event.dataTransfer), $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$a8a4766474a1e455$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $kCV8T.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $eS2Dn.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $gZGBX.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $gZGBX.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($a8a4766474a1e455$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$a8a4766474a1e455$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $a8a4766474a1e455$var$selectionToDOM(view);
        }, 20);
    }
};
$a8a4766474a1e455$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$a8a4766474a1e455$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $a8a4766474a1e455$var$editHandlers)$a8a4766474a1e455$var$handlers[prop] = $a8a4766474a1e455$var$editHandlers[prop];
function $a8a4766474a1e455$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $a8a4766474a1e455$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $a8a4766474a1e455$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $a8a4766474a1e455$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$InlineType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $a8a4766474a1e455$var$InlineType;
    }
    destroy() {}
}
class $a8a4766474a1e455$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a8a4766474a1e455$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $a8a4766474a1e455$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $a8a4766474a1e455$var$NodeType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $a8a4766474a1e455$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(pos, pos, new $a8a4766474a1e455$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $a8a4766474a1e455$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $a8a4766474a1e455$var$WidgetType;
    }
}
const $a8a4766474a1e455$var$none = [], $a8a4766474a1e455$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $a8a4766474a1e455$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $a8a4766474a1e455$var$none;
        this.children = children.length ? children : $a8a4766474a1e455$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $a8a4766474a1e455$var$buildTree(decorations, doc, 0, $a8a4766474a1e455$var$noSpec) : $a8a4766474a1e455$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $a8a4766474a1e455$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $a8a4766474a1e455$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $a8a4766474a1e455$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none) : $a8a4766474a1e455$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $a8a4766474a1e455$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $a8a4766474a1e455$var$buildTree(found, childNode, baseOffset + 1, $a8a4766474a1e455$var$noSpec));
            childIndex += 3;
        });
        let local = $a8a4766474a1e455$var$moveSpans(childIndex ? $a8a4766474a1e455$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $a8a4766474a1e455$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($a8a4766474a1e455$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $a8a4766474a1e455$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $a8a4766474a1e455$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(local, children) : $a8a4766474a1e455$var$empty;
    }
    forChild(offset, node) {
        if (this == $a8a4766474a1e455$var$empty) return this;
        if (node.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $a8a4766474a1e455$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $a8a4766474a1e455$export$93bf62eb445cec98(local.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none);
            return child ? new $a8a4766474a1e455$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $a8a4766474a1e455$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $a8a4766474a1e455$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $a8a4766474a1e455$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$var$none;
        if (node.inlineContent || !this.local.some($a8a4766474a1e455$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $a8a4766474a1e455$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $a8a4766474a1e455$export$93bf62eb445cec98.empty = new $a8a4766474a1e455$export$93bf62eb445cec98([], []);
/**
@internal
*/ $a8a4766474a1e455$export$93bf62eb445cec98.removeOverlap = $a8a4766474a1e455$var$removeOverlap;
const $a8a4766474a1e455$var$empty = $a8a4766474a1e455$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $a8a4766474a1e455$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $a8a4766474a1e455$var$noSpec));
        return $a8a4766474a1e455$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $a8a4766474a1e455$var$empty) continue;
            if (result instanceof $a8a4766474a1e455$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $a8a4766474a1e455$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $a8a4766474a1e455$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $a8a4766474a1e455$var$removeOverlap(sorted ? result : result.sort($a8a4766474a1e455$var$byPos)) : $a8a4766474a1e455$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $a8a4766474a1e455$var$empty;
            case 1:
                return members[0];
            default:
                return new $a8a4766474a1e455$var$DecorationGroup(members.every((m)=>m instanceof $a8a4766474a1e455$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $a8a4766474a1e455$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $a8a4766474a1e455$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $a8a4766474a1e455$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $a8a4766474a1e455$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), children);
}
function $a8a4766474a1e455$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $a8a4766474a1e455$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $a8a4766474a1e455$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $a8a4766474a1e455$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $a8a4766474a1e455$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $a8a4766474a1e455$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $a8a4766474a1e455$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $a8a4766474a1e455$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $a8a4766474a1e455$var$moveSpans(hasNulls ? $a8a4766474a1e455$var$withoutNulls(spans) : spans, -offset).sort($a8a4766474a1e455$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(locals, children) : $a8a4766474a1e455$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $a8a4766474a1e455$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $a8a4766474a1e455$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $a8a4766474a1e455$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $a8a4766474a1e455$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $a8a4766474a1e455$var$insertAhead(array, i, deco) {
    while(i < array.length && $a8a4766474a1e455$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $a8a4766474a1e455$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $a8a4766474a1e455$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($a8a4766474a1e455$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $a8a4766474a1e455$var$DecorationGroup.from(found);
}
const $a8a4766474a1e455$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $a8a4766474a1e455$var$useCharData = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11;
class $a8a4766474a1e455$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $a8a4766474a1e455$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $a8a4766474a1e455$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($a8a4766474a1e455$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $a8a4766474a1e455$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$a8a4766474a1e455$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $a8a4766474a1e455$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $a8a4766474a1e455$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($a8a4766474a1e455$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $a8a4766474a1e455$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $a8a4766474a1e455$var$selectionCollapsed(sel) && (readSel = $a8a4766474a1e455$var$selectionFromDOM(view)) && readSel.eq((0, $gZGBX.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $a8a4766474a1e455$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $a8a4766474a1e455$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $a8a4766474a1e455$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $a8a4766474a1e455$var$cssChecked = new WeakMap();
let $a8a4766474a1e455$var$cssCheckWarned = false;
function $a8a4766474a1e455$var$checkCSS(view) {
    if ($a8a4766474a1e455$var$cssChecked.has(view)) return;
    $a8a4766474a1e455$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $a8a4766474a1e455$var$gecko;
        if ($a8a4766474a1e455$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $a8a4766474a1e455$var$cssCheckWarned = true;
    }
}
function $a8a4766474a1e455$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($a8a4766474a1e455$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $a8a4766474a1e455$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $a8a4766474a1e455$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $a8a4766474a1e455$var$rangeToSelectionRange(view, found) : null;
}
function $a8a4766474a1e455$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $a8a4766474a1e455$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$a8a4766474a1e455$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($a8a4766474a1e455$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $kCV8T.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $a8a4766474a1e455$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $a8a4766474a1e455$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($a8a4766474a1e455$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $a8a4766474a1e455$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $a8a4766474a1e455$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $a8a4766474a1e455$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $a8a4766474a1e455$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $a8a4766474a1e455$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $a8a4766474a1e455$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $a8a4766474a1e455$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$a8a4766474a1e455$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $gZGBX.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $a8a4766474a1e455$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $gZGBX.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $gZGBX.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $a8a4766474a1e455$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) {
        if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($a8a4766474a1e455$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($a8a4766474a1e455$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $a8a4766474a1e455$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $a8a4766474a1e455$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($a8a4766474a1e455$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $a8a4766474a1e455$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $a8a4766474a1e455$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $a8a4766474a1e455$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $a8a4766474a1e455$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $kCV8T.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $a8a4766474a1e455$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $a8a4766474a1e455$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($a8a4766474a1e455$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $a8a4766474a1e455$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $a8a4766474a1e455$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $a8a4766474a1e455$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $a8a4766474a1e455$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $a8a4766474a1e455$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $a8a4766474a1e455$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $a8a4766474a1e455$export$38b79e3fdcfcfd68 = $a8a4766474a1e455$var$serializeForClipboard;
/**
@internal
*/ const $a8a4766474a1e455$export$5d42ca91c11c9e4d = $a8a4766474a1e455$var$parseFromClipboard;
/**
@internal
*/ const $a8a4766474a1e455$export$76b14d3c719c32fc = $a8a4766474a1e455$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $a8a4766474a1e455$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $a8a4766474a1e455$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($a8a4766474a1e455$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $a8a4766474a1e455$var$getEditable(this);
        $a8a4766474a1e455$var$updateCursorWrapper(this);
        this.nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
        this.docView = $a8a4766474a1e455$var$docViewDesc(this.state.doc, $a8a4766474a1e455$var$computeDocDeco(this), $a8a4766474a1e455$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $a8a4766474a1e455$var$DOMObserver(this, (from, to, typeOver, added)=>$a8a4766474a1e455$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $a8a4766474a1e455$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($a8a4766474a1e455$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $a8a4766474a1e455$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
            if ($a8a4766474a1e455$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
        this.editable = $a8a4766474a1e455$var$getEditable(this);
        $a8a4766474a1e455$var$updateCursorWrapper(this);
        let innerDeco = $a8a4766474a1e455$var$viewDecorations(this), outerDeco = $a8a4766474a1e455$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $a8a4766474a1e455$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($a8a4766474a1e455$var$ie || $a8a4766474a1e455$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $a8a4766474a1e455$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $a8a4766474a1e455$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $a8a4766474a1e455$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $a8a4766474a1e455$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $a8a4766474a1e455$var$anchorInRightPlace(this))) $a8a4766474a1e455$var$selectionToDOM(this, forceSelUpdate);
            else {
                $a8a4766474a1e455$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $a8a4766474a1e455$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $gZGBX.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $a8a4766474a1e455$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $a8a4766474a1e455$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $a8a4766474a1e455$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $gZGBX.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($a8a4766474a1e455$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $a8a4766474a1e455$var$focusPreventScroll(this.dom);
        $a8a4766474a1e455$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $a8a4766474a1e455$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $a8a4766474a1e455$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $a8a4766474a1e455$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $a8a4766474a1e455$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $a8a4766474a1e455$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $a8a4766474a1e455$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $a8a4766474a1e455$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $a8a4766474a1e455$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $a8a4766474a1e455$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $a8a4766474a1e455$var$safari && this.root.nodeType === 11 && $a8a4766474a1e455$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $a8a4766474a1e455$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $a8a4766474a1e455$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $a8a4766474a1e455$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $a8a4766474a1e455$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $a8a4766474a1e455$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $a8a4766474a1e455$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $a8a4766474a1e455$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $a8a4766474a1e455$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $a8a4766474a1e455$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $a8a4766474a1e455$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});


parcelRegister("7Y3BJ", function(module, exports) {

$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $65853fcadaed25d5$export$650082547b31be68);

var $3xRyR = parcelRequire("3xRyR");

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");
const $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $65853fcadaed25d5$export$650082547b31be68() {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $3xRyR.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $etG8M.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $3xRyR.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $etG8M.Decoration).node(pos, pos + node.nodeSize, {
                            class: $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $etG8M.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $etG8M.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
					 * After view update can clean up decorations...
					 */ const pluginState = (0, $3xRyR.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $etG8M.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $3xRyR.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});
parcelRegister("3xRyR", function(module, exports) {

$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $b4549f33660d686a$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $b4549f33660d686a$export$6b97b121e15a69b7);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gZGBX = parcelRequire("gZGBX");

var $5qeGx = parcelRequire("5qeGx");

var $6J9GW = parcelRequire("6J9GW");

var $7KZr8 = parcelRequire("7KZr8");
const $b4549f33660d686a$export$325659f41b2239a7 = new (0, $gZGBX.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $b4549f33660d686a$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $b4549f33660d686a$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $b4549f33660d686a$var$debounceToEditorViewMap = new WeakMap();
const $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $b4549f33660d686a$export$6c7e823c919edf69(view) {
    $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $b4549f33660d686a$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $b4549f33660d686a$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $b4549f33660d686a$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $b4549f33660d686a$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $6J9GW.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $6J9GW.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $b4549f33660d686a$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $5qeGx.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $5qeGx.scheduleCallback)(()=>{
                $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($b4549f33660d686a$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $6J9GW.LazyNodeView)(node, view, getPos, decorations);
    };
};

});
parcelRegister("5qeGx", function(module, exports) {

$parcel$export(module.exports, "scheduleCallback", () => $76aba5618edd3d60$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $76aba5618edd3d60$export$b888d8f981c07a46);
const $76aba5618edd3d60$var$hasIdleCallback = 'requestIdleCallback' in window;
const $76aba5618edd3d60$export$4db3c991f22dbc2d = (cb, options)=>{
    return $76aba5618edd3d60$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $76aba5618edd3d60$export$b888d8f981c07a46 = (id)=>{
    return $76aba5618edd3d60$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("6J9GW", function(module, exports) {

$parcel$export(module.exports, "makeNodePlaceholderId", () => $178c99317a21749f$export$f306d9dd555af398);
$parcel$export(module.exports, "LazyNodeView", () => $178c99317a21749f$export$dccb00b9da782c66);

var $gJBT6 = parcelRequire("gJBT6");

var $kCV8T = parcelRequire("kCV8T");
const $178c99317a21749f$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $178c99317a21749f$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
function $178c99317a21749f$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
class $178c99317a21749f$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$178c99317a21749f$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $178c99317a21749f$var$getEditorLineWidth(view)
        };
        const fallback = (0, $kCV8T.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', $178c99317a21749f$export$f306d9dd555af398(node.type.name, pos));
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});

parcelRegister("7KZr8", function(module, exports) {

$parcel$export(module.exports, "convertToInlineCss", () => $383278441dd86b5b$export$7da93c9174ab9340);
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $383278441dd86b5b$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $383278441dd86b5b$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $383278441dd86b5b$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});



parcelRegister("6qtBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $459ed5956f03f982$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $k24a0 = parcelRequire("k24a0");
var $ggL2v = parcelRequire("ggL2v");

var $vWFRY = parcelRequire("vWFRY");

var $gZGBX = parcelRequire("gZGBX");
const $459ed5956f03f982$export$2f489388b18569dd = new (0, $gZGBX.PluginKey)('newlinePreserveMarksPlugin');
const $459ed5956f03f982$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $459ed5956f03f982$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $459ed5956f03f982$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $459ed5956f03f982$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $vWFRY.keydownHandler)({
                Enter: (0, $k24a0.filterCommand)([
                    (0, $ggL2v.isSelectionEndOfParagraph),
                    $459ed5956f03f982$var$isSelectionAligned
                ], $459ed5956f03f982$var$splitBlockPreservingMarks)
            })
        }
    });

});
parcelRegister("k24a0", function(module, exports) {

$parcel$export(module.exports, "walkNextNode", () => $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $9c1f67beb7dd4702$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $9c1f67beb7dd4702$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $9c1f67beb7dd4702$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $9c1f67beb7dd4702$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $9c1f67beb7dd4702$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $9c1f67beb7dd4702$export$a52ade1f964aef2c);
$parcel$export(module.exports, "insertContentDeleteRange", () => $9c1f67beb7dd4702$export$1a87582f65bdc5db);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $9c1f67beb7dd4702$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $9c1f67beb7dd4702$export$aedf35c057f77b82);
$parcel$export(module.exports, "filterCommand", () => $9c1f67beb7dd4702$export$3dea766d36a8935f);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $hPjvp = parcelRequire("hPjvp");

var $594Yf = parcelRequire("594Yf");

var $20Kbb = parcelRequire("20Kbb");
const $9c1f67beb7dd4702$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $9c1f67beb7dd4702$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $9c1f67beb7dd4702$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $kCV8T.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $gZGBX.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $9c1f67beb7dd4702$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $14FOE.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    })($9c1f67beb7dd4702$export$c2d9390f63354627());
const $9c1f67beb7dd4702$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$9c1f67beb7dd4702$var$canMoveUp(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
        $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $9c1f67beb7dd4702$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$9c1f67beb7dd4702$var$canMoveDown(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
        $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $9c1f67beb7dd4702$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $gZGBX.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $9c1f67beb7dd4702$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $gZGBX.TextSelection)) {
            if ($9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $gZGBX.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $9c1f67beb7dd4702$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $gZGBX.NodeSelection) && (0, $20Kbb.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $gZGBX.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$9c1f67beb7dd4702$export$e9083e8cbe24bec0(state);
}
function $9c1f67beb7dd4702$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $gZGBX.NodeSelection) && (0, $20Kbb.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $gZGBX.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$9c1f67beb7dd4702$export$4ca816540352da02(state);
}
function $9c1f67beb7dd4702$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $9c1f67beb7dd4702$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $9c1f67beb7dd4702$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $594Yf.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $9c1f67beb7dd4702$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $gZGBX.TextSelection)(getSelectionResolvedPos(tr)));
};
const $9c1f67beb7dd4702$export$55f1e30b4664ff16 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $hPjvp.GapCursorSelection));
};
const $9c1f67beb7dd4702$export$aedf35c057f77b82 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $hPjvp.GapCursorSelection));
};

});
parcelRegister("14FOE", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $6ff06cde8c465d99$export$af9baadf0e4f6e13);
function $6ff06cde8c465d99$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});

parcelRegister("hPjvp", function(module, exports) {

$parcel$export(module.exports, "Side", () => $b20495f9cc03905d$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $b20495f9cc03905d$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $b20495f9cc03905d$export$7d98c58ca1423246);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $2xQXF = parcelRequire("2xQXF");
var $b20495f9cc03905d$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $b20495f9cc03905d$export$d9f9f34e18094ffd = 'gapcursor';
class $b20495f9cc03905d$export$7d98c58ca1423246 extends (0, $gZGBX.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $2xQXF.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $2xQXF.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos)) return new $b20495f9cc03905d$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $b20495f9cc03905d$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos, this.side) : (0, $gZGBX.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $b20495f9cc03905d$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $kCV8T.Slice).empty;
    }
    getBookmark() {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $b20495f9cc03905d$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $gZGBX.Selection).jsonID($b20495f9cc03905d$export$d9f9f34e18094ffd, $b20495f9cc03905d$export$7d98c58ca1423246);
class $b20495f9cc03905d$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos) : (0, $gZGBX.Selection).near($pos);
    }
}

});
parcelRegister("2xQXF", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $2d159bb5ec0bb7a6$export$b485b49b5e1715ef);

var $3jyjs = parcelRequire("3jyjs");
const $2d159bb5ec0bb7a6$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $3jyjs.isIgnored)(node);
};

});
parcelRegister("3jyjs", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $48a4afee3b713705$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $48a4afee3b713705$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $48a4afee3b713705$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $48a4afee3b713705$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});



parcelRegister("20Kbb", function(module, exports) {

$parcel$export(module.exports, "isParagraph", () => $4198c3b63e236a69$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $4198c3b63e236a69$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $4198c3b63e236a69$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "SelectedState", () => $4198c3b63e236a69$export$a6212ae0c82963af);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $4198c3b63e236a69$export$5125f50e751e84db);
$parcel$export(module.exports, "isSupportedInParent", () => $4198c3b63e236a69$export$b6e38334b1fb4d1b);
$parcel$export(module.exports, "isMediaNode", () => $4198c3b63e236a69$export$d6ca4605aefeca32);
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $4198c3b63e236a69$export$cfaa7840b0c93780);
$parcel$export(module.exports, "toJSON", () => $4198c3b63e236a69$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $4198c3b63e236a69$export$3a858d3babd60825);

var $hYNZx = parcelRequire("hYNZx");

var $5r0mK = parcelRequire("5r0mK");
const $4198c3b63e236a69$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $4198c3b63e236a69$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $4198c3b63e236a69$export$996213f7c272fc6f = (nodes)=>nodes.every($4198c3b63e236a69$export$4c39e41e39b3c449);
const $4198c3b63e236a69$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $4198c3b63e236a69$export$d7ae8c533ae18832 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $4198c3b63e236a69$export$1879817ac5c922b7 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.text);
const $4198c3b63e236a69$export$5dfeda3a9e6fe056 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.marks.link);
var $4198c3b63e236a69$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $4198c3b63e236a69$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $4198c3b63e236a69$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $4198c3b63e236a69$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $4198c3b63e236a69$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $5r0mK.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $4198c3b63e236a69$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $4198c3b63e236a69$export$54fd2c36b5cc6731(node) {
    return $4198c3b63e236a69$var$transformer.encode(node);
}
function $4198c3b63e236a69$export$3a858d3babd60825(node) {
    return $4198c3b63e236a69$var$transformer.encodeNode(node);
}

});


parcelRegister("ggL2v", function(module, exports) {

$parcel$export(module.exports, "getStepRange", () => $c63a5e20023dc0f3$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $c63a5e20023dc0f3$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $c63a5e20023dc0f3$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $c63a5e20023dc0f3$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $c63a5e20023dc0f3$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "hasVisibleContent", () => $c63a5e20023dc0f3$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $c63a5e20023dc0f3$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $c63a5e20023dc0f3$export$fd9c3e0f31aab835);
$parcel$export(module.exports, "isReplaceDocOperation", () => $c63a5e20023dc0f3$export$b81ebf241519dbe1);

var $eS2Dn = parcelRequire("eS2Dn");

var $594Yf = parcelRequire("594Yf");
const $c63a5e20023dc0f3$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $c63a5e20023dc0f3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $594Yf.isEmptyParagraph)(nodeChild);
}
function $c63a5e20023dc0f3$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $c63a5e20023dc0f3$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $c63a5e20023dc0f3$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $c63a5e20023dc0f3$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $c63a5e20023dc0f3$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $c63a5e20023dc0f3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $c63a5e20023dc0f3$export$fd9c3e0f31aab835(tr) {
    return $c63a5e20023dc0f3$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $c63a5e20023dc0f3$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $eS2Dn.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};

});


parcelRegister("cpAC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7308593ddbe0677$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $6OgMR = parcelRequire("6OgMR");
const $b7308593ddbe0677$var$GUTTER_SIZE_IN_PX = 120;
const $b7308593ddbe0677$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $b7308593ddbe0677$var$createGutter(gutterSize, parent) {
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $b7308593ddbe0677$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var $b7308593ddbe0677$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $b7308593ddbe0677$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $6OgMR.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $6OgMR.scrollGutterPluginKey))) return tr.getMeta((0, $6OgMR.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $b7308593ddbe0677$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};

});

parcelRegister("ifnBN", function(module, exports) {

$parcel$export(module.exports, "getKeyboardHeight", () => $0be4535785a4bbee$export$af5702f0c69bf4d7);

var $6OgMR = parcelRequire("6OgMR");
const $0be4535785a4bbee$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $6OgMR.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};

});

parcelRegister("63wcB", function(module, exports) {

$parcel$export(module.exports, "inputTracking", () => $f59d9be74f9c3dfe$export$30b652f8daa79df4);
const $f59d9be74f9c3dfe$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};

});



parcelRegister("aboEQ", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => (parcelRequire("2hnN6")).blockTypePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2hnN6 = parcelRequire("2hnN6");

});
parcelRegister("2hnN6", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => $968ed2855767f974$export$896c3d927d705025);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aXBFx = parcelRequire("aXBFx");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");

var $gkwXh = parcelRequire("gkwXh");

var $6cqU9 = parcelRequire("6cqU9");
var $e9qoo = parcelRequire("e9qoo");

var $9NKqk = parcelRequire("9NKqk");

var $I02Nt = parcelRequire("I02Nt");

var $kXC89 = parcelRequire("kXC89");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $iJp6U = parcelRequire("iJp6U");

var $eKy27 = parcelRequire("eKy27");

var $kdso8 = parcelRequire("kdso8");

var $5pNa3 = parcelRequire("5pNa3");

var $6AEe7 = parcelRequire("6AEe7");

var $62ifj = parcelRequire("62ifj");
const $968ed2855767f974$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $9NKqk.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $e9qoo.tooltip)((0, $6cqU9.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $9NKqk.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).FORMATTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $968ed2855767f974$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $9NKqk.messages).blockquote),
            description: formatMessage((0, $9NKqk.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).FORMATTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $968ed2855767f974$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $kXC89.ToolbarSize).XXL : toolbarSize < (0, $kXC89.ToolbarSize).XL;
        if ((0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $kXC89.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $62ifj.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $lRTZM.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $aXBFx.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $jnMM2.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $5pNa3.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $eKy27.default)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $kdso8.default)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $iJp6U.insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $iJp6U.setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $iJp6U.insertBlockQuoteWithAnalyticsCommand)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $iJp6U.clearFormatting)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $5pNa3.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            selectionToolbar: ()=>{
                if (api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking === 'none' && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, _dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6AEe7.FloatingToolbarComponent), {
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 8
                    };
                } else return undefined;
            },
            ...(0, $gmhCD.editorExperiment)('platform_editor_insertion', 'control') && {
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$968ed2855767f974$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$968ed2855767f974$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        }
    };
};

});
parcelRegister("e9qoo", function(module, exports) {

$parcel$export(module.exports, "addAltText", () => $fd6a91b3693b55d8$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $fd6a91b3693b55d8$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $fd6a91b3693b55d8$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $fd6a91b3693b55d8$export$7be006a99a30f86b);
$parcel$export(module.exports, "askAIQuickInsert", () => $fd6a91b3693b55d8$export$ae37214e128d9cc3);
$parcel$export(module.exports, "toggleBold", () => $fd6a91b3693b55d8$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $fd6a91b3693b55d8$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $fd6a91b3693b55d8$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $fd6a91b3693b55d8$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $fd6a91b3693b55d8$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $fd6a91b3693b55d8$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $fd6a91b3693b55d8$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $fd6a91b3693b55d8$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $fd6a91b3693b55d8$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $fd6a91b3693b55d8$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $fd6a91b3693b55d8$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $fd6a91b3693b55d8$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $fd6a91b3693b55d8$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $fd6a91b3693b55d8$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $fd6a91b3693b55d8$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $fd6a91b3693b55d8$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleOrderedList", () => $fd6a91b3693b55d8$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $fd6a91b3693b55d8$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $fd6a91b3693b55d8$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $fd6a91b3693b55d8$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $fd6a91b3693b55d8$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $fd6a91b3693b55d8$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $fd6a91b3693b55d8$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $fd6a91b3693b55d8$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $fd6a91b3693b55d8$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $fd6a91b3693b55d8$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $fd6a91b3693b55d8$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $fd6a91b3693b55d8$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $fd6a91b3693b55d8$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $fd6a91b3693b55d8$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $fd6a91b3693b55d8$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $fd6a91b3693b55d8$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $fd6a91b3693b55d8$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "submit", () => $fd6a91b3693b55d8$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $fd6a91b3693b55d8$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $fd6a91b3693b55d8$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $fd6a91b3693b55d8$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $fd6a91b3693b55d8$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $fd6a91b3693b55d8$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $fd6a91b3693b55d8$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $fd6a91b3693b55d8$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $fd6a91b3693b55d8$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $fd6a91b3693b55d8$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $fd6a91b3693b55d8$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $fd6a91b3693b55d8$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $fd6a91b3693b55d8$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $fd6a91b3693b55d8$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $fd6a91b3693b55d8$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $fd6a91b3693b55d8$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $fd6a91b3693b55d8$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $fd6a91b3693b55d8$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $fd6a91b3693b55d8$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $fd6a91b3693b55d8$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $fd6a91b3693b55d8$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $fd6a91b3693b55d8$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $fd6a91b3693b55d8$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeft", () => $fd6a91b3693b55d8$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRight", () => $fd6a91b3693b55d8$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDown", () => $fd6a91b3693b55d8$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUp", () => $fd6a91b3693b55d8$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $fd6a91b3693b55d8$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $fd6a91b3693b55d8$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $fd6a91b3693b55d8$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $fd6a91b3693b55d8$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $fd6a91b3693b55d8$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $fd6a91b3693b55d8$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $fd6a91b3693b55d8$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $fd6a91b3693b55d8$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "selectRow", () => $fd6a91b3693b55d8$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $fd6a91b3693b55d8$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $fd6a91b3693b55d8$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $fd6a91b3693b55d8$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $fd6a91b3693b55d8$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $fd6a91b3693b55d8$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $fd6a91b3693b55d8$export$ec123199f2fe4770);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $fd6a91b3693b55d8$export$6b05735f625d1c82);
$parcel$export(module.exports, "continueInRovoChat", () => $fd6a91b3693b55d8$export$54f122e0d55178a9);
$parcel$export(module.exports, "formatShortcut", () => $fd6a91b3693b55d8$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $fd6a91b3693b55d8$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $fd6a91b3693b55d8$export$4096cb8ab9668358);
$parcel$export(module.exports, "findKeymapByDescription", () => $fd6a91b3693b55d8$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $fd6a91b3693b55d8$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $fd6a91b3693b55d8$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $fd6a91b3693b55d8$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $fd6a91b3693b55d8$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $fd6a91b3693b55d8$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $fd6a91b3693b55d8$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $fd6a91b3693b55d8$export$f2da701c7659a26c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1SLCf = parcelRequire("1SLCf");

var $31nwk = parcelRequire("31nwk");

var $gE8f9 = parcelRequire("gE8f9");


var $6cqU9 = parcelRequire("6cqU9");
const $fd6a91b3693b55d8$export$82527b23b485fa7f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $fd6a91b3693b55d8$export$9288bbefb6b7498b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $fd6a91b3693b55d8$export$7be006a99a30f86b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $fd6a91b3693b55d8$export$ae37214e128d9cc3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $fd6a91b3693b55d8$export$183fe6d20e9e58ba = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $fd6a91b3693b55d8$export$b03177f345903916 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $fd6a91b3693b55d8$export$6bcc93697958b66d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $fd6a91b3693b55d8$export$6d564ba4eaf138d9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $fd6a91b3693b55d8$export$d26ab98fee0c804 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $fd6a91b3693b55d8$export$4af6b58e12324fd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $fd6a91b3693b55d8$export$70686c6e7e15ed46 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $fd6a91b3693b55d8$export$ab06dc742bb20e03 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $fd6a91b3693b55d8$export$195de5d8e201efd7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $fd6a91b3693b55d8$export$63c4f0859cc75dc6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $fd6a91b3693b55d8$export$953ab0e6a5d310a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $fd6a91b3693b55d8$export$192a351cfd6ca247 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $fd6a91b3693b55d8$export$fe382f3f4c871c62 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $fd6a91b3693b55d8$export$4073e08db19e0e31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $fd6a91b3693b55d8$export$b84e85b2035ddb39 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $fd6a91b3693b55d8$export$86b1ac99fd15509b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $fd6a91b3693b55d8$export$dca848a1b50b6a31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $fd6a91b3693b55d8$export$17f69a767ce93bb3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $fd6a91b3693b55d8$export$c0e115f47553645e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $fd6a91b3693b55d8$export$34ed0cbd4f7ff88 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $fd6a91b3693b55d8$export$c2d9390f63354627 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $fd6a91b3693b55d8$export$dfd73a1c108b1570 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $fd6a91b3693b55d8$export$9e5a9569a07601f2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $fd6a91b3693b55d8$export$e920ee2eb756d384 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $fd6a91b3693b55d8$export$5f13bbad564673d4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $fd6a91b3693b55d8$export$21f930c44940fd98 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $fd6a91b3693b55d8$export$44935f8a884b57b9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $fd6a91b3693b55d8$export$8eba228b343b3599 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $fd6a91b3693b55d8$export$108f27160c89e515 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $fd6a91b3693b55d8$export$e2c874fbfec7201 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $fd6a91b3693b55d8$export$8066a906978eedb2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $fd6a91b3693b55d8$export$959569198ddbbe17 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $fd6a91b3693b55d8$export$c0e41ad67d77f6bb = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $fd6a91b3693b55d8$export$1688e416fee0a49e = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $fd6a91b3693b55d8$export$1e2fd7795238a2d3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $fd6a91b3693b55d8$export$56b88caa6d8a3bff = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $fd6a91b3693b55d8$export$fd78ad47ea0892f4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $fd6a91b3693b55d8$export$853c27de4ce0f746 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $fd6a91b3693b55d8$export$e668df1bcd81e4d2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Enter', 'Enter');
const $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $fd6a91b3693b55d8$export$62d58b1c91e8e902 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Tab', 'Tab');
const $fd6a91b3693b55d8$export$79ebfa808dffa5c6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent', 'Tab');
const $fd6a91b3693b55d8$export$25755c0352544598 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $fd6a91b3693b55d8$export$1ea584ca7009bcc1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $fd6a91b3693b55d8$export$9603e93cdf38d7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete', 'Delete');
const $fd6a91b3693b55d8$export$9e41eded5cb7e706 = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $fd6a91b3693b55d8$export$a941ed4b947d12f8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Space', 'Space');
const $fd6a91b3693b55d8$export$4e7f196112fea3c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Escape', 'Escape');
const $fd6a91b3693b55d8$export$172699367bb25225 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $fd6a91b3693b55d8$export$69838570e03d7193 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $fd6a91b3693b55d8$export$776c0cd47234205a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $fd6a91b3693b55d8$export$9ad63694f5781e16 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $fd6a91b3693b55d8$export$33b9473b3f67763f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $fd6a91b3693b55d8$export$a57fbe0d9c764ae0 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $fd6a91b3693b55d8$export$2e3087448cf87857 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $fd6a91b3693b55d8$export$fbcf51cabbe4a007 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $fd6a91b3693b55d8$export$bf95f7b7d259c19f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $fd6a91b3693b55d8$export$717d5ccb817cdecc = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $fd6a91b3693b55d8$export$5851c701392d3bfd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $fd6a91b3693b55d8$export$73fa63faf0fd6077 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $fd6a91b3693b55d8$export$875b853996fced8d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $fd6a91b3693b55d8$export$414418ca306c22bd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $fd6a91b3693b55d8$export$f092689a35ce978d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $fd6a91b3693b55d8$export$863ee96d9e15383b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $fd6a91b3693b55d8$export$13c2dd2d968ada2a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $fd6a91b3693b55d8$export$e6749a6fc243b921 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $fd6a91b3693b55d8$export$f4f2d7d33085c714 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $fd6a91b3693b55d8$export$2ef39e5ffdaff9ed = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $fd6a91b3693b55d8$export$8f58457f1327dd26 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $fd6a91b3693b55d8$export$af2a99f971a346e6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $fd6a91b3693b55d8$export$784d13d8ee351f07 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $fd6a91b3693b55d8$export$9b6706c8686cfc8e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $fd6a91b3693b55d8$export$3c1455b21d3e7aab = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $fd6a91b3693b55d8$export$71aa6c912b956294 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $fd6a91b3693b55d8$export$ca42dd9a1a0eb501 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $fd6a91b3693b55d8$export$f4a51ff076cc9a09 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $fd6a91b3693b55d8$export$faf8793e4a37a5a2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $fd6a91b3693b55d8$export$6f041e7a1d88fa51 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $fd6a91b3693b55d8$export$e247ed8cec4832f4 = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $fd6a91b3693b55d8$export$c2e8772deb1607ea = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $fd6a91b3693b55d8$export$625c5b9bf13f01a8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $fd6a91b3693b55d8$export$fdeca4160ac263c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $fd6a91b3693b55d8$export$5ec5f857fec297eb = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $fd6a91b3693b55d8$export$36141559a83247ee = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $fd6a91b3693b55d8$export$ec123199f2fe4770 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $fd6a91b3693b55d8$export$62f87f0ca411e518 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $fd6a91b3693b55d8$export$6b05735f625d1c82 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $fd6a91b3693b55d8$export$a1bdda43619f945f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $fd6a91b3693b55d8$export$9bf312985dc8137e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $fd6a91b3693b55d8$export$c4f661b85fc92fd1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $fd6a91b3693b55d8$export$61c867f4a21787f6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $fd6a91b3693b55d8$export$ba34d2a4e6aa10e4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $fd6a91b3693b55d8$export$54f122e0d55178a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $fd6a91b3693b55d8$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $fd6a91b3693b55d8$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderRadius: '2px',
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $gE8f9.browser).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Cmd/i, '\u2318')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Shift/i, '\u21E7')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Ctrl/i, '\u2303')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Alt/i, '\u2325')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Backspace/i, '\u232B')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Enter/i, '\u23CE');
    else // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $fd6a91b3693b55d8$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $gE8f9.browser).mac ? '' : '+');
}
function $fd6a91b3693b55d8$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $fd6a91b3693b55d8$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $fd6a91b3693b55d8$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $fd6a91b3693b55d8$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($fd6a91b3693b55d8$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $f8Sb3.jsx)("br", null))));
});
function $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description) {
    const matches = $fd6a91b3693b55d8$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $fd6a91b3693b55d8$export$ca66063a345ce3ab(description) {
    const keymap = $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description);
    if (keymap) return $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap);
    return;
}
function $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap) {
    if ((0, $gE8f9.browser).mac) return keymap.mac;
    return keymap.windows;
}
function $fd6a91b3693b55d8$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[(0, $gE8f9.browser).mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $fd6a91b3693b55d8$var$ALL = [
    $fd6a91b3693b55d8$export$dca848a1b50b6a31,
    $fd6a91b3693b55d8$export$c0e115f47553645e,
    $fd6a91b3693b55d8$export$183fe6d20e9e58ba,
    $fd6a91b3693b55d8$export$b03177f345903916,
    $fd6a91b3693b55d8$export$6bcc93697958b66d,
    $fd6a91b3693b55d8$export$6d564ba4eaf138d9,
    $fd6a91b3693b55d8$export$d26ab98fee0c804,
    $fd6a91b3693b55d8$export$4af6b58e12324fd,
    $fd6a91b3693b55d8$export$70686c6e7e15ed46,
    $fd6a91b3693b55d8$export$63c4f0859cc75dc6,
    $fd6a91b3693b55d8$export$953ab0e6a5d310a9,
    $fd6a91b3693b55d8$export$192a351cfd6ca247,
    $fd6a91b3693b55d8$export$fe382f3f4c871c62,
    $fd6a91b3693b55d8$export$4073e08db19e0e31,
    $fd6a91b3693b55d8$export$b84e85b2035ddb39,
    $fd6a91b3693b55d8$export$86b1ac99fd15509b,
    $fd6a91b3693b55d8$export$34ed0cbd4f7ff88,
    $fd6a91b3693b55d8$export$c2d9390f63354627,
    $fd6a91b3693b55d8$export$5f13bbad564673d4,
    $fd6a91b3693b55d8$export$9e5a9569a07601f2,
    $fd6a91b3693b55d8$export$e920ee2eb756d384,
    $fd6a91b3693b55d8$export$1688e416fee0a49e,
    $fd6a91b3693b55d8$export$21f930c44940fd98,
    $fd6a91b3693b55d8$export$71aa6c912b956294,
    $fd6a91b3693b55d8$export$4e7f196112fea3c5,
    $fd6a91b3693b55d8$export$e668df1bcd81e4d2,
    $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29
];
function $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        windows: windows.replace(/Mod/i, 'Ctrl'),
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, common) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const windows = common.replace(/Mod/i, 'Ctrl');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = common.replace(/Mod/i, 'Cmd');
    return $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $fd6a91b3693b55d8$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $fd6a91b3693b55d8$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $fd6a91b3693b55d8$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, (0, $31nwk.editorCommandToPMCommand)(cmd), keymap);
}
function $fd6a91b3693b55d8$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        if ((0, $gE8f9.browser).mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $fd6a91b3693b55d8$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $1SLCf.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $1SLCf.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});
parcelRegister("31nwk", function(module, exports) {

$parcel$export(module.exports, "editorCommandToPMCommand", () => $9c736ce93f64dbdf$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $9c736ce93f64dbdf$export$95069e054e554fa9);

var $gZGBX = parcelRequire("gZGBX");
function $9c736ce93f64dbdf$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $9c736ce93f64dbdf$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $9c736ce93f64dbdf$export$95069e054e554fa9 extends (0, $gZGBX.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});


parcelRegister("I02Nt", function(module, exports) {

$parcel$export(module.exports, "IconAction", () => $513b94a8224240d6$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $513b94a8224240d6$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $513b94a8224240d6$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $513b94a8224240d6$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $513b94a8224240d6$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $513b94a8224240d6$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $513b94a8224240d6$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $513b94a8224240d6$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $513b94a8224240d6$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $513b94a8224240d6$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $513b94a8224240d6$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $513b94a8224240d6$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $513b94a8224240d6$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $513b94a8224240d6$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $513b94a8224240d6$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $513b94a8224240d6$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $513b94a8224240d6$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $513b94a8224240d6$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $513b94a8224240d6$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconOneColumnLayout", () => $513b94a8224240d6$export$8f1e9e900568bfce);
$parcel$export(module.exports, "IconTwoColumnLayout", () => $513b94a8224240d6$export$732a7fc4975ab5a4);
$parcel$export(module.exports, "IconThreeColumnLayout", () => $513b94a8224240d6$export$fdfaf73f45072edb);
$parcel$export(module.exports, "IconFourColumnLayout", () => $513b94a8224240d6$export$a1588f873a973762);
$parcel$export(module.exports, "IconFiveColumnLayout", () => $513b94a8224240d6$export$ff1f32987b4c27d9);
$parcel$export(module.exports, "IconHeading", () => $513b94a8224240d6$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $513b94a8224240d6$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $513b94a8224240d6$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $513b94a8224240d6$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $513b94a8224240d6$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $513b94a8224240d6$export$29a810fd0b8c3f03);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

const $513b94a8224240d6$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("kQcAy")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("17q5G")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iUvkP")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lMkkv")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("h94WP")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8AyzB")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("e98Nk")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lmVo5")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iKIPX")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("20xgW")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4NtKw")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iHdul")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gYCXP")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("deQFB")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("eneOz")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("dquU6")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("x2iq8")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("ahjoF")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bVRSS")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8oGGK")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jxhCk")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("cDqQP")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8uf5O")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3ihyX")).then((module)=>module.default),
    loading: ()=>null
});






function $513b94a8224240d6$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("8oVIH"));
        case 2:
            return (parcelRequire("lrCC6"));
        case 3:
            return (parcelRequire("ic0fJ"));
        case 4:
            return (parcelRequire("bAPc0"));
        case 5:
            return (parcelRequire("d4woI"));
        case 6:
        default:
            return (parcelRequire("7RttZ"));
    }
}
const $513b94a8224240d6$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>$513b94a8224240d6$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        ...props
    });
};

const $513b94a8224240d6$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("3AGqm")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gctzC")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5bHiN")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lFb30")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gKY1y")).then((module)=>module.default),
    loading: ()=>null
});

const $513b94a8224240d6$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("68faM")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("kQcAy", function(module, exports) {

let $f2c26dc854d08681$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f2c26dc854d08681$var$load("724qH").then(()=>parcelRequire('fGUVQ'));

});

parcelRegister("17q5G", function(module, exports) {

let $0d0aaef7babb1fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d0aaef7babb1fbe$var$load("3ZkZ1").then(()=>parcelRequire('7mMCo'));

});

parcelRegister("iUvkP", function(module, exports) {

let $dc45c36a53b3f530$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc45c36a53b3f530$var$load("f06BP").then(()=>parcelRequire('hhrZv'));

});

parcelRegister("lMkkv", function(module, exports) {

let $fdadd9b65aef2931$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdadd9b65aef2931$var$load("eQvmQ").then(()=>parcelRequire('dWg6W'));

});

parcelRegister("h94WP", function(module, exports) {

let $c7b71d74ffaec16e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7b71d74ffaec16e$var$load("7cbdH").then(()=>parcelRequire('eAdWP'));

});

parcelRegister("8AyzB", function(module, exports) {

let $640c8106ded5c675$var$load = (parcelRequire("28QjX"))(4);
module.exports = $640c8106ded5c675$var$load("atxYO").then(()=>parcelRequire('i375O'));

});

parcelRegister("e98Nk", function(module, exports) {

let $a4c8ba64f63c5a1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4c8ba64f63c5a1a$var$load("izOBN").then(()=>parcelRequire('e88pi'));

});

parcelRegister("lmVo5", function(module, exports) {

let $f8e82b01e803441c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8e82b01e803441c$var$load("1gkGf").then(()=>parcelRequire('7ZWch'));

});

parcelRegister("iKIPX", function(module, exports) {

let $da6f4d8f6a438929$var$load = (parcelRequire("28QjX"))(4);
module.exports = $da6f4d8f6a438929$var$load("3U0GW").then(()=>parcelRequire('7AaHD'));

});

parcelRegister("20xgW", function(module, exports) {

let $1765640ab389ea83$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1765640ab389ea83$var$load("9z10I").then(()=>parcelRequire('2TyBm'));

});

parcelRegister("4NtKw", function(module, exports) {

let $37e2d0a178a271d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37e2d0a178a271d8$var$load("8QQNW").then(()=>parcelRequire('ieCqs'));

});

parcelRegister("iHdul", function(module, exports) {

let $d9c6b4af0c4a82f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9c6b4af0c4a82f5$var$load("eLVEG").then(()=>parcelRequire('aIi75'));

});

parcelRegister("gYCXP", function(module, exports) {

let $c5c07962f9030eb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5c07962f9030eb1$var$load("6Iwmh").then(()=>parcelRequire('6m8b0'));

});

parcelRegister("deQFB", function(module, exports) {

let $9a35705a50bbe312$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a35705a50bbe312$var$load("dpTsM").then(()=>parcelRequire('hpPu5'));

});

parcelRegister("eneOz", function(module, exports) {

let $a76eb49017125812$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a76eb49017125812$var$load("bttvz").then(()=>parcelRequire('2d5K5'));

});

parcelRegister("dquU6", function(module, exports) {

let $9c65aceba817f190$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c65aceba817f190$var$load("kCsFm").then(()=>parcelRequire('j7B0X'));

});

parcelRegister("x2iq8", function(module, exports) {

let $0634dd24079b3644$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0634dd24079b3644$var$load("dIPxP").then(()=>parcelRequire('g2ofu'));

});

parcelRegister("ahjoF", function(module, exports) {

let $77ba89b6c076bcef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77ba89b6c076bcef$var$load("19fts").then(()=>parcelRequire('aWSsM'));

});

parcelRegister("bVRSS", function(module, exports) {

let $8afed0dc59133fdb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8afed0dc59133fdb$var$load("cqBQJ").then(()=>parcelRequire('clu4g'));

});

parcelRegister("8oGGK", function(module, exports) {

let $61d1adac887d123e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61d1adac887d123e$var$load("lc1q7").then(()=>parcelRequire('aKp87'));

});

parcelRegister("jxhCk", function(module, exports) {

let $e38ec3d28a1274ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e38ec3d28a1274ef$var$load("ayCPI").then(()=>parcelRequire('5a4B6'));

});

parcelRegister("cDqQP", function(module, exports) {

let $932df4a35c119da7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $932df4a35c119da7$var$load("4KLcr").then(()=>parcelRequire('hZOiE'));

});

parcelRegister("8uf5O", function(module, exports) {

let $62dcd52a648fe31a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62dcd52a648fe31a$var$load("3IT4G").then(()=>parcelRequire('6P7Pf'));

});

parcelRegister("3ihyX", function(module, exports) {

let $2660ad2991dbb53d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2660ad2991dbb53d$var$load("1E6UJ").then(()=>parcelRequire('5ytLq'));

});

parcelRegister("8oVIH", function(module, exports) {

let $61dd569d0d5a5d1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61dd569d0d5a5d1a$var$load("hmwx0").then(()=>parcelRequire('dMM4v'));

});

parcelRegister("lrCC6", function(module, exports) {

let $f9ca12715aed8560$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9ca12715aed8560$var$load("cf9Pv").then(()=>parcelRequire('6cKKb'));

});

parcelRegister("ic0fJ", function(module, exports) {

let $d3e98b262e21a151$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3e98b262e21a151$var$load("8TQC3").then(()=>parcelRequire('9iWN4'));

});

parcelRegister("bAPc0", function(module, exports) {

let $870ac447bf028b7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $870ac447bf028b7a$var$load("kgQKy").then(()=>parcelRequire('eKOIc'));

});

parcelRegister("d4woI", function(module, exports) {

let $9844c79149dbd3ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9844c79149dbd3ba$var$load("ajw0S").then(()=>parcelRequire('9OxUo'));

});

parcelRegister("7RttZ", function(module, exports) {

let $5b945a48e3462c32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b945a48e3462c32$var$load("eiNIw").then(()=>parcelRequire('dYSoJ'));

});

parcelRegister("3AGqm", function(module, exports) {

let $29d5a4749da44398$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29d5a4749da44398$var$load("6Sret").then(()=>parcelRequire('65bRZ'));

});

parcelRegister("gctzC", function(module, exports) {

let $bcb4b50643fcb5bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bcb4b50643fcb5bd$var$load("4jVs5").then(()=>parcelRequire('hwHW3'));

});

parcelRegister("5bHiN", function(module, exports) {

let $3c6f91bbf9960130$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c6f91bbf9960130$var$load("69mZe").then(()=>parcelRequire('aoo70'));

});

parcelRegister("lFb30", function(module, exports) {

let $fc55ff1b12cbce60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc55ff1b12cbce60$var$load("9eYWW").then(()=>parcelRequire('jvVU5'));

});

parcelRegister("gKY1y", function(module, exports) {

let $c32f80bee9162a98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c32f80bee9162a98$var$load("bb7Ve").then(()=>parcelRequire('4H15d'));

});

parcelRegister("68faM", function(module, exports) {

let $476f427503a57968$var$load = (parcelRequire("28QjX"))(4);
module.exports = $476f427503a57968$var$load("igji4").then(()=>parcelRequire('8Giki'));

});


parcelRegister("iJp6U", function(module, exports) {

$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $a2f47a40ffbb9304$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $a2f47a40ffbb9304$export$283e32d0388e302a);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $a2f47a40ffbb9304$export$52d74b15bd103d7f);
$parcel$export(module.exports, "clearFormatting", () => $a2f47a40ffbb9304$export$195de5d8e201efd7);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $a2f47a40ffbb9304$export$50b4331f407b3ab6);
$parcel$export(module.exports, "insertBlockQuoteWithAnalyticsCommand", () => $a2f47a40ffbb9304$export$f5e16b3b6b62d83);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $a2f47a40ffbb9304$export$9c6026f8ac831f44);

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $594Yf = parcelRequire("594Yf");
var $aeKzo = parcelRequire("aeKzo");

var $kCV8T = parcelRequire("kCV8T");

var $hFEwm = parcelRequire("hFEwm");

var $8QX3X = parcelRequire("8QX3X");

var $lP8Yg = parcelRequire("lP8Yg");

var $4k6sj = parcelRequire("4k6sj");
function $a2f47a40ffbb9304$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $8QX3X.NORMAL_TEXT).name && nodes.paragraph) return $a2f47a40ffbb9304$export$63c4f0859cc75dc6()({
            tr: tr
        });
        const headingBlockType = (0, $8QX3X.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                const content = $from.node().content;
                const headingNode = schema.nodes.heading.createChecked({
                    level: level
                }, content);
                const slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(headingNode), 0, 0);
                tr.replaceRange(range.start, range.end, slice);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        return tr;
    };
}
function $a2f47a40ffbb9304$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $8QX3X.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $a2f47a40ffbb9304$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                tr.lift(range, 0);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        return tr;
    };
}
function $a2f47a40ffbb9304$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $lP8Yg.FORMATTING_MARK_TYPES).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $lP8Yg.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $lP8Yg.formatTypes)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $lP8Yg.formatTypes)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $lP8Yg.FORMATTING_NODE_TYPES).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $lP8Yg.cellSelectionNodesBetween)(tr.selection, tr.doc, (0, $lP8Yg.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $lP8Yg.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).FORMATTED,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $a2f47a40ffbb9304$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $594Yf.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a2f47a40ffbb9304$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $a2f47a40ffbb9304$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $a2f47a40ffbb9304$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $aeKzo.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $a2f47a40ffbb9304$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $14FOE.withAnalytics)(editorAnalyticsApi, {
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($a2f47a40ffbb9304$var$insertBlockQuote());
};
function $a2f47a40ffbb9304$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $4k6sj.wrapSelectionInBlockType)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $a2f47a40ffbb9304$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});
parcelRegister("aeKzo", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionIn", () => $e364b1498c53313f$export$f63f505240212912);

var $iXNbm = parcelRequire("iXNbm");
function $e364b1498c53313f$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $iXNbm.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("iXNbm", function(module, exports) {

$parcel$export(module.exports, "createWrapSelectionTransaction", () => $4678f0237e36a927$export$d5c308539c2b2123);

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $594Yf = parcelRequire("594Yf");
function $4678f0237e36a927$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $594Yf.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $4678f0237e36a927$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $5r0mK.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $4678f0237e36a927$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $eS2Dn.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});


parcelRegister("8QX3X", function(module, exports) {

$parcel$export(module.exports, "NORMAL_TEXT", () => $3e54611e0bd0552a$export$58d6de174a4025df);
$parcel$export(module.exports, "HEADING_1", () => $3e54611e0bd0552a$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $3e54611e0bd0552a$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $3e54611e0bd0552a$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $3e54611e0bd0552a$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $3e54611e0bd0552a$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $3e54611e0bd0552a$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $3e54611e0bd0552a$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $3e54611e0bd0552a$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $3e54611e0bd0552a$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $3e54611e0bd0552a$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $3e54611e0bd0552a$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $3e54611e0bd0552a$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $3e54611e0bd0552a$export$73b50f8f13648c71);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $3e54611e0bd0552a$export$c6516682f7569488);
$parcel$export(module.exports, "getBlockTypesInDropdown", () => $3e54611e0bd0552a$export$a1bb601016dd2309);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $3e54611e0bd0552a$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $3e54611e0bd0552a$export$33dfdcd30c23ea87);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9NKqk = parcelRequire("9NKqk");

var $54hRX = parcelRequire("54hRX");

var $7fdtk = parcelRequire("7fdtk");

var $eMtMm = parcelRequire("eMtMm");

var $7LKVc = parcelRequire("7LKVc");

var $3Mh5S = parcelRequire("3Mh5S");

var $f4BiX = parcelRequire("f4BiX");

var $5Hpaz = parcelRequire("5Hpaz");

var $gmhCD = parcelRequire("gmhCD");

var $k8Zwf = parcelRequire("k8Zwf");
const $3e54611e0bd0552a$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $9NKqk.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.Text), {})
};
const $3e54611e0bd0552a$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $9NKqk.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eMtMm))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H1), {})
};
const $3e54611e0bd0552a$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $9NKqk.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4BiX))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H2), {})
};
const $3e54611e0bd0552a$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $9NKqk.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mh5S))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H3), {})
};
const $3e54611e0bd0552a$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $9NKqk.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fdtk))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H4), {})
};
const $3e54611e0bd0552a$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $9NKqk.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54hRX))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H5), {})
};
const $3e54611e0bd0552a$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $9NKqk.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7LKVc))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8Zwf.H6), {})
};
const $3e54611e0bd0552a$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $9NKqk.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $3e54611e0bd0552a$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $9NKqk.messages).codeblock,
    nodeName: 'codeBlock'
};
const $3e54611e0bd0552a$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $9NKqk.messages).infoPanel,
    nodeName: 'panel'
};
const $3e54611e0bd0552a$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $9NKqk.messages).other,
    nodeName: ''
};
const $3e54611e0bd0552a$export$2ec1d6c4f06d927 = [
    $3e54611e0bd0552a$export$58d6de174a4025df,
    $3e54611e0bd0552a$export$aca53469ff012f69,
    $3e54611e0bd0552a$export$8af5e2d4f952c9f0,
    $3e54611e0bd0552a$export$4b4c4ef3a93a84d8,
    $3e54611e0bd0552a$export$67379271b4d26982,
    $3e54611e0bd0552a$export$230d7efa1736763e,
    $3e54611e0bd0552a$export$329adfa5d98f30d5
];
const $3e54611e0bd0552a$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $3e54611e0bd0552a$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $3e54611e0bd0552a$export$c6516682f7569488 = [
    $3e54611e0bd0552a$export$175cdd8bc7e4b125,
    $3e54611e0bd0552a$export$cf55d1bff75690da,
    $3e54611e0bd0552a$export$867b449446b85962
];
const $3e54611e0bd0552a$export$237f26fa8dbc0d9a = $3e54611e0bd0552a$export$2ec1d6c4f06d927.concat($3e54611e0bd0552a$export$c6516682f7569488);
const $3e54611e0bd0552a$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return (0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true, {
        exposure: true
    }) && includeBlockQuoteAsTextstyleOption ? [
        ...$3e54611e0bd0552a$export$2ec1d6c4f06d927,
        $3e54611e0bd0552a$export$175cdd8bc7e4b125
    ] : $3e54611e0bd0552a$export$2ec1d6c4f06d927;
};
const $3e54611e0bd0552a$export$110c9c3e05131569 = $3e54611e0bd0552a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $3e54611e0bd0552a$export$33dfdcd30c23ea87 = $3e54611e0bd0552a$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});
parcelRegister("54hRX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f20174f511024dbb8c8d349f218c646e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b0b2ff65e59d223$var$_react = $3b0b2ff65e59d223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3b0b2ff65e59d223$var$_baseNew = $3b0b2ff65e59d223$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3b0b2ff65e59d223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b0b2ff65e59d223$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $3b0b2ff65e59d223$var$_react.default.createElement($3b0b2ff65e59d223$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$3b0b2ff65e59d223$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $3b0b2ff65e59d223$var$_default = module.exports.default = $3b0b2ff65e59d223$var$TextHeadingFiveIcon;

});

parcelRegister("7fdtk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e1c911275bbc9f09d8b74402467dc96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546462666800b816$var$_react = $546462666800b816$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $546462666800b816$var$_baseNew = $546462666800b816$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $546462666800b816$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546462666800b816$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $546462666800b816$var$_react.default.createElement($546462666800b816$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$546462666800b816$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $546462666800b816$var$_default = module.exports.default = $546462666800b816$var$TextHeadingFourIcon;

});

parcelRegister("eMtMm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a96af59b8b25fc6d7b24bf13d8c2c64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac2ca5e0db3b7b68$var$_react = $ac2ca5e0db3b7b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ac2ca5e0db3b7b68$var$_baseNew = $ac2ca5e0db3b7b68$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ac2ca5e0db3b7b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac2ca5e0db3b7b68$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $ac2ca5e0db3b7b68$var$_react.default.createElement($ac2ca5e0db3b7b68$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$ac2ca5e0db3b7b68$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $ac2ca5e0db3b7b68$var$_default = module.exports.default = $ac2ca5e0db3b7b68$var$TextHeadingOneIcon;

});

parcelRegister("7LKVc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd4b564b4f9efff19c6a7ab8cfffa74a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8151d100811dd6$var$_react = $5a8151d100811dd6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a8151d100811dd6$var$_baseNew = $5a8151d100811dd6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5a8151d100811dd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8151d100811dd6$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $5a8151d100811dd6$var$_react.default.createElement($5a8151d100811dd6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$5a8151d100811dd6$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $5a8151d100811dd6$var$_default = module.exports.default = $5a8151d100811dd6$var$TextHeadingSixIcon;

});

parcelRegister("3Mh5S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69eb91f82b309428a7917986dda5ee35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c031d41a72514f9$var$_react = $2c031d41a72514f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2c031d41a72514f9$var$_baseNew = $2c031d41a72514f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2c031d41a72514f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c031d41a72514f9$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $2c031d41a72514f9$var$_react.default.createElement($2c031d41a72514f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$2c031d41a72514f9$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $2c031d41a72514f9$var$_default = module.exports.default = $2c031d41a72514f9$var$TextHeadingThreeIcon;

});

parcelRegister("f4BiX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d33290aac1089ceab1f15dfb1bfcf01>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af942ab13fd9e775$var$_react = $af942ab13fd9e775$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af942ab13fd9e775$var$_baseNew = $af942ab13fd9e775$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af942ab13fd9e775$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af942ab13fd9e775$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $af942ab13fd9e775$var$_react.default.createElement($af942ab13fd9e775$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$af942ab13fd9e775$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $af942ab13fd9e775$var$_default = module.exports.default = $af942ab13fd9e775$var$TextHeadingTwoIcon;

});

parcelRegister("k8Zwf", function(module, exports) {

$parcel$export(module.exports, "Text", () => $d1689df415d7af0e$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $d1689df415d7af0e$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $d1689df415d7af0e$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $d1689df415d7af0e$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $d1689df415d7af0e$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $d1689df415d7af0e$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $d1689df415d7af0e$export$a559fb8039b06400);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $d1689df415d7af0e$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $d1689df415d7af0e$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $d1689df415d7af0e$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($d1689df415d7af0e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("lP8Yg", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $9840ca256f751a84$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $9840ca256f751a84$export$73b50f8f13648c71);
$parcel$export(module.exports, "formatTypes", () => $9840ca256f751a84$export$ce157a3b6664c924);
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $9840ca256f751a84$export$bd443c1dba3019b8);
$parcel$export(module.exports, "clearNodeFormattingOnSelection", () => $9840ca256f751a84$export$10ed2145ce1a03b1);

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");
const $9840ca256f751a84$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $9840ca256f751a84$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $9840ca256f751a84$export$ce157a3b6664c924 = {
    em: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $9840ca256f751a84$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $9840ca256f751a84$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eS2Dn.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}

});

parcelRegister("4k6sj", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionInBlockType", () => $77fcbbfe95f30545$export$bb05c9a6c853122f);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
function $77fcbbfe95f30545$export$bb05c9a6c853122f(nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /**Remove alignment and indentation marks from the selection */ const marksToRemove = [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $eS2Dn.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}

});


parcelRegister("eKy27", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ccb780a6937c50a$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $93WYh = parcelRequire("93WYh");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $inLhu = parcelRequire("inLhu");

var $eWNtX = parcelRequire("eWNtX");
const $3ccb780a6937c50a$var$MAX_HEADING_LEVEL = 6;
function $3ccb780a6937c50a$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $3ccb780a6937c50a$var$headingRule(nodeType, maxLevel) {
    return (0, $eWNtX.createWrappingTextBlockRule)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $3ccb780a6937c50a$var$getHeadingLevel
    });
}
function $3ccb780a6937c50a$var$blockQuoteRule(nodeType) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return (0, $eWNtX.createJoinNodesRule)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $3ccb780a6937c50a$var$headingRule(schema.nodes.heading, $3ccb780a6937c50a$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $2Abpa.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $93WYh.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $2Abpa.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $gkwXh.ACTION).FORMATTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $3ccb780a6937c50a$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $3ccb780a6937c50a$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $2Abpa.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $93WYh.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $3ccb780a6937c50a$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $3ccb780a6937c50a$export$2e2bcd8739ae039 = $3ccb780a6937c50a$var$inputRulePlugin;

});
parcelRegister("93WYh", function(module, exports) {

$parcel$export(module.exports, "insertBlock", () => $0e69bbce5359b325$export$f51280337625031);

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");
const $0e69bbce5359b325$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $5r0mK.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});

parcelRegister("2Abpa", function(module, exports) {

$parcel$export(module.exports, "inputRuleWithAnalytics", () => $9aa3f9797dcf58b2$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $9aa3f9797dcf58b2$export$6341edfa2d147bc);
$parcel$export(module.exports, "createRule", () => $9aa3f9797dcf58b2$export$56e87122f905fac0);

var $fZzhT = parcelRequire("fZzhT");

var $eS2Dn = parcelRequire("eS2Dn");

var $57ZlA = parcelRequire("57ZlA");
const $9aa3f9797dcf58b2$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $9aa3f9797dcf58b2$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $eS2Dn.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $eS2Dn.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $57ZlA.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $9aa3f9797dcf58b2$export$56e87122f905fac0(match, handler);
};
const $9aa3f9797dcf58b2$export$56e87122f905fac0 = (match, handler)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $fZzhT.closeHistory)(tr);
        }
    };
};

});
parcelRegister("57ZlA", function(module, exports) {

$parcel$export(module.exports, "DELETE_DIRECTION", () => $4b9a10a7caaf11e5$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $4b9a10a7caaf11e5$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $4b9a10a7caaf11e5$export$43e6a678b13eb45f);
$parcel$export(module.exports, "OUTDENT_SCENARIOS", () => $4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8);
var $4b9a10a7caaf11e5$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $4b9a10a7caaf11e5$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $4b9a10a7caaf11e5$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});

});


parcelRegister("inLhu", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0178415f004b9eed$export$ae829ec7b2625219);

var $fZzhT = parcelRequire("fZzhT");

var $gZGBX = parcelRequire("gZGBX");

var $2CgsA = parcelRequire("2CgsA");

var $eLc4o = parcelRequire("eLc4o");
const $0178415f004b9eed$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $0178415f004b9eed$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $0178415f004b9eed$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $gZGBX.TextSelection)) && !(0, $2CgsA.isGapCursorSelection)(state.selection) && !isInline || $0178415f004b9eed$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $0178415f004b9eed$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $eLc4o.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $fZzhT.closeHistory)(tr);
        }
    });
};

});
parcelRegister("2CgsA", function(module, exports) {

$parcel$export(module.exports, "isGapCursorSelection", () => $79c3774b0460e64a$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $79c3774b0460e64a$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("eLc4o", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $301ed6c086d04b75$export$dc83f374e2af640d);

var $gZGBX = parcelRequire("gZGBX");


var $a7z0s = parcelRequire("a7z0s");
function $301ed6c086d04b75$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $gZGBX.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $a7z0s.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $gZGBX.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $d19733ae55e58348$export$a96b909f1510512b = '\ufffc';
const $d19733ae55e58348$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $d19733ae55e58348$export$af78bb669dec9658 = 500;

parcelRegister("a7z0s", function(module, exports) {

$parcel$export(module.exports, "createInputEventHandler", () => $df6df97092dea2d9$export$9bcba4b183c6bb83);


var $2CgsA = parcelRequire("2CgsA");
const $df6df97092dea2d9$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658)), $from.parentOffset, undefined, (0, $d19733ae55e58348$export$a96b909f1510512b)) + text;
        const result = $df6df97092dea2d9$var$findMatchOnRules({
            rules: rules,
            textBefore: textBefore,
            from: from,
            to: to,
            state: state
        });
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $df6df97092dea2d9$var$findMatchOnRules({ rules: rules, textBefore: textBefore, from: from, to: to, state: state }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textBefore` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $2CgsA.isGapCursorSelection)(state.selection) ? textBefore.at(-1) ?? '' : textBefore;
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});



parcelRegister("eWNtX", function(module, exports) {

$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $4c437d0d04103ee6$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $4c437d0d04103ee6$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $4c437d0d04103ee6$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $4c437d0d04103ee6$export$52adb8d9a3386cb8);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $4c437d0d04103ee6$export$4b48a1fc423972ea);
$parcel$export(module.exports, "hasBlockQuoteInOptions", () => $4c437d0d04103ee6$export$bce51f4ee2032263);

var $30Enc = parcelRequire("30Enc");

var $2Abpa = parcelRequire("2Abpa");

var $gmhCD = parcelRequire("gmhCD");

var $8QX3X = parcelRequire("8QX3X");
const $4c437d0d04103ee6$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $8QX3X.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $4c437d0d04103ee6$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $2Abpa.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $4c437d0d04103ee6$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $2Abpa.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $4c437d0d04103ee6$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $4c437d0d04103ee6$export$52adb8d9a3386cb8(state) {
    const nodesTypes = $4c437d0d04103ee6$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    if ((0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return nodesTypes.filter((type)=>type !== panel).length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return nodesTypes.filter((type)=>type !== panel).length > 0;
}
const $4c437d0d04103ee6$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $8QX3X.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $4c437d0d04103ee6$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $8QX3X.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $30Enc.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $4c437d0d04103ee6$export$4b48a1fc423972ea = (state)=>{
    return $4c437d0d04103ee6$var$marksArePresent(state) || $4c437d0d04103ee6$var$blockStylingIsPresent(state);
};
const $4c437d0d04103ee6$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};

});
parcelRegister("30Enc", function(module, exports) {

$parcel$export(module.exports, "anyMarkActive", () => $5046559148b4fd0d$export$3d7a3b3f27c57f56);
$parcel$export(module.exports, "isMarkAllowedInRange", () => $5046559148b4fd0d$export$22a8bb98a26ef60);
$parcel$export(module.exports, "isMarkExcluded", () => $5046559148b4fd0d$export$87b559fec4a10a1a);

var $hFEwm = parcelRequire("hFEwm");
const $5046559148b4fd0d$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $hFEwm.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
const $5046559148b4fd0d$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
const $5046559148b4fd0d$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});



parcelRegister("kdso8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25680dc6fd050d04$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");
var $6cqU9 = parcelRequire("6cqU9");

var $k24a0 = parcelRequire("k24a0");

var $2RHbH = parcelRequire("2RHbH");

var $fZzhT = parcelRequire("fZzhT");

var $8QX3X = parcelRequire("8QX3X");

var $iJp6U = parcelRequire("iJp6U");

var $jMN7x = parcelRequire("jMN7x");

var $7eSM1 = parcelRequire("7eSM1");

var $eWNtX = parcelRequire("eWNtX");
const $25680dc6fd050d04$var$backspaceCommand = (0, $2RHbH.chainCommands)((0, $iJp6U.cleanUpAtTheStartOfDocument), (0, $7eSM1.deleteBlockContent)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $jMN7x.deleteAndMoveCursor));
const $25680dc6fd050d04$var$del = (0, $2RHbH.chainCommands)((0, $k24a0.deleteEmptyParagraphAndMoveBlockUp)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $7eSM1.deleteBlockContent)((0, $eWNtX.isNodeAWrappingBlockNode)), (0, $jMN7x.deleteAndMoveCursor));
function $25680dc6fd050d04$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.insertNewLine).common, (0, $k24a0.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveUp).common, (0, $k24a0.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveDown).common, (0, $k24a0.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redo)), (0, $fZzhT.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.undo).common, (0, $fZzhT.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.backspace).common, $25680dc6fd050d04$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.deleteKey).common, $25680dc6fd050d04$var$del, list);
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.forwardDelete).mac, $25680dc6fd050d04$var$del, list);
    if (schema.nodes[$8QX3X.BLOCK_QUOTE.nodeName]) (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.findShortcutByKeymap)((0, $e9qoo.toggleBlockQuote)), (0, $iJp6U.insertBlockQuoteWithAnalytics)((0, $gkwXh.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $6cqU9.keymap)(list);
}

});
parcelRegister("jMN7x", function(module, exports) {

$parcel$export(module.exports, "deleteAndMoveCursor", () => $aab5fb9291da562a$export$6c408f720f6b44a7);

var $gZGBX = parcelRequire("gZGBX");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $aab5fb9291da562a$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $aab5fb9291da562a$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!$aab5fb9291da562a$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("7eSM1", function(module, exports) {

$parcel$export(module.exports, "deleteBlockContent", () => $523f65c5ad5003d8$export$9c1a524875bfb8ec);

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");
// function to check whether the selected node is the sole decision item in the decision list
const $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $5r0mK.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $523f65c5ad5003d8$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $gZGBX.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $523f65c5ad5003d8$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $5r0mK.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $5r0mK.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $523f65c5ad5003d8$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});


parcelRegister("5pNa3", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $eef5dca48c9b3cf7$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $eef5dca48c9b3cf7$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $gE8f9 = parcelRequire("gE8f9");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $8QX3X = parcelRequire("8QX3X");

var $iJp6U = parcelRequire("iJp6U");

var $eTqxy = parcelRequire("eTqxy");

var $eWNtX = parcelRequire("eWNtX");
const $eef5dca48c9b3cf7$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $8QX3X.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.type === schema.nodes.paragraph) return 0, $8QX3X.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $8QX3X.BLOCK_QUOTE;
    return 0, $8QX3X.OTHER;
};
const $eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $8QX3X.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $8QX3X.HEADING_1:
        case 0, $8QX3X.HEADING_2:
        case 0, $8QX3X.HEADING_3:
        case 0, $8QX3X.HEADING_4:
        case 0, $8QX3X.HEADING_5:
        case 0, $8QX3X.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $8QX3X.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $8QX3X.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $8QX3X.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $eef5dca48c9b3cf7$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $8QX3X.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $eef5dca48c9b3cf7$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $8QX3X.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $8QX3X.OTHER);
            return false;
        }
    });
    return blockType || (0, $8QX3X.OTHER);
};
const $eef5dca48c9b3cf7$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $iJp6U.setNormalTextWithAnalytics)((0, $gkwXh.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $iJp6U.setHeadingWithAnalytics)(headingLevel, (0, $gkwXh.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $eef5dca48c9b3cf7$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('blockTypePlugin');
const $eef5dca48c9b3cf7$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $5KWxh.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $8QX3X.TEXT_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $8QX3X.WRAPPER_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $8QX3X.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $eWNtX.hasBlockQuoteInOptions)(availableBlockTypesInDropdown) ? (0, $eWNtX.checkFormattingIsPresent)(state) : undefined;
                return {
                    currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $eWNtX.areBlockTypesDisabled)(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $eWNtX.areBlockTypesDisabled)(newState),
                    formattingIsPresent: (0, $eWNtX.hasBlockQuoteInOptions)(oldPluginState.availableBlockTypesInDropdown) ? (0, $eWNtX.checkFormattingIsPresent)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($eef5dca48c9b3cf7$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $eef5dca48c9b3cf7$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                const headingLevel = (0, $eTqxy.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel > -1 && event.altKey) {
                    if ((0, $gE8f9.browser).mac && event.metaKey) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!(0, $gE8f9.browser).mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};

});
parcelRegister("eTqxy", function(module, exports) {

$parcel$export(module.exports, "HEADING_KEYS", () => $3efc03d9dac5e81b$export$442e847723cf0569);
const $3efc03d9dac5e81b$var$KEY_0 = 48;
const $3efc03d9dac5e81b$var$KEY_1 = 49;
const $3efc03d9dac5e81b$var$KEY_2 = 50;
const $3efc03d9dac5e81b$var$KEY_3 = 51;
const $3efc03d9dac5e81b$var$KEY_4 = 52;
const $3efc03d9dac5e81b$var$KEY_5 = 53;
const $3efc03d9dac5e81b$var$KEY_6 = 54;
const $3efc03d9dac5e81b$export$442e847723cf0569 = [
    $3efc03d9dac5e81b$var$KEY_0,
    $3efc03d9dac5e81b$var$KEY_1,
    $3efc03d9dac5e81b$var$KEY_2,
    $3efc03d9dac5e81b$var$KEY_3,
    $3efc03d9dac5e81b$var$KEY_4,
    $3efc03d9dac5e81b$var$KEY_5,
    $3efc03d9dac5e81b$var$KEY_6
];

});


parcelRegister("6AEe7", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarComponent", () => $0c9730fe31036e72$export$b15abb95157a91c7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $gmhCD = parcelRequire("gmhCD");

var $6Gwcf = parcelRequire("6Gwcf");
const $0c9730fe31036e72$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
const $0c9730fe31036e72$var$useFloatingToolbarComponentPluginState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const currentBlockType = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const blockTypesDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.blockTypesDisabled');
    const availableBlockTypes = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypes');
    const availableBlockTypesInDropdown = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const formattingIsPresent = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.formattingIsPresent');
    return {
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent
    };
}, (api)=>{
    const { blockTypeState: blockTypeState } = (0, $awTmI.useSharedPluginState)(api, [
        'blockType'
    ]);
    return {
        currentBlockType: blockTypeState?.currentBlockType,
        blockTypesDisabled: blockTypeState?.blockTypesDisabled,
        availableBlockTypes: blockTypeState?.availableBlockTypes,
        availableBlockTypesInDropdown: blockTypeState?.availableBlockTypesInDropdown,
        formattingIsPresent: blockTypeState?.formattingIsPresent
    };
});
function $0c9730fe31036e72$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = $0c9730fe31036e72$var$useFloatingToolbarComponentPluginState(api);
    const boundSetBlockType = (0, $5uXOq.useCallback)((name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const wrapBlockQuote = (0, $5uXOq.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $5uXOq.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $gkwXh.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Gwcf.default), {
        isSmall: $0c9730fe31036e72$var$FloatingToolbarSettings.isSmall,
        isDisabled: $0c9730fe31036e72$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? false : $0c9730fe31036e72$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $0c9730fe31036e72$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("7qATA", function(module, exports) {

$parcel$export(module.exports, "sharedPluginStateHookMigratorFactory", () => $86b7829f189cc565$export$5fd276487301609);

var $jEEXJ = parcelRequire("jEEXJ");

var $gmhCD = parcelRequire("gmhCD");
function $86b7829f189cc565$export$5fd276487301609(newHook, oldHook) {
    return (0, $jEEXJ.conditionalHooksFactory)(()=>(0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', true), newHook, oldHook);
}

});
parcelRegister("jEEXJ", function(module, exports) {

$parcel$export(module.exports, "conditionalHooksFactory", () => $6d9e8048eeca0f8f$export$691e93bad45e6f07);
/**
 * A factory function to create a conditional hook. The condition must return a boolean value
 * that does not change after initialisation. This function will cache the result of the condition
 * and use it to determine which hook to call. If the condition changes between renders,
 * unexpected behaviour may occur.
 *
 * **This hook should only be used for Feature Gates & Experiments where the value doesn't change.**
 * ```ts
 * // Acceptable use
 * const useMyHook = conditionalHooksFactory(
 *   () => isFeatureEnabled('my-feature'),
 *   useMyNewHook,
 *   useMyOldHook,
 * );
 *
 * // Not acceptable use
 * const useMyHook = conditionalHooksFactory(
 *    () => someVarThatCouldChange === 'my-value',
 *    useMyNewHook,
 *    useMyOldHook,
 * );
 * ```
 *
 * @param condition The condition function that will be used to determine which hook to call.
 * @param newHook The new hook to call if the condition is true.
 * @param oldHook The old hook to call if the condition is false.
 * @returns A migrator hook that will call either the new hook or the old hook based on the condition.
 */ function $6d9e8048eeca0f8f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    // Since we are conditionally rendering hooks, we need to ensure the condition result won't change
    // between renders. We can do this by caching the result of the condition.
    let conditionCache = null;
    return (...args)=>{
        const conditionResult = condition(); // call each time so we can track exposures
        if (conditionCache === null) conditionCache = conditionResult;
        if (conditionCache) return newHook(...args);
        else return oldHook(...args);
    };
}

});


parcelRegister("awTmI", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginState", () => $c96ea81c1b46425f$export$a4c4fd90e2b72baa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $c96ea81c1b46425f$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $c96ea81c1b46425f$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>plugins, []);
}
function $c96ea81c1b46425f$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $c96ea81c1b46425f$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $c96ea81c1b46425f$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $c96ea81c1b46425f$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $5uXOq.useState)($c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $5uXOq.useRef)({});
    const mounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});

parcelRegister("9LY0t", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginStateSelector", () => $3103cc59045a29ce$export$feb16861fe41d066);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $ajpes = parcelRequire("ajpes");

var $lra7E = parcelRequire("lra7E");
function $3103cc59045a29ce$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $5uXOq.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $5uXOq.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $5uXOq.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api?.[pluginName]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $3103cc59045a29ce$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $3103cc59045a29ce$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $5uXOq.useState)(()=>initialState);
    (0, $lra7E.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
}

});
parcelRegister("lra7E", function(module, exports) {

$parcel$export(module.exports, "usePluginStateEffect", () => $8bf04bed6d22b818$export$85f3fdc261c569b3);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $gmhCD = parcelRequire("gmhCD");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $8bf04bed6d22b818$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $8bf04bed6d22b818$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>plugins, []);
}
function $8bf04bed6d22b818$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $8bf04bed6d22b818$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $8bf04bed6d22b818$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $8bf04bed6d22b818$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $5uXOq.useRef)();
    const cleanup = (0, $5uXOq.useRef)();
    const latestEffect = (0, $5uXOq.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled || (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', false)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (options.disabled || (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', true)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $8bf04bed6d22b818$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}

});


parcelRegister("6Gwcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $407f1dfb51124f0f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $e9qoo = parcelRequire("e9qoo");

var $eDTMN = parcelRequire("eDTMN");

var $ejItq = parcelRequire("ejItq");

var $2rNvX = parcelRequire("2rNvX");

var $iHYdz = parcelRequire("iHYdz");

var $5Hpaz = parcelRequire("5Hpaz");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $8Zdb4 = parcelRequire("8Zdb4");

var $8QX3X = parcelRequire("8QX3X");

var $ijWlC = parcelRequire("ijWlC");

var $k8Zwf = parcelRequire("k8Zwf");

var $fMJd2 = parcelRequire("fMJd2");
const $407f1dfb51124f0f$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $407f1dfb51124f0f$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        const observer = new (0, $8Zdb4.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType?.name).map((blockType)=>blockType.title);
        const defaultIcon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
            label: ""
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8Zwf.Text), null);
        const currentIcon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? currentBlockType?.icon : currentBlockType?.LEGACY_icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ijWlC.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType?.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                css: (0, $gmhCD.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $ejItq.wrapperStyle),
                    (0, $fMJd2.floatingToolbarWrapperStyle)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $ejItq.wrapperStyle)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2rNvX.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $iHYdz.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, (0, $VSDnB.fg)('platform_editor_comments_toolbar_responsiveness') ? // extra wrapper added to prevent flex shrinking of the button
            /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $407f1dfb51124f0f$var$buttonWrapperStyles
            }, button) : button), !api?.primaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $ejItq.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ejItq.wrapperStyle)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ijWlC.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType?.name,
            blockTypeIcon: (0, $VSDnB.fg)('platform_editor_controls_patch_10') ? currentIcon || defaultIcon : undefined
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $ejItq.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        }, this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        }, this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        }, this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const keyMap = (0, $e9qoo.findKeymapByDescription)(blockType.title.defaultMessage);
                const icon = (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? blockType?.icon : blockType.LEGACY_icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: (0, $fMJd2.blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $e9qoo.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: [
                            (0, $fMJd2.keyboardShortcut),
                            isActive && (0, $fMJd2.keyboardShortcutSelect)
                        ]
                    }, (0, $e9qoo.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("p", null, (0, $eDTMN.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting), (0, $eDTMN.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        css: [
                            (0, $fMJd2.keyboardShortcut)
                        ]
                    }, (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $8QX3X.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.currentBlockType?.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
var $407f1dfb51124f0f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($407f1dfb51124f0f$var$ToolbarBlockType);

});
parcelRegister("ejItq", function(module, exports) {

$parcel$export(module.exports, "buttonGroupStyleBeforeVisualRefresh", () => $2e37247ce5cb1937$export$7638a34f4ed2b514);
$parcel$export(module.exports, "buttonGroupStyle", () => $2e37247ce5cb1937$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $2e37247ce5cb1937$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $2e37247ce5cb1937$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStyles", () => $2e37247ce5cb1937$export$147e2cce6f264c9b);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $2e37247ce5cb1937$export$f2c6a721c78d3c4a);
$parcel$export(module.exports, "disableBlueBorderStyles", () => $2e37247ce5cb1937$export$cd86615b96818354);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $2e37247ce5cb1937$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e37247ce5cb1937$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $2e37247ce5cb1937$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $2e37247ce5cb1937$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $2e37247ce5cb1937$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};

});

parcelRegister("2rNvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc30f060f41991fa$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $bc30f060f41991fa$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $bc30f060f41991fa$export$9e0cd5a62a7d99cf);
/* eslint-disable @repo/internal/react/no-class-components */ /**
                                                               * @jsxRuntime classic
                                                               * @jsx jsx
                                                               */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $1aogK = parcelRequire("1aogK");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $gKjGW = parcelRequire("gKjGW");

var $kdDpx = parcelRequire("kdDpx");

var $jdyxs = parcelRequire("jdyxs");

var $iraaj = parcelRequire("iraaj");

var $4N9VB = parcelRequire("4N9VB");

var $2WNBA = parcelRequire("2WNBA");

var $8v0FX = parcelRequire("8v0FX");
function $bc30f060f41991fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bc30f060f41991fa$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $bc30f060f41991fa$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
    outline: 'none'
});
const $bc30f060f41991fa$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, transparent);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $bc30f060f41991fa$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $jdyxs.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iraaj.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $bc30f060f41991fa$var$DropListWithOutsideListeners = (0, $jdyxs.default)($bc30f060f41991fa$var$DropListWithOutsideClickTargetRef);
class $bc30f060f41991fa$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $8v0FX.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $iHYdz.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: (e)=>{
                if (!allowEnterDefaultBehavior) e.preventDefault();
                e.stopPropagation();
            },
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $bc30f060f41991fa$var$wrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        }, this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
    }
}
const $bc30f060f41991fa$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $bc30f060f41991fa$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $gKjGW.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: ()=>$bc30f060f41991fa$var$buttonStyles(item.isActive, submenuActive),
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1aogK.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: ()=>onItemActivated && onItemActivated({
                item: item
            }),
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        component: $bc30f060f41991fa$var$DropdownMenuItemCustomComponent,
        onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                item: item
            }),
        onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                item: item
            }),
        "aria-expanded": item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $bc30f060f41991fa$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $5uXOq.useContext)((0, $kdDpx.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($bc30f060f41991fa$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        },
        ...props
    });
});

});
parcelRegister("gKjGW", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $493935277ba8bc7b$export$94c0f60c32e7bd13);
const $493935277ba8bc7b$export$15eb942addb87cf6 = 'pm-dropdown';
const $493935277ba8bc7b$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$493935277ba8bc7b$export$15eb942addb87cf6}-submenu`
};

});

parcelRegister("kdDpx", function(module, exports) {

$parcel$export(module.exports, "KeyDownHandlerContext", () => $78f86f420f59a10b$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $78f86f420f59a10b$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $3fEIr = parcelRequire("3fEIr");

var $kXnoC = parcelRequire("kXnoC");

var $3AEXe = parcelRequire("3AEXe");

function $78f86f420f59a10b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78f86f420f59a10b$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $78f86f420f59a10b$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $78f86f420f59a10b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const selectedItemIndex = (0, $5uXOq.useRef)(0);
    const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRight = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowLeft = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTab = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowRightMemoized = (0, $5uXOq.useCallback)(()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $5uXOq.useCallback)(()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $5uXOq.useCallback)(()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContextRaw = {
        handleArrowLeft: handleArrowLeft,
        handleArrowRight: handleArrowRight,
        handleTab: handleTab
    };
    const submenuKeydownHandleContextMemoized = (0, $5uXOq.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    const submenuKeydownHandleContext = (0, $VSDnB.fg)('platform_editor_toolbar_rerender_optimization') ? submenuKeydownHandleContextMemoized : submenuKeydownHandleContextRaw;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $3fEIr.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $3AEXe.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: editorAppearance === 'comment' && $78f86f420f59a10b$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $kXnoC.messages).toolbarLabel),
        "aria-controls": (0, $c7748e834fcd4f22$export$b16ce0826b76e795)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($78f86f420f59a10b$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $78f86f420f59a10b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $78f86f420f59a10b$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $78f86f420f59a10b$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("3fEIr", function(module, exports) {

$parcel$export(module.exports, "GRID_SIZE", () => $e09bdf0cd98bec8e$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $e09bdf0cd98bec8e$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $e09bdf0cd98bec8e$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $e09bdf0cd98bec8e$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $e09bdf0cd98bec8e$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $e09bdf0cd98bec8e$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $e09bdf0cd98bec8e$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $e09bdf0cd98bec8e$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $e09bdf0cd98bec8e$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $e09bdf0cd98bec8e$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $e09bdf0cd98bec8e$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $e09bdf0cd98bec8e$export$6ee360fa4b93ee8e);
const $e09bdf0cd98bec8e$export$bc90872e265d166e = 8;
const $e09bdf0cd98bec8e$export$1f1798e92fa75806 = {
    small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 40,
    medium: $e09bdf0cd98bec8e$export$bc90872e265d166e * 75,
    large: $e09bdf0cd98bec8e$export$bc90872e265d166e * 128
};
const $e09bdf0cd98bec8e$export$69bde1b03e8b5224 = {
    small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 50,
    medium: $e09bdf0cd98bec8e$export$1f1798e92fa75806.medium,
    large: $e09bdf0cd98bec8e$export$1f1798e92fa75806.large
};
const $e09bdf0cd98bec8e$export$780035d9fe48eb32 = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 25}px`;
const $e09bdf0cd98bec8e$export$95b62a1773aa5ebe = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 6}px`;
const $e09bdf0cd98bec8e$export$387950d54d372827 = '12px';
const $e09bdf0cd98bec8e$export$51a2d6b2c009fbfd = '54px';
const $e09bdf0cd98bec8e$export$df8bcac60101d466 = '20px';
const $e09bdf0cd98bec8e$export$9a6bb2acef5e644a = 15;
const $e09bdf0cd98bec8e$export$3b8e93b2c0f295b0 = 2;
const $e09bdf0cd98bec8e$export$6d221f35db1b75aa = 60;
const $e09bdf0cd98bec8e$export$ab53450bc5fd5b7d = 10;
const $e09bdf0cd98bec8e$export$6ee360fa4b93ee8e = 'editor-element-browser';

});

const $c7748e834fcd4f22$export$b16ce0826b76e795 = 'ak-editor-textarea';


parcelRegister("jdyxs", function(module, exports) {

$parcel$export(module.exports, "OutsideClickTargetRefContext", () => $4fed9d772c4caad7$export$798d66d2e25c3c95);
$parcel$export(module.exports, "default", () => $4fed9d772c4caad7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");

var $12Kqg = parcelRequire("12Kqg");
const $4fed9d772c4caad7$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(()=>Object);
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4fed9d772c4caad7$var$WithOutsideClick extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .addEventListener('keydown', this.handleKeydown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .removeEventListener('keydown', this.handleKeydown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        }, this.handleKeydown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4fed9d772c4caad7$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $4fed9d772c4caad7$export$2e2bcd8739ae039(Component) {
    return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, captureClick: captureClick, ...props })=>{
        const isActiveProp = $4fed9d772c4caad7$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $5uXOq.useState)(false);
        const outsideClickTargetRef = (0, $5uXOq.useRef)(null);
        const setOutsideClickTargetRef = (0, $5uXOq.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4fed9d772c4caad7$export$798d66d2e25c3c95.Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($4fed9d772c4caad7$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});
parcelRegister("12Kqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be525c6bf2dfa69$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $5be525c6bf2dfa69$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
var $5be525c6bf2dfa69$export$2e2bcd8739ae039 = $5be525c6bf2dfa69$var$ReactEditorViewContext;

});


parcelRegister("iraaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0608b252bfbe5a2a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gB4mS = parcelRequire("gB4mS");

var $994MI = parcelRequire("994MI");

var $cb25w = parcelRequire("cb25w");

var $cUHb0 = parcelRequire("cUHb0");
const $0608b252bfbe5a2a$var$packageName = "platform-pkg";
const $0608b252bfbe5a2a$var$packageVersion = "0.0.0-use.local";
const $0608b252bfbe5a2a$var$halfFocusRing = 1;
const $0608b252bfbe5a2a$var$dropOffset = '0, 8';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $0608b252bfbe5a2a$var$DropList extends (0, $5uXOq.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.wrapperStyles,
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cUHb0.default), {
            content: layerContent,
            offset: $0608b252bfbe5a2a$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: this.triggerStyles,
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args), this.wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        }), this.triggerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        }), /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                color: "var(--ds-text-subtle, #44546F)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-border-radius, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        }, /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        }, this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        }, this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        }, this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $0608b252bfbe5a2a$var$halfFocusRing * 2}px`;
        }, this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        }, this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        }, this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        }, this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        }, this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
var $0608b252bfbe5a2a$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'droplist',
    packageName: $0608b252bfbe5a2a$var$packageName,
    packageVersion: $0608b252bfbe5a2a$var$packageVersion
})((0, $cb25w.default)({
    onOpenChange: $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $0608b252bfbe5a2a$var$packageName,
            packageVersion: $0608b252bfbe5a2a$var$packageVersion
        }
    })
})($0608b252bfbe5a2a$var$DropList));

});
parcelRegister("cUHb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde32d597d72978f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fgNYa = parcelRequire("fgNYa");

var $7nRxN = parcelRequire("7nRxN");

var $a488G = parcelRequire("a488G");
const $bde32d597d72978f$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $bde32d597d72978f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // working with extract-react-types
        this.defaultProps = {
            boundariesElement: 'viewport',
            children: null,
            content: null,
            offset: '0, 0',
            position: 'right middle',
            zIndex: 400,
            lockScroll: false,
            isAlwaysFixed: false,
            onPositioned: ()=>{}
        };
    }
    constructor(props){
        super(props), this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $bde32d597d72978f$var$defaultState;
        this.extractStyles = (0, $7nRxN.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
	 * the bottom of the popper not being viewable.
	 * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
	 */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $a488G.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $fgNYa.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
}

});
parcelRegister("fgNYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1df1c8342df5413$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $b1df1c8342df5413$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $b1df1c8342df5413$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $b1df1c8342df5413$var$timeoutDuration = 0;
for(var $b1df1c8342df5413$var$i = 0; $b1df1c8342df5413$var$i < $b1df1c8342df5413$var$longerTimeoutBrowsers.length; $b1df1c8342df5413$var$i += 1)if ($b1df1c8342df5413$var$isBrowser && navigator.userAgent.indexOf($b1df1c8342df5413$var$longerTimeoutBrowsers[$b1df1c8342df5413$var$i]) >= 0) {
    $b1df1c8342df5413$var$timeoutDuration = 1;
    break;
}
function $b1df1c8342df5413$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $b1df1c8342df5413$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $b1df1c8342df5413$var$timeoutDuration);
        }
    };
}
var $b1df1c8342df5413$var$supportsMicroTasks = $b1df1c8342df5413$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $b1df1c8342df5413$var$debounce = $b1df1c8342df5413$var$supportsMicroTasks ? $b1df1c8342df5413$var$microtaskDebounce : $b1df1c8342df5413$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $b1df1c8342df5413$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $b1df1c8342df5413$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $b1df1c8342df5413$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $b1df1c8342df5413$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $b1df1c8342df5413$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(element));
}
var $b1df1c8342df5413$var$isIE11 = $b1df1c8342df5413$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $b1df1c8342df5413$var$isIE10 = $b1df1c8342df5413$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $b1df1c8342df5413$var$isIE(version) {
    if (version === 11) return $b1df1c8342df5413$var$isIE11;
    if (version === 10) return $b1df1c8342df5413$var$isIE10;
    return $b1df1c8342df5413$var$isIE11 || $b1df1c8342df5413$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $b1df1c8342df5413$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $b1df1c8342df5413$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $b1df1c8342df5413$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $b1df1c8342df5413$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $b1df1c8342df5413$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $b1df1c8342df5413$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $b1df1c8342df5413$var$getRoot(node) {
    if (node.parentNode !== null) return $b1df1c8342df5413$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $b1df1c8342df5413$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($b1df1c8342df5413$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $b1df1c8342df5413$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $b1df1c8342df5413$var$getRoot(element1);
    if (element1root.host) return $b1df1c8342df5413$var$findCommonOffsetParent(element1root.host, element2);
    else return $b1df1c8342df5413$var$findCommonOffsetParent(element1, $b1df1c8342df5413$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $b1df1c8342df5413$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $b1df1c8342df5413$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
    var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $b1df1c8342df5413$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $b1df1c8342df5413$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $b1df1c8342df5413$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $b1df1c8342df5413$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $b1df1c8342df5413$var$isIE(10) && getComputedStyle(html);
    return {
        height: $b1df1c8342df5413$var$getSize('Height', body, html, computedStyle),
        width: $b1df1c8342df5413$var$getSize('Width', body, html, computedStyle)
    };
}
var $b1df1c8342df5413$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $b1df1c8342df5413$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $b1df1c8342df5413$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $b1df1c8342df5413$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $b1df1c8342df5413$var$getClientRect(offsets) {
    return $b1df1c8342df5413$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $b1df1c8342df5413$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($b1df1c8342df5413$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
            var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $b1df1c8342df5413$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $b1df1c8342df5413$var$getStyleComputedProperty(element);
        horizScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'x');
        vertScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $b1df1c8342df5413$var$getClientRect(result);
}
function $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $b1df1c8342df5413$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $b1df1c8342df5413$var$getBoundingClientRect(children);
    var parentRect = $b1df1c8342df5413$var$getBoundingClientRect(parent);
    var scrollParent = $b1df1c8342df5413$var$getScrollParent(children);
    var styles = $b1df1c8342df5413$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $b1df1c8342df5413$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $b1df1c8342df5413$var$includeScroll(offsets, parent);
    return offsets;
}
function $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $b1df1c8342df5413$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $b1df1c8342df5413$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($b1df1c8342df5413$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $b1df1c8342df5413$var$getParentNode(element);
    if (!parentNode) return false;
    return $b1df1c8342df5413$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $b1df1c8342df5413$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $b1df1c8342df5413$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $b1df1c8342df5413$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$b1df1c8342df5413$var$isFixed(offsetParent)) {
            var _getWindowSizes = $b1df1c8342df5413$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $b1df1c8342df5413$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $b1df1c8342df5413$var$_extends({
            key: key
        }, rects[key], {
            area: $b1df1c8342df5413$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
    return $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $b1df1c8342df5413$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $b1df1c8342df5413$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $b1df1c8342df5413$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $b1df1c8342df5413$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$b1df1c8342df5413$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $b1df1c8342df5413$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $b1df1c8342df5413$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $b1df1c8342df5413$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $b1df1c8342df5413$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $b1df1c8342df5413$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $b1df1c8342df5413$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $b1df1c8342df5413$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $b1df1c8342df5413$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $b1df1c8342df5413$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $b1df1c8342df5413$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $b1df1c8342df5413$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $b1df1c8342df5413$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $b1df1c8342df5413$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($b1df1c8342df5413$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$b1df1c8342df5413$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $b1df1c8342df5413$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $b1df1c8342df5413$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $b1df1c8342df5413$var$attachToScrollParents($b1df1c8342df5413$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $b1df1c8342df5413$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $b1df1c8342df5413$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $b1df1c8342df5413$var$getScrollParent(reference);
    $b1df1c8342df5413$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $b1df1c8342df5413$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $b1df1c8342df5413$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $b1df1c8342df5413$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $b1df1c8342df5413$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $b1df1c8342df5413$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $b1df1c8342df5413$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $b1df1c8342df5413$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $b1df1c8342df5413$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $b1df1c8342df5413$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $b1df1c8342df5413$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $b1df1c8342df5413$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $b1df1c8342df5413$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $b1df1c8342df5413$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $b1df1c8342df5413$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $b1df1c8342df5413$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $b1df1c8342df5413$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $b1df1c8342df5413$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $b1df1c8342df5413$var$isFirefox = $b1df1c8342df5413$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $b1df1c8342df5413$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $b1df1c8342df5413$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$b1df1c8342df5413$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $b1df1c8342df5413$var$_extends({}, attributes, data.attributes);
    data.styles = $b1df1c8342df5413$var$_extends({}, styles, data.styles);
    data.arrowStyles = $b1df1c8342df5413$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $b1df1c8342df5413$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $b1df1c8342df5413$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $b1df1c8342df5413$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $b1df1c8342df5413$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $b1df1c8342df5413$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $b1df1c8342df5413$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $b1df1c8342df5413$var$validPlacements = $b1df1c8342df5413$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $b1df1c8342df5413$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $b1df1c8342df5413$var$validPlacements.indexOf(placement);
    var arr = $b1df1c8342df5413$var$validPlacements.slice(index + 1).concat($b1df1c8342df5413$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $b1df1c8342df5413$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($b1df1c8342df5413$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $b1df1c8342df5413$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $b1df1c8342df5413$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $b1df1c8342df5413$var$clockwise(placement);
            break;
        case $b1df1c8342df5413$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $b1df1c8342df5413$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $b1df1c8342df5413$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $b1df1c8342df5413$var$_extends({}, data.offsets.popper, $b1df1c8342df5413$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $b1df1c8342df5413$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $b1df1c8342df5413$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $b1df1c8342df5413$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($b1df1c8342df5413$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($b1df1c8342df5413$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($b1df1c8342df5413$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $b1df1c8342df5413$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $b1df1c8342df5413$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $b1df1c8342df5413$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $b1df1c8342df5413$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $b1df1c8342df5413$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $b1df1c8342df5413$var$defineProperty({}, side, reference[side]),
            end: $b1df1c8342df5413$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $b1df1c8342df5413$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$hide(data) {
    if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $b1df1c8342df5413$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $b1df1c8342df5413$var$getOppositePlacement(placement);
    data.offsets.popper = $b1df1c8342df5413$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $b1df1c8342df5413$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $b1df1c8342df5413$var$applyStyle,
        /** @prop {Function} */ onLoad: $b1df1c8342df5413$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $b1df1c8342df5413$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $b1df1c8342df5413$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $b1df1c8342df5413$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $b1df1c8342df5413$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $b1df1c8342df5413$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $b1df1c8342df5413$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $b1df1c8342df5413$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $b1df1c8342df5413$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $b1df1c8342df5413$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $b1df1c8342df5413$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $b1df1c8342df5413$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $b1df1c8342df5413$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $b1df1c8342df5413$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $b1df1c8342df5413$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$b1df1c8342df5413$var$Popper.placements = $b1df1c8342df5413$var$placements;
$b1df1c8342df5413$var$Popper.Defaults = $b1df1c8342df5413$var$Defaults;
var $b1df1c8342df5413$export$2e2bcd8739ae039 = $b1df1c8342df5413$var$Popper;

});

parcelRegister("a488G", function(module, exports) {

$parcel$export(module.exports, "positionPropToPopperPosition", () => $5ea83f05db9130f3$export$9e6a7c92c66a7cdd);
const $5ea83f05db9130f3$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
const $5ea83f05db9130f3$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};
function $5ea83f05db9130f3$var$positionToPopper(position) {
    return position && $5ea83f05db9130f3$var$positionMap[position] ? $5ea83f05db9130f3$var$positionMap[position].position : null;
}
function $5ea83f05db9130f3$export$9e6a7c92c66a7cdd(position) {
    return $5ea83f05db9130f3$var$positionToPopper(position) || $5ea83f05db9130f3$var$positionMap[$5ea83f05db9130f3$export$f6c90e9517ee2ce0.default].position;
}

});



parcelRegister("4N9VB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f05c89a5b988c61$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");

var $7nRxN = parcelRequire("7nRxN");

var $7nsd3 = parcelRequire("7nsd3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $f3dKD = parcelRequire("f3dKD");
class $6f05c89a5b988c61$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $f3dKD.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $f3dKD.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $f3dKD.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $7nsd3.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $f3dKD.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.scrollParentElement = (0, $f3dKD.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
		 * https://a11y.atlassian.net/browse/A11Y-9995
		 * We set aria-label to undefined if it's null, no more 'Popup' fallback.
		 * It is meaningless for screen readers and causes confusion.
		 */ const ariaLabel = (0, $VSDnB.fg)('editor_a11y_aria_label_removal_popup') ? this.props.ariaLabel ?? undefined : this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $iHYdz.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $7nsd3.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args), this.rafIds = new Set(), this.state = {
            validPosition: true
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.placement = [
            '',
            ''
        ], this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        }, this.scheduledUpdatePosition = (0, $7nRxN.default)((props)=>{
            this.updatePosition(this.props);
        }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined, /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $7nRxN.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("f3dKD", function(module, exports) {

$parcel$export(module.exports, "calculatePlacement", () => $6f8faaad8d1a72fc$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $6f8faaad8d1a72fc$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $6f8faaad8d1a72fc$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $6f8faaad8d1a72fc$export$ab306cb155a0ca1b);
function $6f8faaad8d1a72fc$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $6f8faaad8d1a72fc$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $6f8faaad8d1a72fc$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $6f8faaad8d1a72fc$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $6f8faaad8d1a72fc$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $6f8faaad8d1a72fc$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
    const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $6f8faaad8d1a72fc$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
    const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $6f8faaad8d1a72fc$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $6f8faaad8d1a72fc$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $6f8faaad8d1a72fc$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position
    });
    const horizontalPosition = $6f8faaad8d1a72fc$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $6f8faaad8d1a72fc$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $6f8faaad8d1a72fc$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("2WNBA", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $4c1bb7d1103deeef$export$ee87cc4950b6d6fe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $12Kqg = parcelRequire("12Kqg");

var $7DsHK = parcelRequire("7DsHK");

var $1K0nW = parcelRequire("1K0nW");

var $8v0FX = parcelRequire("8v0FX");
const $4c1bb7d1103deeef$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $8v0FX.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7DsHK.ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12Kqg.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1K0nW.MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
};

});
parcelRegister("7DsHK", function(module, exports) {

$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $21327cd68207e48b$export$e17115e9cf808589);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $21327cd68207e48b$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const currentSelectedColumnIndex = (0, $5uXOq.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $5uXOq.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $5uXOq.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $21327cd68207e48b$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $21327cd68207e48b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("1K0nW", function(module, exports) {

$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $833d4b83be982376$export$e12b037790bf03e3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $833d4b83be982376$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $833d4b83be982376$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $5uXOq.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $5uXOq.useState)(element);
    const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $5uXOq.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            const focusIndex = incrementIndex(list);
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (disableArrowKeyNavigation) return;
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $833d4b83be982376$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("8v0FX", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationType", () => $c55b0232d5331d8e$export$26c2c5e2f61f437a);
var $c55b0232d5331d8e$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});

});



parcelRegister("ijWlC", function(module, exports) {

$parcel$export(module.exports, "BlockTypeButton", () => $7a2ae92542401a67$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $eDTMN = parcelRequire("eDTMN");

var $cr1aY = parcelRequire("cr1aY");
var $ejItq = parcelRequire("ejItq");

var $1jI4k = parcelRequire("1jI4k");

var $5Hpaz = parcelRequire("5Hpaz");

var $3ti6y = parcelRequire("3ti6y");

var $c8Oei = parcelRequire("c8Oei");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $8QX3X = parcelRequire("8QX3X");

var $fMJd2 = parcelRequire("fMJd2");
const $7a2ae92542401a67$var$buttonContentStyle = (0, $8CUq3.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $7a2ae92542401a67$var$buttonContentReducedSpacingStyle = (0, $8CUq3.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $7a2ae92542401a67$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $eDTMN.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $eDTMN.toolbarMessages).textStylesTooltip);
    const icon = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3ti6y)))
    });
    const chevronIconSpacing = props.isSmall && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? 'spacious' : 'none';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $ejItq.wrapperStyle),
                props.isSmall && (0, $fMJd2.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.isSmall && icon, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $cr1aY.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px"
        }))))
    }, !props.isSmall && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: [
            $7a2ae92542401a67$var$buttonContentStyle,
            props.isReducedSpacing && $7a2ae92542401a67$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), props.title || (0, $8QX3X.NORMAL_TEXT).title)));
};

});
parcelRegister("cr1aY", function(module, exports) {

$parcel$export(module.exports, "expandIconContainerStyle", () => $93aa9de9747de328$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $93aa9de9747de328$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $93aa9de9747de328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93aa9de9747de328$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $93aa9de9747de328$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $93aa9de9747de328$var$prefix = 'ak-editor-expand';
const $93aa9de9747de328$export$6ba39aa0ead007b7 = {
    prefix: $93aa9de9747de328$var$prefix,
    expanded: `${$93aa9de9747de328$var$prefix}__expanded`,
    titleContainer: `${$93aa9de9747de328$var$prefix}__title-container`,
    inputContainer: `${$93aa9de9747de328$var$prefix}__input-container`,
    iconContainer: `${$93aa9de9747de328$var$prefix}__icon-container`,
    icon: `${$93aa9de9747de328$var$prefix}__icon`,
    titleInput: `${$93aa9de9747de328$var$prefix}__title-input`,
    content: `${$93aa9de9747de328$var$prefix}__content`,
    type: (type)=>`${$93aa9de9747de328$var$prefix}__type-${type}`
};

});

parcelRegister("1jI4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6db8a02783a4b1f$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWAZk = parcelRequire("dWAZk");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $gfv5d = parcelRequire("gfv5d");
function $f6db8a02783a4b1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6db8a02783a4b1f$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $f6db8a02783a4b1f$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $gkwXh.ACTION).CLICKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            })).fire((0, $dWAZk.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gfv5d.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f6db8a02783a4b1f$var$buttonWrapper
    }, button));
});
var $f6db8a02783a4b1f$export$2e2bcd8739ae039 = $f6db8a02783a4b1f$var$ToolbarButton;

});
parcelRegister("gfv5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e74c7dea01c8c4$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $15e74c7dea01c8c4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            alignItems: 'center'
        }
    });
});

});


parcelRegister("3ti6y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28721fc49070f49d$var$_react = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $28721fc49070f49d$var$_textStyle = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("kauzw")));
function $28721fc49070f49d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28721fc49070f49d$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $28721fc49070f49d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props, {
        newIcon: $28721fc49070f49d$var$_textStyle.default
    }));
$28721fc49070f49d$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $28721fc49070f49d$var$_default = module.exports.default = $28721fc49070f49d$var$EditorTextStyleIcon;

});
parcelRegister("kauzw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79f720bc74e9099bd9cc2a24f95932ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eaec74c566e8a5e8$var$_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>/*#__PURE__*/ $eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;

});


parcelRegister("fMJd2", function(module, exports) {

$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $e41ad3cbd8b8f72e$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "wrapperSmallStyle", () => $e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a);
$parcel$export(module.exports, "floatingToolbarWrapperStyle", () => $e41ad3cbd8b8f72e$export$a61e5f64ad28e14a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kRRtM = parcelRequire("kRRtM");
var $idytF = parcelRequire("idytF");

var $24JcV = parcelRequire("24JcV");

function $e41ad3cbd8b8f72e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e41ad3cbd8b8f72e$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $kRRtM.blockquoteSharedStyles) : (0, $idytF.headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $f8Sb3.css)((0, $24JcV.shortcutStyle), {
    marginLeft: "var(--ds-space-200, 16px)",
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
});
const $e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
});
const $e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $e41ad3cbd8b8f72e$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $e41ad3cbd8b8f72e$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};

});
parcelRegister("kRRtM", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

});

parcelRegister("idytF", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $152b62c033bbf99a$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            font: (0, $04VvC.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $04VvC.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $04VvC.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $04VvC.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $04VvC.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $04VvC.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $04VvC.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $f8Sb3.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
    });
};

});

parcelRegister("24JcV", function(module, exports) {

$parcel$export(module.exports, "shortcutStyle", () => $c5630718e5a09f0f$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $c5630718e5a09f0f$export$297e5814a2c821bb = /*#__PURE__*/ (0, $f8Sb3.css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-border-radius, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $iHYdz.akEditorMobileMaxWidth), "px){display:none;}");

});





parcelRegister("62ifj", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $f4af8af866ff3914$export$94516d5cccf573e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $6Gwcf = parcelRequire("6Gwcf");
const $f4af8af866ff3914$var$usePrimaryToolbarComponentPluginState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const currentBlockType = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const blockTypesDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.blockTypesDisabled');
    const availableBlockTypes = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypes');
    const availableBlockTypesInDropdown = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const formattingIsPresent = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.formattingIsPresent');
    return {
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent
    };
}, (api)=>{
    const { blockTypeState: blockTypeState } = (0, $awTmI.useSharedPluginState)(api, [
        'blockType'
    ]);
    return {
        currentBlockType: blockTypeState?.currentBlockType,
        blockTypesDisabled: blockTypeState?.blockTypesDisabled,
        availableBlockTypes: blockTypeState?.availableBlockTypes,
        availableBlockTypesInDropdown: blockTypeState?.availableBlockTypesInDropdown,
        formattingIsPresent: blockTypeState?.formattingIsPresent
    };
});
function $f4af8af866ff3914$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = $f4af8af866ff3914$var$usePrimaryToolbarComponentPluginState(api);
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $gkwXh.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $gkwXh.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $gkwXh.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Gwcf.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});



parcelRegister("kjU5q", function(module, exports) {

$parcel$export(module.exports, "ComposableEditor", () => $95f392e3544e55e0$export$36a7c46ebbddbc5d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7rHtO = parcelRequire("7rHtO");

var $1QYAr = parcelRequire("1QYAr");
function $95f392e3544e55e0$export$36a7c46ebbddbc5d(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $5uXOq.useMemo)(()=>(0, $7rHtO.default)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QYAr.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("7rHtO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8b0891f98bd31d$export$2e2bcd8739ae039);

var $6ssPr = parcelRequire("6ssPr");

var $9YhuC = parcelRequire("9YhuC");

var $kuVsL = parcelRequire("kuVsL");
function $4e8b0891f98bd31d$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
            return 0, $kuVsL.FullPageEditor;
        case 'chromeless':
            return 0, $6ssPr.default;
        case 'comment':
            return 0, $9YhuC.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("6ssPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f2e2c18fdb60a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");


var $gmmd2 = parcelRequire("gmmd2");

var $gmhCD = parcelRequire("gmhCD");

var $jZLtJ = parcelRequire("jZLtJ");

var $eq0pk = parcelRequire("eq0pk");

var $iK9VQ = parcelRequire("iK9VQ");

var $7s5ol = parcelRequire("7s5ol");
const $74f2e2c18fdb60a5$var$chromelessEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)("line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4038285048829feb$export$b2380b18b089518f), "max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}");
const $74f2e2c18fdb60a5$export$fceb9665be86d56e = (0, $jZLtJ.createEditorContentStyle)();
$74f2e2c18fdb60a5$export$fceb9665be86d56e.displayName = 'ContentArea';
const $74f2e2c18fdb60a5$var$EditorContainer = (0, $gmmd2.componentWithCondition)(()=>(0, $gmhCD.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $eq0pk.default), $74f2e2c18fdb60a5$export$fceb9665be86d56e);
const $74f2e2c18fdb60a5$var$useEditorViewModePluginState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    return editorViewModeState?.mode;
}, (pluginInjectionApi)=>{
    return (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
});
class $74f2e2c18fdb60a5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'ChromelessEditorAppearance';
    }
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($74f2e2c18fdb60a5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args), this.appearance = 'chromeless', this.containerElement = null, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = $74f2e2c18fdb60a5$var$useEditorViewModePluginState(this.props.editorAPI);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7s5ol.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $74f2e2c18fdb60a5$var$chromelessEditorStyles,
                    maxHeight && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $f8Sb3.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        maxHeight: `${maxHeight}px`
                    }),
                    /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $f8Sb3.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        minHeight: `${minHeight}px`
                    })
                ],
                "data-testid": "chromeless-editor",
                ref: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($74f2e2c18fdb60a5$var$EditorContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
const $74f2e2c18fdb60a5$var$useMaxContentSizePluginState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { maxContentSizeState: maxContentSizeState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize'
    ]);
    return {
        maxContentSizeState: maxContentSizeState
    };
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        }
    };
});
function $74f2e2c18fdb60a5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const { maxContentSizeState: maxContentSizeState } = $74f2e2c18fdb60a5$var$useMaxContentSizePluginState(editorAPI);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, renderChrome({
        maxContentSize: maxContentSizeState
    }));
}

});
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $4038285048829feb$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;

parcelRegister("gmmd2", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $5b194bd8d7426f4b$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $5b194bd8d7426f4b$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("jZLtJ", function(module, exports) {

$parcel$export(module.exports, "createEditorContentStyle", () => $6a8a55d341510e42$export$91e7c20fa6d6a4b5);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
                                                                                                                                                                                                                                                                                   * @jsxRuntime classic
                                                                                                                                                                                                                                                                                   * @jsx jsx
                                                                                                                                                                                                                                                                                   */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
var $g0wej = parcelRequire("g0wej");

var $gE8f9 = parcelRequire("gE8f9");

var $3I3CN = parcelRequire("3I3CN");

var $kin1Z = parcelRequire("kin1Z");
var $3tpiv = parcelRequire("3tpiv");

var $fRmCC = parcelRequire("fRmCC");

var $aABH4 = parcelRequire("aABH4");

var $eAVGd = parcelRequire("eAVGd");

var $5Lu5s = parcelRequire("5Lu5s");
var $1xqpZ = parcelRequire("1xqpZ");
var $cx4Bg = parcelRequire("cx4Bg");
var $cYeQP = parcelRequire("cYeQP");
var $7Acon = parcelRequire("7Acon");
var $4E5wI = parcelRequire("4E5wI");
var $9zgV3 = parcelRequire("9zgV3");
var $cr1aY = parcelRequire("cr1aY");
var $iJOES = parcelRequire("iJOES");
var $bYYy3 = parcelRequire("bYYy3");
var $5fBxY = parcelRequire("5fBxY");
var $aN7BF = parcelRequire("aN7BF");
var $jlYLw = parcelRequire("jlYLw");
var $jQRg9 = parcelRequire("jQRg9");
var $4jyW9 = parcelRequire("4jyW9");
var $hVv9L = parcelRequire("hVv9L");
var $bv4Ps = parcelRequire("bv4Ps");
var $aSoqv = parcelRequire("aSoqv");
var $kRXi9 = parcelRequire("kRXi9");
var $1bQ0V = parcelRequire("1bQ0V");
var $jRk4M = parcelRequire("jRk4M");
var $ahG4O = parcelRequire("ahG4O");
var $fwxzS = parcelRequire("fwxzS");
parcelRequire("6jI8m");
var $2uCrC = parcelRequire("2uCrC");
parcelRequire("9wwua");
var $RhFwz = parcelRequire("RhFwz");
parcelRequire("3p7sF");
var $6pErt = parcelRequire("6pErt");
parcelRequire("eXo2J");
var $2yMev = parcelRequire("2yMev");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hxoiH = parcelRequire("hxoiH");

var $fz5RS = parcelRequire("fz5RS");

var $9O4yy = parcelRequire("9O4yy");

var $cEh6Q = parcelRequire("cEh6Q");

var $dv67m = parcelRequire("dv67m");

var $cBEjw = parcelRequire("cBEjw");

var $hucfL = parcelRequire("hucfL");

var $l5gcr = parcelRequire("l5gcr");

var $6UEu0 = parcelRequire("6UEu0");

var $b3RpZ = parcelRequire("b3RpZ");

var $aUTD3 = parcelRequire("aUTD3");

var $5L329 = parcelRequire("5L329");
function $6a8a55d341510e42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6a8a55d341510e42$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $aN7BF.linkSharedStyle)(), ";}");
const $6a8a55d341510e42$var$ruleStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $bv4Ps.ruleSharedStyles)(), ";hr{cursor:pointer;padding:var(--ds-space-050, 4px) 0;margin:var(--ds-space-300, 24px) 0;background-clip:content-box;&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{outline:none;background-color:", `var(--ds-border-selected, ${(0, $iHYdz.akEditorSelectedBorderColor)})`, ";}}}");
const $6a8a55d341510e42$var$vanillaMentionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $6a8a55d341510e42$var$vanillaSelectionStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".danger{.editor-mention-primitive{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}}.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive,.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-self,.", (0, $iHYdz.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-restricted{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}");
const $6a8a55d341510e42$var$mentionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, "{&.", (0, $iHYdz.akEditorSelectedNodeClassName), " [data-mention-id]>span{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}}.danger{.", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>span>span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}.", (0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER, ">span>span>span{background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);}}");
const $6a8a55d341510e42$var$listsStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{li{position:relative;>p:not(:first-child){margin:var(--ds-space-050, 4px) 0 0 0;}>style:first-child+p{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $gE8f9.browser).safari ? (0, $cYeQP.codeBlockInListSafariFix) : '', ";}}");
const $6a8a55d341510e42$var$reactEmojiStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_NODE, "{cursor:pointer;&.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, ">span{display:flex;}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}");
const $6a8a55d341510e42$var$emojiStyles = /*#__PURE__*/ (0, $f8Sb3.css)("[data-prosemirror-node-view-type='vanilla']{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;}.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{background:no-repeat transparent;display:inline-block;height:", (0, $kin1Z.defaultEmojiHeight), "px;max-height:", (0, $kin1Z.defaultEmojiHeight), "px;cursor:pointer;vertical-align:middle;user-select:all;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}");
const $6a8a55d341510e42$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $6a8a55d341510e42$var$placeholderOverflowStyles = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $6a8a55d341510e42$var$placeholderWrapStyles = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};
const $6a8a55d341510e42$var$firstBlockNodeStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{>.", (0, $aABH4.PanelSharedCssClassName).prefix, ",>.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $cr1aY.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-of-type{margin-top:0;}}");
const $6a8a55d341510e42$var$firstBlockNodeStylesNew = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{>.", (0, $aABH4.PanelSharedCssClassName).prefix, ",>.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $cr1aY.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-child,>.ProseMirror-widget:first-child+hr{margin-top:0;}}");
const $6a8a55d341510e42$export$42a58e6dfeaffebe = ()=>{
    if ((0, $VSDnB.fg)('platform_editor_element_dnd_nested_fix_patch_6')) return $6a8a55d341510e42$var$firstBlockNodeStylesNew;
    return $6a8a55d341510e42$var$firstBlockNodeStyles;
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice = `1266px`;
// We are going to deprecate this in near future
// Currently, we are migrating content styles in packages/editor/editor-core/src/ui/EditorContentContainer.tsx
// Under editor experiment platform_editor_core_static_emotion
// If you are making changes to this file, please make sure to update in EditorContentContainer.tsx as well
var $6a8a55d341510e42$var$_ref = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};
var $6a8a55d341510e42$var$_ref2 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $6a8a55d341510e42$var$_ref3 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $6a8a55d341510e42$var$_ref4 = {
    name: "u7i8rn",
    styles: ".ProseMirror[contenteditable='false'] .taskItemView-content-wrap{pointer-events:none;opacity:0.7;}"
};
const $6a8a55d341510e42$var$legacyContentStyles = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("--ak-editor--default-gutter-padding:", (0, $iHYdz.akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:", (0, $iHYdz.akEditorGutterPaddingDynamic)(), "px;--ak-editor--default-layout-width:", (0, $iHYdz.akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);}.ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding));}.ProseMirror>div[data-prosemirror-node-block] [data-prosemirror-node-block]{--ak-editor-max-container-width:100%;}@container editor-area (width >= ", $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:", (0, $iHYdz.editorFontSize)({
        theme: props.theme
    }), "px;", (0, $fwxzS.whitespaceSharedStyles), ";", (0, $4jyW9.paragraphSharedStyles)(props.typographyTheme), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $5fBxY.indentationSharedStyles), ";", (0, $aSoqv.shadowSharedStyle), ";", (0, $fz5RS.InlineNodeViewSharedStyles), ";}", (0, $VSDnB.fg)('editor_request_to_edit_task') ? null : $6a8a55d341510e42$var$_ref4, " .ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}", (0, $VSDnB.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? $6a8a55d341510e42$var$_ref3 : null, (0, $gmhCD.editorExperiment)('platform_editor_advanced_code_blocks', true) ? $6a8a55d341510e42$var$_ref2 : null, " .ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}", (0, $2yMev.placeholderTextStyles), " ", $6a8a55d341510e42$export$d3bdc0d52bb6c2c8, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $6a8a55d341510e42$var$placeholderOverflowStyles : null, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_quick_insert_placeholder') ? $6a8a55d341510e42$var$placeholderWrapStyles : null, " ", (0, $cEh6Q.codeBlockStyles)(), " ", (0, $2uCrC.blocktypeStyles)(props.typographyTheme), " ", (0, $7Acon.codeMarkSharedStyles)(), " ", (0, $jRk4M.textColorStyles), " ", (0, $1xqpZ.backgroundColorStyles)(), " ", $6a8a55d341510e42$var$listsStyles, " ", $6a8a55d341510e42$var$ruleStyles(), " ", (0, $6UEu0.mediaStyles)(), " ", (0, $l5gcr.layoutStyles)(props.viewMode), " ", (0, $VSDnB.fg)('confluence_team_presence_scroll_to_pointer') ? (0, $3I3CN.telepointerStyle) : (0, $3I3CN.telepointerStyleWithInitialOnly), " ", (0, $eAVGd.gapCursorStyles), ";", (0, $b3RpZ.panelStyles)(), " ", $6a8a55d341510e42$var$mentionsStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $6a8a55d341510e42$var$vanillaMentionsStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $6a8a55d341510e42$var$vanillaSelectionStyles, " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) ? $6a8a55d341510e42$var$emojiStyles : $6a8a55d341510e42$var$reactEmojiStyles, " ", $6a8a55d341510e42$var$emojiStyles, " ", (0, $1bQ0V.tasksAndDecisionsStyles), " ", (0, $bYYy3.gridStyles), " ", $6a8a55d341510e42$export$4ea5976125a01ffa, " ", (0, $cx4Bg.blockMarksSharedStyles), " ", (0, $4E5wI.dateSharedStyle), " ", (0, $hucfL.extensionStyles), " ", (0, $cBEjw.expandStyles)(), " ", (0, $RhFwz.findReplaceStyles), " ", (0, $6pErt.textHighlightStyle), " ", (0, $5L329.taskDecisionStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskItemStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskDecisionStyles), (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithVisualRefresh), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithoutVisualRefresh), " ", (0, $aUTD3.statusStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $aUTD3.vanillaStatusStyles)() : null, " ", (0, $5Lu5s.annotationSharedStyles)(), " ", (0, $kRXi9.smartCardStyles)(), " ", (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? (0, $iJOES.getSmartCardSharedStyles)() : (0, $iJOES.smartCardSharedStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $dv67m.dateVanillaStyles) : null, " ", (0, $dv67m.dateStyles), " ", (0, $9zgV3.embedCardStyles)(), " ", (0, $ahG4O.unsupportedStyles), " ", (0, $hVv9L.resizerStyles), " ", (0, $hVv9L.pragmaticResizerStyles)(), " ", (0, $9O4yy.aiPanelStyles)(props.colorMode), " ", $6a8a55d341510e42$export$42a58e6dfeaffebe(), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar,.", (0, $jQRg9.ClassNames).FLOATING_TOOLBAR_COMPONENT, "{padding:0;}", !(0, $VSDnB.fg)('platform-visual-refresh-icons') ? $6a8a55d341510e42$var$_ref : null, ";");
const $6a8a55d341510e42$var$listLayoutShiftFix = {
    name: "123m56l",
    styles: ".ProseMirror ul, .ProseMirror ol{margin-top:10px;}"
};
const $6a8a55d341510e42$export$91e7c20fa6d6a4b5 = (styles)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { className: className, children: children, featureFlags: featureFlags } = props;
        const theme = (0, $g0wej.u)();
        const { colorMode: colorMode, typography: typography } = (0, $hxoiH.default)();
        const memoizedStyle = (0, $5uXOq.useMemo)(()=>$6a8a55d341510e42$var$legacyContentStyles({
                theme: theme,
                colorMode: colorMode,
                featureFlags: featureFlags,
                viewMode: props.viewMode,
                typographyTheme: typography
            }), [
            theme,
            colorMode,
            featureFlags,
            props.viewMode,
            typography
        ]);
        if (props.isScrollable) return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ],
            "data-editor-scroll-container": "true",
            "data-testid": "editor-content-container"
        }, children);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles,
                (0, $VSDnB.fg)('platform_editor_ssr_fix_lists') && $6a8a55d341510e42$var$listLayoutShiftFix
            ],
            "data-testid": "editor-content-container"
        }, children);
    });
};
var $6a8a55d341510e42$export$2e2bcd8739ae039 = $6a8a55d341510e42$export$91e7c20fa6d6a4b5();

});
parcelRegister("3I3CN", function(module, exports) {

$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $b29cd5b2ebd43bff$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $b29cd5b2ebd43bff$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "TELEPOINTER_PULSE_CLASS", () => $b29cd5b2ebd43bff$export$44ee82a2b1106d13);
$parcel$export(module.exports, "TELEPOINTER_DATA_SESSION_ID_ATTR", () => $b29cd5b2ebd43bff$export$74788e2dc4d9be50);
$parcel$export(module.exports, "telepointerStyleWithInitialOnly", () => $b29cd5b2ebd43bff$export$42e13fa9d2b0c35d);
$parcel$export(module.exports, "telepointerStyle", () => $b29cd5b2ebd43bff$export$c94087d6ea5127ad);
$parcel$export(module.exports, "isDirtyTransaction", () => $b29cd5b2ebd43bff$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $b29cd5b2ebd43bff$export$f25182515d14d793);

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $cSyk1 = parcelRequire("cSyk1");
var $b29cd5b2ebd43bff$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $b29cd5b2ebd43bff$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $b29cd5b2ebd43bff$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $cSyk1.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $b29cd5b2ebd43bff$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $b29cd5b2ebd43bff$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $b29cd5b2ebd43bff$export$42e13fa9d2b0c35d = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $iHYdz.participantColors).map((participantColor, index)=>$b29cd5b2ebd43bff$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge::after{content:attr(data-initial);position:absolute;display:block;top:-14px;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(9), ";padding:var(--ds-space-025, 2px);color:var(--ds-text-inverse, #FFFFFF);left:0px;border-radius:2px 2px 2px 0;line-height:initial;}&.", $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $b29cd5b2ebd43bff$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $f8Sb3.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}13%{transform:scaleX(1.4) scaleY(1.4);opacity:1;}20%,85%{transform:scaleX(1) scaleY(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $iHYdz.participantColors).map((participantColor, index)=>$b29cd5b2ebd43bff$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);color:var(--ds-text-inverse, #FFFFFF);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $b29cd5b2ebd43bff$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2s ease-in-out;}.telepointer-fullname{animation:pulseIn 2s ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $b29cd5b2ebd43bff$var$tintKey = 'collab:isDirtyTransaction';
const $b29cd5b2ebd43bff$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($b29cd5b2ebd43bff$var$tintKey));
};
const $b29cd5b2ebd43bff$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($b29cd5b2ebd43bff$var$tintKey, true);
};

});

parcelRegister("3tpiv", function(module, exports) {

$parcel$export(module.exports, "EmojiSharedCssClassName", () => $0dd4329718798e0e$export$ee47248f9a998789);

const $0dd4329718798e0e$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $63856011855bb785$export$b06c4aab1d012063),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $63856011855bb785$export$1c10634420a08d8a),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $63856011855bb785$export$da61cef1c8919f7c),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $63856011855bb785$export$c7187bbd1a7a9244)
};

});
const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("fRmCC", function(module, exports) {

$parcel$export(module.exports, "MentionSharedCssClassName", () => $4843d72ed8c773f1$export$e5f60e08987c4e73);
const $4843d72ed8c773f1$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});

parcelRegister("aABH4", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $c61dedcc3b2bdafe$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $c61dedcc3b2bdafe$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $c61dedcc3b2bdafe$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $c61dedcc3b2bdafe$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bFtEE = parcelRequire("bFtEE");

var $hAs1r = parcelRequire("hAs1r");

var $iHYdz = parcelRequire("iHYdz");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");
const $c61dedcc3b2bdafe$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $c61dedcc3b2bdafe$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $c61dedcc3b2bdafe$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $iHYdz.akEditorCustomIconSize)) / 2;
const $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment = $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment - 1;
function $c61dedcc3b2bdafe$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$c61dedcc3b2bdafe$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $c61dedcc3b2bdafe$var$prefix = 'ak-editor-panel';
const $c61dedcc3b2bdafe$export$6dd740b6c888e050 = {
    prefix: $c61dedcc3b2bdafe$var$prefix,
    content: `${$c61dedcc3b2bdafe$var$prefix}__content`,
    icon: `${$c61dedcc3b2bdafe$var$prefix}__icon`,
    noIcon: `${$c61dedcc3b2bdafe$var$prefix}__no-icon`
};
const $c61dedcc3b2bdafe$export$b0ee08fae091706a = {
    infoPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).INFO}]`,
    notePanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).NOTE}]`,
    warningPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).WARNING}]`,
    errorPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).ERROR}]`,
    successPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, $bFtEE.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $c61dedcc3b2bdafe$var$getIconStyles = (panelType)=>{
    if ((0, $VSDnB.fg)('platform_editor_lcm_nested_panel_icon_fix')) return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
    else return `
			.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.icon} {
				color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};
			}
		`;
};
const $c61dedcc3b2bdafe$export$8099afddf1b1be78 = (panelType)=>$c61dedcc3b2bdafe$var$lightPanelColors[panelType] || 'none';
const $c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc = (panelType)=>(0, $hAs1r.hexToEditorBackgroundPaletteColor)($c61dedcc3b2bdafe$var$lightPanelColors[panelType]) || 'none';
const $c61dedcc3b2bdafe$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $c61dedcc3b2bdafe$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).INFO), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $63856011855bb785$export$1c10634420a08d8a), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $63856011855bb785$export$da61cef1c8919f7c), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}", (0, $VSDnB.fg)('platform_editor_add_border_for_nested_panel') ? `.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.content} .${$c61dedcc3b2bdafe$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : '', " &[data-panel-type='", (0, $bFtEE.PanelType).INFO, "']{", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).INFO), ";}&[data-panel-type='", (0, $bFtEE.PanelType).NOTE, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).NOTE), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).NOTE), ";}&[data-panel-type='", (0, $bFtEE.PanelType).TIP, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).TIP), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).TIP), ";}&[data-panel-type='", (0, $bFtEE.PanelType).WARNING, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).WARNING), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).WARNING), ";}&[data-panel-type='", (0, $bFtEE.PanelType).ERROR, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).ERROR), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).ERROR), ";}&[data-panel-type='", (0, $bFtEE.PanelType).SUCCESS, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, $bFtEE.PanelType).SUCCESS), " ", $c61dedcc3b2bdafe$var$getIconStyles((0, $bFtEE.PanelType).SUCCESS), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $c61dedcc3b2bdafe$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.prefix}`]: $c61dedcc3b2bdafe$export$d707b378cb63679a()
    });

});

parcelRegister("eAVGd", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $618a810c9ab6b0dd$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $618a810c9ab6b0dd$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $618a810c9ab6b0dd$var$gapCursorBlink = (0, $f8Sb3.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $618a810c9ab6b0dd$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $618a810c9ab6b0dd$var$gapCursor = '.ProseMirror-gapcursor';
const $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $618a810c9ab6b0dd$var$wrapLeft = '[layout="wrap-left"]';
const $618a810c9ab6b0dd$var$wrapRight = '[layout="wrap-right"]';
const $618a810c9ab6b0dd$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{&.", $618a810c9ab6b0dd$export$8adc5edbc4a22166, "{caret-color:transparent;}", $618a810c9ab6b0dd$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $618a810c9ab6b0dd$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $618a810c9ab6b0dd$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $618a810c9ab6b0dd$var$gapCursor, "{display:block;border-color:transparent;}}", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span ", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "{clear:none;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "{float:left;}", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("5Lu5s", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "annotationSharedStyles", () => $973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
    focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`,
    hover: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-hover`
};
const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
    focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
    blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
    draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
};
var $973d0f0bfe5e36b9$var$_ref = {
    name: "1afe5d9",
    styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
var $973d0f0bfe5e36b9$var$_ref2 = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $973d0f0bfe5e36b9$var$_ref3 = {
    name: "1m36z9o",
    styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $973d0f0bfe5e36b9$var$_ref3,
        blur: $973d0f0bfe5e36b9$var$_ref2,
        hover: $973d0f0bfe5e36b9$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $f8Sb3.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $f8Sb3.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.hover, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";", $973d0f0bfe5e36b9$export$261ebe180da42726().hover, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $f8Sb3.css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("1xqpZ", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $31831d84911fc513$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $31831d84911fc513$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
    return $31831d84911fc513$var$_ref;
};

});

parcelRegister("cx4Bg", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $e319ea6be2c09fe0$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e319ea6be2c09fe0$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("7Acon", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $4ae245bd686f7965$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            display: 'inline',
            padding: '2px 0.5ch',
            backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            borderStyle: 'none',
            boxDecorationBreak: 'clone',
            color: "var(--ds-text, #172B4D)",
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.875em',
            fontWeight: "var(--ds-font-weight-regular, 400)",
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    });
};

});

parcelRegister("9zgV3", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $4909a7644b753f01$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $4909a7644b753f01$export$5a1f57c6600b90f1 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout^='wrap-']": {
                maxWidth: '100%',
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-left']": {
                float: 'left'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right']": {
                float: 'right'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
                clear: 'both'
            }
        }
    });
const $4909a7644b753f01$export$9a900b6b0c1fa45 = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-150, 12px)"}`
});

});

parcelRegister("bYYy3", function(module, exports) {

$parcel$export(module.exports, "GRID_GUTTER", () => $ef9988a8733147ec$export$108900bf32350a8b);
$parcel$export(module.exports, "gridStyles", () => $ef9988a8733147ec$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $ef9988a8733147ec$export$108900bf32350a8b = 12;
const $ef9988a8733147ec$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + ${$ef9988a8733147ec$export$108900bf32350a8b * 2}px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorGridLineZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("5fBxY", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $586c09e19d6f6d26$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("aN7BF", function(module, exports) {

$parcel$export(module.exports, "linkSharedStyle", () => $536782e4b54ab634$export$d835732bf782c240);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $VSDnB = parcelRequire("VSDnB");
function $536782e4b54ab634$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $536782e4b54ab634$var$_ref = {
    name: "bp6sai",
    styles: "a.blockLink{display:block;}"
};
var $536782e4b54ab634$var$_ref2 = {
    name: "13hvbxv",
    styles: "a.blockLink{display:block;}a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $536782e4b54ab634$export$d835732bf782c240 = ()=>{
    return (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $536782e4b54ab634$var$_ref2 : $536782e4b54ab634$var$_ref;
};

});

parcelRegister("jQRg9", function(module, exports) {

$parcel$export(module.exports, "ClassNames", () => $efb57f1d3580a030$export$9b9c0f9d9f3552b8);
const $efb57f1d3580a030$var$prefix = 'pm-alt-text';
const $efb57f1d3580a030$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$efb57f1d3580a030$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("4jyW9", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $0bce92e99beab9a0$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $04VvC = parcelRequire("04VvC");
const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $VSDnB.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $04VvC.default)('editor.font.body'),
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $iHYdz.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("hVv9L", function(module, exports) {

$parcel$export(module.exports, "resizerItemClassName", () => $fb7b1e8a090d8802$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $fb7b1e8a090d8802$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $fb7b1e8a090d8802$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $fb7b1e8a090d8802$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $fb7b1e8a090d8802$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $fb7b1e8a090d8802$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $fb7b1e8a090d8802$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $fb7b1e8a090d8802$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleZIndex", () => $fb7b1e8a090d8802$export$3d867927ebf9bc1f);
$parcel$export(module.exports, "resizerStyles", () => $fb7b1e8a090d8802$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $fb7b1e8a090d8802$export$62cd5dfd9881f590);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
function $fb7b1e8a090d8802$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fb7b1e8a090d8802$export$a06160db3520e5a2 = 'resizer-item';
const $fb7b1e8a090d8802$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $fb7b1e8a090d8802$export$10b67c6ff1748bd = 'resizer-is-extended';
const $fb7b1e8a090d8802$export$6afc20f0ff6d041 = 'resizer-handle';
const $fb7b1e8a090d8802$export$a5792d7e2a486d41 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-track`;
const $fb7b1e8a090d8802$export$2201bc1aaee73f36 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-thumb`;
const $fb7b1e8a090d8802$export$97a99610b6f0a178 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-danger`;
// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
const $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $fb7b1e8a090d8802$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $fb7b1e8a090d8802$export$3d867927ebf9bc1f = 1;
const $fb7b1e8a090d8802$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $fb7b1e8a090d8802$export$a06160db3520e5a2, "{will-change:width;&:hover,&.display-handle{&>.", $fb7b1e8a090d8802$export$b123b2c8a2536d05, ">.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{visibility:visible;opacity:1;}}&.is-resizing{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}&.", $fb7b1e8a090d8802$export$97a99610b6f0a178, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{transition:none;background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}}}.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{display:flex;visibility:hidden;opacity:0;flex-direction:column;justify-content:center;align-items:center;width:7px;transition:visibility 0.2s,opacity 0.2s;& div[role='presentation']{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:var(--ds-space-negative-200, -16px);white-space:normal;}&.left{align-items:flex-start;}&.right{align-items:flex-end;}&.small{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:43px;}}&.medium{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:64px;}}&.large{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:96px;}}&.clamped{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:clamp(43px, calc(100% - 32px), 96px);}}&.sticky{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}}&:hover{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}& .", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:visible;opacity:0.5;}}}.", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{content:' ';display:flex;width:3px;margin:0 var(--ds-space-025, 2px);height:64px;transition:background-color 0.2s;border-radius:6px;border:0;padding:0;z-index:2;outline:none;min-height:24px;background:var(--ds-border, #091E4224);&:hover{cursor:col-resize;}&:focus{background:var(--ds-border-selected, #0C66E4);&::after{content:'';position:absolute;top:var(--ds-space-negative-050, -4px);right:var(--ds-space-negative-050, -4px);bottom:var(--ds-space-negative-050, -4px);left:var(--ds-space-negative-050, -4px);border:2px solid var(--ds-border-focused, #388BFF);border-radius:inherit;z-index:-1;}}}.", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:hidden;position:absolute;width:7px;height:calc(100% - 40px);border-radius:4px;opacity:0;transition:background-color 0.2s,visibility 0.2s,opacity 0.2s;&.none{background:none;}&.shadow{background:var(--ds-background-selected, #E9F2FF);}&.full-height{background:var(--ds-background-selected, #E9F2FF);height:100%;min-height:36px;}}.", $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}.ak-editor-no-interaction .", $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName, " .", $fb7b1e8a090d8802$export$6afc20f0ff6d041, ":not(:hover) .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border, #091E4224);}.", $fb7b1e8a090d8802$export$c42cdcfd48254bda, "{position:relative;display:inline-block;width:100%;&.", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:0 var(--ds-space-150, 12px);left:var(--ds-space-negative-150, -12px);}}table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ",table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ".", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:unset;left:unset;}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $fb7b1e8a090d8802$var$_ref = {
    name: "12dt14k",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-left{left:-12px;}> .pm-breakout-resize-handle-right{right:-12px;}> .pm-breakout-resize-handle{height:calc(100% - 12px);}}&:has([data-prosemirror-node-name=\"expand\"]), &:has([data-prosemirror-node-name=\"layoutSection\"]){> .pm-breakout-resize-handle-left{left:-32px;}> .pm-breakout-resize-handle-right{right:-32px;}}&:has([data-prosemirror-node-name=\"expand\"]){> .pm-breakout-resize-handle{height:calc(100% - 4px);}}&:has([data-prosemirror-node-name=\"layoutSection\"]){> .pm-breakout-resize-handle{height:calc(100% - 8px);}}&:has(.first-node-in-document){> .pm-breakout-resize-handle{height:100%;}}}.pm-breakout-resize-handle{position:relative;display:flex;align-items:center;justify-content:center;height:100%;width:7px;align-self:end;grid-row:1;grid-column:1;cursor:col-resize;border-radius:4px;transition:background-color 0.2s, visibility 0.2s, opacity 0.2s;&:hover{background:var(--ds-background-selected, #E9F2FF);.pm-breakout-resize-handle-inner{background:var(--ds-border-focused, #388BFF);}}}.pm-breakout-resize-handle-left{justify-self:start;}.pm-breakout-resize-handle-right{justify-self:end;}.pm-breakout-resize-handle-inner{min-width:3px;height:clamp(27px, calc(100% - 32px), 96px);background:var(--ds-border, #091E4224);border-radius:6px;position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}"
};
const $fb7b1e8a090d8802$export$62cd5dfd9881f590 = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_breakout_resizing', false)) return;
    return $fb7b1e8a090d8802$var$_ref;
};

});

parcelRegister("bv4Ps", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $f15d364691bf541f$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $f15d364691bf541f$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("aSoqv", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $0235d3a2f78ffda6$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $ajc8Z = parcelRequire("ajc8Z");

var $bbl9Y = parcelRequire("bbl9Y");
const $0235d3a2f78ffda6$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $0235d3a2f78ffda6$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("kRXi9", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $5eabaa6e34ebabc6$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $5eabaa6e34ebabc6$export$863ae87a9d233606);
$parcel$export(module.exports, "smartCardStyles", () => $5eabaa6e34ebabc6$export$b346a5d6d598424c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $iJOES = parcelRequire("iJOES");
const $5eabaa6e34ebabc6$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $5eabaa6e34ebabc6$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $5eabaa6e34ebabc6$export$b346a5d6d598424c = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $iJOES.SmartCardSharedCssClassName).INLINE_CARD_CONTAINER, "{max-width:calc(100% - 20px);vertical-align:top;word-break:break-all;", (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : '', " .card{padding-left:var(--ds-space-025, 2px);padding-right:var(--ds-space-025, 2px);padding-top:0.5em;padding-bottom:0.5em;margin-bottom:-0.5em;.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a:focus{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}}", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? `[data-inlinecard-button-overlay='icon-wrapper-line-height'] span {
				line-height: 0;
			}` : '', " &.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{z-index:1;position:relative;}&.danger{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";z-index:2;}}}.", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer', ";a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), " border-radius:var(--ds-border-radius-200, 8px);}&.danger{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, "!important;}}}.", (0, $iJOES.SmartCardSharedCssClassName).DATASOURCE_CONTAINER, ".", (0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{max-width:100%;display:flex;justify-content:center;.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{cursor:pointer;background-color:var(--ds-background-neutral-subtle, #00000000);border-radius:var(--ds-border-radius-200, 8px);border:1px solid var(--ds-border, #091E4224);overflow:hidden;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), " input::selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}input::-moz-selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}}}&.danger{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}}.", (0, $iJOES.SmartCardSharedCssClassName).EMBED_CARD_CONTAINER, "{.", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:pointer;a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}&::after{transition:box-shadow 0s;}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $iJOES.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div::after{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}&.danger{.media-card-frame::after{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, "!important;background:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}}.", $5eabaa6e34ebabc6$export$863ae87a9d233606, "{padding:0;}");

});
parcelRegister("5yojI", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $e0952f45925e7685$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $e0952f45925e7685$export$a716852a0c5e54d5);

var $iHYdz = parcelRequire("iHYdz");

var $bzmFE = parcelRequire("bzmFE");
const $e0952f45925e7685$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$e0952f45925e7685$var$getSelectionStyle(selectionStyle)).concat($e0952f45925e7685$export$a716852a0c5e54d5).join('\n');
const $e0952f45925e7685$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $e0952f45925e7685$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $bzmFE.SelectionStyle).Border:
            return `
        border: ${0, $iHYdz.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $iHYdz.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $bzmFE.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $iHYdz.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $bzmFE.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $bzmFE.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $iHYdz.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("bzmFE", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $2bcf46ee398650df$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $2bcf46ee398650df$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});



parcelRegister("jRk4M", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $e9c9f96b9e0ca8df$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("ahG4O", function(module, exports) {

$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $bb6144152e7474e0$export$629043421dcc56e5);
$parcel$export(module.exports, "unsupportedStyles", () => $bb6144152e7474e0$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
const $bb6144152e7474e0$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $bb6144152e7474e0$var$inlineUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
const $bb6144152e7474e0$var$blockUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
const $bb6144152e7474e0$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $f8Sb3.css)($bb6144152e7474e0$var$blockUnsupportedSelector, ",", $bb6144152e7474e0$var$inlineUnsupportedSelector, "{cursor:pointer;}.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Background,
    (0, $bzmFE.SelectionStyle).Border
]), ";}.danger{.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, $iHYdz.akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{border:", (0, $iHYdz.akEditorSelectedBorderSize), "px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";}}");

});

parcelRegister("fwxzS", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $308dad73f97ce24c$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("6jI8m", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => (parcelRequire("2uCrC")).blocktypeStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2uCrC = parcelRequire("2uCrC");

});
parcelRegister("2uCrC", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $2b2214035a5c6632$export$610a2509037eaf6);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kRRtM = parcelRequire("kRRtM");
var $idytF = parcelRequire("idytF");

var $VSDnB = parcelRequire("VSDnB");
const $2b2214035a5c6632$export$610a2509037eaf6 = (typographyTheme)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $kRRtM.blockquoteSharedStyles), ";", (0, $idytF.headingsSharedStyles)(typographyTheme), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`, ";");

});


parcelRegister("9wwua", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => (parcelRequire("RhFwz")).findReplaceStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $RhFwz = parcelRequire("RhFwz");

});
parcelRegister("RhFwz", function(module, exports) {

$parcel$export(module.exports, "searchMatchClass", () => $9fcae42923e86302$export$cec6db4af40340f0);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $9fcae42923e86302$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "findReplaceStyles", () => $9fcae42923e86302$export$c5ceb9c726010930);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $9fcae42923e86302$export$cec6db4af40340f0 = 'search-match';
const $9fcae42923e86302$export$bf208a338b2a2f1f = 'selected-search-match';
const $9fcae42923e86302$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${$9fcae42923e86302$export$cec6db4af40340f0}`]: {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 0 ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $829f609a65d26a98$export$46987b49aab6d1a8}`})`
    },
    [`.${$9fcae42923e86302$export$bf208a338b2a2f1f}`]: {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});

});


parcelRegister("3p7sF", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => (parcelRequire("6pErt")).textHighlightStyle);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6pErt = parcelRequire("6pErt");

});
parcelRegister("6pErt", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $c96facf2e51cafaa$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $c96facf2e51cafaa$export$b286500adc7d91cd = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $b47580417926a26e$export$78dda1ebb9a1ea84), "{background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff);}");

});
const $b47580417926a26e$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $b47580417926a26e$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $b47580417926a26e$export$78dda1ebb9a1ea84 = 'text-highlight';
const $b47580417926a26e$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $b47580417926a26e$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $b47580417926a26e$export$220f0307408bc0c = 'akEditor';
const $b47580417926a26e$export$299d35c5583816ad = 'paste-options-testid';
const $b47580417926a26e$export$d1234a98f427930 = 'paste-options$';



parcelRegister("eXo2J", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => (parcelRequire("2yMev")).placeholderTextStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2yMev = parcelRequire("2yMev");

});
parcelRegister("2yMev", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $7e369052517216e8$export$56bce713f2cb8aa7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

const $7e369052517216e8$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror span[data-placeholder]{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";display:inline;}.ProseMirror span.pm-placeholder{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder__text{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder.", (0, $iHYdz.akEditorSelectedNodeClassName), "{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Background
]), ";}.ProseMirror span.pm-placeholder__text[data-placeholder]::after{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";cursor:text;content:attr(data-placeholder);display:inline;}.ProseMirror{.ProseMirror-fake-text-cursor{display:inline;pointer-events:none;position:relative;}.ProseMirror-fake-text-cursor::after{content:'';display:inline;top:0;position:absolute;border-right:1px solid var(--ds-border, rgba(0, 0, 0, 0.4));}.ProseMirror-fake-text-selection{display:inline;pointer-events:none;position:relative;background-color:", `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`, ";}}");

});


parcelRegister("fz5RS", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $2404ec09d44bb929$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5BVRS = parcelRequire("5BVRS");

const $2404ec09d44bb929$export$3fc32cdc53f6edeb = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $5BVRS.inlineNodeViewClassname}`]: {
        display: 'inline',
        userSelect: 'all',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > *:not(.zeroWidthSpaceContainer)': {
            whiteSpace: 'pre-wrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .assistive': {
            userSelect: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-safari': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`.${0, $5BVRS.inlineNodeViewClassname}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::selection, *::selection': {
                background: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`&.ua-chrome .${0, $5BVRS.inlineNodeViewClassname} > span`]: {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $5BVRS.inlineNodeViewClassname}AddZeroWidthSpace`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: `'${(0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)}'`
        }
    }
});

});
parcelRegister("5BVRS", function(module, exports) {

$parcel$export(module.exports, "inlineNodeViewClassname", () => $376ab61f8223d072$export$dfb58b577a6f1cd9);
$parcel$export(module.exports, "getInlineNodeViewProducer", () => $376ab61f8223d072$export$17a8c3162956317d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $9pOon = parcelRequire("9pOon");

var $4NUlu = parcelRequire("4NUlu");
var $gE8f9 = parcelRequire("gE8f9");
var $WXnhI = parcelRequire("WXnhI");


var $4tEIi = parcelRequire("4tEIi");

var $9xrrM = parcelRequire("9xrrM");
const $376ab61f8223d072$var$isSSR = Boolean(undefined);
const $376ab61f8223d072$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $376ab61f8223d072$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $376ab61f8223d072$var$virtualizedNodeAllowlist = [
    'status',
    'mention',
    'emoji',
    'date',
    'inlineCard'
];
function $376ab61f8223d072$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4tEIi.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $376ab61f8223d072$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$376ab61f8223d072$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($376ab61f8223d072$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $WXnhI.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $WXnhI.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $WXnhI.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $376ab61f8223d072$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $376ab61f8223d072$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4tEIi.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $376ab61f8223d072$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$376ab61f8223d072$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($376ab61f8223d072$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$376ab61f8223d072$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $kCV8T.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $9xrrM.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $376ab61f8223d072$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $376ab61f8223d072$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $376ab61f8223d072$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9pOon.ErrorBoundary), {
            component: (0, $gkwXh.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $gkwXh.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)), /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $gE8f9.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $376ab61f8223d072$var$counterPerEditorViewMap = new WeakMap();
function $376ab61f8223d072$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $376ab61f8223d072$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $376ab61f8223d072$var$isSSR) return $376ab61f8223d072$var$createNodeView(parameters);
        if ((0, $VSDnB.fg)('platform_editor_inline_node_virt_threshold_override')) return $376ab61f8223d072$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $376ab61f8223d072$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $376ab61f8223d072$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $376ab61f8223d072$var$createNodeView(parameters);
        return $376ab61f8223d072$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}

});
parcelRegister("9pOon", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $88b42bbe41ec844f$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $1KzE6 = parcelRequire("1KzE6");
class $88b42bbe41ec844f$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("WXnhI", function(module, exports) {

$parcel$export(module.exports, "getPerformanceOptions", () => $c14b3b53100539b7$export$9838b97af1c61be);
$parcel$export(module.exports, "startMeasureReactNodeViewRendered", () => $c14b3b53100539b7$export$2630f5971dfad231);
$parcel$export(module.exports, "stopMeasureReactNodeViewRendered", () => $c14b3b53100539b7$export$dc5a82f0bfc526c3);

var $gkwXh = parcelRequire("gkwXh");

var $iN9lO = parcelRequire("iN9lO");
// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $c14b3b53100539b7$var$nodeViewRenderedEventsCounter = 0;
const $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE = 100;
const $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD = 7;
function $c14b3b53100539b7$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $c14b3b53100539b7$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $iN9lO.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $c14b3b53100539b7$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $iN9lO.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$c14b3b53100539b7$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}

});

parcelRegister("4tEIi", function(module, exports) {

$parcel$export(module.exports, "generateUniqueNodeKey", () => $50f69fedc475632c$export$4a323a0542a1e4d1);

var $bXrHm = parcelRequire("bXrHm");
const $50f69fedc475632c$export$4a323a0542a1e4d1 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
};

});

parcelRegister("9xrrM", function(module, exports) {

$parcel$export(module.exports, "getOrCreateOnVisibleObserver", () => $29d167941afc2c06$export$d73c873f0a6a03c3);

var $gJBT6 = parcelRequire("gJBT6");
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $29d167941afc2c06$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $29d167941afc2c06$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $29d167941afc2c06$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($29d167941afc2c06$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$29d167941afc2c06$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});

});



parcelRegister("9O4yy", function(module, exports) {

$parcel$export(module.exports, "aiPanelStyles", () => $1e36f2eb545c5b87$export$cdf1b75966a7ba92);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $1e36f2eb545c5b87$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $1e36f2eb545c5b87$var$rotationAnimation = (0, $f8Sb3.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $1e36f2eb545c5b87$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $1e36f2eb545c5b87$var$prismBorderAnimationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        animationName: $1e36f2eb545c5b87$var$rotationAnimation,
        animationDuration: '2s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1e36f2eb545c5b87$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $1e36f2eb545c5b87$var$prismBorderStyles = (colorMode, hover)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        content: "''",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
        transform: 'translate3d(0, 0, 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...hover ? {
            background: "var(--ds-border-input, #8590A2)"
        } : $1e36f2eb545c5b87$var$isFirefox ? {
            background: `linear-gradient(90deg,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
            backgroundSize: '200%'
        } : {
            background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
        }
    });
const $1e36f2eb545c5b87$export$cdf1b75966a7ba92 = (colorMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("@property --panel-gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}div[extensionType='com.atlassian.ai-blocks']{.extension-label{display:none;}.extension-container{position:relative;box-shadow:none;overflow:unset;background-color:var(--ds-surface, #FFFFFF)!important;&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}&.with-hover-border{&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode, true), ";}}& .with-margin-styles{background-color:var(--ds-surface, #FFFFFF)!important;border-radius:var(--ds-border-radius-100, 3px);}}}div[extensionType='com.atlassian.ai-blocks']:has(.streaming){.extension-container{box-shadow:none;overflow:unset;", $1e36f2eb545c5b87$var$prismBorderAnimationStyles, " &::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}}}div[extensionType='com.atlassian.ai-blocks'].danger{.extension-container{box-shadow:0 0 0 1px var(--ds-border-danger, #E2483D);}}div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension']{div[data-node-type='actionList']{margin:0!important;}}");

});

parcelRegister("cEh6Q", function(module, exports) {

$parcel$export(module.exports, "codeBlockStyles", () => $fae98ce4976198e8$export$4baaed2b257b830);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $cYeQP = parcelRequire("cYeQP");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $cwax5 = parcelRequire("cwax5");
function $fae98ce4976198e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fae98ce4976198e8$var$_ref3 = {
    name: "1dgciks",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, none);}"
};
const $fae98ce4976198e8$var$GutterDangerOverlay = ()=>$fae98ce4976198e8$var$_ref3;
/* When code-block is inside the panel  */ var $fae98ce4976198e8$var$_ref = {
    name: "czrl7q",
    styles: ".ak-editor-panel__content{>.code-block:first-child{margin:0 0 0 0!important;}}"
};
var $fae98ce4976198e8$var$_ref2 = {
    name: "142jt9z",
    styles: ".ak-editor-panel__content{>.code-block:first-child,>.ProseMirror-widget:first-child+.code-block,>.ProseMirror-widget:first-child+.ProseMirror-widget+.code-block{margin:0 0 0 0!important;}}"
};
const $fae98ce4976198e8$var$firstCodeBlockWithNoMargin = (0, $cwax5.functionWithFG)('platform_editor_nested_dnd_styles_changes', ()=>$fae98ce4976198e8$var$_ref2, ()=>$fae98ce4976198e8$var$_ref);
const $fae98ce4976198e8$export$4baaed2b257b830 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $cYeQP.codeBlockSharedStyles)(), ";}.ProseMirror li{>.code-block{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:0;}>div:last-of-type.code-block,>pre:last-of-type.code-block{margin-bottom:", (0, $iHYdz.blockNodesVerticalMargin), ";}}.ProseMirror .code-block.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";}.ProseMirror .danger.code-block{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, #FFECEB);color:", `var(--ds-text-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}}.ProseMirror .danger .code-block{.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, rgba(255, 143, 115, 0.5));color:", `var(--ds-text-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:var(--ds-blanket-danger, rgba(255, 189, 173, 0.5));}}", $fae98ce4976198e8$var$firstCodeBlockWithNoMargin(), ";");

});
parcelRegister("cwax5", function(module, exports) {

$parcel$export(module.exports, "functionWithFG", () => $c02fe85c5c1e243f$export$53903226fff06fbb);

var $VSDnB = parcelRequire("VSDnB");

var $eXpHn = parcelRequire("eXpHn");
const $c02fe85c5c1e243f$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $eXpHn.functionWithCondition)(()=>(0, $VSDnB.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("eXpHn", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $abb9266deac9e1cc$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $abb9266deac9e1cc$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $abb9266deac9e1cc$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $abb9266deac9e1cc$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});



parcelRegister("dv67m", function(module, exports) {

$parcel$export(module.exports, "dateVanillaStyles", () => $f64e5f28f7da36f5$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $f64e5f28f7da36f5$export$37579fbc35dcc1a9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4E5wI = parcelRequire("4E5wI");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
const $f64e5f28f7da36f5$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span": {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span:hover": {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red": {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red:hover": {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $f64e5f28f7da36f5$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $4E5wI.DateSharedCssClassName).DATE_CONTAINER, "{.", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, "{line-height:initial;cursor:pointer;}&.", (0, $iHYdz.akEditorSelectedNodeClassName), "{.", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, ">span{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}.danger{.", (0, $4E5wI.DateSharedCssClassName).DATE_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER, ">span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}}");

});

parcelRegister("cBEjw", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $ac21c05ea8fc9971$export$4bb28258452e3b9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5HrRs = parcelRequire("5HrRs");
var $cr1aY = parcelRequire("cr1aY");
var $dVbMk = parcelRequire("dVbMk");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
function $ac21c05ea8fc9971$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
var $ac21c05ea8fc9971$var$_ref2 = {
    name: "1t3zvjb",
    styles: "color:var(--ds-icon-subtle, #626F86)"
};
const $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR = ()=>$ac21c05ea8fc9971$var$_ref2;
const $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
const $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
var $ac21c05ea8fc9971$var$_ref = {
    name: "1oz7tqa",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}>div.ak-editor-expand[data-node-type='nestedExpand']{margin-top:var(--ds-space-050, 0.25rem);}"
};
const $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $ac21c05ea8fc9971$var$_ref : '';
const $ac21c05ea8fc9971$export$4bb28258452e3b9a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $cr1aY.expandClassNames).icon, ">div{display:flex;}.", (0, $cr1aY.expandClassNames).prefix, "{", (0, $dVbMk.sharedExpandStyles).containerStyles({
        expanded: false,
        focused: false
    })(), " cursor:pointer;box-sizing:border-box;td>&{margin-top:0;}.", (0, $cr1aY.expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(90deg);}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]) + `border: ${0, $iHYdz.akEditorSelectedBorder};` : (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket,
        (0, $bzmFE.SelectionStyle).Border
    ]), ";}&.danger{background:", $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR, ";border-color:", $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR, ";}}.ProseMirror>.", (0, $cr1aY.expandClassNames).type('expand'), ",.", (0, $5HrRs.BreakoutCssClassName).BREAKOUT_MARK_DOM, ">.", (0, $cr1aY.expandClassNames).type('expand'), "{margin-left:-", (0, $iHYdz.akLayoutGutterOffset), "px;margin-right:-", (0, $iHYdz.akLayoutGutterOffset), "px;}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, $cr1aY.expandClassNames).type('expand')},
		.${(0, $5HrRs.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $cr1aY.expandClassNames).type('expand')} {
		margin-left: -${(0, $iHYdz.akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, $iHYdz.akLayoutGutterOffset) + 8}px;
	}`, " .", (0, $cr1aY.expandClassNames).content, "{", (0, $dVbMk.sharedExpandStyles).contentStyles({
        expanded: false,
        focused: false
    })(), " cursor:text;padding-top:0px;}.", (0, $cr1aY.expandClassNames).titleInput, "{", (0, $dVbMk.sharedExpandStyles).titleInputStyles(), ";}.", (0, $cr1aY.expandClassNames).titleContainer, "{", (0, $dVbMk.sharedExpandStyles).titleContainerStyles(), ";align-items:center;overflow:visible;}.", (0, $cr1aY.expandClassNames).expanded, "{background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";border-color:var(--ds-border, #091E4224);.", (0, $cr1aY.expandClassNames).content, "{padding-top:var(--ds-space-100, 8px);", $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop(), ";}}.", (0, $cr1aY.expandClassNames).inputContainer, "{width:100%;}.", (0, $cr1aY.expandClassNames).prefix, ":(.", (0, $cr1aY.expandClassNames).expanded, "){.expand-content-wrapper{height:auto;}}.", (0, $cr1aY.expandClassNames).prefix, ":not(.", (0, $cr1aY.expandClassNames).expanded, "){.ak-editor-expand__content{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);white-space:nowrap;}.", (0, $cr1aY.expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(0deg);}&:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "):not(.danger){background:transparent;border-color:transparent;&:hover{border-color:var(--ds-border, #091E4224);background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";}}}");

});
parcelRegister("5HrRs", function(module, exports) {

$parcel$export(module.exports, "BreakoutCssClassName", () => $96d4c7fd1ee4abdc$export$c21a3b023fccd534);
const $96d4c7fd1ee4abdc$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("dVbMk", function(module, exports) {

$parcel$export(module.exports, "sharedExpandStyles", () => $78318408d2d2a85d$export$8c0b53d8e8508fed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $78318408d2d2a85d$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
const $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
const $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
const $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
const $78318408d2d2a85d$var$containerStyles = (styleProps)=>{
    const { expanded: expanded, focused: focused } = styleProps;
    const marginTop = "var(--ds-space-050, 0.25rem)";
    const marginBottom = 0;
    // Only only these margins if the expand isn't editable
    // and is the root level expand.
    const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, $iHYdz.akLayoutGutterOffset}px` : 0;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
    return ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
            borderWidth: '1px',
            borderStyle: 'solid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: focused ? $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR : $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR,
            borderRadius: $78318408d2d2a85d$var$BORDER_RADIUS,
            minHeight: '25px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: !expanded ? $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND : $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND,
            margin: margin,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `background 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'td > :not(style):first-child, td > style:first-child + *': {
                marginTop: 0
            }
        });
};
const $78318408d2d2a85d$var$contentStyles = (styleProps)=>()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        (0, $f8Sb3.css)("padding-top:", styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)", ";padding-right:var(--ds-space-100, 8px);padding-left:var(--ds-space-300, 24px);margin-left:var(--ds-space-050, 4px);display:flow-root;/* The follow rules inside @supports block are added as a part of ED-8893\n\t\tThe fix is targeting mobile bridge on iOS 12 or below,\n\t\tWe should consider remove this fix when we no longer support iOS 12 */@supports not (display: flow-root){width:100%;box-sizing:border-box;}", !styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : '', ";");
const $78318408d2d2a85d$var$titleInputStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? 1 : (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    });
const $78318408d2d2a85d$var$titleContainerStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        overflow: 'hidden',
        cursor: 'pointer',
        '&:focus': {
            outline: 0
        }
    });
const $78318408d2d2a85d$export$8c0b53d8e8508fed = {
    titleInputStyles: $78318408d2d2a85d$var$titleInputStyles,
    titleContainerStyles: $78318408d2d2a85d$var$titleContainerStyles,
    containerStyles: $78318408d2d2a85d$var$containerStyles,
    contentStyles: $78318408d2d2a85d$var$contentStyles
};

});


parcelRegister("hucfL", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $734bc965b81ee341$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $734bc965b81ee341$var$extensionLabelStyles = /*#__PURE__*/ (0, $f8Sb3.css)("&.danger>span>div>.extension-label{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);opacity:1;box-shadow:none;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label{background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4);opacity:1;box-shadow:none;}&.danger>span>div>.extension-label>span{display:inline;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div .extension-label>span{display:inline;}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-danger, #E2483D);}&.danger.", (0, $iHYdz.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container>.extension-edit-toggle{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);box-shadow:none;}");
const $734bc965b81ee341$var$dangerOverlayStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0.3,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-danger-hovered, ${(0, $iHYdz.akEditorDeleteBackground)})`
});
const $734bc965b81ee341$export$c0c648396dbd86d3 = /*#__PURE__*/ (0, $f8Sb3.css)(".multiBodiedExtensionView-content-wrap{&.danger>span>.multiBodiedExtension--container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.multiBodiedExtension--overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.multiBodiedExtension--container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Blanket
]), ";}}.multiBodiedExtension--container{width:100%;max-width:100%;}}.inlineExtensionView-content-wrap{", $734bc965b81ee341$var$extensionLabelStyles, ";&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}&.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}}.bodied-extension-to-dom-label::after{content:attr(data-bodied-extension-label);}.extensionView-content-wrap,.multiBodiedExtensionView-content-wrap,.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:0;}&:not(.danger).", (0, $iHYdz.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow
]), ";}}&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&.inline{word-wrap:break-all;}}.extensionView-content-wrap .extension-container{overflow:hidden;&:has(.extension-editable-area){overflow:visible;}}.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container{width:100%;max-width:100%;}[data-mark-type='fragment']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0;}}&:first-child{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}}}&:nth-last-of-type(-n + 2):not(:first-of-type){&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}}}}");

});

parcelRegister("l5gcr", function(module, exports) {

$parcel$export(module.exports, "layoutStyles", () => $d274b53d45a9ace1$export$ac8f5049e4e10701);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $719f3 = parcelRequire("719f3");
var $ejmVg = parcelRequire("ejmVg");
parcelRequire("8OrBn");
var $jecUf = parcelRequire("jecUf");
parcelRequire("eTjGD");
var $1v4Xe = parcelRequire("1v4Xe");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
function $d274b53d45a9ace1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d274b53d45a9ace1$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
var $d274b53d45a9ace1$var$_ref = {
    name: "kzeyqg",
    styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
};
var $d274b53d45a9ace1$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $d274b53d45a9ace1$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $d274b53d45a9ace1$var$_ref2 : $d274b53d45a9ace1$var$_ref;
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO handle responsive
const $d274b53d45a9ace1$var$layoutColumnStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)(">[data-layout-column]{margin:0 ", (0, $ejmVg.LAYOUT_SECTION_MARGIN) / 2, "px;}>[data-layout-column]:first-of-type{margin-left:0;}>[data-layout-column]:last-of-type{margin-right:0;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin:0;}}>[data-layout-column].", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";::before{width:calc(100% - 8px);left:4px;border-radius:var(--ds-border-radius, 3px);}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("[data-layout-column]+[data-layout-column]{margin-left:", (0, $ejmVg.LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}");
const $d274b53d45a9ace1$var$layoutSectionStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)((0, $719f3.columnLayoutResponsiveSharedStyle), ";.layout-section-container [data-layout-section]{>.ProseMirror-widget{flex:none;display:contents!important;&[data-blocks-drag-handle-container] div{display:contents!important;}&[data-blocks-drop-target-container]{display:block!important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}&+[data-layout-column]{margin:0;}}>[data-layout-column]{margin:0;}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)((0, $719f3.columnLayoutSharedStyle), ";");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$layoutBorderStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column],&:hover [data-layout-column]{border:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger [data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Border,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), " ::after{background-color:transparent;}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$columnSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-left:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;height:calc(100% - 24px);margin-left:-25px;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$rowSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-top:", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;width:calc(100% - 32px);margin-top:-13px;border-left:unset;margin-left:unset;height:unset;}");
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles = (breakpoint, viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected,&:hover,&.selected.danger,&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){@container editor-area (max-width:", breakpoint, "px){", $d274b53d45a9ace1$var$rowSeparatorStyles(viewMode), ";}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles = (viewMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return /*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column]:not(:first-of-type),[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}&.selected.danger [data-layout-section]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";border-radius:4px;[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger) [data-layout-section]{box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);border-radius:4px;background-color:var(--ds-background-selected, #E9F2FF);[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]), " border:0px;::before{background-color:transparent;}}[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}");
};
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $d274b53d45a9ace1$var$layoutResponsiveStyles = (viewMode)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(724, viewMode), ";[data-layout-section]{@container editor-area (max-width:724px){flex-direction:column;}}}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(788, viewMode), ";[data-layout-section]{@container editor-area (max-width:788px){flex-direction:column;}}}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(820, viewMode), ";[data-layout-section]{@container editor-area (max-width:820px){flex-direction:column;}}}}");
const $d274b53d45a9ace1$export$ac8f5049e4e10701 = (viewMode)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", $d274b53d45a9ace1$var$layoutSectionStyles(), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, $iHYdz.akLayoutGutterOffset) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $d274b53d45a9ace1$var$AK_NESTED_DND_GUTTER_OFFSET : 0), "px 0;transition:border-color 0.3s ", (0, $iHYdz.akEditorSwoopCubicBezier), ";cursor:", viewMode === 'view' ? 'default' : 'pointer', ";", $d274b53d45a9ace1$var$layoutColumnStyles(), ";[data-layout-column]{flex:1;position:relative;min-width:0;border:", viewMode === 'view' || (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, $ejmVg.LAYOUT_COLUMN_PADDING), "px ", (0, $ejmVg.LAYOUT_COLUMN_PADDING) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px;box-sizing:border-box;>div{", $d274b53d45a9ace1$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles(viewMode) : $d274b53d45a9ace1$var$layoutBorderStyles(viewMode), ";}}", (0, $gmhCD.editorExperiment)('advanced_layouts', true) && $d274b53d45a9ace1$var$layoutResponsiveStyles(viewMode), "[data-blocks-drop-target-container]~[data-layout-column]>[data-layout-content]::before{display:none;}.fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, $1v4Xe.tableMarginFullWidthMode), "px;}}}", (0, $gmhCD.editorExperiment)('advanced_layouts', false) && (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $iHYdz.akLayoutGutterOffset) + 8}px 0;
				}`, ";");

});
parcelRegister("719f3", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $2e5d010f6440279f$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $2e5d010f6440279f$export$3afcac98e7ca927d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
function $2e5d010f6440279f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e5d010f6440279f$export$6891a39948814a80 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2e5d010f6440279f$export$3afcac98e7ca927d = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER = 629;
/* jest warning: JSDOM version (22) doesn't support the new @container CSS rule */ const $2e5d010f6440279f$export$f2451ec7aca7656c = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$2e5d010f6440279f$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("8OrBn", function(module, exports) {

$parcel$export(module.exports, "TableCssClassName", () => (parcelRequire("jecUf")).TableCssClassName);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jecUf = parcelRequire("jecUf");

});
parcelRegister("jecUf", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $2e822d78af9e1ad0$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $2e822d78af9e1ad0$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $2e822d78af9e1ad0$export$19a8a7a6488b1b9f);
$parcel$export(module.exports, "ShadowEvent", () => $2e822d78af9e1ad0$export$ce63d9b315ac58c9);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9UDEr = parcelRequire("9UDEr");

var $6gEe5 = parcelRequire("6gEe5");
const $2e822d78af9e1ad0$export$1a38c7157d718094 = 30;
var $2e822d78af9e1ad0$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    return TableDecorations;
}({});
const $2e822d78af9e1ad0$export$19a8a7a6488b1b9f = {
    ...(0, $6gEe5.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $9UDEr.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $9UDEr.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $9UDEr.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $9UDEr.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $9UDEr.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $9UDEr.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $9UDEr.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $9UDEr.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $9UDEr.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $9UDEr.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $9UDEr.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $9UDEr.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $9UDEr.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $9UDEr.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $9UDEr.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $9UDEr.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $9UDEr.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $9UDEr.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $9UDEr.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $9UDEr.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $9UDEr.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $9UDEr.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $9UDEr.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $9UDEr.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $9UDEr.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $9UDEr.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $9UDEr.tableCellSelector),
    TABLE_HEADER_CELL: (0, $9UDEr.tableHeaderSelector),
    TABLE_STICKY: `${(0, $9UDEr.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $9UDEr.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $9UDEr.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $9UDEr.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $9UDEr.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $9UDEr.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $9UDEr.tablePrefixSelector)}-last-row-insert-line__inactive`
};
var $2e822d78af9e1ad0$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});

});


parcelRegister("eTjGD", function(module, exports) {

$parcel$export(module.exports, "tableMarginFullWidthMode", () => (parcelRequire("1v4Xe")).tableMarginFullWidthMode);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1v4Xe = parcelRequire("1v4Xe");

});
parcelRegister("1v4Xe", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundColor", () => $25c191bb2717b458$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $25c191bb2717b458$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $25c191bb2717b458$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $25c191bb2717b458$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $25c191bb2717b458$export$f26d047169b4195d);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $25c191bb2717b458$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $25c191bb2717b458$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $25c191bb2717b458$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $25c191bb2717b458$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $25c191bb2717b458$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $25c191bb2717b458$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $25c191bb2717b458$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $25c191bb2717b458$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $25c191bb2717b458$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $25c191bb2717b458$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $25c191bb2717b458$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $25c191bb2717b458$export$92421f8864c287b1);
$parcel$export(module.exports, "tableMarginFullWidthMode", () => $25c191bb2717b458$export$cbcfa4314b903419);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $25c191bb2717b458$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $25c191bb2717b458$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableDeleteButtonOffset", () => $25c191bb2717b458$export$52b432855099b8bd);
$parcel$export(module.exports, "tableToolbarSize", () => $25c191bb2717b458$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $25c191bb2717b458$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $25c191bb2717b458$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $25c191bb2717b458$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $25c191bb2717b458$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $25c191bb2717b458$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $25c191bb2717b458$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $25c191bb2717b458$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $25c191bb2717b458$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $25c191bb2717b458$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $25c191bb2717b458$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $25c191bb2717b458$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $25c191bb2717b458$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidth", () => $25c191bb2717b458$export$a6ed027d1a83416d);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $25c191bb2717b458$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $25c191bb2717b458$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $25c191bb2717b458$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $25c191bb2717b458$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tableOverflowShadowWidth", () => $25c191bb2717b458$export$40311377f05dbfc4);
$parcel$export(module.exports, "tableOverflowShadowWidthWide", () => $25c191bb2717b458$export$1680d391e1ce7b96);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $25c191bb2717b458$export$3cdde837cf189e96);
$parcel$export(module.exports, "dropTargetsZIndex", () => $25c191bb2717b458$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $25c191bb2717b458$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $25c191bb2717b458$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $25c191bb2717b458$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $25c191bb2717b458$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $25c191bb2717b458$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $25c191bb2717b458$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $25c191bb2717b458$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $25c191bb2717b458$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $25c191bb2717b458$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $25c191bb2717b458$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "colorPalletteColumns", () => $25c191bb2717b458$export$2c18704a8d793cdb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $jecUf = parcelRequire("jecUf");
const $25c191bb2717b458$export$3efa753685336605 = `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $25c191bb2717b458$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableHeaderCellBackground)})`;
const $25c191bb2717b458$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $iHYdz.akEditorTableToolbar)})`;
const $25c191bb2717b458$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $25c191bb2717b458$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`;
const $25c191bb2717b458$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $25c191bb2717b458$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $iHYdz.akEditorTableCellBlanketSelected)})`;
const $25c191bb2717b458$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
const $25c191bb2717b458$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $iHYdz.akEditorTableBorderSelected)})`;
const $25c191bb2717b458$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`;
const $25c191bb2717b458$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
const $25c191bb2717b458$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorTableCellBlanketDeleted)})`;
const $25c191bb2717b458$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
const $25c191bb2717b458$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $829f609a65d26a98$export$b34b069eff244586)})`;
const $25c191bb2717b458$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $25c191bb2717b458$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`;
const $25c191bb2717b458$export$371da7842ff35a5b = 3;
const $25c191bb2717b458$export$e5ff276883773ffd = 8;
const $25c191bb2717b458$export$92421f8864c287b1 = 15;
const $25c191bb2717b458$export$cbcfa4314b903419 = 2;
const $25c191bb2717b458$export$6d23b13c5fcb846c = 20;
const $25c191bb2717b458$export$cb376ed67c7ae37e = 16;
const $25c191bb2717b458$export$52b432855099b8bd = 6;
const $25c191bb2717b458$export$a4d60e31f4f6188b = (0, $iHYdz.akEditorTableToolbarSize);
const $25c191bb2717b458$export$880976487022eb5 = (0, $6gEe5.tableMarginTop) + $25c191bb2717b458$export$e5ff276883773ffd - (0, $6gEe5.tableCellBorderWidth);
const $25c191bb2717b458$export$73b1242ebdcc73be = 3;
const $25c191bb2717b458$export$86dfc955b6099b88 = 32;
const $25c191bb2717b458$export$893fc0cfd2a0c40e = 13;
const $25c191bb2717b458$export$a3e71c692f2c2213 = 4;
const $25c191bb2717b458$export$62374dd2f63076b0 = 25;
const $25c191bb2717b458$export$da0ccd381b1a80f = (0, $iHYdz.akEditorUnitZIndex) * 10;
const $25c191bb2717b458$export$83da30a15600a83e = $25c191bb2717b458$export$da0ccd381b1a80f + 1;
const $25c191bb2717b458$export$45aeeddcedd441ab = (0, $iHYdz.akEditorUnitZIndex) * 10;
const $25c191bb2717b458$export$5b53cc051bf05434 = $25c191bb2717b458$export$83da30a15600a83e + 1;
const $25c191bb2717b458$export$cc7ed656b7dcf729 = 3;
const $25c191bb2717b458$export$72409f838e9c33c7 = (0, $jecUf.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $25c191bb2717b458$export$45d9825f76985b4e = 2;
const $25c191bb2717b458$export$887c1388be90c08e = $25c191bb2717b458$export$da0ccd381b1a80f + (0, $iHYdz.akRichMediaResizeZIndex);
const $25c191bb2717b458$export$3969371f057ce1e5 = 16;
const $25c191bb2717b458$export$a6ed027d1a83416d = 180;
const $25c191bb2717b458$export$42d9040c5091b076 = 250;
const $25c191bb2717b458$export$1279af870a198fea = $25c191bb2717b458$export$887c1388be90c08e + 2;
const $25c191bb2717b458$export$83c60dd0aac17107 = 8;
const $25c191bb2717b458$export$13b0e72269a9a3aa = 1;
const $25c191bb2717b458$export$40311377f05dbfc4 = 8;
const $25c191bb2717b458$export$1680d391e1ce7b96 = 32;
const $25c191bb2717b458$export$3cdde837cf189e96 = 188;
const $25c191bb2717b458$export$b2015400488f9243 = 14;
const $25c191bb2717b458$export$8f6133b6e2b4291 = 9;
const $25c191bb2717b458$export$edb1b9caf8ff5b32 = 10;
const $25c191bb2717b458$export$7af5c65e392a647 = 2;
const $25c191bb2717b458$export$11cf30061861ec4a = 5;
const $25c191bb2717b458$export$858d012f03ae70a5 = -68;
const $25c191bb2717b458$export$a13bd817a2eda041 = 92;
const $25c191bb2717b458$export$e0140c2b978caac5 = 4;
const $25c191bb2717b458$export$c6a9e7014cf7aedc = 6;
const $25c191bb2717b458$export$963fb187132ee7cf = 250;
const $25c191bb2717b458$export$d18320cc8ee69115 = 16;
const $25c191bb2717b458$export$6bec1f8a2aa82be8 = 150;
const $25c191bb2717b458$export$2c18704a8d793cdb = 7;
const $25c191bb2717b458$export$150cd2564fec30b7 = 8;

});



parcelRegister("6UEu0", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $0d5dc640686a6518$export$abd2efc27ac7e809);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9R9Rb = parcelRequire("9R9Rb");

var $ceYEW = parcelRequire("ceYEW");

var $iHYdz = parcelRequire("iHYdz");

var $79PaE = parcelRequire("79PaE");
const $0d5dc640686a6518$export$abd2efc27ac7e809 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $ceYEW.mediaSingleSharedStyleNew), " & [layout='full-width'] .", (0, $ceYEW.richMediaClassName), ",& [layout='wide'] .", (0, $ceYEW.richMediaClassName), "{margin-left:50%;transform:translateX(-50%);}.media-extended-resize-experience[layout^='wrap-']{overflow:visible!important;}& [layout^='wrap-']+[layout^='wrap-']{clear:none;&+p,&+div[class^='fabric-editor-align'],&+ul,&+ol,&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{clear:both!important;}& .", (0, $ceYEW.richMediaClassName), "{margin-left:0;margin-right:0;}}", (0, $9R9Rb.mediaInlineImageStyles), " .mediaSingleView-content-wrap[layout^='wrap-']{max-width:100%;clear:inherit;}.mediaSingleView-content-wrap[layout='wrap-left']{float:left;}.mediaSingleView-content-wrap[layout='wrap-right']{float:right;}.mediaSingleView-content-wrap[layout='wrap-right']+.mediaSingleView-content-wrap[layout='wrap-left']{clear:both;}&>.mediaSingleView-content-wrap{.richMedia-resize-handle-right{margin-right:-", (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide), "px;}.richMedia-resize-handle-left{margin-left:-", (0, $iHYdz.akEditorMediaResizeHandlerPaddingWide), "px;}}}.richMedia-resize-handle-right,.richMedia-resize-handle-left{display:flex;flex-direction:column;justify-content:center;}.richMedia-resize-handle-right{align-items:flex-end;padding-right:var(--ds-space-150, 12px);margin-right:-", (0, $iHYdz.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-left{align-items:flex-start;padding-left:var(--ds-space-150, 12px);margin-left:-", (0, $iHYdz.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{content:' ';display:flex;width:3px;height:64px;border-radius:6px;}.", (0, $ceYEW.richMediaClassName), ":hover .richMedia-resize-handle-left::after,.", (0, $ceYEW.richMediaClassName), ":hover .richMedia-resize-handle-right::after{background:var(--ds-border, #091E4224);}.", (0, $iHYdz.akEditorSelectedNodeClassName), " .richMedia-resize-handle-right::after,.", (0, $iHYdz.akEditorSelectedNodeClassName), " .richMedia-resize-handle-left::after,.", (0, $ceYEW.richMediaClassName), " .richMedia-resize-handle-right:hover::after,.", (0, $ceYEW.richMediaClassName), " .richMedia-resize-handle-left:hover::after,.", (0, $ceYEW.richMediaClassName), ".is-resizing .richMedia-resize-handle-right::after,.", (0, $ceYEW.richMediaClassName), ".is-resizing .richMedia-resize-handle-left::after{background:var(--ds-border-focused, #388BFF);}.__resizable_base__{left:unset!important;width:auto!important;height:auto!important;}.danger>div>div>.media-card-frame,.danger>span>a{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";box-shadow:0px 0px 0px ", (0, $iHYdz.akEditorSelectedBorderBoldSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";transition:background-color 0s,box-shadow 0s;}.danger{.", (0, $ceYEW.richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}.", (0, $ceYEW.richMediaClassName), " .", (0, $79PaE.inlinePlayerClassName), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}.", (0, $ceYEW.richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}.resizer-handle-thumb{background:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}div div .media-card-frame,.inlineCardView-content-wrap>span>a{background-color:var(--ds-blanket-danger, rgb(255, 189, 173, 0.5));transition:background-color 0s;}div div .media-card-frame::after{box-shadow:none;}}.warning{.", (0, $ceYEW.richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $ceYEW.richMediaClassName), " .", (0, $79PaE.inlinePlayerClassName), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $ceYEW.richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px var(--ds-border-warning, #E56910)!important;}.resizer-handle-thumb{background:var(--ds-icon-warning, #E56910)!important;}}.media-filmstrip-list-item{cursor:pointer;}.mediaGroupView-content-wrap.", (0, $iHYdz.akEditorSelectedNodeClassName), " #newFileExperienceWrapper{box-shadow:", (0, $iHYdz.akEditorSelectedBoxShadow), ";}.ak-editor-no-interaction #newFileExperienceWrapper{box-shadow:none;}"); /* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */ 

});
parcelRegister("79PaE", function(module, exports) {

$parcel$export(module.exports, "inlinePlayerClassName", () => $c63e9575ac7419ed$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $c63e9575ac7419ed$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $lv9SR = parcelRequire("lv9SR");

var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $c63e9575ac7419ed$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $5yojI.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, $k5uoT.borderRadius}
      ${selected ? (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $c63e9575ac7419ed$export$70bc5d30fe886af = 'media-card-inline-player';
const $c63e9575ac7419ed$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $f8Sb3.css)("width:", (0, $lv9SR.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $lv9SR.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:", (0, $k5uoT.borderRadius)(), "px;position:relative;max-width:100%;max-height:100%;", $c63e9575ac7419ed$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$c63e9575ac7419ed$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});
parcelRegister("lv9SR", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $d8ce749d15267dc5$export$36acad525b1fb57b);
const $d8ce749d15267dc5$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});


const $6d9332e5e7a86517$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("b3RpZ", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $baaf4c6520958d3a$export$8290cf129669d0cb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aABH4 = parcelRequire("aABH4");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
const $baaf4c6520958d3a$export$8290cf129669d0cb = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", (0, $aABH4.panelSharedStyles)(), ";.", (0, $aABH4.PanelSharedCssClassName).prefix, "{cursor:pointer;&.danger{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, "!important;.", (0, $aABH4.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, "!important;}}}.", (0, $aABH4.PanelSharedCssClassName).content, "{cursor:text;}.danger .", (0, $aABH4.PanelSharedCssClassName).prefix, "{&[data-panel-type]{background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";.", (0, $aABH4.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $iHYdz.akEditorDeleteIconColor)})`, ";}}}}.", (0, $aABH4.PanelSharedCssClassName).prefix, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow,
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";}", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, $aABH4.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, $aABH4.PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`, ";", (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, $aABH4.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, $aABH4.PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`, ";");

});

parcelRegister("aUTD3", function(module, exports) {

$parcel$export(module.exports, "vanillaStatusStyles", () => $2df8a0e92b077e8e$export$5393c24101671903);
$parcel$export(module.exports, "statusStyles", () => $2df8a0e92b077e8e$export$79c8c9ad308bbe07);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kZxLT = parcelRequire("kZxLT");
var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");
function $2df8a0e92b077e8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $2df8a0e92b077e8e$var$getVisualRefreshStatusStyles = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:", (0, $iHYdz.akEditorSelectedBoldBoxShadow), ";}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("&.", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).BoxShadow
    ]), ";}");
var $2df8a0e92b077e8e$var$_ref = {
    name: "1qcr8hm",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-wrapper{background-color:var(--ds-background-neutral, #091E420F);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-text{color:var(--ds-text-subtle, #44546F);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-wrapper{background-color:var(--ds-background-discovery, #F3F0FF);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-text{color:var(--ds-text-discovery, #5E4DB2);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-wrapper{background-color:var(--ds-background-information, #E9F2FF);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-text{color:var(--ds-text-information, #0055CC);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-wrapper{background-color:var(--ds-background-warning, #FFF7D6);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-text{color:var(--ds-text-warning, #A54800);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-wrapper{background-color:var(--ds-background-danger, #FFECEB);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-text{color:var(--ds-text-danger, #AE2E24);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-wrapper{background-color:var(--ds-background-success, #DCFFF1);}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-text{color:var(--ds-text-success, #216E4E);}"
};
var $2df8a0e92b077e8e$var$_ref2 = {
    name: "lq7sbf",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] .lozenge-text{color:#292A2E;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=neutral] > .lozenge-wrapper{background-color:#DDDEE1;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=purple] > .lozenge-wrapper{background-color:#D8A0F7;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=blue] > .lozenge-wrapper{background-color:#8FB8F6;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=yellow] > .lozenge-wrapper{background-color:#F9C84E;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=red] > .lozenge-wrapper{background-color:#FD9891;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"status\"] > [data-color=green] > .lozenge-wrapper{background-color:#B3DF72;}"
};
const $2df8a0e92b077e8e$var$getStatusColors = ()=>(0, $VSDnB.fg)('platform-component-visual-refresh') ? $2df8a0e92b077e8e$var$_ref2 : $2df8a0e92b077e8e$var$_ref;
const $2df8a0e92b077e8e$var$baseVanillaStatusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        borderRadius: '3px',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $2df8a0e92b077e8e$export$5393c24101671903 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($2df8a0e92b077e8e$var$baseVanillaStatusStyles, " ", $2df8a0e92b077e8e$var$getStatusColors(), ";");
const $2df8a0e92b077e8e$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $6gEe5.TableSharedCssClassName).TABLE_CELL_WRAPPER, ",.", (0, $6gEe5.TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER, ",[data-layout-section]{.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, "{max-width:100%;line-height:0;>span{width:100%;}}}.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, "{", $2df8a0e92b077e8e$var$getVisualRefreshStatusStyles(), ";>span{cursor:pointer;line-height:0;}}.danger{.", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{background-color:", (0, $iHYdz.akEditorDeleteBackgroundWithOpacity), ";}.", (0, $kZxLT.StatusSharedCssClassName).STATUS_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), " .", (0, $kZxLT.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";}}");

});
parcelRegister("kZxLT", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $1b48498df0149da7$export$b18e58a1c082b710);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $1b48498df0149da7$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};

});


parcelRegister("5L329", function(module, exports) {

$parcel$export(module.exports, "taskDecisionStyles", () => $f9553b9bb33991d4$export$6083a263609cde43);
$parcel$export(module.exports, "vanillaTaskDecisionStyles", () => $f9553b9bb33991d4$export$7ac91fa205fa129a);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithVisualRefresh", () => $f9553b9bb33991d4$export$eab9dc0cfe87f6c3);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithoutVisualRefresh", () => $f9553b9bb33991d4$export$ac2a2eaab13bfe49);
$parcel$export(module.exports, "vanillaTaskItemStyles", () => $f9553b9bb33991d4$export$5d2a537111c20a83);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1bQ0V = parcelRequire("1bQ0V");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");
function $f9553b9bb33991d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9553b9bb33991d4$export$6083a263609cde43 = /*#__PURE__*/ (0, $f8Sb3.css)("[data-decision-wrapper]{cursor:pointer;}.", (0, $iHYdz.akEditorSelectedNodeClassName), ">[data-decision-wrapper],ol[data-node-type='decisionList'].", (0, $iHYdz.akEditorSelectedNodeClassName), "{border-radius:4px;", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).BoxShadow,
    (0, $bzmFE.SelectionStyle).Blanket
]), ";}.danger{.", (0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER, ".", (0, $iHYdz.akEditorSelectedNodeClassName), ">div{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $iHYdz.akEditorDeleteBackgroundWithOpacity)})`, ";&::after{content:none;}}}");
const $f9553b9bb33991d4$export$7ac91fa205fa129a = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $f9553b9bb33991d4$export$eab9dc0cfe87f6c3 = {
    name: "yu3jaj",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $f9553b9bb33991d4$export$ac2a2eaab13bfe49 = {
    name: "14ovu2b",
    styles: "[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-view-type=\"vanilla\"][data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $f9553b9bb33991d4$export$5d2a537111c20a83 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]:has([data-empty]):not(:has([data-type-ahead])) [data-component="placeholder"]': {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] .${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});


parcelRegister("eq0pk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d083f891c71c0e7$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
                                                                                                                                                                                                                                                                                   * @jsxRuntime classic
                                                                                                                                                                                                                                                                                   * @jsx jsx
                                                                                                                                                                                                                                                                                   */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
var $g0wej = parcelRequire("g0wej");

var $gE8f9 = parcelRequire("gE8f9");

var $eAVGd = parcelRequire("eAVGd");

var $bYYy3 = parcelRequire("bYYy3");
var $jlYLw = parcelRequire("jlYLw");
parcelRequire("6jI8m");
var $2uCrC = parcelRequire("2uCrC");
parcelRequire("9wwua");
var $RhFwz = parcelRequire("RhFwz");
parcelRequire("3p7sF");
var $6pErt = parcelRequire("6pErt");
parcelRequire("eXo2J");
var $2yMev = parcelRequire("2yMev");
parcelRequire("7uhma");
var $cipm3 = parcelRequire("cipm3");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hxoiH = parcelRequire("hxoiH");

var $fz5RS = parcelRequire("fz5RS");

var $cBEjw = parcelRequire("cBEjw");

var $hucfL = parcelRequire("hucfL");

var $b3RpZ = parcelRequire("b3RpZ");

var $aUTD3 = parcelRequire("aUTD3");

var $5L329 = parcelRequire("5L329");

var $3ocoR = parcelRequire("3ocoR");

var $4XLx3 = parcelRequire("4XLx3");

var $4K18w = parcelRequire("4K18w");

var $k6XMu = parcelRequire("k6XMu");

var $evQkh = parcelRequire("evQkh");

var $agmiM = parcelRequire("agmiM");

var $kRg9j = parcelRequire("kRg9j");

var $ftikQ = parcelRequire("ftikQ");

var $leSmY = parcelRequire("leSmY");

var $AvhE9 = parcelRequire("AvhE9");

var $3rVzC = parcelRequire("3rVzC");

var $abFhg = parcelRequire("abFhg");

var $4dQ9D = parcelRequire("4dQ9D");

var $8lqK0 = parcelRequire("8lqK0");

var $3Ab0J = parcelRequire("3Ab0J");

var $48I7C = parcelRequire("48I7C");

var $bpyDZ = parcelRequire("bpyDZ");

var $5WJgZ = parcelRequire("5WJgZ");

var $jSEpg = parcelRequire("jSEpg");

var $7MDnl = parcelRequire("7MDnl");

var $dO5G8 = parcelRequire("dO5G8");

var $gVpk5 = parcelRequire("gVpk5");

var $lfF6s = parcelRequire("lfF6s");

var $iqJDL = parcelRequire("iqJDL");

var $i9LjJ = parcelRequire("i9LjJ");

var $7ei03 = parcelRequire("7ei03");

var $eMf5t = parcelRequire("eMf5t");
function $3d083f891c71c0e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3d083f891c71c0e7$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $3d083f891c71c0e7$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $3d083f891c71c0e7$var$placeholderOverflowStyles = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $3d083f891c71c0e7$var$placeholderWrapStyles = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $3d083f891c71c0e7$var$akEditorBreakpointForSmallDevice = `1266px`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
var $3d083f891c71c0e7$var$_ref = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};
var $3d083f891c71c0e7$var$_ref2 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $3d083f891c71c0e7$var$_ref3 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $3d083f891c71c0e7$var$_ref4 = {
    name: "u7i8rn",
    styles: ".ProseMirror[contenteditable='false'] .taskItemView-content-wrap{pointer-events:none;opacity:0.7;}"
};
const $3d083f891c71c0e7$var$contentStyles = ()=>/*#__PURE__*/ (0, $f8Sb3.css)("--ak-editor--default-gutter-padding:", (0, $iHYdz.akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:", (0, $iHYdz.akEditorGutterPaddingDynamic)(), "px;--ak-editor--default-layout-width:", (0, $iHYdz.akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, $iHYdz.akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);}.ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding));}.ProseMirror>div[data-prosemirror-node-block] [data-prosemirror-node-block]{--ak-editor-max-container-width:100%;}@container editor-area (width >= ", $3d083f891c71c0e7$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, $iHYdz.akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:var(--ak-editor-base-font-size);", (0, $eMf5t.whitespaceStyles), ";", (0, $jlYLw.listsSharedStyles), ";", (0, $abFhg.indentationStyles), ";", (0, $dO5G8.shadowStyles), ";", (0, $fz5RS.InlineNodeViewSharedStyles), ";}", (0, $VSDnB.fg)('editor_request_to_edit_task') ? null : $3d083f891c71c0e7$var$_ref4, " .ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}", (0, $VSDnB.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? $3d083f891c71c0e7$var$_ref3 : null, (0, $gmhCD.editorExperiment)('platform_editor_advanced_code_blocks', true) ? $3d083f891c71c0e7$var$_ref2 : null, " .ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}", (0, $2yMev.placeholderTextStyles), " ", $3d083f891c71c0e7$export$d3bdc0d52bb6c2c8, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $3d083f891c71c0e7$var$placeholderOverflowStyles : null, " ", (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_quick_insert_placeholder') ? $3d083f891c71c0e7$var$placeholderWrapStyles : null, " ", (0, $evQkh.codeBlockStyles), " ", (0, $2uCrC.blocktypeStyles)(), " ", (0, $agmiM.codeMarkStyles), " ", (0, $i9LjJ.textColorStyles), " ", (0, $4K18w.backgroundColorStyles), " ", (0, $3Ab0J.listsStyles), " ", (0, $7MDnl.ruleStyles), " ", (0, $48I7C.mediaStyles), " ", (0, $VSDnB.fg)('confluence_team_presence_scroll_to_pointer') ? (0, $iqJDL.telepointerStyle) : (0, $iqJDL.telepointerStyleWithInitialOnly), (0, $iqJDL.telepointerColorAndCommonStyle), " ", (0, $eAVGd.gapCursorStyles), ";", (0, $b3RpZ.panelStyles)(), " ", (0, $bpyDZ.mentionsStyles), " ", (0, $lfF6s.tasksAndDecisionsStyles), " ", (0, $3rVzC.gridStyles), " ", (0, $k6XMu.blockMarksStyles), " ", (0, $kRg9j.dateStyles), " ", (0, $hucfL.extensionStyles), " ", (0, $cBEjw.expandStyles)(), " ", (0, $RhFwz.findReplaceStyles), " ", (0, $6pErt.textHighlightStyle), " ", (0, $5L329.taskDecisionStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskItemStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $5L329.vanillaTaskDecisionStyles), (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithVisualRefresh), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $5L329.vanillaTaskDecisionIconWithoutVisualRefresh), " ", (0, $aUTD3.statusStyles), " ", (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $aUTD3.vanillaStatusStyles)() : null, " ", (0, $4XLx3.annotationStyles), " ", (0, $gVpk5.smartCardStyles), " ", (0, $ftikQ.embedCardStyles), " ", (0, $7ei03.unsupportedStyles), " ", (0, $jSEpg.resizerStyles), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar{padding:0;}", !(0, $VSDnB.fg)('platform-visual-refresh-icons') ? $3d083f891c71c0e7$var$_ref : null, ";");
const $3d083f891c71c0e7$var$CommentEditorMargin = 14;
// Originally copied from packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx
const $3d083f891c71c0e7$var$commentEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$3d083f891c71c0e7$var$CommentEditorMargin - (0, $bYYy3.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $cipm3.tableCommentEditorStyles));
// Originally copied from scrollStyles in packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts
const $3d083f891c71c0e7$var$fullPageEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4038285048829feb$export$b2380b18b089518f));
const $3d083f891c71c0e7$var$listLayoutShiftFix = {
    name: "123m56l",
    styles: ".ProseMirror ul, .ProseMirror ol{margin-top:10px;}"
};
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $3d083f891c71c0e7$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance } = props;
    const theme = (0, $g0wej.u)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width';
    const isComment = appearance === 'comment';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        css: [
            $3d083f891c71c0e7$var$contentStyles(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4dQ9D.layoutBaseStyles)(),
            (0, $VSDnB.fg)('linking_platform_smart_links_in_live_pages') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $gVpk5.smartLinksInLivePagesStyles) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $gVpk5.smartLinksInLivePagesStylesOld),
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $gVpk5.linkingVisualRefreshV1Styles),
            (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kRg9j.dateVanillaStyles),
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? (0, $VSDnB.fg)('platform-dst-jira-web-fonts') || (0, $VSDnB.fg)('confluence_typography_refreshed') || (0, $VSDnB.fg)('atlas_editor_typography_refreshed') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5WJgZ.paragraphStylesUGCRefreshed) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5WJgZ.paragraphStylesUGCModernized) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5WJgZ.paragraphStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? (0, $8lqK0.linkStyles) : (0, $8lqK0.linkStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $gE8f9.browser).safari && (0, $3Ab0J.listsStylesSafariFix),
            (0, $gmhCD.editorExperiment)('platform_editor_breakout_resizing', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jSEpg.pragmaticResizerStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3ocoR.aiPanelBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $3d083f891c71c0e7$var$isFirefox && (0, $3ocoR.aiPanelBaseFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $3ocoR.aiPanelDarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $3d083f891c71c0e7$var$isFirefox && (0, $3ocoR.aiPanelDarkFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $4dQ9D.layoutViewStyles),
            isComment && $3d083f891c71c0e7$var$commentEditorStyles,
            isFullPage && $3d083f891c71c0e7$var$fullPageEditorStyles,
            (0, $VSDnB.fg)('platform_editor_ssr_fix_lists') && $3d083f891c71c0e7$var$listLayoutShiftFix,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $evQkh.firstCodeBlockWithNoMargin) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $evQkh.firstCodeBlockWithNoMarginOld),
            (0, $VSDnB.fg)('platform_editor_element_dnd_nested_fix_patch_6') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $AvhE9.firstBlockNodeStyles) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $AvhE9.firstBlockNodeStylesOld),
            (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
                exposure: false
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bpyDZ.vanillaMentionsStyles),
            (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
                exposure: false
            }) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bpyDZ.vanillaMentionsSelectionStyles),
            (0, $gmhCD.editorExperiment)('platform_editor_vanilla_dom', true, {
                exposure: false
            }) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $leSmY.vanillaEmojiStyles) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $leSmY.reactEmojiStyles)
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--ak-editor-base-font-size': `${(0, $iHYdz.editorFontSize)({
                theme: theme
            })}px`
        }
    }, children);
});
var $3d083f891c71c0e7$export$2e2bcd8739ae039 = $3d083f891c71c0e7$var$EditorContentContainer;

});
parcelRegister("7uhma", function(module, exports) {

$parcel$export(module.exports, "tableFullPageEditorStyles", () => (parcelRequire("cipm3")).tableFullPageEditorStyles);
$parcel$export(module.exports, "tableCommentEditorStyles", () => (parcelRequire("cipm3")).tableCommentEditorStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cipm3 = parcelRequire("cipm3");

});
parcelRegister("cipm3", function(module, exports) {

$parcel$export(module.exports, "insertColumnButtonOffset", () => $ba57a0e7ca2009cd$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $ba57a0e7ca2009cd$export$e938d6f191645a3e);
$parcel$export(module.exports, "tableFullPageEditorStyles", () => $ba57a0e7ca2009cd$export$b0d19c9126eaec7a);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $ba57a0e7ca2009cd$export$61a2da566f69d1df);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $6gEe5 = parcelRequire("6gEe5");


var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");


var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $MDErT = parcelRequire("MDErT");
const $ba57a0e7ca2009cd$var$cornerControlHeight = (0, $1v4Xe.tableToolbarSize) + 1;
const $ba57a0e7ca2009cd$export$af45328890cf2a82 = (0, $1v4Xe.tableInsertColumnButtonSize) / 2;
const $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 = 44;
const $ba57a0e7ca2009cd$var$rangeSelectionStyles = `
.${(0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $iHYdz.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket,
    (0, $bzmFE.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $ba57a0e7ca2009cd$var$sentinelStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $1v4Xe.columnControlsDecorationHeight)}px;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $1v4Xe.tableScrollbarOffset) + (0, $1v4Xe.stickyRowOffsetTop) + (0, $1v4Xe.tablePadding) * 2 + 23}px;
  }
  &.${(0, $jecUf.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $1v4Xe.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $1v4Xe.columnControlsDecorationHeight) + $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $iHYdz.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles = `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $ba57a0e7ca2009cd$var$stickyScrollbarStyles = `${$ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles} ${$ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles}`;
const $ba57a0e7ca2009cd$var$shadowSentinelStyles = `
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $ba57a0e7ca2009cd$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(">*:not([data-mark-type='fragment']) .", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $ba57a0e7ca2009cd$var$viewModeSortStyles = ()=>{
    return (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? /*#__PURE__*/ (0, $f8Sb3.css)("th{.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":hover)){>.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}}") : /*#__PURE__*/ (0, $f8Sb3.css)("th{.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}&:has(.is-active){.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}&:hover{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}");
};
const $ba57a0e7ca2009cd$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $1v4Xe.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    /*
     This is MAGIC!
     This fixes a bug which occurs in firefox when the first row becomes sticky.
     see https://product-fabric.atlassian.net/browse/ED-19177
   */ if ((0, $gE8f9.browser).gecko) return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $ba57a0e7ca2009cd$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $6gEe5.tableSharedStyle)(), ";", (0, $MDErT.columnControlsLineMarker)(), ";", (0, $MDErT.hoveredDeleteButton)(), ";", (0, $MDErT.hoveredCell)(), ";", (0, $MDErT.hoveredWarningCell), ";", (0, $MDErT.insertLine)(), ";", (0, $MDErT.resizeHandle)(), ";", $ba57a0e7ca2009cd$var$rangeSelectionStyles, ";", $ba57a0e7ca2009cd$var$viewModeSortStyles(), ";.", (0, $jecUf.TableCssClassName).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $jecUf.TableCssClassName).TABLE_CELL, "{background-color:", (0, $1v4Xe.tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";border-bottom:1px solid ", (0, $1v4Xe.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $MDErT.insertColumnButtonWrapper)(), ";}.", (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $MDErT.insertRowButtonWrapper)(), ";}", (0, $MDErT.dragInsertButtonWrapper)(), " ", (0, $MDErT.dragCornerControlButton)(), (0, $MDErT.DeleteButton)(), (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {` : `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {`}
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.stickyRowOffsetTop) : (0, $1v4Xe.stickyRowOffsetTop) + 2}px;
			width: ${0, $iHYdz.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $iHYdz.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $1v4Xe.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		` : `
    	.${(0, $jecUf.TableCssClassName).TABLE_STICKY} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN} .${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.stickyRowOffsetTop) : (0, $1v4Xe.stickyRowOffsetTop) + 2}px;
			width: ${0, $iHYdz.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $iHYdz.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $1v4Xe.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		`, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $iHYdz.akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, $1v4Xe.tableToolbarSize), "px;height:", (0, $1v4Xe.tableToolbarSize), "px;}.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $1v4Xe.tableToolbarSize), "px;width:", (0, $1v4Xe.tableToolbarSize), "px;}", $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).ROW_CONTROLS, " .", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $iHYdz.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $1v4Xe.tableToolbarSize), "px solid var(--ds-surface, white);margin-left:-", (0, $1v4Xe.tableToolbarSize), "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, $1v4Xe.stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ".", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $1v4Xe.tableToolbarSize), "px;}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $jecUf.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $jecUf.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $1v4Xe.stickyHeaderBorderBottomWidth), "px solid ", (0, $1v4Xe.tableBorderColor), ";margin-right:-1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $ba57a0e7ca2009cd$export$af45328890cf2a82 + 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $1v4Xe.resizeHandlerAreaWidth) - (0, $1v4Xe.resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $1v4Xe.resizeHandlerAreaWidth) - (0, $1v4Xe.resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, $jecUf.TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{z-index:1;}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $1v4Xe.tableControlsSpacing), "px;}", (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $jecUf.TableCssClassName).WITH_CONTROLS}.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) : (0, $1v4Xe.tableControlsSpacing) + 2}px;
		}
		` : `
		.${(0, $jecUf.TableCssClassName).WITH_CONTROLS}.${(0, $jecUf.TableCssClassName).TABLE_STICKY}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) : (0, $1v4Xe.tableControlsSpacing) + 2}px;
		}
		`, " .", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) - (0, $1v4Xe.tableToolbarSize) : (0, $1v4Xe.tableControlsSpacing) - (0, $1v4Xe.tableToolbarSize) + 2, "px solid var(--ds-surface, white);}", $ba57a0e7ca2009cd$var$sentinelStyles, " ", (0, $MDErT.OverflowShadow)(props.featureFlags?.tableDragAndDrop), " ", $ba57a0e7ca2009cd$var$stickyScrollbarStyles, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $1v4Xe.tablePadding), "px;.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $1v4Xe.tablePadding), "px;&::after{right:6px!important;}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $1v4Xe.tablePadding), "px;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) + (0, $1v4Xe.tablePadding) - 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{width:", (0, $1v4Xe.tableOverflowShadowWidth), "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:8px;}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ".", (0, $jecUf.TableCssClassName).TABLE_CHROMELESS, "{left:calc(100% - 16px);}}>.", (0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $ba57a0e7ca2009cd$var$breakoutWidthStyling(), " ", (0, $MDErT.columnControlsDecoration)(), ";", (0, $MDErT.rowControlsWrapperDotStyle)(), ";.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, "{width:", (0, $1v4Xe.tableToolbarSize) + 1, "px;height:", $ba57a0e7ca2009cd$var$cornerControlHeight, "px;display:none;.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $MDErT.InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $1v4Xe.tableToolbarSize) + 1, "px;height:", (0, $1v4Xe.tableToolbarSize) + 1, "px;border:1px solid ", (0, $1v4Xe.tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, $1v4Xe.tableBorderRadiusSize), "px;background:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background:", (0, $1v4Xe.tableToolbarSelectedColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ",.", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, $iHYdz.akEditorTableToolbarSize) + (0, $iHYdz.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, " .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background:", (0, $1v4Xe.tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";background:", (0, $1v4Xe.tableToolbarDeleteColor), ";}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{width:", (0, $1v4Xe.tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, $MDErT.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $MDErT.HeaderButton)(`
        border-bottom: 1px solid ${(0, $1v4Xe.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $1v4Xe.tableToolbarSize)}px;

        .${(0, $jecUf.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $jecUf.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $1v4Xe.tableBorderRadiusSize), "px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $VSDnB.fg)('platform_editor_table_column_selected_state_fix') ? (0, $1v4Xe.rowControlsZIndex) + 4 : (0, $iHYdz.akEditorUnitZIndex), ";.", (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:24px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:24px;width:100%;}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, $jecUf.TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, $MDErT.floatingColumnControls)(), " :not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{", (0, $MDErT.HeaderButtonHover)(), " ", (0, $MDErT.HeaderButtonDanger)(), ";}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $iHYdz.akEditorTableToolbarSize), "px;top:", ((0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? props.isDragAndDropEnabled : props.featureFlags?.tableDragAndDrop) || (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, $iHYdz.akEditorTableToolbarSize), "px;width:", (0, $iHYdz.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $1v4Xe.tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:10px 2px;text-align:center;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";background-color:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";color:", (0, $1v4Xe.tableTextColor), ";border-color:", (0, $1v4Xe.tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}", (0, $VSDnB.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER} {
				.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {` : `.${(0, $jecUf.TableCssClassName).TABLE_STICKY} > .${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} {
				.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {`}
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		` : `
		.${(0, $jecUf.TableCssClassName).TABLE_STICKY} {
			.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		`, " .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{.", (0, $jecUf.TableCssClassName).CORNER_CONTROLS, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-bottom:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}}:not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{border-bottom:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}.", (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`, ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after,.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $iHYdz.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "{border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $1v4Xe.tableCellSelectedColor), ";z-index:", (0, $iHYdz.akEditorSmallZIndex), ";}th.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}td.", (0, $jecUf.TableCssClassName).HOVERED_CELL, ",td.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $iHYdz.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}&.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $6gEe5.tableMarginTop), "px;left:-", (0, $1v4Xe.tableToolbarSize) + 1, "px;", (0, $VSDnB.fg)('platform_editor_table_column_selected_state_fix') ? '' : `z-index: ${(0, $1v4Xe.rowControlsZIndex) + 4}`, ";}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled && (0, $VSDnB.fg)('platform_editor_numbered_column_misalignment') ? `
			margin-top: ${0, $6gEe5.tableMarginTop}px;
			top: 0;
			left: -${(0, $1v4Xe.tableToolbarSize) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $6gEe5.tableMarginTop) - $ba57a0e7ca2009cd$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $1v4Xe.tableToolbarSize}px;
		`, ";}.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, ".", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $6gEe5.tableMarginTop), "px;}.", (0, $jecUf.TableCssClassName).TABLE_STICKY, " .", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $VSDnB.fg)('platform_editor_nested_table_drag_controls') ? `
		.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER} {
			.${(0, $jecUf.TableCssClassName).TABLE_STICKY} .${(0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
				position: absolute;
				z-index: ${0, $iHYdz.akEditorUnitZIndex};
			}
		}
		` : '', " .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}");
const $ba57a0e7ca2009cd$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", $ba57a0e7ca2009cd$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, $jecUf.TableCssClassName).IS_RESIZING, "{.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $4038285048829feb$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $jecUf.TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}", $ba57a0e7ca2009cd$var$shadowSentinelStyles, ";");
const $ba57a0e7ca2009cd$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $ba57a0e7ca2009cd$export$61a2da566f69d1df = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror .", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $4038285048829feb$export$b2380b18b089518f), ";}");

});
const $f32dbb5556fcfa26$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $f32dbb5556fcfa26$export$fb5c0ba8f0806db1 = 'is-disabled';
const $f32dbb5556fcfa26$export$665a01df2c44393a = 'data-sort-index';

parcelRegister("MDErT", function(module, exports) {

$parcel$export(module.exports, "InsertMarker", () => $d31b53cc0f00ae8f$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $d31b53cc0f00ae8f$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $d31b53cc0f00ae8f$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $d31b53cc0f00ae8f$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $d31b53cc0f00ae8f$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $d31b53cc0f00ae8f$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $d31b53cc0f00ae8f$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $d31b53cc0f00ae8f$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $d31b53cc0f00ae8f$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "OverflowShadow", () => $d31b53cc0f00ae8f$export$f802e22253ad2b2c);
$parcel$export(module.exports, "floatingColumnControls", () => $d31b53cc0f00ae8f$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $d31b53cc0f00ae8f$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $d31b53cc0f00ae8f$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $d31b53cc0f00ae8f$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $d31b53cc0f00ae8f$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $d31b53cc0f00ae8f$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $d31b53cc0f00ae8f$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $d31b53cc0f00ae8f$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
const $d31b53cc0f00ae8f$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, $1v4Xe.tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";", cssString, ";}");
const $d31b53cc0f00ae8f$var$Marker = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $1v4Xe.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $1v4Xe.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $1v4Xe.lineMarkerSize)}px`,
        borderRadius: '50%',
        pointerEvents: 'none'
    });
const $d31b53cc0f00ae8f$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_MARKER, "{", $d31b53cc0f00ae8f$var$Marker(), ";", cssString, ";}");
const $d31b53cc0f00ae8f$var$Button = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)("border-radius:var(--ds-border-radius, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $d31b53cc0f00ae8f$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{background:", (0, $1v4Xe.tableHeaderCellBackgroundColor), ";border:1px solid ", (0, $1v4Xe.tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";}");
const $d31b53cc0f00ae8f$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, $1v4Xe.tableToolbarSelectedColor), ";border-color:", (0, $1v4Xe.tableBorderSelectedColor), ";cursor:pointer;}");
const $d31b53cc0f00ae8f$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";position:relative;z-index:", (0, $iHYdz.akEditorUnitZIndex), ";}");
const $d31b53cc0f00ae8f$var$InsertButton = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, $1v4Xe.tableInsertColumnButtonSize), "px;width:", (0, $1v4Xe.tableInsertColumnButtonSize), "px;}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};
      color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    `), ";}.", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
const $d31b53cc0f00ae8f$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $iHYdz.akEditorUnitZIndex) + 10, ";}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $1v4Xe.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $1v4Xe.dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $d31b53cc0f00ae8f$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $iHYdz.akEditorUnitZIndex) * 99, ";&.active .", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
const $d31b53cc0f00ae8f$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $d31b53cc0f00ae8f$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $d31b53cc0f00ae8f$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, $1v4Xe.tableInsertColumnButtonSize) - 1}px;
  `));
const $d31b53cc0f00ae8f$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $d31b53cc0f00ae8f$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, $1v4Xe.tableDeleteButtonSize), "px;width:", (0, $1v4Xe.tableDeleteButtonSize), "px;}.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
        background: ${(0, $1v4Xe.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $1v4Xe.tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $1v4Xe.tableCellHoverDeleteIconBackground), ";color:", (0, $1v4Xe.tableCellHoverDeleteIconColor), ";cursor:pointer;}");
const $d31b53cc0f00ae8f$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $6gEe5.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $6gEe5.tableMarginTop), "px;z-index:", (0, $iHYdz.akEditorShadowZIndex), ";width:", (0, $1v4Xe.tableOverflowShadowWidthWide), "px;}.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW, ").", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, $1v4Xe.tableOverflowShadowWidthWide), "px);}.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, "{", $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}");
const $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $6gEe5.tableMarginTopWithControl), "px);top:", (0, $6gEe5.tableMarginTopWithControl), "px;}");
};
const $d31b53cc0f00ae8f$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $1v4Xe.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $d31b53cc0f00ae8f$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $1v4Xe.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $1v4Xe.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $1v4Xe.columnControlsSelectedZIndex)
    });
const $d31b53cc0f00ae8f$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr th:last-child .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $d31b53cc0f00ae8f$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $d31b53cc0f00ae8f$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("div.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ">.", (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $jecUf.TableCssClassName).WITH_CONTROLS, ">.", (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;right:-1px;}");
};
const $d31b53cc0f00ae8f$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $1v4Xe.columnControlsDecorationHeight) + (0, $6gEe5.tableCellBorderWidth), "px;height:", (0, $1v4Xe.columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, $1v4Xe.tableBorderColor), ";position:absolute;height:", (0, $1v4Xe.lineMarkerSize), "px;width:", (0, $1v4Xe.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $d31b53cc0f00ae8f$var$columnHeaderButton(`
        border-right: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        border-top: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        border-bottom: ${(0, $6gEe5.tableCellBorderWidth)}px solid ${(0, $1v4Xe.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $1v4Xe.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $1v4Xe.columnControlsDecorationHeight) - (0, $1v4Xe.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $1v4Xe.columnControlsZIndex)};
      `), ";}}", $d31b53cc0f00ae8f$var$getFloatingDotOverrides(), " .", (0, $jecUf.TableCssClassName).WITH_CONTROLS, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_TABLE, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";border-left:", (0, $6gEe5.tableCellBorderWidth), "px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";left:-", (0, $6gEe5.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $jecUf.TableCssClassName).HOVERED_COLUMN, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $1v4Xe.tableToolbarDeleteColor), ";border-color:", (0, $1v4Xe.tableBorderDeleteColor), ";border-left:", (0, $6gEe5.tableCellBorderWidth), "px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";left:-", (0, $6gEe5.tableCellBorderWidth), "px;z-index:", (0, $iHYdz.akEditorUnitZIndex) * 100, ";}}}.", (0, $jecUf.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, $jecUf.TableCssClassName).TABLE_CELL, ",.", (0, $jecUf.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, $jecUf.TableCssClassName).TABLE_HEADER_CELL, "{.", (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}}");
};
const $d31b53cc0f00ae8f$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ".", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, $jecUf.TableCssClassName).SELECTED_CELL, ",.", (0, $jecUf.TableCssClassName).COLUMN_SELECTED, ",.", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}.", (0, $jecUf.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";}.", (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}th.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $1v4Xe.tableCellDeleteColor), ";border:1px solid ", (0, $1v4Xe.tableBorderDeleteColor), ";}}}");
const $d31b53cc0f00ae8f$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(":not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, $jecUf.TableCssClassName).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $1v4Xe.tableBorderSelectedColor), ";}.", (0, $jecUf.TableCssClassName).HOVERED_CELL, ".", (0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $1v4Xe.tableBorderColor), ";}}");
const $d31b53cc0f00ae8f$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $f8Sb3.css)(":not(.", (0, $jecUf.TableCssClassName).IS_RESIZING, ") .", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, $jecUf.TableCssClassName).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)})`, ";}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $d31b53cc0f00ae8f$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)("th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;}td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";}th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $1v4Xe.resizeLineWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);background-color:", (0, $1v4Xe.tableBorderSelectedColor), ";z-index:", (0, $1v4Xe.columnControlsZIndex) * 2, ";top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;}");
};
const $d31b53cc0f00ae8f$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{.", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $1v4Xe.resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, $1v4Xe.resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}tr th:last-child .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $1v4Xe.resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $1v4Xe.resizeHandlerZIndex), ";}", $d31b53cc0f00ae8f$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px;height:calc(100% + ", (0, $1v4Xe.tableToolbarSize) + (0, $6gEe5.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $6gEe5.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $1v4Xe.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1v4Xe.columnControlsZIndex) * 2
});
const $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $1v4Xe.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $6gEe5.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1v4Xe.columnControlsZIndex) * 2
});
const $d31b53cc0f00ae8f$var$insertLineActiveColor = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $1v4Xe.tableBorderSelectedColor)
});
const $d31b53cc0f00ae8f$var$insertLineInactiveColor = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`
});
const $d31b53cc0f00ae8f$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{td.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $6gEe5.tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}}");

});



parcelRegister("3ocoR", function(module, exports) {

$parcel$export(module.exports, "aiPanelBaseStyles", () => $c83e278a52b553dc$export$7d2a5652980d3808);
$parcel$export(module.exports, "aiPanelBaseFirefoxStyles", () => $c83e278a52b553dc$export$541b06daf7fd8fce);
$parcel$export(module.exports, "aiPanelDarkStyles", () => $c83e278a52b553dc$export$9a2d17c0df63f635);
$parcel$export(module.exports, "aiPanelDarkFirefoxStyles", () => $c83e278a52b553dc$export$18b242302a502e32);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $c83e278a52b553dc$var$rotationAnimation = (0, $f8Sb3.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $c83e278a52b553dc$var$rotationAnimationFirefox = (0, $f8Sb3.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $c83e278a52b553dc$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $c83e278a52b553dc$var$aiPrismColorStep1Light = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.1']['light'];
const $c83e278a52b553dc$var$aiPrismColorStep2Light = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.2']['light'];
const $c83e278a52b553dc$var$aiPrismColorStep3Light = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.3']['light'];
const $c83e278a52b553dc$var$aiPrismColorStep4Light = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.4']['light'];
const $c83e278a52b553dc$var$aiPrismColorStep1Dark = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.1']['dark'];
const $c83e278a52b553dc$var$aiPrismColorStep2Dark = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.2']['dark'];
const $c83e278a52b553dc$var$aiPrismColorStep3Dark = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.3']['dark'];
const $c83e278a52b553dc$var$aiPrismColorStep4Dark = $c83e278a52b553dc$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c83e278a52b553dc$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$c83e278a52b553dc$var$aiPrismColorStep1Light} 0%, ${$c83e278a52b553dc$var$aiPrismColorStep2Light} 12%, ${$c83e278a52b553dc$var$aiPrismColorStep3Light} 24%, ${$c83e278a52b553dc$var$aiPrismColorStep4Light} 48%, ${$c83e278a52b553dc$var$aiPrismColorStep3Light} 64%, ${$c83e278a52b553dc$var$aiPrismColorStep2Light} 80%, ${$c83e278a52b553dc$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c83e278a52b553dc$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$c83e278a52b553dc$var$aiPrismColorStep1Light} 0%, ${$c83e278a52b553dc$var$aiPrismColorStep2Light} 20%, ${$c83e278a52b553dc$var$aiPrismColorStep3Light} 50%, ${$c83e278a52b553dc$var$aiPrismColorStep4Light} 56%, ${$c83e278a52b553dc$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c83e278a52b553dc$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$c83e278a52b553dc$var$aiPrismColorStep1Dark} 0%, ${$c83e278a52b553dc$var$aiPrismColorStep2Dark} 12%, ${$c83e278a52b553dc$var$aiPrismColorStep3Dark} 24%, ${$c83e278a52b553dc$var$aiPrismColorStep4Dark} 48%, ${$c83e278a52b553dc$var$aiPrismColorStep3Dark} 64%, ${$c83e278a52b553dc$var$aiPrismColorStep2Dark} 80%, ${$c83e278a52b553dc$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $c83e278a52b553dc$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$c83e278a52b553dc$var$aiPrismColorStep1Dark} 0%, ${$c83e278a52b553dc$var$aiPrismColorStep2Dark} 20%, ${$c83e278a52b553dc$var$aiPrismColorStep3Dark} 50%, ${$c83e278a52b553dc$var$aiPrismColorStep4Dark} 56%, ${$c83e278a52b553dc$var$aiPrismColorStep1Dark} 100%)`;
const $c83e278a52b553dc$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $f8Sb3.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $c83e278a52b553dc$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-border-radius-100, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $c83e278a52b553dc$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $c83e278a52b553dc$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $c83e278a52b553dc$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $c83e278a52b553dc$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $c83e278a52b553dc$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $c83e278a52b553dc$var$prismBorderDarkBackground
            }
        }
    }
});
const $c83e278a52b553dc$export$18b242302a502e32 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $c83e278a52b553dc$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});

});

parcelRegister("4XLx3", function(module, exports) {

$parcel$export(module.exports, "annotationStyles", () => $f6de7df2dbcf3ec7$export$65cde0a0b7e7c1c1);

var $f8Sb3 = parcelRequire("f8Sb3");

var $5Lu5s = parcelRequire("5Lu5s");
const $f6de7df2dbcf3ec7$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $5Lu5s.AnnotationSharedClassNames).blur}, .${(0, $5Lu5s.AnnotationSharedClassNames).focus}, .${(0, $5Lu5s.AnnotationSharedClassNames).draft}, .${(0, $5Lu5s.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $5Lu5s.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $5Lu5s.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $5Lu5s.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $5Lu5s.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});

});

parcelRegister("4K18w", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $b408d156131b76e3$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $b408d156131b76e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b408d156131b76e3$export$e4cca17cf56e99d = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};

});

parcelRegister("k6XMu", function(module, exports) {

$parcel$export(module.exports, "blockMarksStyles", () => $ebf9cffbca1cc24b$export$e561f1e4e17b129d);
function $ebf9cffbca1cc24b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ebf9cffbca1cc24b$export$e561f1e4e17b129d = {
    name: "13r502m",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment), .fabric-editor-alignment:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};

});

parcelRegister("evQkh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $c7f6db6fc04b94bb$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockStyles", () => $c7f6db6fc04b94bb$export$4baaed2b257b830);
$parcel$export(module.exports, "firstCodeBlockWithNoMargin", () => $c7f6db6fc04b94bb$export$ddc3dd3ba723d1af);
$parcel$export(module.exports, "firstCodeBlockWithNoMarginOld", () => $c7f6db6fc04b94bb$export$50458a606d5c37d0);

var $f8Sb3 = parcelRequire("f8Sb3");

var $7bcYJ = parcelRequire("7bcYJ");

var $guxYI = parcelRequire("guxYI");
function $c7f6db6fc04b94bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7f6db6fc04b94bb$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $c7f6db6fc04b94bb$var$fontSize14px = `${0.875}rem`;
const $c7f6db6fc04b94bb$var$blockNodesVerticalMargin = '0.75rem';
const $c7f6db6fc04b94bb$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $c7f6db6fc04b94bb$export$4baaed2b257b830 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            '--ds--code--bg-color': 'transparent',
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-border-radius, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$c7f6db6fc04b94bb$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $7bcYJ.overflowShadowStyles),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #091E420F)",
                    display: 'flex',
                    borderRadius: "var(--ds-border-radius, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #091E420F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $c7f6db6fc04b94bb$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $c7f6db6fc04b94bb$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #172B4D)",
                    borderRadius: "var(--ds-border-radius, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $c7f6db6fc04b94bb$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $c7f6db6fc04b94bb$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #505F79)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$c7f6db6fc04b94bb$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $c7f6db6fc04b94bb$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $c7f6db6fc04b94bb$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $c7f6db6fc04b94bb$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$c7f6db6fc04b94bb$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $c7f6db6fc04b94bb$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $c7f6db6fc04b94bb$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};

});
parcelRegister("7bcYJ", function(module, exports) {

$parcel$export(module.exports, "overflowShadowStyles", () => $fc725b44bf6f0470$export$cd7bee32f3fef345);

var $f8Sb3 = parcelRequire("f8Sb3");
const $fc725b44bf6f0470$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});

});

parcelRegister("guxYI", function(module, exports) {

$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $9b15ca092c7b8f72$export$a716852a0c5e54d5);
$parcel$export(module.exports, "borderSelectionStyles", () => $9b15ca092c7b8f72$export$48dd9ca0c16e4625);
$parcel$export(module.exports, "boxShadowSelectionStyles", () => $9b15ca092c7b8f72$export$a8e8bf15b18b52a0);
$parcel$export(module.exports, "backgroundSelectionStyles", () => $9b15ca092c7b8f72$export$b2937e5c446645ec);
$parcel$export(module.exports, "blanketSelectionStyles", () => $9b15ca092c7b8f72$export$e7c1f2908e268236);

var $f8Sb3 = parcelRequire("f8Sb3");
function $9b15ca092c7b8f72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b15ca092c7b8f72$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $9b15ca092c7b8f72$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #0C66E4)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $9b15ca092c7b8f72$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    borderColor: 'transparent'
});
const $9b15ca092c7b8f72$export$b2937e5c446645ec = {
    name: "1l5b1jb",
    styles: "background-color:var(--ds-background-selected, #E9F2FF)"
};
const $9b15ca092c7b8f72$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};

});


parcelRegister("agmiM", function(module, exports) {

$parcel$export(module.exports, "codeMarkStyles", () => $1490cf6499a7b9d9$export$2029176b06e1b241);

var $f8Sb3 = parcelRequire("f8Sb3");
const $1490cf6499a7b9d9$export$2029176b06e1b241 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});

});

parcelRegister("kRg9j", function(module, exports) {

$parcel$export(module.exports, "dateVanillaStyles", () => $e1c68554ac2296b8$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $e1c68554ac2296b8$export$37579fbc35dcc1a9);

var $f8Sb3 = parcelRequire("f8Sb3");

var $guxYI = parcelRequire("guxYI");
const $e1c68554ac2296b8$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $e1c68554ac2296b8$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $e1c68554ac2296b8$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.hideNativeBrowserTextSelectionStyles)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$e1c68554ac2296b8$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});

});

parcelRegister("ftikQ", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $110ef5893354251b$export$5a1f57c6600b90f1);
function $110ef5893354251b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $110ef5893354251b$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};

});

parcelRegister("leSmY", function(module, exports) {

$parcel$export(module.exports, "reactEmojiStyles", () => $88c83d90a90b8930$export$26346fea43cee12e);
$parcel$export(module.exports, "vanillaEmojiStyles", () => $88c83d90a90b8930$export$bfea5a7627ab2d50);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");

var $kin1Z = parcelRequire("kin1Z");
var $3tpiv = parcelRequire("3tpiv");

var $iHYdz = parcelRequire("iHYdz");

var $guxYI = parcelRequire("guxYI");
function $88c83d90a90b8930$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88c83d90a90b8930$var$reactEmojiSelectionStyles = {
    name: "tg3mx0",
    styles: "border-radius:2px"
};
const $88c83d90a90b8930$export$26346fea43cee12e = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_NODE}`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE} > span`]: {
                /** needed for selection style to cover custom emoji image properly */ display: 'flex'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $iHYdz.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.blanketSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.hideNativeBrowserTextSelectionStyles),
                $88c83d90a90b8930$var$reactEmojiSelectionStyles
            ]
        }
    }
});
const $88c83d90a90b8930$var$vanillaEmojiSelectionStyles = {
    name: "tg3mx0",
    styles: "border-radius:2px"
};
const $88c83d90a90b8930$export$bfea5a7627ab2d50 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
            display: 'inline-block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
            background: 'no-repeat transparent',
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $kin1Z.defaultEmojiHeight)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            maxHeight: `${(0, $kin1Z.defaultEmojiHeight)}px`,
            cursor: 'pointer',
            verticalAlign: 'middle',
            userSelect: 'all'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $iHYdz.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`.${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $3tpiv.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
                $88c83d90a90b8930$var$vanillaEmojiSelectionStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.blanketSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.hideNativeBrowserTextSelectionStyles)
            ]
        }
    }
});

});

parcelRegister("AvhE9", function(module, exports) {

$parcel$export(module.exports, "firstBlockNodeStylesOld", () => $04dfd1a8b2aab2ce$export$196e1990cf92dc61);
$parcel$export(module.exports, "firstBlockNodeStyles", () => $04dfd1a8b2aab2ce$export$2d6e8a1d666d4a60);

var $f8Sb3 = parcelRequire("f8Sb3");

var $aABH4 = parcelRequire("aABH4");

var $cr1aY = parcelRequire("cr1aY");
var $iJOES = parcelRequire("iJOES");

var $evQkh = parcelRequire("evQkh");
const $04dfd1a8b2aab2ce$export$196e1990cf92dc61 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $aABH4.PanelSharedCssClassName).prefix}, > .${(0, $evQkh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}, > .${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $cr1aY.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-of-type': {
            marginTop: 0
        }
    }
});
const $04dfd1a8b2aab2ce$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $aABH4.PanelSharedCssClassName).prefix}, > .${(0, $evQkh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}, > .${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $cr1aY.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});

});

parcelRegister("3rVzC", function(module, exports) {

$parcel$export(module.exports, "gridStyles", () => $4ad3e5774ae84e73$export$61d0da483c72dda3);

var $f8Sb3 = parcelRequire("f8Sb3");
const $4ad3e5774ae84e73$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("abFhg", function(module, exports) {

$parcel$export(module.exports, "indentationStyles", () => $5c226c703870e30b$export$fc74cf03693076b4);
function $5c226c703870e30b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5c226c703870e30b$export$fc74cf03693076b4 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("4dQ9D", function(module, exports) {

$parcel$export(module.exports, "layoutBaseStyles", () => $383fab304184cce6$export$ce383b8d82e44bf5);
$parcel$export(module.exports, "layoutViewStyles", () => $383fab304184cce6$export$912935b267e01be9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");

var $ejmVg = parcelRequire("ejmVg");
parcelRequire("8OrBn");
var $jecUf = parcelRequire("jecUf");
parcelRequire("eTjGD");
var $1v4Xe = parcelRequire("1v4Xe");

var $iHYdz = parcelRequire("iHYdz");
var $5yojI = parcelRequire("5yojI");
var $bzmFE = parcelRequire("bzmFE");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
function $383fab304184cce6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $383fab304184cce6$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $383fab304184cce6$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
var $383fab304184cce6$var$_ref = {
    name: "kzeyqg",
    styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
};
var $383fab304184cce6$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $383fab304184cce6$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $383fab304184cce6$var$_ref2 : $383fab304184cce6$var$_ref;
const $383fab304184cce6$var$layoutColumnStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)(">[data-layout-column]{margin:0 ", (0, $ejmVg.LAYOUT_SECTION_MARGIN) / 2, "px;}>[data-layout-column]:first-of-type{margin-left:0;}>[data-layout-column]:last-of-type{margin-right:0;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin:0;}}>[data-layout-column].", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){", (0, $5yojI.getSelectionStyles)([
        (0, $bzmFE.SelectionStyle).Blanket
    ]), ";::before{width:calc(100% - 8px);left:4px;border-radius:var(--ds-border-radius, 3px);}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)("[data-layout-column]+[data-layout-column]{margin-left:", (0, $ejmVg.LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, $iHYdz.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}");
const $383fab304184cce6$var$layoutSectionStyles = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)($383fab304184cce6$var$columnLayoutResponsiveSharedStyle, ";.layout-section-container [data-layout-section]{>.ProseMirror-widget{flex:none;display:contents!important;&[data-blocks-drag-handle-container] div{display:contents!important;}&[data-blocks-drop-target-container]{display:block!important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}&+[data-layout-column]{margin:0;}}>[data-layout-column]{margin:0;}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $f8Sb3.css)($383fab304184cce6$var$columnLayoutSharedStyle, ";");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutBorderBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column],&:hover [data-layout-column]{border:", (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger [data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, $iHYdz.akEditorDeleteBorder)})`, ";}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Border,
    (0, $bzmFE.SelectionStyle).Blanket
]), " ::after{background-color:transparent;}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutBorderViewStyles = {
    name: "qrl2gv",
    styles: "&.selected [data-layout-column],&:hover [data-layout-column]{border:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$columnSeparatorBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-left:", (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;height:calc(100% - 24px);margin-left:-25px;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$columnSeparatorViewStyles = {
    name: "b3k9b1",
    styles: "[data-layout-content]::before{border-left:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)("[data-layout-content]::before{content:'';border-top:", (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;width:calc(100% - 32px);margin-top:-13px;border-left:unset;margin-left:unset;height:unset;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$rowSeparatorViewStyles = {
    name: "123xnjx",
    styles: "[data-layout-content]::before{border-top:0;}"
};
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveBaseStyles = (breakpoint)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected,&:hover,&.selected.danger,&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){@container editor-area (max-width:", breakpoint, "px){", $383fab304184cce6$var$rowSeparatorBaseStyles, ";}}}");
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveViewStyles = (breakpoint)=>/*#__PURE__*/ (0, $f8Sb3.css)("&.selected,&:hover,&.selected.danger,&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){@container editor-area (max-width:", breakpoint, "px){", $383fab304184cce6$var$rowSeparatorViewStyles, ";}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutWithSeparatorBorderBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column]:not(:first-of-type),[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorBaseStyles, ";}&.selected.danger [data-layout-section]{background-color:", `var(--ds-background-danger, ${(0, $iHYdz.akEditorDeleteBackground)})`, ";box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px ", (0, $iHYdz.akEditorDeleteBorder), ";border-radius:4px;[data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorBaseStyles, ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger) [data-layout-section]{box-shadow:0 0 0 ", (0, $iHYdz.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);border-radius:4px;background-color:var(--ds-background-selected, #E9F2FF);[data-layout-column]{", (0, $5yojI.getSelectionStyles)([
    (0, $bzmFE.SelectionStyle).Blanket
]), " border:0px;::before{background-color:transparent;}}[data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorBaseStyles, ";}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutWithSeparatorBorderViewStyles = /*#__PURE__*/ (0, $f8Sb3.css)("&.selected [data-layout-column]:not(:first-of-type),[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorViewStyles, ";}&.selected.danger [data-layout-section]{box-shadow:0 0 0 0 ", (0, $iHYdz.akEditorDeleteBorder), ";[data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorViewStyles, ";}}&.", (0, $iHYdz.akEditorSelectedNodeClassName), ":not(.danger) [data-layout-section]{box-shadow:0 0 0 0 var(--ds-border-selected, #0C66E4);[data-layout-column]:not(:first-of-type){", $383fab304184cce6$var$columnSeparatorViewStyles, ";}}");
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutResponsiveBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveBaseStyles(724), ";[data-layout-section]{@container editor-area (max-width:724px){flex-direction:column;}}}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveBaseStyles(788), ";[data-layout-section]{@container editor-area (max-width:788px){flex-direction:column;}}}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveBaseStyles(820), ";[data-layout-section]{@container editor-area (max-width:820px){flex-direction:column;}}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $383fab304184cce6$var$layoutResponsiveViewStyles = /*#__PURE__*/ (0, $f8Sb3.css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveViewStyles(724), ";}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveViewStyles(788), ";}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $383fab304184cce6$var$layoutWithSeparatorBorderResponsiveViewStyles(820), ";}}");
const $383fab304184cce6$export$ce383b8d82e44bf5 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{", $383fab304184cce6$var$layoutSectionStyles(), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, $iHYdz.akLayoutGutterOffset) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px 0;transition:border-color 0.3s ", (0, $iHYdz.akEditorSwoopCubicBezier), ";cursor:pointer;", $383fab304184cce6$var$layoutColumnStyles(), ";[data-layout-column]{flex:1;position:relative;min-width:0;border:", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? 0 : (0, $iHYdz.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, $ejmVg.LAYOUT_COLUMN_PADDING), "px ", (0, $ejmVg.LAYOUT_COLUMN_PADDING) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px;box-sizing:border-box;>div{", $383fab304184cce6$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? $383fab304184cce6$var$layoutWithSeparatorBorderBaseStyles : $383fab304184cce6$var$layoutBorderBaseStyles, ";}}", (0, $gmhCD.editorExperiment)('advanced_layouts', true) && $383fab304184cce6$var$layoutResponsiveBaseStyles, "[data-blocks-drop-target-container]~[data-layout-column]>[data-layout-content]::before{display:none;}.fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, $jecUf.TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, $1v4Xe.tableMarginFullWidthMode), "px;}}}", (0, $gmhCD.editorExperiment)('advanced_layouts', false) && (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $iHYdz.akLayoutGutterOffset) + 8}px 0;
				}`, ";");
const $383fab304184cce6$export$912935b267e01be9 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? $383fab304184cce6$var$layoutWithSeparatorBorderViewStyles : $383fab304184cce6$var$layoutBorderViewStyles, ";}}", (0, $gmhCD.editorExperiment)('advanced_layouts', true) && $383fab304184cce6$var$layoutResponsiveViewStyles, ";");

});

parcelRegister("8lqK0", function(module, exports) {

$parcel$export(module.exports, "linkStyles", () => $281eb4fcc8bf0007$export$4ea5976125a01ffa);
$parcel$export(module.exports, "linkStylesOld", () => $281eb4fcc8bf0007$export$d9d1ccc645b021);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $281eb4fcc8bf0007$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $281eb4fcc8bf0007$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $281eb4fcc8bf0007$export$d9d1ccc645b021 = {
    name: "qnti7x",
    styles: ".ProseMirror a.blockLink{display:block;}"
};

});

parcelRegister("3Ab0J", function(module, exports) {

$parcel$export(module.exports, "listsStyles", () => $d105e78dc3f5f146$export$5f95d55c83a3b7bc);
$parcel$export(module.exports, "listsStylesSafariFix", () => $d105e78dc3f5f146$export$dba87c9b43c1033d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $d105e78dc3f5f146$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $d105e78dc3f5f146$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $d105e78dc3f5f146$var$blockNodesVerticalMargin = '0.75rem';
const $d105e78dc3f5f146$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror li': {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '& > p:not(:first-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
        },
        /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
    	The following rule resets the first p tag back to its original margin
    	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '& > style:first-child + p': {
            marginTop: $d105e78dc3f5f146$var$blockNodesVerticalMargin
        }
    }
});
const $d105e78dc3f5f146$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$d105e78dc3f5f146$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $d105e78dc3f5f146$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$d105e78dc3f5f146$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$d105e78dc3f5f146$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$d105e78dc3f5f146$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$d105e78dc3f5f146$var$akEditorLineHeight}em !important`
    }
});

});

parcelRegister("48I7C", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $ca070cab65926478$export$abd2efc27ac7e809);

var $f8Sb3 = parcelRequire("f8Sb3");

var $9R9Rb = parcelRequire("9R9Rb");

var $jQRg9 = parcelRequire("jQRg9");
var $ceYEW = parcelRequire("ceYEW");

var $iHYdz = parcelRequire("iHYdz");

var $79PaE = parcelRequire("79PaE");
const $ca070cab65926478$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $ca070cab65926478$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $ca070cab65926478$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $ca070cab65926478$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $ceYEW.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $ceYEW.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-right, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$ca070cab65926478$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $ceYEW.richMediaClassName}, & [layout='wide'] .${0, $ceYEW.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $ceYEW.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $ca070cab65926478$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$ca070cab65926478$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $ca070cab65926478$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $iHYdz.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $iHYdz.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $jQRg9.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $iHYdz.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $iHYdz.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: 6
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $ceYEW.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $ceYEW.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $iHYdz.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $iHYdz.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $ceYEW.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $ceYEW.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $ceYEW.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $ceYEW.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #388BFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $iHYdz.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $025bde419ff72534$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $79PaE.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $025bde419ff72534$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $79PaE.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $ceYEW.richMediaClassName} .${0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E56910)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E56910)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $iHYdz.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $iHYdz.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});

});

parcelRegister("bpyDZ", function(module, exports) {

$parcel$export(module.exports, "mentionsStyles", () => $e738110f52cad0f7$export$1445f2e2b3a1d9c8);
$parcel$export(module.exports, "vanillaMentionsStyles", () => $e738110f52cad0f7$export$a9817586edf31c70);
$parcel$export(module.exports, "vanillaMentionsSelectionStyles", () => $e738110f52cad0f7$export$900203039d88899d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");

var $fRmCC = parcelRequire("fRmCC");

var $iHYdz = parcelRequire("iHYdz");

var $guxYI = parcelRequire("guxYI");
function $e738110f52cad0f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $e738110f52cad0f7$var$mentionsSelectedColor = {
    name: "4hmdsz",
    styles: "color:var(--ds-text-subtle, #44546F)"
};
const $e738110f52cad0f7$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $iHYdz.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.backgroundSelectionStyles),
            $e738110f52cad0f7$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER}.${0, $iHYdz.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $iHYdz.akEditorSelectedBorderSize)}px ${(0, $iHYdz.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $fRmCC.MentionSharedCssClassName).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            color: "var(--ds-text-subtle, #44546F)"
        }
    }
});
const $e738110f52cad0f7$export$a9817586edf31c70 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $e738110f52cad0f7$export$900203039d88899d = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $iHYdz.akEditorSelectedBorderSize)}px ${(0, $iHYdz.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $iHYdz.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles),
            $e738110f52cad0f7$var$mentionsSelectedColor
        ]
    }
});

});

parcelRegister("5WJgZ", function(module, exports) {

$parcel$export(module.exports, "paragraphStylesUGCRefreshed", () => $de280df182b80cc3$export$29f6e72d2a83d55a);
$parcel$export(module.exports, "paragraphStylesUGCModernized", () => $de280df182b80cc3$export$a251c8dae8d8433a);
$parcel$export(module.exports, "paragraphStylesOld", () => $de280df182b80cc3$export$855ac5a16d662324);

var $f8Sb3 = parcelRequire("f8Sb3");
const $de280df182b80cc3$var$blockNodesVerticalMargin = '0.75rem';
const $de280df182b80cc3$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $de280df182b80cc3$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $de280df182b80cc3$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $de280df182b80cc3$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $de280df182b80cc3$export$855ac5a16d662324 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $de280df182b80cc3$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("jSEpg", function(module, exports) {

$parcel$export(module.exports, "resizerStyles", () => $ae54e7e1de57ebac$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $ae54e7e1de57ebac$export$62cd5dfd9881f590);

var $f8Sb3 = parcelRequire("f8Sb3");
function $ae54e7e1de57ebac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ae54e7e1de57ebac$export$a06160db3520e5a2 = 'resizer-item';
const $ae54e7e1de57ebac$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $ae54e7e1de57ebac$export$10b67c6ff1748bd = 'resizer-is-extended';
const $ae54e7e1de57ebac$export$6afc20f0ff6d041 = 'resizer-handle';
const $ae54e7e1de57ebac$export$a5792d7e2a486d41 = `${$ae54e7e1de57ebac$export$6afc20f0ff6d041}-track`;
const $ae54e7e1de57ebac$export$2201bc1aaee73f36 = `${$ae54e7e1de57ebac$export$6afc20f0ff6d041}-thumb`;
const $ae54e7e1de57ebac$export$97a99610b6f0a178 = `${$ae54e7e1de57ebac$export$6afc20f0ff6d041}-danger`;
const $ae54e7e1de57ebac$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $ae54e7e1de57ebac$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$ae54e7e1de57ebac$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$ae54e7e1de57ebac$export$b123b2c8a2536d05} > .${$ae54e7e1de57ebac$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$ae54e7e1de57ebac$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$ae54e7e1de57ebac$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$ae54e7e1de57ebac$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: 6,
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #091E4224)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #0C66E4)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$ae54e7e1de57ebac$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: 4,
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FF)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FF)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$ae54e7e1de57ebac$export$6afc20f0ff6d041}:not(:hover) .${$ae54e7e1de57ebac$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$ae54e7e1de57ebac$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$ae54e7e1de57ebac$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$ae54e7e1de57ebac$export$c42cdcfd48254bda}, table .${$ae54e7e1de57ebac$export$c42cdcfd48254bda}.${$ae54e7e1de57ebac$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $ae54e7e1de57ebac$export$62cd5dfd9881f590 = {
    name: "12dt14k",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"codeBlock\"]){> .pm-breakout-resize-handle-left{left:-12px;}> .pm-breakout-resize-handle-right{right:-12px;}> .pm-breakout-resize-handle{height:calc(100% - 12px);}}&:has([data-prosemirror-node-name=\"expand\"]), &:has([data-prosemirror-node-name=\"layoutSection\"]){> .pm-breakout-resize-handle-left{left:-32px;}> .pm-breakout-resize-handle-right{right:-32px;}}&:has([data-prosemirror-node-name=\"expand\"]){> .pm-breakout-resize-handle{height:calc(100% - 4px);}}&:has([data-prosemirror-node-name=\"layoutSection\"]){> .pm-breakout-resize-handle{height:calc(100% - 8px);}}&:has(.first-node-in-document){> .pm-breakout-resize-handle{height:100%;}}}.pm-breakout-resize-handle{position:relative;display:flex;align-items:center;justify-content:center;height:100%;width:7px;align-self:end;grid-row:1;grid-column:1;cursor:col-resize;border-radius:4px;transition:background-color 0.2s, visibility 0.2s, opacity 0.2s;&:hover{background:var(--ds-background-selected, #E9F2FF);.pm-breakout-resize-handle-inner{background:var(--ds-border-focused, #388BFF);}}}.pm-breakout-resize-handle-left{justify-self:start;}.pm-breakout-resize-handle-right{justify-self:end;}.pm-breakout-resize-handle-inner{min-width:3px;height:clamp(27px, calc(100% - 32px), 96px);background:var(--ds-border, #091E4224);border-radius:6px;position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}"
};

});

parcelRegister("7MDnl", function(module, exports) {

$parcel$export(module.exports, "ruleStyles", () => $df1a46ef4ba7a748$export$2413e968422424ec);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $df1a46ef4ba7a748$export$2413e968422424ec = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        height: '2px',
        borderRadius: '1px',
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $iHYdz.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #0C66E4)"
    }
});

});

parcelRegister("dO5G8", function(module, exports) {

$parcel$export(module.exports, "shadowStyles", () => $be5537177f2956b7$export$9750a92ac0203c10);

var $f8Sb3 = parcelRequire("f8Sb3");
const $be5537177f2956b7$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $be5537177f2956b7$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $be5537177f2956b7$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$be5537177f2956b7$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$be5537177f2956b7$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$be5537177f2956b7$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 2,
        width: 8,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$be5537177f2956b7$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
        background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
        top: 0,
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
        background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
        right: 0,
        top: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
        height: '100%',
        width: 0,
        minWidth: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${$be5537177f2956b7$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
        height: '100%',
        width: 0,
        minWidth: 0
    }
});

});

parcelRegister("gVpk5", function(module, exports) {

$parcel$export(module.exports, "smartCardStyles", () => $fb0065a6cdd4b43c$export$b346a5d6d598424c);
$parcel$export(module.exports, "smartLinksInLivePagesStyles", () => $fb0065a6cdd4b43c$export$cb0683bb9c4e1322);
$parcel$export(module.exports, "smartLinksInLivePagesStylesOld", () => $fb0065a6cdd4b43c$export$d0907e21de0d46fc);
$parcel$export(module.exports, "linkingVisualRefreshV1Styles", () => $fb0065a6cdd4b43c$export$1a87a16059da4299);

var $f8Sb3 = parcelRequire("f8Sb3");

var $guxYI = parcelRequire("guxYI");
const $fb0065a6cdd4b43c$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $fb0065a6cdd4b43c$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $fb0065a6cdd4b43c$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $fb0065a6cdd4b43c$export$b346a5d6d598424c = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-border-radius-200, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-border-radius-200, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$fb0065a6cdd4b43c$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $guxYI.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$fb0065a6cdd4b43c$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $fb0065a6cdd4b43c$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'text',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'pointer'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'pointer'
            }
        }
    }
});
const $fb0065a6cdd4b43c$export$d0907e21de0d46fc = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $fb0065a6cdd4b43c$export$1a87a16059da4299 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$fb0065a6cdd4b43c$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});

});

parcelRegister("lfF6s", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $d82d9eeb48e5f38f$export$df437277fbc8b4f5);

var $f8Sb3 = parcelRequire("f8Sb3");
const $d82d9eeb48e5f38f$var$akEditorLineHeight = 1.714;
const $d82d9eeb48e5f38f$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $d82d9eeb48e5f38f$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$d82d9eeb48e5f38f$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d82d9eeb48e5f38f$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d82d9eeb48e5f38f$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$d82d9eeb48e5f38f$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d82d9eeb48e5f38f$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $d82d9eeb48e5f38f$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$d82d9eeb48e5f38f$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$d82d9eeb48e5f38f$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});

});

parcelRegister("iqJDL", function(module, exports) {

$parcel$export(module.exports, "telepointerColorAndCommonStyle", () => $91d403c19a8b75bb$export$3f28e75e37279280);
$parcel$export(module.exports, "telepointerStyle", () => $91d403c19a8b75bb$export$c94087d6ea5127ad);
$parcel$export(module.exports, "telepointerStyleWithInitialOnly", () => $91d403c19a8b75bb$export$42e13fa9d2b0c35d);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $91d403c19a8b75bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $91d403c19a8b75bb$var$pulseIn = (0, $f8Sb3.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '13%': {
        transform: 'scaleX(1.4) scaleY(1.4)',
        opacity: 1
    },
    '20%, 85%': {
        transform: 'scaleX(1) scaleY(1)',
        opacity: 1
    }
});
const $91d403c19a8b75bb$var$pulseOut = (0, $f8Sb3.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $91d403c19a8b75bb$export$3f28e75e37279280 = {
    name: "13y51hg",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #0C66E4);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #6E5DC6);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #C25100);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #626F86);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #579DFF);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FEA362);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #F5CD47);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #9F8FEF);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $91d403c19a8b75bb$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                borderRadius: '0 2px 2px 0'
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$91d403c19a8b75bb$var$pulseOut} 2s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$91d403c19a8b75bb$var$pulseIn} 2s ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});
const $91d403c19a8b75bb$export$42e13fa9d2b0c35d = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge::after': {
            content: 'attr(data-initial)',
            position: 'absolute',
            display: 'block',
            top: -14,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.5625rem',
            padding: "var(--ds-space-025, 2px)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            left: 0,
            borderRadius: '2px 2px 2px 0',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});

});

parcelRegister("i9LjJ", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $6d0fc024a1eccf35$export$a518ea5d00002b38);
function $6d0fc024a1eccf35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d0fc024a1eccf35$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("7ei03", function(module, exports) {

$parcel$export(module.exports, "unsupportedStyles", () => $98b04ffa82673297$export$637bcb89343f7ef4);

var $f8Sb3 = parcelRequire("f8Sb3");

var $guxYI = parcelRequire("guxYI");
const $98b04ffa82673297$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $98b04ffa82673297$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$98b04ffa82673297$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$98b04ffa82673297$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$98b04ffa82673297$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$98b04ffa82673297$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.borderSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $guxYI.hideNativeBrowserTextSelectionStyles)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$98b04ffa82673297$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$98b04ffa82673297$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});

});

parcelRegister("eMf5t", function(module, exports) {

$parcel$export(module.exports, "whitespaceStyles", () => $0dde9fd5e3f06c00$export$2ee83b65ab9fac74);
function $0dde9fd5e3f06c00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0dde9fd5e3f06c00$export$2ee83b65ab9fac74 = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});


parcelRegister("iK9VQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee089fbaad1c4b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $gkwXh = parcelRequire("gkwXh");

var $bLuIS = parcelRequire("bLuIS");

var $65Q6Y = parcelRequire("65Q6Y");
function $fee089fbaad1c4b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fee089fbaad1c4b9$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $fee089fbaad1c4b9$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bLuIS.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $65Q6Y.MountPluginHooks), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $fee089fbaad1c4b9$var$pluginsComponentsWrapper
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(element, props);
    })));
};
const $fee089fbaad1c4b9$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($fee089fbaad1c4b9$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
$fee089fbaad1c4b9$var$PluginSlotComponent.displayName = 'PluginSlot';
var $fee089fbaad1c4b9$export$2e2bcd8739ae039 = $fee089fbaad1c4b9$var$PluginSlotComponent;

});
parcelRegister("bLuIS", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $d3f657eabcbe16a5$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $1KzE6 = parcelRequire("1KzE6");
class $d3f657eabcbe16a5$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("65Q6Y", function(module, exports) {

$parcel$export(module.exports, "MountPluginHooks", () => $4428e2244acd6367$export$a9224552b63e3fe8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $4428e2244acd6367$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $4428e2244acd6367$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, $2OMIu.jsx)($4428e2244acd6367$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            }, key))
    });
}

});


parcelRegister("7s5ol", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92b9f53390f6f70$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
const $a92b9f53390f6f70$var$pulseBackground = (0, $f8Sb3.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $a92b9f53390f6f70$var$pulseBackgroundReverse = (0, $f8Sb3.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $a92b9f53390f6f70$var$flashWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $a92b9f53390f6f70$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $a92b9f53390f6f70$var$flashWrapperAnimated = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$a92b9f53390f6f70$var$flashWrapper} & > div`]: {
        animationName: $a92b9f53390f6f70$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $a92b9f53390f6f70$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: animate ? $a92b9f53390f6f70$var$flashWrapperAnimated : $a92b9f53390f6f70$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args), this.toggle = false;
    }
}

});


parcelRegister("9YhuC", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithIntl", () => $1f6a75b9646aed6f$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ci4W = parcelRequire("9ci4W");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $8DYpW = parcelRequire("8DYpW");

var $bYYy3 = parcelRequire("bYYy3");

var $4ceoy = parcelRequire("4ceoy");

var $kdDpx = parcelRequire("kdDpx");

var $9LY0t = parcelRequire("9LY0t");
parcelRequire("7uhma");
var $cipm3 = parcelRequire("cipm3");

var $iHYdz = parcelRequire("iHYdz");

var $gmmd2 = parcelRequire("gmmd2");

var $gmhCD = parcelRequire("gmhCD");

var $cex0T = parcelRequire("cex0T");

var $3SvBp = parcelRequire("3SvBp");

var $jZLtJ = parcelRequire("jZLtJ");

var $eq0pk = parcelRequire("eq0pk");

var $iK9VQ = parcelRequire("iK9VQ");

var $5093p = parcelRequire("5093p");

var $7s5ol = parcelRequire("7s5ol");

var $fBLMg = parcelRequire("fBLMg");
const $1f6a75b9646aed6f$var$CommentEditorMargin = 14;
const $1f6a75b9646aed6f$var$commentEditorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $1f6a75b9646aed6f$var$ContentArea = (0, $jZLtJ.createEditorContentStyle)(/*#__PURE__*/ (0, $f8Sb3.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$1f6a75b9646aed6f$var$CommentEditorMargin - (0, $bYYy3.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $cipm3.tableCommentEditorStyles)));
$1f6a75b9646aed6f$var$ContentArea.displayName = 'ContentArea';
const $1f6a75b9646aed6f$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $1f6a75b9646aed6f$var$appearance = 'comment';
const $1f6a75b9646aed6f$var$EditorContainer = (0, $gmmd2.componentWithCondition)(()=>(0, $gmhCD.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $eq0pk.default), $1f6a75b9646aed6f$var$ContentArea);
const $1f6a75b9646aed6f$var$useCommentEditorPluginsStates = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ]);
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    const primaryToolbarComponents = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'primaryToolbar.components');
    const editorViewMode = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        },
        primaryToolbarState: !primaryToolbarComponents ? undefined : {
            components: primaryToolbarComponents
        },
        editorViewModeState: !editorViewMode ? undefined : {
            mode: editorViewMode
        }
    };
});
const $1f6a75b9646aed6f$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarState, editorViewModeState: editorViewModeState } = $1f6a75b9646aed6f$var$useCommentEditorPluginsStates(editorAPI);
    const { mediaState: mediaState } = (0, $awTmI.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $koVbs.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $5uXOq.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $5uXOq.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $5uXOq.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $5uXOq.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7s5ol.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $1f6a75b9646aed6f$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fBLMg.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kdDpx.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $1f6a75b9646aed6f$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5093p.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $1f6a75b9646aed6f$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $fBLMg.mainToolbarCustomComponentsSlotStyle)(isTwoLineToolbarEnabled)
    }, customPrimaryToolbarComponents))), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cex0T.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($1f6a75b9646aed6f$var$EditorContainer, {
            ref: containerElement,
            css: maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('ak-editor-content-area', {
                'less-margin': width < (0, $iHYdz.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewModeState?.mode,
            appearance: $1f6a75b9646aed6f$var$appearance
        }, customContentComponents && 'before' in customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(customContentComponents.before) : (0, $3SvBp.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $1f6a75b9646aed6f$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1f6a75b9646aed6f$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, !!onSave && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eCeGD.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $8DYpW.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $8DYpW.default).cancelButton))), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$1f6a75b9646aed6f$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("9ci4W", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("cex0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $78865ac916ce418a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $a3qhX = parcelRequire("a3qhX");
function $78865ac916ce418a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $78865ac916ce418a$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $78865ac916ce418a$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $a3qhX.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $78865ac916ce418a$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $78865ac916ce418a$export$2e2bcd8739ae039 = $78865ac916ce418a$export$68468c5dbde37b99;

});
parcelRegister("a3qhX", function(module, exports) {

$parcel$export(module.exports, "clickAreaClickHandler", () => $78b1133e759b60f6$export$28b64e3e5a38e8a2);

var $3I3CN = parcelRequire("3I3CN");

var $jNU25 = parcelRequire("jNU25");

var $5Vvw4 = parcelRequire("5Vvw4");

var $eQcNy = parcelRequire("eQcNy");

var $VSDnB = parcelRequire("VSDnB");

var $3SvBp = parcelRequire("3SvBp");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $78b1133e759b60f6$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $78b1133e759b60f6$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $78b1133e759b60f6$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $78b1133e759b60f6$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $78b1133e759b60f6$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $78b1133e759b60f6$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $eQcNy.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $eQcNy.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $eQcNy.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = (0, $VSDnB.fg)('platform_editor_keep_focus_on_content_comp_clicks') ? target?.parentElement?.closest(`[${(0, $3SvBp.ignoreAttribute)}]`) : !!(0, $eQcNy.closestElement)(target, `[${(0, $3SvBp.ignoreAttribute)}]`) || target?.getAttribute((0, $3SvBp.ignoreAttribute)) === 'true';
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $eQcNy.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $eQcNy.closestElement)(target, 'div[offset]'));
    const isButtonClicked = Boolean((0, $eQcNy.closestElement)(event.currentTarget, 'button')) || Boolean((0, $eQcNy.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $78b1133e759b60f6$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $78b1133e759b60f6$export$c5a7a653c4681bfd(view, event);
};
const $78b1133e759b60f6$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $jNU25.addParagraphAtEnd)(tr);
    }
    (0, $5Vvw4.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $3I3CN.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("jNU25", function(module, exports) {

$parcel$export(module.exports, "addParagraphAtEnd", () => $2372cedf5b014ac0$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $2372cedf5b014ac0$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $2372cedf5b014ac0$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $2372cedf5b014ac0$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $2372cedf5b014ac0$export$72d6145976985e8c);
$parcel$export(module.exports, "findCutBefore", () => $2372cedf5b014ac0$export$ad1078cb3917e860);

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $93WYh = parcelRequire("93WYh");
function $2372cedf5b014ac0$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $2372cedf5b014ac0$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $2372cedf5b014ac0$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $2372cedf5b014ac0$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $2372cedf5b014ac0$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $2372cedf5b014ac0$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $2372cedf5b014ac0$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $2372cedf5b014ac0$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $hFEwm.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $2372cedf5b014ac0$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $gZGBX.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $2372cedf5b014ac0$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $2372cedf5b014ac0$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $hFEwm.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("5Vvw4", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $d7ff16845adf5723$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $d7ff16845adf5723$export$44fdd7840a0a11f2);

var $gZGBX = parcelRequire("gZGBX");

var $hPjvp = parcelRequire("hPjvp");

var $2xQXF = parcelRequire("2xQXF");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $d7ff16845adf5723$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $hPjvp.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT;
            let position;
            if (side === (0, $hPjvp.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $d7ff16845adf5723$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $d7ff16845adf5723$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $hPjvp.Side).LEFT ? (0, $2xQXF.isValidTargetNode)($pos.nodeAfter) : (0, $2xQXF.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $hPjvp.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $hPjvp.GapCursorSelection)) tr.setSelection((0, $gZGBX.Selection).near($pos));
        else tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $gZGBX.Selection).findFrom($pos, cursorCoords.side === (0, $hPjvp.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $d7ff16845adf5723$export$44fdd7840a0a11f2 = (position, side = (0, $hPjvp.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $hPjvp.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});

parcelRegister("3SvBp", function(module, exports) {

$parcel$export(module.exports, "ignoreAttribute", () => $88975c433721924a$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $88975c433721924a$export$57a965c23051130d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $88975c433721924a$export$72d101e93c081651 = 'data-editor-content-component';
const $88975c433721924a$export$57a965c23051130d = (reactComponents)=>{
    if (!(0, $VSDnB.fg)('platform_editor_content_component_ignore_click')) return reactComponents;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});



parcelRegister("5093p", function(module, exports) {

$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $c2315883ffd82628$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1v3g5 = parcelRequire("1v3g5");

var $kXC89 = parcelRequire("kXC89");

var $iHYdz = parcelRequire("iHYdz");

var $gJlZe = parcelRequire("gJlZe");

var $5j6KQ = parcelRequire("5j6KQ");

var $9CMqB = parcelRequire("9CMqB");

var $9Bsv7 = parcelRequire("9Bsv7");

var $9Hbxn = parcelRequire("9Hbxn");
const $c2315883ffd82628$var$toolbar = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: '1 / 2',
        gridRow: 2,
        width: 'calc(100% - 30px)',
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $c2315883ffd82628$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(undefined);
    const elementWidth = (0, $9CMqB.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $1v3g5.isSSR)() && (0, $5j6KQ.isFullPage)(props.appearance) ? (0, $kXC89.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $9Hbxn.widthToToolbarSize)(width || elementWidth, props.appearance);
    const toolbarStyle = (0, $5uXOq.useMemo)(()=>{
        const toolbarWidth = (0, $5j6KQ.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $kXC89.ToolbarSize).S : (0, $kXC89.ToolbarSize).M;
        const toolbarMinWidth = (0, $9Hbxn.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
        return [
            $c2315883ffd82628$var$toolbar,
            minWidth
        ];
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: toolbarStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Bsv7.Toolbar), {
        ...props,
        toolbarSize: toolbarSize
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref
    })));
};

});
parcelRegister("5j6KQ", function(module, exports) {

$parcel$export(module.exports, "isFullPage", () => $5d5227b0967d81cf$export$2800a15841f40ad7);
function $5d5227b0967d81cf$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("9CMqB", function(module, exports) {

$parcel$export(module.exports, "useElementWidth", () => $e59cb6bcde959be1$export$1217913212f99c7);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $e59cb6bcde959be1$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!skip && ref.current && !(0, $VSDnB.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("9Bsv7", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $8c0c376ea2e85785$export$4c260019440d418f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kXC89 = parcelRequire("kXC89");

var $6bmop = parcelRequire("6bmop");
const $8c0c376ea2e85785$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6bmop.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $kXC89.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};

});
parcelRegister("6bmop", function(module, exports) {

$parcel$export(module.exports, "ToolbarInner", () => $80b700b8d431b480$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $1v3g5 = parcelRequire("1v3g5");

var $iHYdz = parcelRequire("iHYdz");
const $80b700b8d431b480$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $80b700b8d431b480$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $1v3g5.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $80b700b8d431b480$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});


parcelRegister("9Hbxn", function(module, exports) {

$parcel$export(module.exports, "toolbarSizeToWidth", () => $5ee4a44c812606dd$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $5ee4a44c812606dd$export$886398ab6922a80f);

var $kXC89 = parcelRequire("kXC89");

var $VSDnB = parcelRequire("VSDnB");

var $5j6KQ = parcelRequire("5j6KQ");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $5ee4a44c812606dd$var$toolbarSizesFullPageNext = [
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPageNext).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $5ee4a44c812606dd$var$toolbarSizesFullPage = [
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsFullPage).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
const $5ee4a44c812606dd$var$toolbarSizesNext = [
    {
        width: (0, $kXC89.ToolbarWidthsNext).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidthsNext).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $5ee4a44c812606dd$var$toolbarSizes = [
    {
        width: (0, $kXC89.ToolbarWidths).XXL,
        size: (0, $kXC89.ToolbarSize).XXL
    },
    {
        width: (0, $kXC89.ToolbarWidths).XL,
        size: (0, $kXC89.ToolbarSize).XL
    },
    {
        width: (0, $kXC89.ToolbarWidths).L,
        size: (0, $kXC89.ToolbarSize).L
    },
    {
        width: (0, $kXC89.ToolbarWidths).M,
        size: (0, $kXC89.ToolbarSize).M
    },
    {
        width: (0, $kXC89.ToolbarWidths).S,
        size: (0, $kXC89.ToolbarSize).S
    }
];
const $5ee4a44c812606dd$var$toolbarSizesForAppearance = (appearance)=>(0, $5j6KQ.isFullPage)(appearance) ? (0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesFullPageNext : $5ee4a44c812606dd$var$toolbarSizesFullPage : (0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesNext : $5ee4a44c812606dd$var$toolbarSizes;
const $5ee4a44c812606dd$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $kXC89.ToolbarWidths).S
    }).width;
};
const $5ee4a44c812606dd$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $kXC89.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("fBLMg", function(module, exports) {

$parcel$export(module.exports, "MainToolbar", () => $1a03e2eb8d62ff43$export$f7e5e5a2fbd99270);
$parcel$export(module.exports, "mainToolbarCustomComponentsSlotStyle", () => $1a03e2eb8d62ff43$export$a9324f11be65944);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
/* eslint-disable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;align-items:center;padding:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0;display:flex;height:auto;background-color:var(--ds-surface, white);box-shadow:none;padding-left:var(--ds-space-250, 20px);&>div{", isTwoLineEditorToolbar && `
        @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        /* make this more explicit for a toolbar */
        > *:nth-child(1) {
          @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `, ";>:first-child:not(style),>style:first-child+*{margin-left:0;}}.block-type-btn{padding-left:0;}", (0, $VSDnB.fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }', ";");
/* eslint-enable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle = /*#__PURE__*/ (0, $f8Sb3.css)("position:relative;position:sticky;padding-bottom:var(--ds-space-100, 8px);z-index:", (0, $iHYdz.akEditorMenuZIndex), ";transition:box-shadow ease-in-out 0.2s;&.show-keyline{box-shadow:0 ", (0, $iHYdz.akEditorToolbarKeylineHeight), "px 0 0 var(--ds-background-accent-gray-subtlest, #F1F2F4);}");
const $1a03e2eb8d62ff43$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $5uXOq.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $5uXOq.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $1a03e2eb8d62ff43$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $1a03e2eb8d62ff43$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $1a03e2eb8d62ff43$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $f8Sb3.jsx)($1a03e2eb8d62ff43$var$StickyToolbar, {
        ...$1a03e2eb8d62ff43$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($1a03e2eb8d62ff43$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
};
const $1a03e2eb8d62ff43$export$a9324f11be65944 = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)("display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);>div{display:flex;flex-shrink:0;}", isTwoLineEditorToolbar && `
    @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `, ";");

});


parcelRegister("kuVsL", function(module, exports) {

$parcel$export(module.exports, "FullPageEditor", () => $4ddf5ad19e1c12c5$export$a15423dd96de66f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $DXgOv = parcelRequire("DXgOv");

var $9LY0t = parcelRequire("9LY0t");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $1YV33 = parcelRequire("1YV33");

var $eMbnU = parcelRequire("eMbnU");

var $cOyi5 = parcelRequire("cOyi5");

var $2mrTE = parcelRequire("2mrTE");
const $4ddf5ad19e1c12c5$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: (0, $gE8f9.browser).safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $4ddf5ad19e1c12c5$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $4ddf5ad19e1c12c5$var$useFullPageEditorPluginsStates = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode',
        'primaryToolbar',
        'interaction'
    ]);
}, (pluginInjectionApi)=>{
    const primaryToolbarComponents = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'primaryToolbar.components');
    const editorViewMode = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    const hasHadInteraction = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.hasHadInteraction');
    const interactionState = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    return {
        primaryToolbarState: !primaryToolbarComponents ? undefined : {
            components: primaryToolbarComponents
        },
        editorViewModeState: !editorViewMode ? undefined : {
            mode: editorViewMode
        },
        interactionState: hasHadInteraction === undefined || interactionState === undefined ? undefined : {
            hasHadInteraction: hasHadInteraction,
            interactionState: interactionState
        }
    };
});
const $4ddf5ad19e1c12c5$export$a15423dd96de66f2 = (props)=>{
    const wrapperElementRef = (0, $5uXOq.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $5uXOq.useRef)(null);
    const showKeyline = $4ddf5ad19e1c12c5$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarState, interactionState: interactionState } = $4ddf5ad19e1c12c5$var$useFullPageEditorPluginsStates(editorAPI);
    const viewMode = (0, $cOyi5.getEditorViewMode)(editorViewModeState, props.preset);
    // Remove all this logic when platform_editor_interaction_api_refactor is cleaned up
    let hasHadInteraction;
    if ((0, $VSDnB.fg)('platform_editor_interaction_api_refactor')) // Warning: this logic is a cluster-f but `hasHadInteraction` depends on undefined being allowed
    // in which case no class will be rendered at all. In this way we only set `hasHadInteraction to
    // boolean when interactionState is not undefined.
    {
        if (interactionState) hasHadInteraction = interactionState.interactionState !== 'hasNotHadInteraction';
    } else hasHadInteraction = interactionState?.hasHadInteraction;
    let toolbarDocking = (0, $9LY0t.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking');
    if (!toolbarDocking && (0, $VSDnB.fg)('platform_editor_controls_toolbar_ssr_fix')) {
        // This is a workaround for the rendering issue with the selection toolbar
        // where using useSharedPluginStateSelector or useSharedPluginState the state are not
        // available when the editor is first loaded. and cause the toolbar to blink.
        const defaultDocking = props.__livePage ? 'none' : 'top';
        toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = (0, $VSDnB.fg)('platform_editor_sync_editor_view_mode_state') ? viewMode === 'view' : editorViewModeState?.mode === 'view';
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $VSDnB.fg)('platform_editor_controls_toolbar_ssr_fix')) {
            if (toolbarDocking === 'none') {
                primaryToolbarComponents = [];
                if (!$4ddf5ad19e1c12c5$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else {
            if (toolbarDocking !== 'top') primaryToolbarComponents = [];
            if (!primaryToolbarComponents?.length && !$4ddf5ad19e1c12c5$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $2mrTE.fullPageEditorWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, !isEditorToolbarHidden && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eMbnU.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1YV33.FullPageContentArea), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: editorViewModeState?.mode,
        hasHadInteraction: hasHadInteraction
    })));
};

});
parcelRegister("DXgOv", function(module, exports) {

$parcel$export(module.exports, "ContextPanelWidthProvider", () => $7236ed0b18c0a994$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $7236ed0b18c0a994$export$24734d8d7782a3fc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7236ed0b18c0a994$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $7236ed0b18c0a994$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.state = {
            width: 0,
            positionedOverEditor: false
        }, this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        }, this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7236ed0b18c0a994$export$e38af27e662e9783, {
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
}
const { Provider: $7236ed0b18c0a994$export$e38af27e662e9783, Consumer: $7236ed0b18c0a994$export$24734d8d7782a3fc } = $7236ed0b18c0a994$export$c174a7dc96b2afb8;

});

parcelRegister("1YV33", function(module, exports) {

$parcel$export(module.exports, "FullPageContentArea", () => $0c715cb9d6308084$export$7db1e8e055ebd208);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
var $g0wej = parcelRequire("g0wej");

var $9ci4W = parcelRequire("9ci4W");

var $8RXs9 = parcelRequire("8RXs9");

var $kXnoC = parcelRequire("kXnoC");


var $VSDnB = parcelRequire("VSDnB");

var $gmmd2 = parcelRequire("gmmd2");

var $gmhCD = parcelRequire("gmhCD");

var $cex0T = parcelRequire("cex0T");

var $3SvBp = parcelRequire("3SvBp");

var $jZLtJ = parcelRequire("jZLtJ");

var $hMZun = parcelRequire("hMZun");

var $eq0pk = parcelRequire("eq0pk");

var $iK9VQ = parcelRequire("iK9VQ");

var $2mrTE = parcelRequire("2mrTE");
const $0c715cb9d6308084$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $0c715cb9d6308084$export$5c151fe82051a1a7 = 'ak-editor-container';
const $0c715cb9d6308084$var$scrollStyles = /*#__PURE__*/ (0, $f8Sb3.css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4038285048829feb$export$b2380b18b089518f));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0c715cb9d6308084$var$ScrollContainer = (0, $jZLtJ.createEditorContentStyle)($0c715cb9d6308084$var$scrollStyles);
$0c715cb9d6308084$var$ScrollContainer.displayName = 'ScrollContainer';
const $0c715cb9d6308084$var$EditorContainer = (0, $gmmd2.componentWithCondition)(()=>(0, $gmhCD.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $eq0pk.default), $0c715cb9d6308084$var$ScrollContainer);
const $0c715cb9d6308084$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const theme = (0, $g0wej.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const scrollContainerRef = (0, $5uXOq.useRef)(null);
    const contentAreaRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    // Remove entire `hasHadInteraction` logic and prop when 'platform_editor_interaction_api_refactor' is cleaned up
    let interactionClassName;
    if ((0, $VSDnB.fg)('platform_editor_interaction_api_refactor')) ;
    else if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    props.hasHadInteraction !== undefined && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) interactionClassName = props.hasHadInteraction ? 'ak-editor-has-interaction' : 'ak-editor-no-interaction';
    const shouldSetHiddenDataAttribute = ()=>{
        // When platform_editor_offline_banner_toolbar_position is enabled we use a different method to
        // determine if the toolbar is hidden from outside of the editor, which doesn't require setting
        // data-editor-primary-toolbar-hidden on the content area
        // NOTE: When tidying, this function and the data attribute can be removed
        if (!props.isEditorToolbarHidden || (0, $VSDnB.fg)('platform_editor_offline_banner_toolbar_position')) return false;
        return (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $2mrTE.contentArea),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            props.isEditorToolbarHidden && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $2mrTE.contentAreaHeightNoToolbar)
        ],
        "data-testid": $0c715cb9d6308084$export$81adcdb8b9fca1f7,
        ref: containerRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $2mrTE.contentAreaWrapper),
        "data-testid": $0c715cb9d6308084$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($0c715cb9d6308084$var$EditorContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cex0T.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            ...(0, $2mrTE.editorContentAreaStyle)({
                fullWidthMode: fullWidthMode,
                layoutMaxWidth: theme.layoutMaxWidth,
                isEditorToolbarHidden: props.isEditorToolbarHidden
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "ak-editor-content-area-region",
        "data-editor-editable-content": true,
        "data-editor-primary-toolbar-hidden": shouldSetHiddenDataAttribute() ? 'true' : undefined,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $kXnoC.messages).editableContentLabel),
        ref: contentAreaRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $2mrTE.editorContentGutterStyle)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init') ? (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('ak-editor-content-area', 'appearance-full-page', interactionClassName, {
            'fabric-editor--full-width-mode': fullWidthMode
        }) : [
            'ak-editor-content-area',
            'appearance-full-page',
            fullWidthMode ? 'fabric-editor--full-width-mode' : ''
        ].join(' '),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iK9VQ.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $3SvBp.contentComponentClickWrapper)(props.customContentComponents.after) : null))))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $2mrTE.sidebarArea)
    }, props.contextPanel || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hMZun.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $0c715cb9d6308084$export$7db1e8e055ebd208 = (0, $8RXs9.default)($0c715cb9d6308084$var$Content, {
    forwardRef: true
});

});
parcelRegister("hMZun", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $38c4a2495ec84d05$export$c174a7dc96b2afb8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ahdj0 = parcelRequire("ahdj0");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $DXgOv = parcelRequire("DXgOv");

var $9LY0t = parcelRequire("9LY0t");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
function $38c4a2495ec84d05$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $38c4a2495ec84d05$var$ANIM_SPEED_MS = 500;
const $38c4a2495ec84d05$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $38c4a2495ec84d05$export$21f42ab9b6679f44 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $iHYdz.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$38c4a2495ec84d05$var$ANIM_SPEED_MS}ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
});
const $38c4a2495ec84d05$var$disablePanelAnimation = {
    name: "1wx2bp",
    styles: "transition:none"
};
const $38c4a2495ec84d05$export$a7db06668cad9adb = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $iHYdz.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $38c4a2495ec84d05$var$paddingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
class $38c4a2495ec84d05$export$2aac880ec6fe2608 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $iHYdz.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const customPanelWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${this.props.customWidth}px`,
            overflowX: 'hidden'
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $38c4a2495ec84d05$export$21f42ab9b6679f44,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $38c4a2495ec84d05$var$panelHidden,
                    (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') && $38c4a2495ec84d05$var$disablePanelAnimation
                ],
                "data-testid": "context-panel-panel",
                "aria-labelledby": "context-panel-title",
                role: "dialog"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                "data-testid": "context-panel-content",
                css: [
                    $38c4a2495ec84d05$export$a7db06668cad9adb,
                    hasPadding && $38c4a2495ec84d05$var$paddingStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $38c4a2495ec84d05$var$panelHidden,
                    (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') && $38c4a2495ec84d05$var$disablePanelAnimation
                ]
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args), this.state = {
            mounted: false,
            currentPluginContent: undefined
        }, this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        }, this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') ? 0 : $38c4a2495ec84d05$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ahdj0.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: ()=>this.unsetPluginContent()
            }, currentPluginContent);
        }, this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $VSDnB.fg)('platform_editor_disable_context_panel_animation') ? 0 : $38c4a2495ec84d05$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ahdj0.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
const $38c4a2495ec84d05$var$useContextPanelSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { contextPanelState: contextPanelState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'contextPanel'
    ]);
    return contextPanelState?.contents;
}, (pluginInjectionApi)=>{
    return (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'contextPanel.contents');
});
function $38c4a2495ec84d05$export$c174a7dc96b2afb8(props) {
    const contextPanelContents = $38c4a2495ec84d05$var$useContextPanelSharedState(props.editorAPI);
    const firstContent = contextPanelContents && contextPanelContents.find(Boolean);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)($38c4a2495ec84d05$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    }));
}

});

parcelRegister("2mrTE", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorWrapper", () => $2ea8babea89be1bc$export$ffbc962f588258d5);
$parcel$export(module.exports, "contentArea", () => $2ea8babea89be1bc$export$26bdc8f90c1f72f6);
$parcel$export(module.exports, "contentAreaWrapper", () => $2ea8babea89be1bc$export$484266f72d7ebbab);
$parcel$export(module.exports, "contentAreaHeightNoToolbar", () => $2ea8babea89be1bc$export$848a137fb02bc242);
$parcel$export(module.exports, "sidebarArea", () => $2ea8babea89be1bc$export$a838a71bfc839c1d);
$parcel$export(module.exports, "editorContentAreaStyle", () => $2ea8babea89be1bc$export$fc070501506e6d7a);
$parcel$export(module.exports, "editorContentGutterStyle", () => $2ea8babea89be1bc$export$95d13e1170f2991);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8gSD8 = parcelRequire("8gSD8");
var $43mJF = parcelRequire("43mJF");
parcelRequire("7uhma");
var $cipm3 = parcelRequire("cipm3");
parcelRequire("eTjGD");
var $1v4Xe = parcelRequire("1v4Xe");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
function $2ea8babea89be1bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$SWOOP_ANIMATION = `0.5s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`;
const $2ea8babea89be1bc$var$getTotalPadding = ()=>(0, $iHYdz.akEditorGutterPaddingDynamic)() * 2;
const $2ea8babea89be1bc$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $2ea8babea89be1bc$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $2ea8babea89be1bc$export$26bdc8f90c1f72f6 = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '&.ak-editor-content-area-no-toolbar': {
            // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
            // to match the toolbar height
            height: `calc(100% + 1px)`
        },
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`
    });
};
const $2ea8babea89be1bc$export$484266f72d7ebbab = {
    name: "znpqtq",
    styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
};
const $2ea8babea89be1bc$export$848a137fb02bc242 = {
    name: "13udsys",
    styles: "height:100%"
};
const $2ea8babea89be1bc$export$a838a71bfc839c1d = {
    name: "18di8tn",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end;.extension-editable-area &{height:auto;position:sticky;top:0;align-self:flex-start;}"
};
const $2ea8babea89be1bc$export$14d7990cf2a76cb6 = {
    name: "1ffp76g",
    styles: ".fabric-editor--full-width-mode{.pm-table-container, .code-block, .extension-container{display:none;}.multiBodiedExtension--container{display:none;}}"
};
/* Prevent horizontal scroll on page in full width mode */ const $2ea8babea89be1bc$var$editorContentAreaContainerStyle = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.code-block, .extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${(0, $1v4Xe.tableMarginFullWidthMode) * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${((0, $iHYdz.akLayoutGutterOffset) + ((0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $2ea8babea89be1bc$var$AK_NESTED_DND_GUTTER_OFFSET : 0)) * 2}px)`
            }
        }
    });
const $2ea8babea89be1bc$export$fc070501506e6d7a = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode, isEditorToolbarHidden: isEditorToolbarHidden })=>[
        $2ea8babea89be1bc$var$editorContentArea,
        !fullWidthMode && $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
        $2ea8babea89be1bc$var$editorContentAreaContainerStyle(),
        ...(0, $VSDnB.fg)('platform_editor_controls_no_toolbar_space') ? [] : [
            (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $2ea8babea89be1bc$var$contentAreaReducedHeaderSpace,
            isEditorToolbarHidden && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $2ea8babea89be1bc$var$contentAreaReservedPrimaryToolbarSpace
        ]
    ];
const $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // this restricts max width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${layoutMaxWidth + $2ea8babea89be1bc$var$getTotalPadding()}px`
    });
const $2ea8babea89be1bc$var$editorContentArea = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/ui-styling-standard/no-unsafe-values
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + ${(0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)()} + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth) + $2ea8babea89be1bc$var$getTotalPadding()}px`,
    transition: `max-width ${$2ea8babea89be1bc$var$SWOOP_ANIMATION}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $43mJF.taskListSelector}):not(${0, $8gSD8.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $cipm3.tableFullPageEditorStyles), ".fabric-editor--full-width-mode{.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}");
const $2ea8babea89be1bc$export$95d13e1170f2991 = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $iHYdz.akEditorGutterPaddingDynamic)()}px`
    });
};
// An additional spacing applied at the top of the content area reserving space when the primary toolbar
// is hidden – this avoids layout shift when the toolbar is toggled under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$contentAreaReservedPrimaryToolbarSpace = /*#__PURE__*/ (0, $f8Sb3.css)({
    // extra 1px to account for the bottom border on the toolbar
    marginTop: `calc(${"var(--ds-space-500, 40px)"} + 1px)`
});
// A reduced top spacing applied to the content area to compensate for the reserved space at the top
// of the page when the primary toolbar is hidden under the editor controls feature
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2ea8babea89be1bc$var$contentAreaReducedHeaderSpace = {
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
};

});


parcelRegister("eMbnU", function(module, exports) {

$parcel$export(module.exports, "FullPageToolbar", () => $53d9c5fa01d5f1ad$export$26f3f0e30f9545b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $kXnoC = parcelRequire("kXnoC");

var $DXgOv = parcelRequire("DXgOv");

var $kdDpx = parcelRequire("kdDpx");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9JEFz = parcelRequire("9JEFz");

var $5093p = parcelRequire("5093p");

var $5k24a = parcelRequire("5k24a");

var $eWGrU = parcelRequire("eWGrU");
const $53d9c5fa01d5f1ad$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $5uXOq.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $9JEFz.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.nonCustomToolbarWrapperStyle)
    }, props.beforeIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.mainToolbarIconBeforeStyle)
    }, props.beforeIcon), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5093p.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWGrU.customToolbarWrapperStyle)
    }, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5k24a.BeforePrimaryToolbarWrapper), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, !((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_find_and_replace_duplication')) && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $5uXOq.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $eWGrU.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbarRaw = (event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    };
    const isShortcutToFocusToolbarMemoized = (0, $5uXOq.useCallback)(isShortcutToFocusToolbarRaw, []);
    const isShortcutToFocusToolbar = (0, $VSDnB.fg)('platform_editor_toolbar_rerender_optimization') ? isShortcutToFocusToolbarMemoized : isShortcutToFocusToolbarRaw;
    const handleEscapeRaw = (event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    };
    const handleEscapeMemoized = (0, $5uXOq.useCallback)((event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        props.editorView
    ]);
    const handleEscape = (0, $VSDnB.fg)('platform_editor_toolbar_rerender_optimization') ? handleEscapeMemoized : handleEscapeRaw;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $DXgOv.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kdDpx.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ToolbarPortal, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $eWGrU.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $kXnoC.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9JEFz.ToolbarPortalMountPoint), null)))));
});
const $53d9c5fa01d5f1ad$export$26f3f0e30f9545b4 = (0, $8RXs9.default)($53d9c5fa01d5f1ad$export$477aaffea178bc4e);

});
parcelRegister("9JEFz", function(module, exports) {

$parcel$export(module.exports, "ToolbarPortalContextProvider", () => $fa35fdbbfc9383a9$export$89a0c16b81a39772);
$parcel$export(module.exports, "useToolbarPortal", () => $fa35fdbbfc9383a9$export$9fa9b541c351558);
$parcel$export(module.exports, "ToolbarPortalMountPoint", () => $fa35fdbbfc9383a9$export$ed65ed0e830b18c8);
/* ToolbarPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $fa35fdbbfc9383a9$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $fa35fdbbfc9383a9$export$89a0c16b81a39772 = ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fa35fdbbfc9383a9$var$ToolbarPortalContext.Provider, {
        value: value,
        children: children
    });
};
const $fa35fdbbfc9383a9$export$9fa9b541c351558 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($fa35fdbbfc9383a9$var$ToolbarPortalContext);
};
const $fa35fdbbfc9383a9$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $fa35fdbbfc9383a9$export$ed65ed0e830b18c8 = ()=>{
    const portal = $fa35fdbbfc9383a9$export$9fa9b541c351558();
    // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $fa35fdbbfc9383a9$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};

});

parcelRegister("5k24a", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $b5e0689e02fdf117$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $b5e0689e02fdf117$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $b5e0689e02fdf117$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});

parcelRegister("eWGrU", function(module, exports) {

$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $ea400237c23c8b06$export$f71dca5c73c8a7);
$parcel$export(module.exports, "mainToolbarStyle", () => $ea400237c23c8b06$export$149462a46fbcc8c8);
$parcel$export(module.exports, "mainToolbarIconBeforeStyle", () => $ea400237c23c8b06$export$8ae7cf5e67319342);
$parcel$export(module.exports, "mainToolbarFirstChildStyle", () => $ea400237c23c8b06$export$53973a689c603614);
$parcel$export(module.exports, "mainToolbarSecondChildStyle", () => $ea400237c23c8b06$export$b0242e3e235d994c);
$parcel$export(module.exports, "nonCustomToolbarWrapperStyle", () => $ea400237c23c8b06$export$a41238ec40a49ad0);
$parcel$export(module.exports, "customToolbarWrapperStyle", () => $ea400237c23c8b06$export$9c5878561f814452);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
function $ea400237c23c8b06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea400237c23c8b06$export$f71dca5c73c8a7 = 868;
// box-shadow is overriden by the mainToolbar
const $ea400237c23c8b06$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
});
const $ea400237c23c8b06$var$mainToolbarTwoLineStyle = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    });
};
const $ea400237c23c8b06$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $ea400237c23c8b06$var$mainToolbar = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        alignItems: 'center',
        boxShadow: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `box-shadow 200ms ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: editorToolbarHeight,
        flexShrink: 0,
        backgroundColor: "var(--ds-surface, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& object': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            height: '0 !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ea400237c23c8b06$var$flexibleIconSize);
};
const $ea400237c23c8b06$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbar,
        showKeyline && $ea400237c23c8b06$var$mainToolbarWithKeyline,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarTwoLineStyle
    ];
const $ea400237c23c8b06$export$8ae7cf5e67319342 = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $ea400237c23c8b06$var$mainToolbarFirstChild = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $iHYdz.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $ea400237c23c8b06$var$mainToolbarFirstChildTowLine = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            justifyContent: 'flex-end',
            minWidth: 'fit-content'
        }
    });
};
const $ea400237c23c8b06$export$53973a689c603614 = (twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbarFirstChild,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarFirstChildTowLine
    ];
const $ea400237c23c8b06$var$mainToolbarSecondChild = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
const $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine = ()=>{
    const editorToolbarHeight = (0, $iHYdz.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
            display: 'flex',
            flexGrow: 1,
            flex: '1 1 100%',
            margin: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            minWidth: 0
        }
    });
};
const $ea400237c23c8b06$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
        $ea400237c23c8b06$var$mainToolbarSecondChild,
        twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine
    ];
const $ea400237c23c8b06$export$a41238ec40a49ad0 = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $ea400237c23c8b06$export$9c5878561f814452 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};

});


parcelRegister("cOyi5", function(module, exports) {

$parcel$export(module.exports, "getEditorViewMode", () => $52954376e8c36f04$export$419814ca23c581e8);

var $VSDnB = parcelRequire("VSDnB");
// Retrieve the initial config value from the editor view plugin preset
const $52954376e8c36f04$var$getViewModeSync = (preset)=>{
    if (!(0, $VSDnB.fg)('platform_editor_sync_editor_view_mode_state')) return undefined;
    // @ts-expect-error - data is a private property
    const editorViewModePlugin = preset.data.find((p)=>{
        if (Array.isArray(p)) {
            const [plugin, config] = p;
            return plugin({
                config: config
            }).name === 'editorViewMode';
        } else return p?.({
            config: undefined
        })?.name === 'editorViewMode';
    });
    // If we have set a default value on the view mode (index 1) then we can return the mode, otherwise we haven't set by default
    return Array.isArray(editorViewModePlugin) ? editorViewModePlugin[1]?.mode : undefined;
};
const $52954376e8c36f04$export$419814ca23c581e8 = (editorViewModeState, preset)=>{
    if (!editorViewModeState?.mode) return $52954376e8c36f04$var$getViewModeSync(preset);
    return editorViewModeState?.mode;
};

});



parcelRegister("1QYAr", function(module, exports) {

$parcel$export(module.exports, "CoreEditor", () => $74a39720d38c82c6$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ajpes = parcelRequire("ajpes");

var $bXrHm = parcelRequire("bXrHm");

var $1PVpv = parcelRequire("1PVpv");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $iN9lO = parcelRequire("iN9lO");

var $4NUlu = parcelRequire("4NUlu");

var $1rAg3 = parcelRequire("1rAg3");

var $ankW9 = parcelRequire("ankW9");

var $fkGS3 = parcelRequire("fkGS3");

var $5cNeT = parcelRequire("5cNeT");

var $8iwfw = parcelRequire("8iwfw");

var $2E1QW = parcelRequire("2E1QW");

var $cjRyP = parcelRequire("cjRyP");

var $dACrN = parcelRequire("dACrN");

var $1d04s = parcelRequire("1d04s");

var $jRRkB = parcelRequire("jRRkB");

var $2JODI = parcelRequire("2JODI");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $74a39720d38c82c6$var$Editor(passedProps) {
    const propsRef = (0, $5uXOq.useRef)(passedProps);
    const props = (0, $1d04s.default)(passedProps);
    (0, $5uXOq.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $ankW9.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $5uXOq.useMemo)(()=>new (0, $1rAg3.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $5uXOq.useCallback)((data)=>{
        (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $5uXOq.useCallback)(()=>{
        return {
            ...(0, $fkGS3.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $5uXOq.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $iN9lO.startMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $iN9lO.stopMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK, (0, $2JODI.default)((0, $gkwXh.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $5uXOq.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $dACrN.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $jRRkB.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $5uXOq.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, isFullPageApperance ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2E1QW.EditorINPMetrics), null) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cjRyP.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $74a39720d38c82c6$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $5uXOq.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $74a39720d38c82c6$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    const data = (0, $5uXOq.useMemo)(()=>{
        return {
            packageName: (0, $8iwfw.name),
            packageVersion: (0, $8iwfw.version),
            componentName: 'editorCore',
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $74a39720d38c82c6$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($74a39720d38c82c6$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$74a39720d38c82c6$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $74a39720d38c82c6$export$2e2bcd8739ae039 = $74a39720d38c82c6$export$be7eaacc86ce4514;

});
parcelRegister("ctLRZ", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $c6d39b0cc0e8a4ed$export$c7d191551feb734);

var $dWAZk = parcelRequire("dWAZk");

var $3C0Tq = parcelRequire("3C0Tq");
const $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;
const $c6d39b0cc0e8a4ed$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $3C0Tq.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("3C0Tq", function(module, exports) {

$parcel$export(module.exports, "AnalyticsQueue", () => $db724abd22ea4847$export$b44c4ba8fe19bbc7);

var $8QpSo = parcelRequire("8QpSo");
class $db724abd22ea4847$export$b44c4ba8fe19bbc7 {
    static{
        this.get = (0, $8QpSo.default)(()=>new $db724abd22ea4847$export$b44c4ba8fe19bbc7());
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});


parcelRegister("1rAg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd26123fc5f51a3$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $lY6DM = parcelRequire("lY6DM");

var $agxMF = parcelRequire("agxMF");

var $4NUlu = parcelRequire("4NUlu");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $QWvft = parcelRequire("QWvft");

var $9V8N3 = parcelRequire("9V8N3");

var $b1dHu = parcelRequire("b1dHu");

var $pvAs1 = parcelRequire("pvAs1");

var $lIbnY = parcelRequire("lIbnY");

var $9jeYG = parcelRequire("9jeYG");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $fbd26123fc5f51a3$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $fbd26123fc5f51a3$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $fbd26123fc5f51a3$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
            if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        } else this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated This is deprecated and is no longer maintained.
	 *
	 * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
	 * it has inbuilt throttling and is designed for use with `ComposableEditor`.
	 *
	 * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
	 *
	 * WARNING: this may be called repeatedly, async with care
	 */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $QWvft.getEditorValueWithMedia)(editorView);
        const json = (0, $9jeYG.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $kCV8T.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
	 * @example 
	  	const { editorApi, preset } = usePreset(...);
		const extensionAPI = editorAPI?.extension?.actions?.api();
		// Use nodeWithPos as desired
		const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
		const node = nodeWithPos.node;
		const nodePos = nodeWithPos.pos;
	 */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $lIbnY.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $b1dHu.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
	 * This method will return the currently selected `Node` if the selection is a `Node`.
	 * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
	 */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node;
            return (0, $5r0mK.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $pvAs1.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `replaceDocument` found in the core plugin actions instead
	 * using this will reset your Editor State which could cause some things to break (like emojis)
	 * @example - use the `replaceDocument` from the core plugin actions instead
	 * ```ts
	 * const { editorApi, preset } = usePreset(...);
		// where you need it
		editorApi?.core.actions.replaceDocument(value);
		return <ComposableEditor preset={preset} ... />
	 */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $9V8N3.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $agxMF.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $agxMF.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $5r0mK.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $lY6DM.createDispatch)(this.eventDispatcher);
                dispatch((0, $4NUlu.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
	 * If editor is using new collab service,
	 * we want editor to call the collab provider to
	 * retrieve the final acknowledged state of the
	 * editor. The final acknowledged editor state
	 * refers to the latest state of editor with confirmed
	 * steps.
	 */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $QWvft.getEditorValueWithMedia)(editorView);
            const collabEditState = $fbd26123fc5f51a3$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("lY6DM", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $468232df5c6ea546$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $468232df5c6ea546$export$f57f9cc7ce57b7d0);
class $468232df5c6ea546$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $468232df5c6ea546$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $468232df5c6ea546$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($468232df5c6ea546$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("agxMF", function(module, exports) {

$parcel$export(module.exports, "processRawValueWithoutValidation", () => $06227a323d5b9cf2$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $06227a323d5b9cf2$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "processRawFragmentValue", () => $06227a323d5b9cf2$export$89b7989c347e6a7b);

var $6pVhb = parcelRequire("6pVhb");
var $jzlPz = parcelRequire("jzlPz");
var $KiRx2 = parcelRequire("KiRx2");
var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");
var $g7mYL = parcelRequire("g7mYL");
var $dADdx = parcelRequire("dADdx");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $17TS1 = parcelRequire("17TS1");

var $d54NZ = parcelRequire("d54NZ");

var $4IuOY = parcelRequire("4IuOY");
const $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $06227a323d5b9cf2$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) {
        // Convert nested-table extensions into nested tables
        const { transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
        return (0, $kCV8T.Node).fromJSON(schema, transformedAdf);
    } else return (0, $kCV8T.Node).fromJSON(schema, node);
}
function $06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $kCV8T.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dADdx.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $6pVhb.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $g7mYL.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jzlPz.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $KiRx2.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $4IuOY.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $06227a323d5b9cf2$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $kCV8T.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $d54NZ.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $06227a323d5b9cf2$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $kCV8T.Fragment).from(adfEntities);
}
function $06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $06227a323d5b9cf2$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $17TS1.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("6pVhb", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $4ff23f41b9c1a5b1$export$af4e387303482581);

var $l1C1k = parcelRequire("l1C1k");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $4ff23f41b9c1a5b1$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        text: (node)=>{
            if ($4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("jzlPz", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $8dff8a40c1912f4c$export$c06e4b521519af22);

var $l1C1k = parcelRequire("l1C1k");
const $8dff8a40c1912f4c$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $8dff8a40c1912f4c$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $8dff8a40c1912f4c$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        tableCell: (node)=>{
            if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("KiRx2", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf);

var $l1C1k = parcelRequire("l1C1k");

var $ebjue = parcelRequire("ebjue");
const $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $ebjue.isEmpty)(node));
        //remove other remaining dupicates
        $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("g7mYL", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $4a8cb4828f326aed$export$652814b83c30d251);

var $l1C1k = parcelRequire("l1C1k");

var $6DeCT = parcelRequire("6DeCT");
var $50sdg = parcelRequire("50sdg");
var $jVGjh = parcelRequire("jVGjh");
var $geBph = parcelRequire("geBph");

var $ebjue = parcelRequire("ebjue");
const $4a8cb4828f326aed$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $4a8cb4828f326aed$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $50sdg.paragraph)()
            ];
        default:
            return [];
    }
};
const $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $ebjue.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$createValidEmptyContent(node)
            };
        }
    };
const $4a8cb4828f326aed$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $4a8cb4828f326aed$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $ebjue.isEmpty)(childNode)) {
                    const result = (0, $6DeCT.listItem)([
                        (0, $50sdg.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $6DeCT.listItem)([
                    (0, $50sdg.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $6DeCT.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($4a8cb4828f326aed$var$hasNonListItemChildren(node) || $4a8cb4828f326aed$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $4a8cb4828f326aed$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $4a8cb4828f326aed$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $geBph.tableRow)([
                    (0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $geBph.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $ebjue.isEmpty)(childNode)) return (0, $geBph.tableRow)([
                    ...new Array(maxColsCount).fill((0, $jVGjh.tableCell)({})((0, $50sdg.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $4a8cb4828f326aed$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($4a8cb4828f326aed$var$hasEmptyTableRowChildren(node) || $4a8cb4828f326aed$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $4a8cb4828f326aed$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $ebjue.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $4a8cb4828f326aed$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $l1C1k.traverse)(adf, {
        tableCell: $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $l1C1k.traverse)(transformedAdf || adf, {
        mediaSingle: $4a8cb4828f326aed$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $l1C1k.traverse)(transformedAdf || adf, {
        bulletList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("6DeCT", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $a2cd5bff5444dafb$export$76c7e83ecc9cdf05);
const $a2cd5bff5444dafb$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("jVGjh", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $45a16984030f79a3$export$e1e720e5f4603e6a);
const $45a16984030f79a3$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("geBph", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $3b3a7f8c343ad0af$export$ce666bf02318c957);
const $3b3a7f8c343ad0af$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("dADdx", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $1d4506554e727afe$export$3d531d2daf0e8a14);

var $l1C1k = parcelRequire("l1C1k");
const $1d4506554e727afe$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $1d4506554e727afe$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $1d4506554e727afe$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        text: (node)=>{
            if ($1d4506554e727afe$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $1d4506554e727afe$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("17TS1", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $149b214359f7ee68$export$8a32f625580e0a06);

var $l1C1k = parcelRequire("l1C1k");

var $3mm6g = parcelRequire("3mm6g");
function $149b214359f7ee68$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $3mm6g.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});
parcelRegister("3mm6g", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $9565842f98e50876$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $9565842f98e50876$export$ae1fce5f69858ef3);

var $dS9cn = parcelRequire("dS9cn");

var $cqJWb = parcelRequire("cqJWb");

var $6Ctoj = parcelRequire("6Ctoj");

var $4kfbr = parcelRequire("4kfbr");

var $lFKmC = parcelRequire("lFKmC");
const $9565842f98e50876$var$MAX_QUERY_ITEMS = 100;
const $9565842f98e50876$var$MAX_NOTIFIED_ITEMS = 20;
const $9565842f98e50876$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $9565842f98e50876$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $9565842f98e50876$export$8576ba1ed2760927 extends $9565842f98e50876$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $6Ctoj.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $6Ctoj.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $9565842f98e50876$export$5a4331e3e1c43553 extends $9565842f98e50876$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $6Ctoj.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $cqJWb.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $9565842f98e50876$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).INITIAL_STATE, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $9565842f98e50876$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dS9cn.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4kfbr.SLI_EVENT_TYPE), (0, $cqJWb.SliNames).SEARCH, (0, $cqJWb.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $cqJWb.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $cqJWb.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $9565842f98e50876$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $9565842f98e50876$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $9565842f98e50876$export$2e2bcd8739ae039 = $9565842f98e50876$export$5a4331e3e1c43553;

});
parcelRegister("cqJWb", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $90ca79fb430b6e09$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $90ca79fb430b6e09$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $90ca79fb430b6e09$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $90ca79fb430b6e09$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $90ca79fb430b6e09$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $90ca79fb430b6e09$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $90ca79fb430b6e09$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $90ca79fb430b6e09$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $90ca79fb430b6e09$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $90ca79fb430b6e09$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $90ca79fb430b6e09$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $90ca79fb430b6e09$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $90ca79fb430b6e09$export$4369c812aac99591);
var $90ca79fb430b6e09$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $90ca79fb430b6e09$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $90ca79fb430b6e09$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $90ca79fb430b6e09$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $90ca79fb430b6e09$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $90ca79fb430b6e09$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $90ca79fb430b6e09$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
}
function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
}
function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
}
function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
}
function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("6Ctoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e109bd73548e92fc$export$2e2bcd8739ae039);
let $e109bd73548e92fc$var$debugEnabled = false;
let $e109bd73548e92fc$var$stacktracesEnabled = false;
function $e109bd73548e92fc$export$748ada60eaf985cc(enable) {
    $e109bd73548e92fc$var$debugEnabled = enable;
}
function $e109bd73548e92fc$export$4f7017086af31c25(enable) {
    $e109bd73548e92fc$var$stacktracesEnabled = enable;
}
function $e109bd73548e92fc$export$2a858f450a2f66d() {
    if ($e109bd73548e92fc$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e109bd73548e92fc$export$2e2bcd8739ae039(msg, ...args) {
    if ($e109bd73548e92fc$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4kfbr", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $f8976e2813fe24b2$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $f8976e2813fe24b2$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $f8976e2813fe24b2$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $f8976e2813fe24b2$export$91b2fa6a0fe06408);



var $cqJWb = parcelRequire("cqJWb");
const $f8976e2813fe24b2$var$packageName = "platform-pkg";
const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, $cqJWb.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $cqJWb.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        return event;
    };
const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        attributes: {
            packageName: $f8976e2813fe24b2$var$packageName,
            packageVersion: $f8976e2813fe24b2$var$packageVersion,
            componentName: (0, $cqJWb.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $cqJWb.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, $cqJWb.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $cqJWb.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';





parcelRegister("QWvft", function(module, exports) {

$parcel$export(module.exports, "getEditorValueWithMedia", () => $ef540e8b72c50d6c$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $ef540e8b72c50d6c$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $ef540e8b72c50d6c$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $ef540e8b72c50d6c$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("9V8N3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a285f68f22f6664d$export$2e2bcd8739ae039);
function $a285f68f22f6664d$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $a285f68f22f6664d$export$2e2bcd8739ae039 = $a285f68f22f6664d$var$deprecationWarnings;

});

parcelRegister("b1dHu", function(module, exports) {

$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $d7150c63727d169a$export$1dc8bea8646ac811);
const $d7150c63727d169a$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("pvAs1", function(module, exports) {

$parcel$export(module.exports, "isEmptyDocument", () => $2b33f98e049d60d3$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $2b33f98e049d60d3$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $2b33f98e049d60d3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $2b33f98e049d60d3$export$b648602b09795358(nodeChild);
}

});

parcelRegister("lIbnY", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $59fd907a3078acac$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $59fd907a3078acac$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("9jeYG", function(module, exports) {

$parcel$export(module.exports, "toJSON", () => $75ea2b648e87890e$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $hYNZx = parcelRequire("hYNZx");
const $75ea2b648e87890e$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $75ea2b648e87890e$export$54fd2c36b5cc6731(node) {
    return $75ea2b648e87890e$var$transformer.encode(node);
}

});


parcelRegister("ankW9", function(module, exports) {

$parcel$export(module.exports, "useEditorContext", () => $0216bf80b2f4530e$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $0216bf80b2f4530e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $8v2ZL = parcelRequire("8v2ZL");

var $VSDnB = parcelRequire("VSDnB");

var $1rAg3 = parcelRequire("1rAg3");
const $0216bf80b2f4530e$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $8v2ZL.EditorContext));
class $0216bf80b2f4530e$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
    }
    render() {
        if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2') || (0, $VSDnB.fg)('platform_editor_react18_phase2_v2_extended')) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($0216bf80b2f4530e$var$LegacyEditorContextNew, {
            ...this.props,
            children: this.props.children
        });
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($0216bf80b2f4530e$export$2e2bcd8739ae039, {
            ...this.props,
            children: this.props.children
        });
    }
}
function $0216bf80b2f4530e$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8v2ZL.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $1rAg3.default)()
        },
        children: children
    });
}
class $0216bf80b2f4530e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.childContextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
        };
    }
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $1rAg3.default)();
    }
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8v2ZL.EditorContext).Provider, {
            value: this.getChildContext(),
            children: this.props.children
        });
    }
}

});
parcelRegister("8v2ZL", function(module, exports) {

$parcel$export(module.exports, "EditorContext", () => $1ceb886f8ac7152d$export$27b8dd149e32f6c7);

var $5uXOq = parcelRequire("5uXOq");
const $1ceb886f8ac7152d$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});

});


parcelRegister("fkGS3", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $9cb3176a03e5a295$export$63102b0cbe181144);

var $4zXba = parcelRequire("4zXba");
function $9cb3176a03e5a295$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $9cb3176a03e5a295$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $9cb3176a03e5a295$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $9cb3176a03e5a295$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $9cb3176a03e5a295$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $9cb3176a03e5a295$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("5cNeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6d404d928de370$export$2e2bcd8739ae039);
var $7b6d404d928de370$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("8iwfw", function(module, exports) {

$parcel$export(module.exports, "name", () => $060d6f70d3cebea6$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $060d6f70d3cebea6$export$83d89fbfd8236492);
const $060d6f70d3cebea6$export$a8ff84c12d48cfa6 = "platform-pkg";
const $060d6f70d3cebea6$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("2E1QW", function(module, exports) {

$parcel$export(module.exports, "EditorINPMetrics", () => $50f25bf0d2d29280$export$5942461441325be9);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $4UKRW = parcelRequire("4UKRW");

var $bFU4G = parcelRequire("bFU4G");
const $50f25bf0d2d29280$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $2NMNM.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $5uXOq.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $50f25bf0d2d29280$var$createIdleCallback(()=>{
            cleanupFn = (0, $4UKRW.setupINPTracking)(({ value: value })=>{
                const interaction = (0, $bFU4G.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $50f25bf0d2d29280$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $50f25bf0d2d29280$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $50f25bf0d2d29280$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};

});
parcelRegister("4UKRW", function(module, exports) {

$parcel$export(module.exports, "setupINPTracking", () => $5650593f5a79c4e4$export$56930d9a67e0aae6);

var $64jjv = parcelRequire("64jjv");

var $6cAn5 = parcelRequire("6cAn5");
const $5650593f5a79c4e4$export$56930d9a67e0aae6 = (callback)=>{
    if (!$5650593f5a79c4e4$var$isINPSupported()) return;
    return (0, $64jjv.onINP)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $5650593f5a79c4e4$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $6cAn5 !== 'undefined' && Boolean($6cAn5?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};

});
parcelRegister("64jjv", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $72521b5ed45c791e$export$7df4b36ecaed99e1);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts

var $k7PDJ = parcelRequire("k7PDJ");

var $6R2LH = parcelRequire("6R2LH");

var $gvLIy = parcelRequire("gvLIy");

var $gZE3o = parcelRequire("gZE3o");
const $72521b5ed45c791e$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $k7PDJ.bindReporter)(callback);
    const interactionManager = new (0, $6R2LH.InteractionManager)();
    const handleEntries = (entries)=>{
        (0, $gZE3o.whenIdle)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $72521b5ed45c791e$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $gvLIy.onHidden)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $72521b5ed45c791e$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};

});
parcelRegister("k7PDJ", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $95736c0e24388675$export$17679dccdd551979);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $95736c0e24388675$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};

});

parcelRegister("6R2LH", function(module, exports) {

$parcel$export(module.exports, "InteractionManager", () => $0dce2132e627a665$export$aaa80641d584351c);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts

var $8sEWa = parcelRequire("8sEWa");
class $0dce2132e627a665$export$aaa80641d584351c {
    static{
        this.MAX_INTERACTIONS_TO_CONSIDER = 10;
    }
    constructor(){
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $8sEWa.InteractionCountPolyfill)();
    }
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
	 * Returns the estimated p98 longest interaction based on the stored
	 * interaction candidates and the interaction count for the current page.
	 */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
	 * Takes a performance entry and adds it to the list of worst interactions
	 * if its duration is long enough to make it among the worst. If the
	 * entry is part of an existing interaction, it is merged and the latency
	 * and entries list is updated as needed.
	 */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($0dce2132e627a665$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
}

});
parcelRegister("8sEWa", function(module, exports) {

$parcel$export(module.exports, "InteractionCountPolyfill", () => $8d7ae74f6dbc524a$export$51e52147760fc784);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $8d7ae74f6dbc524a$export$51e52147760fc784 {
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
	 * Returns the `interactionCount` value using the native API (if available)
	 * or the polyfill estimate in this module.
	 */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
}

});


parcelRegister("gvLIy", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $7bab6a12dd8cc283$export$91ec2be6fdd8f1b4);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $7bab6a12dd8cc283$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};

});

parcelRegister("gZE3o", function(module, exports) {

$parcel$export(module.exports, "whenIdle", () => $b819e9ee269a4812$export$4d9952dcbf5b2792);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

var $gvLIy = parcelRequire("gvLIy");
const $b819e9ee269a4812$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $b819e9ee269a4812$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $gvLIy.onHidden)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $b819e9ee269a4812$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});




parcelRegister("cjRyP", function(module, exports) {

$parcel$export(module.exports, "EditorInternal", () => $71ed6365bae516ba$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gkwXh = parcelRequire("gkwXh");

var $gJcSd = parcelRequire("gJcSd");

var $VSDnB = parcelRequire("VSDnB");

var $ax7J7 = parcelRequire("ax7J7");

var $fbZFm = parcelRequire("fbZFm");

var $ankW9 = parcelRequire("ankW9");

var $fggrl = parcelRequire("fggrl");

var $fkGS3 = parcelRequire("fkGS3");

var $g5Huu = parcelRequire("g5Huu");

var $j0Vvw = parcelRequire("j0Vvw");

var $8pML4 = parcelRequire("8pML4");
function $71ed6365bae516ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $71ed6365bae516ba$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $71ed6365bae516ba$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $5uXOq.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $fkGS3.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $VSDnB.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $gJcSd.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $gJcSd.usePortalProvider)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $g5Huu.RenderTracking), {
        componentProps: props,
        action: (0, $gkwXh.ACTION).RE_RENDERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ax7J7.default), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $71ed6365bae516ba$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ankW9.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fggrl.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fbZFm.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $j0Vvw.BaseThemeWrapper), {
                baseFontSize: (0, $8pML4.getBaseFontSize)(props.appearance)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeViewPortalRenderer, null)))))));
});

});
parcelRegister("gJcSd", function(module, exports) {

$parcel$export(module.exports, "usePortalProvider", () => $1a1c543e60e2eb98$export$9b00782c24eb3d6b);

var $5uXOq = parcelRequire("5uXOq");

var $fi43S = parcelRequire("fi43S");

var $kPNeK = parcelRequire("kPNeK");
function $1a1c543e60e2eb98$export$9b00782c24eb3d6b() {
    const portalManager = (0, $5uXOq.useMemo)(()=>new (0, $kPNeK.PortalManager)(), []);
    const PortalRenderer = (0, $5uXOq.useMemo)(()=>(0, $fi43S.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $5uXOq.useMemo)(()=>(0, $fi43S.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("fi43S", function(module, exports) {

$parcel$export(module.exports, "createPortalRendererComponent", () => $1acbd9e60fdf02dd$export$adfaaa25a1ea6e69);
$parcel$export(module.exports, "getPortalProviderAPI", () => $1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fh7Yr = parcelRequire("fh7Yr");
function $1acbd9e60fdf02dd$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $5uXOq.useState)(portalManager.getBuckets());
        (0, $5uXOq.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $5uXOq.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fh7Yr.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: portalsElements
        });
    };
}
const $1acbd9e60fdf02dd$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: getChildren()
    });
};
const $1acbd9e60fdf02dd$var$PortalRenderWrapper = /*#__PURE__*/ (0, $5uXOq.memo)($1acbd9e60fdf02dd$export$eab0ea19ad3bed77);
$1acbd9e60fdf02dd$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)($1acbd9e60fdf02dd$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            } else {
                const portal = /*#__PURE__*/ (0, $7nsd3.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("fh7Yr", function(module, exports) {

$parcel$export(module.exports, "PortalBucket", () => $0dce56c275d3c858$export$828f0f29e8293a07);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $0dce56c275d3c858$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $5uXOq.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $5uXOq.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $5uXOq.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: portalElements
    });
}

});


parcelRegister("kPNeK", function(module, exports) {

$parcel$export(module.exports, "PortalManager", () => $1815e788e0c02d29$export$52c7ef79917c2f38);
const $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS = 50;
const $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO = 0.5;
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $1815e788e0c02d29$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $1815e788e0c02d29$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO){
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$1815e788e0c02d29$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($1815e788e0c02d29$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
    }
    updateBuckets(id) {
        this.buckets[id].updater?.(()=>{
            // new object is required to trigger react updates
            return {
                ...this.buckets[id].portals
            };
        });
    }
    registerPortal(key, portal) {
        this.createBucket();
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        this.portalToBucketMap.set(key, id);
        if (this.buckets[id].portals[key] !== portal) {
            this.buckets[id].portals[key] = portal;
            this.updateBuckets(id);
        }
        //returns a function to unregister the portal
        return ()=>{
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            this.buckets[id].capacity += 1;
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
            this.updateBuckets(id);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
	 * Cleans up resources used by the PortalManager. This includes clearing all portals,
	 * unregistering all buckets, and resetting internal state.
	 */ destroy() {
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("ax7J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $60d0c72e469dbfd3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $ifv4n = parcelRequire("ifv4n");

var $fIJEx = parcelRequire("fIJEx");

var $1KzE6 = parcelRequire("1KzE6");

var $1eqsC = parcelRequire("1eqsC");

var $jAZiu = parcelRequire("jAZiu");
class $60d0c72e469dbfd3$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            rethrow: true,
            errorTracking: true
        };
    }
    constructor(props){
        super(props), this.browserExtensions = undefined, this.state = {
            error: undefined
        }, this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $ifv4n.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $1eqsC.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $1KzE6.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        }, this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        }, this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ctLRZ.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIJEx.IntlErrorBoundary), {
            children: this.props.children
        });
    }
}
var $60d0c72e469dbfd3$export$2e2bcd8739ae039 = (0, $jAZiu.WithEditorView)($60d0c72e469dbfd3$export$d6d3bedcc5fc09c8);

});
parcelRegister("ifv4n", function(module, exports) {

$parcel$export(module.exports, "getDocStructure", () => $a2ddee04b57518c1$export$6451b72139862cbd);
const $a2ddee04b57518c1$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $a2ddee04b57518c1$var$shortHash(type, isMark) {
    const code = $a2ddee04b57518c1$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $a2ddee04b57518c1$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$a2ddee04b57518c1$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$a2ddee04b57518c1$var$compactStringifier(node)).join(',');
    return marks(`${$a2ddee04b57518c1$var$shortHash(node.type, false)}(${content})`);
}
const $a2ddee04b57518c1$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $a2ddee04b57518c1$var$getBlockNode(doc, 0);
        if (options?.compact) return $a2ddee04b57518c1$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $a2ddee04b57518c1$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $a2ddee04b57518c1$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $a2ddee04b57518c1$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $a2ddee04b57518c1$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $a2ddee04b57518c1$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $a2ddee04b57518c1$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $a2ddee04b57518c1$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $a2ddee04b57518c1$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $a2ddee04b57518c1$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("1eqsC", function(module, exports) {

$parcel$export(module.exports, "isOutdatedBrowser", () => $f4d0395ac92d9621$export$12d09524e028927);
const $f4d0395ac92d9621$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("jAZiu", function(module, exports) {

$parcel$export(module.exports, "WithEditorView", () => $54173e5a1716911b$export$cf381084b490bd31);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ankW9 = parcelRequire("ankW9");
const $54173e5a1716911b$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $ankW9.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("fbZFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0780699b8986d8d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bXrHm = parcelRequire("bXrHm");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
var $hETfp = parcelRequire("hETfp");

var $lY6DM = parcelRequire("lY6DM");

var $2cB15 = parcelRequire("2cB15");
var $7Em36 = parcelRequire("7Em36");

var $cK5m0 = parcelRequire("cK5m0");

var $4zXba = parcelRequire("4zXba");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $3IZIX = parcelRequire("3IZIX");

var $agxMF = parcelRequire("agxMF");

var $12Kqg = parcelRequire("12Kqg");

var $4NUlu = parcelRequire("4NUlu");

var $ggL2v = parcelRequire("ggL2v");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $geOTC = parcelRequire("geOTC");

var $fkGS3 = parcelRequire("fkGS3");

var $az5cZ = parcelRequire("az5cZ");

var $5j6KQ = parcelRequire("5j6KQ");

var $g5Huu = parcelRequire("g5Huu");

var $5cNeT = parcelRequire("5cNeT");


var $9MoyJ = parcelRequire("9MoyJ");

var $gAD8U = parcelRequire("gAD8U");

var $ijurB = parcelRequire("ijurB");

var $h0q50 = parcelRequire("h0q50");

var $7HMhY = parcelRequire("7HMhY");

var $cj93n = parcelRequire("cj93n");

var $jNTUV = parcelRequire("jNTUV");

var $kpgvz = parcelRequire("kpgvz");
const $b0780699b8986d8d$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $b0780699b8986d8d$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $5uXOq.useState)(undefined);
    const editorRef = (0, $5uXOq.useRef)(null);
    const viewRef = (0, $5uXOq.useRef)();
    const focusTimeoutId = (0, $5uXOq.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $5uXOq.useRef)(true);
    const editorId = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    const eventDispatcher = (0, $5uXOq.useMemo)(()=>new (0, $lY6DM.EventDispatcher)(), []);
    const config = (0, $5uXOq.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $5uXOq.useRef)(undefined);
    const featureFlags = (0, $5uXOq.useMemo)(()=>(0, $fkGS3.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $5uXOq.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $5uXOq.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $5uXOq.useMemo)(()=>(0, $lY6DM.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $5uXOq.useMemo)(()=>(0, $9MoyJ.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        (0, $ctLRZ.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const dispatch = (0, $lY6DM.createDispatch)(eventDispatcher);
        dispatch((0, $4NUlu.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $5uXOq.useRef)(new (0, $3IZIX.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    (0, $5uXOq.useLayoutEffect)(()=>{
        setEditorAPI(pluginInjectionAPI.current.api());
    }, []);
    const createEditorState = (0, $5uXOq.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
					 * ReactEditorView currently does NOT handle dynamic schema,
					 * We are reusing the existing schema, and rely on #reconfigureState
					 * to update `this.config`
					 */ schema = viewRef.current.state.schema;
            else {
                /**
					 * There's presently a number of issues with changing the schema of a
					 * editor inflight. A significant issue is that we lose the ability
					 * to keep track of a user's history as the internal plugin state
					 * keeps a list of Steps to undo/redo (which are tied to the schema).
					 * Without a good way to do work around this, we prevent this for now.
					 */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $9MoyJ.processPluginsList)((0, $gAD8U.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $ijurB.createSchema)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $9MoyJ.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $VSDnB.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined && (0, $VSDnB.fg)('editor_load_conf_collab_docs_without_checks') || options.props.editorProps.skipValidation) doc = (0, $agxMF.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $agxMF.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $gZGBX.TextSelection)(doc.resolve(0));
                return (0, $gZGBX.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $gZGBX.Selection).atStart(doc) : (0, $gZGBX.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $gZGBX.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $gZGBX.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $5uXOq.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $5j6KQ.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $5uXOq.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $5uXOq.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $5uXOq.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local'
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $2cB15.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).STARTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $hETfp.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $4zXba.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        });
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $5uXOq.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $gAD8U.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $9MoyJ.processPluginsList)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $9MoyJ.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $VSDnB.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $5uXOq.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        if (!(0, $VSDnB.fg)('platform_editor_catch_missing_injection_states')) pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: newEditorState,
            oldEditorState: oldEditorState
        });
        if (!(0, $VSDnB.fg)('platform_editor_migrate_state_updates')) config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $jNTUV.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $geOTC.useProviders)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $5uXOq.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $5uXOq.useCallback)((node)=>{
        (0, $ap7h6.measureRender)((0, $5cNeT.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $4NUlu.getAnalyticsEventSeverity)(duration, (0, $da8c6c1b49848045$export$646a6982857f2cd5), (0, $da8c6c1b49848045$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodes = (0, $az5cZ.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $kFiBa.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $etG8M.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $5uXOq.useState)(undefined);
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef((0, $5j6KQ.isFullPage)(props.editorProps.appearance) && (0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start') ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $5j6KQ.isFullPage)(props.editorProps.appearance) && (0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start') && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix')) {
            if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (!mitigateScrollJump) {
                    const liveDocWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(editorView.state.doc);
                    if (!liveDocWithContent || !(0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(editorView);
                }
            } else {
                const liveDocWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent || !(0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump
    ]);
    const handleEditorViewRef = (0, $5uXOq.useCallback)((node)=>{
        if (!viewRef.current && node) {
            // make sure this doesn't expose the experiment
            if ((0, $gmhCD.editorExperiment)('platform_editor_nodevisibility', true, {
                exposure: false
            })) (0, $cK5m0.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (mitigateScrollJump) {
                    const scrollElement = document.querySelector('[data-editor-scroll-container]');
                    scrollElement?.scrollTo({
                        top: originalScrollToRestore.current,
                        behavior: 'instant'
                    });
                }
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
					 * Defer using startTransition when it is available (in React 18) to fix
					 * autofocus bug where React 18's concurrent rendering mode interferes with
					 * setTimeout used in handleEditorFocus, causing autofocus to break.
					 */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if ((0, $VSDnB.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                        if (!mitigateScrollJump) {
                            const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(view.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
                            if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(view);
                        }
                    } else {
                        const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(view.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(view);
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $4NUlu.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            if ((0, $gmhCD.editorExperiment)('platform_editor_nodevisibility', true)) (0, $cK5m0.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $5uXOq.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7HMhY.getUAPrefix)(),
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || props.intl.formatMessage((0, $h0q50.editorMessages).editorAssistiveLabel),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $b0780699b8986d8d$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current
        }, "ProseMirror");
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $7Em36.default)(preset);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7Em36.default)(disabled);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = __livePage && !(0, $ggL2v.isEmptyDocument)(viewRef.current.state.doc) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init');
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $cj93n.handleEditorFocus)(viewRef.current);
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $kpgvz.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $5uXOq.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $VSDnB.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $12Kqg.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        },
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g5Huu.RenderTracking), {
                componentProps: props,
                action: (0, $gkwXh.ACTION).RE_RENDERED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }),
            props.render ? props.render?.({
                editor: editor,
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorRef: editorRef,
                editorAPI: editorAPI
            }) ?? editor : editor
        ]
    });
}
var $b0780699b8986d8d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b0780699b8986d8d$export$e7d1b1cbca007e16);

});
parcelRegister("2cB15", function(module, exports) {

$parcel$export(module.exports, "default", () => $304fa3f1418bd834$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $304fa3f1418bd834$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $5uXOq.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("7Em36", function(module, exports) {

$parcel$export(module.exports, "default", () => $474014b73fe6d1f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $474014b73fe6d1f7$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $5uXOq.useRef)(initialValue);
    (0, $5uXOq.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("cK5m0", function(module, exports) {

$parcel$export(module.exports, "nodeVisibilityManager", () => $43226ec0429bc0c3$export$565ab8668cdfbb7c);
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $43226ec0429bc0c3$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $43226ec0429bc0c3$var$editorObservers = new WeakMap();
const $43226ec0429bc0c3$var$callbackMap = new WeakMap();
const $43226ec0429bc0c3$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $43226ec0429bc0c3$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $43226ec0429bc0c3$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $43226ec0429bc0c3$var$callbackMap.set(observerConfig.element, observerConfig);
        $43226ec0429bc0c3$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($43226ec0429bc0c3$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($43226ec0429bc0c3$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $43226ec0429bc0c3$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $43226ec0429bc0c3$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $43226ec0429bc0c3$var$editorObservers.get(editorElement)?.disconnect();
        $43226ec0429bc0c3$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};

});

parcelRegister("3IZIX", function(module, exports) {

$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $90985e08491cf82f$export$50ccbedb1c6559a0);

var $ajpes = parcelRequire("ajpes");

var $34ck9 = parcelRequire("34ck9");

var $31bJ2 = parcelRequire("31bJ2");
function $90985e08491cf82f$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $90985e08491cf82f$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $90985e08491cf82f$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $90985e08491cf82f$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $90985e08491cf82f$var$hasGetSharedState(plugin));
const $90985e08491cf82f$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$90985e08491cf82f$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $90985e08491cf82f$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $90985e08491cf82f$export$855252f33d470a3f {
}
class $90985e08491cf82f$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$90985e08491cf82f$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $90985e08491cf82f$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$90985e08491cf82f$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $90985e08491cf82f$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$90985e08491cf82f$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $90985e08491cf82f$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $90985e08491cf82f$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $90985e08491cf82f$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $90985e08491cf82f$var$editorAPICache = new WeakMap();
class $90985e08491cf82f$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $90985e08491cf82f$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $90985e08491cf82f$var$ActionsAPI();
        this.commandsAPI = new $90985e08491cf82f$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $31bJ2.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$90985e08491cf82f$var$editorAPICache.get(this)) $90985e08491cf82f$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $90985e08491cf82f$var$editorAPICache.get(this);
    }
}

});
parcelRegister("31bJ2", function(module, exports) {

$parcel$export(module.exports, "corePlugin", () => $bd2341d5492ad0c3$export$71ab138dd170c35);

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $agxMF = parcelRequire("agxMF");

var $31nwk = parcelRequire("31nwk");

var $hcUHh = parcelRequire("hcUHh");
const $bd2341d5492ad0c3$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $hcUHh.createThrottleSchedule)((0, $hcUHh.returnDocumentRequest));
    return {
        name: 'core',
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $31nwk.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $agxMF.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $agxMF.processRawFragmentValue)(schema, replaceValue) : (0, $agxMF.processRawValue)(schema, replaceValue);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $VSDnB.fg)('platform_editor_replace_document_shortcircuit') && content instanceof (0, $kCV8T.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr);
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            }
        }
    };
};

});
parcelRegister("hcUHh", function(module, exports) {

$parcel$export(module.exports, "createThrottleSchedule", () => $fb1316c40c469b7f$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $fb1316c40c469b7f$export$dce79649e5264171);

var $hYNZx = parcelRequire("hYNZx");

var $kCV8T = parcelRequire("kCV8T");

var $gkwXh = parcelRequire("gkwXh");
const $fb1316c40c469b7f$var$transformer = new (0, $hYNZx.JSONTransformer)();
function $fb1316c40c469b7f$export$54fd2c36b5cc6731(node) {
    return $fb1316c40c469b7f$var$transformer.encode(node);
}
function $fb1316c40c469b7f$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) callback(...lastArgs);
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $fb1316c40c469b7f$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $fb1316c40c469b7f$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $kCV8T.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $gkwXh.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}

});



parcelRegister("geOTC", function(module, exports) {

$parcel$export(module.exports, "useProviders", () => $4ce81023af8e02ce$export$e4c19534640d7866);

var $5uXOq = parcelRequire("5uXOq");
const $4ce81023af8e02ce$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $5uXOq.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("az5cZ", function(module, exports) {

$parcel$export(module.exports, "getNodesCount", () => $73bdd5ff554f00ca$export$3674f49b2d541ad);
function $73bdd5ff554f00ca$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("g5Huu", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $d1e11c1c8b2cc0e9$export$fe16de086fea1f5f);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $gkwXh = parcelRequire("gkwXh");

var $REa58 = parcelRequire("REa58");
function $d1e11c1c8b2cc0e9$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $REa58.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("REa58", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $8eae713cd4396df0$export$ebce6d7d8ca67353);

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $cCR0b = parcelRequire("cCR0b");
function $8eae713cd4396df0$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $5uXOq.useRef)();
    const renderCountRef = (0, $5uXOq.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))());
    (0, $5uXOq.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $cCR0b.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $cCR0b.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("cCR0b", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $8e3652061a23f798$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $8e3652061a23f798$export$418b0a935c0a0030);

var $5uXOq = parcelRequire("5uXOq");
const $8e3652061a23f798$export$74743eda5dda3ccf = Object.keys;
const $8e3652061a23f798$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $8e3652061a23f798$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $8e3652061a23f798$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $8e3652061a23f798$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value1),
                newValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $8e3652061a23f798$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



const $da8c6c1b49848045$export$646a6982857f2cd5 = 2000;
const $da8c6c1b49848045$export$79d7eac6cbb6352d = 3000;
const $da8c6c1b49848045$export$7d7bd496a5206996 = 100;

parcelRegister("9MoyJ", function(module, exports) {

$parcel$export(module.exports, "fixExcludes", () => $c0c676c2bd95d8c4$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $c0c676c2bd95d8c4$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $c0c676c2bd95d8c4$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $c0c676c2bd95d8c4$export$e98521bb0cea2db1);

var $fTi1m = parcelRequire("fTi1m");

var $aZPvj = parcelRequire("aZPvj");

var $1AaPO = parcelRequire("1AaPO");
function $c0c676c2bd95d8c4$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $c0c676c2bd95d8c4$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $c0c676c2bd95d8c4$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $c0c676c2bd95d8c4$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $aZPvj.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $1AaPO.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $c0c676c2bd95d8c4$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $fTi1m.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("fTi1m", function(module, exports) {

$parcel$export(module.exports, "ErrorReporter", () => $af8126628ab56549$export$88da0ac32d9c271e);
class $af8126628ab56549$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("aZPvj", function(module, exports) {

$parcel$export(module.exports, "sortByOrder", () => $c37ea3a6202d7c12$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $c37ea3a6202d7c12$export$b4ae7ad1c009d0a1);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $c37ea3a6202d7c12$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $c37ea3a6202d7c12$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});

parcelRegister("1AaPO", function(module, exports) {

$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $8fbcfb1366e3adf2$export$e0355cecc74597d);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $8fbcfb1366e3adf2$var$key = new (0, $gZGBX.PluginKey)('editorStateNotificationPlugin');
const $8fbcfb1366e3adf2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    let transactions = [];
    return new (0, $5KWxh.SafePlugin)({
        key: $8fbcfb1366e3adf2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    const originalTransaction = $8fbcfb1366e3adf2$var$key.getState(view.state)?.latestTransaction;
                    if (originalTransaction && (0, $VSDnB.fg)('platform_editor_migrate_state_updates')) {
                        onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                            entry.callback({
                                originalTransaction: originalTransaction,
                                transactions: transactions,
                                oldEditorState: oldEditorState,
                                newEditorState: view.state
                            });
                        });
                        transactions = [];
                    }
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});


parcelRegister("gAD8U", function(module, exports) {

$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $fae66c98e35fd436$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $fae66c98e35fd436$export$2e2bcd8739ae039);

var $fkGS3 = parcelRequire("fkGS3");

var $5j6KQ = parcelRequire("5j6KQ");
const $fae66c98e35fd436$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $fae66c98e35fd436$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $5j6KQ.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $fae66c98e35fd436$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $fkGS3.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $fae66c98e35fd436$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $fae66c98e35fd436$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$fae66c98e35fd436$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("ijurB", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $e23c0e6a9c2302d0$export$5f4ce795563f4211);

var $7P7H6 = parcelRequire("7P7H6");

var $aZPvj = parcelRequire("aZPvj");

var $2RN5d = parcelRequire("2RN5d");

var $kCV8T = parcelRequire("kCV8T");

var $9MoyJ = parcelRequire("9MoyJ");
const $e23c0e6a9c2302d0$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $2RN5d.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $e23c0e6a9c2302d0$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $e23c0e6a9c2302d0$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $e23c0e6a9c2302d0$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $e23c0e6a9c2302d0$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $e23c0e6a9c2302d0$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $9MoyJ.fixExcludes)(editorConfig.marks.sort((0, $aZPvj.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $7P7H6.sanitizeNodes)(editorConfig.nodes.sort((0, $aZPvj.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});

parcelRegister("h0q50", function(module, exports) {

$parcel$export(module.exports, "editorMessages", () => $83b423bd4c954bb9$export$3b488057bfc1868f);

var $7VHMR = parcelRequire("7VHMR");
const $83b423bd4c954bb9$export$3b488057bfc1868f = (0, $7VHMR.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    }
});

});

parcelRegister("7HMhY", function(module, exports) {

$parcel$export(module.exports, "getUAPrefix", () => $6f98ce41d7ee5a01$export$11a24c7b1b4aab81);

var $gE8f9 = parcelRequire("gE8f9");
function $6f98ce41d7ee5a01$export$11a24c7b1b4aab81() {
    if ((0, $gE8f9.browser).chrome) return 'ua-chrome';
    else if ((0, $gE8f9.browser).ie) return 'ua-ie';
    else if ((0, $gE8f9.browser).gecko) return 'ua-firefox';
    else if ((0, $gE8f9.browser).safari) return 'ua-safari';
    return '';
}

});

parcelRegister("cj93n", function(module, exports) {

$parcel$export(module.exports, "handleEditorFocus", () => $86566110343db703$export$ebebb7f5b9271fd7);

var $5uXOq = parcelRequire("5uXOq");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
function $86566110343db703$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)))?.startTransition && (0, $VSDnB.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if ((0, $VSDnB.fg)('platform_editor_posfromdom_null_fix')) {
            if (view?.isDestroyed) return;
        }
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $gZGBX.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}

});

parcelRegister("jNTUV", function(module, exports) {

$parcel$export(module.exports, "useDispatchTransaction", () => $8e65b5e3b9ae9277$export$b582387940572fe7);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");
var $J5Axj = parcelRequire("J5Axj");

var $ifv4n = parcelRequire("ifv4n");

var $iN9lO = parcelRequire("iN9lO");

var $VSDnB = parcelRequire("VSDnB");

var $4r96J = parcelRequire("4r96J");

var $acfJa = parcelRequire("acfJa");

var $dReYX = parcelRequire("dReYX");

var $96xlM = parcelRequire("96xlM");
const $8e65b5e3b9ae9277$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $5uXOq.useRef)(onChange);
    (0, $5uXOq.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $5uXOq.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $4r96J.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $96xlM.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $acfJa.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? (0, $VSDnB.fg)('platform_editor_transaction_skip_validation') && isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                (0, $iN9lO.startMeasure)((0, $dReYX.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source
                });
                (0, $iN9lO.stopMeasure)((0, $dReYX.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $96xlM.validNode)(node)).map((node)=>(0, $ifv4n.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $J5Axj.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    ...(0, $VSDnB.fg)('platform_editor_transaction_skip_validation') ? {
                        isRemoteReplaceDocumentTransaction: isRemoteReplace
                    } : {}
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("4r96J", function(module, exports) {

$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $7155804a07622bac$export$cdc577fd3f583194);

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");
const $7155804a07622bac$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                let nodeToCheck = node;
                if ((0, $VSDnB.fg)('cc_complexit_fe_improve_node_validation')) {
                    const { schema: schema } = tr.selection.$from.doc.type;
                    const parentNode = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(tr.selection);
                    nodeToCheck = parentNode ? parentNode.node : node;
                }
                if (!nodes.find((n)=>n === nodeToCheck)) nodes.push(nodeToCheck);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("acfJa", function(module, exports) {

$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $1bc4cc3d64f3585e$export$668aa008bdae439f);

var $gkwXh = parcelRequire("gkwXh");
const $1bc4cc3d64f3585e$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $1bc4cc3d64f3585e$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $1bc4cc3d64f3585e$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $1bc4cc3d64f3585e$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($1bc4cc3d64f3585e$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($1bc4cc3d64f3585e$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($1bc4cc3d64f3585e$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("dReYX", function(module, exports) {

$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $78f2616dc044c230$export$bb82e7cfb8987f35);

var $b7gJe = parcelRequire("b7gJe");

var $iN9lO = parcelRequire("iN9lO");

var $5dI4U = parcelRequire("5dI4U");
const $78f2616dc044c230$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $78f2616dc044c230$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $78f2616dc044c230$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $78f2616dc044c230$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $78f2616dc044c230$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $78f2616dc044c230$export$735da5ee20c885d5 = false;
const $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE = 100;
const $78f2616dc044c230$var$noop = ()=>{};
class $78f2616dc044c230$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $78f2616dc044c230$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $78f2616dc044c230$var$noop,
                stopMeasure: $78f2616dc044c230$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $iN9lO.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $iN9lO.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $5dI4U.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("5dI4U", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $b84a5fedb7732bc1$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $b84a5fedb7732bc1$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("96xlM", function(module, exports) {

$parcel$export(module.exports, "validNode", () => $4488669a13e53cb9$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $4488669a13e53cb9$export$996213f7c272fc6f);
const $4488669a13e53cb9$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $4488669a13e53cb9$export$996213f7c272fc6f = (nodes)=>nodes.every($4488669a13e53cb9$export$4c39e41e39b3c449);

});


parcelRegister("kpgvz", function(module, exports) {

$parcel$export(module.exports, "useFireFullWidthEvent", () => $b28a7eb8b5fedc52$export$4998b7b36606f9c3);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $7Em36 = parcelRequire("7Em36");

var $1hwge = parcelRequire("1hwge");
const $b28a7eb8b5fedc52$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7Em36.default)(appearance);
    (0, $5uXOq.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $1hwge.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $1hwge.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("1hwge", function(module, exports) {

$parcel$export(module.exports, "formatFullWidthAppearance", () => $1e164d4b24e45932$export$47d5b79f3ddf0b92);

var $hETfp = parcelRequire("hETfp");
const $1e164d4b24e45932$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $hETfp.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $hETfp.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("fggrl", function(module, exports) {

$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $5641d4a75c12a4ef$export$742fe272b8921eea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");
const $5641d4a75c12a4ef$var$useCheckIntlContext = ()=>(0, $5uXOq.useContext)((0, $8RXs9.Context)) === null;
function $5641d4a75c12a4ef$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $5641d4a75c12a4ef$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("j0Vvw", function(module, exports) {

$parcel$export(module.exports, "BaseThemeWrapper", () => $ec97f93103c51466$export$3de34996b814f0f0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $ec97f93103c51466$var$defaultFontSize = 14;
function $ec97f93103c51466$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || $ec97f93103c51466$var$defaultFontSize,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}

});

parcelRegister("8pML4", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $5e4d3b841efcfea0$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
function $5e4d3b841efcfea0$export$8e2864079bc476bd(appearance) {
    if (appearance === undefined) return 0, $iHYdz.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("dACrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ad4bc9aab4b58d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $iN9lO = parcelRequire("iN9lO");

var $5cNeT = parcelRequire("5cNeT");

var $2JODI = parcelRequire("2JODI");

var $dCdqM = parcelRequire("dCdqM");
function $9ad4bc9aab4b58d4$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $dCdqM.default)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $iN9lO.stopMeasure)((0, $5cNeT.default).EDITOR_MOUNTED, (0, $2JODI.default)((0, $gkwXh.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $iN9lO.clearMeasure)((0, $5cNeT.default).EDITOR_MOUNTED);
            (0, $iN9lO.clearMeasure)((0, $5cNeT.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("2JODI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b92cee7571d3699$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
function $2b92cee7571d3699$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("dCdqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6123a7e35e2a74e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2cB15 = parcelRequire("2cB15");

var $iN9lO = parcelRequire("iN9lO");

var $5cNeT = parcelRequire("5cNeT");
function $6123a7e35e2a74e1$export$2e2bcd8739ae039() {
    (0, $2cB15.default)(()=>{
        (0, $iN9lO.startMeasure)((0, $5cNeT.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("1d04s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3dd8adf4b990f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $5uXOq.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation
    ]);
    return memodProps;
};
var $5e3dd8adf4b990f5$export$2e2bcd8739ae039 = $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d;

});

parcelRegister("jRRkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5333f04c6da13671$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $3thTj = parcelRequire("3thTj");

var $bntD2 = parcelRequire("bntD2");

var $10FSK = parcelRequire("10FSK");

var $2ncO1 = parcelRequire("2ncO1");
function $5333f04c6da13671$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $5333f04c6da13671$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $3thTj.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $bntD2.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $5333f04c6da13671$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $5uXOq.useMemo)(()=>(0, $10FSK.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $5uXOq.useRef)(new (0, $dGzaM.default)());
    const editorRef = $5333f04c6da13671$var$useEditorRef(props.preset);
    const preparedProviders = (0, $5uXOq.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $5333f04c6da13671$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ncO1.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("3thTj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8798f349fd39c0ec$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $5WUYC = parcelRequire("5WUYC");
function $8798f349fd39c0ec$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $5WUYC.default)(extensionProviders(editorActions));
    return (0, $5WUYC.default)(extensionProviders);
}
const $8798f349fd39c0ec$var$prepareExtensionProvider = (getEditorActions)=>(0, $8QpSo.default)((extensionProviders)=>$8798f349fd39c0ec$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $8798f349fd39c0ec$export$2e2bcd8739ae039 = $8798f349fd39c0ec$var$prepareExtensionProvider;

});
parcelRegister("5WUYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d246d6c54b9ec0c3$export$2e2bcd8739ae039);

var $lBEBY = parcelRequire("lBEBY");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $d246d6c54b9ec0c3$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $lBEBY.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("lBEBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c37a15ec98ede43$export$2e2bcd8739ae039);

var $3B8Ug = parcelRequire("3B8Ug");
const $8c37a15ec98ede43$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $8c37a15ec98ede43$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $3B8Ug.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $3B8Ug.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $3B8Ug.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $3B8Ug.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $3B8Ug.getOnlyFulfilled)(results);
        return $8c37a15ec98ede43$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("3B8Ug", function(module, exports) {

$parcel$export(module.exports, "waitForAllPromises", () => $682d4194c4aac261$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $682d4194c4aac261$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $682d4194c4aac261$export$b7581cbf0e22e36b);
var $682d4194c4aac261$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $682d4194c4aac261$var$isFullfilled = (result)=>result.status === "fulfilled";
const $682d4194c4aac261$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $682d4194c4aac261$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $682d4194c4aac261$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($682d4194c4aac261$var$markFullfilled).catch($682d4194c4aac261$var$markRejected)));
};
const $682d4194c4aac261$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $682d4194c4aac261$export$b7581cbf0e22e36b = (results)=>results.filter($682d4194c4aac261$var$isFullfilled).map((result)=>result.value);

});




parcelRegister("bntD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ee1a571c17d3b4$export$2e2bcd8739ae039);

var $f1ZF9 = parcelRequire("f1ZF9");
function $37ee1a571c17d3b4$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $f1ZF9.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $f1ZF9.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("f1ZF9", function(module, exports) {

$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $acd9c39774394075$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $acd9c39774394075$export$e3759a254d73dcb7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");

var $04ZRC = parcelRequire("04ZRC");
var $izxHQ = parcelRequire("izxHQ");

var $lBEBY = parcelRequire("lBEBY");

var $4NUlu = parcelRequire("4NUlu");

var $VSDnB = parcelRequire("VSDnB");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $VSDnB.fg)('platform_nested_nbm_analytics_location') ? (0, $4NUlu.findInsertLocation)(selection) : undefined;
        (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $gkwXh.ACTION).INSERTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $gkwXh.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }
        });
    }
}
const $acd9c39774394075$var$showDummyAPIWarning = (location)=>{};
const $acd9c39774394075$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$acd9c39774394075$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$acd9c39774394075$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$acd9c39774394075$var$showDummyAPIWarning('doc:update')
    }
};
async function $acd9c39774394075$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $04ZRC.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $izxHQ.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $izxHQ.resolveImport)(item.node($acd9c39774394075$var$dummyExtensionAPI)).then((node)=>{
                                $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $acd9c39774394075$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $lBEBY.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});
parcelRegister("04ZRC", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $ceac48cd89560646$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $ceac48cd89560646$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $ceac48cd89560646$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $ceac48cd89560646$export$9d13b95c50a2a6c9);

var $VSDnB = parcelRequire("VSDnB");

var $izxHQ = parcelRequire("izxHQ");
const $ceac48cd89560646$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $izxHQ.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $ceac48cd89560646$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $ceac48cd89560646$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(// Ignored via go/ees005
    // eslint-disable-next-line require-await
    extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $ceac48cd89560646$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $ceac48cd89560646$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $ceac48cd89560646$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ceac48cd89560646$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $ceac48cd89560646$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $ceac48cd89560646$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $ceac48cd89560646$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $ceac48cd89560646$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $ceac48cd89560646$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $ceac48cd89560646$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $ceac48cd89560646$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$ceac48cd89560646$var$compareContext(currentContext, context)));
    }
};
const $ceac48cd89560646$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $ceac48cd89560646$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $ceac48cd89560646$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($ceac48cd89560646$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ((0, $VSDnB.fg)('forge-ui-macro-autoconvert')) {
                        if ($ceac48cd89560646$var$isToolbarButton(toolbarItem)) return $ceac48cd89560646$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                        return toolbarItem;
                    } else return $ceac48cd89560646$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $ceac48cd89560646$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $ceac48cd89560646$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}

});



parcelRegister("10FSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc30c3c0fe5f5799$export$2e2bcd8739ae039);
function $bc30c3c0fe5f5799$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("2ncO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e179e49684dee1$export$2e2bcd8739ae039);
function $73e179e49684dee1$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});




parcelRegister("gXAdO", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => (parcelRequire("cKx1R")).typeAheadPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cKx1R = parcelRequire("cKx1R");

});
parcelRegister("cKx1R", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => $614ad81eb16a153a$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dtyqo = parcelRequire("dtyqo");

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $3UtTx = parcelRequire("3UtTx");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $5Vwh8 = parcelRequire("5Vwh8");

var $eF1Qh = parcelRequire("eF1Qh");

var $ctcYc = parcelRequire("ctcYc");

var $8oJYH = parcelRequire("8oJYH");

var $ldgDZ = parcelRequire("ldgDZ");

var $b6IDf = parcelRequire("b6IDf");

var $2RUDH = parcelRequire("2RUDH");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");

var $hgbc1 = parcelRequire("hgbc1");
const $614ad81eb16a153a$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
            (0, $ctcYc.openTypeAheadAtCursor)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            })({
                tr: tr
            });
            // This function is called from the editor-plugin-emoji and editor-plugin-type-ahead
            // createOpenAtTransaction <- createOpenTypeAhead <- actions.open
            // 	<- emoji-plugin (Not used)
            //  <- type-ahead-plugin (Used)
            // and this caused the analytics event to be fired twice, as other places are relying on the
            // `onEditorViewStateUpdated` method to fire the analytics event
            // We want to disable this event
            if (!(0, $VSDnB.fg)('platform_editor_controls_patch_analytics_3')) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INVOKED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $614ad81eb16a153a$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $614ad81eb16a153a$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $614ad81eb16a153a$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $eF1Qh.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $3UtTx.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $614ad81eb16a153a$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $iiwBk.findHandler)(trigger, view.state);
    };
const $614ad81eb16a153a$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $iiwBk.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $5Vwh8.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $iiwBk.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $614ad81eb16a153a$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $dtyqo.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $2RUDH.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $5KWxh.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $ldgDZ.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $8oJYH.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $etG8M.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $iiwBk.isTypeAheadOpen)(editorState);
            const state = (0, $iiwBk.getPluginState)(editorState);
            return {
                query: (0, $iiwBk.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $iiwBk.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $etG8M.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $iiwBk.isTypeAheadOpen),
            isAllowed: (0, $iiwBk.isTypeAheadAllowed),
            open: $614ad81eb16a153a$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $614ad81eb16a153a$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $614ad81eb16a153a$var$createFindHandlerByTrigger(editorViewRef),
            insert: $614ad81eb16a153a$var$createInsertTypeAheadItem(editorViewRef),
            close: $614ad81eb16a153a$var$createCloseTypeAhead(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgbc1.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $iiwBk.getPluginState)(oldEditorState);
            const newPluginState = (0, $iiwBk.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $b6IDf.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $2D6mf.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $iiwBk.isTypeAheadOpen)(oldEditorState);
            const newIsOpen = (0, $iiwBk.isTypeAheadOpen)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $gkwXh.INPUT_METHOD).QUICK_INSERT && Object.values((0, $3UtTx.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) {
                    if ((0, $VSDnB.fg)('platform_editor_controls_patch_analytics_3')) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).INVOKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $gkwXh.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    }, undefined, {
                        context: {
                            selection: newEditorState.selection
                        }
                    });
                    else api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).INVOKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $gkwXh.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                }
            } else if (oldIsOpen && !newIsOpen && (0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};

});
parcelRegister("3UtTx", function(module, exports) {

$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $a7f24fcc6d3b7633$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $a7f24fcc6d3b7633$export$4d7d0343c6d95a0e);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8ptyJ = parcelRequire("8ptyJ");
var $a7f24fcc6d3b7633$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $a7f24fcc6d3b7633$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    SelectItemMode["TAB"] = "tab";
    return SelectItemMode;
}({});

});
parcelRegister("8ptyJ", function(module, exports) {

$parcel$export(module.exports, "typeAheadListMessages", () => $df168ce559caf975$export$940a17143b866527);

var $7VHMR = parcelRequire("7VHMR");
const $df168ce559caf975$export$940a17143b866527 = (0, $7VHMR.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'the result of a typeahead, similar to autocomplete results+'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'the result of a quick insert typeahead, similar to autocomplete results+'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'assisitve text for typeahed input field'
    },
    quickInsertInputPlaceholderLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel',
        defaultMessage: 'Search',
        description: 'placeholder for typeahed input field'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'assisitve text for typeahed input field'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'assisitve text for typeahed input field'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Description'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Text shortcut'
    },
    offlineErrorFallbackHeading: {
        id: 'fabric.editor.offlineErrorFallbackHeading',
        defaultMessage: 'Something went wrong!',
        description: 'heading for offline error fallback when mentions are not available'
    },
    offlineErrorFallbackDesc: {
        id: 'fabric.editor.offlineErrorFallbackDescription',
        defaultMessage: 'Try reloading the page.',
        description: 'description for offline error fallback when mentions are not available'
    },
    viewAllInserts: {
        id: 'fablric.editor.viewAllInserts',
        defaultMessage: 'View all inserts',
        description: 'a text on a button that opens a side panel with a list of all insertable editor elements'
    },
    emptySearchResults: {
        id: 'fabric.editor.emptySearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'a message displayed when there are no search results'
    },
    emptySearchResultsSuggestion: {
        id: 'fabric.editor.emptySearchResultsSuggestion',
        defaultMessage: 'Select {buttonName} to browse inserts.',
        description: 'a prompt to suggest user to click a button to browse inserts when there are no search results'
    }
});

});


parcelRegister("5Vwh8", function(module, exports) {

$parcel$export(module.exports, "closeTypeAhead", () => $0d2dd1000e07b5a6$export$daba40574d0568e3);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $0d2dd1000e07b5a6$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $b6IDf.pluginKey), {
        action: (0, $7eFnB.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});
parcelRegister("7eFnB", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $d12f7dcf5833e13e$export$92a1a3b7554e9387);
var $d12f7dcf5833e13e$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    return ACTIONS;
}({});

});

parcelRegister("b6IDf", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $f2e6ba5f517d8a79$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $f2e6ba5f517d8a79$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('typeAheadPlugin');

});


parcelRegister("eF1Qh", function(module, exports) {

$parcel$export(module.exports, "insertTypeAheadItem", () => $ea5e5e0c4f528fae$export$173ade35125a6637);

var $ez3YZ = parcelRequire("ez3YZ");

var $3UtTx = parcelRequire("3UtTx");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");

var $5Vwh8 = parcelRequire("5Vwh8");

var $b3yfA = parcelRequire("b3yfA");
const $ea5e5e0c4f528fae$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $kCV8T.Node) || maybeNode instanceof (0, $kCV8T.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $kCV8T.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $ea5e5e0c4f528fae$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $ea5e5e0c4f528fae$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $5Vwh8.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $kCV8T.Node) && node.isBlock ? (0, $b3yfA.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $b3yfA.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $fZzhT.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $ez3YZ.InsertTypeAheadStep)(config));
        return tr;
    };
const $ea5e5e0c4f528fae$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $fZzhT.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $ez3YZ.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $ea5e5e0c4f528fae$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $iiwBk.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $2D6mf.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $3UtTx.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $3UtTx.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $ea5e5e0c4f528fae$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $fZzhT.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $b6IDf.pluginKey))) (0, $5Vwh8.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).INSERT_RAW_QUERY,
            params: $ea5e5e0c4f528fae$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $fZzhT.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };

});
parcelRegister("ez3YZ", function(module, exports) {

$parcel$export(module.exports, "InsertTypeAheadStages", () => $a9a76c74962f10f8$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $a9a76c74962f10f8$export$5ca6d15deb246b5d);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $a9a76c74962f10f8$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
let $a9a76c74962f10f8$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $a9a76c74962f10f8$export$5ca6d15deb246b5d extends (0, $eS2Dn.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($a9a76c74962f10f8$export$2f0b0962a5993fe0, $a9a76c74962f10f8$export$5ca6d15deb246b5d);

});

parcelRegister("2D6mf", function(module, exports) {

$parcel$export(module.exports, "StatsModifier", () => $f05a9d8982368ab5$export$630efe5940bb4d41);
class $f05a9d8982368ab5$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("iiwBk", function(module, exports) {

$parcel$export(module.exports, "isTypeAheadHandler", () => $d20c753282e6c55d$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $d20c753282e6c55d$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $d20c753282e6c55d$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $d20c753282e6c55d$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $d20c753282e6c55d$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $d20c753282e6c55d$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $d20c753282e6c55d$export$2bae95e359577df4);
$parcel$export(module.exports, "skipForwardToSafeItem", () => $d20c753282e6c55d$export$84a03e6192df0237);
$parcel$export(module.exports, "moveSelectedIndex", () => $d20c753282e6c55d$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $d20c753282e6c55d$export$19cacaa810ba988a);

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gmhCD = parcelRequire("gmhCD");

var $bmkwl = parcelRequire("bmkwl");

var $koD1m = parcelRequire("koD1m");

var $b6IDf = parcelRequire("b6IDf");

var $2D6mf = parcelRequire("2D6mf");
const $d20c753282e6c55d$export$be092076596418f1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
handler)=>{
    return handler && Object.values((0, $3UtTx.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $d20c753282e6c55d$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $b6IDf.pluginKey)?.getState(editorState)?.decorationSet?.find().length;
};
const $d20c753282e6c55d$export$f05434c51e3762e = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState);
};
const $d20c753282e6c55d$export$c1eba975d6442029 = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState)?.triggerHandler;
};
const $d20c753282e6c55d$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $b6IDf.pluginKey).getState(editorState)?.query;
};
const $d20c753282e6c55d$export$74b0f581633f8412 = (state)=>{
    const isOpen = $d20c753282e6c55d$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $d20c753282e6c55d$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $b6IDf.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $d20c753282e6c55d$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $d20c753282e6c55d$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $d20c753282e6c55d$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $b6IDf.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $d20c753282e6c55d$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $d20c753282e6c55d$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $2D6mf.StatsModifier) ? typeAheadState.stats : new (0, $2D6mf.StatsModifier)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $koD1m.itemIsDisabled)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
			 * See: https://product-fabric.atlassian.net/browse/ED-17200
			 * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
			 * and only do so when there is explicit logic to focus into the typeahead
			 * options.
			 *
			 * This check for "set index to 1 when -1"
			 * - is a temporary workaround to get back the previous behaviour without
			 *    entirely reverting the a11y improvements
			 *
			 */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $d20c753282e6c55d$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $d20c753282e6c55d$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $d20c753282e6c55d$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("bmkwl", function(module, exports) {

$parcel$export(module.exports, "updateSelectedIndex", () => $2917e7df6f0f82cb$export$9993709486a96a6b);

var $7eFnB = parcelRequire("7eFnB");

var $koD1m = parcelRequire("koD1m");

var $b6IDf = parcelRequire("b6IDf");
const $2917e7df6f0f82cb$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $b6IDf.pluginKey).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $koD1m.itemIsDisabled)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});
parcelRegister("koD1m", function(module, exports) {

$parcel$export(module.exports, "itemIsDisabled", () => $ea4f5e057c318306$export$1ebf03cc1b973f80);
const $ea4f5e057c318306$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
    return isOffline && item?.isDisabledOffline === true;
};

});



parcelRegister("b3yfA", function(module, exports) {

$parcel$export(module.exports, "insertBlockNode", () => $3d2e2b42ea5fc125$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $3d2e2b42ea5fc125$export$a6d430434014dc1c);

var $dlzPV = parcelRequire("dlzPV");

var $aDFRV = parcelRequire("aDFRV");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
function $3d2e2b42ea5fc125$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $3d2e2b42ea5fc125$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $dlzPV.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, $aDFRV.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $dlzPV.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $kCV8T.Slice).maxOpen((0, $kCV8T.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $3d2e2b42ea5fc125$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $gZGBX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $3d2e2b42ea5fc125$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $kCV8T.Node) ? (0, $kCV8T.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});
parcelRegister("dlzPV", function(module, exports) {

$parcel$export(module.exports, "normaliseNestedLayout", () => $3c014faca3b7f131$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $3c014faca3b7f131$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $3c014faca3b7f131$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $3c014faca3b7f131$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $3c014faca3b7f131$export$b6980e4b8ea578a5);
$parcel$export(module.exports, "fragmentContainsNodeType", () => $3c014faca3b7f131$export$2b1594c8921b5b2e);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $hPjvp = parcelRequire("hPjvp");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");
var $uTDrM = parcelRequire("uTDrM");
var $3c014faca3b7f131$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $3c014faca3b7f131$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $3c014faca3b7f131$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $3c014faca3b7f131$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $3c014faca3b7f131$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $5r0mK.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $3c014faca3b7f131$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $5r0mK.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $3c014faca3b7f131$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $5r0mK.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $uTDrM.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $3c014faca3b7f131$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($3c014faca3b7f131$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $3c014faca3b7f131$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c014faca3b7f131$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $3c014faca3b7f131$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $kCV8T.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $5r0mK.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $5r0mK.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $594Yf.isEmptyParagraph)($insertPos.parent)) {
            if ($3c014faca3b7f131$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($3c014faca3b7f131$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$3c014faca3b7f131$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $3c014faca3b7f131$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$3c014faca3b7f131$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $5r0mK.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $594Yf.isEmptyParagraph)($insertPos.parent) && (0, $5r0mK.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $3c014faca3b7f131$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $5r0mK.canInsert)($proposedPosition, content)) return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($3c014faca3b7f131$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $3c014faca3b7f131$var$finaliseInsert($3c014faca3b7f131$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $gZGBX.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $3c014faca3b7f131$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $eS2Dn.ReplaceStep) || lastStep instanceof (0, $eS2Dn.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $hPjvp.Side).RIGHT)).scrollIntoView();
};
const $3c014faca3b7f131$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $kCV8T.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $kCV8T.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $kCV8T.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $kCV8T.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $kCV8T.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $3c014faca3b7f131$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $594Yf.isEmptyParagraph)(tr.selection.$from.parent)) tr = $3c014faca3b7f131$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $5r0mK.safeInsert)($3c014faca3b7f131$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $kCV8T.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $kCV8T.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $3c014faca3b7f131$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $kCV8T.Fragment).from(content))) return true;
    return false;
};
function $3c014faca3b7f131$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $3c014faca3b7f131$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}

});
parcelRegister("77j9j", function(module, exports) {

$parcel$export(module.exports, "pmHistoryPluginKey", () => $3eac7c1ce2173d69$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $3eac7c1ce2173d69$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $3eac7c1ce2173d69$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $3eac7c1ce2173d69$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $3eac7c1ce2173d69$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $3eac7c1ce2173d69$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $3eac7c1ce2173d69$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $3eac7c1ce2173d69$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $3eac7c1ce2173d69$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $3eac7c1ce2173d69$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("594Yf")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("ggL2v")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5r0mK = parcelRequire("5r0mK");

var $ggL2v = parcelRequire("ggL2v");

var $594Yf = parcelRequire("594Yf");

var $gOwky = parcelRequire("gOwky");

var $h03xs = parcelRequire("h03xs");

var $lVKVw = parcelRequire("lVKVw");

var $gE8f9 = parcelRequire("gE8f9");

var $fTi1m = parcelRequire("fTi1m");

var $cAMv0 = parcelRequire("cAMv0");

var $c1exv = parcelRequire("c1exv");

var $eOOFp = parcelRequire("eOOFp");

var $20Kbb = parcelRequire("20Kbb");

var $aOimD = parcelRequire("aOimD");

var $7vpuQ = parcelRequire("7vpuQ");

var $eQcNy = parcelRequire("eQcNy");


var $4NUlu = parcelRequire("4NUlu");

var $2KwKW = parcelRequire("2KwKW");

var $d54NZ = parcelRequire("d54NZ");






var $2vGdQ = parcelRequire("2vGdQ");

var $5or39 = parcelRequire("5or39");

var $5J0oM = parcelRequire("5J0oM");

var $5vnE9 = parcelRequire("5vnE9");

var $lGkyv = parcelRequire("lGkyv");


var $fc6h8 = parcelRequire("fc6h8");


var $WXnhI = parcelRequire("WXnhI");

var $4AgYP = parcelRequire("4AgYP");


var $4IuOY = parcelRequire("4IuOY");




var $2Cwj1 = parcelRequire("2Cwj1");

var $hEIDx = parcelRequire("hEIDx");

var $uTDrM = parcelRequire("uTDrM");

var $dPSMN = parcelRequire("dPSMN");

var $j9To4 = parcelRequire("j9To4");

var $agxMF = parcelRequire("agxMF");

var $cROsB = parcelRequire("cROsB");


var $3dBkm = parcelRequire("3dBkm");

var $k24a0 = parcelRequire("k24a0");




var $2Abpa = parcelRequire("2Abpa");

var $cz9kf = parcelRequire("cz9kf");

var $iXNbm = parcelRequire("iXNbm");

var $aDFRV = parcelRequire("aDFRV");

var $aeKzo = parcelRequire("aeKzo");

var $2C7zq = parcelRequire("2C7zq");

var $biLOy = parcelRequire("biLOy");


const $3eac7c1ce2173d69$export$d4f2631252432abf = 'history$';
function $3eac7c1ce2173d69$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $3eac7c1ce2173d69$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $3eac7c1ce2173d69$export$92d47fcf661e090e = (state)=>{
    return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $3eac7c1ce2173d69$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $3eac7c1ce2173d69$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3eac7c1ce2173d69$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $3eac7c1ce2173d69$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $3eac7c1ce2173d69$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $3eac7c1ce2173d69$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $594Yf.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $594Yf.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $3eac7c1ce2173d69$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $594Yf.isEmptyParagraph)(node) && (0, $ggL2v.hasDocAsParent)($anchor);
}

});
parcelRegister("gOwky", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $a8453eeff8b41d2c$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $a8453eeff8b41d2c$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $a8453eeff8b41d2c$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$a8453eeff8b41d2c$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $a8453eeff8b41d2c$export$e19a09e301eaa6bb(match) {
    return $a8453eeff8b41d2c$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("lVKVw", function(module, exports) {

$parcel$export(module.exports, "getExtensionLozengeData", () => $1938aba83063b4fb$export$4fd8ecadd193bea0);
const $1938aba83063b4fb$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("cAMv0", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $c5b07ac9bae9c35c$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $c5b07ac9bae9c35c$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $c5b07ac9bae9c35c$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $c5b07ac9bae9c35c$export$fbc04a9e57b04a80);

var $SzDmm = parcelRequire("SzDmm");

var $kUxFz = parcelRequire("kUxFz");
var $c5b07ac9bae9c35c$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c5b07ac9bae9c35c$var$FORMATS || {});
const $c5b07ac9bae9c35c$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c5b07ac9bae9c35c$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c5b07ac9bae9c35c$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c5b07ac9bae9c35c$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c5b07ac9bae9c35c$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCDate())}`;
};
const $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $kUxFz.default)(new Date(Number(timestamp)), new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562())));
};
const $c5b07ac9bae9c35c$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $SzDmm.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c5b07ac9bae9c35c$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c5b07ac9bae9c35c$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("c1exv", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $9600f65038d22dcf$export$9b0f795b2e33f057);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $9600f65038d22dcf$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $9600f65038d22dcf$export$9b0f795b2e33f057 = (Wrapped)=>{
    if ((0, $VSDnB.fg)('platform_editor_react18_phase2_v2') || (0, $VSDnB.fg)('platform_editor_react18_phase2_v2_extended')) return $9600f65038d22dcf$var$withImageLoaderNew(Wrapped);
    return $9600f65038d22dcf$export$3a0bcc6ff2e20f36(Wrapped);
};

});

parcelRegister("aOimD", function(module, exports) {

$parcel$export(module.exports, "pluginFactory", () => $b35c4d4356c0af83$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b35c4d4356c0af83$var$isFunction(x) {
    return typeof x === 'function';
}
function $b35c4d4356c0af83$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$b35c4d4356c0af83$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $b35c4d4356c0af83$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("7vpuQ", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $cd200aea723473fd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $cd200aea723473fd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $cd200aea723473fd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $cd200aea723473fd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $cd200aea723473fd$export$e0baa27f47733a4a);

var $kCV8T = parcelRequire("kCV8T");
function $cd200aea723473fd$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $cd200aea723473fd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($cd200aea723473fd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $kCV8T.Fragment)) children.push(...$cd200aea723473fd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $kCV8T.Fragment).fromArray(children);
}
function $cd200aea723473fd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $cd200aea723473fd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $kCV8T.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $cd200aea723473fd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(fragmentContent);
}
function $cd200aea723473fd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $kCV8T.Fragment) ? node : node.content));
    return array;
}
const $cd200aea723473fd$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $cd200aea723473fd$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$cd200aea723473fd$var$findNode(predicate)(slice);
    };

});

parcelRegister("lGkyv", function(module, exports) {

$parcel$export(module.exports, "isTextInput", () => $4ed0bf9464bdda71$export$3e6057b9bf6b0bbb);

var $eS2Dn = parcelRequire("eS2Dn");
const $4ed0bf9464bdda71$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $eS2Dn.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("4AgYP", function(module, exports) {

$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $5be8a446da622e19$export$4cd1ca2600761f65);
const $5be8a446da622e19$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $5be8a446da622e19$var$RACE_COMPLETE = 'race_complete';
const $5be8a446da622e19$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $5be8a446da622e19$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $5be8a446da622e19$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $5be8a446da622e19$var$registerDetectors(options.extensions, $5be8a446da622e19$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $5be8a446da622e19$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("2Cwj1", function(module, exports) {

$parcel$export(module.exports, "autoJoinTr", () => $34e191c8f61c54e1$export$c7c1e59168a7f554);

var $eS2Dn = parcelRequire("eS2Dn");
function $34e191c8f61c54e1$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $eS2Dn.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("hEIDx", function(module, exports) {

$parcel$export(module.exports, "isReferencedSource", () => $0a8d6f5b4b6694a4$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $0a8d6f5b4b6694a4$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $0a8d6f5b4b6694a4$export$c98d43680e607ac1);
$parcel$export(module.exports, "getNodeName", () => $0a8d6f5b4b6694a4$export$651544f548703224);
const $0a8d6f5b4b6694a4$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $0a8d6f5b4b6694a4$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
    const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $0a8d6f5b4b6694a4$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $0a8d6f5b4b6694a4$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $0a8d6f5b4b6694a4$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes),
        amount: $0a8d6f5b4b6694a4$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $0a8d6f5b4b6694a4$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $0a8d6f5b4b6694a4$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0a8d6f5b4b6694a4$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $0a8d6f5b4b6694a4$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $0a8d6f5b4b6694a4$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $0a8d6f5b4b6694a4$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};

});

parcelRegister("dPSMN", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $c71efdd24f85e7a0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c71efdd24f85e7a0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c71efdd24f85e7a0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c71efdd24f85e7a0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c71efdd24f85e7a0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c71efdd24f85e7a0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c71efdd24f85e7a0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c71efdd24f85e7a0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c71efdd24f85e7a0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iZOJ9 = parcelRequire("iZOJ9");

var $gkwXh = parcelRequire("gkwXh");

var $gOwky = parcelRequire("gOwky");

var $7vpuQ = parcelRequire("7vpuQ");
const $c71efdd24f85e7a0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c71efdd24f85e7a0$export$dabcc234035f6703 = /^(\$|{)/;
class $c71efdd24f85e7a0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c71efdd24f85e7a0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iZOJ9.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c71efdd24f85e7a0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iZOJ9.isSafeUrl)(url)) return url;
    return (0, $iZOJ9.normalizeUrl)(url);
}
function $c71efdd24f85e7a0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c71efdd24f85e7a0$var$findLinkMatches(text).filter((0, $gOwky.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c71efdd24f85e7a0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c71efdd24f85e7a0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c71efdd24f85e7a0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c71efdd24f85e7a0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c71efdd24f85e7a0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c71efdd24f85e7a0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iZOJ9.linkify).match(text) || [];
}
const $c71efdd24f85e7a0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c71efdd24f85e7a0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c71efdd24f85e7a0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c71efdd24f85e7a0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c71efdd24f85e7a0$export$238a6141b3685c21(url)
        }
    };
}
const $c71efdd24f85e7a0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link));
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});

parcelRegister("j9To4", function(module, exports) {

$parcel$export(module.exports, "gridTypeForLayout", () => $d114efb4a396db73$export$27813bf9aa3826dc);
const $d114efb4a396db73$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});

parcelRegister("cROsB", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $3161276a2e2e68a3$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $3161276a2e2e68a3$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $3161276a2e2e68a3$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $3161276a2e2e68a3$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $3161276a2e2e68a3$export$de65085e667b4bf1);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $kKuJi = parcelRequire("kKuJi");
const $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $3161276a2e2e68a3$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $3161276a2e2e68a3$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $3161276a2e2e68a3$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $3161276a2e2e68a3$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $kKuJi.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $3161276a2e2e68a3$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $kKuJi.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $kKuJi.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $iHYdz.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("kKuJi", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $96e639534456f333$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $96e639534456f333$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $96e639534456f333$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $96e639534456f333$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $96e639534456f333$export$5e51fc02b9ada5af);

var $iHYdz = parcelRequire("iHYdz");

var $intz5 = parcelRequire("intz5");
const $96e639534456f333$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $96e639534456f333$export$adfc02948d64a4f2 = (layout)=>$96e639534456f333$var$validWidthModes.indexOf(layout) > -1;
function $96e639534456f333$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $96e639534456f333$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
}
function $96e639534456f333$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $intz5.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $96e639534456f333$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $96e639534456f333$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($96e639534456f333$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $96e639534456f333$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $iHYdz.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $iHYdz.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($96e639534456f333$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $96e639534456f333$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $96e639534456f333$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $96e639534456f333$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($96e639534456f333$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $96e639534456f333$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("intz5", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $7676dd27b358f47a$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $7676dd27b358f47a$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $7676dd27b358f47a$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $7676dd27b358f47a$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $7676dd27b358f47a$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $7676dd27b358f47a$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $7676dd27b358f47a$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $7676dd27b358f47a$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $7676dd27b358f47a$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $7676dd27b358f47a$export$b4b560efd3c61856);
const $7676dd27b358f47a$export$5937600f4cc784f0 = 24;
const $7676dd27b358f47a$export$71d660e8ca5b8f73 = 320;
const $7676dd27b358f47a$export$cd11d7d46412c89b = 3;
const $7676dd27b358f47a$export$71482734bb54ac3 = 10;
const $7676dd27b358f47a$export$fd2b09475ada41cc = 12;
const $7676dd27b358f47a$export$8c5ac0b0c62a3d21 = 8;
const $7676dd27b358f47a$export$68d0abe4f03863fb = $7676dd27b358f47a$export$fd2b09475ada41cc * 2;
const $7676dd27b358f47a$export$d722b7527b1834a8 = 250;
const $7676dd27b358f47a$export$da894f7669b4e67c = 200;
const $7676dd27b358f47a$export$e13825c38da2ce1 = 100;
var $7676dd27b358f47a$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $7676dd27b358f47a$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7676dd27b358f47a$export$4d41d008e9cd4f34 = 0.5;
const $7676dd27b358f47a$export$b4b560efd3c61856 = 'caption-placeholder';

});



parcelRegister("3dBkm", function(module, exports) {

$parcel$export(module.exports, "getDatasourceType", () => $690615f85cf46a23$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $690615f85cf46a23$export$1974047c293dd52e);

var $lX6w0 = parcelRequire("lX6w0");
var $f980L = parcelRequire("f980L");
var $7mvwv = parcelRequire("7mvwv");

var $VSDnB = parcelRequire("VSDnB");
const $690615f85cf46a23$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7mvwv.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $lX6w0.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $f980L.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $690615f85cf46a23$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $690615f85cf46a23$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $VSDnB.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("lX6w0", function(module, exports) {

$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $b26c1258743f5547$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $b26c1258743f5547$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b26c1258743f5547$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $b26c1258743f5547$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2mcAV")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $b26c1258743f5547$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b26c1258743f5547$var$LazyAssetsConfigModal, props));
};
var $b26c1258743f5547$export$2e2bcd8739ae039 = $b26c1258743f5547$var$AssetsConfigModalWithWrappers;

});
parcelRegister("2mcAV", function(module, exports) {

let $1b7767dd4fc62d71$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1b7767dd4fc62d71$var$load("fliVL"),
    $1b7767dd4fc62d71$var$load("kNFvF"),
    $1b7767dd4fc62d71$var$load("76n7a"),
    $1b7767dd4fc62d71$var$load("l253H"),
    $1b7767dd4fc62d71$var$load("ffQaD"),
    $1b7767dd4fc62d71$var$load("kvRbA"),
    $1b7767dd4fc62d71$var$load("ezcTa")
]).then(()=>parcelRequire('4QSOw'));

});


parcelRegister("f980L", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $4b1899e250d97ce5$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $4b1899e250d97ce5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4b1899e250d97ce5$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("4JVgX")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal, props));
};
var $4b1899e250d97ce5$export$2e2bcd8739ae039 = $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("4JVgX", function(module, exports) {

let $3737ca7ffae54f05$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3737ca7ffae54f05$var$load("fliVL"),
    $3737ca7ffae54f05$var$load("kNFvF"),
    $3737ca7ffae54f05$var$load("76n7a"),
    $3737ca7ffae54f05$var$load("l253H"),
    $3737ca7ffae54f05$var$load("ffQaD"),
    $3737ca7ffae54f05$var$load("kvRbA"),
    $3737ca7ffae54f05$var$load("eD1Zc")
]).then(()=>parcelRequire('ayFsd'));

});


parcelRegister("7mvwv", function(module, exports) {

$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $0edb3309d3119e6e$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $0edb3309d3119e6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0edb3309d3119e6e$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $0edb3309d3119e6e$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hxtAf")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0edb3309d3119e6e$var$LazyJiraIssuesConfigModal, props));
};
var $0edb3309d3119e6e$export$2e2bcd8739ae039 = $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("hxtAf", function(module, exports) {

let $cc4c776dad067f4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cc4c776dad067f4a$var$load("fliVL"),
    $cc4c776dad067f4a$var$load("kNFvF"),
    $cc4c776dad067f4a$var$load("76n7a"),
    $cc4c776dad067f4a$var$load("l253H"),
    $cc4c776dad067f4a$var$load("ffQaD"),
    $cc4c776dad067f4a$var$load("kvRbA"),
    $cc4c776dad067f4a$var$load("jcDM2")
]).then(()=>parcelRequire('2WQ9j'));

});



parcelRegister("cz9kf", function(module, exports) {

$parcel$export(module.exports, "dedupe", () => $b4d75c9e493507f1$export$f3a259b74a77132f);
function $b4d75c9e493507f1$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("aDFRV", function(module, exports) {

$parcel$export(module.exports, "transformNodeIntoListItem", () => $3e3acfe58aba3a90$export$f4c81471ccea5042);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $uTDrM = parcelRequire("uTDrM");
// Taken from `editor-plugin-content-insertion`
function $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $kCV8T.Slice).maxOpen((0, $kCV8T.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $gZGBX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $3e3acfe58aba3a90$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $5r0mK.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("2C7zq", function(module, exports) {

$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $5d709aa1b364f0a8$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $5d709aa1b364f0a8$export$4fdfbe77de19eec);
$parcel$export(module.exports, "calculateToolbarPositionOnCellSelection", () => $5d709aa1b364f0a8$export$2d9cc331fb808a87);

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $5d709aa1b364f0a8$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $5d709aa1b364f0a8$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $5d709aa1b364f0a8$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $5d709aa1b364f0a8$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $5d709aa1b364f0a8$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop = 10;
const $5d709aa1b364f0a8$var$scrollbarWidth = 20;
const $5d709aa1b364f0a8$var$offsetTopOnColumnSelection = 4;
const $5d709aa1b364f0a8$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $hFEwm.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $5r0mK.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $5r0mK.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $5d709aa1b364f0a8$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $5d709aa1b364f0a8$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom && (0, $VSDnB.fg)('platform_editor_controls_patch_2')) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $5d709aa1b364f0a8$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };

});

parcelRegister("biLOy", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $f5822fec42041939$export$947fc26275418e36);
const $f5822fec42041939$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});





parcelRegister("ctcYc", function(module, exports) {

$parcel$export(module.exports, "openTypeAheadAtCursor", () => $4b1439ea28428b41$export$e7ce737179b76875);

var $hPjvp = parcelRequire("hPjvp");

var $gZGBX = parcelRequire("gZGBX");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $4b1439ea28428b41$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $4b1439ea28428b41$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $4b1439ea28428b41$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $gZGBX.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $gZGBX.TextSelection) || selection instanceof (0, $hPjvp.GapCursorSelection) || selection instanceof (0, $gZGBX.NodeSelection))) return tr;
        if (selection instanceof (0, $hPjvp.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $gZGBX.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});

parcelRegister("8oJYH", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $3181220485a0177f$export$568a7ed6897c4817);

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $inLhu = parcelRequire("inLhu");

var $ctcYc = parcelRequire("ctcYc");
function $3181220485a0177f$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $d19733ae55e58348$export$a96b909f1510512b)}])(${trigger})$`);
        acc.push((0, $2Abpa.createRule)(regex, (state, match)=>{
            return (0, $ctcYc.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $3181220485a0177f$export$2e2bcd8739ae039 = $3181220485a0177f$export$568a7ed6897c4817;

});

parcelRegister("ldgDZ", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $8bd7a547b078e11d$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $7eFnB = parcelRequire("7eFnB");

var $a6cBt = parcelRequire("a6cBt");
function $8bd7a547b078e11d$export$ae829ec7b2625219() {
    return new (0, $5KWxh.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $a6cBt.isInsertionTransaction)(transactions, (0, $7eFnB.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("a6cBt", function(module, exports) {

$parcel$export(module.exports, "isInsertionTransaction", () => $2056d03687a2446d$export$e715282b081c154e);

var $b6IDf = parcelRequire("b6IDf");
const $2056d03687a2446d$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $b6IDf.pluginKey))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $b6IDf.pluginKey))?.params;
};

});


parcelRegister("2RUDH", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $45b1a64a630ececf$export$ae829ec7b2625219);

var $ez3YZ = parcelRequire("ez3YZ");

var $5KWxh = parcelRequire("5KWxh");

var $eQcNy = parcelRequire("eQcNy");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $7eFnB = parcelRequire("7eFnB");

var $8oQ7W = parcelRequire("8oQ7W");

var $ieoPC = parcelRequire("ieoPC");

var $a6cBt = parcelRequire("a6cBt");

var $b6IDf = parcelRequire("b6IDf");

var $dp8V8 = parcelRequire("dp8V8");
const $45b1a64a630ececf$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $ez3YZ.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $45b1a64a630ececf$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $ieoPC.factoryDecorations)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $dp8V8.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $b6IDf.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $etG8M.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $45b1a64a630ececf$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $b6IDf.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $a6cBt.isInsertionTransaction)(transactions, (0, $7eFnB.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $b6IDf.pluginKey).getState(state)?.decorationSet;
            },
            handleDOMEvents: {
                compositionend: (view, event)=>{
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $eQcNy.closest)(target, `[data-type-ahead=${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("8oQ7W", function(module, exports) {

$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $6f65c97870929cfc$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $6f65c97870929cfc$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $6f65c97870929cfc$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $6f65c97870929cfc$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $6f65c97870929cfc$export$fc2dc87cf13c1ab1);
const $6f65c97870929cfc$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $6f65c97870929cfc$export$be8a8259777b339f = 'typeaheadDecoration';
const $6f65c97870929cfc$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $6f65c97870929cfc$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $6f65c97870929cfc$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});

});

parcelRegister("ieoPC", function(module, exports) {

$parcel$export(module.exports, "factoryDecorations", () => $f1ca46bfdfc04632$export$116b677c5744e397);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $7Jxgt = parcelRequire("7Jxgt");

var $1SLCf = parcelRequire("1SLCf");

var $fZzhT = parcelRequire("fZzhT");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");


var $kQKqn = parcelRequire("kQKqn");

var $5Vwh8 = parcelRequire("5Vwh8");

var $8oQ7W = parcelRequire("8oQ7W");

var $2D6mf = parcelRequire("2D6mf");

var $iiwBk = parcelRequire("iiwBk");
const $f1ca46bfdfc04632$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $gZGBX.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $etG8M.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        const decorationId = `decoration_id_${(0, $8oQ7W.TYPE_AHEAD_DECORATION_KEY)}_${(0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $2D6mf.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $etG8M.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $iiwBk.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $fZzhT.undo) : (0, $fZzhT.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $5Vwh8.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQKqn.WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                }), typeaheadComponent, decorationId);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $1SLCf.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $etG8M.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $etG8M.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("kQKqn", function(module, exports) {

$parcel$export(module.exports, "WrapperTypeAhead", () => $8ef46ca5d5299ac6$export$970faf6afe0d9376);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $3UtTx = parcelRequire("3UtTx");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $6tlgz = parcelRequire("6tlgz");

var $2sbpe = parcelRequire("2sbpe");

var $koD1m = parcelRequire("koD1m");

var $iiwBk = parcelRequire("iiwBk");

var $ihi8h = parcelRequire("ihi8h");

var $kjRsq = parcelRequire("kjRsq");

var $52b7w = parcelRequire("52b7w");

var $kz2Z2 = parcelRequire("kz2Z2");
const $8ef46ca5d5299ac6$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const showViewMore = triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT && !!openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    const [closed, setClosed] = (0, $5uXOq.useState)(false);
    const [query, setQuery] = (0, $5uXOq.useState)(reopenQuery || '');
    const queryRef = (0, $5uXOq.useRef)(query);
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    const items = (0, $kjRsq.useLoadItems)(triggerHandler, editorView, query, showViewMore);
    (0, $5uXOq.useEffect)(()=>{
        if (!closed && (0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $ihi8h.useItemInsert)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, (0, $gkwXh.ACTION).CANCELLED, !!queryRef.current, (0, $gkwXh.INPUT_METHOD).KEYBOARD, (0, $iiwBk.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $5uXOq.useCallback)((mode = (0, $3UtTx.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $iiwBk.getPluginState)(view.state);
        const safeSelectedIndex = (0, $iiwBk.skipForwardToSafeItem)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $koD1m.itemIsDisabled)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, (0, $gkwXh.ACTION).INSERTED, !!queryRef.current, (0, $gkwXh.INPUT_METHOD).KEYBOARD, (0, $iiwBk.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $5uXOq.useCallback)(()=>{}, []);
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $iiwBk.getPluginState)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $2sbpe.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $52b7w.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kz2Z2.InputQuery), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$8ef46ca5d5299ac6$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("6tlgz", function(module, exports) {

$parcel$export(module.exports, "fireTypeAheadClosedAnalyticsEvent", () => $3cc55692bf5a5959$export$4a6068dadc2c7771);

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");
const $3cc55692bf5a5959$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    const additionalAttributes = (0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? {
        invocationMethod: invocationMethod
    } : {};
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $gkwXh.ACTION).CLOSED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            ...additionalAttributes
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    });
};

});

parcelRegister("2sbpe", function(module, exports) {

$parcel$export(module.exports, "updateQuery", () => $51fa8a395f333c02$export$4d1bf8b2f67bcb1);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $51fa8a395f333c02$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $b6IDf.pluginKey).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("ihi8h", function(module, exports) {

$parcel$export(module.exports, "useItemInsert", () => $eb595ad3aa140c9b$export$3a3385069392b26f);

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $5Vwh8 = parcelRequire("5Vwh8");

var $eF1Qh = parcelRequire("eF1Qh");

var $ecipM = parcelRequire("ecipM");

var $8oQ7W = parcelRequire("8oQ7W");

var $koD1m = parcelRequire("koD1m");
const $eb595ad3aa140c9b$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $5Vwh8.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $ecipM.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $eb595ad3aa140c9b$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    const itemsRef = (0, $5uXOq.useRef)(items);
    const onTextInsert = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $eb595ad3aa140c9b$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $5uXOq.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $koD1m.itemIsDisabled)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $eF1Qh.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $5uXOq.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $3UtTx.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("ecipM", function(module, exports) {

$parcel$export(module.exports, "setSelectionBeforeQuery", () => $323bc7045def31d4$export$5af11333ab9d7643);

var $gZGBX = parcelRequire("gZGBX");
const $323bc7045def31d4$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $gZGBX.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("kjRsq", function(module, exports) {

$parcel$export(module.exports, "useLoadItems", () => $d8a2315e9c730da4$export$36f5628e43bc3fcd);

var $5uXOq = parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");

var $6Tdem = parcelRequire("6Tdem");

var $7lNrQ = parcelRequire("7lNrQ");
const $d8a2315e9c730da4$var$EMPTY_LIST_ITEM = [];
const $d8a2315e9c730da4$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore)=>{
    const [items, setItems] = (0, $5uXOq.useState)($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $5uXOq.useRef)(true);
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    (0, $5uXOq.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        getItems(options).then((result)=>{
            const list = result.length > 0 ? result : $d8a2315e9c730da4$var$EMPTY_LIST_ITEM;
            if (componentIsMounted.current) setItems(list);
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $7lNrQ.updateListItem)(showViewMore ? list.concat(viewMoreItem) : list)(view.state, view.dispatch);
            });
        }).catch((e)=>{
            if ((0, $gmhCD.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $6Tdem.updateListError)(e)(view.state, view.dispatch);
                    });
                }
            }
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("6Tdem", function(module, exports) {

$parcel$export(module.exports, "updateListError", () => $92abbbe801e1416a$export$4f4014ebb73e8d41);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $92abbbe801e1416a$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("7lNrQ", function(module, exports) {

$parcel$export(module.exports, "updateListItem", () => $3098d34af4194062$export$e482099e4c227d2);

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");
const $3098d34af4194062$export$e482099e4c227d2 = (items)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $b6IDf.pluginKey), {
            action: (0, $7eFnB.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});


parcelRegister("52b7w", function(module, exports) {

$parcel$export(module.exports, "useOnForceSelect", () => $be9bd9cb734881d4$export$4715c10ec9ca9321);

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $eF1Qh = parcelRequire("eF1Qh");
const $be9bd9cb734881d4$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $5uXOq.useRef)(editorView);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $eF1Qh.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $3UtTx.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("kz2Z2", function(module, exports) {

$parcel$export(module.exports, "InputQuery", () => $aac54d4dcb1a378a$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $1SLCf = parcelRequire("1SLCf");

var $gE8f9 = parcelRequire("gE8f9");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gFzVq = parcelRequire("gFzVq");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");
function $aac54d4dcb1a378a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aac54d4dcb1a378a$var$placeholderStyles = {
    name: "1onny3l",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #626F86);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #091E420F);border-radius:3px;}"
};
const $aac54d4dcb1a378a$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        content: `''`
    }
});
const $aac54d4dcb1a378a$var$querySpanStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $iHYdz.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #0052CC)"
    }
});
const $aac54d4dcb1a378a$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $aac54d4dcb1a378a$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $1SLCf.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $aac54d4dcb1a378a$var$getAriaLabel = (triggerPrefix, intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $8ptyJ.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $8ptyJ.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $8ptyJ.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $8ptyJ.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $aac54d4dcb1a378a$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $5uXOq.useRef)(document.createElement('span'));
    const inputRef = (0, $5uXOq.useRef)(null);
    const [query, setQuery] = (0, $5uXOq.useState)(null);
    const isEditorInsertionEnabled = (0, $gmhCD.editorExperiment)('platform_editor_insertion', 'variant1');
    const isEditorControlsPatch2Enabled = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_2');
    const isSearchPlaceholderEnabled = isEditorInsertionEnabled || (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $5uXOq.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $5r0mK.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $5uXOq.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $5uXOq.useCallback)((event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $5uXOq.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $5uXOq.useState)(false);
    const checkKeyEvent = (0, $5uXOq.useCallback)((event)=>{
        const key = (0, $1SLCf.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $3UtTx.SelectItemMode).SHIFT_ENTER : (0, $3UtTx.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                if (selectedIndex === -1) {
                    /**
           * TODO DTR-1401: (also see ED-17200) There are two options
           * here, either
           * - set the index directly to 1 in WrapperTypeAhead.tsx's
           *   `insertSelectedItem` at the cost of breaking some of the a11y
           *   focus changes,
           * - or do this jank at the cost of some small analytics noise.
           *
           */ selectPreviousItem();
                    selectNextItem();
                }
                // TODO: DTR-1401 - why is this calling select item when hitting tab? fix this in DTR-1401
                onItemSelect((0, $3UtTx.SelectItemMode).TAB);
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $aac54d4dcb1a378a$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($aac54d4dcb1a378a$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onQueryFocus();
        inputRef.current?.focus();
        return false;
    }, [
        onQueryFocus
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const onFocusIn = (event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $1SLCf.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if (((0, $gE8f9.browser).ie || (0, $gE8f9.browser).chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if ((0, $gE8f9.browser).safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if ((0, $gE8f9.browser).safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            if ((0, $gE8f9.browser).safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $5uXOq.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $koVbs.default)();
    /**
   When we migrated to emotion from styled component, we started getting this error.
   jsx-a11y/interactive-supports-focus
   Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
  */ return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $aac54d4dcb1a378a$var$querySpanStyles,
            isSearchPlaceholderEnabled && $aac54d4dcb1a378a$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $aac54d4dcb1a378a$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        onClick: onClick,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-controls": (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $8ptyJ.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($aac54d4dcb1a378a$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gFzVq.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $8ptyJ.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$aac54d4dcb1a378a$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("gFzVq", function(module, exports) {

$parcel$export(module.exports, "AssistiveText", () => $fa1c36596b67c458$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lFKmC = parcelRequire("lFKmC");
function $fa1c36596b67c458$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa1c36596b67c458$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $fa1c36596b67c458$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $5uXOq.useState)(false);
    const [debounced, setDebounced] = (0, $5uXOq.useState)(false);
    const [silenced, setSilenced] = (0, $5uXOq.useState)(false);
    const debounceStatusUpdate = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!debounced) {
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (debounced) {
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $fa1c36596b67c458$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};

});




parcelRegister("dp8V8", function(module, exports) {

$parcel$export(module.exports, "createReducer", () => $e28e7fc4651e6649$export$473eb76d322d0290);

var $ez3YZ = parcelRequire("ez3YZ");

var $gkwXh = parcelRequire("gkwXh");

var $etG8M = parcelRequire("etG8M");

var $7eFnB = parcelRequire("7eFnB");

var $b6IDf = parcelRequire("b6IDf");

var $iiwBk = parcelRequire("iiwBk");
const $e28e7fc4651e6649$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $e28e7fc4651e6649$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $ez3YZ.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $e28e7fc4651e6649$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $ez3YZ.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $e28e7fc4651e6649$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $e28e7fc4651e6649$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $etG8M.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $b6IDf.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $e28e7fc4651e6649$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($e28e7fc4651e6649$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $7eFnB.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $iiwBk.isTypeAheadHandler)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $7eFnB.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $7eFnB.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $7eFnB.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $7eFnB.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $7eFnB.ACTIONS).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $7eFnB.ACTIONS).UPDATE_SELECTED_INDEX;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("hgbc1", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $d3e8f95cdf408c42$export$2dda1e4a1d1f6a81);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $3UtTx = parcelRequire("3UtTx");

var $9LY0t = parcelRequire("9LY0t");

var $gmhCD = parcelRequire("gmhCD");

var $gJ2x0 = parcelRequire("gJ2x0");

var $gw7Nh = parcelRequire("gw7Nh");
const $d3e8f95cdf408c42$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const triggerHandler = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.triggerHandler');
    const errorInfo = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.errorInfo');
    const decorationElement = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.decorationElement');
    const decorationSet = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.decorationSet');
    const query = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.query');
    const selectedIndex = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.selectedIndex');
    const items = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.items');
    return {
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        decorationElement: decorationElement,
        decorationSet: decorationSet,
        query: query,
        selectedIndex: selectedIndex
    };
}, (api)=>{
    const { typeAheadState: typeAheadState } = (0, $awTmI.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    return {
        triggerHandler: typeAheadState?.triggerHandler,
        items: typeAheadState?.items,
        errorInfo: typeAheadState?.errorInfo,
        decorationElement: typeAheadState?.decorationElement,
        decorationSet: typeAheadState?.decorationSet,
        query: typeAheadState?.query,
        selectedIndex: typeAheadState?.selectedIndex
    };
});
function $d3e8f95cdf408c42$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = $d3e8f95cdf408c42$var$useSharedState(api);
    if (items === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    if (// TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
    !(0, $gmhCD.editorExperiment)('platform_editor_insertion', 'control') && triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gJ2x0.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        api: api
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gw7Nh.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}

});
parcelRegister("gJ2x0", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $48e3b31cf5a335d2$export$b11addef9209139);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $bmkwl = parcelRequire("bmkwl");

var $ihi8h = parcelRequire("ihi8h");

var $lE4zE = parcelRequire("lE4zE");
const $48e3b31cf5a335d2$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert] = (0, $ihi8h.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((mode = (0, $3UtTx.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lE4zE.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        // selectedIndex={selectedIndex}
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        query: query,
        cancel: cancel,
        api: api
    });
});

});
parcelRegister("lE4zE", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $70eeadf988d1044d$export$fbc0702507873a7d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nRxN = parcelRequire("7nRxN");

var $koVbs = parcelRequire("koVbs");

var $gkwXh = parcelRequire("gkwXh");

var $1IiUD = parcelRequire("1IiUD");

var $f3dKD = parcelRequire("f3dKD");
var $4N9VB = parcelRequire("4N9VB");

var $1iN2Y = parcelRequire("1iN2Y");
var $5NQrW = parcelRequire("5NQrW");

var $iHYdz = parcelRequire("iHYdz");

var $dZbEw = parcelRequire("dZbEw");

var $VSDnB = parcelRequire("VSDnB");


var $8oQ7W = parcelRequire("8oQ7W");

var $cDzXZ = parcelRequire("cDzXZ");
const $70eeadf988d1044d$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 520;
// const DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $70eeadf988d1044d$var$ITEM_PADDING = 12;
const $70eeadf988d1044d$var$INSERT_PANEL_WIDTH = 320;
const $70eeadf988d1044d$var$typeAheadContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '280px',
    maxHeight: '520px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $70eeadf988d1044d$var$OFFSET = [
    0,
    8
];
const $70eeadf988d1044d$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, query: query, setSelectedItem: setSelectedItem } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultMenuHeight = $70eeadf988d1044d$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT;
    const startTime = (0, $5uXOq.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    // useEffect(() => {
    // 	if (!api?.analytics?.actions?.fireAnalyticsEvent) {
    // 		return;
    // 	}
    // 	api?.analytics?.actions?.fireAnalyticsEvent({
    // 		action: ACTION.VIEWED,
    // 		actionSubject: ACTION_SUBJECT.TYPEAHEAD_ITEM,
    // 		eventType: EVENT_TYPE.OPERATIONAL,
    // 		attributes: {
    // 			index: selectedIndex,
    // 			items: items.length,
    // 		},
    // 	});
    // }, [
    // 	items,
    // 	api,
    // 	selectedIndex,
    // 	// In case the current triggerHandler changes
    // 	// e.g: Inserting a mention using the quick insert
    // 	// we need to send the event again
    // 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // 	triggerHandler,
    // ]);
    const [fitHeight, setFitHeight] = (0, $5uXOq.useState)(defaultMenuHeight);
    const getFitHeight = (0, $5uXOq.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $70eeadf988d1044d$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $7nRxN.default)(getFitHeight);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $f3dKD.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji and @ typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $VSDnB.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                const innerEditor = anchorElement.closest('.extension-editable-area');
                if (innerEditor) {
                    // When there is no related target, we default to not closing the popup
                    let newFocusInsideCurrentEditor = !relatedTarget;
                    if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                    newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                    if (!isTextSelected && newFocusInsideCurrentEditor) return;
                } else {
                    // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                    if (!isTextSelected) return;
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $5uXOq.useLayoutEffect)(()=>{
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel
    ]);
    const handleViewAllItemsClick = (0, $5uXOq.useCallback)(()=>{
        const showContextPanel = api?.contextPanel?.actions?.showPanel;
        if (!showContextPanel || !items) return;
        // Opens main editor controls side panel
        showContextPanel({
            id: 'editor-element-insert-sidebar-panel',
            headerComponentElements: {
                headerLabel: (0, $1IiUD.elementInsertSidePanel).title,
                HeaderIcon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: formatMessage((0, $1IiUD.elementInsertSidePanel).title)
                    })
            },
            BodyComponent: ()=>{
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5NQrW.SideInsertPanel), {
                    items: items,
                    onItemInsert: onItemInsert
                });
            }
        }, 'push', $70eeadf988d1044d$var$INSERT_PANEL_WIDTH);
        // Closes typeahead
        cancel({
            addPrefixTrigger: true,
            setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
            forceFocusOnEditor: true
        });
    }, [
        api,
        cancel,
        formatMessage,
        items,
        onItemInsert
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 280,
        offset: $70eeadf988d1044d$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $70eeadf988d1044d$var$typeAheadContent
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cDzXZ.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1iN2Y.QuickInsertPanel), {
        items: items,
        onItemInsert: onItemInsert,
        query: query,
        setSelectedItem: setSelectedItem,
        onViewAllItemsClick: Boolean(api?.contextPanel) ? handleViewAllItemsClick : undefined
    }))));
});
$70eeadf988d1044d$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("1iN2Y", function(module, exports) {

$parcel$export(module.exports, "QuickInsertPanel", () => $a6039491f2a80e46$export$c4b59221ed3995fe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $gIDRO = parcelRequire("gIDRO");

var $74NcZ = parcelRequire("74NcZ");

var $bOqDA = parcelRequire("bOqDA");

var $IV5RJ = parcelRequire("IV5RJ");

var $77Kxe = parcelRequire("77Kxe");
const $a6039491f2a80e46$var$navButtonContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $a6039491f2a80e46$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                id: suggested.id,
                items: suggested.items.slice(0, 6),
                label: suggested.label,
                onItemSelected: onItemSelected,
                setSelectedItem: setSelectedItem,
                startingIndex: 0
            }),
            (0, $gIDRO.CategoriesStructure).map((category)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                return items.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                    hasSeparator: true,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $a6039491f2a80e46$var$navButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.LinkNavButton), {
                            id: category.id,
                            label: category.title,
                            onClick: onCategorySelected
                        })
                    })
                }, category.id);
            })
        ]
    });
};
const $a6039491f2a80e46$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $gIDRO.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    let startingIndex = categoryLevelItems.length;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $luBm6.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $77Kxe.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected,
                    startingIndex: 0
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    if (categoryRegistry[id]) {
                        const list = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                            id: id,
                            label: title,
                            items: categoryRegistry[id],
                            onItemSelected: onItemSelected,
                            startingIndex: startingIndex
                        });
                        startingIndex += categoryRegistry[id].length;
                        return list;
                    }
                })
            ]
        })
    });
};
const $a6039491f2a80e46$var$SearchView = ({ items: items, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: 0
    });
};
const $a6039491f2a80e46$var$EmptySearchView = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    align: "center",
                    as: "p",
                    children: "We couldn't find any results."
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
                    align: "center",
                    as: "p",
                    children: [
                        "Select ",
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                            weight: "medium",
                            children: "View all"
                        }),
                        " to browser inserts."
                    ]
                })
            ]
        })
    });
};
const $a6039491f2a80e46$export$c4b59221ed3995fe = /*#__PURE__*/ (0, $5uXOq.memo)(({ items: items, onItemInsert: onItemInsert, onViewAllItemsClick: onViewAllItemsClick, query: query, setSelectedItem: setSelectedItem })=>{
    const onItemSelect = (0, $5uXOq.useCallback)((index)=>{
        onItemInsert((0, $3UtTx.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { suggested: suggested, categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSelectedCategory: setSelectedCategory } = (0, $gIDRO.useItems)(items, query);
    const showViewAllItems = Boolean(onViewAllItemsClick);
    const view = searchItems ? searchItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect,
        setSelectedItem: setSelectedItem
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$EmptySearchView, {}) : selectedCategory ? /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a6039491f2a80e46$var$DefaultView, {
        suggested: suggested,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        },
        setSelectedItem: setSelectedItem
    });
    if (showViewAllItems) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            view,
            showViewAllItems && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ViewAllButtonItem), {
                isViewAllInserts: true,
                label: 'View all inserts',
                onClick: onViewAllItemsClick ? onViewAllItemsClick : ()=>{}
            })
        ]
    });
    else return view;
});

});
parcelRegister("gIDRO", function(module, exports) {

$parcel$export(module.exports, "CategoriesStructure", () => $74beeb514a2542ee$export$55e347ea2fcfe5fb);
$parcel$export(module.exports, "PredefinedCategories", () => $74beeb514a2542ee$export$55985cbdefca4b42);
$parcel$export(module.exports, "useItems", () => $74beeb514a2542ee$export$7bfdd97581ca93c);

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $f38Uc = parcelRequire("f38Uc");

var $8TaEl = parcelRequire("8TaEl");
const $74beeb514a2542ee$var$transformBrowserElementItem = (item)=>{
    return {
        index: item.tempKey,
        title: item.title,
        description: item.description,
        showDescription: Boolean(item?.id) && item.id !== 'datasource' ? false : true,
        keyshortcut: item.keyshortcut ? (0, $e9qoo.makeKeyMapWithCommon)('', item.keyshortcut) : undefined,
        renderIcon: item.icon
    };
};
const $74beeb514a2542ee$export$55e347ea2fcfe5fb = [
    {
        id: 'media',
        title: 'Media',
        subcategories: [],
        // defaultItems and array or native elements' ids or titles of an extensions
        // TODO: ED-26961 - how should we identify extensions in prod?
        // Note: only 'media' or 'media-insert' will be available, so we'll display only 5 default items
        defautltItems: [
            'media',
            'media-insert',
            'emoji',
            'hyperlink',
            'loom',
            'Create whiteboard'
        ]
    },
    {
        id: 'structure',
        title: 'Structure',
        subcategories: [
            {
                id: 'text structure',
                title: 'Text structure'
            },
            {
                id: 'page structure',
                title: 'Page structure'
            },
            {
                id: 'connect pages',
                title: 'Connect pages'
            },
            {
                id: 'navigation',
                title: 'Navigation'
            },
            {
                id: 'search',
                title: 'Search'
            }
        ],
        defautltItems: [
            'date',
            'decision',
            'status',
            'table',
            'Table of contents'
        ]
    },
    {
        id: 'data',
        title: 'Data',
        subcategories: [
            {
                id: 'charts',
                title: 'Charts'
            },
            {
                id: 'gadgets',
                title: 'Gadgets'
            },
            {
                id: 'jira',
                title: 'Jira'
            },
            {
                id: 'labels',
                title: 'Labels'
            },
            {
                id: 'reports',
                title: 'Reports'
            },
            {
                id: 'timelines',
                title: 'Timelines'
            }
        ],
        defautltItems: [
            'Create database',
            'Filter by label',
            'Chart',
            'Create Jira issue',
            'Content Report Table'
        ]
    },
    {
        id: 'collaborate',
        title: 'Collaborate',
        subcategories: [],
        defautltItems: [
            'mention',
            'Contributors',
            'Contributors Summary',
            'User Profile',
            'Spaces List'
        ]
    },
    {
        id: 'ai',
        title: 'Atlassian Intelligence',
        subcategories: [],
        defautltItems: []
    },
    {
        id: 'apps',
        title: 'Apps',
        subcategories: [],
        defautltItems: []
    }
];
const $74beeb514a2542ee$export$55985cbdefca4b42 = new Map();
$74beeb514a2542ee$export$55e347ea2fcfe5fb.forEach((categoryData)=>{
    $74beeb514a2542ee$export$55985cbdefca4b42.set(categoryData.id, categoryData);
    categoryData.subcategories.forEach((subcategoryData)=>{
        $74beeb514a2542ee$export$55985cbdefca4b42.set(subcategoryData.id, subcategoryData);
    });
});
const $74beeb514a2542ee$var$parseCategories = (itemCategories)=>{
    if (!itemCategories) return [
        'apps'
    ];
    const filteredCategories = itemCategories.filter((category)=>{
        return $74beeb514a2542ee$export$55985cbdefca4b42.has(category.toLocaleLowerCase());
    });
    return filteredCategories.length > 0 ? filteredCategories : [
        'apps'
    ];
};
const $74beeb514a2542ee$var$suggestedIds = [
    'table',
    'action',
    'codeblock',
    'infopanel',
    'threecolumnslayout',
    'emoji',
    'rule',
    'expand'
];
const $74beeb514a2542ee$export$7bfdd97581ca93c = (quickInsertPanelItems, query)=>{
    const [searchText, setSearchText] = (0, $5uXOq.useState)(query);
    const [selectedCategory, setSelectedCategory] = (0, $5uXOq.useState)();
    const insertPanelItems = (0, $5uXOq.useMemo)(()=>(0, $f38Uc.getMappedItems)(quickInsertPanelItems), [
        quickInsertPanelItems
    ]);
    const categoryRegistry = {};
    const itemsRegistry = {};
    const suggestedItems = [];
    insertPanelItems.forEach((item)=>{
        const categories = $74beeb514a2542ee$var$parseCategories(item.categories);
        const preparedItem = $74beeb514a2542ee$var$transformBrowserElementItem(item);
        categories.forEach((category)=>{
            category = category.toLocaleLowerCase();
            if (categoryRegistry[category]) categoryRegistry[category].push(preparedItem);
            else categoryRegistry[category] = [
                preparedItem
            ];
        });
        const itemKey = item.id || item.title;
        itemsRegistry[itemKey] = preparedItem;
        for(let i = 0; i < $74beeb514a2542ee$var$suggestedIds.length; i++){
            const realSuggestedItems = suggestedItems.filter((item)=>item);
            if (realSuggestedItems.length < $74beeb514a2542ee$var$suggestedIds.length && itemKey === $74beeb514a2542ee$var$suggestedIds[i]) suggestedItems[i] = preparedItem;
        }
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    const suggested = {
        id: 'suggested',
        label: 'Suggestions',
        items: suggestedItems
    }; // TODO define the id and label as constants
    // when query gets updated from the prop drilling it won't cause a re-render of the hook
    // as it will be treated only as default state, so for now combinbing searchText and query here
    // we need to find a better more performant solution for the search (after the demo)
    const combinedSearchText = (0, $5uXOq.useMemo)(()=>searchText || query, [
        query,
        searchText
    ]);
    const searchItems = (0, $5uXOq.useMemo)(()=>{
        if (!combinedSearchText) return undefined;
        const filteredItems = (0, $8TaEl.find)(combinedSearchText, insertPanelItems);
        return filteredItems.map((item)=>$74beeb514a2542ee$var$transformBrowserElementItem(item));
    }, [
        insertPanelItems,
        combinedSearchText
    ]);
    return {
        suggested: suggested,
        categoryRegistry: categoryRegistry,
        itemsRegistry: itemsRegistry,
        selectedCategory: selectedCategory,
        searchItems: searchItems,
        setSearchText: setSearchText,
        setSelectedCategory: setSelectedCategory
    };
};

});
parcelRegister("f38Uc", function(module, exports) {

$parcel$export(module.exports, "getMappedItems", () => $866f0e1daf5bd577$export$c9a8cf32755faa87);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7Xf9k = parcelRequire("7Xf9k");

var $6TPL7 = parcelRequire("6TPL7");

var $cgRoK = parcelRequire("cgRoK");

var $jSlaY = parcelRequire("jSlaY");

var $3fesp = parcelRequire("3fesp");

var $8HSNL = parcelRequire("8HSNL");

var $cVLny = parcelRequire("cVLny");

var $dgJHC = parcelRequire("dgJHC");

var $fhbwe = parcelRequire("fhbwe");

var $9e98Z = parcelRequire("9e98Z");

var $bh6Q5 = parcelRequire("bh6Q5");

var $1f9bV = parcelRequire("1f9bV");

var $izMdR = parcelRequire("izMdR");

var $2UiHO = parcelRequire("2UiHO");

var $4xPlE = parcelRequire("4xPlE");

var $aiLjp = parcelRequire("aiLjp");
const $866f0e1daf5bd577$var$getItemData = (item, tempKey)=>{
    const itemId = item.id;
    const itemTitle = item.title;
    if (itemId && itemId !== 'datasource') switch(itemId){
        case 'action':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'media-insert':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fhbwe))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'mention':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($izMdR))), {
                        label: ""
                    }),
                categories: [
                    'collaborate'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'emoji':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cVLny))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'expand':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TPL7))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'table':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgJHC))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'codeblock':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'status':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgRoK))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'infopanel':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9e98Z))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Panel',
                tempKey: tempKey
            };
        case 'date':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                        label: ""
                    }),
                categories: [
                    'date'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'loom':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aiLjp))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'decision':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8HSNL))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'threecolumnslayout':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6Q5))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Layout',
                tempKey: tempKey
            };
        case 'hyperlink':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'rule':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Xf9k))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'blockquote':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
    }
    else if (itemTitle) switch(itemTitle){
        case 'Assets':
            return {
                ...item,
                categories: [
                    'data'
                ],
                tempKey: tempKey
            };
        case 'Jira Issues':
        case 'Jira Road Map':
            return {
                ...item,
                categories: [
                    'jira'
                ],
                tempKey: tempKey
            };
        case 'Labels List':
        case 'Related Labels':
        case 'Labels Gadget':
        case 'Popular Labels':
            return {
                ...item,
                categories: [
                    'labels'
                ],
                tempKey: tempKey
            };
        case 'Version Report':
        case 'Time to First Response':
        case 'Decision report':
        case 'Two Dimensional Filter Statistics':
        case 'Task report':
        case 'Issue Statistics':
        case 'Page Properties Report':
            return {
                ...item,
                categories: [
                    'reports'
                ],
                tempKey: tempKey
            };
        case 'Opsgenie Incident Timeline EU':
        case 'Opsgenie Incident Timeline':
        case 'Jira timeline':
        case 'JSM Incident Timeline EU':
        case 'JSM Incident Timeline':
        case 'Resolution Time':
            return {
                ...item,
                categories: [
                    'timelines'
                ],
                tempKey: tempKey
            };
        case 'Create database':
        case 'Filter by label':
        case 'Chart':
        case 'Create Jira issue':
        case 'Content Report Table':
            return {
                ...item,
                categories: [
                    'data'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Heat Map':
        case 'Pie Chart':
        case 'Time Since Chart':
        case 'Recently Created Chart':
        case 'Created vs. Resolved Chart':
        case 'Average Age Chart':
            return {
                ...item,
                categories: [
                    'charts'
                ],
                tempKey: tempKey
            };
        case 'Agile Wallboard Gadget':
        case 'Sprint Burndown Gadget':
            return {
                ...item,
                categories: [
                    'gadgets'
                ],
                tempKey: tempKey
            };
        case 'Anchor link':
        case 'Child pages':
        case 'Page Index':
            return {
                ...item,
                categories: [
                    'navigation'
                ],
                tempKey: tempKey
            };
        case 'Table of contents':
            return {
                ...item,
                categories: [
                    'page structure'
                ],
                tempKey: tempKey
            };
        case 'Insert Confluence list':
        case 'Live Search':
        case 'Page Tree Search':
        case 'Page Tree':
            return {
                ...item,
                categories: [
                    'search'
                ],
                tempKey: tempKey
            };
        case 'Excerpt':
        case 'Recently Updated Dashboard':
        case 'Create from Template':
            return {
                ...item,
                categories: [
                    'connect pages'
                ],
                tempKey: tempKey
            };
        case 'Powerpoint':
        case 'Excel':
        case 'Iframe':
        case 'Profile Picture':
        case 'Blog Posts':
        case 'Gallery':
        case 'Word':
        case 'PDF':
        case 'Widget Connector':
            return {
                ...item,
                categories: [
                    'media'
                ],
                tempKey: tempKey
            };
        case 'Create whiteboard':
            return {
                ...item,
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Contributors':
        case 'Contributors Summary':
        case 'User List':
        case 'Voted Issues':
        case 'User Profile':
        case 'Spaces List':
            return {
                ...item,
                categories: [
                    'collaborate'
                ],
                tempKey: tempKey
            };
        case 'Gliffy Diagram':
            return {
                ...item,
                categories: [
                    'apps'
                ],
                tempKey: tempKey
            };
        default:
            return {
                ...item,
                tempKey: tempKey
            };
    }
    return {
        ...item,
        categories: [
            'apps'
        ],
        tempKey: // category: 'apps',
        // subCategory: undefined,
        tempKey
    };
};
const $866f0e1daf5bd577$export$c9a8cf32755faa87 = (items)=>{
    return items.map((item, index)=>$866f0e1daf5bd577$var$getItemData(item, index));
};

});
parcelRegister("7Xf9k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42c245ec8a5b0fa184f110b30fb6ce93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ca9cb73d345844f$var$_react = $5ca9cb73d345844f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5ca9cb73d345844f$var$_baseNew = $5ca9cb73d345844f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5ca9cb73d345844f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DividerElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting divider elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ca9cb73d345844f$var$DividerElementIcon = (props)=>/*#__PURE__*/ $5ca9cb73d345844f$var$_react.default.createElement($5ca9cb73d345844f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 15v-2.5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2V15h1.5v-2.5A.5.5 0 0 1 4 12h8a.5.5 0 0 1 .5.5V15zm2-7.75H0v1.5h16zM2 3.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V1h-1.5v2.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V1H2z" clip-rule="evenodd"/>`
    }, props));
$5ca9cb73d345844f$var$DividerElementIcon.displayName = 'DividerElementIcon';
var $5ca9cb73d345844f$var$_default = module.exports.default = $5ca9cb73d345844f$var$DividerElementIcon;

});

parcelRegister("6TPL7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a282fcec9b1cefd6b5b937a5b07c1f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50600767480aaa35$var$_react = $50600767480aaa35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $50600767480aaa35$var$_baseNew = $50600767480aaa35$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $50600767480aaa35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50600767480aaa35$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $50600767480aaa35$var$_react.default.createElement($50600767480aaa35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$50600767480aaa35$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $50600767480aaa35$var$_default = module.exports.default = $50600767480aaa35$var$ExpandElementIcon;

});

parcelRegister("cgRoK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3dcba78c5e5642b8396cd93a41d6ef1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ef0666e0cb275e1$var$_react = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8ef0666e0cb275e1$var$_baseNew = $8ef0666e0cb275e1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8ef0666e0cb275e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ef0666e0cb275e1$var$LozengeIcon = (props)=>/*#__PURE__*/ $8ef0666e0cb275e1$var$_react.default.createElement($8ef0666e0cb275e1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$8ef0666e0cb275e1$var$LozengeIcon.displayName = 'LozengeIcon';
var $8ef0666e0cb275e1$var$_default = module.exports.default = $8ef0666e0cb275e1$var$LozengeIcon;

});

parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("8HSNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $656cd9546d343d79$var$_react = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $656cd9546d343d79$var$_baseNew = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $656cd9546d343d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $656cd9546d343d79$var$DecisionIcon = (props)=>/*#__PURE__*/ $656cd9546d343d79$var$_react.default.createElement($656cd9546d343d79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$656cd9546d343d79$var$DecisionIcon.displayName = 'DecisionIcon';
var $656cd9546d343d79$var$_default = module.exports.default = $656cd9546d343d79$var$DecisionIcon;

});

parcelRegister("cVLny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $969f8f5da972f70f$var$_react = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $969f8f5da972f70f$var$_baseNew = $969f8f5da972f70f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $969f8f5da972f70f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $969f8f5da972f70f$var$EmojiIcon = (props)=>/*#__PURE__*/ $969f8f5da972f70f$var$_react.default.createElement($969f8f5da972f70f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$969f8f5da972f70f$var$EmojiIcon.displayName = 'EmojiIcon';
var $969f8f5da972f70f$var$_default = module.exports.default = $969f8f5da972f70f$var$EmojiIcon;

});

parcelRegister("dgJHC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a903891a1134335$var$_react = $9a903891a1134335$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a903891a1134335$var$_baseNew = $9a903891a1134335$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9a903891a1134335$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a903891a1134335$var$GridIcon = (props)=>/*#__PURE__*/ $9a903891a1134335$var$_react.default.createElement($9a903891a1134335$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$9a903891a1134335$var$GridIcon.displayName = 'GridIcon';
var $9a903891a1134335$var$_default = module.exports.default = $9a903891a1134335$var$GridIcon;

});

parcelRegister("fhbwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d4dfc113a3924af0f8a9fba22d539c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f160f6235a0c00$var$_react = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b1f160f6235a0c00$var$_baseNew = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b1f160f6235a0c00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f160f6235a0c00$var$ImageIcon = (props)=>/*#__PURE__*/ $b1f160f6235a0c00$var$_react.default.createElement($b1f160f6235a0c00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$b1f160f6235a0c00$var$ImageIcon.displayName = 'ImageIcon';
var $b1f160f6235a0c00$var$_default = module.exports.default = $b1f160f6235a0c00$var$ImageIcon;

});

parcelRegister("9e98Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b7c83a53e38e447$var$_react = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6b7c83a53e38e447$var$_baseNew = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6b7c83a53e38e447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b7c83a53e38e447$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $6b7c83a53e38e447$var$_react.default.createElement($6b7c83a53e38e447$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$6b7c83a53e38e447$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $6b7c83a53e38e447$var$_default = module.exports.default = $6b7c83a53e38e447$var$InformationCircleIcon;

});

parcelRegister("bh6Q5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455753a667f20f1d7529d077b0a47e9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8356965a09dcfb04$var$_react = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8356965a09dcfb04$var$_baseNew = $8356965a09dcfb04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8356965a09dcfb04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8356965a09dcfb04$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $8356965a09dcfb04$var$_react.default.createElement($8356965a09dcfb04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$8356965a09dcfb04$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $8356965a09dcfb04$var$_default = module.exports.default = $8356965a09dcfb04$var$LayoutThreeColumnsIcon;

});

parcelRegister("izMdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1b019ad514d335985b9dfdb2c8fe134>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d860e6e53b6f4f6d$var$_react = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d860e6e53b6f4f6d$var$_baseNew = $d860e6e53b6f4f6d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d860e6e53b6f4f6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d860e6e53b6f4f6d$var$MentionIcon = (props)=>/*#__PURE__*/ $d860e6e53b6f4f6d$var$_react.default.createElement($d860e6e53b6f4f6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$d860e6e53b6f4f6d$var$MentionIcon.displayName = 'MentionIcon';
var $d860e6e53b6f4f6d$var$_default = module.exports.default = $d860e6e53b6f4f6d$var$MentionIcon;

});

parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("aiLjp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780049045b006d7f$var$_react = $780049045b006d7f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780049045b006d7f$var$_baseNew = $780049045b006d7f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $780049045b006d7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780049045b006d7f$var$VideoIcon = (props)=>/*#__PURE__*/ $780049045b006d7f$var$_react.default.createElement($780049045b006d7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$780049045b006d7f$var$VideoIcon.displayName = 'VideoIcon';
var $780049045b006d7f$var$_default = module.exports.default = $780049045b006d7f$var$VideoIcon;

});


parcelRegister("8TaEl", function(module, exports) {

$parcel$export(module.exports, "find", () => $f4f493143bf1264b$export$71aa6c912b956294);

var $3W2qa = parcelRequire("3W2qa");
// Copied from platform/packages/editor/editor-common/src/quick-insert/utils.ts
const $f4f493143bf1264b$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
// If an item has an id, it is a native editor element
// for the demo we could also use item.shouldDisplayAtTop (can potentially be
// replaced by item.isEditorExtention or something similar).
// For now, let's test search usring id as it is closer to production implementation.
const $f4f493143bf1264b$var$prioritySortingFn = (items)=>{
    return (a, b)=>{
        if (items[a.idx].id && items[b.idx].id) return a.score - b.score;
        else if (items[a.idx].id) return -1;
        else return 1;
    };
};
function $f4f493143bf1264b$export$71aa6c912b956294(query, items) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$f4f493143bf1264b$var$options,
        sortFn: $f4f493143bf1264b$var$prioritySortingFn(items)
    };
    const fuse = new (0, $3W2qa.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("3W2qa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd8aaa87a991518$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $2dd8aaa87a991518$var$isArray(value) {
    return !Array.isArray ? $2dd8aaa87a991518$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $2dd8aaa87a991518$var$INFINITY = 1 / 0;
function $2dd8aaa87a991518$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$2dd8aaa87a991518$var$INFINITY ? '-0' : result;
}
function $2dd8aaa87a991518$var$toString(value) {
    return value == null ? '' : $2dd8aaa87a991518$var$baseToString(value);
}
function $2dd8aaa87a991518$var$isString(value) {
    return typeof value === 'string';
}
function $2dd8aaa87a991518$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $2dd8aaa87a991518$var$isBoolean(value) {
    return value === true || value === false || $2dd8aaa87a991518$var$isObjectLike(value) && $2dd8aaa87a991518$var$getTag(value) == '[object Boolean]';
}
function $2dd8aaa87a991518$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $2dd8aaa87a991518$var$isObjectLike(value) {
    return $2dd8aaa87a991518$var$isObject(value) && value !== null;
}
function $2dd8aaa87a991518$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $2dd8aaa87a991518$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $2dd8aaa87a991518$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $2dd8aaa87a991518$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $2dd8aaa87a991518$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $2dd8aaa87a991518$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $2dd8aaa87a991518$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $2dd8aaa87a991518$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $2dd8aaa87a991518$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $2dd8aaa87a991518$var$hasOwn = Object.prototype.hasOwnProperty;
class $2dd8aaa87a991518$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $2dd8aaa87a991518$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $2dd8aaa87a991518$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($2dd8aaa87a991518$var$isString(key) || $2dd8aaa87a991518$var$isArray(key)) {
        src = key;
        path = $2dd8aaa87a991518$var$createKeyPath(key);
        id = $2dd8aaa87a991518$var$createKeyId(key);
    } else {
        if (!$2dd8aaa87a991518$var$hasOwn.call(key, 'name')) throw new Error($2dd8aaa87a991518$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($2dd8aaa87a991518$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($2dd8aaa87a991518$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $2dd8aaa87a991518$var$createKeyPath(name);
        id = $2dd8aaa87a991518$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $2dd8aaa87a991518$var$createKeyPath(key) {
    return $2dd8aaa87a991518$var$isArray(key) ? key : key.split('.');
}
function $2dd8aaa87a991518$var$createKeyId(key) {
    return $2dd8aaa87a991518$var$isArray(key) ? key.join('.') : key;
}
function $2dd8aaa87a991518$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$2dd8aaa87a991518$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$2dd8aaa87a991518$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($2dd8aaa87a991518$var$isString(value) || $2dd8aaa87a991518$var$isNumber(value) || $2dd8aaa87a991518$var$isBoolean(value))) list.push($2dd8aaa87a991518$var$toString(value));
            else if ($2dd8aaa87a991518$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $2dd8aaa87a991518$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $2dd8aaa87a991518$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $2dd8aaa87a991518$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $2dd8aaa87a991518$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $2dd8aaa87a991518$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $2dd8aaa87a991518$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $2dd8aaa87a991518$var$Config = {
    ...$2dd8aaa87a991518$var$BasicOptions,
    ...$2dd8aaa87a991518$var$MatchOptions,
    ...$2dd8aaa87a991518$var$FuzzyOptions,
    ...$2dd8aaa87a991518$var$AdvancedOptions
};
const $2dd8aaa87a991518$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $2dd8aaa87a991518$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($2dd8aaa87a991518$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $2dd8aaa87a991518$var$FuseIndex {
    constructor({ getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}){
        this.norm = $2dd8aaa87a991518$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($2dd8aaa87a991518$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($2dd8aaa87a991518$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$2dd8aaa87a991518$var$isDefined(doc) || $2dd8aaa87a991518$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$2dd8aaa87a991518$var$isDefined(value)) return;
            if ($2dd8aaa87a991518$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$2dd8aaa87a991518$var$isDefined(value)) continue;
                    if ($2dd8aaa87a991518$var$isString(value) && !$2dd8aaa87a991518$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($2dd8aaa87a991518$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($2dd8aaa87a991518$var$isString(value) && !$2dd8aaa87a991518$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $2dd8aaa87a991518$var$createIndex(keys, docs, { getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $2dd8aaa87a991518$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($2dd8aaa87a991518$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $2dd8aaa87a991518$var$parseIndex(data, { getFn: getFn = $2dd8aaa87a991518$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2dd8aaa87a991518$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $2dd8aaa87a991518$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $2dd8aaa87a991518$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $2dd8aaa87a991518$var$Config.distance, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $2dd8aaa87a991518$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $2dd8aaa87a991518$var$MAX_BITS = 32;
function $2dd8aaa87a991518$var$search(text, pattern, patternAlphabet, { location: location = $2dd8aaa87a991518$var$Config.location, distance: distance = $2dd8aaa87a991518$var$Config.distance, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $2dd8aaa87a991518$var$MAX_BITS) throw new Error($2dd8aaa87a991518$var$PATTERN_LENGTH_TOO_LARGE($2dd8aaa87a991518$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $2dd8aaa87a991518$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $2dd8aaa87a991518$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $2dd8aaa87a991518$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $2dd8aaa87a991518$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $2dd8aaa87a991518$var$BitapSearch {
    constructor(pattern, { location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $2dd8aaa87a991518$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $2dd8aaa87a991518$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $2dd8aaa87a991518$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $2dd8aaa87a991518$var$MAX_BITS), i);
                i += $2dd8aaa87a991518$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $2dd8aaa87a991518$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $2dd8aaa87a991518$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $2dd8aaa87a991518$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $2dd8aaa87a991518$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $2dd8aaa87a991518$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $2dd8aaa87a991518$var$ExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $2dd8aaa87a991518$var$InverseExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $2dd8aaa87a991518$var$PrefixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $2dd8aaa87a991518$var$InversePrefixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $2dd8aaa87a991518$var$SuffixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $2dd8aaa87a991518$var$InverseSuffixExactMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $2dd8aaa87a991518$var$FuzzyMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern, { location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $2dd8aaa87a991518$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $2dd8aaa87a991518$var$IncludeMatch extends $2dd8aaa87a991518$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $2dd8aaa87a991518$var$searchers = [
    $2dd8aaa87a991518$var$ExactMatch,
    $2dd8aaa87a991518$var$IncludeMatch,
    $2dd8aaa87a991518$var$PrefixExactMatch,
    $2dd8aaa87a991518$var$InversePrefixExactMatch,
    $2dd8aaa87a991518$var$InverseSuffixExactMatch,
    $2dd8aaa87a991518$var$SuffixExactMatch,
    $2dd8aaa87a991518$var$InverseExactMatch,
    $2dd8aaa87a991518$var$FuzzyMatch
];
const $2dd8aaa87a991518$var$searchersLen = $2dd8aaa87a991518$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $2dd8aaa87a991518$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $2dd8aaa87a991518$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $2dd8aaa87a991518$var$parseQuery(pattern, options = {}) {
    return pattern.split($2dd8aaa87a991518$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($2dd8aaa87a991518$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $2dd8aaa87a991518$var$searchersLen){
                const searcher = $2dd8aaa87a991518$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $2dd8aaa87a991518$var$searchersLen){
                const searcher = $2dd8aaa87a991518$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $2dd8aaa87a991518$var$MultiMatchSet = new Set([
    $2dd8aaa87a991518$var$FuzzyMatch.type,
    $2dd8aaa87a991518$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $2dd8aaa87a991518$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $2dd8aaa87a991518$var$Config.isCaseSensitive, includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $2dd8aaa87a991518$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $2dd8aaa87a991518$var$Config.ignoreLocation, findAllMatches: findAllMatches = $2dd8aaa87a991518$var$Config.findAllMatches, location: location = $2dd8aaa87a991518$var$Config.location, threshold: threshold = $2dd8aaa87a991518$var$Config.threshold, distance: distance = $2dd8aaa87a991518$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $2dd8aaa87a991518$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($2dd8aaa87a991518$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $2dd8aaa87a991518$var$registeredSearchers = [];
function $2dd8aaa87a991518$var$register(...args) {
    $2dd8aaa87a991518$var$registeredSearchers.push(...args);
}
function $2dd8aaa87a991518$var$createSearcher(pattern, options) {
    for(let i = 0, len = $2dd8aaa87a991518$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $2dd8aaa87a991518$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $2dd8aaa87a991518$var$BitapSearch(pattern, options);
}
const $2dd8aaa87a991518$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $2dd8aaa87a991518$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $2dd8aaa87a991518$var$isExpression = (query)=>!!(query[$2dd8aaa87a991518$var$LogicalOperator.AND] || query[$2dd8aaa87a991518$var$LogicalOperator.OR]);
const $2dd8aaa87a991518$var$isPath = (query)=>!!query[$2dd8aaa87a991518$var$KeyType.PATH];
const $2dd8aaa87a991518$var$isLeaf = (query)=>!$2dd8aaa87a991518$var$isArray(query) && $2dd8aaa87a991518$var$isObject(query) && !$2dd8aaa87a991518$var$isExpression(query);
const $2dd8aaa87a991518$var$convertToExplicit = (query)=>({
        [$2dd8aaa87a991518$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $2dd8aaa87a991518$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $2dd8aaa87a991518$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$2dd8aaa87a991518$var$isExpression(query)) return next($2dd8aaa87a991518$var$convertToExplicit(query));
        if ($2dd8aaa87a991518$var$isLeaf(query)) {
            const key = isQueryPath ? query[$2dd8aaa87a991518$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$2dd8aaa87a991518$var$KeyType.PATTERN] : query[key];
            if (!$2dd8aaa87a991518$var$isString(pattern)) throw new Error($2dd8aaa87a991518$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $2dd8aaa87a991518$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $2dd8aaa87a991518$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($2dd8aaa87a991518$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$2dd8aaa87a991518$var$isExpression(query)) query = $2dd8aaa87a991518$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $2dd8aaa87a991518$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $2dd8aaa87a991518$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $2dd8aaa87a991518$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$2dd8aaa87a991518$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$2dd8aaa87a991518$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $2dd8aaa87a991518$var$transformScore(result, data) {
    data.score = result.score;
}
function $2dd8aaa87a991518$var$format(results, docs, { includeMatches: includeMatches = $2dd8aaa87a991518$var$Config.includeMatches, includeScore: includeScore = $2dd8aaa87a991518$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($2dd8aaa87a991518$var$transformMatches);
    if (includeScore) transformers.push($2dd8aaa87a991518$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $2dd8aaa87a991518$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$2dd8aaa87a991518$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $2dd8aaa87a991518$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $2dd8aaa87a991518$var$FuseIndex)) throw new Error($2dd8aaa87a991518$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $2dd8aaa87a991518$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$2dd8aaa87a991518$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $2dd8aaa87a991518$var$isString(query) ? $2dd8aaa87a991518$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $2dd8aaa87a991518$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($2dd8aaa87a991518$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $2dd8aaa87a991518$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $2dd8aaa87a991518$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2dd8aaa87a991518$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $2dd8aaa87a991518$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $2dd8aaa87a991518$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($2dd8aaa87a991518$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $2dd8aaa87a991518$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$2dd8aaa87a991518$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$2dd8aaa87a991518$var$isDefined(value)) return [];
        let matches = [];
        if ($2dd8aaa87a991518$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2dd8aaa87a991518$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$2dd8aaa87a991518$export$2e2bcd8739ae039.version = '6.6.2';
$2dd8aaa87a991518$export$2e2bcd8739ae039.createIndex = $2dd8aaa87a991518$var$createIndex;
$2dd8aaa87a991518$export$2e2bcd8739ae039.parseIndex = $2dd8aaa87a991518$var$parseIndex;
$2dd8aaa87a991518$export$2e2bcd8739ae039.config = $2dd8aaa87a991518$var$Config;
$2dd8aaa87a991518$export$2e2bcd8739ae039.parseQuery = $2dd8aaa87a991518$var$parse;
$2dd8aaa87a991518$var$register($2dd8aaa87a991518$var$ExtendedSearch);

});



parcelRegister("74NcZ", function(module, exports) {

$parcel$export(module.exports, "ListButtonGroupWithHeading", () => $ab159540455f820a$export$3f355796bb73d7b);
$parcel$export(module.exports, "ListButtonGroup", () => $ab159540455f820a$export$645edeb616ed3f65);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bOqDA = parcelRequire("bOqDA");
const $ab159540455f820a$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $ab159540455f820a$var$itemsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $ab159540455f820a$var$ListButtonGroupBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $ab159540455f820a$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $ab159540455f820a$var$itemsContainerStyles
                ],
                children: items.map((item, index)=>{
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ListButtonItem), {
                        index: item.index,
                        isSelected: startingIndex === undefined ? undefined : startingIndex + index === 0,
                        title: item.title,
                        description: item.description,
                        showDescription: item.showDescription,
                        attributes: item.attributes,
                        keyshortcut: item.keyshortcut,
                        renderIcon: item.renderIcon,
                        onItemSelected: (index)=>onItemSelected?.(index, id),
                        setSelectedItem: setSelectedItem
                    }, item.index);
                })
            })
        ]
    });
});
const $ab159540455f820a$export$3f355796bb73d7b = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ab159540455f820a$var$ListButtonGroupBase, {
        id: id,
        label: label,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});
const $ab159540455f820a$export$645edeb616ed3f65 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ab159540455f820a$var$ListButtonGroupBase, {
        id: id,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});

});
parcelRegister("bOqDA", function(module, exports) {

$parcel$export(module.exports, "ListButtonItem", () => $f6e09b587e792d34$export$74006863e39733dc);
$parcel$export(module.exports, "ViewAllButtonItem", () => $f6e09b587e792d34$export$5beeafc8353ee1ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $3dGN0 = parcelRequire("3dGN0");

var $3u0c5 = parcelRequire("3u0c5");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $8Syuu = parcelRequire("8Syuu");
const $f6e09b587e792d34$var$shortcutStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius',
    borderStyle: 'none'
});
const $f6e09b587e792d34$var$selectedColorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.selected'
});
const $f6e09b587e792d34$var$disabledShortcutStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled',
    backgroundColor: 'color.background.disabled'
});
const $f6e09b587e792d34$var$viewAllStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    position: 'sticky',
    bottom: '-4px',
    width: '100%',
    height: '40px',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $f6e09b587e792d34$var$ListButtonItemBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ index: index, title: title, description: description, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, showDescription: showDescription = false, renderContent: renderContent, renderIcon: renderIcon, renderElementAfter: renderElementAfter, onItemSelected: onItemSelected })=>{
    const beforeElement = (0, $5uXOq.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Syuu.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    const afterElement = (0, $5uXOq.useMemo)(()=>renderElementAfter?.(), [
        renderElementAfter
    ]);
    const content = (0, $5uXOq.useMemo)(()=>renderContent?.(), [
        renderContent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                ...tooltipProps,
                iconBefore: beforeElement,
                iconAfter: afterElement,
                description: showDescription ? description : undefined,
                shouldDescriptionWrap: true,
                isSelected: isSelected,
                isDisabled: isDisabled,
                onClick: ()=>onItemSelected?.(index),
                children: content
            })
    });
});
const $f6e09b587e792d34$export$74006863e39733dc = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, attributes: attributes, title: title, setSelectedItem: setSelectedItem, index: index } = props;
    const shortcutComponent = (0, $5uXOq.useCallback)(()=>{
        const shortcut = keyshortcut && (0, $e9qoo.formatShortcut)(keyshortcut);
        if (!shortcut) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            paddingInline: "space.025",
            paddingBlock: "space.025",
            xcss: [
                $f6e09b587e792d34$var$shortcutStyles,
                isSelected && $f6e09b587e792d34$var$selectedColorStyles,
                isDisabled && $f6e09b587e792d34$var$disabledShortcutStyles
            ],
            children: shortcut
        });
    }, [
        isDisabled,
        isSelected,
        keyshortcut
    ]);
    const contentComponent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    children: title
                }),
                attributes?.new && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                    appearance: "new",
                    children: "New"
                })
            ]
        });
    }, [
        attributes?.new,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected) setSelectedItem?.({
            index: index
        });
    }, [
        isSelected,
        setSelectedItem,
        index
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
        ...props,
        renderContent: contentComponent,
        renderElementAfter: shortcutComponent
    });
});
const $f6e09b587e792d34$export$5beeafc8353ee1ed = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick, isViewAllInserts: isViewAllInserts = false })=>{
    const contentComponent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: 'color.text.selected',
                    children: label
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    xcss: [
                        $f6e09b587e792d34$var$selectedColorStyles
                    ],
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: label
                    })
                })
            ]
        });
    }, [
        label
    ]);
    return isViewAllInserts ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $f6e09b587e792d34$var$viewAllStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
            index: -1,
            title: label,
            onItemSelected: onClick,
            renderContent: contentComponent,
            isViewAll: true
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($f6e09b587e792d34$var$ListButtonItemBase, {
        index: -1,
        title: label,
        onItemSelected: onClick,
        renderContent: contentComponent
    });
});

});
parcelRegister("8Syuu", function(module, exports) {

$parcel$export(module.exports, "IconRenderer", () => $e575111e40c4d04b$export$32ff197eed95e568);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $e575111e40c4d04b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e575111e40c4d04b$var$iconWrapperStyles = {
    name: "e42xni",
    styles: "max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);div{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}span{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}"
};
const $e575111e40c4d04b$export$32ff197eed95e568 = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $e575111e40c4d04b$var$iconWrapperStyles
        ]
    }, children);
});

});



parcelRegister("IV5RJ", function(module, exports) {

$parcel$export(module.exports, "LinkNavButton", () => $7dca3a901b769ca2$export$98ce6410d0ba022);
$parcel$export(module.exports, "ExpandableNavButton", () => $7dca3a901b769ca2$export$6f3d5e896fa382de);
$parcel$export(module.exports, "BackNavButton", () => $7dca3a901b769ca2$export$b83dc6f7d9624732);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $ctqwA = parcelRequire("ctqwA");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $jj3Gi = parcelRequire("jj3Gi");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
const $7dca3a901b769ca2$var$buttonStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: 'auto',
    minHeight: 'space.400',
    width: '100%',
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $7dca3a901b769ca2$var$selectedButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $7dca3a901b769ca2$var$disabledButtonStyles = (0, $8CUq3.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $7dca3a901b769ca2$var$headingContainerStyles = (0, $8CUq3.xcss)({
    textAlign: 'left',
    color: 'color.text.accent.orange'
});
const $7dca3a901b769ca2$var$ButtonBase = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, mode: mode, label: label, isSelected: isSelected, isDisabled: isDisabled, isExpanded: isExpanded, attributes: attributes, onClick: onClick })=>{
    const iconComponent = (0, $5uXOq.useMemo)(()=>{
        let Icon;
        let iconLabel;
        switch(mode){
            case 'expandable':
                Icon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jj3Gi))) : (0, (/*@__PURE__*/$parcel$interopDefault($hORKG)));
                iconLabel = isExpanded ? `Collapse ${label} inserts` : `Expand ${label} inserts`;
                break;
            default:
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0)));
                iconLabel = `View all ${label} inserts`;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: iconLabel
        });
    }, [
        isExpanded,
        label,
        mode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
                ...tooltipProps,
                type: "button",
                isDisabled: isDisabled,
                onClick: ()=>onClick?.(id),
                xcss: [
                    $7dca3a901b769ca2$var$buttonStyles,
                    isSelected && $7dca3a901b769ca2$var$selectedButtonStyles,
                    isDisabled && $7dca3a901b769ca2$var$disabledButtonStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: 'space.100',
                    grow: "fill",
                    shouldWrap: false,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                            alignBlock: "center",
                            space: "space.100",
                            shouldWrap: false,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                    xcss: $7dca3a901b769ca2$var$headingContainerStyles,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                                        size: 'xsmall',
                                        as: "span",
                                        children: label
                                    })
                                }),
                                attributes?.new && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                                        appearance: "new",
                                        children: "New"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            children: iconComponent
                        })
                    ]
                })
            })
    });
});
const $7dca3a901b769ca2$export$98ce6410d0ba022 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)($7dca3a901b769ca2$var$ButtonBase, {
        mode: "navigation",
        ...props
    }));
const $7dca3a901b769ca2$export$6f3d5e896fa382de = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)($7dca3a901b769ca2$var$ButtonBase, {
        mode: "expandable",
        ...props
    }));
const $7dca3a901b769ca2$export$b83dc6f7d9624732 = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                ...tooltipProps,
                label: label,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctqwA))),
                appearance: "subtle",
                spacing: "compact",
                onClick: onClick
            })
    });
});

});

parcelRegister("77Kxe", function(module, exports) {

$parcel$export(module.exports, "SubPanelWithBackButton", () => $26cc178212916a97$export$bc997d97789f130b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $IV5RJ = parcelRequire("IV5RJ");
const $26cc178212916a97$var$itemContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.025',
    paddingLeft: 'space.250',
    paddingRight: 'space.250'
});
const $26cc178212916a97$export$bc997d97789f130b = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, buttonLabel: buttonLabel, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
        space: "space.0",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                alignBlock: "center",
                alignInline: "start",
                space: 'space.050',
                xcss: $26cc178212916a97$var$itemContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.BackNavButton), {
                        onClick: onClick,
                        label: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: 'xsmall',
                        as: "span",
                        children: label
                    })
                ]
            }),
            children
        ]
    });
});

});


parcelRegister("5NQrW", function(module, exports) {

$parcel$export(module.exports, "SideInsertPanel", () => $bf681e382b325fc0$export$dfdc13f605e27090);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $414Wj = parcelRequire("414Wj");

var $gIDRO = parcelRequire("gIDRO");

var $dTvsq = parcelRequire("dTvsq");

var $7vV9i = parcelRequire("7vV9i");

var $74NcZ = parcelRequire("74NcZ");

var $5q8nL = parcelRequire("5q8nL");

var $77Kxe = parcelRequire("77Kxe");
const $bf681e382b325fc0$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7vV9i.IconButtonGroup), {
                id: suggested.id,
                items: suggested.items,
                label: suggested.label,
                onItemSelected: onItemSelected
            }),
            (0, $gIDRO.CategoriesStructure).map((category, i)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                const shoudldShowSeparator = i === 0 && !suggested ? false : true;
                return items.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTvsq.ExpandablePanel), {
                    id: category.id,
                    label: category.title,
                    items: items,
                    hasSeparator: shoudldShowSeparator,
                    onItemSelected: onItemSelected,
                    onViewAllSelected: onCategorySelected
                }, category.id);
            })
        ]
    });
};
const $bf681e382b325fc0$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $gIDRO.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $77Kxe.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    return categoryRegistry[id] && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroupWithHeading), {
                        id: id,
                        label: title,
                        items: categoryRegistry[id],
                        onItemSelected: onItemSelected
                    });
                })
            ]
        })
    });
};
const $bf681e382b325fc0$var$SearchView = ({ items: items, onItemSelected: onItemSelected })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $74NcZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected
    });
};
const $bf681e382b325fc0$export$dfdc13f605e27090 = ({ items: items, onItemInsert: onItemInsert })=>{
    const onItemSelect = (0, $5uXOq.useCallback)((index)=>{
        onItemInsert((0, $3UtTx.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSearchText: setSearchText, setSelectedCategory: setSelectedCategory } = (0, $gIDRO.useItems)(items);
    const view = searchItems ? /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect
    }) : selectedCategory ? /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($bf681e382b325fc0$var$DefaultView, {
        suggested: undefined,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5q8nL.SearchPanel), {
                onChange: (event)=>{
                    setSearchText(event.target.value);
                }
            }),
            view
        ]
    });
};

});
parcelRegister("dTvsq", function(module, exports) {

$parcel$export(module.exports, "ExpandablePanel", () => $517071ce1990def3$export$dbf21a0adc6a9ee0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $bOqDA = parcelRequire("bOqDA");

var $IV5RJ = parcelRequire("IV5RJ");
const $517071ce1990def3$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $517071ce1990def3$var$itemsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $517071ce1990def3$export$dbf21a0adc6a9ee0 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, attributes: attributes, onItemSelected: onItemSelected, onViewAllSelected: onViewAllSelected })=>{
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
    // Dirty fix for AI label
    const shortAIlabel = label === 'Atlassian Intelligence';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $517071ce1990def3$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IV5RJ.ExpandableNavButton), {
                    id: id,
                    label: label,
                    isExpanded: isExpanded,
                    attributes: attributes,
                    onClick: ()=>setIsExpanded(!isExpanded)
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                space: "space.025",
                xcss: [
                    $517071ce1990def3$var$itemsContainerStyles
                ],
                children: [
                    items.map((item)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ListButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOqDA.ViewAllButtonItem), {
                        label: `View all ${shortAIlabel ? 'AI' : label.toLocaleLowerCase()} options`,
                        onClick: ()=>onViewAllSelected?.(id)
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("7vV9i", function(module, exports) {

$parcel$export(module.exports, "IconButtonGroup", () => $d0a08a6eece6fc8b$export$62ad8bbf2c8664a6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $602FZ = parcelRequire("602FZ");
const $d0a08a6eece6fc8b$var$headingContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d0a08a6eece6fc8b$var$buttonsContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d0a08a6eece6fc8b$export$62ad8bbf2c8664a6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $d0a08a6eece6fc8b$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: [
                    $d0a08a6eece6fc8b$var$buttonsContainerStyles
                ],
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: "space.050",
                    rowSpace: "space.150",
                    grow: "fill",
                    shouldWrap: true,
                    children: items.map((item)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $602FZ.IconButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    })
                })
            })
        ]
    }));
});

});
parcelRegister("602FZ", function(module, exports) {

$parcel$export(module.exports, "IconButtonItem", () => $08622a063e1a0721$export$b2bea3403fa20e61);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e9qoo = parcelRequire("e9qoo");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $8Syuu = parcelRequire("8Syuu");
const $08622a063e1a0721$var$WIDTH = '60px';
const $08622a063e1a0721$var$largeButtonStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: `${$08622a063e1a0721$var$WIDTH}`,
    width: `${$08622a063e1a0721$var$WIDTH}`,
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    '::after': {
        position: 'absolute',
        inset: 'space.0',
        content: '""',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        pointerEvents: 'none'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $08622a063e1a0721$var$selectedButtonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $08622a063e1a0721$var$disabledButtonStyles = (0, $8CUq3.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $08622a063e1a0721$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
const $08622a063e1a0721$var$textStyles = (0, $8CUq3.xcss)({
    width: `${$08622a063e1a0721$var$WIDTH}`
});
const $08622a063e1a0721$var$LargeIconButtonWithRef = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ icon: icon, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
        ...rest,
        ref: ref,
        type: "button",
        isDisabled: isDisabled,
        onClick: onClick,
        xcss: [
            $08622a063e1a0721$var$largeButtonStyles,
            isSelected && $08622a063e1a0721$var$selectedButtonStyles,
            isDisabled && $08622a063e1a0721$var$disabledButtonStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            as: "span",
            xcss: $08622a063e1a0721$var$iconStyles,
            children: icon
        })
    });
}));
const $08622a063e1a0721$export$b2bea3403fa20e61 = /*#__PURE__*/ (0, $5uXOq.memo)(({ index: index, title: title, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, renderIcon: renderIcon, onItemSelected: onItemSelected })=>{
    const iconComponent = (0, $5uXOq.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Syuu.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($08622a063e1a0721$var$LargeIconButtonWithRef, {
                        ...tooltipProps,
                        icon: iconComponent,
                        isSelected: isSelected,
                        isDisabled: isDisabled,
                        onClick: ()=>onItemSelected?.(index)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $08622a063e1a0721$var$textStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                            align: "center",
                            maxLines: 1,
                            color: isDisabled ? 'color.text.disabled' : isSelected ? 'color.text.selected' : 'color.text.subtle',
                            size: "small",
                            children: title
                        })
                    })
                ]
            })
    });
});

});


parcelRegister("5q8nL", function(module, exports) {

$parcel$export(module.exports, "SearchPanel", () => $437ff3f6ed62ba4a$export$ea47151d20780fe9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");
const $437ff3f6ed62ba4a$var$searchPanelStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $437ff3f6ed62ba4a$var$searchIconStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0'
});
const $437ff3f6ed62ba4a$export$ea47151d20780fe9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onChange: onChange })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $437ff3f6ed62ba4a$var$searchPanelStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
            name: "search",
            id: "search-textfield",
            placeholder: "Find or describe...",
            elemBeforeInput: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $437ff3f6ed62ba4a$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
                    label: "search",
                    color: "var(--ds-text-subtlest, #626F86)"
                })
            }),
            onChange: onChange
        })
    });
});

});


parcelRegister("cDzXZ", function(module, exports) {

$parcel$export(module.exports, "TypeAheadErrorFallback", () => $484e2e2b6b626403$export$71ea07f9d4f4ab38);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $8ptyJ = parcelRequire("8ptyJ");

var $km5PY = parcelRequire("km5PY");

var $7KF6U = parcelRequire("7KF6U");
function $484e2e2b6b626403$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $484e2e2b6b626403$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $484e2e2b6b626403$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $koVbs.default)();
    const header = intl.formatMessage((0, $8ptyJ.typeAheadListMessages).offlineErrorFallbackHeading);
    const description = intl.formatMessage((0, $8ptyJ.typeAheadListMessages).offlineErrorFallbackDesc);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": "mentions-typeahead-error-boundary-ui",
        css: $484e2e2b6b626403$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $km5PY.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7KF6U.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("km5PY", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $e721e83561737f1e$export$fddf379e22a74b00);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $e721e83561737f1e$var$containerStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $e721e83561737f1e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        xcss: $e721e83561737f1e$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7KF6U", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $bb53bd6e46954378$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $bb53bd6e46954378$var$HEIGHT = 90;
const $bb53bd6e46954378$var$genericErrorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `${$bb53bd6e46954378$var$HEIGHT}px`,
    display: 'block'
});
const $bb53bd6e46954378$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $bb53bd6e46954378$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("defs", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});




parcelRegister("gw7Nh", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $cc7eb8bda80979f8$export$b11addef9209139);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3UtTx = parcelRequire("3UtTx");

var $gmhCD = parcelRequire("gmhCD");

var $bmkwl = parcelRequire("bmkwl");

var $ihi8h = parcelRequire("ihi8h");

var $inLlw = parcelRequire("inLlw");
const $cc7eb8bda80979f8$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $ihi8h.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $bmkwl.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((mode = (0, $3UtTx.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $3UtTx.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const showViewMore = triggerHandler?.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT && !!openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1');
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !showViewMore && items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $inLlw.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showViewMore: showViewMore
    });
});

});
parcelRegister("inLlw", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $8352663f3ec19656$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7nRxN = parcelRequire("7nRxN");

var $gkwXh = parcelRequire("gkwXh");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $3UtTx = parcelRequire("3UtTx");

var $f3dKD = parcelRequire("f3dKD");
var $4N9VB = parcelRequire("4N9VB");

var $9LY0t = parcelRequire("9LY0t");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");

var $6tlgz = parcelRequire("6tlgz");

var $5Vwh8 = parcelRequire("5Vwh8");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");

var $cDzXZ = parcelRequire("cDzXZ");

var $5tYDm = parcelRequire("5tYDm");
function $8352663f3ec19656$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $8352663f3ec19656$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $8352663f3ec19656$var$ITEM_PADDING = 12;
const $8352663f3ec19656$var$typeAheadContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $8352663f3ec19656$var$typeAheadContentOverride = /*#__PURE__*/ (0, $f8Sb3.css)({
    maxHeight: `${$8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $8352663f3ec19656$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $8352663f3ec19656$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $8352663f3ec19656$var$OFFSET = [
    0,
    8
];
const $8352663f3ec19656$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const moreElementsInQuickInsertView = (0, $9LY0t.useSharedPluginStateSelector)(api, 'featureFlags.moreElementsInQuickInsertView');
    return {
        moreElementsInQuickInsertView: moreElementsInQuickInsertView
    };
}, (api)=>{
    const { featureFlagsState: featureFlagsState } = (0, $awTmI.useSharedPluginState)(api, [
        'featureFlags'
    ]);
    return {
        moreElementsInQuickInsertView: featureFlagsState?.moreElementsInQuickInsertView
    };
});
const $8352663f3ec19656$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showViewMore: showViewMore } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = $8352663f3ec19656$var$useSharedState(api);
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsPatch2Enabled = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_2');
    const defaultMenuHeight = (0, $5uXOq.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $5uXOq.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (0, $iiwBk.getPluginState)(editorView.state)?.inputMethod
    });
    const startTime = (0, $5uXOq.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).RENDERED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).VIEWED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $5uXOq.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $5uXOq.useMemo)(()=>{
        if (showViewMore) return fitHeight - $8352663f3ec19656$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showViewMore
    ]);
    const getFitHeight = (0, $5uXOq.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $8352663f3ec19656$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $7nRxN.default)(getFitHeight);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $f3dKD.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $8oQ7W.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $VSDnB.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                const innerEditor = anchorElement.closest('.extension-editable-area');
                if (innerEditor) {
                    // When there is no related target, we default to not closing the popup
                    let newFocusInsideCurrentEditor = !relatedTarget;
                    if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                    newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                    if (!isTextSelected && newFocusInsideCurrentEditor) return;
                } else {
                    // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                    if (!isTextSelected) return;
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsPatch2Enabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $iiwBk.getPluginState)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $gkwXh.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsPatch2Enabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $8oQ7W.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsPatch2Enabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const close = (editorView)=>{
        const { state: { tr: tr } } = editorView;
        (0, $5Vwh8.closeTypeAhead)(tr);
        editorView.dispatch(tr);
    };
    const onViewMoreClick = (0, $5uXOq.useCallback)(()=>{
        close(editorView);
        if (openElementBrowserModal && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) activityStateRef.current = {
            inputMethod: (0, $gkwXh.INPUT_METHOD).MOUSE,
            closeAction: (0, $gkwXh.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
        // TODO: ED-26959 - when clean up, remove config in quick insert plugin
        // platform/packages/editor/editor-plugin-quick-insert/src/quickInsertPlugin.tsx (typeAhead.openElementBrowserModal)
        openElementBrowserModal?.();
    }, [
        editorView,
        openElementBrowserModal
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        zIndex: (0, $iHYdz.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $8352663f3ec19656$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $6tlgz.fireTypeAheadClosedAnalyticsEvent)(api, activityStateRef.current.closeAction || (0, $gkwXh.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $gkwXh.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $8352663f3ec19656$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $8352663f3ec19656$var$typeAheadContentOverride,
            showViewMore && $8352663f3ec19656$var$typeAheadWrapperWithViewMoreOverride
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8oQ7W.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cDzXZ.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($8352663f3ec19656$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5tYDm.TypeAheadList), {
        items: items,
        selectedIndex: selectedIndex,
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $gkwXh.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showViewMore: showViewMore,
        onViewMoreClick: onViewMoreClick
    }))));
});
$8352663f3ec19656$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("5tYDm", function(module, exports) {

$parcel$export(module.exports, "TypeAheadList", () => $d72dfd0f40a0ed4b$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");
var $koVbs = parcelRequire("koVbs");

var $7Pkjl = parcelRequire("7Pkjl");

var $aLlKO = parcelRequire("aLlKO");

var $gkwXh = parcelRequire("gkwXh");

var $2i4K4 = parcelRequire("2i4K4");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $gFzVq = parcelRequire("gFzVq");

var $eZUJu = parcelRequire("eZUJu");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $bmkwl = parcelRequire("bmkwl");

var $8oQ7W = parcelRequire("8oQ7W");

var $iiwBk = parcelRequire("iiwBk");

var $96cc5 = parcelRequire("96cc5");

var $gIpUw = parcelRequire("gIpUw");

var $8PLnn = parcelRequire("8PLnn");
const $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $d72dfd0f40a0ed4b$var$LIST_WIDTH = 320;
const $d72dfd0f40a0ed4b$var$list = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gFzVq.AssistiveText), {
        assistiveText: intl.formatMessage((0, $8ptyJ.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $d72dfd0f40a0ed4b$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showViewMore: showViewMore, onViewMoreClick: onViewMoreClick })=>{
    const listRef = (0, $5uXOq.useRef)();
    const listContainerRef = (0, $5uXOq.useRef)(null);
    const lastVisibleIndexes = (0, $5uXOq.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showViewMore ? items.length - 1 : items.length;
    const estimatedHeight = itemsLength * $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $5uXOq.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $5uXOq.useState)(new (0, $7Pkjl.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const onItemsRendered = (0, $5uXOq.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $5uXOq.useCallback)(()=>{
        //To reset the selected index
        (0, $bmkwl.updateSelectedIndex)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, $iiwBk.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showViewMore && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showViewMore
    ]);
    const onMouseMove = (event, index)=>{
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === index) return;
        (0, $bmkwl.updateSelectedIndex)(index, api)(editorView.state, editorView.dispatch);
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showViewMore && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showViewMore
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setCache(new (0, $7Pkjl.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = showViewMore ? items.slice(0, -1) : items;
        const height = Math.min(itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        items,
        cache,
        fitHeight,
        showViewMore
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) switch(event.key){
                case 'ArrowDown':
                    selectNextItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // TODO: DTR-1401 - why is this calling item click when hitting tab? fix this in DTR-1401
                case 'Tab':
                    //Tab key quick inserts the selected item.
                    onItemClick((0, $3UtTx.SelectItemMode).TAB, selectedIndex, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
                    event.preventDefault();
                    break;
                case 'Enter':
                    //Enter key quick inserts the selected item.
                    if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                        onItemClick(event.shiftKey ? (0, $3UtTx.SelectItemMode).SHIFT_ENTER : (0, $3UtTx.SelectItemMode).ENTER, selectedIndex, (0, $gkwXh.INPUT_METHOD).KEYBOARD);
                        event.preventDefault();
                    }
                    break;
                default:
                    event.preventDefault();
            }
            else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $5uXOq.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentItem = items[index];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7Pkjl.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, (0, $VSDnB.fg)('platform_editor_typeahead_dynamic_height_fix') ? ({ measure: measure, registerChild: registerChild })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $96cc5.ListRow), {
                registerChild: registerChild,
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                onMouseMove: (e)=>onMouseMove(e, index)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gIpUw.TypeAheadListItem), {
                key: items[index].title,
                item: currentItem,
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: index,
                selectedIndex: selectedIndex,
                onItemClick: (mode, index)=>{
                    actions.onItemClick(mode, index, (0, $gkwXh.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api
            })) : /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            "data-index": index
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: (e)=>onMouseMove(e, index)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gIpUw.TypeAheadListItem), {
            key: items[index].title,
            item: currentItem,
            firstOnlineSupportedIndex: firstOnlineSupportedRow,
            itemsLength: itemsLength,
            itemIndex: index,
            selectedIndex: selectedIndex,
            onItemClick: (mode, index)=>{
                actions.onItemClick(mode, index, (0, $gkwXh.INPUT_METHOD).MOUSE);
            },
            ariaLabel: (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
            moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
            api: api
        }))));
    };
    const popupAriaLabel = (0, $iiwBk.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $8oQ7W.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    const EmptyResultView = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $MHKc7.default), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $8ptyJ.typeAheadListMessages).emptySearchResultsSuggestion, {
        buttonName: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
            weight: "medium"
        }, intl.formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aLlKO.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: itemsLength,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $d72dfd0f40a0ed4b$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        // We need to make this walkaround to make TS happy, cannot pass undefined otherwise ReactVirualized will make it equal to "grid" which we want to avoid
        // https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/Grid.js#L260
        "aria-label": null,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $d72dfd0f40a0ed4b$var$list
        ]
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, !showViewMore || itemsLength ? ListContent : EmptyResultView, showViewMore && onViewMoreClick && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8PLnn.ViewMore), {
        onClick: onViewMoreClick,
        isFocused: selectedIndex === itemsLength
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $d72dfd0f40a0ed4b$export$81b66b5b19964713 = (0, $8RXs9.default)($d72dfd0f40a0ed4b$var$TypeAheadListComponent);
$d72dfd0f40a0ed4b$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("7Pkjl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CellMeasurerCache = module.exports.CellMeasurer = undefined;

var $39v3u = parcelRequire("39v3u");
var $5b2d0d312f5c1e98$var$_CellMeasurer2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($39v3u);

var $ewGy7 = parcelRequire("ewGy7");
var $5b2d0d312f5c1e98$var$_CellMeasurerCache2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($ewGy7);
function $5b2d0d312f5c1e98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
module.exports.CellMeasurer = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
module.exports.CellMeasurerCache = $5b2d0d312f5c1e98$var$_CellMeasurerCache2.default;

});
parcelRegister("39v3u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29Ol4 = parcelRequire("29Ol4");
var $24ba4d50b29169e6$var$_getPrototypeOf2 = $24ba4d50b29169e6$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $24ba4d50b29169e6$var$_classCallCheck3 = $24ba4d50b29169e6$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $24ba4d50b29169e6$var$_createClass3 = $24ba4d50b29169e6$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $24ba4d50b29169e6$var$_possibleConstructorReturn3 = $24ba4d50b29169e6$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $24ba4d50b29169e6$var$_inherits3 = $24ba4d50b29169e6$var$_interopRequireDefault($gHLl6);

var $5uXOq = parcelRequire("5uXOq");
var $24ba4d50b29169e6$var$React = $24ba4d50b29169e6$var$_interopRequireWildcard($5uXOq);

var $7nsd3 = parcelRequire("7nsd3");
parcelRequire("bN49P");

var $8rCP3 = parcelRequire("8rCP3");
var $24ba4d50b29169e6$var$_propTypes2 = $24ba4d50b29169e6$var$_interopRequireDefault($8rCP3);
function $24ba4d50b29169e6$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $24ba4d50b29169e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $24ba4d50b29169e6$var$CellMeasurer = function(_React$PureComponent) {
    (0, $24ba4d50b29169e6$var$_inherits3.default)(CellMeasurer, _React$PureComponent);
    function CellMeasurer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $24ba4d50b29169e6$var$_classCallCheck3.default)(this, CellMeasurer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, $24ba4d50b29169e6$var$_getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._measure = function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        }, _temp), (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $24ba4d50b29169e6$var$_createClass3.default)(CellMeasurer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return typeof children === 'function' ? children({
                    measure: this._measure
                }) : children;
            }
        },
        {
            key: '_getCellMeasurements',
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = (0, $7nsd3.findDOMNode)(this);
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: '_maybeMeasureCell',
            value: function _maybeMeasureCell() {
                var _props = this.props, cache = _props.cache, _props$columnIndex = _props.columnIndex, columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex, parent = _props.parent, _props$rowIndex = _props.rowIndex, rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _getCellMeasurements2 = this._getCellMeasurements(), height = _getCellMeasurements2.height, width = _getCellMeasurements2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
    return CellMeasurer;
}($24ba4d50b29169e6$var$React.PureComponent);
// Used for DEV mode warning check
$24ba4d50b29169e6$var$CellMeasurer.__internalCellMeasurerFlag = false;
$24ba4d50b29169e6$var$CellMeasurer.propTypes = null;
module.exports.default = $24ba4d50b29169e6$var$CellMeasurer;

});
parcelRegister("29Ol4", function(module, exports) {

module.exports = {
    "default": (parcelRequire("1F0kH")),
    __esModule: true
};

});
parcelRegister("1F0kH", function(module, exports) {
parcelRequire("diPPd");

module.exports = (parcelRequire("ej9UZ")).Object.getPrototypeOf;

});
parcelRegister("diPPd", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $1QSIO = parcelRequire("1QSIO");

var $aHGNE = parcelRequire("aHGNE");

(parcelRequire("4JSIZ"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $aHGNE($1QSIO(it));
    };
});

});
parcelRegister("1QSIO", function(module, exports) {
// 7.1.13 ToObject(argument)

var $6gewm = parcelRequire("6gewm");
module.exports = function(it) {
    return Object($6gewm(it));
};

});
parcelRegister("6gewm", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("aHGNE", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $fm44J = parcelRequire("fm44J");

var $1QSIO = parcelRequire("1QSIO");

var $7caf1eaa217f5dae$var$IE_PROTO = (parcelRequire("95ldZ"))('IE_PROTO');
var $7caf1eaa217f5dae$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $1QSIO(O);
    if ($fm44J(O, $7caf1eaa217f5dae$var$IE_PROTO)) return O[$7caf1eaa217f5dae$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $7caf1eaa217f5dae$var$ObjectProto : null;
};

});
parcelRegister("fm44J", function(module, exports) {
var $b2dc125a652b0b38$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $b2dc125a652b0b38$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("95ldZ", function(module, exports) {

var $69d50b745ca4aaf7$var$shared = (parcelRequire("3x15D"))('keys');

var $9cy65 = parcelRequire("9cy65");
module.exports = function(key) {
    return $69d50b745ca4aaf7$var$shared[key] || ($69d50b745ca4aaf7$var$shared[key] = $9cy65(key));
};

});
parcelRegister("3x15D", function(module, exports) {

var $ej9UZ = parcelRequire("ej9UZ");

var $bTLKS = parcelRequire("bTLKS");
var $29254c932144f16e$var$SHARED = '__core-js_shared__';
var $29254c932144f16e$var$store = $bTLKS[$29254c932144f16e$var$SHARED] || ($bTLKS[$29254c932144f16e$var$SHARED] = {});

(module.exports = function(key, value) {
    return $29254c932144f16e$var$store[key] || ($29254c932144f16e$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $ej9UZ.version,
    mode: (parcelRequire("f62P5")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ej9UZ", function(module, exports) {
var $a6aa8898cd049079$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $a6aa8898cd049079$var$core; // eslint-disable-line no-undef

});

parcelRegister("bTLKS", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $8a99dff3b3d230d9$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $8a99dff3b3d230d9$var$global; // eslint-disable-line no-undef

});

parcelRegister("f62P5", function(module, exports) {
module.exports = true;

});


parcelRegister("9cy65", function(module, exports) {
var $6b2faf093ce7f33b$var$id = 0;
var $6b2faf093ce7f33b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$6b2faf093ce7f33b$var$id + $6b2faf093ce7f33b$var$px).toString(36));
};

});



parcelRegister("4JSIZ", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $23Rxz = parcelRequire("23Rxz");

var $ej9UZ = parcelRequire("ej9UZ");

var $eYm1n = parcelRequire("eYm1n");
module.exports = function(KEY, exec) {
    var fn = ($ej9UZ.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $23Rxz($23Rxz.S + $23Rxz.F * $eYm1n(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("23Rxz", function(module, exports) {

var $bTLKS = parcelRequire("bTLKS");

var $ej9UZ = parcelRequire("ej9UZ");

var $eMwHM = parcelRequire("eMwHM");

var $lTOYY = parcelRequire("lTOYY");

var $fm44J = parcelRequire("fm44J");
var $180564a0bab19a6c$var$PROTOTYPE = 'prototype';
var $180564a0bab19a6c$var$$export = function(type, name, source) {
    var IS_FORCED = type & $180564a0bab19a6c$var$$export.F;
    var IS_GLOBAL = type & $180564a0bab19a6c$var$$export.G;
    var IS_STATIC = type & $180564a0bab19a6c$var$$export.S;
    var IS_PROTO = type & $180564a0bab19a6c$var$$export.P;
    var IS_BIND = type & $180564a0bab19a6c$var$$export.B;
    var IS_WRAP = type & $180564a0bab19a6c$var$$export.W;
    var exports = IS_GLOBAL ? $ej9UZ : $ej9UZ[name] || ($ej9UZ[name] = {});
    var expProto = exports[$180564a0bab19a6c$var$PROTOTYPE];
    var target = IS_GLOBAL ? $bTLKS : IS_STATIC ? $bTLKS[name] : ($bTLKS[name] || {})[$180564a0bab19a6c$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $fm44J(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $eMwHM(out, $bTLKS) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$180564a0bab19a6c$var$PROTOTYPE] = C[$180564a0bab19a6c$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $eMwHM(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $180564a0bab19a6c$var$$export.R && expProto && !expProto[key]) $lTOYY(expProto, key, out);
        }
    }
};
// type bitmap
$180564a0bab19a6c$var$$export.F = 1; // forced
$180564a0bab19a6c$var$$export.G = 2; // global
$180564a0bab19a6c$var$$export.S = 4; // static
$180564a0bab19a6c$var$$export.P = 8; // proto
$180564a0bab19a6c$var$$export.B = 16; // bind
$180564a0bab19a6c$var$$export.W = 32; // wrap
$180564a0bab19a6c$var$$export.U = 64; // safe
$180564a0bab19a6c$var$$export.R = 128; // real proto method for `library`
module.exports = $180564a0bab19a6c$var$$export;

});
parcelRegister("eMwHM", function(module, exports) {
// optional / simple context binding

var $4eZ4N = parcelRequire("4eZ4N");
module.exports = function(fn, that, length) {
    $4eZ4N(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4eZ4N", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("lTOYY", function(module, exports) {

var $gBk2k = parcelRequire("gBk2k");

var $bcNKn = parcelRequire("bcNKn");

module.exports = (parcelRequire("3u2mT")) ? function(object, key, value) {
    return $gBk2k.f(object, key, $bcNKn(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("gBk2k", function(module, exports) {

$parcel$export(module.exports, "f", () => $c15fa4e86907aae3$export$2d1720544b23b823, (v) => $c15fa4e86907aae3$export$2d1720544b23b823 = v);
var $c15fa4e86907aae3$export$2d1720544b23b823;

var $ZeX88 = parcelRequire("ZeX88");

var $bS797 = parcelRequire("bS797");

var $laQPh = parcelRequire("laQPh");
var $c15fa4e86907aae3$var$dP = Object.defineProperty;

$c15fa4e86907aae3$export$2d1720544b23b823 = (parcelRequire("3u2mT")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $ZeX88(O);
    P = $laQPh(P, true);
    $ZeX88(Attributes);
    if ($bS797) try {
        return $c15fa4e86907aae3$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("ZeX88", function(module, exports) {

var $908oX = parcelRequire("908oX");
module.exports = function(it) {
    if (!$908oX(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("908oX", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("bS797", function(module, exports) {



module.exports = !(parcelRequire("3u2mT")) && !(parcelRequire("eYm1n"))(function() {
    return Object.defineProperty((parcelRequire("dA4Im"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("3u2mT", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("eYm1n"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("eYm1n", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("dA4Im", function(module, exports) {

var $908oX = parcelRequire("908oX");

var $bTLKS = parcelRequire("bTLKS");
var $9e324b5d3246cdaf$require$document = $bTLKS.document;
// typeof document.createElement is 'object' in old IE
var $9e324b5d3246cdaf$var$is = $908oX($9e324b5d3246cdaf$require$document) && $908oX($9e324b5d3246cdaf$require$document.createElement);
module.exports = function(it) {
    return $9e324b5d3246cdaf$var$is ? $9e324b5d3246cdaf$require$document.createElement(it) : {};
};

});


parcelRegister("laQPh", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $908oX = parcelRequire("908oX");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$908oX(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$908oX(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$908oX(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$908oX(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("bcNKn", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("aXTp8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7fba6438b4dbf46b$export$1e511d4a378977f5, (v) => $7fba6438b4dbf46b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7fba6438b4dbf46b$export$2e2bcd8739ae039, (v) => $7fba6438b4dbf46b$export$2e2bcd8739ae039 = v);
var $7fba6438b4dbf46b$export$1e511d4a378977f5;
var $7fba6438b4dbf46b$export$2e2bcd8739ae039;
"use strict";
$7fba6438b4dbf46b$export$1e511d4a378977f5 = true;
$7fba6438b4dbf46b$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("4tLNB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $342ef2b9df8992a7$export$1e511d4a378977f5, (v) => $342ef2b9df8992a7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $342ef2b9df8992a7$export$2e2bcd8739ae039, (v) => $342ef2b9df8992a7$export$2e2bcd8739ae039 = v);
var $342ef2b9df8992a7$export$1e511d4a378977f5;
var $342ef2b9df8992a7$export$2e2bcd8739ae039;
"use strict";
$342ef2b9df8992a7$export$1e511d4a378977f5 = true;

var $aWlLP = parcelRequire("aWlLP");
var $342ef2b9df8992a7$var$_defineProperty2 = $342ef2b9df8992a7$var$_interopRequireDefault($aWlLP);
function $342ef2b9df8992a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$342ef2b9df8992a7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $342ef2b9df8992a7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("aWlLP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8PCAa")),
    __esModule: true
};

});
parcelRegister("8PCAa", function(module, exports) {
parcelRequire("hIjYS");

var $ej9UZ = parcelRequire("ej9UZ");
var $66e103cc3532e463$require$$Object = $ej9UZ.Object;
module.exports = function defineProperty(it, key, desc) {
    return $66e103cc3532e463$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("hIjYS", function(module, exports) {

var $23Rxz = parcelRequire("23Rxz");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$23Rxz($23Rxz.S + $23Rxz.F * !(parcelRequire("3u2mT")), 'Object', {
    defineProperty: (parcelRequire("gBk2k")).f
});

});




parcelRegister("5pMaQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3f14a7e1704920da$export$1e511d4a378977f5, (v) => $3f14a7e1704920da$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3f14a7e1704920da$export$2e2bcd8739ae039, (v) => $3f14a7e1704920da$export$2e2bcd8739ae039 = v);
var $3f14a7e1704920da$export$1e511d4a378977f5;
var $3f14a7e1704920da$export$2e2bcd8739ae039;
"use strict";
$3f14a7e1704920da$export$1e511d4a378977f5 = true;

var $kt6ai = parcelRequire("kt6ai");
var $3f14a7e1704920da$var$_typeof3 = $3f14a7e1704920da$var$_interopRequireDefault($kt6ai);
function $3f14a7e1704920da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3f14a7e1704920da$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $3f14a7e1704920da$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("kt6ai", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ee6b4c58df698443$export$1e511d4a378977f5, (v) => $ee6b4c58df698443$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ee6b4c58df698443$export$2e2bcd8739ae039, (v) => $ee6b4c58df698443$export$2e2bcd8739ae039 = v);
var $ee6b4c58df698443$export$1e511d4a378977f5;
var $ee6b4c58df698443$export$2e2bcd8739ae039;
"use strict";
$ee6b4c58df698443$export$1e511d4a378977f5 = true;

var $5YQKd = parcelRequire("5YQKd");
var $ee6b4c58df698443$var$_iterator2 = $ee6b4c58df698443$var$_interopRequireDefault($5YQKd);

var $V3332 = parcelRequire("V3332");
var $ee6b4c58df698443$var$_symbol2 = $ee6b4c58df698443$var$_interopRequireDefault($V3332);
var $ee6b4c58df698443$var$_typeof = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && typeof $ee6b4c58df698443$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $ee6b4c58df698443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ee6b4c58df698443$export$2e2bcd8739ae039 = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && $ee6b4c58df698443$var$_typeof($ee6b4c58df698443$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
};

});
parcelRegister("5YQKd", function(module, exports) {

module.exports = {
    "default": (parcelRequire("4cuVP")),
    __esModule: true
};

});
parcelRegister("4cuVP", function(module, exports) {
parcelRequire("6kbwg");
parcelRequire("dSGoU");

module.exports = (parcelRequire("9cAaO")).f('iterator');

});
parcelRegister("6kbwg", function(module, exports) {
'use strict';

var $49ad8bd83a06a6d1$var$$at = (parcelRequire("2c4hw"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("8utbd"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $49ad8bd83a06a6d1$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("2c4hw", function(module, exports) {

var $7ibZE = parcelRequire("7ibZE");

var $6gewm = parcelRequire("6gewm");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($6gewm(that));
        var i = $7ibZE(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("7ibZE", function(module, exports) {
// 7.1.4 ToInteger
var $54f384786d598419$var$ceil = Math.ceil;
var $54f384786d598419$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $54f384786d598419$var$floor : $54f384786d598419$var$ceil)(it);
};

});


parcelRegister("8utbd", function(module, exports) {
'use strict';

var $f62P5 = parcelRequire("f62P5");

var $23Rxz = parcelRequire("23Rxz");

var $7TNl9 = parcelRequire("7TNl9");

var $lTOYY = parcelRequire("lTOYY");

var $2YvtX = parcelRequire("2YvtX");

var $9o2FD = parcelRequire("9o2FD");

var $h9gAE = parcelRequire("h9gAE");

var $aHGNE = parcelRequire("aHGNE");

var $62e7c29c61980990$var$ITERATOR = (parcelRequire("9YxKW"))('iterator');
var $62e7c29c61980990$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $62e7c29c61980990$var$FF_ITERATOR = '@@iterator';
var $62e7c29c61980990$var$KEYS = 'keys';
var $62e7c29c61980990$var$VALUES = 'values';
var $62e7c29c61980990$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $9o2FD(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$62e7c29c61980990$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $62e7c29c61980990$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $62e7c29c61980990$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $62e7c29c61980990$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$62e7c29c61980990$var$ITERATOR] || proto[$62e7c29c61980990$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $aHGNE($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $h9gAE(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$f62P5 && typeof IteratorPrototype[$62e7c29c61980990$var$ITERATOR] != 'function') $lTOYY(IteratorPrototype, $62e7c29c61980990$var$ITERATOR, $62e7c29c61980990$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $62e7c29c61980990$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$f62P5 || FORCED) && ($62e7c29c61980990$var$BUGGY || VALUES_BUG || !proto[$62e7c29c61980990$var$ITERATOR])) $lTOYY(proto, $62e7c29c61980990$var$ITERATOR, $default);
    // Plug for library
    $2YvtX[NAME] = $default;
    $2YvtX[TAG] = $62e7c29c61980990$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($62e7c29c61980990$var$VALUES),
            keys: IS_SET ? $default : getMethod($62e7c29c61980990$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $7TNl9(proto, key, methods[key]);
        } else $23Rxz($23Rxz.P + $23Rxz.F * ($62e7c29c61980990$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("7TNl9", function(module, exports) {

module.exports = (parcelRequire("lTOYY"));

});

parcelRegister("2YvtX", function(module, exports) {
module.exports = {};

});

parcelRegister("9o2FD", function(module, exports) {
'use strict';

var $kLWwA = parcelRequire("kLWwA");

var $bcNKn = parcelRequire("bcNKn");

var $h9gAE = parcelRequire("h9gAE");
var $6d586d43f776ea3d$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("lTOYY"))($6d586d43f776ea3d$var$IteratorPrototype, (parcelRequire("9YxKW"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $kLWwA($6d586d43f776ea3d$var$IteratorPrototype, {
        next: $bcNKn(1, next)
    });
    $h9gAE(Constructor, NAME + ' Iterator');
};

});
parcelRegister("kLWwA", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $ZeX88 = parcelRequire("ZeX88");

var $1f4ZE = parcelRequire("1f4ZE");

var $grdgS = parcelRequire("grdgS");

var $f1f59835c16f7211$var$IE_PROTO = (parcelRequire("95ldZ"))('IE_PROTO');
var $f1f59835c16f7211$var$Empty = function() {};
var $f1f59835c16f7211$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f1f59835c16f7211$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("dA4Im"))('iframe');
    var i = $grdgS.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("avcZT")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f1f59835c16f7211$var$createDict = iframeDocument.F;
    while(i--)delete $f1f59835c16f7211$var$createDict[$f1f59835c16f7211$var$PROTOTYPE][$grdgS[i]];
    return $f1f59835c16f7211$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f1f59835c16f7211$var$Empty[$f1f59835c16f7211$var$PROTOTYPE] = $ZeX88(O);
        result = new $f1f59835c16f7211$var$Empty();
        $f1f59835c16f7211$var$Empty[$f1f59835c16f7211$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f1f59835c16f7211$var$IE_PROTO] = O;
    } else result = $f1f59835c16f7211$var$createDict();
    return Properties === undefined ? result : $1f4ZE(result, Properties);
};

});
parcelRegister("1f4ZE", function(module, exports) {

var $gBk2k = parcelRequire("gBk2k");

var $ZeX88 = parcelRequire("ZeX88");

var $7jJx7 = parcelRequire("7jJx7");

module.exports = (parcelRequire("3u2mT")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $ZeX88(O);
    var keys = $7jJx7(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$gBk2k.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("7jJx7", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $gm1LE = parcelRequire("gm1LE");

var $grdgS = parcelRequire("grdgS");
module.exports = Object.keys || function keys(O) {
    return $gm1LE(O, $grdgS);
};

});
parcelRegister("gm1LE", function(module, exports) {

var $fm44J = parcelRequire("fm44J");

var $lXF0F = parcelRequire("lXF0F");

var $be80126eef393a78$var$arrayIndexOf = (parcelRequire("5UfGt"))(false);

var $be80126eef393a78$var$IE_PROTO = (parcelRequire("95ldZ"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $lXF0F(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $be80126eef393a78$var$IE_PROTO) $fm44J(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($fm44J(O, key = names[i++])) ~$be80126eef393a78$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("lXF0F", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $qozEq = parcelRequire("qozEq");

var $6gewm = parcelRequire("6gewm");
module.exports = function(it) {
    return $qozEq($6gewm(it));
};

});
parcelRegister("qozEq", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $aScHa = parcelRequire("aScHa");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $aScHa(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("aScHa", function(module, exports) {
var $7ea8cb8e6fc27600$var$toString = {}.toString;
module.exports = function(it) {
    return $7ea8cb8e6fc27600$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("5UfGt", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $lXF0F = parcelRequire("lXF0F");

var $ibmXJ = parcelRequire("ibmXJ");

var $9QVSH = parcelRequire("9QVSH");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $lXF0F($this);
        var length = $ibmXJ(O.length);
        var index = $9QVSH(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("ibmXJ", function(module, exports) {
// 7.1.15 ToLength

var $7ibZE = parcelRequire("7ibZE");
var $d3cb10e95b7062b4$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $d3cb10e95b7062b4$var$min($7ibZE(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("9QVSH", function(module, exports) {

var $7ibZE = parcelRequire("7ibZE");
var $72c5de648e81e4e2$var$max = Math.max;
var $72c5de648e81e4e2$var$min = Math.min;
module.exports = function(index, length) {
    index = $7ibZE(index);
    return index < 0 ? $72c5de648e81e4e2$var$max(index + length, 0) : $72c5de648e81e4e2$var$min(index, length);
};

});



parcelRegister("grdgS", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("avcZT", function(module, exports) {

var $bTLKS = parcelRequire("bTLKS");
var $7a56e19c8d13b001$require$document = $bTLKS.document;
module.exports = $7a56e19c8d13b001$require$document && $7a56e19c8d13b001$require$document.documentElement;

});


parcelRegister("h9gAE", function(module, exports) {

var $gBk2k = parcelRequire("gBk2k");
var $c7c0256839ad025b$require$def = $gBk2k.f;

var $fm44J = parcelRequire("fm44J");

var $c7c0256839ad025b$var$TAG = (parcelRequire("9YxKW"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$fm44J(it = stat ? it : it.prototype, $c7c0256839ad025b$var$TAG)) $c7c0256839ad025b$require$def(it, $c7c0256839ad025b$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("9YxKW", function(module, exports) {

var $7433e6e6a0c6bdda$var$store = (parcelRequire("3x15D"))('wks');

var $9cy65 = parcelRequire("9cy65");

var $bTLKS = parcelRequire("bTLKS");
var $7433e6e6a0c6bdda$require$Symbol = $bTLKS.Symbol;
var $7433e6e6a0c6bdda$var$USE_SYMBOL = typeof $7433e6e6a0c6bdda$require$Symbol == 'function';
var $7433e6e6a0c6bdda$var$$exports = module.exports = function(name) {
    return $7433e6e6a0c6bdda$var$store[name] || ($7433e6e6a0c6bdda$var$store[name] = $7433e6e6a0c6bdda$var$USE_SYMBOL && $7433e6e6a0c6bdda$require$Symbol[name] || ($7433e6e6a0c6bdda$var$USE_SYMBOL ? $7433e6e6a0c6bdda$require$Symbol : $9cy65)('Symbol.' + name));
};
$7433e6e6a0c6bdda$var$$exports.store = $7433e6e6a0c6bdda$var$store;

});





parcelRegister("dSGoU", function(module, exports) {
parcelRequire("gYCqr");

var $bTLKS = parcelRequire("bTLKS");

var $lTOYY = parcelRequire("lTOYY");

var $2YvtX = parcelRequire("2YvtX");

var $a1b1356b82dd8b53$var$TO_STRING_TAG = (parcelRequire("9YxKW"))('toStringTag');
var $a1b1356b82dd8b53$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $a1b1356b82dd8b53$var$i = 0; $a1b1356b82dd8b53$var$i < $a1b1356b82dd8b53$var$DOMIterables.length; $a1b1356b82dd8b53$var$i++){
    var $a1b1356b82dd8b53$var$NAME = $a1b1356b82dd8b53$var$DOMIterables[$a1b1356b82dd8b53$var$i];
    var $a1b1356b82dd8b53$var$Collection = $bTLKS[$a1b1356b82dd8b53$var$NAME];
    var $a1b1356b82dd8b53$var$proto = $a1b1356b82dd8b53$var$Collection && $a1b1356b82dd8b53$var$Collection.prototype;
    if ($a1b1356b82dd8b53$var$proto && !$a1b1356b82dd8b53$var$proto[$a1b1356b82dd8b53$var$TO_STRING_TAG]) $lTOYY($a1b1356b82dd8b53$var$proto, $a1b1356b82dd8b53$var$TO_STRING_TAG, $a1b1356b82dd8b53$var$NAME);
    $2YvtX[$a1b1356b82dd8b53$var$NAME] = $2YvtX.Array;
}

});
parcelRegister("gYCqr", function(module, exports) {
'use strict';

var $8Suxj = parcelRequire("8Suxj");

var $9ITsg = parcelRequire("9ITsg");

var $2YvtX = parcelRequire("2YvtX");

var $lXF0F = parcelRequire("lXF0F");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("8utbd"))(Array, 'Array', function(iterated, kind) {
    this._t = $lXF0F(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $9ITsg(1);
    }
    if (kind == 'keys') return $9ITsg(0, index);
    if (kind == 'values') return $9ITsg(0, O[index]);
    return $9ITsg(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$2YvtX.Arguments = $2YvtX.Array;
$8Suxj('keys');
$8Suxj('values');
$8Suxj('entries');

});
parcelRegister("8Suxj", function(module, exports) {
module.exports = function() {};

});

parcelRegister("9ITsg", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("9cAaO", function(module, exports) {

$parcel$export(module.exports, "f", () => $6b314b58b253132c$export$2d1720544b23b823, (v) => $6b314b58b253132c$export$2d1720544b23b823 = v);
var $6b314b58b253132c$export$2d1720544b23b823;

$6b314b58b253132c$export$2d1720544b23b823 = (parcelRequire("9YxKW"));

});



parcelRegister("V3332", function(module, exports) {

module.exports = {
    "default": (parcelRequire("7quRT")),
    __esModule: true
};

});
parcelRegister("7quRT", function(module, exports) {
parcelRequire("fWOP2");
parcelRequire("h1GAN");
parcelRequire("ozKiO");
parcelRequire("jvsDy");

module.exports = (parcelRequire("ej9UZ")).Symbol;

});
parcelRegister("fWOP2", function(module, exports) {
'use strict';

var $bTLKS = parcelRequire("bTLKS");

var $fm44J = parcelRequire("fm44J");

var $3u2mT = parcelRequire("3u2mT");

var $23Rxz = parcelRequire("23Rxz");

var $7TNl9 = parcelRequire("7TNl9");

var $l4sfk = parcelRequire("l4sfk");
var $b9c3b20855935d2c$require$META = $l4sfk.KEY;

var $eYm1n = parcelRequire("eYm1n");

var $3x15D = parcelRequire("3x15D");

var $h9gAE = parcelRequire("h9gAE");

var $9cy65 = parcelRequire("9cy65");

var $9YxKW = parcelRequire("9YxKW");

var $9cAaO = parcelRequire("9cAaO");

var $6dNBL = parcelRequire("6dNBL");

var $aKYBs = parcelRequire("aKYBs");

var $aOV2h = parcelRequire("aOV2h");

var $ZeX88 = parcelRequire("ZeX88");

var $908oX = parcelRequire("908oX");

var $1QSIO = parcelRequire("1QSIO");

var $lXF0F = parcelRequire("lXF0F");

var $laQPh = parcelRequire("laQPh");

var $bcNKn = parcelRequire("bcNKn");

var $kLWwA = parcelRequire("kLWwA");

var $8HlY4 = parcelRequire("8HlY4");

var $NZ3qv = parcelRequire("NZ3qv");

var $hI7QD = parcelRequire("hI7QD");

var $gBk2k = parcelRequire("gBk2k");

var $7jJx7 = parcelRequire("7jJx7");
var $b9c3b20855935d2c$var$gOPD = $NZ3qv.f;
var $b9c3b20855935d2c$var$dP = $gBk2k.f;
var $b9c3b20855935d2c$var$gOPN = $8HlY4.f;
var $b9c3b20855935d2c$var$$Symbol = $bTLKS.Symbol;
var $b9c3b20855935d2c$var$$JSON = $bTLKS.JSON;
var $b9c3b20855935d2c$var$_stringify = $b9c3b20855935d2c$var$$JSON && $b9c3b20855935d2c$var$$JSON.stringify;
var $b9c3b20855935d2c$var$PROTOTYPE = 'prototype';
var $b9c3b20855935d2c$var$HIDDEN = $9YxKW('_hidden');
var $b9c3b20855935d2c$var$TO_PRIMITIVE = $9YxKW('toPrimitive');
var $b9c3b20855935d2c$var$isEnum = {}.propertyIsEnumerable;
var $b9c3b20855935d2c$var$SymbolRegistry = $3x15D('symbol-registry');
var $b9c3b20855935d2c$var$AllSymbols = $3x15D('symbols');
var $b9c3b20855935d2c$var$OPSymbols = $3x15D('op-symbols');
var $b9c3b20855935d2c$var$ObjectProto = Object[$b9c3b20855935d2c$var$PROTOTYPE];
var $b9c3b20855935d2c$var$USE_NATIVE = typeof $b9c3b20855935d2c$var$$Symbol == 'function' && !!$hI7QD.f;
var $b9c3b20855935d2c$var$QObject = $bTLKS.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $b9c3b20855935d2c$var$setter = !$b9c3b20855935d2c$var$QObject || !$b9c3b20855935d2c$var$QObject[$b9c3b20855935d2c$var$PROTOTYPE] || !$b9c3b20855935d2c$var$QObject[$b9c3b20855935d2c$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $b9c3b20855935d2c$var$setSymbolDesc = $3u2mT && $eYm1n(function() {
    return $kLWwA($b9c3b20855935d2c$var$dP({}, 'a', {
        get: function() {
            return $b9c3b20855935d2c$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $b9c3b20855935d2c$var$gOPD($b9c3b20855935d2c$var$ObjectProto, key);
    if (protoDesc) delete $b9c3b20855935d2c$var$ObjectProto[key];
    $b9c3b20855935d2c$var$dP(it, key, D);
    if (protoDesc && it !== $b9c3b20855935d2c$var$ObjectProto) $b9c3b20855935d2c$var$dP($b9c3b20855935d2c$var$ObjectProto, key, protoDesc);
} : $b9c3b20855935d2c$var$dP;
var $b9c3b20855935d2c$var$wrap = function(tag) {
    var sym = $b9c3b20855935d2c$var$AllSymbols[tag] = $kLWwA($b9c3b20855935d2c$var$$Symbol[$b9c3b20855935d2c$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $b9c3b20855935d2c$var$isSymbol = $b9c3b20855935d2c$var$USE_NATIVE && typeof $b9c3b20855935d2c$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $b9c3b20855935d2c$var$$Symbol;
};
var $b9c3b20855935d2c$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $b9c3b20855935d2c$var$ObjectProto) $b9c3b20855935d2c$var$$defineProperty($b9c3b20855935d2c$var$OPSymbols, key, D);
    $ZeX88(it);
    key = $laQPh(key, true);
    $ZeX88(D);
    if ($fm44J($b9c3b20855935d2c$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$fm44J(it, $b9c3b20855935d2c$var$HIDDEN)) $b9c3b20855935d2c$var$dP(it, $b9c3b20855935d2c$var$HIDDEN, $bcNKn(1, {}));
            it[$b9c3b20855935d2c$var$HIDDEN][key] = true;
        } else {
            if ($fm44J(it, $b9c3b20855935d2c$var$HIDDEN) && it[$b9c3b20855935d2c$var$HIDDEN][key]) it[$b9c3b20855935d2c$var$HIDDEN][key] = false;
            D = $kLWwA(D, {
                enumerable: $bcNKn(0, false)
            });
        }
        return $b9c3b20855935d2c$var$setSymbolDesc(it, key, D);
    }
    return $b9c3b20855935d2c$var$dP(it, key, D);
};
var $b9c3b20855935d2c$var$$defineProperties = function defineProperties(it, P) {
    $ZeX88(it);
    var keys = $aKYBs(P = $lXF0F(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$b9c3b20855935d2c$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $b9c3b20855935d2c$var$$create = function create(it, P) {
    return P === undefined ? $kLWwA(it) : $b9c3b20855935d2c$var$$defineProperties($kLWwA(it), P);
};
var $b9c3b20855935d2c$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $b9c3b20855935d2c$var$isEnum.call(this, key = $laQPh(key, true));
    if (this === $b9c3b20855935d2c$var$ObjectProto && $fm44J($b9c3b20855935d2c$var$AllSymbols, key) && !$fm44J($b9c3b20855935d2c$var$OPSymbols, key)) return false;
    return E || !$fm44J(this, key) || !$fm44J($b9c3b20855935d2c$var$AllSymbols, key) || $fm44J(this, $b9c3b20855935d2c$var$HIDDEN) && this[$b9c3b20855935d2c$var$HIDDEN][key] ? E : true;
};
var $b9c3b20855935d2c$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $lXF0F(it);
    key = $laQPh(key, true);
    if (it === $b9c3b20855935d2c$var$ObjectProto && $fm44J($b9c3b20855935d2c$var$AllSymbols, key) && !$fm44J($b9c3b20855935d2c$var$OPSymbols, key)) return;
    var D = $b9c3b20855935d2c$var$gOPD(it, key);
    if (D && $fm44J($b9c3b20855935d2c$var$AllSymbols, key) && !($fm44J(it, $b9c3b20855935d2c$var$HIDDEN) && it[$b9c3b20855935d2c$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $b9c3b20855935d2c$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $b9c3b20855935d2c$var$gOPN($lXF0F(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$fm44J($b9c3b20855935d2c$var$AllSymbols, key = names[i++]) && key != $b9c3b20855935d2c$var$HIDDEN && key != $b9c3b20855935d2c$require$META) result.push(key);
    return result;
};
var $b9c3b20855935d2c$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $b9c3b20855935d2c$var$ObjectProto;
    var names = $b9c3b20855935d2c$var$gOPN(IS_OP ? $b9c3b20855935d2c$var$OPSymbols : $lXF0F(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($fm44J($b9c3b20855935d2c$var$AllSymbols, key = names[i++]) && (IS_OP ? $fm44J($b9c3b20855935d2c$var$ObjectProto, key) : true)) result.push($b9c3b20855935d2c$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$b9c3b20855935d2c$var$USE_NATIVE) {
    $b9c3b20855935d2c$var$$Symbol = function Symbol() {
        if (this instanceof $b9c3b20855935d2c$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $9cy65(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $b9c3b20855935d2c$var$ObjectProto) $set.call($b9c3b20855935d2c$var$OPSymbols, value);
            if ($fm44J(this, $b9c3b20855935d2c$var$HIDDEN) && $fm44J(this[$b9c3b20855935d2c$var$HIDDEN], tag)) this[$b9c3b20855935d2c$var$HIDDEN][tag] = false;
            $b9c3b20855935d2c$var$setSymbolDesc(this, tag, $bcNKn(1, value));
        };
        if ($3u2mT && $b9c3b20855935d2c$var$setter) $b9c3b20855935d2c$var$setSymbolDesc($b9c3b20855935d2c$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $b9c3b20855935d2c$var$wrap(tag);
    };
    $7TNl9($b9c3b20855935d2c$var$$Symbol[$b9c3b20855935d2c$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $NZ3qv.f = $b9c3b20855935d2c$var$$getOwnPropertyDescriptor;
    $gBk2k.f = $b9c3b20855935d2c$var$$defineProperty;
    (parcelRequire("inM2a")).f = $8HlY4.f = $b9c3b20855935d2c$var$$getOwnPropertyNames;
    (parcelRequire("P5l67")).f = $b9c3b20855935d2c$var$$propertyIsEnumerable;
    $hI7QD.f = $b9c3b20855935d2c$var$$getOwnPropertySymbols;
    if ($3u2mT && !(parcelRequire("f62P5"))) $7TNl9($b9c3b20855935d2c$var$ObjectProto, 'propertyIsEnumerable', $b9c3b20855935d2c$var$$propertyIsEnumerable, true);
    $9cAaO.f = function(name) {
        return $b9c3b20855935d2c$var$wrap($9YxKW(name));
    };
}
$23Rxz($23Rxz.G + $23Rxz.W + $23Rxz.F * !$b9c3b20855935d2c$var$USE_NATIVE, {
    Symbol: $b9c3b20855935d2c$var$$Symbol
});
for(var $b9c3b20855935d2c$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $b9c3b20855935d2c$var$j = 0; $b9c3b20855935d2c$var$es6Symbols.length > $b9c3b20855935d2c$var$j;)$9YxKW($b9c3b20855935d2c$var$es6Symbols[$b9c3b20855935d2c$var$j++]);
for(var $b9c3b20855935d2c$var$wellKnownSymbols = $7jJx7($9YxKW.store), $b9c3b20855935d2c$var$k = 0; $b9c3b20855935d2c$var$wellKnownSymbols.length > $b9c3b20855935d2c$var$k;)$6dNBL($b9c3b20855935d2c$var$wellKnownSymbols[$b9c3b20855935d2c$var$k++]);
$23Rxz($23Rxz.S + $23Rxz.F * !$b9c3b20855935d2c$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $fm44J($b9c3b20855935d2c$var$SymbolRegistry, key += '') ? $b9c3b20855935d2c$var$SymbolRegistry[key] : $b9c3b20855935d2c$var$SymbolRegistry[key] = $b9c3b20855935d2c$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$b9c3b20855935d2c$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $b9c3b20855935d2c$var$SymbolRegistry)if ($b9c3b20855935d2c$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $b9c3b20855935d2c$var$setter = true;
    },
    useSimple: function() {
        $b9c3b20855935d2c$var$setter = false;
    }
});
$23Rxz($23Rxz.S + $23Rxz.F * !$b9c3b20855935d2c$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $b9c3b20855935d2c$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $b9c3b20855935d2c$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $b9c3b20855935d2c$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $b9c3b20855935d2c$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $b9c3b20855935d2c$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $b9c3b20855935d2c$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $b9c3b20855935d2c$var$FAILS_ON_PRIMITIVES = $eYm1n(function() {
    $hI7QD.f(1);
});
$23Rxz($23Rxz.S + $23Rxz.F * $b9c3b20855935d2c$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $hI7QD.f($1QSIO(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$b9c3b20855935d2c$var$$JSON && $23Rxz($23Rxz.S + $23Rxz.F * (!$b9c3b20855935d2c$var$USE_NATIVE || $eYm1n(function() {
    var S = $b9c3b20855935d2c$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $b9c3b20855935d2c$var$_stringify([
        S
    ]) != '[null]' || $b9c3b20855935d2c$var$_stringify({
        a: S
    }) != '{}' || $b9c3b20855935d2c$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$908oX(replacer) && it === undefined || $b9c3b20855935d2c$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$aOV2h(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$b9c3b20855935d2c$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $b9c3b20855935d2c$var$_stringify.apply($b9c3b20855935d2c$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$b9c3b20855935d2c$var$$Symbol[$b9c3b20855935d2c$var$PROTOTYPE][$b9c3b20855935d2c$var$TO_PRIMITIVE] || (parcelRequire("lTOYY"))($b9c3b20855935d2c$var$$Symbol[$b9c3b20855935d2c$var$PROTOTYPE], $b9c3b20855935d2c$var$TO_PRIMITIVE, $b9c3b20855935d2c$var$$Symbol[$b9c3b20855935d2c$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$h9gAE($b9c3b20855935d2c$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$h9gAE(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$h9gAE($bTLKS.JSON, 'JSON', true);

});
parcelRegister("l4sfk", function(module, exports) {

var $f56fe1ceb7a2a976$var$META = (parcelRequire("9cy65"))('meta');

var $908oX = parcelRequire("908oX");

var $fm44J = parcelRequire("fm44J");

var $gBk2k = parcelRequire("gBk2k");
var $f56fe1ceb7a2a976$require$setDesc = $gBk2k.f;
var $f56fe1ceb7a2a976$var$id = 0;
var $f56fe1ceb7a2a976$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $f56fe1ceb7a2a976$var$FREEZE = !(parcelRequire("eYm1n"))(function() {
    return $f56fe1ceb7a2a976$var$isExtensible(Object.preventExtensions({}));
});
var $f56fe1ceb7a2a976$var$setMeta = function(it) {
    $f56fe1ceb7a2a976$require$setDesc(it, $f56fe1ceb7a2a976$var$META, {
        value: {
            i: 'O' + ++$f56fe1ceb7a2a976$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $f56fe1ceb7a2a976$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$908oX(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$fm44J(it, $f56fe1ceb7a2a976$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$f56fe1ceb7a2a976$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $f56fe1ceb7a2a976$var$setMeta(it);
    // return object ID
    }
    return it[$f56fe1ceb7a2a976$var$META].i;
};
var $f56fe1ceb7a2a976$var$getWeak = function(it, create) {
    if (!$fm44J(it, $f56fe1ceb7a2a976$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$f56fe1ceb7a2a976$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $f56fe1ceb7a2a976$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$f56fe1ceb7a2a976$var$META].w;
};
// add metadata on freeze-family methods calling
var $f56fe1ceb7a2a976$var$onFreeze = function(it) {
    if ($f56fe1ceb7a2a976$var$FREEZE && $f56fe1ceb7a2a976$var$meta.NEED && $f56fe1ceb7a2a976$var$isExtensible(it) && !$fm44J(it, $f56fe1ceb7a2a976$var$META)) $f56fe1ceb7a2a976$var$setMeta(it);
    return it;
};
var $f56fe1ceb7a2a976$var$meta = module.exports = {
    KEY: $f56fe1ceb7a2a976$var$META,
    NEED: false,
    fastKey: $f56fe1ceb7a2a976$var$fastKey,
    getWeak: $f56fe1ceb7a2a976$var$getWeak,
    onFreeze: $f56fe1ceb7a2a976$var$onFreeze
};

});

parcelRegister("6dNBL", function(module, exports) {

var $bTLKS = parcelRequire("bTLKS");

var $ej9UZ = parcelRequire("ej9UZ");

var $f62P5 = parcelRequire("f62P5");

var $9cAaO = parcelRequire("9cAaO");

var $gBk2k = parcelRequire("gBk2k");
var $487a70228d1fbd01$require$defineProperty = $gBk2k.f;
module.exports = function(name) {
    var $Symbol = $ej9UZ.Symbol || ($ej9UZ.Symbol = $f62P5 ? {} : $bTLKS.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $487a70228d1fbd01$require$defineProperty($Symbol, name, {
        value: $9cAaO.f(name)
    });
};

});

parcelRegister("aKYBs", function(module, exports) {
// all enumerable object keys, includes symbols

var $7jJx7 = parcelRequire("7jJx7");

var $hI7QD = parcelRequire("hI7QD");

var $P5l67 = parcelRequire("P5l67");
module.exports = function(it) {
    var result = $7jJx7(it);
    var getSymbols = $hI7QD.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $P5l67.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("hI7QD", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce4ca22b4d4e4df2$export$2d1720544b23b823, (v) => $ce4ca22b4d4e4df2$export$2d1720544b23b823 = v);
var $ce4ca22b4d4e4df2$export$2d1720544b23b823;
$ce4ca22b4d4e4df2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("P5l67", function(module, exports) {

$parcel$export(module.exports, "f", () => $0998e7ce3baa7781$export$2d1720544b23b823, (v) => $0998e7ce3baa7781$export$2d1720544b23b823 = v);
var $0998e7ce3baa7781$export$2d1720544b23b823;
$0998e7ce3baa7781$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("aOV2h", function(module, exports) {
// 7.2.2 IsArray(argument)

var $aScHa = parcelRequire("aScHa");
module.exports = Array.isArray || function isArray(arg) {
    return $aScHa(arg) == 'Array';
};

});

parcelRegister("8HlY4", function(module, exports) {

$parcel$export(module.exports, "f", () => $65536141e9ffebba$export$2d1720544b23b823, (v) => $65536141e9ffebba$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $65536141e9ffebba$export$2d1720544b23b823;

var $lXF0F = parcelRequire("lXF0F");

var $inM2a = parcelRequire("inM2a");
var $65536141e9ffebba$require$gOPN = $inM2a.f;
var $65536141e9ffebba$var$toString = {}.toString;
var $65536141e9ffebba$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $65536141e9ffebba$var$getWindowNames = function(it) {
    try {
        return $65536141e9ffebba$require$gOPN(it);
    } catch (e) {
        return $65536141e9ffebba$var$windowNames.slice();
    }
};
$65536141e9ffebba$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $65536141e9ffebba$var$windowNames && $65536141e9ffebba$var$toString.call(it) == '[object Window]' ? $65536141e9ffebba$var$getWindowNames(it) : $65536141e9ffebba$require$gOPN($lXF0F(it));
};

});
parcelRegister("inM2a", function(module, exports) {

$parcel$export(module.exports, "f", () => $d61fa2898030f87b$export$2d1720544b23b823, (v) => $d61fa2898030f87b$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $d61fa2898030f87b$export$2d1720544b23b823;

var $gm1LE = parcelRequire("gm1LE");

var $d61fa2898030f87b$var$hiddenKeys = (parcelRequire("grdgS")).concat('length', 'prototype');
$d61fa2898030f87b$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $gm1LE(O, $d61fa2898030f87b$var$hiddenKeys);
};

});


parcelRegister("NZ3qv", function(module, exports) {

$parcel$export(module.exports, "f", () => $0963efd2e0bd8ddd$export$2d1720544b23b823, (v) => $0963efd2e0bd8ddd$export$2d1720544b23b823 = v);
var $0963efd2e0bd8ddd$export$2d1720544b23b823;

var $P5l67 = parcelRequire("P5l67");

var $bcNKn = parcelRequire("bcNKn");

var $lXF0F = parcelRequire("lXF0F");

var $laQPh = parcelRequire("laQPh");

var $fm44J = parcelRequire("fm44J");

var $bS797 = parcelRequire("bS797");
var $0963efd2e0bd8ddd$var$gOPD = Object.getOwnPropertyDescriptor;

$0963efd2e0bd8ddd$export$2d1720544b23b823 = (parcelRequire("3u2mT")) ? $0963efd2e0bd8ddd$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $lXF0F(O);
    P = $laQPh(P, true);
    if ($bS797) try {
        return $0963efd2e0bd8ddd$var$gOPD(O, P);
    } catch (e) {}
    if ($fm44J(O, P)) return $bcNKn(!$P5l67.f.call(O, P), O[P]);
};

});


parcelRegister("h1GAN", function(module, exports) {

});

parcelRegister("ozKiO", function(module, exports) {

(parcelRequire("6dNBL"))('asyncIterator');

});

parcelRegister("jvsDy", function(module, exports) {

(parcelRequire("6dNBL"))('observable');

});





parcelRegister("gHLl6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c295621de530ae6b$export$1e511d4a378977f5, (v) => $c295621de530ae6b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c295621de530ae6b$export$2e2bcd8739ae039, (v) => $c295621de530ae6b$export$2e2bcd8739ae039 = v);
var $c295621de530ae6b$export$1e511d4a378977f5;
var $c295621de530ae6b$export$2e2bcd8739ae039;
"use strict";
$c295621de530ae6b$export$1e511d4a378977f5 = true;

var $2gkZm = parcelRequire("2gkZm");
var $c295621de530ae6b$var$_setPrototypeOf2 = $c295621de530ae6b$var$_interopRequireDefault($2gkZm);

var $gqjuI = parcelRequire("gqjuI");
var $c295621de530ae6b$var$_create2 = $c295621de530ae6b$var$_interopRequireDefault($gqjuI);

var $kt6ai = parcelRequire("kt6ai");
var $c295621de530ae6b$var$_typeof3 = $c295621de530ae6b$var$_interopRequireDefault($kt6ai);
function $c295621de530ae6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c295621de530ae6b$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c295621de530ae6b$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $c295621de530ae6b$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c295621de530ae6b$var$_setPrototypeOf2.default ? (0, $c295621de530ae6b$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("2gkZm", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gH7Ce")),
    __esModule: true
};

});
parcelRegister("gH7Ce", function(module, exports) {
parcelRequire("8fIWi");

module.exports = (parcelRequire("ej9UZ")).Object.setPrototypeOf;

});
parcelRegister("8fIWi", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $23Rxz = parcelRequire("23Rxz");

$23Rxz($23Rxz.S, 'Object', {
    setPrototypeOf: (parcelRequire("5gppo")).set
});

});
parcelRegister("5gppo", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $908oX = parcelRequire("908oX");

var $ZeX88 = parcelRequire("ZeX88");
var $3d5227f7b600717a$var$check = function(O, proto) {
    $ZeX88(O);
    if (!$908oX(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("eMwHM"))(Function.call, (parcelRequire("NZ3qv")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $3d5227f7b600717a$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $3d5227f7b600717a$var$check
};

});




parcelRegister("gqjuI", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cRpJx")),
    __esModule: true
};

});
parcelRegister("cRpJx", function(module, exports) {
parcelRequire("ftkae");

var $ej9UZ = parcelRequire("ej9UZ");
var $95ce656eb4b39741$require$$Object = $ej9UZ.Object;
module.exports = function create(P, D) {
    return $95ce656eb4b39741$require$$Object.create(P, D);
};

});
parcelRegister("ftkae", function(module, exports) {

var $23Rxz = parcelRequire("23Rxz");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$23Rxz($23Rxz.S, 'Object', {
    create: (parcelRequire("kLWwA"))
});

});




parcelRegister("bN49P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_CellMeasureCache = undefined;

var $8rCP3 = parcelRequire("8rCP3");
var $89577ee8c01f218b$var$_propTypes2 = $89577ee8c01f218b$var$_interopRequireDefault($8rCP3);
function $89577ee8c01f218b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache = null;
module.exports.bpfrpt_proptype_CellMeasureCache = $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache;

});


parcelRegister("ewGy7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = undefined;

var $aXTp8 = parcelRequire("aXTp8");
var $a9350f4628fe309c$var$_classCallCheck3 = $a9350f4628fe309c$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $a9350f4628fe309c$var$_createClass3 = $a9350f4628fe309c$var$_interopRequireDefault($4tLNB);
parcelRequire("bN49P");
function $a9350f4628fe309c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a9350f4628fe309c$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $a9350f4628fe309c$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/**
 * Caches measurements for a given cell.
 */ var $a9350f4628fe309c$var$CellMeasurerCache = function() {
    function CellMeasurerCache() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $a9350f4628fe309c$var$_classCallCheck3.default)(this, CellMeasurerCache);
        this._cellHeightCache = {};
        this._cellWidthCache = {};
        this._columnWidthCache = {};
        this._rowHeightCache = {};
        this._columnCount = 0;
        this._rowCount = 0;
        this.columnWidth = function(_ref) {
            var index = _ref.index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
        };
        this.rowHeight = function(_ref2) {
            var index = _ref2.index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
        };
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $a9350f4628fe309c$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $a9350f4628fe309c$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $a9350f4628fe309c$var$DEFAULT_WIDTH);
    }
    (0, $a9350f4628fe309c$var$_createClass3.default)(CellMeasurerCache, [
        {
            key: 'clear',
            value: function clear(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: 'clearAll',
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: 'hasFixedHeight',
            value: function hasFixedHeight() {
                return this._hasFixedHeight;
            }
        },
        {
            key: 'hasFixedWidth',
            value: function hasFixedWidth() {
                return this._hasFixedWidth;
            }
        },
        {
            key: 'getHeight',
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: 'getWidth',
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: 'has',
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache.hasOwnProperty(key);
            }
        },
        {
            key: 'set',
            value: function set(rowIndex, columnIndex, width, height) {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: '_updateCachedColumnAndRowSizes',
            value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        },
        {
            key: 'defaultHeight',
            get: function get() {
                return this._defaultHeight;
            }
        },
        {
            key: 'defaultWidth',
            get: function get() {
                return this._defaultWidth;
            }
        }
    ]);
    return CellMeasurerCache;
}();
module.exports.default = $a9350f4628fe309c$var$CellMeasurerCache;
function $a9350f4628fe309c$var$defaultKeyMapper(rowIndex, columnIndex) {
    return rowIndex + '-' + columnIndex;
}

});


parcelRegister("aLlKO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;

var $eAgCH = parcelRequire("eAgCH");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
    }
});
Object.defineProperty(module.exports, 'List', {
    enumerable: true,
    get: function get() {
        return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
    }
});

var $2AKv3 = parcelRequire("2AKv3");
function $7d5f2b12ba6a0316$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_RowRendererParams = $2AKv3.bpfrpt_proptype_RowRendererParams;

});
parcelRegister("eAgCH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $knQh8 = parcelRequire("knQh8");
var $a9e1528011c3c32e$var$_extends3 = $a9e1528011c3c32e$var$_interopRequireDefault($knQh8);

var $kSGvk = parcelRequire("kSGvk");
var $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2 = $a9e1528011c3c32e$var$_interopRequireDefault($kSGvk);

var $29Ol4 = parcelRequire("29Ol4");
var $a9e1528011c3c32e$var$_getPrototypeOf2 = $a9e1528011c3c32e$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $a9e1528011c3c32e$var$_classCallCheck3 = $a9e1528011c3c32e$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $a9e1528011c3c32e$var$_createClass3 = $a9e1528011c3c32e$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $a9e1528011c3c32e$var$_possibleConstructorReturn3 = $a9e1528011c3c32e$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $a9e1528011c3c32e$var$_inherits3 = $a9e1528011c3c32e$var$_interopRequireDefault($gHLl6);

var $648t0 = parcelRequire("648t0");
var $a9e1528011c3c32e$var$_Grid2 = $a9e1528011c3c32e$var$_interopRequireDefault($648t0);

var $5uXOq = parcelRequire("5uXOq");
var $a9e1528011c3c32e$var$React = $a9e1528011c3c32e$var$_interopRequireWildcard($5uXOq);

var $hazy9 = parcelRequire("hazy9");
var $a9e1528011c3c32e$var$_clsx2 = $a9e1528011c3c32e$var$_interopRequireDefault($hazy9);
parcelRequire("2AKv3");

var $8rCP3 = parcelRequire("8rCP3");
var $a9e1528011c3c32e$var$_propTypes2 = $a9e1528011c3c32e$var$_interopRequireDefault($8rCP3);
function $a9e1528011c3c32e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a9e1528011c3c32e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $a9e1528011c3c32e$var$List = function(_React$PureComponent) {
    (0, $a9e1528011c3c32e$var$_inherits3.default)(List, _React$PureComponent);
    function List() {
        var _ref;
        var _temp, _this, _ret;
        (0, $a9e1528011c3c32e$var$_classCallCheck3.default)(this, List);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $a9e1528011c3c32e$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
            var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var _Object$getOwnPropert = (0, $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
            if (writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        }, _this._setRef = function(ref) {
            _this.Grid = ref;
        }, _this._onScroll = function(_ref3) {
            var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, _this._onSectionRendered = function(_ref4) {
            var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        }, _temp), (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $a9e1528011c3c32e$var$_createClass3.default)(List, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref5) {
                var alignment = _ref5.alignment, index = _ref5.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return _scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref6) {
                var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                var classNames = (0, $a9e1528011c3c32e$var$_clsx2.default)('ReactVirtualized__List', className);
                return $a9e1528011c3c32e$var$React.createElement($a9e1528011c3c32e$var$_Grid2.default, (0, $a9e1528011c3c32e$var$_extends3.default)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($a9e1528011c3c32e$var$React.PureComponent);
$a9e1528011c3c32e$var$List.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $648t0.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
$a9e1528011c3c32e$var$List.propTypes = null;
module.exports.default = $a9e1528011c3c32e$var$List;

});
parcelRegister("knQh8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ed6e817027dc4fd8$export$1e511d4a378977f5, (v) => $ed6e817027dc4fd8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ed6e817027dc4fd8$export$2e2bcd8739ae039, (v) => $ed6e817027dc4fd8$export$2e2bcd8739ae039 = v);
var $ed6e817027dc4fd8$export$1e511d4a378977f5;
var $ed6e817027dc4fd8$export$2e2bcd8739ae039;
"use strict";
$ed6e817027dc4fd8$export$1e511d4a378977f5 = true;

var $cjLx9 = parcelRequire("cjLx9");
var $ed6e817027dc4fd8$var$_assign2 = $ed6e817027dc4fd8$var$_interopRequireDefault($cjLx9);
function $ed6e817027dc4fd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ed6e817027dc4fd8$export$2e2bcd8739ae039 = $ed6e817027dc4fd8$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("cjLx9", function(module, exports) {

module.exports = {
    "default": (parcelRequire("aumBU")),
    __esModule: true
};

});
parcelRegister("aumBU", function(module, exports) {
parcelRequire("lzpM6");

module.exports = (parcelRequire("ej9UZ")).Object.assign;

});
parcelRegister("lzpM6", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $23Rxz = parcelRequire("23Rxz");

$23Rxz($23Rxz.S + $23Rxz.F, 'Object', {
    assign: (parcelRequire("189sz"))
});

});
parcelRegister("189sz", function(module, exports) {
'use strict';

var $3u2mT = parcelRequire("3u2mT");

var $7jJx7 = parcelRequire("7jJx7");

var $hI7QD = parcelRequire("hI7QD");

var $P5l67 = parcelRequire("P5l67");

var $1QSIO = parcelRequire("1QSIO");

var $qozEq = parcelRequire("qozEq");
var $0d2de056b709be74$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$0d2de056b709be74$var$$assign || (parcelRequire("eYm1n"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $0d2de056b709be74$var$$assign({}, A)[S] != 7 || Object.keys($0d2de056b709be74$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1QSIO(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $hI7QD.f;
    var isEnum = $P5l67.f;
    while(aLen > index){
        var S = $qozEq(arguments[index++]);
        var keys = getSymbols ? $7jJx7(S).concat(getSymbols(S)) : $7jJx7(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$3u2mT || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $0d2de056b709be74$var$$assign;

});





parcelRegister("kSGvk", function(module, exports) {

module.exports = {
    "default": (parcelRequire("fdpDU")),
    __esModule: true
};

});
parcelRegister("fdpDU", function(module, exports) {
parcelRequire("clOa1");

var $ej9UZ = parcelRequire("ej9UZ");
var $b13bf6048d864af3$require$$Object = $ej9UZ.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $b13bf6048d864af3$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("clOa1", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $lXF0F = parcelRequire("lXF0F");

var $NZ3qv = parcelRequire("NZ3qv");
var $8fde5b096fb17d08$require$$getOwnPropertyDescriptor = $NZ3qv.f;

(parcelRequire("4JSIZ"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $8fde5b096fb17d08$require$$getOwnPropertyDescriptor($lXF0F(it), key);
    };
});

});



parcelRegister("648t0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;

var $fqRL4 = parcelRequire("fqRL4");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
    }
});
Object.defineProperty(module.exports, 'Grid', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
    }
});

var $eAUMQ = parcelRequire("eAUMQ");
Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($eAUMQ).default;
    }
});

var $4n59m = parcelRequire("4n59m");
Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($4n59m).default;
    }
});

var $3yG4I = parcelRequire("3yG4I");
Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $46a9af1c8a4ac81a$var$_interopRequireDefault($3yG4I).default;
    }
});

var $7G6q0 = parcelRequire("7G6q0");
function $46a9af1c8a4ac81a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_NoContentRenderer = $7G6q0.bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Alignment = $7G6q0.bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_CellPosition = $7G6q0.bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellSize = $7G6q0.bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $7G6q0.bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_RenderedSection = $7G6q0.bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_CellRendererParams = $7G6q0.bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_Scroll = $7G6q0.bpfrpt_proptype_Scroll;

});
parcelRegister("fqRL4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var $cjLx9 = parcelRequire("cjLx9");
var $b3c2fbf6a4e71818$var$_assign2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($cjLx9);

var $knQh8 = parcelRequire("knQh8");
var $b3c2fbf6a4e71818$var$_extends3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($knQh8);

var $29Ol4 = parcelRequire("29Ol4");
var $b3c2fbf6a4e71818$var$_getPrototypeOf2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($29Ol4);

var $aXTp8 = parcelRequire("aXTp8");
var $b3c2fbf6a4e71818$var$_classCallCheck3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $b3c2fbf6a4e71818$var$_createClass3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4tLNB);

var $5pMaQ = parcelRequire("5pMaQ");
var $b3c2fbf6a4e71818$var$_possibleConstructorReturn3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5pMaQ);

var $gHLl6 = parcelRequire("gHLl6");
var $b3c2fbf6a4e71818$var$_inherits3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($gHLl6);

var $5uXOq = parcelRequire("5uXOq");
var $b3c2fbf6a4e71818$var$React = $b3c2fbf6a4e71818$var$_interopRequireWildcard($5uXOq);

var $hazy9 = parcelRequire("hazy9");
var $b3c2fbf6a4e71818$var$_clsx2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($hazy9);

var $5YXtN = parcelRequire("5YXtN");
var $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5YXtN);

var $7LPqF = parcelRequire("7LPqF");
var $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($7LPqF);

var $18tv5 = parcelRequire("18tv5");
var $b3c2fbf6a4e71818$var$_createCallbackMemoizer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($18tv5);

var $3yG4I = parcelRequire("3yG4I");
var $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($3yG4I);

var $dMJpU = parcelRequire("dMJpU");
var $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dMJpU);

var $4n59m = parcelRequire("4n59m");
var $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4n59m);

var $dzPmK = parcelRequire("dzPmK");
var $b3c2fbf6a4e71818$var$_scrollbarSize2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dzPmK);

var $9mAr6 = parcelRequire("9mAr6");

var $cpGQi = parcelRequire("cpGQi");
parcelRequire("7G6q0");

var $8rCP3 = parcelRequire("8rCP3");
var $b3c2fbf6a4e71818$var$_propTypes2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($8rCP3);
function $b3c2fbf6a4e71818$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b3c2fbf6a4e71818$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $b3c2fbf6a4e71818$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $b3c2fbf6a4e71818$var$Grid = function(_React$PureComponent) {
    (0, $b3c2fbf6a4e71818$var$_inherits3.default)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        (0, $b3c2fbf6a4e71818$var$_classCallCheck3.default)(this, Grid);
        var _this = (0, $b3c2fbf6a4e71818$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $b3c2fbf6a4e71818$var$_getPrototypeOf2.default)(Grid)).call(this, props));
        _this._onGridRenderedMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)();
        _this._onScrollMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)(false);
        _this._deferredInvalidateColumnIndex = null;
        _this._deferredInvalidateRowIndex = null;
        _this._recomputeScrollLeftFlag = false;
        _this._recomputeScrollTopFlag = false;
        _this._horizontalScrollBarSize = 0;
        _this._verticalScrollBarSize = 0;
        _this._scrollbarPresenceChanged = false;
        _this._renderedColumnStartIndex = 0;
        _this._renderedColumnStopIndex = 0;
        _this._renderedRowStartIndex = 0;
        _this._renderedRowStopIndex = 0;
        _this._styleCache = {};
        _this._cellCache = {};
        _this._debounceScrollEndedCallback = function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        };
        _this._invokeOnGridRenderedHelper = function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        };
        _this._setScrollingContainerRef = function(ref) {
            _this._scrollingContainer = ref;
        };
        _this._onScroll = function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        };
        var columnSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $3yG4I.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $3yG4I.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $b3c2fbf6a4e71818$var$_createClass3.default)(Grid, [
        {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: _scrollDirectionHorizontal,
                        scrollDirectionVertical: _scrollDirectionVertical,
                        scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: 'measureAllCells',
            value: function measureAllCells() {
                var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $3yG4I.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $3yG4I.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $b3c2fbf6a4e71818$var$React.createElement('div', (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: (0, $b3c2fbf6a4e71818$var$_clsx2.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, gridStyle, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $b3c2fbf6a4e71818$var$React.createElement('div', {
                    className: 'ReactVirtualized__Grid__innerScrollContainer',
                    role: containerRole,
                    style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $cpGQi.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: '_handleInvalidatedGridSize',
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: '_isScrolling',
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    _onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: 'scrollToPosition',
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = rowIndex + '-' + columnIndex;
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, {
                    isScrolling: false
                });
                var maybeStateA = void 0;
                var maybeStateB = void 0;
                (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
            }
        },
        {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: '_getScrollToPositionStateUpdate',
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return null;
            }
        },
        {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return null;
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return null;
            }
        }
    ]);
    return Grid;
}($b3c2fbf6a4e71818$var$React.PureComponent);
$b3c2fbf6a4e71818$var$Grid.defaultProps = {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2.default,
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $b3c2fbf6a4e71818$var$_scrollbarSize2.default,
    noContentRenderer: $b3c2fbf6a4e71818$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2.default,
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
};
$b3c2fbf6a4e71818$var$Grid.propTypes = null;
(0, $9mAr6.polyfill)($b3c2fbf6a4e71818$var$Grid);
module.exports.default = $b3c2fbf6a4e71818$var$Grid;

});
parcelRegister("hazy9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $c7fef249cf6cf466$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $c7fef249cf6cf466$export$2e2bcd8739ae039);
function $c7fef249cf6cf466$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c7fef249cf6cf466$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c7fef249cf6cf466$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c7fef249cf6cf466$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c7fef249cf6cf466$export$2e2bcd8739ae039 = $c7fef249cf6cf466$export$4f5d2d50c9deca37;

});

parcelRegister("5YXtN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
function $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
} /**
 * Helper method that determines when to recalculate row or column metadata.
 */ 

});

parcelRegister("7LPqF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1JRrJ = parcelRequire("1JRrJ");
var $5a84d0ec79150934$var$_objectWithoutProperties3 = $5a84d0ec79150934$var$_interopRequireDefault($1JRrJ);

var $aXTp8 = parcelRequire("aXTp8");
var $5a84d0ec79150934$var$_classCallCheck3 = $5a84d0ec79150934$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $5a84d0ec79150934$var$_createClass3 = $5a84d0ec79150934$var$_interopRequireDefault($4tLNB);

var $iCIeR = parcelRequire("iCIeR");
var $5a84d0ec79150934$var$_CellSizeAndPositionManager2 = $5a84d0ec79150934$var$_interopRequireDefault($iCIeR);

var $iLAay = parcelRequire("iLAay");
parcelRequire("7G6q0");
function $5a84d0ec79150934$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ var $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager = function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $iLAay.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $5a84d0ec79150934$var$_objectWithoutProperties3.default)(_ref, [
            'maxScrollSize'
        ]);
        (0, $5a84d0ec79150934$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $5a84d0ec79150934$var$_CellSizeAndPositionManager2.default(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $5a84d0ec79150934$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: 'configure',
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: '_getOffsetPercentage',
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: '_offsetToSafeOffset',
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: '_safeOffsetToOffset',
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();
module.exports.default = $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager;

});
parcelRegister("1JRrJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $144373be65000f07$export$1e511d4a378977f5, (v) => $144373be65000f07$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $144373be65000f07$export$2e2bcd8739ae039, (v) => $144373be65000f07$export$2e2bcd8739ae039 = v);
var $144373be65000f07$export$1e511d4a378977f5;
var $144373be65000f07$export$2e2bcd8739ae039;
"use strict";
$144373be65000f07$export$1e511d4a378977f5 = true;
$144373be65000f07$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("iCIeR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aXTp8 = parcelRequire("aXTp8");
var $d8ee1776fff0aaf0$var$_classCallCheck3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($aXTp8);

var $4tLNB = parcelRequire("4tLNB");
var $d8ee1776fff0aaf0$var$_createClass3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($4tLNB);
parcelRequire("7G6q0");
function $d8ee1776fff0aaf0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $d8ee1776fff0aaf0$var$CellSizeAndPositionManager = function() {
    // Used in deferred mode to track which cells have been queued for measurement.
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $d8ee1776fff0aaf0$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
        this._cellSizeAndPositionData = {};
        this._lastMeasuredIndex = -1;
        this._lastBatchedIndex = -1;
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    (0, $d8ee1776fff0aaf0$var$_createClass3.default)(CellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: 'configure',
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var _size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                        else if (_size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: _size
                            };
                            _offset += _size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset = void 0;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: '_binarySearch',
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (_currentOffset === offset) return middle;
                    else if (_currentOffset < offset) low = middle + 1;
                    else if (_currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: '_exponentialSearch',
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: '_findNearestCell',
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();
module.exports.default = $d8ee1776fff0aaf0$var$CellSizeAndPositionManager;

});
parcelRegister("7G6q0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;

var $5uXOq = parcelRequire("5uXOq");
var $59716f33b0e6b532$var$React = $59716f33b0e6b532$var$_interopRequireWildcard($5uXOq);

var $7LPqF = parcelRequire("7LPqF");
var $59716f33b0e6b532$var$_ScalingCellSizeAndPositionManager2 = $59716f33b0e6b532$var$_interopRequireDefault($7LPqF);

var $8rCP3 = parcelRequire("8rCP3");
var $59716f33b0e6b532$var$_propTypes2 = $59716f33b0e6b532$var$_interopRequireDefault($8rCP3);
function $59716f33b0e6b532$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59716f33b0e6b532$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellCache = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_CellSize = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_Scroll = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_Alignment = null;
var $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange = null;
module.exports.bpfrpt_proptype_CellPosition = $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_CellRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer;
module.exports.bpfrpt_proptype_CellCache = $59716f33b0e6b532$var$bpfrpt_proptype_CellCache;
module.exports.bpfrpt_proptype_StyleCache = $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache;
module.exports.bpfrpt_proptype_CellRangeRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams;
module.exports.bpfrpt_proptype_CellRangeRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer;
module.exports.bpfrpt_proptype_CellSizeGetter = $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter;
module.exports.bpfrpt_proptype_CellSize = $59716f33b0e6b532$var$bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_NoContentRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Scroll = $59716f33b0e6b532$var$bpfrpt_proptype_Scroll;
module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange;
module.exports.bpfrpt_proptype_RenderedSection = $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams;
module.exports.bpfrpt_proptype_OverscanIndices = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_Alignment = $59716f33b0e6b532$var$bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_VisibleCellRange = $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange;

});


parcelRegister("iLAay", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $da98ac3c245269b0$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $da98ac3c245269b0$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $da98ac3c245269b0$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
    if ($da98ac3c245269b0$var$isBrowser()) {
        if ($da98ac3c245269b0$var$isChrome()) return $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("18tv5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9lQFv = parcelRequire("9lQFv");
var $0d3d6bf35b624a82$var$_keys2 = $0d3d6bf35b624a82$var$_interopRequireDefault($9lQFv);
module.exports.default = $0d3d6bf35b624a82$var$createCallbackMemoizer;
function $0d3d6bf35b624a82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $0d3d6bf35b624a82$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = (0, $0d3d6bf35b624a82$var$_keys2.default)(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== (0, $0d3d6bf35b624a82$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});
parcelRegister("9lQFv", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bCMZi")),
    __esModule: true
};

});
parcelRegister("bCMZi", function(module, exports) {
parcelRequire("50N6x");

module.exports = (parcelRequire("ej9UZ")).Object.keys;

});
parcelRegister("50N6x", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $1QSIO = parcelRequire("1QSIO");

var $7jJx7 = parcelRequire("7jJx7");

(parcelRequire("4JSIZ"))('keys', function() {
    return function keys(it) {
        return $7jJx7($1QSIO(it));
    };
});

});




parcelRegister("3yG4I", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $29752f486201a5cb$var$defaultOverscanIndicesGetter;
parcelRequire("7G6q0");
var $29752f486201a5cb$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $29752f486201a5cb$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $29752f486201a5cb$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $29752f486201a5cb$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("dMJpU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a092fce61c6915f9$var$updateScrollIndexHelper;

var $7LPqF = parcelRequire("7LPqF");
var $a092fce61c6915f9$var$_ScalingCellSizeAndPositionManager2 = $a092fce61c6915f9$var$_interopRequireDefault($7LPqF);
parcelRequire("7G6q0");
function $a092fce61c6915f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ function $a092fce61c6915f9$var$updateScrollIndexHelper(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("4n59m", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32ed4e129ee96b29$var$defaultCellRangeRenderer;
parcelRequire("7G6q0");
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $32ed4e129ee96b29$var$defaultCellRangeRenderer(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = rowIndex + '-' + columnIndex;
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $32ed4e129ee96b29$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("dzPmK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9e266377030444a5$export$2e2bcd8739ae039);

var $5B5cv = parcelRequire("5B5cv");
var $9e266377030444a5$var$size;
function $9e266377030444a5$export$2e2bcd8739ae039(recalc) {
    if (!$9e266377030444a5$var$size && $9e266377030444a5$var$size !== 0 || recalc) {
        if (0, $5B5cv.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9e266377030444a5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9e266377030444a5$var$size;
}

});
parcelRegister("5B5cv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4134712f1bdfe873$export$2e2bcd8739ae039);
var $4134712f1bdfe873$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("9mAr6", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $6d126e96e4dcb8d7$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $6d126e96e4dcb8d7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $6d126e96e4dcb8d7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $6d126e96e4dcb8d7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$6d126e96e4dcb8d7$var$componentWillMount.__suppressDeprecationWarning = true;
$6d126e96e4dcb8d7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$6d126e96e4dcb8d7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $6d126e96e4dcb8d7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $6d126e96e4dcb8d7$var$componentWillMount;
        prototype.componentWillReceiveProps = $6d126e96e4dcb8d7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $6d126e96e4dcb8d7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("cpGQi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;

var $i67QH = parcelRequire("i67QH");
var $90990d7bb4c83bf1$var$_promise2 = $90990d7bb4c83bf1$var$_interopRequireDefault($i67QH);

var $b81LX = parcelRequire("b81LX");

var $8rCP3 = parcelRequire("8rCP3");
var $90990d7bb4c83bf1$var$_propTypes2 = $90990d7bb4c83bf1$var$_interopRequireDefault($8rCP3);
function $90990d7bb4c83bf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId = null;
var $90990d7bb4c83bf1$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
    return (0, $b81LX.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $90990d7bb4c83bf1$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
    var start = void 0;
    // wait for end of processing current event handler, because event handler may be long
    $90990d7bb4c83bf1$var$_promise2.default.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $b81LX.raf)(timeout);
    };
    var frame = {
        id: (0, $b81LX.raf)(timeout)
    };
    return frame;
};
module.exports.bpfrpt_proptype_AnimationTimeoutId = $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId;

});
parcelRegister("i67QH", function(module, exports) {

module.exports = {
    "default": (parcelRequire("6MMh6")),
    __esModule: true
};

});
parcelRegister("6MMh6", function(module, exports) {
parcelRequire("h1GAN");
parcelRequire("6kbwg");
parcelRequire("dSGoU");
parcelRequire("7WKTk");
parcelRequire("jlPCh");
parcelRequire("4mnuX");

module.exports = (parcelRequire("ej9UZ")).Promise;

});
parcelRegister("7WKTk", function(module, exports) {
'use strict';

var $f62P5 = parcelRequire("f62P5");

var $bTLKS = parcelRequire("bTLKS");

var $eMwHM = parcelRequire("eMwHM");

var $4RdU9 = parcelRequire("4RdU9");

var $23Rxz = parcelRequire("23Rxz");

var $908oX = parcelRequire("908oX");

var $4eZ4N = parcelRequire("4eZ4N");

var $e9rn7 = parcelRequire("e9rn7");

var $1OucH = parcelRequire("1OucH");

var $3JXTj = parcelRequire("3JXTj");

var $7mnFY = parcelRequire("7mnFY");
var $5c9252db60d5364f$require$task = $7mnFY.set;

var $5c9252db60d5364f$var$microtask = (parcelRequire("9mBS7"))();

var $asp7M = parcelRequire("asp7M");

var $ch86E = parcelRequire("ch86E");

var $5perC = parcelRequire("5perC");

var $lopOa = parcelRequire("lopOa");
var $5c9252db60d5364f$var$PROMISE = 'Promise';
var $5c9252db60d5364f$var$TypeError = $bTLKS.TypeError;
var $5c9252db60d5364f$var$process = $bTLKS.process;
var $5c9252db60d5364f$var$versions = $5c9252db60d5364f$var$process && $5c9252db60d5364f$var$process.versions;
var $5c9252db60d5364f$var$v8 = $5c9252db60d5364f$var$versions && $5c9252db60d5364f$var$versions.v8 || '';
var $5c9252db60d5364f$var$$Promise = $bTLKS[$5c9252db60d5364f$var$PROMISE];
var $5c9252db60d5364f$var$isNode = $4RdU9($5c9252db60d5364f$var$process) == 'process';
var $5c9252db60d5364f$var$empty = function() {};
var $5c9252db60d5364f$var$Internal, $5c9252db60d5364f$var$newGenericPromiseCapability, $5c9252db60d5364f$var$OwnPromiseCapability, $5c9252db60d5364f$var$Wrapper;
var $5c9252db60d5364f$var$newPromiseCapability = $5c9252db60d5364f$var$newGenericPromiseCapability = $asp7M.f;

var $5c9252db60d5364f$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $5c9252db60d5364f$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("9YxKW"))('species')] = function(exec) {
            exec($5c9252db60d5364f$var$empty, $5c9252db60d5364f$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($5c9252db60d5364f$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($5c9252db60d5364f$var$empty) instanceof FakePromise && $5c9252db60d5364f$var$v8.indexOf('6.6') !== 0 && $5perC.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $5c9252db60d5364f$var$isThenable = function(it) {
    var then;
    return $908oX(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $5c9252db60d5364f$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $5c9252db60d5364f$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $5c9252db60d5364f$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($5c9252db60d5364f$var$TypeError('Promise-chain cycle'));
                    else if (then = $5c9252db60d5364f$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $5c9252db60d5364f$var$onUnhandled(promise);
    });
};
var $5c9252db60d5364f$var$onUnhandled = function(promise) {
    $5c9252db60d5364f$require$task.call($bTLKS, function() {
        var value = promise._v;
        var unhandled = $5c9252db60d5364f$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $ch86E(function() {
                if ($5c9252db60d5364f$var$isNode) $5c9252db60d5364f$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $bTLKS.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $bTLKS.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $5c9252db60d5364f$var$isNode || $5c9252db60d5364f$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $5c9252db60d5364f$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $5c9252db60d5364f$var$onHandleUnhandled = function(promise) {
    $5c9252db60d5364f$require$task.call($bTLKS, function() {
        var handler;
        if ($5c9252db60d5364f$var$isNode) $5c9252db60d5364f$var$process.emit('rejectionHandled', promise);
        else if (handler = $bTLKS.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $5c9252db60d5364f$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $5c9252db60d5364f$var$notify(promise, true);
};
var $5c9252db60d5364f$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $5c9252db60d5364f$var$TypeError("Promise can't be resolved itself");
        if (then = $5c9252db60d5364f$var$isThenable(value)) $5c9252db60d5364f$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $eMwHM($5c9252db60d5364f$var$$resolve, wrapper, 1), $eMwHM($5c9252db60d5364f$var$$reject, wrapper, 1));
            } catch (e) {
                $5c9252db60d5364f$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $5c9252db60d5364f$var$notify(promise, false);
        }
    } catch (e) {
        $5c9252db60d5364f$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$5c9252db60d5364f$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $5c9252db60d5364f$var$$Promise = function Promise(executor) {
        $e9rn7(this, $5c9252db60d5364f$var$$Promise, $5c9252db60d5364f$var$PROMISE, '_h');
        $4eZ4N(executor);
        $5c9252db60d5364f$var$Internal.call(this);
        try {
            executor($eMwHM($5c9252db60d5364f$var$$resolve, this, 1), $eMwHM($5c9252db60d5364f$var$$reject, this, 1));
        } catch (err) {
            $5c9252db60d5364f$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $5c9252db60d5364f$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $5c9252db60d5364f$var$Internal.prototype = (parcelRequire("hPlyR"))($5c9252db60d5364f$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $5c9252db60d5364f$var$newPromiseCapability($3JXTj(this, $5c9252db60d5364f$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $5c9252db60d5364f$var$isNode ? $5c9252db60d5364f$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $5c9252db60d5364f$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $5c9252db60d5364f$var$OwnPromiseCapability = function() {
        var promise = new $5c9252db60d5364f$var$Internal();
        this.promise = promise;
        this.resolve = $eMwHM($5c9252db60d5364f$var$$resolve, promise, 1);
        this.reject = $eMwHM($5c9252db60d5364f$var$$reject, promise, 1);
    };
    $asp7M.f = $5c9252db60d5364f$var$newPromiseCapability = function(C) {
        return C === $5c9252db60d5364f$var$$Promise || C === $5c9252db60d5364f$var$Wrapper ? new $5c9252db60d5364f$var$OwnPromiseCapability(C) : $5c9252db60d5364f$var$newGenericPromiseCapability(C);
    };
}
$23Rxz($23Rxz.G + $23Rxz.W + $23Rxz.F * !$5c9252db60d5364f$var$USE_NATIVE, {
    Promise: $5c9252db60d5364f$var$$Promise
});

(parcelRequire("h9gAE"))($5c9252db60d5364f$var$$Promise, $5c9252db60d5364f$var$PROMISE);

(parcelRequire("dipyf"))($5c9252db60d5364f$var$PROMISE);

$5c9252db60d5364f$var$Wrapper = (parcelRequire("ej9UZ"))[$5c9252db60d5364f$var$PROMISE];
// statics
$23Rxz($23Rxz.S + $23Rxz.F * !$5c9252db60d5364f$var$USE_NATIVE, $5c9252db60d5364f$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $5c9252db60d5364f$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$23Rxz($23Rxz.S + $23Rxz.F * ($f62P5 || !$5c9252db60d5364f$var$USE_NATIVE), $5c9252db60d5364f$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $lopOa($f62P5 && this === $5c9252db60d5364f$var$Wrapper ? $5c9252db60d5364f$var$$Promise : this, x);
    }
});

$23Rxz($23Rxz.S + $23Rxz.F * !($5c9252db60d5364f$var$USE_NATIVE && (parcelRequire("2AFN2"))(function(iter) {
    $5c9252db60d5364f$var$$Promise.all(iter)['catch']($5c9252db60d5364f$var$empty);
})), $5c9252db60d5364f$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $5c9252db60d5364f$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $ch86E(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $1OucH(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $5c9252db60d5364f$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $ch86E(function() {
            $1OucH(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("4RdU9", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $aScHa = parcelRequire("aScHa");

var $3896e5d68eab6701$var$TAG = (parcelRequire("9YxKW"))('toStringTag');
// ES3 wrong here
var $3896e5d68eab6701$var$ARG = $aScHa(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $3896e5d68eab6701$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $3896e5d68eab6701$var$tryGet(O = Object(it), $3896e5d68eab6701$var$TAG)) == 'string' ? T : $3896e5d68eab6701$var$ARG ? $aScHa(O) : (B = $aScHa(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("e9rn7", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("1OucH", function(module, exports) {

var $eMwHM = parcelRequire("eMwHM");

var $foiXx = parcelRequire("foiXx");

var $7v7HI = parcelRequire("7v7HI");

var $ZeX88 = parcelRequire("ZeX88");

var $ibmXJ = parcelRequire("ibmXJ");

var $g1so9 = parcelRequire("g1so9");
var $1521e3caa4267aa4$var$BREAK = {};
var $1521e3caa4267aa4$var$RETURN = {};
var $1521e3caa4267aa4$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $g1so9(iterable);
    var f = $eMwHM(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($7v7HI(iterFn)) for(length = $ibmXJ(iterable.length); length > index; index++){
        result = entries ? f($ZeX88(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $1521e3caa4267aa4$var$BREAK || result === $1521e3caa4267aa4$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $foiXx(iterator, f, step.value, entries);
        if (result === $1521e3caa4267aa4$var$BREAK || result === $1521e3caa4267aa4$var$RETURN) return result;
    }
};
$1521e3caa4267aa4$var$exports.BREAK = $1521e3caa4267aa4$var$BREAK;
$1521e3caa4267aa4$var$exports.RETURN = $1521e3caa4267aa4$var$RETURN;

});
parcelRegister("foiXx", function(module, exports) {
// call something on iterator step with safe closing on error

var $ZeX88 = parcelRequire("ZeX88");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($ZeX88(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $ZeX88(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("7v7HI", function(module, exports) {
// check on default Array iterator

var $2YvtX = parcelRequire("2YvtX");

var $57616780773ebeec$var$ITERATOR = (parcelRequire("9YxKW"))('iterator');
var $57616780773ebeec$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($2YvtX.Array === it || $57616780773ebeec$var$ArrayProto[$57616780773ebeec$var$ITERATOR] === it);
};

});

parcelRegister("g1so9", function(module, exports) {

var $4RdU9 = parcelRequire("4RdU9");

var $baa2c2b5946a3f2d$var$ITERATOR = (parcelRequire("9YxKW"))('iterator');

var $2YvtX = parcelRequire("2YvtX");

module.exports = (parcelRequire("ej9UZ")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$baa2c2b5946a3f2d$var$ITERATOR] || it['@@iterator'] || $2YvtX[$4RdU9(it)];
};

});


parcelRegister("3JXTj", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $ZeX88 = parcelRequire("ZeX88");

var $4eZ4N = parcelRequire("4eZ4N");

var $2b94083165108f58$var$SPECIES = (parcelRequire("9YxKW"))('species');
module.exports = function(O, D) {
    var C = $ZeX88(O).constructor;
    var S;
    return C === undefined || (S = $ZeX88(C)[$2b94083165108f58$var$SPECIES]) == undefined ? D : $4eZ4N(S);
};

});

parcelRegister("7mnFY", function(module, exports) {

var $eMwHM = parcelRequire("eMwHM");

var $7DW3p = parcelRequire("7DW3p");

var $avcZT = parcelRequire("avcZT");

var $dA4Im = parcelRequire("dA4Im");

var $bTLKS = parcelRequire("bTLKS");
var $55bcf408883a5a6f$var$process = $bTLKS.process;
var $55bcf408883a5a6f$var$setTask = $bTLKS.setImmediate;
var $55bcf408883a5a6f$var$clearTask = $bTLKS.clearImmediate;
var $55bcf408883a5a6f$var$MessageChannel = $bTLKS.MessageChannel;
var $55bcf408883a5a6f$var$Dispatch = $bTLKS.Dispatch;
var $55bcf408883a5a6f$var$counter = 0;
var $55bcf408883a5a6f$var$queue = {};
var $55bcf408883a5a6f$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $55bcf408883a5a6f$var$defer, $55bcf408883a5a6f$var$channel, $55bcf408883a5a6f$var$port;
var $55bcf408883a5a6f$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($55bcf408883a5a6f$var$queue.hasOwnProperty(id)) {
        var fn = $55bcf408883a5a6f$var$queue[id];
        delete $55bcf408883a5a6f$var$queue[id];
        fn();
    }
};
var $55bcf408883a5a6f$var$listener = function(event) {
    $55bcf408883a5a6f$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$55bcf408883a5a6f$var$setTask || !$55bcf408883a5a6f$var$clearTask) {
    $55bcf408883a5a6f$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $55bcf408883a5a6f$var$queue[++$55bcf408883a5a6f$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $7DW3p(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $55bcf408883a5a6f$var$defer($55bcf408883a5a6f$var$counter);
        return $55bcf408883a5a6f$var$counter;
    };
    $55bcf408883a5a6f$var$clearTask = function clearImmediate(id) {
        delete $55bcf408883a5a6f$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("aScHa"))($55bcf408883a5a6f$var$process) == 'process') $55bcf408883a5a6f$var$defer = function(id) {
        $55bcf408883a5a6f$var$process.nextTick($eMwHM($55bcf408883a5a6f$var$run, id, 1));
    };
    else if ($55bcf408883a5a6f$var$Dispatch && $55bcf408883a5a6f$var$Dispatch.now) $55bcf408883a5a6f$var$defer = function(id) {
        $55bcf408883a5a6f$var$Dispatch.now($eMwHM($55bcf408883a5a6f$var$run, id, 1));
    };
    else if ($55bcf408883a5a6f$var$MessageChannel) {
        $55bcf408883a5a6f$var$channel = new $55bcf408883a5a6f$var$MessageChannel();
        $55bcf408883a5a6f$var$port = $55bcf408883a5a6f$var$channel.port2;
        $55bcf408883a5a6f$var$channel.port1.onmessage = $55bcf408883a5a6f$var$listener;
        $55bcf408883a5a6f$var$defer = $eMwHM($55bcf408883a5a6f$var$port.postMessage, $55bcf408883a5a6f$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($bTLKS.addEventListener && typeof postMessage == 'function' && !$bTLKS.importScripts) {
        $55bcf408883a5a6f$var$defer = function(id) {
            $bTLKS.postMessage(id + '', '*');
        };
        $bTLKS.addEventListener('message', $55bcf408883a5a6f$var$listener, false);
    // IE8-
    } else if ($55bcf408883a5a6f$var$ONREADYSTATECHANGE in $dA4Im('script')) $55bcf408883a5a6f$var$defer = function(id) {
        $avcZT.appendChild($dA4Im('script'))[$55bcf408883a5a6f$var$ONREADYSTATECHANGE] = function() {
            $avcZT.removeChild(this);
            $55bcf408883a5a6f$var$run.call(id);
        };
    };
    else $55bcf408883a5a6f$var$defer = function(id) {
        setTimeout($eMwHM($55bcf408883a5a6f$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $55bcf408883a5a6f$var$setTask,
    clear: $55bcf408883a5a6f$var$clearTask
};

});
parcelRegister("7DW3p", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("9mBS7", function(module, exports) {

var $bTLKS = parcelRequire("bTLKS");

var $7mnFY = parcelRequire("7mnFY");
var $6d138bb076122738$require$macrotask = $7mnFY.set;
var $6d138bb076122738$var$Observer = $bTLKS.MutationObserver || $bTLKS.WebKitMutationObserver;
var $6d138bb076122738$var$process = $bTLKS.process;
var $6d138bb076122738$var$Promise = $bTLKS.Promise;

var $6d138bb076122738$var$isNode = (parcelRequire("aScHa"))($6d138bb076122738$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($6d138bb076122738$var$isNode && (parent = $6d138bb076122738$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($6d138bb076122738$var$isNode) notify = function() {
        $6d138bb076122738$var$process.nextTick(flush);
    };
    else if ($6d138bb076122738$var$Observer && !($bTLKS.navigator && $bTLKS.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $6d138bb076122738$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($6d138bb076122738$var$Promise && $6d138bb076122738$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $6d138bb076122738$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $6d138bb076122738$require$macrotask.call($bTLKS, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("asp7M", function(module, exports) {

$parcel$export(module.exports, "f", () => $79d00216fce33fe6$export$2d1720544b23b823, (v) => $79d00216fce33fe6$export$2d1720544b23b823 = v);
var $79d00216fce33fe6$export$2d1720544b23b823;
'use strict';

var $4eZ4N = parcelRequire("4eZ4N");
function $79d00216fce33fe6$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4eZ4N(resolve);
    this.reject = $4eZ4N(reject);
}
$79d00216fce33fe6$export$2d1720544b23b823 = function(C) {
    return new $79d00216fce33fe6$var$PromiseCapability(C);
};

});

parcelRegister("ch86E", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("5perC", function(module, exports) {

var $bTLKS = parcelRequire("bTLKS");
var $3efa7df0864247d2$var$navigator = $bTLKS.navigator;
module.exports = $3efa7df0864247d2$var$navigator && $3efa7df0864247d2$var$navigator.userAgent || '';

});

parcelRegister("lopOa", function(module, exports) {

var $ZeX88 = parcelRequire("ZeX88");

var $908oX = parcelRequire("908oX");

var $asp7M = parcelRequire("asp7M");
module.exports = function(C, x) {
    $ZeX88(C);
    if ($908oX(x) && x.constructor === C) return x;
    var promiseCapability = $asp7M.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});

parcelRegister("hPlyR", function(module, exports) {

var $lTOYY = parcelRequire("lTOYY");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $lTOYY(target, key, src[key]);
    return target;
};

});

parcelRegister("dipyf", function(module, exports) {
'use strict';

var $bTLKS = parcelRequire("bTLKS");

var $ej9UZ = parcelRequire("ej9UZ");

var $gBk2k = parcelRequire("gBk2k");

var $3u2mT = parcelRequire("3u2mT");

var $9ae0c6ca2be84063$var$SPECIES = (parcelRequire("9YxKW"))('species');
module.exports = function(KEY) {
    var C = typeof $ej9UZ[KEY] == 'function' ? $ej9UZ[KEY] : $bTLKS[KEY];
    if ($3u2mT && C && !C[$9ae0c6ca2be84063$var$SPECIES]) $gBk2k.f(C, $9ae0c6ca2be84063$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("2AFN2", function(module, exports) {

var $1e2f5c3169a4aa75$var$ITERATOR = (parcelRequire("9YxKW"))('iterator');
var $1e2f5c3169a4aa75$var$SAFE_CLOSING = false;
try {
    var $1e2f5c3169a4aa75$var$riter = [
        7
    ][$1e2f5c3169a4aa75$var$ITERATOR]();
    $1e2f5c3169a4aa75$var$riter['return'] = function() {
        $1e2f5c3169a4aa75$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($1e2f5c3169a4aa75$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$1e2f5c3169a4aa75$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$1e2f5c3169a4aa75$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$1e2f5c3169a4aa75$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});


parcelRegister("jlPCh", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
'use strict';

var $23Rxz = parcelRequire("23Rxz");

var $ej9UZ = parcelRequire("ej9UZ");

var $bTLKS = parcelRequire("bTLKS");

var $3JXTj = parcelRequire("3JXTj");

var $lopOa = parcelRequire("lopOa");
$23Rxz($23Rxz.P + $23Rxz.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $3JXTj(this, $ej9UZ.Promise || $bTLKS.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $lopOa(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $lopOa(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("4mnuX", function(module, exports) {
'use strict';

var $23Rxz = parcelRequire("23Rxz");

var $asp7M = parcelRequire("asp7M");

var $ch86E = parcelRequire("ch86E");
$23Rxz($23Rxz.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $asp7M.f(this);
        var result = $ch86E(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});



parcelRegister("b81LX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Properly handle server-side rendering.
var $81a1d1111f5cbdf9$var$win = void 0;
if (typeof window !== 'undefined') $81a1d1111f5cbdf9$var$win = window;
else if (typeof self !== 'undefined') $81a1d1111f5cbdf9$var$win = self;
else $81a1d1111f5cbdf9$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $81a1d1111f5cbdf9$var$request = $81a1d1111f5cbdf9$var$win.requestAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.mozRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.oRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.msRequestAnimationFrame || function(callback) {
    return $81a1d1111f5cbdf9$var$win.setTimeout(callback, 1000 / 60);
};
var $81a1d1111f5cbdf9$var$cancel = $81a1d1111f5cbdf9$var$win.cancelAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.mozCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.oCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.msCancelAnimationFrame || function(id) {
    $81a1d1111f5cbdf9$var$win.clearTimeout(id);
};
var $81a1d1111f5cbdf9$var$raf = module.exports.raf = $81a1d1111f5cbdf9$var$request;
var $81a1d1111f5cbdf9$var$caf = module.exports.caf = $81a1d1111f5cbdf9$var$cancel;

});



parcelRegister("eAUMQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter;
parcelRequire("7G6q0");
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});


parcelRegister("2AKv3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;

var $5uXOq = parcelRequire("5uXOq");
var $1e3303757d69af0d$var$React = $1e3303757d69af0d$var$_interopRequireWildcard($5uXOq);

var $8rCP3 = parcelRequire("8rCP3");
var $1e3303757d69af0d$var$_propTypes2 = $1e3303757d69af0d$var$_interopRequireDefault($8rCP3);
function $1e3303757d69af0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1e3303757d69af0d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows = null;
var $1e3303757d69af0d$var$bpfrpt_proptype_Scroll = null;
module.exports.bpfrpt_proptype_RowRendererParams = $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams;
module.exports.bpfrpt_proptype_RowRenderer = $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer;
module.exports.bpfrpt_proptype_RenderedRows = $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows;
module.exports.bpfrpt_proptype_Scroll = $1e3303757d69af0d$var$bpfrpt_proptype_Scroll;

});



parcelRegister("96cc5", function(module, exports) {

$parcel$export(module.exports, "ListRow", () => $2e506314683cadb6$export$c36f87108246a02a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $2e506314683cadb6$export$c36f87108246a02a({ children: children, registerChild: registerChild, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }) {
    const childElementRef = (0, $5uXOq.useRef)(null);
    const setListElementRef = (element)=>{
        registerChild?.(element ?? undefined);
    };
    (0, $5uXOq.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: setListElementRef,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
}

});

parcelRegister("gIpUw", function(module, exports) {

$parcel$export(module.exports, "TypeAheadListItem", () => $2ed08364f40e4ff0$export$913373331e95c13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $5tY4R = parcelRequire("5tY4R");

var $3UtTx = parcelRequire("3UtTx");
var $8ptyJ = parcelRequire("8ptyJ");

var $9LY0t = parcelRequire("9LY0t");

var $iHYdz = parcelRequire("iHYdz");

var $24JcV = parcelRequire("24JcV");

var $kJpBP = parcelRequire("kJpBP");

function $2ed08364f40e4ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ed08364f40e4ff0$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `1px solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $2ed08364f40e4ff0$var$itemIconSize = {
    name: "4y81cs",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);svg:first-of-type{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $2ed08364f40e4ff0$var$itemText = /*#__PURE__*/ (0, $f8Sb3.css)({
    whiteSpace: 'initial',
    color: `${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`}`
});
const $2ed08364f40e4ff0$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $2ed08364f40e4ff0$var$itemTitleOverride = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $2ed08364f40e4ff0$var$itemDescription = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $iHYdz.relativeFontSizeToBase16)(12)};`,
    color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $2ed08364f40e4ff0$var$itemDescriptionOverride = {
    name: "7ynmig",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$customRenderItemDivStyle = /*#__PURE__*/ (0, $f8Sb3.css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";outline:none;}");
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $2ed08364f40e4ff0$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`,
        backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $2ed08364f40e4ff0$var$selectedStyle = /*#__PURE__*/ (0, $f8Sb3.css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";");
const $2ed08364f40e4ff0$var$disabledStyle = {
    name: "16lzvw8",
    styles: "color:var(--ds-text-disabled, #091E424F)"
};
const $2ed08364f40e4ff0$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5tY4R.default), null);
});
const $2ed08364f40e4ff0$var$noop = ()=>{};
const $2ed08364f40e4ff0$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $5uXOq.useMemo)(()=>{
        return [
            $2ed08364f40e4ff0$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $2ed08364f40e4ff0$var$selectedStyle,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $2ed08364f40e4ff0$var$noop
    })));
});
const $2ed08364f40e4ff0$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const connectivityMode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'connectivity.mode');
    return {
        connectivityMode: connectivityMode
    };
}, (api)=>{
    const { connectivityState: connectivityState } = (0, $awTmI.useSharedPluginState)(api, [
        'connectivity'
    ]);
    return {
        connectivityMode: connectivityState?.mode
    };
});
const $2ed08364f40e4ff0$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex })=>{
    const { connectivityMode: connectivityMode } = $2ed08364f40e4ff0$var$useSharedState(api);
    const isItemDisabled = (item)=>connectivityMode === 'offline' && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = connectivityMode === 'offline' && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $koVbs.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $8ptyJ.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $2ed08364f40e4ff0$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemIconSize
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $f8Sb3.jsx)($2ed08364f40e4ff0$var$FallbackIcon, {
            label: title
        }));
    }, [
        icon,
        title,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $5uXOq.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $3UtTx.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $5uXOq.useMemo)(()=>{
        return [
            $2ed08364f40e4ff0$var$selectionFrame,
            isSelected && !itemIsDisabled && $2ed08364f40e4ff0$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) customItemRef?.current?.focus();
    }, [
        customItemRef,
        shouldUpdateFocus
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) buttonItemRef?.current?.focus();
    }, [
        buttonItemRef,
        shouldUpdateFocus
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)($2ed08364f40e4ff0$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: listItemClasses
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        // TODO: ED-26959 - aria-description is in draft for ARIA 1.3.
        // For now replace it with aria-describedby.
        // eslint-disable-next-line jsx-a11y/aria-props
        "aria-description": `${descriptionText} ${shortcutText}`,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemText
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2ed08364f40e4ff0$var$itemBody
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemTitleOverride,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ]
    }, item.title), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2ed08364f40e4ff0$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $24JcV.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2ed08364f40e4ff0$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemDescriptionOverride,
            itemIsDisabled && $2ed08364f40e4ff0$var$disabledStyle
        ]
    }, item.description))))));
});

});
parcelRegister("5tY4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3a69629e592a00$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6v7Sc = parcelRequire("6v7Sc");
function $8c3a69629e592a00$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $6v7Sc.useIconThemed)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("6v7Sc", function(module, exports) {

$parcel$export(module.exports, "useIconThemed", () => $9722d0b207f9c9df$export$a38bb9a8c9e5bc30);

var $hxoiH = parcelRequire("hxoiH");
const $9722d0b207f9c9df$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});



parcelRegister("8PLnn", function(module, exports) {

$parcel$export(module.exports, "ViewMore", () => $2693df730c07ec69$export$d4bcefa42749a40f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $2i4K4 = parcelRequire("2i4K4");

var $fP8bU = parcelRequire("fP8bU");

var $kJpBP = parcelRequire("kJpBP");
var $9UCCQ = parcelRequire("9UCCQ");

var $VSDnB = parcelRequire("VSDnB");

const $2693df730c07ec69$var$buttonStylesNoOutline = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:focus': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        outline: 'none'
    }
});
const $2693df730c07ec69$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:focus': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    }
});
const $2693df730c07ec69$export$d4bcefa42749a40f = ({ onClick: onClick, isFocused: isFocused })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            } else if (e.key === 'Tab') {
                // TypeaheadList will try to insert selected item on Tab press
                // hence stop propagation to prevent that and treat this as noop
                e.stopPropagation();
                e.preventDefault();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $VSDnB.fg)('platform_editor_controls_patch_8') ? $2693df730c07ec69$var$buttonStyles : $2693df730c07ec69$var$buttonStylesNoOutline
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kJpBP.default), {
        ref: ref,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fP8bU))), {
            label: ""
        }),
        "aria-describedby": (0, $VSDnB.fg)('platform_editor_refactor_view_more') ? undefined : formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore),
        "aria-label": (0, $VSDnB.fg)('platform_editor_refactor_view_more') ? formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMoreAriaLabel) : undefined,
        "data-testid": "quick-insert-view-more-elements-item"
    }, formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore))));
};

});
parcelRegister("fP8bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad5194e08f67bfe24a1828a13f5785c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b851f9035a4ffaf9$var$_react = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b851f9035a4ffaf9$var$_showMoreHorizontal = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $b851f9035a4ffaf9$var$_more = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("6qrUW")));
function $b851f9035a4ffaf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b851f9035a4ffaf9$var$_react.default.createElement($b851f9035a4ffaf9$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b851f9035a4ffaf9$var$_more.default
    }, props));
$b851f9035a4ffaf9$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $b851f9035a4ffaf9$var$_default = module.exports.default = $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon;

});
parcelRegister("6qrUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4adad3971ebc70ba$var$_react = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4adad3971ebc70ba$var$_showMoreHorizontal = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("8U6zd")));
function $4adad3971ebc70ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4adad3971ebc70ba$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $4adad3971ebc70ba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $4adad3971ebc70ba$var$_showMoreHorizontal.default
    }));
$4adad3971ebc70ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $4adad3971ebc70ba$var$_default = module.exports.default = $4adad3971ebc70ba$var$EditorMoreIcon;

});









parcelRegister("at6Ig", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => (parcelRequire("kiLfG")).betterTypeHistoryPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kiLfG = parcelRequire("kiLfG");

});
parcelRegister("kiLfG", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $10c9d21a664b94c0$export$5587393ddd97118a);

var $jkD4K = parcelRequire("jkD4K");

var $jsq8Z = parcelRequire("jsq8Z");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $10c9d21a664b94c0$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $jsq8Z.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $jkD4K.default)()
                }
            ];
        }
    };
};

});
parcelRegister("jkD4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $f65bcd99d0e862c8$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $594Yf = parcelRequire("594Yf");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $jsq8Z = parcelRequire("jsq8Z");
const $f65bcd99d0e862c8$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $gZGBX.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $f65bcd99d0e862c8$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $f65bcd99d0e862c8$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $kCV8T.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $f65bcd99d0e862c8$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $jsq8Z.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $jsq8Z.pluginKey)));
            if (hasHandlePasteMeta) return (0, $fZzhT.closeHistory)(newState.tr);
            const enterStep = $f65bcd99d0e862c8$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $594Yf.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($f65bcd99d0e862c8$var$isSliceSplittingBlockNode(slice) || $f65bcd99d0e862c8$var$isSliceAddingNewlineChar(slice, schema))) return (0, $fZzhT.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("jsq8Z", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $1d2020e42b3f90c2$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $1d2020e42b3f90c2$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('betterTypeHistoryPlugin');

});




parcelRegister("cVzPm", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => (parcelRequire("9UHJN")).clearMarksOnEmptyDocPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9UHJN = parcelRequire("9UHJN");

});
parcelRegister("9UHJN", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => $909665f51df345d6$export$30b76f1055cbb7e9);

var $5KWxh = parcelRequire("5KWxh");

var $ggL2v = parcelRequire("ggL2v");

var $gZGBX = parcelRequire("gZGBX");
const $909665f51df345d6$var$pluginKey = new (0, $gZGBX.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $909665f51df345d6$var$createPlugin() {
    return new (0, $5KWxh.SafePlugin)({
        key: $909665f51df345d6$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $ggL2v.isEmptyDocument)(oldState.doc) && (0, $ggL2v.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $909665f51df345d6$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $909665f51df345d6$var$createPlugin
                }
            ];
        }
    });

});


parcelRegister("oFSWG", function(module, exports) {

$parcel$export(module.exports, "clipboardPlugin", () => (parcelRequire("kd7KX")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kd7KX = parcelRequire("kd7KX");

});
parcelRegister("kd7KX", function(module, exports) {

$parcel$export(module.exports, "default", () => $281e1faf12170a31$export$2e2bcd8739ae039);

var $9Loj3 = parcelRequire("9Loj3");
const $281e1faf12170a31$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $9Loj3.createPlugin)(options)
                }
            ];
        }
    });
var $281e1faf12170a31$export$2e2bcd8739ae039 = $281e1faf12170a31$var$clipboard;

});
parcelRegister("9Loj3", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bd4683358ea19f8e$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $cYcwl = parcelRequire("cYcwl");

var $5KWxh = parcelRequire("5KWxh");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $i9Yaa = parcelRequire("i9Yaa");
var $bd4683358ea19f8e$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $bd4683358ea19f8e$var$lastEventType = null;
const $bd4683358ea19f8e$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $i9Yaa.clipboardPluginKey),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $bd4683358ea19f8e$export$47cf4f31f028e0c9("CUT");
                    return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $gkwXh.ACTION).CUT);
                },
                copy: (view)=>{
                    $bd4683358ea19f8e$export$47cf4f31f028e0c9("COPY");
                    return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $gkwXh.ACTION).COPIED);
                }
            },
            clipboardSerializer: $bd4683358ea19f8e$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $bd4683358ea19f8e$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $kCV8T.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $kCV8T.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $5r0mK.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $kCV8T.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($bd4683358ea19f8e$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            if ((0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                // Content for media parents can include multiple content nodes (media and captions). We now take that
                // into consideration when we are stripping annotations
                let contentArray = [
                    strippedMediaNode
                ];
                content.forEach((node)=>{
                    if (node.type.name !== 'media') contentArray = [
                        ...contentArray,
                        node
                    ];
                });
                const newContent = (0, $kCV8T.Fragment).fromArray(contentArray);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            } else {
                const newContent = (0, $kCV8T.Fragment).from(strippedMediaNode);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            }
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $bd4683358ea19f8e$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $cYcwl.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $bd4683358ea19f8e$export$47cf4f31f028e0c9 = (eventType)=>$bd4683358ea19f8e$var$lastEventType = eventType;

});
parcelRegister("cYcwl", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $e78f458911acd4e2$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $e78f458911acd4e2$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $e78f458911acd4e2$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $e78f458911acd4e2$export$4feda93c1c6b2d80);
$parcel$export(module.exports, "getNodeCopiedAnalyticsPayload", () => $e78f458911acd4e2$export$f8811fa45a00fd64);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $2x8Ci = parcelRequire("2x8Ci");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $8AlsS = parcelRequire("8AlsS");
const $e78f458911acd4e2$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $e78f458911acd4e2$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $e78f458911acd4e2$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $e78f458911acd4e2$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($e78f458911acd4e2$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($e78f458911acd4e2$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $e78f458911acd4e2$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($e78f458911acd4e2$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $e78f458911acd4e2$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $e78f458911acd4e2$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $2x8Ci.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $2x8Ci.write([
        dt
    ]);
};
const $e78f458911acd4e2$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $8AlsS.getNodeSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $8AlsS.getAllSelectionAnalyticsPayload)(selection) || (0, $8AlsS.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $gkwXh.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($e78f458911acd4e2$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $gkwXh.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($e78f458911acd4e2$var$isExtensionNode(node)) return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.$cursor) return {
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $e78f458911acd4e2$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($e78f458911acd4e2$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        action: (0, $gkwXh.ACTION).COPIED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};

});
parcelRegister("2x8Ci", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $1d8558ea290058b8$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $1d8558ea290058b8$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $1d8558ea290058b8$var$TEXT_PLAIN = "text/plain";
var $1d8558ea290058b8$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $1d8558ea290058b8$var$debugLogImpl = (s)=>{};
function $1d8558ea290058b8$var$debugLog(s) {
    $1d8558ea290058b8$var$debugLogImpl(s);
}
function $1d8558ea290058b8$export$e014146e87162c32(logFn) {
    $1d8558ea290058b8$var$debugLogImpl = logFn;
}
var $1d8558ea290058b8$var$showWarnings = true;
function $1d8558ea290058b8$export$ba5c9528becaaf25() {
    $1d8558ea290058b8$var$showWarnings = false;
}
function $1d8558ea290058b8$var$shouldShowWarnings() {
    return $1d8558ea290058b8$var$showWarnings;
}
function $1d8558ea290058b8$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $1d8558ea290058b8$var$warn = $1d8558ea290058b8$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $1d8558ea290058b8$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $1d8558ea290058b8$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $1d8558ea290058b8$var$_a, $1d8558ea290058b8$var$_b, $1d8558ea290058b8$var$_c;
var $1d8558ea290058b8$var$promiseConstructorImpl = ($1d8558ea290058b8$var$_c = ($1d8558ea290058b8$var$_a = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a.Promise) != null ? $1d8558ea290058b8$var$_c : ($1d8558ea290058b8$var$_b = $1d8558ea290058b8$var$originalGlobalThis) == null ? void 0 : $1d8558ea290058b8$var$_b.Promise;
function $1d8558ea290058b8$var$getPromiseConstructor() {
    if (!$1d8558ea290058b8$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $1d8558ea290058b8$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $1d8558ea290058b8$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $1d8558ea290058b8$var$originalNavigatorClipboard = $1d8558ea290058b8$var$originalNavigator == null ? void 0 : $1d8558ea290058b8$var$originalNavigator.clipboard;
var $1d8558ea290058b8$var$_a2;
var $1d8558ea290058b8$var$originalNavigatorClipboardRead = ($1d8558ea290058b8$var$_a2 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.read) == null ? void 0 : $1d8558ea290058b8$var$_a2.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a3;
var $1d8558ea290058b8$var$originalNavigatorClipboardReadText = ($1d8558ea290058b8$var$_a3 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.readText) == null ? void 0 : $1d8558ea290058b8$var$_a3.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a4;
var $1d8558ea290058b8$var$originalNavigatorClipboardWrite = ($1d8558ea290058b8$var$_a4 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.write) == null ? void 0 : $1d8558ea290058b8$var$_a4.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a5;
var $1d8558ea290058b8$var$originalNavigatorClipboardWriteText = ($1d8558ea290058b8$var$_a5 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.writeText) == null ? void 0 : $1d8558ea290058b8$var$_a5.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
var $1d8558ea290058b8$var$_a6;
var $1d8558ea290058b8$var$originalWindowClipboardItem = ($1d8558ea290058b8$var$_a6 = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a6.ClipboardItem;
var $1d8558ea290058b8$var$promiseConstructor = $1d8558ea290058b8$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $1d8558ea290058b8$var$ieWindow = $1d8558ea290058b8$var$originalWindow;
function $1d8558ea290058b8$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData) !== "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $1d8558ea290058b8$var$writeTextIE(text) {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) return false;
    var success = $1d8558ea290058b8$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $1d8558ea290058b8$var$debugLog("writeTextIE worked");
    return success;
}
function $1d8558ea290058b8$var$readTextIE() {
    if (!$1d8558ea290058b8$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $1d8558ea290058b8$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $1d8558ea290058b8$var$copyListener(tracker, data, e) {
    $1d8558ea290058b8$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $1d8558ea290058b8$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $1d8558ea290058b8$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $1d8558ea290058b8$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $1d8558ea290058b8$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $1d8558ea290058b8$var$copyUsingTempSelection(e, data) {
    $1d8558ea290058b8$var$selectionSet(e);
    var success = $1d8558ea290058b8$var$execCopy(data);
    $1d8558ea290058b8$var$selectionClear();
    return success;
}
function $1d8558ea290058b8$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $1d8558ea290058b8$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $1d8558ea290058b8$var$copyTextUsingDOM(str) {
    $1d8558ea290058b8$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $1d8558ea290058b8$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $1d8558ea290058b8$var$selectionSet(span);
    var result = document.execCommand("copy");
    $1d8558ea290058b8$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $1d8558ea290058b8$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $1d8558ea290058b8$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $1d8558ea290058b8$var$writeFallback(stringItem) {
    var hasTextPlain = $1d8558ea290058b8$var$TEXT_PLAIN in stringItem;
    if ($1d8558ea290058b8$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($1d8558ea290058b8$var$writeTextIE(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($1d8558ea290058b8$var$execCopy(stringItem)) {
        $1d8558ea290058b8$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $1d8558ea290058b8$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempSelection(document.body, stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyUsingTempElem(stringItem)) {
        $1d8558ea290058b8$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($1d8558ea290058b8$var$copyTextUsingDOM(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) {
        $1d8558ea290058b8$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $1d8558ea290058b8$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $1d8558ea290058b8$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $1d8558ea290058b8$var$voidPromise = $1d8558ea290058b8$var$promiseConstructor.resolve();
var $1d8558ea290058b8$var$truePromiseFn = ()=>$1d8558ea290058b8$var$promiseConstructor.resolve(true);
var $1d8558ea290058b8$var$falsePromise = $1d8558ea290058b8$var$promiseConstructor.resolve(false);
function $1d8558ea290058b8$var$rejectThrownErrors(executor) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $1d8558ea290058b8$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$1d8558ea290058b8$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $1d8558ea290058b8$export$bec150f75a9b8f11(s) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWriteText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardWriteText(s).catch($1d8558ea290058b8$var$writeTextStringFallback);
        }
        return $1d8558ea290058b8$var$promiseConstructor.resolve($1d8558ea290058b8$var$writeTextStringFallback(s));
    });
}
function $1d8558ea290058b8$var$writeTextStringFallback(s) {
    if (!$1d8558ea290058b8$var$writeFallback($1d8558ea290058b8$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $1d8558ea290058b8$export$bee0113684d8879b() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardReadText) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardReadText();
        }
        if ($1d8558ea290058b8$var$seemToBeInIE()) {
            var result = $1d8558ea290058b8$var$readTextIE();
            return $1d8558ea290058b8$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $1d8558ea290058b8$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $1d8558ea290058b8$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $1d8558ea290058b8$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $1d8558ea290058b8$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $1d8558ea290058b8$export$3b1380c0957dc8fe = $1d8558ea290058b8$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $1d8558ea290058b8$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $1d8558ea290058b8$var$blobToString(blob) {
    return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $1d8558ea290058b8$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($1d8558ea290058b8$var$originalWindowClipboardItem) resolve(new $1d8558ea290058b8$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $1d8558ea290058b8$var$textToClipboardItem(text) {
    var items = {};
    items[$1d8558ea290058b8$var$TEXT_PLAIN] = $1d8558ea290058b8$var$stringToBlob(text, $1d8558ea290058b8$var$TEXT_PLAIN);
    return new $1d8558ea290058b8$export$3b1380c0957dc8fe(items);
}
function $1d8558ea290058b8$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $1d8558ea290058b8$var$blobToString(text);
    });
}
function $1d8558ea290058b8$var$toStringItem(data) {
    return $1d8558ea290058b8$var$promiseRecordMap(data.types, function(type) {
        return $1d8558ea290058b8$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $1d8558ea290058b8$export$68d8715fc104d294(data) {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardWrite && $1d8558ea290058b8$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $1d8558ea290058b8$var$originalNavigatorClipboardWrite;
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.write()`.");
            return $1d8558ea290058b8$var$promiseConstructor.all(data.map($1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($1d8558ea290058b8$var$truePromiseFn).catch((e)=>{
                    if (!$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN) && !$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_HTML)) throw e;
                    return $1d8558ea290058b8$var$falsePromise;
                });
            });
        }
        return $1d8558ea290058b8$var$falsePromise;
    }).then((success)=>{
        if (success) return $1d8558ea290058b8$var$voidPromise;
        var hasTextPlain = $1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN);
        if ($1d8558ea290058b8$var$shouldShowWarnings() && !hasTextPlain) $1d8558ea290058b8$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $1d8558ea290058b8$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$1d8558ea290058b8$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $1d8558ea290058b8$export$aafa59e2e03f2942() {
    return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
        if ($1d8558ea290058b8$var$originalNavigatorClipboardRead) {
            $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.read()`.");
            return $1d8558ea290058b8$var$originalNavigatorClipboardRead();
        }
        return $1d8558ea290058b8$export$bee0113684d8879b().then((text)=>{
            return [
                $1d8558ea290058b8$var$textToClipboardItem(text)
            ];
        });
    });
}

});

parcelRegister("8AlsS", function(module, exports) {

$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $09b21fe82b545f9f$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $09b21fe82b545f9f$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $hHsVB = parcelRequire("hHsVB");

var $gkwXh = parcelRequire("gkwXh");

var $6MkyM = parcelRequire("6MkyM");

var $hPjvp = parcelRequire("hPjvp");

var $5Vvw4 = parcelRequire("5Vvw4");

var $3jyjs = parcelRequire("3jyjs");

var $2xQXF = parcelRequire("2xQXF");

var $fMoO3 = parcelRequire("fMoO3");

var $eAVGd = parcelRequire("eAVGd");

var $k6Y9i = parcelRequire("k6Y9i");
function $09b21fe82b545f9f$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $gZGBX.NodeSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $09b21fe82b545f9f$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $gZGBX.AllSelection)) return {
        action: (0, $gkwXh.ACTION).SELECTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
}
function $09b21fe82b545f9f$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $hFEwm.CellSelection)) {
        const rect = (0, $hHsVB.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $09b21fe82b545f9f$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $gZGBX.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $gkwXh.ACTION).SELECTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $09b21fe82b545f9f$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $gZGBX.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $09b21fe82b545f9f$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $09b21fe82b545f9f$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("hHsVB", function(module, exports) {

$parcel$export(module.exports, "selectedRect", () => $78cade064f4edb3a$export$39ce22e69aa9ed17);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $22PoI = parcelRequire("22PoI");
function $78cade064f4edb3a$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $22PoI.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $hFEwm.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("22PoI", function(module, exports) {

$parcel$export(module.exports, "selectionCell", () => $6e0c68deaeecd60c$export$aad75348c8f2d244);

var $6hQQ3 = parcelRequire("6hQQ3");

var $iGxzn = parcelRequire("iGxzn");
function $6e0c68deaeecd60c$export$aad75348c8f2d244(selection) {
    if ((0, $iGxzn.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $iGxzn.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $6hQQ3.cellAround)(selection.$head) || (0, $6hQQ3.cellNear)(selection.$head);
}

});
parcelRegister("iGxzn", function(module, exports) {

$parcel$export(module.exports, "isSelectionType", () => $a99399272acf3f8b$export$626dcc173023aed7);
function $a99399272acf3f8b$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("6MkyM", function(module, exports) {

$parcel$export(module.exports, "RelativeSelectionPos", () => $1e3782577a66fd65$export$cb9005d223ae8de7);
var $1e3782577a66fd65$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("fMoO3", function(module, exports) {

$parcel$export(module.exports, "setGapCursorSelection", () => $860240a1613ee906$export$a8946811e8b82dd);

var $hPjvp = parcelRequire("hPjvp");
function $860240a1613ee906$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("k6Y9i", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $2aa2babce658057c$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $2aa2babce658057c$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $2aa2babce658057c$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $2aa2babce658057c$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $2aa2babce658057c$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $2aa2babce658057c$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $2aa2babce658057c$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $2aa2babce658057c$export$ced77c72038c89cb);

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $hPjvp = parcelRequire("hPjvp");
const $2aa2babce658057c$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $2aa2babce658057c$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $2aa2babce658057c$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $2aa2babce658057c$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $2aa2babce658057c$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $2aa2babce658057c$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return false;
    if (selection instanceof (0, $gZGBX.NodeSelection) && selection.node.isBlock) return true;
    return $2aa2babce658057c$export$ced77c72038c89cb($from) === $from.pos;
}
function $2aa2babce658057c$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $2aa2babce658057c$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
const $2aa2babce658057c$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = fromDepth ? $from.before() : $from.pos;
            selectionEnd = fromDepth ? $to.after(fromDepth) : $to.after(1);
        }
    } else if (toDepth < fromDepth) {
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = toDepth ? $from.before(toDepth) : $from.before(1);
            selectionEnd = toDepth ? $to.after() : $to.pos;
        }
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        if ((0, $VSDnB.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = $from.before(fromDepth - 1);
            selectionEnd = $to.after(toDepth - 1);
        }
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});



parcelRegister("i9Yaa", function(module, exports) {

$parcel$export(module.exports, "clipboardPluginKey", () => $e8931e12a5242325$export$7ff3d0e65871bad3);

var $gZGBX = parcelRequire("gZGBX");
const $e8931e12a5242325$export$7ff3d0e65871bad3 = new (0, $gZGBX.PluginKey)('clipboardPlugin');

});




parcelRegister("5Xe3v", function(module, exports) {

$parcel$export(module.exports, "usePreset", () => $df819121659b5a33$export$1d81a44583df97d2);

var $5uXOq = parcelRequire("5uXOq");

var $jy0M7 = parcelRequire("jy0M7");
function $df819121659b5a33$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $5uXOq.useState)(undefined);
    const preset = (0, $5uXOq.useMemo)(()=>createPreset(new (0, $jy0M7.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $5uXOq.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}

});
parcelRegister("jy0M7", function(module, exports) {

$parcel$export(module.exports, "EditorPresetBuilder", () => $727f0ffe9f739d15$export$dab03ba05a79e5c7);

var $lY6DM = parcelRequire("lY6DM");
class $727f0ffe9f739d15$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $727f0ffe9f739d15$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
    add(nextOrTuple) {
        return new $727f0ffe9f739d15$export$dab03ba05a79e5c7(/**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $727f0ffe9f739d15$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $727f0ffe9f739d15$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            const plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $727f0ffe9f739d15$var$APIDispatcher {
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $lY6DM.EventDispatcher)();
        this.key = 'api-resolved-event';
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
    /**
	 * Used to observe Editor API events
	 *
	 * @param cb Callback to listen to the editor API.
	 * This will also emit the last event if the stream has already started.
	 * @returns Cleanup function to cleanup the listener
	 */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
}

});


parcelRegister("g36b0", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => (parcelRequire("lsZ2i")).analyticsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lsZ2i = parcelRequire("lsZ2i");

});
parcelRegister("lsZ2i", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => $38b0cff75c831b25$export$f26023c5d4a5ab44);

var $5uXOq = parcelRequire("5uXOq");

var $8aY84 = parcelRequire("8aY84");

var $2NMNM = parcelRequire("2NMNM");

var $gkwXh = parcelRequire("gkwXh");
var $ctLRZ = parcelRequire("ctLRZ");
var $J5Axj = parcelRequire("J5Axj");

var $b7gJe = parcelRequire("b7gJe");

var $ap7h6 = parcelRequire("ap7h6");

var $5KWxh = parcelRequire("5KWxh");

var $bgfWv = parcelRequire("bgfWv");

var $eMmNA = parcelRequire("eMmNA");

var $fLgtE = parcelRequire("fLgtE");

var $8Zx8B = parcelRequire("8Zx8B");

var $78yQH = parcelRequire("78yQH");
function $38b0cff75c831b25$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $b7gJe.isPerformanceAPIAvailable)();
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $8Zx8B.analyticsPluginKey),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $ctLRZ.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $8Zx8B.analyticsPluginKey)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $J5Axj.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $gkwXh.ACTION).INSERTED && payload.action !== (0, $gkwXh.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $ap7h6.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $ctLRZ.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $38b0cff75c831b25$export$a3e5fcfb76b37e49({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $38b0cff75c831b25$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $8Zx8B.analyticsPluginKey).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $bgfWv.createAttachPayloadIntoTransaction)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $fLgtE.editorAnalyticsChannel))=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent: (payload, channel = (0, $fLgtE.editorAnalyticsChannel), options)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (options?.context) payload = (0, $eMmNA.getStateContext)(options.context.selection, payload);
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: payload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
            (0, $5uXOq.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $8Zx8B.analyticsPluginKey), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    createAnalyticsEvent(payload)?.fire(channel ?? (0, $fLgtE.editorAnalyticsChannel));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$38b0cff75c831b25$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $8Zx8B.analyticsPluginKey).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $8aY84.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $78yQH.generateUndoRedoInputSoucePayload)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $ctLRZ.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $38b0cff75c831b25$export$a3e5fcfb76b37e49({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
    };
}

});
parcelRegister("bgfWv", function(module, exports) {

$parcel$export(module.exports, "createAttachPayloadIntoTransaction", () => $70c38d4fb0ac5a50$export$539ce7f09649e93);

var $8aY84 = parcelRequire("8aY84");

var $gkwXh = parcelRequire("gkwXh");

var $eMmNA = parcelRequire("eMmNA");

var $7D97R = parcelRequire("7D97R");
const $70c38d4fb0ac5a50$var$actionsToIgnore = [
    (0, $gkwXh.ACTION).INVOKED,
    (0, $gkwXh.ACTION).OPENED
];
const $70c38d4fb0ac5a50$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$70c38d4fb0ac5a50$export$dff9776b7883fc5f({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
const $70c38d4fb0ac5a50$export$dff9776b7883fc5f = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $eMmNA.getStateContext)(selection, payload, tr);
    payload = (0, $7D97R.mapActionSubjectIdToAttributes)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $8aY84.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $70c38d4fb0ac5a50$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};

});
parcelRegister("eMmNA", function(module, exports) {

$parcel$export(module.exports, "getStateContext", () => $b2e7d92ac50916bf$export$b8d8bec4e31cbd66);

var $gkwXh = parcelRequire("gkwXh");
var $7IaNe = parcelRequire("7IaNe");

var $4NUlu = parcelRequire("4NUlu");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
function $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $7IaNe.SELECTION_TYPE).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $hFEwm.CellSelection)) type = (0, $7IaNe.SELECTION_TYPE).CELL;
    else if (selection instanceof (0, $gZGBX.NodeSelection)) type = (0, $7IaNe.SELECTION_TYPE).NODE;
    else if (selection.from !== selection.to) type = (0, $7IaNe.SELECTION_TYPE).RANGED;
    else {
        type = (0, $7IaNe.SELECTION_TYPE).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $7IaNe.SELECTION_POSITION).START;
        else if (from === $from.end()) position = (0, $7IaNe.SELECTION_POSITION).END;
        else position = (0, $7IaNe.SELECTION_POSITION).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $b2e7d92ac50916bf$export$46ac691122c4c55e(oldSelection, newSelection) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $hFEwm.CellSelection)) return table.name;
    const insertLocationInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let parentNodePos = newSelection.$from.doc.resolve(insertLocationInfo?.start || 0);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newSelection.$from.doc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $b2e7d92ac50916bf$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $4NUlu.findInsertLocation)(selection);
    if (tr && payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject !== (0, $gkwXh.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $gkwXh.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $b2e7d92ac50916bf$export$46ac691122c4c55e(selection, tr.selection);
    if (payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).DOCUMENT && payload.attributes) payload.attributes.insertLocation = insertLocation;
    else payload.attributes.nodeLocation = insertLocation;
    return payload;
}

});
parcelRegister("7IaNe", function(module, exports) {

$parcel$export(module.exports, "SELECTION_TYPE", () => $4f3bea2b77126b29$export$96527b3d022fe7df);
$parcel$export(module.exports, "SELECTION_POSITION", () => $4f3bea2b77126b29$export$f64a96dc7664cbe5);
var $4f3bea2b77126b29$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $4f3bea2b77126b29$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});

});


parcelRegister("7D97R", function(module, exports) {

$parcel$export(module.exports, "mapActionSubjectIdToAttributes", () => $4733c7621036df00$export$dd48e359ffe98e59);

var $gkwXh = parcelRequire("gkwXh");
function $4733c7621036df00$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $gkwXh.ACTION).INSERTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $gkwXh.ACTION).FORMATTED && payload.actionSubject === (0, $gkwXh.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}

});


parcelRegister("fLgtE", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $9fde11f34ce18b49$export$1467dbbb3bb418c6);

var $dWAZk = parcelRequire("dWAZk");
const $9fde11f34ce18b49$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;

});

parcelRegister("8Zx8B", function(module, exports) {

$parcel$export(module.exports, "analyticsPluginKey", () => $2b7c67819c225dd8$export$c4a4504e8a9a0b2e);

var $gZGBX = parcelRequire("gZGBX");
const $2b7c67819c225dd8$export$c4a4504e8a9a0b2e = new (0, $gZGBX.PluginKey)('analyticsPlugin');

});

parcelRegister("78yQH", function(module, exports) {

$parcel$export(module.exports, "generateUndoRedoInputSoucePayload", () => $bbad6368f6555977$export$67d130a769494b9b);
const $bbad6368f6555977$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $bbad6368f6555977$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $bbad6368f6555977$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};

});



parcelRegister("ceDVv", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => (parcelRequire("izJY1")).compositionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $izJY1 = parcelRequire("izJY1");

});
parcelRegister("izJY1", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => $fe0d4250ae554ed9$export$afd1652ef5208b);

var $fuDg1 = parcelRequire("fuDg1");

var $4gJQv = parcelRequire("4gJQv");
const $fe0d4250ae554ed9$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $4gJQv.pluginKey).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $fuDg1.default)()
                }
            ];
        }
    };
};

});
parcelRegister("fuDg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0db51e3a44ecc7$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");


var $4gJQv = parcelRequire("4gJQv");
const $1e0db51e3a44ecc7$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $1e0db51e3a44ecc7$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: (0, $4gJQv.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $4gJQv.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $4gJQv.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($1e0db51e3a44ecc7$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $4gJQv.pluginKey), false);
                    if ($1e0db51e3a44ecc7$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $4gJQv.pluginKey).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("4gJQv", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $f06bf058060e8acd$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $f06bf058060e8acd$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('compositionPlugin');

});




parcelRegister("cAUAO", function(module, exports) {

$parcel$export(module.exports, "contentInsertionPlugin", () => (parcelRequire("eeKOR")).contentInsertionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eeKOR = parcelRequire("eeKOR");

});
parcelRegister("eeKOR", function(module, exports) {

$parcel$export(module.exports, "contentInsertionPlugin", () => $14b39d749c221f70$export$8469b5a27995930b);

var $iLcSZ = parcelRequire("iLcSZ");
const $14b39d749c221f70$export$8469b5a27995930b = ({ api: api })=>{
    const { actions: actions, commands: commands } = (0, $iLcSZ.createInsertNodeAPI)(api?.analytics?.actions);
    return {
        name: 'contentInsertion',
        actions: actions,
        commands: commands
    };
};

});
parcelRegister("iLcSZ", function(module, exports) {

$parcel$export(module.exports, "createInsertNodeAPI", () => $4488a7db0e8c66a0$export$e8397698249f8f72);

var $h4f0C = parcelRequire("h4f0C");
const $4488a7db0e8c66a0$export$e8397698249f8f72 = (analyticsApi)=>({
        actions: {
            insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
                if (!state || !dispatch) return false;
                const { tr: tr } = state;
                (0, $h4f0C.handleInsertContent)({
                    node: node,
                    options: options
                })(tr);
                if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                dispatch(tr);
                return true;
            }
        },
        commands: {
            insert: ({ node: node, options: options })=>({ tr: tr })=>{
                    (0, $h4f0C.handleInsertContent)({
                        node: node,
                        options: options
                    })(tr);
                    if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                    return tr;
                }
        }
    });

});
parcelRegister("h4f0C", function(module, exports) {

$parcel$export(module.exports, "handleInsertContent", () => $e4990f7038b58d9f$export$68b1ab6a0b98c537);

var $kCV8T = parcelRequire("kCV8T");

var $bjYQF = parcelRequire("bjYQF");
const $e4990f7038b58d9f$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = options.insertAt ?? tr.selection;
        if (!(node instanceof (0, $kCV8T.Node) || node instanceof (0, $kCV8T.Fragment))) return false;
        (0, $bjYQF.insertProseMirrorContent)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };

});
parcelRegister("bjYQF", function(module, exports) {

$parcel$export(module.exports, "insertProseMirrorContent", () => $8f5607e90c2b77cf$export$a6d88483216c3859);
/* Copied from type-ahead */ 
var $dlzPV = parcelRequire("dlzPV");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
function $8f5607e90c2b77cf$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $8f5607e90c2b77cf$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        const mappedStart = start;
        const nodeNormalized = (0, $dlzPV.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $dlzPV.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $kCV8T.Slice).maxOpen((0, $kCV8T.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $8f5607e90c2b77cf$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $gZGBX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $8f5607e90c2b77cf$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $kCV8T.Node) ? (0, $kCV8T.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(start + (fragment?.size || 0))));
};
const $8f5607e90c2b77cf$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $kCV8T.Node) && node.isBlock) $8f5607e90c2b77cf$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $8f5607e90c2b77cf$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};

});





parcelRegister("98yYt", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => (parcelRequire("3LITD")).contextIdentifierPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3LITD = parcelRequire("3LITD");

});
parcelRegister("3LITD", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierPlugin", () => $21ce7faef1d06a3b$export$43b392516e89a467);

var $beDlk = parcelRequire("beDlk");
const $21ce7faef1d06a3b$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $beDlk.pluginKey), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $beDlk.pluginKey).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $beDlk.createPlugin)(config, api)
                }
            ];
        }
    };
};

});
parcelRegister("beDlk", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $a4429cc4007a2924$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $a4429cc4007a2924$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $a4429cc4007a2924$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('contextIdentiferPlugin');
async function $a4429cc4007a2924$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $a4429cc4007a2924$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $a4429cc4007a2924$var$updateContextIdentifier(initialConfig, api);
        return new (0, $5KWxh.SafePlugin)({
            key: $a4429cc4007a2924$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($a4429cc4007a2924$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };

});



parcelRegister("gmJvQ", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => (parcelRequire("jnbcS")).copyButtonPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jnbcS = parcelRequire("jnbcS");

});
parcelRegister("jnbcS", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => $bcfd81dd8839116d$export$ea22bdb37423f02c);

var $9RYlU = parcelRequire("9RYlU");

var $48EvW = parcelRequire("48EvW");
const $bcfd81dd8839116d$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $9RYlU.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $48EvW.processCopyButtonItems)(api?.analytics?.actions, api)
        }
    });

});
parcelRegister("9RYlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0493fd9b5d8c1e6b$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $5c8Iv = parcelRequire("5c8Iv");
function $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $0493fd9b5d8c1e6b$export$ea22bdb37423f02c() {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5c8Iv.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $5c8Iv.copyButtonPluginKey));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $etG8M.DecorationSet).empty;
            }
        }
    });
}
var $0493fd9b5d8c1e6b$export$2e2bcd8739ae039 = $0493fd9b5d8c1e6b$export$ea22bdb37423f02c;

});
parcelRegister("5c8Iv", function(module, exports) {

$parcel$export(module.exports, "copyButtonPluginKey", () => $83f9fb1f851039a9$export$e41a18c2cdafffa9);

var $gZGBX = parcelRequire("gZGBX");
const $83f9fb1f851039a9$export$e41a18c2cdafffa9 = new (0, $gZGBX.PluginKey)('copyButtonPlugin');

});


parcelRegister("48EvW", function(module, exports) {

$parcel$export(module.exports, "processCopyButtonItems", () => $79fea903647c241d$export$f61ed03c42ac876f);

var $8DYpW = parcelRequire("8DYpW");

var $3Fq5M = parcelRequire("3Fq5M");

var $40riH = parcelRequire("40riH");

var $5c8Iv = parcelRequire("5c8Iv");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $79fea903647c241d$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $79fea903647c241d$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
function $79fea903647c241d$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($79fea903647c241d$var$isNodeOptions(options)) buttonActionHandlers = {
        onClick: (0, $40riH.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $8DYpW.default).copiedToClipboard)),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseLeave: (0, $40riH.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
        onBlur: (0, $40riH.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
    };
    else buttonActionHandlers = {
        onClick: (0, $40riH.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $40riH.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $40riH.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $40riH.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $40riH.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        title: formatMessage(copyButtonState?.copied ? (0, $8DYpW.default).copiedToClipboard : (0, $8DYpW.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $79fea903647c241d$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$79fea903647c241d$var$isSeparator(copyButtonItem) ? copyButtonItem : $79fea903647c241d$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("3Fq5M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));

var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
function $2ab970d264bef26f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab970d264bef26f$var$CopyIcon = (props)=>/*#__PURE__*/ $2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
    }, props));
$2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;

});
parcelRegister("8w53e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63353af41c1756be$var$_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $63353af41c1756be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63353af41c1756be$var$CopyIcon = (props)=>/*#__PURE__*/ $63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;

});

parcelRegister("eE13R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa959fe1f5a86e24$var$CopyIcon = (props)=>/*#__PURE__*/ $aa959fe1f5a86e24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $aa959fe1f5a86e24$var$_copy.default
    }));
$aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;

});


parcelRegister("40riH", function(module, exports) {

$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $5dfad2b63514853f$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $5dfad2b63514853f$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $5dfad2b63514853f$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $5dfad2b63514853f$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $5dfad2b63514853f$export$3e0b07341e7576a);

var $gkwXh = parcelRequire("gkwXh");

var $gE8f9 = parcelRequire("gE8f9");

var $cYcwl = parcelRequire("cYcwl");

var $SYwgb = parcelRequire("SYwgb");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $5c8Iv = parcelRequire("5c8Iv");
function $5dfad2b63514853f$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $SYwgb.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $cYcwl.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $cYcwl.getAnalyticsPayload)(state, (0, $gkwXh.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $gkwXh.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $5dfad2b63514853f$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $5dfad2b63514853f$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $5dfad2b63514853f$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $SYwgb.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $cYcwl.getAnalyticsPayload)(state, (0, $gkwXh.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $gkwXh.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $SYwgb.toDOM)(contentNodeWithPos.node, schema);
            if (domNode) {
                const div = document.createElement('div');
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if ((0, $gE8f9.browser).safari && state.selection instanceof (0, $gZGBX.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $cYcwl.copyHTMLToClipboardPolyfill)(div);
                else (0, $cYcwl.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage && (0, $VSDnB.fg)('editor_a11y_aria_announcement_for_copied_status')) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $5dfad2b63514853f$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $5c8Iv.copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $5c8Iv.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});
parcelRegister("SYwgb", function(module, exports) {

$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $ca84f4e43934dc04$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $ca84f4e43934dc04$export$289411c5a7970646);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");
function $ca84f4e43934dc04$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $5r0mK.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $5r0mK.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $ca84f4e43934dc04$export$289411c5a7970646 = (node, schema)=>{
    return (0, $kCV8T.DOMSerializer).fromSchema(schema).serializeNode(node);
};

});





parcelRegister("6FArF", function(module, exports) {

$parcel$export(module.exports, "codeBlockPlugin", () => (parcelRequire("lNW3b")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lNW3b = parcelRequire("lNW3b");

});
parcelRegister("lNW3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a945efc989051c77$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8vlrc = parcelRequire("8vlrc");

var $gkwXh = parcelRequire("gkwXh");

var $9NKqk = parcelRequire("9NKqk");

var $I02Nt = parcelRequire("I02Nt");

var $fQ1NG = parcelRequire("fQ1NG");

var $aoLnV = parcelRequire("aoLnV");

var $1cYjT = parcelRequire("1cYjT");

var $1O0eH = parcelRequire("1O0eH");

var $4mEzM = parcelRequire("4mEzM");

var $lf7v6 = parcelRequire("lf7v6");

var $g1XnR = parcelRequire("g1XnR");

var $2XjHv = parcelRequire("2XjHv");

var $ddg9r = parcelRequire("ddg9r");
const $a945efc989051c77$var$codeBlockPlugin = ({ config: options, api: api })=>{
    return {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $8vlrc.codeBlock)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                copyButtonHoverNode: (0, $1cYjT.copySelectionPluginKey).getState(state).codeBlockNode
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $g1XnR.createPlugin)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        return (0, $4mEzM.createCodeBlockInputRule)(schema, api?.analytics?.actions);
                    }
                },
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $1O0eH.default)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $lf7v6.default)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $1cYjT.codeBlockCopySelectionPlugin)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $aoLnV.codeBlockAutoFullStopTransformPlugin)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $2XjHv.default)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
			 * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
			 */ insertCodeBlock: (inputMethod)=>(0, $fQ1NG.insertCodeBlockWithAnalytics)(inputMethod, api?.analytics?.actions)
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'codeblock',
                        title: formatMessage((0, $9NKqk.messages).codeblock),
                        description: formatMessage((0, $9NKqk.messages).codeblockDescription),
                        keywords: [
                            'code block'
                        ],
                        priority: 700,
                        keyshortcut: '```',
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $I02Nt.IconCode), {}),
                        action (_insert, state) {
                            const tr = (0, $fQ1NG.createInsertCodeBlockTransaction)({
                                state: state
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $gkwXh.ACTION).INSERTED,
                                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CODE_BLOCK,
                                attributes: {
                                    inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $ddg9r.getToolbarConfig)(options?.allowCopyToClipboard, api, options?.overrideLanguageName)
        }
    };
};
var $a945efc989051c77$export$2e2bcd8739ae039 = $a945efc989051c77$var$codeBlockPlugin;

});
parcelRegister("fQ1NG", function(module, exports) {

$parcel$export(module.exports, "removeCodeBlockWithAnalytics", () => $f80772afd5ddc397$export$44b4779780b25933);
$parcel$export(module.exports, "removeCodeBlock", () => $f80772afd5ddc397$export$e635d7f974817375);
$parcel$export(module.exports, "changeLanguage", () => $f80772afd5ddc397$export$61465194746e7fd2);
$parcel$export(module.exports, "copyContentToClipboardWithAnalytics", () => $f80772afd5ddc397$export$50ffc017f5e54c0);
$parcel$export(module.exports, "copyContentToClipboard", () => $f80772afd5ddc397$export$859674cc23da4522);
$parcel$export(module.exports, "resetCopiedState", () => $f80772afd5ddc397$export$3e0b07341e7576a);
$parcel$export(module.exports, "ignoreFollowingMutations", () => $f80772afd5ddc397$export$e6e93d61d1873d0c);
$parcel$export(module.exports, "resetShouldIgnoreFollowingMutations", () => $f80772afd5ddc397$export$60364cd5f5fed191);
$parcel$export(module.exports, "createInsertCodeBlockTransaction", () => $f80772afd5ddc397$export$c875ffe428b4a5f);
$parcel$export(module.exports, "insertCodeBlockWithAnalytics", () => $f80772afd5ddc397$export$a8d9c0f039b6fb43);
$parcel$export(module.exports, "toggleWordWrapStateForCodeBlockNode", () => $f80772afd5ddc397$export$160d674382436f98);

var $gkwXh = parcelRequire("gkwXh");
var $hETfp = parcelRequire("hETfp");

var $cYcwl = parcelRequire("cYcwl");

var $dAV9O = parcelRequire("dAV9O");

var $14FOE = parcelRequire("14FOE");

var $dlzPV = parcelRequire("dlzPV");

var $iYg8V = parcelRequire("iYg8V");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $buYiu = parcelRequire("buYiu");

var $1cYjT = parcelRequire("1cYjT");

var $2YkQ9 = parcelRequire("2YkQ9");

var $aYcDb = parcelRequire("aYcDb");
const $f80772afd5ddc397$export$44b4779780b25933 = (editorAnalyticsAPI)=>{
    return (0, $14FOE.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $gkwXh.ACTION).DELETED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    })($f80772afd5ddc397$export$e635d7f974817375);
};
const $f80772afd5ddc397$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $5r0mK.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $5r0mK.removeSelectedNode)(tr);
        else removeTr = (0, $5r0mK.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $f80772afd5ddc397$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language)=>(state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (0, $2YkQ9.pluginKey).getState(state)?.pos;
            if (typeof pos !== 'number') return false;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                language: language
            }).setMeta('scrollIntoView', false);
            const selection = (0, $5r0mK.isNodeSelection)(state.selection) ? (0, $gZGBX.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $f80772afd5ddc397$export$50ffc017f5e54c0 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const codeBlock = (0, $5r0mK.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
        const textContent = codeBlock && codeBlock.node.textContent;
        if (textContent) {
            (0, $cYcwl.copyToClipboard)(textContent);
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, $2YkQ9.pluginKey), {
                type: (0, $buYiu.ACTIONS).SET_COPIED_TO_CLIPBOARD,
                data: true
            });
            copyToClipboardTr.setMeta((0, $1cYjT.copySelectionPluginKey), 'remove-selection');
            if (editorAnalyticsAPI) {
                const analyticsPayload = (0, $cYcwl.getAnalyticsPayload)(state, (0, $gkwXh.ACTION).COPIED);
                if (analyticsPayload) {
                    analyticsPayload.attributes.inputMethod = (0, $gkwXh.INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.nodeType = codeBlock?.node.type.name;
                    editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
                }
            }
            if (dispatch) dispatch(copyToClipboardTr);
        }
        return true;
    };
const $f80772afd5ddc397$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $5r0mK.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $cYcwl.copyToClipboard)(textContent);
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $2YkQ9.pluginKey), {
            type: (0, $buYiu.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $1cYjT.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $f80772afd5ddc397$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $2YkQ9.pluginKey).getState(state);
    const resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $2YkQ9.pluginKey), {
            type: (0, $buYiu.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $1cYjT.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $1cYjT.copySelectionPluginKey), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $f80772afd5ddc397$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $2YkQ9.pluginKey), {
        type: (0, $buYiu.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $f80772afd5ddc397$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $2YkQ9.pluginKey), {
        type: (0, $buYiu.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $f80772afd5ddc397$export$c875ffe428b4a5f({ state: state }) {
    let { tr: tr } = state;
    const { from: from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
	 * AND it's a valid child of the grandparent node.
	 * Insert the current selection as codeBlock content unless it contains nodes other
	 * than paragraphs and inline.
	 */ const canInsertCodeBlock = (0, $dlzPV.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $dlzPV.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $aYcDb.transformToCodeBlockAction)(state, from, undefined);
    else (0, $5r0mK.safeInsert)(codeBlock.createAndFill())(tr).scrollIntoView();
    return tr;
}
function $f80772afd5ddc397$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI) {
    return (0, $14FOE.withAnalytics)(analyticsAPI, {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const tr = $f80772afd5ddc397$export$c875ffe428b4a5f({
            state: state
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $f80772afd5ddc397$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const codeBlockNode = (0, $iYg8V.findCodeBlock)(state)?.node;
        const { tr: tr } = state;
        if (!(0, $dAV9O.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $dAV9O.isCodeBlockWordWrapEnabled)(codeBlockNode);
        (0, $dAV9O.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $2YkQ9.pluginKey), {
            type: (0, $buYiu.ACTIONS).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $hETfp.PLATFORMS).WEB,
                    mode: (0, $hETfp.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };

});
parcelRegister("dAV9O", function(module, exports) {

$parcel$export(module.exports, "defaultWordWrapState", () => $bd649685760db4c7$export$dea78458f6234074);
$parcel$export(module.exports, "codeBlockWrappedStates", () => $bd649685760db4c7$export$15e74cb2b99d4f44);
$parcel$export(module.exports, "isCodeBlockWordWrapEnabled", () => $bd649685760db4c7$export$ca74aa614fc297de);
$parcel$export(module.exports, "transferCodeBlockWrappedValue", () => $bd649685760db4c7$export$8de8069131d61656);
$parcel$export(module.exports, "updateCodeBlockWrappedStateNodeKeys", () => $bd649685760db4c7$export$de41d58f29620282);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ const $bd649685760db4c7$export$dea78458f6234074 = false;
const $bd649685760db4c7$export$15e74cb2b99d4f44 = new WeakMap();
const $bd649685760db4c7$export$ca74aa614fc297de = (codeBlockNode)=>{
    const currentNodeWordWrapState = $bd649685760db4c7$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $bd649685760db4c7$export$dea78458f6234074;
};
const $bd649685760db4c7$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($bd649685760db4c7$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $bd649685760db4c7$export$ca74aa614fc297de(oldCodeBlockNode);
    $bd649685760db4c7$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $bd649685760db4c7$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
const $bd649685760db4c7$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($bd649685760db4c7$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $bd649685760db4c7$export$ca74aa614fc297de(oldCodeBlockNode);
        $bd649685760db4c7$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};

});

parcelRegister("iYg8V", function(module, exports) {

$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $99fc3db05934d60c$export$5a682e48ed34e262);
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $99fc3db05934d60c$export$d1dc8019f50dded8);
$parcel$export(module.exports, "findCodeBlock", () => $99fc3db05934d60c$export$8435d1ef36841a34);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $7vpuQ = parcelRequire("7vpuQ");
function $99fc3db05934d60c$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $99fc3db05934d60c$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($99fc3db05934d60c$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $kCV8T.Fragment).from(children);
}
function $99fc3db05934d60c$export$5a682e48ed34e262(slice) {
    slice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $kCV8T.Slice)($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
const $99fc3db05934d60c$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};
const $99fc3db05934d60c$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $5r0mK.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});

parcelRegister("buYiu", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $7078a407c881eb46$export$92a1a3b7554e9387);
const $7078a407c881eb46$export$92a1a3b7554e9387 = {
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED'
};

});

parcelRegister("1cYjT", function(module, exports) {

$parcel$export(module.exports, "copySelectionPluginKey", () => $6ba8d6376046e4d2$export$97324d26e7dfa2c5);
$parcel$export(module.exports, "codeBlockCopySelectionPlugin", () => $6ba8d6376046e4d2$export$bf11b3ffc9027f6b);
$parcel$export(module.exports, "provideVisualFeedbackForCopyButton", () => $6ba8d6376046e4d2$export$73dae478fefb96e);
$parcel$export(module.exports, "removeVisualFeedbackForCopyButton", () => $6ba8d6376046e4d2$export$1ec425a919cc0ea);

var $SYwgb = parcelRequire("SYwgb");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");
const $6ba8d6376046e4d2$export$97324d26e7dfa2c5 = new (0, $gZGBX.PluginKey)('codeBlockCopySelectionPlugin');
function $6ba8d6376046e4d2$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $SYwgb.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined,
        codeBlockNode: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd,
        codeBlockNode: codeBlockNode.node
    };
}
function $6ba8d6376046e4d2$export$bf11b3ffc9027f6b() {
    return new (0, $5KWxh.SafePlugin)({
        key: $6ba8d6376046e4d2$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($6ba8d6376046e4d2$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $6ba8d6376046e4d2$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $6ba8d6376046e4d2$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($6ba8d6376046e4d2$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $6ba8d6376046e4d2$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $etG8M.DecorationSet).create(state.doc, [
                        (0, $etG8M.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $etG8M.DecorationSet).empty;
            }
        }
    });
}
function $6ba8d6376046e4d2$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($6ba8d6376046e4d2$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $6ba8d6376046e4d2$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($6ba8d6376046e4d2$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}

});

parcelRegister("2YkQ9", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $4f79d66957b464c8$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $4f79d66957b464c8$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('codeBlockPlugin');

});

parcelRegister("aYcDb", function(module, exports) {

$parcel$export(module.exports, "transformToCodeBlockAction", () => $4b21930bfee9c992$export$92adcb8baa0906a6);
$parcel$export(module.exports, "isConvertableToCodeBlock", () => $4b21930bfee9c992$export$4b5d5858845bfcf6);

var $hPjvp = parcelRequire("hPjvp");

var $7vpuQ = parcelRequire("7vpuQ");
var $cAMv0 = parcelRequire("cAMv0");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");
function $4b21930bfee9c992$export$92adcb8baa0906a6(state, start, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $hPjvp.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $7vpuQ.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $cAMv0.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $kCV8T.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $gZGBX.TextSelection).findFrom(mapped, state.selection instanceof (0, $hPjvp.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $4b21930bfee9c992$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}

});


parcelRegister("aoLnV", function(module, exports) {

$parcel$export(module.exports, "codeBlockAutoFullStopTransformPlugin", () => $f69db0451994d458$export$67e82b3aa944d041);

var $5KWxh = parcelRequire("5KWxh");

var $iYg8V = parcelRequire("iYg8V");

var $gE8f9 = parcelRequire("gE8f9");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $f69db0451994d458$export$6114c8149cd0d98e = new (0, $gZGBX.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $f69db0451994d458$export$67e82b3aa944d041() {
    return new (0, $5KWxh.SafePlugin)({
        key: $f69db0451994d458$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $VSDnB.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $iYg8V.findCodeBlock)(oldState, trOld.selection) && !!(0, $iYg8V.findCodeBlock)(newState, trNew.selection);
            /**
			 * Mac will auto insert a fullstop when the user double taps the space key after some content.
			 * Line number decorators are assumed content so on new lines the fullstop is inserted.
			 *
			 * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
			 * - The text returned for the old state returns as a space with the selection from - 1
			 * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
			 *
			 * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
			 *
			 * There are some solutions to this problem in codemirror which can be read further here
			 * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
			 */ // both selections must be of code block early exit
            if ((0, $gE8f9.browser).mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}

});

parcelRegister("1O0eH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbdc5017516ffa56$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $k24a0 = parcelRequire("k24a0");

var $vWFRY = parcelRequire("vWFRY");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $cRGtl = parcelRequire("cRGtl");

var $57NKE = parcelRequire("57NKE");

var $2sPkS = parcelRequire("2sPkS");

var $7VkWI = parcelRequire("7VkWI");

var $34pmK = parcelRequire("34pmK");

var $epStL = parcelRequire("epStL");
const $cbdc5017516ffa56$var$ideUX = (pluginInjectionApi)=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi?.composition?.sharedState.currentState();
                if ((0, $2sPkS.isCursorInsideCodeBlock)(state) && !compositionPluginState?.isComposing) {
                    const beforeText = (0, $2sPkS.getStartOfCurrentLine)(state).text;
                    const afterText = (0, $2sPkS.getEndOfCurrentLine)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $7VkWI.isCursorBeforeClosingCharacter)(afterText) && (0, $7VkWI.isClosingCharacter)(text) && afterText.startsWith(text)) {
                        dispatch((0, $5r0mK.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $cRGtl.shouldAutoCloseBracket)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $cRGtl.getAutoClosingBracketInfo)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            const tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $5r0mK.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $34pmK.shouldAutoCloseQuote)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $34pmK.getAutoClosingQuoteInfo)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            const tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $5r0mK.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $vWFRY.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $2sPkS.isCursorInsideCodeBlock)(state)) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const $cursor = (0, $epStL.getCursor)(state.selection);
                        const beforeText = (0, $2sPkS.getStartOfCurrentLine)(state).text;
                        const afterText = (0, $2sPkS.getEndOfCurrentLine)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $cRGtl.getAutoClosingBracketInfo)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $34pmK.getAutoClosingQuoteInfo)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $2sPkS.getLineInfo)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $k24a0.filterCommand)((0, $2sPkS.isSelectionEntirelyInsideCodeBlock), (0, $57NKE.insertNewlineWithIndent)),
                'Mod-]': (0, $k24a0.filterCommand)((0, $2sPkS.isSelectionEntirelyInsideCodeBlock), (0, $57NKE.indent)(editorAnalyticsAPI)),
                'Mod-[': (0, $k24a0.filterCommand)((0, $2sPkS.isSelectionEntirelyInsideCodeBlock), (0, $57NKE.outdent)(editorAnalyticsAPI)),
                Tab: (0, $k24a0.filterCommand)((0, $2sPkS.isSelectionEntirelyInsideCodeBlock), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $2sPkS.isCursorInsideCodeBlock)(state)) return (0, $57NKE.insertIndent)(state, dispatch);
                    return (0, $57NKE.indent)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $k24a0.filterCommand)((0, $2sPkS.isSelectionEntirelyInsideCodeBlock), (0, $57NKE.outdent)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $2sPkS.isSelectionEntirelyInsideCodeBlock)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $cbdc5017516ffa56$export$2e2bcd8739ae039 = $cbdc5017516ffa56$var$ideUX;

});
parcelRegister("cRGtl", function(module, exports) {

$parcel$export(module.exports, "BRACKET_MAP", () => $06136feeb9e2eea8$export$94d363c96bda1dd9);
$parcel$export(module.exports, "shouldAutoCloseBracket", () => $06136feeb9e2eea8$export$29c04e6b1b08e223);
$parcel$export(module.exports, "getAutoClosingBracketInfo", () => $06136feeb9e2eea8$export$a40becce5a71614c);
const $06136feeb9e2eea8$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
const $06136feeb9e2eea8$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    return true;
};
const $06136feeb9e2eea8$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($06136feeb9e2eea8$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $06136feeb9e2eea8$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};

});

parcelRegister("57NKE", function(module, exports) {

$parcel$export(module.exports, "indent", () => $90b36463f76cb8c6$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $90b36463f76cb8c6$export$25755c0352544598);
$parcel$export(module.exports, "insertIndent", () => $90b36463f76cb8c6$export$ba3935b326bda6a5);
$parcel$export(module.exports, "insertNewlineWithIndent", () => $90b36463f76cb8c6$export$1b9cc0cafa2b529c);

var $gkwXh = parcelRequire("gkwXh");
var $hJkLL = parcelRequire("hJkLL");

var $gZGBX = parcelRequire("gZGBX");

var $2sPkS = parcelRequire("2sPkS");
/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $90b36463f76cb8c6$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $90b36463f76cb8c6$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $2sPkS.getLinesFromSelection)(state);
        const { tr: tr, selection: selection } = state;
        (0, $2sPkS.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $2sPkS.getLineInfo)(line);
            const indentLevel = $90b36463f76cb8c6$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $hJkLL.INDENT_DIRECTION).INDENT,
                    indentType: (0, $hJkLL.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $90b36463f76cb8c6$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $2sPkS.getLinesFromSelection)(state);
        const { tr: tr } = state;
        (0, $2sPkS.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $2sPkS.getLineInfo)(line);
            if (indentText) {
                const indentLevel = $90b36463f76cb8c6$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).FORMATTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $hJkLL.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $hJkLL.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $90b36463f76cb8c6$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $2sPkS.getStartOfCurrentLine)(state);
    const { indentToken: indentToken } = (0, $2sPkS.getLineInfo)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $90b36463f76cb8c6$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $2sPkS.getStartOfCurrentLine)(state);
    const { indentText: indentText } = (0, $2sPkS.getLineInfo)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}

});
parcelRegister("hJkLL", function(module, exports) {

$parcel$export(module.exports, "INDENT_DIRECTION", () => $305ebc54c0dfbf46$export$c8090e81b8640d69);
$parcel$export(module.exports, "INDENT_TYPE", () => $305ebc54c0dfbf46$export$303836d45647271d);
var $305ebc54c0dfbf46$export$c8090e81b8640d69 = /*#__PURE__*/ function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
    return INDENT_DIRECTION;
}({});
var $305ebc54c0dfbf46$export$303836d45647271d = /*#__PURE__*/ function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
    return INDENT_TYPE;
}({});

});

parcelRegister("2sPkS", function(module, exports) {

$parcel$export(module.exports, "isSelectionEntirelyInsideCodeBlock", () => $a5898fd1331c9a19$export$b54b55a89e362241);
$parcel$export(module.exports, "isCursorInsideCodeBlock", () => $a5898fd1331c9a19$export$cecd33f3def3e129);
$parcel$export(module.exports, "getStartOfCurrentLine", () => $a5898fd1331c9a19$export$13a3ef35664ba7de);
$parcel$export(module.exports, "getEndOfCurrentLine", () => $a5898fd1331c9a19$export$8291149050336443);
$parcel$export(module.exports, "getLinesFromSelection", () => $a5898fd1331c9a19$export$64ccdebd7526708f);
$parcel$export(module.exports, "forEachLine", () => $a5898fd1331c9a19$export$7f5b487b51da88d0);
$parcel$export(module.exports, "getLineInfo", () => $a5898fd1331c9a19$export$7af82191547c5ff7);

var $epStL = parcelRequire("epStL");
const $a5898fd1331c9a19$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $a5898fd1331c9a19$export$cecd33f3def3e129 = (state)=>!!(0, $epStL.getCursor)(state.selection) && $a5898fd1331c9a19$export$b54b55a89e362241(state);
const $a5898fd1331c9a19$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $a5898fd1331c9a19$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $a5898fd1331c9a19$export$64ccdebd7526708f(state) {
    const { pos: start } = $a5898fd1331c9a19$export$13a3ef35664ba7de(state);
    const { pos: end } = $a5898fd1331c9a19$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $a5898fd1331c9a19$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a5898fd1331c9a19$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a5898fd1331c9a19$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $a5898fd1331c9a19$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $a5898fd1331c9a19$var$TAB : $a5898fd1331c9a19$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};

});
parcelRegister("epStL", function(module, exports) {

$parcel$export(module.exports, "getCursor", () => $557f33c7a94ad6fc$export$da3f040fb23d21f);
$parcel$export(module.exports, "getAllCodeBlockNodesInDoc", () => $557f33c7a94ad6fc$export$f43d710a87ced169);
$parcel$export(module.exports, "getAllChangedCodeBlocksInTransaction", () => $557f33c7a94ad6fc$export$3fa3c149b89781e7);
function $557f33c7a94ad6fc$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $557f33c7a94ad6fc$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}
function $557f33c7a94ad6fc$export$3fa3c149b89781e7(tr) {
    const changedCodeBlocks = [];
    const nodePositions = new Set();
    tr.steps.forEach((step)=>{
        const mapResult = step.getMap();
        mapResult.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                if (node.type.name === 'codeBlock') {
                    if (!nodePositions.has(pos)) {
                        nodePositions.add(pos);
                        changedCodeBlocks.push({
                            node: node,
                            pos: pos
                        });
                    }
                }
            });
        });
    });
    if (changedCodeBlocks.length < 1) return null;
    return changedCodeBlocks;
}

});



parcelRegister("7VkWI", function(module, exports) {

$parcel$export(module.exports, "isCursorBeforeClosingCharacter", () => $af84ec8fa0c4ca49$export$1d6d73d16dcadbdd);
$parcel$export(module.exports, "isClosingCharacter", () => $af84ec8fa0c4ca49$export$ea0560eb552fb0a7);

var $cRGtl = parcelRequire("cRGtl");

var $34pmK = parcelRequire("34pmK");
const $af84ec8fa0c4ca49$var$PAIRED_CHARACTER_MAP = {
    ...(0, $cRGtl.BRACKET_MAP),
    ...(0, $34pmK.QUOTE_MAP)
};
const $af84ec8fa0c4ca49$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($af84ec8fa0c4ca49$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($af84ec8fa0c4ca49$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $af84ec8fa0c4ca49$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($af84ec8fa0c4ca49$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $af84ec8fa0c4ca49$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};

});
parcelRegister("34pmK", function(module, exports) {

$parcel$export(module.exports, "QUOTE_MAP", () => $259379cf9239ad45$export$bb64b01afeb72d0a);
$parcel$export(module.exports, "shouldAutoCloseQuote", () => $259379cf9239ad45$export$42f0a0996a9a464d);
$parcel$export(module.exports, "getAutoClosingQuoteInfo", () => $259379cf9239ad45$export$6af564d7e42f37e8);
const $259379cf9239ad45$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
const $259379cf9239ad45$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    // exclusion: when directly after a letter or quote
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/[A-Za-z0-9]$/.test(before) || /[\'\"\`]$/.test(before)) return false;
    return true;
};
const $259379cf9239ad45$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($259379cf9239ad45$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $259379cf9239ad45$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};

});



parcelRegister("4mEzM", function(module, exports) {

$parcel$export(module.exports, "createCodeBlockInputRule", () => $c3c93d4b93888c19$export$bdcd7d8080bcac7f);

var $gkwXh = parcelRequire("gkwXh");

var $93WYh = parcelRequire("93WYh");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $5r0mK = parcelRequire("5r0mK");

var $inLhu = parcelRequire("inLhu");

var $aYcDb = parcelRequire("aYcDb");
function $c3c93d4b93888c19$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI) {
    const rules = $c3c93d4b93888c19$var$getCodeBlockRules(editorAnalyticsAPI, schema);
    return new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $c3c93d4b93888c19$var$getCodeBlockRules(editorAnalyticsAPI, schema) {
    const ruleAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    // eslint-disable-next-line require-unicode-regexp
    const threeTildeRule = (0, $2Abpa.createRule)(/(?!\s)(`{3,})$/, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        if ((0, $aYcDb.isConvertableToCodeBlock)(state)) return (0, $aYcDb.transformToCodeBlockAction)(state, start, attributes);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked();
        (0, $5r0mK.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $2Abpa.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`((${(0, $d19733ae55e58348$export$a96b909f1510512b)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attributes = {};
        if (match[4]) attributes.language = match[4];
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $93WYh.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}

});

parcelRegister("lf7v6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc851c5068e92c61$export$2e2bcd8739ae039);

var $77j9j = parcelRequire("77j9j");

var $vWFRY = parcelRequire("vWFRY");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $epStL = parcelRequire("epStL");
const $bc851c5068e92c61$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $bc851c5068e92c61$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
function $bc851c5068e92c61$export$e832373cff8dec22(schema) {
    return (0, $vWFRY.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $epStL.getCursor)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn, paragraph: paragraph } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $5r0mK.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, []).setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            if ($cursor.node && (0, $77j9j.isEmptyNode)(schema)($cursor.node()) && ((0, $5r0mK.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $5r0mK.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $bc851c5068e92c61$var$deleteCurrentItem($cursor)(tr);
                $bc851c5068e92c61$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $77j9j.isEmptyNode)(schema)($cursor.node())) {
                dispatch($bc851c5068e92c61$var$deleteCurrentItem($cursor)(state?.tr));
                return true;
            }
            return false;
        }
    });
}
var $bc851c5068e92c61$export$2e2bcd8739ae039 = $bc851c5068e92c61$export$e832373cff8dec22;

});

parcelRegister("g1XnR", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $96879ea780dcf93c$export$ae829ec7b2625219);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $gE8f9 = parcelRequire("gE8f9");

var $dAV9O = parcelRequire("dAV9O");

var $9NKqk = parcelRequire("9NKqk");

var $5KWxh = parcelRequire("5KWxh");

var $8AlsS = parcelRequire("8AlsS");

var $iYg8V = parcelRequire("iYg8V");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $fQ1NG = parcelRequire("fQ1NG");

var $1F3Mx = parcelRequire("1F3Mx");

var $3JHBh = parcelRequire("3JHBh");

var $buYiu = parcelRequire("buYiu");

var $jSowG = parcelRequire("jSowG");

var $2YkQ9 = parcelRequire("2YkQ9");

var $epStL = parcelRequire("epStL");
const $96879ea780dcf93c$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = (0, $VSDnB.fg)('platform_editor_interaction_on_code_blocks') ? {
        click: ()=>{
            // Set hasHadInteraction to true on any click of code blocks, as clicks
            // on code blocks to not propagate to editor-level click handlers
            api?.core?.actions.execute(api?.interaction?.commands.handleInteraction);
        }
    } : {};
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        if ((0, $gE8f9.browser).ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $iYg8V.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if ((0, $gE8f9.browser).android && event.composed && eventInputType === 'insertCompositionText' && eventText[eventText?.length - 1] === '\n' && (0, $iYg8V.findCodeBlock)(view.state, view.state.selection)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $fQ1NG.ignoreFollowingMutations)(view.state, view.dispatch);
            return true;
        }
        if ((0, $gE8f9.browser).android) (0, $fQ1NG.resetShouldIgnoreFollowingMutations)(view.state, view.dispatch);
        return false;
    };
    return new (0, $5KWxh.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $iYg8V.findCodeBlock)(state, state.selection);
                const initialDecorations = (0, $jSowG.generateInitialDecorations)(state);
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    isNodeSelected: false,
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $etG8M.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $2YkQ9.pluginKey));
                if (meta?.type === (0, $buYiu.ACTIONS).SET_IS_WRAPPED) {
                    const node = (0, $iYg8V.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $jSowG.updateDecorationSetWithWordWrappedDecorator)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $iYg8V.findCodeBlock)(newState, tr.selection);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    const codeBlockNodes = (0, $VSDnB.fg)('editor_code_wrapping_perf_improvement_ed-25141') ? (0, $epStL.getAllChangedCodeBlocksInTransaction)(tr) : (0, $epStL.getAllCodeBlockNodesInDoc)(newState);
                    if (codeBlockNodes) {
                        (0, $dAV9O.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        // Disabled when using advanced code block for performance reasons
                        // @ts-expect-error Code block advanced cannot depend on code block
                        if (api?.codeBlockAdvanced === undefined) updatedDecorationSet = (0, $jSowG.updateCodeBlockDecorations)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $gZGBX.NodeSelection),
                        decorations: updatedDecorationSet
                    };
                    return newPluginState;
                }
                if (tr.selectionSet) {
                    const node = (0, $iYg8V.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $gZGBX.NodeSelection)
                    };
                    return newPluginState;
                }
                if (meta?.type === (0, $buYiu.ACTIONS).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if (meta?.type === (0, $buYiu.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                return pluginState;
            }
        },
        key: (0, $2YkQ9.pluginKey),
        props: {
            decorations (state) {
                return (0, $2YkQ9.pluginKey).getState(state).decorations || (0, $etG8M.DecorationSet).empty;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $9NKqk.messages).codeblock);
                    return (0, $1F3Mx.codeBlockNodeView)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $8AlsS.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>!!(target.classList.contains((0, $3JHBh.codeBlockClassNames).lineNumberWidget) || target.classList.contains((0, $3JHBh.codeBlockClassNames).gutter)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};

});
parcelRegister("1F3Mx", function(module, exports) {

$parcel$export(module.exports, "codeBlockNodeView", () => $24a8f1bce6ca5b62$export$9ea0022afafc61b7);

var $gE8f9 = parcelRequire("gE8f9");

var $dAV9O = parcelRequire("dAV9O");

var $kCV8T = parcelRequire("kCV8T");

var $fQ1NG = parcelRequire("fQ1NG");

var $cHhY4 = parcelRequire("cHhY4");

var $3JHBh = parcelRequire("3JHBh");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $24a8f1bce6ca5b62$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $24a8f1bce6ca5b62$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: (0, $3JHBh.codeBlockClassNames).container
        },
        [
            'div',
            {
                class: (0, $3JHBh.codeBlockClassNames).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: (0, $3JHBh.codeBlockClassNames).contentWrapper
            },
            [
                'div',
                {
                    class: (0, $3JHBh.codeBlockClassNames).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $3JHBh.codeBlockClassNames).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $3JHBh.codeBlockClassNames).end,
                contenteditable: 'false'
            }
        ]
    ];
class $24a8f1bce6ca5b62$export$84ecc4258da6ad44 {
    constructor(node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.formattedAriaLabel = '';
        this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                totalLineCount += (node.text.match($24a8f1bce6ca5b62$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        const { dom: dom, contentDOM: contentDOM } = (0, $kCV8T.DOMSerializer).renderSpec(document, $24a8f1bce6ca5b62$var$toDOM(node, !api?.editorDisabled?.sharedState.currentState()?.editorDisabled, formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $3JHBh.codeBlockClassNames).gutter}`);
        this.api = api;
        this.maintainDynamicGutterSize();
        // Ensure the code block node has a wrapped state.
        // Wrapped state may already exist from breakout's recreating the node.
        if (!(0, $dAV9O.codeBlockWrappedStates).has(node)) (0, $dAV9O.codeBlockWrappedStates).set(node, (0, $dAV9O.defaultWordWrapState));
        this.handleEditorDisabledChanged();
    }
    handleEditorDisabledChanged() {
        if (this.api?.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes?.length > 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel?.removeAllRanges();
                sel?.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            this.maintainDynamicGutterSize();
            if ((0, $gE8f9.browser).android) {
                this.coalesceDOMElements();
                (0, $fQ1NG.resetShouldIgnoreFollowingMutations)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $cHhY4.getPluginState)(this.view.state);
        if (pluginState?.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
const $24a8f1bce6ca5b62$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $24a8f1bce6ca5b62$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);

});
parcelRegister("cHhY4", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $64d3c53f7c9dfe7e$export$f05434c51e3762e);

var $2YkQ9 = parcelRequire("2YkQ9");
const $64d3c53f7c9dfe7e$export$f05434c51e3762e = (state)=>(0, $2YkQ9.pluginKey).getState(state);

});

parcelRegister("3JHBh", function(module, exports) {

$parcel$export(module.exports, "codeBlockClassNames", () => $b76efdb16b29b62f$export$4ffea7f3ae91d083);

var $cYeQP = parcelRequire("cYeQP");
const $b76efdb16b29b62f$export$4ffea7f3ae91d083 = {
    container: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    gutter: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    lineNumberWidget: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET
};

});


parcelRegister("jSowG", function(module, exports) {

$parcel$export(module.exports, "generateInitialDecorations", () => $036d8cfa25e09e0f$export$e39f4b987bac6a89);
$parcel$export(module.exports, "updateCodeBlockDecorations", () => $036d8cfa25e09e0f$export$af0ed0ae85f93cba);
$parcel$export(module.exports, "updateDecorationSetWithWordWrappedDecorator", () => $036d8cfa25e09e0f$export$655c2c2993b251d2);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $dAV9O = parcelRequire("dAV9O");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $3JHBh = parcelRequire("3JHBh");

var $epStL = parcelRequire("epStL");
const $036d8cfa25e09e0f$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $036d8cfa25e09e0f$export$7d62a9abd4358350 = 'decorationNodeType';
const $036d8cfa25e09e0f$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $epStL.getAllCodeBlockNodesInDoc)(state);
    return codeBlockNodes.flatMap((node)=>$036d8cfa25e09e0f$export$9955827033f49bf6($036d8cfa25e09e0f$export$e2f66570e25f0fa7(node)));
};
const $036d8cfa25e09e0f$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // Update line number decorators for changed code block nodes if new line added or line removed.
    updatedDecorationSet = $036d8cfa25e09e0f$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $036d8cfa25e09e0f$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $036d8cfa25e09e0f$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    if (!(0, $VSDnB.fg)('editor_code_wrapping_perf_improvement_ed-25141')) {
        const children = updatedDecorationSet.find(undefined, undefined, (spec)=>spec.type === $036d8cfa25e09e0f$export$feb1744c3f7a1a44);
        updatedDecorationSet = updatedDecorationSet.remove(children);
    }
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        if ((0, $VSDnB.fg)('editor_code_wrapping_perf_improvement_ed-25141')) {
            const existingWidgetsOnNode = updatedDecorationSet.find(node.pos, node.pos + node.node.nodeSize, (spec)=>spec.type === $036d8cfa25e09e0f$export$feb1744c3f7a1a44);
            const newLineAttributes = $036d8cfa25e09e0f$export$e2f66570e25f0fa7(node);
            // There will be no widgets on initialisation. If the number of existing widgets does not equal the amount of lines, regenerate the widgets.
            // There may be a case where the number of existing widgets and the number of lines are the same, that's why we track totalLineCount. This allows
            // us to know how many lines there were when the widget was created. It avoids a break in line numbers, e.g. "1, 2, 3, 5, 6". Happens on line removal.
            if (existingWidgetsOnNode.length === 0 || existingWidgetsOnNode.length !== newLineAttributes.length || existingWidgetsOnNode[0].spec.totalLineCount !== newLineAttributes.length) {
                updatedDecorationSet = updatedDecorationSet.remove(existingWidgetsOnNode);
                lineNumberDecorators.push(...$036d8cfa25e09e0f$export$9955827033f49bf6(newLineAttributes));
            }
        } else lineNumberDecorators.push(...$036d8cfa25e09e0f$export$9955827033f49bf6($036d8cfa25e09e0f$export$e2f66570e25f0fa7(node)));
    });
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $036d8cfa25e09e0f$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $036d8cfa25e09e0f$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $3JHBh.codeBlockClassNames).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        // totalLineCount is used to know whether or not to update the line numbers when a new line is added or removed.
        return (0, $etG8M.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $036d8cfa25e09e0f$export$feb1744c3f7a1a44,
            side: -1,
            totalLineCount: (0, $VSDnB.fg)('editor_code_wrapping_perf_improvement_ed-25141') ? lineAttributes.length : undefined
        });
    });
    return widgetDecorations;
};
const $036d8cfa25e09e0f$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $dAV9O.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $036d8cfa25e09e0f$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $036d8cfa25e09e0f$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $036d8cfa25e09e0f$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $dAV9O.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $036d8cfa25e09e0f$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
        // In code block advanced we don't use the node decoration - however a change in decorations
        // is how we detect updates to the word wrap. If we have no decorations attached we've
        // likely changed the breakout width with the toggle ON - we add an empty decoration to force
        // prosemirror to recognise the change so we can update in our node view. This gets filtered
        // out on the next toggle.
        if (currentWrappedBlockDecorationSet.length === 0 && (0, $gmhCD.editorExperiment)('platform_editor_advanced_code_blocks', true)) {
            const wrappedBlock = (0, $etG8M.Decoration).node(pos, pos + innerNode.nodeSize, {}, {
                type: $036d8cfa25e09e0f$export$7d62a9abd4358350
            });
            updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
                wrappedBlock
            ]);
        }
    } else {
        const wrappedBlock = (0, $etG8M.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $3JHBh.codeBlockClassNames).contentWrapped
        }, {
            type: $036d8cfa25e09e0f$export$7d62a9abd4358350
        });
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $036d8cfa25e09e0f$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $036d8cfa25e09e0f$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};

});


parcelRegister("2XjHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ebfa1c20e32ec9$export$2e2bcd8739ae039);

var $gE8f9 = parcelRequire("gE8f9");

var $2YkQ9 = parcelRequire("2YkQ9");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $86ebfa1c20e32ec9$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $86ebfa1c20e32ec9$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    if ((0, $gE8f9.browser).gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof (0, $2YkQ9.pluginKey).getState(editorState)?.pos === 'number') $86ebfa1c20e32ec9$export$b3bd6df96c05d596();
};
var $86ebfa1c20e32ec9$export$2e2bcd8739ae039 = $86ebfa1c20e32ec9$var$refreshBrowserSelectionOnChange;

});

parcelRegister("ddg9r", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $38082ca4e19f7e8f$export$86ce8f8241c20a3);

var $dAV9O = parcelRequire("dAV9O");

var $lQKNV = parcelRequire("lQKNV");
var $8DYpW = parcelRequire("8DYpW");

var $5r0mK = parcelRequire("5r0mK");

var $4IrpZ = parcelRequire("4IrpZ");

var $3Fq5M = parcelRequire("3Fq5M");

var $5Fuj0 = parcelRequire("5Fuj0");

var $bByG8 = parcelRequire("bByG8");

var $VSDnB = parcelRequire("VSDnB");

var $fQ1NG = parcelRequire("fQ1NG");

var $abQTN = parcelRequire("abQTN");

var $1cYjT = parcelRequire("1cYjT");

var $e8jIr = parcelRequire("e8jIr");

var $2YkQ9 = parcelRequire("2YkQ9");
const $38082ca4e19f7e8f$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api, overrideLanguageName)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const codeBlockState = (0, $2YkQ9.pluginKey).getState(state);
        const pos = codeBlockState?.pos ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if (node?.type !== nodeType) return;
        const isWrapped = (0, $dAV9O.isCodeBlockWordWrapEnabled)(node);
        const language = node?.attrs?.language;
        const languageList = (0, $e8jIr.createLanguageList)(overrideLanguageName ? (0, $e8jIr.DEFAULT_LANGUAGES).map((language)=>({
                ...language,
                name: overrideLanguageName(language.name)
            })) : (0, $e8jIr.DEFAULT_LANGUAGES));
        const options = languageList.map((lang)=>({
                label: lang.name,
                value: (0, $e8jIr.getLanguageIdentifier)(lang),
                alias: lang.alias
            }));
        // If language is not undefined search for it in the value and then search in the aliases
        const defaultValue = language ? options.find((option)=>option.value === language) || options.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $fQ1NG.changeLanguage)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $lQKNV.codeBlockButtonMessages).selectLanguage),
            options: options,
            filterOption: $38082ca4e19f7e8f$export$fffed505cd33273c
        };
        const separator = {
            type: 'separator'
        };
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
                // note: copyContentToClipboard contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $VSDnB.fg)('platform_editor_controls_patch_analytics_2') ? (0, $fQ1NG.copyContentToClipboardWithAnalytics)(editorAnalyticsAPI) : (0, $fQ1NG.copyContentToClipboard),
                title: formatMessage(codeBlockState.contentCopied ? (0, $lQKNV.codeBlockButtonMessages).copiedCodeToClipboard : (0, $lQKNV.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $1cYjT.provideVisualFeedbackForCopyButton),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $fQ1NG.resetCopiedState),
                onFocus: (0, $1cYjT.provideVisualFeedbackForCopyButton),
                onBlur: (0, $1cYjT.removeVisualFeedbackForCopyButton),
                hideTooltipOnClick: false,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        const deleteButton = {
            id: 'editor.codeBlock.delete',
            type: 'button',
            appearance: 'danger',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            onClick: (0, $VSDnB.fg)('platform_editor_controls_patch_analytics_2') ? (0, $fQ1NG.removeCodeBlockWithAnalytics)(editorAnalyticsAPI) : (0, $fQ1NG.removeCodeBlock),
            title: formatMessage((0, $8DYpW.default).remove),
            tabIndex: null
        };
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            supportsViewMode: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bByG8))),
            iconFallback: (0, $abQTN.WrapIcon),
            onClick: (0, $fQ1NG.toggleWordWrapStateForCodeBlockNode)(editorAnalyticsAPI),
            title: (0, $VSDnB.fg)('editor_a11y_remove_unwrap_button') ? formatMessage((0, $lQKNV.codeBlockButtonMessages).wrapCode) : isWrapped ? formatMessage((0, $lQKNV.codeBlockButtonMessages).unwrapCode) : formatMessage((0, $lQKNV.codeBlockButtonMessages).wrapCode),
            tabIndex: null,
            selected: isWrapped
        };
        return {
            title: 'CodeBlock floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $5r0mK.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: [
                languageSelect,
                separator,
                codeBlockWrapButton,
                separator,
                ...copyToClipboardItems,
                deleteButton
            ],
            scrollable: true
        };
    };
const $38082ca4e19f7e8f$export$fffed505cd33273c = (option, rawInput)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};

});
parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("5Fuj0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bce2e8cefeb7a1e23af480e5534534d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42084a291eb7f82a$var$_react = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42084a291eb7f82a$var$_delete = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("4IrpZ")));

var $42084a291eb7f82a$var$_remove = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("f5BqX")));
function $42084a291eb7f82a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42084a291eb7f82a$var$DeleteIcon = (props)=>/*#__PURE__*/ $42084a291eb7f82a$var$_react.default.createElement($42084a291eb7f82a$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $42084a291eb7f82a$var$_remove.default
    }, props));
$42084a291eb7f82a$var$DeleteIcon.Name = 'DeleteIconMigration';
var $42084a291eb7f82a$var$_default = module.exports.default = $42084a291eb7f82a$var$DeleteIcon;

});
parcelRegister("f5BqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $afc45c3418436f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $afc45c3418436f46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $afc45c3418436f46$var$_delete.default
    }));
$afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;

});


parcelRegister("bByG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4f32f9af07c407c19ef2d6f11fe69c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $872e0ce208c674fb$var$_react = $872e0ce208c674fb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $872e0ce208c674fb$var$_baseNew = $872e0ce208c674fb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $872e0ce208c674fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $872e0ce208c674fb$var$TextWrapIcon = (props)=>/*#__PURE__*/ $872e0ce208c674fb$var$_react.default.createElement($872e0ce208c674fb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$872e0ce208c674fb$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $872e0ce208c674fb$var$_default = module.exports.default = $872e0ce208c674fb$var$TextWrapIcon;

});

parcelRegister("abQTN", function(module, exports) {

$parcel$export(module.exports, "WrapIcon", () => $ce9196c0a31b9fbc$export$93a804c703d50d67);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $ce9196c0a31b9fbc$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fill: "currentColor",
            clipPath: "url(#clip0_654_431)",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })
        })
    });
const $ce9196c0a31b9fbc$export$93a804c703d50d67 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $ce9196c0a31b9fbc$var$CustomGlyph,
        label: "wrapIcon"
    });
};

});

parcelRegister("e8jIr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LANGUAGES", () => $040d5fb5cb480483$export$5a175c817b3d7154);
$parcel$export(module.exports, "getLanguageIdentifier", () => $040d5fb5cb480483$export$8ef04e71795bc8a6);
$parcel$export(module.exports, "createLanguageList", () => $040d5fb5cb480483$export$e2dc9c8f242e4ee2);

var $8Y2ZY = parcelRequire("8Y2ZY");
const $040d5fb5cb480483$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $8Y2ZY.SUPPORTED_LANGUAGES)
];
function $040d5fb5cb480483$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $040d5fb5cb480483$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $040d5fb5cb480483$export$5a175c817b3d7154;
    return $040d5fb5cb480483$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $040d5fb5cb480483$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $040d5fb5cb480483$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});





parcelRegister("3wlyh", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => (parcelRequire("IBShN")).decorationsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $IBShN = parcelRequire("IBShN");

});
parcelRegister("IBShN", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => $06578ce7d2c93dd5$export$1c07ef1814918eb5);

var $lljQA = parcelRequire("lljQA");
const $06578ce7d2c93dd5$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $lljQA.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $lljQA.hoverDecoration,
            removeDecoration: $lljQA.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $lljQA.decorationStateKey).getState(editorState);
        }
    });

});
parcelRegister("lljQA", function(module, exports) {

$parcel$export(module.exports, "decorationStateKey", () => $c34271d73c40a7ed$export$385f768f10dabdd5);
$parcel$export(module.exports, "removeDecoration", () => $c34271d73c40a7ed$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $c34271d73c40a7ed$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $c34271d73c40a7ed$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");
const $c34271d73c40a7ed$export$385f768f10dabdd5 = new (0, $gZGBX.PluginKey)('decorationPlugin');
var $c34271d73c40a7ed$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $c34271d73c40a7ed$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    if ((0, $VSDnB.fg)('platform_editor_remove_slow_table_transactions')) {
        const { decoration: decoration } = $c34271d73c40a7ed$export$385f768f10dabdd5.getState(state);
        if (decoration && dispatch) {
            dispatch(tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
                action: 1
            }));
            return true;
        }
    } else if (dispatch) {
        dispatch(tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $c34271d73c40a7ed$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $gZGBX.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $5r0mK.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $etG8M.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $c34271d73c40a7ed$export$2e2bcd8739ae039 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $c34271d73c40a7ed$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                const meta = tr.getMeta($c34271d73c40a7ed$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data
                        };
                    case 1:
                        return {
                            decoration: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $c34271d73c40a7ed$export$385f768f10dabdd5.getState(state);
                if (decoration) return (0, $etG8M.DecorationSet).create(doc, [
                    decoration
                ]);
                return null;
            }
        }
    });
};

});



parcelRegister("6mXgW", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => (parcelRequire("2U5eR")).editorDisabledPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2U5eR = parcelRequire("2U5eR");

});
parcelRegister("2U5eR", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => $c155798ed80d2453$export$db5fb3a4c4390f03);

var $7nRxN = parcelRequire("7nRxN");

var $5KWxh = parcelRequire("5KWxh");

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");
const $c155798ed80d2453$var$pluginKey = new (0, $gZGBX.PluginKey)('editorDisabledPlugin');
function $c155798ed80d2453$var$reducer(_pluginState, meta) {
    return meta;
}
const { createPluginState: $c155798ed80d2453$var$createPluginState, getPluginState: $c155798ed80d2453$var$getPluginState } = (0, $aOimD.pluginFactory)($c155798ed80d2453$var$pluginKey, $c155798ed80d2453$var$reducer);
const $c155798ed80d2453$var$scheduleEditorDisabledUpdate = (0, $7nRxN.default)((view)=>{
    if ($c155798ed80d2453$var$getPluginState(view.state).editorDisabled !== !view.editable) {
        const tr = view.state.tr.setMeta($c155798ed80d2453$var$pluginKey, {
            editorDisabled: !view.editable
        });
        tr.setMeta('isLocal', true);
        view.dispatch(tr);
    }
});
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $c155798ed80d2453$var$createPlugin(dispatch) {
    return new (0, $5KWxh.SafePlugin)({
        key: $c155798ed80d2453$var$pluginKey,
        state: $c155798ed80d2453$var$createPluginState(dispatch, {
            editorDisabled: false
        }),
        view: ()=>{
            return {
                update (view) {
                    $c155798ed80d2453$var$scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    $c155798ed80d2453$var$scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $c155798ed80d2453$export$db5fb3a4c4390f03 = ()=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $c155798ed80d2453$var$pluginKey.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return pluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$c155798ed80d2453$var$createPlugin(dispatch)
                }
            ]
    });

});


parcelRegister("2fcyF", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => (parcelRequire("1bV4T")).floatingToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1bV4T = parcelRequire("1bV4T");

});
parcelRegister("1bV4T", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => $e87d40a96b12aa71$export$baed971c987bc0e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $gkwXh = parcelRequire("gkwXh");

var $1v3g5 = parcelRequire("1v3g5");

var $9pOon = parcelRequire("9pOon");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9Egzu = parcelRequire("9Egzu");

var $5KWxh = parcelRequire("5KWxh");

var $4N9VB = parcelRequire("4N9VB");

var $9LY0t = parcelRequire("9LY0t");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $c2Qhg = parcelRequire("c2Qhg");

var $3FjQE = parcelRequire("3FjQE");

var $bZuB7 = parcelRequire("bZuB7");

var $8gLmf = parcelRequire("8gLmf");

var $9NIbV = parcelRequire("9NIbV");

var $lPuFS = parcelRequire("lPuFS");

var $g0hjU = parcelRequire("g0hjU");

var $7uxXk = parcelRequire("7uxXk");

var $eFn4q = parcelRequire("eFn4q");
const $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $5r0mK.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $gZGBX.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $lPuFS.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $e87d40a96b12aa71$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).ERRORED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $gkwXh.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $e87d40a96b12aa71$var$filterUndefined(x) {
    return !!x;
}
const $e87d40a96b12aa71$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$e87d40a96b12aa71$export$5c1ec0ef773ca0cc({
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $8gLmf.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $3FjQE.default)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $3FjQE.forceFocusSelector
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>(0, $c2Qhg.copyNode)(nodeType, api?.analytics?.actions, inputMethod)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const _hasHadInteraction = api?.interaction?.sharedState.currentState()?.hasHadInteraction;
            const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
            let configWithNodeInfo;
            if ((0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) {
                const hasHadInteraction = (0, $VSDnB.fg)('platform_editor_interaction_api_refactor') ? interactionState !== 'hasNotHadInteraction' : _hasHadInteraction !== false;
                configWithNodeInfo = hasHadInteraction ? $e87d40a96b12aa71$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            } else configWithNodeInfo = $e87d40a96b12aa71$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $9NIbV.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($e87d40a96b12aa71$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $e87d40a96b12aa71$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    // floatingToolbar
    const configWithNodeInfo = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'floatingToolbar.configWithNodeInfo');
    const floatingToolbarData = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'floatingToolbar.floatingToolbarData');
    // editorDisabled
    const editorDisabledState = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorDisabled.editorDisabled');
    // editorViewMode
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    // userIntent
    const currentUserIntent = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'userIntent.currentUserIntent');
    // blockControls
    const isDragging = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    'blockControls.isDragging');
    // isMenuOpen
    const isMenuOpen = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    'blockControls.isMenuOpen');
    return {
        configWithNodeInfo: configWithNodeInfo,
        floatingToolbarData: floatingToolbarData,
        editorDisabled: editorDisabledState,
        mode: mode,
        currentUserIntent: currentUserIntent,
        isDragging: isDragging,
        isMenuOpen: isMenuOpen
    };
}, (pluginInjectionApi)=>{
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState, blockControlsState: // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    blockControlsState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent',
        // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
        'blockControls'
    ]);
    return {
        configWithNodeInfo: floatingToolbarState?.configWithNodeInfo,
        floatingToolbarData: floatingToolbarState?.floatingToolbarData,
        editorDisabled: editorDisabledState?.editorDisabled,
        mode: editorViewModeState?.mode,
        currentUserIntent: userIntentState?.currentUserIntent,
        isDragging: blockControlsState?.isDragging,
        isMenuOpen: blockControlsState?.isMenuOpen
    };
});
function $e87d40a96b12aa71$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { configWithNodeInfo: configWithNodeInfo, currentUserIntent: currentUserIntent, editorDisabled: editorDisabled, floatingToolbarData: floatingToolbarData, isDragging: isDragging, isMenuOpen: isMenuOpen, mode: mode } = $e87d40a96b12aa71$var$useSharedState(pluginInjectionApi);
    if ((0, $1v3g5.isSSR)() && (0, $gmhCD.editorExperiment)('platform_editor_hide_floating_toolbar_in_ssr', true, {
        exposure: true
    })) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if ((0, $VSDnB.fg)('platform_editor_user_intent_plugin')) {
        if (currentUserIntent === 'dragging') return null;
    // TODO: ED-27539 - This feature is unreleased and rendering logic needs to be move userIntentState which is not ready yet
    // if (blockControlsState?.isMenuOpen && editorExperiment('platform_editor_controls', 'variant1')) {
    // 	return null;
    // }
    } else {
        if (isDragging) return null;
        if (isMenuOpen && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) return null;
    }
    const { config: config, node: node } = configWithNodeInfo;
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $e87d40a96b12aa71$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isInViewMode = mode === 'view';
    if (!targetRef || editorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $eFn4q.consolidateOverflowDropdownItems)(overflowDropdownItems);
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
    const confirmButtonItem = confirmDialogForItem ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    toolbarItems[confirmDialogForItem] : undefined;
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9pOon.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
                ariaLabel: title,
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
                    providerFactory: providerFactory,
                    providers: [
                        'extensionProvider'
                    ],
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uxXk.ToolbarLoader), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0hjU.ConfirmationModal), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                onClose: ()=>{
                    dispatchCommand((0, $bZuB7.hideConfirmDialog)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $e87d40a96b12aa71$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($e87d40a96b12aa71$var$filterUndefined)
    };
    return config;
}
function $e87d40a96b12aa71$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                if (config.__suppressAllToolbars && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $5KWxh.SafePlugin)({
        key: $e87d40a96b12aa71$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                // Use this point to preload the UI
                (0, $7uxXk.ToolbarLoader).preload();
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: apply
        }
    });
}

});
parcelRegister("c2Qhg", function(module, exports) {

$parcel$export(module.exports, "copyNode", () => $a08d499b9c4de77f$export$978ef9948557240e);

var $gE8f9 = parcelRequire("gE8f9");

var $cYcwl = parcelRequire("cYcwl");

var $SYwgb = parcelRequire("SYwgb");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $a08d499b9c4de77f$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $SYwgb.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $SYwgb.toDOM)(contentNodeWithPos.node, schema);
        if (domNode) {
            const div = document.createElement('div');
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if ((0, $gE8f9.browser).safari && tr.selection instanceof (0, $gZGBX.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $cYcwl.copyHTMLToClipboardPolyfill)(div);
            else (0, $cYcwl.copyHTMLToClipboard)(div);
        }
        if (editorAnalyticsApi && (0, $VSDnB.fg)('platform_editor_controls_patch_analytics_2')) {
            const analyticsPayload = (0, $cYcwl.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };

});

parcelRegister("3FjQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $678344aaf110db44$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $678344aaf110db44$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $678344aaf110db44$export$a2ced8424a9be595);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $678344aaf110db44$export$ded15a80767f6af7 = new (0, $gZGBX.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $678344aaf110db44$export$2e2bcd8739ae039 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $678344aaf110db44$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($678344aaf110db44$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $678344aaf110db44$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($678344aaf110db44$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $678344aaf110db44$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $678344aaf110db44$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($678344aaf110db44$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("bZuB7", function(module, exports) {

$parcel$export(module.exports, "showConfirmDialog", () => $631febdcbf84957f$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $631febdcbf84957f$export$5a3c1357cfd1045c);

var $6ka1z = parcelRequire("6ka1z");
const $631febdcbf84957f$export$c0076bd4afc29e7a = (buttonIndex)=>(0, $6ka1z.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $631febdcbf84957f$export$5a3c1357cfd1045c = ()=>(0, $6ka1z.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("6ka1z", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $5a9052fdd4f97f79$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $5a9052fdd4f97f79$export$8d4021544bdece00);

var $aOimD = parcelRequire("aOimD");

var $9NIbV = parcelRequire("9NIbV");

var $iT6WM = parcelRequire("iT6WM");
const { createPluginState: $5a9052fdd4f97f79$export$656c7661095efe2e, createCommand: $5a9052fdd4f97f79$export$8d4021544bdece00, getPluginState: $5a9052fdd4f97f79$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $9NIbV.pluginKey), (0, $iT6WM.reducer));

});
parcelRegister("9NIbV", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $9835a39d0d550488$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $9835a39d0d550488$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('floatingToolbarData');

});

parcelRegister("iT6WM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $ac14a01a9a722e87$export$1650419e431d3ba3);
const $ac14a01a9a722e87$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("8gLmf", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a3032e30bd40b708$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $6ka1z = parcelRequire("6ka1z");

var $9NIbV = parcelRequire("9NIbV");
const $a3032e30bd40b708$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $5KWxh.SafePlugin)({
        state: (0, $6ka1z.createPluginState)(dispatch, {}),
        key: (0, $9NIbV.pluginKey)
    });
};

});

parcelRegister("lPuFS", function(module, exports) {

$parcel$export(module.exports, "findNode", () => $a9058a265ed6ea0d$export$5b92d7a8b5d33ee2);
function $a9058a265ed6ea0d$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});

parcelRegister("g0hjU", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $06e379d09049f01c$export$1f33f980da756c46);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $i8Qvm = parcelRequire("i8Qvm");

var $f9HzI = parcelRequire("f9HzI");

var $gKJRF = parcelRequire("gKJRF");
const $06e379d09049f01c$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f9HzI.CheckboxModal), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gKJRF.SimpleModal), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: renderModel(options?.isReferentialityDialog)
    }) : null;
};
const $06e379d09049f01c$export$1f33f980da756c46 = (0, $8RXs9.default)($06e379d09049f01c$var$ConfirmationModalImpl);

});
parcelRegister("f9HzI", function(module, exports) {

$parcel$export(module.exports, "CheckboxModal", () => $2670a3f256ccd0e9$export$9c828de50258a892);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $kkJfY = parcelRequire("kkJfY");

var $5K8Ey = parcelRequire("5K8Ey");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dS3PR = parcelRequire("dS3PR");
const $2670a3f256ccd0e9$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $5uXOq.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $5K8Ey.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $5uXOq.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
            id: id,
            children: formatMessage((0, $5K8Ey.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        children: options?.message
                    }),
                    !!childrenInfo?.length && /*#__PURE__*/ (0, $2OMIu.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkJfY.default), {
                            isChecked: isChecked,
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("5K8Ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aa315cef11144c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1aa315cef11144c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "a floating toolbar's aria label"
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});

});


parcelRegister("gKJRF", function(module, exports) {

$parcel$export(module.exports, "SimpleModal", () => $09c3f293e9a8351d$export$f96c193e316d2274);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $5K8Ey = parcelRequire("5K8Ey");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dS3PR = parcelRequire("dS3PR");
const $09c3f293e9a8351d$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $5K8Ey.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $5K8Ey.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    as: "p",
                    children: options?.message
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("7uxXk", function(module, exports) {

$parcel$export(module.exports, "ToolbarLoader", () => $f13a9dac652e34d3$export$8f0e0160298415aa);

var $4qBtX = parcelRequire("4qBtX");

const $f13a9dac652e34d3$export$8f0e0160298415aa = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5JMS2")).then((mod)=>mod.default),
    loading: ()=>null
});

});
parcelRegister("5JMS2", function(module, exports) {

let $42d71067fde541d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42d71067fde541d6$var$load("76n7a"),
    $42d71067fde541d6$var$load("l253H"),
    $42d71067fde541d6$var$load("KCWes")
]).then(()=>parcelRequire('4vSmI'));

});


parcelRegister("eFn4q", function(module, exports) {

$parcel$export(module.exports, "consolidateOverflowDropdownItems", () => $00caf0f0e1fb7061$export$2f5751d7b477f660);
const $00caf0f0e1fb7061$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};

});



parcelRegister("7bJco", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => (parcelRequire("4y8T6")).focusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4y8T6 = parcelRequire("4y8T6");

});
parcelRegister("4y8T6", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => $3a3c0b11abeb4fe9$export$78540d08bd386fba);

var $6N2wx = parcelRequire("6N2wx");
const $3a3c0b11abeb4fe9$export$78540d08bd386fba = ({ api: api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $6N2wx.key).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $6N2wx.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("6N2wx", function(module, exports) {

$parcel$export(module.exports, "key", () => $e2f10d9885742530$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $e2f10d9885742530$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $e2f10d9885742530$export$df61b30b684217c0 = new (0, $gZGBX.PluginKey)('focusPluginHandler');
const $e2f10d9885742530$export$ae829ec7b2625219 = ()=>new (0, $5KWxh.SafePlugin)({
        key: $e2f10d9885742530$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($e2f10d9885742530$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });

});



parcelRegister("2DIrX", function(module, exports) {

$parcel$export(module.exports, "historyPlugin", () => (parcelRequire("5kxA9")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5kxA9 = parcelRequire("5kxA9");

});
parcelRegister("5kxA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb056ac66a521c1$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $aOimD = parcelRequire("aOimD");

var $7c8yA = parcelRequire("7c8yA");

var $8Hc3a = parcelRequire("8Hc3a");

var $lnSB9 = parcelRequire("lnSB9");

var $fb5I4 = parcelRequire("fb5I4");
const $fbb056ac66a521c1$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $fbb056ac66a521c1$var$createPluginState, getPluginState: $fbb056ac66a521c1$var$getPluginState } = (0, $aOimD.pluginFactory)((0, $fb5I4.historyPluginKey), (0, $8Hc3a.default));
const $fbb056ac66a521c1$var$createPlugin = (dispatch)=>new (0, $5KWxh.SafePlugin)({
        state: $fbb056ac66a521c1$var$createPluginState(dispatch, $fbb056ac66a521c1$var$getInitialState),
        key: (0, $fb5I4.historyPluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false)) {
                const pmHistoryPluginState = (0, $lnSB9.getPmHistoryPluginState)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $fbb056ac66a521c1$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $7c8yA.HistoryActionTypes).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $fb5I4.historyPluginKey), action);
                }
            }
        }
    });
const $fbb056ac66a521c1$var$historyPlugin = ({ api: api })=>({
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$fbb056ac66a521c1$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $fb5I4.historyPluginKey).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $lnSB9.getPmHistoryPluginState)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: done?.eventCount ?? 0
                },
                undone: {
                    eventCount: undone?.eventCount ?? 0
                }
            };
        },
        commands: {
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = api?.history.sharedState.currentState() ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $7c8yA.HistoryActionTypes).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $fb5I4.historyPluginKey), action);
            }
        }
    });
var $fbb056ac66a521c1$export$2e2bcd8739ae039 = $fbb056ac66a521c1$var$historyPlugin;

});
parcelRegister("7c8yA", function(module, exports) {

$parcel$export(module.exports, "HistoryActionTypes", () => $14a9c7d92e1cbfec$export$324bf1d9598f1f30);
var $14a9c7d92e1cbfec$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});

});

parcelRegister("8Hc3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fe0207d549ed61$export$2e2bcd8739ae039);

var $7c8yA = parcelRequire("7c8yA");
const $89fe0207d549ed61$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $7c8yA.HistoryActionTypes).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $89fe0207d549ed61$export$2e2bcd8739ae039 = $89fe0207d549ed61$var$reducer;

});

parcelRegister("lnSB9", function(module, exports) {

$parcel$export(module.exports, "getPmHistoryPluginState", () => $dea5962b6e26cf49$export$6bcebd7b5d7b9325);

var $77j9j = parcelRequire("77j9j");

var $VSDnB = parcelRequire("VSDnB");
const $dea5962b6e26cf49$export$37e0e4eb94b3734e = (state)=>{
    return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (plugin)=>plugin.key === (0, $77j9j.pmHistoryPluginKey));
};
// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $dea5962b6e26cf49$var$fakePluginKey = {
    key: (0, $77j9j.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $77j9j.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $77j9j.pmHistoryPluginKey));
    }
};
const $dea5962b6e26cf49$export$6bcebd7b5d7b9325 = (state)=>{
    if ((0, $VSDnB.fg)('platform_editor_improve_history_state_performance')) return $dea5962b6e26cf49$var$fakePluginKey.getState(state);
    const pmHistoryPlugin = $dea5962b6e26cf49$export$37e0e4eb94b3734e(state);
    if (!pmHistoryPlugin) return;
    return pmHistoryPlugin.getState(state);
};

});

parcelRegister("fb5I4", function(module, exports) {

$parcel$export(module.exports, "historyPluginKey", () => $2c27a7bd386b5f30$export$8869884044241c3c);

var $gZGBX = parcelRequire("gZGBX");
const $2c27a7bd386b5f30$export$8869884044241c3c = new (0, $gZGBX.PluginKey)('historyPlugin');

});



parcelRegister("gha0X", function(module, exports) {

$parcel$export(module.exports, "insertBlockPlugin", () => (parcelRequire("6cMFS")).insertBlockPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6cMFS = parcelRequire("6cMFS");

});
parcelRegister("6cMFS", function(module, exports) {

$parcel$export(module.exports, "insertBlockPlugin", () => $d5f878cb0ba60e19$export$b7df1817ade19df9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $hd31W = parcelRequire("hd31W");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9Egzu = parcelRequire("9Egzu");

var $kXC89 = parcelRequire("kXC89");

var $9LY0t = parcelRequire("9LY0t");

var $8QX3X = parcelRequire("8QX3X");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $e17Md = parcelRequire("e17Md");

var $i3rM2 = parcelRequire("i3rM2");
const $d5f878cb0ba60e19$export$7e87882fdef9bc6 = (toolbarSize, appearance)=>{
    // Different button numbers for full-page to better match full page toolbar breakpoints
    if (appearance === 'full-page' && (0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $kXC89.ToolbarSize).XXL:
        case (0, $kXC89.ToolbarSize).XL:
        case (0, $kXC89.ToolbarSize).L:
            return 7;
        case (0, $kXC89.ToolbarSize).M:
            return 3;
        default:
            return 0;
    }
    if ((0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes')) switch(toolbarSize){
        case (0, $kXC89.ToolbarSize).XXL:
        case (0, $kXC89.ToolbarSize).XL:
            return 7;
        case (0, $kXC89.ToolbarSize).L:
            return 5;
        case (0, $kXC89.ToolbarSize).M:
        case (0, $kXC89.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
    else switch(toolbarSize){
        case (0, $kXC89.ToolbarSize).XXL:
        case (0, $kXC89.ToolbarSize).XL:
        case (0, $kXC89.ToolbarSize).L:
        case (0, $kXC89.ToolbarSize).M:
            return 7;
        case (0, $kXC89.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
};
/**
 * Wrapper over insertBlockTypeWithAnalytics to autobind toolbar input method
 * @param name Block name
 */ function $d5f878cb0ba60e19$var$handleInsertBlockType(insertCodeBlock, insertPanel, insertBlockQuote) {
    return (name)=>{
        if (name === (0, $8QX3X.CODE_BLOCK).name && insertCodeBlock) return insertCodeBlock((0, $gkwXh.INPUT_METHOD).TOOLBAR);
        if (name === (0, $8QX3X.PANEL).name && insertPanel) return insertPanel((0, $gkwXh.INPUT_METHOD).TOOLBAR);
        if (name === (0, $8QX3X.BLOCK_QUOTE).name && insertBlockQuote) return insertBlockQuote((0, $gkwXh.INPUT_METHOD).INSERT_MENU);
        return ()=>false;
    };
}
function $d5f878cb0ba60e19$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $d5f878cb0ba60e19$export$b7df1817ade19df9 = ({ config: options = {}, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem })=>{
        const renderNode = (providers)=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)($d5f878cb0ba60e19$var$ToolbarInsertBlockWithInjectionApi, {
                pluginInjectionApi: api,
                editorView: editorView,
                editorActions: editorActions,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                toolbarSize: toolbarSize,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                isLastItem: isLastItem,
                providers: providers,
                options: options,
                appearance: options.appearance
            });
        };
        if ((0, $gmhCD.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return /*#__PURE__*/ (0, $2OMIu.jsx)($d5f878cb0ba60e19$var$ToolbarInsertBlockWithInjectionApi, {
            pluginInjectionApi: api,
            editorView: editorView,
            editorActions: editorActions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            isLastItem: isLastItem,
            options: options,
            appearance: options.appearance
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Egzu.WithProviders), {
            providerFactory: providerFactory,
            providers: [
                'emojiProvider'
            ],
            renderNode: renderNode
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'insertBlock',
        component: primaryToolbarComponent
    });
    const plugin = {
        name: 'insertBlock',
        actions: {
            toggleAdditionalMenu: ()=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $e17Md.toggleInsertBlockPmKey), true);
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState || ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '')) return;
            const toggleInsertBlockPluginState = (0, $e17Md.toggleInsertBlockPmKey).getState(editorState);
            return {
                showElementBrowser: toggleInsertBlockPluginState?.showElementBrowser || false
            };
        },
        usePluginHook () {
            (0, $5uXOq.useEffect)(()=>{
                // This is to optimise the UI so that when the user first clicks on the insert
                // menu it opens instantly. As we're delaying the loading this won't affect the
                // initial editor rendering metrics.
                $d5f878cb0ba60e19$var$delayUntilIdle(()=>{
                    (0, $hd31W.default).preload();
                });
            }, []);
        },
        pmPlugins: ()=>{
            [
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '');
            const plugins = [];
            plugins.push({
                name: 'toggleInsertBlockPmPlugin',
                plugin: ()=>(0, $e17Md.toggleInsertBlockPmPlugin)()
            });
            return plugins;
        },
        pluginsOptions: {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
    return plugin;
};
const $d5f878cb0ba60e19$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const emojiProviderSelector = (0, $9LY0t.useSharedPluginStateSelector)(api, 'emoji.emojiProvider', {
        disabled: (0, $gmhCD.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)
    });
    const showMediaPicker = (0, $9LY0t.useSharedPluginStateSelector)(api, 'media.showMediaPicker');
    const mediaAllowsUploads = (0, $9LY0t.useSharedPluginStateSelector)(api, 'media.allowsUploads');
    const showElementBrowser = (0, $9LY0t.useSharedPluginStateSelector)(api, 'insertBlock.showElementBrowser');
    const isTypeAheadAllowed = (0, $9LY0t.useSharedPluginStateSelector)(api, 'typeAhead.isAllowed');
    const mentionProvider = (0, $9LY0t.useSharedPluginStateSelector)(api, 'mention.mentionProvider');
    const canInsertMention = (0, $9LY0t.useSharedPluginStateSelector)(api, 'mention.canInsertMention');
    const dateEnabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'date.isInitialised');
    const placeholderTextAllowInserting = (0, $9LY0t.useSharedPluginStateSelector)(api, 'placeholderText.allowInserting');
    const connectivityMode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const imageUploadEnabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'imageUpload.enabled');
    const availableWrapperBlockTypes = (0, $9LY0t.useSharedPluginStateSelector)(api, 'blockType.availableWrapperBlockTypes');
    const canInsertLink = (0, $9LY0t.useSharedPluginStateSelector)(api, 'hyperlink.canInsertLink');
    const activeLinkMark = (0, $9LY0t.useSharedPluginStateSelector)(api, 'hyperlink.activeLinkMark');
    return {
        emojiProviderSelector: emojiProviderSelector,
        showMediaPicker: showMediaPicker,
        mediaAllowsUploads: mediaAllowsUploads,
        showElementBrowser: showElementBrowser,
        isTypeAheadAllowed: isTypeAheadAllowed,
        mentionProvider: mentionProvider,
        canInsertMention: canInsertMention,
        dateEnabled: dateEnabled,
        placeholderTextAllowInserting: placeholderTextAllowInserting,
        connectivityMode: connectivityMode,
        imageUploadEnabled: imageUploadEnabled,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        canInsertLink: canInsertLink,
        activeLinkMark: activeLinkMark
    };
}, (api)=>{
    const { dateState: dateState, hyperlinkState: hyperlinkState, imageUploadState: imageUploadState, mentionState: mentionState, emojiState: emojiState, blockTypeState: blockTypeState, mediaState: mediaState, typeAheadState: typeAheadState, placeholderTextState: placeholderTextState, insertBlockState: insertBlockState, connectivityState: connectivityState } = (0, $awTmI.useSharedPluginState)(api, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText',
        'insertBlock',
        'connectivity'
    ]);
    return {
        emojiProviderSelector: emojiState?.emojiProvider,
        showMediaPicker: mediaState?.showMediaPicker,
        mediaAllowsUploads: mediaState?.allowsUploads,
        showElementBrowser: insertBlockState?.showElementBrowser,
        isTypeAheadAllowed: typeAheadState?.isAllowed,
        mentionProvider: mentionState?.mentionProvider,
        canInsertMention: mentionState?.canInsertMention,
        dateEnabled: dateState?.isInitialised,
        placeholderTextAllowInserting: placeholderTextState?.allowInserting,
        connectivityMode: connectivityState?.mode,
        imageUploadEnabled: imageUploadState?.enabled,
        availableWrapperBlockTypes: blockTypeState?.availableWrapperBlockTypes,
        canInsertLink: hyperlinkState?.canInsertLink,
        activeLinkMark: hyperlinkState?.activeLinkMark
    };
});
function $d5f878cb0ba60e19$var$ToolbarInsertBlockWithInjectionApi({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem, providers: providers, pluginInjectionApi: pluginInjectionApi, options: options, appearance: appearance }) {
    const buttons = $d5f878cb0ba60e19$export$7e87882fdef9bc6(toolbarSize, appearance);
    const { emojiProviderSelector: emojiProviderSelector, showMediaPicker: showMediaPicker, mediaAllowsUploads: mediaAllowsUploads, showElementBrowser: showElementBrowser, isTypeAheadAllowed: isTypeAheadAllowed, mentionProvider: mentionProvider, canInsertMention: canInsertMention, dateEnabled: dateEnabled, placeholderTextAllowInserting: placeholderTextAllowInserting, connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled, availableWrapperBlockTypes: availableWrapperBlockTypes, canInsertLink: canInsertLink, activeLinkMark: activeLinkMark } = $d5f878cb0ba60e19$var$useSharedState(pluginInjectionApi);
    const emojiProviderPromise = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'emoji.emojiProviderPromise', {
        disabled: !(0, $gmhCD.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)
    });
    const getEmojiProvider = ()=>{
        if (emojiProviderSelector) return Promise.resolve(emojiProviderSelector);
    };
    const emojiProvider = (0, $gmhCD.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true, {
        exposure: true
    }) ? emojiProviderPromise : getEmojiProvider();
    const onShowMediaPicker = (mountInfo)=>{
        if (!showMediaPicker) return;
        if ((0, $VSDnB.fg)('platform_editor_add_media_from_url_rollout')) pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.mediaInsert?.commands.showMediaInsertPopup(mountInfo));
        else showMediaPicker();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3rM2.default), {
        showElementBrowser: showElementBrowser || false,
        pluginInjectionApi: pluginInjectionApi,
        buttons: buttons,
        isReducedSpacing: isToolbarReducedSpacing,
        isDisabled: disabled,
        isTypeAheadAllowed: Boolean(isTypeAheadAllowed),
        editorView: editorView,
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        mentionsSupported: !!mentionProvider,
        mentionsDisabled: !canInsertMention,
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        dateEnabled: !!dateEnabled,
        placeholderTextEnabled: !!placeholderTextAllowInserting,
        layoutSectionEnabled: Boolean(pluginInjectionApi?.layout),
        expandEnabled: !!options.allowExpand,
        mediaUploadsEnabled: mediaAllowsUploads ?? undefined,
        onShowMediaPicker: onShowMediaPicker,
        mediaSupported: mediaAllowsUploads !== undefined,
        isEditorOffline: connectivityMode === 'offline',
        imageUploadSupported: !!pluginInjectionApi?.imageUpload,
        imageUploadEnabled: imageUploadEnabled,
        handleImageUpload: pluginInjectionApi?.imageUpload?.actions.startUpload,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        linkSupported: canInsertLink !== undefined,
        linkDisabled: !canInsertLink || !!activeLinkMark,
        emojiDisabled: !emojiProvider,
        emojiProvider: emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        onInsertBlockType: $d5f878cb0ba60e19$var$handleInsertBlockType(pluginInjectionApi?.codeBlock?.actions.insertCodeBlock, pluginInjectionApi?.panel?.actions.insertPanel, pluginInjectionApi?.blockType?.actions.insertBlockQuote),
        onInsertMacroFromMacroBrowser: pluginInjectionApi?.extension?.actions.insertMacroFromMacroBrowser,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        insertMenuItems: options.insertMenuItems,
        editorActions: editorActions,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        showElementBrowserLink: options.showElementBrowserLink,
        showSeparator: !isLastItem && toolbarSize <= (0, $kXC89.ToolbarSize).S,
        editorAppearance: options.appearance
    });
}

});
parcelRegister("hd31W", function(module, exports) {

$parcel$export(module.exports, "default", () => $968bc7c024db8f2b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4qBtX = parcelRequire("4qBtX");

var $eZJjh = parcelRequire("eZJjh");
function $968bc7c024db8f2b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $968bc7c024db8f2b$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $968bc7c024db8f2b$var$ElementBrowserLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("6pm7U")).then((module)=>module.default),
    loading: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $968bc7c024db8f2b$var$spinnerContainer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
            size: "medium",
            interactionName: "element-browser-spinner"
        }))
});
var $968bc7c024db8f2b$export$2e2bcd8739ae039 = $968bc7c024db8f2b$var$ElementBrowserLoader;

});
parcelRegister("6pm7U", function(module, exports) {

let $4aa63dc3bcb0aa62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4aa63dc3bcb0aa62$var$load("4FFTC").then(()=>parcelRequire('3sddq'));

});


parcelRegister("e17Md", function(module, exports) {

$parcel$export(module.exports, "toggleInsertBlockPmKey", () => $9ce574ee41ab9658$export$fef912314604ae84);
$parcel$export(module.exports, "toggleInsertBlockPmPlugin", () => $9ce574ee41ab9658$export$6f80226cf0aae60e);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $9ce574ee41ab9658$export$fef912314604ae84 = new (0, $gZGBX.PluginKey)('toggleInsertBlockPmKey');
const $9ce574ee41ab9658$export$6f80226cf0aae60e = ()=>new (0, $5KWxh.SafePlugin)({
        key: $9ce574ee41ab9658$export$fef912314604ae84,
        state: {
            init () {
                return {
                    showElementBrowser: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($9ce574ee41ab9658$export$fef912314604ae84);
                if (!meta) return pluginState;
                return {
                    showElementBrowser: !pluginState.showElementBrowser
                };
            }
        }
    });

});

parcelRegister("i3rM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4a027c2b3a387b$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");

var $2i4K4 = parcelRequire("2i4K4");

var $ejItq = parcelRequire("ejItq");

var $4N9VB = parcelRequire("4N9VB");
var $1CHgS = parcelRequire("1CHgS");

var $1jI4k = parcelRequire("1jI4k");

var $jdyxs = parcelRequire("jdyxs");

var $iHYdz = parcelRequire("iHYdz");

var $k9ixM = parcelRequire("k9ixM");

var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");

var $7r2Qp = parcelRequire("7r2Qp");

var $b8wiF = parcelRequire("b8wiF");
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $df4a027c2b3a387b$var$isDetachedElement = (el)=>!document.body.contains(el);
const $df4a027c2b3a387b$var$TABLE_SELECTOR_STRING = 'table selector';
// TODO: ED-26959 - Jenga team will create a component for a split button using this css
const $df4a027c2b3a387b$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${`var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`};

    &:hover {
      background: ${`var(--ds-background-neutral-hovered, ${0, $829f609a65d26a98$export$920c0d5c49070351})`};
    }
  }`;
const $df4a027c2b3a387b$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $jdyxs.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k9ixM.default), {
        onPickerRef: setOutsideClickTargetRef,
        ...props
    });
};
const $df4a027c2b3a387b$var$EmojiPickerWithListeners = (0, $jdyxs.default)($df4a027c2b3a387b$var$EmojiPicker);
const $df4a027c2b3a387b$export$6555404d88cb913b = ({ isTableSelectorOpen: isTableSelectorOpen, isButtonDisabled: isButtonDisabled })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation due to mixins
    (0, $f8Sb3.css)("display:flex;", !isTableSelectorOpen && !isButtonDisabled && $df4a027c2b3a387b$var$getHoverStyles('.table-selector-toolbar-btn'), " ", !isTableSelectorOpen && !isButtonDisabled && $df4a027c2b3a387b$var$getHoverStyles('.table-toolbar-btn'), " .table-toolbar-btn{border-top-right-radius:var(--ds-border-radius-200, 0px);border-bottom-right-radius:var(--ds-border-radius-200, 0px);margin-right:var(--ds-space-025, 1px);padding:var(--ds-space-0, 0px);&>span{min-width:16px;margin:var(--ds-space-0, 0px);}}.table-selector-toolbar-btn{padding:var(--ds-space-0, 0px);border-top-left-radius:var(--ds-border-radius-200, 0px)!important;border-bottom-left-radius:var(--ds-border-radius-200, 0px)!important;&>span{margin:var(--ds-space-0, 0px);width:16px!important;display:flex;justify-content:center;}}");
class $df4a027c2b3a387b$export$630ae7da9d01a215 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        const [buttons, dropdownItems] = (0, $b8wiF.createItems)({
            isTypeAheadAllowed: props.isTypeAheadAllowed,
            tableSupported: props.tableSupported,
            tableSelectorSupported: props.tableSelectorSupported,
            mediaUploadsEnabled: props.mediaUploadsEnabled,
            mediaSupported: props.mediaSupported,
            isEditorOffline: props.isEditorOffline,
            imageUploadSupported: props.imageUploadSupported,
            imageUploadEnabled: props.imageUploadEnabled,
            mentionsSupported: props.mentionsSupported,
            mentionsDisabled: props.mentionsDisabled,
            actionSupported: props.actionSupported,
            decisionSupported: props.decisionSupported,
            linkSupported: props.linkSupported,
            linkDisabled: props.linkDisabled,
            emojiDisabled: props.emojiDisabled,
            hasEmojiPlugin: !!props.pluginInjectionApi?.emoji,
            hasMentionsPlugin: !!props.pluginInjectionApi?.mention,
            hasMediaPlugin: !!props.pluginInjectionApi?.media,
            nativeStatusSupported: props.nativeStatusSupported,
            dateEnabled: props.dateEnabled,
            placeholderTextEnabled: props.placeholderTextEnabled,
            horizontalRuleEnabled: props.horizontalRuleEnabled,
            layoutSectionEnabled: props.layoutSectionEnabled,
            expandEnabled: props.expandEnabled,
            showElementBrowserLink: props.showElementBrowserLink,
            emojiProvider: props.emojiProvider,
            availableWrapperBlockTypes: props.availableWrapperBlockTypes,
            insertMenuItems: props.insertMenuItems,
            schema: props.editorView.state.schema,
            numberOfButtons: props.buttons,
            formatMessage: props.intl.formatMessage
        });
        return {
            ...state,
            buttons: buttons,
            dropdownItems: dropdownItems
        };
    }
    componentDidUpdate(prevProps) {
        // If number of visible buttons changed, close emoji picker and table selector
        if (prevProps.buttons !== this.props.buttons) this.setState({
            emojiPickerOpen: false,
            isTableSelectorOpen: false
        });
        if (this.state.isOpenedByKeyboard) {
            const downArrowEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.dropdownButtonRef?.deref()?.dispatchEvent(downArrowEvent);
            this.setState({
                ...this.state,
                isOpenedByKeyboard: false
            });
        }
        if (this.state.isTableSelectorOpen) this.setState({
            isTableSelectorOpenedByKeyboard: false
        });
        if (this.props.showElementBrowser !== prevProps.showElementBrowser) {
            this.handleClick();
            this.setState({
                ...this.state,
                isPlusMenuOpen: this.props.showElementBrowser
            });
        }
    }
    renderPopup() {
        const { emojiPickerOpen: emojiPickerOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, emojiProvider: emojiProvider } = this.props;
        const dropdownEmoji = this.state.dropdownItems.some(({ value: { name: name } })=>name === 'emoji');
        const dropDownButtonRef = this.plusButtonRef;
        const ref = dropdownEmoji ? dropDownButtonRef : this.emojiButtonRef;
        if (!emojiPickerOpen || !ref || !emojiProvider) return null;
        const onUnmount = ()=>{
            requestAnimationFrame(()=>this.props.pluginInjectionApi?.core?.actions?.focus());
        };
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
            target: ref.deref(),
            fitHeight: 350,
            fitWidth: 350,
            offset: [
                0,
                3
            ],
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onUnmount: onUnmount,
            focusTrap: true,
            zIndex: (0, $iHYdz.akEditorMenuZIndex)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($df4a027c2b3a387b$var$EmojiPickerWithListeners, {
            emojiProvider: emojiProvider,
            onSelection: this.handleSelectedEmoji,
            handleClickOutside: this.handleEmojiClickOutside,
            handleEscapeKeydown: this.handleEmojiPressEscape
        }));
    }
    renderTableSelectorPopup() {
        const { isTableSelectorOpen: isTableSelectorOpen, isTableSelectorOpenedByKeyboard: isTableSelectorOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, pluginInjectionApi: pluginInjectionApi } = this.props;
        const ref = this.tableButtonRef.current ?? undefined;
        if (!isTableSelectorOpen) return null;
        // We use focusTrap in the Popup. When we insert a table via popup,
        // the popup closes, focusTrap gets destroyed and the popup detaches.
        // The focus gets set to the body element. onUnmount method sets focus on the editor right before the
        // Popup will be unmounted to ensure that the new table has a selection with a blinking cursor.
        // So we can start typing right away.
        const onUnmount = ()=>pluginInjectionApi?.core?.actions?.focus();
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1CHgS.default), {
            allowOutsideSelection: true,
            target: ref,
            onUnmount: onUnmount,
            onSelection: this.handleSelectedTableSize,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            handleClickOutside: this.handleTableSelectorClickOutside,
            handleEscapeKeydown: this.handleTableSelectorPressEscape,
            isOpenedByKeyboard: isTableSelectorOpenedByKeyboard
        });
    }
    render() {
        const { buttons: buttons, dropdownItems: dropdownItems, emojiPickerOpen: emojiPickerOpen, isTableSelectorOpen: isTableSelectorOpen } = this.state;
        const { isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, editorAppearance: editorAppearance } = this.props;
        const isFullPageAppearance = [
            'full-page',
            'full-width'
        ].includes(editorAppearance ?? '');
        const isTableButtonVisible = buttons.some(({ value: value })=>value.name === 'table');
        const isTableSizeVisible = buttons.some(({ value: value })=>value.name === 'table selector');
        if (buttons.length === 0 && dropdownItems.length === 0) return null;
        const toolbarButtons = [];
        let tableSelectorButton;
        let tableButton;
        // Seperate table buttons from toolbar buttons
        for (const btn of buttons){
            if (btn.value.name === $df4a027c2b3a387b$var$TABLE_SELECTOR_STRING) tableSelectorButton = btn;
            else if (btn.value.name === 'table' && this.props.tableSelectorSupported) tableButton = btn;
            else toolbarButtons.push(btn);
        }
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ejItq.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $ejItq.buttonGroupStyleBeforeVisualRefresh)
        }, toolbarButtons.map((btn)=>{
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
                item: btn,
                testId: String(btn.content),
                ref: this.handleToolbarRef(btn.value.name),
                key: btn.value.name,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: isDisabled || btn.isDisabled,
                iconBefore: btn.elemBefore,
                selected: btn.value.name === 'emoji' && emojiPickerOpen || btn.isActive,
                title: btn.title,
                "aria-label": btn['aria-label'],
                "aria-haspopup": btn['aria-haspopup'],
                "aria-keyshortcuts": btn['aria-keyshortcuts'],
                onItemClick: this.insertToolbarMenuItem
            });
        }), this.props.tableSelectorSupported && (isTableButtonVisible || isTableSizeVisible) && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $df4a027c2b3a387b$export$6555404d88cb913b({
                isTableSelectorOpen: isTableSelectorOpen,
                isButtonDisabled: tableButton?.isDisabled
            })
        }, isTableButtonVisible && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-toolbar-btn",
            item: tableButton,
            ref: this.tableButtonRef,
            testId: String(tableButton?.content),
            key: tableButton?.value.name,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableButton?.isDisabled,
            iconBefore: tableButton?.elemBefore,
            selected: tableButton?.isActive || isTableSelectorOpen,
            title: tableButton?.title,
            "aria-label": tableButton ? tableButton['aria-label'] : undefined,
            "aria-haspopup": tableButton ? tableButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableButton ? tableButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem
        }), isTableButtonVisible && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-selector-toolbar-btn",
            item: tableSelectorButton,
            testId: String(tableSelectorButton?.content),
            key: tableSelectorButton?.value.name,
            ref: this.tableSelectorButtonRef,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || tableSelectorButton?.isDisabled,
            iconBefore: tableSelectorButton?.elemBefore,
            selected: tableSelectorButton?.isActive || isTableSelectorOpen,
            title: tableSelectorButton?.title,
            "aria-label": tableSelectorButton ? tableSelectorButton['aria-label'] : undefined,
            "aria-haspopup": tableSelectorButton ? tableSelectorButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableSelectorButton ? tableSelectorButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem,
            onKeyDown: this.handleTableSelectorOpenByKeyboard
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ejItq.wrapperStyle)
        }, this.renderPopup(), this.renderTableSelectorPopup(), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7r2Qp.BlockInsertMenu), {
            popupsMountPoint: this.props.popupsMountPoint,
            popupsBoundariesElement: this.props.popupsBoundariesElement,
            popupsScrollableElement: this.props.popupsScrollableElement,
            disabled: this.props.isDisabled ?? false,
            editorView: this.props.editorView,
            spacing: this.props.isReducedSpacing ? 'none' : 'default',
            label: this.props.intl.formatMessage((0, $2i4K4.toolbarInsertBlockMessages).insertMenu),
            open: this.state.isPlusMenuOpen,
            plusButtonRef: this.plusButtonRef?.deref(),
            items: this.state.dropdownItems,
            onRef: this.handleDropDownButtonRef,
            onPlusButtonRef: this.handlePlusButtonRef,
            onClick: this.handleClick,
            onKeyDown: this.handleOpenByKeyboard,
            onItemActivated: this.insertInsertMenuItem,
            onInsert: this.insertInsertMenuItem,
            onOpenChange: this.onOpenChange,
            togglePlusMenuVisibility: this.togglePlusMenuVisibility,
            showElementBrowserLink: this.props.showElementBrowserLink || false,
            pluginInjectionApi: this.props.pluginInjectionApi,
            isFullPageAppearance: isFullPageAppearance
        })), (!this.props.pluginInjectionApi?.primaryToolbar && this.props.showSeparator || isFullPageAppearance && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ejItq.separatorStyles)
        }));
    }
    constructor(...args){
        super(...args), this.tableButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.tableSelectorButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.state = {
            isPlusMenuOpen: false,
            emojiPickerOpen: false,
            isOpenedByKeyboard: false,
            buttons: [],
            dropdownItems: [],
            isTableSelectorOpen: false,
            isTableSelectorOpenedByKeyboard: false
        }, this.onOpenChange = (attrs)=>{
            const state = {
                isPlusMenuOpen: attrs.isPlusMenuOpen,
                emojiPickerOpen: this.state.emojiPickerOpen
            };
            if (this.state.emojiPickerOpen && !attrs.open) state.emojiPickerOpen = false;
            this.setState(state, ()=>{
                const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                if (!dispatchAnalyticsEvent) return;
                const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
                if (isPlusMenuOpen) return dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).OPENED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
                return dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).CLOSED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            });
        }, this.togglePlusMenuVisibility = (event)=>{
            const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            if (pluginInjectionApi && (0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) pluginInjectionApi.core.actions.execute(({ tr: tr })=>{
                if (isPlusMenuOpen) pluginInjectionApi.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                else pluginInjectionApi.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return tr;
            });
            this.onOpenChange({
                isPlusMenuOpen: !isPlusMenuOpen
            });
            if (event?.key === 'Escape') (this.plusButtonRef || this.dropdownButtonRef)?.deref()?.focus();
        }, this.toggleEmojiPicker = (inputMethod = (0, $gkwXh.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    emojiPickerOpen: !prevState.emojiPickerOpen
                }), ()=>{
                if (this.state.emojiPickerOpen) {
                    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                    if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).OPENED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                }
            });
        }, this.handleEmojiPressEscape = ()=>{
            this.toggleEmojiPicker((0, $gkwXh.INPUT_METHOD).KEYBOARD);
            this.emojiButtonRef?.deref()?.focus();
        }, this.handleEmojiClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$df4a027c2b3a387b$var$isDetachedElement(e.target)) this.toggleEmojiPicker((0, $gkwXh.INPUT_METHOD).TOOLBAR);
        }, this.handleToolbarRef = (buttonName)=>(ref)=>{
                if (!ref) return;
                switch(buttonName){
                    case 'emoji':
                        this.emojiButtonRef = new WeakRef(ref);
                        break;
                    case 'media':
                        this.mediaButtonRef = new WeakRef(ref);
                        break;
                }
            }, this.handlePlusButtonRef = (ref)=>{
            if (ref) this.plusButtonRef = new WeakRef(ref);
        }, this.handleDropDownButtonRef = (ref)=>{
            if (ref) this.dropdownButtonRef = new WeakRef(ref);
        }, this.toggleTableSelector = (inputMethod = (0, $gkwXh.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    isTableSelectorOpen: !prevState.isTableSelectorOpen
                }));
        }, this.handleSelectedTableSize = (rowsCount, colsCount)=>{
            this.insertTableWithSize((0, $gkwXh.INPUT_METHOD).TOOLBAR, rowsCount, colsCount)();
            this.toggleTableSelector();
        }, this.handleTableSelectorPressEscape = ()=>{
            this.toggleTableSelector((0, $gkwXh.INPUT_METHOD).KEYBOARD);
            this.tableSelectorButtonRef.current?.focus();
        }, this.handleTableSelectorClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$df4a027c2b3a387b$var$isDetachedElement(e.target)) this.toggleTableSelector((0, $gkwXh.INPUT_METHOD).TOOLBAR);
        }, this.handleClick = ()=>{
            this.togglePlusMenuVisibility();
        }, this.handleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                this.setState({
                    ...this.state,
                    isOpenedByKeyboard: true
                });
                event.preventDefault();
                this.togglePlusMenuVisibility();
            }
        }, this.handleTableSelectorOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') this.setState({
                isTableSelectorOpenedByKeyboard: true
            });
        }, this.toggleLinkPanel = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.hyperlink?.commands.showLinkToolbar(inputMethod)) ?? false;
        }, this.insertMention = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (!editorView) return true;
            const pluginState = pluginInjectionApi?.mention?.sharedState.currentState();
            if (pluginState && pluginState.canInsertMention === false) return false;
            return Boolean(pluginInjectionApi?.mention?.actions?.openTypeAhead(inputMethod));
        }, this.insertTable = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi, editorView: editorView } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                pluginInjectionApi?.table?.actions.insertTable?.({
                    action: (0, $gkwXh.ACTION).INSERTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }, this.insertTableWithSize = (inputMethod, rowsCount, colsCount)=>()=>{
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.table?.commands.insertTableWithSize(rowsCount, colsCount, (0, $gkwXh.INPUT_METHOD).PICKER));
                });
            }, this.createDate = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.date?.commands?.insertDate({
                inputMethod: inputMethod
            }));
            return true;
        }, this.createPlaceholderText = ()=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.placeholderText?.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
            return true;
        }, this.insertLayoutColumns = (inputMethod)=>{
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.layout?.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
            return true;
        }, this.createStatus = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return Boolean(pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.status?.commands?.insertStatus(inputMethod)));
        }, this.openMediaPicker = (inputMethod)=>{
            const { onShowMediaPicker: onShowMediaPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (onShowMediaPicker) {
                const ref = this.mediaButtonRef?.deref();
                const args = ref ? {
                    ref: ref,
                    mountPoint: this.props.popupsMountPoint ?? ref
                } : undefined;
                onShowMediaPicker(args);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).OPENED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $VSDnB.fg)('platform_editor_add_media_from_url_rollout') ? (0, $gkwXh.ACTION_SUBJECT_ID).PICKER_MEDIA : (0, $gkwXh.ACTION_SUBJECT_ID).PICKER_CLOUD,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).UI
                });
            }
            return true;
        }, this.insertTaskDecision = (name, inputMethod)=>()=>{
                const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
                const listType = name === 'action' ? 'taskList' : 'decisionList';
                return pluginInjectionApi?.taskDecision?.actions.insertTaskDecision(listType, inputMethod)(state, dispatch) ?? false;
            }, this.insertHorizontalRule = (inputMethod)=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.rule?.actions.insertHorizontalRule(inputMethod)(state, dispatch) ?? false;
        }, this.insertExpand = ()=>{
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return pluginInjectionApi?.expand?.actions.insertExpand(state, dispatch) ?? false;
        }, this.insertBlockType = (itemName)=>()=>{
                const { editorView: editorView, onInsertBlockType: onInsertBlockType } = this.props;
                const { state: state, dispatch: dispatch } = editorView;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onInsertBlockType(itemName)(state, dispatch);
                return true;
            }, this.handleSelectedEmoji = (emojiId)=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            this.props.editorView.focus();
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi.emoji?.commands.insertEmoji(emojiId, (0, $gkwXh.INPUT_METHOD).PICKER));
            this.toggleEmojiPicker();
            return true;
        }, this.openElementBrowser = ()=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
        }, this.onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
            const { editorView: editorView, handleImageUpload: handleImageUpload, expandEnabled: expandEnabled } = this.props;
            // need to do this before inserting nodes so scrollIntoView works properly
            if (!editorView.hasFocus()) editorView.focus();
            switch(item.value.name){
                case 'link':
                    this.toggleLinkPanel(inputMethod);
                    break;
                case 'table':
                    this.insertTable(inputMethod);
                    break;
                case 'table selector':
                    this.toggleTableSelector(inputMethod);
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        const { state: state, dispatch: dispatch } = editorView;
                        handleImageUpload()(state, dispatch);
                    }
                    break;
                case 'media':
                    this.openMediaPicker(inputMethod);
                    break;
                case 'mention':
                    this.insertMention(inputMethod);
                    break;
                case 'emoji':
                    this.toggleEmojiPicker(inputMethod);
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    this.insertBlockType(item.value.name)();
                    break;
                case 'action':
                case 'decision':
                    this.insertTaskDecision(item.value.name, inputMethod)();
                    break;
                case 'horizontalrule':
                    this.insertHorizontalRule(inputMethod);
                    break;
                case 'macro':
                    /**
         * Remove 'macro' case when cleaning up platform_editor_refactor_view_more
         * along with the 'more' function from platform/packages/editor/editor-plugin-insert-block/src/ui/ToolbarInsertBlock/item.tsx
         * as it will no longer be needed for the View More button.
         * This will also reduce confusion from the 'macro' naming.
         */ if (!(0, $VSDnB.fg)('platform_editor_refactor_view_more')) this.openElementBrowser();
                    break;
                case 'date':
                    this.createDate(inputMethod);
                    break;
                case 'placeholder text':
                    this.createPlaceholderText();
                    break;
                case 'layout':
                    this.insertLayoutColumns(inputMethod);
                    break;
                case 'status':
                    this.createStatus(inputMethod);
                    break;
                // https://product-fabric.atlassian.net/browse/ED-8053
                // @ts-ignore: OK to fallthrough to default
                case 'expand':
                    if (expandEnabled) {
                        this.insertExpand();
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    if (item && item.onClick) {
                        item.onClick();
                        break;
                    }
            }
            this.setState({
                isPlusMenuOpen: false
            });
        }, this.insertToolbarMenuItem = (btn)=>this.onItemActivated({
                item: btn,
                inputMethod: (0, $gkwXh.INPUT_METHOD).TOOLBAR
            }), this.insertInsertMenuItem = ({ item: item })=>this.onItemActivated({
                item: item,
                inputMethod: (0, $gkwXh.INPUT_METHOD).INSERT_MENU
            });
    }
}
var $df4a027c2b3a387b$export$2e2bcd8739ae039 = (0, $8RXs9.default)($df4a027c2b3a387b$export$630ae7da9d01a215);

});
parcelRegister("1CHgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c35fc74477f687$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");


var $gmhCD = parcelRequire("gmhCD");

var $jdyxs = parcelRequire("jdyxs");

var $4N9VB = parcelRequire("4N9VB");

var $bmt19 = parcelRequire("bmt19");
const $d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_TOP = 8;
const $d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_SIDE = 10;
const $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS = 5;
const $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS = 10;
const $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE = 1;
const $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS = 10;
const $d7c35fc74477f687$var$TableSelectorWithListeners = (0, $jdyxs.default)((0, $bmt19.default));
const $d7c35fc74477f687$var$initialSizeState = {
    col: $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    row: $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    maxCol: $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS,
    maxRow: $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS
};
const $d7c35fc74477f687$var$tableSelectorPopupWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    padding: `${`var(--ds-space-100, ${`${$d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_TOP}px`})`} ${$d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_SIDE}px`
});
const $d7c35fc74477f687$export$4b4bd4d01ec9c7c9 = (props)=>{
    const [size, setSize] = (0, $5uXOq.useState)({
        ...$d7c35fc74477f687$var$initialSizeState,
        ...props.defaultSize
    });
    const tablePopupRef = (0, $5uXOq.useRef)(null);
    // If popup opened by keyboard enable keyboard mode
    const isKeyboardMode = (0, $5uXOq.useRef)(props.isOpenedByKeyboard);
    const enableKeyboardMode = (0, $5uXOq.useCallback)(()=>{
        if (!isKeyboardMode.current) isKeyboardMode.current = true;
    }, [
        isKeyboardMode
    ]);
    const disableKeyboardMode = (0, $5uXOq.useCallback)(()=>{
        if (isKeyboardMode.current) isKeyboardMode.current = false;
    }, [
        isKeyboardMode
    ]);
    // Mouse move is used to allow selection changes outside of the popup and is more reactive to changes.
    const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
        if (!tablePopupRef.current) return;
        disableKeyboardMode();
        const tablePopup = tablePopupRef.current;
        const { left: left, top: top } = tablePopup.getBoundingClientRect();
        // Mouse position on popup
        const selectedWidth = e.clientX - left;
        const selectedHeight = e.clientY - top;
        // Calculate number grid cells selected
        let selectedGridCols = Math.ceil((selectedWidth - $d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_SIDE + (0, $bmt19.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $bmt19.TABLE_SELECTOR_BUTTON_GAP) + (0, $bmt19.TABLE_SELECTOR_BUTTON_SIZE)));
        let selectedGridRows = Math.ceil((selectedHeight - $d7c35fc74477f687$var$TABLE_SELECTOR_PADDING_TOP + (0, $bmt19.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $bmt19.TABLE_SELECTOR_BUTTON_GAP) + (0, $bmt19.TABLE_SELECTOR_BUTTON_SIZE)));
        // Keep the selected rows and columns within the defined bounds
        let gridRows = $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS;
        if (selectedGridCols < 1) selectedGridCols = 1;
        if (selectedGridCols > size.maxCol) selectedGridCols = size.maxCol;
        if (selectedGridRows < 1) selectedGridRows = 1;
        // Expand grid when row selection is greater than the default grid size
        if (selectedGridRows >= $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS && selectedGridRows < $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) gridRows = selectedGridRows + 1;
        if (selectedGridRows >= $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) {
            selectedGridRows = $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
            gridRows = $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
        }
        if (selectedGridCols !== size.col || selectedGridRows !== size.row) setSize({
            col: selectedGridCols,
            row: selectedGridRows,
            maxCol: $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS,
            maxRow: gridRows
        });
    }, [
        disableKeyboardMode,
        size,
        setSize
    ]);
    const decreasingSequence = (maxNumber, prevNumber)=>{
        let nextNumber = prevNumber - 1;
        if (prevNumber === 1) nextNumber = maxNumber;
        return nextNumber;
    };
    const getMaxRow = (prevSize, eventKey)=>{
        switch(eventKey){
            case 'ArrowDown':
                // Expand the grid size when last row selected
                if (prevSize.maxRow < $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.row >= $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS - 1) return prevSize.maxRow + 1;
                if (prevSize.row === $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) return $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS;
                return prevSize.maxRow;
            case 'ArrowLeft':
                const moveToPrevRow = prevSize.col === 1 && prevSize.row > 1;
                const moveToLastRow = prevSize.row === 1 && prevSize.col === 1;
                // Expand the popup to max size when selected row wraps around to last row
                if (moveToLastRow) return $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                // Decrease the popup when decreased row selection
                if (prevSize.maxRow > $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS && moveToPrevRow) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowUp':
                if (prevSize.row === 1) return $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                else if (prevSize.maxRow > $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowRight':
                const moveToNextRow = prevSize.col === $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS;
                const increaseMaxRow = prevSize.maxRow < $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && moveToNextRow && prevSize.row + 1 === prevSize.maxRow;
                // Decrease popup size for wrap around to selection 1 x 1
                if (prevSize.row === $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.col === $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS) return $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_ROWS;
                else if (increaseMaxRow) return prevSize.maxRow + 1;
                return prevSize.maxRow;
            default:
                return prevSize.maxRow;
        }
    };
    const handleInitialButtonFocus = (0, $5uXOq.useCallback)(()=>{
        if (isKeyboardMode.current !== true) {
            enableKeyboardMode();
            setSize($d7c35fc74477f687$var$initialSizeState);
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.key === 'ArrowDown') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                return {
                    ...prevSize,
                    row: prevSize.row % prevSize.maxRow + 1,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_table_picker')) event.preventDefault();
        }
        if (event.key === 'ArrowRight') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToNextRow = prevSize.col === $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS;
                return {
                    ...prevSize,
                    col: prevSize.col % $d7c35fc74477f687$var$DEFAULT_TABLE_SELECTOR_COLS + 1,
                    row: moveToNextRow ? prevSize.row % prevSize.maxRow + 1 : prevSize.row,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowLeft') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const getRow = (prevRow, prevCol)=>{
                    const row = prevRow;
                    // Move to previous row for wrap around
                    if (prevSize.col === 1 && prevSize.row > 1) return prevRow - 1;
                    else if (prevRow === 1 && prevCol === 1) return $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                    return row;
                };
                return {
                    ...prevSize,
                    col: decreasingSequence(prevSize.maxCol, prevSize.col),
                    row: getRow(prevSize.row, prevSize.col),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowUp') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToLastRow = prevSize.row === 1;
                return {
                    ...prevSize,
                    row: moveToLastRow ? $d7c35fc74477f687$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS : decreasingSequence(prevSize.maxRow, prevSize.row),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_table_picker')) event.preventDefault();
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        const target = props.allowOutsideSelection ? window : tablePopupRef.current;
        if (target) unbind = (0, $cBeZP.bind)(target, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return unbind;
    }, [
        handleMouseMove,
        props.allowOutsideSelection,
        tablePopupRef
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        target: props.target,
        offset: [
            0,
            3
        ],
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        focusTrap: true,
        onUnmount: props.onUnmount,
        zIndex: (0, $iHYdz.akEditorMenuZIndex)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d7c35fc74477f687$var$tableSelectorPopupWrapperStyles,
        ref: tablePopupRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($d7c35fc74477f687$var$TableSelectorWithListeners, {
        handleClickOutside: props.handleClickOutside,
        handleEscapeKeydown: props.handleEscapeKeydown,
        maxCols: size.maxCol,
        maxRows: size.maxRow,
        onSelection: props.onSelection,
        selectedCol: size.col,
        selectedRow: size.row,
        onKeyDown: handleKeyDown,
        isFocused: isKeyboardMode.current,
        handleInitialButtonFocus: handleInitialButtonFocus
    })));
};
var $d7c35fc74477f687$export$2e2bcd8739ae039 = $d7c35fc74477f687$export$4b4bd4d01ec9c7c9;

});
parcelRegister("bmt19", function(module, exports) {

$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_GAP", () => $2df775b93555100f$export$fe015b05aaf05d59);
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_SIZE", () => $2df775b93555100f$export$80d6f86639b2335);
$parcel$export(module.exports, "default", () => $2df775b93555100f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $414Wj = parcelRequire("414Wj");


var $gmhCD = parcelRequire("gmhCD");

var $2i4K4 = parcelRequire("2i4K4");

var $jdyxs = parcelRequire("jdyxs");
function $2df775b93555100f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2df775b93555100f$export$fe015b05aaf05d59 = 2;
const $2df775b93555100f$export$80d6f86639b2335 = 17;
const $2df775b93555100f$var$selectedButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #579DFF)",
    border: `1px solid ${"var(--ds-background-accent-blue-subtle, #579DFF)"}`
});
const $2df775b93555100f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `${$2df775b93555100f$export$80d6f86639b2335}px`,
    width: `${$2df775b93555100f$export$80d6f86639b2335}px`,
    border: `1px solid ${"var(--ds-border, #091e4224)"}`,
    backgroundColor: "var(--ds-background-input, #ffffff)",
    borderRadius: '3px',
    cursor: 'pointer',
    display: 'block',
    '&:focus': {
        outline: 'none',
        border: `1px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
        boxShadow: `0 0 0 0.5px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $2df775b93555100f$var$selectionSizeTextStyles = {
    name: "bn43i4",
    styles: "line-height:14px;display:flex;justify-content:center;margin-top:var(--ds-space-075, 5px);padding:var(--ds-space-075, 10px)"
};
const $2df775b93555100f$var$TableSelectorButton = ({ row: row, col: col, isActive: isActive, onClick: onClick, label: label, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus })=>{
    const btnRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (btnRef.current) {
            if (isFocused) btnRef.current.focus({
                preventScroll: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_table_picker') ? true : undefined
            });
            else btnRef.current.blur();
        }
    }, [
        isFocused,
        btnRef
    ]);
    const handleFocus = col === 1 && row === 1 ? ()=>handleInitialButtonFocus() : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        css: [
            $2df775b93555100f$var$buttonStyles,
            isActive ? $2df775b93555100f$var$selectedButtonStyles : undefined
        ],
        onClick: ()=>onClick(row, col),
        "aria-label": label,
        onKeyDown: onKeyDown,
        ref: btnRef,
        onFocus: handleFocus
    });
};
const $2df775b93555100f$var$createArray = (maxCols, maxRows)=>{
    const arr = [];
    for(let i = 1; i < maxRows + 1; i++)for(let j = 1; j < maxCols + 1; j++)arr.push({
        col: j,
        row: i
    });
    return arr;
};
const $2df775b93555100f$var$gridWrapperStyles = ({ maxCols: maxCols, maxRows: maxRows })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'grid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateRows: `repeat(${maxRows}, 1fr)`,
        gap: `${`var(--ds-space-025, ${`${$2df775b93555100f$export$fe015b05aaf05d59}px`})`}`
    });
const $2df775b93555100f$var$TableSelectorPopup = ({ maxCols: maxCols, maxRows: maxRows, onSelection: onSelection, selectedCol: selectedCol, selectedRow: selectedRow, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus, intl: { formatMessage: formatMessage } })=>{
    const buttons = (0, $5uXOq.useMemo)(()=>{
        return $2df775b93555100f$var$createArray(maxCols, maxRows);
    }, [
        maxCols,
        maxRows
    ]);
    const setOutsideClickTargetRef = (0, $5uXOq.useContext)((0, $jdyxs.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $414Wj.default), {
        ref: setOutsideClickTargetRef
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-label": `${formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableSizeSelectorPopup)}`,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        $2df775b93555100f$var$gridWrapperStyles({
            maxCols: maxCols,
            maxRows: maxRows
        })
    }, buttons.map(({ col: col, row: row }, index)=>{
        const isCurrentFocused = isFocused && selectedCol === col && selectedRow === row;
        const isActive = selectedCol >= col && selectedRow >= row ? true : false;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($2df775b93555100f$var$TableSelectorButton, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            isActive: isActive,
            col: col,
            row: row,
            onClick: onSelection,
            label: `${formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableSizeSelectorButton, {
                numberOfColumns: col,
                numberOfRows: row
            })}`,
            onKeyDown: onKeyDown,
            isFocused: isCurrentFocused,
            handleInitialButtonFocus: handleInitialButtonFocus
        });
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $2df775b93555100f$var$selectionSizeTextStyles,
        "aria-hidden": true
    }, `${selectedCol} x ${selectedRow}`));
};
var $2df775b93555100f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($2df775b93555100f$var$TableSelectorPopup);

});


parcelRegister("7r2Qp", function(module, exports) {

$parcel$export(module.exports, "BlockInsertMenu", () => $c05eb3f6bb63bd8a$export$4476666e12e8d26e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7MgUr = parcelRequire("7MgUr");

var $fe0QZ = parcelRequire("fe0QZ");
const $c05eb3f6bb63bd8a$export$4476666e12e8d26e = (props)=>{
    if ((0, $VSDnB.fg)('platform_editor_refactor_view_more')) {
        if (props.items.length === 0 && !props.showElementBrowserLink) return null;
    } else {
        if (props.items.length === 0) return null;
    }
    if (props.disabled) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fe0QZ.DropDownButton), {
            "aria-expanded": props.open,
            "aria-haspopup": true,
            handleRef: props.onRef,
            selected: props.open,
            disabled: props.disabled,
            onClick: props.onClick,
            onKeyDown: props.onKeyDown,
            spacing: props.spacing,
            label: props.label,
            "aria-keyshortcuts": "/"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7MgUr.BlockInsertElementBrowser), {
        disabled: props.disabled,
        editorView: props.editorView,
        items: props.items,
        label: props.label,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        onInsert: props.onInsert,
        onRef: props.onPlusButtonRef,
        open: props.open,
        plusButtonRef: props.plusButtonRef,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        spacing: props.spacing,
        togglePlusMenuVisibility: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    });
};

});
parcelRegister("7MgUr", function(module, exports) {

$parcel$export(module.exports, "BlockInsertElementBrowser", () => $c3817db5867b8b97$export$fa06a3a473615c12);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4N9VB = parcelRequire("4N9VB");

var $63Sss = parcelRequire("63Sss");

var $fe0QZ = parcelRequire("fe0QZ");
// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $c3817db5867b8b97$var$FIT_HEIGHT_BUFFER = 100;
const $c3817db5867b8b97$export$fa06a3a473615c12 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            props.open && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
                target: props.plusButtonRef,
                fitHeight: (0, $63Sss.DEFAULT_HEIGHT) + $c3817db5867b8b97$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                offset: [
                    0,
                    3
                ],
                mountTo: props.popupsMountPoint,
                boundariesElement: props.popupsBoundariesElement,
                scrollableElement: props.popupsScrollableElement,
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $63Sss.default), {
                    editorView: props.editorView,
                    dropdownItems: props.items,
                    onInsert: props.onInsert,
                    toggleVisiblity: props.togglePlusMenuVisibility,
                    showElementBrowserLink: props.showElementBrowserLink,
                    pluginInjectionApi: props.pluginInjectionApi,
                    isFullPageAppearance: props.isFullPageAppearance
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fe0QZ.DropDownButton), {
                "aria-expanded": props.open,
                "aria-haspopup": true,
                handleRef: props.onRef,
                selected: props.open,
                disabled: props.disabled,
                onClick: props.onClick,
                onKeyDown: props.onKeyDown,
                spacing: props.spacing,
                label: props.label,
                "aria-keyshortcuts": "/"
            })
        ]
    });
};

});
parcelRegister("63Sss", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_HEIGHT", () => $8773e39d4c9ba9af$export$611c894df53833b0);
$parcel$export(module.exports, "default", () => $8773e39d4c9ba9af$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7Pkjl = parcelRequire("7Pkjl");

var $gkwXh = parcelRequire("gkwXh");

var $3fEIr = parcelRequire("3fEIr");
var $hd31W = parcelRequire("hd31W");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $I02Nt = parcelRequire("I02Nt");

var $jdyxs = parcelRequire("jdyxs");

var $9LY0t = parcelRequire("9LY0t");

var $VSDnB = parcelRequire("VSDnB");

var $k5uoT = parcelRequire("k5uoT");

function $8773e39d4c9ba9af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8773e39d4c9ba9af$export$611c894df53833b0 = 560;
const $8773e39d4c9ba9af$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const connectivityMode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'connectivity.mode');
    return {
        connectivityMode: connectivityMode
    };
}, (api)=>{
    const { connectivityState: connectivityState } = (0, $awTmI.useSharedPluginState)(api, [
        'connectivity'
    ]);
    return {
        connectivityMode: connectivityState?.mode
    };
});
const $8773e39d4c9ba9af$var$InsertMenu = ({ editorView: editorView, dropdownItems: dropdownItems, showElementBrowserLink: showElementBrowserLink, onInsert: onInsert, toggleVisiblity: toggleVisiblity, pluginInjectionApi: pluginInjectionApi, isFullPageAppearance: isFullPageAppearance })=>{
    const [itemCount, setItemCount] = (0, $5uXOq.useState)(0);
    const [height, setHeight] = (0, $5uXOq.useState)($8773e39d4c9ba9af$export$611c894df53833b0);
    const cache = (0, $5uXOq.useMemo)(()=>{
        return new (0, $7Pkjl.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: (0, $3fEIr.ELEMENT_ITEM_HEIGHT),
            minHeight: (0, $3fEIr.ELEMENT_ITEM_HEIGHT)
        });
    }, []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Figure based on visuals to exclude the searchbar, padding/margin, and the ViewMore item.
        const EXTRA_SPACE_EXCLUDING_ELEMENTLIST = 128;
        const totalItemHeight = [
            ...Array(itemCount)
        ].reduce((sum, _, index)=>sum + cache.rowHeight({
                index: index
            }), 0) + EXTRA_SPACE_EXCLUDING_ELEMENTLIST;
        if (itemCount > 0 && totalItemHeight < $8773e39d4c9ba9af$export$611c894df53833b0) setHeight(totalItemHeight);
        else setHeight($8773e39d4c9ba9af$export$611c894df53833b0);
    }, [
        cache,
        itemCount
    ]);
    const transform = (0, $5uXOq.useCallback)((item)=>({
            title: item.content,
            description: item.tooltipDescription,
            keyshortcut: item.shortcut,
            icon: ()=>$8773e39d4c9ba9af$var$getSvgIconForItem({
                    name: item.value.name
                }) || item.elemBefore,
            /**
     * @note This transformed items action is only used when a quick insert item has been
     * called from the quick insert menu and a search has not been performed.
     */ action: ()=>onInsert({
                    item: item
                }),
            // "insertInsertMenuItem" expects these 2 properties.
            onClick: item.onClick,
            value: item.value
        }), [
        onInsert
    ]);
    const quickInsertDropdownItems = dropdownItems.map(transform);
    // Please clean up viewMoreItem when cleaning up platform_editor_refactor_view_more
    const viewMoreItem = !(0, $VSDnB.fg)('platform_editor_refactor_view_more') && showElementBrowserLink ? quickInsertDropdownItems.pop() : undefined;
    const onInsertItem = (0, $5uXOq.useCallback)((item)=>{
        toggleVisiblity();
        if (!editorView.hasFocus()) editorView.focus();
        pluginInjectionApi?.quickInsert?.actions.insertItem(item, (0, $gkwXh.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        toggleVisiblity,
        pluginInjectionApi
    ]);
    const { connectivityMode: connectivityMode } = $8773e39d4c9ba9af$var$useSharedState(pluginInjectionApi);
    const getItems = (0, $5uXOq.useCallback)((query, category)=>{
        let result;
        /**
     * @warning The results if there is a query are not the same as the results if there is no query.
     * For example: If you have a typed panel and then select the panel item then it will call a different action
     * than is specified on the editor plugins quick insert
     * @see above transform function for more details.
     */ if (query) result = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
            query: query,
            category: category
        })?.map((item)=>connectivityMode === 'offline' && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item) ?? [];
        else {
            const featuredQuickInsertSuggestions = pluginInjectionApi?.quickInsert?.actions.getSuggestions({
                category: category,
                featuredItems: true
            })?.map((item)=>connectivityMode === 'offline' && item.isDisabledOffline ? {
                    ...item,
                    isDisabled: true
                } : item) ?? [];
            result = quickInsertDropdownItems.concat(featuredQuickInsertSuggestions);
        }
        setItemCount(result.length);
        return result;
    }, [
        pluginInjectionApi?.quickInsert?.actions,
        quickInsertDropdownItems,
        connectivityMode
    ]);
    const emptyStateHandler = pluginInjectionApi?.quickInsert?.sharedState.currentState()?.emptyStateHandler;
    const onViewMore = (0, $5uXOq.useCallback)(()=>{
        toggleVisiblity();
        pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.quickInsert?.commands.openElementBrowserModal);
    }, [
        pluginInjectionApi,
        toggleVisiblity
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8773e39d4c9ba9af$var$insertMenuWrapper(height, isFullPageAppearance)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($8773e39d4c9ba9af$var$ElementBrowserWrapper, {
        handleClickOutside: toggleVisiblity,
        handleEscapeKeydown: toggleVisiblity,
        closeOnTab: !(0, $VSDnB.fg)('editor_a11y_tab_does_not_close_menus')
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hd31W.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        viewMoreItem: viewMoreItem,
        onViewMore: onViewMore,
        cache: cache
    }))));
};
const $8773e39d4c9ba9af$var$getSvgIconForItem = ({ name: name })=>{
    const Icon = {
        codeblock: (0, $I02Nt.IconCode),
        panel: (0, $I02Nt.IconPanel),
        blockquote: (0, $I02Nt.IconQuote),
        decision: (0, $I02Nt.IconDecision),
        horizontalrule: (0, $I02Nt.IconDivider),
        expand: (0, $I02Nt.IconExpand),
        date: (0, $I02Nt.IconDate),
        status: (0, $I02Nt.IconStatus)
    }[name];
    return Icon ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
        label: ""
    }) : undefined;
};
const $8773e39d4c9ba9af$var$insertMenuWrapper = (height, isFullPageAppearance)=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${height}px`,
        backgroundColor: `${`var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $k5uoT.borderRadius)()}px`,
        boxShadow: `${`var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)},
    0 2px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)},
    0 0 20px -6px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`}`
    });
};
const $8773e39d4c9ba9af$var$flexWrapperStyles = {
    name: "1wlc510",
    styles: "display:flex;flex:1;box-sizing:border-box;overflow:hidden"
};
const $8773e39d4c9ba9af$var$FlexWrapper = (props)=>{
    const setOutsideClickTargetRef = (0, $5uXOq.useContext)((0, $jdyxs.OutsideClickTargetRefContext));
    const { children: children, ...divProps } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setOutsideClickTargetRef,
        css: $8773e39d4c9ba9af$var$flexWrapperStyles,
        ...divProps
    }, children));
};
const $8773e39d4c9ba9af$var$ElementBrowserWrapper = (0, $jdyxs.default)($8773e39d4c9ba9af$var$FlexWrapper);
var $8773e39d4c9ba9af$export$2e2bcd8739ae039 = $8773e39d4c9ba9af$var$InsertMenu;

});

parcelRegister("fe0QZ", function(module, exports) {

$parcel$export(module.exports, "DropDownButton", () => $cb103d19850ee23e$export$e200d4ca2624495d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e9qoo = parcelRequire("e9qoo");

var $1jI4k = parcelRequire("1jI4k");

var $faod6 = parcelRequire("faod6");

var $c8Oei = parcelRequire("c8Oei");

var $a648C = parcelRequire("a648C");
const $cb103d19850ee23e$var$DropDownButtonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $a648C.triggerWrapper)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        label: props.label,
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        label: "",
        color: "currentColor",
        LEGACY_margin: "0 0 0 -8px"
    }))));
const $cb103d19850ee23e$export$e200d4ca2624495d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        ref: props.handleRef,
        selected: props.selected,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        "aria-expanded": props['aria-expanded'],
        "aria-haspopup": props['aria-haspopup'],
        "aria-keyshortcuts": props['aria-keyshortcuts'],
        "aria-label": `${props.label}`,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)($cb103d19850ee23e$var$DropDownButtonIcon, {
            label: ""
        }),
        title: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: props.label,
            shortcutOverride: "/"
        })
    }));

});
parcelRegister("a648C", function(module, exports) {

$parcel$export(module.exports, "triggerWrapper", () => $84e03596731ec6bd$export$61533625d778d03b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $84e03596731ec6bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $84e03596731ec6bd$export$61533625d778d03b = {
    name: "y71vja",
    styles: "width:42px;display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}"
};
const $84e03596731ec6bd$export$16be3daa8c26e74d = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};

});




parcelRegister("b8wiF", function(module, exports) {

$parcel$export(module.exports, "createItems", () => $c68d192190f0f7a3$export$af56db357559c888);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gJBT6 = parcelRequire("gJBT6");

var $8QpSo = parcelRequire("8QpSo");

var $e9qoo = parcelRequire("e9qoo");

var $9NKqk = parcelRequire("9NKqk");
var $2i4K4 = parcelRequire("2i4K4");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hMH4H = parcelRequire("hMH4H");

var $33tRe = parcelRequire("33tRe");
const $c68d192190f0f7a3$var$buttonToItem = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((button)=>({
        ...button,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: button.content,
            shortcutOverride: button.shortcut
        })
    }));
const $c68d192190f0f7a3$var$buttonToDropdownItem = (0, $8QpSo.default)((title)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((button)=>({
            ...button,
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
                description: title,
                shortcutOverride: "/"
            })
        })));
const $c68d192190f0f7a3$var$createInsertBlockItems = (config)=>{
    const { isTypeAheadAllowed: isTypeAheadAllowed, tableSupported: tableSupported, tableSelectorSupported: tableSelectorSupported, mediaUploadsEnabled: mediaUploadsEnabled, mediaSupported: mediaSupported, imageUploadSupported: imageUploadSupported, imageUploadEnabled: imageUploadEnabled, mentionsSupported: mentionsSupported, mentionsDisabled: mentionsDisabled, availableWrapperBlockTypes: availableWrapperBlockTypes, actionSupported: actionSupported, decisionSupported: decisionSupported, showElementBrowserLink: showElementBrowserLink, linkSupported: linkSupported, linkDisabled: linkDisabled, emojiDisabled: emojiDisabled, emojiProvider: emojiProvider, hasEmojiPlugin: hasEmojiPlugin, hasMentionsPlugin: hasMentionsPlugin, hasMediaPlugin: hasMediaPlugin, nativeStatusSupported: nativeStatusSupported, insertMenuItems: insertMenuItems, dateEnabled: dateEnabled, placeholderTextEnabled: placeholderTextEnabled, horizontalRuleEnabled: horizontalRuleEnabled, layoutSectionEnabled: layoutSectionEnabled, expandEnabled: expandEnabled, numberOfButtons: numberOfButtons, schema: schema, formatMessage: formatMessage, isEditorOffline: isEditorOffline } = config;
    const items = [];
    const isOffline = isEditorOffline === true;
    if (actionSupported) items.push((0, $hMH4H.action)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).action),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).actionDescription),
        disabled: false
    }));
    if (linkSupported) items.push((0, $hMH4H.link)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).link),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).linkDescription),
        disabled: !!linkDisabled,
        'aria-haspopup': 'dialog'
    }));
    if ((0, $gmhCD.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) {
        if (imageUploadSupported) items.push((0, $hMH4H.imageUpload)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        else if (hasMediaPlugin) items.push((0, $hMH4H.media)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline || !mediaSupported || !mediaUploadsEnabled
        }));
        if (hasMentionsPlugin) items.push((0, $hMH4H.mention)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled || !mentionsSupported,
            'aria-haspopup': 'listbox'
        }));
        if (hasEmojiPlugin) items.push((0, $hMH4H.emoji)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed || !emojiProvider,
            'aria-haspopup': 'dialog'
        }));
    } else {
        if (mediaSupported && mediaUploadsEnabled) items.push((0, $hMH4H.media)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).addMediaFiles),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mediaFilesDescription),
            disabled: isOffline
        }));
        if (imageUploadSupported) items.push((0, $hMH4H.imageUpload)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).image),
            disabled: !imageUploadEnabled || isOffline
        }));
        if (mentionsSupported) items.push((0, $hMH4H.mention)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mention),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).mentionDescription),
            disabled: !isTypeAheadAllowed || !!mentionsDisabled,
            'aria-haspopup': 'listbox'
        }));
        if (emojiProvider) items.push((0, $hMH4H.emoji)({
            content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).emoji),
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).emojiDescription),
            disabled: emojiDisabled || !isTypeAheadAllowed,
            'aria-haspopup': 'dialog'
        }));
    }
    if (tableSupported) items.push((0, $hMH4H.table)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).table),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableDescription),
        disabled: false
    }));
    if (tableSupported && tableSelectorSupported) items.push((0, $hMH4H.tableSelector)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableSelector),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableSelectorDescription),
        disabled: false
    }));
    if (layoutSectionEnabled) {
        const labelColumns = formatMessage((0, $2i4K4.toolbarInsertBlockMessages).columns);
        items.push((0, $hMH4H.layout)({
            content: labelColumns,
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).columnsDescription),
            disabled: false
        }));
    }
    const blockTypes = availableWrapperBlockTypes || [];
    const codeblockData = blockTypes.find((type)=>type.name === 'codeblock');
    const panelData = blockTypes.find((type)=>type.name === 'panel');
    const blockquoteData = blockTypes.find((type)=>type.name === 'blockquote');
    if (codeblockData) items.push((0, $hMH4H.codeblock)({
        content: formatMessage(codeblockData.title),
        tooltipDescription: formatMessage((0, $9NKqk.messages).codeblockDescription),
        disabled: false,
        shortcut: '```'
    }));
    if (panelData) items.push((0, $hMH4H.panel)({
        content: formatMessage(panelData.title),
        tooltipDescription: formatMessage((0, $9NKqk.messages).infoPanelDescription),
        disabled: false
    }));
    if (blockquoteData) items.push((0, $hMH4H.blockquote)({
        content: formatMessage(blockquoteData.title),
        tooltipDescription: formatMessage((0, $9NKqk.messages).blockquoteDescription),
        disabled: false,
        shortcut: '>'
    }));
    if (decisionSupported) items.push((0, $hMH4H.decision)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).decision),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).decisionDescription),
        disabled: false
    }));
    if (horizontalRuleEnabled && schema.nodes.rule) items.push((0, $hMH4H.horizontalrule)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).horizontalRule),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).horizontalRuleDescription),
        disabled: false
    }));
    if (expandEnabled && schema.nodes.expand) items.push((0, $hMH4H.expand)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).expand),
        tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).expandDescription),
        disabled: false
    }));
    if (dateEnabled) {
        const labelDate = formatMessage((0, $2i4K4.toolbarInsertBlockMessages).date);
        items.push((0, $hMH4H.date)({
            content: labelDate,
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).dateDescription),
            disabled: false
        }));
    }
    if (placeholderTextEnabled) items.push((0, $hMH4H.placeholder)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).placeholderText),
        disabled: false
    }));
    if (nativeStatusSupported) {
        const labelStatus = formatMessage((0, $2i4K4.toolbarInsertBlockMessages).status);
        items.push((0, $hMH4H.status)({
            content: labelStatus,
            tooltipDescription: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).statusDescription),
            disabled: false
        }));
    }
    if (insertMenuItems) items.push(...insertMenuItems);
    if (showElementBrowserLink && !(0, $VSDnB.fg)('platform_editor_refactor_view_more')) items.push((0, $hMH4H.more)({
        content: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).viewMore),
        disabled: false
    }));
    let numButtonsAdjusted = numberOfButtons;
    if ((0, $VSDnB.fg)('platform_editor_toolbar_responsive_fixes')) {
        if (items.slice(0, numButtonsAdjusted).some((item)=>item.value.name === 'table selector')) numButtonsAdjusted++;
    } else numButtonsAdjusted = tableSupported && tableSelectorSupported ? numberOfButtons + 1 : numberOfButtons;
    const buttonItems = items.slice(0, numButtonsAdjusted).map($c68d192190f0f7a3$var$buttonToItem);
    const remainingItems = items.slice(numButtonsAdjusted).filter(({ value: { name: name } })=>name !== 'table selector');
    const dropdownItems = remainingItems.map($c68d192190f0f7a3$var$buttonToDropdownItem(formatMessage((0, $2i4K4.toolbarInsertBlockMessages).insertMenu)));
    return [
        buttonItems,
        dropdownItems
    ];
};
const $c68d192190f0f7a3$export$af56db357559c888 = (0, $8QpSo.default)($c68d192190f0f7a3$var$createInsertBlockItems, (0, $33tRe.shallowEquals));

});
parcelRegister("hMH4H", function(module, exports) {

$parcel$export(module.exports, "action", () => $76a587742864f15c$export$31eb53bd5b582a97);
$parcel$export(module.exports, "link", () => $76a587742864f15c$export$9c30223ca0a664fb);
$parcel$export(module.exports, "media", () => $76a587742864f15c$export$987d49ffe1b0900f);
$parcel$export(module.exports, "imageUpload", () => $76a587742864f15c$export$d5dd7159835f64ad);
$parcel$export(module.exports, "mention", () => $76a587742864f15c$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $76a587742864f15c$export$a19185d1233fc4b2);
$parcel$export(module.exports, "table", () => $76a587742864f15c$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableSelector", () => $76a587742864f15c$export$614b510decb5e0d8);
$parcel$export(module.exports, "layout", () => $76a587742864f15c$export$b3219800bda33a1f);
$parcel$export(module.exports, "codeblock", () => $76a587742864f15c$export$c0626db977961abf);
$parcel$export(module.exports, "panel", () => $76a587742864f15c$export$21f42ab9b6679f44);
$parcel$export(module.exports, "blockquote", () => $76a587742864f15c$export$67dc04e652a298ca);
$parcel$export(module.exports, "decision", () => $76a587742864f15c$export$29bcf506ab92b297);
$parcel$export(module.exports, "horizontalrule", () => $76a587742864f15c$export$f7cc6d560fcfab9b);
$parcel$export(module.exports, "expand", () => $76a587742864f15c$export$9f77e0932fb78f72);
$parcel$export(module.exports, "date", () => $76a587742864f15c$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $76a587742864f15c$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "status", () => $76a587742864f15c$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "more", () => $76a587742864f15c$export$a627d162e8aad100);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $e9qoo = parcelRequire("e9qoo");

var $24JcV = parcelRequire("24JcV");

var $b0NCQ = parcelRequire("b0NCQ");

var $cgRoK = parcelRequire("cgRoK");

var $2uTgk = parcelRequire("2uTgk");

var $kjQah = parcelRequire("kjQah");

var $8ndMa = parcelRequire("8ndMa");

var $1VG19 = parcelRequire("1VG19");

var $j0PWQ = parcelRequire("j0PWQ");

var $cgRqd = parcelRequire("cgRqd");

var $96UJI = parcelRequire("96UJI");

var $c1wLk = parcelRequire("c1wLk");

var $fcZox = parcelRequire("fcZox");

var $kKn0Y = parcelRequire("kKn0Y");

var $l0mND = parcelRequire("l0mND");

var $bboDl = parcelRequire("bboDl");

var $fP8bU = parcelRequire("fP8bU");

var $4xPlE = parcelRequire("4xPlE");

var $8evqP = parcelRequire("8evqP");

var $ehtr6 = parcelRequire("ehtr6");

var $1pwdH = parcelRequire("1pwdH");

var $c8Oei = parcelRequire("c8Oei");

var $3RcFX = parcelRequire("3RcFX");

var $33tRe = parcelRequire("33tRe");
const $76a587742864f15c$var$from = (init)=>({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        value: {
            name: init.name
        },
        elemBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)(init.Icon, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        elemAfter: init.shortcut ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $24JcV.shortcutStyle)
        }, init.shortcut) : undefined,
        'aria-label': init.shortcut ? init.content + ' ' + init.shortcut : init.content,
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': init['aria-keyshortcuts'],
        shortcut: init.shortcut,
        isDisabled: init.disabled
    });
const $76a587742864f15c$var$mem = (fn)=>(0, $8QpSo.default)(fn, (0, $33tRe.shallowEquals));
const $76a587742864f15c$export$31eb53bd5b582a97 = $76a587742864f15c$var$mem((init)=>{
    return $76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'action',
        shortcut: '[]',
        Icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8evqP)))
            }),
        'aria-keyshortcuts': '[ ] Space'
    });
});
const $76a587742864f15c$export$9c30223ca0a664fb = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'link',
        shortcut: (0, $e9qoo.tooltip)((0, $e9qoo.addLink)),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fcZox))),
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': (0, $e9qoo.getAriaKeyshortcuts)((0, $e9qoo.addLink))
    }));
const $76a587742864f15c$export$987d49ffe1b0900f = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'media',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cgRqd)))
    }));
const $76a587742864f15c$export$d5dd7159835f64ad = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'image upload',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cgRqd)))
    }));
const $76a587742864f15c$export$db83999c14438df4 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'mention',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kKn0Y))),
        shortcut: '@',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+2 Space'
    }));
const $76a587742864f15c$export$a19185d1233fc4b2 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'emoji',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1VG19))),
        shortcut: ':',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+;'
    }));
const $76a587742864f15c$export$9852986a3ec5f6a0 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($j0PWQ))),
        shortcut: (0, $e9qoo.tooltip)((0, $e9qoo.toggleTable)),
        'aria-keyshortcuts': (0, $e9qoo.getAriaKeyshortcuts)((0, $e9qoo.toggleTable))
    }));
const $76a587742864f15c$export$614b510decb5e0d8 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table selector',
        Icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                label: "",
                color: "currentColor"
            })
    }));
const $76a587742864f15c$export$b3219800bda33a1f = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'layout',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c1wLk)))
    }));
const $76a587742864f15c$export$c0626db977961abf = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'codeblock',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2uTgk))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $e9qoo.getAriaKeyshortcuts)(init.shortcut)
    }));
const $76a587742864f15c$export$21f42ab9b6679f44 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'panel',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96UJI))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $e9qoo.getAriaKeyshortcuts)(init.shortcut)
    }));
const $76a587742864f15c$export$67dc04e652a298ca = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'blockquote',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bboDl))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': 'Shift+. Space'
    }));
const $76a587742864f15c$export$29bcf506ab92b297 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'decision',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8ndMa))),
        shortcut: '<>',
        'aria-keyshortcuts': 'Shift+, Shift+. Space'
    }));
const $76a587742864f15c$export$f7cc6d560fcfab9b = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'horizontalrule',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l0mND))),
        shortcut: '---',
        'aria-keyshortcuts': '- - -'
    }));
const $76a587742864f15c$export$9f77e0932fb78f72 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'expand',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3RcFX)))
    }));
const $76a587742864f15c$export$324d90190a8b822a = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'date',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kjQah))),
        shortcut: '//',
        'aria-keyshortcuts': '/ / Enter'
    }));
const $76a587742864f15c$export$c7187bbd1a7a9244 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'placeholder text',
        Icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b0NCQ))), {
                label: "",
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ehtr6)))
            })
    }));
const $76a587742864f15c$export$471f7ae5c4103ae1 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'status',
        Icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgRoK))), {
                label: "",
                color: "currentColor",
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1pwdH)))
            })
    }));
const $76a587742864f15c$export$a627d162e8aad100 = $76a587742864f15c$var$mem((init)=>$76a587742864f15c$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'macro',
        Icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fP8bU))), {
                label: "",
                color: "currentColor"
            })
    }));

});
parcelRegister("b0NCQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f9cbf95ff826dbea235ae2539545b0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80463063111cbcbb$var$_react = $80463063111cbcbb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $80463063111cbcbb$var$_baseNew = $80463063111cbcbb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $80463063111cbcbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80463063111cbcbb$var$FieldTextIcon = (props)=>/*#__PURE__*/ $80463063111cbcbb$var$_react.default.createElement($80463063111cbcbb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$80463063111cbcbb$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $80463063111cbcbb$var$_default = module.exports.default = $80463063111cbcbb$var$FieldTextIcon;

});

parcelRegister("2uTgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e519cf0978c0b8571eb278151e6a33c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d194014e27a1cf0$var$_react = $1d194014e27a1cf0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1d194014e27a1cf0$var$_angleBrackets = $1d194014e27a1cf0$var$_interopRequireDefault((parcelRequire("jSlaY")));

var $1d194014e27a1cf0$var$_code = $1d194014e27a1cf0$var$_interopRequireDefault((parcelRequire("lniq9")));
function $1d194014e27a1cf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "EditorCodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d194014e27a1cf0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $1d194014e27a1cf0$var$_react.default.createElement($1d194014e27a1cf0$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $1d194014e27a1cf0$var$_code.default
    }, props));
$1d194014e27a1cf0$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $1d194014e27a1cf0$var$_default = module.exports.default = $1d194014e27a1cf0$var$AngleBracketsIcon;

});
parcelRegister("lniq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8fa08f589ab90da$var$_react = $f8fa08f589ab90da$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f8fa08f589ab90da$var$_angleBrackets = $f8fa08f589ab90da$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $f8fa08f589ab90da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8fa08f589ab90da$var$EditorCodeIcon = (props)=>/*#__PURE__*/ $f8fa08f589ab90da$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0m3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483"/></svg>`
    }, props, {
        newIcon: $f8fa08f589ab90da$var$_angleBrackets.default
    }));
$f8fa08f589ab90da$var$EditorCodeIcon.displayName = 'EditorCodeIcon';
var $f8fa08f589ab90da$var$_default = module.exports.default = $f8fa08f589ab90da$var$EditorCodeIcon;

});


parcelRegister("kjQah", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f88b1ea3518cb3ea6d0e4d6285a798cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecae0bd3381faef4$var$_react = $ecae0bd3381faef4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ecae0bd3381faef4$var$_calendar = $ecae0bd3381faef4$var$_interopRequireDefault((parcelRequire("3fesp")));

var $ecae0bd3381faef4$var$_date = $ecae0bd3381faef4$var$_interopRequireDefault((parcelRequire("5ujFr")));
function $ecae0bd3381faef4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "EditorDateIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ecae0bd3381faef4$var$CalendarIcon = (props)=>/*#__PURE__*/ $ecae0bd3381faef4$var$_react.default.createElement($ecae0bd3381faef4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $ecae0bd3381faef4$var$_date.default
    }, props));
$ecae0bd3381faef4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $ecae0bd3381faef4$var$_default = module.exports.default = $ecae0bd3381faef4$var$CalendarIcon;

});
parcelRegister("5ujFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fef029bb0678cd1$var$_react = $3fef029bb0678cd1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3fef029bb0678cd1$var$_calendar = $3fef029bb0678cd1$var$_interopRequireDefault((parcelRequire("3fesp")));
function $3fef029bb0678cd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fef029bb0678cd1$var$EditorDateIcon = (props)=>/*#__PURE__*/ $3fef029bb0678cd1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51zm2 2.995v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 11h-.99a.497.497 0 0 0-.505.505m3 0v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99a.497.497 0 0 0-.505-.505h-.99a.497.497 0 0 0-.505.505m-3 3v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 14h-.99a.497.497 0 0 0-.505.505M7.5 8v1h3V8zm6 0v1h3V8zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8z"/></svg>`
    }, props, {
        newIcon: $3fef029bb0678cd1$var$_calendar.default
    }));
$3fef029bb0678cd1$var$EditorDateIcon.displayName = 'EditorDateIcon';
var $3fef029bb0678cd1$var$_default = module.exports.default = $3fef029bb0678cd1$var$EditorDateIcon;

});


parcelRegister("8ndMa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618b284e40a0b360$var$_react = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618b284e40a0b360$var$_decision = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("8HSNL")));

var $618b284e40a0b360$var$_decision2 = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("fkXRs")));
function $618b284e40a0b360$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618b284e40a0b360$var$DecisionIcon = (props)=>/*#__PURE__*/ $618b284e40a0b360$var$_react.default.createElement($618b284e40a0b360$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $618b284e40a0b360$var$_decision2.default
    }, props));
$618b284e40a0b360$var$DecisionIcon.Name = 'DecisionIconMigration';
var $618b284e40a0b360$var$_default = module.exports.default = $618b284e40a0b360$var$DecisionIcon;

});
parcelRegister("fkXRs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2a7287aaf779f72$var$_react = $b2a7287aaf779f72$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $b2a7287aaf779f72$var$_decision = $b2a7287aaf779f72$var$_interopRequireDefault((parcelRequire("8HSNL")));
function $b2a7287aaf779f72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2a7287aaf779f72$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b2a7287aaf779f72$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $b2a7287aaf779f72$var$_decision.default
    }));
$b2a7287aaf779f72$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b2a7287aaf779f72$var$_default = module.exports.default = $b2a7287aaf779f72$var$EditorDecisionIcon;

});


parcelRegister("1VG19", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be2db0d473b67ee2b7dfc80ce4f694c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $167bb52569d93b17$var$_react = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $167bb52569d93b17$var$_emoji = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("cVLny")));

var $167bb52569d93b17$var$_emoji2 = $167bb52569d93b17$var$_interopRequireDefault((parcelRequire("5KHlT")));
function $167bb52569d93b17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $167bb52569d93b17$var$EmojiIcon = (props)=>/*#__PURE__*/ $167bb52569d93b17$var$_react.default.createElement($167bb52569d93b17$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $167bb52569d93b17$var$_emoji2.default
    }, props));
$167bb52569d93b17$var$EmojiIcon.Name = 'EmojiIconMigration';
var $167bb52569d93b17$var$_default = module.exports.default = $167bb52569d93b17$var$EmojiIcon;

});
parcelRegister("5KHlT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4302e071af14b636$var$_react = $4302e071af14b636$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4302e071af14b636$var$_emoji = $4302e071af14b636$var$_interopRequireDefault((parcelRequire("cVLny")));
function $4302e071af14b636$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4302e071af14b636$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $4302e071af14b636$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props, {
        newIcon: $4302e071af14b636$var$_emoji.default
    }));
$4302e071af14b636$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $4302e071af14b636$var$_default = module.exports.default = $4302e071af14b636$var$EditorEmojiIcon;

});


parcelRegister("j0PWQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6068ce094a58d2a4e41058e6491fe82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd765035bcf7e8e4$var$_react = $dd765035bcf7e8e4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd765035bcf7e8e4$var$_grid = $dd765035bcf7e8e4$var$_interopRequireDefault((parcelRequire("dgJHC")));

var $dd765035bcf7e8e4$var$_table = $dd765035bcf7e8e4$var$_interopRequireDefault((parcelRequire("8x6ku")));
function $dd765035bcf7e8e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GridIcon.
 * This component is GridIcon, with `UNSAFE_fallbackIcon` set to "EditorTableIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd765035bcf7e8e4$var$GridIcon = (props)=>/*#__PURE__*/ $dd765035bcf7e8e4$var$_react.default.createElement($dd765035bcf7e8e4$var$_grid.default, Object.assign({
        LEGACY_fallbackIcon: $dd765035bcf7e8e4$var$_table.default
    }, props));
$dd765035bcf7e8e4$var$GridIcon.Name = 'GridIconMigration';
var $dd765035bcf7e8e4$var$_default = module.exports.default = $dd765035bcf7e8e4$var$GridIcon;

});
parcelRegister("8x6ku", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $636650b51cd285e6$var$_react = $636650b51cd285e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $636650b51cd285e6$var$_grid = $636650b51cd285e6$var$_interopRequireDefault((parcelRequire("dgJHC")));
function $636650b51cd285e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $636650b51cd285e6$var$EditorTableIcon = (props)=>/*#__PURE__*/ $636650b51cd285e6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $636650b51cd285e6$var$_grid.default
    }));
$636650b51cd285e6$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $636650b51cd285e6$var$_default = module.exports.default = $636650b51cd285e6$var$EditorTableIcon;

});


parcelRegister("cgRqd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26ae4d434fb8f3aabcf062c18176f1fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ef06b2394af7201$var$_react = $8ef06b2394af7201$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8ef06b2394af7201$var$_image = $8ef06b2394af7201$var$_interopRequireDefault((parcelRequire("fhbwe")));

var $8ef06b2394af7201$var$_image2 = $8ef06b2394af7201$var$_interopRequireDefault((parcelRequire("7L2Ry")));
function $8ef06b2394af7201$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ImageIcon.
 * This component is ImageIcon, with `UNSAFE_fallbackIcon` set to "EditorImageIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ef06b2394af7201$var$ImageIcon = (props)=>/*#__PURE__*/ $8ef06b2394af7201$var$_react.default.createElement($8ef06b2394af7201$var$_image.default, Object.assign({
        LEGACY_fallbackIcon: $8ef06b2394af7201$var$_image2.default
    }, props));
$8ef06b2394af7201$var$ImageIcon.Name = 'ImageIconMigration';
var $8ef06b2394af7201$var$_default = module.exports.default = $8ef06b2394af7201$var$ImageIcon;

});
parcelRegister("7L2Ry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a5f24a98cf5ac24$var$_react = $5a5f24a98cf5ac24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5a5f24a98cf5ac24$var$_image = $5a5f24a98cf5ac24$var$_interopRequireDefault((parcelRequire("fhbwe")));
function $5a5f24a98cf5ac24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a5f24a98cf5ac24$var$EditorImageIcon = (props)=>/*#__PURE__*/ $5a5f24a98cf5ac24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11 15-1-1-2 2h8v-1.8L14 12zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>`
    }, props, {
        newIcon: $5a5f24a98cf5ac24$var$_image.default
    }));
$5a5f24a98cf5ac24$var$EditorImageIcon.displayName = 'EditorImageIcon';
var $5a5f24a98cf5ac24$var$_default = module.exports.default = $5a5f24a98cf5ac24$var$EditorImageIcon;

});


parcelRegister("96UJI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c283363b764d34f6b30155eda3eaef46>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a20af3e274078d5$var$_react = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6a20af3e274078d5$var$_information = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $6a20af3e274078d5$var$_info = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("iRH6p")));
function $6a20af3e274078d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a20af3e274078d5$var$InformationIcon = (props)=>/*#__PURE__*/ $6a20af3e274078d5$var$_react.default.createElement($6a20af3e274078d5$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $6a20af3e274078d5$var$_info.default
    }, props));
$6a20af3e274078d5$var$InformationIcon.Name = 'InformationIconMigration';
var $6a20af3e274078d5$var$_default = module.exports.default = $6a20af3e274078d5$var$InformationIcon;

});
parcelRegister("iRH6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $dbbe9c7ad934f1e0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $dbbe9c7ad934f1e0$var$_information.default
    }));
$dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;

});


parcelRegister("c1wLk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5db5debf34e76a8ad809bb3a247e273>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c0efdf379a64ff4$var$_react = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c0efdf379a64ff4$var$_layoutTwoColumns = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("lhITB")));

var $8c0efdf379a64ff4$var$_layoutTwoEqual = $8c0efdf379a64ff4$var$_interopRequireDefault((parcelRequire("fdFa0")));
function $8c0efdf379a64ff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsIcon.
 * This component is LayoutTwoColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c0efdf379a64ff4$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $8c0efdf379a64ff4$var$_react.default.createElement($8c0efdf379a64ff4$var$_layoutTwoColumns.default, Object.assign({
        LEGACY_fallbackIcon: $8c0efdf379a64ff4$var$_layoutTwoEqual.default
    }, props));
$8c0efdf379a64ff4$var$LayoutTwoColumnsIcon.Name = 'LayoutTwoColumnsIconMigration';
var $8c0efdf379a64ff4$var$_default = module.exports.default = $8c0efdf379a64ff4$var$LayoutTwoColumnsIcon;

});
parcelRegister("lhITB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a49c5b5418c2c6666b4305c3541f252>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7ee02e1f6e030a1$var$_react = $f7ee02e1f6e030a1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7ee02e1f6e030a1$var$_baseNew = $f7ee02e1f6e030a1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7ee02e1f6e030a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $f7ee02e1f6e030a1$var$_react.default.createElement($f7ee02e1f6e030a1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $f7ee02e1f6e030a1$var$_default = module.exports.default = $f7ee02e1f6e030a1$var$LayoutTwoColumnsIcon;

});

parcelRegister("fdFa0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b147ff8615535e6d$var$_react = $b147ff8615535e6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $b147ff8615535e6d$var$_layoutTwoColumns = $b147ff8615535e6d$var$_interopRequireDefault((parcelRequire("lhITB")));
function $b147ff8615535e6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b147ff8615535e6d$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $b147ff8615535e6d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $b147ff8615535e6d$var$_layoutTwoColumns.default
    }));
$b147ff8615535e6d$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $b147ff8615535e6d$var$_default = module.exports.default = $b147ff8615535e6d$var$EditorLayoutTwoEqualIcon;

});


parcelRegister("fcZox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12799b511c38ec3$var$_react = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b12799b511c38ec3$var$_link = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $b12799b511c38ec3$var$_link2 = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("7WxSP")));
function $b12799b511c38ec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b12799b511c38ec3$var$LinkIcon = (props)=>/*#__PURE__*/ $b12799b511c38ec3$var$_react.default.createElement($b12799b511c38ec3$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b12799b511c38ec3$var$_link2.default
    }, props));
$b12799b511c38ec3$var$LinkIcon.Name = 'LinkIconMigration';
var $b12799b511c38ec3$var$_default = module.exports.default = $b12799b511c38ec3$var$LinkIcon;

});
parcelRegister("7WxSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $5c883bb6fff27f31$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $5c883bb6fff27f31$var$_link.default
    }));
$5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;

});


parcelRegister("kKn0Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8421189d331f9e049ee797d0467057ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1a9f4c691bc9057$var$_react = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f1a9f4c691bc9057$var$_mention = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("izMdR")));

var $f1a9f4c691bc9057$var$_mention2 = $f1a9f4c691bc9057$var$_interopRequireDefault((parcelRequire("3kXe9")));
function $f1a9f4c691bc9057$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1a9f4c691bc9057$var$MentionIcon = (props)=>/*#__PURE__*/ $f1a9f4c691bc9057$var$_react.default.createElement($f1a9f4c691bc9057$var$_mention.default, Object.assign({
        LEGACY_fallbackIcon: $f1a9f4c691bc9057$var$_mention2.default
    }, props));
$f1a9f4c691bc9057$var$MentionIcon.Name = 'MentionIconMigration';
var $f1a9f4c691bc9057$var$_default = module.exports.default = $f1a9f4c691bc9057$var$MentionIcon;

});
parcelRegister("3kXe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26e12eaafd006aef$var$_react = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $26e12eaafd006aef$var$_mention = $26e12eaafd006aef$var$_interopRequireDefault((parcelRequire("izMdR")));
function $26e12eaafd006aef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $26e12eaafd006aef$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $26e12eaafd006aef$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $26e12eaafd006aef$var$_mention.default
    }));
$26e12eaafd006aef$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $26e12eaafd006aef$var$_default = module.exports.default = $26e12eaafd006aef$var$EditorMentionIcon;

});


parcelRegister("l0mND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e97962a641ed95eb219dd8e918f4682d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4ab4896b2231043$var$_react = $f4ab4896b2231043$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f4ab4896b2231043$var$_minus = $f4ab4896b2231043$var$_interopRequireDefault((parcelRequire("cGbU6")));

var $f4ab4896b2231043$var$_horizontalRule = $f4ab4896b2231043$var$_interopRequireDefault((parcelRequire("54x4x")));
function $f4ab4896b2231043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MinusIcon.
 * This component is MinusIcon, with `UNSAFE_fallbackIcon` set to "EditorHorizontalRuleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4ab4896b2231043$var$MinusIcon = (props)=>/*#__PURE__*/ $f4ab4896b2231043$var$_react.default.createElement($f4ab4896b2231043$var$_minus.default, Object.assign({
        LEGACY_fallbackIcon: $f4ab4896b2231043$var$_horizontalRule.default
    }, props));
$f4ab4896b2231043$var$MinusIcon.Name = 'MinusIconMigration';
var $f4ab4896b2231043$var$_default = module.exports.default = $f4ab4896b2231043$var$MinusIcon;

});
parcelRegister("cGbU6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $93b2a42556cf480d$var$_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $93b2a42556cf480d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93b2a42556cf480d$var$MinusIcon = (props)=>/*#__PURE__*/ $93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;

});

parcelRegister("54x4x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b16faec96c05702$var$_react = $3b16faec96c05702$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3b16faec96c05702$var$_minus = $3b16faec96c05702$var$_interopRequireDefault((parcelRequire("cGbU6")));
function $3b16faec96c05702$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b16faec96c05702$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $3b16faec96c05702$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props, {
        newIcon: $3b16faec96c05702$var$_minus.default
    }));
$3b16faec96c05702$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $3b16faec96c05702$var$_default = module.exports.default = $3b16faec96c05702$var$EditorHorizontalRuleIcon;

});


parcelRegister("bboDl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b6bac237a0c461904e6a964e56f26f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8243d48763fee196$var$_react = $8243d48763fee196$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8243d48763fee196$var$_quotationMark = $8243d48763fee196$var$_interopRequireDefault((parcelRequire("2UiHO")));

var $8243d48763fee196$var$_quote = $8243d48763fee196$var$_interopRequireDefault((parcelRequire("6BZqN")));
function $8243d48763fee196$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8243d48763fee196$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $8243d48763fee196$var$_react.default.createElement($8243d48763fee196$var$_quotationMark.default, Object.assign({
        LEGACY_fallbackIcon: $8243d48763fee196$var$_quote.default
    }, props));
$8243d48763fee196$var$QuotationMarkIcon.Name = 'QuotationMarkIconMigration';
var $8243d48763fee196$var$_default = module.exports.default = $8243d48763fee196$var$QuotationMarkIcon;

});
parcelRegister("6BZqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013e07a4125c7091$var$_react = $013e07a4125c7091$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $013e07a4125c7091$var$_quotationMark = $013e07a4125c7091$var$_interopRequireDefault((parcelRequire("2UiHO")));
function $013e07a4125c7091$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $013e07a4125c7091$var$QuoteIcon = (props)=>/*#__PURE__*/ $013e07a4125c7091$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6"/></svg>`
    }, props, {
        newIcon: $013e07a4125c7091$var$_quotationMark.default
    }));
$013e07a4125c7091$var$QuoteIcon.displayName = 'QuoteIcon';
var $013e07a4125c7091$var$_default = module.exports.default = $013e07a4125c7091$var$QuoteIcon;

});


parcelRegister("8evqP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5fe803328eb1ebb0$var$_react = $5fe803328eb1ebb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5fe803328eb1ebb0$var$_checkboxChecked = $5fe803328eb1ebb0$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $5fe803328eb1ebb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5fe803328eb1ebb0$var$EditorTaskIcon = (props)=>/*#__PURE__*/ $5fe803328eb1ebb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6m3.072 8.838.143.154a.5.5 0 0 0 .769-.042l.13-.175 3.733-5.045a.8.8 0 0 0-.11-1.064.665.665 0 0 0-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 0 0-.99 0 .8.8 0 0 0 0 1.07z"/></svg>`
    }, props, {
        newIcon: $5fe803328eb1ebb0$var$_checkboxChecked.default
    }));
$5fe803328eb1ebb0$var$EditorTaskIcon.displayName = 'EditorTaskIcon';
var $5fe803328eb1ebb0$var$_default = module.exports.default = $5fe803328eb1ebb0$var$EditorTaskIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("ehtr6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6597ca325c4cb95$var$_react = $a6597ca325c4cb95$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a6597ca325c4cb95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a6597ca325c4cb95$var$MediaServicesTextIcon = (props)=>/*#__PURE__*/ $a6597ca325c4cb95$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v11h-2zM6 5h12v2H6z"/><path d="M5 5h2v3H5zm5 13h4v2h-4zm7-13h2v3h-2z"/></g></svg>`
    }, props));
$a6597ca325c4cb95$var$MediaServicesTextIcon.displayName = 'MediaServicesTextIcon';
var $a6597ca325c4cb95$var$_default = module.exports.default = $a6597ca325c4cb95$var$MediaServicesTextIcon;

});

parcelRegister("1pwdH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10711e7344caba74$var$_react = $10711e7344caba74$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $10711e7344caba74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10711e7344caba74$var$StatusIcon = (props)=>/*#__PURE__*/ $10711e7344caba74$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$10711e7344caba74$var$StatusIcon.displayName = 'StatusIcon';
var $10711e7344caba74$var$_default = module.exports.default = $10711e7344caba74$var$StatusIcon;

});

parcelRegister("3RcFX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef3c287fd1ecc2180854973691d76a75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cf02776393750bb$var$_react = $2cf02776393750bb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cf02776393750bb$var$_chevronRight = $2cf02776393750bb$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $2cf02776393750bb$var$_chevronRightCircle = $2cf02776393750bb$var$_interopRequireDefault((parcelRequire("8KJVQ")));
function $2cf02776393750bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cf02776393750bb$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $2cf02776393750bb$var$_react.default.createElement($2cf02776393750bb$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $2cf02776393750bb$var$_chevronRightCircle.default
    }, props));
$2cf02776393750bb$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $2cf02776393750bb$var$_default = module.exports.default = $2cf02776393750bb$var$ChevronRightIcon;

});
parcelRegister("8KJVQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65f63fbd27b0c00e$var$_react = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $65f63fbd27b0c00e$var$_chevronRight = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("bpC55")));
function $65f63fbd27b0c00e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65f63fbd27b0c00e$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $65f63fbd27b0c00e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $65f63fbd27b0c00e$var$_chevronRight.default
    }));
$65f63fbd27b0c00e$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $65f63fbd27b0c00e$var$_default = module.exports.default = $65f63fbd27b0c00e$var$ChevronRightCircleIcon;

});


parcelRegister("33tRe", function(module, exports) {

$parcel$export(module.exports, "shallowEquals", () => $32fa06d28aafd188$export$fa1c2bbf4100b8bc);
const $32fa06d28aafd188$export$fa1c2bbf4100b8bc = ([aRaw], [bRaw])=>{
    const a = aRaw;
    const b = bRaw;
    return !Object.keys(a).some((key)=>{
        const k = key;
        return a[k] !== b[k];
    });
};

});






parcelRegister("ewWTS", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => (parcelRequire("54Pnl")).pastePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $54Pnl = parcelRequire("54Pnl");

});
parcelRegister("54Pnl", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => $28b8ca4838b99c5f$export$2d7f4bd9c1268cd7);

var $aehLH = parcelRequire("aehLH");

var $2NfYE = parcelRequire("2NfYE");

var $6eO8M = parcelRequire("6eO8M");
const $28b8ca4838b99c5f$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>(0, $aehLH.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $2NfYE.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                lastContentPasted: null
            };
            const pluginState = (0, $6eO8M.pluginKey).getState(editorState);
            return {
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("aehLH", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $d10e66844f67b307$export$ae829ec7b2625219);

var $7Jxgt = parcelRequire("7Jxgt");

var $gkwXh = parcelRequire("gkwXh");
var $2yLEW = parcelRequire("2yLEW");

var $1ZWXY = parcelRequire("1ZWXY");

var $kxM7f = parcelRequire("kxM7f");

var $04ZRC = parcelRequire("04ZRC");

var $ekofw = parcelRequire("ekofw");
var $1M84d = parcelRequire("1M84d");

var $ap7h6 = parcelRequire("ap7h6");

var $5KWxh = parcelRequire("5KWxh");

var $lKK04 = parcelRequire("lKK04");
var $iYg8V = parcelRequire("iYg8V");
var $8Amfw = parcelRequire("8Amfw");
var $hZCXS = parcelRequire("hZCXS");
var $fH9ql = parcelRequire("fH9ql");

var $h03xs = parcelRequire("h03xs");
var $594Yf = parcelRequire("594Yf");
var $dPSMN = parcelRequire("dPSMN");
var $7vpuQ = parcelRequire("7vpuQ");

var $38KaN = parcelRequire("38KaN");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $hKZR1 = parcelRequire("hKZR1");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $l0B7L = parcelRequire("l0B7L");

var $iMJAN = parcelRequire("iMJAN");

var $sgs63 = parcelRequire("sgs63");

var $hJPkr = parcelRequire("hJPkr");

var $jI1GO = parcelRequire("jI1GO");

var $6eO8M = parcelRequire("6eO8M");

var $bZdX5 = parcelRequire("bZdX5");

var $cOOfv = parcelRequire("cOOfv");

var $hUtHc = parcelRequire("hUtHc");

var $jbxbo = parcelRequire("jbxbo");
const $d10e66844f67b307$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)(blockquote)(state.selection);
};
const $d10e66844f67b307$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $d10e66844f67b307$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, cardOptions, sanitizePrivateContent, providerFactory) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $38KaN.MarkdownTransformer)(schema, (0, $1M84d.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        const textInput = escapeBackslashExceptCodeblock(text);
        const doc = atlassianMarkDownParser.parse((0, $bZdX5.escapeLinks)(textInput));
        if (doc && doc.content) return new (0, $kCV8T.Slice)(doc.content, openStart, openEnd);
        return;
    }
    function escapeBackslashExceptCodeblock(textInput) {
        const codeToken = '```';
        if (!textInput.includes(codeToken)) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return textInput.replace(/\\/g, '\\\\');
        let isInsideCodeblock = false;
        let textSplitByNewLine = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        textSplitByNewLine = textSplitByNewLine.map((text)=>{
            if (text === codeToken) isInsideCodeblock = !isInsideCodeblock;
            else if (text.startsWith(codeToken) && isInsideCodeblock === false) // if there is some text after the ``` mark , it gets counted as language attribute only at the start of codeblock
            isInsideCodeblock = true;
            if (!isInsideCodeblock) // only escape text which is not inside a codeblock
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            text = text.replace(/\\/g, '\\\\');
            return text;
        });
        textInput = textSplitByNewLine.join('\n');
        return textInput;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $04ZRC.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $6eO8M.pluginKey),
        state: (0, $6eO8M.createPluginState)(dispatch, {
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            clipboardTextSerializer: // For serialising to plain text
            $jI1GO.clipboardTextSerializer,
            handleDOMEvents: {
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    return false;
                }
            },
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $VSDnB.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $fH9ql.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $ekofw.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) /**
						 * Microsoft Office, Number, Pages, etc. adds an image to clipboard
						 * with other mime-types so we don't let the event reach media.
						 * The detection ration here is that if the payload has both `html` and
						 * `files`, then it could be one of above or an image copied from web.
						 * Here, we don't have html, so we return true to allow default event behaviour
						 */ return true;
                    /**
					 * We want to return false for external copied image to allow
					 * it to be uploaded by the client.
					 *
					 * Scenario where we are pasting an external image inside a block quote
					 * is skipped and handled in handleRichText
					 */ if ((0, $bZdX5.htmlContainsSingleFile)(html) && !$d10e66844f67b307$export$eedfdbc6a6bc1442(view.state)) return true;
                    /**
					 * https://product-fabric.atlassian.net/browse/ED-21993
					 * stopImmediatePropagation will run the first event attached to the same element
					 * Which chould have race condition issue
					 */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $hJPkr.getContentNodeTypes)(slice.content);
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
                const measureName = `${$d10e66844f67b307$var$PASTE}_${pasteId}`;
                (0, $ap7h6.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $hJPkr.createPasteMeasurePayload)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                });
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $594Yf.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    const isDocChanged = tr.docChanged;
                    (0, $1ZWXY.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $gkwXh.ACTION).PASTED_AS_PLAIN : (0, $gkwXh.ACTION).PASTED,
                        inputMethod: (0, $gkwXh.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                        const pasteEndPos = tr.selection.to;
                        const contentPasted = {
                            pasteStartPos: pasteStartPos,
                            pasteEndPos: pasteEndPos,
                            text: text,
                            isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            view.shiftKey || view.input?.shiftKey),
                            isPlainText: Boolean(isPlainText),
                            pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                            pastedAt: Date.now(),
                            pasteSource: (0, $bZdX5.getPasteSource)(event)
                        };
                        tr.setMeta((0, $6eO8M.pluginKey), {
                            type: (0, $l0B7L.PastePluginActionTypes).ON_PASTE,
                            contentPasted: contentPasted
                        });
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $hUtHc.handleParagraphBlockMarks)(state, slice);
                slice = (0, $cOOfv.handleVSCodeBlock)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                const plainTextPasteSlice = (0, $dPSMN.linkifyContent)(state.schema)(slice);
                if ((0, $hJPkr.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                    if ((0, $hJPkr.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                    // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                    // https://product-fabric.atlassian.net/browse/MEX-1520
                    // Converting caption to plain text needs to be handled before transformSliceForMedia
                    // as createChecked will fail when trying to create a mediaSingle node with a caption
                    // that is not plain text.
                    return true;
                }
                // transform slices based on destination
                slice = (0, $sgs63.transformSliceForMedia)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $hJPkr.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $2yLEW.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $hUtHc.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $2yLEW.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $bZdX5.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $hJPkr.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $hJPkr.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $2yLEW.PasteTypes).binary : (0, $2yLEW.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $hJPkr.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $hJPkr.getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $hKZR1.handlePaste)(view, event, slice, {
                    pasteSource: (0, $bZdX5.getPasteSource)(event)
                })) {
                    (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $2yLEW.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $hJPkr.handleNestedTablePasteWithAnalytics)(editorAnalyticsAPI, (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes'))(view, event, slice)(state, dispatch)) return true;
                if ((0, $hJPkr.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $2yLEW.PasteTypes).plain : (0, $2yLEW.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $hJPkr.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $2yLEW.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $hJPkr.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $d10e66844f67b307$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $7vpuQ.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $5r0mK.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $dPSMN.linkifyContent)(state.schema)(slice);
                    if ((0, $hJPkr.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $hUtHc.handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $hJPkr.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $2yLEW.PasteTypes).richText
                        });
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $hUtHc.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $h03xs.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $hJPkr.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $2yLEW.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $kCV8T.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $hJPkr.handleExpandWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $kxM7f.insideTable)(state)) slice = (0, $8Amfw.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if (!(0, $VSDnB.fg)('platform_editor_fix_captions_on_copy')) {
                        if ((0, $hJPkr.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $2yLEW.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                        // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                        // https://product-fabric.atlassian.net/browse/MEX-1520
                        return true;
                    }
                    if ((0, $hJPkr.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $hJPkr.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $hJPkr.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $hUtHc.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
				 * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $iYg8V.transformSliceToJoinAdjacentCodeBlocks)(slice);
                slice = (0, $iYg8V.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $sgs63.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $sgs63.transformSliceToMediaSingleWithNewExperience)(slice, schema, pluginInjectionApi);
                slice = (0, $hZCXS.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $iMJAN.splitParagraphs)(slice, schema);
                slice = (0, $iMJAN.upgradeTextToLists)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $kCV8T.Slice)(slice.content, 0, 0);
                if (!(0, $gmhCD.editorExperiment)('single_column_layouts', true)) slice = (0, $lKK04.transformSingleColumnLayout)(slice, schema);
                slice = (0, $fH9ql.transformSliceToRemoveMacroId)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $jbxbo.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $jbxbo.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $jbxbo.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $bZdX5.isPastedFromWord)(html) && !(0, $bZdX5.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $sgs63.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $bZdX5.htmlHasInvalidLinkTags)(html)) html = (0, $bZdX5.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("2yLEW", function(module, exports) {

$parcel$export(module.exports, "PasteTypes", () => $18ad867e0f3ed9e5$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $18ad867e0f3ed9e5$export$a82556f999b47168);
const $18ad867e0f3ed9e5$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $18ad867e0f3ed9e5$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $18ad867e0f3ed9e5$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("1ZWXY", function(module, exports) {

$parcel$export(module.exports, "addLinkMetadata", () => $2c279959aed73c3c$export$e2d4855dca88ecc1);
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $2c279959aed73c3c$export$3aba02526a1e2e78);
$parcel$export(module.exports, "commandWithMetadata", () => $2c279959aed73c3c$export$76125a95b70625ac);

var $f5LPn = parcelRequire("f5LPn");
function $2c279959aed73c3c$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $f5LPn.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
function $2c279959aed73c3c$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $f5LPn.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
const $2c279959aed73c3c$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            $2c279959aed73c3c$export$e2d4855dca88ecc1(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});
parcelRegister("f5LPn", function(module, exports) {

$parcel$export(module.exports, "LinkMetaStep", () => $afcc6c37d74355ec$export$40e33c9d27895078);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $afcc6c37d74355ec$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $afcc6c37d74355ec$export$2774298c489a128f = 'editor-linking-meta-invert';
class $afcc6c37d74355ec$export$40e33c9d27895078 extends (0, $eS2Dn.Step) {
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $afcc6c37d74355ec$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $afcc6c37d74355ec$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($afcc6c37d74355ec$export$954e3f6aa93d9ba3, $afcc6c37d74355ec$export$40e33c9d27895078);

});


parcelRegister("kxM7f", function(module, exports) {

$parcel$export(module.exports, "insideTable", () => $1ccde135a1d20ec2$export$244bf4b32387ef62);

var $5r0mK = parcelRequire("5r0mK");
const $1ccde135a1d20ec2$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});

parcelRegister("ekofw", function(module, exports) {

$parcel$export(module.exports, "isPastedFile", () => $569ae1fc879ec97d$export$30c8e5e50a78a591);
function $569ae1fc879ec97d$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function $569ae1fc879ec97d$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return $569ae1fc879ec97d$export$e20225b4cda674a8(clipboardData.types, 'Files');
}

});

parcelRegister("1M84d", function(module, exports) {

$parcel$export(module.exports, "md", () => $76c5a60e1fbb7648$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $ivSSX = parcelRequire("ivSSX");

var $h4jau = parcelRequire("h4jau");

var $2Suqb = parcelRequire("2Suqb");

var $3KuZM = parcelRequire("3KuZM");

var $igwks = parcelRequire("igwks");
const $76c5a60e1fbb7648$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$76c5a60e1fbb7648$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $igwks.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $2Suqb.default));
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $3KuZM.default));
$76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, $h4jau.default));

});
parcelRegister("ivSSX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7fjdG"));

});
parcelRegister("7fjdG", function(module, exports) {
// Main parser class
'use strict';

var $lKlAe = parcelRequire("lKlAe");

var $1mGdb = parcelRequire("1mGdb");

var $keGIi = parcelRequire("keGIi");

var $aVlnc = parcelRequire("aVlnc");

var $81Ci5 = parcelRequire("81Ci5");

var $58y21 = parcelRequire("58y21");

var $43kHv = parcelRequire("43kHv");

var $aK6mt = parcelRequire("aK6mt");

var $k7qPZ = parcelRequire("k7qPZ");



var $5468d7bb65d238e2$var$config = {
    default: (parcelRequire("gcpUf")),
    zero: (parcelRequire("hbvGf")),
    commonmark: (parcelRequire("8Ubo6"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $5468d7bb65d238e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $5468d7bb65d238e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5468d7bb65d238e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $5468d7bb65d238e2$var$BAD_PROTO_RE.test(str) ? $5468d7bb65d238e2$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $5468d7bb65d238e2$var$normalizeLink(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $aK6mt.encode($aK6mt.format(parsed));
}
function $5468d7bb65d238e2$var$normalizeLinkText(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $aK6mt.decode($aK6mt.format(parsed), $aK6mt.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5468d7bb65d238e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5468d7bb65d238e2$var$MarkdownIt)) return new $5468d7bb65d238e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$lKlAe.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $58y21();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $81Ci5();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $aVlnc();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $keGIi();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $43kHv();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5468d7bb65d238e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5468d7bb65d238e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5468d7bb65d238e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $lKlAe;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $lKlAe.assign({}, $1mGdb);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.set = function(options) {
    $lKlAe.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($lKlAe.isString(presets)) {
        presetName = presets;
        presets = $5468d7bb65d238e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $5468d7bb65d238e2$var$MarkdownIt;

});
parcelRegister("lKlAe", function(module, exports) {

$parcel$export(module.exports, "lib", () => $fd4ea2dc11e83b2a$export$16c08b91f883959a, (v) => $fd4ea2dc11e83b2a$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227, (v) => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $fd4ea2dc11e83b2a$export$844ec244b1367d54, (v) => $fd4ea2dc11e83b2a$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5, (v) => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03, (v) => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c, (v) => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d, (v) => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $fd4ea2dc11e83b2a$export$73bfc63873071f74, (v) => $fd4ea2dc11e83b2a$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8, (v) => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $fd4ea2dc11e83b2a$export$f78478f71955b6bc, (v) => $fd4ea2dc11e83b2a$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926, (v) => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c, (v) => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $fd4ea2dc11e83b2a$export$829a0d33ae4e744, (v) => $fd4ea2dc11e83b2a$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $fd4ea2dc11e83b2a$export$4888a643af800fc1, (v) => $fd4ea2dc11e83b2a$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d, (v) => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $fd4ea2dc11e83b2a$export$20ef46802c8744b, (v) => $fd4ea2dc11e83b2a$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $fd4ea2dc11e83b2a$export$16c08b91f883959a;
var $fd4ea2dc11e83b2a$export$e6e34fd1f2686227;
var $fd4ea2dc11e83b2a$export$844ec244b1367d54;
var $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5;
var $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03;
var $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c;
var $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d;
var $fd4ea2dc11e83b2a$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8;
var $fd4ea2dc11e83b2a$export$f78478f71955b6bc;
var $fd4ea2dc11e83b2a$export$1d5ccafae59b4926;
var $fd4ea2dc11e83b2a$export$3c52dd84024ae72c;
var $fd4ea2dc11e83b2a$export$829a0d33ae4e744;
var $fd4ea2dc11e83b2a$export$4888a643af800fc1;
var $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d;
var $fd4ea2dc11e83b2a$export$20ef46802c8744b;
'use strict';
function $fd4ea2dc11e83b2a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fd4ea2dc11e83b2a$var$isString(obj) {
    return $fd4ea2dc11e83b2a$var$_class(obj) === '[object String]';
}
var $fd4ea2dc11e83b2a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $fd4ea2dc11e83b2a$var$has(object, key) {
    return $fd4ea2dc11e83b2a$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $fd4ea2dc11e83b2a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $fd4ea2dc11e83b2a$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $fd4ea2dc11e83b2a$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $fd4ea2dc11e83b2a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE = new RegExp($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE.source + '|' + $fd4ea2dc11e83b2a$var$ENTITY_RE.source, 'gi');
var $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7MxGI = parcelRequire("7MxGI");
function $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, name) {
    var code;
    if ($fd4ea2dc11e83b2a$var$has($7MxGI, name)) return $7MxGI[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($fd4ea2dc11e83b2a$var$isValidEntityCode(code)) return $fd4ea2dc11e83b2a$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $fd4ea2dc11e83b2a$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE, '$1');
}
function $fd4ea2dc11e83b2a$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $fd4ea2dc11e83b2a$var$replaceUnsafeChar(ch) {
    return $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS[ch];
}
function $fd4ea2dc11e83b2a$var$escapeHtml(str) {
    if ($fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE, $fd4ea2dc11e83b2a$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $fd4ea2dc11e83b2a$var$escapeRE(str) {
    return str.replace($fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $fd4ea2dc11e83b2a$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $9bBmm = parcelRequire("9bBmm");
// Currently without astral characters support.
function $fd4ea2dc11e83b2a$var$isPunctChar(ch) {
    return $9bBmm.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $fd4ea2dc11e83b2a$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $fd4ea2dc11e83b2a$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$fd4ea2dc11e83b2a$export$16c08b91f883959a = {};

$fd4ea2dc11e83b2a$export$16c08b91f883959a.mdurl = (parcelRequire("aK6mt"));

$fd4ea2dc11e83b2a$export$16c08b91f883959a.ucmicro = (parcelRequire("7G9dc"));
$fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = $fd4ea2dc11e83b2a$var$assign;
$fd4ea2dc11e83b2a$export$844ec244b1367d54 = $fd4ea2dc11e83b2a$var$isString;
$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = $fd4ea2dc11e83b2a$var$has;
$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = $fd4ea2dc11e83b2a$var$unescapeMd;
$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = $fd4ea2dc11e83b2a$var$unescapeAll;
$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = $fd4ea2dc11e83b2a$var$isValidEntityCode;
$fd4ea2dc11e83b2a$export$73bfc63873071f74 = $fd4ea2dc11e83b2a$var$fromCodePoint;
$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = $fd4ea2dc11e83b2a$var$escapeHtml;
$fd4ea2dc11e83b2a$export$f78478f71955b6bc = $fd4ea2dc11e83b2a$var$arrayReplaceAt;
$fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = $fd4ea2dc11e83b2a$var$isSpace;
$fd4ea2dc11e83b2a$export$3c52dd84024ae72c = $fd4ea2dc11e83b2a$var$isWhiteSpace;
$fd4ea2dc11e83b2a$export$829a0d33ae4e744 = $fd4ea2dc11e83b2a$var$isMdAsciiPunct;
$fd4ea2dc11e83b2a$export$4888a643af800fc1 = $fd4ea2dc11e83b2a$var$isPunctChar;
$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = $fd4ea2dc11e83b2a$var$escapeRE;
$fd4ea2dc11e83b2a$export$20ef46802c8744b = $fd4ea2dc11e83b2a$var$normalizeReference;

});
parcelRegister("7MxGI", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("5mepl"));

});
parcelRegister("5mepl", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"\\/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("aK6mt", function(module, exports) {

$parcel$export(module.exports, "encode", () => $7d2322841b1ac049$export$c564cdbbe6da493, (v) => $7d2322841b1ac049$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $7d2322841b1ac049$export$2f872c0f2117be69, (v) => $7d2322841b1ac049$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $7d2322841b1ac049$export$d9468344d3651243, (v) => $7d2322841b1ac049$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $7d2322841b1ac049$export$98e6a39c04603d36, (v) => $7d2322841b1ac049$export$98e6a39c04603d36 = v);
var $7d2322841b1ac049$export$c564cdbbe6da493;
var $7d2322841b1ac049$export$2f872c0f2117be69;
var $7d2322841b1ac049$export$d9468344d3651243;
var $7d2322841b1ac049$export$98e6a39c04603d36;
'use strict';

$7d2322841b1ac049$export$c564cdbbe6da493 = (parcelRequire("6jTHo"));

$7d2322841b1ac049$export$2f872c0f2117be69 = (parcelRequire("qpEB3"));

$7d2322841b1ac049$export$d9468344d3651243 = (parcelRequire("3yKUv"));

$7d2322841b1ac049$export$98e6a39c04603d36 = (parcelRequire("bQztL"));

});
parcelRegister("6jTHo", function(module, exports) {
'use strict';
var $499fb90cb213ebc3$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $499fb90cb213ebc3$var$getEncodeCache(exclude) {
    var i, ch, cache = $499fb90cb213ebc3$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $499fb90cb213ebc3$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $499fb90cb213ebc3$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $499fb90cb213ebc3$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $499fb90cb213ebc3$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$499fb90cb213ebc3$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$499fb90cb213ebc3$var$encode.componentChars = "-_.!~*'()";
module.exports = $499fb90cb213ebc3$var$encode;

});

parcelRegister("qpEB3", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $04f654215177967d$var$decodeCache = {};
function $04f654215177967d$var$getDecodeCache(exclude) {
    var i, ch, cache = $04f654215177967d$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $04f654215177967d$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $04f654215177967d$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $04f654215177967d$var$decode.defaultChars;
    cache = $04f654215177967d$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$04f654215177967d$var$decode.defaultChars = ';/?:@&=+$,#';
$04f654215177967d$var$decode.componentChars = '';
module.exports = $04f654215177967d$var$decode;

});

parcelRegister("3yKUv", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("bQztL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $8a0012734669979b$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $8a0012734669979b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8a0012734669979b$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$8a0012734669979b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$8a0012734669979b$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$8a0012734669979b$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($8a0012734669979b$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$8a0012734669979b$var$autoEscape = [
    '\''
].concat($8a0012734669979b$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$8a0012734669979b$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($8a0012734669979b$var$autoEscape), $8a0012734669979b$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $8a0012734669979b$var$hostnameMaxLen = 255, $8a0012734669979b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8a0012734669979b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$8a0012734669979b$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$8a0012734669979b$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $8a0012734669979b$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $8a0012734669979b$var$Url) return url;
    var u = new $8a0012734669979b$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$8a0012734669979b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $8a0012734669979b$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $8a0012734669979b$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $8a0012734669979b$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$8a0012734669979b$var$hostlessProtocol[proto] && (slashes || proto && !$8a0012734669979b$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$hostEndingChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$nonHostChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($8a0012734669979b$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($8a0012734669979b$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($8a0012734669979b$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $8a0012734669979b$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($8a0012734669979b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$8a0012734669979b$var$Url.prototype.parseHost = function(host) {
    var port = $8a0012734669979b$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $8a0012734669979b$var$urlParse;

});


parcelRegister("7G9dc", function(module, exports) {

$parcel$export(module.exports, "Any", () => $597399ee2a9a2974$export$b24b633b1364b94b, (v) => $597399ee2a9a2974$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $597399ee2a9a2974$export$15dafbac7aec8a57, (v) => $597399ee2a9a2974$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $597399ee2a9a2974$export$239cff0cce87eb56, (v) => $597399ee2a9a2974$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $597399ee2a9a2974$export$56c0d5a1e737357d, (v) => $597399ee2a9a2974$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $597399ee2a9a2974$export$dc98b0b04f4c7758, (v) => $597399ee2a9a2974$export$dc98b0b04f4c7758 = v);
var $597399ee2a9a2974$export$b24b633b1364b94b;
var $597399ee2a9a2974$export$15dafbac7aec8a57;
var $597399ee2a9a2974$export$239cff0cce87eb56;
var $597399ee2a9a2974$export$56c0d5a1e737357d;
var $597399ee2a9a2974$export$dc98b0b04f4c7758;
'use strict';

$597399ee2a9a2974$export$b24b633b1364b94b = (parcelRequire("b9ep3"));

$597399ee2a9a2974$export$15dafbac7aec8a57 = (parcelRequire("23ErL"));

$597399ee2a9a2974$export$239cff0cce87eb56 = (parcelRequire("i4n2C"));

$597399ee2a9a2974$export$56c0d5a1e737357d = (parcelRequire("9bBmm"));

$597399ee2a9a2974$export$dc98b0b04f4c7758 = (parcelRequire("oRY4m"));

});
parcelRegister("i4n2C", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("1mGdb", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $0fe896e38fc1beac$export$2a2c8612930e58d0, (v) => $0fe896e38fc1beac$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $0fe896e38fc1beac$export$22bd24080f95f2b3, (v) => $0fe896e38fc1beac$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $0fe896e38fc1beac$export$89650c5477a69db9, (v) => $0fe896e38fc1beac$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $0fe896e38fc1beac$export$2a2c8612930e58d0;
var $0fe896e38fc1beac$export$22bd24080f95f2b3;
var $0fe896e38fc1beac$export$89650c5477a69db9;
'use strict';

$0fe896e38fc1beac$export$2a2c8612930e58d0 = (parcelRequire("8y5kB"));

$0fe896e38fc1beac$export$22bd24080f95f2b3 = (parcelRequire("guwA0"));

$0fe896e38fc1beac$export$89650c5477a69db9 = (parcelRequire("9bSCV"));

});
parcelRegister("8y5kB", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("guwA0", function(module, exports) {
// Parse link destination
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c018b854bcc71549$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("9bSCV", function(module, exports) {
// Parse link title
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $6b0f83e20702a9d5$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $6b0f83e20702a9d5$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("keGIi", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$assign = $lKlAe.assign;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$unescapeAll = $lKlAe.unescapeAll;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$escapeHtml = $lKlAe.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $ebb63f71260e6c54$var$default_rules = {};
$ebb63f71260e6c54$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $ebb63f71260e6c54$require$escapeHtml(token.content) + '</code>';
};
$ebb63f71260e6c54$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $ebb63f71260e6c54$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ebb63f71260e6c54$require$escapeHtml(token.content);
    else highlighted = $ebb63f71260e6c54$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$ebb63f71260e6c54$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$ebb63f71260e6c54$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$ebb63f71260e6c54$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content);
};
$ebb63f71260e6c54$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$ebb63f71260e6c54$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $ebb63f71260e6c54$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $ebb63f71260e6c54$require$assign({}, $ebb63f71260e6c54$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][0]) + '="' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $ebb63f71260e6c54$var$Renderer;

});

parcelRegister("aVlnc", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");







var $7f3fce7f6016210f$var$_rules = [
    [
        'normalize',
        (parcelRequire("iWx6a"))
    ],
    [
        'block',
        (parcelRequire("iY2Wj"))
    ],
    [
        'inline',
        (parcelRequire("16b9L"))
    ],
    [
        'linkify',
        (parcelRequire("lOz8R"))
    ],
    [
        'replacements',
        (parcelRequire("45Efy"))
    ],
    [
        'smartquotes',
        (parcelRequire("6sbf2"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("jEa7S"))
    ]
];
/**
 * new Core()
 **/ function $7f3fce7f6016210f$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $7f3fce7f6016210f$var$_rules.length; i++)this.ruler.push($7f3fce7f6016210f$var$_rules[i][0], $7f3fce7f6016210f$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7f3fce7f6016210f$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7f3fce7f6016210f$var$Core.prototype.State = (parcelRequire("dRBf6"));
module.exports = $7f3fce7f6016210f$var$Core;

});
parcelRegister("3sin6", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $28423cd2f7c52093$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$28423cd2f7c52093$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$28423cd2f7c52093$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $28423cd2f7c52093$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $28423cd2f7c52093$var$Ruler;

});

parcelRegister("iWx6a", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $dca7516ecd2cb0cd$var$NEWLINES_RE = /\r\n?|\n/g;
var $dca7516ecd2cb0cd$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($dca7516ecd2cb0cd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($dca7516ecd2cb0cd$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("iY2Wj", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("16b9L", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("lOz8R", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $fe1986eb06b8c500$require$arrayReplaceAt = $lKlAe.arrayReplaceAt;
function $fe1986eb06b8c500$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $fe1986eb06b8c500$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($fe1986eb06b8c500$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($fe1986eb06b8c500$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $fe1986eb06b8c500$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("45Efy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $2fa6d9dae6dddfa0$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $2fa6d9dae6dddfa0$var$replaceFn(match, name) {
    return $2fa6d9dae6dddfa0$var$SCOPED_ABBR[name.toLowerCase()];
}
function $2fa6d9dae6dddfa0$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE, $2fa6d9dae6dddfa0$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $2fa6d9dae6dddfa0$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($2fa6d9dae6dddfa0$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_scoped(state.tokens[blkIdx].children);
        if ($2fa6d9dae6dddfa0$var$RARE_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("6sbf2", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
var $4b2e13ec30356b37$var$QUOTE_TEST_RE = /['"]/;
var $4b2e13ec30356b37$var$QUOTE_RE = /['"]/g;
var $4b2e13ec30356b37$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $4b2e13ec30356b37$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $4b2e13ec30356b37$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $4b2e13ec30356b37$var$QUOTE_RE.lastIndex = pos;
            t = $4b2e13ec30356b37$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(lastChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(nextChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $4b2e13ec30356b37$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$4b2e13ec30356b37$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $4b2e13ec30356b37$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("jEa7S", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("dRBf6", function(module, exports) {
// Core state object
//
'use strict';

var $jwpQf = parcelRequire("jwpQf");
function $a17d1d317b1d68ad$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$a17d1d317b1d68ad$var$StateCore.prototype.Token = $jwpQf;
module.exports = $a17d1d317b1d68ad$var$StateCore;

});
parcelRegister("jwpQf", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e3650d20fdc1ba98$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e3650d20fdc1ba98$var$Token;

});



parcelRegister("81Ci5", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");











var $5d7c1e72b0aff81a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gSwCe")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("dHrHm"))
    ],
    [
        'fence',
        (parcelRequire("1KHgS")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79uLo")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("a0gIO")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("bFPxW")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("6Cm2K"))
    ],
    [
        'html_block',
        (parcelRequire("3IX6c")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5VRwl")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("2v0Kv"))
    ],
    [
        'paragraph',
        (parcelRequire("d0isB"))
    ]
];
/**
 * new ParserBlock()
 **/ function $5d7c1e72b0aff81a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $5d7c1e72b0aff81a$var$_rules.length; i++)this.ruler.push($5d7c1e72b0aff81a$var$_rules[i][0], $5d7c1e72b0aff81a$var$_rules[i][1], {
        alt: ($5d7c1e72b0aff81a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$5d7c1e72b0aff81a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $5d7c1e72b0aff81a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$5d7c1e72b0aff81a$var$ParserBlock.prototype.State = (parcelRequire("l865e"));
module.exports = $5d7c1e72b0aff81a$var$ParserBlock;

});
parcelRegister("gSwCe", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c49afd4af32a69df$require$isSpace = $lKlAe.isSpace;
function $c49afd4af32a69df$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c49afd4af32a69df$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c49afd4af32a69df$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c49afd4af32a69df$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c49afd4af32a69df$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c49afd4af32a69df$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("dHrHm", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("1KHgS", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79uLo", function(module, exports) {
// Block quotes
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $53513ca36aaad8c7$require$isSpace = $lKlAe.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53513ca36aaad8c7$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("a0gIO", function(module, exports) {
// Horizontal rule
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $7486e013b11c48f5$require$isSpace = $lKlAe.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$7486e013b11c48f5$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("bFPxW", function(module, exports) {
// Lists
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $87fb82138ea80db7$require$isSpace = $lKlAe.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $87fb82138ea80db7$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $87fb82138ea80db7$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("6Cm2K", function(module, exports) {
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$isSpace = $lKlAe.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$4d1764068d639a24$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$4d1764068d639a24$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $4d1764068d639a24$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("3IX6c", function(module, exports) {
// HTML block
'use strict';

var $9Jgti = parcelRequire("9Jgti");

var $1RRsU = parcelRequire("1RRsU");
var $2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE = $1RRsU.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $2b6352f7d75b50f9$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9Jgti.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $2b6352f7d75b50f9$var$HTML_SEQUENCES.length; i++){
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $2b6352f7d75b50f9$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $2b6352f7d75b50f9$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9Jgti", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("1RRsU", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $15c436cb9ae50f13$export$6db61d2c3a16e419, (v) => $15c436cb9ae50f13$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $15c436cb9ae50f13$export$cd48660d06f74639, (v) => $15c436cb9ae50f13$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $15c436cb9ae50f13$export$6db61d2c3a16e419;
var $15c436cb9ae50f13$export$cd48660d06f74639;
'use strict';
var $15c436cb9ae50f13$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $15c436cb9ae50f13$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $15c436cb9ae50f13$var$single_quoted = "'[^']*'";
var $15c436cb9ae50f13$var$double_quoted = '"[^"]*"';
var $15c436cb9ae50f13$var$attr_value = '(?:' + $15c436cb9ae50f13$var$unquoted + '|' + $15c436cb9ae50f13$var$single_quoted + '|' + $15c436cb9ae50f13$var$double_quoted + ')';
var $15c436cb9ae50f13$var$attribute = '(?:\\s+' + $15c436cb9ae50f13$var$attr_name + '(?:\\s*=\\s*' + $15c436cb9ae50f13$var$attr_value + ')?)';
var $15c436cb9ae50f13$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $15c436cb9ae50f13$var$attribute + '*\\s*\\/?>';
var $15c436cb9ae50f13$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $15c436cb9ae50f13$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $15c436cb9ae50f13$var$processing = '<[?][\\s\\S]*?[?]>';
var $15c436cb9ae50f13$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $15c436cb9ae50f13$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $15c436cb9ae50f13$var$HTML_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + '|' + $15c436cb9ae50f13$var$comment + '|' + $15c436cb9ae50f13$var$processing + '|' + $15c436cb9ae50f13$var$declaration + '|' + $15c436cb9ae50f13$var$cdata + ')');
var $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + ')');
$15c436cb9ae50f13$export$6db61d2c3a16e419 = $15c436cb9ae50f13$var$HTML_TAG_RE;
$15c436cb9ae50f13$export$cd48660d06f74639 = $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5VRwl", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $451bcab957a0998a$require$isSpace = $lKlAe.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$451bcab957a0998a$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $451bcab957a0998a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("2v0Kv", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("d0isB", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("l865e", function(module, exports) {
// Parser state class
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $f61f10562433da3b$require$isSpace = $lKlAe.isSpace;
function $f61f10562433da3b$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f61f10562433da3b$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f61f10562433da3b$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jwpQf(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f61f10562433da3b$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f61f10562433da3b$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f61f10562433da3b$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f61f10562433da3b$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f61f10562433da3b$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f61f10562433da3b$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f61f10562433da3b$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f61f10562433da3b$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f61f10562433da3b$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f61f10562433da3b$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f61f10562433da3b$var$StateBlock.prototype.Token = $jwpQf;
module.exports = $f61f10562433da3b$var$StateBlock;

});


parcelRegister("58y21", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $3bd81911677b8252$var$_rules = [
    [
        'text',
        (parcelRequire("gc14M"))
    ],
    [
        'linkify',
        (parcelRequire("2aNBd"))
    ],
    [
        'newline',
        (parcelRequire("a490I"))
    ],
    [
        'escape',
        (parcelRequire("027TI"))
    ],
    [
        'backticks',
        (parcelRequire("27paT"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).tokenize
    ],
    [
        'link',
        (parcelRequire("frx2x"))
    ],
    [
        'image',
        (parcelRequire("iUeRh"))
    ],
    [
        'autolink',
        (parcelRequire("ktOwv"))
    ],
    [
        'html_inline',
        (parcelRequire("1jFGt"))
    ],
    [
        'entity',
        (parcelRequire("jd9ks"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $3bd81911677b8252$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ey6sy"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("hrHpd"))
    ]
];
/**
 * new ParserInline()
 **/ function $3bd81911677b8252$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules.length; i++)this.ruler.push($3bd81911677b8252$var$_rules[i][0], $3bd81911677b8252$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules2.length; i++)this.ruler2.push($3bd81911677b8252$var$_rules2[i][0], $3bd81911677b8252$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3bd81911677b8252$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3bd81911677b8252$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3bd81911677b8252$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$3bd81911677b8252$var$ParserInline.prototype.State = (parcelRequire("82i7L"));
module.exports = $3bd81911677b8252$var$ParserInline;

});
parcelRegister("gc14M", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $bc9e9a00ea13b29d$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$bc9e9a00ea13b29d$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2aNBd", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1952fd4ef50e3f47$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1952fd4ef50e3f47$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("a490I", function(module, exports) {
// Proceess '\n'
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $754144646e41a199$require$isSpace = $lKlAe.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $754144646e41a199$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("027TI", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $006650534e77ff18$require$isSpace = $lKlAe.isSpace;
var $006650534e77ff18$var$ESCAPED = [];
for(var $006650534e77ff18$var$i = 0; $006650534e77ff18$var$i < 256; $006650534e77ff18$var$i++)$006650534e77ff18$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $006650534e77ff18$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$006650534e77ff18$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $006650534e77ff18$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("27paT", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("lBrF9", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $fba282ec8c4eab24$export$660b2ee2d4fb4eff, (v) => $fba282ec8c4eab24$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $fba282ec8c4eab24$export$7b804a0e0ce836d9, (v) => $fba282ec8c4eab24$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $fba282ec8c4eab24$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $fba282ec8c4eab24$export$7b804a0e0ce836d9;
'use strict';
$fba282ec8c4eab24$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $fba282ec8c4eab24$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$fba282ec8c4eab24$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $fba282ec8c4eab24$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fba282ec8c4eab24$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("2MLmq", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $2074cd535103ea35$export$660b2ee2d4fb4eff, (v) => $2074cd535103ea35$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2074cd535103ea35$export$7b804a0e0ce836d9, (v) => $2074cd535103ea35$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2074cd535103ea35$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2074cd535103ea35$export$7b804a0e0ce836d9;
'use strict';
$2074cd535103ea35$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2074cd535103ea35$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$2074cd535103ea35$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2074cd535103ea35$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2074cd535103ea35$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("frx2x", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$isSpace = $lKlAe.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$b3e301ae0b1788b5$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("iUeRh", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$isSpace = $lKlAe.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$dc38fb80f8b4f166$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("ktOwv", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $ee8db4fa9cfd6224$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $ee8db4fa9cfd6224$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($ee8db4fa9cfd6224$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($ee8db4fa9cfd6224$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("1jFGt", function(module, exports) {
// Process html tags
'use strict';

var $1RRsU = parcelRequire("1RRsU");
var $0f57e66455279f49$require$HTML_TAG_RE = $1RRsU.HTML_TAG_RE;
function $0f57e66455279f49$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0f57e66455279f49$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0f57e66455279f49$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0f57e66455279f49$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0f57e66455279f49$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0f57e66455279f49$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0f57e66455279f49$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("jd9ks", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7MxGI = parcelRequire("7MxGI");

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$has = $lKlAe.has;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$isValidEntityCode = $lKlAe.isValidEntityCode;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$fromCodePoint = $lKlAe.fromCodePoint;
var $dfc677c78d4d441f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $dfc677c78d4d441f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $dfc677c78d4d441f$require$isValidEntityCode(code) ? $dfc677c78d4d441f$require$fromCodePoint(code) : $dfc677c78d4d441f$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$NAMED_RE);
        if (match) {
            if ($dfc677c78d4d441f$require$has($7MxGI, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7MxGI[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ey6sy", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $a979406325d16795$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a979406325d16795$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a979406325d16795$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("hrHpd", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("82i7L", function(module, exports) {
// Inline parser state
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
function $5d9c91befccde6a7$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5d9c91befccde6a7$var$StateInline.prototype.pushPending = function() {
    var token = new $jwpQf('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5d9c91befccde6a7$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jwpQf(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5d9c91befccde6a7$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(lastChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(nextChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5d9c91befccde6a7$var$StateInline.prototype.Token = $jwpQf;
module.exports = $5d9c91befccde6a7$var$StateInline;

});


parcelRegister("43kHv", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $2f377ffd6e81380f$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $2f377ffd6e81380f$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $2f377ffd6e81380f$var$isString(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object String]';
}
function $2f377ffd6e81380f$var$isObject(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Object]';
}
function $2f377ffd6e81380f$var$isRegExp(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object RegExp]';
}
function $2f377ffd6e81380f$var$isFunction(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Function]';
}
function $2f377ffd6e81380f$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $2f377ffd6e81380f$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $2f377ffd6e81380f$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $2f377ffd6e81380f$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $2f377ffd6e81380f$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $2f377ffd6e81380f$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $2f377ffd6e81380f$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $2f377ffd6e81380f$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $2f377ffd6e81380f$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $2f377ffd6e81380f$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $2f377ffd6e81380f$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("5GUip"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($2f377ffd6e81380f$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($2f377ffd6e81380f$var$isObject(val)) {
            if ($2f377ffd6e81380f$var$isRegExp(val.validate)) compiled.validate = $2f377ffd6e81380f$var$createValidator(val.validate);
            else if ($2f377ffd6e81380f$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($2f377ffd6e81380f$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $2f377ffd6e81380f$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($2f377ffd6e81380f$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $2f377ffd6e81380f$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($2f377ffd6e81380f$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $2f377ffd6e81380f$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $2f377ffd6e81380f$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $2f377ffd6e81380f$var$createMatch(self, shift) {
    var match = new $2f377ffd6e81380f$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $2f377ffd6e81380f$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $2f377ffd6e81380f$var$LinkifyIt)) return new $2f377ffd6e81380f$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($2f377ffd6e81380f$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $2f377ffd6e81380f$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $2f377ffd6e81380f$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $2f377ffd6e81380f$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $2f377ffd6e81380f$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $2f377ffd6e81380f$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $2f377ffd6e81380f$var$LinkifyIt;

});
parcelRegister("5GUip", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("k7qPZ", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $ea59477c15f361c2$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $ea59477c15f361c2$var$base = 36;
const $ea59477c15f361c2$var$tMin = 1;
const $ea59477c15f361c2$var$tMax = 26;
const $ea59477c15f361c2$var$skew = 38;
const $ea59477c15f361c2$var$damp = 700;
const $ea59477c15f361c2$var$initialBias = 72;
const $ea59477c15f361c2$var$initialN = 128; // 0x80
const $ea59477c15f361c2$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $ea59477c15f361c2$var$regexPunycode = /^xn--/;
const $ea59477c15f361c2$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $ea59477c15f361c2$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $ea59477c15f361c2$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $ea59477c15f361c2$var$baseMinusTMin = $ea59477c15f361c2$var$base - $ea59477c15f361c2$var$tMin;
const $ea59477c15f361c2$var$floor = Math.floor;
const $ea59477c15f361c2$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $ea59477c15f361c2$var$error(type) {
    throw new RangeError($ea59477c15f361c2$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $ea59477c15f361c2$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $ea59477c15f361c2$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($ea59477c15f361c2$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $ea59477c15f361c2$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $ea59477c15f361c2$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $ea59477c15f361c2$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $ea59477c15f361c2$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $ea59477c15f361c2$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $ea59477c15f361c2$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $ea59477c15f361c2$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$damp) : delta >> 1;
    delta += $ea59477c15f361c2$var$floor(delta / numPoints);
    for(; delta > $ea59477c15f361c2$var$baseMinusTMin * $ea59477c15f361c2$var$tMax >> 1; k += $ea59477c15f361c2$var$base)delta = $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$baseMinusTMin);
    return $ea59477c15f361c2$var$floor(k + ($ea59477c15f361c2$var$baseMinusTMin + 1) * delta / (delta + $ea59477c15f361c2$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $ea59477c15f361c2$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $ea59477c15f361c2$var$initialN;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($ea59477c15f361c2$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $ea59477c15f361c2$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
            if (index >= inputLength) $ea59477c15f361c2$var$error('invalid-input');
            const digit = $ea59477c15f361c2$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $ea59477c15f361c2$var$base) $ea59477c15f361c2$var$error('invalid-input');
            if (digit > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - i) / w)) $ea59477c15f361c2$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $ea59477c15f361c2$var$base - t;
            if (w > $ea59477c15f361c2$var$floor($ea59477c15f361c2$var$maxInt / baseMinusT)) $ea59477c15f361c2$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $ea59477c15f361c2$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($ea59477c15f361c2$var$floor(i / out) > $ea59477c15f361c2$var$maxInt - n) $ea59477c15f361c2$var$error('overflow');
        n += $ea59477c15f361c2$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $ea59477c15f361c2$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $ea59477c15f361c2$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $ea59477c15f361c2$var$initialN;
    let delta = 0;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($ea59477c15f361c2$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($ea59477c15f361c2$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $ea59477c15f361c2$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - delta) / handledCPCountPlusOne)) $ea59477c15f361c2$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $ea59477c15f361c2$var$maxInt) $ea59477c15f361c2$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
                    const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $ea59477c15f361c2$var$base - t;
                    output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $ea59477c15f361c2$var$floor(qMinusT / baseMinusT);
                }
                output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(q, 0)));
                bias = $ea59477c15f361c2$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $ea59477c15f361c2$var$toUnicode = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexPunycode.test(string) ? $ea59477c15f361c2$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $ea59477c15f361c2$var$toASCII = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexNonASCII.test(string) ? 'xn--' + $ea59477c15f361c2$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $ea59477c15f361c2$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $ea59477c15f361c2$var$ucs2decode,
        'encode': $ea59477c15f361c2$var$ucs2encode
    },
    'decode': $ea59477c15f361c2$var$decode,
    'encode': $ea59477c15f361c2$var$encode,
    'toASCII': $ea59477c15f361c2$var$toASCII,
    'toUnicode': $ea59477c15f361c2$var$toUnicode
};
module.exports = $ea59477c15f361c2$var$punycode;

});

parcelRegister("gcpUf", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hbvGf", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("8Ubo6", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("h4jau", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58a68bc6bfddc85$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $b58a68bc6bfddc85$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("2Suqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $89029a8bda2c5b4f$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $e2gHg = parcelRequire("e2gHg");

var $iZOJ9 = parcelRequire("iZOJ9");

var $dPSMN = parcelRequire("dPSMN");
var $gOwky = parcelRequire("gOwky");
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89029a8bda2c5b4f$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $89029a8bda2c5b4f$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $89029a8bda2c5b4f$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89029a8bda2c5b4f$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($89029a8bda2c5b4f$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($89029a8bda2c5b4f$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $iZOJ9.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $gOwky.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $dPSMN.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $dPSMN.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $89029a8bda2c5b4f$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$89029a8bda2c5b4f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $89029a8bda2c5b4f$var$linkify);

});

parcelRegister("3KuZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $abad1ea2bea26d97$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $abad1ea2bea26d97$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$abad1ea2bea26d97$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $abad1ea2bea26d97$var$newline);

});

parcelRegister("igwks", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5de6df8c35efad$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fc5de6df8c35efad$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$fc5de6df8c35efad$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $fc5de6df8c35efad$var$paragraph);

});


parcelRegister("lKK04", function(module, exports) {

$parcel$export(module.exports, "transformSingleColumnLayout", () => $d6d305b7f5ef06a6$export$ca45027befc3fad2);
$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $d6d305b7f5ef06a6$export$82cc8566682e5cf4);

var $kCV8T = parcelRequire("kCV8T");

var $7vpuQ = parcelRequire("7vpuQ");
const $d6d305b7f5ef06a6$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $7vpuQ.mapFragment)((0, $kCV8T.Fragment).from(maybeLayoutSection), (node)=>{
        return $d6d305b7f5ef06a6$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $d6d305b7f5ef06a6$export$238984649a055433(node, i) {
    return i === 0 ? $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(node) : node;
}
function $d6d305b7f5ef06a6$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $d6d305b7f5ef06a6$export$5fc4db161d3fef1f(node) : node;
}
const $d6d305b7f5ef06a6$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kCV8T.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kCV8T.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
function $d6d305b7f5ef06a6$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(slice.content, $d6d305b7f5ef06a6$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("8Amfw", function(module, exports) {

$parcel$export(module.exports, "findExpand", () => $e9a196c58ca29a43$export$fd7bf9c73fdd6f30);
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $e9a196c58ca29a43$export$6d57e15bdf5e650f);
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $e9a196c58ca29a43$export$74dbe7cb6b933cde);
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $e9a196c58ca29a43$export$fd33fafbf6b5abc7);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $e9a196c58ca29a43$export$447e90e618548243);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $7vpuQ = parcelRequire("7vpuQ");
const $e9a196c58ca29a43$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $5r0mK.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};
const $e9a196c58ca29a43$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $kCV8T.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $e9a196c58ca29a43$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $kCV8T.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $e9a196c58ca29a43$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $7vpuQ.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
const $e9a196c58ca29a43$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $7vpuQ.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("hZCXS", function(module, exports) {

$parcel$export(module.exports, "transformSliceToDecisionList", () => $d713d8936b58e45c$export$65d21b4bef5d424b);

var $kCV8T = parcelRequire("kCV8T");
const $d713d8936b58e45c$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("fH9ql", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $945a5a80467e7c21$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $945a5a80467e7c21$export$d2a1206296dcfa47);
$parcel$export(module.exports, "transformSliceToRemoveLegacyContentMacro", () => $945a5a80467e7c21$export$23ce34395aea8526);
$parcel$export(module.exports, "transformSliceToRemoveMacroId", () => $945a5a80467e7c21$export$c20bd22f1bffad40);

var $9IGaJ = parcelRequire("9IGaJ");

var $kCV8T = parcelRequire("kCV8T");

var $7vpuQ = parcelRequire("7vpuQ");
const $945a5a80467e7c21$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $7vpuQ.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $kCV8T.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $945a5a80467e7c21$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $7vpuQ.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $9IGaJ.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $kCV8T.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $945a5a80467e7c21$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $945a5a80467e7c21$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $945a5a80467e7c21$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === extension && $945a5a80467e7c21$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
const $945a5a80467e7c21$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};

});

parcelRegister("38KaN", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $ca5b579471d13098$export$267fd7ead7cc4561);

var $kOFhM = parcelRequire("kOFhM");

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $6fRr3 = parcelRequire("6fRr3");

var $39HCX = parcelRequire("39HCX");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $ca5b579471d13098$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $ca5b579471d13098$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $ca5b579471d13098$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$ca5b579471d13098$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $ca5b579471d13098$export$267fd7ead7cc4561 {
    constructor(schema = (0, $kOFhM.defaultSchema), tokenizer = $ca5b579471d13098$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $ca5b579471d13098$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($ca5b579471d13098$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $39HCX.markdownItMedia));
        this.markdownParser = new (0, $6fRr3.MarkdownParser)(schema, tokenizer, $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, $ca5b579471d13098$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("4iMad", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $321e3433bbbbd43e$export$26a6b72a65821214);

var $ew5rH = parcelRequire("ew5rH");
var $321e3433bbbbd43e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($ew5rH))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("ew5rH", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a9184747dc810078$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a9184747dc810078$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a9184747dc810078$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a9184747dc810078$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a9184747dc810078$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("6fRr3", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $48dd97f13fd6d562$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $48dd97f13fd6d562$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $48dd97f13fd6d562$export$61055fa707e69319);

var $kCV8T = parcelRequire("kCV8T");

var $ivSSX = parcelRequire("ivSSX");
/**
Document schema for the data model used by CommonMark.
*/ const $48dd97f13fd6d562$export$4902baddc787debb = new (0, $kCV8T.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $48dd97f13fd6d562$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $kCV8T.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $48dd97f13fd6d562$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $kCV8T.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $48dd97f13fd6d562$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $kCV8T.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $48dd97f13fd6d562$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $48dd97f13fd6d562$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $48dd97f13fd6d562$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $48dd97f13fd6d562$var$noOp() {}
function $48dd97f13fd6d562$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = $48dd97f13fd6d562$var$noOp;
            else {
                handlers[type + "_open"] = $48dd97f13fd6d562$var$noOp;
                handlers[type + "_close"] = $48dd97f13fd6d562$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $48dd97f13fd6d562$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $48dd97f13fd6d562$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $48dd97f13fd6d562$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $48dd97f13fd6d562$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $48dd97f13fd6d562$export$7517583227ad0cb8 = new $48dd97f13fd6d562$export$a64f782182dea128($48dd97f13fd6d562$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $48dd97f13fd6d562$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $48dd97f13fd6d562$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $48dd97f13fd6d562$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $48dd97f13fd6d562$export$f996452ca6e9a0ae = new $48dd97f13fd6d562$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $48dd97f13fd6d562$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $48dd97f13fd6d562$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $48dd97f13fd6d562$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $48dd97f13fd6d562$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $48dd97f13fd6d562$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("39HCX", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $288ff3bbed487814$export$c8dcbd316b71f8cf);
function $288ff3bbed487814$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $288ff3bbed487814$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $288ff3bbed487814$var$createRule());
};

});


parcelRegister("hKZR1", function(module, exports) {

$parcel$export(module.exports, "handlePaste", () => $ff49e98b89c214ae$export$5dbcc300324fed87);

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $22PoI = parcelRequire("22PoI");

var $3yjNu = parcelRequire("3yjNu");

var $bQFBc = parcelRequire("bQFBc");

var $5i9bT = parcelRequire("5i9bT");
const $ff49e98b89c214ae$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $ff49e98b89c214ae$export$5dbcc300324fed87(view, event, slice, options) {
    if (!(0, $bQFBc.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isNestingAllowed = (0, $gmhCD.editorExperiment)('nested-tables-in-tables', true);
    const isPasteFullTableInsideEmptyCellEnabled = (0, $VSDnB.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $hFEwm.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && isNestingAllowed && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $ff49e98b89c214ae$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $5r0mK.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $5i9bT.pastedCells)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $kCV8T.Fragment).from((0, $5i9bT.fitSlice)((0, $3yjNu.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $uOUlv.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $5i9bT.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $5i9bT.insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $22PoI.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $uOUlv.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $uOUlv.TableMap).get($cell.node(-1));
        (0, $5i9bT.insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $ff49e98b89c214ae$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("3yjNu", function(module, exports) {

$parcel$export(module.exports, "tableNodeTypes", () => $8be71f6754b181de$export$c7782132717464bc);
function $8be71f6754b181de$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});

parcelRegister("5i9bT", function(module, exports) {

$parcel$export(module.exports, "pastedCells", () => $6dd11ae486d7c5ad$export$f6d8f52489457fc4);
$parcel$export(module.exports, "fitSlice", () => $6dd11ae486d7c5ad$export$f09c6b3b06d884fb);
$parcel$export(module.exports, "clipCells", () => $6dd11ae486d7c5ad$export$cdcebd68073bc3f);
$parcel$export(module.exports, "insertCells", () => $6dd11ae486d7c5ad$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $6e6o8 = parcelRequire("6e6o8");

var $hHsVB = parcelRequire("hHsVB");

var $3yjNu = parcelRequire("3yjNu");

var $eNHnZ = parcelRequire("eNHnZ");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $6dd11ae486d7c5ad$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $3yjNu.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $kCV8T.Fragment).from(newCells);
}
function $6dd11ae486d7c5ad$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, $3yjNu.tableNodeTypes)(schema).row, new (0, $kCV8T.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, $3yjNu.tableNodeTypes)(schema).row, new (0, $kCV8T.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$6dd11ae486d7c5ad$var$stripHeaderType(schema, row));
    return $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $kCV8T.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $3yjNu.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $kCV8T.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $6dd11ae486d7c5ad$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $eS2Dn.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $6dd11ae486d7c5ad$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $6e6o8.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $kCV8T.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $kCV8T.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $6dd11ae486d7c5ad$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $3yjNu.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $kCV8T.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $6e6o8.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $6e6o8.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $6dd11ae486d7c5ad$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $6dd11ae486d7c5ad$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $hHsVB.selectedRect)(state);
    const types = (0, $3yjNu.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $eNHnZ.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $eNHnZ.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $uOUlv.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $uOUlv.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($6dd11ae486d7c5ad$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $kCV8T.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $6dd11ae486d7c5ad$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $hFEwm.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("eNHnZ", function(module, exports) {

$parcel$export(module.exports, "isHeaderEnabledByType", () => $9886d955dd3a1a8d$export$96946e3333d0ccc6);
$parcel$export(module.exports, "toggleHeader", () => $9886d955dd3a1a8d$export$dee0ccd8d8f5a56e);

var $uOUlv = parcelRequire("uOUlv");

var $hHsVB = parcelRequire("hHsVB");

var $3yjNu = parcelRequire("3yjNu");

var $bQFBc = parcelRequire("bQFBc");
function $9886d955dd3a1a8d$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $9886d955dd3a1a8d$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $bQFBc.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $3yjNu.tableNodeTypes)(state.schema);
            const rect = (0, $hHsVB.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $uOUlv.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $uOUlv.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("l0B7L", function(module, exports) {

$parcel$export(module.exports, "PastePluginActionTypes", () => $76e285a47bbc9216$export$ad3c0356f902fd97);
var $76e285a47bbc9216$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    return PastePluginActionTypes;
}({});

});

parcelRegister("iMJAN", function(module, exports) {

$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $722f1e15dd092c87$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $722f1e15dd092c87$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $722f1e15dd092c87$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $722f1e15dd092c87$export$f2dc3112f5c2bd10);

var $uTDrM = parcelRequire("uTDrM");
var $7vpuQ = parcelRequire("7vpuQ");

var $2RHbH = parcelRequire("2RHbH");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $l0B7L = parcelRequire("l0B7L");

var $6eO8M = parcelRequire("6eO8M");
const $722f1e15dd092c87$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $6eO8M.createCommand)(()=>{
        return {
            type: (0, $l0B7L.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $722f1e15dd092c87$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $6eO8M.createCommand)(()=>{
        return {
            type: (0, $l0B7L.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $722f1e15dd092c87$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $722f1e15dd092c87$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $722f1e15dd092c87$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $722f1e15dd092c87$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $722f1e15dd092c87$var$bullets
        },
        {
            node: orderedList,
            matcher: $722f1e15dd092c87$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $722f1e15dd092c87$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $722f1e15dd092c87$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $7vpuQ.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $722f1e15dd092c87$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $722f1e15dd092c87$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $722f1e15dd092c87$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $722f1e15dd092c87$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $kCV8T.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $kCV8T.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $gZGBX.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $2RHbH.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $uTDrM.isListNode)(before) && (0, $uTDrM.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $kCV8T.Fragment).from(result);
    return fragment;
};
const $722f1e15dd092c87$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $722f1e15dd092c87$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $722f1e15dd092c87$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $722f1e15dd092c87$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $kCV8T.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $722f1e15dd092c87$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $722f1e15dd092c87$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $kCV8T.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $kCV8T.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("6eO8M", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $79a615e374ca307c$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $79a615e374ca307c$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $79a615e374ca307c$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $79a615e374ca307c$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");

var $h5cYA = parcelRequire("h5cYA");
const $79a615e374ca307c$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('pastePlugin');
const { createPluginState: $79a615e374ca307c$export$656c7661095efe2e, createCommand: $79a615e374ca307c$export$8d4021544bdece00, getPluginState: $79a615e374ca307c$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)($79a615e374ca307c$export$18d4026d1ea86bb1, (0, $h5cYA.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});

});
parcelRegister("h5cYA", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $a8b889ccc948d24f$export$1650419e431d3ba3);

var $l0B7L = parcelRequire("l0B7L");
const $a8b889ccc948d24f$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $l0B7L.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $l0B7L.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $l0B7L.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        default:
            return state;
    }
};

});



parcelRegister("sgs63", function(module, exports) {

$parcel$export(module.exports, "transformSliceForMedia", () => $dd0e5610352b139f$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $dd0e5610352b139f$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $dd0e5610352b139f$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $dd0e5610352b139f$export$3b69af3aaae9ee54);

var $intz5 = parcelRequire("intz5");

var $7vpuQ = parcelRequire("7vpuQ");
var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $27T0s = parcelRequire("27T0s");
function $dd0e5610352b139f$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $5r0mK.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $7vpuQ.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $5r0mK.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $5r0mK.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $dd0e5610352b139f$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $dd0e5610352b139f$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($dd0e5610352b139f$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $dd0e5610352b139f$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $intz5.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $7vpuQ.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $27T0s.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $dd0e5610352b139f$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $dd0e5610352b139f$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $dd0e5610352b139f$var$canContainImage(element) {
    if (!element) return false;
    return $dd0e5610352b139f$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
const $dd0e5610352b139f$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $eQcNy.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($dd0e5610352b139f$var$isElementInvisible(mediaParent) || $dd0e5610352b139f$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($dd0e5610352b139f$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $eQcNy.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $dd0e5610352b139f$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $eQcNy.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("hJPkr", function(module, exports) {

$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $da2e92405151db04$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $da2e92405151db04$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $da2e92405151db04$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $da2e92405151db04$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $da2e92405151db04$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $da2e92405151db04$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $da2e92405151db04$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $da2e92405151db04$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $da2e92405151db04$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $da2e92405151db04$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $da2e92405151db04$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $da2e92405151db04$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleNestedTablePasteWithAnalytics", () => $da2e92405151db04$export$7dc8d4c52517a2f7);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $da2e92405151db04$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $da2e92405151db04$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $da2e92405151db04$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $da2e92405151db04$export$629ff5588e070c83);

var $gkwXh = parcelRequire("gkwXh");
var $2yLEW = parcelRequire("2yLEW");

var $dPSMN = parcelRequire("dPSMN");
var $7vpuQ = parcelRequire("7vpuQ");

var $5r0mK = parcelRequire("5r0mK");

var $bZdX5 = parcelRequire("bZdX5");

var $hUtHc = parcelRequire("hUtHc");
const $da2e92405151db04$var$contentToPasteContent = {
    url: (0, $2yLEW.PasteContents).url,
    paragraph: (0, $2yLEW.PasteContents).text,
    bulletList: (0, $2yLEW.PasteContents).bulletList,
    orderedList: (0, $2yLEW.PasteContents).orderedList,
    heading: (0, $2yLEW.PasteContents).heading,
    blockquote: (0, $2yLEW.PasteContents).blockquote,
    codeBlock: (0, $2yLEW.PasteContents).codeBlock,
    panel: (0, $2yLEW.PasteContents).panel,
    rule: (0, $2yLEW.PasteContents).rule,
    mediaSingle: (0, $2yLEW.PasteContents).mediaSingle,
    mediaCard: (0, $2yLEW.PasteContents).mediaCard,
    mediaGroup: (0, $2yLEW.PasteContents).mediaGroup,
    table: (0, $2yLEW.PasteContents).table,
    tableCells: (0, $2yLEW.PasteContents).tableCells,
    tableHeader: (0, $2yLEW.PasteContents).tableHeader,
    tableRow: (0, $2yLEW.PasteContents).tableRow,
    decisionList: (0, $2yLEW.PasteContents).decisionList,
    decisionItem: (0, $2yLEW.PasteContents).decisionItem,
    taskList: (0, $2yLEW.PasteContents).taskItem,
    extension: (0, $2yLEW.PasteContents).extension,
    bodiedExtension: (0, $2yLEW.PasteContents).bodiedExtension,
    blockCard: (0, $2yLEW.PasteContents).blockCard,
    layoutSection: (0, $2yLEW.PasteContents).layoutSection
};
const $da2e92405151db04$var$nodeToActionSubjectId = {
    blockquote: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $da2e92405151db04$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $2yLEW.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $2yLEW.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    const pasteContent = $da2e92405151db04$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $2yLEW.PasteContents).uncategorized;
}
function $da2e92405151db04$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $da2e92405151db04$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $5r0mK.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $da2e92405151db04$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $gkwXh.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $gkwXh.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $da2e92405151db04$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $gkwXh.ACTION).PASTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $da2e92405151db04$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $da2e92405151db04$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $da2e92405151db04$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $2yLEW.PasteContents).url || content === (0, $2yLEW.PasteContents).mixed) (0, $7vpuQ.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $bZdX5.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted'
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted'
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $2yLEW.PasteTypes).plain) return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $2yLEW.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $dPSMN.getLinkDomain));
        return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        }, linkDomains);
    };
}
function $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $da2e92405151db04$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $da2e92405151db04$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).plain,
            asPlain: true
        }))((0, $hUtHc.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $da2e92405151db04$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $hUtHc.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $hUtHc.handlePasteIntoCaption)(slice));
const $da2e92405151db04$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).plain
        }))((0, $hUtHc.handleCodeBlock)(text));
const $da2e92405151db04$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $hUtHc.handleMediaSingle)((0, $gkwXh.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $da2e92405151db04$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $hUtHc.handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $2yLEW.PasteTypes).markdown
    }))((0, $hUtHc.handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $2yLEW.PasteTypes).richText
    }, pluginInjectionApi))((0, $hUtHc.handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $da2e92405151db04$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText
        }))((0, $hUtHc.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $da2e92405151db04$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handlePasteNonNestableBlockNodesIntoList)(slice));
const $da2e92405151db04$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handleExpandPaste)(slice));
const $da2e92405151db04$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $hUtHc.handleNestedTablePaste)(slice, isNestingTablesSupported));
const $da2e92405151db04$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $2yLEW.PasteTypes).richText
        }))((0, $hUtHc.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $da2e92405151db04$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $hUtHc.handlePasteLinkOnSelectedText)(slice));
const $da2e92405151db04$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $da2e92405151db04$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $gkwXh.ACTION).PASTED_TIMED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $da2e92405151db04$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$da2e92405151db04$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});
parcelRegister("bZdX5", function(module, exports) {

$parcel$export(module.exports, "isPastedFromWord", () => $ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $ad2fbb626fc6cd3c$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $ad2fbb626fc6cd3c$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $ad2fbb626fc6cd3c$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeLinks", () => $ad2fbb626fc6cd3c$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $ad2fbb626fc6cd3c$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $ad2fbb626fc6cd3c$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $ad2fbb626fc6cd3c$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $ad2fbb626fc6cd3c$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $ad2fbb626fc6cd3c$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $ad2fbb626fc6cd3c$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $ad2fbb626fc6cd3c$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $ad2fbb626fc6cd3c$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $ad2fbb626fc6cd3c$export$9ffea5586131a948);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $aZPvj = parcelRequire("aZPvj");

var $20Kbb = parcelRequire("20Kbb");
var $7vpuQ = parcelRequire("7vpuQ");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $cwe6a = parcelRequire("cwe6a");
var $cK1Lv = parcelRequire("cK1Lv");

var $9KG2L = parcelRequire("9KG2L");

var $VSDnB = parcelRequire("VSDnB");
function $ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $ad2fbb626fc6cd3c$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $ad2fbb626fc6cd3c$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $ad2fbb626fc6cd3c$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $ad2fbb626fc6cd3c$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $ad2fbb626fc6cd3c$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $ad2fbb626fc6cd3c$export$41d193509f55b76e(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html.match(/<img .*>/) && !(0, $9KG2L.isMediaBlobUrl)(html);
}
function $ad2fbb626fc6cd3c$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($ad2fbb626fc6cd3c$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($ad2fbb626fc6cd3c$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($ad2fbb626fc6cd3c$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($ad2fbb626fc6cd3c$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $ad2fbb626fc6cd3c$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
    });
}
function $ad2fbb626fc6cd3c$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $ad2fbb626fc6cd3c$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $kCV8T.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $aZPvj.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if ((0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) {
                if (node.isInline && [
                    'inlineCard',
                    'emoji',
                    'status',
                    'date',
                    'mention'
                ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    ...node.marks,
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                ];
            }
            return true;
        });
        return sliceCopy;
    };
}
function $ad2fbb626fc6cd3c$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $kCV8T.Mark).sameSet(emptyNode.marks, node.marks);
}
function $ad2fbb626fc6cd3c$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $gZGBX.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $ad2fbb626fc6cd3c$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $ad2fbb626fc6cd3c$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $gZGBX.NodeSelection) && $ad2fbb626fc6cd3c$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $ad2fbb626fc6cd3c$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $ad2fbb626fc6cd3c$export$35ca1bb0581efaf3 = (html)=>{
    if ($ad2fbb626fc6cd3c$export$3c3a613abe5bb97d(html)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $ad2fbb626fc6cd3c$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $cwe6a.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $dEzej.TABLE_ACTION).REPLACED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $gkwXh.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $ad2fbb626fc6cd3c$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $7vpuQ.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$ad2fbb626fc6cd3c$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $ad2fbb626fc6cd3c$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $20Kbb.isSupportedInParent)(state, frag);
};

});
parcelRegister("dEzej", function(module, exports) {

$parcel$export(module.exports, "TABLE_ACTION", () => $e52e9249b2889c06$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $e52e9249b2889c06$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $e52e9249b2889c06$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $e52e9249b2889c06$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $e52e9249b2889c06$export$ba2dfc055a59d951);
var $e52e9249b2889c06$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    return TABLE_ACTION;
}({});
var $e52e9249b2889c06$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $e52e9249b2889c06$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $e52e9249b2889c06$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $e52e9249b2889c06$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $e52e9249b2889c06$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});

parcelRegister("cwe6a", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $042ffe26ab726773$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $042ffe26ab726773$export$277d5394a2608229);

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $b1RTQ = parcelRequire("b1RTQ");
function $042ffe26ab726773$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $28MvW.findTable)(selection);
    if (table) {
        map = (0, $uOUlv.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $042ffe26ab726773$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $042ffe26ab726773$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});
parcelRegister("28MvW", function(module, exports) {

$parcel$export(module.exports, "findTable", () => $558e59ba96522ad6$export$1ae6a0a4f7784fc4);
$parcel$export(module.exports, "findTableClosestToPos", () => $558e59ba96522ad6$export$9323c80f9a3e899f);
$parcel$export(module.exports, "findCellClosestToPos", () => $558e59ba96522ad6$export$3ac56532a0bf4018);
$parcel$export(module.exports, "findCellRectClosestToPos", () => $558e59ba96522ad6$export$68680ae223aebfa7);

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");
const $558e59ba96522ad6$export$1ae6a0a4f7784fc4 = (selection)=>(0, $5r0mK.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $558e59ba96522ad6$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
};
const $558e59ba96522ad6$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
};
const $558e59ba96522ad6$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $558e59ba96522ad6$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $558e59ba96522ad6$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $uOUlv.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("b1RTQ", function(module, exports) {

$parcel$export(module.exports, "getSelectionRect", () => $0876234ba373a2bf$export$aa946c0ed562e2ed);

var $uOUlv = parcelRequire("uOUlv");

var $iGxzn = parcelRequire("iGxzn");
const $0876234ba373a2bf$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $iGxzn.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});


parcelRegister("cK1Lv", function(module, exports) {

$parcel$export(module.exports, "isColumnSelected", () => $65abce04567f614e$export$8db1cdcc0c397a6d);
$parcel$export(module.exports, "isRowSelected", () => $65abce04567f614e$export$710e11cf672b86c);
$parcel$export(module.exports, "isTableSelected", () => $65abce04567f614e$export$5d08de4a0eeb0408);

var $uOUlv = parcelRequire("uOUlv");

var $iGxzn = parcelRequire("iGxzn");
const $65abce04567f614e$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $iGxzn.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $65abce04567f614e$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
            const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
            return $65abce04567f614e$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $65abce04567f614e$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
            const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
            return $65abce04567f614e$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $65abce04567f614e$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $iGxzn.isSelectionType)(selection, 'cell')) {
        const map = (0, $uOUlv.TableMap).get(selection.$anchorCell.node(-1));
        return $65abce04567f614e$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});

parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});


parcelRegister("hUtHc", function(module, exports) {

$parcel$export(module.exports, "handleMention", () => $4c86f6f3d3a46b33$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $4c86f6f3d3a46b33$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $4c86f6f3d3a46b33$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $4c86f6f3d3a46b33$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $4c86f6f3d3a46b33$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $4c86f6f3d3a46b33$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $4c86f6f3d3a46b33$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $4c86f6f3d3a46b33$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $4c86f6f3d3a46b33$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $4c86f6f3d3a46b33$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $4c86f6f3d3a46b33$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $4c86f6f3d3a46b33$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleNestedTablePaste", () => $4c86f6f3d3a46b33$export$113227139658cc8d);
$parcel$export(module.exports, "handleExpandPaste", () => $4c86f6f3d3a46b33$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $4c86f6f3d3a46b33$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $4c86f6f3d3a46b33$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $4c86f6f3d3a46b33$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $4c86f6f3d3a46b33$export$4ce587bb5876886d);

var $bXrHm = parcelRequire("bXrHm");

var $gkwXh = parcelRequire("gkwXh");

var $kxM7f = parcelRequire("kxM7f");

var $30Enc = parcelRequire("30Enc");

var $9O539 = parcelRequire("9O539");

var $hPjvp = parcelRequire("hPjvp");

var $dPSMN = parcelRequire("dPSMN");
var $77j9j = parcelRequire("77j9j");
var $20Kbb = parcelRequire("20Kbb");
var $uTDrM = parcelRequire("uTDrM");
var $7vpuQ = parcelRequire("7vpuQ");

var $fZzhT = parcelRequire("fZzhT");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $4b1iw = parcelRequire("4b1iw");

var $gmhCD = parcelRequire("gmhCD");

var $iMJAN = parcelRequire("iMJAN");

var $6eO8M = parcelRequire("6eO8M");

var $fnWG9 = parcelRequire("fnWG9");

var $7h0c3 = parcelRequire("7h0c3");

var $bZdX5 = parcelRequire("bZdX5");
const $4c86f6f3d3a46b33$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $5r0mK.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $4c86f6f3d3a46b33$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $4c86f6f3d3a46b33$export$7097a0398467de9c(slice, schema) {
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $4c86f6f3d3a46b33$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $gZGBX.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $5r0mK.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $5r0mK.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const panelNode = (0, $bZdX5.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        if (selectionIsPanel && selectionIsCodeBlock) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $5r0mK.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $dPSMN.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $gZGBX.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $bZdX5.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $30Enc.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $bZdX5.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $4c86f6f3d3a46b33$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $fZzhT.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $bZdX5.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $7h0c3.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $77j9j.isInListItem)(state) || (0, $77j9j.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $kCV8T.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $77j9j.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $5r0mK.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $gZGBX.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $uTDrM.isListNode)(sliceContent.firstChild) && (0, $uTDrM.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $5r0mK.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($4c86f6f3d3a46b33$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $5r0mK.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $fnWG9.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $4c86f6f3d3a46b33$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $4c86f6f3d3a46b33$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$4c86f6f3d3a46b33$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $20Kbb.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $20Kbb.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $20Kbb.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && selection instanceof (0, $gZGBX.TextSelection) && !selection.empty && (0, $dPSMN.canLinkBeCreatedInRange)(from, to)(state)) {
            tr.addMark(from, to, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $fZzhT.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $4b1iw.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bZdX5.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $30Enc.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $5r0mK.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $bZdX5.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $bZdX5.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $fZzhT.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $4c86f6f3d3a46b33$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        view.dispatch((0, $fZzhT.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
        return true;
    }
    return false;
}
function $4c86f6f3d3a46b33$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $kCV8T.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $iMJAN.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $4c86f6f3d3a46b33$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6eO8M.getPluginState)(view.state);
                    if (dispatch) $4c86f6f3d3a46b33$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6eO8M.getPluginState)(view.state);
                    $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $iMJAN.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $4c86f6f3d3a46b33$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $4c86f6f3d3a46b33$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $5r0mK.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $fZzhT.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $4c86f6f3d3a46b33$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $4c86f6f3d3a46b33$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($4c86f6f3d3a46b33$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $kxM7f.insideTable)(state) && $4c86f6f3d3a46b33$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextPos, (0, $hPjvp.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $4c86f6f3d3a46b33$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $4c86f6f3d3a46b33$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $kxM7f.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $7vpuQ.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $kxM7f.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) {
            if ((0, $gmhCD.editorExperiment)('nested-tables-in-tables', true, {
                exposure: true
            })) /* TEST COHORT */ // if slice has table - if pasting to deeply nested location place paste after top table
            {
                if ((0, $9O539.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                    const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                    let { tr: tr } = state;
                    tr = (0, $5r0mK.safeInsert)(slice.content, positionAfterTopTable)(tr);
                    tr.scrollIntoView();
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                }
            } else {
                /* CONTROL COHORT */ // if slice has table - place paste after top table
                const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $5r0mK.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$4c86f6f3d3a46b33$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $kxM7f.insideTable)(state) && !isInsideNestableExpand || !$4c86f6f3d3a46b33$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $7vpuQ.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch (e) {
                    tr = (0, $5r0mK.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $kCV8T.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $5r0mK.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $4c86f6f3d3a46b33$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $fZzhT.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $gZGBX.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $4c86f6f3d3a46b33$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $4c86f6f3d3a46b33$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $4c86f6f3d3a46b33$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child) || (0, $uTDrM.isListItemNode)(child) && (0, $uTDrM.isListNode)(child.firstChild)) $4c86f6f3d3a46b33$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $4c86f6f3d3a46b33$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $kxM7f.insideTable)(state) && (0, $uTDrM.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $4c86f6f3d3a46b33$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $4c86f6f3d3a46b33$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
function $4c86f6f3d3a46b33$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: { $from: $from } } = state;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$4c86f6f3d3a46b33$var$sliceHasTopLevelMarks(slice)) return slice;
    // If pasting a single paragraph into pre-existing content, match destination formatting
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $4c86f6f3d3a46b33$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    if (forbiddenMarkTypes.length === 0) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $kCV8T.Slice)(slice.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        else if (node.type === schema.nodes.heading) // Preserve heading attributes to keep formatting
        return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
}
function $4c86f6f3d3a46b33$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $4c86f6f3d3a46b33$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $kCV8T.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
function $4c86f6f3d3a46b33$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($4c86f6f3d3a46b33$var$hasInlineCode(state, slice)) $4c86f6f3d3a46b33$var$removePrecedingBackTick(tr);
        if ($4c86f6f3d3a46b33$var$shouldFlattenList(state, slice)) slice = $4c86f6f3d3a46b33$export$79d83373d2946ba6(slice);
        (0, $fZzhT.closeHistory)(tr);
        const isFirstChildListNode = (0, $uTDrM.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $uTDrM.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        const panelParentOverCurrentSelection = (0, $5r0mK.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $fnWG9.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $fnWG9.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $gZGBX.TextSelection).findFrom($nextPos, -1, true) : new (0, $hPjvp.GapCursorSelection)($nextPos, (0, $hPjvp.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $77j9j.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextPos, (0, $hPjvp.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $77j9j.insideTableCell)(state) && (0, $77j9j.isInListItem)(state) && (0, $5r0mK.canInsert)(selection.$from, slice.content) && (0, $5r0mK.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice) && !$4c86f6f3d3a46b33$export$67c0f4368bb304c3(state)) (0, $fnWG9.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $5r0mK.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice)) (0, $fnWG9.updateSelectionAfterReplace)({
                    tr: tr
                });
            }
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $gZGBX.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $gkwXh.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4c86f6f3d3a46b33$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $5r0mK.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $4c86f6f3d3a46b33$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $4b1iw.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bZdX5.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $4c86f6f3d3a46b33$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $77j9j.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $4c86f6f3d3a46b33$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $uTDrM.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}

});
parcelRegister("9O539", function(module, exports) {

$parcel$export(module.exports, "getParentOfTypeCount", () => $d19def70e328a0c5$export$d5cbd8b17958f08b);
$parcel$export(module.exports, "getPositionAfterTopParentNodeOfType", () => $d19def70e328a0c5$export$ae584b8f0be37f04);
$parcel$export(module.exports, "isSelectionTableNestedInTable", () => $d19def70e328a0c5$export$3dd46fa6c35aa514);

var $28MvW = parcelRequire("28MvW");
const $d19def70e328a0c5$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $d19def70e328a0c5$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $d19def70e328a0c5$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $28MvW.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};

});

parcelRegister("4b1iw", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $567d91c47399f4b9$export$ea73b328547c6ad5);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $28MvW = parcelRequire("28MvW");

var $cK1Lv = parcelRequire("cK1Lv");
const $567d91c47399f4b9$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) {
        const table = (0, $28MvW.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("fnWG9", function(module, exports) {

$parcel$export(module.exports, "insertSliceForLists", () => $f9068438f432e0de$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $f9068438f432e0de$export$2dee216d0a70c94e);
$parcel$export(module.exports, "updateSelectionAfterReplace", () => $f9068438f432e0de$export$e57c13697a8b8195);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $f9068438f432e0de$export$2982aac953f7c8b6);

var $uTDrM = parcelRequire("uTDrM");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $bZdX5 = parcelRequire("bZdX5");

var $7h0c3 = parcelRequire("7h0c3");
function $f9068438f432e0de$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $bZdX5.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $uTDrM.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $7h0c3.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $bZdX5.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $7h0c3.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $bZdX5.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $7h0c3.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $5r0mK.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $uTDrM.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $bZdX5.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $7h0c3.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
function $f9068438f432e0de$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $f9068438f432e0de$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}
function $f9068438f432e0de$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eS2Dn.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $f9068438f432e0de$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    const selectionBeforeReplace = tr.selection.from;
    tr.replaceSelection(new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    const nextSelection = (0, $gZGBX.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
    tr.setSelection(nextSelection);
    tr.replaceSelection(slice);
}

});
parcelRegister("7h0c3", function(module, exports) {

$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $dd1e536a1e22a270$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $dd1e536a1e22a270$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $dd1e536a1e22a270$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $dd1e536a1e22a270$export$778b6ddd10a6aad3);
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");
function $dd1e536a1e22a270$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $dd1e536a1e22a270$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $gZGBX.TextSelection).near(startSlicePosition, direction));
}
function $dd1e536a1e22a270$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $gZGBX.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $dd1e536a1e22a270$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $kCV8T.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $5r0mK.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $kCV8T.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $594Yf.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $eS2Dn.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $gZGBX.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $gZGBX.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});




parcelRegister("jI1GO", function(module, exports) {

$parcel$export(module.exports, "clipboardTextSerializer", () => $29f021d097812b5c$export$31d6ecfc7a959697);
function $29f021d097812b5c$export$31d6ecfc7a959697(slice) {
    const blockSeparator = '\n\n';
    return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
        switch(leafNode.type.name){
            case 'hardBreak':
                return '\n';
            case 'text':
                return leafNode.text;
            case 'inlineCard':
                return leafNode.attrs.url;
            case 'blockCard':
                return leafNode.attrs.url;
            // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
            // pasting a mention does not actually work for the in-product Mention implementation.
            // However, this is also true of the previous implementation.
            // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
            case 'mention':
                return leafNode.attrs.text;
            default:
                // Unsupported node
                return leafNode.text ?? '';
        }
    });
}

});

parcelRegister("cOOfv", function(module, exports) {

$parcel$export(module.exports, "handleVSCodeBlock", () => $e3d6290730f0f4f2$export$d920fedcc56c4475);

var $8Y2ZY = parcelRequire("8Y2ZY");

var $7vpuQ = parcelRequire("7vpuQ");
function $e3d6290730f0f4f2$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch (_e) {}
}
function $e3d6290730f0f4f2$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $e3d6290730f0f4f2$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $8Y2ZY.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $7vpuQ.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}

});

parcelRegister("jbxbo", function(module, exports) {

$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $f13fdafc86889fbe$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $f13fdafc86889fbe$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $f13fdafc86889fbe$export$253f7bda9f1e0696);

var $azYnG = parcelRequire("azYnG");
const $f13fdafc86889fbe$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $f13fdafc86889fbe$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $f13fdafc86889fbe$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $f13fdafc86889fbe$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $f13fdafc86889fbe$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $f13fdafc86889fbe$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($f13fdafc86889fbe$var$exactlyDivisible(thCount, cellCount) || $f13fdafc86889fbe$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $f13fdafc86889fbe$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $f13fdafc86889fbe$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$f13fdafc86889fbe$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $f13fdafc86889fbe$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $f13fdafc86889fbe$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $f13fdafc86889fbe$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $f13fdafc86889fbe$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($f13fdafc86889fbe$var$exactlyDivisible(thCount, possibleColsInRow) && $f13fdafc86889fbe$var$exactlyDivisible(cellCount, possibleColsInRow)) return $f13fdafc86889fbe$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $f13fdafc86889fbe$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $f13fdafc86889fbe$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $f13fdafc86889fbe$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $f13fdafc86889fbe$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});


parcelRegister("2NfYE", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $2be0cbb83c95428b$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $VSDnB = parcelRequire("VSDnB");

var $i7Qmp = parcelRequire("i7Qmp");

var $8rlPn = parcelRequire("8rlPn");

var $5k8Yv = parcelRequire("5k8Yv");

var $9CaqV = parcelRequire("9CaqV");

var $h3AOq = parcelRequire("h3AOq");
const $2be0cbb83c95428b$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5k8Yv.pluginKey),
        state: (0, $8rlPn.createPluginState)(dispatch, (0, $9CaqV.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $8rlPn.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeName || !(0, $h3AOq.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).MOVED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        // keep nodeName from copied slice
                        nodeType: contentMoved?.nodeName,
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $h3AOq.getParentNodeDepth)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $i7Qmp.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                // Note: the following is not the case once `platform_editor_element_drag_and_drop_multiselect` is enabled
                // we now want to track cut events for multiple nodes
                // Content should be just one node, so we added a check for slice.content.childCount === 1;
                // 1. It is possible to select a table by dragging the mouse over the table's rows.
                // As a result, slice will contain rows without tableNode itself and the childCount will be the number of rows.
                // From a user's perspective the whole table is selected and copied and on paste a table will indeed be created.
                // 2. Some block nodes can get selected when a user drags the mouse from the paragraph above the node to
                // the paragraph below the node. Visually only the node in between is selected, in reality, three nodes are
                // in the slice.
                // These cases are ignored and moveContent event won't be counted.
                const isMultiSelectTrackingEnabled = (0, $VSDnB.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $h3AOq.containsExcludedNode)(content)) resetState = true;
                        else {
                            const attributes = (0, $h3AOq.getMultipleSelectionAttributes)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $h3AOq.isExcludedNode)(nodeName)) resetState = true;
                    if (!resetState && !(0, $h3AOq.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, $h3AOq.isInlineNode)(nodeName) && (0, $h3AOq.isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, $h3AOq.isNestedInTable)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $i7Qmp.resetContentMoved)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeName: nodeName,
                        nodeDepth: (0, $h3AOq.getParentNodeDepth)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $i7Qmp.updateContentMoved)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("i7Qmp", function(module, exports) {

$parcel$export(module.exports, "updateContentMoved", () => $798b2c41933df7a4$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $798b2c41933df7a4$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $798b2c41933df7a4$export$47c45651eb91dff0);

var $f6ggO = parcelRequire("f6ggO");

var $8rlPn = parcelRequire("8rlPn");

var $5k8Yv = parcelRequire("5k8Yv");
const $798b2c41933df7a4$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $8rlPn.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $8rlPn.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeName: nextState?.nodeName,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $798b2c41933df7a4$export$56834735aa39d3eb = ()=>(0, $8rlPn.createCommand)(()=>{
        return {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $798b2c41933df7a4$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $5k8Yv.pluginKey), payload);
    };

});
parcelRegister("f6ggO", function(module, exports) {

$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $7965858ec5e0044d$export$a5fa3822909c7e0);
var $7965858ec5e0044d$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});

});

parcelRegister("8rlPn", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $2081a2e3c7261c3b$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $2081a2e3c7261c3b$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $2081a2e3c7261c3b$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $5k8Yv = parcelRequire("5k8Yv");

var $7Pna1 = parcelRequire("7Pna1");
const { createPluginState: $2081a2e3c7261c3b$export$656c7661095efe2e, createCommand: $2081a2e3c7261c3b$export$8d4021544bdece00, getPluginState: $2081a2e3c7261c3b$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $5k8Yv.pluginKey), (0, $7Pna1.reducer));

});
parcelRegister("5k8Yv", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $9ce9393f2b841371$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $9ce9393f2b841371$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("7Pna1", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $b034c2044beda78c$export$1650419e431d3ba3);

var $f6ggO = parcelRequire("f6ggO");

var $9CaqV = parcelRequire("9CaqV");
const $b034c2044beda78c$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $f6ggO.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $f6ggO.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $9CaqV.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("9CaqV", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $b1508633d2c50936$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $b1508633d2c50936$export$49d5fc8cba920a0 = {
    contentMoved: {
        nodeName: undefined,
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};

});




parcelRegister("h3AOq", function(module, exports) {

$parcel$export(module.exports, "isExcludedNode", () => $c3f86eb485557d11$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $c3f86eb485557d11$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $c3f86eb485557d11$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $c3f86eb485557d11$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $c3f86eb485557d11$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $c3f86eb485557d11$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $c3f86eb485557d11$export$b6cb43348b690a2d);
$parcel$export(module.exports, "containsExcludedNode", () => $c3f86eb485557d11$export$c4a09517c4982d7c);
$parcel$export(module.exports, "getMultipleSelectionAttributes", () => $c3f86eb485557d11$export$f3a535d61fe1eda3);

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $c3f86eb485557d11$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $c3f86eb485557d11$export$75248da1527ddfc1 = (nodeName)=>$c3f86eb485557d11$var$excludedNodes.includes(nodeName);
const $c3f86eb485557d11$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $c3f86eb485557d11$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $c3f86eb485557d11$export$82ae59a0847ee78b = (nodeName)=>{
    return $c3f86eb485557d11$var$inlineNodes.includes(nodeName);
};
const $c3f86eb485557d11$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $c3f86eb485557d11$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $hFEwm.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $c3f86eb485557d11$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $5r0mK.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $c3f86eb485557d11$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $c3f86eb485557d11$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($c3f86eb485557d11$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $c3f86eb485557d11$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $VSDnB.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});




parcelRegister("7o36A", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => (parcelRequire("8OUh9")).placeholderPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8OUh9 = parcelRequire("8OUh9");

});
parcelRegister("8OUh9", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => $d98addc52985d2e7$export$ecbe4cfe6671ba88);

var $ixwvf = parcelRequire("ixwvf");

var $5KWxh = parcelRequire("5KWxh");

var $ggL2v = parcelRequire("ggL2v");
var $gE8f9 = parcelRequire("gE8f9");parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $d98addc52985d2e7$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('placeholderPlugin');
function $d98addc52985d2e7$var$getPlaceholderState(editorState) {
    return $d98addc52985d2e7$export$18d4026d1ea86bb1.getState(editorState);
}
const $d98addc52985d2e7$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $d98addc52985d2e7$var$nodeTypesWithLongPlaceholderText = [
    'expand',
    'panel'
];
const $d98addc52985d2e7$var$nodeTypesWithShortPlaceholderText = [
    'tableCell',
    'tableHeader'
];
function $d98addc52985d2e7$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', $d98addc52985d2e7$export$53e9a5af7ff64f3e);
    placeholderDecoration.className = 'placeholder-decoration';
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if ((0, $gE8f9.browser).gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    placeholderNodeWithText.textContent = placeholderText || ' ';
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if ((0, $gE8f9.browser).android && (0, $gE8f9.browser).chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1;
    // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    return (0, $etG8M.DecorationSet).create(editorState.doc, [
        (0, $etG8M.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}
function $d98addc52985d2e7$var$setPlaceHolderState(placeholderText, pos) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        pos: pos ? pos : 1
    };
}
const $d98addc52985d2e7$var$emptyPlaceholder = (placeholderText)=>({
        hasPlaceholder: false,
        placeholderText: placeholderText
    });
function $d98addc52985d2e7$var$createPlaceHolderStateFrom({ isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder }) {
    if (isTypeAheadOpen?.(editorState)) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
    if (defaultPlaceholderText && (0, $ggL2v.isEmptyDocument)(editorState.doc)) return $d98addc52985d2e7$var$setPlaceHolderState(defaultPlaceholderText);
    if (isEditorFocused && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1')) {
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode?.type.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $594Yf.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $d98addc52985d2e7$var$setPlaceHolderState(emptyLinePlaceholder, $from.pos);
        }
        const isEmptyNode = parentNode?.childCount === 1 && parentNode.firstChild?.content.size === 0 && parentNode.firstChild?.type.name === 'paragraph';
        if ($d98addc52985d2e7$var$nodeTypesWithShortPlaceholderText.includes(parentType) && isEmptyNode) {
            if (!(0, $VSDnB.fg)('platform_editor_controls_patch_3')) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).shortEmptyNodePlaceholderText), $from.pos);
            const table = (0, $5r0mK.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
            const isFirstCell = table?.node.firstChild?.content.firstChild === parentNode;
            if (isFirstCell) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).shortEmptyNodePlaceholderText), $from.pos);
        }
        if ($d98addc52985d2e7$var$nodeTypesWithLongPlaceholderText.includes(parentType) && isEmptyNode) return $d98addc52985d2e7$var$setPlaceHolderState(intl.formatMessage((0, $ixwvf.placeholderTextMessages).longEmptyNodePlaceholderText), $from.pos);
        return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
    }
    if (bracketPlaceholderText && (0, $ggL2v.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $d98addc52985d2e7$var$setPlaceHolderState(bracketHint, $from.pos - 1);
    }
    return $d98addc52985d2e7$var$emptyPlaceholder(defaultPlaceholderText);
}
function $d98addc52985d2e7$export$ae829ec7b2625219(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, api) {
    if (!defaultPlaceholderText && !bracketPlaceholderText) return;
    return new (0, $5KWxh.SafePlugin)({
        key: $d98addc52985d2e7$export$18d4026d1ea86bb1,
        state: {
            init: (_, state)=>$d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: Boolean(api?.focus?.sharedState.currentState()?.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                }),
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($d98addc52985d2e7$export$18d4026d1ea86bb1);
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                if (meta?.placeholderText !== undefined) return $d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: meta.placeholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
                return $d98addc52985d2e7$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: placeholderState?.placeholderText ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
            }
        },
        props: {
            decorations (editorState) {
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos } = $d98addc52985d2e7$var$getPlaceholderState(editorState);
                const compositionPluginState = api?.composition?.sharedState.currentState();
                if (hasPlaceholder && placeholderText && pos !== undefined && !compositionPluginState?.isComposing) return $d98addc52985d2e7$export$980ea07f18fbfea9(editorState, placeholderText, pos);
                return;
            }
        }
    });
}
const $d98addc52985d2e7$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options?.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($d98addc52985d2e7$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>$d98addc52985d2e7$export$ae829ec7b2625219(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, api)
                }
            ];
        }
    };
};

});


parcelRegister("3HDda", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => (parcelRequire("7helP")).primaryToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7helP = parcelRequire("7helP");

});
parcelRegister("7helP", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPlugin", () => $c45a005c0d3c741d$export$ad7799fd22a76abd);

var $9xu0r = parcelRequire("9xu0r");

var $llAXH = parcelRequire("llAXH");

var $eZlEZ = parcelRequire("eZlEZ");
const $c45a005c0d3c741d$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $eZlEZ.default));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $9xu0r.registerComponent)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $llAXH.createPlugin)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config?.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $llAXH.primaryToolbarPluginKey).getState(editorState);
        }
    };
};

});
parcelRegister("9xu0r", function(module, exports) {

$parcel$export(module.exports, "registerComponent", () => $139e1948c845d5e6$export$d74092cddf07c0aa);
const $139e1948c845d5e6$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };

});

parcelRegister("llAXH", function(module, exports) {

$parcel$export(module.exports, "primaryToolbarPluginKey", () => $3a6122000cdc0da4$export$36f60c8b3eb879ae);
$parcel$export(module.exports, "createPlugin", () => $3a6122000cdc0da4$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $hyTjY = parcelRequire("hyTjY");
const $3a6122000cdc0da4$export$36f60c8b3eb879ae = new (0, $gZGBX.PluginKey)('primaryToolbar');
const $3a6122000cdc0da4$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $3a6122000cdc0da4$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $hyTjY.getToolbarComponents)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};

});
parcelRegister("hyTjY", function(module, exports) {

$parcel$export(module.exports, "getToolbarComponents", () => $be0d074133b98533$export$a758406ca53b86a5);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $be0d074133b98533$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        const shouldShowUndoRedoGroup = (0, $VSDnB.fg)('platform_editor_undo_redo_find_on_primary_toolbar');
        configuration = $be0d074133b98533$var$toolbarConfigurationV2(true, shouldShowUndoRedoGroup);
    } else {
        const shouldShowFindGroup = !(!contextualFormattingEnabled && (0, $VSDnB.fg)('platform_editor_controls_fix_toolbar_config_embeds'));
        configuration = $be0d074133b98533$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $be0d074133b98533$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $be0d074133b98533$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $be0d074133b98533$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $be0d074133b98533$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $be0d074133b98533$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $be0d074133b98533$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $be0d074133b98533$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $be0d074133b98533$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $be0d074133b98533$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $be0d074133b98533$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $be0d074133b98533$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $be0d074133b98533$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $be0d074133b98533$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$be0d074133b98533$var$undoRedoGroup,
        ...$be0d074133b98533$var$spellCheckGroup,
        ...$be0d074133b98533$var$blockTypeGroup,
        ...$be0d074133b98533$var$textFormattingGroup,
        ...$be0d074133b98533$var$alignmentGroup,
        ...$be0d074133b98533$var$textColorGroup,
        ...$be0d074133b98533$var$listFormattingGroup,
        ...$be0d074133b98533$var$insertBlockGroup,
        ...shouldShowFindGroup ? $be0d074133b98533$var$others : $be0d074133b98533$var$othersGroupNoFind
    ];
const $be0d074133b98533$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowUndoRedoGroup, shouldShowFindGroup = false)=>[
        ...shouldShowUndoRedoGroup ? $be0d074133b98533$var$undoRedoGroup : [],
        ...$be0d074133b98533$var$blockTypeGroup,
        ...$be0d074133b98533$var$textFormattingGroup,
        ...$be0d074133b98533$var$textColorGroup,
        ...$be0d074133b98533$var$alignmentGroup,
        ...$be0d074133b98533$var$listFormattingGroup,
        ...$be0d074133b98533$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $be0d074133b98533$var$insertBlockGroup : [],
        {
            name: 'overflowMenu'
        },
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $be0d074133b98533$var$findGroup : []
    ];

});


parcelRegister("eZlEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcdef81723d8be5b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ejItq = parcelRequire("ejItq");
var $fcdef81723d8be5b$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ejItq.wrapperStyle)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $ejItq.separatorStyles)
    }));

});



parcelRegister("ai1SC", function(module, exports) {

$parcel$export(module.exports, "quickInsertPlugin", () => (parcelRequire("blumq")).quickInsertPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $blumq = parcelRequire("blumq");

});
parcelRegister("blumq", function(module, exports) {

$parcel$export(module.exports, "quickInsertPlugin", () => $d578a19008c7a880$export$2ff93c7de46a9aaa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8C0Ak = parcelRequire("8C0Ak");

var $5KWxh = parcelRequire("5KWxh");

var $3UtTx = parcelRequire("3UtTx");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $kyxC3 = parcelRequire("kyxC3");

var $456we = parcelRequire("456we");

var $42zgk = parcelRequire("42zgk");

var $3xc9s = parcelRequire("3xc9s");
const $d578a19008c7a880$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const onInsert = (item)=>{
        options?.onInsert?.(item);
    };
    const typeAhead = {
        id: (0, $3UtTx.TypeAheadAvailableNodes).QUICK_INSERT,
        trigger: '/',
        headless: options?.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $456we.pluginKey).getState(editorState);
            const queryAllItems = '';
            return Promise.resolve((0, $3xc9s.getQuickInsertSuggestions)({
                query: (0, $gmhCD.editorExperiment)('platform_editor_insertion', 'control') ? query : queryAllItems,
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: options?.prioritySortingFn
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems));
        },
        selectItem: (state, item, insert)=>{
            const quickInsertItem = item;
            const result = quickInsertItem.action(insert, state);
            if (result) onInsert(quickInsertItem);
            return result;
        },
        // @ts-ignore
        // This is used by typeahead plugin to trigger element browser modal without introducing circular dependency.
        // Given it's only temporarily needed to roll out toolbar&menus separate to quick insert/right rail change
        // skip updating `TypeAheadHandler` to avoid unnecessary breaking change.
        openElementBrowserModal: options?.enableElementBrowser ? ()=>{
            api?.core.actions.execute(({ tr: tr })=>{
                if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                (0, $kyxC3.openElementBrowserModal)({
                    tr: tr
                });
                return tr;
            });
        } : undefined
    };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch })=>$d578a19008c7a880$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, options?.emptyStateHandler)
                }
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView }) {
            if (options?.enableElementBrowser) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42zgk.default), {
                editorView: editorView,
                helpUrl: options?.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $456we.pluginKey).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen
            };
        },
        actions: {
            insertItem: (0, $kyxC3.createInsertItem)(onInsert),
            openTypeAhead (inputMethod, removePrefixTriggerOnCancel) {
                return Boolean(api?.typeAhead?.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod,
                    removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
                }));
            },
            getSuggestions: (searchOptions)=>{
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                if (options?.prioritySortingFn) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: options.prioritySortingFn
                };
                return (0, $3xc9s.getQuickInsertSuggestions)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowserModal: ({ tr: tr })=>{
                if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return (0, $kyxC3.openElementBrowserModal)({
                    tr: tr
                });
            },
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    const { lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $8C0Ak.memoProcessQuickInsertItems)([
                        item
                    ], intl);
                    return tr.setMeta((0, $456we.pluginKey), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $koVbs.default)();
        }
    };
};
const $d578a19008c7a880$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $456we.pluginKey), providerState));
        return true;
    };
function $d578a19008c7a880$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, emptyStateHandler) {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $456we.pluginKey),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $8C0Ak.memoProcessQuickInsertItems)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $456we.pluginKey));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $456we.pluginKey), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    $d578a19008c7a880$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("8C0Ak", function(module, exports) {

$parcel$export(module.exports, "memoProcessQuickInsertItems", () => $630b8a123e10b929$export$4fca091f4ee92b6d);
$parcel$export(module.exports, "find", () => $630b8a123e10b929$export$71aa6c912b956294);

var $4UNBW = parcelRequire("4UNBW");

var $8QpSo = parcelRequire("8QpSo");

var $VSDnB = parcelRequire("VSDnB");
const $630b8a123e10b929$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $630b8a123e10b929$var$memoizedProcessQuickInsertItems = (0, $8QpSo.default)($630b8a123e10b929$var$processQuickInsertItems);
const $630b8a123e10b929$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $630b8a123e10b929$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $630b8a123e10b929$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
const $630b8a123e10b929$var$optionsWithPriorityRemoved = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $630b8a123e10b929$export$71aa6c912b956294(query, items, prioritySortingFn) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...(0, $VSDnB.fg)('platform_editor_remove_quick_insert_priority_key') ? $630b8a123e10b929$var$optionsWithPriorityRemoved : $630b8a123e10b929$var$options
    };
    if (prioritySortingFn) {
        const sortFn = prioritySortingFn(items);
        // prioritySortingFn will trigger the experiment exposure, but sortFn
        // will be undefined for the control group.
        if (sortFn) fuseOptions.sortFn = sortFn;
    }
    const fuse = new (0, $4UNBW.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("4UNBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3942e01bac0db9ed$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $3942e01bac0db9ed$var$isArray(value) {
    return !Array.isArray ? $3942e01bac0db9ed$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $3942e01bac0db9ed$var$INFINITY = 1 / 0;
function $3942e01bac0db9ed$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$3942e01bac0db9ed$var$INFINITY ? '-0' : result;
}
function $3942e01bac0db9ed$var$toString(value) {
    return value == null ? '' : $3942e01bac0db9ed$var$baseToString(value);
}
function $3942e01bac0db9ed$var$isString(value) {
    return typeof value === 'string';
}
function $3942e01bac0db9ed$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $3942e01bac0db9ed$var$isBoolean(value) {
    return value === true || value === false || $3942e01bac0db9ed$var$isObjectLike(value) && $3942e01bac0db9ed$var$getTag(value) == '[object Boolean]';
}
function $3942e01bac0db9ed$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $3942e01bac0db9ed$var$isObjectLike(value) {
    return $3942e01bac0db9ed$var$isObject(value) && value !== null;
}
function $3942e01bac0db9ed$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $3942e01bac0db9ed$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $3942e01bac0db9ed$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $3942e01bac0db9ed$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $3942e01bac0db9ed$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $3942e01bac0db9ed$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $3942e01bac0db9ed$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $3942e01bac0db9ed$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $3942e01bac0db9ed$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $3942e01bac0db9ed$var$hasOwn = Object.prototype.hasOwnProperty;
class $3942e01bac0db9ed$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $3942e01bac0db9ed$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $3942e01bac0db9ed$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($3942e01bac0db9ed$var$isString(key) || $3942e01bac0db9ed$var$isArray(key)) {
        src = key;
        path = $3942e01bac0db9ed$var$createKeyPath(key);
        id = $3942e01bac0db9ed$var$createKeyId(key);
    } else {
        if (!$3942e01bac0db9ed$var$hasOwn.call(key, 'name')) throw new Error($3942e01bac0db9ed$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($3942e01bac0db9ed$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($3942e01bac0db9ed$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $3942e01bac0db9ed$var$createKeyPath(name);
        id = $3942e01bac0db9ed$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $3942e01bac0db9ed$var$createKeyPath(key) {
    return $3942e01bac0db9ed$var$isArray(key) ? key : key.split('.');
}
function $3942e01bac0db9ed$var$createKeyId(key) {
    return $3942e01bac0db9ed$var$isArray(key) ? key.join('.') : key;
}
function $3942e01bac0db9ed$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$3942e01bac0db9ed$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$3942e01bac0db9ed$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($3942e01bac0db9ed$var$isString(value) || $3942e01bac0db9ed$var$isNumber(value) || $3942e01bac0db9ed$var$isBoolean(value))) list.push($3942e01bac0db9ed$var$toString(value));
            else if ($3942e01bac0db9ed$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $3942e01bac0db9ed$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $3942e01bac0db9ed$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $3942e01bac0db9ed$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $3942e01bac0db9ed$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $3942e01bac0db9ed$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $3942e01bac0db9ed$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $3942e01bac0db9ed$var$Config = {
    ...$3942e01bac0db9ed$var$BasicOptions,
    ...$3942e01bac0db9ed$var$MatchOptions,
    ...$3942e01bac0db9ed$var$FuzzyOptions,
    ...$3942e01bac0db9ed$var$AdvancedOptions
};
const $3942e01bac0db9ed$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $3942e01bac0db9ed$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($3942e01bac0db9ed$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $3942e01bac0db9ed$var$FuseIndex {
    constructor({ getFn: getFn = $3942e01bac0db9ed$var$Config.getFn, fieldNormWeight: fieldNormWeight = $3942e01bac0db9ed$var$Config.fieldNormWeight } = {}){
        this.norm = $3942e01bac0db9ed$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($3942e01bac0db9ed$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($3942e01bac0db9ed$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$3942e01bac0db9ed$var$isDefined(doc) || $3942e01bac0db9ed$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$3942e01bac0db9ed$var$isDefined(value)) return;
            if ($3942e01bac0db9ed$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$3942e01bac0db9ed$var$isDefined(value)) continue;
                    if ($3942e01bac0db9ed$var$isString(value) && !$3942e01bac0db9ed$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($3942e01bac0db9ed$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($3942e01bac0db9ed$var$isString(value) && !$3942e01bac0db9ed$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $3942e01bac0db9ed$var$createIndex(keys, docs, { getFn: getFn = $3942e01bac0db9ed$var$Config.getFn, fieldNormWeight: fieldNormWeight = $3942e01bac0db9ed$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $3942e01bac0db9ed$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($3942e01bac0db9ed$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $3942e01bac0db9ed$var$parseIndex(data, { getFn: getFn = $3942e01bac0db9ed$var$Config.getFn, fieldNormWeight: fieldNormWeight = $3942e01bac0db9ed$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $3942e01bac0db9ed$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $3942e01bac0db9ed$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $3942e01bac0db9ed$var$Config.distance, ignoreLocation: ignoreLocation = $3942e01bac0db9ed$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $3942e01bac0db9ed$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $3942e01bac0db9ed$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $3942e01bac0db9ed$var$MAX_BITS = 32;
function $3942e01bac0db9ed$var$search(text, pattern, patternAlphabet, { location: location = $3942e01bac0db9ed$var$Config.location, distance: distance = $3942e01bac0db9ed$var$Config.distance, threshold: threshold = $3942e01bac0db9ed$var$Config.threshold, findAllMatches: findAllMatches = $3942e01bac0db9ed$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $3942e01bac0db9ed$var$Config.minMatchCharLength, includeMatches: includeMatches = $3942e01bac0db9ed$var$Config.includeMatches, ignoreLocation: ignoreLocation = $3942e01bac0db9ed$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $3942e01bac0db9ed$var$MAX_BITS) throw new Error($3942e01bac0db9ed$var$PATTERN_LENGTH_TOO_LARGE($3942e01bac0db9ed$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $3942e01bac0db9ed$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $3942e01bac0db9ed$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $3942e01bac0db9ed$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $3942e01bac0db9ed$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $3942e01bac0db9ed$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $3942e01bac0db9ed$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $3942e01bac0db9ed$var$BitapSearch {
    constructor(pattern, { location: location = $3942e01bac0db9ed$var$Config.location, threshold: threshold = $3942e01bac0db9ed$var$Config.threshold, distance: distance = $3942e01bac0db9ed$var$Config.distance, includeMatches: includeMatches = $3942e01bac0db9ed$var$Config.includeMatches, findAllMatches: findAllMatches = $3942e01bac0db9ed$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $3942e01bac0db9ed$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $3942e01bac0db9ed$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $3942e01bac0db9ed$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $3942e01bac0db9ed$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $3942e01bac0db9ed$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $3942e01bac0db9ed$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $3942e01bac0db9ed$var$MAX_BITS), i);
                i += $3942e01bac0db9ed$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $3942e01bac0db9ed$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $3942e01bac0db9ed$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $3942e01bac0db9ed$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $3942e01bac0db9ed$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $3942e01bac0db9ed$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $3942e01bac0db9ed$var$ExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $3942e01bac0db9ed$var$InverseExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $3942e01bac0db9ed$var$PrefixExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $3942e01bac0db9ed$var$InversePrefixExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $3942e01bac0db9ed$var$SuffixExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $3942e01bac0db9ed$var$InverseSuffixExactMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $3942e01bac0db9ed$var$FuzzyMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern, { location: location = $3942e01bac0db9ed$var$Config.location, threshold: threshold = $3942e01bac0db9ed$var$Config.threshold, distance: distance = $3942e01bac0db9ed$var$Config.distance, includeMatches: includeMatches = $3942e01bac0db9ed$var$Config.includeMatches, findAllMatches: findAllMatches = $3942e01bac0db9ed$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $3942e01bac0db9ed$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $3942e01bac0db9ed$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $3942e01bac0db9ed$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $3942e01bac0db9ed$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $3942e01bac0db9ed$var$IncludeMatch extends $3942e01bac0db9ed$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $3942e01bac0db9ed$var$searchers = [
    $3942e01bac0db9ed$var$ExactMatch,
    $3942e01bac0db9ed$var$IncludeMatch,
    $3942e01bac0db9ed$var$PrefixExactMatch,
    $3942e01bac0db9ed$var$InversePrefixExactMatch,
    $3942e01bac0db9ed$var$InverseSuffixExactMatch,
    $3942e01bac0db9ed$var$SuffixExactMatch,
    $3942e01bac0db9ed$var$InverseExactMatch,
    $3942e01bac0db9ed$var$FuzzyMatch
];
const $3942e01bac0db9ed$var$searchersLen = $3942e01bac0db9ed$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $3942e01bac0db9ed$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $3942e01bac0db9ed$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $3942e01bac0db9ed$var$parseQuery(pattern, options = {}) {
    return pattern.split($3942e01bac0db9ed$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($3942e01bac0db9ed$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $3942e01bac0db9ed$var$searchersLen){
                const searcher = $3942e01bac0db9ed$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $3942e01bac0db9ed$var$searchersLen){
                const searcher = $3942e01bac0db9ed$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $3942e01bac0db9ed$var$MultiMatchSet = new Set([
    $3942e01bac0db9ed$var$FuzzyMatch.type,
    $3942e01bac0db9ed$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $3942e01bac0db9ed$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $3942e01bac0db9ed$var$Config.isCaseSensitive, includeMatches: includeMatches = $3942e01bac0db9ed$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $3942e01bac0db9ed$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $3942e01bac0db9ed$var$Config.ignoreLocation, findAllMatches: findAllMatches = $3942e01bac0db9ed$var$Config.findAllMatches, location: location = $3942e01bac0db9ed$var$Config.location, threshold: threshold = $3942e01bac0db9ed$var$Config.threshold, distance: distance = $3942e01bac0db9ed$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $3942e01bac0db9ed$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($3942e01bac0db9ed$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $3942e01bac0db9ed$var$registeredSearchers = [];
function $3942e01bac0db9ed$var$register(...args) {
    $3942e01bac0db9ed$var$registeredSearchers.push(...args);
}
function $3942e01bac0db9ed$var$createSearcher(pattern, options) {
    for(let i = 0, len = $3942e01bac0db9ed$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $3942e01bac0db9ed$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $3942e01bac0db9ed$var$BitapSearch(pattern, options);
}
const $3942e01bac0db9ed$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $3942e01bac0db9ed$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $3942e01bac0db9ed$var$isExpression = (query)=>!!(query[$3942e01bac0db9ed$var$LogicalOperator.AND] || query[$3942e01bac0db9ed$var$LogicalOperator.OR]);
const $3942e01bac0db9ed$var$isPath = (query)=>!!query[$3942e01bac0db9ed$var$KeyType.PATH];
const $3942e01bac0db9ed$var$isLeaf = (query)=>!$3942e01bac0db9ed$var$isArray(query) && $3942e01bac0db9ed$var$isObject(query) && !$3942e01bac0db9ed$var$isExpression(query);
const $3942e01bac0db9ed$var$convertToExplicit = (query)=>({
        [$3942e01bac0db9ed$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $3942e01bac0db9ed$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $3942e01bac0db9ed$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$3942e01bac0db9ed$var$isExpression(query)) return next($3942e01bac0db9ed$var$convertToExplicit(query));
        if ($3942e01bac0db9ed$var$isLeaf(query)) {
            const key = isQueryPath ? query[$3942e01bac0db9ed$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$3942e01bac0db9ed$var$KeyType.PATTERN] : query[key];
            if (!$3942e01bac0db9ed$var$isString(pattern)) throw new Error($3942e01bac0db9ed$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $3942e01bac0db9ed$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $3942e01bac0db9ed$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($3942e01bac0db9ed$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$3942e01bac0db9ed$var$isExpression(query)) query = $3942e01bac0db9ed$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $3942e01bac0db9ed$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $3942e01bac0db9ed$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $3942e01bac0db9ed$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$3942e01bac0db9ed$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$3942e01bac0db9ed$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $3942e01bac0db9ed$var$transformScore(result, data) {
    data.score = result.score;
}
function $3942e01bac0db9ed$var$format(results, docs, { includeMatches: includeMatches = $3942e01bac0db9ed$var$Config.includeMatches, includeScore: includeScore = $3942e01bac0db9ed$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($3942e01bac0db9ed$var$transformMatches);
    if (includeScore) transformers.push($3942e01bac0db9ed$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $3942e01bac0db9ed$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$3942e01bac0db9ed$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $3942e01bac0db9ed$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $3942e01bac0db9ed$var$FuseIndex)) throw new Error($3942e01bac0db9ed$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $3942e01bac0db9ed$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$3942e01bac0db9ed$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $3942e01bac0db9ed$var$isString(query) ? $3942e01bac0db9ed$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $3942e01bac0db9ed$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($3942e01bac0db9ed$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $3942e01bac0db9ed$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $3942e01bac0db9ed$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$3942e01bac0db9ed$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $3942e01bac0db9ed$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $3942e01bac0db9ed$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($3942e01bac0db9ed$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $3942e01bac0db9ed$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$3942e01bac0db9ed$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$3942e01bac0db9ed$var$isDefined(value)) return [];
        let matches = [];
        if ($3942e01bac0db9ed$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$3942e01bac0db9ed$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$3942e01bac0db9ed$export$2e2bcd8739ae039.version = '6.6.2';
$3942e01bac0db9ed$export$2e2bcd8739ae039.createIndex = $3942e01bac0db9ed$var$createIndex;
$3942e01bac0db9ed$export$2e2bcd8739ae039.parseIndex = $3942e01bac0db9ed$var$parseIndex;
$3942e01bac0db9ed$export$2e2bcd8739ae039.config = $3942e01bac0db9ed$var$Config;
$3942e01bac0db9ed$export$2e2bcd8739ae039.parseQuery = $3942e01bac0db9ed$var$parse;
$3942e01bac0db9ed$var$register($3942e01bac0db9ed$var$ExtendedSearch);

});


parcelRegister("kyxC3", function(module, exports) {

$parcel$export(module.exports, "openElementBrowserModal", () => $7e44b8dd113052ed$export$a37159c5d6f821f5);
$parcel$export(module.exports, "closeElementBrowserModal", () => $7e44b8dd113052ed$export$d7c09ddb7ec80ba9);
$parcel$export(module.exports, "createInsertItem", () => $7e44b8dd113052ed$export$40b105cb73ed6b94);

var $dlzPV = parcelRequire("dlzPV");

var $456we = parcelRequire("456we");
const $7e44b8dd113052ed$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $456we.pluginKey), {
        isElementBrowserModalOpen: true
    });
const $7e44b8dd113052ed$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $456we.pluginKey), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $7e44b8dd113052ed$export$40b105cb73ed6b94 = (onInsert)=>$7e44b8dd113052ed$var$insertItem(onInsert);
// this method was adapted from the typeahead plugin so we respect the API for quick insert items
const $7e44b8dd113052ed$var$insertItem = (onInsert)=>(item, source)=>(state, dispatch)=>{
            const insert = (maybeNode, opts = {})=>{
                return (0, $dlzPV.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
            };
            const tr = item.action(insert, state, source);
            /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
            onInsert?.(item);
            return true;
        };

});
parcelRegister("456we", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $73ad07cb51562204$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $73ad07cb51562204$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('quickInsertPluginKey');

});


parcelRegister("42zgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b32c4cfd315bc8f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $VSDnB = parcelRequire("VSDnB");

var $kyxC3 = parcelRequire("kyxC3");

var $50ybW = parcelRequire("50ybW");
const $4b32c4cfd315bc8f$var$Modal = ({ quickInsertState: quickInsertState, isOffline: isOffline, editorView: editorView, helpUrl: helpUrl, insertItem: insertItem, getSuggestions: getSuggestions, api: api })=>{
    const getItems = (0, $5uXOq.useCallback)((query, category)=>getSuggestions?.({
            query: query,
            category: category
        })?.map((item)=>{
            return isOffline && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item;
        }) ?? [], // See: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/157796/overview?commentId=8559952
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getSuggestions,
        quickInsertState.lazyDefaultItems,
        quickInsertState.providedItems,
        isOffline
    ]);
    const focusInEditor = (0, $5uXOq.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const onInsertItem = (0, $5uXOq.useCallback)((item)=>{
        (0, $kyxC3.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        insertableItem.current = item;
    }, [
        editorView,
        api
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $kyxC3.closeElementBrowserModal)()(editorView.state, editorView.dispatch);
        if ((0, $VSDnB.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        focusInEditor();
    }, [
        editorView,
        focusInEditor,
        api
    ]);
    const onCloseComplete = (0, $5uXOq.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        insertItem?.(item)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor,
        insertItem
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50ybW.default), {
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState.isElementBrowserModalOpen || false,
        emptyStateHandler: quickInsertState.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
const $4b32c4cfd315bc8f$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const lazyDefaultItems = (0, $9LY0t.useSharedPluginStateSelector)(api, 'quickInsert.lazyDefaultItems');
    const providedItems = (0, $9LY0t.useSharedPluginStateSelector)(api, 'quickInsert.providedItems');
    const isElementBrowserModalOpen = (0, $9LY0t.useSharedPluginStateSelector)(api, 'quickInsert.isElementBrowserModalOpen');
    const emptyStateHandler = (0, $9LY0t.useSharedPluginStateSelector)(api, 'quickInsert.emptyStateHandler');
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'connectivity.mode');
    return {
        mode: mode,
        lazyDefaultItems: lazyDefaultItems,
        providedItems: providedItems,
        isElementBrowserModalOpen: isElementBrowserModalOpen,
        emptyStateHandler: emptyStateHandler
    };
}, (api)=>{
    const { quickInsertState: quickInsertState, connectivityState: connectivityState } = (0, $awTmI.useSharedPluginState)(api, [
        'quickInsert',
        'connectivity'
    ]);
    return {
        lazyDefaultItems: quickInsertState?.lazyDefaultItems,
        providedItems: quickInsertState?.providedItems,
        isElementBrowserModalOpen: quickInsertState?.isElementBrowserModalOpen,
        emptyStateHandler: quickInsertState?.emptyStateHandler,
        mode: connectivityState?.mode
    };
});
var $4b32c4cfd315bc8f$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems, isElementBrowserModalOpen: isElementBrowserModalOpen, emptyStateHandler: emptyStateHandler, mode: mode } = $4b32c4cfd315bc8f$var$useSharedState(pluginInjectionAPI);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4b32c4cfd315bc8f$var$Modal, {
        quickInsertState: {
            lazyDefaultItems: lazyDefaultItems,
            providedItems: providedItems,
            isElementBrowserModalOpen: isElementBrowserModalOpen,
            emptyStateHandler: emptyStateHandler
        },
        editorView: editorView,
        helpUrl: helpUrl,
        isOffline: mode === 'offline',
        insertItem: pluginInjectionAPI?.quickInsert?.actions?.insertItem,
        getSuggestions: pluginInjectionAPI?.quickInsert?.actions?.getSuggestions,
        api: pluginInjectionAPI
    });
};

});
parcelRegister("50ybW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26bec8b6134a3e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $fVnbM = parcelRequire("fVnbM");

var $hd31W = parcelRequire("hd31W");

var $cgm0V = parcelRequire("cgm0V");

var $dg0Fl = parcelRequire("dg0Fl");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");
var $kdO7l = parcelRequire("kdO7l");


var $iKY7u = parcelRequire("iKY7u");
const $d26bec8b6134a3e2$export$77ff514ac660f8f8 = 16;
const $d26bec8b6134a3e2$var$actionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $d26bec8b6134a3e2$var$actionItemStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $d26bec8b6134a3e2$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
const $d26bec8b6134a3e2$var$modalFooterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $d26bec8b6134a3e2$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $5uXOq.useState)();
    const { helpUrl: helpUrl, intl: intl, onClose: onClose, onInsertItem: onInsertItemFn } = props;
    const onSelectItem = (0, $5uXOq.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $5uXOq.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)($d26bec8b6134a3e2$var$Footer, {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $d26bec8b6134a3e2$var$HelpLink(helpUrl, intl.formatMessage((0, $cgm0V.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    // Since Modal uses stackIndex it's shouldCloseOnEscapePress prop doesn't work.
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const RenderBody = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $d26bec8b6134a3e2$var$wrapperStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hd31W.default), {
            categories: (0, $iKY7u.getCategories)(props.intl),
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler
        })), [
        props.intl,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-editor-popup": true,
        onClick: $d26bec8b6134a3e2$var$onModalClick,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $i8Qvm.default), null, props.isOpen && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1R1Ge.default), {
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        autoFocus: false,
        shouldReturnFocus: props.shouldReturnFocus,
        // defaults to true and doesn't work along with stackIndex=1.
        // packages/design-system/modal-dialog/src/components/Content.tsx Line 287
        shouldCloseOnEscapePress: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(RenderBody, null), /*#__PURE__*/ (0, $f8Sb3.jsx)(RenderFooter, null)))));
};
$d26bec8b6134a3e2$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
// Prevent ModalElementBrowser click propagation through to the editor.
const $d26bec8b6134a3e2$var$onModalClick = (e)=>e.stopPropagation();
const $d26bec8b6134a3e2$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const { onClose: onClose } = (0, $kdO7l.useModal)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d26bec8b6134a3e2$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d26bec8b6134a3e2$var$actionsStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d26bec8b6134a3e2$var$actionItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, "Insert")), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d26bec8b6134a3e2$var$actionItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, "Close"))));
};
const $d26bec8b6134a3e2$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            label: ""
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
var $d26bec8b6134a3e2$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d26bec8b6134a3e2$var$ModalElementBrowser);

});
parcelRegister("cgm0V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2d44bd30c2203588$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2d44bd30c2203588$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    help: {
        id: 'fabric.editor.elementBrowser.help',
        defaultMessage: 'Help',
        description: 'Element browser help button label'
    },
    all: {
        id: 'fabric.editor.elementbrowser.categorylist.category-all',
        defaultMessage: 'All',
        description: 'all'
    },
    formatting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-formatting',
        defaultMessage: 'Formatting',
        description: 'formatting'
    },
    'confluence-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-confluence-content',
        defaultMessage: 'Confluence content',
        description: 'confluence-content'
    },
    media: {
        id: 'fabric.editor.elementbrowser.categorylist.category-media',
        defaultMessage: 'Media',
        description: 'media'
    },
    visuals: {
        id: 'fabric.editor.elementbrowser.categorylist.category-visuals',
        defaultMessage: 'Visuals & images',
        description: 'visuals'
    },
    navigation: {
        id: 'fabric.editor.elementbrowser.categorylist.category-navigation',
        defaultMessage: 'Navigation',
        description: 'navigation'
    },
    'external-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-external-content',
        defaultMessage: 'External content',
        description: 'external-content'
    },
    communication: {
        id: 'fabric.editor.elementbrowser.categorylist.category-communication',
        defaultMessage: 'Communication',
        description: 'communication'
    },
    reporting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-reporting',
        defaultMessage: 'Reporting',
        description: 'reporting'
    },
    admin: {
        id: 'fabric.editor.elementbrowser.categorylist.category-admin',
        defaultMessage: 'Administration',
        description: 'admin'
    },
    development: {
        id: 'fabric.editor.elementbrowser.categorylist.category-development',
        defaultMessage: 'Development',
        description: 'development'
    },
    AI: {
        id: 'fabric.editor.elementbrowser.categorylist.category-ai',
        defaultMessage: 'Atlassian Intelligence',
        description: 'AI'
    }
});

});

parcelRegister("iKY7u", function(module, exports) {

$parcel$export(module.exports, "getCategories", () => $d7ae64c3c5a3e998$export$7a0f33e8df10bd94);

var $cgm0V = parcelRequire("cgm0V");
function $d7ae64c3c5a3e998$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $cgm0V.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $cgm0V.messages).development),
            name: 'development'
        }
    ];
}

});



parcelRegister("3xc9s", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertSuggestions", () => $92d4bb0ca8761edf$export$f7a129a7d10810d3);

var $8C0Ak = parcelRequire("8C0Ak");

var $cz9kf = parcelRequire("cz9kf");

var $VSDnB = parcelRequire("VSDnB");
const $92d4bb0ca8761edf$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    // @ts-ignore
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, prioritySortingFn: prioritySortingFn } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const dedupeFn = (0, $VSDnB.fg)('platform_editor_quick_insert_dedupe_title_desc') ? (item)=>`${item.title}-${item.description ?? ''}` : (item)=>item.title;
    const items = providedItems ? (0, $cz9kf.dedupe)([
        ...defaultItems,
        ...providedItems
    ], dedupeFn) : defaultItems;
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $8C0Ak.find)(query || '', category === 'all' || !category ? items : items.filter((item)=>item.categories && item.categories.includes(category)), prioritySortingFn);
};

});



parcelRegister("644sF", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => (parcelRequire("4R0EL")).selectionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4R0EL = parcelRequire("4R0EL");

});
parcelRegister("4R0EL", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => $2012f1f68381ef84$export$35a6a08064a865b4);

var $58lL3 = parcelRequire("58lL3");

var $3pRoR = parcelRequire("3pRoR");

var $b3cQK = parcelRequire("b3cQK");

var $9Bpzl = parcelRequire("9Bpzl");

var $9fY37 = parcelRequire("9fY37");

var $M3A11 = parcelRequire("M3A11");

var $2mXvz = parcelRequire("2mXvz");

var $gZRC6 = parcelRequire("gZRC6");

var $lvvLW = parcelRequire("lvvLW");
const $2012f1f68381ef84$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $9fY37.gapCursorPluginKey), {
            displayGapCursor: toggle
        });
    };
const $2012f1f68381ef84$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $lvvLW.selectionPluginKey));
        return tr.setMeta((0, $lvvLW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $2012f1f68381ef84$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $lvvLW.selectionPluginKey));
        return tr.setMeta((0, $lvvLW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $2012f1f68381ef84$export$35a6a08064a865b4 = ({ api: api, config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $2012f1f68381ef84$var$displayGapCursor,
            clearManualSelection: $2012f1f68381ef84$var$clearManualSelection,
            setManualSelection: $2012f1f68381ef84$var$setManualSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $3pRoR.selectNearNode)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $lvvLW.selectionPluginKey).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $gZRC6.createPlugin)(api, dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $M3A11.default)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $b3cQK.default)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $9Bpzl.default)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $2mXvz.createMarkBoundaryCursorPlugin)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $58lL3.createAutoExpandSelectionRangeOnInlineNodePlugin)()
                }
            ];
        }
    });
var $2012f1f68381ef84$export$2e2bcd8739ae039 = $2012f1f68381ef84$export$35a6a08064a865b4;

});
parcelRegister("58lL3", function(module, exports) {

$parcel$export(module.exports, "createAutoExpandSelectionRangeOnInlineNodePlugin", () => $c8a43842f23d520f$export$b5faf98028194323);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $hzdhS = parcelRequire("hzdhS");
const $c8a43842f23d520f$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $hzdhS.autoExpandSelectionRangeOnInlineNodePluginKey),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                    // or mouse down doesn't trigger
                    if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                        mouseDownElement = null;
                        return;
                    }
                    // reset mouse down element after mouse up event
                    // so that we can detect the next mouse down event is triggered right after mouse up event or not
                    mouseDownElement = null;
                    // terminate early if mouse up event is not fired on inline node
                    if (!$c8a43842f23d520f$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $gZGBX.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $c8a43842f23d520f$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};

});
parcelRegister("hzdhS", function(module, exports) {

$parcel$export(module.exports, "autoExpandSelectionRangeOnInlineNodePluginKey", () => $0fc886deea4a0a2d$export$e6805678cce429a4);

var $gZGBX = parcelRequire("gZGBX");
const $0fc886deea4a0a2d$export$e6805678cce429a4 = new (0, $gZGBX.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');

});


parcelRegister("3pRoR", function(module, exports) {

$parcel$export(module.exports, "selectNearNode", () => $6cfbef85f365de0a$export$c7d22caae2fd3756);
$parcel$export(module.exports, "arrowRight", () => $6cfbef85f365de0a$export$680a8d7c28b0860);
$parcel$export(module.exports, "arrowLeft", () => $6cfbef85f365de0a$export$3ff8c533d254ed7c);
/* eslint-disable import/no-extraneous-dependencies */ 
var $hPjvp = parcelRequire("hPjvp");
var $3jyjs = parcelRequire("3jyjs");
var $6MkyM = parcelRequire("6MkyM");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");
var $77j9j = parcelRequire("77j9j");

var $gZGBX = parcelRequire("gZGBX");

var $lvvLW = parcelRequire("lvvLW");

var $2qSlm = parcelRequire("2qSlm");

var $8r1CJ = parcelRequire("8r1CJ");

var $igWuw = parcelRequire("igWuw");
const $6cfbef85f365de0a$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $lvvLW.selectionPluginKey), {
            type: (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $6cfbef85f365de0a$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $8r1CJ.createCommand)({
        type: (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $6cfbef85f365de0a$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $6cfbef85f365de0a$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $6cfbef85f365de0a$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.NodeSelection)) return $6cfbef85f365de0a$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.TextSelection)) return $6cfbef85f365de0a$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $6cfbef85f365de0a$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $6cfbef85f365de0a$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.NodeSelection)) return $6cfbef85f365de0a$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $gZGBX.TextSelection)) return $6cfbef85f365de0a$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $6cfbef85f365de0a$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $hPjvp.Side).LEFT) {
            const selectableNode = (0, $igWuw.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $hPjvp.Side).RIGHT && (0, $igWuw.isSelectionAtEndOfParentNode)($from, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (side === (0, $hPjvp.Side).RIGHT) {
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $hPjvp.Side).LEFT && (0, $igWuw.isSelectionAtStartOfParentNode)($from, selection)) {
            if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $igWuw.findSelectableContainerBefore)($parent, state.doc);
                    if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $6cfbef85f365de0a$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
                if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $igWuw.isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, $3jyjs.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $6cfbef85f365de0a$var$findAndSetTextSelection((0, $6MkyM.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart((0, $6MkyM.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $3jyjs.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End)) {
            const selectableNode = (0, $igWuw.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $igWuw.isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, $3jyjs.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $6cfbef85f365de0a$var$findAndSetTextSelection((0, $6MkyM.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $6cfbef85f365de0a$export$7c9ae5d21795cde4((0, $6MkyM.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart((0, $6MkyM.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $3jyjs.isIgnored)(node) && selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $igWuw.isSelectionAtEndOfParentNode)(selection.$to, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $8r1CJ.getPluginState)(state);
        if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) {
            const selectableNode = (0, $igWuw.findSelectableContainerBefore)(selection.$from, state.doc);
            if (selectableNode && (0, $3jyjs.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).End, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $6cfbef85f365de0a$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $igWuw.isSelectionAtStartOfParentNode)(selection.$from, selection)) {
            const selectableNode = (0, $igWuw.findSelectableContainerParent)(selection);
            if (selectableNode) return $6cfbef85f365de0a$export$56a7f03ce3f93e52((0, $6MkyM.RelativeSelectionPos).Start, (0, $gZGBX.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $gZGBX.Selection).findFrom($pos, dir, true);
        if (sel) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $6cfbef85f365de0a$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $77j9j.isNodeEmpty)(node)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
        const selectableNode = (0, $igWuw.findFirstChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $3jyjs.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            else if ((0, $594Yf.isEmptyParagraph)(childNode)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
            else if (!(0, $3jyjs.isIgnored)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $hPjvp.Side).LEFT))(state, dispatch);
            else if ((0, $igWuw.isSelectableContainerNode)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $gZGBX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $6cfbef85f365de0a$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $77j9j.isNodeEmpty)(node)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $lvvLW.SelectionDirection).Before)(state, dispatch);
        const selectableNode = (0, $igWuw.findLastChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $3jyjs.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            else if ((0, $594Yf.isEmptyParagraph)(childNode)) return $6cfbef85f365de0a$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $lvvLW.SelectionDirection).After)(state, dispatch);
            else if (!(0, $3jyjs.isIgnored)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $hPjvp.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $hPjvp.Side).RIGHT))(state, dispatch);
            else if ((0, $igWuw.isSelectableContainerNode)(node)) return $6cfbef85f365de0a$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $gZGBX.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };

});
parcelRegister("lvvLW", function(module, exports) {

$parcel$export(module.exports, "selectionPluginKey", () => $53ae5ee309f6f53a$export$e530ba00b008a680);
$parcel$export(module.exports, "SelectionDirection", () => $53ae5ee309f6f53a$export$5c80dd1df5708938);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json


var $gZGBX = parcelRequire("gZGBX");
const $53ae5ee309f6f53a$export$e530ba00b008a680 = new (0, $gZGBX.PluginKey)('selection');
var $53ae5ee309f6f53a$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});

});

parcelRegister("2qSlm", function(module, exports) {

$parcel$export(module.exports, "SelectionActionTypes", () => $8aff6390c25c493c$export$ab4e2275d2998c63);
var $8aff6390c25c493c$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});

});

parcelRegister("8r1CJ", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $6203900090a6a225$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $6203900090a6a225$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $6203900090a6a225$export$656c7661095efe2e);

var $aOimD = parcelRequire("aOimD");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $lvvLW = parcelRequire("lvvLW");

var $b8hnO = parcelRequire("b8hnO");

var $igWuw = parcelRequire("igWuw");
const $6203900090a6a225$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $igWuw.getDecorations)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $etG8M.DecorationSet).empty
        };
    }
};
const $6203900090a6a225$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $gZGBX.NodeSelection) && (0, $igWuw.isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, $hFEwm.CellSelection)) && !tr.getMeta((0, $lvvLW.selectionPluginKey))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const { createCommand: $6203900090a6a225$export$8d4021544bdece00, getPluginState: $6203900090a6a225$export$f05434c51e3762e, createPluginState: $6203900090a6a225$export$656c7661095efe2e } = (0, $aOimD.pluginFactory)((0, $lvvLW.selectionPluginKey), (0, $b8hnO.reducer), {
    onDocChanged: $6203900090a6a225$var$handleDocChanged,
    onSelectionChanged: $6203900090a6a225$var$handleSelectionChanged
});

});
parcelRegister("b8hnO", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $3f5779eb4402a550$export$1650419e431d3ba3);

var $2qSlm = parcelRequire("2qSlm");
function $3f5779eb4402a550$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $2qSlm.SelectionActionTypes).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $2qSlm.SelectionActionTypes).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("igWuw", function(module, exports) {

$parcel$export(module.exports, "getDecorations", () => $ef3f0c960be97cae$export$968abecb43309c32);
$parcel$export(module.exports, "shouldRecalcDecorations", () => $ef3f0c960be97cae$export$8f1ae47b39045ce2);
$parcel$export(module.exports, "isSelectableContainerNode", () => $ef3f0c960be97cae$export$be9646888fa9d884);
$parcel$export(module.exports, "findSelectableContainerParent", () => $ef3f0c960be97cae$export$15e7624ccd1acbba);
$parcel$export(module.exports, "findSelectableContainerBefore", () => $ef3f0c960be97cae$export$5a13616ef7dc6dd);
$parcel$export(module.exports, "findSelectableContainerAfter", () => $ef3f0c960be97cae$export$f64170c1c72ca928);
$parcel$export(module.exports, "findFirstChildNodeToSelect", () => $ef3f0c960be97cae$export$12f3aca2cb5b5ae9);
$parcel$export(module.exports, "findLastChildNodeToSelect", () => $ef3f0c960be97cae$export$b5a7c30cdb2d437f);
$parcel$export(module.exports, "isSelectionAtStartOfParentNode", () => $ef3f0c960be97cae$export$f80a5aec143de6c6);
$parcel$export(module.exports, "isSelectionAtEndOfParentNode", () => $ef3f0c960be97cae$export$1ab0c837d3abb951);

var $3jyjs = parcelRequire("3jyjs");
var $k6Y9i = parcelRequire("k6Y9i");
parcelRequire("77j9j");
var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $iHYdz = parcelRequire("iHYdz");

var $lvvLW = parcelRequire("lvvLW");
const $ef3f0c960be97cae$export$968abecb43309c32 = (tr, manualSelection)=>{
    let selection = tr.selection;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return (0, $etG8M.DecorationSet).create(tr.doc, [
        (0, $etG8M.Decoration).node(selection.from, selection.to, {
            class: (0, $iHYdz.akEditorSelectedNodeClassName)
        })
    ]);
    if (selection instanceof (0, $gZGBX.TextSelection) || selection instanceof (0, $gZGBX.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $gZGBX.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        const decorations = $ef3f0c960be97cae$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
            return (0, $etG8M.Decoration).node(pos, pos + node.nodeSize, {
                class: (0, $iHYdz.akEditorSelectedNodeClassName)
            });
        });
        return (0, $etG8M.DecorationSet).create(tr.doc, decorations);
    }
    return (0, $etG8M.DecorationSet).empty;
};
const $ef3f0c960be97cae$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $ef3f0c960be97cae$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const isTopLevelNodeThatHasSelectionStyles = $ef3f0c960be97cae$var$topLevelBlockNodesThatHaveSelectionStyles.includes(node.type.name);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $ef3f0c960be97cae$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $lvvLW.selectionPluginKey).getState(oldEditorState);
    const newPluginState = (0, $lvvLW.selectionPluginKey).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $gZGBX.NodeSelection) && newSelection instanceof (0, $gZGBX.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $gZGBX.TextSelection) && newSelection instanceof (0, $gZGBX.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $ef3f0c960be97cae$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $gZGBX.NodeSelection).isSelectable(node));
const $ef3f0c960be97cae$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $594Yf.isEmptyParagraph)(node) || (0, $gZGBX.NodeSelection).isSelectable(node)));
const $ef3f0c960be97cae$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $5r0mK.findParentNode)((node)=>{
        const isSelectable = $ef3f0c960be97cae$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $3jyjs.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $ef3f0c960be97cae$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $ef3f0c960be97cae$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $gZGBX.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($ef3f0c960be97cae$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $3jyjs.isIgnored)(node)) return;
        }
        /**
		 * Stick to the default left selection behaviour,
		 * useful for mediaSingleWithCaption
		 */ if (selectionBefore instanceof (0, $gZGBX.NodeSelection) && (0, $gZGBX.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $ef3f0c960be97cae$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $gZGBX.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($ef3f0c960be97cae$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $3jyjs.isIgnored)(node)) return;
        }
    }
};
const $ef3f0c960be97cae$export$12f3aca2cb5b5ae9 = (parent)=>(0, $5r0mK.flatten)(parent).find((child)=>$ef3f0c960be97cae$export$e6eb31f83412b327(child.node) || !(0, $3jyjs.isIgnored)(child.node));
const $ef3f0c960be97cae$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($ef3f0c960be97cae$export$e6eb31f83412b327(node) || !(0, $3jyjs.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $ef3f0c960be97cae$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $k6Y9i.isSelectionAtStartOfNode)($pos, $ef3f0c960be97cae$export$15e7624ccd1acbba(selection)?.node);
const $ef3f0c960be97cae$export$1ab0c837d3abb951 = ($pos, selection)=>{
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    if ($pos.depth === 0 || (0, $gZGBX.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};

});



parcelRegister("b3cQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3c042b0e4d7383$export$2e2bcd8739ae039);

var $e9qoo = parcelRequire("e9qoo");

var $hPjvp = parcelRequire("hPjvp");

var $2RHbH = parcelRequire("2RHbH");

var $vWFRY = parcelRequire("vWFRY");

var $ltL9w = parcelRequire("ltL9w");

var $7XWv7 = parcelRequire("7XWv7");
function $1c3c042b0e4d7383$export$2e2bcd8739ae039() {
    const map = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $hPjvp.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $2RHbH.createParagraphNear)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $ltL9w.arrow)((0, $7XWv7.Direction).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.backspace).common, (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.deleteKey).common, (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).FORWARD), map);
    return (0, $vWFRY.keymap)(map);
}

});
parcelRegister("ltL9w", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $060fb358ebbf8cd3$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "deleteNode", () => $060fb358ebbf8cd3$export$b05da9e94a08038f);

var $k6Y9i = parcelRequire("k6Y9i");
var $hPjvp = parcelRequire("hPjvp");
var $2xQXF = parcelRequire("2xQXF");

var $20Kbb = parcelRequire("20Kbb");
var $5or39 = parcelRequire("5or39");


var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $9fY37 = parcelRequire("9fY37");

var $7XWv7 = parcelRequire("7XWv7");

var $9z6CR = parcelRequire("9z6CR");
const $060fb358ebbf8cd3$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $7XWv7.Direction).UP:
            if ((0, $k6Y9i.atTheBeginningOfDoc)(state)) return false;
            return (0, $5or39.isPositionNearTableRow)($pos, schema, 'before') || (0, $9z6CR.isTextBlockNearPos)(doc, schema, $pos, -1) || (0, $20Kbb.isNodeBeforeMediaNode)($pos, state);
        case (0, $7XWv7.Direction).DOWN:
            return(// end of a paragraph
            (0, $k6Y9i.atTheEndOfDoc)(state) || (0, $9z6CR.isTextBlockNearPos)(doc, schema, $pos, 1) || (0, $5or39.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $060fb358ebbf8cd3$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $hPjvp.GapCursorSelection) && dir === (0, $7XWv7.Direction).UP && selection.$from.nodeBefore && (0, $20Kbb.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $hPjvp.GapCursorSelection) && dir === (0, $7XWv7.Direction).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $060fb358ebbf8cd3$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $7XWv7.isBackward)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $7XWv7.Direction).UP && selection.$from.nodeBefore && (0, $20Kbb.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $5r0mK.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $hPjvp.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $7XWv7.Direction).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $hPjvp.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $hPjvp.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $060fb358ebbf8cd3$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $7XWv7.isBackward)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $gZGBX.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($060fb358ebbf8cd3$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $7XWv7.isBackward)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $gZGBX.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $7XWv7.Direction).UP && !(0, $k6Y9i.atTheBeginningOfDoc)(state) && !(0, $20Kbb.isNodeBeforeMediaNode)($pos, state) || dir === (0, $7XWv7.Direction).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($060fb358ebbf8cd3$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $060fb358ebbf8cd3$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $hPjvp.GapCursorSelection) && // next node allow gap cursor position
        (0, $2xQXF.isValidTargetNode)((0, $7XWv7.isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $7XWv7.isBackward)(dir) && selection.side === (0, $hPjvp.Side).LEFT || (0, $7XWv7.isForward)(dir) && selection.side === (0, $hPjvp.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, selection.side === (0, $hPjvp.Side).RIGHT ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $5r0mK.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) return false;
        }
        const nextSelection = (0, $hPjvp.GapCursorSelection).findFrom($pos, (0, $7XWv7.isBackward)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $2xQXF.isValidTargetNode)((0, $7XWv7.isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $hPjvp.GapCursorSelection)(nextSelection.$from, (0, $7XWv7.isForward)(dir) ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $060fb358ebbf8cd3$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $hPjvp.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $7XWv7.isBackward)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $hPjvp.GapCursorSelection)($anchor, (0, $hPjvp.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $5r0mK.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $060fb358ebbf8cd3$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $hPjvp.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $hPjvp.Side).LEFT : (0, $hPjvp.Side).RIGHT;
            let position;
            if (side === (0, $hPjvp.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $060fb358ebbf8cd3$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $060fb358ebbf8cd3$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $hPjvp.Side).LEFT ? (0, $2xQXF.isValidTargetNode)($pos.nodeAfter) : (0, $2xQXF.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $hPjvp.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $hPjvp.GapCursorSelection)) tr.setSelection((0, $gZGBX.Selection).near($pos));
        else tr.setSelection(new (0, $hPjvp.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $gZGBX.Selection).findFrom($pos, cursorCoords.side === (0, $hPjvp.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $060fb358ebbf8cd3$export$ddeed8e54d88a7b0 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $060fb358ebbf8cd3$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $060fb358ebbf8cd3$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $9fY37.gapCursorPluginKey).get(state));
};

});
parcelRegister("9fY37", function(module, exports) {

$parcel$export(module.exports, "gapCursorPluginKey", () => $a24c46096a74b6ea$export$21af267ac39e2110);

var $gZGBX = parcelRequire("gZGBX");
const $a24c46096a74b6ea$export$21af267ac39e2110 = new (0, $gZGBX.PluginKey)('gapCursorPlugin');

});

parcelRegister("7XWv7", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $235b6e0569825149$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "isBackward", () => $235b6e0569825149$export$4d894a9a195acd59);
$parcel$export(module.exports, "isForward", () => $235b6e0569825149$export$9439bc4ba99faca1);
var $235b6e0569825149$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $235b6e0569825149$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $235b6e0569825149$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}

});

parcelRegister("9z6CR", function(module, exports) {

$parcel$export(module.exports, "isLeftCursor", () => $bf065ce7cc738c9f$export$2b745dec73894c8a);
$parcel$export(module.exports, "isTextBlockNearPos", () => $bf065ce7cc738c9f$export$84353379d6171bb9);
$parcel$export(module.exports, "getLayoutModeFromTargetNode", () => $bf065ce7cc738c9f$export$698eab35981fecbc);
$parcel$export(module.exports, "isIgnoredClick", () => $bf065ce7cc738c9f$export$e5da7366668fb130);
$parcel$export(module.exports, "getComputedStyleForLayoutMode", () => $bf065ce7cc738c9f$export$b5b7287d8577df27);

var $intz5 = parcelRequire("intz5");

var $hPjvp = parcelRequire("hPjvp");

var $6gEe5 = parcelRequire("6gEe5");
var $ahG4O = parcelRequire("ahG4O");

var $gmhCD = parcelRequire("gmhCD");
const $bf065ce7cc738c9f$export$2b745dec73894c8a = (side)=>side === (0, $hPjvp.Side).LEFT;
function $bf065ce7cc738c9f$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $bf065ce7cc738c9f$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $bf065ce7cc738c9f$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $bf065ce7cc738c9f$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $intz5.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $ahG4O.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $bf065ce7cc738c9f$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $gmhCD.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};

});



parcelRegister("9Bpzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b07c7e10d06e629$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $hPjvp = parcelRequire("hPjvp");
var $eAVGd = parcelRequire("eAVGd");
var $5Vvw4 = parcelRequire("5Vvw4");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $9fY37 = parcelRequire("9fY37");

var $ltL9w = parcelRequire("ltL9w");

var $7XWv7 = parcelRequire("7XWv7");

var $9z6CR = parcelRequire("9z6CR");

var $kb0gW = parcelRequire("kb0gW");
const $9b07c7e10d06e629$var$plugin = new (0, $5KWxh.SafePlugin)({
    key: (0, $9fY37.gapCursorPluginKey),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $9fY37.gapCursorPluginKey));
            const selectionIsGapCursor = newState.selection instanceof (0, $hPjvp.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true
            };
        }
    },
    view: (view)=>{
        /**
		 * If the selection is at the beginning of a document and is a NodeSelection,
		 * convert to a GapCursor selection. This is to stop users accidentally replacing
		 * the first node of a document by accident.
		 */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $gZGBX.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $hPjvp.GapCursorSelection)(view.state.doc.resolve(0), (0, $hPjvp.Side).LEFT)));
        });
        return {
            update (view) {
                const { selectionIsGapCursor: selectionIsGapCursor } = (0, $9fY37.gapCursorPluginKey).getState(view.state);
                /**
				 * Starting with prosemirror-view 1.19.4, cursor wrapper that previously was hiding cursor doesn't exist:
				 * https://github.com/ProseMirror/prosemirror-view/commit/4a56bc7b7e61e96ef879d1dae1014ede0fc09e43
				 *
				 * Because it was causing issues with RTL: https://github.com/ProseMirror/prosemirror/issues/948
				 *
				 * This is the work around which uses `caret-color: transparent` in order to hide regular caret,
				 * when gap cursor is visible.
				 *
				 * Browser support is pretty good: https://caniuse.com/#feat=css-caret-color
				 */ view.dom.classList.toggle((0, $eAVGd.hideCaretModifier), selectionIsGapCursor);
            }
        };
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor } = (0, $9fY37.gapCursorPluginKey).getState(editorState);
            if (selection instanceof (0, $hPjvp.GapCursorSelection) && displayGapCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $hPjvp.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $5r0mK.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $9z6CR.getLayoutModeFromTargetNode)(node);
                return (0, $etG8M.DecorationSet).create(doc, [
                    (0, $etG8M.Decoration).widget(position, (0, $kb0gW.toDOM), {
                        key: `${(0, $hPjvp.JSON_ID)}-${side}-${layoutMode}`,
                        side: layoutMode ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $hFEwm.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $hPjvp.GapCursorSelection).valid($head)) return new (0, $hPjvp.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $9z6CR.isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $hPjvp.Side).RIGHT : (0, $hPjvp.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $5Vvw4.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $5Vvw4.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
			 * Android composition events aren't handled well by Prosemirror
			 * We've added a couple of beforeinput hooks to help PM out when trying to delete
			 * certain nodes. We can remove these when PM has better composition support.
			 * @see https://github.com/ProseMirror/prosemirror/issues/543
			 */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $hPjvp.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $ltL9w.deleteNode)((0, $7XWv7.Direction).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $9b07c7e10d06e629$export$2e2bcd8739ae039 = $9b07c7e10d06e629$var$plugin;

});
parcelRegister("kb0gW", function(module, exports) {

$parcel$export(module.exports, "toDOM", () => $529499ca6d3660be$export$289411c5a7970646);

var $hPjvp = parcelRequire("hPjvp");

var $VSDnB = parcelRequire("VSDnB");

var $9z6CR = parcelRequire("9z6CR");
/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $529499ca6d3660be$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $529499ca6d3660be$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($529499ca6d3660be$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $529499ca6d3660be$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $529499ca6d3660be$var$measureHeight = (style)=>{
    return $529499ca6d3660be$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $529499ca6d3660be$var$measureWidth = (style)=>{
    return $529499ca6d3660be$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $529499ca6d3660be$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $529499ca6d3660be$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $9z6CR.isLeftCursor)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
const $529499ca6d3660be$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $hPjvp.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const nodeStart = getPos();
    // @ts-ignore - [unblock prosemirror bump] nodeStart can be undefined
    const dom = view.nodeDOM(nodeStart);
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (dom instanceof HTMLElement && element.firstChild) {
        const style = $529499ca6d3660be$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
        const gapCursor = element.firstChild;
        gapCursor.style.height = `${$529499ca6d3660be$var$measureHeight(style)}px`;
        const layoutMode = node && (0, $9z6CR.getLayoutModeFromTargetNode)(node);
        if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
        // Tables nested inside other elements such as layouts, expands and other tables do not have fixed width
        const isNestedTable = (0, $VSDnB.fg)('platform_editor_nested_tables_gap_cursor') ? node?.type.name === 'table' && selection.$to.depth > 0 : false;
        if (layoutMode && !isNestedTable) {
            gapCursor.setAttribute('layout', layoutMode);
            const breakoutModeStyle = (0, $9z6CR.getComputedStyleForLayoutMode)(dom, node, style);
            gapCursor.style.width = `${$529499ca6d3660be$var$measureWidth(breakoutModeStyle)}px`;
        } else $529499ca6d3660be$var$mutateElementStyle(gapCursor, style, selection.side);
    }
    return element;
};

});


parcelRegister("M3A11", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f270e126345bfd$export$2e2bcd8739ae039);

var $e9qoo = parcelRequire("e9qoo");

var $vWFRY = parcelRequire("vWFRY");

var $3pRoR = parcelRequire("3pRoR");
function $b4f270e126345bfd$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveRight).common, (0, $3pRoR.arrowRight), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveLeft).common, (0, $3pRoR.arrowLeft), list);
    return (0, $vWFRY.keymap)(list);
}
var $b4f270e126345bfd$export$2e2bcd8739ae039 = $b4f270e126345bfd$var$keymapPlugin;

});

parcelRegister("2mXvz", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorPlugin", () => $d5a435a6cf57495c$export$d3a8cfe12ba42d22);

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $aqqth = parcelRequire("aqqth");

var $cXbKW = parcelRequire("cXbKW");

var $4YNMu = parcelRequire("4YNMu");
const $d5a435a6cf57495c$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $aqqth.markBoundaryCursorPluginKey),
        state: {
            init: ()=>({
                    decorations: (0, $etG8M.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $4YNMu.getActiveMarksSide)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $etG8M.DecorationSet).empty
                };
                return {
                    decorations: (0, $etG8M.DecorationSet).create(doc, [
                        (0, $cXbKW.createMarkBoundaryCursorDecoration)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $aqqth.markBoundaryCursorPluginKey).getState(state)?.decorations;
            }
        }
    });
};

});
parcelRegister("aqqth", function(module, exports) {

$parcel$export(module.exports, "markBoundaryCursorPluginKey", () => $ad9527801014bc00$export$220fecd6a5c51ffb);

var $gZGBX = parcelRequire("gZGBX");
const $ad9527801014bc00$export$220fecd6a5c51ffb = new (0, $gZGBX.PluginKey)('markBoundaryCursorPlugin');

});

parcelRegister("cXbKW", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorDecoration", () => $82ddb9c86885e1fb$export$499e8e2917534a4d);

var $etG8M = parcelRequire("etG8M");
const $82ddb9c86885e1fb$var$containerStyle = `
	position: relative;
`;
const $82ddb9c86885e1fb$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #172B4D)"};
`;
const $82ddb9c86885e1fb$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $82ddb9c86885e1fb$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $82ddb9c86885e1fb$var$caretStyle);
    caret.animate?.([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $82ddb9c86885e1fb$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $etG8M.Decoration).widget(pos, $82ddb9c86885e1fb$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};

});

parcelRegister("4YNMu", function(module, exports) {

$parcel$export(module.exports, "getActiveMarksSide", () => $c802ebf86e549a45$export$8f6a177d567e1134);

var $594Yf = parcelRequire("594Yf");

var $kCV8T = parcelRequire("kCV8T");

var $7WjpF = parcelRequire("7WjpF");

var $7EuDu = parcelRequire("7EuDu");
function $c802ebf86e549a45$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $594Yf.isTextSelection)(selection) || !selection.empty) return (0, $7WjpF.MarksSide).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $kCV8T.Mark).sameSet(leftMarks, rightMarks)) return (0, $7WjpF.MarksSide).None;
    return (0, $7EuDu.getInlineCodeCursorSide)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}

});
parcelRegister("7WjpF", function(module, exports) {

$parcel$export(module.exports, "MarksSide", () => $f16196199ce0e6d7$export$6705e1762430d43f);
var $f16196199ce0e6d7$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});

});

parcelRegister("7EuDu", function(module, exports) {

$parcel$export(module.exports, "getInlineCodeCursorSide", () => $b24a8fd0105c6c7f$export$325621c34246ee7d);

var $7WjpF = parcelRequire("7WjpF");
function $b24a8fd0105c6c7f$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $7WjpF.MarksSide).Right;
    return (0, $7WjpF.MarksSide).None;
}

});



parcelRegister("gZRC6", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0ac64cffabc4b968$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $lvvLW = parcelRequire("lvvLW");

var $2qSlm = parcelRequire("2qSlm");

var $kqfPI = parcelRequire("kqfPI");

var $3z3LP = parcelRequire("3z3LP");

var $DmeyI = parcelRequire("DmeyI");

var $8r1CJ = parcelRequire("8r1CJ");

var $igWuw = parcelRequire("igWuw");
const $0ac64cffabc4b968$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $igWuw.getDecorations)(state.tr),
        selection: state.selection
    });
const $0ac64cffabc4b968$export$ae829ec7b2625219 = (api, dispatch, dispatchAnalyticsEvent, options = {})=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $lvvLW.selectionPluginKey),
        state: (0, $8r1CJ.createPluginState)(dispatch, $0ac64cffabc4b968$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            if ((0, $gmhCD.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) // Start at most recent transaction, look for manualSelection meta
            for(let i = transactions.length - 1; i >= 0; i--){
                manualSelection = transactions[i].getMeta((0, $lvvLW.selectionPluginKey))?.manualSelection;
                if (manualSelection) break;
            }
            if (!(0, $igWuw.shouldRecalcDecorations)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection) return;
            tr.setMeta((0, $lvvLW.selectionPluginKey), {
                type: (0, $2qSlm.SelectionActionTypes).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $igWuw.getDecorations)(tr, manualSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $gZGBX.NodeSelection) && !tr.getMeta((0, $lvvLW.selectionPluginKey))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $gZGBX.NodeSelection) && tr.selection instanceof (0, $gZGBX.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $kqfPI.onCreateSelectionBetween),
            decorations (state) {
                const hasHadInteraction = api?.interaction?.sharedState.currentState()?.hasHadInteraction !== false;
                const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
                // Do not show selection decorations for live pages where the user has not
                // interacted with the page. We do not show cursor until interaction and we do not
                // want to show selections either.
                if (options.__livePage && ((0, $VSDnB.fg)('platform_editor_interaction_api_refactor') ? interactionState === 'hasNotHadInteraction' : !hasHadInteraction) && (0, $VSDnB.fg)('platform_editor_no_cursor_on_live_doc_init')) return (0, $etG8M.DecorationSet).empty;
                return (0, $8r1CJ.getPluginState)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $3z3LP.createOnKeydown)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $DmeyI.onMouseOut)
            }
        }
    });
};

});
parcelRegister("kqfPI", function(module, exports) {

$parcel$export(module.exports, "onCreateSelectionBetween", () => $1b9e3681e85a9d75$export$ba3a236bf89a370d);

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
const $1b9e3681e85a9d75$var$DOC_START_POS = 0;
function $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $1b9e3681e85a9d75$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) && (0, $gZGBX.NodeSelection).isSelectable(maybeNode);
};
function $1b9e3681e85a9d75$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    if ((0, $VSDnB.fg)('platform_editor_fix_drag_and_drop_lists')) {
        // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
        // and $head which are based on a transformed document, but only provides the original
        // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
        if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
        else if ($targetHead.pos !== $1b9e3681e85a9d75$var$DOC_START_POS) {
            const justBeforeHeadPos = $targetHead.pos - 1;
            const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
            maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
        }
    } else if ($targetHead.pos !== $1b9e3681e85a9d75$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $1b9e3681e85a9d75$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$1b9e3681e85a9d75$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $1b9e3681e85a9d75$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $gZGBX.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};

});

parcelRegister("3z3LP", function(module, exports) {

$parcel$export(module.exports, "createOnKeydown", () => $e5c6bd60f2ded2f2$export$1bff6ff05fed49a5);

var $2Hal9 = parcelRequire("2Hal9");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");
/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $e5c6bd60f2ded2f2$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $VSDnB.fg)('platform-editor-single-player-expand')) currentExpandedState = node ? !(0, $2Hal9.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $e5c6bd60f2ded2f2$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $e5c6bd60f2ded2f2$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $e5c6bd60f2ded2f2$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $e5c6bd60f2ded2f2$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $e5c6bd60f2ded2f2$var$isBodiedExtension(node) || $e5c6bd60f2ded2f2$var$isTable(node);
};
const $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $gZGBX.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    return isNavigatingInlineNodeDownward;
};
function $e5c6bd60f2ded2f2$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $gZGBX.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $gZGBX.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}

});
parcelRegister("2Hal9", function(module, exports) {

$parcel$export(module.exports, "expandedState", () => $f0f36d6481cf8dea$export$de2a5eca4f1cacc0);
$parcel$export(module.exports, "isExpandCollapsed", () => $f0f36d6481cf8dea$export$785b8bfd794fa7b6);
const $f0f36d6481cf8dea$export$de2a5eca4f1cacc0 = new WeakMap();
const $f0f36d6481cf8dea$export$785b8bfd794fa7b6 = (node)=>{
    return !$f0f36d6481cf8dea$export$de2a5eca4f1cacc0.get(node) ?? false;
};

});


parcelRegister("DmeyI", function(module, exports) {

$parcel$export(module.exports, "onMouseOut", () => $53286a2ef9e4b5c6$export$65a11040da641544);

var $gZGBX = parcelRequire("gZGBX");
function $53286a2ef9e4b5c6$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $53286a2ef9e4b5c6$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $gZGBX.TextSelection) && $53286a2ef9e4b5c6$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $gZGBX.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}

});




parcelRegister("l4YXu", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => (parcelRequire("9lnYw")).submitEditorPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9lnYw = parcelRequire("9lnYw");

});
parcelRegister("9lnYw", function(module, exports) {

$parcel$export(module.exports, "submitEditorPlugin", () => $2ef620ccaac37f13$export$e488d499f3ae3f86);

var $93rwX = parcelRequire("93rwX");
const $2ef620ccaac37f13$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $93rwX.createPlugin)(dispatch, api, onSave)
                }
            ];
        }
    });

});
parcelRegister("93rwX", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $4ceee44977c17a24$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $4NUlu = parcelRequire("4NUlu");

var $vWFRY = parcelRequire("vWFRY");
function $4ceee44977c17a24$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $vWFRY.keymap)({
        [`${(0, $e9qoo.submit).common}`]: (state, _dispatch, editorView)=>{
            const mediaState = api?.media?.sharedState?.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $4NUlu.analyticsEventKey), $4ceee44977c17a24$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $4ceee44977c17a24$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $gkwXh.ACTION).STOPPED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $gkwXh.EVENT_TYPE).UI
        }
    });

});



parcelRegister("h0erq", function(module, exports) {

$parcel$export(module.exports, "tablesPlugin", () => (parcelRequire("6cRwj")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6cRwj = parcelRequire("6cRwj");

});
parcelRegister("6cRwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc17bdad5d858d8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9UDEr = parcelRequire("9UDEr");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $gE8f9 = parcelRequire("gE8f9");

var $9pOon = parcelRequire("9pOon");

var $gries = parcelRequire("gries");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9mDTH = parcelRequire("9mDTH");

var $e9qoo = parcelRequire("e9qoo");

var $2i4K4 = parcelRequire("2i4K4");

var $9O539 = parcelRequire("9O539");

var $31nwk = parcelRequire("31nwk");

var $8xI1l = parcelRequire("8xI1l");

var $5KWxh = parcelRequire("5KWxh");

var $9LY0t = parcelRequire("9LY0t");

var $j79rm = parcelRequire("j79rm");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $brhD2 = parcelRequire("brhD2");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gWWzt = parcelRequire("gWWzt");

var $6rgjS = parcelRequire("6rgjS");

var $deOBG = parcelRequire("deOBG");

var $4aKeM = parcelRequire("4aKeM");

var $3ojHW = parcelRequire("3ojHW");

var $5PQ8U = parcelRequire("5PQ8U");

var $1wp1Y = parcelRequire("1wp1Y");

var $84dDf = parcelRequire("84dDf");

var $dzNQ0 = parcelRequire("dzNQ0");

var $8JbS8 = parcelRequire("8JbS8");

var $cPPiz = parcelRequire("cPPiz");

var $cun24 = parcelRequire("cun24");

var $9DiKx = parcelRequire("9DiKx");

var $fCcOI = parcelRequire("fCcOI");

var $eRc84 = parcelRequire("eRc84");

var $aajRL = parcelRequire("aajRL");

var $cLyxG = parcelRequire("cLyxG");

var $cjBCM = parcelRequire("cjBCM");

var $gEcXI = parcelRequire("gEcXI");

var $k8KvZ = parcelRequire("k8KvZ");

var $iKKaG = parcelRequire("iKKaG");

var $59C9o = parcelRequire("59C9o");

var $7rFMc = parcelRequire("7rFMc");

var $1tZxL = parcelRequire("1tZxL");

var $aJOib = parcelRequire("aJOib");

var $eRNgV = parcelRequire("eRNgV");

var $1NFM5 = parcelRequire("1NFM5");

var $7j6gm = parcelRequire("7j6gm");

var $lx3Ew = parcelRequire("lx3Ew");

var $4oGFf = parcelRequire("4oGFf");

var $fPXwH = parcelRequire("fPXwH");

var $cvR2q = parcelRequire("cvR2q");

var $guFYO = parcelRequire("guFYO");

var $epMWO = parcelRequire("epMWO");

var $bWCYR = parcelRequire("bWCYR");

var $eZAi0 = parcelRequire("eZAi0");

var $knLk2 = parcelRequire("knLk2");
const $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags = ()=>({});
const $ecc17bdad5d858d8$var$useTableSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
    return {
        mode: mode
    };
}, (api)=>{
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(api, [
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode
    };
});
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $ecc17bdad5d858d8$var$tablePlugin = ({ config: options, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const defaultGetEditorContainerWidth = ()=>{
        return api?.width?.sharedState.currentState() ?? {
            width: document?.body?.offsetWidth ?? 500
        };
    };
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const isTableFixedColumnWidthsOptionEnabled = options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption || false;
    const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
    options?.isCommentEditor);
    const isTableSelectorEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    !options?.isChromelessEditor && !options?.isCommentEditor && options?.getEditorFeatureFlags?.().tableSelector && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_table_picker');
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const tablePluginState = (0, $cPPiz.pluginKey).getState(editorState);
            const tableResizingPluginState = (0, $gEcXI.getPluginState)(editorState);
            const tableWidthResizingPluginState = (0, $7rFMc.pluginKey).getState(editorState);
            const stickyHeadersState = (0, $fCcOI.pluginKey).getState(editorState);
            const stickyHeader = stickyHeadersState ? (0, $eRc84.findStickyHeaderForTable)(stickyHeadersState, tablePluginState?.tablePos) : undefined;
            const dragAndDropState = (0, $84dDf.pluginKey).getState(editorState);
            const sizeSelectorPluginState = (0, $59C9o.pluginKey).getState(editorState);
            const sharedStateInternal = {
                isFullWidthModeEnabled: !!options?.fullWidthEnabled,
                wasFullWidthModeEnabled: !!options?.wasFullWidthEnabled,
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState?.dragging || tableWidthResizingPluginState?.resizing),
                isTableResizing: tableWidthResizingPluginState?.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredColumns: tablePluginState.hoveredColumns,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest,
                resizingTableLocalId: tableWidthResizingPluginState?.tableLocalId,
                tableRef: tablePluginState?.tableRef ?? undefined,
                resizingTableRef: tableWidthResizingPluginState?.tableRef ?? undefined,
                tablePos: tablePluginState.tablePos,
                targetCellPosition: tablePluginState.targetCellPosition,
                isContextualMenuOpen: tablePluginState.isContextualMenuOpen,
                pluginConfig: tablePluginState.pluginConfig,
                insertColumnButtonIndex: tablePluginState.insertColumnButtonIndex,
                insertRowButtonIndex: tablePluginState.insertRowButtonIndex,
                isDragAndDropEnabled: tablePluginState.isDragAndDropEnabled,
                tableWrapperTarget: tablePluginState.tableWrapperTarget,
                isCellMenuOpenByKeyboard: tablePluginState.isCellMenuOpenByKeyboard,
                stickyHeader: stickyHeader,
                dragMenuDirection: dragAndDropState?.dragMenuDirection,
                dragMenuIndex: dragAndDropState?.dragMenuIndex,
                isDragMenuOpen: dragAndDropState?.isDragMenuOpen,
                isSizeSelectorOpen: sizeSelectorPluginState?.isSelectorOpen,
                sizeSelectorTargetRef: sizeSelectorPluginState?.targetRef
            };
            return sharedStateInternal;
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    if (options?.tableOptions?.allowNestedTables && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $31nwk.editorCommandToPMCommand)((0, $4aKeM.insertTableWithNestingSupport)({
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                        isFullWidthModeEnabled: options?.fullWidthEnabled,
                        isCommentEditor: options?.isCommentEditor,
                        isChromelessEditor: options?.isChromelessEditor,
                        isTableResizingEnabled: options?.tableOptions.allowTableResizing
                    }, api, analyticsPayload))(state, dispatch);
                    else {
                        const node = (0, $aJOib.createTableWithWidth)({
                            isTableScalingEnabled: options?.isTableScalingEnabled,
                            isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                            isFullWidthModeEnabled: options?.fullWidthEnabled,
                            isCommentEditor: options?.isCommentEditor,
                            isChromelessEditor: options?.isChromelessEditor,
                            isTableResizingEnabled: options?.tableOptions.allowTableResizing
                        })(state.schema);
                        return api?.contentInsertion?.actions?.insert({
                            state: state,
                            dispatch: dispatch,
                            node: node,
                            options: {
                                selectNodeInserted: false,
                                analyticsPayload: {
                                    ...analyticsPayload,
                                    attributes: {
                                        ...analyticsPayload.attributes,
                                        localId: node.attrs.localId
                                    }
                                }
                            }
                        }) ?? false;
                    }
                }
        },
        commands: {
            insertTableWithSize: (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes') ? (rowsCount, colsCount, inputMethod)=>(0, $4aKeM.insertTableWithNestingSupport)({
                    isTableScalingEnabled: options?.isTableScalingEnabled,
                    isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                    isFullWidthModeEnabled: options?.fullWidthEnabled,
                    isCommentEditor: options?.isCommentEditor,
                    isChromelessEditor: options?.isChromelessEditor,
                    isTableResizingEnabled: options?.tableOptions.allowTableResizing,
                    createTableProps: {
                        rowsCount: rowsCount,
                        colsCount: colsCount
                    }
                }, api, {
                    action: (0, $gkwXh.ACTION).INSERTED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod ?? (0, $gkwXh.INPUT_METHOD).PICKER,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                }) : (0, $4aKeM.insertTableWithSize)(options?.fullWidthEnabled, options?.isTableScalingEnabled, options?.tableOptions.allowTableAlignment, api?.analytics?.actions, options?.isCommentEditor)
        },
        nodes () {
            const { allowColumnResizing: allowColumnResizing } = (0, $3ojHW.pluginConfig)(options?.tableOptions);
            // TODO: ED-25901 - We need to move this into a plugin config option so we don't accidentally enable nested nodes in Jira
            const isNestingSupported = Boolean(options?.tableOptions?.allowNestedTables);
            return isNestingSupported ? [
                {
                    name: 'table',
                    node: (0, $gWWzt.tableNodeSpecWithFixedToDOM)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $9UDEr.tableHeaderWithNestedTable)
                },
                {
                    name: 'tableRow',
                    node: (0, $9UDEr.tableRowWithNestedTable)
                },
                {
                    name: 'tableCell',
                    node: (0, $9UDEr.tableCellWithNestedTable)
                }
            ] : [
                {
                    name: 'table',
                    node: (0, $gWWzt.tableNodeSpecWithFixedToDOM)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $9UDEr.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $9UDEr.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $9UDEr.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = options || {};
                        return (0, $8JbS8.createPlugin)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, (0, $3ojHW.pluginConfig)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags, getIntl, fullWidthEnabled, wasFullWidthEnabled, dragAndDropEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $3ojHW.pluginConfig)(tableOptions);
                        return allowColumnResizing ? (0, $cjBCM.createPlugin)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled || false, !!options?.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $5PQ8U.createPlugin)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableOptions: tableOptions } = options || {};
                        return (0, $dzNQ0.keymapPlugin)(defaultGetEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled, tableOptions?.allowTableAlignment, fullWidthEnabled, api, getIntl, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableOptions?.allowTableResizing);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $iKKaG.tableSelectionKeymapPlugin)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        const { dragAndDropEnabled: dragAndDropEnabled } = options || {};
                        return (0, $brhD2.tableEditing)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $dEzej.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                                })(tr);
                            },
                            dragAndDropEnabled: dragAndDropEnabled
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch, eventDispatcher: eventDispatcher })=>options && options.tableOptions.stickyHeaders ? (0, $9DiKx.createPlugin)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return options?.dragAndDropEnabled ? (0, $1wp1Y.createPlugin)(dispatch, editorAnalyticsAPI, options?.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return api?.editorViewMode ? (0, $eRNgV.createPlugin)(api, nodeViewPortalProviderAPI) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>(0, $cLyxG.createPlugin)(dispatch)
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options?.tableOptions.allowTableResizing ? (0, $7rFMc.createPlugin)(dispatch, dispatchAnalyticsEvent, options.fullWidthEnabled ?? false, options.isTableScalingEnabled ?? false, options.tableOptions.allowTableResizing ?? false, options.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options?.tableOptions.allowTableResizing && options?.isCommentEditor ? (0, $1tZxL.createPlugin)(dispatch, options.tableOptions.allowTableAlignment ?? false) : undefined
                },
                // TODO: ED-26961 - should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $aajRL.createPlugin)(dispatch, dispatchAnalyticsEvent, options?.tableOptions.allowTableResizing ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $6rgjS.createPlugin)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ()=>{
                        return new (0, $5KWxh.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'tableSizeSelectorPlugin',
                    plugin: ({ dispatch: dispatch })=>isTableSelectorEnabled ? (0, $59C9o.createPlugin)(dispatch) : undefined
                }
            ];
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if ((0, $gE8f9.browser).safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $cun24.createPlugin)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if ((0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', true)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NFM5.ContentComponent), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags,
                isTableSelectorEnabled: isTableSelectorEnabled
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9pOon.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).TABLES_PLUGIN,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                fallbackComponent: null,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epMWO.GlobalStylesWrapper), {
                        featureFlags: api?.featureFlags?.sharedState.currentState(),
                        isDragAndDropEnabledOption: options?.dragAndDropEnabled,
                        api: api
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j79rm.WithPluginState), {
                        plugins: {
                            tableAnalyticsPluginState: (0, $deOBG.pluginKey),
                            tablePluginState: (0, $cPPiz.pluginKey),
                            tableWidthPluginState: (0, $7rFMc.pluginKey),
                            tableResizingPluginState: (0, $k8KvZ.pluginKey),
                            stickyHeadersState: (0, $fCcOI.pluginKey),
                            dragAndDropState: (0, $84dDf.pluginKey),
                            sizeSelectorPluginState: (0, $59C9o.pluginKey)
                        },
                        render: ({ tableResizingPluginState: resizingPluginState, stickyHeadersState: stickyHeadersState, tablePluginState: tablePluginState, tableWidthPluginState: tableWidthPluginState, dragAndDropState: dragAndDropState, sizeSelectorPluginState: sizeSelectorPluginState })=>{
                            // Any changes made inside `<WithPluginState>` need to be reflected in the
                            // `<ContentComponent>` as well.
                            const isColumnResizing = resizingPluginState?.dragging;
                            const isTableResizing = tableWidthPluginState?.resizing;
                            const resizingTableLocalId = tableWidthPluginState?.tableLocalId;
                            const resizingTableRef = tableWidthPluginState?.tableRef;
                            const isResizing = isColumnResizing || isTableResizing;
                            const widthToWidest = tablePluginState?.widthToWidest;
                            const isSizeSelectorOpen = sizeSelectorPluginState?.isSelectorOpen;
                            const { tableNode: tableNode, tablePos: tablePos, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = tablePluginState;
                            const { allowControls: allowControls } = pluginConfig;
                            const stickyHeader = stickyHeadersState ? (0, $eRc84.findStickyHeaderForTable)(stickyHeadersState, tablePos) : undefined;
                            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                                children: [
                                    targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7j6gm.default), {
                                        isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                                        editorView: editorView,
                                        tableNode: tableNode,
                                        mountPoint: popupsMountPoint,
                                        targetCellPosition: targetCellPosition,
                                        scrollableElement: popupsScrollableElement,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        isContextualMenuOpen: isContextualMenuOpen,
                                        stickyHeader: stickyHeader,
                                        tableWrapper: tableWrapperTarget,
                                        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
                                    }),
                                    allowControls && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cvR2q.default), {
                                        tableNode: tableNode,
                                        tableRef: tableRef,
                                        insertColumnButtonIndex: insertColumnButtonIndex,
                                        insertRowButtonIndex: insertRowButtonIndex,
                                        isHeaderColumnEnabled: isHeaderColumnEnabled,
                                        isHeaderRowEnabled: isHeaderRowEnabled,
                                        isDragAndDropEnabled: isDragAndDropEnabled,
                                        isTableScalingEnabled: options?.isTableScalingEnabled,
                                        editorView: editorView,
                                        mountPoint: popupsMountPoint,
                                        boundariesElement: popupsBoundariesElement,
                                        scrollableElement: popupsScrollableElement,
                                        hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        editorAnalyticsAPI: editorAnalyticsAPI,
                                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags,
                                        isChromelessEditor: options?.isChromelessEditor,
                                        api: api,
                                        isCommentEditor: options?.isCommentEditor
                                    }),
                                    options?.allowContextualMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lx3Ew.default), {
                                        editorView: editorView,
                                        mountPoint: popupsMountPoint,
                                        boundariesElement: popupsBoundariesElement,
                                        targetCellPosition: targetCellPosition,
                                        isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                                        pluginConfig: pluginConfig,
                                        editorAnalyticsAPI: editorAnalyticsAPI,
                                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags,
                                        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                                        isCommentEditor: options?.isCommentEditor,
                                        api: api
                                    }),
                                    isDragAndDropEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPXwH.default), {
                                        editorView: editorView,
                                        mountPoint: popupsMountPoint,
                                        boundariesElement: popupsBoundariesElement,
                                        tableRef: tableRef,
                                        tableNode: tableNode,
                                        targetCellPosition: targetCellPosition,
                                        direction: dragAndDropState?.dragMenuDirection,
                                        index: dragAndDropState?.dragMenuIndex,
                                        isOpen: !!dragAndDropState?.isDragMenuOpen && !isResizing,
                                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                                        editorAnalyticsAPI: editorAnalyticsAPI,
                                        stickyHeaders: stickyHeader,
                                        pluginConfig: pluginConfig,
                                        isTableScalingEnabled: options?.isTableScalingEnabled,
                                        getEditorFeatureFlags: options?.getEditorFeatureFlags || $ecc17bdad5d858d8$var$defaultGetEditorFeatureFlags,
                                        ariaNotifyPlugin: ariaNotifyPlugin,
                                        api: api,
                                        isCommentEditor: options?.isCommentEditor
                                    }),
                                    allowControls && !isDragAndDropEnabled && !isResizing && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oGFf.default), {
                                        editorView: editorView,
                                        selection: editorView.state.selection,
                                        tableRef: tableRef,
                                        mountPoint: popupsMountPoint,
                                        boundariesElement: popupsBoundariesElement,
                                        scrollableElement: popupsScrollableElement,
                                        stickyHeaders: stickyHeader,
                                        isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                                        editorAnalyticsAPI: editorAnalyticsAPI,
                                        api: api
                                    }),
                                    (options?.isTableScalingEnabled || options?.tableOptions.allowTableResizing && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $guFYO.FloatingToolbarLabel), {
                                        target: resizingTableRef,
                                        content: (0, $gmhCD.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xI1l.ResizerBreakoutModeLabel), {
                                            layout: "full-width"
                                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZAi0.FullWidthDisplay), {}),
                                        alignX: 'center',
                                        alignY: 'bottom',
                                        stick: true,
                                        forcePlacement: true,
                                        zIndex: (0, $iHYdz.akEditorFloatingPanelZIndex),
                                        offset: [
                                            0,
                                            10
                                        ]
                                    }),
                                    isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWCYR.SizeSelector), {
                                        api: api,
                                        isOpenedByKeyboard: false,
                                        popupsMountPoint: popupsMountPoint,
                                        target: sizeSelectorPluginState?.targetRef ?? (0, $gries.getDomRefFromSelection)(editorView, (0, $gkwXh.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api?.analytics?.actions),
                                        popupsBoundariesElement: popupsBoundariesElement,
                                        popupsScrollableElement: popupsScrollableElement
                                    })
                                ]
                            });
                        }
                    })
                ]
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'table',
                        title: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).table),
                        description: formatMessage((0, $2i4K4.toolbarInsertBlockMessages).tableDescription),
                        keywords: [
                            'cell',
                            'table'
                        ],
                        priority: 600,
                        keyshortcut: (0, $e9qoo.tooltip)((0, $e9qoo.toggleTable)),
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9mDTH.IconTable), {}),
                        action (insert, state) {
                            if (isTableSelectorEnabled) {
                                const tr = insert('');
                                tr.setMeta((0, $59C9o.pluginKey), {
                                    isSelectorOpen: true
                                });
                                return tr;
                            }
                            // see comment on tablesPlugin.getSharedState on usage
                            const tableState = api?.table?.sharedState.currentState();
                            const tableNodeProps = {
                                isTableScalingEnabled: options?.isTableScalingEnabled,
                                isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                                isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
                                isCommentEditor: options?.isCommentEditor,
                                isChromelessEditor: options?.isChromelessEditor,
                                isTableResizingEnabled: options?.tableOptions.allowTableResizing
                            };
                            let tableNode = (0, $aJOib.createTableWithWidth)(tableNodeProps)(state.schema);
                            let { tr: tr } = state;
                            // If the cursor is inside a table
                            if ((0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options?.tableOptions?.allowNestedTables && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) {
                                // If the experiment is disabled, or we're trying to nest deeper than one level, we insert the table after the top table
                                if ((0, $gmhCD.editorExperiment)('nested-tables-in-tables', false, {
                                    exposure: true
                                }) || (0, $9O539.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
                                    // Nesting is too deep insert table after the top parent table
                                    const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
                                    tr = (0, $5r0mK.safeInsert)(tableNode, positionAfterTopTable)(tr);
                                    tr.scrollIntoView();
                                } else {
                                    // Table can be nested in parent table
                                    tableNode = (0, $aJOib.createTableWithWidth)({
                                        ...tableNodeProps,
                                        isNestedTable: true
                                    })(state.schema);
                                    tr = insert(tableNode);
                                }
                            } else tr = insert(tableNode);
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $gkwXh.ACTION).INSERTED,
                                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
                                attributes: {
                                    inputMethod: (0, $gkwXh.INPUT_METHOD).QUICK_INSERT,
                                    localId: tableNode.attrs.localId
                                },
                                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $knLk2.getToolbarConfig)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $3ojHW.pluginConfig)(options?.tableOptions))
        },
        usePluginHook ({ editorView: editorView }) {
            const { mode: mode } = $ecc17bdad5d858d8$var$useTableSharedState(api);
            (0, $5uXOq.useEffect)(()=>{
                const { state: state, dispatch: dispatch } = editorView;
                const tr = state.tr;
                tr.setMeta('viewModeState', mode);
                if (dispatch) dispatch(tr);
            }, [
                editorView,
                mode
            ]);
        }
    };
};
var $ecc17bdad5d858d8$export$2e2bcd8739ae039 = $ecc17bdad5d858d8$var$tablePlugin;

});
parcelRegister("gries", function(module, exports) {

$parcel$export(module.exports, "getDomRefFromSelection", () => $ed2cde93603ac657$export$49d74ed2464a12b9);

var $5r0mK = parcelRequire("5r0mK");

var $gkwXh = parcelRequire("gkwXh");
const $ed2cde93603ac657$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $gkwXh.ACTION).ERRORED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};

});

parcelRegister("9mDTH", function(module, exports) {

$parcel$export(module.exports, "IconTable", () => $a303a47d566b8f4d$export$84f497075f5b07be);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4qBtX = parcelRequire("4qBtX");

var $eaR7m = parcelRequire("eaR7m");

var $j9muy = parcelRequire("j9muy");

var $f5KSA = parcelRequire("f5KSA");

var $fIRKG = parcelRequire("fIRKG");

var $5AmZK = parcelRequire("5AmZK");

var $2VLx1 = parcelRequire("2VLx1");

var $3S0l7 = parcelRequire("3S0l7");

var $i3VAn = parcelRequire("i3VAn");

const $a303a47d566b8f4d$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bryId")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("eaR7m", function(module, exports) {

$parcel$export(module.exports, "PanelInfoIcon", () => $d91e73a67b7d2b96$export$2187dc2d495c3efc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d91e73a67b7d2b96$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $d91e73a67b7d2b96$export$2187dc2d495c3efc = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $d91e73a67b7d2b96$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("j9muy", function(module, exports) {

$parcel$export(module.exports, "PanelWarningIcon", () => $a15778b28bcee665$export$246c5468186717b7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $a15778b28bcee665$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $a15778b28bcee665$export$246c5468186717b7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $a15778b28bcee665$var$PanelWarningGlyph,
        ...props
    });
};

});

parcelRegister("f5KSA", function(module, exports) {

$parcel$export(module.exports, "PanelErrorIcon", () => $96b527f94a403c7a$export$76fa6c311f4e2871);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $96b527f94a403c7a$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $96b527f94a403c7a$export$76fa6c311f4e2871 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $96b527f94a403c7a$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("fIRKG", function(module, exports) {

$parcel$export(module.exports, "PanelSuccessIcon", () => $442ba659e5a389a4$export$a5a5162e21242c3c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $442ba659e5a389a4$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $442ba659e5a389a4$export$a5a5162e21242c3c = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $442ba659e5a389a4$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("5AmZK", function(module, exports) {

$parcel$export(module.exports, "PanelNoteIcon", () => $6bc8798a62855fe1$export$d4f894f0c3f0db6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $6bc8798a62855fe1$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $6bc8798a62855fe1$export$d4f894f0c3f0db6 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $6bc8798a62855fe1$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("2VLx1", function(module, exports) {

$parcel$export(module.exports, "BorderIcon", () => $4fb2fafef3aeaf7c$export$7e14741e44d551);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4fb2fafef3aeaf7c$var$BorderIconGlyph = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.33333 8C8.15267 8 8 8.14933 8 8.33333V15.6667C8.0007 15.7549 8.03604 15.8392 8.0984 15.9016C8.16076 15.964 8.24514 15.9993 8.33333 16H15.6667C15.8473 16 16 15.8507 16 15.6667V8.33333C16 8.15267 15.8507 8 15.6667 8H8.33333Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM7 6C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7Z",
                fill: "currentColor"
            })
        ]
    });
};
const $4fb2fafef3aeaf7c$export$7e14741e44d551 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        glyph: $4fb2fafef3aeaf7c$var$BorderIconGlyph,
        ...props
    });
};

});

parcelRegister("3S0l7", function(module, exports) {

$parcel$export(module.exports, "SteppedRainbowIconDecoration", () => $8dd9845d2e1e4f36$export$9141b78f26ee217c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $8dd9845d2e1e4f36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8dd9845d2e1e4f36$var$createSteppedRainbow = (colors)=>{
    return `
    linear-gradient(
      to right,
      ${colors.map((color, i)=>{
        const inc = 100 / colors.length;
        const pos = i + 1;
        if (i === 0) return `${color} ${pos * inc}%,`;
        if (i === colors.length - 1) return `${color} ${(pos - 1) * inc}%`;
        return `
            ${color} ${(pos - 1) * inc}%,
            ${color} ${pos * inc}%,
          `;
    }).join('\n')}
    )`;
};
const $8dd9845d2e1e4f36$var$rainbow = $8dd9845d2e1e4f36$var$createSteppedRainbow([
    "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    "var(--ds-background-accent-orange-subtle, #FEA362)",
    "var(--ds-background-accent-red-bolder, #C9372C)"
]);
const $8dd9845d2e1e4f36$var$disabledRainbow = $8dd9845d2e1e4f36$var$createSteppedRainbow([
    "var(--ds-background-accent-gray-subtle, #8590A2)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)",
    "var(--ds-background-accent-gray-subtle-pressed, #DCDFE4)",
    "var(--ds-background-accent-gray-subtle-hovered, #B3B9C4)"
]);
const $8dd9845d2e1e4f36$var$barStyles = {
    name: "1t7p4fi",
    styles: "position:absolute;left:0;right:0;top:var(--ds-space-200, 16px);margin:auto;width:12px;height:3px;border-radius:var(--ds-border-radius, 3px)"
};
const $8dd9845d2e1e4f36$var$textColorIconWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $8dd9845d2e1e4f36$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    if (disabled) return $8dd9845d2e1e4f36$var$disabledRainbow;
    return $8dd9845d2e1e4f36$var$rainbow;
};
const $8dd9845d2e1e4f36$export$9141b78f26ee217c = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $8dd9845d2e1e4f36$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": "toolbar-icon-stepped-rainbow",
        style: {
            background: $8dd9845d2e1e4f36$var$getBackground(selectedColor, disabled)
        },
        css: $8dd9845d2e1e4f36$var$barStyles
    }));
};

});

parcelRegister("i3VAn", function(module, exports) {

$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => $f6203279acdcbdec$export$76b0278e018f8601);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $f6203279acdcbdec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6203279acdcbdec$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $f6203279acdcbdec$var$textColorIconWrapper = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $f6203279acdcbdec$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
};
const $f6203279acdcbdec$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $f6203279acdcbdec$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $f6203279acdcbdec$var$getBackground(selectedColor, disabled)
        },
        css: $f6203279acdcbdec$var$barStyles
    }));
};

});

parcelRegister("bryId", function(module, exports) {

let $854d2469c4796561$var$load = (parcelRequire("28QjX"))(4);
module.exports = $854d2469c4796561$var$load("5DFaA").then(()=>parcelRequire('3PNvw'));

});


parcelRegister("8xI1l", function(module, exports) {

$parcel$export(module.exports, "ResizerBreakoutModeLabel", () => $e8c4b95ab2331173$export$46c20f09a5d207e4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $1C4XH = parcelRequire("1C4XH");
const $e8c4b95ab2331173$var$fullWidthLabelWrapperStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $e8c4b95ab2331173$var$fullWidthLabelStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $e8c4b95ab2331173$export$46c20f09a5d207e4 = ({ layout: breaktoutLayout })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        switch(breaktoutLayout){
            case 'full-width':
                return formatMessage((0, $1C4XH.messages).fullWidthLabel);
            case 'wide':
                return formatMessage((0, $1C4XH.messages).wideWidthLabel);
            default:
                return null;
        }
    }, [
        breaktoutLayout,
        formatMessage
    ]);
    return message && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $e8c4b95ab2331173$var$fullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
            xcss: $e8c4b95ab2331173$var$fullWidthLabelStyles,
            children: message
        })
    });
};

});

parcelRegister("j79rm", function(module, exports) {

$parcel$export(module.exports, "WithPluginState", () => $d985d7d8deb0b848$export$38a2fcbdfe5b863a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $lY6DM = parcelRequire("lY6DM");

var $iN9lO = parcelRequire("iN9lO");

var $8v2ZL = parcelRequire("8v2ZL");

var $4NUlu = parcelRequire("4NUlu");
const $d985d7d8deb0b848$var$DEFAULT_SAMPLING_RATE = 100;
const $d985d7d8deb0b848$var$DEFAULT_SLOW_THRESHOLD = 4;
/**
 * @private
 * @deprecated
 *
 * Using this component is deprecated. It should be replaced with `useSharedPluginState`.
 * This requires having access to the injection API from the plugin itself.
 *
 * An example of the refactor with the new hook (using hyperlink as an example) is:
 *
 * Before:
 * ```ts
 * <WithPluginState
 *   editorView={editorView}
 *   plugins={{
 *     hyperlinkState: hyperlinkPluginKey
 *   }}
 *   render={({ hyperlinkState }) =>
 *     renderComponent({ hyperlinkState })
 *   }
 * />
 * ```
 *
 * After:
 * ```ts
 * import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
 * import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
 *
 * function ComponentWithState(
 *   api: ExtractInjectionAPI<typeof hyperlinkPlugin> | undefined
 * ) {
 *   const { hyperlinkState } = useSharedPluginState(api, ['hyperlink']);
 *   return renderComponent({ hyperlinkState })
 * }
 * ```
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, react/prefer-stateless-function
class $d985d7d8deb0b848$export$38a2fcbdfe5b863a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
    }
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($d985d7d8deb0b848$var$WithPluginStateEditionActionsWrapper, {
            ...this.props
        });
    }
}
function $d985d7d8deb0b848$var$WithPluginStateEditionActionsWrapper(props) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $8v2ZL.EditorContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d985d7d8deb0b848$export$c41b245ea9f92714, {
        ...props,
        editorActions: context?.editorActions
    });
}
class $d985d7d8deb0b848$export$c41b245ea9f92714 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'WithPluginState';
    }
    constructor(props){
        super(props), this.listeners = {}, this.debounce = null, this.notAppliedState = {}, this.isSubscribed = false, this.callsCount = 0, this.handlePluginStateChange = (propName, pluginName, performanceOptions, skipEqualityCheck)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (pluginState)=>{
                // skipEqualityCheck is being used for old plugins since they are mutating plugin state instead of creating a new one
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (this.state[propName] !== pluginState || skipEqualityCheck) this.updateState({
                    stateSubset: {
                        [propName]: pluginState
                    },
                    pluginName: pluginName,
                    performanceOptions: performanceOptions
                });
            }, /**
	 * Debounces setState calls in order to reduce number of re-renders caused by several plugin state changes.
	 */ this.updateState = ({ stateSubset: stateSubset, pluginName: pluginName, performanceOptions: performanceOptions })=>{
            this.notAppliedState = {
                ...this.notAppliedState,
                ...stateSubset
            };
            if (this.debounce) window.clearTimeout(this.debounce);
            const debounce = this.props.debounce !== false ? (fn)=>window.setTimeout(fn, 0) : (fn)=>fn();
            this.debounce = debounce(()=>{
                const measure = `\u{1F989}${pluginName}::WithPluginState`;
                performanceOptions.trackingEnabled && (0, $iN9lO.startMeasure)(measure);
                this.setState(this.notAppliedState, ()=>{
                    performanceOptions.trackingEnabled && (0, $iN9lO.stopMeasure)(measure, (duration)=>{
                        // Each WithPluginState component will fire analytics event no more than once every `samplingLimit` times
                        if (++this.callsCount % performanceOptions.samplingRate === 0 && duration > performanceOptions.slowThreshold) this.dispatchAnalyticsEvent({
                            action: (0, $gkwXh.ACTION).WITH_PLUGIN_STATE_CALLED,
                            actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                plugin: pluginName,
                                duration: duration
                            }
                        });
                    });
                });
                this.debounce = null;
                this.notAppliedState = {};
            });
        }, this.dispatchAnalyticsEvent = (payload)=>{
            const eventDispatcher = this.getEventDispatcher();
            if (eventDispatcher) {
                const dispatch = (0, $lY6DM.createDispatch)(eventDispatcher);
                dispatch((0, $4NUlu.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.state = this.getPluginsStates(this.props.plugins, this.getEditorView(props));
    }
    getEditorView(maybeProps) {
        const props = maybeProps || this.props;
        const editorActions = props.editorActions;
        return props.editorView || editorActions?._privateGetEditorView();
    }
    getEventDispatcher(maybeProps) {
        const props = maybeProps || this.props;
        return props.eventDispatcher || props.editorActions?._privateGetEventDispatcher();
    }
    getPluginsStates(plugins, editorView) {
        if (!editorView || !plugins) return {};
        const keys = Object.keys(plugins);
        return keys.reduce((acc, propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return acc;
            acc[propName] = pluginKey.getState(editorView.state);
            return acc;
        }, {});
    }
    subscribe(props) {
        const plugins = props.plugins;
        const eventDispatcher = this.getEventDispatcher(props);
        const editorView = this.getEditorView(props);
        if (!eventDispatcher || !editorView || this.isSubscribed) return;
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakePluginKey = {
            key: 'analyticsPlugin$',
            getState: (state)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return state['analyticsPlugin$'];
            }
        };
        const analyticsPlugin = fakePluginKey.getState(editorView.state);
        const uiTracking = analyticsPlugin && analyticsPlugin.performanceTracking ? analyticsPlugin.performanceTracking.uiTracking || {} : {};
        const trackingEnabled = uiTracking.enabled === true;
        const samplingRate = uiTracking.samplingRate ?? $d985d7d8deb0b848$var$DEFAULT_SAMPLING_RATE;
        const slowThreshold = uiTracking.slowThreshold ?? $d985d7d8deb0b848$var$DEFAULT_SLOW_THRESHOLD;
        this.isSubscribed = true;
        const pluginsStates = this.getPluginsStates(plugins, editorView);
        this.setState(pluginsStates);
        Object.keys(plugins).forEach((propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pluginName = pluginKey.key;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pluginState = pluginsStates[propName];
            const isPluginWithSubscribe = pluginState && pluginState.subscribe;
            const handler = this.handlePluginStateChange(propName, pluginName, {
                samplingRate: samplingRate,
                slowThreshold: slowThreshold,
                trackingEnabled: trackingEnabled
            }, isPluginWithSubscribe);
            if (isPluginWithSubscribe) pluginState.subscribe(handler);
            else // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            eventDispatcher.on(pluginKey.key, handler);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.listeners[pluginKey.key] = {
                handler: handler,
                pluginKey: pluginKey
            };
        });
    }
    unsubscribe() {
        const eventDispatcher = this.getEventDispatcher();
        const editorView = this.getEditorView();
        if (!eventDispatcher || !editorView || !this.isSubscribed) return;
        Object.keys(this.listeners).forEach((key)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pluginState = this.listeners[key].pluginKey.getState(editorView.state);
            if (pluginState && pluginState.unsubscribe) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            pluginState.unsubscribe(this.listeners[key].handler);
            else // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            eventDispatcher.off(key, this.listeners[key].handler);
        });
        this.listeners = [];
    }
    subscribeToContextUpdates() {
        this.props.editorActions?._privateSubscribe(()=>this.subscribe(this.props));
    }
    unsubscribeFromContextUpdates() {
        this.props.editorActions?._privateUnsubscribe(()=>this.subscribe(this.props));
    }
    componentDidMount() {
        this.subscribe(this.props);
        this.subscribeToContextUpdates();
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.isSubscribed) this.subscribe(nextProps);
    }
    componentWillUnmount() {
        if (this.debounce) window.clearTimeout(this.debounce);
        this.unsubscribeFromContextUpdates();
        this.unsubscribe();
    }
    render() {
        const { render: render } = this.props;
        return render(this.state);
    }
}

});

parcelRegister("brhD2", function(module, exports) {

$parcel$export(module.exports, "tableEditing", () => $ca9bad29ab57d689$export$e382fe3f780a6548);

var $gZGBX = parcelRequire("gZGBX");

var $hKZR1 = parcelRequire("hKZR1");

var $dltxa = parcelRequire("dltxa");

var $kguIk = parcelRequire("kguIk");

var $fnDrj = parcelRequire("fnDrj");

var $gtoG2 = parcelRequire("gtoG2");

var $c5FiX = parcelRequire("c5FiX");
function $ca9bad29ab57d689$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, dragAndDropEnabled: dragAndDropEnabled = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $gZGBX.Plugin)({
        key: (0, $c5FiX.tableEditingKey),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $c5FiX.tableEditingKey));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $dltxa.drawCellSelection),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $gtoG2.handleMouseDown)(view, event, dragAndDropEnabled);
                }
            },
            createSelectionBetween (view) {
                if ((0, $c5FiX.tableEditingKey).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $gtoG2.handleTripleClick,
            handleKeyDown: $gtoG2.handleKeyDown,
            handlePaste: $hKZR1.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $fnDrj.normalizeSelection)(state, (0, $kguIk.fixTables)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}

});
parcelRegister("dltxa", function(module, exports) {

$parcel$export(module.exports, "drawCellSelection", () => $707bb61f9093abc1$export$938a078fa3e1d420);

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");
function $707bb61f9093abc1$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $hFEwm.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $etG8M.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $etG8M.DecorationSet).create(state.doc, cells);
}

});

parcelRegister("kguIk", function(module, exports) {

$parcel$export(module.exports, "fixTables", () => $a7ee445977c13f24$export$d6d48849d9121a1);

var $c5FiX = parcelRequire("c5FiX");

var $uOUlv = parcelRequire("uOUlv");

var $6e6o8 = parcelRequire("6e6o8");

var $3yjNu = parcelRequire("3yjNu");
// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function $a7ee445977c13f24$var$changedDescendants(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    // eslint-disable-next-line no-labels
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $a7ee445977c13f24$var$changedDescendants(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}
function $a7ee445977c13f24$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = $a7ee445977c13f24$export$26dfac117c7732d8(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) $a7ee445977c13f24$var$changedDescendants(oldState.doc, state.doc, 0, check);
    return tr;
}
function $a7ee445977c13f24$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $uOUlv.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $uOUlv.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $6e6o8.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $uOUlv.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $uOUlv.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $uOUlv.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nodes.push((0, $3yjNu.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $c5FiX.fixTablesKey), {
        fixTables: true
    });
}

});
parcelRegister("c5FiX", function(module, exports) {

$parcel$export(module.exports, "tableEditingKey", () => $417a1b09ccc4d71c$export$8dc63188bf2e0962);
$parcel$export(module.exports, "fixTablesKey", () => $417a1b09ccc4d71c$export$9731ba46aee163cb);

var $gZGBX = parcelRequire("gZGBX");
const $417a1b09ccc4d71c$export$8dc63188bf2e0962 = new (0, $gZGBX.PluginKey)('selectingCells');
const $417a1b09ccc4d71c$export$9731ba46aee163cb = new (0, $gZGBX.PluginKey)('fix-tables');

});


parcelRegister("fnDrj", function(module, exports) {

$parcel$export(module.exports, "normalizeSelection", () => $b9e14ec61ec8549f$export$64b8795b15903d8d);

var $gZGBX = parcelRequire("gZGBX");

var $gmhCD = parcelRequire("gmhCD");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");
function $b9e14ec61ec8549f$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $gZGBX.NodeSelection)) role = sel.node.type.spec.tableRole;
    const isMultiSelect = (0, $gmhCD.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    if (sel instanceof (0, $gZGBX.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $hFEwm.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $hFEwm.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $uOUlv.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $hFEwm.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $gZGBX.TextSelection) && $b9e14ec61ec8549f$var$isCellBoundarySelection(sel)) normalize = (0, $gZGBX.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $gZGBX.TextSelection) && (isMultiSelect ? $b9e14ec61ec8549f$var$isTextSelectionAcrossSameTableCells(sel) : $b9e14ec61ec8549f$var$isTextSelectionAcrossCells(sel))) normalize = (0, $gZGBX.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $b9e14ec61ec8549f$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return afterFrom === beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function $b9e14ec61ec8549f$var$isTextSelectionAcrossCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            fromCellBoundaryNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            toCellBoundaryNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function $b9e14ec61ec8549f$var$isTextSelectionAcrossSameTableCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    let fromCellTableNode;
    let toCellTableNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') fromCellBoundaryNode = node;
        if (node.type.name === 'table') {
            fromCellTableNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') toCellBoundaryNode = node;
        if (node.type.name === 'table') {
            toCellTableNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== undefined && toCellBoundaryNode !== undefined && fromCellBoundaryNode !== toCellBoundaryNode && toCellTableNode === fromCellTableNode && $to.parentOffset === 0;
}

});

parcelRegister("gtoG2", function(module, exports) {

$parcel$export(module.exports, "handleKeyDown", () => $ada990384abd2f9a$export$bab59f27a7347e45);
$parcel$export(module.exports, "handleTripleClick", () => $ada990384abd2f9a$export$f17e34274dd6fcf5);
$parcel$export(module.exports, "handleMouseDown", () => $ada990384abd2f9a$export$b4a93e0b711d8f7);
// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $vWFRY = parcelRequire("vWFRY");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $28MvW = parcelRequire("28MvW");
var $3yjNu = parcelRequire("3yjNu");

var $6hQQ3 = parcelRequire("6hQQ3");

var $bQFBc = parcelRequire("bQFBc");

var $c5FiX = parcelRequire("c5FiX");
const $ada990384abd2f9a$export$bab59f27a7347e45 = (0, $vWFRY.keydownHandler)({
    ArrowLeft: $ada990384abd2f9a$var$arrow('horiz', -1),
    ArrowRight: $ada990384abd2f9a$var$arrow('horiz', 1),
    ArrowUp: $ada990384abd2f9a$var$arrow('vert', -1),
    ArrowDown: $ada990384abd2f9a$var$arrow('vert', 1),
    'Shift-ArrowLeft': $ada990384abd2f9a$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $ada990384abd2f9a$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $ada990384abd2f9a$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $ada990384abd2f9a$var$shiftArrow('vert', 1),
    Backspace: $ada990384abd2f9a$var$deleteCellSelection,
    'Mod-Backspace': $ada990384abd2f9a$var$deleteCellSelection,
    Delete: $ada990384abd2f9a$var$deleteCellSelection,
    'Mod-Delete': $ada990384abd2f9a$var$deleteCellSelection
});
function $ada990384abd2f9a$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $ada990384abd2f9a$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $hFEwm.CellSelection)) return $ada990384abd2f9a$var$maybeSetSelection(state, dispatch, (0, $gZGBX.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $ada990384abd2f9a$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $ada990384abd2f9a$var$maybeSetSelection(state, dispatch, (0, $gZGBX.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $6hQQ3.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $gZGBX.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $gZGBX.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $gZGBX.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $ada990384abd2f9a$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $ada990384abd2f9a$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $hFEwm.CellSelection))) {
            const end = view ? $ada990384abd2f9a$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes(maybeTableCell?.parent?.type.name || '');
            if (!sameCell) return false;
            sel = new (0, $hFEwm.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $6hQQ3.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $ada990384abd2f9a$var$maybeSetSelection(state, dispatch, new (0, $hFEwm.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $ada990384abd2f9a$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $hFEwm.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const baseContent = (0, $3yjNu.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $kCV8T.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
function $ada990384abd2f9a$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $6hQQ3.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $hFEwm.CellSelection)($cell)));
    return true;
}
function $ada990384abd2f9a$export$b4a93e0b711d8f7(view, event, dragAndDropEnabled) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const startDOMCell = $ada990384abd2f9a$var$domInCell(view, startEvent.target);
    const $anchor = (0, $6hQQ3.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $hFEwm.CellSelection)) {
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        const isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (dragAndDropEnabled && isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $ada990384abd2f9a$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $ada990384abd2f9a$var$cellUnderMouse(view, event);
        const starting = (0, $c5FiX.tableEditingKey).getState(view.state) == null;
        if (!$head || !(0, $bQFBc.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $hFEwm.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $c5FiX.tableEditingKey), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mouseup', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('dragstart', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mousemove', move);
        if ((0, $c5FiX.tableEditingKey).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $c5FiX.tableEditingKey), -1));
    }
    function move(event) {
        const anchor = (0, $c5FiX.tableEditingKey).getState(view.state);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const currDOMCell = $ada990384abd2f9a$var$domInCell(view, event.target);
        const isCurrCellInsideNestedTable = $ada990384abd2f9a$var$isInsideNestedTable(view, event);
        const isStartCellInsideNestedTable = $ada990384abd2f9a$var$isInsideNestedTable(view, startEvent);
        const isBothCellsInSameTable = isCurrCellInsideNestedTable === isStartCellInsideNestedTable;
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if (currDOMCell !== startDOMCell && isBothCellsInSameTable) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $ada990384abd2f9a$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('dragstart', stop);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mousemove', move);
    return false;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $ada990384abd2f9a$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $gZGBX.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}
function $ada990384abd2f9a$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $ada990384abd2f9a$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $6hQQ3.cellAround)(view.state.doc.resolve(mousePos.pos));
}
function $ada990384abd2f9a$var$isInsideNestedTable(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return false;
    const pos = view.state.doc.resolve(mousePos.pos);
    const table = (0, $28MvW.findTableClosestToPos)(pos);
    if (!table) return false;
    const parent = view.state.doc.resolve(table.pos).parent;
    const nodeTypes = view.state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
}

});


parcelRegister("gWWzt", function(module, exports) {

$parcel$export(module.exports, "tableNodeSpecWithFixedToDOM", () => $9eca89ee41c176e5$export$477bb32cbededd65);

var $3T6Xo = parcelRequire("3T6Xo");

var $9UDEr = parcelRequire("9UDEr");

var $7KZr8 = parcelRequire("7KZr8");

var $iHYdz = parcelRequire("iHYdz");

var $iQMCj = parcelRequire("iQMCj");

var $9QiRG = parcelRequire("9QiRG");

var $1SASl = parcelRequire("1SASl");
const $9eca89ee41c176e5$export$477bb32cbededd65 = (config)=>{
    const tableNode = config.isNestingSupported ? (0, $9UDEr.tableWithNestedTable) : (0, $9UDEr.table);
    return {
        ...tableNode,
        toDOM: (node)=>{
            const gutterPadding = (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2;
            const alignmentStyle = Object.entries((0, $1SASl.getAlignmentStyle)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(v)}`).join(';');
            const tableMinWidth = (0, $iQMCj.getResizerMinWidth)(node);
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width
            };
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $iQMCj.generateColgroup)(node)
            ];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-with-left-shadow',
                        style: 'visibility: hidden'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-wrapper'
                    },
                    [
                        'table',
                        attrs,
                        [
                            'span',
                            {
                                class: 'pm-table-shadow-sentinel-right'
                            }
                        ],
                        [
                            'span',
                            {
                                class: 'pm-table-shadow-sentinel-left'
                            }
                        ],
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-with-right-shadow',
                        style: 'visibility: hidden'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ]
            ];
            if (!config.tableResizingEnabled) return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableContainerDiv
            ];
            const tableWidthAttribute = node.attrs.width ? `${node.attrs.width}px` : `100%`;
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: `width: min(calc(100cqw - ${gutterPadding}px), ${tableWidthAttribute});`
                    },
                    [
                        'div',
                        {
                            class: 'resizer-item display-handle',
                            style: (0, $7KZr8.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-gutter-padding': `${gutterPadding}px`,
                                '--ak-editor-table-max-width': `${(0, $9QiRG.TABLE_MAX_WIDTH)}px`,
                                '--ak-editor-table-min-width': `${tableMinWidth}px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: `min(calc(100cqw - var(--ak-editor-table-gutter-padding)), var(--ak-editor-table-max-width))`,
                                width: `min(calc(100cqw - var(--ak-editor-table-gutter-padding)), ${tableWidthAttribute})`
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableResizingDiv
            ];
        }
    };
};

});
parcelRegister("iQMCj", function(module, exports) {

$parcel$export(module.exports, "getColWidthFix", () => $afd30a44e5a88a9e$export$66302252070a658d);
$parcel$export(module.exports, "generateColgroup", () => $afd30a44e5a88a9e$export$6628e11a2af8bd40);
$parcel$export(module.exports, "insertColgroupFromNode", () => $afd30a44e5a88a9e$export$ae5d9647f2a0891c);
$parcel$export(module.exports, "hasTableBeenResized", () => $afd30a44e5a88a9e$export$8c07f44cea64e3c7);
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $afd30a44e5a88a9e$export$b44a013e4f554514);
$parcel$export(module.exports, "isMinCellWidthTable", () => $afd30a44e5a88a9e$export$2878318085bf6dbf);
$parcel$export(module.exports, "getColgroupChildrenLength", () => $afd30a44e5a88a9e$export$dc24345db4290451);
$parcel$export(module.exports, "getResizerMinWidth", () => $afd30a44e5a88a9e$export$e7ee55be67771d90);

var $6gEe5 = parcelRequire("6gEe5");

var $7vpuQ = parcelRequire("7vpuQ");

var $kCV8T = parcelRequire("kCV8T");

var $uOUlv = parcelRequire("uOUlv");

var $9QiRG = parcelRequire("9QiRG");

var $118VY = parcelRequire("118VY");
const $afd30a44e5a88a9e$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $afd30a44e5a88a9e$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentEditor)=>{
    const cols = [];
    const map = (0, $uOUlv.TableMap).get(table);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentEditor && !table.attrs?.width) scalePercent = (0, $118VY.getScalingPercentForTableWithoutWidth)(table, tableRef);
                else scalePercent = (0, $118VY.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    const fixedColWidth = $afd30a44e5a88a9e$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $6gEe5.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$afd30a44e5a88a9e$export$66302252070a658d(width ? Math.max(width, (0, $6gEe5.tableCellMinWidth)) : (0, $6gEe5.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $6gEe5.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $afd30a44e5a88a9e$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let colgroup = tableRef?.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef?.removeChild(colgroup);
    colgroup = $afd30a44e5a88a9e$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
    if (shouldRemove) tableRef?.insertBefore(colgroup, tableRef?.firstChild);
    return colgroup.children;
};
const $afd30a44e5a88a9e$export$8c07f44cea64e3c7 = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return !!(0, $7vpuQ.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $afd30a44e5a88a9e$export$b44a013e4f554514 = $afd30a44e5a88a9e$export$8c07f44cea64e3c7;
const $afd30a44e5a88a9e$export$2878318085bf6dbf = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cellArray = (0, $7vpuQ.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $6gEe5.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $afd30a44e5a88a9e$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor) {
    const rendered = (0, $kCV8T.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$afd30a44e5a88a9e$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor)
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return rendered.dom;
}
const $afd30a44e5a88a9e$export$dc24345db4290451 = (table)=>{
    const map = (0, $uOUlv.TableMap).get(table);
    return map.width;
};
const $afd30a44e5a88a9e$export$e7ee55be67771d90 = (node)=>{
    const currentColumnCount = $afd30a44e5a88a9e$export$dc24345db4290451(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $9QiRG.COLUMN_MIN_WIDTH);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};

});
parcelRegister("9QiRG", function(module, exports) {

$parcel$export(module.exports, "COLUMN_MIN_WIDTH", () => $6c2dc0078caf299a$export$dd66abdcfb4bb2cf);
$parcel$export(module.exports, "TABLE_MAX_WIDTH", () => $6c2dc0078caf299a$export$8a91b25da594a758);
$parcel$export(module.exports, "FULL_WIDTH_EDITOR_CONTENT_WIDTH", () => $6c2dc0078caf299a$export$b5e6eff3efdc4860);
$parcel$export(module.exports, "MAX_SCALING_PERCENT", () => $6c2dc0078caf299a$export$e8dbf55270553cd3);
$parcel$export(module.exports, "MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION", () => $6c2dc0078caf299a$export$2e7c88a39ad490e6);
$parcel$export(module.exports, "TABLE_EDITOR_MARGIN", () => $6c2dc0078caf299a$export$7c8bcfa1d3f9af23);
$parcel$export(module.exports, "TABLE_OFFSET_IN_COMMENT_EDITOR", () => $6c2dc0078caf299a$export$c332ba2dd5aa2199);
const $6c2dc0078caf299a$export$dd66abdcfb4bb2cf = 48;
const $6c2dc0078caf299a$export$8a91b25da594a758 = 1800;
const $6c2dc0078caf299a$export$b5e6eff3efdc4860 = 1800;
const $6c2dc0078caf299a$export$e8dbf55270553cd3 = 0.3;
const $6c2dc0078caf299a$export$2e7c88a39ad490e6 = 0.4;
const $6c2dc0078caf299a$export$7c8bcfa1d3f9af23 = 76;
const $6c2dc0078caf299a$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $6c2dc0078caf299a$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $6c2dc0078caf299a$export$c332ba2dd5aa2199 = 2 * ($6c2dc0078caf299a$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $6c2dc0078caf299a$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);

});

parcelRegister("118VY", function(module, exports) {

$parcel$export(module.exports, "getLayoutSize", () => $0016e744446c9406$export$7bde9ac1d5d663fc);
$parcel$export(module.exports, "pointsAtCell", () => $0016e744446c9406$export$3c89e45c7dff9619);
$parcel$export(module.exports, "currentColWidth", () => $0016e744446c9406$export$8f862fd911e06936);
$parcel$export(module.exports, "getTableMaxWidth", () => $0016e744446c9406$export$8bfbafe1083a527d);
$parcel$export(module.exports, "getTableElementWidth", () => $0016e744446c9406$export$44361276769f7eff);
$parcel$export(module.exports, "getTableContainerElementWidth", () => $0016e744446c9406$export$a34136fcfaec1907);
$parcel$export(module.exports, "getTableScalingPercent", () => $0016e744446c9406$export$b2c142721a99201b);
$parcel$export(module.exports, "getScalingPercentForTableWithoutWidth", () => $0016e744446c9406$export$4e884677f8e54bba);
$parcel$export(module.exports, "getStaticTableScalingPercent", () => $0016e744446c9406$export$f9c5ace2959c7a33);

var $fKLIs = parcelRequire("fKLIs");

var $6gEe5 = parcelRequire("6gEe5");

var $5or39 = parcelRequire("5or39");

var $iHYdz = parcelRequire("iHYdz");

var $iQMCj = parcelRequire("iQMCj");

var $9QiRG = parcelRequire("9QiRG");
function $0016e744446c9406$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) return containerWidth ? Math.min(containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
    const calculatedTableWidth = (0, $6gEe5.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $fKLIs.layoutToWidth)[tableLayout] || containerWidth;
}
function $0016e744446c9406$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $0016e744446c9406$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    const width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $0016e744446c9406$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $fKLIs.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $0016e744446c9406$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $iHYdz.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $0016e744446c9406$export$44361276769f7eff = (table)=>{
    if ((0, $iQMCj.hasTableBeenResized)(table)) // TODO: ED-26961 - is there a scenario where ADF columns are SMALLER than container width?
    return (0, $5or39.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $0016e744446c9406$export$a34136fcfaec1907(table);
};
const $0016e744446c9406$export$a34136fcfaec1907 = (table)=>{
    return (0, $fKLIs.getTableContainerWidth)(table);
};
const $0016e744446c9406$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $9QiRG.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $9QiRG.MAX_SCALING_PERCENT);
    const tableWidth = $0016e744446c9406$export$a34136fcfaec1907(table);
    const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $0016e744446c9406$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $iQMCj.hasTableColumnBeenResized)(table)) {
        const tableWidth = (0, $5or39.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $0016e744446c9406$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $9QiRG.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $9QiRG.MAX_SCALING_PERCENT);
    const tableWidth = $0016e744446c9406$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};

});


parcelRegister("1SASl", function(module, exports) {

$parcel$export(module.exports, "getAlignmentStyle", () => $b55a49c6c19c3545$export$b4e2cb644a5e9e7e);

var $fkJZJ = parcelRequire("fkJZJ");
const $b55a49c6c19c3545$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $b55a49c6c19c3545$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $b55a49c6c19c3545$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $fkJZJ.ALIGN_START) ? $b55a49c6c19c3545$var$leftAlignStyle : $b55a49c6c19c3545$var$centerAlignStyle;

});
parcelRegister("fkJZJ", function(module, exports) {

$parcel$export(module.exports, "ALIGN_START", () => $6a95faa8e0b00632$export$2cbc54593c64b1f2);
$parcel$export(module.exports, "ALIGN_CENTER", () => $6a95faa8e0b00632$export$3ea9e188ab01c845);
$parcel$export(module.exports, "normaliseAlignment", () => $6a95faa8e0b00632$export$2e10df95acfe6933);
$parcel$export(module.exports, "shouldChangeAlignmentToCenterResized", () => $6a95faa8e0b00632$export$8dcb9bda5f25db3a);

var $9QiRG = parcelRequire("9QiRG");
const $6a95faa8e0b00632$export$2cbc54593c64b1f2 = 'align-start';
const $6a95faa8e0b00632$export$3ea9e188ab01c845 = 'center';
const $6a95faa8e0b00632$export$2e10df95acfe6933 = (layout)=>layout === $6a95faa8e0b00632$export$3ea9e188ab01c845 || layout === $6a95faa8e0b00632$export$2cbc54593c64b1f2 ? layout : $6a95faa8e0b00632$export$3ea9e188ab01c845;
const $6a95faa8e0b00632$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $6a95faa8e0b00632$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $9QiRG.FULL_WIDTH_EDITOR_CONTENT_WIDTH));

});



parcelRegister("6rgjS", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $9e250161adb7f6b1$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $5KWxh = parcelRequire("5KWxh");

var $66MHx = parcelRequire("66MHx");

var $eHLxx = parcelRequire("eHLxx");

var $avgz8 = parcelRequire("avgz8");

var $deOBG = parcelRequire("deOBG");

var $hD8zo = parcelRequire("hD8zo");
const $9e250161adb7f6b1$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $5KWxh.SafePlugin)({
        key: (0, $deOBG.pluginKey),
        state: (0, $avgz8.createPluginState)(dispatch, (0, $hD8zo.defaultState)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta((0, $deOBG.pluginKey))?.data?.currentActions?.includes('pasted'));
            if (tr) {
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $dEzej.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        type: tr.getMeta((0, $deOBG.pluginKey))?.data?.type
                    }
                });
                return (0, $eHLxx.resetRowOrColumnMovedTransform)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $66MHx.getTableElementMoveTypeBySlice)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $66MHx.isInsideFirstCellOfRowOrColumn)(state.selection, type)) return;
                const count = (0, $66MHx.countCellsInSlice)(slice, schema, type);
                (0, $eHLxx.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $66MHx.getTableSelectionType)(state.selection);
                const count = (0, $66MHx.countCellsInSlice)(slice, schema, type);
                (0, $eHLxx.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });

});
parcelRegister("66MHx", function(module, exports) {

$parcel$export(module.exports, "setEditorFocus", () => $312a0a8df8dc14c4$export$f516ed9c5f43abfc);
$parcel$export(module.exports, "setTableRef", () => $312a0a8df8dc14c4$export$79b661cbf50c3490);
$parcel$export(module.exports, "transformSliceRemoveCellBackgroundColor", () => $312a0a8df8dc14c4$export$f4e57bcfd514085d);
$parcel$export(module.exports, "transformSliceToAddTableHeaders", () => $312a0a8df8dc14c4$export$bb3294affcb5059f);
$parcel$export(module.exports, "transformSliceToRemoveColumnsWidths", () => $312a0a8df8dc14c4$export$8fcd87e05a98248e);
$parcel$export(module.exports, "countCellsInSlice", () => $312a0a8df8dc14c4$export$6dfa233a4abfaf9);
$parcel$export(module.exports, "getTableSelectionType", () => $312a0a8df8dc14c4$export$e5b37491e59cd9d);
$parcel$export(module.exports, "getTableElementMoveTypeBySlice", () => $312a0a8df8dc14c4$export$1798097ddb0b05de);
$parcel$export(module.exports, "isInsideFirstCellOfRowOrColumn", () => $312a0a8df8dc14c4$export$950c7c2913136ae5);
$parcel$export(module.exports, "deleteTable", () => $312a0a8df8dc14c4$export$4882f04e79ed0a80);
$parcel$export(module.exports, "deleteTableIfSelected", () => $312a0a8df8dc14c4$export$a853c8f1dbe33b1f);
$parcel$export(module.exports, "moveCursorBackward", () => $312a0a8df8dc14c4$export$f49961c90342f4db);
$parcel$export(module.exports, "setMultipleCellAttrs", () => $312a0a8df8dc14c4$export$91116982335533cf);
$parcel$export(module.exports, "selectColumn", () => $312a0a8df8dc14c4$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectColumns", () => $312a0a8df8dc14c4$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRow", () => $312a0a8df8dc14c4$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $312a0a8df8dc14c4$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "showInsertColumnButton", () => $312a0a8df8dc14c4$export$72433e6f15f8aeaa);
$parcel$export(module.exports, "showInsertRowButton", () => $312a0a8df8dc14c4$export$6ed6a4eb343cf21);
$parcel$export(module.exports, "hideInsertColumnOrRowButton", () => $312a0a8df8dc14c4$export$27d9631a056c3f39);
$parcel$export(module.exports, "addResizeHandleDecorations", () => $312a0a8df8dc14c4$export$cc6f44d67305c400);
$parcel$export(module.exports, "updateResizeHandleDecorations", () => $312a0a8df8dc14c4$export$31eed8673ceee613);
$parcel$export(module.exports, "removeResizeHandleDecorations", () => $312a0a8df8dc14c4$export$99c5230572e6696d);
$parcel$export(module.exports, "autoSizeTable", () => $312a0a8df8dc14c4$export$d6e5d8afaa172954);
$parcel$export(module.exports, "addBoldInEmptyHeaderCells", () => $312a0a8df8dc14c4$export$bf5ab08a5036bda8);
$parcel$export(module.exports, "updateWidthToWidest", () => $312a0a8df8dc14c4$export$833849b68219cbcc);
$parcel$export(module.exports, "setTableAlignment", () => $312a0a8df8dc14c4$export$e0cd4746386d78b5);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPos", () => $312a0a8df8dc14c4$export$2880e63de92f5116);
$parcel$export(module.exports, "setFocusToCellMenu", () => $312a0a8df8dc14c4$export$a6e5155a1ac72366);

var $ajpes = parcelRequire("ajpes");

var $fKLIs = parcelRequire("fKLIs");

var $eQcNy = parcelRequire("eQcNy");
var $20Kbb = parcelRequire("20Kbb");
var $594Yf = parcelRequire("594Yf");
var $7vpuQ = parcelRequire("7vpuQ");

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $l57lo = parcelRequire("l57lo");
var $fCttG = parcelRequire("fCttG");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");
var $cK1Lv = parcelRequire("cK1Lv");
var $i3UPz = parcelRequire("i3UPz");
var $bhEri = parcelRequire("bhEri");
var $22PoI = parcelRequire("22PoI");
var $bM6Pi = parcelRequire("bM6Pi");

var $jecUf = parcelRequire("jecUf");

var $5PQ8U = parcelRequire("5PQ8U");

var $jB7vb = parcelRequire("jB7vb");

var $gseSq = parcelRequire("gseSq");

var $i1dKX = parcelRequire("i1dKX");

var $9kb0R = parcelRequire("9kb0R");

var $evhdb = parcelRequire("evhdb");

var $fc5Ja = parcelRequire("fc5Ja");
const $312a0a8df8dc14c4$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $gseSq.createCommand)({
        type: 'SET_EDITOR_FOCUS',
        data: {
            editorHasFocus: editorHasFocus
        }
    });
const $312a0a8df8dc14c4$export$79b661cbf50c3490 = (ref)=>(0, $gseSq.createCommand)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $28MvW.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $eQcNy.closestElement)(tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $evhdb.checkIfNumberColumnEnabled)(state.selection),
                isHeaderRowEnabled: (0, $evhdb.checkIfHeaderRowEnabled)(state.selection),
                isHeaderColumnEnabled: (0, $evhdb.checkIfHeaderColumnEnabled)(state.selection),
                // decoration set is drawn by the decoration plugin, skip this for DnD as all controls are floating
                decorationSet: !isDragAndDropEnabled ? (0, $fc5Ja.updatePluginStateDecorations)(state, (0, $9kb0R.createColumnControlsDecoration)(state.selection), (0, $jecUf.TableDecorations).COLUMN_CONTROLS_DECORATIONS) : undefined,
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$c8d277469ceb354b = (name, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $hFEwm.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $22PoI.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter?.type, {
                    ...cell.nodeAfter?.attrs,
                    [name]: value
                }));
                return true;
            }
        }
        return false;
    };
const $312a0a8df8dc14c4$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $gZGBX.TextSelection)) {
            const cell = (0, $28MvW.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $hFEwm.CellSelection)) {
            const rect = (0, $b1RTQ.getSelectionRect)(selection);
            if (!(0, $evhdb.checkIfHeaderRowEnabled)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $312a0a8df8dc14c4$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $312a0a8df8dc14c4$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $312a0a8df8dc14c4$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $312a0a8df8dc14c4$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $312a0a8df8dc14c4$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $hFEwm.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $312a0a8df8dc14c4$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $28MvW.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $uOUlv.TableMap).get(currentTable.node);
        const slicedMap = (0, $uOUlv.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch (e) {
        return undefined;
    }
};
const $312a0a8df8dc14c4$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table || !type) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const map = (0, $uOUlv.TableMap).get(table.node);
    const cell = (0, $28MvW.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $312a0a8df8dc14c4$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $i3UPz.removeTable)(state.tr));
    return true;
};
const $312a0a8df8dc14c4$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) return $312a0a8df8dc14c4$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $312a0a8df8dc14c4$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $28MvW.findTable)(tr.selection);
        const map = (0, $uOUlv.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $312a0a8df8dc14c4$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $evhdb.isIsolating)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $evhdb.isIsolating)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
    ensure we're just at a top level paragraph
    otherwise, perform regular backspace behaviour
   */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $gZGBX.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $gZGBX.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $312a0a8df8dc14c4$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $gseSq.getPluginState)(state);
        if ((0, $iGxzn.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $bM6Pi.setCellAttrs)((0, $28MvW.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $28MvW.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $bM6Pi.setCellAttrs)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                if (cursorPos !== undefined) {
                    editorView?.focus();
                    tr.setSelection(new (0, $gZGBX.TextSelection)(tr.doc.resolve(cursorPos)));
                }
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $312a0a8df8dc14c4$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $gseSq.createCommand)((state)=>{
        const cells = (0, $l57lo.getCellsInColumn)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const decorations = (0, $9kb0R.createColumnSelectedDecoration)((0, $bhEri.selectColumn)(column, expand)(state.tr));
        const decorationSet = (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>(0, $bhEri.selectColumn)(column, expand)(tr).setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard));
const $312a0a8df8dc14c4$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $gseSq.createCommand)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $l57lo.getCellsInColumn)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $9kb0R.createColumnSelectedDecoration)((0, $bhEri.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $l57lo.getCellsInColumn)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $bhEri.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $312a0a8df8dc14c4$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $gseSq.createCommand)((state)=>{
        let targetCellPosition;
        const cells = (0, $fCttG.getCellsInRow)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $bhEri.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $312a0a8df8dc14c4$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $gseSq.createCommand)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $fCttG.getCellsInRow)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $fCttG.getCellsInRow)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $bhEri.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$72433e6f15f8aeaa = (columnIndex)=>(0, $gseSq.createCommand)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $gseSq.createCommand)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$27d9631a056c3f39 = ()=>(0, $gseSq.createCommand)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, nodeViewPortalProviderAPI, isKeyboardResize)=>(0, $gseSq.createCommand)((state)=>{
        const tableNode = (0, $28MvW.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $gseSq.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $jB7vb.buildColumnResizingDecorations)(rowIndex, columnIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $5PQ8U.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$31eed8673ceee613 = (nodeViewPortalProviderAPI, rowIndex, columnIndex, includeTooltip)=>(0, $gseSq.createCommand)((state)=>{
        const tableNode = (0, $28MvW.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $gseSq.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $jB7vb.buildColumnResizingDecorations)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $5PQ8U.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$99c5230572e6696d = ()=>(0, $gseSq.createCommand)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $jB7vb.clearColumnResizingDecorations)()({
                    tr: state.tr,
                    decorationSet: (0, $5PQ8U.getDecorations)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $312a0a8df8dc14c4$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $i1dKX.fixAutoSizedTable)(view, node, table, basePos, opts));
    return true;
};
const $312a0a8df8dc14c4$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $594Yf.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $20Kbb.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $312a0a8df8dc14c4$export$833849b68219cbcc = (widthToWidest)=>(0, $gseSq.createCommand)((state)=>{
        const { widthToWidest: prevWidthToWidest } = (0, $gseSq.getPluginState)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $312a0a8df8dc14c4$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $28MvW.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $fKLIs.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $312a0a8df8dc14c4$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $fKLIs.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $312a0a8df8dc14c4$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $gseSq.createCommand)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));

});
parcelRegister("l57lo", function(module, exports) {

$parcel$export(module.exports, "getCellsInColumn", () => $a78e188ef8639842$export$c14b77638b178c5d);

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
const $a78e188ef8639842$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return;
        const map = (0, $uOUlv.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("fCttG", function(module, exports) {

$parcel$export(module.exports, "getCellsInRow", () => $9f711dca1551152f$export$a804b6b4ce22aa92);

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
const $9f711dca1551152f$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return;
        const map = (0, $uOUlv.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("i3UPz", function(module, exports) {

$parcel$export(module.exports, "removeTable", () => $b2d24535c585f904$export$5b4a0d6329b35552);

var $8HJeP = parcelRequire("8HJeP");
const $b2d24535c585f904$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $8HJeP.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};

});
parcelRegister("8HJeP", function(module, exports) {

$parcel$export(module.exports, "cloneTr", () => $efed7c6fe461da0a$export$5add988076756575);
const $efed7c6fe461da0a$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());

});


parcelRegister("bhEri", function(module, exports) {

$parcel$export(module.exports, "selectColumn", () => $3db60baca696f514$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectRow", () => $3db60baca696f514$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $3db60baca696f514$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "selectColumns", () => $3db60baca696f514$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectTable", () => $3db60baca696f514$export$625c5b9bf13f01a8);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");
const $3db60baca696f514$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $28MvW.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $uOUlv.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $28MvW.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $3db60baca696f514$export$c2e8772deb1607ea = $3db60baca696f514$var$select('column');
const $3db60baca696f514$export$e247ed8cec4832f4 = $3db60baca696f514$var$select('row');
const $3db60baca696f514$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $28MvW.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $uOUlv.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
        };
const $3db60baca696f514$export$b5ba3b60192c7a8d = $3db60baca696f514$var$selectRowsOrColumns('rows');
const $3db60baca696f514$export$41a42e79fbe56d35 = $3db60baca696f514$var$selectRowsOrColumns('columns');
const $3db60baca696f514$export$625c5b9bf13f01a8 = (tr)=>{
    const table = (0, $28MvW.findTable)(tr.selection);
    if (table) {
        const { map: map } = (0, $uOUlv.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
const $3db60baca696f514$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    const table = (0, $28MvW.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $uOUlv.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8HJeP.cloneTr)(tr.setSelection(new (0, $hFEwm.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};

});

parcelRegister("bM6Pi", function(module, exports) {

$parcel$export(module.exports, "setCellAttrs", () => $b1a6d7935a9b5a82$export$aa21d3b96c1c378c);

var $8HJeP = parcelRequire("8HJeP");
const $b1a6d7935a9b5a82$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $8HJeP.cloneTr)(tr);
        }
        return tr;
    };

});

parcelRegister("5PQ8U", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $c76e17361503b1b6$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getDecorations", () => $c76e17361503b1b6$export$968abecb43309c32);
$parcel$export(module.exports, "createPlugin", () => $c76e17361503b1b6$export$ae829ec7b2625219);

var $kxM7f = parcelRequire("kxM7f");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $cPPiz = parcelRequire("cPPiz");

var $7rFMc = parcelRequire("7rFMc");

var $i7OwX = parcelRequire("i7OwX");
const $c76e17361503b1b6$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableDecorationsPlugin');
const $c76e17361503b1b6$export$968abecb43309c32 = (state)=>$c76e17361503b1b6$export$18d4026d1ea86bb1.getState(state);
const $c76e17361503b1b6$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    const isResizing = (0, $7rFMc.pluginKey).getState(newState)?.resizing;
    const wasResizing = (0, $7rFMc.pluginKey).getState(oldState)?.resizing;
    const { isDragAndDropEnabled: isDragAndDropEnabled = false, isInDanger: isInDanger, isTableHovered: isTableHovered } = (0, $cPPiz.pluginKey).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $etG8M.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $hFEwm.CellSelection) || changedResizing) return (0, $i7OwX.buildColumnControlsDecorations)({
        decorationSet: decorationSet,
        tr: tr,
        options: {
            isDragAndDropEnabled: isDragAndDropEnabled
        }
    });
    else if (tr.selectionSet) {
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $hFEwm.CellSelection)) return (0, $i7OwX.maybeUpdateColumnControlsSelectedDecoration)({
            decorationSet: decorationSet,
            tr: tr
        });
        if ((0, $VSDnB.fg)('platform_editor_remove_slow_table_transactions')) {
            // We're exiting a table with an existing decorations so we should clean it up
            if ((isInDanger || isTableHovered) && (!(0, $kxM7f.insideTable)(newState) || (0, $28MvW.findTable)(newState.selection)?.node !== (0, $28MvW.findTable)(oldState.selection)?.node)) return (0, $i7OwX.buildColumnControlsDecorations)({
                decorationSet: decorationSet,
                tr: tr,
                options: {
                    isDragAndDropEnabled: isDragAndDropEnabled
                }
            });
        }
    }
    return decorationSet;
};
const $c76e17361503b1b6$export$ae829ec7b2625219 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        state: {
            init: ()=>(0, $etG8M.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $cPPiz.pluginKey));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $7rFMc.pluginKey))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $c76e17361503b1b6$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $c76e17361503b1b6$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$c76e17361503b1b6$export$968abecb43309c32(state)
        }
    });
};

});
parcelRegister("cPPiz", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $65cec184f0d2cf8f$export$18d4026d1ea86bb1);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");
const $65cec184f0d2cf8f$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tablePlugin');

});

parcelRegister("7rFMc", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $61d131decdb49c4c$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $61d131decdb49c4c$export$ae829ec7b2625219);
/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $2gIj5 = parcelRequire("2gIj5");

var $5KWxh = parcelRequire("5KWxh");

var $ggL2v = parcelRequire("ggL2v");

var $gZGBX = parcelRequire("gZGBX");

var $iHYdz = parcelRequire("iHYdz");

var $9QiRG = parcelRequire("9QiRG");

var $fkJZJ = parcelRequire("fkJZJ");
const $61d131decdb49c4c$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableWidthPlugin');
const $61d131decdb49c4c$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $61d131decdb49c4c$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($61d131decdb49c4c$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($61d131decdb49c4c$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = (0, $ggL2v.isReplaceDocOperation)(transactions, oldState);
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (fullWidthEnabled) tableWidthCal = (0, $iHYdz.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $iHYdz.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $iHYdz.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $iHYdz.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $2gIj5.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== (0, $9QiRG.TABLE_MAX_WIDTH)) tr.setNodeAttribute(pos, 'width', (0, $9QiRG.TABLE_MAX_WIDTH));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $fkJZJ.ALIGN_START));
                        }
                    });
                });
            });
            return tr;
        }
    });
};

});
parcelRegister("2gIj5", function(module, exports) {

$parcel$export(module.exports, "SetAttrsStep", () => $1a6f71c955cd80a7$export$8cfd0a0bfa522949);

var $eS2Dn = parcelRequire("eS2Dn");

var $kCV8T = parcelRequire("kCV8T");
class $1a6f71c955cd80a7$export$8cfd0a0bfa522949 extends (0, $eS2Dn.Step) {
    constructor(pos, attrs){
        super();
        this.pos = pos;
        this.attrs = attrs;
    }
    apply(doc) {
        let target = doc.nodeAt(this.pos);
        if (!target) return (0, $eS2Dn.StepResult).fail('No node at given position');
        if (target.isText) return (0, $eS2Dn.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        let newNode = target.type.create(attrs, (0, $kCV8T.Fragment).empty, target.marks);
        let slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $eS2Dn.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        let target = doc.nodeAt(this.pos);
        return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        let result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
}
(0, $eS2Dn.Step).jsonID('setAttrs', $1a6f71c955cd80a7$export$8cfd0a0bfa522949);

});


parcelRegister("i7OwX", function(module, exports) {

$parcel$export(module.exports, "maybeUpdateColumnControlsSelectedDecoration", () => $c0749fbaa269934c$export$cbb3730335eda2fb);
$parcel$export(module.exports, "buildColumnControlsDecorations", () => $c0749fbaa269934c$export$967c329e5e466f2);
// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck

var $hFEwm = parcelRequire("hFEwm");

var $28MvW = parcelRequire("28MvW");

var $jecUf = parcelRequire("jecUf");

var $9kb0R = parcelRequire("9kb0R");

var $2E7DP = parcelRequire("2E7DP");
const $c0749fbaa269934c$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $hFEwm.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $c0749fbaa269934c$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9kb0R.findControlsHoverDecoration)(decorationSet));
const $c0749fbaa269934c$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$c0749fbaa269934c$var$isColumnSelected(tr)) return decorationSet;
    return (0, $9kb0R.updateDecorations)(tr.doc, decorationSet, (0, $9kb0R.createColumnSelectedDecoration)(tr), (0, $jecUf.TableDecorations).COLUMN_SELECTED);
};
const $c0749fbaa269934c$var$maybeUpdateColumnControlsDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    const table = (0, $28MvW.findTable)(tr.selection);
    if (!table) return decorationSet;
    return (0, $9kb0R.updateDecorations)(tr.doc, decorationSet, (0, $9kb0R.createColumnControlsDecoration)(tr.selection), (0, $jecUf.TableDecorations).COLUMN_CONTROLS_DECORATIONS);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $c0749fbaa269934c$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9kb0R.findColumnControlSelectedDecoration)(decorationSet));
const $c0749fbaa269934c$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $9kb0R.findColumnControlSelectedDecoration)(decorationSet).length;
const $c0749fbaa269934c$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$c0749fbaa269934c$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $c0749fbaa269934c$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $c0749fbaa269934c$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr, options: options })=>{
    if (options.isDragAndDropEnabled) return (0, $2E7DP.composeDecorations)([
        $c0749fbaa269934c$var$removeColumnControlsSelectedDecoration,
        $c0749fbaa269934c$var$removeControlsHoverDecoration,
        $c0749fbaa269934c$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
    return (0, $2E7DP.composeDecorations)([
        $c0749fbaa269934c$var$removeColumnControlsSelectedDecoration,
        $c0749fbaa269934c$var$removeControlsHoverDecoration,
        $c0749fbaa269934c$var$maybeUpdateColumnSelectedDecoration,
        $c0749fbaa269934c$var$maybeUpdateColumnControlsDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};

});
parcelRegister("9kb0R", function(module, exports) {

$parcel$export(module.exports, "findColumnControlSelectedDecoration", () => $d8b5eab36f34ebaa$export$8042b574593bd713);
$parcel$export(module.exports, "findControlsHoverDecoration", () => $d8b5eab36f34ebaa$export$6577d2f7fe84e45c);
$parcel$export(module.exports, "createCellHoverDecoration", () => $d8b5eab36f34ebaa$export$e1f7dd2d4ed6c778);
$parcel$export(module.exports, "createControlsHoverDecoration", () => $d8b5eab36f34ebaa$export$ecf836094c108a0);
$parcel$export(module.exports, "createColumnSelectedDecoration", () => $d8b5eab36f34ebaa$export$9bd7e7efc13bb839);
$parcel$export(module.exports, "createColumnControlsDecoration", () => $d8b5eab36f34ebaa$export$fbcaf99fd4d31ced);
$parcel$export(module.exports, "updateDecorations", () => $d8b5eab36f34ebaa$export$77a59c867f92cbc7);
$parcel$export(module.exports, "createResizeHandleDecoration", () => $d8b5eab36f34ebaa$export$dab489ad285db87);
$parcel$export(module.exports, "createColumnLineResize", () => $d8b5eab36f34ebaa$export$c1faae7fcf0653ce);
$parcel$export(module.exports, "createColumnInsertLine", () => $d8b5eab36f34ebaa$export$6012cbb334f87faa);
$parcel$export(module.exports, "createRowInsertLine", () => $d8b5eab36f34ebaa$export$c47f6da2c2a0ebc8);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bXrHm = parcelRequire("bXrHm");

var $594Yf = parcelRequire("594Yf");

var $etG8M = parcelRequire("etG8M");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $fCttG = parcelRequire("fCttG");
var $b1RTQ = parcelRequire("b1RTQ");

var $jecUf = parcelRequire("jecUf");

var $j7ezv = parcelRequire("j7ezv");
const $d8b5eab36f34ebaa$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $d8b5eab36f34ebaa$export$8042b574593bd713 = (decorationSet)=>$d8b5eab36f34ebaa$var$filterDecorationByKey((0, $jecUf.TableDecorations).COLUMN_SELECTED, decorationSet);
const $d8b5eab36f34ebaa$export$6577d2f7fe84e45c = (decorationSet)=>$d8b5eab36f34ebaa$var$filterDecorationByKey((0, $jecUf.TableDecorations).ALL_CONTROLS_HOVER, decorationSet);
const $d8b5eab36f34ebaa$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $etG8M.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $jecUf.TableCssClassName).HOVERED_CELL_WARNING
        }, {
            key: (0, $jecUf.TableDecorations).CELL_CONTROLS_HOVER
        }));
const $d8b5eab36f34ebaa$export$ecf836094c108a0 = (cells, type, tr, isDragAndDropEnable, hoveredIndexes, danger, selected)=>{
    const table = (0, $28MvW.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $uOUlv.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $28MvW.findTable)(selection);
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $jecUf.TableCssClassName).HOVERED_CELL
        ];
        if (danger) classes.push((0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $jecUf.TableCssClassName).SELECTED_CELL);
        if (isDragAndDropEnable) {
            if (type === 'column' || type === 'row') {
                classes.pop();
                classes.push((0, $jecUf.TableCssClassName).HOVERED_NO_HIGHLIGHT);
            }
        } else classes.push(type === 'column' ? (0, $jecUf.TableCssClassName).HOVERED_COLUMN : type === 'row' ? (0, $jecUf.TableCssClassName).HOVERED_ROW : (0, $jecUf.TableCssClassName).HOVERED_TABLE);
        let key;
        switch(type){
            case 'row':
                key = (0, $jecUf.TableDecorations).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $jecUf.TableDecorations).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $jecUf.TableDecorations).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $etG8M.Decoration).node(pos, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $d8b5eab36f34ebaa$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $28MvW.findTable)(selection);
    const rect = (0, $b1RTQ.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $uOUlv.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $etG8M.Decoration).node(pos + table.start, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + table.start + cell.nodeSize, {
            class: (0, $jecUf.TableCssClassName).COLUMN_SELECTED
        }, {
            key: `${(0, $jecUf.TableDecorations).COLUMN_SELECTED}_${index}`
        });
    });
};
const $d8b5eab36f34ebaa$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $fCttG.getCellsInRow)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $etG8M.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $jecUf.TableDecorations).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $d8b5eab36f34ebaa$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $d8b5eab36f34ebaa$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $d8b5eab36f34ebaa$var$makeArray = (n)=>Array.from(Array(n).keys());
const $d8b5eab36f34ebaa$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl, nodeViewPortalProviderAPI)=>{
    const emptyResult = [
        [],
        []
    ];
    const table = (0, $28MvW.findTable)(tr.selection);
    if (!table || !table.node) return emptyResult;
    const map = (0, $uOUlv.TableMap).get(table.node);
    if (!map.width) return emptyResult;
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $etG8M.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            nodeViewPortalProviderAPI.render(()=>(0, $5uXOq.createElement)((0, $8RXs9.Provider), {
                    value: getIntl()
                }, (0, $5uXOq.createElement)((0, $j7ezv.ColumnResizeWidget), {
                    startIndex: cellColumnPositioning.left,
                    endIndex: cellColumnPositioning.right,
                    includeTooltip: includeTooltip
                })), element, decorationRenderKey);
            return element;
        }, {
            key: `${(0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (node)=>{
                nodeViewPortalProviderAPI.remove(decorationRenderKey);
            }
        });
    };
    const createLastCellElementDecoration = (cellColumnPositioning, cellPos, cellNode)=>{
        let lastItemPositions;
        cellNode.forEach((childNode, offset, index)=>{
            if (index === cellNode.childCount - 1) {
                const from = offset + cellPos + 1;
                lastItemPositions = {
                    from: from,
                    to: from + childNode.nodeSize
                };
            }
        });
        if (!lastItemPositions) return null;
        return (0, $etG8M.Decoration).node(lastItemPositions.from, lastItemPositions.to, {
            class: (0, $jecUf.TableCssClassName).LAST_ITEM_IN_CELL
        }, {
            key: `${(0, $jecUf.TableDecorations).LAST_CELL_ELEMENT}_${cellColumnPositioning.left}_${cellColumnPositioning.right}`
        });
    };
    const resizeHandleCellDecorations = [];
    const lastCellElementsDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            const lastCellDec = createLastCellElementDecoration({
                left: startIndex,
                right: endIndex
            }, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
            lastCellElementsDecorations.push(lastCellDec);
        }
    }
    return [
        resizeHandleCellDecorations,
        lastCellElementsDecorations.filter((0, $594Yf.nonNullable))
    ];
};
const $d8b5eab36f34ebaa$export$c1faae7fcf0653ce = (selection, cellColumnPositioning, isDragAndDropEnabled)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $uOUlv.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isDragAndDropEnabled ? isLastColumn ? (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN : (0, $jecUf.TableCssClassName).WITH_DRAG_RESIZE_LINE : isLastColumn ? (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN : (0, $jecUf.TableCssClassName).WITH_RESIZE_LINE;
    const cellPositions = $d8b5eab36f34ebaa$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $etG8M.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $594Yf.nonNullable));
};
const $d8b5eab36f34ebaa$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table) return [];
    const map = (0, $uOUlv.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $jecUf.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $jecUf.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE : (0, $jecUf.TableCssClassName).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $d8b5eab36f34ebaa$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $etG8M.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $jecUf.TableDecorations).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $594Yf.nonNullable));
};
const $d8b5eab36f34ebaa$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table) return [];
    const map = (0, $uOUlv.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $fCttG.getCellsInRow)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $jecUf.TableCssClassName).WITH_LAST_ROW_INSERT_LINE : (0, $jecUf.TableCssClassName).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $etG8M.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $jecUf.TableDecorations).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $594Yf.nonNullable));
};

});
parcelRegister("j7ezv", function(module, exports) {

$parcel$export(module.exports, "ColumnResizeWidget", () => $850a4097ad449861$export$e84bed3a1e3da852);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $e9qoo = parcelRequire("e9qoo");

var $2V0EL = parcelRequire("2V0EL");

var $3bDjY = parcelRequire("3bDjY");

var $jecUf = parcelRequire("jecUf");
const $850a4097ad449861$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: formatMessage((0, $2V0EL.messages).adjustColumns),
            keymap: (0, $e9qoo.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};

});


parcelRegister("2E7DP", function(module, exports) {

$parcel$export(module.exports, "composeDecorations", () => $9bdda30ca5904dab$export$c3909dd6d9555879);
const $9bdda30ca5904dab$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);

});



parcelRegister("jB7vb", function(module, exports) {

$parcel$export(module.exports, "buildColumnResizingDecorations", () => $7efae06f1ea9cd1a$export$aa1fe977609f5606);
$parcel$export(module.exports, "clearColumnResizingDecorations", () => $7efae06f1ea9cd1a$export$a590d16867e1babd);

var $jecUf = parcelRequire("jecUf");

var $9kb0R = parcelRequire("9kb0R");

var $2E7DP = parcelRequire("2E7DP");
const $7efae06f1ea9cd1a$var$emptyDecorations = [
    [],
    []
];
const $7efae06f1ea9cd1a$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $9kb0R.updateDecorations)(tr.doc, decorationSet, columnResizesDecorations, (0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET);
const $7efae06f1ea9cd1a$var$updateLastCellElement = (lastCellElementsDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $9kb0R.updateDecorations)(tr.doc, decorationSet, lastCellElementsDecorations, (0, $jecUf.TableDecorations).LAST_CELL_ELEMENT);
const $7efae06f1ea9cd1a$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = columnEndIndex < 0 ? $7efae06f1ea9cd1a$var$emptyDecorations : (0, $9kb0R.createResizeHandleDecoration)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl, nodeViewPortalProviderAPI);
        return (0, $2E7DP.composeDecorations)([
            $7efae06f1ea9cd1a$var$updateColumnResizeHandle(columnResizesDecorations),
            $7efae06f1ea9cd1a$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $7efae06f1ea9cd1a$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = $7efae06f1ea9cd1a$var$emptyDecorations;
        return (0, $2E7DP.composeDecorations)([
            $7efae06f1ea9cd1a$var$updateColumnResizeHandle(columnResizesDecorations),
            $7efae06f1ea9cd1a$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };

});

parcelRegister("gseSq", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $fcf88e3d36eae8c1$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $fcf88e3d36eae8c1$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $fcf88e3d36eae8c1$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $2tOaZ = parcelRequire("2tOaZ");

var $cPPiz = parcelRequire("cPPiz");

var $7OiDj = parcelRequire("7OiDj");
const { createPluginState: $fcf88e3d36eae8c1$export$656c7661095efe2e, createCommand: $fcf88e3d36eae8c1$export$8d4021544bdece00, getPluginState: $fcf88e3d36eae8c1$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $cPPiz.pluginKey), (0, $7OiDj.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $2tOaZ.handleDocOrSelectionChanged),
    onSelectionChanged: (0, $2tOaZ.handleDocOrSelectionChanged)
});

});
parcelRegister("2tOaZ", function(module, exports) {

$parcel$export(module.exports, "handleDocOrSelectionChanged", () => $55d04a45987da2c9$export$a9962e3214ca2ff7);
// #region Imports

var $5ZnzP = parcelRequire("5ZnzP");

var $lGkyv = parcelRequire("lGkyv");

var $5r0mK = parcelRequire("5r0mK");

var $28MvW = parcelRequire("28MvW");

var $eKJcE = parcelRequire("eKJcE");

var $k8KvZ = parcelRequire("k8KvZ");

var $4MKI8 = parcelRequire("4MKI8");

var $evhdb = parcelRequire("evhdb");
const $55d04a45987da2c9$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $5ZnzP.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $55d04a45987da2c9$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $k8KvZ.pluginKey))) return undefined;
    return resizeHandleColumnIndex;
};
const $55d04a45987da2c9$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $5r0mK.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        if (pluginState.targetCellPosition === targetCellPosition) return pluginState;
        return {
            ...pluginState,
            targetCellPosition: targetCellPosition
        };
    };
const $55d04a45987da2c9$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $lGkyv.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $eKJcE.defaultTableSelection),
            tableNode: tableNode,
            ordering: $55d04a45987da2c9$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $55d04a45987da2c9$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $evhdb.checkIfNumberColumnEnabled)(tr.selection),
            isHeaderColumnEnabled: (0, $evhdb.checkIfHeaderColumnEnabled)(tr.selection),
            isHeaderRowEnabled: (0, $evhdb.checkIfHeaderRowEnabled)(tr.selection)
        };
    };
const $55d04a45987da2c9$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
		 * If we don't have focus, or collapse isn't allowed, or a table node doesn't
		 * exist, we don't need to waste extra checks below
		 */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $5r0mK.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $4MKI8.isTableCollapsible)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $55d04a45987da2c9$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) return pluginState.targetCellPosition ? {
                ...pluginState,
                targetCellPosition: undefined
            } : pluginState;
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $55d04a45987da2c9$export$a9962e3214ca2ff7 = (tr, pluginState)=>$55d04a45987da2c9$var$buildPluginState([
        $55d04a45987da2c9$var$updateTargetCellPosition,
        $55d04a45987da2c9$var$updateTableNodePluginState,
        $55d04a45987da2c9$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $28MvW.findTable)(tr.selection)
    })(pluginState);

});
parcelRegister("5ZnzP", function(module, exports) {

$parcel$export(module.exports, "TableSortStep", () => $9b15ba5eea984bbe$export$c1b7e6427b2a2113);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");parcelRequire("c3rYx");
var $eS2Dn = parcelRequire("eS2Dn");
const $9b15ba5eea984bbe$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $9b15ba5eea984bbe$export$c1b7e6427b2a2113 extends (0, $eS2Dn.Step) {
    constructor(pos, prev, next){
        super();
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
    invert() {
        return new $9b15ba5eea984bbe$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $eS2Dn.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $eS2Dn.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $9b15ba5eea984bbe$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $eS2Dn.ReplaceStep)(0, 0, (0, $kCV8T.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $eS2Dn.Step).jsonID($9b15ba5eea984bbe$export$3f33e36adb7672cc, $9b15ba5eea984bbe$export$c1b7e6427b2a2113);

});
parcelRegister("c3rYx", function(module, exports) {

$parcel$export(module.exports, "Step", () => (parcelRequire("eS2Dn")).Step);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $8c6b772f0b7d41ed$var$originalFromJSON = (0, $eS2Dn.Step).fromJSON;
(0, $eS2Dn.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $8c6b772f0b7d41ed$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $VSDnB.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});


parcelRegister("eKJcE", function(module, exports) {

$parcel$export(module.exports, "defaultTableSelection", () => $6f24b282436c2a42$export$af473ce758096273);
$parcel$export(module.exports, "defaultHoveredCell", () => $6f24b282436c2a42$export$4c0699e9a8272521);
const $6f24b282436c2a42$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $6f24b282436c2a42$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};

});

parcelRegister("k8KvZ", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $2ef9fc49a65d3f8e$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $2ef9fc49a65d3f8e$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableFlexiColumnResizing');

});

parcelRegister("4MKI8", function(module, exports) {

$parcel$export(module.exports, "isTableCollapsible", () => $0a7002d155dd92bd$export$34840b5e3787a37c);
$parcel$export(module.exports, "collapseSelectedTable", () => $0a7002d155dd92bd$export$436c9f28d887a0c3);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");

var $28MvW = parcelRequire("28MvW");
const $0a7002d155dd92bd$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $0a7002d155dd92bd$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $28MvW.findTable)(selection);
    if (!nodePos) return $0a7002d155dd92bd$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $kCV8T.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $0a7002d155dd92bd$var$bail();
    const canWrap = (0, $eS2Dn.findWrapping)(range, expand);
    if (canWrap === null) return $0a7002d155dd92bd$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
		 * Do we ever want to deal with the result of `findWrapping`? Probably not,
		 * but we have it anyway.
		 */ findWrappingRes: canWrap
    };
};
const $0a7002d155dd92bd$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $0a7002d155dd92bd$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
	 * TODO: add attrs: { __expanded: false } when
	 * - it is working with new collab (CEMS-1204)
	 * - synchrony is no longer used
	 *
	 *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
	 *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
	 */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};

});

parcelRegister("evhdb", function(module, exports) {

$parcel$export(module.exports, "isIsolating", () => $5c1d0015c6a39d52$export$b75dc620676872cc);
$parcel$export(module.exports, "containsHeaderColumn", () => $5c1d0015c6a39d52$export$a21ded6c12f16fdf);
$parcel$export(module.exports, "containsHeaderRow", () => $5c1d0015c6a39d52$export$86a810659e2d575);
$parcel$export(module.exports, "checkIfHeaderColumnEnabled", () => $5c1d0015c6a39d52$export$653b4f383b39a1d0);
$parcel$export(module.exports, "checkIfHeaderRowEnabled", () => $5c1d0015c6a39d52$export$b8efdc0183f04d59);
$parcel$export(module.exports, "checkIfNumberColumnEnabled", () => $5c1d0015c6a39d52$export$101f2696d8127fe0);
$parcel$export(module.exports, "getTableWidth", () => $5c1d0015c6a39d52$export$4910020ffe58186f);
$parcel$export(module.exports, "tablesHaveDifferentColumnWidths", () => $5c1d0015c6a39d52$export$8f2a10e9b102ac33);
$parcel$export(module.exports, "tablesHaveDifferentNoOfColumns", () => $5c1d0015c6a39d52$export$bc84d95d2dfa63bf);
$parcel$export(module.exports, "tablesHaveDifferentNoOfRows", () => $5c1d0015c6a39d52$export$8fe872ff9fc9b477);
$parcel$export(module.exports, "isTableNested", () => $5c1d0015c6a39d52$export$d4302a800316ebd6);
$parcel$export(module.exports, "isTableNestedInMoreThanOneNode", () => $5c1d0015c6a39d52$export$e31912a493829c23);
$parcel$export(module.exports, "supportedHeaderRow", () => $5c1d0015c6a39d52$export$4af45fdaadf67b18);

var $7vpuQ = parcelRequire("7vpuQ");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
const $5c1d0015c6a39d52$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $5c1d0015c6a39d52$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $uOUlv.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch (e) {
        return false;
    }
    return true;
};
const $5c1d0015c6a39d52$export$86a810659e2d575 = (table)=>{
    const map = (0, $uOUlv.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $5c1d0015c6a39d52$export$653b4f383b39a1d0 = (selection)=>$5c1d0015c6a39d52$var$filterNearSelection(selection, (0, $28MvW.findTable), $5c1d0015c6a39d52$export$a21ded6c12f16fdf, false);
const $5c1d0015c6a39d52$export$b8efdc0183f04d59 = (selection)=>$5c1d0015c6a39d52$var$filterNearSelection(selection, (0, $28MvW.findTable), $5c1d0015c6a39d52$export$86a810659e2d575, false);
const $5c1d0015c6a39d52$export$101f2696d8127fe0 = (selection)=>$5c1d0015c6a39d52$var$filterNearSelection(selection, (0, $28MvW.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $5c1d0015c6a39d52$export$4910020ffe58186f = (node)=>{
    return $5c1d0015c6a39d52$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $5c1d0015c6a39d52$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    const currentTableWidths = $5c1d0015c6a39d52$var$getTableWidths(currentTable);
    const previousTableWidths = $5c1d0015c6a39d52$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $5c1d0015c6a39d52$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $uOUlv.TableMap).get(previousTable);
    const currentMap = (0, $uOUlv.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $5c1d0015c6a39d52$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $uOUlv.TableMap).get(previousTable);
    const currentMap = (0, $uOUlv.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $5c1d0015c6a39d52$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $5c1d0015c6a39d52$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    const tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $5c1d0015c6a39d52$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const parent = state.doc.resolve(tablePos).parent;
    const nodeTypes = state.schema.nodes;
    return parent.type === nodeTypes.layoutColumn || parent.type === nodeTypes.expand || parent.type === nodeTypes.bodiedExtension || parent.type === nodeTypes.extensionFrame || parent.type === nodeTypes.tableHeader || parent.type === nodeTypes.tableCell;
};
const $5c1d0015c6a39d52$export$e31912a493829c23 = (state, tablePos = 0)=>{
    return state.doc.resolve(tablePos).depth > 2;
};
const $5c1d0015c6a39d52$var$anyChildCellMergedAcrossRow = (node)=>(0, $7vpuQ.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $5c1d0015c6a39d52$export$4af45fdaadf67b18 = (node)=>{
    const allHeaders = (0, $7vpuQ.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    const someMerged = $5c1d0015c6a39d52$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};

});


parcelRegister("7OiDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c15610b0897581a5$export$2e2bcd8739ae039);

var $eKJcE = parcelRequire("eKJcE");
var $c15610b0897581a5$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $eKJcE.defaultTableSelection)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};

});


parcelRegister("i1dKX", function(module, exports) {

$parcel$export(module.exports, "fixTables", () => $2d15fecc8a8bdd95$export$d6d48849d9121a1);
$parcel$export(module.exports, "fixAutoSizedTable", () => $2d15fecc8a8bdd95$export$8d491ebb055c561d);

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $9k1tn = parcelRequire("9k1tn");

var $aAqz9 = parcelRequire("aAqz9");

var $118VY = parcelRequire("118VY");
const $2d15fecc8a8bdd95$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $2d15fecc8a8bdd95$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = $2d15fecc8a8bdd95$var$replaceCells(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $2d15fecc8a8bdd95$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $2d15fecc8a8bdd95$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $2d15fecc8a8bdd95$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $2d15fecc8a8bdd95$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $2d15fecc8a8bdd95$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $2d15fecc8a8bdd95$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $118VY.getLayoutSize)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = $2d15fecc8a8bdd95$var$replaceCells(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $2d15fecc8a8bdd95$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $iHYdz.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $iHYdz.akEditorDefaultLayoutWidth) && totalWidth < (0, $iHYdz.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $2d15fecc8a8bdd95$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    const cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $9k1tn.getCellsRefsInColumn)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $9k1tn.calculateColumnWidth)(cells, (_, col)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return (0, $aAqz9.contentWidth)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $6gEe5.tableCellMinWidth));
        }
    }
    return cols;
}
// TODO: ED-26961 - move to prosemirror-utils
const $2d15fecc8a8bdd95$var$replaceCells = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // TODO: ED-26961 - The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};

});
parcelRegister("9k1tn", function(module, exports) {

$parcel$export(module.exports, "getColumnStateFromDOM", () => $cc78dcedc8a0da45$export$5c09bfb77c404ce);
$parcel$export(module.exports, "calculateColumnWidth", () => $cc78dcedc8a0da45$export$8c54458430be6d1d);
$parcel$export(module.exports, "getFreeSpace", () => $cc78dcedc8a0da45$export$529a1befd331574);
$parcel$export(module.exports, "getCellsRefsInColumn", () => $cc78dcedc8a0da45$export$43e8ce817a8e5c42);

var $6gEe5 = parcelRequire("6gEe5");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $aAqz9 = parcelRequire("aAqz9");

var $7qQu3 = parcelRequire("7qQu3");
const $cc78dcedc8a0da45$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $cc78dcedc8a0da45$export$8c54458430be6d1d(cells, $cc78dcedc8a0da45$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? (0, $6gEe5.tableNewColumnMinWidth) : $cc78dcedc8a0da45$export$8c54458430be6d1d(cells, $cc78dcedc8a0da45$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $6gEe5.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $cc78dcedc8a0da45$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $cc78dcedc8a0da45$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $uOUlv.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const col = (0, $5r0mK.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $cc78dcedc8a0da45$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $cc78dcedc8a0da45$export$8a19622c99267fdf = (amount, css)=>amount + (0, $7qQu3.unitToNumber)(css.paddingLeft) + (0, $7qQu3.unitToNumber)(css.paddingRight);
function $cc78dcedc8a0da45$var$calculateColumnWidthCallback(css) {
    return (0, $7qQu3.unitToNumber)(css.width);
}
function $cc78dcedc8a0da45$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $7qQu3.unitToNumber)(css.width);
        const { minWidth: minContentWidth } = (0, $aAqz9.contentWidth)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($cc78dcedc8a0da45$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}

});
parcelRegister("aAqz9", function(module, exports) {

$parcel$export(module.exports, "contentWidth", () => $32a65b696cdee647$export$698d25a635a3873a);

var $7qQu3 = parcelRequire("7qQu3");
function $32a65b696cdee647$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $32a65b696cdee647$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $32a65b696cdee647$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $32a65b696cdee647$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $32a65b696cdee647$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO: ED-26961 - There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // TODO: ED-26961 - doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $7qQu3.unitToNumber)(style.minWidth));
            const { width: width } = $32a65b696cdee647$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $32a65b696cdee647$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $32a65b696cdee647$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlaskit/editor/no-as-casting
    parent = node.parentNode;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($32a65b696cdee647$var$measureText(canvas, current, font), acc), 0);
    return $32a65b696cdee647$var$measureText(canvas, textContent, font);
}

});
parcelRegister("7qQu3", function(module, exports) {

$parcel$export(module.exports, "unitToNumber", () => $036f18e002fedc0b$export$d486eb5767febcd9);
const $036f18e002fedc0b$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;

});




parcelRegister("fc5Ja", function(module, exports) {

$parcel$export(module.exports, "updatePluginStateDecorations", () => $e36f0b575e0319fa$export$884c674a282996e7);

var $5PQ8U = parcelRequire("5PQ8U");

var $9kb0R = parcelRequire("9kb0R");
const $e36f0b575e0319fa$export$884c674a282996e7 = (state, decorations, key)=>(0, $9kb0R.updateDecorations)(state.doc, (0, $5PQ8U.getDecorations)(state), decorations, key);

});


parcelRegister("eHLxx", function(module, exports) {

$parcel$export(module.exports, "updateRowOrColumnMoved", () => $ffe4d01eae5c4e9d$export$7edd58207362eb7c);
$parcel$export(module.exports, "resetRowOrColumnMovedTransform", () => $ffe4d01eae5c4e9d$export$39ebe85f9f5fbe7e);
$parcel$export(module.exports, "updateRowOrColumnMovedTransform", () => $ffe4d01eae5c4e9d$export$800a77929fdae774);

var $2TWcb = parcelRequire("2TWcb");

var $avgz8 = parcelRequire("avgz8");

var $deOBG = parcelRequire("deOBG");

var $bsG3o = parcelRequire("bsG3o");
const $ffe4d01eae5c4e9d$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $avgz8.createCommand)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $avgz8.getPluginState)(state);
        const data = (0, $bsG3o.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $2TWcb.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $ffe4d01eae5c4e9d$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $2TWcb.AnalyticPluginTypes).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $deOBG.pluginKey), payload);
    };
const $ffe4d01eae5c4e9d$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $avgz8.getPluginState)(state);
        const data = (0, $bsG3o.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $2TWcb.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $deOBG.pluginKey), payload);
    };

});
parcelRegister("2TWcb", function(module, exports) {

$parcel$export(module.exports, "AnalyticPluginTypes", () => $1aa3860ade0225dc$export$4e6e4e454d4dbb37);
var $1aa3860ade0225dc$export$4e6e4e454d4dbb37 = /*#__PURE__*/ function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
    return AnalyticPluginTypes;
}({});

});

parcelRegister("avgz8", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $eee40a9041453d18$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $eee40a9041453d18$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $eee40a9041453d18$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $deOBG = parcelRequire("deOBG");

var $4H7ze = parcelRequire("4H7ze");
const { createPluginState: $eee40a9041453d18$export$656c7661095efe2e, createCommand: $eee40a9041453d18$export$8d4021544bdece00, getPluginState: $eee40a9041453d18$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $deOBG.pluginKey), (0, $4H7ze.reducer));

});
parcelRegister("deOBG", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $7138ac8bc39880f3$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $7138ac8bc39880f3$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableAnalyticPlugin');

});

parcelRegister("4H7ze", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $d103000a29d32035$export$1650419e431d3ba3);

var $2TWcb = parcelRequire("2TWcb");

var $hD8zo = parcelRequire("hD8zo");
const $d103000a29d32035$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $2TWcb.AnalyticPluginTypes).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $2TWcb.AnalyticPluginTypes).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $hD8zo.defaultState).rowOrColumnMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("hD8zo", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $51fd8c9efaf6edd3$export$49d5fc8cba920a0);
const $51fd8c9efaf6edd3$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};

});



parcelRegister("bsG3o", function(module, exports) {

$parcel$export(module.exports, "getMovedPayload", () => $45c9107cd3ea49f3$export$245979e0371ee049);

var $hD8zo = parcelRequire("hD8zo");
const $45c9107cd3ea49f3$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $45c9107cd3ea49f3$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $45c9107cd3ea49f3$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $hD8zo.defaultState).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells || prevState.numberOfCells,
        type: nextState?.type
    };
};

});



parcelRegister("4aKeM", function(module, exports) {

$parcel$export(module.exports, "addColumnBefore", () => $6e97c057ca518bc0$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addColumnAfter", () => $6e97c057ca518bc0$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "insertColumn", () => $6e97c057ca518bc0$export$35ae1d3df4b27cf0);
$parcel$export(module.exports, "insertRow", () => $6e97c057ca518bc0$export$5a4e94bbc04b5f2);
$parcel$export(module.exports, "createTable", () => $6e97c057ca518bc0$export$33bbb3ec7652e187);
$parcel$export(module.exports, "insertTableWithSize", () => $6e97c057ca518bc0$export$505b7f2cb88dd074);
$parcel$export(module.exports, "insertTableWithNestingSupport", () => $6e97c057ca518bc0$export$b57b177fe1ab7f1f);
// #region Imports

var $6Ad8w = parcelRequire("6Ad8w");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $9O539 = parcelRequire("9O539");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $2miaS = parcelRequire("2miaS");
var $lJ4Xv = parcelRequire("lJ4Xv");
var $28MvW = parcelRequire("28MvW");
var $hHsVB = parcelRequire("hHsVB");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $eHLxx = parcelRequire("eHLxx");

var $aajRL = parcelRequire("aajRL");

var $7DDbz = parcelRequire("7DDbz");

var $aJOib = parcelRequire("aJOib");

var $5QPA6 = parcelRequire("5QPA6");

var $evhdb = parcelRequire("evhdb");

var $g4A0f = parcelRequire("g4A0f");
function $6e97c057ca518bc0$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (table) return tr.step((0, $6Ad8w.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $6e97c057ca518bc0$export$93d48be6ee61745(api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $6e97c057ca518bc0$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $2miaS.addColumnAt)(column)(updatedTr);
            const table = (0, $28MvW.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $7DDbz.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $eHLxx.updateRowOrColumnMovedTransform)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $6e97c057ca518bc0$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $28MvW.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $hHsVB.selectedRect)(state);
            dispatch($6e97c057ca518bc0$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $5QPA6.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $6e97c057ca518bc0$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $28MvW.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $hHsVB.selectedRect)(state);
            dispatch($6e97c057ca518bc0$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $5QPA6.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $6e97c057ca518bc0$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            const tr = $6e97c057ca518bc0$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $5QPA6.getAllowAddColumnCustomStep)(state), view)(state.tr);
            const table = (0, $28MvW.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $uOUlv.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $6e97c057ca518bc0$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $evhdb.checkIfHeaderRowEnabled)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $g4A0f.copyPreviousRow)(state.schema)(row)(state.tr) : (0, $lJ4Xv.addRowAt)(row, undefined)(state.tr);
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $uOUlv.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $eHLxx.updateRowOrColumnMovedTransform)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $6e97c057ca518bc0$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $aJOib.createTableWithWidth)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $5r0mK.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INSERTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: (0, $gkwXh.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $6e97c057ca518bc0$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $aJOib.createTableWithWidth)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $5r0mK.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).INSERTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: rowsCount,
                    totalColumnCount: colsCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            })(newTr);
            return newTr;
        };
    };
const $6e97c057ca518bc0$export$b57b177fe1ab7f1f = ({ isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, isFullWidthModeEnabled: isFullWidthModeEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, isTableResizingEnabled: isTableResizingEnabled = false, createTableProps: createTableProps = {} }, api, analyticsPayload)=>({ tr: tr })=>{
        const { schema: schema } = tr.doc.type;
        // If the cursor is inside a table
        let insertAt;
        let isNestedTable = false;
        if ((0, $5r0mK.hasParentNodeOfType)(schema.nodes.table)(tr.selection) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) {
            // If the experiment is disabled, or we're trying to nest deeper than one level, we insert the table after the top table
            if ((0, $gmhCD.editorExperiment)('nested-tables-in-tables', false, {
                exposure: true
            }) || (0, $9O539.getParentOfTypeCount)(schema.nodes.table)(tr.selection.$from) > 1) {
                const positionAfterTopTable = (0, $9O539.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(tr.selection.$from);
                if (!positionAfterTopTable) return tr;
                insertAt = (0, $gZGBX.TextSelection).create(tr.doc, positionAfterTopTable);
            } else // Table can be nested in parent table
            isNestedTable = true;
        }
        const node = (0, $aJOib.createTableWithWidth)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled,
            isNestedTable: isNestedTable,
            createTableProps: createTableProps
        })(schema);
        api?.contentInsertion?.commands?.insert({
            node: node,
            options: {
                selectNodeInserted: false,
                analyticsPayload: analyticsPayload ? {
                    ...analyticsPayload,
                    attributes: {
                        ...analyticsPayload.attributes,
                        localId: node.attrs.localId
                    }
                } : undefined,
                insertAt: insertAt
            }
        })({
            tr: tr
        });
        return tr;
    };

});
parcelRegister("6Ad8w", function(module, exports) {

$parcel$export(module.exports, "AddColumnStep", () => $574919971b337254$export$7f589f68a74fcd15);

var $8QpSo = parcelRequire("8QpSo");
parcelRequire("c3rYx");
var $eS2Dn = parcelRequire("eS2Dn");
var $eS2Dn = parcelRequire("eS2Dn");

var $aLBwD = parcelRequire("aLBwD");

var $9hCas = parcelRequire("9hCas");

var $g46R9 = parcelRequire("g46R9");

var $lQ3d3 = parcelRequire("lQ3d3");

var $Z3Enj = parcelRequire("Z3Enj");
const $574919971b337254$var$ADD_COLUMN_STEP = 'ak-add-column';
function $574919971b337254$var$printColumnInfo(columnInfo) {
    const cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $574919971b337254$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $574919971b337254$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $8QpSo.default)(()=>{
        const rect = (0, $lQ3d3.getTableRectFromDoc)(doc, pos);
        const column = (0, $g46R9.findColumn)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $574919971b337254$export$7f589f68a74fcd15 extends (0, $eS2Dn.Step) {
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $Z3Enj.SideEffectsHandler)(addColumnStepInfo.sideEffects);
        this.columnInfo = $574919971b337254$var$createColumnInfo(addColumnStepInfo.cells);
    }
    /**
	 * Detect the column based on all the cells step in column info.
	 * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
	 * If isDelete
	 *    Decrease colspan if one row has merged cell
	 *    Remove all the cells using columnInfo.cellStep[].from
	 * else
	 *    Increase colspan if one row had merged cell
	 *    Add all new cells at columnInfo.cellStep[].from,
	 *      if there is columnInfo.cellStep[].newCell use it
	 *      else create an empty cell
	 *
	 * @param doc Current document
	 */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $eS2Dn.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $eS2Dn.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $lQ3d3.getTableRectFromDoc)(doc, tablePos);
        } catch (e) {
            return (0, $eS2Dn.StepResult).fail(e.message);
        }
        const column = (0, $g46R9.findColumn)(this.columnInfo, tableRect);
        if (column === null) return (0, $eS2Dn.StepResult).fail(`No column for this cells "${$574919971b337254$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $eS2Dn.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $eS2Dn.StepResult).ok(tr.doc);
    }
    /**
	 * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
	 * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
	 * if cellStep.length === 0 remove the step
	 * Create a new step with all the position updated
	 * @param mapping
	 */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $574919971b337254$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
	 * if isDelete
	 *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
	 *    Create a copy of the node
	 *    Create a new cellStep with the same positions but with the clone node as a content
	 *    return new step inverted
	 * else
	 *    Remove the content from each columnInfo.cellStep[].content
	 *    return new step inverted
	 * @param originalDoc
	 */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $574919971b337254$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $aLBwD.invertCellStep)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $574919971b337254$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
	 * StepMap is created based on columnInfo.
	 * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
	 * if isDelete
	 *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
	 * else
	 *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
	 *
	 * Ranges in ProseMirror are represented by each 3 elements in an array.
	 * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
	 * pos: Position in the document
	 * currentSize: Represent the affected range, this will be pos + currentSize
	 * newSize: Represent the new values, pos + newSize
	 */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $aLBwD.getMapFromCellStep)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $eS2Dn.StepMap)(ranges);
    }
    /**
	 * Try to merge this step with another one, to be applied directly
	 * after it. Returns the merged step when possible, null if the
	 * steps can't be merged.
	 */ merge(other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
	 * Create a JSON-serializeable representation of this step. When
	 * defining this for a custom subclass, make sure the result object
	 * includes the step type's [JSON id](#transform.Step^jsonID) under
	 * the `stepType` property.
	 */ toJSON() {
        const addColumnStepJson = {
            stepType: $574919971b337254$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
	 * Deserialize a step from its JSON representation. Will call
	 * through to the step class' own implementation of this method.
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJSON(schema, json) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $Z3Enj.SideEffectsHandler).fromJSON(schema, json.sideEffects);
        return new $574919971b337254$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $lQ3d3.getTableRectFromDoc)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $9hCas.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $aLBwD.createCellStep)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $574919971b337254$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $9hCas.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $aLBwD.createCellStep)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $aLBwD.applyCellStep)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
}
(0, $eS2Dn.Step).jsonID($574919971b337254$var$ADD_COLUMN_STEP, $574919971b337254$export$7f589f68a74fcd15);

});
parcelRegister("aLBwD", function(module, exports) {

$parcel$export(module.exports, "applyCellStep", () => $07d5f1b04cb67662$export$1e67a55385d21834);
$parcel$export(module.exports, "getMapFromCellStep", () => $07d5f1b04cb67662$export$13a5db78deedf2bc);
$parcel$export(module.exports, "invertCellStep", () => $07d5f1b04cb67662$export$1238fc51d97634a);
$parcel$export(module.exports, "createCellStep", () => $07d5f1b04cb67662$export$e2625d4b6ce2d04b);

var $6e6o8 = parcelRequire("6e6o8");
const $07d5f1b04cb67662$var$EmptyCellNodeSize = 4;
function $07d5f1b04cb67662$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $07d5f1b04cb67662$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $6e6o8.removeColSpan)(cellNode.attrs, columns) : (0, $6e6o8.addColSpan)(cellNode.attrs, columns);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $07d5f1b04cb67662$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $07d5f1b04cb67662$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $07d5f1b04cb67662$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $07d5f1b04cb67662$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $07d5f1b04cb67662$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $07d5f1b04cb67662$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $07d5f1b04cb67662$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $07d5f1b04cb67662$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
	 * We need a correct map when a cell is added
	 * We need the normal map position minus the size of the cell you added it. Why?
	 * Having a table 3x3 and we add a new column at 2 creates this ranges
	 * [
	 *  10, 0, 4,
	 *  20, 0, 4,
	 *  30, 0, 4,
	 *  ]
	 *  Where:
	 *    * [10, 20, 30] are the original cell positions where we add the cells
	 *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
	 *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
	 *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
	 *  this is calculated in the given way
	 *    * Map the position using this step mapping function, this will return the cell in the next column
	 *    * Remove the diff (4 - 0 in this case) of the current position.
	 *  For a delete action this not happen, it will always return the right value
	 */ const offset = $07d5f1b04cb67662$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $07d5f1b04cb67662$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}

});

parcelRegister("9hCas", function(module, exports) {

$parcel$export(module.exports, "cellsAtColumn", () => $fcf70a53bc8ce03b$export$7ca27240fa9450d9);

var $i8Gio = parcelRequire("i8Gio");
var $3yjNu = parcelRequire("3yjNu");

var $eNJCD = parcelRequire("eNJCD");
function* $fcf70a53bc8ce03b$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $i8Gio.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = (0, $eNJCD.getCellIndex)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $eNJCD.hasMergedColumns)(rect.map, row, col) && (0, $eNJCD.isRootRow)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        const type = refColumn == null ? (0, $3yjNu.tableNodeTypes)(table.type.schema).cell : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        const cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}

});
parcelRegister("i8Gio", function(module, exports) {

$parcel$export(module.exports, "columnIsHeader", () => $0b452fbfdd9a16d9$export$c71ebdbebc3fa79b);
$parcel$export(module.exports, "addColumn", () => $0b452fbfdd9a16d9$export$9e26b0bcc810b84c);

var $6e6o8 = parcelRequire("6e6o8");

var $3yjNu = parcelRequire("3yjNu");
function $0b452fbfdd9a16d9$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $3yjNu.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $0b452fbfdd9a16d9$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col) {
    let refColumn = col > 0 ? -1 : 0;
    if ($0b452fbfdd9a16d9$export$c71ebdbebc3fa79b(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $6e6o8.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $6e6o8.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $3yjNu.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}

});

parcelRegister("eNJCD", function(module, exports) {

$parcel$export(module.exports, "getCellIndex", () => $8db066866ce93450$export$858eb3bd69719bea);
$parcel$export(module.exports, "hasMergedColumns", () => $8db066866ce93450$export$9854dd07bd861449);
$parcel$export(module.exports, "isRootRow", () => $8db066866ce93450$export$8575677d782d45d2);
const $8db066866ce93450$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $8db066866ce93450$export$9854dd07bd861449(map, row, col) {
    const index = $8db066866ce93450$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $8db066866ce93450$export$b17f150b6103459c(map, row, col) {
    const index = $8db066866ce93450$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $8db066866ce93450$export$8575677d782d45d2(map, row, col) {
    const index = $8db066866ce93450$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $8db066866ce93450$export$d119febc0282b034(map, row, col) {
    const index = $8db066866ce93450$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}

});


parcelRegister("g46R9", function(module, exports) {

$parcel$export(module.exports, "findColumn", () => $c439c5d14d359c88$export$718b3d71c384ca05);
function $c439c5d14d359c88$export$718b3d71c384ca05(columnInfo, rect) {
    /**
	 * Algorithm explained
	 * Given a table like this:
	 *    | 5  | 10      |
	 *    | 15      | 20 |
	 *    | 25 | 30 | 35 |
	 * Represented by a table map like this:
	 *   rect.map = [5, 10, 10,
	 *              15, 15, 20,
	 *              25, 30, 35]
	 * And a have this inputs:
	 *   columnInfo[].from = [10, 15, 30]
	 *
	 * Algorithm:
	 *    * Initial state
	 *      start = 0;
	 *      end = 2 (rect.width - 1 === 3 - 1)
	 *    * Iterate until find first cell position
	 *      start = 1
	 *      end = 2 (min(start column + colspan - 1, start column + end column))
	 *    * Iterate until find second cell position
	 *      start = 1
	 *      end = 1
	 *    * Start === end return 1
	 */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}

});

parcelRegister("lQ3d3", function(module, exports) {

$parcel$export(module.exports, "getTableRectFromDoc", () => $e4929d82e094ffa6$export$7a7f743a3e044584);

var $uOUlv = parcelRequire("uOUlv");
function $e4929d82e094ffa6$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $uOUlv.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}

});

parcelRegister("Z3Enj", function(module, exports) {

$parcel$export(module.exports, "SideEffectsHandler", () => $0ddaad4a82049c33$export$2e0f8a284a2635ac);

var $1oUhQ = parcelRequire("1oUhQ");

var $42J0k = parcelRequire("42J0k");
class $0ddaad4a82049c33$export$2e0f8a284a2635ac {
    constructor(sideEffects){
        this.table = new (0, $42J0k.TableSideEffectHandler)(sideEffects && sideEffects.table);
        this.rows = new (0, $1oUhQ.RowsSideEffectHandler)(sideEffects && sideEffects.rows);
    }
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $42J0k.TableSideEffectHandler).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $1oUhQ.RowsSideEffectHandler).fromJSON(schema, json.rows);
        return sideEffects;
    }
}

});
parcelRegister("1oUhQ", function(module, exports) {

$parcel$export(module.exports, "RowsSideEffectHandler", () => $8a5cde1e13019042$export$6a87112aa04a9486);

var $eNJCD = parcelRequire("eNJCD");
function $8a5cde1e13019042$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $8a5cde1e13019042$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $8a5cde1e13019042$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $8a5cde1e13019042$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $eNJCD.hasMergedColumns)(rect.map, row, col);
}
function $8a5cde1e13019042$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    const to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $8a5cde1e13019042$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $8a5cde1e13019042$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $8a5cde1e13019042$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $8a5cde1e13019042$export$6a87112aa04a9486 {
    constructor(rowsSideEffect){
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, cell)=>{
                    if (!$8a5cde1e13019042$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $8a5cde1e13019042$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while(// Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    (nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $8a5cde1e13019042$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    // Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    while(nextRow = this.rows[i]){
                        $8a5cde1e13019042$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $8a5cde1e13019042$var$mergedRanges(ranges, rowRanges);
    }
    map(mapping) {
        return [];
    }
    invert(originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            const offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
}

});

parcelRegister("42J0k", function(module, exports) {

$parcel$export(module.exports, "TableSideEffectHandler", () => $4da475f4f531fbce$export$9d510b823609a5ac);

var $eS2Dn = parcelRequire("eS2Dn");
class $4da475f4f531fbce$export$9d510b823609a5ac {
    constructor(tableSideEffect){
        if (tableSideEffect) this.table = tableSideEffect;
    }
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $eS2Dn.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $eS2Dn.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
}

});



parcelRegister("2miaS", function(module, exports) {

$parcel$export(module.exports, "addColumnAt", () => $432008e7f4a2555c$export$93d48be6ee61745);

var $uOUlv = parcelRequire("uOUlv");

var $i8Gio = parcelRequire("i8Gio");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");
const $432008e7f4a2555c$export$93d48be6ee61745 = (columnIndex)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (table) {
            const map = (0, $uOUlv.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $8HJeP.cloneTr)((0, $i8Gio.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex));
        }
        return tr;
    };

});

parcelRegister("lJ4Xv", function(module, exports) {

$parcel$export(module.exports, "addRowAt", () => $b783704593cd1dfa$export$643f25d380b0167d);

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $7r8fy = parcelRequire("7r8fy");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");

var $fCttG = parcelRequire("fCttG");

var $bM6Pi = parcelRequire("bM6Pi");

var $3yjNu = parcelRequire("3yjNu");
const $b783704593cd1dfa$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        const foundCells = [];
        const cells = (0, $fCttG.getCellsInRow)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $b783704593cd1dfa$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (table) {
            const map = (0, $uOUlv.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $3yjNu.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                const cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    const rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        const foundCells = $b783704593cd1dfa$var$filterCellsInRow(i, (cell, tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $bM6Pi.setCellAttrs)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $5r0mK.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };
const $b783704593cd1dfa$export$643f25d380b0167d = (rowIndex, clonePreviousRow)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (table) {
            const map = (0, $uOUlv.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $8HJeP.cloneTr)($b783704593cd1dfa$export$46bec710cf196d80(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $8HJeP.cloneTr)((0, $7r8fy.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex));
        }
        return tr;
    };

});
parcelRegister("7r8fy", function(module, exports) {

$parcel$export(module.exports, "addRow", () => $144c46dafd8422c2$export$40ed00dbc18f8b2f);

var $3yjNu = parcelRequire("3yjNu");
function $144c46dafd8422c2$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $3yjNu.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $144c46dafd8422c2$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($144c46dafd8422c2$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $3yjNu.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background) attrs = {
                background: cell.attrs.background
            };
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $3yjNu.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}

});


parcelRegister("aajRL", function(module, exports) {

$parcel$export(module.exports, "META_KEYS", () => $75798f7ba642ca61$export$210bf30466b5bcc8);
$parcel$export(module.exports, "createPlugin", () => $75798f7ba642ca61$export$ae829ec7b2625219);
/**
 * A plugin is created for collecting payload data for tableOverflowChanged analytics event
 */ 
var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $75798f7ba642ca61$var$pluginKey = new (0, $gZGBX.PluginKey)('tableOverflowAnalyticsPlugin');
const $75798f7ba642ca61$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $75798f7ba642ca61$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $5KWxh.SafePlugin)({
        key: $75798f7ba642ca61$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($75798f7ba642ca61$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($75798f7ba642ca61$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const newPluginState = $75798f7ba642ca61$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            const lastTriggerName = newPluginState?.lastTrigger?.name || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($75798f7ba642ca61$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $dEzej.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($75798f7ba642ca61$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });

});

parcelRegister("7DDbz", function(module, exports) {

$parcel$export(module.exports, "updateColumnWidths", () => $7f1206369807355f$export$6688b13ec132acdf);
$parcel$export(module.exports, "rescaleColumns", () => $7f1206369807355f$export$81edad89dedd3529);

var $6gEe5 = parcelRequire("6gEe5");

var $eS2Dn = parcelRequire("eS2Dn");

var $uOUlv = parcelRequire("uOUlv");

var $VSDnB = parcelRequire("VSDnB");

var $iQMCj = parcelRequire("iQMCj");

var $118VY = parcelRequire("118VY");

var $fISuL = parcelRequire("fISuL");

var $fFJjk = parcelRequire("fFJjk");
const $7f1206369807355f$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $uOUlv.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $eS2Dn.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth === undefined ? null : updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api?.batchAttributeUpdates && (0, $VSDnB.fg)('platform_editor_batch_steps_table')) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $7f1206369807355f$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement?.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $iQMCj.hasTableBeenResized)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $118VY.getTableElementWidth)(table.node),
                possibleMaxWidth: (0, $118VY.getTableContainerElementWidth)(table.node),
                isResized: isResized
            };
            else previousTableInfo = {
                // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                /** the is the width the table can reach before overflowing */ possibleMaxWidth: tableRef?.parentElement?.clientWidth || 0,
                isResized: isResized
            };
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $uOUlv.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $6gEe5.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $6gEe5.tableCellMinWidth) || previousTableInfo.isResized && (0, $iQMCj.isMinCellWidthTable)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $6gEe5.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $6gEe5.tableCellMinWidth),
                        minWidth: (0, $6gEe5.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $7f1206369807355f$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $fISuL.getResizeState)({
                minWidth: (0, $6gEe5.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $fFJjk.scaleTableTo)(resizeState, previousTableInfo.possibleMaxWidth);
            return $7f1206369807355f$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };

});
parcelRegister("fISuL", function(module, exports) {

$parcel$export(module.exports, "getResizeState", () => $52d715952e2917c6$export$38f73cf370cfaafc);
$parcel$export(module.exports, "updateColgroup", () => $52d715952e2917c6$export$23e0010f5fd8981);
$parcel$export(module.exports, "getTotalWidth", () => $52d715952e2917c6$export$fbc5c7e5991c30a8);
$parcel$export(module.exports, "adjustColumnsWidths", () => $52d715952e2917c6$export$b07f5f5f9c98720a);
$parcel$export(module.exports, "evenAllColumnsWidths", () => $52d715952e2917c6$export$aa593d179f012fe1);
$parcel$export(module.exports, "bulkColumnsResize", () => $52d715952e2917c6$export$7d703099c5579705);
$parcel$export(module.exports, "getNewResizeStateFromSelectedColumns", () => $52d715952e2917c6$export$8490eb29eba3007d);

var $fKLIs = parcelRequire("fKLIs");

var $6gEe5 = parcelRequire("6gEe5");

var $5or39 = parcelRequire("5or39");

var $hxf42 = parcelRequire("hxf42");

var $iQMCj = parcelRequire("iQMCj");

var $9k1tn = parcelRequire("9k1tn");

var $7mmRV = parcelRequire("7mmRV");

var $118VY = parcelRequire("118VY");
const $52d715952e2917c6$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && table.attrs?.width) {
        const scalePercent = (0, $118VY.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $iQMCj.hasTableBeenResized)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $5or39.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $6gEe5.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $6gEe5.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $iQMCj.insertColgroupFromNode)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !table.attrs?.width ? maxSize : (0, $fKLIs.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $9k1tn.getCellsRefsInColumn)(index, table, start, domAtPos);
        return (0, $9k1tn.getColumnStateFromDOM)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $52d715952e2917c6$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef?.querySelectorAll('col');
    const columnsCount = cols?.length;
    /**
     updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
     We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
     We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
     * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $iQMCj.getColWidthFix)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $6gEe5.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols?.[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols?.[i]) cols[i].style.width = `${(0, $iQMCj.getColWidthFix)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $7mmRV.syncStickyRowToTable)(tableRef);
};
const $52d715952e2917c6$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $52d715952e2917c6$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $52d715952e2917c6$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $52d715952e2917c6$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $52d715952e2917c6$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $52d715952e2917c6$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $52d715952e2917c6$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $52d715952e2917c6$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $52d715952e2917c6$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $52d715952e2917c6$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $52d715952e2917c6$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $52d715952e2917c6$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $52d715952e2917c6$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fixes total table widths by adding missing pixels to columns widths here and there
    return $52d715952e2917c6$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $52d715952e2917c6$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $52d715952e2917c6$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $hxf42.getSelectedTableInfo)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $iQMCj.hasTableBeenResized)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement?.closest('table');
    if (!tableRef) return;
    const layout = $52d715952e2917c6$var$normaliseTableLayout(tableRef?.dataset.layout);
    const maxSize = (0, $118VY.getTableMaxWidth)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = $52d715952e2917c6$export$38f73cf370cfaafc({
        minWidth: (0, $6gEe5.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $52d715952e2917c6$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};

});
parcelRegister("hxf42", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $c282cea2ed9b3c46$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $c282cea2ed9b3c46$export$277d5394a2608229);
$parcel$export(module.exports, "withEditorAnalyticsAPI", () => $c282cea2ed9b3c46$export$c27221be174b6703);
$parcel$export(module.exports, "generateResizedPayload", () => $c282cea2ed9b3c46$export$a12b1eaff522a2d1);
$parcel$export(module.exports, "generateResizeFrameRatePayloads", () => $c282cea2ed9b3c46$export$29574a7e6ffc8eb4);
$parcel$export(module.exports, "useMeasureFramerate", () => $c282cea2ed9b3c46$export$9642a56c1e8805cc);

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");

var $iQMCj = parcelRequire("iQMCj");

var $evhdb = parcelRequire("evhdb");
function $c282cea2ed9b3c46$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $28MvW.findTable)(selection);
    if (table) {
        map = (0, $uOUlv.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $c282cea2ed9b3c46$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $c282cea2ed9b3c46$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $c282cea2ed9b3c46$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI?.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $c282cea2ed9b3c46$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $uOUlv.TableMap).get(props.resizedNode);
    return {
        action: (0, $dEzej.TABLE_ACTION).RESIZED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $iQMCj.hasTableBeenResized)(props.resizedNode) ? (0, $evhdb.getTableWidth)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $c282cea2ed9b3c46$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $c282cea2ed9b3c46$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $c282cea2ed9b3c46$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $dEzej.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $c282cea2ed9b3c46$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    const frameCount = (0, $5uXOq.useRef)(0);
    const lastTime = (0, $5uXOq.useRef)(0);
    const timeoutId = (0, $5uXOq.useRef)();
    const frameRateSamples = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};

});

parcelRegister("7mmRV", function(module, exports) {

$parcel$export(module.exports, "updateControls", () => $798e94d793515996$export$13c259c17cfd51f5);
$parcel$export(module.exports, "syncStickyRowToTable", () => $798e94d793515996$export$43080b9794565cc4);
$parcel$export(module.exports, "isClickNear", () => $798e94d793515996$export$f76d638a91295d45);
$parcel$export(module.exports, "getResizeCellPos", () => $798e94d793515996$export$3658aa65e79e3104);
$parcel$export(module.exports, "updateStickyMargins", () => $798e94d793515996$export$ec6da316e37a54bf);

var $6gEe5 = parcelRequire("6gEe5");

var $eQcNy = parcelRequire("eQcNy");

var $jecUf = parcelRequire("jecUf");

var $gseSq = parcelRequire("gseSq");

var $lOQGo = parcelRequire("lOQGo");

var $g4A0f = parcelRequire("g4A0f");
const $798e94d793515996$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $gseSq.getPluginState)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON);
        $798e94d793515996$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $g4A0f.getRowHeights)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $798e94d793515996$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $798e94d793515996$export$3658aa65e79e3104 = (view, event)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    if (!(0, $eQcNy.containsClassName)(target, (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $eQcNy.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $798e94d793515996$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $eQcNy.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $6gEe5.tableCellBorderWidth);
    table.style.marginTop = `${(0, $6gEe5.tableMarginTop) + firstRowHeight}px`;
};
const $798e94d793515996$var$applyColWidthsToStickyRow = (// @ts-ignore - CCFE error TS6133: 'colGroup' is declared but its value is never read.
colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $lOQGo.colWidthsForRow)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $798e94d793515996$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $798e94d793515996$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $798e94d793515996$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $798e94d793515996$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
    }
};

});
parcelRegister("lOQGo", function(module, exports) {

$parcel$export(module.exports, "getColumnsWidths", () => $518cec8110e9dd10$export$79aef9e007571c);
$parcel$export(module.exports, "getColumnDeleteButtonParams", () => $518cec8110e9dd10$export$bedfed4734d37a07);
$parcel$export(module.exports, "colWidthsForRow", () => $518cec8110e9dd10$export$d231dfb66a75f6c1);
$parcel$export(module.exports, "convertHTMLCellIndexToColumnIndex", () => $518cec8110e9dd10$export$b53a50910add7502);
$parcel$export(module.exports, "getColumnIndexMappedToColumnIndexInFirstRow", () => $518cec8110e9dd10$export$ffa56ed053ef832e);

var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");

var $1v4Xe = parcelRequire("1v4Xe");
const $518cec8110e9dd10$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $28MvW.findTable)(selection);
    if (table) {
        const map = (0, $uOUlv.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const cellRef = (0, $5r0mK.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $518cec8110e9dd10$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $b1RTQ.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $1v4Xe.tableDeleteButtonSize) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $518cec8110e9dd10$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $518cec8110e9dd10$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $518cec8110e9dd10$export$d231dfb66a75f6c1 = (tr)=>{
    // get the colspans
    const rowColSpans = (0, $eQcNy.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $eQcNy.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        const domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...$518cec8110e9dd10$var$getRelativeDomCellWidths(cell));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $518cec8110e9dd10$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $518cec8110e9dd10$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $518cec8110e9dd10$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};

});

parcelRegister("g4A0f", function(module, exports) {

$parcel$export(module.exports, "getRowHeights", () => $ba080a6357a0bf48$export$3e5149a60ac7416b);
$parcel$export(module.exports, "getRowDeleteButtonParams", () => $ba080a6357a0bf48$export$b0ece9f607a8bda1);
$parcel$export(module.exports, "getRowsParams", () => $ba080a6357a0bf48$export$b8127ab1acaa6d46);
$parcel$export(module.exports, "getRowClassNames", () => $ba080a6357a0bf48$export$8969ab96fc5961ae);
$parcel$export(module.exports, "copyPreviousRow", () => $ba080a6357a0bf48$export$173c92a3a1ff68a7);

var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $cK1Lv = parcelRequire("cK1Lv");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
const $ba080a6357a0bf48$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        const rows = tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $eQcNy.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $ba080a6357a0bf48$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $b1RTQ.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $1v4Xe.tableDeleteButtonSize) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $ba080a6357a0bf48$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $ba080a6357a0bf48$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $cK1Lv.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $jecUf.TableCssClassName).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $ba080a6357a0bf48$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $28MvW.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $uOUlv.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            const cells = [];
            const fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $5r0mK.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };

});



parcelRegister("fFJjk", function(module, exports) {

$parcel$export(module.exports, "scaleTableTo", () => $55e1cec74d7ed28d$export$5de2ae9923ce5a0);
$parcel$export(module.exports, "previewScaleTable", () => $55e1cec74d7ed28d$export$2d57109fc9066ba2);
$parcel$export(module.exports, "scaleTable", () => $55e1cec74d7ed28d$export$edcf1a404e75ce35);

var $fKLIs = parcelRequire("fKLIs");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $7DDbz = parcelRequire("7DDbz");

var $evhdb = parcelRequire("evhdb");

var $118VY = parcelRequire("118VY");

var $8rO01 = parcelRequire("8rO01");

var $fISuL = parcelRequire("fISuL");

var $iQMCj = parcelRequire("iQMCj");

var $7mmRV = parcelRequire("7mmRV");
// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $55e1cec74d7ed28d$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $fKLIs.getTableContainerWidth)(node) : (0, $118VY.getLayoutSize)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $evhdb.getTableWidth)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $fKLIs.getTableContainerWidth)(node) : (0, $118VY.getLayoutSize)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $iHYdz.akEditorTableNumberColumnWidth);
    const resizeState = (0, $fISuL.getResizeState)({
        minWidth: (0, $6gEe5.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $55e1cec74d7ed28d$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $55e1cec74d7ed28d$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $fISuL.getResizeState)({
        minWidth: (0, $6gEe5.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $iHYdz.akEditorTableNumberColumnWidth);
    return $55e1cec74d7ed28d$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $55e1cec74d7ed28d$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $fISuL.getTotalWidth)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    const newTotalWidth = (0, $fISuL.getTotalWidth)(newState);
    if (newTotalWidth > maxSize) newState = (0, $8rO01.reduceSpace)(newState, newTotalWidth - maxSize);
    return (0, $fISuL.adjustColumnsWidths)(newState, maxSize);
}
const $55e1cec74d7ed28d$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, isTableWithFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $iQMCj.hasTableBeenResized)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $7mmRV.syncStickyRowToTable)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
    const resizeState = parentWidth ? $55e1cec74d7ed28d$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, shouldUseIncreasedScalingPercent) : $55e1cec74d7ed28d$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $fISuL.updateColgroup)(resizeState, tableRef, node, false, 1);
};
const $55e1cec74d7ed28d$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $iQMCj.hasTableBeenResized)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $iQMCj.insertColgroupFromNode)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) resizeState = $55e1cec74d7ed28d$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        else resizeState = $55e1cec74d7ed28d$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $7DDbz.updateColumnWidths)(resizeState, node, start, api)(tr);
            if (!(0, $VSDnB.fg)('platform_editor_fix_table_resizing_undo')) tr.setMeta('addToHistory', false);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
           scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
           Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
         */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };

});
parcelRegister("8rO01", function(module, exports) {

$parcel$export(module.exports, "growColumn", () => $5ab5ab66a65bd990$export$276e2d0f37ca319a);
$parcel$export(module.exports, "shrinkColumn", () => $5ab5ab66a65bd990$export$99e30963fc7d1a1e);
$parcel$export(module.exports, "reduceSpace", () => $5ab5ab66a65bd990$export$827dd2d6fa38543e);

var $9k1tn = parcelRequire("9k1tn");

var $fISuL = parcelRequire("fISuL");
const $5ab5ab66a65bd990$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $5ab5ab66a65bd990$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $5ab5ab66a65bd990$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $fISuL.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
const $5ab5ab66a65bd990$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $5ab5ab66a65bd990$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $fISuL.getTotalWidth)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $5ab5ab66a65bd990$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $fISuL.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
function $5ab5ab66a65bd990$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $9k1tn.getFreeSpace)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $5ab5ab66a65bd990$var$ColType = /*#__PURE__*/ function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
    return ColType;
}($5ab5ab66a65bd990$var$ColType || {});
// TODO: ED-26961 - should handle when destIdx:
// - is beyond the range, and then not give it back
function $5ab5ab66a65bd990$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $9k1tn.getFreeSpace)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($5ab5ab66a65bd990$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($5ab5ab66a65bd990$var$amountFor("src")(amount) < 0 && $5ab5ab66a65bd990$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $5ab5ab66a65bd990$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $5ab5ab66a65bd990$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $fISuL.getTotalWidth)(state);
        if (totalWidth - srcCol.width + $5ab5ab66a65bd990$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $5ab5ab66a65bd990$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $5ab5ab66a65bd990$var$stackSpace(state, destIdx, amount) {
    let candidates = $5ab5ab66a65bd990$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        const candidateIdx = $5ab5ab66a65bd990$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $9k1tn.getFreeSpace)(column) <= 0) break;
        const res = $5ab5ab66a65bd990$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $5ab5ab66a65bd990$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $9k1tn.getFreeSpace)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $5ab5ab66a65bd990$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $5ab5ab66a65bd990$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $5ab5ab66a65bd990$var$amountFor(colType)(amount);
}
function $5ab5ab66a65bd990$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $5ab5ab66a65bd990$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}

});



parcelRegister("aJOib", function(module, exports) {

$parcel$export(module.exports, "createTableWithWidth", () => $904f9c480b587460$export$5003ecb973fc11c2);

var $jOcQZ = parcelRequire("jOcQZ");

var $9QiRG = parcelRequire("9QiRG");
const $904f9c480b587460$var$NESTED_TABLE_DEFAULT_ROWS = 2;
const $904f9c480b587460$var$NESTED_TABLE_DEFAULT_COLS = 2;
const $904f9c480b587460$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, isNestedTable: isNestedTable, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isNestedTable) {
            attrsOverrides.rowsCount = createTableProps?.rowsCount ? createTableProps?.rowsCount : $904f9c480b587460$var$NESTED_TABLE_DEFAULT_ROWS;
            attrsOverrides.colsCount = createTableProps?.colsCount ? createTableProps?.colsCount : $904f9c480b587460$var$NESTED_TABLE_DEFAULT_COLS;
        }
        if (isTableScalingEnabled && isFullWidthModeEnabled && !isCommentEditor) attrsOverrides.tableWidth = (0, $9QiRG.TABLE_MAX_WIDTH);
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $jOcQZ.createTable)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };

});
parcelRegister("jOcQZ", function(module, exports) {

$parcel$export(module.exports, "createTable", () => $38672bd103fd4d69$export$33bbb3ec7652e187);

var $3yjNu = parcelRequire("3yjNu");

var $1sGyr = parcelRequire("1sGyr");
const $38672bd103fd4d69$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $38672bd103fd4d69$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $3yjNu.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $38672bd103fd4d69$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $38672bd103fd4d69$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $1sGyr.uuid).generate(),
        width: width,
        layout: layout
    }, rows);
};

});
parcelRegister("1sGyr", function(module, exports) {

$parcel$export(module.exports, "uuid", () => $7dc5df7957a58101$export$31b40729666a4ae0);
/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $7dc5df7957a58101$export$1c3aefb711c3a4cc = ()=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7dc5df7957a58101$var$staticValue = false;
const $7dc5df7957a58101$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7dc5df7957a58101$var$staticValue = value;
    },
    generate () {
        return $7dc5df7957a58101$var$staticValue || $7dc5df7957a58101$export$1c3aefb711c3a4cc();
    }
};

});



parcelRegister("5QPA6", function(module, exports) {

$parcel$export(module.exports, "getAllowAddColumnCustomStep", () => $6a30d1d6ad45a585$export$f8ddfdc64e14a808);

var $gseSq = parcelRequire("gseSq");
function $6a30d1d6ad45a585$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $gseSq.getPluginState)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}

});


parcelRegister("3ojHW", function(module, exports) {

$parcel$export(module.exports, "pluginConfig", () => $2dc4cb271766fe4f$export$c23fbabe48bd9130);
const $2dc4cb271766fe4f$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};

});

parcelRegister("1wp1Y", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $6c7da0ba4097a41e$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $5KWxh = parcelRequire("5KWxh");

var $etG8M = parcelRequire("etG8M");

var $hFEwm = parcelRequire("hFEwm");

var $fCttG = parcelRequire("fCttG");
var $cwe6a = parcelRequire("cwe6a");

var $3KYe6 = parcelRequire("3KYe6");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $gseSq = parcelRequire("gseSq");

var $cPPiz = parcelRequire("cPPiz");

var $iQMCj = parcelRequire("iQMCj");

var $aj3mz = parcelRequire("aj3mz");

var $g0UHf = parcelRequire("g0UHf");

var $f7q3E = parcelRequire("f7q3E");

var $gF4dk = parcelRequire("gF4dk");

var $euUbE = parcelRequire("euUbE");

var $eOCd8 = parcelRequire("eOCd8");

var $22Go6 = parcelRequire("22Go6");

var $84dDf = parcelRequire("84dDf");

var $6vGNf = parcelRequire("6vGNf");
const $6c7da0ba4097a41e$var$destroyFn = (editorView, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                // 'null' will remove the inline style
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $3KYe6.autoScrollForElements)({
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $4hDdm.combine)(...rowAutoScrollers, (0, $7gWdR.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $gseSq.getPluginState)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === tableNode?.attrs.localId;
        },
        onDragStart: ({ location: location })=>{
            (0, $gF4dk.toggleDragMenu)(false)(editorView.state, editorView.dispatch);
        },
        onDrag (event) {
            const data = (0, $6vGNf.getDraggableDataFromEvent)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $gF4dk.clearDropTarget)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: ED-26961 - as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $eOCd8.DropTargetType).ROW : (0, $eOCd8.DropTargetType).COLUMN;
            const hasMergedCells = (0, $g0UHf.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $gF4dk.setDropTarget)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
        },
        onDrop (event) {
            const data = (0, $6vGNf.getDraggableDataFromEvent)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $gseSq.getPluginState)(editorView.state);
            const cell = (0, $aj3mz.findNearestCellIndexToPoint)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: cell?.row ?? hoveredCell.rowIndex,
                        colIndex: cell?.col ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $cPPiz.pluginKey), action);
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                if (event?.source?.data?.type === 'table-row' || event?.source?.data?.type === 'table-column') return (0, $euUbE.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, event.source.data?.indexes, (0, $dEzej.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                return (0, $gF4dk.clearDropTarget)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $g0UHf.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $eOCd8.DropTargetType).ROW : (0, $eOCd8.DropTargetType).COLUMN)(editorView.state.selection)) {
                (0, $euUbE.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $dEzej.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                return;
            }
            requestAnimationFrame(()=>{
                if (behaviour === 'clone') (0, $euUbE.cloneSourceWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $euUbE.moveSourceWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $gseSq.getPluginState)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $iQMCj.insertColgroupFromNode)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
            });
        }
    }));
};
const $6c7da0ba4097a41e$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    return new (0, $5KWxh.SafePlugin)({
        state: (0, $22Go6.createPluginState)(dispatch, (state)=>({
                decorationSet: (0, $etG8M.DecorationSet).empty,
                dropTargetType: (0, $eOCd8.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $84dDf.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $gseSq.getPluginState)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $gseSq.getPluginState)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $22Go6.getPluginState)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $f7q3E.DragAndDropActionType).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $fCttG.getCellsInRow)(dragMenuIndex)(tr.selection);
                        // TODO: ED-20673 - check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $hFEwm.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $84dDf.pluginKey), action);
                         // else NOP
                    } else return tr.setMeta((0, $84dDf.pluginKey), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $6c7da0ba4097a41e$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $22Go6.getPluginState)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
				 * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
				 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
				 */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $cwe6a.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((event.target || null)?.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $22Go6.getPluginState)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};

});
parcelRegister("3KYe6", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $5ea44a3a02963798$export$4b66ee8317094cdb);

var $7gWdR = parcelRequire("7gWdR");

var $1XBB4 = parcelRequire("1XBB4");
const $5ea44a3a02963798$var$api = (0, $1XBB4.makeApi)({
    monitor: (0, $7gWdR.monitorForElements)
});
const $5ea44a3a02963798$export$4b66ee8317094cdb = $5ea44a3a02963798$var$api.autoScroll;
const $5ea44a3a02963798$export$c9168f41de61f525 = $5ea44a3a02963798$var$api.autoScrollWindow;

});
parcelRegister("1XBB4", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $7c9f5b9e5aad06df$export$b8fa21320a811083);

var $4hDdm = parcelRequire("4hDdm");

var $4HETl = parcelRequire("4HETl");

var $5DMYW = parcelRequire("5DMYW");

var $dN2fr = parcelRequire("dN2fr");
function $7c9f5b9e5aad06df$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $4hDdm.combine)((0, $5DMYW.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $dN2fr.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $4HETl.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("4HETl", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $76249ae4e9f30f38$export$5cff7ac265db316a);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $3d4ga = parcelRequire("3d4ga");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $76249ae4e9f30f38$var$schedulers = new Map();
function $76249ae4e9f30f38$export$5cff7ac265db316a(monitor) {
    const scheduler = $76249ae4e9f30f38$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $76249ae4e9f30f38$var$makeScheduler(monitor);
    $76249ae4e9f30f38$var$schedulers.set(monitor, created);
    return created;
}
function $76249ae4e9f30f38$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $3d4ga.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $3d4ga.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("3d4ga", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $cdcee60ad04716da$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $cdcee60ad04716da$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $cdcee60ad04716da$export$13ae770ed39b71ea);
const $cdcee60ad04716da$var$ledger = new Map();
const $cdcee60ad04716da$var$requested = new Set();
function $cdcee60ad04716da$export$8c764c3f2fc3d2d2(element) {
    $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element);
    const entry = $cdcee60ad04716da$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $cdcee60ad04716da$var$ledger.set(element, fresh);
    return fresh;
}
function $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element) {
    $cdcee60ad04716da$var$requested.add(element);
}
function $cdcee60ad04716da$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $cdcee60ad04716da$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $cdcee60ad04716da$var$ledger.forEach((_, element)=>{
        if (!$cdcee60ad04716da$var$requested.has(element)) $cdcee60ad04716da$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $cdcee60ad04716da$var$requested.clear();
}
function $cdcee60ad04716da$export$13ae770ed39b71ea() {
    $cdcee60ad04716da$var$ledger.clear();
}

});


parcelRegister("5DMYW", function(module, exports) {

$parcel$export(module.exports, "selector", () => $05e8460564c70d18$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $05e8460564c70d18$export$4ec12fb57dfebd53);
const $05e8460564c70d18$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $05e8460564c70d18$export$aea217a45095ce11 = `[${$05e8460564c70d18$export$4b152ab55cad4fd6}="true"]`;
function $05e8460564c70d18$export$4ec12fb57dfebd53(element) {
    element.setAttribute($05e8460564c70d18$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($05e8460564c70d18$export$4b152ab55cad4fd6);
}

});

parcelRegister("dN2fr", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $95daf559d8aa786a$export$233199807749476d);

var $kjAuM = parcelRequire("kjAuM");

var $3d4ga = parcelRequire("3d4ga");

var $5DMYW = parcelRequire("5DMYW");

var $i4SSA = parcelRequire("i4SSA");
function $95daf559d8aa786a$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $95daf559d8aa786a$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $5DMYW.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $95daf559d8aa786a$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $3d4ga.markAndGetEngagement)(element);
    const config = (0, $kjAuM.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $i4SSA.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $95daf559d8aa786a$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $3d4ga.markAndGetEngagement)(element);
        const config = (0, $kjAuM.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $i4SSA.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $95daf559d8aa786a$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $95daf559d8aa786a$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(remainder)) return;
    $95daf559d8aa786a$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("kjAuM", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $8aedd24a4f7bb643$export$e96028ec7ff9d079);
const $8aedd24a4f7bb643$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $8aedd24a4f7bb643$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $8aedd24a4f7bb643$export$e96028ec7ff9d079(provided) {
    return {
        ...$8aedd24a4f7bb643$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $8aedd24a4f7bb643$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("i4SSA", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $f221acff344cd122$export$6cfa6dfe6898b98f);

var $iduok = parcelRequire("iduok");

var $ffSUw = parcelRequire("ffSUw");

var $c3M8M = parcelRequire("c3M8M");

var $gfxd2 = parcelRequire("gfxd2");

var $hTDOm = parcelRequire("hTDOm");

var $2dwAb = parcelRequire("2dwAb");
function $f221acff344cd122$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $f221acff344cd122$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $f221acff344cd122$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ffSUw.edges).reduce((map, edge)=>{
        const hitbox = (0, $c3M8M.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ffSUw.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $hTDOm.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $2dwAb.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iduok.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iduok", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $dc24cd2fd79e74bd$export$ccd6d9407403fcad);
const $dc24cd2fd79e74bd$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("ffSUw", function(module, exports) {

$parcel$export(module.exports, "edges", () => $77e5ecf85ecb98dd$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $77e5ecf85ecb98dd$export$7fc144124ccf8292);
const $77e5ecf85ecb98dd$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $77e5ecf85ecb98dd$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("c3M8M", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $4e0c1489e6f6f1ed$export$b9a449c20abb0e9);

var $9w8nT = parcelRequire("9w8nT");

var $aHtK2 = parcelRequire("aHtK2");
function $4e0c1489e6f6f1ed$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9w8nT.axisLookup)[axis];
        const side = (0, $aHtK2.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $4e0c1489e6f6f1ed$export$b9a449c20abb0e9 = {
    top: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("9w8nT", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $4007ed2af13415f1$export$42e42cdab35a2b96);
const $4007ed2af13415f1$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $4007ed2af13415f1$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $4007ed2af13415f1$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $4007ed2af13415f1$var$vertical,
        crossAxis: $4007ed2af13415f1$var$horizontal
    },
    horizontal: {
        mainAxis: $4007ed2af13415f1$var$horizontal,
        crossAxis: $4007ed2af13415f1$var$vertical
    }
};

});

parcelRegister("aHtK2", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4b97aced6f7f08e4$export$a45c0cd714a4dbaa);
const $4b97aced6f7f08e4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("gfxd2", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $b3ae2158089b2ceb$export$470a2ff46db8cee8);

var $9w8nT = parcelRequire("9w8nT");

var $lUX3m = parcelRequire("lUX3m");

var $aHtK2 = parcelRequire("aHtK2");
// We want a consistent scroll speed across devices, regardless of framerate
function $b3ae2158089b2ceb$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $b3ae2158089b2ceb$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $9w8nT.axisLookup)[axis];
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $b3ae2158089b2ceb$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $b3ae2158089b2ceb$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $b3ae2158089b2ceb$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $lUX3m.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("lUX3m", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $15bc8d2c21c8e1e4$export$1a29de000a332d74);
function $15bc8d2c21c8e1e4$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("hTDOm", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $9d9969f3e7f53880$export$7120fdbd90bd1292);
function $9d9969f3e7f53880$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("2dwAb", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $df40d0415a8c41aa$export$cda7a9d4399bf2e3);
function $df40d0415a8c41aa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("aj3mz", function(module, exports) {

$parcel$export(module.exports, "isCell", () => $051ce0e76abed2e1$export$835df158d20ae2f0);
$parcel$export(module.exports, "isCornerButton", () => $051ce0e76abed2e1$export$94cf9243187b20f0);
$parcel$export(module.exports, "isInsertRowButton", () => $051ce0e76abed2e1$export$7a8d111d40fb198c);
$parcel$export(module.exports, "getColumnOrRowIndex", () => $051ce0e76abed2e1$export$e5e82c478fd9ea3);
$parcel$export(module.exports, "isColumnControlsDecorations", () => $051ce0e76abed2e1$export$14eb53395cc0cf57);
$parcel$export(module.exports, "isRowControlsButton", () => $051ce0e76abed2e1$export$edad492f0c70264f);
$parcel$export(module.exports, "isResizeHandleDecoration", () => $051ce0e76abed2e1$export$4cf9002f70d2d324);
$parcel$export(module.exports, "isTableControlsButton", () => $051ce0e76abed2e1$export$b4f0758743701ac9);
$parcel$export(module.exports, "isTableContainerOrWrapper", () => $051ce0e76abed2e1$export$2b59104f44ee317b);
$parcel$export(module.exports, "isDragRowFloatingInsertDot", () => $051ce0e76abed2e1$export$b2ae534578c0ae33);
$parcel$export(module.exports, "isDragColumnFloatingInsertDot", () => $051ce0e76abed2e1$export$666ae3fd07127e7f);
$parcel$export(module.exports, "isDragCornerButton", () => $051ce0e76abed2e1$export$571c943db7bc729c);
$parcel$export(module.exports, "getMousePositionHorizontalRelativeByElement", () => $051ce0e76abed2e1$export$3dde6150a2e2df0a);
$parcel$export(module.exports, "getMousePositionVerticalRelativeByElement", () => $051ce0e76abed2e1$export$3bf5911758d564a4);
$parcel$export(module.exports, "hasResizeHandler", () => $051ce0e76abed2e1$export$80e4fcc9d7220616);
$parcel$export(module.exports, "getTree", () => $051ce0e76abed2e1$export$b76263aac816aadb);
$parcel$export(module.exports, "getTop", () => $051ce0e76abed2e1$export$449115d164fc37c3);
$parcel$export(module.exports, "findNearestCellIndexToPoint", () => $051ce0e76abed2e1$export$fe489db90f7f492a);

var $eQcNy = parcelRequire("eQcNy");

var $jecUf = parcelRequire("jecUf");
const $051ce0e76abed2e1$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $eQcNy.closestElement)(node, `.${(0, $jecUf.TableCssClassName).TABLE_HEADER_CELL}`) || !!(0, $eQcNy.closestElement)(node, `.${(0, $jecUf.TableCssClassName).TABLE_CELL}`)));
};
const $051ce0e76abed2e1$export$94cf9243187b20f0 = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON);
const $051ce0e76abed2e1$export$7a8d111d40fb198c = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).CONTROLS_INSERT_ROW) || (0, $eQcNy.closestElement)(node, `.${(0, $jecUf.TableCssClassName).CONTROLS_INSERT_ROW}`) || (0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_OVERLAY) && (0, $eQcNy.closestElement)(node, `.${(0, $jecUf.TableCssClassName).ROW_CONTROLS}`);
const $051ce0e76abed2e1$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $051ce0e76abed2e1$export$14eb53395cc0cf57 = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
const $051ce0e76abed2e1$export$edad492f0c70264f = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON) || (0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON);
const $051ce0e76abed2e1$export$4cf9002f70d2d324 = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION);
const $051ce0e76abed2e1$export$b4f0758743701ac9 = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).CONTROLS_BUTTON) || (0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP);
const $051ce0e76abed2e1$export$2b59104f44ee317b = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).TABLE_CONTAINER) || (0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER);
const $051ce0e76abed2e1$export$b2ae534578c0ae33 = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $051ce0e76abed2e1$export$666ae3fd07127e7f = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $051ce0e76abed2e1$export$571c943db7bc729c = (node)=>(0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON) || (0, $eQcNy.containsClassName)(node, (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER);
const $051ce0e76abed2e1$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $051ce0e76abed2e1$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $051ce0e76abed2e1$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $eQcNy.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $jecUf.TableCssClassName).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $051ce0e76abed2e1$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $051ce0e76abed2e1$export$449115d164fc37c3 = (element)=>{
    if (!element || element instanceof Window) return 0;
    return element?.getBoundingClientRect?.()?.top ?? 0;
};
const $051ce0e76abed2e1$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = cell?.parentElement ?? undefined;
    if (!Number.isFinite(row?.rowIndex) || !Number.isFinite(cell?.cellIndex)) return undefined;
    return {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        row: row.rowIndex,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        col: cell.cellIndex
    };
};

});

parcelRegister("g0UHf", function(module, exports) {

$parcel$export(module.exports, "hasMergedCellsInBetween", () => $f4786d032f1fef77$export$6e6c0cf88a287d8);
$parcel$export(module.exports, "hasMergedCellsWithColumnNextToColumnIndex", () => $f4786d032f1fef77$export$834c4ba4fe64e8f2);
$parcel$export(module.exports, "hasMergedCellsWithRowNextToRowIndex", () => $f4786d032f1fef77$export$7ef37f297601e698);
$parcel$export(module.exports, "hasMergedCellsInSelection", () => $f4786d032f1fef77$export$e4c313e419348ae7);
$parcel$export(module.exports, "findDuplicatePosition", () => $f4786d032f1fef77$export$1d4a5608e72f1096);

var $28MvW = parcelRequire("28MvW");
var $uOUlv = parcelRequire("uOUlv");
const $f4786d032f1fef77$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $f4786d032f1fef77$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return false;
        const map = (0, $uOUlv.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $f4786d032f1fef77$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $f4786d032f1fef77$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $uOUlv.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $f4786d032f1fef77$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $28MvW.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $uOUlv.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $f4786d032f1fef77$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return false;
        const map = (0, $uOUlv.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $f4786d032f1fef77$export$9af117e01db30223(indexes, map, type);
    };
const $f4786d032f1fef77$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    const minIndex = Math.min(...indexes);
    const maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
   * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
   TODO: ED-22335 this should better called only when hover over the drag handle.
  */ const isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    const isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $f4786d032f1fef77$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};

});

parcelRegister("f7q3E", function(module, exports) {

$parcel$export(module.exports, "DragAndDropActionType", () => $647457370ecc220c$export$b6bb967ba58ec81c);
const $647457370ecc220c$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};

});

parcelRegister("gF4dk", function(module, exports) {

$parcel$export(module.exports, "setDropTarget", () => $131025a34079c9a2$export$a54c991ec4a21b4a);
$parcel$export(module.exports, "clearDropTarget", () => $131025a34079c9a2$export$e74dec9e818a8c0b);
$parcel$export(module.exports, "moveSource", () => $131025a34079c9a2$export$1326c72b3102f66d);
$parcel$export(module.exports, "toggleDragMenu", () => $131025a34079c9a2$export$8a902a12acc69924);
$parcel$export(module.exports, "cloneSource", () => $131025a34079c9a2$export$88277f1015e99c8a);

var $etG8M = parcelRequire("etG8M");

var $6Vlwb = parcelRequire("6Vlwb");
var $aVFCu = parcelRequire("aVFCu");
var $iHqDM = parcelRequire("iHqDM");
var $hkcDd = parcelRequire("hkcDd");

var $jecUf = parcelRequire("jecUf");

var $9kb0R = parcelRequire("9kb0R");

var $f7q3E = parcelRequire("f7q3E");

var $eOCd8 = parcelRequire("eOCd8");

var $22Go6 = parcelRequire("22Go6");

var $84dDf = parcelRequire("84dDf");
// TODO: ED-26961 - This command is a placeholder example. Please replace this if required.
const $131025a34079c9a2$var$getDecorations = (state)=>{
    return (0, $84dDf.pluginKey).getState(state)?.decorationSet || (0, $etG8M.DecorationSet).empty;
};
const $131025a34079c9a2$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $9kb0R.updateDecorations)(state.doc, $131025a34079c9a2$var$getDecorations(state), decorations, key);
const $131025a34079c9a2$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $22Go6.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $22Go6.getPluginState)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $etG8M.DecorationSet).empty;
        if (type === 'column') decorationSet = $131025a34079c9a2$var$updatePluginStateDecorations(state, (0, $9kb0R.createColumnInsertLine)(index, state.selection, hasMergedCells), (0, $jecUf.TableDecorations).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $131025a34079c9a2$var$updatePluginStateDecorations(state, (0, $9kb0R.createRowInsertLine)(index, state.selection, hasMergedCells), (0, $jecUf.TableDecorations).ROW_INSERT_LINE);
        return {
            type: (0, $f7q3E.DragAndDropActionType).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $131025a34079c9a2$export$e74dec9e818a8c0b = (tr)=>(0, $22Go6.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $22Go6.getPluginState)(state);
        if (dropTargetType === (0, $eOCd8.DropTargetType).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $f7q3E.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $etG8M.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $131025a34079c9a2$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $22Go6.createCommand)((state)=>{
        return {
            type: (0, $f7q3E.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $etG8M.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $hkcDd.moveRow) : (0, $iHqDM.moveColumn);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $131025a34079c9a2$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $22Go6.createCommand)((state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $22Go6.getPluginState)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $f7q3E.DragAndDropActionType).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $131025a34079c9a2$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $22Go6.createCommand)((state)=>{
        return {
            type: (0, $f7q3E.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $etG8M.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $aVFCu.cloneRow) : (0, $6Vlwb.cloneColumn);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });

});
parcelRegister("6Vlwb", function(module, exports) {

$parcel$export(module.exports, "cloneColumn", () => $1ce06d2c58ebf6cc$export$799175205f855ccd);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $iryZ6 = parcelRequire("iryZ6");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");

var $cFUic = parcelRequire("cFUic");

var $kNERd = parcelRequire("kNERd");

var $3yjNu = parcelRequire("3yjNu");
function $1ce06d2c58ebf6cc$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $1ce06d2c58ebf6cc$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $uOUlv.TableMap).get(table.node);
        const originalColumnRanges = (0, $cFUic.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $cFUic.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $kNERd.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $3yjNu.tableNodeTypes)(state.schema);
        const direction = $1ce06d2c58ebf6cc$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $iryZ6.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $1ce06d2c58ebf6cc$var$createContentNodeFactory(table);
        const newTr = (0, $8HJeP.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $1ce06d2c58ebf6cc$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$1ce06d2c58ebf6cc$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $cFUic.getSelectionRangeInColumn)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $hFEwm.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $1ce06d2c58ebf6cc$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $1ce06d2c58ebf6cc$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $1ce06d2c58ebf6cc$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("iryZ6", function(module, exports) {

$parcel$export(module.exports, "determineTableHeaderStateFromTableNode", () => $1b026c8cb7438a09$export$9206f249edb43d1b);
function $1b026c8cb7438a09$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the 2nd cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the 2nd cell is a header then the entire row/col is a header.
    // Be carefull though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we wont be able to reliably identify header state on tables smaller the 2x2, however we can do best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, 1) is a header cell or not
    // bit: 2 = Identifies if the cell at (1, 0) is a header cell or not
    let mask = 0;
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = table.nodeAt(tableMap.map[1]);
        // If the cell at (0, 1) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}

});

parcelRegister("cFUic", function(module, exports) {

$parcel$export(module.exports, "getSelectionRangeInColumn", () => $78746769e8cdd0f3$export$7032a6f0de5ecc29);

var $l57lo = parcelRequire("l57lo");

var $fCttG = parcelRequire("fCttG");
const $78746769e8cdd0f3$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $l57lo.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $l57lo.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $l57lo.getCellsInColumn)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $l57lo.getCellsInColumn)(startIndex)(tr.selection);
        const firstRowCells = (0, $fCttG.getCellsInRow)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $l57lo.getCellsInColumn)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});

parcelRegister("kNERd", function(module, exports) {

$parcel$export(module.exports, "convertArrayOfRowsToTableNode", () => $026e5cd00b269a8c$export$5c8f3870f9ad667);
$parcel$export(module.exports, "convertTableNodeToArrayOfRows", () => $026e5cd00b269a8c$export$63019a088e9d8f5f);
$parcel$export(module.exports, "isValidReorder", () => $026e5cd00b269a8c$export$fd791265d075eb03);

var $uOUlv = parcelRequire("uOUlv");
const $026e5cd00b269a8c$export$9cb09a71b7d66923 = (array)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array[0].map((_, i)=>{
        return array.map((column)=>column[i]);
    });
};
const $026e5cd00b269a8c$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $uOUlv.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};
const $026e5cd00b269a8c$var$moveRowInArrayOfRows = (arrayOfNodes, indexesOrigin, indexesTarget, directionOverride)=>{
    const direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;
    const rowsExtracted = arrayOfNodes.splice(indexesOrigin[0], indexesOrigin.length);
    const positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
    let target;
    if (directionOverride === -1 && direction === 1) target = indexesTarget[0] - 1;
    else if (directionOverride === 1 && direction === -1) target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
    else target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
    // @ts-ignore no idea what this line does
    arrayOfNodes.splice.apply(arrayOfNodes, [
        target,
        0
    ].concat(rowsExtracted));
    return arrayOfNodes;
};
const $026e5cd00b269a8c$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $uOUlv.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};
const $026e5cd00b269a8c$export$8eeacd95914015c2 = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $026e5cd00b269a8c$export$63019a088e9d8f5f(table.node);
    rows = $026e5cd00b269a8c$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    return $026e5cd00b269a8c$export$5c8f3870f9ad667(table.node, rows);
};
const $026e5cd00b269a8c$export$18d467ff157d6daa = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $026e5cd00b269a8c$export$9cb09a71b7d66923($026e5cd00b269a8c$export$63019a088e9d8f5f(table.node));
    rows = $026e5cd00b269a8c$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    rows = $026e5cd00b269a8c$export$9cb09a71b7d66923(rows);
    return $026e5cd00b269a8c$export$5c8f3870f9ad667(table.node, rows);
};
const $026e5cd00b269a8c$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};

});


parcelRegister("aVFCu", function(module, exports) {

$parcel$export(module.exports, "cloneRow", () => $e0ada7804b11a573$export$94fc9bbbd60f961f);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $iryZ6 = parcelRequire("iryZ6");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");

var $eymtZ = parcelRequire("eymtZ");

var $kNERd = parcelRequire("kNERd");

var $3yjNu = parcelRequire("3yjNu");
function $e0ada7804b11a573$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $e0ada7804b11a573$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $uOUlv.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $eymtZ.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $eymtZ.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $kNERd.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $3yjNu.tableNodeTypes)(state.schema);
        const direction = $e0ada7804b11a573$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8HJeP.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $iryZ6.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$e0ada7804b11a573$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $eymtZ.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $hFEwm.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $e0ada7804b11a573$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});
parcelRegister("eymtZ", function(module, exports) {

$parcel$export(module.exports, "getSelectionRangeInRow", () => $e358e0db5ee5adfb$export$550d44f4e6042645);

var $l57lo = parcelRequire("l57lo");

var $fCttG = parcelRequire("fCttG");
const $e358e0db5ee5adfb$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $fCttG.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $fCttG.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $fCttG.getCellsInRow)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $fCttG.getCellsInRow)(startIndex)(tr.selection);
        const firstColumnCells = (0, $l57lo.getCellsInColumn)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $fCttG.getCellsInRow)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});


parcelRegister("iHqDM", function(module, exports) {

$parcel$export(module.exports, "moveColumn", () => $e97414c3867b0a04$export$d1fbe0eb3fc9219);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $iryZ6 = parcelRequire("iryZ6");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");

var $cFUic = parcelRequire("cFUic");

var $OfQ3F = parcelRequire("OfQ3F");

var $kNERd = parcelRequire("kNERd");

var $3yjNu = parcelRequire("3yjNu");
const $e97414c3867b0a04$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $uOUlv.TableMap).get(table.node);
        const originalColumnRanges = (0, $cFUic.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $cFUic.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $kNERd.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $3yjNu.tableNodeTypes)(state.schema);
        const direction = (0, $OfQ3F.normalizeDirection)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $iryZ6.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $e97414c3867b0a04$var$createContentNodeFactory(table);
        const newTr = (0, $8HJeP.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $e97414c3867b0a04$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' || tableMap.isCellMergedTopLeft(y, actualTargetIndex) ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$e97414c3867b0a04$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $cFUic.getSelectionRangeInColumn)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $hFEwm.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $e97414c3867b0a04$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $e97414c3867b0a04$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $e97414c3867b0a04$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("OfQ3F", function(module, exports) {

$parcel$export(module.exports, "normalizeDirection", () => $dfbb63f72f4f3222$export$3d9c15b8c24b72f5);
function $dfbb63f72f4f3222$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : dir;
}

});


parcelRegister("hkcDd", function(module, exports) {

$parcel$export(module.exports, "moveRow", () => $aeff6c4cc3c70015$export$fbe24096ca2da576);

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $iryZ6 = parcelRequire("iryZ6");

var $8HJeP = parcelRequire("8HJeP");

var $28MvW = parcelRequire("28MvW");

var $eymtZ = parcelRequire("eymtZ");

var $OfQ3F = parcelRequire("OfQ3F");

var $kNERd = parcelRequire("kNERd");

var $3yjNu = parcelRequire("3yjNu");
const $aeff6c4cc3c70015$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $uOUlv.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $eymtZ.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $eymtZ.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $kNERd.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $3yjNu.tableNodeTypes)(state.schema);
        const direction = (0, $OfQ3F.normalizeDirection)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8HJeP.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $iryZ6.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$aeff6c4cc3c70015$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $eymtZ.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $hFEwm.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $aeff6c4cc3c70015$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});

parcelRegister("eOCd8", function(module, exports) {

$parcel$export(module.exports, "DropTargetType", () => $641e435ad96edf5f$export$9377432e002bc2da);
const $641e435ad96edf5f$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};

});

parcelRegister("22Go6", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $f872427806221b23$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $f872427806221b23$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $f872427806221b23$export$f05434c51e3762e);

var $aOimD = parcelRequire("aOimD");

var $cPPiz = parcelRequire("cPPiz");

var $84dDf = parcelRequire("84dDf");

var $6B235 = parcelRequire("6B235");
const { createPluginState: $f872427806221b23$export$656c7661095efe2e, createCommand: $f872427806221b23$export$8d4021544bdece00, getPluginState: $f872427806221b23$export$f05434c51e3762e } = (0, $aOimD.pluginFactory)((0, $84dDf.pluginKey), (0, $6B235.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $cPPiz.pluginKey));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});

});
parcelRegister("84dDf", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $97d10c602bf56a0f$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $97d10c602bf56a0f$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('dragAndDropPlugin');

});

parcelRegister("6B235", function(module, exports) {

$parcel$export(module.exports, "default", () => $e27a5d480f9fa801$export$2e2bcd8739ae039);

var $f7q3E = parcelRequire("f7q3E");

var $eOCd8 = parcelRequire("eOCd8");
var $e27a5d480f9fa801$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $f7q3E.DragAndDropActionType).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $f7q3E.DragAndDropActionType).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $eOCd8.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $f7q3E.DragAndDropActionType).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("euUbE", function(module, exports) {

$parcel$export(module.exports, "clearDropTargetWithAnalytics", () => $6ab716fcc69b8e41$export$fbaa62c9a250295d);
$parcel$export(module.exports, "moveSourceWithAnalytics", () => $6ab716fcc69b8e41$export$137f4de350aca2d8);
$parcel$export(module.exports, "moveSourceWithAnalyticsViaShortcut", () => $6ab716fcc69b8e41$export$a01080da268c1d9d);
$parcel$export(module.exports, "cloneSourceWithAnalytics", () => $6ab716fcc69b8e41$export$e432b518ff8f345a);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $2V0EL = parcelRequire("2V0EL");

var $hFEwm = parcelRequire("hFEwm");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");

var $hxf42 = parcelRequire("hxf42");

var $01hCL = parcelRequire("01hCL");

var $9bHWx = parcelRequire("9bHWx");

var $gF4dk = parcelRequire("gF4dk");
const $6ab716fcc69b8e41$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $dEzej.TABLE_ACTION).MOVED_ROW : (0, $dEzej.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes?.length ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $gF4dk.clearDropTarget)(tr)(state, dispatch);
            return true;
        });
    };
const $6ab716fcc69b8e41$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $dEzej.TABLE_ACTION).MOVED_ROW : (0, $dEzej.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $dEzej.TABLE_STATUS).CANCELLED : (0, $dEzej.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $gF4dk.moveSource)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $gkwXh.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $2V0EL.messages).rowMovedDown : (0, $2V0EL.messages).rowMovedUp : direction > 0 ? (0, $2V0EL.messages).columnMovedRight : (0, $2V0EL.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $6ab716fcc69b8e41$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $hFEwm.CellSelection);
            const selectionRect = isCellSelection ? (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $9bHWx.getSelectedRowIndexes)(selectionRect) : (0, $9bHWx.getSelectedColumnIndexes)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            if (!(0, $01hCL.canMove)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $01hCL.getTargetIndex)(selectedIndexes, direction);
            return $6ab716fcc69b8e41$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $gkwXh.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $6ab716fcc69b8e41$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $dEzej.TABLE_ACTION).CLONED_ROW : (0, $dEzej.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $dEzej.TABLE_STATUS).CANCELLED : (0, $dEzej.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $gF4dk.cloneSource)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };

});
parcelRegister("01hCL", function(module, exports) {

$parcel$export(module.exports, "getTargetIndex", () => $ab833bcd6eb41af6$export$79db8995cf046b43);
$parcel$export(module.exports, "canMove", () => $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2);
$parcel$export(module.exports, "getDragMenuConfig", () => $ab833bcd6eb41af6$export$25f919d23e41e94d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7kHYO = parcelRequire("7kHYO");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $jpYlM = parcelRequire("jpYlM");

var $enBAU = parcelRequire("enBAU");

var $8Ygfu = parcelRequire("8Ygfu");

var $kgJ2q = parcelRequire("kgJ2q");

var $19Rn8 = parcelRequire("19Rn8");

var $jDupz = parcelRequire("jDupz");

var $dKti0 = parcelRequire("dKti0");

var $5deCl = parcelRequire("5deCl");

var $3GUid = parcelRequire("3GUid");

var $7zKok = parcelRequire("7zKok");

var $hZBhm = parcelRequire("hZBhm");

var $4jI4w = parcelRequire("4jI4w");

var $irW11 = parcelRequire("irW11");

var $sZuQW = parcelRequire("sZuQW");

var $ls8Y7 = parcelRequire("ls8Y7");

var $3gt3f = parcelRequire("3gt3f");

var $8RBk4 = parcelRequire("8RBk4");

var $kAObg = parcelRequire("kAObg");

var $d5Zn3 = parcelRequire("d5Zn3");

var $jlnXH = parcelRequire("jlnXH");

var $f5BqX = parcelRequire("f5BqX");

var $ei5gP = parcelRequire("ei5gP");

var $csttc = parcelRequire("csttc");

var $kZUa4 = parcelRequire("kZUa4");

var $6yBNR = parcelRequire("6yBNR");

var $1MLIG = parcelRequire("1MLIG");

var $awVU3 = parcelRequire("awVU3");

var $knLk2 = parcelRequire("knLk2");

var $6lSoW = parcelRequire("6lSoW");

var $euUbE = parcelRequire("euUbE");

var $gseSq = parcelRequire("gseSq");

var $fISuL = parcelRequire("fISuL");

var $g0UHf = parcelRequire("g0UHf");

var $9bHWx = parcelRequire("9bHWx");
const $ab833bcd6eb41af6$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $9bHWx.getSelectedRowIndexes)(selectionRect) : (0, $9bHWx.getSelectedColumnIndexes)(selectionRect);
    const targetIndex = $ab833bcd6eb41af6$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $g0UHf.hasMergedCellsWithRowNextToRowIndex)(targetIndex, selection) : (0, $g0UHf.hasMergedCellsWithColumnNextToColumnIndex)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $g0UHf.hasMergedCellsInSelection)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $ab833bcd6eb41af6$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $knLk2.getClosestSelectionRect)(state);
    if (rect) {
        const selectedColIndexes = (0, $9bHWx.getSelectedColumnIndexes)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $ab833bcd6eb41af6$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $ab833bcd6eb41af6$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, ariaNotifyPlugin, isCommentEditor = false)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $gseSq.getPluginState)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7zKok))), {
                    LEGACY_fallbackIcon: (0, $1MLIG.AddRowAboveIcon),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hZBhm))), {
                    LEGACY_fallbackIcon: (0, $awVU3.AddRowBelowIcon),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kgJ2q))), {
                    LEGACY_fallbackIcon: (0, $kZUa4.AddColLeftIcon),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19Rn8))), {
                    LEGACY_fallbackIcon: (0, $6yBNR.AddColRightIcon),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.addColumnAfter)
        }
    ];
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($sZuQW))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kAObg))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.moveRowUp),
            canMove: $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2('table-row', -1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $9bHWx.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($irW11))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ls8Y7))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.moveRowDown),
            canMove: $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2('table-row', 1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $9bHWx.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dKti0))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3gt3f))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.moveColumnLeft),
            canMove: $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2('table-column', -1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $9bHWx.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5deCl))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.moveColumnRight),
            canMove: $ab833bcd6eb41af6$export$a4ef2b0c3fa55ad2('table-column', 1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $9bHWx.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $7kHYO.SortOrder).ASC,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jpYlM))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($csttc))),
                    spacing: 'spacious',
                    label: ''
                })
        },
        {
            label: 'decreasing',
            order: (0, $7kHYO.SortOrder).DESC,
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($enBAU))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ei5gP))),
                    spacing: 'spacious',
                    label: ''
                })
        }
    ] : [];
    const sortConfigs = [
        ...sortOptions.map(({ label: label, order: order, icon: icon })=>({
                id: `sort_column_${order}`,
                title: `Sort ${label}`,
                disabled: hasMergedCellsInTable,
                icon: icon,
                onClick: (state, dispatch)=>{
                    (0, $6lSoW.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                    return true;
                }
            }))
    ];
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $6lSoW.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $e9qoo.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$ab833bcd6eb41af6$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $knLk2.getClosestSelectionRect)(state);
                if (selectionRect) {
                    const newResizeState = (0, $fISuL.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $6lSoW.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GUid))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jlnXH))),
                    spacing: 'spacious',
                    label: ''
                })
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $6lSoW.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ygfu))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $e9qoo.tooltip)((0, $e9qoo.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $6lSoW.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $ab833bcd6eb41af6$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $6lSoW.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $ab833bcd6eb41af6$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: direction === 'row' ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jI4w))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX))),
                    spacing: 'spacious',
                    label: ''
                }) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jDupz))), {
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX))),
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: direction === 'row' ? (0, $e9qoo.tooltip)((0, $e9qoo.deleteRow)) : (0, $e9qoo.tooltip)((0, $e9qoo.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $euUbE.moveSourceWithAnalytics)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $gkwXh.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getOriginIndexes(selectionRect), // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $e9qoo.tooltip)(keymap)
            }))
    ];
    const allConfigs = [
        ...restConfigs
    ];
    allConfigs.unshift(...sortConfigs);
    return allConfigs.filter(Boolean);
};

});
parcelRegister("7kHYO", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $25034718fc1e746e$export$7ae723045d45777a);
var $25034718fc1e746e$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});

});

parcelRegister("jpYlM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1533407203f003b100b6bc9fc1cca1a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e22f2a6ad3c1f502$var$_react = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e22f2a6ad3c1f502$var$_baseNew = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e22f2a6ad3c1f502$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e22f2a6ad3c1f502$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $e22f2a6ad3c1f502$var$_react.default.createElement($e22f2a6ad3c1f502$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$e22f2a6ad3c1f502$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $e22f2a6ad3c1f502$var$_default = module.exports.default = $e22f2a6ad3c1f502$var$SortAscendingIcon;

});

parcelRegister("enBAU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2611905fa87d707c1d555c941da4c1d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a780601c67e57879$var$_react = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a780601c67e57879$var$_baseNew = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a780601c67e57879$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a780601c67e57879$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $a780601c67e57879$var$_react.default.createElement($a780601c67e57879$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a780601c67e57879$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $a780601c67e57879$var$_default = module.exports.default = $a780601c67e57879$var$SortDescendingIcon;

});

parcelRegister("8Ygfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3715da6d70daf42dde6fa4bf98f69d2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $688088014092f4ab$var$_react = $688088014092f4ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $688088014092f4ab$var$_baseNew = $688088014092f4ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $688088014092f4ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $688088014092f4ab$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $688088014092f4ab$var$_react.default.createElement($688088014092f4ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$688088014092f4ab$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $688088014092f4ab$var$_default = module.exports.default = $688088014092f4ab$var$TableCellClearIcon;

});

parcelRegister("kgJ2q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4901bdad23f2ff7f260f46733eb1c6c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec183ce611938f24$var$_react = $ec183ce611938f24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ec183ce611938f24$var$_baseNew = $ec183ce611938f24$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ec183ce611938f24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table column to the left of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec183ce611938f24$var$TableColumnAddLeftIcon = (props)=>/*#__PURE__*/ $ec183ce611938f24$var$_react.default.createElement($ec183ce611938f24$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.75 8.75V11h-1.5V8.75H0v-1.5h2.25V5h1.5v2.25H6v1.5z" clip-rule="evenodd"/>`
    }, props));
$ec183ce611938f24$var$TableColumnAddLeftIcon.displayName = 'TableColumnAddLeftIcon';
var $ec183ce611938f24$var$_default = module.exports.default = $ec183ce611938f24$var$TableColumnAddLeftIcon;

});

parcelRegister("19Rn8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80598cafc95af209e49a10c3bad49691>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d800852c8512dd4$var$_react = $0d800852c8512dd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0d800852c8512dd4$var$_baseNew = $0d800852c8512dd4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0d800852c8512dd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table column to the right of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d800852c8512dd4$var$TableColumnAddRightIcon = (props)=>/*#__PURE__*/ $0d800852c8512dd4$var$_react.default.createElement($0d800852c8512dd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.25 6.25V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5z" clip-rule="evenodd"/>`
    }, props));
$0d800852c8512dd4$var$TableColumnAddRightIcon.displayName = 'TableColumnAddRightIcon';
var $0d800852c8512dd4$var$_default = module.exports.default = $0d800852c8512dd4$var$TableColumnAddRightIcon;

});

parcelRegister("jDupz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::794da10f91c68785b0517548c8a93ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4b93fe6f95ce58b$var$_react = $e4b93fe6f95ce58b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e4b93fe6f95ce58b$var$_baseNew = $e4b93fe6f95ce58b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e4b93fe6f95ce58b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for deleting a table column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4b93fe6f95ce58b$var$TableColumnDeleteIcon = (props)=>/*#__PURE__*/ $e4b93fe6f95ce58b$var$_react.default.createElement($e4b93fe6f95ce58b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm11 6.25h-6v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$e4b93fe6f95ce58b$var$TableColumnDeleteIcon.displayName = 'TableColumnDeleteIcon';
var $e4b93fe6f95ce58b$var$_default = module.exports.default = $e4b93fe6f95ce58b$var$TableColumnDeleteIcon;

});

parcelRegister("dKti0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33e9c113020d7c156fa51184c7111efd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0264a878af6e383$var$_react = $a0264a878af6e383$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a0264a878af6e383$var$_baseNew = $a0264a878af6e383$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a0264a878af6e383$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0264a878af6e383$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $a0264a878af6e383$var$_react.default.createElement($a0264a878af6e383$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$a0264a878af6e383$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $a0264a878af6e383$var$_default = module.exports.default = $a0264a878af6e383$var$TableColumnMoveLeftIcon;

});

parcelRegister("5deCl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e97c2a0961e1124d49b08ff14e114eac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cb9816081d7c52a$var$_react = $3cb9816081d7c52a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cb9816081d7c52a$var$_baseNew = $3cb9816081d7c52a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cb9816081d7c52a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table column to the right of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cb9816081d7c52a$var$TableColumnMoveRightIcon = (props)=>/*#__PURE__*/ $3cb9816081d7c52a$var$_react.default.createElement($3cb9816081d7c52a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.78 1.97 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 1.72-1.72H10v-1.5h3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$3cb9816081d7c52a$var$TableColumnMoveRightIcon.displayName = 'TableColumnMoveRightIcon';
var $3cb9816081d7c52a$var$_default = module.exports.default = $3cb9816081d7c52a$var$TableColumnMoveRightIcon;

});

parcelRegister("3GUid", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78298474d22014d47c8de5bc58c5ffc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b00f5ec2a9c48d2$var$_react = $2b00f5ec2a9c48d2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2b00f5ec2a9c48d2$var$_baseNew = $2b00f5ec2a9c48d2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2b00f5ec2a9c48d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b00f5ec2a9c48d2$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $2b00f5ec2a9c48d2$var$_react.default.createElement($2b00f5ec2a9c48d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$2b00f5ec2a9c48d2$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $2b00f5ec2a9c48d2$var$_default = module.exports.default = $2b00f5ec2a9c48d2$var$TableColumnsDistributeIcon;

});

parcelRegister("7zKok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cca627b1b0f6703ebb5dcb94a1a472a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $583fc9ab0ba3f2ca$var$_react = $583fc9ab0ba3f2ca$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $583fc9ab0ba3f2ca$var$_baseNew = $583fc9ab0ba3f2ca$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $583fc9ab0ba3f2ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddAbove".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table row above the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $583fc9ab0ba3f2ca$var$TableRowAddAboveIcon = (props)=>/*#__PURE__*/ $583fc9ab0ba3f2ca$var$_react.default.createElement($583fc9ab0ba3f2ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm6.25-7.25H11v-1.5H8.75V0h-1.5v2.25H5v1.5h2.25V6h1.5z" clip-rule="evenodd"/>`
    }, props));
$583fc9ab0ba3f2ca$var$TableRowAddAboveIcon.displayName = 'TableRowAddAboveIcon';
var $583fc9ab0ba3f2ca$var$_default = module.exports.default = $583fc9ab0ba3f2ca$var$TableRowAddAboveIcon;

});

parcelRegister("hZBhm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a40931a3fbc8b4e78b4affe054d4f84b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1950d0897bde213$var$_react = $d1950d0897bde213$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1950d0897bde213$var$_baseNew = $d1950d0897bde213$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1950d0897bde213$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1950d0897bde213$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $d1950d0897bde213$var$_react.default.createElement($d1950d0897bde213$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$d1950d0897bde213$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $d1950d0897bde213$var$_default = module.exports.default = $d1950d0897bde213$var$TableRowAddBelowIcon;

});

parcelRegister("4jI4w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e612cbb8389956f960de73eed9cb0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $324b1f8ab806fb33$var$_react = $324b1f8ab806fb33$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $324b1f8ab806fb33$var$_baseNew = $324b1f8ab806fb33$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $324b1f8ab806fb33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $324b1f8ab806fb33$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $324b1f8ab806fb33$var$_react.default.createElement($324b1f8ab806fb33$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$324b1f8ab806fb33$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $324b1f8ab806fb33$var$_default = module.exports.default = $324b1f8ab806fb33$var$TableRowDeleteIcon;

});

parcelRegister("irW11", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb832afe4c95ea6abe00ab150b1ac5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6e7c04791af7eb9$var$_react = $d6e7c04791af7eb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d6e7c04791af7eb9$var$_baseNew = $d6e7c04791af7eb9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d6e7c04791af7eb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6e7c04791af7eb9$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $d6e7c04791af7eb9$var$_react.default.createElement($d6e7c04791af7eb9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$d6e7c04791af7eb9$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $d6e7c04791af7eb9$var$_default = module.exports.default = $d6e7c04791af7eb9$var$TableRowMoveDownIcon;

});

parcelRegister("sZuQW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8fa7aedce89a177aa58aff789b34e64b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05725196bc35e993$var$_react = $05725196bc35e993$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05725196bc35e993$var$_baseNew = $05725196bc35e993$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $05725196bc35e993$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05725196bc35e993$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $05725196bc35e993$var$_react.default.createElement($05725196bc35e993$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$05725196bc35e993$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $05725196bc35e993$var$_default = module.exports.default = $05725196bc35e993$var$TableRowMoveUpIcon;

});

parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});


parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});


parcelRegister("kAObg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
function $efde1844fc0ef421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $efde1844fc0ef421$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $efde1844fc0ef421$var$_arrowUp.default
    }));
$efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;

});
parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});


parcelRegister("jlnXH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e15290ccf9d9577f$var$_react = $e15290ccf9d9577f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e15290ccf9d9577f$var$_layoutThreeColumns = $e15290ccf9d9577f$var$_interopRequireDefault((parcelRequire("bh6Q5")));
function $e15290ccf9d9577f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon = (props)=>/*#__PURE__*/ $e15290ccf9d9577f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $e15290ccf9d9577f$var$_layoutThreeColumns.default
    }));
$e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var $e15290ccf9d9577f$var$_default = module.exports.default = $e15290ccf9d9577f$var$EditorLayoutThreeEqualIcon;

});

parcelRegister("ei5gP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a676d5b620d83af6$var$_react = $a676d5b620d83af6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a676d5b620d83af6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a676d5b620d83af6$var$HipchatChevronDoubleDownIcon = (props)=>/*#__PURE__*/ $a676d5b620d83af6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m14.3 13.29-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0m0-6.01-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0"/></svg>`
    }, props));
$a676d5b620d83af6$var$HipchatChevronDoubleDownIcon.displayName = 'HipchatChevronDoubleDownIcon';
var $a676d5b620d83af6$var$_default = module.exports.default = $a676d5b620d83af6$var$HipchatChevronDoubleDownIcon;

});

parcelRegister("csttc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $911ef5a9dad024d0$var$_react = $911ef5a9dad024d0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $911ef5a9dad024d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $911ef5a9dad024d0$var$HipchatChevronDoubleUpIcon = (props)=>/*#__PURE__*/ $911ef5a9dad024d0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.22 6.32 8.29 9.28a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0L12 8.38l2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32m0 6-2.93 2.96a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0l2.3-2.32 2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32"/></svg>`
    }, props));
$911ef5a9dad024d0$var$HipchatChevronDoubleUpIcon.displayName = 'HipchatChevronDoubleUpIcon';
var $911ef5a9dad024d0$var$_default = module.exports.default = $911ef5a9dad024d0$var$HipchatChevronDoubleUpIcon;

});

parcelRegister("kZUa4", function(module, exports) {

$parcel$export(module.exports, "AddColLeftIcon", () => $7b3fd246556224ab$export$c00389776f30ea2f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $7b3fd246556224ab$export$c00389776f30ea2f = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                transform: "matrix(0 -1 1 0 0 24)",
                fill: "none",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "12",
                y: "18",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-90 12 18)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "16",
                y: "18",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-90 16 18)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7 11H5.99C5.72652 11.0026 5.47473 11.1092 5.28935 11.2964C5.10397 11.4837 4.99999 11.7365 5 12C5 12.556 5.444 13 5.99 13H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V13H10.01C10.2735 12.9974 10.5253 12.8908 10.7107 12.7036C10.896 12.5163 11 12.2635 11 12C11 11.444 10.556 11 10.01 11H9V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V11Z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("6yBNR", function(module, exports) {

$parcel$export(module.exports, "AddColRightIcon", () => $bd3abe487ffdfdc7$export$79e27ed0f7fcb6f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $bd3abe487ffdfdc7$export$79e27ed0f7fcb6f4 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                transform: "translate(0 24) rotate(-90)",
                fill: "none",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "9",
                y: "18",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-90 9 18)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "5",
                y: "18",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-90 5 18)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 11L13.99 11C13.7265 11.0026 13.4747 11.1092 13.2893 11.2964C13.104 11.4837 13 11.7365 13 12C13 12.556 13.444 13 13.99 13L15 13L15 14C15 14.2652 15.1054 14.5196 15.2929 14.7071C15.4804 14.8946 15.7348 15 16 15C16.2652 15 16.5196 14.8946 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14L17 13L18.01 13C18.2735 12.9974 18.5253 12.8908 18.7107 12.7036C18.896 12.5163 19 12.2635 19 12C19 11.444 18.556 11 18.01 11L17 11L17 10C17 9.73478 16.8946 9.48043 16.7071 9.29289C16.5196 9.10536 16.2652 9 16 9C15.7348 9 15.4804 9.10536 15.2929 9.29289C15.1054 9.48043 15 9.73478 15 10L15 11Z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("1MLIG", function(module, exports) {

$parcel$export(module.exports, "AddRowAboveIcon", () => $c61945fbebad76eb$export$d272e13742d8d9ba);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $c61945fbebad76eb$export$d272e13742d8d9ba = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "var(--ds-border-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "6",
                y: "12",
                width: "12",
                height: "3",
                rx: "0.5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "6",
                y: "16",
                width: "12",
                height: "3",
                rx: "0.5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13 7V5.99C12.9974 5.72652 12.8908 5.47473 12.7036 5.28935C12.5163 5.10397 12.2635 4.99999 12 5C11.444 5 11 5.444 11 5.99V7H10C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8C9 8.26522 9.10536 8.51957 9.29289 8.70711C9.48043 8.89464 9.73478 9 10 9H11V10.01C11.0026 10.2735 11.1092 10.5253 11.2964 10.7107C11.4837 10.896 11.7365 11 12 11C12.556 11 13 10.556 13 10.01V9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H13Z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("awVU3", function(module, exports) {

$parcel$export(module.exports, "AddRowBelowIcon", () => $370f632286775113$export$20c35a12cdc2ee1a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $370f632286775113$export$20c35a12cdc2ee1a = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                transform: "matrix(-1 0 0 -1 24 24)",
                fill: "var(--ds-border-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "18",
                y: "12",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-180 18 12)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "18",
                y: "8",
                width: "12",
                height: "3",
                rx: "0.5",
                transform: "rotate(-180 18 8)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 17V18.01C11.0026 18.2735 11.1092 18.5253 11.2964 18.7107C11.4837 18.896 11.7365 19 12 19C12.556 19 13 18.556 13 18.01V17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5196 15.1054 14.2652 15 14 15H13V13.99C12.9974 13.7265 12.8908 13.4747 12.7036 13.2893C12.5163 13.104 12.2635 13 12 13C11.444 13 11 13.444 11 13.99V15H10C9.73478 15 9.48043 15.1054 9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071C9.48043 16.8946 9.73478 17 10 17H11Z",
                fill: "currentColor"
            })
        ]
    });

});

parcelRegister("knLk2", function(module, exports) {

$parcel$export(module.exports, "getClosestSelectionRect", () => $fef7c46560ad10fb$export$e3ff63a8559e7571);
$parcel$export(module.exports, "getToolbarConfig", () => $fef7c46560ad10fb$export$86ce8f8241c20a3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $7kHYO = parcelRequire("7kHYO");

var $dEzej = parcelRequire("dEzej");
var $gkwXh = parcelRequire("gkwXh");

var $1SrEi = parcelRequire("1SrEi");

var $e9qoo = parcelRequire("e9qoo");

var $8DYpW = parcelRequire("8DYpW");
var $2V0EL = parcelRequire("2V0EL");

var $9O539 = parcelRequire("9O539");

var $fKLIs = parcelRequire("fKLIs");

var $fHEWI = parcelRequire("fHEWI");
var $cGel6 = parcelRequire("cGel6");

var $eQcNy = parcelRequire("eQcNy");
var $hEIDx = parcelRequire("hEIDx");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $24JcV = parcelRequire("24JcV");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");
var $aOnxY = parcelRequire("aOnxY");

var $2LESl = parcelRequire("2LESl");

var $gvHjN = parcelRequire("gvHjN");

var $8w53e = parcelRequire("8w53e");

var $8jMCF = parcelRequire("8jMCF");

var $5Fuj0 = parcelRequire("5Fuj0");

var $3GUid = parcelRequire("3GUid");

var $5VgMH = parcelRequire("5VgMH");

var $kTcZO = parcelRequire("kTcZO");

var $jlnXH = parcelRequire("jlnXH");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9fJGy = parcelRequire("9fJGy");
var $9K9fn = parcelRequire("9K9fn");

var $6lSoW = parcelRequire("6lSoW");

var $22Go6 = parcelRequire("22Go6");

var $gseSq = parcelRequire("gseSq");

var $k8KvZ = parcelRequire("k8KvZ");

var $118VY = parcelRequire("118VY");

var $fISuL = parcelRequire("fISuL");

var $7rFMc = parcelRequire("7rFMc");

var $fUbGn = parcelRequire("fUbGn");

var $fkJZJ = parcelRequire("fkJZJ");

var $evhdb = parcelRequire("evhdb");

var $9bHWx = parcelRequire("9bHWx");

var $3PWLJ = parcelRequire("3PWLJ");

var $jecUf = parcelRequire("jecUf");

var $vVoyO = parcelRequire("vVoyO");
const $fef7c46560ad10fb$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $2V0EL.messages).lockColumnWidths),
            onClick: (0, $6lSoW.toggleFixedColumnWidthsOptionAnalytics)(editorAnalyticsAPI, (0, $gkwXh.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $2V0EL.messages).headerRow),
            onClick: (0, $6lSoW.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $2V0EL.messages).headerColumn),
            onClick: (0, $6lSoW.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $2V0EL.messages).numberedColumn),
            onClick: (0, $6lSoW.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $2V0EL.messages).collapseTable),
            onClick: (0, $6lSoW.wrapTableInExpandWithAnalytics)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    if (state.isDragAndDropEnabled) return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        icon: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))),
        iconBefore: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? (0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))) : undefined,
        title: formatMessage((0, $2V0EL.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
    else return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        title: formatMessage((0, $2V0EL.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $fef7c46560ad10fb$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $gseSq.getPluginState)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $2V0EL.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
                const index = selectionRect?.right;
                if (index) (0, $6lSoW.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $24JcV.shortcutStyle)
            }, (0, $e9qoo.tooltip)((0, $e9qoo.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $2V0EL.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
                const index = selectionRect?.bottom;
                if (index) (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $24JcV.shortcutStyle)
            }, (0, $e9qoo.tooltip)((0, $e9qoo.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $2V0EL.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $6lSoW.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $fef7c46560ad10fb$var$highlightColumnsHandler,
            onBlur: (0, $9fJGy.clearHoverSelection)(),
            onMouseOver: $fef7c46560ad10fb$var$highlightColumnsHandler,
            onMouseLeave: (0, $9fJGy.clearHoverSelection)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $2V0EL.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $6lSoW.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $fef7c46560ad10fb$var$highlightRowsHandler,
            onBlur: (0, $9fJGy.clearHoverSelection)(),
            onMouseOver: $fef7c46560ad10fb$var$highlightRowsHandler,
            onMouseLeave: (0, $9fJGy.clearHoverSelection)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $2V0EL.messages).mergeCells),
        onClick: (0, $6lSoW.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $fUbGn.canMergeCells)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $2V0EL.messages).splitCell),
        onClick: (0, $6lSoW.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $aOnxY.splitCell)(editorState)
    });
    if (pluginState?.pluginConfig?.allowDistributeColumns) {
        const newResizeStateWithAnalytics = editorView ? (0, $fISuL.getNewResizeStateFromSelectedColumns)(initialSelectionRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor) : undefined;
        const wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        const distributeColumnWidths = (state, dispatch)=>{
            if (newResizeStateWithAnalytics) {
                (0, $6lSoW.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
                return true;
            }
            return false;
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $2V0EL.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: !wouldChange
        });
    }
    if (pluginState?.pluginConfig?.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $3PWLJ.getMergedCellsPositions)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $2V0EL.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $2V0EL.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $3PWLJ.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $9fJGy.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $9fJGy.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $6lSoW.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $7kHYO.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $2V0EL.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $3PWLJ.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $9fJGy.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $9fJGy.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $6lSoW.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $7kHYO.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $2V0EL.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $gseSq.getPluginState)(state);
            (0, $6lSoW.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $24JcV.shortcutStyle)
        }, (0, $e9qoo.tooltip)((0, $e9qoo.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $2V0EL.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $fef7c46560ad10fb$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $iGxzn.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
};
const $fef7c46560ad10fb$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $28MvW.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $uOUlv.TableMap).get(tableObject.node);
    const tableRect = new (0, $uOUlv.Rect)(0, 0, map.width, map.height);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, $iGxzn.isSelectionType)(selection, 'cell') ? (0, $b1RTQ.getSelectionRect)(selection) : tableRect;
};
const $fef7c46560ad10fb$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $28MvW.findTable)(state.selection);
            const pluginState = (0, $gseSq.getPluginState)(state);
            const resizeState = (0, $k8KvZ.pluginKey).getState(state);
            const tableWidthState = (0, $7rFMc.pluginKey).getState(state);
            const isTableScalingEnabled = options?.isTableScalingEnabled || false;
            const nodeType = state.schema.nodes.table;
            const toolbarTitle = 'Table floating controls';
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4')) {
                let isDragHandleMenuOpened = false;
                let isTableRowOrColumnDragged = false;
                if (options?.dragAndDropEnabled) {
                    const { isDragMenuOpen: isDragMenuOpen = false, isDragging: isDragging = false } = (0, $22Go6.getPluginState)(state);
                    isDragHandleMenuOpened = isDragMenuOpen;
                    isTableRowOrColumnDragged = isDragging;
                }
                const isTableOrColumnResizing = !!(resizeState?.dragging || tableWidthState?.resizing);
                const isTableMenuOpened = pluginState.isContextualMenuOpen || isDragHandleMenuOpened;
                const isTableState = isTableRowOrColumnDragged || isTableOrColumnResizing || isTableMenuOpened;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Note: when focus is in codeblocks, pluginState.editorHasFocus is false, so the codeblocks toolbar
                // won't be suppressed.
                const shouldSuppressAllToolbars = isTableState && pluginState.editorHasFocus && !isViewMode;
                if (shouldSuppressAllToolbars) return {
                    title: toolbarTitle,
                    items: [],
                    nodeType: nodeType,
                    __suppressAllToolbars: true
                };
            }
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState?.resizing;
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing) {
                const isNested = pluginState.tablePos && (0, $evhdb.isTableNested)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $5r0mK.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) {
                        const tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                        if (tableRef) element = (0, $eQcNy.closestElement)(tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
                    }
                    return element;
                };
                const menu = $fef7c46560ad10fb$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = config.allowTableAlignment && !isNested ? $fef7c46560ad10fb$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, options?.fullWidthEnabled, options?.isCommentEditor) : [];
                const cellItems = pluginState.isDragAndDropEnabled ? [] : $fef7c46560ad10fb$var$getCellItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                const columnSettingsItems = pluginState.isDragAndDropEnabled ? $fef7c46560ad10fb$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options?.isCommentEditor) : [];
                const colorPicker = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? $fef7c46560ad10fb$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView) : [];
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $hEIDx.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $2V0EL.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $2V0EL.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $2V0EL.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $2V0EL.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $hEIDx.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $2V0EL.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $hEIDx.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $2V0EL.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$fef7c46560ad10fb$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                const deleteButton = {
                    id: 'editor.table.delete',
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))),
                    onClick: (0, $6lSoW.deleteTableWithAnalytics)(editorAnalyticsAPI),
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: (0, $9fJGy.hoverTable)(true),
                    onFocus: (0, $9fJGy.hoverTable)(true),
                    onBlur: (0, $9fJGy.clearHoverSelection)(),
                    onMouseLeave: (0, $9fJGy.clearHoverSelection)(),
                    title: intl.formatMessage((0, $8DYpW.default).remove),
                    focusEditoronEnter: true,
                    confirmDialog: confirmDialog
                };
                const copyButton = {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onMouseEnter: (0, $9fJGy.hoverTable)(false, true),
                            onMouseLeave: (0, $9fJGy.clearHoverSelection)(),
                            onFocus: (0, $9fJGy.hoverTable)(false, true),
                            onBlur: (0, $9fJGy.clearHoverSelection)()
                        }
                    ]
                };
                const isNestedTable = (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes') && (0, $9O539.isSelectionTableNestedInTable)(state);
                const hoverTableProps = (isInDanger, isSelected)=>({
                        onMouseEnter: (0, $9fJGy.hoverTable)(isInDanger, isSelected),
                        onMouseLeave: (0, $9fJGy.clearHoverSelection)(),
                        onFocus: (0, $9fJGy.hoverTable)(isInDanger, isSelected),
                        onBlur: (0, $9fJGy.clearHoverSelection)()
                    });
                const shouldGroupWithoutSeparators = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_6');
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const overflowDropdownTestId = (0, $VSDnB.fg)('platform_editor_controls_patch_8') ? 'table-overflow-dropdown-trigger' : undefined;
                return {
                    title: toolbarTitle,
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $iHYdz.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        ...!shouldGroupWithoutSeparators ? [
                            $fef7c46560ad10fb$var$separator(menu.hidden)
                        ] : [],
                        ...alignmentMenu,
                        ...!shouldGroupWithoutSeparators ? [
                            $fef7c46560ad10fb$var$separator(alignmentMenu.length === 0)
                        ] : [],
                        ...cellItems,
                        ...columnSettingsItems,
                        ...colorPicker,
                        ...(0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? [
                            {
                                type: 'extensions-placeholder',
                                separator: 'end'
                            },
                            copyButton,
                            {
                                type: 'separator'
                            },
                            deleteButton
                        ] : [
                            shouldGroupWithoutSeparators && {
                                type: 'separator',
                                fullHeight: true
                            },
                            {
                                type: 'overflow-dropdown',
                                testId: overflowDropdownTestId,
                                dropdownWidth: 220,
                                options: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        render: (editorView, dropdownOptions)=>{
                                            if (!editorView) return null;
                                            const extensionState = api?.extension?.sharedState?.currentState();
                                            const extensionApi = api?.extension?.actions.api();
                                            if (!extensionApi || !extensionState?.extensionProvider) return null;
                                            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1SrEi.DropdownMenuExtensionItems), {
                                                node: tableObject.node,
                                                editorView: editorView,
                                                extension: {
                                                    extensionProvider: extensionState?.extensionProvider ? Promise.resolve(extensionState.extensionProvider) : undefined,
                                                    extensionApi: api?.extension?.actions.api()
                                                },
                                                dropdownOptions: dropdownOptions,
                                                disabled: (key)=>{
                                                    return isNestedTable && [
                                                        'referentiality:connections',
                                                        'chart:insert-chart'
                                                    ].includes(key);
                                                }
                                            });
                                        }
                                    },
                                    {
                                        title: intl.formatMessage((0, $8DYpW.default).copyToClipboard),
                                        onClick: ()=>{
                                            api?.core?.actions.execute(// @ts-ignore
                                            api?.floatingToolbar?.commands.copyNode(nodeType, (0, $gkwXh.INPUT_METHOD).FLOATING_TB));
                                            return true;
                                        },
                                        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                                            label: intl.formatMessage((0, $8DYpW.default).copyToClipboard)
                                        }),
                                        ...hoverTableProps(false, true)
                                    },
                                    {
                                        title: intl.formatMessage((0, $8DYpW.default).delete),
                                        onClick: (0, $6lSoW.deleteTableWithAnalytics)(editorAnalyticsAPI),
                                        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0))), {
                                            label: intl.formatMessage((0, $8DYpW.default).delete)
                                        }),
                                        ...hoverTableProps(true)
                                    }
                                ]
                            }
                        ]
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $fef7c46560ad10fb$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $fef7c46560ad10fb$var$getCellItems = (state, view, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const initialSelectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
    if (initialSelectionRect) {
        const cellOptions = $fef7c46560ad10fb$export$99943093c6d7192b(state, view, initialSelectionRect, {
            formatMessage: formatMessage
        }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            cellOptions,
            $fef7c46560ad10fb$var$separator(cellOptions.hidden)
        ];
    }
    return [];
};
const $fef7c46560ad10fb$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $fef7c46560ad10fb$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $fISuL.getNewResizeStateFromSelectedColumns)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $6lSoW.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $fef7c46560ad10fb$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    const pluginState = (0, $gseSq.getPluginState)(editorState);
    const selectionOrTableRect = $fef7c46560ad10fb$var$getClosestSelectionOrTableRect(editorState);
    if (!selectionOrTableRect || !editorView) return [];
    const newResizeStateWithAnalytics = (0, $fISuL.getNewResizeStateFromSelectedColumns)(selectionOrTableRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
    const wouldChange = newResizeStateWithAnalytics?.changed ?? false;
    const items = [];
    if (pluginState?.pluginConfig?.allowDistributeColumns && pluginState.isDragAndDropEnabled) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $2V0EL.messages).distributeColumns),
        icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GUid))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jlnXH))),
                spacing: 'spacious',
                label: ''
            }),
        onClick: (state, dispatch, view)=>$fef7c46560ad10fb$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: !wouldChange
    });
    if (items.length !== 0 && (!(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') || !(0, $VSDnB.fg)('platform_editor_controls_patch_6'))) items.push({
        type: 'separator'
    });
    return items;
};
const $fef7c46560ad10fb$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $gseSq.getPluginState)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = node?.attrs?.background || '#ffffff';
    const defaultPalette = (0, $fHEWI.default).find((item)=>item.value === currentBackground) || {
        label: 'Custom',
        value: currentBackground,
        border: (0, $cGel6.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $2V0EL.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            defaultValue: defaultPalette,
            options: (0, $fHEWI.default),
            returnEscToButton: true,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: (option)=>(0, $6lSoW.setColorWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $fef7c46560ad10fb$var$separator(menu.hidden)
    ];
};
const $fef7c46560ad10fb$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $6lSoW.deleteTableWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
        else (0, $9K9fn.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };
const $fef7c46560ad10fb$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $9fJGy.hoverRows)((0, $9bHWx.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $fef7c46560ad10fb$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $fef7c46560ad10fb$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $9fJGy.hoverColumns)((0, $9bHWx.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $fef7c46560ad10fb$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $28MvW.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gvHjN))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-start-icon",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kTcZO)))
                })
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2LESl))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-center-icon",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5VgMH)))
                })
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $2V0EL.messages).alignTableCenter,
        'align-start': (0, $2V0EL.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $fkJZJ.normaliseAlignment)(currentLayout) === value,
            onClick: (0, $6lSoW.setTableAlignmentWithAnalytics)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $gkwXh.INPUT_METHOD).FLOATING_TB, (0, $dEzej.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...$fef7c46560ad10fb$var$isLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor) && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $vVoyO.FloatingAlignmentButtons), {
                alignmentButtons: alignmentButtons,
                ...props
            });
        },
        width: 74,
        height: 32
    };
    const selectedAlignmentIcon = $fef7c46560ad10fb$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $2V0EL.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon?.icon
        }
    ];
    return alignmentToolbarItem;
};
const $fef7c46560ad10fb$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $fkJZJ.normaliseAlignment)(selectedAlignment));
};
const $fef7c46560ad10fb$var$isLayoutOptionDisabled = (selectedNode, getEditorContainerWidth, getDomRef, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (editorView) {
        const tableWrapperWidth = (0, $VSDnB.fg)('platform_editor_remove_slow_table_transactions') ? tableContainerWidth : getDomRef(editorView)?.clientWidth || tableContainerWidth;
        const scalePercent = (0, $118VY.getStaticTableScalingPercent)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};

});
parcelRegister("1SrEi", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuExtensionItems", () => $c0abb1b1e7d87158$export$24b801b186044441);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $04ZRC = parcelRequire("04ZRC");

var $20Kbb = parcelRequire("20Kbb");

var $giNwu = parcelRequire("giNwu");
const $c0abb1b1e7d87158$var$noop = ()=>null;
const $c0abb1b1e7d87158$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $c0abb1b1e7d87158$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $c0abb1b1e7d87158$var$noop;
    const maybeIcon = await getIcon();
    return $c0abb1b1e7d87158$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $c0abb1b1e7d87158$var$convertExtensionToDropdownMenuItem = ({ item: item, disabled: disabled, node: node, extension: extension })=>{
    const ButtonIcon = item.icon ? (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        loader: async ()=>$c0abb1b1e7d87158$var$resolveExtensionIcon(item.icon),
        loading: $c0abb1b1e7d87158$var$noop
    }) : undefined;
    let title = '';
    if (item.label) title = item.label;
    else if (typeof item.tooltip === 'string') title = item.tooltip;
    else if (item.ariaLabel) title = item.ariaLabel;
    item.disabled = disabled?.(item.key) || false;
    return {
        title: title,
        icon: ButtonIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonIcon, {
            label: item.label || ''
        }) : undefined,
        disabled: item.disabled,
        onClick: ()=>{
            if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
            const targetNodeAdf = (0, $20Kbb.nodeToJSON)(node);
            extension.extensionApi && item.action(targetNodeAdf, extension.extensionApi);
            return true;
        }
    };
};
const $c0abb1b1e7d87158$var$DropdownMenuExtensionItem = ({ item: item, editorView: editorView, disabled: disabled, node: node, extension: extension, dropdownOptions: dropdownOptions })=>{
    const dropdownItem = $c0abb1b1e7d87158$var$convertExtensionToDropdownMenuItem({
        item: item,
        disabled: disabled,
        node: node,
        extension: extension
    });
    if (!dropdownItem) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $giNwu.DropdownMenuItem), {
        item: dropdownItem,
        editorView: editorView,
        hide: dropdownOptions.hide,
        dispatchCommand: dropdownOptions.dispatchCommand,
        showSelected: dropdownOptions.showSelected,
        intl: dropdownOptions.intl
    }, item.key);
};
const $c0abb1b1e7d87158$export$24b801b186044441 = (props)=>{
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $5uXOq.useState)([]);
    (0, $5uXOq.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extension.extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    }, [
        extension.extensionProvider
    ]);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $20Kbb.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!extension.extensionApi) return [];
        return (0, $04ZRC.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
    }, [
        extensions,
        nodeAdf,
        extension.extensionApi
    ]);
    if (!extensionItems.length || !dropdownOptions) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: extensionItems.map((item, idx)=>{
            if (!('key' in item)) return null;
            return /*#__PURE__*/ (0, $2OMIu.jsx)($c0abb1b1e7d87158$var$DropdownMenuExtensionItem, {
                item: item,
                editorView: editorView,
                disabled: disabled,
                node: node,
                extension: extension,
                dropdownOptions: dropdownOptions
            }, item.key);
        })
    });
};

});
parcelRegister("giNwu", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuItem", () => $f5ef40db916bd879$export$ed97964d1871885d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eJbwP = parcelRequire("eJbwP");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $5K8Ey = parcelRequire("5K8Ey");
function $f5ef40db916bd879$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5ef40db916bd879$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $f5ef40db916bd879$var$labelStyles = {
    name: "18nns55",
    styles: "display:inline-block;width:100%"
};
const $f5ef40db916bd879$var$spacerStyles = {
    name: "nce1h9",
    styles: "display:flex;flex:1;padding:var(--ds-space-100, 8px)"
};
const $f5ef40db916bd879$var$DropdownButtonItem = (0, $kJpBP.default);
const $f5ef40db916bd879$var$SelectedIconBefore = ({ itemSelected: itemSelected, intl: intl, showSelected: showSelected })=>{
    if (showSelected && itemSelected) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
        LEGACY_primaryColor: "var(--ds-icon-selected, #0C66E4)",
        LEGACY_size: "small",
        label: intl.formatMessage((0, $5K8Ey.default).confirmModalOK),
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $f5ef40db916bd879$var$spacerStyles
    });
};
const $f5ef40db916bd879$export$ed97964d1871885d = (props)=>{
    const { item: item, hide: hide, dispatchCommand: dispatchCommand, editorView: editorView, showSelected: showSelected, intl: intl } = props;
    const itemSelected = item.selected;
    const iconBefore = (0, $5uXOq.useMemo)(()=>{
        if (item.icon) return item.icon;
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)($f5ef40db916bd879$var$SelectedIconBefore, {
            itemSelected: itemSelected,
            showSelected: showSelected,
            intl: intl
        });
    }, [
        itemSelected,
        showSelected,
        intl,
        item.icon
    ]);
    const [tooltipContent, setTooltipContent] = (0, $5uXOq.useState)(item.tooltip || '');
    const handleItemMouseOut = (0, $5uXOq.useCallback)(()=>{
        setTooltipContent('');
        if (item.onMouseOut) dispatchCommand(item.onMouseOut);
    }, [
        item.onMouseOut,
        dispatchCommand
    ]);
    const handleItemMouseDown = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault(); // ED-16204 - This is needed for safari to get handleItemClick() to work
        if (item.onMouseDown) dispatchCommand(item.onMouseDown);
    }, [
        item.onMouseDown,
        dispatchCommand
    ]);
    const handleItemMouseOver = (0, $5uXOq.useCallback)(()=>{
        setTooltipContent(item.tooltip || '');
        if (item.onMouseOver) dispatchCommand(item.onMouseOver);
    }, [
        item.tooltip,
        item.onMouseOver,
        dispatchCommand
    ]);
    const handleItemMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        if (item.onMouseEnter) {
            e.preventDefault();
            dispatchCommand(item.onMouseEnter);
        }
    }, [
        item.onMouseEnter,
        dispatchCommand
    ]);
    const handleItemMouseLeave = (0, $5uXOq.useCallback)((e)=>{
        if (item.onMouseLeave) {
            e.preventDefault();
            dispatchCommand(item.onMouseLeave);
        }
    }, [
        item.onMouseLeave,
        dispatchCommand
    ]);
    const handleItemOnFocus = (0, $5uXOq.useCallback)((e)=>{
        if (item.onFocus) {
            e.preventDefault();
            dispatchCommand(item.onFocus);
        }
    }, [
        item.onFocus,
        dispatchCommand
    ]);
    const handleItemOnBlur = (0, $5uXOq.useCallback)((e)=>{
        if (item.onBlur) {
            e.preventDefault();
            dispatchCommand(item.onBlur);
        }
    }, [
        item.onBlur,
        dispatchCommand
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(()=>{
        /**
     * The order of dispatching the event and hide() is important, because
     * the ClickAreaBlock will be relying on the element to calculate the
     * click coordinate.
     * For more details, please visit the comment in this PR https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5328/edm-1321-set-selection-near-smart-link?link_source=email#chg-packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
     */ dispatchCommand(item.onClick);
        hide();
        if (!editorView?.hasFocus()) editorView?.focus();
    }, [
        dispatchCommand,
        item.onClick,
        hide,
        editorView
    ]);
    /* ED-16704 - Native mouse event handler to overcome firefox issue on disabled <button> - https://github.com/whatwg/html/issues/5886 */ const labelRef = (0, $5uXOq.useRef)(null);
    const handleTitleWrapperMouseEvent = (0, $5uXOq.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (item.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, [
        item.disabled
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isAriaChecked = (item)=>{
        const { selected: selected, domItemOptions: domItemOptions } = item;
        return domItemOptions?.type === 'item-checkbox' ? selected : undefined;
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasRole = (item)=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_9')) return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : 'menuitem';
        return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : undefined;
    };
    (0, $5uXOq.useEffect)(()=>{
        const labelRefCurrent = labelRef.current;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('click', handleTitleWrapperMouseEvent);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('mousedown', handleTitleWrapperMouseEvent);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('click', handleTitleWrapperMouseEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('mousedown', handleTitleWrapperMouseEvent);
        };
    });
    const itemContent = /*#__PURE__*/ (0, $f8Sb3.jsx)($f5ef40db916bd879$var$DropdownButtonItem, {
        isSelected: itemSelected,
        iconBefore: iconBefore,
        iconAfter: item.elemAfter,
        onClick: handleItemClick,
        "data-testid": item.testId,
        isDisabled: item.disabled,
        onMouseDown: handleItemMouseDown,
        onMouseOver: handleItemMouseOver,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        onMouseOut: handleItemMouseOut,
        onFocus: handleItemOnFocus,
        onBlur: handleItemOnBlur,
        role: hasRole(item),
        "aria-checked": isAriaChecked(item)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: labelRef,
        css: $f5ef40db916bd879$var$labelStyles
    }, item.title));
    if (tooltipContent) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent
    }, itemContent);
    return itemContent;
};

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});




parcelRegister("fHEWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8a61aca86c59bc$export$2e2bcd8739ae039);

var $9UDEr = parcelRequire("9UDEr");

var $7zTX4 = parcelRequire("7zTX4");

var $lPMag = parcelRequire("lPMag");
const $bc8a61aca86c59bc$var$cellBackgroundColorPalette = [];
(0, $9UDEr.tableBackgroundColorPalette).forEach((label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $7zTX4.default)((0, $lPMag.default), key);
    $bc8a61aca86c59bc$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $9UDEr.tableBackgroundBorderColor),
        message: message
    });
});
var $bc8a61aca86c59bc$export$2e2bcd8739ae039 = $bc8a61aca86c59bc$var$cellBackgroundColorPalette;

});
parcelRegister("7zTX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85823ff75ec00d0$export$2e2bcd8739ae039);
function $f85823ff75ec00d0$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("lPMag", function(module, exports) {

$parcel$export(module.exports, "default", () => $6529092b9ec46438$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6529092b9ec46438$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    white: {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    'light-blue': {
        id: 'fabric.theme.light-blue',
        defaultMessage: 'Light blue',
        description: 'Name of a color'
    },
    'light-teal': {
        id: 'fabric.theme.light-teal',
        defaultMessage: 'Light teal',
        description: 'Name of a color'
    },
    'light-green': {
        id: 'fabric.theme.light-green',
        defaultMessage: 'Light green',
        description: 'Name of a color'
    },
    'light-yellow': {
        id: 'fabric.theme.light-yellow',
        defaultMessage: 'Light yellow',
        description: 'Name of a color'
    },
    'light-red': {
        id: 'fabric.theme.light-red',
        defaultMessage: 'Light red',
        description: 'Name of a color'
    },
    'light-purple': {
        id: 'fabric.theme.light-purple',
        defaultMessage: 'Light purple',
        description: 'Name of a color'
    },
    'light-gray': {
        id: 'fabric.theme.light-gray',
        defaultMessage: 'Light gray',
        description: 'Name of a color'
    },
    blue: {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    teal: {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    green: {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    yellow: {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    red: {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    orange: {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    purple: {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    gray: {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    'dark-blue': {
        id: 'fabric.theme.dark-blue',
        defaultMessage: 'Dark blue',
        description: 'Name of a color'
    },
    'dark-teal': {
        id: 'fabric.theme.dark-teal',
        defaultMessage: 'Dark teal',
        description: 'Name of a color'
    },
    'dark-green': {
        id: 'fabric.theme.dark-green',
        defaultMessage: 'Dark green',
        description: 'Name of a color'
    },
    'dark-yellow': {
        id: 'fabric.theme.dark-yellow',
        defaultMessage: 'Dark yellow',
        description: 'Name of a color'
    },
    'dark-red': {
        id: 'fabric.theme.dark-red',
        defaultMessage: 'Dark red',
        description: 'Name of a color'
    },
    'dark-purple': {
        id: 'fabric.theme.dark-purple',
        defaultMessage: 'Dark purple',
        description: 'Name of a color'
    },
    'subtle-gray': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    'bold-gray': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    // Colors only used in highlight palette
    'no-color': {
        id: 'fabric.theme.no-color',
        defaultMessage: 'No highlight',
        description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
    },
    lime: {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
    },
    magenta: {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
    }
});

});


parcelRegister("cGel6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BORDER_COLOR", () => $2ca56123707c7972$export$f54f5cacf382b9f2);

var $dBl98 = parcelRequire("dBl98");
/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $2ca56123707c7972$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $dBl98.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $2ca56123707c7972$export$f54f5cacf382b9f2 = $2ca56123707c7972$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});

parcelRegister("aOnxY", function(module, exports) {

$parcel$export(module.exports, "splitCell", () => $89bf427b0b077ae6$export$74933b5979945879);

var $cQdoo = parcelRequire("cQdoo");

var $3yjNu = parcelRequire("3yjNu");
const $89bf427b0b077ae6$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $3yjNu.tableNodeTypes)(state.schema);
    return (0, $cQdoo.splitCellWithType)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};

});
parcelRegister("cQdoo", function(module, exports) {

$parcel$export(module.exports, "splitCellWithType", () => $a5e2f051490863c7$export$8c441a625fd4d770);

var $kCV8T = parcelRequire("kCV8T");

var $hFEwm = parcelRequire("hFEwm");

var $6hQQ3 = parcelRequire("6hQQ3");

var $hHsVB = parcelRequire("hHsVB");
function $a5e2f051490863c7$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}
function $a5e2f051490863c7$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        const sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $hFEwm.CellSelection))) {
            cellNode = $a5e2f051490863c7$export$603245c099db0b11(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $6hQQ3.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            const rect = (0, $hHsVB.selectedRect)(state);
            const tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $hFEwm.CellSelection) && $lastCellPosition instanceof (0, $kCV8T.ResolvedPos)) {
                const cellSelection = new (0, $hFEwm.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}

});


parcelRegister("2LESl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c29f4a0259814750cfbaa12b98a0b76b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $203fad917f7870a7$var$_react = $203fad917f7870a7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $203fad917f7870a7$var$_baseNew = $203fad917f7870a7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $203fad917f7870a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $203fad917f7870a7$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $203fad917f7870a7$var$_react.default.createElement($203fad917f7870a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$203fad917f7870a7$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $203fad917f7870a7$var$_default = module.exports.default = $203fad917f7870a7$var$AlignImageCenterIcon;

});

parcelRegister("gvHjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::506bf6a220572205d8f164c0b4e914b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05124b017ce4e0b$var$_react = $c05124b017ce4e0b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c05124b017ce4e0b$var$_baseNew = $c05124b017ce4e0b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c05124b017ce4e0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05124b017ce4e0b$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $c05124b017ce4e0b$var$_react.default.createElement($c05124b017ce4e0b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$c05124b017ce4e0b$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $c05124b017ce4e0b$var$_default = module.exports.default = $c05124b017ce4e0b$var$AlignImageLeftIcon;

});

parcelRegister("8jMCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59e43c1f00fcc95f49aa5b3733f7f372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));

var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>/*#__PURE__*/ $60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
    }, props));
$60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});


parcelRegister("5VgMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44ff4babc14cbb00$var$_react = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $44ff4babc14cbb00$var$_alignImageCenter = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("2LESl")));
function $44ff4babc14cbb00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $44ff4babc14cbb00$var$EditorAlignImageCenterIcon = (props)=>/*#__PURE__*/ $44ff4babc14cbb00$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $44ff4babc14cbb00$var$_alignImageCenter.default
    }));
$44ff4babc14cbb00$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var $44ff4babc14cbb00$var$_default = module.exports.default = $44ff4babc14cbb00$var$EditorAlignImageCenterIcon;

});

parcelRegister("kTcZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f353066a4e332113$var$_react = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f353066a4e332113$var$_alignImageLeft = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("gvHjN")));
function $f353066a4e332113$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f353066a4e332113$var$EditorAlignImageLeftIcon = (props)=>/*#__PURE__*/ $f353066a4e332113$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $f353066a4e332113$var$_alignImageLeft.default
    }));
$f353066a4e332113$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var $f353066a4e332113$var$_default = module.exports.default = $f353066a4e332113$var$EditorAlignImageLeftIcon;

});

parcelRegister("9fJGy", function(module, exports) {

$parcel$export(module.exports, "hoverMergedCells", () => $a4f7d4b1c2b2c269$export$59dcdc44819c7e7c);
$parcel$export(module.exports, "hoverColumns", () => $a4f7d4b1c2b2c269$export$4cf548f2efac0afe);
$parcel$export(module.exports, "hoverRows", () => $a4f7d4b1c2b2c269$export$ab63d99b591b89);
$parcel$export(module.exports, "hoverTable", () => $a4f7d4b1c2b2c269$export$41c571b711ba06e);
$parcel$export(module.exports, "clearHoverSelection", () => $a4f7d4b1c2b2c269$export$d4bebf197f3770e4);
$parcel$export(module.exports, "showResizeHandleLine", () => $a4f7d4b1c2b2c269$export$9b72d13d82d16e72);
$parcel$export(module.exports, "hideResizeHandleLine", () => $a4f7d4b1c2b2c269$export$5ad4eed96dbaffaf);
$parcel$export(module.exports, "setTableHovered", () => $a4f7d4b1c2b2c269$export$f217071b524cec4f);
$parcel$export(module.exports, "hoverCell", () => $a4f7d4b1c2b2c269$export$1d614a0f0fe37c44);
// #region Imports

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $l57lo = parcelRequire("l57lo");
var $fCttG = parcelRequire("fCttG");

var $jecUf = parcelRequire("jecUf");

var $gseSq = parcelRequire("gseSq");

var $9kb0R = parcelRequire("9kb0R");

var $3PWLJ = parcelRequire("3PWLJ");

var $fc5Ja = parcelRequire("fc5Ja");
const $a4f7d4b1c2b2c269$var$makeArray = (n)=>Array.from(Array(n).keys());
const $a4f7d4b1c2b2c269$export$59dcdc44819c7e7c = ()=>(0, $gseSq.createCommand)((state)=>{
        const mergedCellsPositions = (0, $3PWLJ.getMergedCellsPositions)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $28MvW.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $9kb0R.createCellHoverDecoration)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a4f7d4b1c2b2c269$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $gseSq.createCommand)((state)=>{
        const cells = (0, $l57lo.getCellsInColumn)(hoveredColumns)(state.tr.selection);
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        if (!cells) return false;
        const decorations = (0, $9kb0R.createControlsHoverDecoration)(cells, 'column', state.tr, isDragAndDropEnabled, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a4f7d4b1c2b2c269$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $gseSq.createCommand)((state)=>{
        const cells = (0, $fCttG.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        const decorations = (0, $9kb0R.createControlsHoverDecoration)(cells, 'row', state.tr, isDragAndDropEnabled, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a4f7d4b1c2b2c269$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $gseSq.createCommand)((state)=>{
        const table = (0, $28MvW.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $uOUlv.TableMap).get(table.node);
        const hoveredColumns = $a4f7d4b1c2b2c269$var$makeArray(map.width);
        const hoveredRows = $a4f7d4b1c2b2c269$var$makeArray(map.height);
        const cells = (0, $fCttG.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        const decorations = (0, $9kb0R.createControlsHoverDecoration)(cells, 'table', state.tr, isDragAndDropEnabled, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, decorations, (0, $jecUf.TableDecorations).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a4f7d4b1c2b2c269$export$d4bebf197f3770e4 = ()=>(0, $gseSq.createCommand)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, [], (0, $jecUf.TableDecorations).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $a4f7d4b1c2b2c269$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $gseSq.createCommand)((state)=>{
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        return {
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, (0, $9kb0R.createColumnLineResize)(state.selection, cellColumnPositioning, isDragAndDropEnabled), (0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        };
    });
const $a4f7d4b1c2b2c269$export$5ad4eed96dbaffaf = ()=>(0, $gseSq.createCommand)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $fc5Ja.updatePluginStateDecorations)(state, [], (0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $a4f7d4b1c2b2c269$export$f217071b524cec4f = (hovered)=>(0, $gseSq.createCommand)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a4f7d4b1c2b2c269$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $gseSq.createCommand)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $gseSq.getPluginState)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("3PWLJ", function(module, exports) {

$parcel$export(module.exports, "getMergedCellsPositions", () => $4e486fdc09d85fc3$export$ffded79ba5549697);
$parcel$export(module.exports, "getAssistiveMessage", () => $4e486fdc09d85fc3$export$cea95ea93d5f9224);

var $2V0EL = parcelRequire("2V0EL");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
const $4e486fdc09d85fc3$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $28MvW.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $uOUlv.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $4e486fdc09d85fc3$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $uOUlv.TableMap).get(prevTableNode);
    const currentTableMap = (0, $uOUlv.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $2V0EL.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $2V0EL.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $2V0EL.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $2V0EL.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};

});


parcelRegister("9K9fn", function(module, exports) {

$parcel$export(module.exports, "removeDescendantNodes", () => $1fa6efdffd50ffba$export$fa79c3ccfdddfece);

var $hEIDx = parcelRequire("hEIDx");

var $gseSq = parcelRequire("gseSq");
const $1fa6efdffd50ffba$export$fa79c3ccfdddfece = (sourceNode)=>(0, $gseSq.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $hEIDx.removeConnectedNodes)(state, sourceNode) : tr;
    });

});

parcelRegister("6lSoW", function(module, exports) {

$parcel$export(module.exports, "emptyMultipleCellsWithAnalytics", () => $c51cc979f8c1e8d2$export$67e5a2aa802b5be1);
$parcel$export(module.exports, "mergeCellsWithAnalytics", () => $c51cc979f8c1e8d2$export$96680f9d22153cab);
$parcel$export(module.exports, "splitCellWithAnalytics", () => $c51cc979f8c1e8d2$export$e30671f873d3125c);
$parcel$export(module.exports, "setColorWithAnalytics", () => $c51cc979f8c1e8d2$export$d0cc02883d6bbba);
$parcel$export(module.exports, "addRowAroundSelection", () => $c51cc979f8c1e8d2$export$4df69ad9d7ac565d);
$parcel$export(module.exports, "insertRowWithAnalytics", () => $c51cc979f8c1e8d2$export$e45f3a1f9c021052);
$parcel$export(module.exports, "changeColumnWidthByStepWithAnalytics", () => $c51cc979f8c1e8d2$export$e75fc938db126e1a);
$parcel$export(module.exports, "insertColumnWithAnalytics", () => $c51cc979f8c1e8d2$export$fc693eab55df8b35);
$parcel$export(module.exports, "deleteRowsWithAnalytics", () => $c51cc979f8c1e8d2$export$ad9854279980efbe);
$parcel$export(module.exports, "deleteColumnsWithAnalytics", () => $c51cc979f8c1e8d2$export$4c11b948fab97510);
$parcel$export(module.exports, "deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut", () => $c51cc979f8c1e8d2$export$a5b48d8f68e0fbd);
$parcel$export(module.exports, "deleteTableWithAnalytics", () => $c51cc979f8c1e8d2$export$3e2fb93914330b82);
$parcel$export(module.exports, "deleteTableIfSelectedWithAnalytics", () => $c51cc979f8c1e8d2$export$253ebd9c41cefd54);
$parcel$export(module.exports, "toggleHeaderRowWithAnalytics", () => $c51cc979f8c1e8d2$export$2e66edaa488e7a1d);
$parcel$export(module.exports, "toggleHeaderColumnWithAnalytics", () => $c51cc979f8c1e8d2$export$9fd5a66fcada8ad2);
$parcel$export(module.exports, "toggleNumberColumnWithAnalytics", () => $c51cc979f8c1e8d2$export$9e4b8d27ecc9c55);
$parcel$export(module.exports, "sortColumnWithAnalytics", () => $c51cc979f8c1e8d2$export$1be9cb7a554871e3);
$parcel$export(module.exports, "distributeColumnsWidthsWithAnalytics", () => $c51cc979f8c1e8d2$export$9bca7816a0c95373);
$parcel$export(module.exports, "wrapTableInExpandWithAnalytics", () => $c51cc979f8c1e8d2$export$70cd1c3ffea1a5d0);
$parcel$export(module.exports, "toggleFixedColumnWidthsOptionAnalytics", () => $c51cc979f8c1e8d2$export$ebf85a007abbf908);
$parcel$export(module.exports, "setTableAlignmentWithAnalytics", () => $c51cc979f8c1e8d2$export$5d8dfbdf832abbae);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPosWithAnalytics", () => $c51cc979f8c1e8d2$export$58691b745e97f79d);

var $9UDEr = parcelRequire("9UDEr");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $31nwk = parcelRequire("31nwk");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");

var $gseSq = parcelRequire("gseSq");

var $9u865 = parcelRequire("9u865");

var $cUQeV = parcelRequire("cUQeV");

var $fUbGn = parcelRequire("fUbGn");

var $hxf42 = parcelRequire("hxf42");

var $evhdb = parcelRequire("evhdb");

var $aAmt7 = parcelRequire("aAmt7");

var $fBkEA = parcelRequire("fBkEA");

var $9iOcS = parcelRequire("9iOcS");

var $fU3Yc = parcelRequire("fU3Yc");

var $fxDYU = parcelRequire("fxDYU");

var $4aKeM = parcelRequire("4aKeM");

var $66MHx = parcelRequire("66MHx");

var $2TykN = parcelRequire("2TykN");

var $3BFNI = parcelRequire("3BFNI");

var $4nVrL = parcelRequire("4nVrL");
const $c51cc979f8c1e8d2$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedCellInfo)(selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).CLEARED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $aAmt7.clearMultipleCells)(targetCellPosition));
const $c51cc979f8c1e8d2$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedCellInfo)(selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).MERGED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $fUbGn.mergeCells)(state.tr));
            return true;
        });
const $c51cc979f8c1e8d2$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedCellInfo)(selection);
            const cell = (0, $28MvW.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $dEzej.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $3BFNI.splitCell));
const $c51cc979f8c1e8d2$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedCellInfo)(selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).COLORED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $9UDEr.tableBackgroundColorPalette).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $66MHx.setMultipleCellAttrs)({
            background: cellColor
        }, editorView));
const $c51cc979f8c1e8d2$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $hFEwm.CellSelection);
            const rect = isCellSelection ? (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $c51cc979f8c1e8d2$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $c51cc979f8c1e8d2$export$e45f3a1f9c021052 = (editorAnalyticsAPI)=>(inputMethod, options)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $4aKeM.insertRow)(options.index, options.moveCursorToInsertedRow));
const $c51cc979f8c1e8d2$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $gseSq.getPluginState)(state);
            return {
                action: (0, $dEzej.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table?.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $9iOcS.changeColumnWidthByStep)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $c51cc979f8c1e8d2$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $4aKeM.insertColumn)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $c51cc979f8c1e8d2$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $cUQeV.deleteRows)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $c51cc979f8c1e8d2$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $fU3Yc.deleteColumnsCommand)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $c51cc979f8c1e8d2$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $hFEwm.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $66MHx.getTableSelectionType)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $gseSq.getPluginState)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $c51cc979f8c1e8d2$export$ad9854279980efbe(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $c51cc979f8c1e8d2$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $gkwXh.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $c51cc979f8c1e8d2$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(selection);
    return {
        action: (0, $dEzej.TABLE_ACTION).DELETED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
};
const $c51cc979f8c1e8d2$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>$c51cc979f8c1e8d2$var$getTableDeletedAnalytics(selection, (0, $gkwXh.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $66MHx.deleteTable));
const $c51cc979f8c1e8d2$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $hxf42.withEditorAnalyticsAPI)(({ selection: selection })=>$c51cc979f8c1e8d2$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $66MHx.deleteTableIfSelected));
const $c51cc979f8c1e8d2$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $gseSq.getPluginState)(state);
        return {
            action: (0, $dEzej.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4nVrL.toggleHeaderRow));
const $c51cc979f8c1e8d2$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $gseSq.getPluginState)(state);
        return {
            action: (0, $dEzej.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4nVrL.toggleHeaderColumn));
const $c51cc979f8c1e8d2$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $dEzej.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $evhdb.checkIfNumberColumnEnabled)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4nVrL.toggleNumberColumn));
const $c51cc979f8c1e8d2$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $2TykN.sortByColumn)(columnIndex, sortOrder));
const $c51cc979f8c1e8d2$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $hxf42.withEditorAnalyticsAPI)(()=>{
            return {
                action: (0, $dEzej.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $9u865.distributeColumnsWidths)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $c51cc979f8c1e8d2$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $dEzej.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $fBkEA.wrapTableInExpand));
const $c51cc979f8c1e8d2$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table?.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $dEzej.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $dEzej.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table?.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $31nwk.editorCommandToPMCommand)((0, $fxDYU.setTableDisplayMode)));
const $c51cc979f8c1e8d2$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, // previous alignment could be a breakout value, if so use 'null' to indicate alignment was not previously set
    previousAlignment, inputMethod, reason)=>(0, $hxf42.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $dEzej.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table?.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $31nwk.editorCommandToPMCommand)((0, $66MHx.setTableAlignment)(newAlignment, isCommentEditor)));
const $c51cc979f8c1e8d2$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $hxf42.withEditorAnalyticsAPI)(()=>{
            const map = (0, $uOUlv.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $dEzej.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $31nwk.editorCommandToPMCommand)((0, $66MHx.setTableAlignmentWithTableContentWithPos)(newAlignment, tableNodeWithPos)));

});
parcelRegister("9u865", function(module, exports) {

$parcel$export(module.exports, "evenColumns", () => $fb82c982fae72d18$export$c955b9a736441250);
$parcel$export(module.exports, "distributeColumnsWidths", () => $fb82c982fae72d18$export$e8f15c4883bd4cb9);
$parcel$export(module.exports, "stopResizing", () => $fb82c982fae72d18$export$d1301521f1f26547);
$parcel$export(module.exports, "setResizeHandlePos", () => $fb82c982fae72d18$export$4d14ce8b526952e5);
$parcel$export(module.exports, "setDragging", () => $fb82c982fae72d18$export$e747fb9908ce65b7);

var $dEzej = parcelRequire("dEzej");

var $cK1Lv = parcelRequire("cK1Lv");

var $aajRL = parcelRequire("aajRL");

var $7DDbz = parcelRequire("7DDbz");

var $gEcXI = parcelRequire("gEcXI");

var $7mmRV = parcelRequire("7mmRV");

var $fISuL = parcelRequire("fISuL");
const $fb82c982fae72d18$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $cK1Lv.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $gEcXI.getPluginState)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $7mmRV.isClickNear)(event, lastClick)) {
            const newState = (0, $fISuL.evenAllColumnsWidths)(resizeState);
            $fb82c982fae72d18$var$setLastClick(null, (tr)=>(0, $7DDbz.updateColumnWidths)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $fb82c982fae72d18$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $fb82c982fae72d18$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $7DDbz.updateColumnWidths)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $fb82c982fae72d18$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $fb82c982fae72d18$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $gEcXI.createCommand)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $fb82c982fae72d18$export$d1301521f1f26547 = (tr)=>(0, $gEcXI.createCommand)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $fb82c982fae72d18$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $gEcXI.createCommand)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $fb82c982fae72d18$var$setLastClick = (lastClick, transform)=>(0, $gEcXI.createCommand)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);

});
parcelRegister("gEcXI", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $f1e5767ecd2bf388$export$8d4021544bdece00);
$parcel$export(module.exports, "createPluginState", () => $f1e5767ecd2bf388$export$656c7661095efe2e);
$parcel$export(module.exports, "getPluginState", () => $f1e5767ecd2bf388$export$f05434c51e3762e);
// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck

var $aOimD = parcelRequire("aOimD");

var $k8KvZ = parcelRequire("k8KvZ");

var $5zhcJ = parcelRequire("5zhcJ");
function $f1e5767ecd2bf388$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $f1e5767ecd2bf388$var$factory = (0, $aOimD.pluginFactory)((0, $k8KvZ.pluginKey), (0, $5zhcJ.default), {
    mapping: $f1e5767ecd2bf388$var$mapping
});
const $f1e5767ecd2bf388$export$8d4021544bdece00 = $f1e5767ecd2bf388$var$factory.createCommand;
const $f1e5767ecd2bf388$export$656c7661095efe2e = $f1e5767ecd2bf388$var$factory.createPluginState;
const $f1e5767ecd2bf388$export$f05434c51e3762e = $f1e5767ecd2bf388$var$factory.getPluginState;

});
parcelRegister("5zhcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $137ebb48f53162b2$export$2e2bcd8739ae039);
var $137ebb48f53162b2$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("cUQeV", function(module, exports) {

$parcel$export(module.exports, "deleteRows", () => $af5d835cb7b81c49$export$88b7a0bb8d808bf6);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $cPPiz = parcelRequire("cPPiz");

var $fUbGn = parcelRequire("fUbGn");
const $af5d835cb7b81c49$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $uOUlv.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $fUbGn.mergeEmptyColumns)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $af5d835cb7b81c49$var$getNextCursorPos(newTable, rowsToDelete);
        // If we delete a row we should also clean up the hover selection
        if ((0, $VSDnB.fg)('platform_editor_remove_slow_table_transactions')) tr.setMeta((0, $cPPiz.pluginKey), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $af5d835cb7b81c49$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $uOUlv.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}

});
parcelRegister("fUbGn", function(module, exports) {

$parcel$export(module.exports, "mergeCells", () => $3cbf8aab4fb0354f$export$124b0cee26577176);
$parcel$export(module.exports, "canMergeCells", () => $3cbf8aab4fb0354f$export$9df87bad3fce982f);
$parcel$export(module.exports, "mergeEmptyColumns", () => $3cbf8aab4fb0354f$export$84575ef2cffee22a);

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
function $3cbf8aab4fb0354f$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $hFEwm.CellSelection)) || !$3cbf8aab4fb0354f$export$9df87bad3fce982f(tr)) return tr;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rect = (0, $b1RTQ.getSelectionRect)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $28MvW.findTable)(selection);
    const map = (0, $uOUlv.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $3cbf8aab4fb0354f$var$isEmptyCell(cell) ? (0, $kCV8T.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$3cbf8aab4fb0354f$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $3cbf8aab4fb0354f$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $kCV8T.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $3cbf8aab4fb0354f$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $gZGBX.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $3cbf8aab4fb0354f$export$9df87bad3fce982f(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $hFEwm.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $b1RTQ.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    if ($3cbf8aab4fb0354f$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $3cbf8aab4fb0354f$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $3cbf8aab4fb0354f$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $3cbf8aab4fb0354f$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $3cbf8aab4fb0354f$var$getEmptyColumnIndexes(table) {
    const map = (0, $uOUlv.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $3cbf8aab4fb0354f$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $uOUlv.TableMap).get(table);
    const emptyColumnIndexes = $3cbf8aab4fb0354f$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}

});


parcelRegister("aAmt7", function(module, exports) {

$parcel$export(module.exports, "clearMultipleCells", () => $b5eb1c7e8dc40780$export$5d68db27bfdddb78);

var $gZGBX = parcelRequire("gZGBX");

var $goAyn = parcelRequire("goAyn");
var $28MvW = parcelRequire("28MvW");
var $iGxzn = parcelRequire("iGxzn");
const $b5eb1c7e8dc40780$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $iGxzn.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $goAyn.emptyCell)((0, $28MvW.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $28MvW.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $goAyn.emptyCell)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $gZGBX.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("goAyn", function(module, exports) {

$parcel$export(module.exports, "emptyCell", () => $374dde1f3d4b59b3$export$1a1df84fec87e1b5);

var $8HJeP = parcelRequire("8HJeP");

var $3yjNu = parcelRequire("3yjNu");
const $374dde1f3d4b59b3$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $3yjNu.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $8HJeP.cloneTr)(tr);
            }
        }
        return tr;
    };

});


parcelRegister("fBkEA", function(module, exports) {

$parcel$export(module.exports, "wrapTableInExpand", () => $dea5ccc7a6175941$export$8afb7fb379a7ebd1);

var $4MKI8 = parcelRequire("4MKI8");
const $dea5ccc7a6175941$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $4MKI8.collapseSelectedTable)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};

});

parcelRegister("9iOcS", function(module, exports) {

$parcel$export(module.exports, "initiateKeyboardColumnResizing", () => $dcbe251430eccc7d$export$833f46f974daec36);
$parcel$export(module.exports, "activateNextResizeArea", () => $dcbe251430eccc7d$export$44cde2b92e1bbc4a);
$parcel$export(module.exports, "changeColumnWidthByStep", () => $dcbe251430eccc7d$export$4627714f08bcfd8);
$parcel$export(module.exports, "stopKeyboardColumnResizing", () => $dcbe251430eccc7d$export$b77825ff607efdbb);

var $2V0EL = parcelRequire("2V0EL");

var $6gEe5 = parcelRequire("6gEe5");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");
var $6hQQ3 = parcelRequire("6hQQ3");

var $jecUf = parcelRequire("jecUf");

var $5PQ8U = parcelRequire("5PQ8U");

var $jB7vb = parcelRequire("jB7vb");

var $gseSq = parcelRequire("gseSq");

var $gEcXI = parcelRequire("gEcXI");

var $k8KvZ = parcelRequire("k8KvZ");

var $7mmRV = parcelRequire("7mmRV");

var $118VY = parcelRequire("118VY");

var $eC4bz = parcelRequire("eC4bz");

var $fISuL = parcelRequire("fISuL");

var $7DDbz = parcelRequire("7DDbz");

var $9kb0R = parcelRequire("9kb0R");

var $9bHWx = parcelRequire("9bHWx");
const $dcbe251430eccc7d$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $gseSq.createCommand)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $dcbe251430eccc7d$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos, nodeViewPortalProviderAPI)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $jB7vb.buildColumnResizingDecorations)(rowIndex, columnIndex, true, getIntl, nodeViewPortalProviderAPI)({
            tr: customTr,
            decorationSet: (0, $5PQ8U.getDecorations)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $9kb0R.updateDecorations)(customTr.doc, decorationsWithWidget, (0, $9kb0R.createColumnLineResize)(state.selection, {
            right: columnIndex
        }, isDragAndDropEnabled), (0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $dcbe251430eccc7d$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $k8KvZ.pluginKey), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $dcbe251430eccc7d$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $iGxzn.isSelectionType)(selection, 'cell') ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $28MvW.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $dcbe251430eccc7d$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos, nodeViewPortalProviderAPI)(state, dispatch);
        return false;
    };
const $dcbe251430eccc7d$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $gEcXI.getPluginState)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $28MvW.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $28MvW.findTableClosestToPos)($currentCell);
        const tableMap = (0, $uOUlv.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $6hQQ3.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $dcbe251430eccc7d$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $dcbe251430eccc7d$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $dcbe251430eccc7d$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch);
            }
        }
        return false;
    };
const $dcbe251430eccc7d$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $gEcXI.getPluginState)(state);
        const cell = (0, $28MvW.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $uOUlv.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell?.node.attrs;
        const width = (0, $118VY.currentColWidth)(view, cell?.pos, cellAttrs);
        (0, $gEcXI.createCommand)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $118VY.getTableMaxWidth)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $fISuL.getResizeState)({
            minWidth: (0, $6gEe5.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $7mmRV.updateControls)()(state);
        const selectionRect = (0, $b1RTQ.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $9bHWx.getSelectedColumnIndexes)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width ? (0, $118VY.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $118VY.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
        const newResizeState = (0, $eC4bz.resizeColumn)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $7DDbz.updateColumnWidths)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $dcbe251430eccc7d$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $jB7vb.clearColumnResizingDecorations)()({
            tr: customTr,
            decorationSet: (0, $5PQ8U.getDecorations)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $9kb0R.updateDecorations)(customTr.doc, decorationWithoutWidget, [], (0, $jecUf.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $dcbe251430eccc7d$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $gEcXI.createCommand)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };

});
parcelRegister("eC4bz", function(module, exports) {

$parcel$export(module.exports, "resizeColumn", () => $fbd7abc477df0d0f$export$7f7e69ee7fe25ed6);
// Resize a given column by an amount from the current state

var $8rO01 = parcelRequire("8rO01");

var $fISuL = parcelRequire("fISuL");
const $fbd7abc477df0d0f$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $8rO01.growColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $8rO01.shrinkColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $fISuL.updateColgroup)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};

});

parcelRegister("9bHWx", function(module, exports) {

$parcel$export(module.exports, "getSelectedColumnIndexes", () => $f3680badf5bbd030$export$915a77877be361e9);
$parcel$export(module.exports, "getSelectedRowIndexes", () => $f3680badf5bbd030$export$d023456f91fdf995);
const $f3680badf5bbd030$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $f3680badf5bbd030$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};

});


parcelRegister("fU3Yc", function(module, exports) {

$parcel$export(module.exports, "deleteColumnsCommand", () => $39906618ce00b511$export$136e266e21963ad8);

var $VSDnB = parcelRequire("VSDnB");

var $cPPiz = parcelRequire("cPPiz");

var $fX6zg = parcelRequire("fX6zg");

var $5QPA6 = parcelRequire("5QPA6");
const $39906618ce00b511$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $fX6zg.deleteColumns)(rect, (0, $5QPA6.getAllowAddColumnCustomStep)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        // If we delete a column we should also clean up the hover selection
        if ((0, $VSDnB.fg)('platform_editor_remove_slow_table_transactions')) tr.setMeta((0, $cPPiz.pluginKey), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("fX6zg", function(module, exports) {

$parcel$export(module.exports, "deleteColumns", () => $bff0e38509ad858d$export$9dbd3595d5638a0b);

var $6Ad8w = parcelRequire("6Ad8w");

var $dEzej = parcelRequire("dEzej");

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $aajRL = parcelRequire("aajRL");

var $7DDbz = parcelRequire("7DDbz");

var $gyCDg = parcelRequire("gyCDg");
const $bff0e38509ad858d$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: ED-26961 - After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $gyCDg.splitCellsInColumns)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        const mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $6Ad8w.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $bff0e38509ad858d$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $bff0e38509ad858d$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $uOUlv.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $bff0e38509ad858d$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $bff0e38509ad858d$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $bff0e38509ad858d$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $uOUlv.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $bff0e38509ad858d$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $bff0e38509ad858d$var$fixRowSpans(table) {
    const map = (0, $uOUlv.TableMap).get(table);
    const minRowSpans = $bff0e38509ad858d$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $bff0e38509ad858d$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $bff0e38509ad858d$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $bff0e38509ad858d$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $28MvW.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $7DDbz.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };

});
parcelRegister("gyCDg", function(module, exports) {

$parcel$export(module.exports, "splitCellsInColumns", () => $429c9e6dd4c91fe6$export$e526e68a5eecfb66);

var $uOUlv = parcelRequire("uOUlv");
function $429c9e6dd4c91fe6$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    const mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $uOUlv.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                const mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}

});



parcelRegister("fxDYU", function(module, exports) {

$parcel$export(module.exports, "setTableDisplayMode", () => $5aedcaffbed81798$export$6ed6a850e47b73cc);

var $28MvW = parcelRequire("28MvW");
const $5aedcaffbed81798$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $28MvW.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};

});

parcelRegister("2TykN", function(module, exports) {

$parcel$export(module.exports, "sortByColumn", () => $5eb5fe9ead20154a$export$53e8d4c581cfe158);

var $7kHYO = parcelRequire("7kHYO");
var $5ZnzP = parcelRequire("5ZnzP");

var $5J0oM = parcelRequire("5J0oM");

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");

var $kNERd = parcelRequire("kNERd");
var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");

var $gseSq = parcelRequire("gseSq");
const $5eb5fe9ead20154a$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (data && (data.name || data.title)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $5eb5fe9ead20154a$export$53e8d4c581cfe158 = (columnIndex, order = (0, $7kHYO.SortOrder).DESC)=>(0, $gseSq.createCommand)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $28MvW.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $iGxzn.isSelectionType)(tr.selection, 'cell') ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $b1RTQ.getSelectionRect)(tr.selection) : (0, $28MvW.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $gseSq.getPluginState)(state);
        const tableArray = (0, $kNERd.convertTableNodeToArrayOfRows)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
            getInlineCardTextFromStore: $5eb5fe9ead20154a$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $kNERd.convertArrayOfRowsToTableNode)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $uOUlv.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $5ZnzP.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(table.start + pos)));
    });

});

parcelRegister("3BFNI", function(module, exports) {

$parcel$export(module.exports, "splitCell", () => $f5120580b7d269d8$export$74933b5979945879);

var $cQdoo = parcelRequire("cQdoo");

var $gseSq = parcelRequire("gseSq");
const $f5120580b7d269d8$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $gseSq.getPluginState)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $cQdoo.splitCellWithType)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};

});

parcelRegister("4nVrL", function(module, exports) {

$parcel$export(module.exports, "toggleHeaderRow", () => $7ef09efd9bb0eab9$export$2155c86bec6ad614);
$parcel$export(module.exports, "toggleHeaderColumn", () => $7ef09efd9bb0eab9$export$cb41f2462444ad87);
$parcel$export(module.exports, "toggleNumberColumn", () => $7ef09efd9bb0eab9$export$67d4f89bd3067fa2);
$parcel$export(module.exports, "toggleContextualMenu", () => $7ef09efd9bb0eab9$export$458dbe7d48b81d0a);
//#region Imports

var $dEzej = parcelRequire("dEzej");

var $28MvW = parcelRequire("28MvW");
var $eNHnZ = parcelRequire("eNHnZ");

var $gseSq = parcelRequire("gseSq");

var $aajRL = parcelRequire("aajRL");
const $7ef09efd9bb0eab9$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $7ef09efd9bb0eab9$export$2155c86bec6ad614 = (state, dispatch)=>(0, $eNHnZ.toggleHeader)('row')(state, (tr)=>(0, $gseSq.createCommand)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $7ef09efd9bb0eab9$export$cb41f2462444ad87 = (state, dispatch)=>(0, $eNHnZ.toggleHeader)('column')(state, (tr)=>(0, $gseSq.createCommand)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $7ef09efd9bb0eab9$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { node: node, pos: pos } = (0, $28MvW.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $7ef09efd9bb0eab9$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $28MvW.findTable)(state.selection);
    if (!table) return false;
    const layout = $7ef09efd9bb0eab9$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $gseSq.createCommand)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $7ef09efd9bb0eab9$export$458dbe7d48b81d0a = ()=>(0, $gseSq.createCommand)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion

});


parcelRegister("vVoyO", function(module, exports) {

$parcel$export(module.exports, "FloatingAlignmentButtons", () => $a4c35e0d0160b8cb$export$a6e8f537af71668f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ldJSL = parcelRequire("ldJSL");

var $e3WeH = parcelRequire("e3WeH");
var $2ENth = parcelRequire("2ENth");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $a4c35e0d0160b8cb$var$containerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
const $a4c35e0d0160b8cb$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $a4c35e0d0160b8cb$var$containerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2ENth.default), {
                    key: idx
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e3WeH.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    }
                });
        }
    })));
};

});
parcelRegister("e3WeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b970e46d885591$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $bvPiX = parcelRequire("bvPiX");

var $46YIs = parcelRequire("46YIs");

var $5Y3eC = parcelRequire("5Y3eC");
const $07b970e46d885591$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
var $07b970e46d885591$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, spotlightConfig: spotlightConfig })=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $5Y3eC.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    const ariaChecked = isRadioButton ? isButtonPressed : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    const [spotlightReferenceElement, setSpotlightReferenceElement] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSpotlightTargetClick = spotlightConfig?.isSpotlightOpen ? spotlightConfig?.onTargetClick : undefined;
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        // fire the spotlight onTargetClick callback if a spotlight is rendered and callback is provided
        onSpotlightTargetClick?.();
        onClick?.(event);
    }, [
        onClick,
        onSpotlightTargetClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                // Only fallback to title for tooltip if title is not shown
                content: tooltipContent || (iconOnly ? title : undefined),
                component: tooltipStyle,
                hideTooltipOnClick: hideTooltipOnClick,
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvPiX.Pulse), {
                        pulse: pulse || spotlightConfig?.pulse,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                            className: className,
                            ref: (buttonElement)=>setSpotlightReferenceElement(buttonElement),
                            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                            theme: (adgTheme, themeProps)=>{
                                const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                                return {
                                    buttonStyles: {
                                        ...buttonStyles,
                                        ...customSpacing,
                                        ...appearance === 'danger' && (0, $5Y3eC.getButtonStyles)({
                                            appearance: appearance,
                                            state: themeProps.state,
                                            mode: themeProps.mode
                                        }),
                                        ...(0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $07b970e46d885591$var$customSizeAndPadding : {}
                                    },
                                    ...rest
                                };
                            },
                            "aria-label": ariaLabel || title,
                            "aria-pressed": ariaPressed,
                            "aria-checked": ariaChecked,
                            role: isRadioButton ? 'radio' : undefined,
                            "aria-expanded": ariaHasPopup ? selected : undefined,
                            "aria-controls": ariaHasPopup ? areaControls : undefined,
                            spacing: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
                            href: href,
                            target: target,
                            appearance: appearance,
                            "aria-haspopup": ariaHasPopup,
                            iconBefore: icon || undefined,
                            iconAfter: iconAfter,
                            onClick: handleOnClick,
                            onKeyDown: onKeyDown,
                            isSelected: selected,
                            isDisabled: disabled,
                            testId: testId,
                            interactionName: interactionName,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            // @ts-ignore
                            // tabIndex set as 0 by default in the design system  ButtonBase component
                            // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                            // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                            tabIndex: tabIndex,
                            children: children
                        })
                    })
                })
            }),
            spotlightConfig?.isSpotlightOpen && spotlightReferenceElement && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $46YIs.ButtonSpotlightCard), {
                referenceElement: spotlightReferenceElement,
                ...spotlightConfig.spotlightCardOptions
            })
        ]
    });
};

});
parcelRegister("bvPiX", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $aec212985ae99997$export$927d63e2511364c0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
function $aec212985ae99997$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
    if (pulse) return(// SpotlightPulse shows pulse effect if `pulse` is `undefined`.
    // That's why we need to cast `pulse` to `false` if it's `undefined`.
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k6T4f.Pulse), {
        radius: radius,
        pulse: pulse ?? false,
        children: children
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});

parcelRegister("46YIs", function(module, exports) {

$parcel$export(module.exports, "ButtonSpotlightCard", () => $b3626800b48613e0$export$beb7ede7fcdf145c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5ujeO = parcelRequire("5ujeO");

var $4oNEb = parcelRequire("4oNEb");
const $b3626800b48613e0$export$beb7ede7fcdf145c = (props)=>{
    const { referenceElement: referenceElement, placement: placement = 'top-start', ...spotlightCardProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        referenceElement: referenceElement,
        placement: placement,
        strategy: "absolute",
        children: ({ ref: ref, style: style })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: ref,
                style: style,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ujeO.default), {
                    ...spotlightCardProps
                })
            })
    });
};

});

parcelRegister("5Y3eC", function(module, exports) {

$parcel$export(module.exports, "iconOnlySpacing", () => $44f0337781655622$export$7d8cec9727d4e603);
$parcel$export(module.exports, "getButtonStyles", () => $44f0337781655622$export$f98ea88a275be66c);

var $VSDnB = parcelRequire("VSDnB");
const $44f0337781655622$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};
const $44f0337781655622$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $44f0337781655622$var$background = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        active: {
            light: "var(--ds-background-neutral-pressed, #091E424F)",
            dark: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }
};
const $44f0337781655622$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FD9891)",
            dark: "var(--ds-background-danger-pressed, #FD9891)"
        }
    }
};
const $44f0337781655622$var$color = {
    danger: {
        default: {
            light: "var(--ds-icon, #44546F)",
            dark: "var(--ds-icon, #44546F)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $44f0337781655622$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #626F86)",
            dark: "var(--ds-icon-subtle, #626F86)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $44f0337781655622$export$f98ea88a275be66c = (props)=>({
        background: $44f0337781655622$var$getStyles(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $44f0337781655622$var$backgroundVisualRefresh : $44f0337781655622$var$background, props),
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        color: $44f0337781655622$var$getStyles((0, $VSDnB.fg)('platform-visual-refresh-icons') ? $44f0337781655622$var$colorVisualRefresh : $44f0337781655622$var$color, props)
    });

});


parcelRegister("2ENth", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6bb55008eb3feca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gmhCD = parcelRequire("gmhCD");
function $f6bb55008eb3feca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6bb55008eb3feca$var$separator = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $f6bb55008eb3feca$var$separatorNew = {
    name: "876g5t",
    styles: "background:var(--ds-border, #091E4224);width:1px;height:20px;align-self:center"
};
const $f6bb55008eb3feca$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $f6bb55008eb3feca$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? $f6bb55008eb3feca$var$separatorNew : $f6bb55008eb3feca$var$separator,
            fullHeight && $f6bb55008eb3feca$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});





parcelRegister("6vGNf", function(module, exports) {

$parcel$export(module.exports, "getDraggableDataFromEvent", () => $01da37bbcc672c9c$export$6d440138302b6316);

var $biEfA = parcelRequire("biEfA");

var $3hM1t = parcelRequire("3hM1t");
const $01da37bbcc672c9c$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $biEfA.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $3hM1t.getDragBehaviour)(location.current.input)
    };
};

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("3hM1t", function(module, exports) {

$parcel$export(module.exports, "getDragBehaviour", () => $fc78233002aaf5c9$export$b95259a1f587c41);

var $gE8f9 = parcelRequire("gE8f9");
const $fc78233002aaf5c9$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const isCloneModifierKeyPressed = (0, $gE8f9.browser).mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};

});



parcelRegister("dzNQ0", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $1ded6f75655b18cf$export$e832373cff8dec22);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $31nwk = parcelRequire("31nwk");

var $2RHbH = parcelRequire("2RHbH");

var $vWFRY = parcelRequire("vWFRY");

var $VSDnB = parcelRequire("VSDnB");

var $euUbE = parcelRequire("euUbE");

var $2MykN = parcelRequire("2MykN");
var $66MHx = parcelRequire("66MHx");

var $9iOcS = parcelRequire("9iOcS");

var $6lSoW = parcelRequire("6lSoW");

var $2MykN = parcelRequire("2MykN");

var $4aKeM = parcelRequire("4aKeM");
function $1ded6f75655b18cf$export$e832373cff8dec22(getEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.nextCell).common, (0, $2MykN.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.previousCell).common, (0, $2MykN.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleTable).common, (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes') ? (0, $31nwk.editorCommandToPMCommand)((0, $4aKeM.insertTableWithNestingSupport)({
        isTableScalingEnabled: isTableScalingEnabled,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: !!isFullWidthEnabled,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableResizingEnabled: isTableResizingEnabled
    }, api, {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).SHORTCUT
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    })) : (0, $4aKeM.createTable)(isTableScalingEnabled, isTableAlignmentEnabled, !!isFullWidthEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.backspace).common, (0, $2RHbH.chainCommands)((0, $6lSoW.deleteTableIfSelectedWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).KEYBOARD), (0, $6lSoW.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).KEYBOARD)), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.backspace).common, (0, $66MHx.moveCursorBackward), list);
    // Add row/column shortcuts
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addRowBefore).common, (0, $6lSoW.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addRowAfter).common, (0, $6lSoW.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addColumnBefore).common, (0, $4aKeM.addColumnBefore)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addColumnAfter).common, (0, $4aKeM.addColumnAfter)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addRowBeforeVO).common, (0, $6lSoW.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addRowAfterVO).common, (0, $6lSoW.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addColumnBeforeVO).common, (0, $4aKeM.addColumnBefore)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.addColumnAfterVO).common, (0, $4aKeM.addColumnAfter)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if (dragAndDropEnabled) {
        // Move row/column shortcuts
        /**
		 * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
		 * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
		 * to make sure the logic for holding the shortcut keys is valid
		 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
		 */ (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.moveRowDown).common, (0, $euUbE.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.moveRowUp).common, (0, $euUbE.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.moveColumnLeft).common, (0, $euUbE.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.moveColumnRight).common, (0, $euUbE.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.deleteColumn).common, (0, $6lSoW.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.deleteRow).common, (0, $6lSoW.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.startColumnResizing).common, (0, $9iOcS.initiateKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveRight).common, (0, $9iOcS.activateNextResizeArea)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveLeft).common, (0, $9iOcS.activateNextResizeArea)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveDown).common, (0, $2MykN.goToNextCellVertical)(1), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.moveUp).common, (0, $2MykN.goToNextCellVertical)(-1), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.decreaseMediaSize).common, (0, $6lSoW.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $gkwXh.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.increaseMediaSize).common, (0, $6lSoW.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $gkwXh.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.escape).common, (0, $9iOcS.stopKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.focusToContextMenuTrigger).common, (0, $66MHx.setFocusToCellMenu)(), list);
    return (0, $vWFRY.keymap)(list);
}
var $1ded6f75655b18cf$export$2e2bcd8739ae039 = $1ded6f75655b18cf$export$e832373cff8dec22;

});
parcelRegister("2MykN", function(module, exports) {

$parcel$export(module.exports, "goToNextCell", () => $3feee543a8db063b$export$78a7cb7971e0752d);
$parcel$export(module.exports, "goToNextCellVertical", () => $3feee543a8db063b$export$24bf4ae22c7b6454);

var $gkwXh = parcelRequire("gkwXh");

var $9O539 = parcelRequire("9O539");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $kr5gY = parcelRequire("kr5gY");
var $cK1Lv = parcelRequire("cK1Lv");

var $gseSq = parcelRequire("gseSq");

var $9iOcS = parcelRequire("9iOcS");

var $6lSoW = parcelRequire("6lSoW");
const $3feee543a8db063b$var$TAB_FORWARD_DIRECTION = 1;
const $3feee543a8db063b$var$TAB_BACKWARD_DIRECTION = -1;
const $3feee543a8db063b$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            const table = (0, $28MvW.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (0, $gseSq.getPluginState)(state)?.isKeyboardResize;
            if (isColumnResizing) {
                (0, $9iOcS.stopKeyboardColumnResizing)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $uOUlv.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $5r0mK.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // When tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $3feee543a8db063b$var$TAB_BACKWARD_DIRECTION) {
                (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // When tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $3feee543a8db063b$var$TAB_FORWARD_DIRECTION) {
                (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $kr5gY.goToNextCell)(direction)(state, dispatch);
            return true;
        };
const $3feee543a8db063b$export$24bf4ae22c7b6454 = (direction)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const nestedTableSelection = (0, $9O539.isSelectionTableNestedInTable)(state);
        if (!(selection instanceof (0, $gZGBX.NodeSelection)) && !nestedTableSelection) return false; // Let ProseMirror handle other selection types
        let table = (0, $28MvW.findTable)(selection);
        let cell = (0, $28MvW.findCellClosestToPos)(state.doc.resolve(selection.from));
        let selectionPos = selection.from;
        // Handle when we have nested table fully selected
        if (table && nestedTableSelection && (0, $cK1Lv.isTableSelected)(selection)) {
            const parentTablePos = table.pos;
            table = (0, $28MvW.findTableClosestToPos)(state.doc.resolve(parentTablePos));
            cell = (0, $28MvW.findCellClosestToPos)(state.doc.resolve(parentTablePos));
            selectionPos = parentTablePos;
        }
        if (!table || !cell || !cell.pos) return false;
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        // Let ProseMirror handle movement within the cell if content exists above/below
        if ($3feee543a8db063b$var$cellHasContentInDirection(cell.node, cell.pos, selectionPos, direction)) return false;
        // Move to the next cell vertically
        const map = (0, $uOUlv.TableMap).get(table.node);
        const nextCellPos = map.nextCell(cell.pos - table.start, 'vert', direction);
        if (dispatch && nextCellPos) {
            const nextCellStart = table.start + nextCellPos;
            const $nextCell = state.doc.resolve(nextCellStart);
            if ($nextCell.nodeAfter?.type && [
                tableCell,
                tableHeader
            ].includes($nextCell.nodeAfter?.type)) {
                const contentPos = $3feee543a8db063b$var$getTargetPositionInNextCell($nextCell.nodeAfter, nextCellStart, direction);
                dispatch(state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, contentPos)));
                return true;
            }
            return false;
        }
        return false; // No next cell found
    };
function $3feee543a8db063b$var$cellHasContentInDirection(cellNode, cellPos, selectionPos, direction) {
    let hasContent = false;
    cellNode.content.forEach((node, offset)=>{
        const nodeStart = cellPos + 1 + offset;
        const nodeEnd = nodeStart + node.nodeSize;
        if (direction === 1 && nodeStart > selectionPos && node.isBlock) hasContent = true; // Content below
        else if (direction === -1 && nodeEnd <= selectionPos && node.isBlock) hasContent = true; // Content above
    });
    return hasContent;
}
function $3feee543a8db063b$var$getTargetPositionInNextCell(cellNode, nextCellStart, direction) {
    let contentPos = nextCellStart + 1; // Default: just inside the cell
    if (cellNode.content.size > 0) {
        if (direction === 1) {
            const firstChild = cellNode.firstChild;
            if (firstChild && firstChild.isBlock) contentPos = nextCellStart + 1 + (firstChild.isLeaf ? 0 : 1); // Down: Start of first block
        } else if (direction === -1) {
            let lastBlock;
            let lastOffset = 0;
            cellNode.content.forEach((node, offset)=>{
                if (node.isBlock) {
                    lastBlock = node;
                    lastOffset = offset;
                }
            });
            if (lastBlock) contentPos = nextCellStart + 1 + lastOffset + (lastBlock.isLeaf ? 0 : lastBlock.nodeSize - 1);
        }
    }
    return contentPos;
}

});
parcelRegister("kr5gY", function(module, exports) {

$parcel$export(module.exports, "goToNextCell", () => $a3ba0b15b1b3e171$export$78a7cb7971e0752d);

var $gZGBX = parcelRequire("gZGBX");

var $22PoI = parcelRequire("22PoI");

var $bQFBc = parcelRequire("bQFBc");
function $a3ba0b15b1b3e171$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $a3ba0b15b1b3e171$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $bQFBc.isInTable)(state)) return false;
        const cellSelection = (0, $22PoI.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $a3ba0b15b1b3e171$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $gZGBX.TextSelection).between($cell, $a3ba0b15b1b3e171$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $a3ba0b15b1b3e171$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        let table = $cell.node(-1);
        // table is the parent table, not the nested table
        if ($cell.node(-4) && $cell.node(-4).type.name === 'table') table = $cell.node(-4);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}

});



parcelRegister("8JbS8", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $68b3ea5fbece65a3$export$ae829ec7b2625219);

var $gkwXh = parcelRequire("gkwXh");

var $kxM7f = parcelRequire("kxM7f");
var $1v3g5 = parcelRequire("1v3g5");

var $5KWxh = parcelRequire("5KWxh");

var $fH9ql = parcelRequire("fH9ql");
var $8Amfw = parcelRequire("8Amfw");
var $lKK04 = parcelRequire("lKK04");

var $gE8f9 = parcelRequire("gE8f9");
var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $7yskl = parcelRequire("7yskl");

var $5PQ8U = parcelRequire("5PQ8U");

var $jecUf = parcelRequire("jecUf");

var $gv1lY = parcelRequire("gv1lY");

var $66MHx = parcelRequire("66MHx");
var $9fJGy = parcelRequire("9fJGy");

var $9iOcS = parcelRequire("9iOcS");

var $66MHx = parcelRequire("66MHx");

var $eKJcE = parcelRequire("eKJcE");

var $gseSq = parcelRequire("gseSq");

var $cPPiz = parcelRequire("cPPiz");

var $i1dKX = parcelRequire("i1dKX");

var $kWnD2 = parcelRequire("kWnD2");

var $9kb0R = parcelRequire("9kb0R");

var $lN4uM = parcelRequire("lN4uM");
const $68b3ea5fbece65a3$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, fullWidthModeEnabled, previousFullWidthModeEnabled, dragAndDropEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor)=>{
    const state = (0, $gseSq.createPluginState)(dispatch, {
        pluginConfig: pluginConfig,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isDragAndDropEnabled: dragAndDropEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        ...(0, $eKJcE.defaultHoveredCell),
        ...(0, $eKJcE.defaultTableSelection),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    const nodeViews = (0, $1v3g5.isSSR)() && (0, $VSDnB.fg)('platform_editor_table_fallback_to_dom_on_ssr') ? undefined : {
        table: (0, $7yskl.lazyTableView)({
            portalProviderAPI: portalProviderAPI,
            eventDispatcher: eventDispatcher,
            getEditorContainerWidth: getEditorContainerWidth,
            getEditorFeatureFlags: getEditorFeatureFlags,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor
        }),
        tableRow: (0, $7yskl.lazyTableRowView)({
            eventDispatcher: eventDispatcher
        }),
        tableCell: (0, $7yskl.lazyTableCellView)({
            eventDispatcher: eventDispatcher,
            pluginInjectionApi: pluginInjectionApi
        }),
        tableHeader: (0, $7yskl.lazyTableHeaderView)({
            eventDispatcher: eventDispatcher,
            pluginInjectionApi: pluginInjectionApi
        })
    };
    return new (0, $5KWxh.SafePlugin)({
        state: state,
        key: (0, $cPPiz.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $gv1lY.handleCut)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $i1dKX.fixTables)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $i1dKX.fixTables)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            return {
                update: (view, prevState)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $gseSq.getPluginState)(state);
                    let tableRef;
                    if (pluginState.editorHasFocus) {
                        const parent = (0, $5r0mK.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                        if (parent) tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                        const tableNode = (0, $28MvW.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $gseSq.getPluginState)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = pluginPrevState?.tableNode !== tableNode?.node;
                            if (pluginPrevState?.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $uOUlv.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $uOUlv.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $9iOcS.stopKeyboardColumnResizing)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $9iOcS.stopKeyboardColumnResizing)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $66MHx.setTableRef)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $5r0mK.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $66MHx.addBoldInEmptyHeaderCells)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $66MHx.removeResizeHandleDecorations)()(state, dispatch);
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $kxM7f.insideTable)(editorState) && (0, $lN4uM.isHeaderRowRequired)(editorState)) slice = (0, $66MHx.transformSliceToAddTableHeaders)(slice, schema);
                // This fixes pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $kxM7f.insideTable)(editorState) && isCommentEditor && pluginConfig.allowTableAlignment && isTableScalingEnabled) slice = (0, $lN4uM.transformSliceTableLayoutDefaultToCenter)(slice, schema);
                slice = (0, $lN4uM.transformSliceToFixHardBreakProblemOnCopyFromCell)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $lKK04.transformSliceToRemoveOpenLayoutNodes)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $8Amfw.transformSliceToRemoveOpenExpand)(slice, schema);
                // transformSliceToRemoveOpenTable() transforms based on the depth of the root node, assuming that the tables will be at the root
                // Bodied extensions will contribute to the depth of the table selection so we need to remove them first
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $fH9ql.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $lN4uM.transformSliceToRemoveOpenTable)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $fH9ql.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $lN4uM.transformSliceToCorrectEmptyTableCells)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $66MHx.transformSliceToRemoveColumnsWidths)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $66MHx.transformSliceRemoveCellBackgroundColor)(slice, schema);
                slice = (0, $8Amfw.transformSliceToRemoveOpenNestedExpand)(slice, schema);
                if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) slice = (0, $lN4uM.transformSliceToRemoveNestedTables)(slice, schema, editorState.selection);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $5PQ8U.pluginKey).getState(state);
                if ((0, $9kb0R.findControlsHoverDecoration)(decorationSet).length) (0, $9fJGy.clearHoverSelection)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if ((0, $gE8f9.browser).chrome && event.target) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $jecUf.TableCssClassName).CONTROLS_BUTTON) || targetClassList.contains((0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE) || targetClassList.contains((0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER) && (0, $VSDnB.fg)('platform_editor_table_last_col_drag_handle_fix')) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $5r0mK.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $eQcNy.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $gseSq.getPluginState)(state);
                if (isKeyboardResize) {
                    (0, $9iOcS.stopKeyboardColumnResizing)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $kWnD2.replaceSelectedTable)(state, text, (0, $gkwXh.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: nodeViews,
            handleDOMEvents: {
                focus: (0, $gv1lY.handleFocus),
                blur: (0, $gv1lY.handleBlur),
                mousedown: (0, $gv1lY.withCellTracking)((0, $gv1lY.handleMouseDown)),
                mouseleave: (0, $gv1lY.handleMouseLeave),
                mousemove: (0, $gv1lY.whenTableInFocus)((0, $gv1lY.handleMouseMove)(nodeViewPortalProviderAPI), pluginInjectionApi),
                mouseenter: (0, $gv1lY.handleMouseEnter),
                mouseup: (0, $gv1lY.whenTableInFocus)((0, $gv1lY.handleMouseUp)),
                click: (0, $gv1lY.withCellTracking)((0, $gv1lY.whenTableInFocus)((0, $gv1lY.handleClick)))
            },
            handleTripleClick: $gv1lY.handleTripleClick
        }
    });
};

});
parcelRegister("7yskl", function(module, exports) {

$parcel$export(module.exports, "lazyTableView", () => $db5b01acd9b81024$export$6adeaf57e719865f);
$parcel$export(module.exports, "lazyTableCellView", () => $db5b01acd9b81024$export$707bb9908dc3f82e);
$parcel$export(module.exports, "lazyTableHeaderView", () => $db5b01acd9b81024$export$60095ee7fb81fb2d);
$parcel$export(module.exports, "lazyTableRowView", () => $db5b01acd9b81024$export$ec45d318e5ca055a);

var $3xRyR = parcelRequire("3xRyR");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $ipw1r = parcelRequire("ipw1r");

var $eAHBa = parcelRequire("eAHBa");

var $jgRSe = parcelRequire("jgRSe");

const $db5b01acd9b81024$export$6adeaf57e719865f = (options)=>{
    // LNV tables were broken in concurrent mode - they were temporarily disabled to unblock concurrent mode.
    // Enabling them again via the platform_editor_enable_table_lnv flag.
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $VSDnB.fg)('platform_editor_enable_table_lnv') && (0, $VSDnB.fg)('platform_editor_disable_table_lnv')) return (node, view, getPos)=>{
        return (0, $ipw1r.createTableView)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("ipw1r"))).then(({ createTableView: createTableView })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = getNodeViewOptions();
                return createTableView(node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor);
            };
        });
        return result;
    };
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'table',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $db5b01acd9b81024$export$707bb9908dc3f82e = (options)=>{
    // LNV tables were broken in concurrent mode - they were temporarily disabled to unblock concurrent mode.
    // Enabling them again via the platform_editor_enable_table_lnv flag.
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $VSDnB.fg)('platform_editor_enable_table_lnv') && (0, $VSDnB.fg)('platform_editor_disable_table_lnv')) return (node, view, getPos)=>{
        return new (0, $eAHBa.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("eAHBa"))).then(({ default: TableCell })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher, pluginInjectionApi: pluginInjectionApi } = getNodeViewOptions();
                return new TableCell(node, view, getPos, eventDispatcher, pluginInjectionApi?.analytics?.actions);
            };
        });
        return result;
    };
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'tableCell',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $db5b01acd9b81024$export$60095ee7fb81fb2d = (options)=>{
    // LNV tables were broken in concurrent mode - they were temporarily disabled to unblock concurrent mode.
    // Enabling them again via the platform_editor_enable_table_lnv flag.
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $VSDnB.fg)('platform_editor_enable_table_lnv') && (0, $VSDnB.fg)('platform_editor_disable_table_lnv')) return (node, view, getPos)=>{
        return new (0, $eAHBa.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("eAHBa"))).then(({ default: TableCell })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher, pluginInjectionApi: pluginInjectionApi } = getNodeViewOptions();
                return new TableCell(node, view, getPos, eventDispatcher, pluginInjectionApi?.analytics?.actions);
            };
        });
        return result;
    };
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'tableHeader',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

const $db5b01acd9b81024$export$ec45d318e5ca055a = (options)=>{
    // LNV tables were broken in concurrent mode - they were temporarily disabled to unblock concurrent mode.
    // Enabling them again via the platform_editor_enable_table_lnv flag.
    if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, $VSDnB.fg)('platform_editor_enable_table_lnv') && (0, $VSDnB.fg)('platform_editor_disable_table_lnv')) return (node, view, getPos)=>{
        return new (0, $jgRSe.default)(node, view, getPos, options.eventDispatcher);
    };
    const loader = ()=>{
        const result = Promise.resolve((parcelRequire("jgRSe"))).then(({ default: TableRow })=>{
            return (node, view, getPos, decorations, getNodeViewOptions)=>{
                const { eventDispatcher: eventDispatcher } = getNodeViewOptions();
                return new TableRow(node, view, getPos, eventDispatcher);
            };
        });
        return result;
    };
    return (0, $3xRyR.withLazyLoading)({
        nodeName: 'tableRow',
        getNodeViewOptions: ()=>options,
        loader: loader
    });
};

});
parcelRegister("ipw1r", function(module, exports) {

$parcel$export(module.exports, "createTableView", () => $919cb2bb4706c761$export$f0e1dd383a612bf9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fKLIs = parcelRequire("fKLIs");

var $j8AmE = parcelRequire("j8AmE");

var $j79rm = parcelRequire("j79rm");

var $kCV8T = parcelRequire("kCV8T");

var $iHYdz = parcelRequire("iHYdz");

var $uOUlv = parcelRequire("uOUlv");

var $VSDnB = parcelRequire("VSDnB");

var $3ojHW = parcelRequire("3ojHW");

var $84dDf = parcelRequire("84dDf");

var $gseSq = parcelRequire("gseSq");

var $cPPiz = parcelRequire("cPPiz");

var $k8KvZ = parcelRequire("k8KvZ");

var $iQMCj = parcelRequire("iQMCj");

var $7rFMc = parcelRequire("7rFMc");

var $evhdb = parcelRequire("evhdb");

var $4tUYJ = parcelRequire("4tUYJ");

var $2w6hs = parcelRequire("2w6hs");

var $gWWzt = parcelRequire("gWWzt");
const $919cb2bb4706c761$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $919cb2bb4706c761$var$getInlineWidth = (node, options, state, pos, allowTableResizing)=>{
    if (!node.attrs.width && options?.isCommentEditor && allowTableResizing) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = allowTableResizing && !(0, $evhdb.isTableNested)(state, pos);
    let widthValue = (0, $fKLIs.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $iHYdz.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $919cb2bb4706c761$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
// Remove after removing the platform_editor_table_initial_load_fix flag.
const $919cb2bb4706c761$var$toDOM = (node, props)=>{
    let colgroup = '';
    if (props.allowColumnResizing) colgroup = [
        'colgroup',
        {},
        ...(0, $iQMCj.generateColgroup)(node)
    ];
    return [
        'table',
        $919cb2bb4706c761$var$tableAttributes(node),
        colgroup,
        [
            'tbody',
            0
        ]
    ];
};
class $919cb2bb4706c761$export$2e2bcd8739ae039 extends (0, $j8AmE.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props), this.getNode = ()=>{
            return this.node;
        }, this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
        if ((0, $VSDnB.fg)('platform_editor_table_initial_load_fix')) this.handleRef = (node)=>this._handleTableRef(node);
    }
    getContentDOM() {
        let tableDOMStructure;
        if ((0, $VSDnB.fg)('platform_editor_table_initial_load_fix')) tableDOMStructure = (0, $gWWzt.tableNodeSpecWithFixedToDOM)({
            allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
            tableResizingEnabled: !!this.reactComponentProps.allowTableResizing,
            getEditorContainerWidth: this.reactComponentProps.getEditorContainerWidth
        }).toDOM(this.node);
        else tableDOMStructure = $919cb2bb4706c761$var$toDOM(this.node, this.reactComponentProps);
        const rendered = (0, $kCV8T.DOMSerializer).renderSpec(document, tableDOMStructure);
        if (rendered.dom) {
            if ((0, $VSDnB.fg)('platform_editor_table_initial_load_fix')) {
                const tableElement = rendered.dom.querySelector('table');
                this.table = tableElement ? tableElement : rendered.dom;
                this.renderedDOM = rendered.dom;
            } else this.table = rendered.dom;
            if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $919cb2bb4706c761$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos(), this.reactComponentProps.allowTableResizing);
                if (tableInlineWidth) $919cb2bb4706c761$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    /**
	 * Handles moving the table from ProseMirror's DOM structure into a React-rendered table node.
	 * Temporarily disables mutation observers (except for selection changes) during the move,
	 * preserves selection state, and restores it afterwards if mutations occurred and cursor
	 * wasn't at start of node. This prevents duplicate tables and maintains editor state during
	 * the DOM manipulation.
	 */ _handleTableRef(node) {
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // Only proceed if we have both a node and table, and the table isn't already inside the node
        if (node && this.table && !node.contains(this.table)) {
            // Store the current ignoreMutation handler so we can restore it later
            oldIgnoreMutation = this.ignoreMutation;
            // Set up a temporary mutation handler that:
            // - Ignores all DOM mutations except selection changes
            // - Tracks when mutations have been ignored via mutationsIgnored flag
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // Store the current selection state if there is a visible selection
            // This lets us restore it after DOM changes
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            // Remove the ProseMirror table DOM structure to avoid duplication, as it's replaced with the React table node.
            if (this.dom && this.renderedDOM) this.dom.removeChild(this.renderedDOM);
            // Move the table from the ProseMirror table structure into the React rendered table node.
            node.appendChild(this.table);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        if ((0, $VSDnB.fg)('platform_editor_r18_fix_selection_resync')) {
                            const tr = this.view.state.tr.setSelection(resolvedSelection);
                            tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                            this.view.dispatch(tr);
                        } else this.view.dispatch(this.view.state.tr.setSelection(resolvedSelection));
                    }
                }
            });
        }
    }
    setDomAttrs(node) {
        if (!this.table) return;
        const attrs = $919cb2bb4706c761$var$tableAttributes(node);
        Object.keys(attrs).forEach((attr)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.table.setAttribute(attr, attrs[attr]);
        });
        // Preserve Table Width cannot have inline width set on the table
        if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption && node.attrs.displayMode === 'fixed') {
            // handle inline style when table been resized
            const tableInlineWidth = $919cb2bb4706c761$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos(), this.reactComponentProps.allowTableResizing);
            const isTableResizing = (0, $7rFMc.pluginKey).getState(this.view.state)?.resizing;
            if (!isTableResizing && tableInlineWidth) $919cb2bb4706c761$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    render(props, forwardRef) {
        if ((0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w6hs.TableComponentWithSharedState), {
            forwardRef: forwardRef,
            getNode: this.getNode,
            view: props.view,
            options: props.options,
            eventDispatcher: props.eventDispatcher,
            api: props.pluginInjectionApi,
            allowColumnResizing: props.allowColumnResizing,
            allowTableAlignment: props.allowTableAlignment,
            allowTableResizing: props.allowTableResizing,
            allowControls: props.allowControls,
            getPos: props.getPos,
            getEditorFeatureFlags: props.getEditorFeatureFlags,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
        });
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakePluginKey = {
            key: 'widthPlugin$',
            getState: (state)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return state['widthPlugin$'];
            }
        };
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakeMediaPluginKey = {
            key: 'mediaPlugin$',
            getState: (state)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return state['mediaPlugin$'];
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j79rm.WithPluginState), {
            plugins: {
                pluginState: (0, $cPPiz.pluginKey),
                tableResizingPluginState: (0, $k8KvZ.pluginKey),
                tableWidthPluginState: (0, $7rFMc.pluginKey),
                widthPlugin: fakePluginKey,
                mediaState: fakeMediaPluginKey,
                tableDragAndDropState: (0, $84dDf.pluginKey)
            },
            editorView: props.view,
            render: (pluginStates)=>{
                const { tableResizingPluginState: tableResizingPluginState, tableWidthPluginState: tableWidthPluginState, pluginState: pluginState, mediaState: mediaState } = pluginStates;
                const containerWidth = props.getEditorContainerWidth();
                const isTableResizing = tableWidthPluginState?.resizing;
                const isResizing = Boolean(tableResizingPluginState?.dragging || isTableResizing);
                /**
					 *  ED-19810
					 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
					 *  directly to confluence since this bug is now in production.
					 */ let tablePos;
                try {
                    tablePos = props.getPos ? props.getPos() : undefined;
                } catch (e) {
                    tablePos = undefined;
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const tableActive = tablePos === pluginState.tablePos && !isTableResizing;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tUYJ.default), {
                    view: props.view,
                    allowColumnResizing: props.allowColumnResizing,
                    eventDispatcher: props.eventDispatcher,
                    getPos: props.getPos,
                    isMediaFullscreen: mediaState?.isFullscreen,
                    options: props.options,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    allowControls: pluginState.pluginConfig.allowControls,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    isHeaderRowEnabled: pluginState.isHeaderRowEnabled,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    isHeaderColumnEnabled: pluginState.isHeaderColumnEnabled,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    isDragAndDropEnabled: pluginState.isDragAndDropEnabled,
                    isTableScalingEnabled: props.options?.isTableScalingEnabled,
                    allowTableAlignment: props.allowTableAlignment,
                    allowTableResizing: props.allowTableResizing,
                    tableActive: tableActive,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    ordering: pluginState.ordering,
                    isResizing: isResizing,
                    getNode: this.getNode,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    containerWidth: containerWidth,
                    contentDOM: forwardRef,
                    getEditorFeatureFlags: props.getEditorFeatureFlags,
                    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                    pluginInjectionApi: props.pluginInjectionApi
                });
            }
        });
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $gseSq.getPluginState)(this.view.state);
        const hoveredRowsChanged = !!hoveredRows?.length !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!hoveredRows?.length;
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $uOUlv.TableMap).get(node);
        const nextTableMap = (0, $uOUlv.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && nodeName?.toUpperCase() === 'DIV' && firstChild?.nodeName.toUpperCase() === 'TABLE') return false;
        // ED-16668
        // Do not remove this fixes an issue with windows firefox that relates to
        // the addition of the shadow sentinels
        if (type === 'selection' && nodeName?.toUpperCase() === 'TABLE' && (firstChild?.nodeName.toUpperCase() === 'COLGROUP' || firstChild?.nodeName.toUpperCase() === 'SPAN')) return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher?.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
}
const $919cb2bb4706c761$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor)=>{
    const { pluginConfig: pluginConfig, isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled, isDragAndDropEnabled: isDragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $gseSq.getPluginState)(view.state);
    // Use shared state for isFullWidthModeEnabled and wasFullWidthModeEnabled for most up-to-date values
    const tableState = pluginInjectionApi?.table?.sharedState.currentState();
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls, allowTableResizing: allowTableResizing, allowTableAlignment: allowTableAlignment } = (0, $3ojHW.pluginConfig)(pluginConfig);
    return new $919cb2bb4706c761$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowTableResizing: allowTableResizing,
        allowTableAlignment: allowTableAlignment,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: (0, $VSDnB.fg)('platform_editor_table_overflow_in_full_width_fix') ? tableState?.isFullWidthModeEnabled : isFullWidthModeEnabled,
            wasFullWidthModeEnabled: (0, $VSDnB.fg)('platform_editor_table_overflow_in_full_width_fix') ? tableState?.wasFullWidthModeEnabled : wasFullWidthModeEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi
    }).init();
};

});
parcelRegister("j8AmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $180f7addf4ccc56b$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $lY6DM = parcelRequire("lY6DM");

var $9pOon = parcelRequire("9pOon");

var $WXnhI = parcelRequire("WXnhI");

var $4NUlu = parcelRequire("4NUlu");

var $4tEIi = parcelRequire("4tEIi");

var $5BVRS = parcelRequire("5BVRS");
class $180f7addf4ccc56b$export$2e2bcd8739ae039 {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate){
        this.decorations = [];
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $lY6DM.createDispatch)(this.eventDispatcher);
                dispatch((0, $4NUlu.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $4tEIi.generateUniqueNodeKey)();
    }
    /**
	 * This method exists to move initialization logic out of the constructor,
	 * so object can be initialized properly before calling render first time.
	 *
	 * Example:
	 * Instance properties get added to an object only after super call in
	 * constructor, which leads to some methods being undefined during the
	 * first render.
	 */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $WXnhI.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $WXnhI.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $WXnhI.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pOon.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $gkwXh.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: component()
            });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.portalProviderAPI.render(componentWithErrorBoundary, this.domRef, this.key);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let parentOffset = 0; // Remove with feature gate: platform_editor_r18_fix_selection_resync
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            // ... and capture parent offset before DOM change
            if (!(0, $VSDnB.fg)('platform_editor_r18_fix_selection_resync')) {
                if (this.view.state.selection?.ranges.length > 0) parentOffset = this.view.state.selection?.ranges[0].$from?.parentOffset ?? 0;
            }
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    if ((0, $VSDnB.fg)('platform_editor_r18_fix_selection_resync')) {
                        const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                        // Don't set the selection if it's the same as the current selection.
                        if (!resolvedSelection.eq(this.view.state.selection)) {
                            const tr = this.view.state.tr.setSelection(resolvedSelection);
                            tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                            this.view.dispatch(tr);
                        }
                    } else if (parentOffset > 0) // ... and dispatch expected selection state
                    this.view.dispatch(this.view.state.tr.setSelection(selectionBookmark.resolve(this.view.state.tr.doc)));
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
	 * Copies the attributes from a ProseMirror Node to a DOM node.
	 * @param node The Prosemirror Node from which to source the attributes
	 */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $180f7addf4ccc56b$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
}

});

parcelRegister("4tUYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e40e687ca2375f1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $3I3CN = parcelRequire("3I3CN");

var $9O539 = parcelRequire("9O539");

var $cK5m0 = parcelRequire("cK5m0");

var $fKLIs = parcelRequire("fKLIs");

var $6gEe5 = parcelRequire("6gEe5");

var $gE8f9 = parcelRequire("gE8f9");
var $594Yf = parcelRequire("594Yf");

var $iHYdz = parcelRequire("iHYdz");

var $28MvW = parcelRequire("28MvW");
var $cK1Lv = parcelRequire("cK1Lv");

var $VSDnB = parcelRequire("VSDnB");

var $4hDdm = parcelRequire("4hDdm");

var $gmhCD = parcelRequire("gmhCD");

var $66MHx = parcelRequire("66MHx");
var $9fJGy = parcelRequire("9fJGy");

var $jU0CZ = parcelRequire("jU0CZ");

var $gseSq = parcelRequire("gseSq");

var $fCcOI = parcelRequire("fCcOI");

var $eRc84 = parcelRequire("eRc84");

var $aajRL = parcelRequire("aajRL");

var $iQMCj = parcelRequire("iQMCj");

var $9QiRG = parcelRequire("9QiRG");

var $7mmRV = parcelRequire("7mmRV");

var $118VY = parcelRequire("118VY");

var $fISuL = parcelRequire("fISuL");

var $fFJjk = parcelRequire("fFJjk");

var $evhdb = parcelRequire("evhdb");

var $3PWLJ = parcelRequire("3PWLJ");

var $jecUf = parcelRequire("jecUf");

var $gv1lY = parcelRequire("gv1lY");

var $6bhrr = parcelRequire("6bhrr");

var $cEOF0 = parcelRequire("cEOF0");

var $u33of = parcelRequire("u33of");

var $8tMQh = parcelRequire("8tMQh");

var $gvxwa = parcelRequire("gvxwa");

var $zgDo7 = parcelRequire("zgDo7");
const $2e40e687ca2375f1$var$isIE11 = (0, $gE8f9.browser).ie_version === 11;
// When table is inserted via paste, keyboard shortcut or quickInsert,
// componentDidUpdate is called multiple times. The isOverflowing value is correct only on the last update.
// To make sure we capture the last update, we use setTimeout.
const $2e40e687ca2375f1$var$initialOverflowCaptureTimeroutDelay = 300;
// This is a hard switch for controlling whether the overflow analytics should be dispatched. There has been 6months of data
// already collected which we could use but have not. This has been disabled rather then removed entirely in the event that
// the current collected data becomes stale and we want to start collecting fresh data again in future.
// PLEASE NOTE: that the current way this alaytics has been configured WILL cause reflows to occur. This is why the has been disabled.
const $2e40e687ca2375f1$var$isOverflowAnalyticsEnabled = false;
// Prevent unnecessary parentWidth updates when table is nested inside of a node that is nested itself.
const $2e40e687ca2375f1$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD = 2;
const $2e40e687ca2375f1$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD = 20;
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2e40e687ca2375f1$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'TableComponent';
    }
    constructor(props){
        super(props), this.state = {
            scroll: 0,
            parentWidth: undefined,
            [(0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW]: false,
            [(0, $jecUf.ShadowEvent).SHOW_AFTER_SHADOW]: false,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined
        }, this.handleMouseOut = (event)=>{
            if (!(0, $gv1lY.isTableInFocus)(this.props.view)) return false;
            return (0, $gv1lY.handleMouseOut)(this.props.view, event);
        }, this.handleMouseOver = (event)=>{
            if (!(0, $gv1lY.isTableInFocus)(this.props.view)) return false;
            return (0, $gv1lY.withCellTracking)((0, $gv1lY.handleMouseOver))(this.props.view, event);
        }, this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        }, this.updateShadowState = (shadowKey, value)=>{
            if (this.state[shadowKey] === value) return;
            this.setState({
                [shadowKey]: value
            });
        }, this.createShadowSentinels = (table)=>{
            if (table) {
                const shadowSentinelLeft = document.createElement('span');
                shadowSentinelLeft.className = (0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT;
                const shadowSentinelRight = document.createElement('span');
                shadowSentinelRight.className = (0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT;
                table.prepend(shadowSentinelLeft);
                table.prepend(shadowSentinelRight);
            }
        }, this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $594Yf.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $eRc84.findStickyHeaderForTable)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) {
                this.setState({
                    stickyHeader: stickyHeader
                });
                if (this.overflowShadowsObserver) this.overflowShadowsObserver.updateStickyShadows();
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.prevTableState = null, this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
            }
            this.setState({
                [(0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW]: this.wrapper.scrollLeft !== 0
            });
        }, this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options, allowTableResizing: allowTableResizing } = this.props;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const isNested = (0, $evhdb.isTableNested)(this.props.view.state, this.props.getPos());
            let parentWidth = this.getParentNodeWidth();
            if (isNested && (0, $evhdb.isTableNestedInMoreThanOneNode)(this.props.view.state, this.props.getPos())) {
                const resizeObsWrapperWidth = this.wrapperWidth || 0;
                const wrapperWidthDiffBetweenRerenders = Math.abs(resizeObsWrapperWidth - (this.state.parentWidth || 0));
                const isOusideOfThreshold = wrapperWidthDiffBetweenRerenders <= $2e40e687ca2375f1$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD || wrapperWidthDiffBetweenRerenders > $2e40e687ca2375f1$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD;
                // 1. Check isOusideOfThreshold is added to prevent undersired state update.
                // When table is nested in the extenstion and the table column is being resized,
                // space available within extension can change and cause undesirable state update.
                // MIN_THRESNESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLDHOLD value is required
                // as the resizeObsWrapperWidth can differ between page reloads by 2px.
                // 2. Check resizeObsWrapperWidth > 1 is added to prevent parentWidth update when table unmounts.
                // When a is nested table in a nested expand and the expand collabses, the table unmounts and
                // resizeObsWrapperWidth becomes 1.
                parentWidth = isOusideOfThreshold && resizeObsWrapperWidth > 1 ? resizeObsWrapperWidth : this.state.parentWidth;
            }
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $evhdb.tablesHaveDifferentNoOfColumns)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!allowTableResizing || allowTableResizing && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (allowTableResizing && hasNumberedColumnChanged) {
                    if (!(0, $iQMCj.hasTableBeenResized)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        }, // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $594Yf.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $fFJjk.scaleTable)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) {
                (0, $3I3CN.tintDirtyTransaction)(tr);
                if ((0, $VSDnB.fg)('platform_editor_fix_table_resizing_undo')) // Avoid adding this transaction separately to the history as these are automatic updates
                // as a consequence of another action
                tr.setMeta('addToHistory', false);
            }
            dispatch(tr);
        }, this.setTimerToSendInitialOverflowCaptured = (isOverflowing)=>{
            const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerWidth: containerWidth, allowTableResizing: allowTableResizing } = this.props;
            const parentWidth = this.state?.parentWidth || 0;
            this.initialOverflowCaptureTimerId = setTimeout(()=>{
                dispatchAnalyticsEvent({
                    action: (0, $dEzej.TABLE_ACTION).INITIAL_OVERFLOW_CAPTURED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        editorWidth: containerWidth.width || 0,
                        isOverflowing: isOverflowing,
                        tableResizingEnabled: allowTableResizing || false,
                        width: this.node.attrs.width || 0,
                        parentWidth: parentWidth
                    }
                });
                this.isInitialOverflowSent = true;
            }, $2e40e687ca2375f1$var$initialOverflowCaptureTimeroutDelay);
        }, this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $594Yf.isValidPosition)(pos, view.state)) return;
                (0, $66MHx.autoSizeTable)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        }, this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        }, this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $594Yf.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $fKLIs.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        }, this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        }, this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $118VY.getLayoutSize)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {}), this.scaleTableDebounced = (0, $7nRxN.default)(this.scaleTable), this.handleTableResizingDebounced = (0, $7nRxN.default)(this.handleTableResizing), this.handleScrollDebounced = (0, $7nRxN.default)(this.handleScroll), this.handleAutoSizeDebounced = (0, $7nRxN.default)(this.handleAutoSize), this.handleWindowResizeDebounced = (0, $7nRxN.default)(this.handleWindowResize), this.updateShadowStateDebounced = (0, $7nRxN.default)(this.updateShadowState);
        const { options: options, containerWidth: containerWidth, getNode: getNode } = props;
        this.node = getNode();
        this.containerWidth = containerWidth;
        const tablePos = props.getPos();
        this.isNestedInTable = tablePos ? (0, $9O539.getParentOfTypeCount)(props.view.state.schema.nodes.table)(props.view.state.doc.resolve(tablePos)) > 0 : false;
        this.isInitialOverflowSent = false;
        if (!this.updateColGroupFromFullWidthChange) this.updateColGroupFromFullWidthChange = options?.isFullWidthModeEnabled && !options?.wasFullWidthModeEnabled;
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = options ? options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)this.setState((prev)=>{
                return prev?.tableWrapperWidth === entry.contentRect?.width && prev?.tableWrapperHeight === entry.contentRect?.height ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
        // Disable inline table editing and resizing controls in Firefox
        // https://github.com/ProseMirror/prosemirror/issues/432
        if ('execCommand' in document) [
            'enableObjectResizing',
            'enableInlineTableEditing'
        ].forEach((cmd)=>{
            if (document.queryCommandSupported(cmd)) document.execCommand(cmd, false, 'false');
        });
    }
    componentDidMount() {
        if ((0, $gmhCD.editorExperiment)('platform_editor_nodevisibility', false)) {
            this.initialiseEventListenersAfterMount();
            return;
        }
        const { observe: observe } = (0, $cK5m0.nodeVisibilityManager)(this.props.view.dom);
        if (this.table) this.nodeVisibilityObserverCleanupFn = observe({
            element: this.table,
            onFirstVisible: ()=>{
                this.initialiseEventListenersAfterMount();
            }
        });
    }
    initialiseEventListenersAfterMount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseover', this.handleMouseOver);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) this.handleColgroupUpdates(true);
        if (isTableScalingEnabled && tableWithFixedColumnWidthsOption && getNode().attrs.displayMode !== 'fixed') this.handleColgroupUpdates(true);
        if (this.wrapper) {
            this.wrapperReisizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries)this.wrapperWidth = entry.contentRect?.width;
            });
            this.wrapperReisizeObserver.observe(this.wrapper);
        }
        if (allowColumnResizing && this.wrapper && !$2e40e687ca2375f1$var$isIE11) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if ((0, $VSDnB.fg)('disable-sticky-scrollbar-for-nested-tables')) {
                if (this.table && !this.isNestedInTable) this.stickyScrollbar = new (0, $zgDo7.TableStickyScrollbar)(this.wrapper, this.props.view);
            } else if (this.table) this.stickyScrollbar = new (0, $zgDo7.TableStickyScrollbar)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $4hDdm.combine)(...(0, $jU0CZ.autoScrollerFactory)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $fCcOI.pluginKey).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.on((0, $fCcOI.pluginKey).key, this.onStickyState);
        if ($2e40e687ca2375f1$var$isOverflowAnalyticsEnabled) {
            const initialIsOveflowing = this.state[(0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW] || this.state[(0, $jecUf.ShadowEvent).SHOW_AFTER_SHADOW];
            this.setTimerToSendInitialOverflowCaptured(initialIsOveflowing);
        }
    }
    componentWillUnmount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled } = this.props;
        if (this.wrapper && !$2e40e687ca2375f1$var$isIE11) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        if (this.nodeVisibilityObserverCleanupFn) this.nodeVisibilityObserverCleanupFn();
        this.resizeObserver?.disconnect();
        this.wrapperReisizeObserver?.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!allowTableResizing) this.handleWindowResizeDebounced.cancel();
        if (!allowTableResizing && allowColumnResizing) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeDebounced);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseover', this.handleMouseOver);
        if (this.overflowShadowsObserver) this.overflowShadowsObserver.dispose();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.off((0, $fCcOI.pluginKey).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, getEditorFeatureFlags: getEditorFeatureFlags, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options?.isCommentEditor ? containerWidth.width - ((0, $9QiRG.TABLE_OFFSET_IN_COMMENT_EDITOR) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $9QiRG.TABLE_EDITOR_MARGIN);
        tableNodeWidth = options?.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $evhdb.tablesHaveDifferentNoOfColumns)(tableNode, this.node);
        const { width: containerWidthValue, lineLength: containerLineLength } = containerWidth;
        const isLineLengthChanged = this.containerWidth?.lineLength !== containerLineLength;
        const isFullWidthModeAndLineLengthChanged = this.updateColGroupFromFullWidthChange && isLineLengthChanged && (0, $VSDnB.fg)('platform_editor_table_overflow_in_full_width_fix');
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !options?.isCommentEditor || isNumberColumnChanged || isNumberOfColumnsChanged;
        if (force || maybeScale || isFullWidthModeAndLineLengthChanged) {
            const isWidthChanged = this.containerWidth?.width !== containerWidthValue;
            const wasTableResized = (0, $iQMCj.hasTableBeenResized)(this.node);
            const isTableResized = (0, $iQMCj.hasTableBeenResized)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = isWidthChanged || isColumnsDistributed || isTableResizedFullWidth || isTableWidthChanged || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || isFullWidthModeAndLineLengthChanged;
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!this.props.options?.isTableScalingEnabled && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!this.props.options?.isTableScalingEnabled && !!this.props.options?.isCommentEditor;
            if (force || !isResizing && shouldUpdateColgroup) {
                const resizeState = (0, $fISuL.getResizeState)({
                    minWidth: (0, $9QiRG.COLUMN_MIN_WIDTH),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!this.props.options?.isCommentEditor
                });
                let shouldScaleOnColgroupUpdate = false;
                if (this.props.options?.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if (this.props.options?.isTableScalingEnabled && this.props.options?.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!this.props.options?.isCommentEditor || this.props.options?.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $118VY.getTableScalingPercent)(tableNode, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, shouldUseIncreasedScalingPercent);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    scalePercent = (0, $118VY.getScalingPercentForTableWithoutWidth)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $fISuL.updateColgroup)(resizeState, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        if (isFullWidthModeAndLineLengthChanged) this.updateColGroupFromFullWidthChange = false;
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentDidUpdate(_, prevState) {
        const { view: view, getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, getEditorFeatureFlags: getEditorFeatureFlags } = this.props;
        let { isInDanger: isInDanger } = this.props;
        const table = (0, $28MvW.findTable)(view.state.selection);
        if (!(0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg')) {
            const pluginState = (0, $gseSq.getPluginState)(view.state);
            isInDanger = pluginState.isInDanger;
        }
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!this.props.options?.isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if (isInDanger && !table) (0, $9fJGy.clearHoverSelection)()(view.state, view.dispatch);
        if (this.props.options?.isCommentEditor && allowTableResizing && !options?.isTableScalingEnabled) this.removeInlineTableWidth();
        if (this.wrapper?.parentElement && this.table && !this.overflowShadowsObserver) {
            if (this.props.isDragAndDropEnabled) // requestAnimationFrame is used here to fix a race condition issue
            // that happens when a table is nested in expand and expand's width is
            // changed via breakout button
            window.requestAnimationFrame(()=>{
                this.overflowShadowsObserver = new (0, $8tMQh.OverflowShadowsObserver)((0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? this.updateShadowStateDebounced : this.updateShadowState, // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.table, this.wrapper);
            });
            else this.overflowShadowsObserver = new (0, $8tMQh.OverflowShadowsObserver)(this.updateShadowState, this.table, this.wrapper);
        }
        if (this.overflowShadowsObserver) this.overflowShadowsObserver.observeShadowSentinels(this.state.stickyHeader?.sticky);
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $evhdb.tablesHaveDifferentNoOfColumns)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $evhdb.tablesHaveDifferentNoOfRows)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) this.props.pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify((0, $3PWLJ.getAssistiveMessage)(previousTable, currentTable, this.props.intl), {
            priority: 'important'
        });
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $evhdb.tablesHaveDifferentColumnWidths)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !allowTableResizing || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $iQMCj.insertColgroupFromNode)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                }
                (0, $7mmRV.updateControls)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
        if ($2e40e687ca2375f1$var$isOverflowAnalyticsEnabled) {
            const newIsOverflowing = this.state[(0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW] || this.state[(0, $jecUf.ShadowEvent).SHOW_AFTER_SHADOW];
            const prevIsOverflowing = prevState[(0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW] || prevState[(0, $jecUf.ShadowEvent).SHOW_AFTER_SHADOW];
            if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
            if (!this.isInitialOverflowSent) this.setTimerToSendInitialOverflowCaptured(newIsOverflowing);
            if (this.isInitialOverflowSent && prevIsOverflowing !== newIsOverflowing) {
                const { dispatch: dispatch, state: { tr: tr } } = this.props.view;
                dispatch(tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_STATE_CHANGED, {
                    isOverflowing: newIsOverflowing,
                    wasOverflowing: prevIsOverflowing,
                    editorWidth: this.props.containerWidth.width || 0,
                    width: this.node.attrs.width || 0,
                    parentWidth: this.state?.parentWidth || 0
                }));
            }
        }
    }
    observeTable(table) {
        if (table) this.resizeObserver?.observe(table);
    }
    render() {
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, allowTableResizing: // here we can use options.isTableScalingEnabled
        allowTableResizing, allowTableAlignment: allowTableAlignment, selection: selection } = this.props;
        let { isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const { showBeforeShadow: showBeforeShadow, showAfterShadow: showAfterShadow } = this.state;
        const node = getNode();
        if (!(0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg')) {
            const pluginState = (0, $gseSq.getPluginState)(view.state);
            isInDanger = pluginState.isInDanger;
            hoveredRows = pluginState.hoveredRows;
            hoveredCell = pluginState.hoveredCell;
            isTableHovered = pluginState.isTableHovered;
            isWholeTableInDanger = pluginState.isWholeTableInDanger;
        }
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $evhdb.containsHeaderRow)(node);
        const rowControls = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEOF0.default), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: this.state.stickyHeader,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        });
        const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6bhrr.default), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: this.state.stickyHeader,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            getScrollOffset: ()=>this.wrapper?.scrollLeft || 0,
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        }) : null;
        const shadowPadding = allowControls && tableActive ? -(0, $iHYdz.akEditorTableToolbarSize) : (0, $6gEe5.tableMarginSides);
        const shadowStyle = (0, $8QpSo.default)((visible)=>({
                visibility: visible ? 'visible' : 'hidden'
            }));
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $evhdb.isTableNested)(view.state, tablePos);
        const topShadowPadding = isDragAndDropEnabled ? 0 : shadowPadding;
        const topOffset = 0;
        const topStickyShadowPosition = this.state.stickyHeader && topOffset + this.state.stickyHeader.padding + topShadowPadding + 2;
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!this.props.options?.isCommentEditor);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gvxwa.TableContainer), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).TABLE_CONTAINER, {
                [(0, $jecUf.TableCssClassName).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $jecUf.TableCssClassName).TABLE_STICKY]: this.state.stickyHeader && hasHeaderRow,
                [(0, $jecUf.TableCssClassName).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $jecUf.TableCssClassName).TABLE_SELECTED]: (0, $cK1Lv.isTableSelected)(selection ?? view.state.selection),
                [(0, $jecUf.TableCssClassName).NESTED_TABLE_WITH_CONTROLS]: tableActive && allowControls && this.isNestedInTable
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: allowTableResizing,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableWithFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: allowTableAlignment,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options?.isCommentEditor,
            isChromelessEditor: options?.isChromelessEditor,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP,
                    "data-testid": "sticky-sentinel-top"
                }),
                (0, $VSDnB.fg)('disable-sticky-scrollbar-for-nested-tables') ? !this.isNestedInTable && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }),
                allowControls && rowControls,
                isDragAndDropEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $u33of.ExternalDropTargets), {
                    editorView: view,
                    node: node,
                    getScrollOffset: ()=>{
                        return this.wrapper?.scrollLeft || 0;
                    },
                    getTableWrapperWidth: ()=>{
                        return this.wrapper?.clientWidth || 760;
                    }
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: shadowStyle(showBeforeShadow),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: options?.isChromelessEditor && !isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW + ' ' + (0, $jecUf.TableCssClassName).TABLE_CHROMELESS : (0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW
                }),
                this.state.stickyHeader && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${(0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW} ${(0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW}`,
                    style: {
                        visibility: showBeforeShadow && hasHeaderRow ? 'visible' : 'hidden',
                        top: `${topStickyShadowPosition}px`,
                        paddingBottom: `${isDragAndDropEnabled && "var(--ds-space-025, 2px)"}`
                    }
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER),
                    ref: (elem)=>{
                        this.wrapper = elem;
                        if (elem) {
                            this.props.contentDOM(elem);
                            const tableElement = elem.querySelector('table');
                            if (tableElement !== this.table) {
                                this.table = tableElement;
                                this.createShadowSentinels(this.table);
                                this.observeTable(this.table);
                            }
                        }
                    },
                    children: allowControls && colControls
                }),
                (0, $VSDnB.fg)('disable-sticky-scrollbar-for-nested-tables') ? !this.isNestedInTable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: 'none',
                        // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                        width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            width: tableRef?.clientWidth,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: '100%'
                        }
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        width: tableRef?.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    }
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: 'none',
                        // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                        width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            width: tableRef?.clientWidth,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: '100%'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: shadowStyle(showAfterShadow),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: options?.isChromelessEditor && !isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW + ' ' + (0, $jecUf.TableCssClassName).TABLE_CHROMELESS : (0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW
                }),
                this.state.stickyHeader && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        right: "var(--ds-space-400, 32px)" // tableOverflowShadowWidthWide
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW} ${(0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW}`,
                        style: {
                            visibility: showAfterShadow && hasHeaderRow ? 'visible' : 'hidden',
                            top: `${topStickyShadowPosition}px`,
                            paddingBottom: `${isDragAndDropEnabled && "var(--ds-space-025, 2px)"}`
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM,
                    "data-testid": "sticky-sentinel-bottom"
                }),
                (0, $VSDnB.fg)('disable-sticky-scrollbar-for-nested-tables') ? !this.isNestedInTable && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                })
            ]
        });
    }
}
var $2e40e687ca2375f1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($2e40e687ca2375f1$var$TableComponent);

});
parcelRegister("jU0CZ", function(module, exports) {

$parcel$export(module.exports, "autoScrollerFactory", () => $377bc54489ad9a59$export$aed4bc7b473fc217);

var $3KYe6 = parcelRequire("3KYe6");

var $hHbF1 = parcelRequire("hHbF1");

var $1v4Xe = parcelRequire("1v4Xe");
const $377bc54489ad9a59$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $3KYe6.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            }
        }),
        (0, $hHbF1.unsafeOverflowAutoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            },
            getOverflow: ()=>({
                    forTopEdge: {
                        top: (0, $1v4Xe.dropTargetExtendedWidth),
                        right: (0, $1v4Xe.dropTargetExtendedWidth),
                        left: (0, $1v4Xe.dropTargetExtendedWidth)
                    },
                    forRightEdge: {
                        right: (0, $1v4Xe.dropTargetExtendedWidth),
                        top: (0, $1v4Xe.dropTargetExtendedWidth),
                        bottom: (0, $1v4Xe.dropTargetExtendedWidth)
                    },
                    forLeftEdge: {
                        top: (0, $1v4Xe.dropTargetExtendedWidth),
                        left: (0, $1v4Xe.dropTargetExtendedWidth),
                        bottom: (0, $1v4Xe.dropTargetExtendedWidth)
                    }
                })
        })
    ];
};

});
parcelRegister("hHbF1", function(module, exports) {

$parcel$export(module.exports, "unsafeOverflowAutoScrollForElements", () => $376815ba2a294cc1$export$b6fc2123c6c7faac);

var $7gWdR = parcelRequire("7gWdR");

var $7AHkB = parcelRequire("7AHkB");
const $376815ba2a294cc1$var$api = (0, $7AHkB.makeApi)({
    monitor: (0, $7gWdR.monitorForElements)
});
const $376815ba2a294cc1$export$b6fc2123c6c7faac = $376815ba2a294cc1$var$api.unsafeOverflowAutoScroll;

});
parcelRegister("7AHkB", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $cbdf565a21734796$export$b8fa21320a811083);

var $4HETl = parcelRequire("4HETl");

var $8Y8AZ = parcelRequire("8Y8AZ");
function $cbdf565a21734796$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $8Y8AZ.tryOverflowScrollElements)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $4HETl.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}

});
parcelRegister("8Y8AZ", function(module, exports) {

$parcel$export(module.exports, "tryOverflowScrollElements", () => $974f735cf8e89e8e$export$10dd8807a40dbd8b);

var $kjAuM = parcelRequire("kjAuM");

var $cWWAu = parcelRequire("cWWAu");
function $974f735cf8e89e8e$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $kjAuM.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $cWWAu.getScrollBy)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}

});
parcelRegister("cWWAu", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $a11f043761a50b51$export$6cfa6dfe6898b98f);

var $iduok = parcelRequire("iduok");

var $ffSUw = parcelRequire("ffSUw");

var $3d4ga = parcelRequire("3d4ga");

var $gfxd2 = parcelRequire("gfxd2");

var $hTDOm = parcelRequire("hTDOm");

var $2dwAb = parcelRequire("2dwAb");

var $SKPtr = parcelRequire("SKPtr");
// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $a11f043761a50b51$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $a11f043761a50b51$var$getSpacingFromProvided(value) {
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
function $a11f043761a50b51$var$getHitboxSpacing(provided) {
    return {
        top: $a11f043761a50b51$var$getSpacingFromProvided(provided.forTopEdge),
        right: $a11f043761a50b51$var$getSpacingFromProvided(provided.forRightEdge),
        bottom: $a11f043761a50b51$var$getSpacingFromProvided(provided.forBottomEdge),
        left: $a11f043761a50b51$var$getSpacingFromProvided(provided.forLeftEdge)
    };
}
function $a11f043761a50b51$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $a11f043761a50b51$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $ffSUw.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $SKPtr.getHitbox)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
			 * Intentionally _not_ doing an explicit check to
			 * see if `client` is with within the `overElementHitbox`.
			 *
			 * **Why?**
			 *
			 * 1. 🥱 Redundant
			 * This check is already achieved by `element.contains(underUsersPointer)`
			 *
			 * 2. 📐 Overlap on boundaries
			 * Two elements can share the same `{x,y}` points on shared edges.
			 * It's not clear which of the two will be picked by
			 * `const underUsersPointer = document.elementFromPoint(x,y)`
			 * The edge of an "outside" element, can have shared `{x,y}`
			 * values along the edge of an "inside element".
			 * So when `underUsersPointer` is the "outer" element, the `client`
			 * point might actually be also within the "inner" element.
			 * We are exclusively relying on `underUsersPointer` make the decision
			 * on what we are "over" so we should not be doing "over element" hitbox
			 * testing here.
			 * https://twitter.com/alexandereardon/status/1721758766507638996
			 *
			 *
			 * 3. 🐞 Chrome bug
			 * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
			 * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
			 * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
			 */ if ((0, $2dwAb.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $2dwAb.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $3d4ga.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $hTDOm.isAxisAllowed)((0, $ffSUw.edgeAxisLookup)[value.edge], allowedAxis) && (0, $iduok.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $a11f043761a50b51$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $a11f043761a50b51$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $a11f043761a50b51$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $a11f043761a50b51$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("SKPtr", function(module, exports) {

$parcel$export(module.exports, "getHitbox", () => $aba85c91005230ec$export$b220adcde0a1c5fd);

var $9w8nT = parcelRequire("9w8nT");

var $c3M8M = parcelRequire("c3M8M");
function $aba85c91005230ec$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9w8nT.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $c3M8M.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $aba85c91005230ec$export$b220adcde0a1c5fd = {
    top: $aba85c91005230ec$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $aba85c91005230ec$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $aba85c91005230ec$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $aba85c91005230ec$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};

});






parcelRegister("fCcOI", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $603a2a0b5143c0c6$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $603a2a0b5143c0c6$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('stickyHeadersPlugin');

});

parcelRegister("eRc84", function(module, exports) {

$parcel$export(module.exports, "findStickyHeaderForTable", () => $1d006da39fff5272$export$91d61a242b14c7fb);
const $1d006da39fff5272$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};

});

parcelRegister("gv1lY", function(module, exports) {

$parcel$export(module.exports, "handleBlur", () => $66ce2faf4cebfacb$export$27d5d91e7417534c);
$parcel$export(module.exports, "handleFocus", () => $66ce2faf4cebfacb$export$185584c64f36588);
$parcel$export(module.exports, "handleClick", () => $66ce2faf4cebfacb$export$b981489921ee18cd);
$parcel$export(module.exports, "handleMouseOver", () => $66ce2faf4cebfacb$export$321c2da35903b013);
$parcel$export(module.exports, "handleMouseUp", () => $66ce2faf4cebfacb$export$88f4dbb0cd0ffc84);
$parcel$export(module.exports, "handleMouseDown", () => $66ce2faf4cebfacb$export$b4a93e0b711d8f7);
$parcel$export(module.exports, "handleMouseOut", () => $66ce2faf4cebfacb$export$72517da01e0ce829);
$parcel$export(module.exports, "handleMouseEnter", () => $66ce2faf4cebfacb$export$2560ef85393729a7);
$parcel$export(module.exports, "handleMouseLeave", () => $66ce2faf4cebfacb$export$fcff8e67f71577c3);
$parcel$export(module.exports, "isTableInFocus", () => $66ce2faf4cebfacb$export$42d5d9cc7457d81e);
$parcel$export(module.exports, "handleMouseMove", () => $66ce2faf4cebfacb$export$3248c033e90a4ba0);
$parcel$export(module.exports, "handleTripleClick", () => $66ce2faf4cebfacb$export$f17e34274dd6fcf5);
$parcel$export(module.exports, "handleCut", () => $66ce2faf4cebfacb$export$1c3f791fb2a5168);
$parcel$export(module.exports, "whenTableInFocus", () => $66ce2faf4cebfacb$export$82a75cb550f27e28);
$parcel$export(module.exports, "withCellTracking", () => $66ce2faf4cebfacb$export$87e6a6bf8341824f);

var $7nRxN = parcelRequire("7nRxN");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $9O539 = parcelRequire("9O539");

var $gE8f9 = parcelRequire("gE8f9");
var $eQcNy = parcelRequire("eQcNy");
var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");
var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $i3UPz = parcelRequire("i3UPz");

var $66MHx = parcelRequire("66MHx");
var $9fJGy = parcelRequire("9fJGy");

var $22Go6 = parcelRequire("22Go6");

var $gseSq = parcelRequire("gseSq");

var $gEcXI = parcelRequire("gEcXI");

var $fX6zg = parcelRequire("fX6zg");

var $cUQeV = parcelRequire("cUQeV");

var $hxf42 = parcelRequire("hxf42");

var $lOQGo = parcelRequire("lOQGo");

var $aj3mz = parcelRequire("aj3mz");

var $5QPA6 = parcelRequire("5QPA6");

var $jecUf = parcelRequire("jecUf");
const $66ce2faf4cebfacb$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $66ce2faf4cebfacb$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $66ce2faf4cebfacb$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $66ce2faf4cebfacb$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $66ce2faf4cebfacb$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $66ce2faf4cebfacb$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $gE8f9.browser).ie_version !== 11 && !$66ce2faf4cebfacb$var$isFocusingCalendar(event) && !$66ce2faf4cebfacb$var$isFocusingModal(event) && !$66ce2faf4cebfacb$var$isFocusingFloatingToolbar(event) && !$66ce2faf4cebfacb$var$isFocusingDragHandles(event) && !$66ce2faf4cebfacb$var$isFocusingDragHandlesClickableZone(event)) (0, $66MHx.setEditorFocus)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $66ce2faf4cebfacb$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $66MHx.setEditorFocus)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $66ce2faf4cebfacb$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $28MvW.findTable)(view.state.selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    if (event instanceof MouseEvent && (0, $aj3mz.isColumnControlsDecorations)(element)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const [startIndex] = (0, $aj3mz.getColumnOrRowIndex)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $66MHx.selectColumn)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    !(0, $594Yf.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $uOUlv.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const colElement = (0, $eQcNy.closestElement)(element, 'td') || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $eQcNy.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $eQcNy.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $594Yf.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $594Yf.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $66ce2faf4cebfacb$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $gseSq.getPluginState)(state);
    if ((0, $aj3mz.isInsertRowButton)(target)) {
        const [startIndex, endIndex] = (0, $aj3mz.getColumnOrRowIndex)(target);
        const positionRow = (0, $aj3mz.getMousePositionVerticalRelativeByElement)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $66MHx.showInsertRowButton)(positionRow)(state, dispatch);
    }
    if ((0, $aj3mz.isColumnControlsDecorations)(target)) {
        const [startIndex] = (0, $aj3mz.getColumnOrRowIndex)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $9fJGy.hoverColumns)([
            startIndex
        ], false)(state, dispatch);
    }
    const isNestedTable = (0, $9O539.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1;
    if (isNestedTable) {
        // if the table is nested inside a table, we only call hideInsertColumnOrRowButton if the table nearest to the mouse target is NOT the parent table
        const nearestTable = (0, $eQcNy.closestElement)(target, 'table');
        const nestedTable = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(state.doc.resolve(state.selection.from), [
            state.schema.nodes.table
        ]);
        const parentTable = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(state.doc.resolve(nestedTable?.pos || 0), [
            state.schema.nodes.table
        ]);
        if (nearestTable?.dataset.tableLocalId !== parentTable?.node.attrs.localId && ((0, $aj3mz.isCell)(target) || (0, $aj3mz.isCornerButton)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $66MHx.hideInsertColumnOrRowButton)()(state, dispatch);
    } else if (((0, $aj3mz.isCell)(target) || (0, $aj3mz.isCornerButton)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $66MHx.hideInsertColumnOrRowButton)()(state, dispatch);
    if ((0, $aj3mz.isResizeHandleDecoration)(target)) {
        const [startIndex, endIndex] = (0, $aj3mz.getColumnOrRowIndex)(target);
        return (0, $9fJGy.showResizeHandleLine)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $9fJGy.setTableHovered)(true)(state, dispatch);
    return false;
};
const $66ce2faf4cebfacb$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $gseSq.getPluginState)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $uOUlv.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $66MHx.showInsertColumnButton)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $66ce2faf4cebfacb$export$b4a93e0b711d8f7 = (_, event)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $aj3mz.isTableContainerOrWrapper)(event.target) || (0, $aj3mz.isColumnControlsDecorations)(event.target) || (0, $aj3mz.isRowControlsButton)(event.target) || (0, $aj3mz.isDragCornerButton)(event.target)));
    if (isControl) event.preventDefault();
    return isControl;
};
const $66ce2faf4cebfacb$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $aj3mz.isColumnControlsDecorations)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $9fJGy.clearHoverSelection)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $aj3mz.isResizeHandleDecoration)(target) && !(0, $aj3mz.isResizeHandleDecoration)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $gseSq.getPluginState)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $9fJGy.hideResizeHandleLine)()(state, dispatch);
    }
    return false;
};
const $66ce2faf4cebfacb$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $gseSq.getPluginState)(state);
    if (!isTableHovered) return (0, $9fJGy.setTableHovered)(true)(state, dispatch);
    return false;
};
const $66ce2faf4cebfacb$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isDragAndDropEnabled: isDragAndDropEnabled, isTableHovered: isTableHovered } = (0, $gseSq.getPluginState)(state);
    if (isTableHovered) {
        if (isDragAndDropEnabled) {
            const { isDragMenuOpen: isDragMenuOpen = false } = (0, $22Go6.getPluginState)(state);
            !isDragMenuOpen && (0, $9fJGy.setTableHovered)(false)(state, dispatch);
        } else (0, $9fJGy.setTableHovered)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$66ce2faf4cebfacb$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $aj3mz.isTableControlsButton)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $66MHx.hideInsertColumnOrRowButton)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $66ce2faf4cebfacb$var$handleMouseMoveDebounce = (nodeViewPortalProviderAPI)=>(0, $7nRxN.default)((view, event, offsetX)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        const element = event.target;
        if ((0, $aj3mz.isColumnControlsDecorations)(element) || (0, $aj3mz.isDragColumnFloatingInsertDot)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $gseSq.getPluginState)(state);
            const [startIndex, endIndex] = (0, $aj3mz.getColumnOrRowIndex)(element);
            const positionColumn = (0, $aj3mz.getMousePositionHorizontalRelativeByElement)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
            if (positionColumn !== insertColumnButtonIndex) return (0, $66MHx.showInsertColumnButton)(positionColumn)(state, dispatch);
        }
        if ((0, $aj3mz.isRowControlsButton)(element) || (0, $aj3mz.isDragRowFloatingInsertDot)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertRowButtonIndex: insertRowButtonIndex } = (0, $gseSq.getPluginState)(state);
            const [startIndex, endIndex] = (0, $aj3mz.getColumnOrRowIndex)(element);
            const positionRow = (0, $aj3mz.getMousePositionVerticalRelativeByElement)(event) === 'bottom' ? endIndex : startIndex;
            if (positionRow !== insertRowButtonIndex) return (0, $66MHx.showInsertRowButton)(positionRow)(state, dispatch);
        }
        if (!(0, $aj3mz.isResizeHandleDecoration)(element) && (0, $aj3mz.isCell)(element)) {
            const positionColumn = (0, $aj3mz.getMousePositionHorizontalRelativeByElement)(event, offsetX, (0, $jecUf.RESIZE_HANDLE_AREA_DECORATION_GAP));
            if (positionColumn !== null) {
                const { state: state, dispatch: dispatch } = view;
                const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $gseSq.getPluginState)(state);
                const isKeyboardResize = (0, $gseSq.getPluginState)(state).isKeyboardResize;
                const tableCell = (0, $eQcNy.closestElement)(element, 'td, th');
                const cellStartPosition = view.posAtDOM(tableCell, 0);
                const rect = (0, $28MvW.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
                if (rect) {
                    const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                    const rowIndexTarget = rect.top;
                    if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $aj3mz.hasResizeHandler)({
                        target: element,
                        columnEndIndexTarget: columnEndIndexTarget
                    })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                    ) return (0, $66MHx.addResizeHandleDecorations)(rowIndexTarget, columnEndIndexTarget, true, nodeViewPortalProviderAPI)(state, dispatch);
                }
            }
        }
        return false;
    });
const $66ce2faf4cebfacb$export$3248c033e90a4ba0 = (nodeViewPortalProviderAPI)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
        // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
        // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
        // in the deferred callback handler.
        // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
        $66ce2faf4cebfacb$var$handleMouseMoveDebounce(nodeViewPortalProviderAPI)(view, event, (0, $gE8f9.browser).gecko ? event.offsetX : NaN);
        return false;
    };
function $66ce2faf4cebfacb$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $6hQQ3.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $gZGBX.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $gZGBX.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $gZGBX.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $66ce2faf4cebfacb$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $hFEwm.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $hFEwm.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $hFEwm.CellSelection)) {
            const rect = (0, $b1RTQ.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedCellInfo)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $dEzej.TABLE_ACTION).CUT,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $hFEwm.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $i3UPz.removeTable)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $gseSq.getPluginState)(newState);
                        tr = (0, $cUQeV.deleteRows)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $fX6zg.deleteColumns)(rect, (0, $5QPA6.getAllowAddColumnCustomStep)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $66ce2faf4cebfacb$export$42d5d9cc7457d81e = (view)=>{
    return !!(0, $gseSq.getPluginState)(view.state)?.tableNode && !(0, $gEcXI.getPluginState)(view.state)?.dragging;
};
const $66ce2faf4cebfacb$export$82a75cb550f27e28 = (eventHandler, pluginInjectionApi)=>(view, mouseEvent)=>{
        if (!$66ce2faf4cebfacb$export$42d5d9cc7457d81e(view)) return false;
        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        /**
		 * Table cannot be in focus if we are in view mode.
		 * This will prevent an infinite flow of adding and removing
		 * resize handle decorations in view mode that causes unpredictable
		 * selections.
		 */ if (isViewMode) return false;
        return eventHandler(view, mouseEvent);
    };
const $66ce2faf4cebfacb$var$trackCellLocation = (view, mouseEvent)=>{
    const target = mouseEvent.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const maybeTableCell = (0, $594Yf.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $gseSq.getPluginState)(view.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const tableElement = (0, $eQcNy.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement?.dataset?.tableLocalId && tableElement.dataset.tableLocalId !== tableNode?.attrs.localId) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $eQcNy.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const tableMap = tableNode && (0, $uOUlv.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $lOQGo.convertHTMLCellIndexToColumnIndex)(htmlColIndex, htmlRowIndex, tableMap);
        colIndex = (0, $lOQGo.getColumnIndexMappedToColumnIndexInFirstRow)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $9fJGy.hoverCell)(htmlRowIndex, colIndex)(view.state, view.dispatch);
};
const $66ce2faf4cebfacb$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $gseSq.getPluginState)(view.state).isDragAndDropEnabled && (0, $22Go6.getPluginState)(view.state) && !(0, $22Go6.getPluginState)(view.state).isDragging) $66ce2faf4cebfacb$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };

});

parcelRegister("6bhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeff38f39c44947$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $lOQGo = parcelRequire("lOQGo");

var $evhdb = parcelRequire("evhdb");

var $g4A0f = parcelRequire("g4A0f");

var $jecUf = parcelRequire("jecUf");

var $cK7P1 = parcelRequire("cK7P1");

var $9ZHsX = parcelRequire("9ZHsX");
const $ddeff38f39c44947$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor })=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node?.attrs.localId;
    const hasHeaderColumn = (0, $evhdb.containsHeaderColumn)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $5uXOq.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $g4A0f.getRowHeights)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $lOQGo.getColumnsWidths)(editorView);
    if (stickyTop) {
        const columnControlTopOffsetFromParent = '-12px';
        containerRef?.current?.style.setProperty('top', columnControlTopOffsetFromParent);
    } else containerRef?.current?.style.removeProperty('top');
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $jecUf.TableCssClassName).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cK7P1.ColumnControls), {
                editorView: editorView,
                hoveredCell: hoveredCell,
                tableRef: tableRef,
                tableActive: tableActive,
                isTableHovered: isTableHovered,
                stickyTop: tableActive ? stickyTop : undefined,
                localId: currentNodeLocalId,
                isInDanger: isInDanger,
                rowHeights: rowHeights,
                colWidths: colWidths,
                hasHeaderColumn: hasHeaderColumn,
                tableContainerWidth: tableContainerWidth,
                isNumberColumnEnabled: isNumberColumnEnabled,
                isDragging: isDragging,
                getScrollOffset: getScrollOffset,
                api: (0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg') ? api : undefined
            }),
            isDragging && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ZHsX.ColumnDropTargets), {
                tableRef: tableRef,
                isHeaderSticky: stickyHeader?.sticky && hasHeaderRow,
                tableHeight: tableWrapperHeight,
                localId: currentNodeLocalId,
                colWidths: colWidths,
                getScrollOffset: getScrollOffset
            })
        ]
    });
};
var $ddeff38f39c44947$export$2e2bcd8739ae039 = $ddeff38f39c44947$var$TableFloatingColumnControls;

});
parcelRegister("cK7P1", function(module, exports) {

$parcel$export(module.exports, "ColumnControls", () => $404606f781cda6c9$export$a71b12ee0b179860);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $6gEe5 = parcelRequire("6gEe5");

var $9LY0t = parcelRequire("9LY0t");

var $iHYdz = parcelRequire("iHYdz");

var $hFEwm = parcelRequire("hFEwm");

var $b1RTQ = parcelRequire("b1RTQ");

var $VSDnB = parcelRequire("VSDnB");

var $9fJGy = parcelRequire("9fJGy");
var $66MHx = parcelRequire("66MHx");

var $gF4dk = parcelRequire("gF4dk");

var $g4A0f = parcelRequire("g4A0f");

var $9bHWx = parcelRequire("9bHWx");

var $jecUf = parcelRequire("jecUf");

var $2fY9A = parcelRequire("2fY9A");
const $404606f781cda6c9$var$getSelectedColumns = (selection)=>{
    if (selection instanceof (0, $hFEwm.CellSelection) && selection.isColSelection()) {
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $9bHWx.getSelectedColumnIndexes)(rect);
    }
    return [];
};
const $404606f781cda6c9$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const selection = (0, $9LY0t.useSharedPluginStateSelector)(api, 'selection.selection');
    return {
        selection: selection
    };
}, (api)=>{
    const { selectionState: selectionState } = (0, $awTmI.useSharedPluginState)(api, [
        'selection'
    ]);
    return {
        selection: selectionState?.selection
    };
});
const $404606f781cda6c9$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $5uXOq.useRef)(null);
    const { selection: selection } = $404606f781cda6c9$var$useSharedState(api);
    const widths = colWidths?.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ') ?? '0px';
    // TODO: ED-26961 - reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $g4A0f.getRowsParams)(colWidths ?? []);
    const colIndex = hoveredCell?.colIndex;
    const selectedColIndexes = $404606f781cda6c9$var$getSelectedColumns(selection || editorView.state.selection);
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = 45;
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $66MHx.selectColumn)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $66MHx.selectColumns)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $9fJGy.hoverColumns)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $9fJGy.hoverCell)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $5uXOq.useCallback)((trigger, event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (event?.shiftKey) return;
        (0, $gF4dk.toggleDragMenu)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex
    ]);
    const colIndexes = (0, $5uXOq.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = getScrollOffset?.() ?? 0;
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = rowHeights?.reduce((sum, cur)=>sum + cur, 0) ?? 0;
        const previewWidth = colWidths?.reduce((sum, v, i)=>sum + (v ?? (0, $6gEe5.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0) ?? (0, $6gEe5.tableCellMinWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            contentEditable: false,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative'
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : selectedColIndexes[0]}-drag-handle`,
            children: (0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2fY9A.DragHandleWithSharedState), {
                isDragMenuTarget: !isHover,
                direction: "column",
                tableLocalId: localId || '',
                indexes: indexes,
                hoveredCell: hoveredCell,
                previewWidth: previewWidth,
                forceDefaultHandle: !isHover,
                previewHeight: previewHeight,
                appearance: appearance,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView,
                api: api
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2fY9A.DragHandle), {
                isDragMenuTarget: !isHover,
                direction: "column",
                tableLocalId: localId || '',
                indexes: indexes,
                hoveredCell: hoveredCell,
                previewWidth: previewWidth,
                forceDefaultHandle: !isHover,
                previewHeight: previewHeight,
                appearance: appearance,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = selectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > selectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedColIndexes[0] + 1} / span ${selectedColIndexes.length}`, selectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !selectedColIndexes.includes(colIndex)) handles.push(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: columnControlsRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridTemplateColumns: widths,
                marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginTop,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                width: stickyTop ? containerWidth : undefined,
                overflowX: stickyTop ? 'hidden' : 'visible',
                pointerEvents: isDragging ? 'none' : undefined
            },
            children: [
                columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            gridColumn: `${startIndex + 1} / span 1`
                        },
                        "data-start-index": startIndex,
                        "data-end-index": endIndex,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
                        contentEditable: false,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: columnParams.length - 1 === index ? {
                                right: '0'
                            } : {}
                        })
                    }, index)),
                columnHandles()
            ]
        })
    }));
};

});
parcelRegister("2fY9A", function(module, exports) {

$parcel$export(module.exports, "DragHandle", () => $0f7a2d72136078d9$export$a0c24614540b0efb);
$parcel$export(module.exports, "DragHandleWithSharedState", () => $0f7a2d72136078d9$export$7ced4b5b2e3229c9);
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $7nsd3 = parcelRequire("7nsd3");

var $8RXs9 = parcelRequire("8RXs9");

var $gE8f9 = parcelRequire("gE8f9");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $2V0EL = parcelRequire("2V0EL");

var $gZGBX = parcelRequire("gZGBX");

var $28MvW = parcelRequire("28MvW");
var $uOUlv = parcelRequire("uOUlv");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $22Go6 = parcelRequire("22Go6");

var $gseSq = parcelRequire("gseSq");

var $g0UHf = parcelRequire("g0UHf");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $b1OxO = parcelRequire("b1OxO");

var $cASmu = parcelRequire("cASmu");

var $dS0Ra = parcelRequire("dS0Ra");
const $0f7a2d72136078d9$var$DragHandleComponent = ({ isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage }, hoveredColumns: hoveredColumns, hoveredRows: hoveredRows })=>{
    const dragHandleDivRef = (0, $5uXOq.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $5uXOq.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    if (hoveredColumns === undefined || hoveredRows === undefined) {
        const { hoveredColumns: hoveredColumnsState, hoveredRows: hoveredRowsState } = (0, $gseSq.getPluginState)(state);
        hoveredColumns = hoveredColumnsState;
        hoveredRows = hoveredRowsState;
    }
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $22Go6.getPluginState)(state);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    // Added !isDragMenuOpen check so when hover 'Delete column/row' from drag menu
    // the handle of the next column/row does not show the 'hovered' state icon
    const isRowHandleHovered = isRow && hoveredRows.length > 0 && !isDragMenuOpen;
    const isColumnHandleHovered = isColumn && hoveredColumns.length > 0 && !isDragMenuOpen;
    const hasMergedCells = (0, $5uXOq.useMemo)(()=>{
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return false;
        const map = (0, $uOUlv.TableMap).get(table?.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $gZGBX.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $g0UHf.findDuplicatePosition)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $g0UHf.findDuplicatePosition)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $g0UHf.hasMergedCellsInSelection)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $g0UHf.hasMergedCellsInSelection)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isColumnHandleHovered || isRowHandleHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $5uXOq.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        if (dragHandleDivRefCurrent) return (0, $7gWdR.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if ((0, $gE8f9.browser).safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                type: "button",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
                "data-testid": "table-drag-handle-clickable-zone-button",
                style: {
                    height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $1v4Xe.dragTableInsertColumnButtonSize}px)` : `${"var(--ds-space-200, 16px)"}`,
                    // 16px here because it's the size of drag handle button's large side
                    width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
                     : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $1v4Xe.dragTableInsertColumnButtonSize}px)`,
                    left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
                    bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
                    alignSelf: isColumn ? 'none' : 'center',
                    zIndex: isColumn ? '-1' : 'auto',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    pointerEvents: 'auto'
                },
                onMouseUp: (e)=>{
                    // should toggle menu if current drag menu open.
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                type: "button",
                id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
                    [(0, $jecUf.TableCssClassName).DRAG_HANDLE_DISABLED]: hasMergedCells
                }),
                ref: dragHandleDivRef,
                style: {
                    transform: isColumn ? 'none' : 'rotate(90deg)',
                    alignSelf: isColumn ? 'none' : 'center'
                },
                "data-testid": "table-drag-handle-button",
                "aria-label": formatMessage(isRow ? (0, $2V0EL.messages).rowDragHandle : (0, $2V0EL.messages).columnDragHandle),
                "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
                "aria-haspopup": "menu",
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: onMouseOver,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOut: onMouseOut,
                onMouseUp: (e)=>{
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') toggleDragMenu && toggleDragMenu('keyboard');
                },
                children: appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
                (0, $gE8f9.browser).gecko ? // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS0Ra.HandleIconComponent), {
                    ...handleIconProps
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        pointerEvents: 'none'
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS0Ra.HandleIconComponent), {
                        ...handleIconProps
                    })
                }) : null
            }),
            previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1OxO.DragPreview), {
                direction: direction,
                width: previewWidth,
                height: previewHeight
            }), previewContainer)
        ]
    });
};
const $0f7a2d72136078d9$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const hoveredColumns = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'hoveredColumns');
    const hoveredRows = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'hoveredRows');
    return {
        hoveredColumns: hoveredColumns,
        hoveredRows: hoveredRows
    };
}, (api)=>{
    const { tableState: tableState } = (0, $awTmI.useSharedPluginState)(api, [
        'table'
    ]);
    const tableStateInternal = tableState;
    return {
        hoveredColumns: tableStateInternal?.hoveredColumns,
        hoveredRows: tableStateInternal?.hoveredRows
    };
});
const $0f7a2d72136078d9$var$DragHandleComponentWithSharedState = ({ isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction, appearance: appearance, indexes: indexes, forceDefaultHandle: forceDefaultHandle, previewHeight: previewHeight, previewWidth: previewWidth, onMouseOver: onMouseOver, onMouseOut: onMouseOut, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: intl, api: api })=>{
    const { hoveredColumns: hoveredColumns, hoveredRows: hoveredRows } = $0f7a2d72136078d9$var$useSharedState(api);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0f7a2d72136078d9$var$DragHandleComponent, {
        isDragMenuTarget: isDragMenuTarget,
        tableLocalId: tableLocalId,
        direction: direction,
        appearance: appearance,
        indexes: indexes,
        forceDefaultHandle: forceDefaultHandle,
        previewWidth: previewWidth,
        previewHeight: previewHeight,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        toggleDragMenu: toggleDragMenu,
        hoveredCell: hoveredCell,
        onClick: onClick,
        editorView: editorView,
        intl: intl,
        hoveredColumns: hoveredColumns,
        hoveredRows: hoveredRows
    });
};
const $0f7a2d72136078d9$export$a0c24614540b0efb = (0, $8RXs9.default)($0f7a2d72136078d9$var$DragHandleComponent);
const $0f7a2d72136078d9$export$7ced4b5b2e3229c9 = (0, $8RXs9.default)($0f7a2d72136078d9$var$DragHandleComponentWithSharedState);

});
parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("b1OxO", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $597200b808321d2f$export$905ab40ac2179daa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $iUUXe = parcelRequire("iUUXe");
const $597200b808321d2f$var$boxStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.outline',
    backgroundColor: 'color.blanket.selected'
});
const $597200b808321d2f$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    const marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    const marginTop = direction === 'row' ? height / 2 - 14 : -10;
    const transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $597200b808321d2f$var$boxStyles,
        style: {
            width: `${width}px`,
            height: `${height}px`
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iUUXe.DragInMotionIcon), {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `${marginLeft}px`,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: `${marginTop}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                transform: transform
            }
        })
    });
};

});
parcelRegister("iUUXe", function(module, exports) {

$parcel$export(module.exports, "DragInMotionIcon", () => $463c2fc5cbfe0639$export$227151c7eab30def);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $463c2fc5cbfe0639$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "9",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "13",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "17",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                stroke: "var(--ds-border-inverse, #FFFFFF)",
                strokeWidth: "2"
            })
        ]
    });

});


parcelRegister("cASmu", function(module, exports) {

$parcel$export(module.exports, "useInternalTablePluginStateSelector", () => $512f6e57fad59434$export$1cf94b4c4f363107);

var $9LY0t = parcelRequire("9LY0t");
const $512f6e57fad59434$export$1cf94b4c4f363107 = (api, key, options)=>{
    // Need to disable the eslint rule here because the key is for the TableSharedStateInternal type
    // and we are using it as a string to access the value in the useSharedPluginStateSelector
    // which is typed only for the public TableSharedState type.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $9LY0t.useSharedPluginStateSelector)(api, `table.${key}`, options);
    return value;
};

});

parcelRegister("dS0Ra", function(module, exports) {

$parcel$export(module.exports, "HandleIconComponent", () => $77d6fce7720bfe0b$export$8749e1cb5c52435f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dDrUj = parcelRequire("dDrUj");

var $eNBGX = parcelRequire("eNBGX");

var $lJrUO = parcelRequire("lJrUO");
const $77d6fce7720bfe0b$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDrUj.DragHandleDisabledIcon), {}) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eNBGX.DragHandleIcon), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJrUO.MinimisedHandleIcon), {});
};

});
parcelRegister("dDrUj", function(module, exports) {

$parcel$export(module.exports, "DragHandleDisabledIcon", () => $9a149358f22d1613$export$b005cb3a0f2a5647);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $9a149358f22d1613$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        x: "7",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        x: "11",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        x: "15",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    })
                ]
            })
        ]
    });

});

parcelRegister("eNBGX", function(module, exports) {

$parcel$export(module.exports, "DragHandleIcon", () => $4e2e2d998602889d$export$7d3bc85820ac4455);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $4e2e2d998602889d$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                })
            })
        ]
    });

});

parcelRegister("lJrUO", function(module, exports) {

$parcel$export(module.exports, "MinimisedHandleIcon", () => $ca1baa660c056e46$export$e32dc8bb64018ca1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jecUf = parcelRequire("jecUf");
const $ca1baa660c056e46$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).DRAG_HANDLE_MINIMISED,
            width: "24",
            height: "5",
            rx: "3"
        })
    });

});




parcelRegister("9ZHsX", function(module, exports) {

$parcel$export(module.exports, "ColumnDropTargets", () => $8cc303dfa33bea16$export$9878f6beafc50edd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jecUf = parcelRequire("jecUf");

var $6VUM9 = parcelRequire("6VUM9");
const $8cc303dfa33bea16$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $5uXOq.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${getScrollOffset?.() ?? 0}px`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls-drop-targets",
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6VUM9.ColumnDropTarget), {
                    index: index,
                    localId: localId,
                    width: width,
                    height: tableHeight,
                    marginTop: 0
                }, index);
            })
        })
    });
};

});
parcelRegister("6VUM9", function(module, exports) {

$parcel$export(module.exports, "ColumnDropTarget", () => $1c11600f1d0ddb01$export$e8a325e09c5453d5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");

var $3hM1t = parcelRequire("3hM1t");
const $1c11600f1d0ddb01$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $7gWdR.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $3hM1t.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $3hM1t.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $3hM1t.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};

});



parcelRegister("cEOF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d6693b5c7c172f9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gE8f9 = parcelRequire("gE8f9");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $9fJGy = parcelRequire("9fJGy");
var $66MHx = parcelRequire("66MHx");

var $evhdb = parcelRequire("evhdb");

var $jecUf = parcelRequire("jecUf");

var $gVITo = parcelRequire("gVITo");

var $eE5BD = parcelRequire("eE5BD");

var $2jemI = parcelRequire("2jemI");

var $5gb5P = parcelRequire("5gb5P");

var $jMrSZ = parcelRequire("jMrSZ");

var $bJJMP = parcelRequire("bJJMP");
const $2d6693b5c7c172f9$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, isDragAndDropEnabled: isDragAndDropEnabled, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $5uXOq.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $gE8f9.browser).ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $66MHx.selectRow)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $5uXOq.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $gE8f9.browser).ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $66MHx.selectRows)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $5uXOq.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $9fJGy.hoverRows)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $5uXOq.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $9fJGy.hoverCell)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $jecUf.TableCssClassName).TABLE_CHROMELESS : (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $jecUf.TableCssClassName).ROW_CONTROLS_WRAPPER;
    const tablePos = (0, $28MvW.findTable)(editorView.state.selection)?.pos;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const isNested = tablePos !== undefined && (0, $evhdb.isTableNested)(editorView.state, tablePos);
    const shouldShowCornerControls = isNested && !(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes');
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault(),
            children: [
                isNumberColumnEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5gb5P.default), {
                    editorView: editorView,
                    hoverRows: _hoverRows,
                    tableRef: tableRef,
                    tableActive: tableActive,
                    hoveredRows: hoveredRows,
                    hasHeaderRow: hasHeaderRow,
                    isInDanger: isInDanger,
                    isResizing: isResizing,
                    selectRow: _selectRow,
                    updateCellHoverLocation: updateCellHoverLocation,
                    stickyTop: stickyTop,
                    isDragAndDropEnabled: isDragAndDropEnabled
                }) : null,
                tableActive && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: isDragAndDropEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: (0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                shouldShowCornerControls && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE5BD.DragCornerControlsWithSelection), {
                                    editorView: editorView,
                                    tableRef: tableRef,
                                    isInDanger: isInDanger,
                                    isResizing: isResizing,
                                    api: api
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJJMP.DragControlsWithSelection), {
                                    tableRef: tableRef,
                                    tableNode: tableNode,
                                    hoveredCell: hoveredCell,
                                    isTableHovered: isTableHovered,
                                    editorView: editorView,
                                    tableActive: tableActive,
                                    isInDanger: isInDanger,
                                    isResizing: isResizing,
                                    // Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    tableWidth: tableWrapperWidth,
                                    hoverRows: _hoverRows,
                                    selectRow: _selectRow,
                                    selectRows: _selectRows,
                                    updateCellHoverLocation: updateCellHoverLocation,
                                    api: api
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                shouldShowCornerControls && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE5BD.DragCornerControls), {
                                    editorView: editorView,
                                    tableRef: tableRef,
                                    isInDanger: isInDanger,
                                    isResizing: isResizing
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJJMP.DragControls), {
                                    tableRef: tableRef,
                                    tableNode: tableNode,
                                    hoveredCell: hoveredCell,
                                    isTableHovered: isTableHovered,
                                    editorView: editorView,
                                    tableActive: tableActive,
                                    isInDanger: isInDanger,
                                    isResizing: isResizing,
                                    // Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    tableWidth: tableWrapperWidth,
                                    hoverRows: _hoverRows,
                                    selectRow: _selectRow,
                                    selectRows: _selectRows,
                                    updateCellHoverLocation: updateCellHoverLocation
                                })
                            ]
                        })
                    }) : (0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2jemI.FloatingControlsWithSelection), {
                        editorView: editorView,
                        tableRef: tableRef,
                        isInDanger: isInDanger,
                        isResizing: isResizing,
                        isHeaderRowEnabled: isHeaderRowEnabled,
                        isHeaderColumnEnabled: isHeaderColumnEnabled,
                        hoveredRows: hoveredRows,
                        stickyTop: tableActive ? stickyTop : undefined,
                        tableActive: tableActive,
                        hoverRows: _hoverRows,
                        selectRow: _selectRow,
                        api: api
                    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVITo.CornerControls), {
                                editorView: editorView,
                                tableRef: tableRef,
                                isInDanger: isInDanger,
                                isResizing: isResizing,
                                isHeaderRowEnabled: isHeaderRowEnabled,
                                isHeaderColumnEnabled: isHeaderColumnEnabled,
                                hoveredRows: hoveredRows,
                                stickyTop: tableActive ? stickyTop : undefined
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jMrSZ.RowControls), {
                                editorView: editorView,
                                tableRef: tableRef,
                                hoverRows: _hoverRows,
                                hoveredRows: hoveredRows,
                                isInDanger: isInDanger,
                                isResizing: isResizing,
                                selectRow: _selectRow,
                                stickyTop: tableActive ? stickyTop : undefined
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var $2d6693b5c7c172f9$export$2e2bcd8739ae039 = $2d6693b5c7c172f9$export$1e425115e5c75aac;

});
parcelRegister("gVITo", function(module, exports) {

$parcel$export(module.exports, "CornerControls", () => $39072d9f7563907e$export$c4e380678531b264);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $8RXs9 = parcelRequire("8RXs9");

var $2V0EL = parcelRequire("2V0EL");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $cK1Lv = parcelRequire("cK1Lv");
var $bhEri = parcelRequire("bhEri");

var $9fJGy = parcelRequire("9fJGy");

var $jecUf = parcelRequire("jecUf");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, @typescript-eslint/no-explicit-any
class $39072d9f7563907e$var$CornerControlComponent extends (0, $5uXOq.Component) {
    render() {
        const { isInDanger: isInDanger, tableRef: tableRef, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, intl: { formatMessage: formatMessage } } = this.props;
        if (!tableRef) return null;
        const isActive = this.isActive();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).CORNER_CONTROLS, {
                active: isActive,
                sticky: this.props.stickyTop !== undefined
            }),
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: this.props.stickyTop !== undefined ? `0px` : undefined
            },
            contentEditable: false,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                    "aria-label": formatMessage((0, $2V0EL.messages).cornerControl),
                    type: "button",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).CONTROLS_CORNER_BUTTON, {
                        danger: isActive && isInDanger
                    }),
                    onClick: this.selectTable,
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    onMouseOver: this.hoverTable,
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    onMouseOut: this.clearHoverSelection
                }),
                !isHeaderRowEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_MARKER
                    })
                }),
                !isHeaderColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $jecUf.TableCssClassName).CORNER_CONTROLS_INSERT_COLUMN_MARKER,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_MARKER
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.isActive = ()=>{
            const { editorView: editorView, hoveredRows: hoveredRows, isResizing: isResizing } = this.props;
            const { selection: selection } = editorView.state;
            const table = (0, $28MvW.findTable)(selection);
            if (!table) return false;
            return (0, $cK1Lv.isTableSelected)(selection) || hoveredRows && hoveredRows.length === (0, $uOUlv.TableMap).get(table.node).height && !isResizing;
        }, this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        }, this.selectTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            dispatch((0, $bhEri.selectTable)(state.tr).setMeta('addToHistory', false));
        }, this.hoverTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $9fJGy.hoverTable)()(state, dispatch);
        };
    }
}
const $39072d9f7563907e$export$c4e380678531b264 = (0, $8RXs9.default)($39072d9f7563907e$var$CornerControlComponent);

});

parcelRegister("eE5BD", function(module, exports) {

$parcel$export(module.exports, "DragCornerControlsWithSelection", () => $d9026721cd001ee8$export$2e06061cfdb64df2);
$parcel$export(module.exports, "DragCornerControls", () => $d9026721cd001ee8$export$2beb96b6455e9966);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $8RXs9 = parcelRequire("8RXs9");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $2V0EL = parcelRequire("2V0EL");

var $9LY0t = parcelRequire("9LY0t");

var $28MvW = parcelRequire("28MvW");
var $cK1Lv = parcelRequire("cK1Lv");
var $bhEri = parcelRequire("bhEri");

var $9fJGy = parcelRequire("9fJGy");

var $jecUf = parcelRequire("jecUf");
const $d9026721cd001ee8$var$DragCornerControlsComponent = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage } })=>{
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $bhEri.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $9fJGy.clearHoverSelection)()(state, dispatch);
    };
    const isActive = (0, $5uXOq.useMemo)(()=>{
        const { selection: selection } = editorView.state;
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return false;
        return (0, $cK1Lv.isTableSelected)(selection);
    }, [
        editorView.state
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2V0EL.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        onMouseOut: handleMouseOut,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $d9026721cd001ee8$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const selectionsSelector = (0, $9LY0t.useSharedPluginStateSelector)(api, 'selection.selection');
    return {
        selection: selectionsSelector
    };
}, (api)=>{
    const { selectionState: selectionState } = (0, $awTmI.useSharedPluginState)(api, [
        'selection'
    ]);
    return {
        selection: selectionState?.selection
    };
});
const $d9026721cd001ee8$var$DragCornerControlsComponentWithSelection = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, api: api })=>{
    const { selection: selection } = $d9026721cd001ee8$var$useSharedState(api);
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $bhEri.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $9fJGy.clearHoverSelection)()(state, dispatch);
    };
    const isActive = (0, $5uXOq.useMemo)(()=>{
        if (!selection) return;
        const table = (0, $28MvW.findTable)(selection);
        if (!table) return false;
        return (0, $cK1Lv.isTableSelected)(selection);
    }, [
        selection
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2V0EL.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        onMouseOut: handleMouseOut,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $jecUf.TableCssClassName).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $d9026721cd001ee8$export$2e06061cfdb64df2 = (0, $8RXs9.default)($d9026721cd001ee8$var$DragCornerControlsComponentWithSelection);
const $d9026721cd001ee8$export$2beb96b6455e9966 = (0, $8RXs9.default)($d9026721cd001ee8$var$DragCornerControlsComponent);

});

parcelRegister("2jemI", function(module, exports) {

$parcel$export(module.exports, "FloatingControlsWithSelection", () => $bf2c2918d1711e29$export$4017f69d73e46bd1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $gVITo = parcelRequire("gVITo");

var $jMrSZ = parcelRequire("jMrSZ");
const $bf2c2918d1711e29$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const selectionsSelector = (0, $9LY0t.useSharedPluginStateSelector)(api, 'selection.selection');
    return {
        selection: selectionsSelector
    };
}, (api)=>{
    const { selectionState: selectionState } = (0, $awTmI.useSharedPluginState)(api, [
        'selection'
    ]);
    return {
        selection: selectionState?.selection
    };
});
const $bf2c2918d1711e29$export$4017f69d73e46bd1 = ({ editorView: editorView, tableRef: tableRef, isInDanger: isInDanger, isResizing: isResizing, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, hoveredRows: hoveredRows, stickyTop: stickyTop, hoverRows: hoverRows, selectRow: selectRow, tableActive: tableActive, api: api })=>{
    const { selection: selection } = $bf2c2918d1711e29$var$useSharedState(api);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVITo.CornerControls), {
                editorView: editorView,
                tableRef: tableRef,
                isInDanger: isInDanger,
                isResizing: isResizing,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                hoveredRows: hoveredRows,
                stickyTop: tableActive ? stickyTop : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jMrSZ.RowControls), {
                selection: selection,
                editorView: editorView,
                tableRef: tableRef,
                hoverRows: hoverRows,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isResizing: isResizing,
                selectRow: selectRow,
                stickyTop: tableActive ? stickyTop : undefined
            })
        ]
    });
};

});
parcelRegister("jMrSZ", function(module, exports) {

$parcel$export(module.exports, "RowControls", () => $c58184b70ea39065$export$bd67b796ee9987b2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $2V0EL = parcelRequire("2V0EL");

var $VSDnB = parcelRequire("VSDnB");

var $9fJGy = parcelRequire("9fJGy");

var $g4A0f = parcelRequire("g4A0f");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c58184b70ea39065$var$RowControlsComponent extends (0, $5uXOq.Component) {
    render() {
        const { editorView: editorView, tableRef: tableRef, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, selection: selectionState } = this.props;
        if (!tableRef) return null;
        const { selection: selection } = editorView.state;
        const rowHeights = (0, $g4A0f.getRowHeights)(tableRef);
        const rowsParams = (0, $g4A0f.getRowsParams)(rowHeights);
        const firstRow = tableRef.querySelector('tr');
        const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $jecUf.TableCssClassName).ROW_CONTROLS,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $jecUf.TableCssClassName).ROW_CONTROLS_INNER,
                children: rowsParams.map(({ startIndex: startIndex, endIndex: endIndex, height: height }, index)=>{
                    // if previous row was header row, add its height to our margin
                    let marginTop = -1;
                    if (index === 1 && hasHeaderRow && this.props.stickyTop !== undefined) marginTop += rowHeights[index - 1] + (0, $1v4Xe.tableToolbarSize);
                    const thisRowSticky = this.props.stickyTop !== undefined && index === 0 && hasHeaderRow;
                    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP} ${(0, $g4A0f.getRowClassNames)(startIndex, selectionState || selection, hoveredRows, isInDanger, isResizing)} ${thisRowSticky ? 'sticky' : ''}`,
                        style: {
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            height: height,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            marginTop: `${marginTop}px`,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            top: thisRowSticky ? `3px` : undefined,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            paddingTop: thisRowSticky ? `${(0, $VSDnB.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $1v4Xe.tableControlsSpacing) - 2 : (0, $1v4Xe.tableControlsSpacing)}px` : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                                "aria-label": formatMessage((0, $2V0EL.messages).rowControl),
                                type: "button",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: `${(0, $jecUf.TableCssClassName).ROW_CONTROLS_BUTTON} ${(0, $jecUf.TableCssClassName).CONTROLS_BUTTON}`,
                                onClick: (event)=>this.props.selectRow(startIndex, event.shiftKey),
                                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                                onMouseOver: ()=>this.props.hoverRows([
                                        startIndex
                                    ]),
                                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                                onMouseOut: this.clearHoverSelection,
                                "data-start-index": startIndex,
                                "data-end-index": endIndex
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_MARKER
                            })
                        ]
                    }, startIndex);
                })
            })
        }));
    }
    constructor(...args){
        super(...args), this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        };
    }
}
const $c58184b70ea39065$export$bd67b796ee9987b2 = (0, $8RXs9.default)($c58184b70ea39065$var$RowControlsComponent);

});


parcelRegister("5gb5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4383c8b10dbb9df$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $gZGBX = parcelRequire("gZGBX");

var $cK1Lv = parcelRequire("cK1Lv");

var $VSDnB = parcelRequire("VSDnB");

var $9fJGy = parcelRequire("9fJGy");

var $g4A0f = parcelRequire("g4A0f");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
class $d4383c8b10dbb9df$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $g4A0f.getRowHeights)(tableRef);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $1v4Xe.tableBorderColor}` : undefined
            },
            contentEditable: false,
            children: rowHeights.map((rowHeight, index)=>isDragAndDropEnabled ? // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index, true),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    onMouseOver: ()=>updateCellHoverLocation(index),
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`) : // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    onClick: (event)=>this.selectRow(index, event),
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    onMouseOver: ()=>this.hoverRows(index),
                    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                    onMouseOut: this.clearHoverSelection,
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`))
        });
    }
    constructor(...args){
        super(...args), this.hoverRows = (index)=>{
            return this.props.tableActive ? this.props.hoverRows([
                index
            ]) : null;
        }, this.selectRow = (index, event)=>{
            const { tableActive: tableActive, editorView: editorView, selectRow: selectRow } = this.props;
            // If selection is outside the table then first reset the selection inside table
            if (!tableActive && event.target && event.target instanceof Node) {
                const { doc: doc, selection: selection, tr: tr } = editorView.state;
                const pos = editorView.posAtDOM(event.target, 1);
                const $pos = doc.resolve(pos);
                const newPos = selection.head > pos ? // nodeSize - 3 will move the position inside last table cell
                (0, $gZGBX.Selection).near(doc.resolve(pos + ($pos.parent.nodeSize - 3)), -1) : (0, $gZGBX.Selection).near($pos);
                editorView.dispatch(tr.setSelection(newPos));
            }
            selectRow(index, event.shiftKey);
        }, this.clearHoverSelection = ()=>{
            const { tableActive: tableActive, editorView: editorView } = this.props;
            if (tableActive) {
                const { state: state, dispatch: dispatch } = editorView;
                (0, $9fJGy.clearHoverSelection)()(state, dispatch);
            }
        }, this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = 0;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        }, this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, tableActive: tableActive } = this.props;
            const isActive = (0, $cK1Lv.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            if ((0, $VSDnB.fg)('platform_editor_nested_tables_number_column_fixes')) return (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, {
                [(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER]: tableActive && isActive && isInDanger,
                [(0, $jecUf.TableCssClassName).HOVERED_CELL_ACTIVE]: tableActive && isActive
            });
            else return (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON, {
                [(0, $jecUf.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $jecUf.TableCssClassName).HOVERED_CELL_IN_DANGER]: isActive && isInDanger,
                [(0, $jecUf.TableCssClassName).HOVERED_CELL_ACTIVE]: isActive
            });
        };
    }
}

});

parcelRegister("bJJMP", function(module, exports) {

$parcel$export(module.exports, "DragControls", () => $82d7d547153d6fa7$export$350d0cf1f91b53f4);
$parcel$export(module.exports, "DragControlsWithSelection", () => $82d7d547153d6fa7$export$8bade456cc132de4);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $hFEwm = parcelRequire("hFEwm");

var $b1RTQ = parcelRequire("b1RTQ");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $9fJGy = parcelRequire("9fJGy");

var $gF4dk = parcelRequire("gF4dk");

var $gseSq = parcelRequire("gseSq");

var $g4A0f = parcelRequire("g4A0f");

var $9bHWx = parcelRequire("9bHWx");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $2fY9A = parcelRequire("2fY9A");

var $klP00 = parcelRequire("klP00");
const $82d7d547153d6fa7$var$getSelectedRows = (selection)=>{
    if (selection instanceof (0, $hFEwm.CellSelection) && selection.isRowSelection()) {
        const rect = (0, $b1RTQ.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $9bHWx.getSelectedRowIndexes)(rect);
    }
    return [];
};
const $82d7d547153d6fa7$export$350d0cf1f91b53f4 = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api, selection: selection })=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
    const rowHeights = (0, $g4A0f.getRowHeights)(tableRef);
    const rowsParams = (0, $g4A0f.getRowsParams)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $82d7d547153d6fa7$var$getSelectedRows(selection ?? editorView.state.selection);
    const currentNodeLocalId = tableNode?.attrs?.localId ?? '';
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $gseSq.getPluginState)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === tableNode?.attrs.localId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $5uXOq.useCallback)((trigger, event)=>{
        if (event?.shiftKey) return;
        (0, $gF4dk.toggleDragMenu)(undefined, 'row', hoveredCell?.rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell?.rowIndex
    ]);
    const rowIndex = hoveredCell?.rowIndex;
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target?.closest(`.${(0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS}`);
        const rowIndex = target?.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $5uXOq.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        const isClickOutsideSelectedRows = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectRow(rowIndex, e.shiftKey);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`,
            children: (0, $VSDnB.fg)('platform_editor_table_use_shared_state_hook_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2fY9A.DragHandleWithSharedState), {
                isDragMenuTarget: !isHover,
                direction: "row",
                tableLocalId: currentNodeLocalId,
                indexes: indexes,
                forceDefaultHandle: !isHover,
                previewWidth: tableWidth,
                previewHeight: previewHeight,
                appearance: appearance,
                hoveredCell: hoveredCell,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView,
                api: api
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2fY9A.DragHandle), {
                isDragMenuTarget: !isHover,
                direction: "row",
                tableLocalId: currentNodeLocalId,
                indexes: indexes,
                forceDefaultHandle: !isHover,
                previewWidth: tableWidth,
                previewHeight: previewHeight,
                appearance: appearance,
                hoveredCell: hoveredCell,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder', `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $1v4Xe.dropTargetExtendedWidth}px 14px ${tableWidth}px` : '0px 14px 0px',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $1v4Xe.dropTargetExtendedWidth) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false,
        children: [
            rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '2'
                            },
                            "data-start-index": startIndex,
                            "data-end-index": endIndex,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
                            contentEditable: false,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                className: (0, $jecUf.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT
                            })
                        }, `insert-dot-${index}`),
                        isDragging && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $klP00.default), {
                            index: index,
                            localId: currentNodeLocalId,
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '1 / span 3',
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                pointerEvents: 'auto',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                position: 'relative',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                left: "var(--ds-space-negative-100, -8px)"
                            }
                        }, `drop-target-${index}`)
                    ]
                }, index)),
            rowHandles()
        ]
    }));
};
const $82d7d547153d6fa7$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const selectionsSelector = (0, $9LY0t.useSharedPluginStateSelector)(api, 'selection.selection');
    return {
        selection: selectionsSelector
    };
}, (api)=>{
    const { selectionState: selectionState } = (0, $awTmI.useSharedPluginState)(api, [
        'selection'
    ]);
    return {
        selection: selectionState?.selection
    };
});
const $82d7d547153d6fa7$export$8bade456cc132de4 = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, tableActive: tableActive, hoveredCell: hoveredCell, isInDanger: isInDanger, isTableHovered: isTableHovered, isResizing: isResizing, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api })=>{
    const { selection: selection } = $82d7d547153d6fa7$var$useSharedState(api);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($82d7d547153d6fa7$export$350d0cf1f91b53f4, {
        editorView: editorView,
        tableRef: tableRef,
        tableNode: tableNode,
        tableWidth: tableWidth,
        tableActive: tableActive,
        hoveredCell: hoveredCell,
        isInDanger: isInDanger,
        isTableHovered: isTableHovered,
        isResizing: isResizing,
        hoverRows: hoverRows,
        selectRow: selectRow,
        selectRows: selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api,
        selection: selection
    });
};

});
parcelRegister("klP00", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b7394f238350c4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");

var $3hM1t = parcelRequire("3hM1t");
const $c1b7394f238350c4$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $7gWdR.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $3hM1t.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $3hM1t.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $3hM1t.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $c1b7394f238350c4$export$2e2bcd8739ae039 = $c1b7394f238350c4$var$RowDropTarget;

});



parcelRegister("u33of", function(module, exports) {

$parcel$export(module.exports, "ExternalDropTargets", () => $92e0465627ca5ad9$export$1041cb8214100cd2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $7gWdR = parcelRequire("7gWdR");

var $lOQGo = parcelRequire("lOQGo");

var $1v4Xe = parcelRequire("1v4Xe");

var $6VUM9 = parcelRequire("6VUM9");
const $92e0465627ca5ad9$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
    const currentNodeLocalId = node?.attrs.localId;
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $lOQGo.getColumnsWidths)(editorView);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $1v4Xe.dropTargetExtendedWidth) - (0, $6gEe5.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $1v4Xe.dropTargetsZIndex)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // move drop targets based on table wrapper scroll
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `-${getScrollOffset()}px`
            },
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6VUM9.ColumnDropTarget), {
                    index: index,
                    localId: currentNodeLocalId,
                    width: width,
                    height: (0, $1v4Xe.dropTargetExtendedWidth),
                    marginTop: 0
                }, index);
            })
        })
    });
};

});

parcelRegister("8tMQh", function(module, exports) {

$parcel$export(module.exports, "OverflowShadowsObserver", () => $38b656d66c36faf1$export$54a3f2df32d0a7c9);

var $7nRxN = parcelRequire("7nRxN");

var $jecUf = parcelRequire("jecUf");

var $i0Qle = parcelRequire("i0Qle");
class $38b656d66c36faf1$export$54a3f2df32d0a7c9 {
    // updateShadowState is a method to update shadow key
    constructor(updateShadowState, table, wrapper){
        this.leftShadowSentinel = null;
        this.rightShadowSentinel = null;
        this.shadowsObserved = false;
        this.isSticky = false;
        this.stickyRowHeight = 0;
        this.init = ()=>{
            const table = this.table;
            if (!this.wrapper || !table) return;
            if (!this.tableIntersectionObserver) {
                const intersectonOnbserverCallback = (entry)=>{
                    if (entry.target !== this.leftShadowSentinel && entry.target !== this.rightShadowSentinel) return;
                    this.updateStickyShadowsHeightIfChanged();
                    this.updateShadowState(this.leftShadowSentinel === entry.target ? (0, $jecUf.ShadowEvent).SHOW_BEFORE_SHADOW : (0, $jecUf.ShadowEvent).SHOW_AFTER_SHADOW, entry.intersectionRatio !== 1);
                };
                this.tableIntersectionObserver = new IntersectionObserver((entries, _)=>{
                    entries.forEach((entry)=>intersectonOnbserverCallback(entry));
                }, {
                    threshold: [
                        0,
                        1
                    ],
                    root: this.wrapper,
                    rootMargin: '0px'
                });
                return;
            }
        };
        this.observeShadowSentinels = (isSticky)=>{
            if (this.isSticky === isSticky) return;
            this.isSticky = !!isSticky;
            // reset height
            this.stickyRowHeight = 0;
            // update sticky shadows
            this.updateStickyShadowsHeightIfChanged();
            this.leftShadowSentinel = this.table?.querySelector(`.${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT}`);
            this.rightShadowSentinel = this.table?.querySelector(`.${(0, $jecUf.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT}`);
            if (this.tableIntersectionObserver && this.leftShadowSentinel && this.rightShadowSentinel && !this.shadowsObserved) {
                this.tableIntersectionObserver.disconnect();
                this.tableIntersectionObserver.observe(this.leftShadowSentinel);
                this.tableIntersectionObserver.observe(this.rightShadowSentinel);
                this.shadowsObserved = true;
            }
        };
        /**
	 * Takes a heightStyle if it can be computed in a less expensive manner,
	 * e.g. bounds on an IntersectionObserverEntry, otherwise proceed with
	 * reading it from sticky cell
	 */ this.updateStickyShadows = (0, $7nRxN.default)((stickyRowHeight)=>{
            if (!this.isSticky) return;
            const stickyCell = this.getStickyCell();
            if (!stickyCell || !this.wrapper?.parentElement) return;
            // Reflow Warning! - stickyCell.clientHeight
            const newStickyRowHeight = stickyRowHeight || stickyCell.clientHeight + 1;
            if (newStickyRowHeight !== this.stickyRowHeight) {
                this.stickyRowHeight = newStickyRowHeight;
                const heightStyleOrCompute = `${newStickyRowHeight}px`;
                // Use getElementsByClassName here for a live node list to capture
                // sticky shadows
                const liveRightShadows = this.wrapper?.parentElement?.getElementsByClassName(`${(0, $jecUf.TableCssClassName).TABLE_RIGHT_SHADOW}`);
                const liveLeftShadows = this.wrapper?.parentElement?.getElementsByClassName(`${(0, $jecUf.TableCssClassName).TABLE_LEFT_SHADOW}`);
                (0, $i0Qle.updateShadowListForStickyStyles)(heightStyleOrCompute, liveLeftShadows);
                (0, $i0Qle.updateShadowListForStickyStyles)(heightStyleOrCompute, liveRightShadows);
            }
        });
        this.updateShadowState = updateShadowState;
        this.table = table;
        this.wrapper = wrapper;
        this.init();
    }
    updateStickyShadowsHeightIfChanged() {
        if (!this.isSticky) return;
        const stickyCell = this.getStickyCell();
        if (!stickyCell) return;
        this.updateStickyShadows();
    }
    getStickyCell() {
        const stickyRow = this.wrapper?.querySelector('tr.sticky');
        const stickyCell = stickyRow && stickyRow.firstElementChild;
        return stickyCell;
    }
    dispose() {
        if (this.tableIntersectionObserver) {
            this.tableIntersectionObserver.disconnect();
            this.tableIntersectionObserver = undefined;
        }
    }
}

});
parcelRegister("i0Qle", function(module, exports) {

$parcel$export(module.exports, "updateShadowListForStickyStyles", () => $2ee19608347ec115$export$d8af1cc051b8af31);

var $jecUf = parcelRequire("jecUf");
const $2ee19608347ec115$export$d8af1cc051b8af31 = (heightStyle, shadows)=>{
    Array.from(shadows).forEach((shadow)=>{
        if (shadow.classList.contains((0, $jecUf.TableCssClassName).TABLE_STICKY_SHADOW)) {
            if (shadow instanceof HTMLElement && shadow.style.height !== heightStyle) shadow.style.height = heightStyle;
        }
    });
};

});


parcelRegister("gvxwa", function(module, exports) {

$parcel$export(module.exports, "TableContainer", () => $f085bcc31789cf7d$export$f2c3aea42b2a048f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $dEzej = parcelRequire("dEzej");
var $gkwXh = parcelRequire("gkwXh");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $fKLIs = parcelRequire("fKLIs");

var $9LY0t = parcelRequire("9LY0t");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $6lSoW = parcelRequire("6lSoW");

var $gseSq = parcelRequire("gseSq");

var $9QiRG = parcelRequire("9QiRG");

var $fkJZJ = parcelRequire("fkJZJ");

var $jecUf = parcelRequire("jecUf");

var $1SASl = parcelRequire("1SASl");

var $gxSoi = parcelRequire("gxSoi");
const $f085bcc31789cf7d$var$InnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, style: style, node: node, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-testid": "table-container",
        children: children
    });
});
const $f085bcc31789cf7d$var$useAlignmentStableContainerSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const isFullWidthModeEnabled = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'table.isFullWidthModeEnabled');
    const wasFullWidthModeEnabled = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'table.wasFullWidthModeEnabled');
    return {
        tableState: undefined,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        wasFullWidthModeEnabled: wasFullWidthModeEnabled
    };
}, (pluginInjectionApi)=>{
    const { tableState: tableState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'table'
    ]);
    return {
        tableState: tableState,
        isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
        wasFullWidthModeEnabled: tableState?.wasFullWidthModeEnabled
    };
});
const $f085bcc31789cf7d$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $fkJZJ.ALIGN_START) ? (0, $fkJZJ.ALIGN_CENTER) : (0, $fkJZJ.ALIGN_START);
    const { tableState: tableState, isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled } = $f085bcc31789cf7d$var$useAlignmentStableContainerSharedState(pluginInjectionApi);
    (0, $5uXOq.useEffect)(()=>{
        if (!tableState && (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', false)) return;
        if (editorView && getPos) {
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $fkJZJ.ALIGN_CENTER) && node.attrs.width > (0, $iHYdz.akEditorDefaultLayoutWidth)) {
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $6lSoW.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi?.analytics?.actions)((0, $fkJZJ.ALIGN_CENTER), alignment, {
                    pos: pos,
                    node: node
                }, (0, $gkwXh.INPUT_METHOD).AUTO, (0, $dEzej.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        tableState,
        isFullWidthModeEnabled,
        wasFullWidthModeEnabled,
        node
    ]);
    const style = (0, $5uXOq.useMemo)(()=>{
        return (0, $1SASl.getAlignmentStyle)(alignment);
    }, [
        alignment
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "table-alignment-container",
        style: style,
        children: children
    }));
};
const $f085bcc31789cf7d$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "table-alignment-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: children
    });
};
const $f085bcc31789cf7d$var$useResizeableTableContainerSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const isFullWidthModeEnabled = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'table.isFullWidthModeEnabled');
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    return {
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        mode: mode
    };
}, (pluginInjectionApi)=>{
    const { tableState: tableState, editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'table',
        'editorViewMode'
    ]);
    return {
        isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
        mode: editorViewModeState?.mode
    };
});
const $f085bcc31789cf7d$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const tableWidthRef = (0, $5uXOq.useRef)((0, $iHYdz.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $5uXOq.useState)(false);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled, mode: mode } = $f085bcc31789cf7d$var$useResizeableTableContainerSharedState(pluginInjectionApi);
    const updateContainerHeight = (0, $5uXOq.useCallback)((height)=>{
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = containerRef.current?.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            const stickyHeaderHeight = containerRef.current?.getElementsByTagName('th')[0].getBoundingClientRect().height || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $5uXOq.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $5uXOq.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $5uXOq.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $5uXOq.useCallback)((guidelines)=>{
        return pluginInjectionApi?.guideline?.actions?.displayGuideline(editorView)({
            guidelines: guidelines
        }) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        return pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $5uXOq.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const tableWidth = (0, $fKLIs.getTableContainerWidth)(node);
    let responsiveContainerWidth = 0;
    const resizeHandleSpacing = 12;
    // When Full width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
    // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
    // issues when viwport width is less than full width Editor's width. To detect avoid them
    // we need to use lineLength to defined responsiveWidth instead of containerWidth
    // (which does not get updated when Mac setting changes) in Full-width editor.
    if (isFullWidthModeEnabled) {
        // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
        // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
        // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
        responsiveContainerWidth = isTableScalingEnabled ? lineLength : containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 - resizeHandleSpacing;
        // platform_editor_table_fw_numcol_overflow_fix:
        // lineLength is undefined on first paint → width: NaN → wrapper expands to page
        // width. rAF col-sizing then runs before the number-column padding and
        // the final shrink, so column widths are locked in wrong.
        // With the flag ON, if the value isn’t finite we fall back to gutterWidth
        // for that first frame—no flash, no premature rAF.
        //
        // Type clean-up comes later:
        // 1) ship this runtime guard (quick fix, no breakage);
        // 2) TODO: widen lineLength to `number|undefined` and remove this block.
        if ((0, $VSDnB.fg)('platform_editor_table_fw_numcol_overflow_fix')) {
            if (isTableScalingEnabled && !Number.isFinite(responsiveContainerWidth)) responsiveContainerWidth = containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 - resizeHandleSpacing;
        }
    } else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $9QiRG.TABLE_OFFSET_IN_COMMENT_EDITOR);
    else // 76 is currently an accepted padding value considering the spacing for resizer handle
    // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
    // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
    // padding left = padding right = akEditorGutterPadding = 32
    responsiveContainerWidth = isTableScalingEnabled ? containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 : containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 - resizeHandleSpacing;
    const width = !node.attrs.width && isCommentEditor ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
    if (!isResizing) tableWidthRef.current = width;
    const maxResizerWidth = isCommentEditor ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $9QiRG.TABLE_MAX_WIDTH));
    const tableResizerProps = {
        width: width,
        maxWidth: maxResizerWidth,
        containerWidth: containerWidth,
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor
    };
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            style: {
                width: tableWidthRef.current,
                height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
                position: isLivePageViewMode ? 'relative' : 'unset'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).TABLE_RESIZER_CONTAINER,
            ref: containerRef,
            children: [
                (0, $VSDnB.fg)('platform_editor_live_page_prevent_table_recreation') ? null : isLivePageViewMode ? /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$InnerContainer, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: className,
                    node: node,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        width: 'inherit'
                    },
                    children: children
                }) : // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gxSoi.TableResizer), {
                    ...tableResizerProps,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$InnerContainer, {
                        className: className,
                        node: node,
                        children: children
                    })
                }),
                (0, $VSDnB.fg)('platform_editor_live_page_prevent_table_recreation') ? // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gxSoi.TableResizer), {
                    ...tableResizerProps,
                    disabled: isLivePageViewMode,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$InnerContainer, {
                        className: className,
                        node: node,
                        children: children
                    })
                }) : null
            ]
        })
    });
});
const $f085bcc31789cf7d$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerWidth: editorWidth,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor,
        children: children
    });
    const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f085bcc31789cf7d$var$InnerContainer, {
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))(className, {
            'less-padding': editorWidth < (0, $iHYdz.akEditorMobileBreakoutPoint) && !isNested && !(isChromelessEditor && isDragAndDropEnabled)
        }),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined
        },
        children: children
    });
};

});
parcelRegister("gxSoi", function(module, exports) {

$parcel$export(module.exports, "TableResizer", () => $169e868a2cdb407f$export$65233f8d64070eeb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $koVbs = parcelRequire("koVbs");

var $dEzej = parcelRequire("dEzej");
var $gkwXh = parcelRequire("gkwXh");

var $gE8f9 = parcelRequire("gE8f9");

var $cE509 = parcelRequire("cE509");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $e9qoo = parcelRequire("e9qoo");

var $2V0EL = parcelRequire("2V0EL");

var $1KzE6 = parcelRequire("1KzE6");

var $hQy06 = parcelRequire("hQy06");

var $9LY0t = parcelRequire("9LY0t");

var $2RHbH = parcelRequire("2RHbH");

var $iHYdz = parcelRequire("iHYdz");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $6lSoW = parcelRequire("6lSoW");

var $66MHx = parcelRequire("66MHx");

var $aajRL = parcelRequire("aajRL");

var $iQMCj = parcelRequire("iQMCj");

var $9QiRG = parcelRequire("9QiRG");

var $fFJjk = parcelRequire("fFJjk");

var $7rFMc = parcelRequire("7rFMc");

var $fkJZJ = parcelRequire("fkJZJ");

var $hxf42 = parcelRequire("hxf42");

var $5EJxI = parcelRequire("5EJxI");

var $7Wznx = parcelRequire("7Wznx");

var $1v4Xe = parcelRequire("1v4Xe");

var $cASmu = parcelRequire("cASmu");
const $169e868a2cdb407f$var$RESIZE_STEP_VALUE = 10;
const $169e868a2cdb407f$var$handles = {
    right: true
};
const $169e868a2cdb407f$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $169e868a2cdb407f$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = tableRef?.clientHeight ?? 0;
    /*
     - One row table height (minimum possible table height) ~ 45px
     - Two row table height ~ 90px
     - Three row table height ~ 134px
      In the if below we need to use:
     - > 46 because the height of the table can be a float number like 45.44.
     - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $169e868a2cdb407f$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $iQMCj.getColgroupChildrenLength)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $9QiRG.COLUMN_MIN_WIDTH);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $169e868a2cdb407f$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $1v4Xe.TABLE_GUIDELINE_VISIBLE_ADJUSTMENT);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $5EJxI.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET) + 1;
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * (0, $iHYdz.akEditorGutterPaddingDynamic)() + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $169e868a2cdb407f$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const widthToWidest = (0, $cASmu.useInternalTablePluginStateSelector)(pluginInjectionApi, 'widthToWidest');
    return {
        widthToWidest: widthToWidest
    };
}, (pluginInjectionApi)=>{
    const { tableState: tableState } = (0, $awTmI.useSharedPluginState)(pluginInjectionApi, [
        'table'
    ]);
    const tableStateInternal = tableState;
    return {
        widthToWidest: tableStateInternal.widthToWidest
    };
});
const $169e868a2cdb407f$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled: isTableWithFixedColumnWidthsOptionEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, disabled: disabled })=>{
    const currentGap = (0, $5uXOq.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $5uXOq.useRef)(false);
    const areResizeMetaKeysPressed = (0, $5uXOq.useRef)(false);
    const resizerRef = (0, $5uXOq.useRef)(null);
    const interactionState = (0, $9LY0t.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const { widthToWidest: widthToWidest } = $169e868a2cdb407f$var$useSharedState(pluginInjectionApi);
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const currentSelection = editorView.state?.selection;
    const tableFromSelection = (0, $5uXOq.useMemo)(()=>{
        return (0, $28MvW.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection?.pos;
    const isTableSelected = (0, $5uXOq.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        if (interactionState === 'hasNotHadInteraction' && (0, $VSDnB.fg)('platform_editor_hide_expand_selection_states')) return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $1KzE6.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        interactionState,
        getPos
    ]);
    const resizerMinWidth = $169e868a2cdb407f$var$getResizerMinWidth(node);
    const handleSize = $169e868a2cdb407f$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $hxf42.useMeasureFramerate)();
    const excludeGuidelineConfig = (0, $5uXOq.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && isFullWidthModeEnabled)
        }), [
        isFullWidthModeEnabled,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $5uXOq.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $169e868a2cdb407f$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $5EJxI.defaultGuidelinesForPreserveTable)((0, $5EJxI.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * (0, $iHYdz.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $5EJxI.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $cE509.getGuidelinesWithHighlights)(gap, (0, $1v4Xe.TABLE_SNAP_GAP), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $5uXOq.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $7Wznx.defaultTablePreserveSnappingWidths)((0, $7Wznx.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * (0, $iHYdz.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $7Wznx.defaultSnappingWidths)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $5uXOq.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $fkJZJ.shouldChangeAlignmentToCenterResized)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $6lSoW.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi?.analytics?.actions)((0, $fkJZJ.ALIGN_CENTER), (0, $fkJZJ.ALIGN_START), tableNodeWithPos, (0, $gkwXh.INPUT_METHOD).AUTO, (0, $dEzej.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi?.analytics?.actions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $7rFMc.pluginKey), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $5uXOq.useCallback)(()=>{
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $7rFMc.pluginKey), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        dispatch(tr);
        const visibleGuidelines = $169e868a2cdb407f$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $5EJxI.defaultGuidelinesForPreserveTable)((0, $5EJxI.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * (0, $iHYdz.akEditorGutterPaddingDynamic)() : containerWidth, excludeGuidelineConfig) : (0, $5EJxI.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        displayGuideline,
        onResizeStart,
        isFullWidthModeEnabled
    ]);
    const handleResize = (0, $5uXOq.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (originalState, delta)=>{
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch (e) {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * (0, $iHYdz.akEditorGutterPaddingDynamic)() : containerWidth;
        const closestSnap = !isCommentEditor && (0, $7Wznx.findClosestSnap)(newWidth, isTableScalingEnabled ? (0, $7Wznx.defaultTablePreserveSnappingWidths)((0, $7Wznx.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $7Wznx.defaultSnappingWidths), isTableScalingEnabled ? (0, $5EJxI.defaultGuidelinesForPreserveTable)((0, $5EJxI.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $5EJxI.defaultGuidelines), (0, $1v4Xe.TABLE_HIGHLIGHT_GAP), (0, $1v4Xe.TABLE_HIGHLIGHT_TOLERANCE));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const fullWidthGuideline = (0, $5EJxI.defaultGuidelinesForPreserveTable)((0, $5EJxI.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = closestSnap && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = isCommentEditor ? Math.floor(containerWidth - (0, $9QiRG.TABLE_OFFSET_IN_COMMENT_EDITOR)) : (0, $9QiRG.TABLE_MAX_WIDTH);
        const shouldUpdateWidthToWidest = isCommentEditor ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = isCommentEditor && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $fFJjk.previewScaleTable)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, isTableWithFixedColumnWidthsOptionEnabled, isCommentEditor);
        (0, $2RHbH.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $66MHx.updateWidthToWidest)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isTableScalingEnabled,
        isTableWithFixedColumnWidthsOptionEnabled,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $5uXOq.useMemo)(()=>(0, $7nRxN.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $5uXOq.useCallback)((originalState, delta)=>{
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const tableMaxWidth = isCommentEditor ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $9QiRG.TABLE_MAX_WIDTH);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $7rFMc.pluginKey), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $hxf42.generateResizeFrameRatePayloads)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                attachAnalyticsEvent(payload)?.(tr);
            });
        }
        if (typeof pos === 'number') {
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth,
                layout: node.attrs.layout !== (0, $fkJZJ.ALIGN_START) && node.attrs.layout !== (0, $fkJZJ.ALIGN_CENTER) ? (0, $fkJZJ.ALIGN_CENTER) : node.attrs.layout
            });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $fFJjk.scaleTable)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment editor, because in comment editor
                // newWidth can be underined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                parentWidth: isCommentEditor ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, isCommentEditor)(tr);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const scaledNode = tr.doc.nodeAt(pos);
            attachAnalyticsEvent((0, $hxf42.generateResizedPayload)({
                originalNode: node,
                resizedNode: scaledNode
            }))?.(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2V0EL.messages).tableSizeDecreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        else if (delta.width > 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2V0EL.messages).tableSizeIncreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        return newWidth;
    }, [
        editorView,
        getPos,
        node,
        isCommentEditor,
        widthToWidest,
        endMeasure,
        displayGapCursor,
        displayGuideline,
        updateWidth,
        scheduleResize,
        onResizeStop,
        attachAnalyticsEvent,
        tableRef,
        pluginInjectionApi,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        formatMessage
    ]);
    const handleTableSizeChangeOnKeypress = (0, $5uXOq.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth > maxWidth || newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        maxWidth,
        resizerMinWidth
    ]);
    const handleEscape = (0, $5uXOq.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = (0, $gE8f9.browser).mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $169e868a2cdb407f$var$RESIZE_STEP_VALUE : -$169e868a2cdb407f$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $5uXOq.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const metaKey = (0, $gE8f9.browser).mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView?.dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keydown', handleKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keyup', handleKeyUp);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keydown', handleKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $fkJZJ.normaliseAlignment)(node.attrs.layout) === (0, $fkJZJ.ALIGN_CENTER) ? 2 : 1;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hQy06.default), {
            ref: resizerRef,
            enable: (0, $VSDnB.fg)('platform_editor_live_page_prevent_table_recreation') ? disabled ? {} : $169e868a2cdb407f$var$handles : $169e868a2cdb407f$var$handles,
            width: width,
            handleAlignmentMethod: "sticky",
            handleSize: handleSize,
            handleStyles: $169e868a2cdb407f$var$handleStyles,
            handleResizeStart: handleResizeStart,
            handleResize: scheduleResize,
            handleResizeStop: handleResizeStop,
            resizeRatio: resizeRatio,
            minWidth: resizerMinWidth,
            maxWidth: maxWidth,
            snapGap: (0, $1v4Xe.TABLE_SNAP_GAP),
            snap: guidelineSnaps,
            handlePositioning: "adjacent",
            isHandleVisible: isTableSelected,
            needExtendedResizeZone: !isTableSelected,
            appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
            handleHighlight: "shadow",
            handleTooltipContent: ({ update: update })=>{
                updateTooltip.current = update;
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
                    description: formatMessage((0, $2V0EL.messages).resizeTable),
                    keymap: (0, $e9qoo.focusTableResizer)
                });
            },
            children: children
        })
    });
};

});
parcelRegister("cE509", function(module, exports) {

$parcel$export(module.exports, "getGuidelinesWithHighlights", () => $17cbb82e6e1855ba$export$529f80a31b4cd2ac);
const $17cbb82e6e1855ba$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $17cbb82e6e1855ba$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $17cbb82e6e1855ba$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};

});

parcelRegister("hQy06", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8f66bca4d6b902$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $eHaD2 = parcelRequire("eHaD2");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $3bDjY = parcelRequire("3bDjY");

var $1C4XH = parcelRequire("1C4XH");

var $hVv9L = parcelRequire("hVv9L");
const $ab8f66bca4d6b902$var$resizerLabelStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $ab8f66bca4d6b902$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $ab8f66bca4d6b902$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $ab8f66bca4d6b902$var$ResizerNext = (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    const resizable = (0, $5uXOq.useRef)(null);
    const resizeHandleThumbRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const onResizeStart = (0, $5uXOq.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $5uXOq.useCallback)((_event, _direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        handleResize(originalState, delta);
    }, [
        handleResize
    ]);
    const onResizeStop = (0, $5uXOq.useCallback)((_event, _direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        setIsResizing(false);
        handleResizeStop(originalState, delta);
    }, [
        handleResizeStop
    ]);
    const handles = {
        left: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))(handleClassName ?? (0, $hVv9L.resizerHandleClassName), 'left', handleSize, handleAlignmentMethod),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))(handleClassName ?? (0, $hVv9L.resizerHandleClassName), 'right', handleSize, handleAlignmentMethod)
    };
    const baseHandleStyles = {
        width: handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)",
        zIndex: (0, $hVv9L.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const offset = handlePositioning === 'adjacent' ? `calc(${baseHandleStyles.width} * -1)` : `calc(${baseHandleStyles.width} * -0.5)`;
    const nextHandleStyles = $ab8f66bca4d6b902$var$SUPPORTED_HANDLES.reduce((result, position)=>({
            ...result,
            [position]: {
                ...baseHandleStyles,
                [position]: offset,
                ...handleStyles?.[position]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))(className, (0, $hVv9L.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $hVv9L.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $hVv9L.resizerHoverZoneClassName), {
        [(0, $hVv9L.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleComponent = (0, $5uXOq.useMemo)(()=>{
        return $ab8f66bca4d6b902$var$SUPPORTED_HANDLES.reduce((result, position)=>{
            const thumb = /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $hVv9L.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position}-thumb`,
                "aria-label": formatMessage((0, $1C4XH.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result,
                [position]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    thumb,
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $hVv9L.resizerHandleTrackClassName), handleHighlight),
                        "data-testid": `resizer-handle-${position}-track`
                    })
                ]
            });
            if (!!handleTooltipContent) return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    contentEditable: false,
                    style: $ab8f66bca4d6b902$var$inheritedCSS,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: handleTooltipContent,
                        hideTooltipOnClick: true,
                        position: "mouse",
                        mousePosition: "auto-start",
                        testId: `resizer-handle-${position}-tooltip`,
                        children: thumbWithTrack
                    })
                })
            };
            return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    contentEditable: false,
                    style: $ab8f66bca4d6b902$var$inheritedCSS,
                    children: thumbWithTrack
                })
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $5uXOq.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eHaD2.Resizable), {
        ref: resizable,
        size: {
            width: width ?? 'auto',
            // just content itself (no paddings)
            height: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $hVv9L.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: resizerZoneClassName,
                ref: (ref)=>childrenDOMRef && childrenDOMRef(ref),
                children: children
            }),
            labelComponent && (0, $gmhCD.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $ab8f66bca4d6b902$var$resizerLabelStyles,
                children: labelComponent
            })
        ]
    });
};
var $ab8f66bca4d6b902$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($ab8f66bca4d6b902$var$ResizerNext);

});
parcelRegister("eHaD2", function(module, exports) {
"use strict";
var $ab2d5372f352af9c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ab2d5372f352af9c$var$__assign = module.exports && module.exports.__assign || function() {
    $ab2d5372f352af9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab2d5372f352af9c$var$__assign.apply(this, arguments);
};
var $ab2d5372f352af9c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $ab2d5372f352af9c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ab2d5372f352af9c$var$React = $ab2d5372f352af9c$var$__importStar((parcelRequire("5uXOq")));

var $f6P3s = parcelRequire("f6P3s");

var $ab2d5372f352af9c$var$fast_memoize_1 = $ab2d5372f352af9c$var$__importDefault((parcelRequire("8mQ2m")));
var $ab2d5372f352af9c$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $ab2d5372f352af9c$var$clamp = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $ab2d5372f352af9c$var$snap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $ab2d5372f352af9c$var$hasDirection = $ab2d5372f352af9c$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $ab2d5372f352af9c$var$findClosestSnap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $ab2d5372f352af9c$var$endsWith = $ab2d5372f352af9c$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $ab2d5372f352af9c$var$getStringSize = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'px')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, '%')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vh')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vw')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vmax')) return n;
    if ($ab2d5372f352af9c$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $ab2d5372f352af9c$var$calculateNewMax = $ab2d5372f352af9c$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $ab2d5372f352af9c$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $ab2d5372f352af9c$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $ab2d5372f352af9c$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $ab2d5372f352af9c$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $ab2d5372f352af9c$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $ab2d5372f352af9c$var$baseClassName = '__resizable_base__';
var $ab2d5372f352af9c$var$Resizable = /** @class */ function(_super) {
    $ab2d5372f352af9c$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $ab2d5372f352af9c$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($ab2d5372f352af9c$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $ab2d5372f352af9c$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($ab2d5372f352af9c$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $ab2d5372f352af9c$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($ab2d5372f352af9c$var$baseClassName);
        else element.className += $ab2d5372f352af9c$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($ab2d5372f352af9c$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($ab2d5372f352af9c$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($ab2d5372f352af9c$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($ab2d5372f352af9c$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $ab2d5372f352af9c$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $ab2d5372f352af9c$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $ab2d5372f352af9c$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $ab2d5372f352af9c$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $ab2d5372f352af9c$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $ab2d5372f352af9c$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $ab2d5372f352af9c$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $ab2d5372f352af9c$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $ab2d5372f352af9c$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($ab2d5372f352af9c$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($ab2d5372f352af9c$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($ab2d5372f352af9c$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($ab2d5372f352af9c$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($ab2d5372f352af9c$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($ab2d5372f352af9c$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $ab2d5372f352af9c$var$React.createElement($f6P3s.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $ab2d5372f352af9c$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($ab2d5372f352af9c$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $ab2d5372f352af9c$var$React.createElement("div", $ab2d5372f352af9c$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $ab2d5372f352af9c$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $ab2d5372f352af9c$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($ab2d5372f352af9c$var$React.PureComponent);
module.exports.Resizable = $ab2d5372f352af9c$var$Resizable;

});
parcelRegister("f6P3s", function(module, exports) {
"use strict";
var $afff04f5d63d71a2$var$__assign = module.exports && module.exports.__assign || function() {
    $afff04f5d63d71a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $afff04f5d63d71a2$var$__assign.apply(this, arguments);
};
var $afff04f5d63d71a2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $afff04f5d63d71a2$var$React = $afff04f5d63d71a2$var$__importStar((parcelRequire("5uXOq")));
var $afff04f5d63d71a2$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $afff04f5d63d71a2$var$Resizer(props) {
    return $afff04f5d63d71a2$var$React.createElement("div", {
        className: props.className || '',
        style: $afff04f5d63d71a2$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $afff04f5d63d71a2$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $afff04f5d63d71a2$var$Resizer;

});

parcelRegister("8mQ2m", function(module, exports) {
//
// Main
//
function $6178be4d98a9a554$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $6178be4d98a9a554$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $6178be4d98a9a554$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $6178be4d98a9a554$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $6178be4d98a9a554$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $6178be4d98a9a554$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $6178be4d98a9a554$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6178be4d98a9a554$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6178be4d98a9a554$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $6178be4d98a9a554$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $6178be4d98a9a554$var$monadic : $6178be4d98a9a554$var$variadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6178be4d98a9a554$var$strategyVariadic(fn, options) {
    var strategy = $6178be4d98a9a554$var$variadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6178be4d98a9a554$var$strategyMonadic(fn, options) {
    var strategy = $6178be4d98a9a554$var$monadic;
    return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $6178be4d98a9a554$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $6178be4d98a9a554$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $6178be4d98a9a554$var$cacheDefault = {
    create: function create() {
        return new $6178be4d98a9a554$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $6178be4d98a9a554$var$memoize;
module.exports.strategies = {
    variadic: $6178be4d98a9a554$var$strategyVariadic,
    monadic: $6178be4d98a9a554$var$strategyMonadic
};

});



parcelRegister("5EJxI", function(module, exports) {

$parcel$export(module.exports, "defaultGuidelines", () => $3a64adb280a3cdd2$export$71ea7e0a71c6d202);
$parcel$export(module.exports, "PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET", () => $3a64adb280a3cdd2$export$d25f7f8989bf9598);
$parcel$export(module.exports, "defaultGuidelinesForPreserveTable", () => $3a64adb280a3cdd2$export$be2db36e9da53e09);

var $5OeUx = parcelRequire("5OeUx");

var $7Wznx = parcelRequire("7Wznx");
const $3a64adb280a3cdd2$export$71ea7e0a71c6d202 = (0, $5OeUx.createFixedGuidelinesFromLengths)([
    0,
    ...(0, $7Wznx.calculateDefaultSnappings)(-1)
]);
const $3a64adb280a3cdd2$export$d25f7f8989bf9598 = -1;
const $3a64adb280a3cdd2$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $7Wznx.calculateDefaultTablePreserveSnappings)(lengthOffset, editorContainerWidth, exclude);
    return (0, $5OeUx.createFixedGuidelinesFromLengths)(lengths, undefined, true);
};

});
parcelRegister("5OeUx", function(module, exports) {

$parcel$export(module.exports, "createFixedGuidelinesFromLengths", () => $7e4445b4deb2a997$export$24448ad8894709b4);
const $7e4445b4deb2a997$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};
const $7e4445b4deb2a997$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return $7e4445b4deb2a997$export$192a1a4af16beb38(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};

});

parcelRegister("7Wznx", function(module, exports) {

$parcel$export(module.exports, "calculateDefaultSnappings", () => $654cbbb0474f6cde$export$c4ddb11be0806484);
$parcel$export(module.exports, "calculateDefaultTablePreserveSnappings", () => $654cbbb0474f6cde$export$7542cd96381664c2);
$parcel$export(module.exports, "defaultSnappingWidths", () => $654cbbb0474f6cde$export$c5e672719c546336);
$parcel$export(module.exports, "PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET", () => $654cbbb0474f6cde$export$b2f61428a1609695);
$parcel$export(module.exports, "defaultTablePreserveSnappingWidths", () => $654cbbb0474f6cde$export$461c50a158de0369);
$parcel$export(module.exports, "findClosestSnap", () => $654cbbb0474f6cde$export$5ea7b9558ea477a);

var $4W0cm = parcelRequire("4W0cm");

var $iHYdz = parcelRequire("iHYdz");
const $654cbbb0474f6cde$var$numberOfLanesInDefaultLayoutWidth = 12;
const $654cbbb0474f6cde$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $654cbbb0474f6cde$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$654cbbb0474f6cde$var$calculateSubSnappingWidths($654cbbb0474f6cde$var$numberOfLanesInDefaultLayoutWidth, (0, $iHYdz.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $iHYdz.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $iHYdz.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $iHYdz.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $654cbbb0474f6cde$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWith = (0, $iHYdz.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const dynamicFullWidthLine = editorContainerWith - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 >= (0, $iHYdz.akEditorFullWidthLayoutWidth) ? (0, $iHYdz.akEditorFullWidthLayoutWidth) : editorContainerWith - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    if (!exclude.breakoutPoints) guides.unshift((0, $iHYdz.akEditorDefaultLayoutWidth) + lengthOffset, (0, $iHYdz.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$654cbbb0474f6cde$var$calculateSubSnappingWidths($654cbbb0474f6cde$var$numberOfLanesInDefaultLayoutWidth, (0, $iHYdz.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $654cbbb0474f6cde$export$c5e672719c546336 = $654cbbb0474f6cde$export$c4ddb11be0806484();
const $654cbbb0474f6cde$export$b2f61428a1609695 = 0;
const $654cbbb0474f6cde$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    return editorContainerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 > (0, $iHYdz.akEditorFullWidthLayoutWidth) ? $654cbbb0474f6cde$export$c4ddb11be0806484() : $654cbbb0474f6cde$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $654cbbb0474f6cde$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $4W0cm.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};

});
parcelRegister("4W0cm", function(module, exports) {

$parcel$export(module.exports, "isVerticalPosition", () => $3f27aad0c77d4373$export$75d81fc396e386db);
$parcel$export(module.exports, "getGuidelineTypeFromKey", () => $3f27aad0c77d4373$export$3fa50479f031580);
$parcel$export(module.exports, "getContainerWidthOrFullEditorWidth", () => $3f27aad0c77d4373$export$d52a13210f6817c5);
$parcel$export(module.exports, "getMediaSingleDimensions", () => $3f27aad0c77d4373$export$c7bf42817f6e4244);

var $iHYdz = parcelRequire("iHYdz");

var $8n44w = parcelRequire("8n44w");
const $3f27aad0c77d4373$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $3f27aad0c77d4373$export$e331ccfa6f694c99 = (range)=>!!(typeof range === 'object' && range && 'start' in range && 'end' in range);
const $3f27aad0c77d4373$export$75d81fc396e386db = (pos)=>$3f27aad0c77d4373$export$7e4aa119212bc614(pos.x);
const $3f27aad0c77d4373$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};
const $3f27aad0c77d4373$export$d52a13210f6817c5 = (containerWidth)=>Math.min(containerWidth - (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2, (0, $iHYdz.akEditorFullWidthLayoutWidth)) / 2;
const $3f27aad0c77d4373$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $iHYdz.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = mediaNode?.attrs || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $8n44w.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $8n44w.roundToNearest)(pixelWidth),
        height: (0, $8n44w.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};

});
parcelRegister("8n44w", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $c45fbf05bdb029ba$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $c45fbf05bdb029ba$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $c45fbf05bdb029ba$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $c45fbf05bdb029ba$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $c45fbf05bdb029ba$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $c45fbf05bdb029ba$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $c45fbf05bdb029ba$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $c45fbf05bdb029ba$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $c45fbf05bdb029ba$export$22e4c8c04f58169d);

var $gZGBX = parcelRequire("gZGBX");

var $iHYdz = parcelRequire("iHYdz");

var $cROsB = parcelRequire("cROsB");

var $intz5 = parcelRequire("intz5");
function $c45fbf05bdb029ba$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $c45fbf05bdb029ba$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $c45fbf05bdb029ba$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $c45fbf05bdb029ba$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $intz5.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $c45fbf05bdb029ba$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $c45fbf05bdb029ba$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $iHYdz.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $c45fbf05bdb029ba$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $iHYdz.akEditorGutterPaddingDynamic)() * 2 : (0, $iHYdz.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $iHYdz.akEditorFullWidthLayoutWidth));
};
const $c45fbf05bdb029ba$export$4ab195f543459515 = (origWidth = (0, $intz5.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $iHYdz.akEditorDefaultLayoutWidth), minWidth = (0, $intz5.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $c45fbf05bdb029ba$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $c45fbf05bdb029ba$export$f72673597dacfcfa = (value, interval = (0, $intz5.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $c45fbf05bdb029ba$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $intz5.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $intz5.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $c45fbf05bdb029ba$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $cROsB.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $cROsB.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $c45fbf05bdb029ba$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $c45fbf05bdb029ba$export$7cc71489edfd26f8($pos, view) : $c45fbf05bdb029ba$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $c45fbf05bdb029ba$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $cROsB.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $c45fbf05bdb029ba$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $c45fbf05bdb029ba$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $gZGBX.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});






parcelRegister("zgDo7", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $a4cafe7737e76f8a$export$8c072780619cfc83);

var $f3dKD = parcelRequire("f3dKD");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $jecUf = parcelRequire("jecUf");
class $a4cafe7737e76f8a$export$8c072780619cfc83 {
    constructor(wrapper, view){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.view = view;
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', true)) requestAnimationFrame(()=>{
            this.init();
        });
        else this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.editorScrollableElement = // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $f3dKD.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (entry.rootBounds?.height === 0) return;
                if (target.classList.contains((0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        // Multiple bottom sentinels may be found if there are nested tables. We need to make sure we get the last one which will belong to the parent table.
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = bottomSentinels?.item(bottomSentinels.length - 1);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $jecUf.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>{
            if (el !== null && this.intersectionObserver) this.intersectionObserver.observe(el);
        });
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0) || // When editorScrollableElement is the root document or inside modal,
        // so the boundingClientRect.top will never be less than the rootBounds.top,
        // so we need to check if the boundingClientRect.top is less than 20% of the rootBounds.height
        // to determine if the bottom sentinel is above the scroll area
        entry.boundingClientRect.top < (entry.rootBounds?.height || 0) * 0.2 && (0, $VSDnB.fg)('platform_editor_scroll_table_flickering_fix');
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
}

});


parcelRegister("2w6hs", function(module, exports) {

$parcel$export(module.exports, "TableComponentWithSharedState", () => $33833c588f2036f3$export$b6d58ec6836e4dcf);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $28MvW = parcelRequire("28MvW");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $cASmu = parcelRequire("cASmu");

var $4tUYJ = parcelRequire("4tUYJ");
const $33833c588f2036f3$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    // tableState
    const isTableResizing = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isTableResizing');
    const isHeaderColumnEnabled = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isHeaderColumnEnabled');
    const isHeaderRowEnabled = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isHeaderRowEnabled');
    const ordering = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'ordering');
    const isResizing = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isResizing');
    const isInDanger = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isInDanger');
    const hoveredCell = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'hoveredCell');
    const hoveredRows = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'hoveredRows');
    const isTableHovered = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isTableHovered');
    const isWholeTableInDanger = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isWholeTableInDanger');
    // Required so that table controls re-renders
    (0, $cASmu.useInternalTablePluginStateSelector)(api, 'targetCellPosition');
    // mediaState
    const isFullscreen = (0, $9LY0t.useSharedPluginStateSelector)(api, 'media.isFullscreen');
    // selectionState
    const selection = (0, $9LY0t.useSharedPluginStateSelector)(api, 'selection.selection');
    // editorViewModeState
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
    // widthState
    const width = (0, $9LY0t.useSharedPluginStateSelector)(api, 'width.width');
    const lineLength = (0, $9LY0t.useSharedPluginStateSelector)(api, 'width.lineLength');
    // interactionState
    const interaction = (0, $9LY0t.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    return {
        tableState: undefined,
        widthState: undefined,
        isTableResizing: isTableResizing,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        isHeaderRowEnabled: isHeaderRowEnabled,
        ordering: ordering,
        isResizing: isResizing,
        isInDanger: isInDanger,
        hoveredCell: hoveredCell,
        hoveredRows: hoveredRows,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        isFullscreen: isFullscreen,
        selection: selection,
        mode: mode,
        width: width,
        lineLength: lineLength,
        interaction: interaction
    };
}, (api)=>{
    const { widthState: widthState, tableState: tableState, mediaState: mediaState, selectionState: selectionState, editorViewModeState: editorViewModeState, interactionState: interactionState } = (0, $awTmI.useSharedPluginState)(api, [
        'width',
        'table',
        'media',
        'selection',
        'editorViewMode',
        'interaction'
    ]);
    const tableStateInternal = tableState;
    return {
        tableState: tableState,
        widthState: widthState,
        isTableResizing: tableStateInternal?.isTableResizing,
        isHeaderColumnEnabled: tableStateInternal?.isHeaderColumnEnabled,
        isHeaderRowEnabled: tableStateInternal?.isHeaderRowEnabled,
        ordering: tableStateInternal?.ordering,
        isResizing: tableStateInternal?.isResizing,
        isInDanger: tableStateInternal?.isInDanger,
        hoveredCell: tableStateInternal?.hoveredCell,
        hoveredRows: tableStateInternal?.hoveredRows,
        isTableHovered: tableStateInternal?.isTableHovered,
        isWholeTableInDanger: tableStateInternal?.isWholeTableInDanger,
        isFullscreen: mediaState?.isFullscreen,
        selection: selectionState?.selection,
        mode: editorViewModeState?.mode,
        width: widthState?.width,
        lineLength: widthState?.lineLength,
        interaction: interactionState?.interactionState
    };
});
const $33833c588f2036f3$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing })=>{
    const { tableState: tableState, widthState: widthState, mode: mode, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isFullscreen: isFullscreen, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, isTableResizing: isTableResizing, isWholeTableInDanger: isWholeTableInDanger, lineLength: lineLength, ordering: ordering, selection: selection, width: width, interaction: interaction } = $33833c588f2036f3$var$useSharedState(api);
    const isLivePageViewMode = mode === 'view';
    if ((0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', false) && !tableState) return null;
    /**
	 *  ED-19810
	 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
	 *  directly to confluence since this bug is now in production.
	 */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        currentTablePos = undefined;
    }
    const selectedTable = (0, $28MvW.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tUYJ.default), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: isFullscreen,
        options: options,
        allowControls: allowControls,
        isHeaderRowEnabled: isHeaderRowEnabled ?? false,
        isHeaderColumnEnabled: isHeaderColumnEnabled ?? false,
        isDragAndDropEnabled: options?.isDragAndDropEnabled && !isLivePageViewMode,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        allowTableAlignment: allowTableAlignment,
        allowTableResizing: allowTableResizing,
        tableActive: tableActive && !isLivePageViewMode && (interaction !== 'hasNotHadInteraction' || !(0, $VSDnB.fg)('platform_editor_hide_expand_selection_states')),
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        containerWidth: (0, $gmhCD.editorExperiment)('platform_editor_usesharedpluginstateselector', true) ? {
            width: width ?? 0,
            lineLength: lineLength
        } : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        widthState,
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        selection: selection
    });
};

});


parcelRegister("eAHBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2831e345e518daef$export$2e2bcd8739ae039);

var $9UDEr = parcelRequire("9UDEr");

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $f3Ra7 = parcelRequire("f3Ra7");
const $2831e345e518daef$var$DEFAULT_COL_SPAN = 1;
const $2831e345e518daef$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $2831e345e518daef$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2831e345e518daef$var$cssVariablePattern = /^VAR\(--.*\)$/;
class $2831e345e518daef$export$2e2bcd8739ae039 extends (0, $f3Ra7.default) {
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher), this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                // eslint-disable-next-line compat/compat
                window?.cancelIdleCallback?.(this.delayHandle);
                window?.cancelAnimationFrame?.(this.delayHandle);
            }
        };
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        if ($2831e345e518daef$var$cssVariablePattern.test(node.attrs.background)) this.delayHandle = $2831e345e518daef$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $dEzej.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = (0, $9UDEr.getCellDomAttrs)(this.node);
        const nextAttrs = (0, $9UDEr.getCellDomAttrs)(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $9UDEr.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $2831e345e518daef$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $2831e345e518daef$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
}

});
parcelRegister("f3Ra7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc79d426d320d4e$export$2e2bcd8739ae039);

var $kCV8T = parcelRequire("kCV8T");
class $4bc79d426d320d4e$export$2e2bcd8739ae039 {
    /**
	 * @constructor
	 */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { dom: dom, contentDOM: contentDOM } = (0, $kCV8T.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}

});


parcelRegister("jgRSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f768ab2343ec8eb2$export$2e2bcd8739ae039);

var $lFKmC = parcelRequire("lFKmC");

var $34ck9 = parcelRequire("34ck9");

var $9O539 = parcelRequire("9O539");

var $cK5m0 = parcelRequire("cK5m0");

var $f3dKD = parcelRequire("f3dKD");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gseSq = parcelRequire("gseSq");

var $cPPiz = parcelRequire("cPPiz");

var $iZiKV = parcelRequire("iZiKV");

var $7mmRV = parcelRequire("7mmRV");

var $aj3mz = parcelRequire("aj3mz");

var $evhdb = parcelRequire("evhdb");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $f3Ra7 = parcelRequire("f3Ra7");
// limit scroll event calls
const $f768ab2343ec8eb2$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $f768ab2343ec8eb2$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $f768ab2343ec8eb2$export$2e2bcd8739ae039 extends (0, $f3Ra7.default) {
    constructor(node, view, getPos, eventDispatcher){
        super(node, view, getPos, eventDispatcher), this.colControlsOffset = 0, this.focused = false, this.topPosEditorElement = 0, this.sentinels = {}, this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        }, this.listening = false, this.padding = 0, this.top = 0, /**
	 * Methods
	 */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $f768ab2343ec8eb2$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT), // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $f768ab2343ec8eb2$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.isHeaderRow = (0, $evhdb.supportedHeaderRow)(node);
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $gseSq.getPluginState)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        const pos = this.getPos();
        this.isInNestedTable = false;
        if (pos) this.isInNestedTable = (0, $9O539.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        if (this.isHeaderRow) {
            if ((0, $gmhCD.editorExperiment)('platform_editor_nodevisibility', false)) this.subscribeWhenRowVisible();
            else {
                const { observe: observe } = (0, $cK5m0.nodeVisibilityManager)(view.dom);
                this.nodeVisibilityObserverCleanupFn = observe({
                    element: this.contentDOM,
                    onFirstVisible: ()=>{
                        this.subscribeWhenRowVisible();
                    }
                });
            }
        }
    }
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
	 * Methods: Nodeview Lifecycle
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $evhdb.supportedHeaderRow)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $7mmRV.syncStickyRowToTable)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $aj3mz.getTree)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
		 * so it should be safe to ignore mutations that we cause
		 * by updating styles and classnames on this DOM element
		 *
		 * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
		 * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
		 * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
		 * Update: should not ignore mutations when an node is added, as this interferes with
		 * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
		 *
		 * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
		 * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
		 * selection and insertion.
		 */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $f3dKD.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $aj3mz.getTop)(this.editorScrollableElement);
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $cPPiz.pluginKey).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $cPPiz.pluginKey).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $aj3mz.getTree)(this.dom)?.wrapper.closest(`.${(0, $jecUf.TableCssClassName).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                if ((0, $VSDnB.fg)('platform_editor_table_initial_load_fix')) {
                    const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                    // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                    if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                    observeStickySentinels();
                    else {
                        // concurrent loading issue - here TableRow is too eager trying to
                        // observe sentinels before they are in the DOM, use MutationObserver
                        // to wait for sentinels to be added to the parent Table node DOM
                        // then attach the IntersectionObserver
                        this.tableContainerObserver = new MutationObserver(()=>{
                            // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                            // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                            if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                            if (sentinelsInDom()) {
                                observeStickySentinels();
                                this.tableContainerObserver?.disconnect();
                            }
                        });
                        const mutatingNode = tableContainer;
                        if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                            subtree: true,
                            childList: true
                        });
                    }
                } else if (sentinelsInDom()) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    const tableContainerObserver = new MutationObserver(()=>{
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            tableContainerObserver.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode) tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $aj3mz.getTree)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $1v4Xe.stickyHeaderBorderBottomWidth)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $1v4Xe.tableScrollbarOffset) + (0, $1v4Xe.stickyRowOffsetTop) + newHeight}px`;
                        (0, $7mmRV.updateStickyMargins)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $jecUf.TableCssClassName).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $aj3mz.getTree)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.shouldSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    const isInsideLayout = (0, $5r0mK.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })?.node;
                    if (isInsideLayout) return false;
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
    # Overview
      I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
      The format of the states are;    {top|bottom}:{in|above|below}
      ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport

      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
      above and out of the viewport

      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.

    # States
      top:in / bottom:in - NOT sticky
      top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
      top:in / bottom:below - NOT sticky
      top:above / bottom:in - STICKY
      top:above / bottom:above - NOT sticky
      top:above / bottom:below - STICKY
      top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
      top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
      top:below / bottom:below - NOT sticky

    # Summary
      The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
      is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $aj3mz.getTree)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $1v4Xe.tableControlsSpacing);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $7mmRV.syncStickyRowToTable)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $aj3mz.getTree)(this.dom);
        if (!tree) return;
        (0, $7mmRV.syncStickyRowToTable)(tree.table);
    }
    /**
	 * Manually refire the intersection observers.
	 * Useful when the header may have detached from the table.
	 */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $aj3mz.getTop)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            (0, $7mmRV.syncStickyRowToTable)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $jecUf.TableCssClassName).TABLE_STICKY);
            this.isSticky = true;
            /**
			 * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
			 * detaches from the table. This typically happens during a fast scroll by the user which causes
			 * the intersection observer logic to not fire as expected.
			 */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $7mmRV.updateStickyMargins)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $jecUf.TableCssClassName).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $1v4Xe.tableControlsSpacing);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $aj3mz.getTop)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $iZiKV.updateStickyState)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $iZiKV.updateStickyState)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
}

});
parcelRegister("iZiKV", function(module, exports) {

$parcel$export(module.exports, "updateStickyState", () => $baa1a8820b2659cc$export$dd348cf8bfd51272);

var $3AyQ5 = parcelRequire("3AyQ5");
const $baa1a8820b2659cc$export$dd348cf8bfd51272 = (rowState)=>(0, $3AyQ5.createCommand)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $baa1a8820b2659cc$export$98af81c5504c750e = (pos)=>(0, $3AyQ5.createCommand)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("3AyQ5", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $76bd8764ac788123$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $76bd8764ac788123$export$8d4021544bdece00);

var $aOimD = parcelRequire("aOimD");

var $fCcOI = parcelRequire("fCcOI");
const $76bd8764ac788123$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const { createPluginState: $76bd8764ac788123$export$656c7661095efe2e, createCommand: $76bd8764ac788123$export$8d4021544bdece00 } = (0, $aOimD.pluginFactory)((0, $fCcOI.pluginKey), $76bd8764ac788123$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});

});




parcelRegister("kWnD2", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $e3362ab84950de18$export$ea73b328547c6ad5);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $28MvW = parcelRequire("28MvW");
var $cK1Lv = parcelRequire("cK1Lv");

var $hxf42 = parcelRequire("hxf42");
const $e3362ab84950de18$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $cK1Lv.isTableSelected)(state.selection)) {
        const table = (0, $28MvW.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $gZGBX.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $hxf42.getSelectedTableInfo)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $dEzej.TABLE_ACTION).REPLACED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("lN4uM", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveNestedTables", () => $06aa6d90e5c9f9e3$export$8bc9a7cde47c4f8e);
$parcel$export(module.exports, "transformSliceToFixHardBreakProblemOnCopyFromCell", () => $06aa6d90e5c9f9e3$export$fc3230cbfe498044);
$parcel$export(module.exports, "transformSliceToRemoveOpenTable", () => $06aa6d90e5c9f9e3$export$7932630df6a9b5d9);
$parcel$export(module.exports, "transformSliceToCorrectEmptyTableCells", () => $06aa6d90e5c9f9e3$export$5354b8e5d3b01769);
$parcel$export(module.exports, "isHeaderRowRequired", () => $06aa6d90e5c9f9e3$export$cbabf4b236642ebb);
$parcel$export(module.exports, "transformSliceTableLayoutDefaultToCenter", () => $06aa6d90e5c9f9e3$export$4e98c990eb0fdba6);

var $9O539 = parcelRequire("9O539");

var $7vpuQ = parcelRequire("7vpuQ");

var $kCV8T = parcelRequire("kCV8T");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $gseSq = parcelRequire("gseSq");
const $06aa6d90e5c9f9e3$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
                content.push(...(0, $5r0mK.flatten)(maybeCell, false).map((child)=>child.node));
                return false;
            }
            return true;
        });
        return content;
    }
    return maybeTable;
};
// Flattens nested tables after a given nesting depth
// If this looks familiar, it's a heavily modified version of `mapFragment` which has been
// adjusted to support tracking nesting depth. This wasn't possible by using `mapFragment` directly
const $06aa6d90e5c9f9e3$var$unwrapNestedTables = (content, schema, unwrapNestDepth, currentNestDepth = 0)=>{
    const flattenNested = (node, tableDepth)=>{
        if (node.type === schema.nodes.table) {
            if (tableDepth >= unwrapNestDepth) return $06aa6d90e5c9f9e3$export$c2e425c24c996f14(node);
            return node;
        }
        return node;
    };
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? flattenNested(node, currentNestDepth) : flattenNested(node.copy((0, $kCV8T.Fragment).fromArray($06aa6d90e5c9f9e3$var$unwrapNestedTables(node.content, schema, unwrapNestDepth, node.type === schema.nodes.table ? currentNestDepth + 1 : currentNestDepth))), currentNestDepth);
        if (transformed) {
            if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return children;
};
const $06aa6d90e5c9f9e3$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $06aa6d90e5c9f9e3$export$c2e425c24c996f14(node) : node;
};
const $06aa6d90e5c9f9e3$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $06aa6d90e5c9f9e3$export$c2e425c24c996f14(node) : node;
};
const $06aa6d90e5c9f9e3$export$8bc9a7cde47c4f8e = (slice, schema, selection)=>{
    const isNestingAllowed = (0, $gmhCD.editorExperiment)('nested-tables-in-tables', true);
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let openEnd = slice.openEnd;
    const newFragment = (0, $7vpuQ.flatmap)(slice.content, (node, i, fragment)=>{
        // if pasted content is a node that supports nesting a table
        // such as layoutSection or expand allow 1 level by default
        let allowedTableNesting = 1;
        const isCellSelection = selection instanceof (0, $hFEwm.CellSelection);
        const isPasteInTable = (0, $5r0mK.hasParentNodeOfType)([
            table,
            tableCell,
            tableHeader
        ])(selection);
        const isPasteInNestedTable = (0, $9O539.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1;
        const isPasteFullTableInsideEmptyCellEnabled = (0, $VSDnB.fg)('platform_editor_paste_full_table_inside_empty_cell');
        // Pasted content only contains a table and no other content
        const isCellPaste = isPasteInTable && slice.content.childCount === 1 && slice.content.firstChild?.type === table && (!isPasteFullTableInsideEmptyCellEnabled || slice.openStart !== 0 && slice.openEnd !== 0);
        if (isNestingAllowed) {
            // if nesting is allowed we bump up the default nesting allowance to 2 to support
            // two levels of nesting in nodes that support table nesting already such as layoutSection and expands
            allowedTableNesting = 2;
            // however if pasted content is a table, allow just one level
            if (node.type === schema.nodes.table) {
                allowedTableNesting = 1;
                // if paste is inside a table, allow no further nesting
                if (isPasteInTable) allowedTableNesting = 0;
                // unless we are pasting inside a nested table, then bounce back to 1 level
                // because editor-plugin-paste will lift the table to the parent table (just below it)
                if (isPasteInNestedTable) allowedTableNesting = 1;
                // paste of table cells into a table cell - content is spread across multiple cells
                // by editor-tables so needs to be treated a little differently
                if (isCellPaste || isCellSelection && (0, $VSDnB.fg)('platform_editor_nested_tables_cellselection_paste')) {
                    allowedTableNesting = 1;
                    if (isPasteInNestedTable) allowedTableNesting = 0;
                }
            }
            // Prevent invalid openEnd after pasting tables with a selection that ends inside a nested table cell.
            // If the slice ends with a selection that ends inside a nested table, and we paste inside a table we
            // need to adjust the openEnd because it is no longer correct. If we don't, Prosemirror fires an exception
            // because it iterates to a non-existent depth and the transform will not be applied
            if (slice.openEnd >= 7 && // depth of a nested table cell
            slice.content.childCount > 1 && slice.content.lastChild?.type === table && isPasteInTable) // re-point the slice's openEnd to non-nested table cell depth
            openEnd = 4;
        } else // for layouts and expands, we start with 1 level of nesting as set above
        // if pasted content is a table, don't allow further nesting
        if (node.type === schema.nodes.table) allowedTableNesting = 0;
        if (isCellSelection && !isCellPaste && (0, $VSDnB.fg)('platform_editor_nested_tables_cellselection_paste')) // if pasting into a cell selection, we need to flatten the parent table as well
        return $06aa6d90e5c9f9e3$var$unwrapNestedTables((0, $kCV8T.Fragment).fromArray([
            node
        ]), schema, allowedTableNesting);
        else {
            // after we've worked out what the allowed nesting depth is, unwrap nested tables
            const newChildren = $06aa6d90e5c9f9e3$var$unwrapNestedTables(node.content, schema, allowedTableNesting);
            return node.copy((0, $kCV8T.Fragment).fromArray(newChildren));
        }
    });
    return new (0, $kCV8T.Slice)(newFragment, slice.openStart, openEnd);
};
const $06aa6d90e5c9f9e3$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak?.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $06aa6d90e5c9f9e3$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $06aa6d90e5c9f9e3$var$isNodeSingleCellTable = (node, schema)=>{
    return node.childCount === 1 && node.firstChild?.type === schema.nodes.tableRow && node.firstChild.childCount === 1 && (node.firstChild.firstChild?.type === schema.nodes.tableCell || node.firstChild.firstChild?.type === schema.nodes.tableHeader);
};
const $06aa6d90e5c9f9e3$var$isFragmentSingleCellTable = (fragment, schema)=>{
    return fragment.childCount === 1 && fragment.firstChild !== null && $06aa6d90e5c9f9e3$var$isNodeSingleCellTable(fragment.firstChild, schema);
};
const $06aa6d90e5c9f9e3$var$containsNonTableBlockChildren = (fragment, schema)=>{
    let containsNonTableBlock = false;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    fragment.forEach((node)=>{
        if (node.isBlock && ![
            table,
            tableCell,
            tableHeader
        ].includes(node.type)) containsNonTableBlock = true;
    });
    return containsNonTableBlock;
};
const $06aa6d90e5c9f9e3$export$7932630df6a9b5d9 = (slice, schema)=>{
    // Case 1: A slice of a block selection inside a nested table
    // Prosemirror wraps nested block selections in their respective tables
    // We are using `safeInsert` to paste nested tables, so we do not want to preserve this wrapping
    // slice starts and ends inside a nested table at the same depth
    if (slice.openStart >= 7 && slice.openEnd >= 7) {
        let cleaned = slice;
        let descendedDepth = 0;
        const tableDepthDecrement = 2;
        // if the slice is a single cell table and contains cells with single cell tables, descend into it until we find textblock children
        if ($06aa6d90e5c9f9e3$var$isFragmentSingleCellTable(slice.content, schema)) slice.content.firstChild?.descendants((node)=>{
            if ($06aa6d90e5c9f9e3$var$isNodeSingleCellTable(node, schema)) descendedDepth += tableDepthDecrement;
            else if (node.type === schema.nodes.table) return false;
            else if ($06aa6d90e5c9f9e3$var$containsNonTableBlockChildren(node.content, schema)) {
                descendedDepth += tableDepthDecrement;
                // create a new slice with the content of non-table block children and the depth of the nested tables subtracted
                cleaned = new (0, $kCV8T.Slice)(node.content, slice.openStart - descendedDepth - tableDepthDecrement, slice.openEnd - descendedDepth - tableDepthDecrement);
                return false;
            }
        });
        if (!cleaned.eq(slice)) return cleaned;
    }
    // Case 2: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    slice.content.firstChild.type === schema.nodes.table) {
        // we're removing the table, tableRow and tableCell reducing the open depth by 3
        const depthDecrement = 3;
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (slice.content.firstChild?.content?.firstChild?.content?.firstChild?.type === schema.nodes.table) cleaned = new (0, $kCV8T.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $kCV8T.Slice)((0, $7vpuQ.flatmap)(cleaned.content, $06aa6d90e5c9f9e3$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 3: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && slice.content.firstChild?.type === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $kCV8T.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $06aa6d90e5c9f9e3$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $7vpuQ.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $06aa6d90e5c9f9e3$export$cbabf4b236642ebb(state) {
    const tableState = (0, $gseSq.getPluginState)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $06aa6d90e5c9f9e3$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $7vpuQ.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});


parcelRegister("cun24", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $0c41d724655a908f$export$ae829ec7b2625219);
/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 
var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $etG8M = parcelRequire("etG8M");
const $0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $gZGBX.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $0c41d724655a908f$export$ae829ec7b2625219 = ()=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $etG8M.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $etG8M.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $etG8M.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $etG8M.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>$0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)?.decorations,
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
					 * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
					 * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
					 * The condition here checks to see if the entire text node is about to be swapped inside of an element
					 */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($0c41d724655a908f$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};

});

parcelRegister("9DiKx", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $047701675a58c5a9$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $fCcOI = parcelRequire("fCcOI");

var $3AyQ5 = parcelRequire("3AyQ5");
const $047701675a58c5a9$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $5KWxh.SafePlugin)({
        state: (0, $3AyQ5.createPluginState)(dispatch, initialState),
        key: (0, $fCcOI.pluginKey)
    });
};

});

parcelRegister("cLyxG", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $52093d5f2c5c7ab9$export$ae829ec7b2625219);
/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 
var $7nRxN = parcelRequire("7nRxN");

var $9IGaJ = parcelRequire("9IGaJ");

var $5KWxh = parcelRequire("5KWxh");

var $594Yf = parcelRequire("594Yf");

var $gZGBX = parcelRequire("gZGBX");
const $52093d5f2c5c7ab9$var$pluginKey = new (0, $gZGBX.PluginKey)('tableLocalIdPlugin');
const $52093d5f2c5c7ab9$var$getPluginState = (state)=>state && $52093d5f2c5c7ab9$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $52093d5f2c5c7ab9$export$ae829ec7b2625219 = (dispatch)=>new (0, $5KWxh.SafePlugin)({
        key: $52093d5f2c5c7ab9$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($52093d5f2c5c7ab9$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($52093d5f2c5c7ab9$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
				 * Utilise the update cycle for _one_ scan through an initial doc
				 * to ensure existing tables without IDs get them when this plugin is
				 * enabled.
				 *
				 * This entire block can be skipped if we simply remove the `checkIsAddingTable`
				 * check in appendTransaction, but that comes with 2 cons:
				 *
				 * 1. require a transaction before we actually add the local IDs
				 * 2. ever slightly more unncessary checks
				 *
				 * Finally, this never happens in practice when utilising this in
				 * confluence, as the collab/synchrony initialisation process will
				 * trigger a transaction which adds tables, and thus this plugin will
				 * add/dedupe the necessary IDs. But general usage of the editor
				 * without collab should still solve for IDs.
				 */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $52093d5f2c5c7ab9$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $7nRxN.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $9IGaJ.uuid).generate()
                                });
                                return false;
                            }
                            /**
							 * Otherwise continue traversing, we can encounter tables nested in
							 * expands/bodiedExtensions
							 */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($52093d5f2c5c7ab9$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $594Yf.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $9IGaJ.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });

});

parcelRegister("cjBCM", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $d1aeba8931ea1dcc$export$ae829ec7b2625219);

var $9ci4W = parcelRequire("9ci4W");

var $5KWxh = parcelRequire("5KWxh");

var $jecUf = parcelRequire("jecUf");

var $gseSq = parcelRequire("gseSq");

var $9u865 = parcelRequire("9u865");

var $ktr9r = parcelRequire("ktr9r");

var $gEcXI = parcelRequire("gEcXI");

var $k8KvZ = parcelRequire("k8KvZ");

var $7mmRV = parcelRequire("7mmRV");
function $d1aeba8931ea1dcc$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, isCommentEditor) {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $k8KvZ.pluginKey),
        state: (0, $gEcXI.createPluginState)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $gEcXI.getPluginState)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).RESIZING_PLUGIN, {
                        [(0, $jecUf.TableCssClassName).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $jecUf.TableCssClassName).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $gEcXI.getPluginState)(state).resizeHandlePos || (0, $7mmRV.getResizeCellPos)(view, event);
                    const { dragging: dragging } = (0, $gEcXI.getPluginState)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
						We need to start listening mouse events if column resize started from keyboard.
						This will allow continue resizing via mouse
					*/ const { isKeyboardResize: isKeyboardResize } = (0, $gseSq.getPluginState)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $ktr9r.handleMouseDown)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $9u865.setResizeHandlePos)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("ktr9r", function(module, exports) {

$parcel$export(module.exports, "handleMouseDown", () => $887b8ce4d8bc336a$export$b4a93e0b711d8f7);

var $gkwXh = parcelRequire("gkwXh");
var $dEzej = parcelRequire("dEzej");

var $6gEe5 = parcelRequire("6gEe5");

var $uOUlv = parcelRequire("uOUlv");

var $b1RTQ = parcelRequire("b1RTQ");

var $9iOcS = parcelRequire("9iOcS");

var $66MHx = parcelRequire("66MHx");

var $gseSq = parcelRequire("gseSq");

var $aajRL = parcelRequire("aajRL");

var $7DDbz = parcelRequire("7DDbz");

var $evhdb = parcelRequire("evhdb");

var $9bHWx = parcelRequire("9bHWx");

var $9u865 = parcelRequire("9u865");

var $gEcXI = parcelRequire("gEcXI");

var $9QiRG = parcelRequire("9QiRG");

var $7mmRV = parcelRequire("7mmRV");

var $118VY = parcelRequire("118VY");

var $eC4bz = parcelRequire("eC4bz");

var $fISuL = parcelRequire("fISuL");
const $887b8ce4d8bc336a$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)=>{
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $118VY.pointsAtCell)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $gseSq.getPluginState)(state);
    event.preventDefault();
    const tr = view.state.tr;
    tr.setMeta((0, $aajRL.META_KEYS).OVERFLOW_TRIGGER, {
        name: (0, $dEzej.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width) maxSize = editorWidth - (0, $9QiRG.TABLE_OFFSET_IN_COMMENT_EDITOR);
    else maxSize = (0, $118VY.getTableMaxWidth)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = (0, $fISuL.getResizeState)({
        minWidth: (0, $6gEe5.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $9u865.evenColumns)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const width = (0, $118VY.currentColWidth)(view, localResizeHandlePos, cell.attrs);
    (0, $9u865.setDragging)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $66MHx.updateResizeHandleDecorations)(nodeViewPortalProviderAPI, undefined, undefined, false)(state, dispatch);
    function finish(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mouseup', finish);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $gEcXI.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $gseSq.getPluginState)(state);
        if (resizeHandlePos === null) return (0, $9u865.stopResizing)()(state, dispatch);
        if (!(0, $118VY.pointsAtCell)(state.doc.resolve(resizeHandlePos))) return;
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9iOcS.stopKeyboardColumnResizing)({})(state, dispatch, view);
            else return (0, $9u865.stopResizing)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            const { startX: startX } = dragging;
            // If the dimensions of the table have changed through a remote modification by another
            // person for example don't persist the new column widths as we couldn't reliably remap them
            // For example, if a table col is deleted
            // There may be a more elegant solution to this, to avoid a jarring experience. This used to
            // be an equality check but that caused issues when a nested table would change (eg. when it
            // dynamically updates its width on resize)
            if (!(0, $evhdb.tablesHaveDifferentNoOfColumns)(originalTable, table)) {
                const map = (0, $uOUlv.TableMap).get(table);
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $b1RTQ.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $9bHWx.getSelectedColumnIndexes)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $118VY.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $118VY.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
                const newResizeState = (0, $eC4bz.resizeColumn)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                tr = (0, $7DDbz.updateColumnWidths)(newResizeState, table, start, api)(tr);
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $dEzej.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $dEzej.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $gkwXh.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9iOcS.stopKeyboardColumnResizing)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $9u865.stopResizing)(tr)(state, dispatch);
        }
    }
    function move(event) {
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $gEcXI.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $gseSq.getPluginState)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $118VY.pointsAtCell)(state.doc.resolve(resizeHandlePos)) || !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $uOUlv.TableMap).get(table);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $118VY.getScalingPercentForTableWithoutWidth)(table, dom) : (0, $118VY.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
        (0, $eC4bz.resizeColumn)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        (0, $7mmRV.updateControls)()(state);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mouseup', finish);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mousemove', move);
    return true;
};

});


parcelRegister("iKKaG", function(module, exports) {

$parcel$export(module.exports, "tableSelectionKeymapPlugin", () => $294a7379d464dc6e$export$21439b5bf6b9c77f);

var $e9qoo = parcelRequire("e9qoo");

var $vWFRY = parcelRequire("vWFRY");

var $jcOiH = parcelRequire("jcOiH");
function $294a7379d464dc6e$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    const list = {};
    const editorSelectionAPI = pluginInjectionApi?.selection;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveRight).common, (0, $jcOiH.arrowRightFromTable)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.moveLeft).common, (0, $jcOiH.arrowLeftFromTable)(editorSelectionAPI)(), list);
    (0, $e9qoo.bindKeymapArrayWithCommand)((0, $e9qoo.selectColumn), (0, $jcOiH.selectColumns)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $e9qoo.bindKeymapArrayWithCommand)((0, $e9qoo.selectRow), (0, $jcOiH.selectRows)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.shiftArrowUp).common, (0, $jcOiH.shiftArrowUpFromTable)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.bindKeymapWithCommand)((0, $e9qoo.selectTable).common, (0, $jcOiH.modASelectTable)(editorSelectionAPI)(), list);
    return (0, $vWFRY.keymap)(list);
}

});
parcelRegister("jcOiH", function(module, exports) {

$parcel$export(module.exports, "arrowLeftFromTable", () => $55e5943cbba833a7$export$2c7e1bbc14ebf0ec);
$parcel$export(module.exports, "arrowRightFromTable", () => $55e5943cbba833a7$export$2e5835b1a25e33b);
$parcel$export(module.exports, "selectColumns", () => $55e5943cbba833a7$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRows", () => $55e5943cbba833a7$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "shiftArrowUpFromTable", () => $55e5943cbba833a7$export$ef446fa0355915f);
$parcel$export(module.exports, "modASelectTable", () => $55e5943cbba833a7$export$1de5b4cd2a72d822);

var $2V0EL = parcelRequire("2V0EL");

var $hPjvp = parcelRequire("hPjvp");
var $k6Y9i = parcelRequire("k6Y9i");
var $6MkyM = parcelRequire("6MkyM");

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $cK1Lv = parcelRequire("cK1Lv");
var $hHsVB = parcelRequire("hHsVB");

var $knLk2 = parcelRequire("knLk2");

var $gseSq = parcelRequire("gseSq");

var $66MHx = parcelRequire("66MHx");
var $55e5943cbba833a7$var$TableSelectionDirection = /*#__PURE__*/ function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
    return TableSelectionDirection;
}($55e5943cbba833a7$var$TableSelectionDirection || {});
const $55e5943cbba833a7$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $hFEwm.CellSelection)) return $55e5943cbba833a7$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $55e5943cbba833a7$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $gZGBX.TextSelection)) return $55e5943cbba833a7$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $55e5943cbba833a7$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $hFEwm.CellSelection)) return $55e5943cbba833a7$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $hPjvp.GapCursorSelection)) return $55e5943cbba833a7$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $gZGBX.TextSelection)) return $55e5943cbba833a7$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $55e5943cbba833a7$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $cK1Lv.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionState?.selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $55e5943cbba833a7$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $55e5943cbba833a7$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $55e5943cbba833a7$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $6MkyM.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $55e5943cbba833a7$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $cK1Lv.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $55e5943cbba833a7$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $55e5943cbba833a7$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $55e5943cbba833a7$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $28MvW.findTable)(selection);
            const rect = (0, $hHsVB.selectedRect)(state);
            if (table && (0, $cK1Lv.isRowSelected)(rect.top)(selection)) return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $66MHx.selectColumn)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $uOUlv.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $55e5943cbba833a7$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $28MvW.findTable)(selection);
            const rect = (0, $hHsVB.selectedRect)(state);
            if (table && (0, $cK1Lv.isColumnSelected)(rect.left)(selection)) return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $66MHx.selectRow)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $uOUlv.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2V0EL.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $55e5943cbba833a7$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $hPjvp.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $hPjvp.Side).LEFT) {
                const table = (0, $28MvW.findTable)(selection);
                if (table && $55e5943cbba833a7$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $55e5943cbba833a7$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $hPjvp.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $hPjvp.Side).RIGHT) {
                const table = (0, $28MvW.findTable)(selection);
                if (table && $55e5943cbba833a7$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $55e5943cbba833a7$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $28MvW.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $gseSq.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($55e5943cbba833a7$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $6MkyM.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $55e5943cbba833a7$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $28MvW.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $gseSq.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($55e5943cbba833a7$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $55e5943cbba833a7$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $uOUlv.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $hFEwm.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $6MkyM.RelativeSelectionPos).End;
            } else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $hFEwm.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $6MkyM.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $hPjvp.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $hPjvp.GapCursorSelection)($firstPosInsideCell, (0, $hPjvp.Side).LEFT) : (0, $gZGBX.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $hPjvp.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $hPjvp.GapCursorSelection)($lastPosInsideCell, (0, $hPjvp.Side).RIGHT) : (0, $gZGBX.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $28MvW.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $hPjvp.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $hPjvp.GapCursorSelection)($beforeTablePos, (0, $hPjvp.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $28MvW.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $hPjvp.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $hPjvp.GapCursorSelection)($afterTablePos, (0, $hPjvp.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $55e5943cbba833a7$var$isSelectionAtStartOfTable = ($pos, selection)=>(0, $k6Y9i.isSelectionAtStartOfNode)($pos, (0, $28MvW.findTable)(selection)?.node);
const $55e5943cbba833a7$var$isSelectionAtEndOfTable = ($pos, selection)=>(0, $k6Y9i.isSelectionAtEndOfNode)($pos, (0, $28MvW.findTable)(selection)?.node);
const $55e5943cbba833a7$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $28MvW.findTable)(selection);
            const selectionRect = (0, $knLk2.getClosestSelectionRect)(state);
            const index = selectionRect?.top;
            if (table && index === 0) return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $55e5943cbba833a7$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $28MvW.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $cK1Lv.isTableSelected)(selection);
            if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $55e5943cbba833a7$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };

});


parcelRegister("59C9o", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $e7d6199c7d7c6658$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $e7d6199c7d7c6658$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
const $e7d6199c7d7c6658$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableSizeSelectorPlugin');
const $e7d6199c7d7c6658$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $e7d6199c7d7c6658$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({
                    isSelectorOpen: false
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($e7d6199c7d7c6658$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return currentPluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...currentPluginState,
                            ...meta
                        };
                        dispatch($e7d6199c7d7c6658$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return currentPluginState;
            }
        }
    });
};

});

parcelRegister("1tZxL", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c497c3622ec95219$export$ae829ec7b2625219);
/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 
var $7nRxN = parcelRequire("7nRxN");

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $iHYdz = parcelRequire("iHYdz");

var $fkJZJ = parcelRequire("fkJZJ");
const $c497c3622ec95219$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('tableWidthInCommentFixPlugin');
const $c497c3622ec95219$var$getPluginState = (state)=>state && $c497c3622ec95219$export$18d4026d1ea86bb1.getState(state);
const $c497c3622ec95219$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $5KWxh.SafePlugin)({
        key: $c497c3622ec95219$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($c497c3622ec95219$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($c497c3622ec95219$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $c497c3622ec95219$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $7nRxN.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $iHYdz.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $fkJZJ.ALIGN_START) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($c497c3622ec95219$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};

});

parcelRegister("eRNgV", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bc06786f1da133b7$export$ae829ec7b2625219);
/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bXrHm = parcelRequire("bXrHm");

var $5KWxh = parcelRequire("5KWxh");

var $9BYlQ = parcelRequire("9BYlQ");

var $etG8M = parcelRequire("etG8M");

var $uOUlv = parcelRequire("uOUlv");

var $VSDnB = parcelRequire("VSDnB");

var $5tw8K = parcelRequire("5tw8K");

var $gseSq = parcelRequire("gseSq");


var $bYDiC = parcelRequire("bYDiC");

var $elH58 = parcelRequire("elH58");
const $bc06786f1da133b7$export$ae829ec7b2625219 = (api, nodeViewPortalProviderAPI)=>{
    return new (0, $5KWxh.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $etG8M.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                // TODO: ED-26961 - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = api.editorViewMode?.sharedState.currentState() || {};
                if (mode !== 'view') {
                    const sortingDecorations = pluginState?.decorations?.find(undefined, undefined, (s)=>s?.type === 'sorting-decoration');
                    return (0, $VSDnB.fg)('platform_editor_sort_decoration_fix_on_live_page') ? {
                        ...pluginState,
                        decorations: pluginState?.decorations?.remove(sortingDecorations)
                    } : pluginState;
                }
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                const removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta?.[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
				 * Create decorations for the sorting icons
				 */ const decs = [];
                const sortingDecorations = pluginState.decorations.find(undefined, undefined, (spec)=>spec.tableId === tableId && spec.type === 'sorting-decoration');
                // TODO: ED-26961 - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta || isTableInState && !sortingDecorations.length && (0, $VSDnB.fg)('platform_editor_sort_decoration_fix_on_live_page')) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $uOUlv.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                            decs.push((0, $etG8M.Decoration).widget(cell + pos + 2, ()=>{
                                const element = document.createElement('div');
                                element.setAttribute((0, $f32dbb5556fcfa26$export$665a01df2c44393a), `${index}`);
                                element.classList.add((0, $f32dbb5556fcfa26$export$b61cb5d3425147f));
                                if (hasMergedCells) element.classList.add((0, $f32dbb5556fcfa26$export$fb5c0ba8f0806db1));
                                let sortOrdered;
                                if (index === sort[tableId]?.index) sortOrdered = sort[tableId]?.direction;
                                else sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $gseSq.getPluginState)(oldState);
                                nodeViewPortalProviderAPI.render(()=>(0, $5uXOq.createElement)((0, $8RXs9.Provider), {
                                        value: getIntl()
                                    }, (0, $5uXOq.createElement)((0, $5tw8K.SortingIconWrapper), {
                                        isSortingAllowed: !hasMergedCells,
                                        sortOrdered: sortOrdered,
                                        onClick: ()=>{},
                                        onKeyDown: ()=>{},
                                        api: api
                                    })), element, decorationRenderKey);
                                return element;
                            }, {
                                destroy: (node)=>{
                                    nodeViewPortalProviderAPI.remove(decorationRenderKey);
                                },
                                type: 'sorting-decoration',
                                tableId: tableId
                            }));
                        });
                    });
                    decorations = (0, $etG8M.DecorationSet).create(tr.doc, decs);
                }
                /**
				 * Map the decorations to the new document if there are changes
				 */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $bYDiC.tableViewModeSortPluginKey,
        appendTransaction: (trs, oldState, newState)=>{
            // return newState.tr;
            const { mode: mode } = api?.editorViewMode?.sharedState.currentState() || {};
            if (mode !== 'view') return newState.tr;
            let allTables = (0, $bYDiC.tableViewModeSortPluginKey).getState(newState)?.allTables || [];
            /**
			 * If incoming changes have affected a table node, remove the sorting. This prevents the
			 * table from breaking if changes like merged cells are incoming.
			 */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $bYDiC.tableViewModeSortPluginKey).getState(oldState);
                const newPluginState = (0, $bYDiC.tableViewModeSortPluginKey).getState(newState);
                for (const table of allTables){
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = oldPluginState?.sort?.[tableId] || {};
                    if (isChangesIncoming) {
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = maybeTableNode?.attrs?.localId !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $elH58.getTableElements)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
					 * Sort the table if the sort order has changed
					 */ const { order: newOrder, direction: newDirection, index: newIndex } = newPluginState?.sort?.[tableId] || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $9BYlQ.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $elH58.getTableElements)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody?.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO: ED-26961 - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        const pluginState = (0, $bYDiC.tableViewModeSortPluginKey).getState(view.state)?.sort || {};
                        (0, $elH58.toggleSort)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    const pluginState = (0, $bYDiC.tableViewModeSortPluginKey).getState(view.state)?.sort || {};
                    (0, $elH58.toggleSort)(view, event, pluginState);
                }
            },
            decorations (state) {
                const decs = (0, $bYDiC.tableViewModeSortPluginKey).getState(state)?.decorations || (0, $etG8M.DecorationSet).empty;
                return decs;
            }
        }
    });
};

});
parcelRegister("5tw8K", function(module, exports) {

$parcel$export(module.exports, "SortingIconWrapper", () => $33ed3e54e05049d7$export$25fb1502cf13990c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $hrpWq = parcelRequire("hrpWq");

var $9LY0t = parcelRequire("9LY0t");
const $33ed3e54e05049d7$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
    return {
        mode: mode
    };
}, (api)=>{
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(api, [
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode
    };
});
const $33ed3e54e05049d7$export$25fb1502cf13990c = (props)=>{
    const { mode: mode } = $33ed3e54e05049d7$var$useSharedState(props.api);
    if (mode === 'edit') return null;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrpWq.default), {
        ...props
    });
};

});

parcelRegister("bYDiC", function(module, exports) {

$parcel$export(module.exports, "tableViewModeSortPluginKey", () => $43f64b2619cadb6a$export$994e077cfffa9ab4);

var $gZGBX = parcelRequire("gZGBX");
const $43f64b2619cadb6a$export$994e077cfffa9ab4 = new (0, $gZGBX.PluginKey)('tableViewModeSortPlugin');

});

parcelRegister("elH58", function(module, exports) {

$parcel$export(module.exports, "toggleSort", () => $68bef1bcb01a85a2$export$e9466f5bf01e21a7);
$parcel$export(module.exports, "getTableElements", () => $68bef1bcb01a85a2$export$8bb6f5de29aeee1e);

var $9BYlQ = parcelRequire("9BYlQ");

var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $VSDnB = parcelRequire("VSDnB");

const $68bef1bcb01a85a2$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const tbody = (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? tableElement.querySelector(`:scope > tbody`) : tableElement.querySelector('tbody');
    const rows = (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? tableElement.querySelectorAll(`:scope > tbody > tr`) : tableElement.querySelectorAll('tr');
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody?.appendChild(rows[item.index + 1]);
    });
};
const $68bef1bcb01a85a2$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        // TODO: ED-26961 - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $68bef1bcb01a85a2$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $f32dbb5556fcfa26$export$b61cb5d3425147f)}`);
    if (widget?.classList.contains((0, $f32dbb5556fcfa26$export$fb5c0ba8f0806db1)) || !widget) return;
    const dataSortIndex = target?.closest('.ProseMirror-widget')?.getAttribute((0, $f32dbb5556fcfa26$export$665a01df2c44393a));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode?.attrs.localId;
    if (!tableId || !tableNode || tableNode?.type?.name !== 'table') return;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, direction: direction, order: oldOrder } = pluginState?.[tableId] || {};
    // Unsort if there was already a sort
    if (direction !== (0, $9BYlQ.SortOrder).NO_ORDER && oldOrder !== undefined) $68bef1bcb01a85a2$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            direction = (0, $9BYlQ.SortOrder).ASC;
            break;
        case (0, $9BYlQ.SortOrder).ASC:
            direction = (0, $9BYlQ.SortOrder).DESC;
            break;
        case (0, $9BYlQ.SortOrder).DESC:
            direction = (0, $9BYlQ.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $9BYlQ.SortOrder).ASC; // default direction when a new index is clicked
    const order = $68bef1bcb01a85a2$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $9BYlQ.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $68bef1bcb01a85a2$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? tableElement?.querySelector(':scope > tbody') : tableElement?.querySelector('tbody');
    const rows = (0, $VSDnB.fg)('platform_editor_nested_tables_view_mode_sort') ? tableElement?.querySelectorAll(':scope > tbody > tr') : tableElement?.querySelectorAll('tr');
    return {
        tbody: tbody,
        rows: rows
    };
};

});


parcelRegister("1NFM5", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $4f0d0021c64697a6$export$2dda1e4a1d1f6a81);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $9pOon = parcelRequire("9pOon");

var $gries = parcelRequire("gries");

var $8xI1l = parcelRequire("8xI1l");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $7j6gm = parcelRequire("7j6gm");

var $lx3Ew = parcelRequire("lx3Ew");

var $4oGFf = parcelRequire("4oGFf");

var $fPXwH = parcelRequire("fPXwH");

var $cvR2q = parcelRequire("cvR2q");

var $guFYO = parcelRequire("guFYO");

var $epMWO = parcelRequire("epMWO");

var $cASmu = parcelRequire("cASmu");

var $bWCYR = parcelRequire("bWCYR");

var $eZAi0 = parcelRequire("eZAi0");
const $4f0d0021c64697a6$var$ContentComponentInternal = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const resizingTableLocalId = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'resizingTableLocalId');
    const resizingTableRef = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'resizingTableRef');
    const isTableResizing = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isTableResizing');
    const isResizing = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isResizing');
    const widthToWidest = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'widthToWidest');
    const tableNode = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'tableNode');
    const targetCellPosition = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'targetCellPosition');
    const isContextualMenuOpen = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isContextualMenuOpen');
    const tableRef = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'tableRef');
    const pluginConfig = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'pluginConfig');
    const insertColumnButtonIndex = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'insertColumnButtonIndex');
    const insertRowButtonIndex = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'insertRowButtonIndex');
    const isHeaderColumnEnabled = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isHeaderColumnEnabled');
    const isHeaderRowEnabled = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isHeaderRowEnabled');
    const isDragAndDropEnabled = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isDragAndDropEnabled');
    const tableWrapperTarget = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'tableWrapperTarget');
    const isCellMenuOpenByKeyboard = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isCellMenuOpenByKeyboard');
    const { allowControls: allowControls } = pluginConfig ?? {};
    const stickyHeader = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'stickyHeader');
    const dragMenuDirection = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'dragMenuDirection');
    const dragMenuIndex = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'dragMenuIndex');
    const isDragMenuOpen = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isDragMenuOpen');
    const isSizeSelectorOpen = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'isSizeSelectorOpen');
    const sizeSelectorTargetRef = (0, $cASmu.useInternalTablePluginStateSelector)(api, 'sizeSelectorTargetRef');
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7j6gm.default), {
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorView: editorView,
                tableNode: tableNode,
                mountPoint: popupsMountPoint,
                targetCellPosition: targetCellPosition,
                scrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                isContextualMenuOpen: isContextualMenuOpen,
                stickyHeader: stickyHeader,
                tableWrapper: tableWrapperTarget,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }),
            allowControls && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cvR2q.default), {
                tableNode: tableNode,
                tableRef: tableRef,
                insertColumnButtonIndex: insertColumnButtonIndex,
                insertRowButtonIndex: insertRowButtonIndex,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isDragAndDropEnabled: isDragAndDropEnabled,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isChromelessEditor: options?.isChromelessEditor,
                api: api,
                isCommentEditor: options?.isCommentEditor
            }),
            options?.allowContextualMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lx3Ew.default), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                targetCellPosition: targetCellPosition,
                isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                pluginConfig: pluginConfig,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isCommentEditor: options?.isCommentEditor,
                api: api
            }),
            isDragAndDropEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPXwH.default), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                tableRef: tableRef,
                tableNode: tableNode,
                targetCellPosition: targetCellPosition,
                direction: dragMenuDirection,
                index: dragMenuIndex,
                isOpen: !!isDragMenuOpen && !isResizing,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                editorAnalyticsAPI: editorAnalyticsAPI,
                stickyHeaders: stickyHeader,
                pluginConfig: pluginConfig,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                ariaNotifyPlugin: ariaNotifyPlugin,
                api: api,
                isCommentEditor: options?.isCommentEditor
            }),
            allowControls && !isDragAndDropEnabled && !isResizing && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oGFf.default), {
                editorView: editorView,
                selection: editorView.state.selection,
                tableRef: tableRef,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                stickyHeaders: stickyHeader,
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorAnalyticsAPI: editorAnalyticsAPI,
                api: api
            }),
            (options?.isTableScalingEnabled || options?.tableOptions.allowTableResizing && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $guFYO.FloatingToolbarLabel), {
                target: resizingTableRef,
                content: (0, $gmhCD.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xI1l.ResizerBreakoutModeLabel), {
                    layout: "full-width"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZAi0.FullWidthDisplay), {}),
                alignX: 'center',
                alignY: 'bottom',
                stick: true,
                forcePlacement: true,
                zIndex: (0, $iHYdz.akEditorFloatingPanelZIndex),
                offset: [
                    0,
                    10
                ]
            }),
            isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWCYR.SizeSelector), {
                api: api,
                isOpenedByKeyboard: false,
                popupsMountPoint: popupsMountPoint,
                target: sizeSelectorTargetRef ?? (0, $gries.getDomRefFromSelection)(editorView, (0, $gkwXh.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api?.analytics?.actions),
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            })
        ]
    });
};
const $4f0d0021c64697a6$export$2dda1e4a1d1f6a81 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9pOon.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).TABLES_PLUGIN,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epMWO.GlobalStylesWrapper), {
                featureFlags: api?.featureFlags?.sharedState.currentState(),
                isDragAndDropEnabledOption: options?.dragAndDropEnabled,
                api: api
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($4f0d0021c64697a6$var$ContentComponentInternal, {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                isTableSelectorEnabled: isTableSelectorEnabled,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags
            })
        ]
    });
};

});
parcelRegister("7j6gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $021a8b74b732102e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");

var $9pOon = parcelRequire("9pOon");

var $e9qoo = parcelRequire("e9qoo");

var $2V0EL = parcelRequire("2V0EL");

var $4N9VB = parcelRequire("4N9VB");

var $1jI4k = parcelRequire("1jI4k");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $c8Oei = parcelRequire("c8Oei");

var $4nVrL = parcelRequire("4nVrL");

var $jecUf = parcelRequire("jecUf");

var $iHefn = parcelRequire("iHefn");

var $jhoqq = parcelRequire("jhoqq");
const $021a8b74b732102e$var$BUTTON_OFFSET = 3;
const $021a8b74b732102e$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $4nVrL.toggleContextualMenu)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $5r0mK.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $5uXOq.useEffect)(()=>{
        if (isCellMenuOpenByKeyboard && !isContextualMenuOpen) {
            const { state: state, dispatch: dispatch } = editorView;
            // open the menu when the keyboard shortcut is pressed
            (0, $4nVrL.toggleContextualMenu)()(state, dispatch);
        }
    }, [
        isCellMenuOpenByKeyboard,
        isContextualMenuOpen,
        editorView
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $2V0EL.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jhoqq.tableFloatingCellButtonStyles)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isContextualMenuOpen && (0, $jhoqq.tableFloatingCellButtonSelectedStyles)()
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_BUTTON,
        selected: isContextualMenuOpen,
        title: labelCellOptions,
        keymap: (0, $e9qoo.focusToContextMenuTrigger),
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: "",
            color: "currentColor"
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": isContextualMenuOpen
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHefn.default), {
        offset: $021a8b74b732102e$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isContextualMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        offset: [
            $021a8b74b732102e$var$BUTTON_OFFSET,
            -$021a8b74b732102e$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $iHYdz.akEditorSmallZIndex)
    }, button);
});
const $021a8b74b732102e$var$FloatingContextualButton = (0, $8RXs9.default)($021a8b74b732102e$var$FloatingContextualButtonInner);
function $021a8b74b732102e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9pOon.ErrorBoundary), {
        component: (0, $gkwXh.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($021a8b74b732102e$var$FloatingContextualButton, props));
}

});
parcelRegister("iHefn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3288ef3b96813c6e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $7nsd3 = parcelRequire("7nsd3");

var $iHYdz = parcelRequire("iHYdz");

var $jecUf = parcelRequire("jecUf");

var $cipm3 = parcelRequire("cipm3");
const $3288ef3b96813c6e$var$BUTTON_WIDTH = 20;
const $3288ef3b96813c6e$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $3288ef3b96813c6e$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $3288ef3b96813c6e$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $5uXOq.useRef)(null);
    const observerTargetRef = (0, $5uXOq.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $5uXOq.useRef)(0);
    const leftPosDataRef = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $3288ef3b96813c6e$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $cipm3.insertColumnButtonOffset)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $7nRxN.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = 0;
    const containerLeft = (0, $5uXOq.useMemo)(()=>{
        const container = targetCellRef.closest('[data-editor-container="true"]');
        return container?.getBoundingClientRect().left || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $5uXOq.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $3288ef3b96813c6e$export$ed0fda2c59cbba0f({
            buttonWidth: $3288ef3b96813c6e$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: fixedButtonRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: fixedButtonTop + stickyHeader.padding + offset * 2,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex),
                left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                left,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: "var(--ds-space-250, 20px)",
                // BUTTON_WIDTH
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_BUTTON_FIXED,
            children: children
        })
    }), mountTo);
};
var $3288ef3b96813c6e$export$2e2bcd8739ae039 = $3288ef3b96813c6e$export$c947181980f67d40;

});

parcelRegister("jhoqq", function(module, exports) {

$parcel$export(module.exports, "tableFloatingCellButtonStyles", () => $8150f634e2d8d63a$export$554a9cb1559eb2d5);
$parcel$export(module.exports, "tableFloatingCellButtonSelectedStyles", () => $8150f634e2d8d63a$export$cd6af2ca27c1a823);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");


var $1v4Xe = parcelRequire("1v4Xe");
const $8150f634e2d8d63a$export$554a9cb1559eb2d5 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: `var(--ds-surface, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $1v4Xe.contextualMenuTriggerSize) + 2}px`,
            flexDirection: 'column',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            ...(0, $VSDnB.fg)('platform-visual-refresh-icons') && {
                width: "var(--ds-space-250, 20px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, none)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${`var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`}`,
            borderRadius: '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6))"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
const $8150f634e2d8d63a$export$cd6af2ca27c1a823 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        }
    });

});


parcelRegister("lx3Ew", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d485a142f880bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4N9VB = parcelRequire("4N9VB");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");

var $gseSq = parcelRequire("gseSq");

var $1v4Xe = parcelRequire("1v4Xe");

var $dUDm6 = parcelRequire("dUDm6");

var $ko9Oy = parcelRequire("ko9Oy");
const $93d485a142f880bb$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api })=>{
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $iGxzn.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $5r0mK.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4N9VB.default), {
        alignX: "right",
        alignY: "top",
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $1v4Xe.tablePopupMenuFitHeight),
        fitWidth: isDragAndDropEnabled ? (0, $1v4Xe.contextualMenuDropdownWidthDnD) : (0, $1v4Xe.contextualMenuDropdownWidth),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $iHYdz.akEditorFloatingDialogZIndex) : (0, $iHYdz.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $ko9Oy.tablePopupStyles)(isDragAndDropEnabled)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dUDm6.default), {
        editorView: editorView,
        offset: [
            (0, $1v4Xe.contextualMenuTriggerSize) / 2,
            -(0, $1v4Xe.contextualMenuTriggerSize)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowMergeCells: pluginConfig.allowMergeCells,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api
    })));
};
$93d485a142f880bb$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $93d485a142f880bb$export$2e2bcd8739ae039 = $93d485a142f880bb$var$FloatingContextualMenu;

});
parcelRegister("dUDm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8a28f7268e97e1$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $7kHYO = parcelRequire("7kHYO");

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $2V0EL = parcelRequire("2V0EL");

var $gKjGW = parcelRequire("gKjGW");

var $by76K = parcelRequire("by76K");
var $fHEWI = parcelRequire("fHEWI");
var $qMg2l = parcelRequire("qMg2l");
var $f35CH = parcelRequire("f35CH");

var $2WNBA = parcelRequire("2WNBA");
var $8v0FX = parcelRequire("8v0FX");
var $2rNvX = parcelRequire("2rNvX");

var $eQcNy = parcelRequire("eQcNy");

var $hAs1r = parcelRequire("hAs1r");

var $24JcV = parcelRequire("24JcV");

var $aOnxY = parcelRequire("aOnxY");

var $dmnFy = parcelRequire("dmnFy");

var $8Ygfu = parcelRequire("8Ygfu");

var $kQV39 = parcelRequire("kQV39");

var $c2GXr = parcelRequire("c2GXr");

var $19Rn8 = parcelRequire("19Rn8");

var $jDupz = parcelRequire("jDupz");

var $3GUid = parcelRequire("3GUid");

var $hZBhm = parcelRequire("hZBhm");

var $4jI4w = parcelRequire("4jI4w");

var $d5Zn3 = parcelRequire("d5Zn3");

var $f5BqX = parcelRequire("f5BqX");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gmhCD = parcelRequire("gmhCD");

var $9fJGy = parcelRequire("9fJGy");
var $66MHx = parcelRequire("66MHx");
var $4nVrL = parcelRequire("4nVrL");

var $6lSoW = parcelRequire("6lSoW");

var $gseSq = parcelRequire("gseSq");

var $cPPiz = parcelRequire("cPPiz");

var $fISuL = parcelRequire("fISuL");

var $fUbGn = parcelRequire("fUbGn");

var $9bHWx = parcelRequire("9bHWx");

var $3PWLJ = parcelRequire("3PWLJ");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $6yBNR = parcelRequire("6yBNR");

var $awVU3 = parcelRequire("awVU3");

var $ll6j8 = parcelRequire("ll6j8");

var $GphiL = parcelRequire("GphiL");

var $ko9Oy = parcelRequire("ko9Oy");
const $cd8a28f7268e97e1$var$arrowsList = new Set([
    'ArrowRight',
    'ArrowLeft'
]);
const $cd8a28f7268e97e1$var$elementBeforeIconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
class $cd8a28f7268e97e1$export$f55c8e309b1cad66 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            boundariesElement: typeof document !== 'undefined' ? document.body : undefined
        };
    }
    componentDidMount() {
        // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
        // until user pressed ArrowDown.
        // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
        // so here is triggering componentDidUpdate inside dropdown to set focus on first element
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        if (isCellMenuOpenByKeyboard) this.setState({
            ...this.state,
            isOpenAllowed: isCellMenuOpenByKeyboard
        });
    }
    render() {
        const { isOpen: isOpen, mountPoint: mountPoint, offset: offset, boundariesElement: boundariesElement, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
        const items = isDragAndDropEnabled ? this.createNewContextMenuItems() : this.createOriginalContextMenuItems();
        let isOpenAllowed = false;
        isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            onMouseLeave: this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2rNvX.default), {
            mountTo: mountPoint,
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            arrowKeyNavigationProviderOptions: {
                type: (0, $8v0FX.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: !isCellMenuOpenByKeyboard || this.state.isSubmenuOpen
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: isDragAndDropEnabled ? (0, $1v4Xe.contextualMenuDropdownWidthDnD) : (0, $1v4Xe.contextualMenuDropdownWidth),
            shouldFocusFirstItem: ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            },
            boundariesElement: boundariesElement,
            offset: offset,
            section: isDragAndDropEnabled ? {
                hasSeparator: true
            } : undefined,
            allowEnterDefaultBehavior: this.state.isSubmenuOpen
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        }, this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.handleSubMenuRef = (ref)=>{
            const parent = (0, $eQcNy.closestElement)(// Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            this.props.editorView.dom, '.fabric-editor-popup-scroll-parent');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (rect.left + rect.width > boundariesRect.width) ref.style.left = `-${rect.width}px`;
        }, this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            if (allowBackgroundColor) {
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
                const selectedRowAndColumnFromPalette = (0, $f35CH.getSelectedRowAndColumnFromPalette)((0, $fHEWI.default), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                background, (0, $1v4Xe.colorPalletteColumns));
                const selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                const selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                return {
                    content: isDragAndDropEnabled ? formatMessage((0, $2V0EL.messages).backgroundColor) : formatMessage((0, $2V0EL.messages).cellBackground),
                    value: {
                        name: 'background'
                    },
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                        xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmnFy))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2V0EL.messages).backgroundColor)
                    })) : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        className: (0, $gKjGW.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $ko9Oy.cellColourPreviewStyles)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: isDragAndDropEnabled ? (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL : (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_ICON
                    }), isSubmenuOpen && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $jecUf.TableCssClassName).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
                        type: (0, $8v0FX.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $qMg2l.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        paletteOptions: {
                            palette: (0, $fHEWI.default),
                            paletteColorTooltipMessages: (0, $by76K.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $hAs1r.hexToEditorBackgroundPaletteColor)
                        }
                    })))),
                    'aria-expanded': isSubmenuOpen
                };
            }
        }, // Used in the NewContextMenuItems object
        this.newDistributeColumnsItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.createDistributeColumnsItemInternal({
                elemBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GUid))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).distributeColumns),
                    LEGACY_fallbackIcon: (0, $ll6j8.MergeCellsIcon)
                }))
            });
        }, this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $2V0EL.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $fUbGn.canMergeCells)(state.tr),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                        xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kQV39))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2V0EL.messages).mergeCells),
                        LEGACY_fallbackIcon: (0, $ll6j8.MergeCellsIcon)
                    })) : undefined
                },
                {
                    content: formatMessage((0, $2V0EL.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $aOnxY.splitCell)(state),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                        xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2GXr))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2V0EL.messages).splitCell),
                        LEGACY_fallbackIcon: (0, $GphiL.SplitCellIcon)
                    })) : undefined
                }
            ];
            return [];
        }, this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2V0EL.messages).addColumnRight : (0, $2V0EL.messages).insertColumn);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    css: (0, $24JcV.shortcutStyle)
                }, (0, $e9qoo.tooltip)((0, $e9qoo.addColumnAfter))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19Rn8))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).addColumnRight),
                    LEGACY_fallbackIcon: (0, $6yBNR.AddColRightIcon)
                })) : undefined,
                'aria-label': (0, $e9qoo.tooltip)((0, $e9qoo.addColumnAfter), String(content))
            };
        }, this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2V0EL.messages).addRowBelow : (0, $2V0EL.messages).insertRow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    css: (0, $24JcV.shortcutStyle)
                }, (0, $e9qoo.tooltip)((0, $e9qoo.addRowAfter))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hZBhm))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).addRowBelow),
                    LEGACY_fallbackIcon: (0, $awVU3.AddRowBelowIcon)
                })) : undefined,
                'aria-label': (0, $e9qoo.tooltip)((0, $e9qoo.addRowAfter), String(content))
            };
        }, this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $2V0EL.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    css: (0, $24JcV.shortcutStyle)
                }, (0, $e9qoo.tooltip)((0, $e9qoo.backspace))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ygfu))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    }),
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3)))
                })) : undefined,
                'aria-label': (0, $e9qoo.tooltip)((0, $e9qoo.backspace), String(content))
            };
        }, this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $2V0EL.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jDupz))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).removeColumns, {
                        0: noOfColumns
                    }),
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX)))
                })) : undefined
            };
        }, this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $2V0EL.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                    xcss: $cd8a28f7268e97e1$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jI4w))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2V0EL.messages).removeRows, {
                        0: noOfRows
                    }),
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f5BqX)))
                })) : undefined
            };
        }, this.createDistributeColumnsItemInternal = (partialMenuItem)=>{
            const { selectionRect: selectionRect, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, intl: { formatMessage: formatMessage } } = this.props;
            const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $gseSq.getPluginState)(editorView.state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const newResizeState = (0, $fISuL.getNewResizeStateFromSelectedColumns)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
            const wouldChange = newResizeState?.changed ?? false;
            return {
                content: formatMessage((0, $2V0EL.messages).distributeColumns),
                value: {
                    name: 'distribute_columns'
                },
                isDisabled: !wouldChange,
                ...partialMenuItem
            };
        }, this.createDistributeColumnsItem = ()=>{
            const { editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled, pluginConfig: { allowDistributeColumns: allowDistributeColumns } } = (0, $gseSq.getPluginState)(editorView.state);
            if (allowDistributeColumns && !isDragAndDropEnabled) return this.createDistributeColumnsItemInternal();
            return null;
        }, this.createSortColumnItems = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView, allowColumnSorting: allowColumnSorting } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $gseSq.getPluginState)(editorView.state);
            if (allowColumnSorting && !isDragAndDropEnabled) {
                const hasMergedCellsInTable = (0, $3PWLJ.getMergedCellsPositions)(editorView.state.tr).length > 0;
                const warning = hasMergedCellsInTable ? {
                    tooltipDescription: formatMessage((0, $2V0EL.messages).canNotSortTable),
                    isDisabled: true
                } : {};
                return [
                    {
                        content: formatMessage((0, $2V0EL.messages).sortColumnASC),
                        value: {
                            name: 'sort_column_asc'
                        },
                        ...warning
                    },
                    {
                        content: formatMessage((0, $2V0EL.messages).sortColumnDESC),
                        value: {
                            name: 'sort_column_desc'
                        },
                        ...warning
                    }
                ];
            }
            return null;
        }, this.createOriginalContextMenuItems = ()=>{
            const items = [];
            const sortColumnItems = this.createSortColumnItems();
            const backgroundColorItem = this.createBackgroundColorItem();
            const distributeColumnsItem = this.createDistributeColumnsItem();
            sortColumnItems && items.push(...sortColumnItems);
            backgroundColorItem && items.push(backgroundColorItem);
            items.push(this.createInsertColumnItem());
            items.push(this.createInsertRowItem());
            items.push(this.createDeleteColumnItem());
            items.push(this.createDeleteRowItem());
            items.push(...this.createMergeSplitCellItems());
            distributeColumnsItem && items.push(distributeColumnsItem);
            items.push(this.createClearCellsItem());
            return [
                {
                    items: items
                }
            ];
        }, this.createNewContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            const items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_2')) items[1].items.push(this.newDistributeColumnsItem());
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        }, this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $gseSq.getPluginState)(state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen)) {
                const { tr: tr } = state;
                tr.setMeta((0, $cPPiz.pluginKey), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $6lSoW.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $7kHYO.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $6lSoW.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $7kHYO.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $6lSoW.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $6lSoW.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $fISuL.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $6lSoW.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, this.props.api)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $6lSoW.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $6lSoW.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $6lSoW.deleteColumnsWithAnalytics)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $gseSq.getPluginState)(state);
                    (0, $6lSoW.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen) this.setState({
                        isSubmenuOpen: true
                    });
                    break;
            }
        }, this.toggleOpen = ()=>{
            const { isOpen: isOpen, editorView: { state: state, dispatch: dispatch } } = this.props;
            (0, $4nVrL.toggleContextualMenu)()(state, dispatch);
            if (!isOpen) this.setState({
                isSubmenuOpen: false
            });
        }, this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (payload) {
                const { event: event } = payload;
                if (event && event instanceof KeyboardEvent) {
                    if (!this.state.isSubmenuOpen) {
                        if ($cd8a28f7268e97e1$var$arrowsList.has(event.key)) // preventing default behavior for avoiding cursor jump to next/previous table column
                        // when left/right arrow pressed.
                        event.preventDefault();
                        (0, $4nVrL.toggleContextualMenu)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        (0, $66MHx.setFocusToCellMenu)(false)(state, dispatch);
                        dom.focus();
                    }
                } else {
                    // mouse click outside
                    (0, $4nVrL.toggleContextualMenu)()(state, dispatch);
                    this.setState({
                        isSubmenuOpen: false
                    });
                    if (isCellMenuOpenByKeyboard) (0, $66MHx.setFocusToCellMenu)(false)(state, dispatch);
                }
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (item.value.name === 'background') {
                if (!this.state.isSubmenuOpen) this.setState({
                    isSubmenuOpen: true
                });
            }
            if (item.value.name === 'delete_column') (0, $9fJGy.hoverColumns)((0, $9bHWx.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $9fJGy.hoverRows)((0, $9bHWx.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $3PWLJ.getMergedCellsPositions)(state.tr).length !== 0) (0, $9fJGy.hoverMergedCells)()(state, dispatch);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (item.value.name === 'background') this.closeSubmenu();
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        }, this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        }, this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            (0, $6lSoW.setColorWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            this.toggleOpen();
        };
    }
}
var $cd8a28f7268e97e1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($cd8a28f7268e97e1$export$f55c8e309b1cad66);

});
parcelRegister("by76K", function(module, exports) {

$parcel$export(module.exports, "textPaletteTooltipMessages", () => $7699dbdde6303fdf$export$d8fe76863446580e);
$parcel$export(module.exports, "backgroundPaletteTooltipMessages", () => $7699dbdde6303fdf$export$c671ecebb9c48677);
$parcel$export(module.exports, "chartsColorPaletteTooltipMessages", () => $7699dbdde6303fdf$export$f8b88c9f6c817aff);
$parcel$export(module.exports, "borderPaletteTooltipMessages", () => $7699dbdde6303fdf$export$515e8edd15e08de7);

var $7VHMR = parcelRequire("7VHMR");
const $7699dbdde6303fdf$export$788a656fb7fb7897 = (0, $7VHMR.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#97A0AF': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#00B8D9': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#36B37E': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF5630': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF991F': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#6554C0': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#0747A6': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#008DA6': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#006644': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#BF2600': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#403294': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.default',
        defaultMessage: 'Default',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$var$darkModeTextPaletteOverrides = (0, $7VHMR.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.dark-gray',
        defaultMessage: 'Dark gray',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$export$cca9f3b863b77c82 = {
    ...$7699dbdde6303fdf$export$788a656fb7fb7897,
    ...$7699dbdde6303fdf$var$darkModeTextPaletteOverrides
};
const $7699dbdde6303fdf$export$d8fe76863446580e = {
    light: $7699dbdde6303fdf$export$788a656fb7fb7897,
    dark: $7699dbdde6303fdf$export$cca9f3b863b77c82
};
const $7699dbdde6303fdf$export$12d66ae3e5b38d26 = (0, $7VHMR.defineMessages)({
    '#DEEBFF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#B3D4FF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#4C9AFF': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#E6FCFF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#B3F5FF': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#79E2F2': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#E3FCEF': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#ABF5D1': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#57D9A3': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#FFFAE6': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFF0B3': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FFC400': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#FFEBE6': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FFBDAD': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#FF8F73': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#C0B6F2': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#998DD9': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Name of a color'
    },
    '#F4F5F7': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$var$darkModeBackgroundPaletteOverrides = (0, $7VHMR.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$export$d1327856929fda16 = {
    ...$7699dbdde6303fdf$export$12d66ae3e5b38d26,
    ...$7699dbdde6303fdf$var$darkModeBackgroundPaletteOverrides
};
const $7699dbdde6303fdf$export$c671ecebb9c48677 = {
    light: $7699dbdde6303fdf$export$12d66ae3e5b38d26,
    dark: $7699dbdde6303fdf$export$d1327856929fda16
};
const $7699dbdde6303fdf$export$3db7ab7dd64ad21a = (0, $7VHMR.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'Name of a color'
    },
    '#247FFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Name of a color'
    },
    '#0055CC': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Name of a color'
    },
    '#003884': {
        id: 'fabric.theme.bolder-blue',
        defaultMessage: 'Bolder blue',
        description: 'Name of a color'
    },
    // Teal color
    '#60C6D2': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'Name of a color'
    },
    '#1D9AAA': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Name of a color'
    },
    '#1D7F8C': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Name of a color'
    },
    '#206B74': {
        id: 'fabric.theme.bolder-teal',
        defaultMessage: 'Bolder teal',
        description: 'Name of a color'
    },
    // Green color
    '#6BE1B0': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'Name of a color'
    },
    '#23A971': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Name of a color'
    },
    '#177D52': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Name of a color'
    },
    '#055C3F': {
        id: 'fabric.theme.bolder-green',
        defaultMessage: 'Bolder green',
        description: 'Name of a color'
    },
    // Yellow color
    '#FFDB57': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'Name of a color'
    },
    '#FFBE33': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Name of a color'
    },
    '#FF9D00': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Name of a color'
    },
    '#946104': {
        id: 'fabric.theme.bolder-yellow',
        defaultMessage: 'Bolder yellow',
        description: 'Name of a color'
    },
    // Red color
    '#FF8F73': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'Name of a color'
    },
    '#FC552C': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Name of a color.'
    },
    '#D32D03': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Name of a color'
    },
    '#A32000': {
        id: 'fabric.theme.bolder-red',
        defaultMessage: 'Bolder red',
        description: 'Name of a color'
    },
    // Orange color
    '#FAA53D': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'Name of a color'
    },
    '#D97008': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Name of a color.'
    },
    '#B65C02': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Name of a color.'
    },
    '#974F0C': {
        id: 'fabric.theme.bolder-orange',
        defaultMessage: 'Bolder orange',
        description: 'Name of a color'
    },
    // Magenta color
    '#E774BB': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'Name of a color'
    },
    '#DA62AC': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'Name of a color'
    },
    '#CD519D': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'Name of a color'
    },
    '#943D73': {
        id: 'fabric.theme.bolder-magenta',
        defaultMessage: 'Bolder magenta',
        description: 'Name of a color'
    },
    // Purple color
    '#B5A7FB': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'Name of a color'
    },
    '#8B77EE': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Name of a color'
    },
    '#5A43D0': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Name of a color'
    },
    '#44368B': {
        id: 'fabric.theme.bolder-purple',
        defaultMessage: 'Bolder purple',
        description: 'Name of a color'
    },
    // Gray color
    '#8993A5': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#8590A2': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    },
    '#44546F': {
        id: 'fabric.theme.bolder-gray',
        defaultMessage: 'Bolder gray',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$var$darkChartsColorPaletteTooltipMessages = {
    ...$7699dbdde6303fdf$export$3db7ab7dd64ad21a
};
const $7699dbdde6303fdf$export$f8b88c9f6c817aff = {
    light: $7699dbdde6303fdf$export$3db7ab7dd64ad21a,
    dark: $7699dbdde6303fdf$var$darkChartsColorPaletteTooltipMessages
};
const $7699dbdde6303fdf$var$lightBorderPaletteTooltipMessages = (0, $7VHMR.defineMessages)({
    '#091E4224': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Name of a color'
    },
    '#758195': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Name of a color'
    },
    '#172B4D': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Name of a color'
    }
});
const $7699dbdde6303fdf$var$darkBorderPaletteTooltipMessages = {
    ...$7699dbdde6303fdf$var$lightBorderPaletteTooltipMessages
};
const $7699dbdde6303fdf$export$515e8edd15e08de7 = {
    light: $7699dbdde6303fdf$var$lightBorderPaletteTooltipMessages,
    dark: $7699dbdde6303fdf$var$darkBorderPaletteTooltipMessages
};

});

parcelRegister("qMg2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfcd52576e9d1834$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dBl98 = parcelRequire("dBl98");

var $8RXs9 = parcelRequire("8RXs9");

var $hxoiH = parcelRequire("hxoiH");

var $3dhSB = parcelRequire("3dhSB");

var $7zTX4 = parcelRequire("7zTX4");

var $kZa7S = parcelRequire("kZa7S");

var $f35CH = parcelRequire("f35CH");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $bfcd52576e9d1834$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $f35CH.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $dBl98.default).difference(b, colorValue) - (0, $dBl98.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)";
}
const $bfcd52576e9d1834$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $f35CH.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $hxoiH.default)();
    const useIconToken = !!hexToPaletteColor;
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return (0, $f35CH.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $kZa7S.colorPaletteWrapper),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup"
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $7zTX4.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $7zTX4.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3dhSB.default), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: $bfcd52576e9d1834$var$getCheckMarkColor(value, useIconToken),
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
var $bfcd52576e9d1834$export$2e2bcd8739ae039 = (0, $8RXs9.default)($bfcd52576e9d1834$var$ColorPalette);

});
parcelRegister("3dhSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $381c37391cb156f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eJbwP = parcelRequire("eJbwP");

var $3bDjY = parcelRequire("3bDjY");

var $3hror = parcelRequire("3hror");
const $381c37391cb156f5$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = '#FFFFFF', hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $3hror.buttonWrapperStyle)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $3hror.buttonStyle),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `1px solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
        LEGACY_primaryColor: checkMarkColor,
        label: ""
    }), decorator)));
};
var $381c37391cb156f5$export$2e2bcd8739ae039 = $381c37391cb156f5$var$Color;

});
parcelRegister("3hror", function(module, exports) {

$parcel$export(module.exports, "buttonStyle", () => $7dd0daed5d6b5281$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $7dd0daed5d6b5281$export$7afe8f4b3442c19d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $7dd0daed5d6b5281$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #091E420F)",
    padding: 0,
    borderRadius: '4px',
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $7dd0daed5d6b5281$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $f8Sb3.css)({
    border: '1px solid transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: '6px',
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #091E4224)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});


parcelRegister("kZa7S", function(module, exports) {

$parcel$export(module.exports, "colorPaletteWrapper", () => $724b0f4b319c2bf0$export$506342f5c0767858);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $724b0f4b319c2bf0$export$506342f5c0767858 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});

});

parcelRegister("f35CH", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $9656064befc3d206$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $9656064befc3d206$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $9656064befc3d206$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $9656064befc3d206$export$426cbff16166281c);
const $9656064befc3d206$export$dc37d14f75a32acb = 7;
function $9656064befc3d206$export$d97d52770ca27b6f(palette, cols = $9656064befc3d206$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $9656064befc3d206$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $9656064befc3d206$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $9656064befc3d206$export$dc37d14f75a32acb) {
    const colorsPerRow = $9656064befc3d206$export$d97d52770ca27b6f(palette, cols);
    return $9656064befc3d206$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $9656064befc3d206$export$426cbff16166281c = (variableExpression)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};

});


parcelRegister("kQV39", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::139b33bd4b774507f69a6a4ee945fea8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2e4eaded012d565$var$_react = $f2e4eaded012d565$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f2e4eaded012d565$var$_baseNew = $f2e4eaded012d565$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f2e4eaded012d565$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellMerge".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for merging table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2e4eaded012d565$var$TableCellMergeIcon = (props)=>/*#__PURE__*/ $f2e4eaded012d565$var$_react.default.createElement($f2e4eaded012d565$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zm12 0H9V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M5.19 8 3.47 6.28l1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06zm4.03-.53 2.25-2.25 1.06 1.06L10.81 8l1.72 1.72-1.06 1.06-2.25-2.25a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$f2e4eaded012d565$var$TableCellMergeIcon.displayName = 'TableCellMergeIcon';
var $f2e4eaded012d565$var$_default = module.exports.default = $f2e4eaded012d565$var$TableCellMergeIcon;

});

parcelRegister("c2GXr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fb30934ba7b32c946d34f90a8ade387>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c46fe704586ef94$var$_react = $8c46fe704586ef94$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c46fe704586ef94$var$_baseNew = $8c46fe704586ef94$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8c46fe704586ef94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c46fe704586ef94$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $8c46fe704586ef94$var$_react.default.createElement($8c46fe704586ef94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$8c46fe704586ef94$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $8c46fe704586ef94$var$_default = module.exports.default = $8c46fe704586ef94$var$TableCellSplitIcon;

});

parcelRegister("ll6j8", function(module, exports) {

$parcel$export(module.exports, "MergeCellsIcon", () => $56d36bb17416b4ef$export$819fbb2e5b1e0de);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $56d36bb17416b4ef$export$819fbb2e5b1e0de = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17H6V7L10 7C10.5523 7 11 6.55228 11 6C11 5.44771 10.5523 5 10 5H6C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19H10ZM14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7H18V17L14 17C13.4477 17 13 17.4477 13 18C13 18.5523 13.4477 19 14 19H18C19.1046 19 20 18.1046 20 17V7C20 5.89543 19.1046 5 18 5H14Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M15.75 10L13.75 12L15.75 14",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.25 14L10.25 12L8.25 10",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

});

parcelRegister("GphiL", function(module, exports) {

$parcel$export(module.exports, "SplitCellIcon", () => $ee6762cffb978ad9$export$d1e42b8eff409354);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $ee6762cffb978ad9$export$d1e42b8eff409354 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M19 18L14 18L14 6L19 6",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M5 6L10 6L9.99999 18L5 18",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 10L5 12L7 14",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M17 14L19 12L17 10",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

});

parcelRegister("ko9Oy", function(module, exports) {

$parcel$export(module.exports, "cellColourPreviewStyles", () => $5ea6c6b0648f6c92$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "tablePopupStyles", () => $5ea6c6b0648f6c92$export$62225ca66ffe289c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
const $5ea6c6b0648f6c92$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $5ea6c6b0648f6c92$export$62225ca66ffe289c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-border-radius, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`, ";display:block;position:absolute;top:0;left:", isDragAndDropEnabled ? (0, $1v4Xe.contextualMenuDropdownWidthDnD) : (0, $1v4Xe.contextualMenuDropdownWidth), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $9UDEr.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:20px;height:20px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`, ";}}.", (0, $jecUf.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $9UDEr.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`, ";}}");

});



parcelRegister("4oGFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b6116fd3431a1c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $gkwXh = parcelRequire("gkwXh");

var $2V0EL = parcelRequire("2V0EL");

var $4N9VB = parcelRequire("4N9VB");

var $eQcNy = parcelRequire("eQcNy");

var $iHYdz = parcelRequire("iHYdz");

var $hFEwm = parcelRequire("hFEwm");

var $b1RTQ = parcelRequire("b1RTQ");
var $cK1Lv = parcelRequire("cK1Lv");

var $9fJGy = parcelRequire("9fJGy");

var $6lSoW = parcelRequire("6lSoW");

var $gseSq = parcelRequire("gseSq");

var $lOQGo = parcelRequire("lOQGo");

var $g4A0f = parcelRequire("g4A0f");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $jjujv = parcelRequire("jjujv");

var $gvsBs = parcelRequire("gvsBs");
function $d7b6116fd3431a1c$var$getSelectionType(selection) {
    if (!(0, $cK1Lv.isTableSelected)(selection) && selection instanceof (0, $hFEwm.CellSelection)) {
        if (selection.isRowSelection()) return 'row';
        if (selection.isColSelection()) return 'column';
    }
    return;
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d7b6116fd3431a1c$var$FloatingDeleteButton extends (0, $5uXOq.Component) {
    static{
        this.displayName = 'FloatingDeleteButton';
    }
    constructor(props){
        super(props), this.wrapper = null, this.updateWrapper = ()=>{
            const tableWrapper = (0, $eQcNy.closestElement)(this.props.tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER}`);
            if (tableWrapper) {
                this.wrapper = tableWrapper;
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.wrapper.addEventListener('scroll', this.onWrapperScrolled);
                this.setState({
                    scrollLeft: tableWrapper.scrollLeft
                });
            } else {
                if (this.wrapper) {
                    // unsubscribe if we previously had one and it just went away
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
                    // and reset scroll position
                    this.setState({
                        scrollLeft: 0
                    });
                }
                this.wrapper = null;
            }
        }, this.onWrapperScrolled = (e)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const wrapper = e.target;
            this.setState({
                scrollLeft: wrapper.scrollLeft
            });
        }, this.handleMouseEnter = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            switch(this.state.selectionType){
                case 'row':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $9fJGy.hoverRows)(this.state.indexes, true)(state, dispatch, this.props.editorView);
                case 'column':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $9fJGy.hoverColumns)(this.state.indexes, true)(state, dispatch, this.props.editorView);
            }
            return false;
        }, this.handleMouseLeave = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            return (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        }, /**
	 *
	 *
	 * @private
	 * @memberof FloatingDeleteButton
	 */ this.handleClick = (event)=>{
            event.preventDefault();
            const { editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            let { state: state, dispatch: dispatch } = this.props.editorView;
            const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $gseSq.getPluginState)(state);
            const rect = (0, $b1RTQ.getSelectionRect)(state.selection);
            if (rect) switch(this.state.selectionType){
                case 'column':
                    (0, $6lSoW.deleteColumnsWithAnalytics)(editorAnalyticsAPI, this.props.api)((0, $gkwXh.INPUT_METHOD).BUTTON, rect)(state, dispatch, this.props.editorView);
                    return;
                case 'row':
                    (0, $6lSoW.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).BUTTON, rect, !!isHeaderRowRequired)(state, dispatch);
                    return;
            }
            ({ state: state, dispatch: dispatch } = this.props.editorView);
            (0, $9fJGy.clearHoverSelection)()(state, dispatch);
        };
        this.state = {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: [],
            scrollLeft: 0
        };
    }
    shouldComponentUpdate(_, nextState) {
        return this.state.selectionType !== nextState.selectionType || this.state.left !== nextState.left || this.state.top !== nextState.top || this.state.scrollLeft !== nextState.scrollLeft;
    }
    componentDidMount() {
        this.updateWrapper();
    }
    componentDidUpdate() {
        this.updateWrapper();
    }
    componentWillUnmount() {
        if (this.wrapper) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
    }
    /**
	 * We derivate the button state from the properties passed.
	 * We do this in here because we need this information in different places
	 * and this prevent to do multiple width calculations in the same component.
	 */ static getDerivedStateFromProps(nextProps, prevState) {
        const selectionType = $d7b6116fd3431a1c$var$getSelectionType(nextProps.selection);
        const inStickyMode = nextProps.stickyHeaders && nextProps.stickyHeaders.sticky;
        const rect = (0, $b1RTQ.getSelectionRect)(nextProps.selection);
        // only tie row delete to sticky header if it's the only thing
        // in the selection, otherwise the row delete will hover around
        // the rest of the selection
        const firstRowInSelection = rect && rect.top === 0 && rect.bottom === 1;
        const shouldStickyButton = inStickyMode && firstRowInSelection;
        const stickyTop = nextProps.stickyHeaders ? nextProps.stickyHeaders.top + nextProps.stickyHeaders.padding : 0;
        if (selectionType) switch(selectionType){
            case 'column':
                {
                    // Calculate the button position and indexes for columns
                    const columnsWidths = (0, $lOQGo.getColumnsWidths)(nextProps.editorView);
                    const deleteBtnParams = (0, $lOQGo.getColumnDeleteButtonParams)(columnsWidths, nextProps.editorView.state.selection);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        top: inStickyMode ? nextProps.stickyHeaders.top : 0,
                        position: inStickyMode ? 'sticky' : undefined,
                        selectionType: selectionType
                    };
                    return null;
                }
            case 'row':
                // Calculate the button position and indexes for rows
                if (nextProps.tableRef) {
                    const rowHeights = (0, $g4A0f.getRowHeights)(nextProps.tableRef);
                    const offsetTop = inStickyMode ? -rowHeights[0] : 0;
                    const deleteBtnParams = (0, $g4A0f.getRowDeleteButtonParams)(rowHeights, nextProps.editorView.state.selection, shouldStickyButton ? stickyTop : offsetTop);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        position: shouldStickyButton ? 'sticky' : undefined,
                        left: 0,
                        selectionType: selectionType
                    };
                }
                return null;
        }
        // Clean state if no type
        if (prevState.selectionType !== selectionType) return {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: []
        };
        // Do nothing if doesn't change anything
        return null;
    }
    render() {
        const { mountPoint: mountPoint, boundariesElement: boundariesElement, tableRef: tableRef } = this.props;
        const { selectionType: selectionType } = this.state;
        if (!selectionType || !tableRef) return null;
        const tableContainerWrapper = (0, $eQcNy.closestElement)(tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER}`);
        const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jjujv.default), {
            removeLabel: selectionType === 'column' ? (0, $2V0EL.messages).removeColumns : (0, $2V0EL.messages).removeRows,
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        });
        const popupOpts = (0, $gvsBs.default)({
            left: this.state.left,
            top: this.state.top,
            selectionType: this.state.selectionType,
            tableWrapper: this.wrapper
        });
        const mountTo = tableContainerWrapper || mountPoint;
        if (this.state.position === 'sticky' && mountTo) {
            const headerRow = tableRef.querySelector('tr.sticky');
            if (headerRow) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const rect = headerRow.getBoundingClientRect();
                const calculatePosition = popupOpts.onPositionCalculated || ((pos)=>pos);
                const pos = calculatePosition({
                    left: this.state.left,
                    top: this.state.top
                });
                return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'fixed',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: pos.top,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        zIndex: (0, $1v4Xe.stickyRowZIndex),
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: rect.left + (pos.left || 0) - (this.state.selectionType === 'column' ? this.state.scrollLeft : 0) - // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        (this.props.isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0)
                    },
                    children: button
                }), mountTo);
            }
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
            target: tableRef,
            mountTo: mountTo,
            boundariesElement: tableContainerWrapper || boundariesElement,
            scrollableElement: this.wrapper || undefined,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...popupOpts,
            children: button
        });
    }
}
var $d7b6116fd3431a1c$export$2e2bcd8739ae039 = $d7b6116fd3431a1c$var$FloatingDeleteButton;

});
parcelRegister("jjujv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb0e51ef6abcd631$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $jecUf = parcelRequire("jecUf");
const $fb0e51ef6abcd631$var$DeleteButton = ({ style: style, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, removeLabel: removeLabel, intl: { formatMessage: formatMessage } })=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-label": formatMessage(removeLabel, {
                0: 1
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jecUf.TableCssClassName).CONTROLS_DELETE_BUTTON,
            onMouseDown: onClick,
            onMouseMove: (e)=>e.preventDefault(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                className: (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_ICON,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M12.242 10.828L9.414 8l2.828-2.829a.999.999 0 1 0-1.414-1.414L8 6.587l-2.829-2.83a1 1 0 0 0-1.414 1.414l2.83 2.83-2.83 2.827a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a.999.999 0 1 0 1.414-1.414",
                    fill: "currentColor",
                    fillRule: "evenodd"
                })
            })
        })
    });
var $fb0e51ef6abcd631$export$2e2bcd8739ae039 = (0, $8RXs9.default)($fb0e51ef6abcd631$var$DeleteButton);

});

parcelRegister("gvsBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51fa9a5bf0b56b9$export$2e2bcd8739ae039);

var $1v4Xe = parcelRequire("1v4Xe");
const $a51fa9a5bf0b56b9$var$DELETE_BUTTON_CONTROLS_OFFSET = (0, $1v4Xe.tableToolbarSize) + (0, $1v4Xe.tableDeleteButtonSize) + (0, $1v4Xe.tableDeleteButtonOffset);
function $a51fa9a5bf0b56b9$var$getColumnOptions(left, tableWrapper) {
    return {
        alignX: 'left',
        alignY: 'start',
        offset: [
            left,
            $a51fa9a5bf0b56b9$var$DELETE_BUTTON_CONTROLS_OFFSET
        ],
        shouldRenderPopup () {
            if (tableWrapper) {
                const rect = tableWrapper.getBoundingClientRect();
                const maxVisibleLeftPosition = rect.width + tableWrapper.scrollLeft - (0, $1v4Xe.tableDeleteButtonSize);
                const minVisibleLeftPosition = tableWrapper.scrollLeft;
                return maxVisibleLeftPosition - left > 0 && left > minVisibleLeftPosition;
            }
            return true;
        }
    };
}
function $a51fa9a5bf0b56b9$var$getRowOptions(top) {
    return {
        alignX: 'left',
        alignY: 'start',
        forcePlacement: true,
        offset: [
            0,
            -top
        ],
        onPositionCalculated (position) {
            return {
                ...position,
                // We need to force left to always be the offset to not be affected by overflow
                left: -$a51fa9a5bf0b56b9$var$DELETE_BUTTON_CONTROLS_OFFSET
            };
        }
    };
}
function $a51fa9a5bf0b56b9$export$2e2bcd8739ae039({ left: left, top: top, selectionType: selectionType, tableWrapper: tableWrapper }) {
    switch(selectionType){
        case 'column':
            return $a51fa9a5bf0b56b9$var$getColumnOptions(left, tableWrapper);
        case 'row':
            return $a51fa9a5bf0b56b9$var$getRowOptions(top);
        default:
            return {};
    }
}

});


parcelRegister("fPXwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $589e42e348f11300$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4N9VB = parcelRequire("4N9VB");

var $iHYdz = parcelRequire("iHYdz");

var $hFEwm = parcelRequire("hFEwm");

var $1v4Xe = parcelRequire("1v4Xe");

var $3gMpG = parcelRequire("3gMpG");
const $589e42e348f11300$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky;
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    const offset = direction === 'row' ? [
        -9,
        0
    ] : [
        0,
        -7
    ];
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $hFEwm.CellSelection))) return null;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags?.() ?? {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $1v4Xe.dragMenuDropdownWidth),
        fitHeight: (0, $1v4Xe.tablePopupMenuFitHeight),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $iHYdz.akEditorFloatingDialogZIndex) : (0, $iHYdz.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: offset,
        stick: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3gMpG.default), {
            editorView: editorView,
            isOpen: isOpen,
            tableNode: tableNode,
            direction: direction,
            index: index,
            target: targetHandleRef || undefined,
            targetCellPosition: targetCellPosition,
            getEditorContainerWidth: getEditorContainerWidth,
            editorAnalyticsAPI: editorAnalyticsAPI,
            pluginConfig: pluginConfig,
            fitWidth: (0, $1v4Xe.dragMenuDropdownWidth),
            fitHeight: (0, $1v4Xe.tablePopupMenuFitHeight),
            mountPoint: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isTableScalingEnabled: isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            ariaNotifyPlugin: ariaNotifyPlugin,
            api: api,
            isCommentEditor: isCommentEditor || false
        })
    });
};
$589e42e348f11300$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $589e42e348f11300$export$2e2bcd8739ae039 = $589e42e348f11300$var$FloatingDragMenu;

});
parcelRegister("3gMpG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2be43c4ac83c147a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");

var $2V0EL = parcelRequire("2V0EL");

var $gKjGW = parcelRequire("gKjGW");

var $by76K = parcelRequire("by76K");
var $fHEWI = parcelRequire("fHEWI");
var $qMg2l = parcelRequire("qMg2l");
var $f35CH = parcelRequire("f35CH");

var $2WNBA = parcelRequire("2WNBA");
var $8v0FX = parcelRequire("8v0FX");

var $eQcNy = parcelRequire("eQcNy");

var $hAs1r = parcelRequire("hAs1r");

var $24JcV = parcelRequire("24JcV");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");
var $b1RTQ = parcelRequire("b1RTQ");
var $iGxzn = parcelRequire("iGxzn");

var $dmnFy = parcelRequire("dmnFy");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $9fJGy = parcelRequire("9fJGy");

var $6lSoW = parcelRequire("6lSoW");

var $gF4dk = parcelRequire("gF4dk");

var $22Go6 = parcelRequire("22Go6");

var $gseSq = parcelRequire("gseSq");

var $01hCL = parcelRequire("01hCL");

var $evhdb = parcelRequire("evhdb");

var $9bHWx = parcelRequire("9bHWx");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");

var $cBrMr = parcelRequire("cBrMr");

var $bGvOb = parcelRequire("bGvOb");
const $2be43c4ac83c147a$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $2V0EL.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $2V0EL.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $2V0EL.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $2V0EL.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $2V0EL.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $2V0EL.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $2V0EL.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $2V0EL.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $2V0EL.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $2V0EL.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $2V0EL.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $2V0EL.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $2V0EL.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $2V0EL.messages).sortColumnDecreasing,
        plural: null
    }
};
const $2be43c4ac83c147a$var$getGroupedDragMenuConfig = ()=>{
    const groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    groupedDragMenuConfig.unshift(sortColumnItems);
    return groupedDragMenuConfig;
};
const $2be43c4ac83c147a$var$elementBeforeIconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $2be43c4ac83c147a$var$convertToDropdownItems = (dragMenuConfig, formatMessage, selectionRect)=>{
    const groupedDragMenuConfig = $2be43c4ac83c147a$var$getGroupedDragMenuConfig();
    const menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    const menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean($2be43c4ac83c147a$var$MapDragMenuOptionIdToMessage[item.id]?.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($2be43c4ac83c147a$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($2be43c4ac83c147a$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $2be43c4ac83c147a$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(item.icon, {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage($2be43c4ac83c147a$var$MapDragMenuOptionIdToMessage[item.id].message, options),
                LEGACY_fallbackIcon: item.iconFallback ? item.iconFallback : undefined
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $24JcV.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        curr?.length > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $2be43c4ac83c147a$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $uOUlv.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $5uXOq.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $22Go6.getPluginState)(state);
    const selectionRect = (0, $iGxzn.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $b1RTQ.getSelectionRect)(selection) : (0, $28MvW.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = tableMap?.hasMergedCells() ?? false;
    const allowBackgroundColor = pluginConfig?.allowBackgroundColor ?? false;
    const dragMenuConfig = (0, $01hCL.getDragMenuConfig)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig?.isHeaderRowRequired, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, ariaNotifyPlugin, isCommentEditor);
    const { menuItems: menuItems, menuCallback: menuCallback } = $2be43c4ac83c147a$var$convertToDropdownItems(dragMenuConfig, formatMessage, selectionRect);
    const handleSubMenuRef = (ref)=>{
        const parent = (0, $eQcNy.closestElement)(// Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom, '.fabric-editor-popup-scroll-parent');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > boundariesRect.width) ref.style.left = `-${rect.width}px`;
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $6lSoW.setColorWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        const { targetCellPosition: targetCellPosition } = (0, $gseSq.getPluginState)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $f35CH.getSelectedRowAndColumnFromPalette)((0, $fHEWI.default), background, (0, $1v4Xe.colorPalletteColumns));
        return {
            key: 'background',
            content: formatMessage((0, $2V0EL.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $2be43c4ac83c147a$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmnFy))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2V0EL.messages).backgroundColor)
            })),
            elemAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $gKjGW.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $bGvOb.dragMenuBackgroundColorStyles)()
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $bGvOb.cellColourPreviewStyles)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $jecUf.TableCssClassName).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                className: (0, $jecUf.TableCssClassName).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
                type: (0, $8v0FX.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    target?.focus();
                    target?.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $qMg2l.default), {
                cols: (0, $1v4Xe.colorPalletteColumns),
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                paletteOptions: {
                    palette: (0, $fHEWI.default),
                    paletteColorTooltipMessages: (0, $by76K.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $hAs1r.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $6lSoW.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $6lSoW.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $6lSoW.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const createHeaderRowColumnMenuItem = (direction)=>{
        return direction === 'column' ? {
            key: 'header_column',
            content: formatMessage((0, $2V0EL.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $bGvOb.toggleStyles)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dTlW6.default), {
                id: "toggle-header-column",
                onChange: toggleHeaderColumn,
                isChecked: (0, $evhdb.checkIfHeaderColumnEnabled)(selection)
            }))
        } : {
            key: 'header_row',
            content: formatMessage((0, $2V0EL.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $bGvOb.toggleStyles)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dTlW6.default), {
                id: "toggle-header-row",
                onChange: toggleHeaderRow,
                isChecked: (0, $evhdb.checkIfHeaderRowEnabled)(selection)
            }))
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $2V0EL.messages).rowNumbers),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $bGvOb.toggleStyles)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dTlW6.default), {
                id: "toggle-row-numbers",
                onChange: toggleRowNumbers,
                isChecked: (0, $evhdb.checkIfNumberColumnEnabled)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $22Go6.getPluginState)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target?.focus();
            else editorView.dom.focus();
            (0, $gF4dk.toggleDragMenu)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        menuCallback[item.value.name]?.(state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!item.value.name?.startsWith('delete')) return;
        (item.value.name === 'delete_column' ? (0, $9fJGy.hoverColumns)((0, $9bHWx.getSelectedColumnIndexes)(selectionRect), true) : (0, $9fJGy.hoverRows)((0, $9bHWx.getSelectedRowIndexes)(selectionRect), true))(state, dispatch);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $9fJGy.clearHoverSelection)()(state, dispatch);
    };
    (0, $5uXOq.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) menuItems[1].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) menuItems.push({
        items: [
            createHeaderRowColumnMenuItem(direction)
        ]
    });
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row') index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cBrMr.DropdownMenu), {
        disableKeyboardHandling: isSubmenuOpen,
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
});
var $2be43c4ac83c147a$export$2e2bcd8739ae039 = (0, $8RXs9.default)($2be43c4ac83c147a$var$DragMenu);

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("cBrMr", function(module, exports) {

$parcel$export(module.exports, "DropdownMenu", () => $cfecbe421d696eb2$export$e44a253a59704894);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iraaj = parcelRequire("iraaj");
var $4N9VB = parcelRequire("4N9VB");

var $2WNBA = parcelRequire("2WNBA");
var $8v0FX = parcelRequire("8v0FX");
var $2rNvX = parcelRequire("2rNvX");

var $jdyxs = parcelRequire("jdyxs");

var $iHYdz = parcelRequire("iHYdz");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1v4Xe = parcelRequire("1v4Xe");
const $cfecbe421d696eb2$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $jdyxs.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iraaj.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $cfecbe421d696eb2$var$DropListWithOutsideListeners = (0, $jdyxs.default)($cfecbe421d696eb2$var$DropListWithOutsideClickTargetRef);
const $cfecbe421d696eb2$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $5uXOq.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $5uXOq.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    const offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    const offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)($cfecbe421d696eb2$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            handleClickOutside: ()=>handleClose('editor'),
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: (0, $1v4Xe.dragMenuDropdownWidth)
                    }
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
                    role: "menu",
                    children: items.map((group, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                            hasSeparator: section?.hasSeparator && index > 0,
                            title: section?.title,
                            children: group.items.map((item)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rNvX.DropdownMenuItem), {
                                    shouldUseDefaultRole: false,
                                    item: item,
                                    onItemActivated: onItemActivated,
                                    onMouseEnter: onMouseEnter,
                                    onMouseLeave: onMouseLeave
                                }, item.key ?? String(item.content)))
                        }, index))
                })
            ]
        });
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: "drag-dropdown-menu-wrapper",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: "drag-dropdown-menu-popup-ref",
                ref: handleRef
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                target: targetRefDiv,
                mountTo: mountPoint,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                onPlacementChanged: (placement)=>{
                    setPopupPlacement(placement);
                },
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: (0, $iHYdz.akEditorFloatingPanelZIndex),
                offset: [
                    offsetX,
                    offsetY
                ],
                allowOutOfBounds: true,
                children: disableKeyboardHandling ? innerMenu() : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WNBA.ArrowKeyNavigationProvider), {
                    closeOnTab: true,
                    type: (0, $8v0FX.ArrowKeyNavigationType).MENU,
                    handleClose: ()=>handleClose('handle'),
                    onSelection: (index)=>{
                        const results = items.flatMap((item)=>'items' in item ? item.items : item);
                        // onSelection is called when any focusable element is 'activated'
                        // this is an issue as some menu items have toggles, which cause the index value
                        // in the callback to be outside of array length.
                        // The logic below normalises the index value based on the number
                        // of menu items with 2 focusable elements, and adjusts the index to ensure
                        // the correct menu item is sent in onItemActivated callback
                        const keys = [
                            'row_numbers',
                            'header_row',
                            'header_column'
                        ];
                        let doubleItemCount = 0;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const firstIndex = results.findIndex((value)=>keys.includes(value.key));
                        if (firstIndex === -1 || index <= firstIndex) {
                            onItemActivated && onItemActivated({
                                item: results[index]
                            });
                            return;
                        }
                        for(let i = firstIndex; i < results.length; i += 1){
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            if (keys.includes(results[i].key)) doubleItemCount += 1;
                            if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                                onItemActivated && onItemActivated({
                                    item: results[i]
                                });
                                return;
                            }
                            if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                                onItemActivated && onItemActivated({
                                    item: results[i]
                                });
                                return;
                            }
                        }
                    },
                    children: innerMenu()
                })
            })
        ]
    }));
};

});

parcelRegister("bGvOb", function(module, exports) {

$parcel$export(module.exports, "cellColourPreviewStyles", () => $878152ced4668201$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "dragMenuBackgroundColorStyles", () => $878152ced4668201$export$2a71c1910478944e);
$parcel$export(module.exports, "toggleStyles", () => $878152ced4668201$export$4e493e7fd1e47c4d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");


var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
function $878152ced4668201$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $878152ced4668201$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $878152ced4668201$export$2a71c1910478944e = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $jecUf.TableCssClassName).DRAG_SUBMENU, "{border-radius:var(--ds-border-radius, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`, ";display:block;position:absolute;top:", (0, $1v4Xe.TABLE_DRAG_MENU_PADDING_TOP) + (0, $1v4Xe.TABLE_DRAG_MENU_SORT_GROUP_HEIGHT) + (0, $1v4Xe.TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT), "px;left:", (0, $1v4Xe.dragMenuDropdownWidth), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $jecUf.TableCssClassName).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $9UDEr.tableBackgroundBorderColor), ";border-radius:var(--ds-border-radius, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`, ";}}");
const $878152ced4668201$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};

});



parcelRegister("cvR2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c008dd98f893e13e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $gkwXh = parcelRequire("gkwXh");

var $4N9VB = parcelRequire("4N9VB");

var $eQcNy = parcelRequire("eQcNy");

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $hFEwm = parcelRequire("hFEwm");

var $uOUlv = parcelRequire("uOUlv");

var $28MvW = parcelRequire("28MvW");

var $6lSoW = parcelRequire("6lSoW");

var $evhdb = parcelRequire("evhdb");

var $jecUf = parcelRequire("jecUf");

var $8JWo0 = parcelRequire("8JWo0");

var $MpdT1 = parcelRequire("MpdT1");
class $c008dd98f893e13e$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.displayName = 'FloatingInsertButton';
    }
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // TODO: ED-26961 - temporarily disable insert button for first column and row https://atlassian.slack.com/archives/C05U8HRQM50/p1698363744682219?thread_ts=1698209039.104909&cid=C05U8HRQM50
        if (isDragAndDropEnabled && (insertColumnButtonIndex === 0 || insertRowButtonIndex === 0)) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can’t display the insert button for row|colum index 0
        // when the header row|colum is enabled, this feature will be change on the future
        if (type === 'column' && isHeaderColumnEnabled && insertColumnButtonIndex === 0 || type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if (tr.selection instanceof (0, $hFEwm.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        const tablePos = (0, $28MvW.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos?.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $5r0mK.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $gkwXh.ACTION).ERRORED,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $gkwXh.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        error: error?.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $eQcNy.closestElement)(target, 'tr') : (0, $eQcNy.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $eQcNy.closestElement)(targetCellRef, `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER}`);
        const tableWrapper = (0, $eQcNy.closestElement)(targetCellRef, `.${(0, $jecUf.TableCssClassName).TABLE_NODE_WRAPPER}`);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $evhdb.checkIfNumberColumnEnabled)(editorView.state.selection);
        // Fixed the 'add column button' not visible issue when sticky header is enabled
        // By setting the Popup z-index higher than the sticky header z-index ( common-styles.ts tr.sticky)
        // Only when inserting a column, otherwise set to undefined
        // Need to set z-index in the Popup, set z-index in the <InsertButton /> will not work
        const zIndex = type === 'column' ? (0, $iHYdz.akEditorTableCellOnStickyHeaderZIndex) : undefined;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $8JWo0.default)(type, index, hasNumberedColumns, !!isDragAndDropEnabled, tableContainerWrapper),
            zIndex: zIndex,
            children: isDragAndDropEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MpdT1.DragAndDropInsertButton), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false,
                isChromelessEditor: isChromelessEditor
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MpdT1.default), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false
            })
        });
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableMap = (0, $uOUlv.TableMap).get(tableNode);
        if (type === 'column') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            (0, $6lSoW.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $6lSoW.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $gkwXh.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
}
var $c008dd98f893e13e$export$2e2bcd8739ae039 = (0, $8RXs9.default)($c008dd98f893e13e$export$e2c2386b8045af89);

});
parcelRegister("8JWo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a57bba798f9f4b8$export$2e2bcd8739ae039);

var $iHYdz = parcelRequire("iHYdz");

var $1v4Xe = parcelRequire("1v4Xe");
const $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $1v4Xe.tableInsertColumnButtonSize) / 2);
const $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $iHYdz.akEditorTableNumberColumnWidth);
const $3a57bba798f9f4b8$var$VERTICAL_ALIGN_COLUMN_BUTTON = (0, $1v4Xe.tableToolbarSize) + (0, $1v4Xe.tableInsertColumnButtonOffset);
const $3a57bba798f9f4b8$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $1v4Xe.tableInsertColumnButtonOffset);
const $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_ROW_BUTTON = -((0, $1v4Xe.tableToolbarSize) + (0, $1v4Xe.tableInsertColumnButtonOffset) + (0, $1v4Xe.tableInsertColumnButtonSize));
const $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $3a57bba798f9f4b8$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $1v4Xe.tableInsertColumnButtonSize) / 2;
function $3a57bba798f9f4b8$var$getRowOptions(index, isDragAndDropEnabled) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $3a57bba798f9f4b8$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$3a57bba798f9f4b8$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: isDragAndDropEnabled ? $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG : $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_ROW_BUTTON
            };
        }
    };
}
function $3a57bba798f9f4b8$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            isDragAndDropEnabled ? $3a57bba798f9f4b8$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG : $3a57bba798f9f4b8$var$VERTICAL_ALIGN_COLUMN_BUTTON
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            const { left: left } = position;
            if (!left) // If not left, lest skip expensive next calculations.
            return position;
            if (index === 0) return {
                ...position,
                left: hasNumberedColumns ? $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $3a57bba798f9f4b8$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $3a57bba798f9f4b8$var$getPopupOptions(direction, index, hasNumberedColumns, isDragAndDropEnabled, tableContainer) {
    switch(direction){
        case 'column':
            return $3a57bba798f9f4b8$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled);
        case 'row':
            return $3a57bba798f9f4b8$var$getRowOptions(index, isDragAndDropEnabled);
        default:
            return {};
    }
}
var $3a57bba798f9f4b8$export$2e2bcd8739ae039 = $3a57bba798f9f4b8$var$getPopupOptions;

});

parcelRegister("MpdT1", function(module, exports) {

$parcel$export(module.exports, "DragAndDropInsertButton", () => $18a3c0f0862a713c$export$5e513603d391e3de);
$parcel$export(module.exports, "default", () => $18a3c0f0862a713c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9ci4W = parcelRequire("9ci4W");

var $8RXs9 = parcelRequire("8RXs9");

var $e9qoo = parcelRequire("e9qoo");

var $2V0EL = parcelRequire("2V0EL");

var $6gEe5 = parcelRequire("6gEe5");

var $eQcNy = parcelRequire("eQcNy");

var $iHYdz = parcelRequire("iHYdz");

var $3bDjY = parcelRequire("3bDjY");

var $jecUf = parcelRequire("jecUf");

var $1v4Xe = parcelRequire("1v4Xe");
const $18a3c0f0862a713c$var$getInsertLineHeight = (tableRef, hasStickyHeaders, isDragAndDropEnabled)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $6gEe5.tableMarginTop) * (isDragAndDropEnabled ? 3 : 4) - LINE_OFFSET : (0, $1v4Xe.tableToolbarSize) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $18a3c0f0862a713c$var$getToolbarSize = (tableRef)=>{
    const parent = (0, $eQcNy.closestElement)(tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}`) ? (0, $1v4Xe.tableToolbarSize) + (0, $iHYdz.akEditorTableNumberColumnWidth) - 1 : (0, $1v4Xe.tableToolbarSize);
    return 0, $1v4Xe.tableToolbarSize;
};
const $18a3c0f0862a713c$var$getNumberColumnWidth = (tableRef, isDragAndDropEnabled)=>{
    const parent = (0, $eQcNy.closestElement)(tableRef, `.${(0, $jecUf.TableCssClassName).TABLE_CONTAINER}`);
    if (parent && isDragAndDropEnabled) return parent.querySelector(`.${(0, $jecUf.TableCssClassName).NUMBERED_COLUMN}`) ? (0, $iHYdz.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $18a3c0f0862a713c$var$getInsertLineWidth = (tableRef, isDragAndDropEnabled, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 4;
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parentOffsetWidth = parentElement.offsetWidth;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    const toolbarSize = isDragAndDropEnabled ? 0 : $18a3c0f0862a713c$var$getToolbarSize(tableRef);
    const lineOffset = isDragAndDropEnabled ? DRAG_LINE_OFFSET : LINE_OFFSET;
    return Math.min(offsetWidth + toolbarSize, parentOffsetWidth + toolbarSize - Math.max(scrollLeft - diff, 0)) + lineOffset + $18a3c0f0862a713c$var$getNumberColumnWidth(tableRef, isDragAndDropEnabled);
};
const $18a3c0f0862a713c$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $2V0EL.messages).insertRow : (0, $2V0EL.messages).insertColumn;
};
const $18a3c0f0862a713c$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: formatMessage(isRow ? (0, $2V0EL.messages).insertRowDrag : (0, $2V0EL.messages).insertColumnDrag),
            keymap: isRow ? (0, $e9qoo.addRowAfter) : (0, $e9qoo.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))((0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
                        [(0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
                        [(0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
                        [(0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
                    }),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_ICON,
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
                                fill: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $18a3c0f0862a713c$var$getInsertLineWidth(tableRef, true, isChromelessEditor),
                        left: "var(--ds-space-150, 12px)"
                    } : {
                        height: $18a3c0f0862a713c$var$getInsertLineHeight(tableRef, hasStickyHeaders, true) - 8,
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: '-3px'
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = isRow ? (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW : (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jecUf.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $jecUf.TableCssClassName).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
const $18a3c0f0862a713c$export$5e513603d391e3de = (0, $8RXs9.default)($18a3c0f0862a713c$var$InsertButtonForDragAndDrop);
const $18a3c0f0862a713c$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e9qoo.ToolTipContent), {
            description: formatMessage($18a3c0f0862a713c$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $e9qoo.addRowAfter) : (0, $e9qoo.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                            className: (0, $jecUf.TableCssClassName).CONTROLS_BUTTON_ICON,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
                                fill: "currentColor",
                                fillRule: "evenodd"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $jecUf.TableCssClassName).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $18a3c0f0862a713c$var$getInsertLineWidth(tableRef)
                    } : {
                        height: $18a3c0f0862a713c$var$getInsertLineHeight(tableRef, hasStickyHeaders)
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = type === 'column' ? (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $jecUf.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jecUf.TableCssClassName).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $jecUf.TableCssClassName).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
var $18a3c0f0862a713c$export$2e2bcd8739ae039 = (0, $8RXs9.default)($18a3c0f0862a713c$var$InsertButton);

});


parcelRegister("guFYO", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarLabel", () => $db622d7a03e076ea$export$a60e1be3b6001ff3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4N9VB = parcelRequire("4N9VB");
const $db622d7a03e076ea$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4N9VB.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset,
        children: content
    });
});

});

parcelRegister("epMWO", function(module, exports) {

$parcel$export(module.exports, "GlobalStylesWrapper", () => $3eee1c6d156d74b9$export$cc5403d58ddfa812);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $cipm3 = parcelRequire("cipm3");
const $3eee1c6d156d74b9$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const mode = (0, $9LY0t.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
    return {
        mode: mode
    };
}, (api)=>{
    const { editorViewModeState: editorViewModeState } = (0, $awTmI.useSharedPluginState)(api, [
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode
    };
});
const $3eee1c6d156d74b9$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags, isDragAndDropEnabledOption: isDragAndDropEnabledOption, api: api })=>{
    const { mode: mode } = $3eee1c6d156d74b9$var$useSharedState(api);
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: (0, $cipm3.tableStyles)({
            featureFlags: featureFlags,
            isDragAndDropEnabled: isDragAndDropEnabledOption && !isLivePageViewMode
        })
    });
};

});

parcelRegister("bWCYR", function(module, exports) {

$parcel$export(module.exports, "SizeSelector", () => $212cf9240867b1f6$export$800b7d81026538f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1CHgS = parcelRequire("1CHgS");

var $59C9o = parcelRequire("59C9o");
const $212cf9240867b1f6$var$DEFAULT_TABLE_SELECTOR_COLS = 3;
const $212cf9240867b1f6$var$DEFAULT_TABLE_SELECTOR_ROWS = 3;
const $212cf9240867b1f6$export$800b7d81026538f2 = ({ api: api, target: target, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    const closeSelectorPopup = (0, $5uXOq.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $59C9o.pluginKey), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onSelection = (0, $5uXOq.useCallback)((rowsCount, colsCount)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.table.commands.insertTableWithSize(rowsCount, colsCount)({
                tr: tr
            });
            tr.setMeta((0, $59C9o.pluginKey), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onUnmount = ()=>{
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1CHgS.default), {
        defaultSize: {
            row: $212cf9240867b1f6$var$DEFAULT_TABLE_SELECTOR_ROWS,
            col: $212cf9240867b1f6$var$DEFAULT_TABLE_SELECTOR_COLS
        },
        target: target,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        popupsBoundariesElement: popupsBoundariesElement,
        isOpenedByKeyboard: true,
        handleClickOutside: closeSelectorPopup,
        handleEscapeKeydown: closeSelectorPopup
    });
};

});

parcelRegister("eZAi0", function(module, exports) {

$parcel$export(module.exports, "FullWidthDisplay", () => $5e4cc9b0c6199375$export$8bde7db5b2aba7d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2V0EL = parcelRequire("2V0EL");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");
const $5e4cc9b0c6199375$var$tableFullWidthLabelWrapperStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $5e4cc9b0c6199375$var$tableFullWidthLabelStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $5e4cc9b0c6199375$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $5e4cc9b0c6199375$var$tableFullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
            xcss: $5e4cc9b0c6199375$var$tableFullWidthLabelStyles,
            children: formatMessage((0, $2V0EL.messages).fullWidthLabel)
        })
    });
};

});




parcelRegister("kzUMS", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => (parcelRequire("9ttYc")).textFormattingPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9ttYc = parcelRequire("9ttYc");

});
parcelRegister("9ttYc", function(module, exports) {

$parcel$export(module.exports, "textFormattingPlugin", () => $4991d512f1499c8d$export$2db686be056cb923);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lcXoV = parcelRequire("lcXoV");
var $l3Tmi = parcelRequire("l3Tmi");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $8EAPB = parcelRequire("8EAPB");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $iBd0o = parcelRequire("iBd0o");

var $eymsB = parcelRequire("eymsB");

var $5lnbm = parcelRequire("5lnbm");

var $ariKO = parcelRequire("ariKO");

var $h3S3m = parcelRequire("h3S3m");

var $31D5k = parcelRequire("31D5k");

var $2Mipj = parcelRequire("2Mipj");

var $a3fff = parcelRequire("a3fff");

var $2AV3Q = parcelRequire("2AV3Q");

var $dbLor = parcelRequire("dbLor");

var $f6iN9 = parcelRequire("f6iN9");
const $4991d512f1499c8d$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if ((0, $VSDnB.fg)('platform_editor_toolbar_rerender_optimization')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6iN9.PrimaryToolbarComponentMemoized), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6iN9.PrimaryToolbarComponent), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $l3Tmi.em)
                },
                {
                    name: 'strong',
                    mark: (0, $hhtT8.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $aUhe2.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $lcXoV.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $4NwJJ.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $8EAPB.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $2Mipj.plugin)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $ariKO.default)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $h3S3m.default)(schema, api?.analytics?.actions, api)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $2AV3Q.default)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $iBd0o.plugin)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $eymsB.default)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $31D5k.default)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const textFormattingState = (0, $a3fff.pluginKey).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (0, $iBd0o.pluginKey).getState(editorState)?.formattingIsPresent,
                isInitialised: !!textFormattingState?.isInitialised
            };
        },
        pluginsOptions: {
            selectionToolbar: ()=>{
                if (api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking === 'none' && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dbLor.FloatingToolbarTextFormalWithIntl), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api?.analytics?.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $5lnbm.toggleSuperscriptWithAnalytics)(api?.analytics?.actions),
            toggleSubscript: (0, $5lnbm.toggleSubscriptWithAnalytics)(api?.analytics?.actions),
            toggleStrike: (0, $5lnbm.toggleStrikeWithAnalytics)(api?.analytics?.actions),
            toggleCode: (0, $5lnbm.toggleCodeWithAnalytics)(api?.analytics?.actions),
            toggleUnderline: (0, $5lnbm.toggleUnderlineWithAnalytics)(api?.analytics?.actions),
            toggleEm: (0, $5lnbm.toggleEmWithAnalytics)(api?.analytics?.actions),
            toggleStrong: (0, $5lnbm.toggleStrongWithAnalytics)(api?.analytics?.actions)
        }
    };
};

});
parcelRegister("iBd0o", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $3da2badab7ebaf7e$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "plugin", () => $3da2badab7ebaf7e$export$ca524d3785e2543);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");

var $It8yn = parcelRequire("It8yn");
const $3da2badab7ebaf7e$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('clearFormattingPlugin');
const $3da2badab7ebaf7e$export$ca524d3785e2543 = (dispatch)=>new (0, $5KWxh.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $It8yn.checkFormattingIsPresent)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $It8yn.checkFormattingIsPresent)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($3da2badab7ebaf7e$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $3da2badab7ebaf7e$export$18d4026d1ea86bb1
    });

});
parcelRegister("It8yn", function(module, exports) {

$parcel$export(module.exports, "hasCode", () => $79cb057306942656$export$435b7561880b778c);
$parcel$export(module.exports, "markActive", () => $79cb057306942656$export$c91f8b3cbd625635);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $79cb057306942656$export$4b48a1fc423972ea);
$parcel$export(module.exports, "compareItemsArrays", () => $79cb057306942656$export$53d327693050b221);
$parcel$export(module.exports, "isArrayContainsContent", () => $79cb057306942656$export$f8f79f933a3fce55);

var $30Enc = parcelRequire("30Enc");

var $i2p1r = parcelRequire("i2p1r");
const $79cb057306942656$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $79cb057306942656$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $79cb057306942656$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $i2p1r.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $79cb057306942656$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $i2p1r.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $30Enc.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $79cb057306942656$export$4b48a1fc423972ea = (state)=>{
    return $79cb057306942656$var$marksArePresent(state) || $79cb057306942656$var$blockStylingIsPresent(state);
};
const $79cb057306942656$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $79cb057306942656$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;

});
parcelRegister("i2p1r", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $095a04f3a3e2a398$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $095a04f3a3e2a398$export$73b50f8f13648c71);
$parcel$export(module.exports, "clearFormattingWithAnalytics", () => $095a04f3a3e2a398$export$332a1f720fc2ba0);

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $hFEwm = parcelRequire("hFEwm");

var $27qyy = parcelRequire("27qyy");
const $095a04f3a3e2a398$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $095a04f3a3e2a398$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $095a04f3a3e2a398$var$formatTypes = {
    em: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $095a04f3a3e2a398$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $095a04f3a3e2a398$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
function $095a04f3a3e2a398$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $eS2Dn.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $095a04f3a3e2a398$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $095a04f3a3e2a398$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $27qyy.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($095a04f3a3e2a398$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($095a04f3a3e2a398$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $095a04f3a3e2a398$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $hFEwm.CellSelection)) (0, $27qyy.cellSelectionNodesBetween)(tr.selection, tr.doc, $095a04f3a3e2a398$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $095a04f3a3e2a398$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $gkwXh.ACTION).FORMATTED,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $gkwXh.INPUT_METHOD).TOOLBAR || inputMethod === (0, $gkwXh.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("27qyy", function(module, exports) {

$parcel$export(module.exports, "cellSelectionNodesBetween", () => $378566212a848ffe$export$bd443c1dba3019b8);
const $378566212a848ffe$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};

});




parcelRegister("eymsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab9516915b18b009$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $vWFRY = parcelRequire("vWFRY");

var $i2p1r = parcelRequire("i2p1r");
function $ab9516915b18b009$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.clearFormatting).common, (0, $i2p1r.clearFormattingWithAnalytics)((0, $gkwXh.INPUT_METHOD).SHORTCUT, editorAnalyticsAPI), list);
    return (0, $vWFRY.keymap)(list);
}
var $ab9516915b18b009$export$2e2bcd8739ae039 = $ab9516915b18b009$export$e832373cff8dec22;

});

parcelRegister("5lnbm", function(module, exports) {

$parcel$export(module.exports, "toggleEmWithAnalytics", () => $53796c9fa41bfea6$export$fe8278eb0d365433);
$parcel$export(module.exports, "toggleStrikeWithAnalytics", () => $53796c9fa41bfea6$export$f08ef336cb688397);
$parcel$export(module.exports, "toggleStrongWithAnalytics", () => $53796c9fa41bfea6$export$686bc7c29753e27);
$parcel$export(module.exports, "toggleUnderlineWithAnalytics", () => $53796c9fa41bfea6$export$bf3c86b5abdb857d);
$parcel$export(module.exports, "toggleSuperscriptWithAnalytics", () => $53796c9fa41bfea6$export$ca1c98793b67ba6b);
$parcel$export(module.exports, "toggleSubscriptWithAnalytics", () => $53796c9fa41bfea6$export$8d0c92ae27a193);
$parcel$export(module.exports, "toggleCodeWithAnalytics", () => $53796c9fa41bfea6$export$2d4f5a54f840ba91);

var $gkwXh = parcelRequire("gkwXh");

var $4ipwT = parcelRequire("4ipwT");

var $fxHaN = parcelRequire("fxHaN");
const $53796c9fa41bfea6$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(em)({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(strike)({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(strong)({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(underline)({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $4ipwT.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $53796c9fa41bfea6$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $53796c9fa41bfea6$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $fxHaN.nextToggleMark)(code, api)({
            tr: tr
        });
    };
const $53796c9fa41bfea6$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $53796c9fa41bfea6$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $gkwXh.ACTION).FORMATTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };

});
parcelRegister("4ipwT", function(module, exports) {

$parcel$export(module.exports, "transformNonTextNodesToText", () => $e0f9df7eb6d27b18$export$abc5e6e01568db39);
$parcel$export(module.exports, "applyMarkOnRange", () => $e0f9df7eb6d27b18$export$94a1aa532f5398df);
$parcel$export(module.exports, "entireSelectionContainsMark", () => $e0f9df7eb6d27b18$export$cc5a5f0a00f537f5);
$parcel$export(module.exports, "toggleMark", () => $e0f9df7eb6d27b18$export$797ad2667b8015a8);
$parcel$export(module.exports, "removeMark", () => $e0f9df7eb6d27b18$export$5c9d031211c1b7c9);

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $e0f9df7eb6d27b18$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e0f9df7eb6d27b18$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($e0f9df7eb6d27b18$var$SMART_TO_ASCII).join('')}]`, 'g');
function $e0f9df7eb6d27b18$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
function $e0f9df7eb6d27b18$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($e0f9df7eb6d27b18$var$FIND_SMART_CHAR, (match)=>$e0f9df7eb6d27b18$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $e0f9df7eb6d27b18$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $e0f9df7eb6d27b18$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $e0f9df7eb6d27b18$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
const $e0f9df7eb6d27b18$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $hFEwm.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = $e0f9df7eb6d27b18$export$cc5a5f0a00f537f5(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $e0f9df7eb6d27b18$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = $e0f9df7eb6d27b18$export$cc5a5f0a00f537f5(mark, tr.doc, $from.pos, $to.pos);
            $e0f9df7eb6d27b18$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $e0f9df7eb6d27b18$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $gZGBX.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $e0f9df7eb6d27b18$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
const $e0f9df7eb6d27b18$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $hFEwm.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $gZGBX.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };

});

parcelRegister("fxHaN", function(module, exports) {

$parcel$export(module.exports, "nextToggleMark", () => $383b6faec4d08fad$export$21e1076136e25038);

var $4ipwT = parcelRequire("4ipwT");

var $gZGBX = parcelRequire("gZGBX");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");
const $383b6faec4d08fad$export$21e1076136e25038 = (markType, api, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $gZGBX.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $383b6faec4d08fad$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $383b6faec4d08fad$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $hFEwm.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $4ipwT.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $383b6faec4d08fad$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $4ipwT.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $383b6faec4d08fad$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $383b6faec4d08fad$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) {
        if ((0, $VSDnB.fg)('platform_editor_resolve_marks')) api?.base?.actions.resolveMarks(from, to, tr);
        else (0, $4ipwT.transformNonTextNodesToText)(from, to, tr);
    }
    /**
	 * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
	 */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};

});


parcelRegister("ariKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5abb43af4d9e8c4$export$2e2bcd8739ae039);

var $5KWxh = parcelRequire("5KWxh");

var $gZGBX = parcelRequire("gZGBX");
var // eslint-disable-next-line import/no-anonymous-default-export
$c5abb43af4d9e8c4$export$2e2bcd8739ae039 = new (0, $5KWxh.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $gZGBX.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});

});

parcelRegister("h3S3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f16bd4ef2ad6528$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $4ipwT = parcelRequire("4ipwT");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $VSDnB = parcelRequire("VSDnB");

var $inLhu = parcelRequire("inLhu");
var $2f16bd4ef2ad6528$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($2f16bd4ef2ad6528$var$ValidAutoformatChars || {});
const $2f16bd4ef2ad6528$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $2f16bd4ef2ad6528$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) return null;
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') {
            if ((0, $VSDnB.fg)('platform_editor_resolve_marks')) api?.base?.actions?.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
            else (0, $4ipwT.transformNonTextNodesToText)(tr.mapping.map(start), tr.mapping.map(end), tr);
        }
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $2f16bd4ef2ad6528$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $2f16bd4ef2ad6528$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const combinations = $2f16bd4ef2ad6528$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $d19733ae55e58348$export$a96b909f1510512b)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $2f16bd4ef2ad6528$var$ReverseRegexExp(replacedRegex);
};
const $2f16bd4ef2ad6528$export$3312a15c47701971 = $2f16bd4ef2ad6528$var$buildRegex("__");
const $2f16bd4ef2ad6528$export$b2c5e5dc4b85ebff = $2f16bd4ef2ad6528$var$buildRegex("**");
const $2f16bd4ef2ad6528$export$5293ac529581c0f9 = $2f16bd4ef2ad6528$var$buildRegex("_");
const $2f16bd4ef2ad6528$export$bef0fedfe2c8027e = $2f16bd4ef2ad6528$var$buildRegex("*");
const $2f16bd4ef2ad6528$export$6dd2d2a62884fadf = $2f16bd4ef2ad6528$var$buildRegex("~~");
const $2f16bd4ef2ad6528$export$b311ac3b6caef479 = $2f16bd4ef2ad6528$var$buildRegex("`");
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $2f16bd4ef2ad6528$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$3312a15c47701971, $2f16bd4ef2ad6528$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$b2c5e5dc4b85ebff, $2f16bd4ef2ad6528$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $2f16bd4ef2ad6528$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$5293ac529581c0f9, $2f16bd4ef2ad6528$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$bef0fedfe2c8027e, $2f16bd4ef2ad6528$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $2f16bd4ef2ad6528$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$6dd2d2a62884fadf, $2f16bd4ef2ad6528$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $2f16bd4ef2ad6528$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $2Abpa.inputRuleWithAnalytics)({
        action: (0, $gkwXh.ACTION).FORMATTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const backTickRule = (0, $2Abpa.createRule)($2f16bd4ef2ad6528$export$b311ac3b6caef479, $2f16bd4ef2ad6528$var$addMark(schema.marks.code, schema, "`", api));
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $2f16bd4ef2ad6528$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$2f16bd4ef2ad6528$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$2f16bd4ef2ad6528$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$2f16bd4ef2ad6528$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$2f16bd4ef2ad6528$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('text-formatting', rules));
    return;
}
var $2f16bd4ef2ad6528$export$2e2bcd8739ae039 = $2f16bd4ef2ad6528$export$568a7ed6897c4817;

});

parcelRegister("31D5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $b71a8b0c15429fb6$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");

var $e9qoo = parcelRequire("e9qoo");

var $5KWxh = parcelRequire("5KWxh");

var $vWFRY = parcelRequire("vWFRY");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $5lnbm = parcelRequire("5lnbm");

var $a3fff = parcelRequire("a3fff");
function $b71a8b0c15429fb6$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleBold).common, (0, $5lnbm.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleItalic).common, (0, $5lnbm.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleCode).common, (0, $5lnbm.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleStrikethrough).common, (0, $5lnbm.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleSubscript).common, (0, $5lnbm.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleSuperscript).common, (0, $5lnbm.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.toggleUnderline).common, (0, $5lnbm.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $a3fff.pluginKey).getState(view.state);
        const list = {};
        if (schema.marks.strong && !textFormattingState?.strongDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleBold).common, (0, $5lnbm.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !textFormattingState?.emDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleItalic).common, (0, $5lnbm.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !textFormattingState?.codeDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleCode).common, (0, $5lnbm.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !textFormattingState?.strikeDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleStrikethrough).common, (0, $5lnbm.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.subscriptDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleSubscript).common, (0, $5lnbm.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.superscriptDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleSuperscript).common, (0, $5lnbm.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !textFormattingState?.underlineDisabled) (0, $e9qoo.bindKeymapWithEditorCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $e9qoo.toggleUnderline).common, (0, $5lnbm.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $gkwXh.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $e9qoo.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_8') ? getEnabledKeylist(view) : list;
                return (0, $vWFRY.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("a3fff", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $719bd93ca56e3e85$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $719bd93ca56e3e85$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('textFormatting');

});


parcelRegister("2Mipj", function(module, exports) {

$parcel$export(module.exports, "plugin", () => $d577485bedd10a66$export$ca524d3785e2543);
// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';

var $e9qoo = parcelRequire("e9qoo");

var $30Enc = parcelRequire("30Enc");

var $5KWxh = parcelRequire("5KWxh");

var $77j9j = parcelRequire("77j9j");

var $2RHbH = parcelRequire("2RHbH");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $c8XKQ = parcelRequire("c8XKQ");

var $a3fff = parcelRequire("a3fff");
const $d577485bedd10a66$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $gZGBX.NodeSelection)) return true;
    return false;
};
const $d577485bedd10a66$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($d577485bedd10a66$var$isSelectionInlineCursor(selection)) return false;
    if (type !== null || type !== undefined) return (0, $2RHbH.toggleMark)(mark, {
        type: type
    })(editorState);
    return (0, $2RHbH.toggleMark)(mark)(editorState);
};
const $d577485bedd10a66$var$getTextFormattingState = (editorState, editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    if (code) {
        state.codeActive = (0, $30Enc.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$d577485bedd10a66$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $30Enc.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $30Enc.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $30Enc.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $30Enc.anyMarkActive)(editorState, subMark);
        state.subscriptDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptActive = (0, $30Enc.anyMarkActive)(editorState, supMark);
        state.superscriptDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $30Enc.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$d577485bedd10a66$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $d577485bedd10a66$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $5KWxh.SafePlugin)({
        state: {
            init (_config, state) {
                return $d577485bedd10a66$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $d577485bedd10a66$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $77j9j.shallowEqual)(pluginState, state)) {
                    dispatch((0, $a3fff.pluginKey), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $a3fff.pluginKey),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $e9qoo.moveRight).common && !event.metaKey) return $c8XKQ.moveRight()(state, dispatch);
                else if (event.key === (0, $e9qoo.moveLeft).common && !event.metaKey) return $c8XKQ.moveLeft()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (0, $a3fff.pluginKey).getState(state)?.underlineDisabled && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_9')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $c8XKQ.createInlineCodeFromTextInputWithAnalytics)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });

});
parcelRegister("c8XKQ", function(module, exports) {

$parcel$export(module.exports, "moveRight", () => $6a76d512cb0295d1$export$e2c874fbfec7201);
$parcel$export(module.exports, "moveLeft", () => $6a76d512cb0295d1$export$108f27160c89e515);
$parcel$export(module.exports, "createInlineCodeFromTextInputWithAnalytics", () => $6a76d512cb0295d1$export$7a99a2b030134bb0);

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $4ipwT = parcelRequire("4ipwT");

var $gZGBX = parcelRequire("gZGBX");

var $It8yn = parcelRequire("It8yn");
const $6a76d512cb0295d1$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $It8yn.markActive)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $6a76d512cb0295d1$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $It8yn.markActive)(state, code.create());
            const currentPosHasCode = (0, $It8yn.hasCode)(state, $cursor.pos);
            const nextPosHasCode = (0, $It8yn.hasCode)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $It8yn.hasCode)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $gZGBX.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $gZGBX.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $6a76d512cb0295d1$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $4ipwT.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $6a76d512cb0295d1$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $14FOE.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $gkwXh.ACTION).FORMATTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $gkwXh.INPUT_METHOD).FORMATTING
            }
        })($6a76d512cb0295d1$var$createInlineCodeFromTextInput(from, to, text));
    };

});


parcelRegister("2AV3Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $37fd0ad4360bfd86$export$2e2bcd8739ae039);

var $gkwXh = parcelRequire("gkwXh");
var $kS6uH = parcelRequire("kS6uH");

var $5KWxh = parcelRequire("5KWxh");

var $2Abpa = parcelRequire("2Abpa");

var $gZGBX = parcelRequire("gZGBX");

var $inLhu = parcelRequire("inLhu");
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $37fd0ad4360bfd86$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $gZGBX.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $37fd0ad4360bfd86$var$createReplacementRule(to, from) {
    return (0, $2Abpa.createRule)(from, $37fd0ad4360bfd86$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $37fd0ad4360bfd86$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $37fd0ad4360bfd86$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $37fd0ad4360bfd86$var$createSingleQuotesRules() {
    return [
        // wrapped text
        // eslint-disable-next-line require-unicode-regexp
        (0, $2Abpa.createRule)(/(\s|^)'(\S+.*\S+)'$/, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        $37fd0ad4360bfd86$var$createReplacementRule("\u2019", /(\w+)(')(\w+)$/)
    ];
}
/**
 * Get replacement rules related to product
 */ function $37fd0ad4360bfd86$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $2Abpa.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $gkwXh.ACTION).SUBSTITUTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $37fd0ad4360bfd86$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Trello: /(\s+|^)(trello)(\s)$/
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $37fd0ad4360bfd86$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $kS6uH.SYMBOL).ARROW_RIGHT,
        "\u2190": (0, $kS6uH.SYMBOL).ARROW_LEFT,
        "\u2194\uFE0E": (0, $kS6uH.SYMBOL).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $2Abpa.inputRuleWithAnalytics)({
            action: (0, $gkwXh.ACTION).SUBSTITUTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $37fd0ad4360bfd86$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2192": /(\s+|^)(--?>)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2190": /(\s+|^)(<--?)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2194\uFE0E": /(\s+|^)(<->?)(\s)$/
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $37fd0ad4360bfd86$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $kS6uH.PUNC).DASH,
        "\u2026": (0, $kS6uH.PUNC).ELLIPSIS,
        "\u201D": (0, $kS6uH.PUNC).QUOTE_DOUBLE,
        [(0, $kS6uH.PUNC).QUOTE_SINGLE]: (0, $kS6uH.PUNC).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $2Abpa.inputRuleWithAnalytics)({
            action: (0, $gkwXh.ACTION).SUBSTITUTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $37fd0ad4360bfd86$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2013": /(\s+|^)(--)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2026": /()(\.\.\.)$/
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $37fd0ad4360bfd86$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201C": /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201D": /"$/
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $37fd0ad4360bfd86$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $kS6uH.PUNC).QUOTE_SINGLE)(rule))
    ];
}
var $37fd0ad4360bfd86$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $5KWxh.SafePlugin)((0, $inLhu.createPlugin)('text-formatting:smart-input', [
        ...$37fd0ad4360bfd86$var$getProductRules(editorAnalyticsAPI),
        ...$37fd0ad4360bfd86$var$getSymbolRules(editorAnalyticsAPI),
        ...$37fd0ad4360bfd86$var$getPunctuationRules(editorAnalyticsAPI)
    ]));

});
parcelRegister("kS6uH", function(module, exports) {

$parcel$export(module.exports, "SYMBOL", () => $c02641b1ecef7c90$export$27c95a7104c1f7aa);
$parcel$export(module.exports, "PUNC", () => $c02641b1ecef7c90$export$3530f2dd0e78fdc2);
var $c02641b1ecef7c90$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $c02641b1ecef7c90$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});

});


parcelRegister("dbLor", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarTextFormalWithIntl", () => $d0d06777cf45dbe2$export$d728f1bdde37938b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $kXC89 = parcelRequire("kXC89");

var $9LY0t = parcelRequire("9LY0t");

var $gZGBX = parcelRequire("gZGBX");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9SSnF = parcelRequire("9SSnF");

var $h7140 = parcelRequire("h7140");

var $kqr1M = parcelRequire("kqr1M");

var $iSbjo = parcelRequire("iSbjo");

var $4CbHS = parcelRequire("4CbHS");

var $32Jbz = parcelRequire("32Jbz");

var $gTSLT = parcelRequire("gTSLT");

var $7ToIY = parcelRequire("7ToIY");
const $d0d06777cf45dbe2$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $kXC89.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $7ToIY.ToolbarType).FLOATING
};
const $d0d06777cf45dbe2$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const isInitialised = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.isInitialised');
    const formattingIsPresent = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.formattingIsPresent');
    const emActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emActive');
    const emDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emDisabled');
    const emHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emHidden');
    const codeActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeActive');
    const codeDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeDisabled');
    const codeHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeHidden');
    const underlineActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineActive');
    const underlineDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineDisabled');
    const underlineHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineHidden');
    const strikeActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeActive');
    const strikeDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeDisabled');
    const strikeHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeHidden');
    const strongActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongActive');
    const strongDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongDisabled');
    const strongHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongHidden');
    const superscriptActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptActive');
    const superscriptDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptDisabled');
    const superscriptHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptHidden');
    const subscriptActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptActive');
    const subscriptDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptDisabled');
    const subscriptHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptHidden');
    return {
        isInitialised: Boolean(isInitialised),
        formattingIsPresent: formattingIsPresent,
        emActive: emActive,
        emDisabled: emDisabled,
        emHidden: emHidden,
        codeActive: codeActive,
        codeDisabled: codeDisabled,
        codeHidden: codeHidden,
        underlineActive: underlineActive,
        underlineDisabled: underlineDisabled,
        underlineHidden: underlineHidden,
        strikeActive: strikeActive,
        strikeDisabled: strikeDisabled,
        strikeHidden: strikeHidden,
        strongActive: strongActive,
        strongDisabled: strongDisabled,
        strongHidden: strongHidden,
        superscriptActive: superscriptActive,
        superscriptDisabled: superscriptDisabled,
        superscriptHidden: superscriptHidden,
        subscriptActive: subscriptActive,
        subscriptDisabled: subscriptDisabled,
        subscriptHidden: subscriptHidden
    };
}, (api)=>{
    const { textFormattingState: textFormattingState } = (0, $awTmI.useSharedPluginState)(api, [
        'textFormatting'
    ]);
    return {
        isInitialised: Boolean(textFormattingState?.isInitialised),
        formattingIsPresent: textFormattingState?.formattingIsPresent,
        emActive: textFormattingState?.emActive,
        emDisabled: textFormattingState?.emDisabled,
        emHidden: textFormattingState?.emHidden,
        codeActive: textFormattingState?.codeActive,
        codeDisabled: textFormattingState?.codeDisabled,
        codeHidden: textFormattingState?.codeHidden,
        underlineActive: textFormattingState?.underlineActive,
        underlineDisabled: textFormattingState?.underlineDisabled,
        underlineHidden: textFormattingState?.underlineHidden,
        strikeActive: textFormattingState?.strikeActive,
        strikeDisabled: textFormattingState?.strikeDisabled,
        strikeHidden: textFormattingState?.strikeHidden,
        strongActive: textFormattingState?.strongActive,
        strongDisabled: textFormattingState?.strongDisabled,
        strongHidden: textFormattingState?.strongHidden,
        superscriptActive: textFormattingState?.superscriptActive,
        superscriptDisabled: textFormattingState?.superscriptDisabled,
        superscriptHidden: textFormattingState?.superscriptHidden,
        subscriptActive: textFormattingState?.subscriptActive,
        subscriptDisabled: textFormattingState?.subscriptDisabled,
        subscriptHidden: textFormattingState?.subscriptHidden
    };
});
const $d0d06777cf45dbe2$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = $d0d06777cf45dbe2$var$useSharedState(api);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    let hasMultiplePartsWithFormattingSelected;
    let commonActiveMarks = [];
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_7')) {
        const { selection: selection } = editorView.state;
        const { from: from, to: to } = selection;
        const selectedContent = selection instanceof (0, $gZGBX.TextSelection) ? editorView.state.doc.slice(from, to).content.content.slice() : undefined;
        hasMultiplePartsWithFormattingSelected = (0, $kqr1M.hasMultiplePartsWithFormattingInSelection)({
            selectedContent: selectedContent
        });
        if ((0, $VSDnB.fg)('platform_editor_controls_patch_10')) commonActiveMarks = (0, $kqr1M.getCommonActiveMarks)({
            selectedContent: selectedContent
        });
    }
    const defaultIcons = (0, $4CbHS.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $d0d06777cf45dbe2$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $d0d06777cf45dbe2$var$FloatingToolbarSettings.toolbarType,
        hasMultiplePartsWithFormattingSelected: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_10') ? hasMultiplePartsWithFormattingSelected : undefined,
        commonActiveMarks: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_10') ? commonActiveMarks : undefined
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $32Jbz.useIconList)({
        icons: defaultIcons,
        iconTypeList: (0, $9SSnF.DefaultFloatingToolbarButtonsNext),
        shouldUnselect: hasMultiplePartsWithFormattingSelected
    });
    const clearIcon = (0, $iSbjo.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $d0d06777cf45dbe2$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $5uXOq.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gTSLT.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h7140.FormattingTextDropdownMenu), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? false : $d0d06777cf45dbe2$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $d0d06777cf45dbe2$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $d0d06777cf45dbe2$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $d0d06777cf45dbe2$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $d0d06777cf45dbe2$var$FloatingToolbarSettings.toolbarType,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected
    }));
};
const $d0d06777cf45dbe2$export$d728f1bdde37938b = (0, $8RXs9.default)($d0d06777cf45dbe2$var$FloatingToolbarTextFormat);

});
parcelRegister("9SSnF", function(module, exports) {

$parcel$export(module.exports, "DefaultButtonsToolbar", () => $237bd00d3284b239$export$723fe6df8f1efc);
$parcel$export(module.exports, "DefaultFloatingToolbarButtonsNext", () => $237bd00d3284b239$export$d721a3fc4d89f470);
$parcel$export(module.exports, "DefaultButtonsToolbarNext", () => $237bd00d3284b239$export$d3cc1a6b8f50ab8b);
$parcel$export(module.exports, "DefaultButtonsMenu", () => $237bd00d3284b239$export$18ed0a4f570c2fe3);
$parcel$export(module.exports, "DefaultButtonsMenuNext", () => $237bd00d3284b239$export$147b62f816addc16);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbar", () => $237bd00d3284b239$export$51e7f8a4dcbe968e);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarNext", () => $237bd00d3284b239$export$8c762656e9d4ed7e);
$parcel$export(module.exports, "ResponsiveCustomMenu", () => $237bd00d3284b239$export$d55a9d117cfa4dfe);
$parcel$export(module.exports, "ResponsiveCustomMenuNext", () => $237bd00d3284b239$export$8dc498a6ade2b0fd);

var $kXC89 = parcelRequire("kXC89");

var $7ToIY = parcelRequire("7ToIY");
const $237bd00d3284b239$export$723fe6df8f1efc = [
    (0, $7ToIY.IconTypes).strong,
    (0, $7ToIY.IconTypes).em
];
const $237bd00d3284b239$export$d721a3fc4d89f470 = [
    (0, $7ToIY.IconTypes).strong
];
const $237bd00d3284b239$export$d3cc1a6b8f50ab8b = [
    (0, $7ToIY.IconTypes).strong,
    (0, $7ToIY.IconTypes).em,
    (0, $7ToIY.IconTypes).underline
];
const $237bd00d3284b239$export$18ed0a4f570c2fe3 = [
    (0, $7ToIY.IconTypes).underline,
    (0, $7ToIY.IconTypes).strike,
    (0, $7ToIY.IconTypes).code,
    (0, $7ToIY.IconTypes).subscript,
    (0, $7ToIY.IconTypes).superscript
];
const $237bd00d3284b239$export$147b62f816addc16 = [
    (0, $7ToIY.IconTypes).strike,
    (0, $7ToIY.IconTypes).code,
    (0, $7ToIY.IconTypes).subscript,
    (0, $7ToIY.IconTypes).superscript
];
const $237bd00d3284b239$export$51e7f8a4dcbe968e = {
    [(0, $kXC89.ToolbarSize).XXL]: $237bd00d3284b239$export$723fe6df8f1efc,
    [(0, $kXC89.ToolbarSize).XL]: $237bd00d3284b239$export$723fe6df8f1efc,
    [(0, $kXC89.ToolbarSize).L]: $237bd00d3284b239$export$723fe6df8f1efc,
    [(0, $kXC89.ToolbarSize).M]: $237bd00d3284b239$export$723fe6df8f1efc,
    [(0, $kXC89.ToolbarSize).S]: $237bd00d3284b239$export$723fe6df8f1efc,
    [(0, $kXC89.ToolbarSize).XXXS]: []
};
const $237bd00d3284b239$export$8c762656e9d4ed7e = {
    [(0, $kXC89.ToolbarSize).XXL]: $237bd00d3284b239$export$d3cc1a6b8f50ab8b,
    [(0, $kXC89.ToolbarSize).XL]: $237bd00d3284b239$export$d3cc1a6b8f50ab8b,
    [(0, $kXC89.ToolbarSize).L]: $237bd00d3284b239$export$d3cc1a6b8f50ab8b,
    [(0, $kXC89.ToolbarSize).M]: [
        (0, $7ToIY.IconTypes).strong,
        (0, $7ToIY.IconTypes).em
    ],
    [(0, $kXC89.ToolbarSize).S]: [
        (0, $7ToIY.IconTypes).strong,
        (0, $7ToIY.IconTypes).em
    ],
    [(0, $kXC89.ToolbarSize).XXXS]: [
        (0, $7ToIY.IconTypes).strong
    ]
};
const $237bd00d3284b239$export$d55a9d117cfa4dfe = {
    [(0, $kXC89.ToolbarSize).XXL]: $237bd00d3284b239$export$18ed0a4f570c2fe3,
    [(0, $kXC89.ToolbarSize).XL]: $237bd00d3284b239$export$18ed0a4f570c2fe3,
    [(0, $kXC89.ToolbarSize).L]: $237bd00d3284b239$export$18ed0a4f570c2fe3,
    [(0, $kXC89.ToolbarSize).M]: $237bd00d3284b239$export$18ed0a4f570c2fe3,
    [(0, $kXC89.ToolbarSize).S]: $237bd00d3284b239$export$18ed0a4f570c2fe3,
    [(0, $kXC89.ToolbarSize).XXXS]: [
        (0, $7ToIY.IconTypes).strong,
        (0, $7ToIY.IconTypes).em,
        ...$237bd00d3284b239$export$18ed0a4f570c2fe3
    ]
};
const $237bd00d3284b239$export$8dc498a6ade2b0fd = {
    [(0, $kXC89.ToolbarSize).XXL]: $237bd00d3284b239$export$147b62f816addc16,
    [(0, $kXC89.ToolbarSize).XL]: $237bd00d3284b239$export$147b62f816addc16,
    [(0, $kXC89.ToolbarSize).L]: $237bd00d3284b239$export$147b62f816addc16,
    [(0, $kXC89.ToolbarSize).M]: [
        (0, $7ToIY.IconTypes).underline,
        ...$237bd00d3284b239$export$147b62f816addc16
    ],
    [(0, $kXC89.ToolbarSize).S]: [
        (0, $7ToIY.IconTypes).underline,
        ...$237bd00d3284b239$export$147b62f816addc16
    ],
    [(0, $kXC89.ToolbarSize).XXXS]: [
        (0, $7ToIY.IconTypes).em,
        (0, $7ToIY.IconTypes).underline,
        ...$237bd00d3284b239$export$147b62f816addc16
    ]
};

});
parcelRegister("7ToIY", function(module, exports) {

$parcel$export(module.exports, "IconTypes", () => $46a96ee8503440b9$export$f84ca76848e3ed34);
$parcel$export(module.exports, "ToolbarType", () => $46a96ee8503440b9$export$a5d11b3163e4b1a5);
var $46a96ee8503440b9$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $46a96ee8503440b9$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});


parcelRegister("h7140", function(module, exports) {

$parcel$export(module.exports, "FormattingTextDropdownMenu", () => $b87a521fc7a6e6a8$export$52e9a2bbe5d185e8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eDTMN = parcelRequire("eDTMN");

var $2rNvX = parcelRequire("2rNvX");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $dTGjQ = parcelRequire("dTGjQ");

var $jYJis = parcelRequire("jYJis");

var $9xkbi = parcelRequire("9xkbi");
const $b87a521fc7a6e6a8$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected, isDisabled: isDisabled })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $jYJis.useMenuState)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $5uXOq.useState)(false);
    const onItemActivated = (0, $5uXOq.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? items[0].items[0]?.elemBefore : undefined;
    const defaultIconName = items[0].items[0]?.value.name;
    let iconBefore;
    let activeIconName = defaultIconName;
    if (hasMultiplePartsWithFormattingSelected && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_7')) iconBefore = defaultIcon;
    else {
        iconBefore = activeItem ? activeItem?.elemBefore : defaultIcon;
        activeIconName = activeItem?.value.name || defaultIconName;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rNvX.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $iHYdz.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        section: {
            hasSeparator: true
        },
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        },
        children: hasMoreButton ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9xkbi.MoreButton), {
            isSelected: isMenuOpen || hasFormattingActive,
            label: moreButtonLabel,
            isReducedSpacing: isReducedSpacing,
            isDisabled: false,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            "aria-expanded": isMenuOpen
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTGjQ.DropdownToolbarButton), {
            isReducedSpacing: isReducedSpacing,
            isDisabled: Boolean(isDisabled),
            isSelected: isMenuOpen,
            label: intl.formatMessage((0, $eDTMN.toolbarMessages).textFormat),
            "aria-expanded": isMenuOpen,
            "aria-haspopup": true,
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            toolbarType: toolbarType,
            iconBefore: iconBefore,
            activeIconName: activeIconName
        })
    });
});

});
parcelRegister("dTGjQ", function(module, exports) {

$parcel$export(module.exports, "DropdownToolbarButton", () => $f82ee7cab92b1c7b$export$7c43b97d70f40057);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ejItq = parcelRequire("ejItq");
var $cr1aY = parcelRequire("cr1aY");

var $1jI4k = parcelRequire("1jI4k");

var $c593V = parcelRequire("c593V");

var $c8Oei = parcelRequire("c8Oei");

var $VSDnB = parcelRequire("VSDnB");

var $7ToIY = parcelRequire("7ToIY");
const $f82ee7cab92b1c7b$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $7ToIY.ToolbarType).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $ejItq.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ejItq.triggerWrapperStylesWithPadding) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ejItq.triggerWrapperStyles),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c593V))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $cr1aY.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px"
        })))
    });
};

});
parcelRegister("c593V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01488cb5e537ee4cbe66cd301abeebd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbcfb3ece99a3a7$var$_react = $8cbcfb3ece99a3a7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8cbcfb3ece99a3a7$var$_textItalic = $8cbcfb3ece99a3a7$var$_interopRequireDefault((parcelRequire("lkrcb")));

var $8cbcfb3ece99a3a7$var$_italic = $8cbcfb3ece99a3a7$var$_interopRequireDefault((parcelRequire("2a1lI")));
function $8cbcfb3ece99a3a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextItalicIcon.
 * This component is TextItalicIcon, with `UNSAFE_fallbackIcon` set to "EditorItalicIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbcfb3ece99a3a7$var$TextItalicIcon = (props)=>/*#__PURE__*/ $8cbcfb3ece99a3a7$var$_react.default.createElement($8cbcfb3ece99a3a7$var$_textItalic.default, Object.assign({
        LEGACY_fallbackIcon: $8cbcfb3ece99a3a7$var$_italic.default
    }, props));
$8cbcfb3ece99a3a7$var$TextItalicIcon.Name = 'TextItalicIconMigration';
var $8cbcfb3ece99a3a7$var$_default = module.exports.default = $8cbcfb3ece99a3a7$var$TextItalicIcon;

});
parcelRegister("lkrcb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4dc41d7000d1518f4f92caf7103b7b0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8708fb4eea5bb10$var$_react = $f8708fb4eea5bb10$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f8708fb4eea5bb10$var$_baseNew = $f8708fb4eea5bb10$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f8708fb4eea5bb10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8708fb4eea5bb10$var$TextItalicIcon = (props)=>/*#__PURE__*/ $f8708fb4eea5bb10$var$_react.default.createElement($f8708fb4eea5bb10$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$f8708fb4eea5bb10$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $f8708fb4eea5bb10$var$_default = module.exports.default = $f8708fb4eea5bb10$var$TextItalicIcon;

});

parcelRegister("2a1lI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192d8fe202023ca8$var$_react = $192d8fe202023ca8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $192d8fe202023ca8$var$_textItalic = $192d8fe202023ca8$var$_interopRequireDefault((parcelRequire("lkrcb")));
function $192d8fe202023ca8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $192d8fe202023ca8$var$EditorItalicIcon = (props)=>/*#__PURE__*/ $192d8fe202023ca8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2M8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m4-8h2l-2 8h-2z"/></svg>`
    }, props, {
        newIcon: $192d8fe202023ca8$var$_textItalic.default
    }));
$192d8fe202023ca8$var$EditorItalicIcon.displayName = 'EditorItalicIcon';
var $192d8fe202023ca8$var$_default = module.exports.default = $192d8fe202023ca8$var$EditorItalicIcon;

});



parcelRegister("jYJis", function(module, exports) {

$parcel$export(module.exports, "useMenuState", () => $322d2b1b65ffc612$export$8091e3849c182a6);

var $5uXOq = parcelRequire("5uXOq");
const $322d2b1b65ffc612$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $5uXOq.useState)(false);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};

});

parcelRegister("9xkbi", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $7529a61929720894$export$7f94856880993f27);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ejItq = parcelRequire("ejItq");

var $1jI4k = parcelRequire("1jI4k");

var $i0Kha = parcelRequire("i0Kha");

var $VSDnB = parcelRequire("VSDnB");
function $7529a61929720894$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7529a61929720894$var$MoreIconStyle = {
    name: "1m17jn9",
    styles: "display:flex;align-items:center;height:var(--ds-space-300, 24px)"
};
const $7529a61929720894$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-prefix -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $7529a61929720894$var$MoreIconStyle : (0, $ejItq.triggerWrapperStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i0Kha))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});

});
parcelRegister("i0Kha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a66b762cb5002d0ff30478d01606386f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1cc1f8733afaf4d$var$_react = $d1cc1f8733afaf4d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1cc1f8733afaf4d$var$_showMoreHorizontal = $d1cc1f8733afaf4d$var$_interopRequireDefault((parcelRequire("1wCbV")));

var $d1cc1f8733afaf4d$var$_more = $d1cc1f8733afaf4d$var$_interopRequireDefault((parcelRequire("6qrUW")));
function $d1cc1f8733afaf4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1cc1f8733afaf4d$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $d1cc1f8733afaf4d$var$_react.default.createElement($d1cc1f8733afaf4d$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $d1cc1f8733afaf4d$var$_more.default
    }, props));
$d1cc1f8733afaf4d$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $d1cc1f8733afaf4d$var$_default = module.exports.default = $d1cc1f8733afaf4d$var$ShowMoreHorizontalIcon;

});



parcelRegister("kqr1M", function(module, exports) {

$parcel$export(module.exports, "hasMultiplePartsWithFormattingInSelection", () => $2a783b4b7451eb84$export$93dfd4ecb1fdf6d4);
$parcel$export(module.exports, "getCommonActiveMarks", () => $2a783b4b7451eb84$export$4c389142e2cf768e);

var $VSDnB = parcelRequire("VSDnB");

var $7ToIY = parcelRequire("7ToIY");
const $2a783b4b7451eb84$var$isMarkInIconTypes = (node)=>node.marks.some((mark)=>Object.values((0, $7ToIY.IconTypes)).includes(mark.type.name));
const $2a783b4b7451eb84$export$93dfd4ecb1fdf6d4 = ({ selectedContent: selectedContent })=>{
    if (!selectedContent) return false;
    if ((0, $VSDnB.fg)('platform_editor_controls_patch_8')) {
        // Check if there are multiple parts with formatting or if only one part has formatting and the rest have none
        const contentWithMarks = selectedContent.filter((child)=>$2a783b4b7451eb84$var$isMarkInIconTypes(child));
        const hasFormatting = contentWithMarks.length > 0;
        const allPartsHaveFormatting = contentWithMarks.length === selectedContent.length;
        return hasFormatting && (!allPartsHaveFormatting || contentWithMarks.length > 1);
    }
    const marks = selectedContent.map((child)=>$2a783b4b7451eb84$var$isMarkInIconTypes(child) ? child.marks : undefined).filter(Boolean);
    return marks.length > 1;
};
const $2a783b4b7451eb84$export$4c389142e2cf768e = ({ selectedContent: selectedContent })=>{
    if (!selectedContent || selectedContent.length === 0) return [];
    // filter out fragment node contains only spaces
    const filteredSelectedContent = selectedContent.filter((child)=>child.text?.trim() !== '');
    // find the active mark type in first part
    const firstPartMarks = selectedContent[0].marks.map((mark)=>mark.type.name);
    // check if all other parts have the same mark type as the first part and return the common mark types
    const commonMarkTypes = firstPartMarks.filter((mark)=>filteredSelectedContent.every((child)=>child.marks.some((m)=>m.type.name === mark)));
    return commonMarkTypes;
};

});

parcelRegister("iSbjo", function(module, exports) {

$parcel$export(module.exports, "useClearIcon", () => $1f5bca172315590b$export$4ff17fae4b9914b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e9qoo = parcelRequire("e9qoo");

var $eDTMN = parcelRequire("eDTMN");

var $24JcV = parcelRequire("24JcV");

var $8Ygfu = parcelRequire("8Ygfu");

var $gmhCD = parcelRequire("gmhCD");

var $i2p1r = parcelRequire("i2p1r");

var $kE1Me = parcelRequire("kE1Me");
const $1f5bca172315590b$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $eDTMN.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $5uXOq.useCallback)((state, dispatch)=>(0, $i2p1r.clearFormattingWithAnalytics)((0, $kE1Me.getInputMethod)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Ygfu))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: (0, $24JcV.shortcutStyle)
            }, (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $e9qoo.clearFormatting) ? (0, $e9qoo.tooltip)((0, $e9qoo.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};

});
parcelRegister("kE1Me", function(module, exports) {

$parcel$export(module.exports, "getInputMethod", () => $5810e3ead7a4cbea$export$8213a6fbfa466e73);

var $gkwXh = parcelRequire("gkwXh");

var $7ToIY = parcelRequire("7ToIY");
const $5810e3ead7a4cbea$export$ec2f5afcaf7ee094 = {
    [(0, $7ToIY.ToolbarType).PRIMARY]: (0, $gkwXh.INPUT_METHOD).TOOLBAR,
    [(0, $7ToIY.ToolbarType).FLOATING]: (0, $gkwXh.INPUT_METHOD).FLOATING_TB
};
const $5810e3ead7a4cbea$export$8213a6fbfa466e73 = (toolbarType)=>$5810e3ead7a4cbea$export$ec2f5afcaf7ee094[toolbarType];

});


parcelRegister("4CbHS", function(module, exports) {

$parcel$export(module.exports, "useFormattingIcons", () => $e567d131b1abf215$export$6f298ec13df828);
$parcel$export(module.exports, "useHasFormattingActived", () => $e567d131b1abf215$export$cb0a2ed6e982a08f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $l4tMX = parcelRequire("l4tMX");

var $e9qoo = parcelRequire("e9qoo");

var $eDTMN = parcelRequire("eDTMN");

var $31nwk = parcelRequire("31nwk");

var $24JcV = parcelRequire("24JcV");

var $2uTgk = parcelRequire("2uTgk");

var $fBmv3 = parcelRequire("fBmv3");

var $c593V = parcelRequire("c593V");

var $iUFrU = parcelRequire("iUFrU");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $5lnbm = parcelRequire("5lnbm");

var $kT4l3 = parcelRequire("kT4l3");

var $kE1Me = parcelRequire("kE1Me");

var $7ToIY = parcelRequire("7ToIY");
const $e567d131b1abf215$var$withInputMethod = (toolbarType, func)=>(0, $31nwk.editorCommandToPMCommand)(func((0, $kE1Me.getInputMethod)(toolbarType)));
const $e567d131b1abf215$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleStrongWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).bold,
            tooltipKeymap: (0, $e9qoo.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBmv3))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleEmWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).italic,
            tooltipKeymap: (0, $e9qoo.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c593V))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).underline,
            tooltipKeymap: (0, $e9qoo.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUFrU))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleStrikeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).strike,
            tooltipKeymap: (0, $e9qoo.toggleStrikethrough)
        },
        code: {
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleCodeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).code,
            tooltipKeymap: (0, $e9qoo.toggleCode)
        },
        subscript: {
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).subscript,
            tooltipKeymap: (0, $e9qoo.toggleSubscript)
        },
        superscript: {
            command: $e567d131b1abf215$var$withInputMethod(toolbarType, (0, $5lnbm.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $eDTMN.toolbarMessages).superscript,
            tooltipKeymap: (0, $e9qoo.toggleSuperscript)
        }
    });
const $e567d131b1abf215$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBmv3))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c593V))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUFrU))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kT4l3.Strikethrough), null)
    },
    code: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2uTgk))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kT4l3.Subscript), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kT4l3.Superscript), null)
    }
};
const $e567d131b1abf215$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $e567d131b1abf215$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $e567d131b1abf215$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $24JcV.shortcutStyle)
        }, (0, $e9qoo.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $e9qoo.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $e9qoo.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $e567d131b1abf215$var$IconsMarkSchema = {
    [(0, $7ToIY.IconTypes).strong]: 'strong',
    [(0, $7ToIY.IconTypes).em]: 'em',
    [(0, $7ToIY.IconTypes).strike]: 'strike',
    [(0, $7ToIY.IconTypes).code]: 'code',
    [(0, $7ToIY.IconTypes).underline]: 'underline',
    [(0, $7ToIY.IconTypes).superscript]: 'subsup',
    [(0, $7ToIY.IconTypes).subscript]: 'subsup'
};
const $e567d131b1abf215$var$buildMenuIconState = (iconMark, hasMultiplePartsWithFormattingSelected, commonActiveMarks)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState?.isInitialised);
        const markSchema = $e567d131b1abf215$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = hasMultiplePartsWithFormattingSelected && !commonActiveMarks?.includes(iconMark) && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_10') ? false : textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $e567d131b1abf215$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks)=>{
    const getState = $e567d131b1abf215$var$buildMenuIconState(iconMark, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $5uXOq.useMemo)(()=>$e567d131b1abf215$var$getIcon({
                iconType: (0, $7ToIY.IconTypes)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $5uXOq.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $e567d131b1abf215$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected, commonActiveMarks: commonActiveMarks })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType,
        hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected,
        commonActiveMarks: commonActiveMarks
    };
    const buildStrongIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).strong, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildEmIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).em, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildUnderlineIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).underline, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildStrikeIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).strike, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildCodeIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).code, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildSubscriptIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).subscript, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const buildSuperscriptIcon = $e567d131b1abf215$var$buildIcon((0, $7ToIY.IconTypes).superscript, editorAnalyticsAPI, toolbarType, hasMultiplePartsWithFormattingSelected, commonActiveMarks);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $5uXOq.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $e567d131b1abf215$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $5uXOq.useMemo)(()=>{
        if (!textFormattingState?.isInitialised) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};

});
parcelRegister("l4tMX", function(module, exports) {

$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $1393bb315c311409$export$f90c25d407b3694a);
var $1393bb315c311409$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});

});

parcelRegister("fBmv3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4f551e0fc4427f006d67b2bd73732a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5bbc3b89b4b2a47$var$_react = $b5bbc3b89b4b2a47$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5bbc3b89b4b2a47$var$_textBold = $b5bbc3b89b4b2a47$var$_interopRequireDefault((parcelRequire("czw3z")));

var $b5bbc3b89b4b2a47$var$_bold = $b5bbc3b89b4b2a47$var$_interopRequireDefault((parcelRequire("eBL3L")));
function $b5bbc3b89b4b2a47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextBoldIcon.
 * This component is TextBoldIcon, with `UNSAFE_fallbackIcon` set to "EditorBoldIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5bbc3b89b4b2a47$var$TextBoldIcon = (props)=>/*#__PURE__*/ $b5bbc3b89b4b2a47$var$_react.default.createElement($b5bbc3b89b4b2a47$var$_textBold.default, Object.assign({
        LEGACY_fallbackIcon: $b5bbc3b89b4b2a47$var$_bold.default
    }, props));
$b5bbc3b89b4b2a47$var$TextBoldIcon.Name = 'TextBoldIconMigration';
var $b5bbc3b89b4b2a47$var$_default = module.exports.default = $b5bbc3b89b4b2a47$var$TextBoldIcon;

});
parcelRegister("czw3z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f3f6bf083da187946fb2c11bc2af09a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92719eb76e292775$var$_react = $92719eb76e292775$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92719eb76e292775$var$_baseNew = $92719eb76e292775$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92719eb76e292775$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92719eb76e292775$var$TextBoldIcon = (props)=>/*#__PURE__*/ $92719eb76e292775$var$_react.default.createElement($92719eb76e292775$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$92719eb76e292775$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $92719eb76e292775$var$_default = module.exports.default = $92719eb76e292775$var$TextBoldIcon;

});

parcelRegister("eBL3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa290674812dc283$var$_react = $aa290674812dc283$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $aa290674812dc283$var$_textBold = $aa290674812dc283$var$_interopRequireDefault((parcelRequire("czw3z")));
function $aa290674812dc283$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aa290674812dc283$var$EditorBoldIcon = (props)=>/*#__PURE__*/ $aa290674812dc283$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h4.832C13.908 6 16 6.5 16 9q0 2-1 2.5 2 .5 2 3c0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9z"/></svg>`
    }, props, {
        newIcon: $aa290674812dc283$var$_textBold.default
    }));
$aa290674812dc283$var$EditorBoldIcon.displayName = 'EditorBoldIcon';
var $aa290674812dc283$var$_default = module.exports.default = $aa290674812dc283$var$EditorBoldIcon;

});


parcelRegister("iUFrU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a8fc19af895cf97d1b251e7bb8b6f2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc4d9be99163b898$var$_react = $dc4d9be99163b898$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc4d9be99163b898$var$_baseNew = $dc4d9be99163b898$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dc4d9be99163b898$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc4d9be99163b898$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $dc4d9be99163b898$var$_react.default.createElement($dc4d9be99163b898$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$dc4d9be99163b898$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $dc4d9be99163b898$var$_default = module.exports.default = $dc4d9be99163b898$var$TextUnderlineIcon;

});

parcelRegister("kT4l3", function(module, exports) {

$parcel$export(module.exports, "Strikethrough", () => $6a549223c23a392e$export$53f33388b3b5115f);
$parcel$export(module.exports, "Subscript", () => $6a549223c23a392e$export$54eb3b8088f84d2b);
$parcel$export(module.exports, "Superscript", () => $6a549223c23a392e$export$a4eac561e2e9d419);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $6a549223c23a392e$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        children: children
    });
const $6a549223c23a392e$export$53f33388b3b5115f = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($6a549223c23a392e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M8.39644 7.25348H13.9004V7.25421H15V8.75421H1V7.25421H2.125V7.25H4.96062C4.45271 6.59457 4.15039 5.77182 4.15039 4.87845C4.15039 2.73833 5.8853 1.00342 8.02542 1.00342H11.9004V2.50342H8.02542C6.71373 2.50342 5.65039 3.56676 5.65039 4.87845C5.65039 6.14664 6.64437 7.18267 7.89576 7.25H8.23074C8.28625 7.25 8.3415 7.25117 8.39644 7.25348ZM12.1058 11.125C12.1058 10.6424 12.0175 10.1804 11.8563 9.75421H10.1705C10.4446 10.1415 10.6058 10.6144 10.6058 11.125C10.6058 12.4367 9.54243 13.5001 8.23074 13.5001H3.15064V15.0001H8.23074C10.3709 15.0001 12.1058 13.2652 12.1058 11.125Z",
                fill: "currentColor"
            })
        })
    });
const $6a549223c23a392e$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($6a549223c23a392e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
                fill: "currentColor"
            })
        })
    });
const $6a549223c23a392e$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($6a549223c23a392e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("32Jbz", function(module, exports) {

$parcel$export(module.exports, "useIconList", () => $227f4677c5442f3b$export$894adbec036a07c6);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $227f4677c5442f3b$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList, shouldUnselect: shouldUnselect })=>{
    return (0, $5uXOq.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            shouldUnselect && icon.isActive && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_7') && !(0, $VSDnB.fg)('platform_editor_controls_patch_10')) icon.isActive = false;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        shouldUnselect,
        iconTypeList
    ]);
};

});

parcelRegister("gTSLT", function(module, exports) {

$parcel$export(module.exports, "SingleToolbarButtons", () => $66e557a6536bf763$export$e3e9702c9c21585);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ejItq = parcelRequire("ejItq");

var $1jI4k = parcelRequire("1jI4k");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $66e557a6536bf763$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView, hasMultiplePartsWithFormattingSelected: hasMultiplePartsWithFormattingSelected })=>{
    const onClick = (0, $5uXOq.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyleBeforeVisualRefresh)
    }, items.map((item)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            hasMultiplePartsWithFormattingSelected && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_7') && !(0, $VSDnB.fg)('platform_editor_controls_patch_10') ? false : item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            hasMultiplePartsWithFormattingSelected && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_7') && !(0, $VSDnB.fg)('platform_editor_controls_patch_10') ? false : item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});

});


parcelRegister("f6iN9", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $add80a24892b762c$export$94516d5cccf573e3);
$parcel$export(module.exports, "PrimaryToolbarComponentMemoized", () => $add80a24892b762c$export$aa7d892cb2b41646);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $9LY0t = parcelRequire("9LY0t");

var $5RrCg = parcelRequire("5RrCg");

var $7ToIY = parcelRequire("7ToIY");
const $add80a24892b762c$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const isInitialised = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.isInitialised');
    const formattingIsPresent = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.formattingIsPresent');
    const emActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emActive');
    const emDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emDisabled');
    const emHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.emHidden');
    const codeActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeActive');
    const codeDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeDisabled');
    const codeHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.codeHidden');
    const underlineActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineActive');
    const underlineDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineDisabled');
    const underlineHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.underlineHidden');
    const strikeActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeActive');
    const strikeDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeDisabled');
    const strikeHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strikeHidden');
    const strongActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongActive');
    const strongDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongDisabled');
    const strongHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.strongHidden');
    const superscriptActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptActive');
    const superscriptDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptDisabled');
    const superscriptHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.superscriptHidden');
    const subscriptActive = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptActive');
    const subscriptDisabled = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptDisabled');
    const subscriptHidden = (0, $9LY0t.useSharedPluginStateSelector)(api, 'textFormatting.subscriptHidden');
    return {
        isInitialised: Boolean(isInitialised),
        formattingIsPresent: formattingIsPresent,
        emActive: emActive,
        emDisabled: emDisabled,
        emHidden: emHidden,
        codeActive: codeActive,
        codeDisabled: codeDisabled,
        codeHidden: codeHidden,
        underlineActive: underlineActive,
        underlineDisabled: underlineDisabled,
        underlineHidden: underlineHidden,
        strikeActive: strikeActive,
        strikeDisabled: strikeDisabled,
        strikeHidden: strikeHidden,
        strongActive: strongActive,
        strongDisabled: strongDisabled,
        strongHidden: strongHidden,
        superscriptActive: superscriptActive,
        superscriptDisabled: superscriptDisabled,
        superscriptHidden: superscriptHidden,
        subscriptActive: subscriptActive,
        subscriptDisabled: subscriptDisabled,
        subscriptHidden: subscriptHidden
    };
}, (api)=>{
    const { textFormattingState: textFormattingState } = (0, $awTmI.useSharedPluginState)(api, [
        'textFormatting'
    ]);
    return {
        isInitialised: Boolean(textFormattingState?.isInitialised),
        formattingIsPresent: textFormattingState?.formattingIsPresent,
        emActive: textFormattingState?.emActive,
        emDisabled: textFormattingState?.emDisabled,
        emHidden: textFormattingState?.emHidden,
        codeActive: textFormattingState?.codeActive,
        codeDisabled: textFormattingState?.codeDisabled,
        codeHidden: textFormattingState?.codeHidden,
        underlineActive: textFormattingState?.underlineActive,
        underlineDisabled: textFormattingState?.underlineDisabled,
        underlineHidden: textFormattingState?.underlineHidden,
        strikeActive: textFormattingState?.strikeActive,
        strikeDisabled: textFormattingState?.strikeDisabled,
        strikeHidden: textFormattingState?.strikeHidden,
        strongActive: textFormattingState?.strongActive,
        strongDisabled: textFormattingState?.strongDisabled,
        strongHidden: textFormattingState?.strongHidden,
        superscriptActive: textFormattingState?.superscriptActive,
        superscriptDisabled: textFormattingState?.superscriptDisabled,
        superscriptHidden: textFormattingState?.superscriptHidden,
        subscriptActive: textFormattingState?.subscriptActive,
        subscriptDisabled: textFormattingState?.subscriptDisabled,
        subscriptHidden: textFormattingState?.subscriptHidden
    };
});
function $add80a24892b762c$export$94516d5cccf573e3({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar }) {
    const textFormattingState = $add80a24892b762c$var$useSharedState(api);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5RrCg.default), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api,
        toolbarType: (0, $7ToIY.ToolbarType).PRIMARY
    });
}
const $add80a24892b762c$export$aa7d892cb2b41646 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($add80a24892b762c$export$94516d5cccf573e3);

});
parcelRegister("5RrCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8c7ed30d9c4ab6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $7Em36 = parcelRequire("7Em36");

var $eDTMN = parcelRequire("eDTMN");

var $ejItq = parcelRequire("ejItq");

var $ldHK3 = parcelRequire("ldHK3");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $It8yn = parcelRequire("It8yn");

var $h7140 = parcelRequire("h7140");

var $iSbjo = parcelRequire("iSbjo");

var $4CbHS = parcelRequire("4CbHS");

var $26hX6 = parcelRequire("26hX6");

var $9xkbi = parcelRequire("9xkbi");

var $gTSLT = parcelRequire("gTSLT");
const $3c8c7ed30d9c4ab6$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $5uXOq.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $4CbHS.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $iSbjo.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $26hX6.useResponsiveIconTypeMenu)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $4CbHS.useHasFormattingActived)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $26hX6.useResponsiveToolbarButtons)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $eDTMN.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $eDTMN.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $eDTMN.toolbarMessages).subscriptOffSuperscriptOn);
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $7Em36.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $It8yn.isArrayContainsContent)(activeItems, 'Subscript') && (0, $It8yn.isArrayContainsContent)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $It8yn.isArrayContainsContent)(activeItems, 'Superscript') && (0, $It8yn.isArrayContainsContent)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $It8yn.compareItemsArrays)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $eDTMN.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $It8yn.compareItemsArrays)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $eDTMN.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $eDTMN.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $5uXOq.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $eDTMN.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $eDTMN.toolbarMessages).textFormatting);
    (0, $5uXOq.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldHK3.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gTSLT.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $ejItq.wrapperStyle)
    }, isToolbarDisabled && !((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_10')) ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9xkbi.MoreButton), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h7140.FormattingTextDropdownMenu), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_4') ? false : true,
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && (0, $VSDnB.fg)('platform_editor_controls_patch_10') ? isToolbarDisabled : false
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ejItq.separatorStyles)
    })));
};
const $3c8c7ed30d9c4ab6$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c8c7ed30d9c4ab6$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
var $3c8c7ed30d9c4ab6$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3c8c7ed30d9c4ab6$var$Toolbar);

});
parcelRegister("ldHK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $460cd7001198a7b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $460cd7001198a7b7$var$timer;
const $460cd7001198a7b7$var$Announcer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        clearTimeout($460cd7001198a7b7$var$timer);
        setContentRendered(false);
        $460cd7001198a7b7$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($460cd7001198a7b7$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            children: text
        })
    });
});
var $460cd7001198a7b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($460cd7001198a7b7$var$Announcer);

});

parcelRegister("26hX6", function(module, exports) {

$parcel$export(module.exports, "useResponsiveIconTypeMenu", () => $ce6d3e38fe2c290b$export$110e6c3d6580196f);
$parcel$export(module.exports, "useResponsiveToolbarButtons", () => $ce6d3e38fe2c290b$export$efa5449fdb315092);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $9SSnF = parcelRequire("9SSnF");

var $32Jbz = parcelRequire("32Jbz");
const $ce6d3e38fe2c290b$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const ResponsiveCustomButtonToolbar = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $VSDnB.fg)('platform_editor_controls_patch_4') ? (0, $9SSnF.ResponsiveCustomButtonToolbarNext) : (0, $9SSnF.ResponsiveCustomButtonToolbar);
    const iconTypeList = (0, $5uXOq.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    return (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $VSDnB.fg)('platform_editor_controls_patch_4') ? (0, $9SSnF.DefaultButtonsToolbarNext) : (0, $9SSnF.DefaultButtonsToolbar);
};
const $ce6d3e38fe2c290b$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const ResponsiveCustomMenu = (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $VSDnB.fg)('platform_editor_controls_patch_4') ? (0, $9SSnF.ResponsiveCustomMenuNext) : (0, $9SSnF.ResponsiveCustomMenu);
    const iconTypeList = (0, $5uXOq.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    return (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $VSDnB.fg)('platform_editor_controls_patch_4') ? (0, $9SSnF.DefaultButtonsMenuNext) : (0, $9SSnF.DefaultButtonsMenu);
};
const $ce6d3e38fe2c290b$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $ce6d3e38fe2c290b$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $32Jbz.useIconList)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};

});





parcelRegister("gYYLA", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => (parcelRequire("04dn4")).undoRedoPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $04dn4 = parcelRequire("04dn4");

});
parcelRegister("04dn4", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => $3240f30d9d6bf16f$export$dcdc7fc7ecd3098);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $5KWxh = parcelRequire("5KWxh");

var $fZzhT = parcelRequire("fZzhT");

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");

var $eZ1X5 = parcelRequire("eZ1X5");

var $20LLb = parcelRequire("20LLb");

var $30ytK = parcelRequire("30ytK");

var $kVmKj = parcelRequire("kVmKj");

var $345K8 = parcelRequire("345K8");

var $cBhLR = parcelRequire("cBhLR");
const $3240f30d9d6bf16f$export$dcdc7fc7ecd3098 = ({ api: api })=>{
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBhLR.default), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    const handleUndo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $345K8.forceFocus)(editorViewRef.current, api)((0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? (0, $eZ1X5.attachInputMetaWithAnalytics)(api?.analytics?.actions)(inputSource || (0, $20LLb.InputSource).EXTERNAL, (0, $gkwXh.ACTION).UNDO_PERFORMED)((0, $fZzhT.undo)) : (0, $eZ1X5.attachInputMeta)(inputSource || (0, $20LLb.InputSource).EXTERNAL)((0, $fZzhT.undo)));
    };
    const handleRedo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $345K8.forceFocus)(editorViewRef.current, api)((0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? (0, $eZ1X5.attachInputMetaWithAnalytics)(api?.analytics?.actions)(inputSource || (0, $20LLb.InputSource).EXTERNAL, (0, $gkwXh.ACTION).REDO_PERFORMED)((0, $fZzhT.redo)) : (0, $eZ1X5.attachInputMeta)(inputSource || (0, $20LLb.InputSource).EXTERNAL)((0, $fZzhT.redo)));
    };
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $30ytK.keymapPlugin)(api)
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $kVmKj.createPlugin)(options)
                }
            ];
            if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $5KWxh.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("eZ1X5", function(module, exports) {

$parcel$export(module.exports, "attachInputMeta", () => $22e4ba3e2ea54174$export$84d159245233a2bb);
$parcel$export(module.exports, "attachInputMetaWithAnalytics", () => $22e4ba3e2ea54174$export$5b05f10224c3caf8);

var $gkwXh = parcelRequire("gkwXh");

var $14FOE = parcelRequire("14FOE");

var $20LLb = parcelRequire("20LLb");

var $5EXQ9 = parcelRequire("5EXQ9");
const $22e4ba3e2ea54174$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $5EXQ9.pluginKey), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };
const $22e4ba3e2ea54174$var$inputSourceToInputMethod = (inputSource)=>{
    switch(inputSource){
        case (0, $20LLb.InputSource).EXTERNAL:
            return (0, $gkwXh.INPUT_METHOD).EXTERNAL;
        case (0, $20LLb.InputSource).KEYBOARD:
            return (0, $gkwXh.INPUT_METHOD).KEYBOARD;
        case (0, $20LLb.InputSource).TOOLBAR:
            return (0, $gkwXh.INPUT_METHOD).TOOLBAR;
        default:
            return (0, $gkwXh.INPUT_METHOD).EXTERNAL;
    }
};
const $22e4ba3e2ea54174$export$5b05f10224c3caf8 = (editorAnalyticsAPI)=>(inputSource, action)=>(command)=>$22e4ba3e2ea54174$export$84d159245233a2bb(inputSource)((0, $14FOE.withAnalytics)(editorAnalyticsAPI, {
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: action,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).EDITOR,
                attributes: {
                    inputMethod: $22e4ba3e2ea54174$var$inputSourceToInputMethod(inputSource)
                }
            })(command));

});
parcelRegister("20LLb", function(module, exports) {

$parcel$export(module.exports, "InputSource", () => $a9d033a76b963a3b$export$c3de12c0810a343d);

var $gkwXh = parcelRequire("gkwXh");
var $a9d033a76b963a3b$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource[InputSource["TOOLBAR"] = (0, $gkwXh.INPUT_METHOD).TOOLBAR] = "TOOLBAR";
    InputSource[InputSource["KEYBOARD"] = (0, $gkwXh.INPUT_METHOD).KEYBOARD] = "KEYBOARD";
    InputSource[InputSource["EXTERNAL"] = (0, $gkwXh.INPUT_METHOD).EXTERNAL] = "EXTERNAL";
    return InputSource;
}({});

});

parcelRegister("5EXQ9", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $99719005f73bb72b$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $99719005f73bb72b$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('undoRedoPlugin');

});


parcelRegister("30ytK", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $249c61699bfcf173$export$e832373cff8dec22);

var $e9qoo = parcelRequire("e9qoo");

var $5KWxh = parcelRequire("5KWxh");

var $vWFRY = parcelRequire("vWFRY");

var $VSDnB = parcelRequire("VSDnB");

var $3WJ7e = parcelRequire("3WJ7e");
function $249c61699bfcf173$export$e832373cff8dec22(api) {
    const list = {};
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redo)), (0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? (0, $3WJ7e.redoFromKeyboardWithAnalytics)(api?.analytics?.actions) : (0, $3WJ7e.redoFromKeyboard), list);
    if ((0, $VSDnB.fg)('platform_editor_cmd_y_mac_redo_shortcut')) (0, $e9qoo.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.findKeyMapForBrowser)((0, $e9qoo.redoAlt)), (0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? (0, $3WJ7e.redoFromKeyboardWithAnalytics)(api?.analytics?.actions) : (0, $3WJ7e.redoFromKeyboard), list);
    (0, $e9qoo.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $e9qoo.undo).common, (0, $VSDnB.fg)('platform_editor_controls_patch_analytics') ? (0, $3WJ7e.undoFromKeyboardWithAnalytics)(api?.analytics?.actions) : (0, $3WJ7e.undoFromKeyboard), list);
    return new (0, $5KWxh.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $e9qoo.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $vWFRY.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("3WJ7e", function(module, exports) {

$parcel$export(module.exports, "undoFromKeyboard", () => $3d40a00c1f581dab$export$1d1a6834315b2876);
$parcel$export(module.exports, "redoFromKeyboard", () => $3d40a00c1f581dab$export$b51f9da6d7e523d2);
$parcel$export(module.exports, "undoFromToolbar", () => $3d40a00c1f581dab$export$841850d252e034f0);
$parcel$export(module.exports, "redoFromToolbar", () => $3d40a00c1f581dab$export$11ad0a77a5cc0ccf);
$parcel$export(module.exports, "undoFromKeyboardWithAnalytics", () => $3d40a00c1f581dab$export$4c45d895aa8430e8);
$parcel$export(module.exports, "redoFromKeyboardWithAnalytics", () => $3d40a00c1f581dab$export$1f3073e8f226f307);
$parcel$export(module.exports, "undoFromToolbarWithAnalytics", () => $3d40a00c1f581dab$export$a9ef7677c700995e);
$parcel$export(module.exports, "redoFromToolbarWithAnalytics", () => $3d40a00c1f581dab$export$1746c262152d0cc4);

var $gkwXh = parcelRequire("gkwXh");

var $fZzhT = parcelRequire("fZzhT");

var $eZ1X5 = parcelRequire("eZ1X5");

var $20LLb = parcelRequire("20LLb");
const $3d40a00c1f581dab$export$1d1a6834315b2876 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).KEYBOARD)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$b51f9da6d7e523d2 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).KEYBOARD)((0, $fZzhT.redo));
const $3d40a00c1f581dab$export$841850d252e034f0 = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).TOOLBAR)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$11ad0a77a5cc0ccf = (0, $eZ1X5.attachInputMeta)((0, $20LLb.InputSource).TOOLBAR)((0, $fZzhT.redo));
const $3d40a00c1f581dab$export$4c45d895aa8430e8 = (editorAnalyticsAPI)=>(0, $eZ1X5.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $20LLb.InputSource).KEYBOARD, (0, $gkwXh.ACTION).UNDO_PERFORMED)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$1f3073e8f226f307 = (editorAnalyticsAPI)=>(0, $eZ1X5.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $20LLb.InputSource).KEYBOARD, (0, $gkwXh.ACTION).REDO_PERFORMED)((0, $fZzhT.redo));
const $3d40a00c1f581dab$export$a9ef7677c700995e = (editorAnalyticsAPI)=>(0, $eZ1X5.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $20LLb.InputSource).TOOLBAR, (0, $gkwXh.ACTION).UNDO_PERFORMED)((0, $fZzhT.undo));
const $3d40a00c1f581dab$export$1746c262152d0cc4 = (editorAnalyticsAPI)=>(0, $eZ1X5.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $20LLb.InputSource).TOOLBAR, (0, $gkwXh.ACTION).REDO_PERFORMED)((0, $fZzhT.redo));

});


parcelRegister("kVmKj", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $68e14e6d3530e7bb$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $5EXQ9 = parcelRequire("5EXQ9");
const $68e14e6d3530e7bb$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $5EXQ9.pluginKey)
    });
};

});

parcelRegister("345K8", function(module, exports) {

$parcel$export(module.exports, "forceFocus", () => $1196bde9495f2f91$export$4126ecb6f20789f0);
const $1196bde9495f2f91$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        if (!editorView) return false;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
        return true;
    };
const $1196bde9495f2f91$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $1196bde9495f2f91$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };

});

parcelRegister("cBhLR", function(module, exports) {

$parcel$export(module.exports, "default", () => $343b86e0a69d2f8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $7qATA = parcelRequire("7qATA");
var $awTmI = parcelRequire("awTmI");

var $e9qoo = parcelRequire("e9qoo");

var $7S9ZN = parcelRequire("7S9ZN");

var $ejItq = parcelRequire("ejItq");

var $l4tMX = parcelRequire("l4tMX");
var $1jI4k = parcelRequire("1jI4k");

var $9LY0t = parcelRequire("9LY0t");

var $eGW7v = parcelRequire("eGW7v");

var $9H08G = parcelRequire("9H08G");

var $VSDnB = parcelRequire("VSDnB");

var $3WJ7e = parcelRequire("3WJ7e");

var $345K8 = parcelRequire("345K8");
const $343b86e0a69d2f8f$var$useSharedState = (0, $7qATA.sharedPluginStateHookMigratorFactory)((api)=>{
    const canUndo = (0, $9LY0t.useSharedPluginStateSelector)(api, 'history.canUndo');
    const canRedo = (0, $9LY0t.useSharedPluginStateSelector)(api, 'history.canRedo');
    return {
        canUndo: canUndo,
        canRedo: canRedo
    };
}, (api)=>{
    const { historyState: historyState } = (0, $awTmI.useSharedPluginState)(api, [
        'history'
    ]);
    return {
        canUndo: historyState?.canUndo,
        canRedo: historyState?.canRedo
    };
});
const $343b86e0a69d2f8f$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { canUndo: canUndo, canRedo: canRedo } = $343b86e0a69d2f8f$var$useSharedState(api);
    const handleUndo = ()=>{
        if ((0, $VSDnB.fg)('platform_editor_controls_patch_analytics')) (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.undoFromToolbarWithAnalytics)(api?.analytics?.actions));
        else (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.undoFromToolbar));
    };
    const handleRedo = ()=>{
        if ((0, $VSDnB.fg)('platform_editor_controls_patch_analytics')) (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.redoFromToolbarWithAnalytics)(api?.analytics?.actions));
        else (0, $345K8.forceFocus)(editorView, api)((0, $3WJ7e.redoFromToolbar));
    };
    const labelUndo = formatMessage((0, $7S9ZN.messages).undo);
    const labelRedo = formatMessage((0, $7S9ZN.messages).redo);
    const redoKeymap = (0, $VSDnB.fg)('platform_editor_cmd_y_mac_redo_shortcut') ? (0, $e9qoo.redoAlt) : (0, $e9qoo.redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $ejItq.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $e9qoo.tooltip)((0, $e9qoo.undo), labelUndo),
        "aria-keyshortcuts": (0, $e9qoo.getAriaKeyshortcuts)((0, $e9qoo.undo)),
        title: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $e9qoo.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9H08G))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jI4k.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $l4tMX.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e9qoo.ToolTipContent), {
            description: labelRedo,
            keymap: redoKeymap
        }),
        iconBefore: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGW7v))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $e9qoo.tooltip)(redoKeymap, labelRedo),
        "aria-keyshortcuts": (0, $e9qoo.getAriaKeyshortcuts)(redoKeymap)
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ejItq.separatorStyles)
    })));
};
var $343b86e0a69d2f8f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($343b86e0a69d2f8f$export$4a0f2fb817767d20);

});
parcelRegister("eGW7v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d059f3ea6105a0395a3e73a1cc411ccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab22125c947bd831$var$_react = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab22125c947bd831$var$_redo = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("51dEo")));

var $ab22125c947bd831$var$_redo2 = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5Pf2J")));
function $ab22125c947bd831$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RedoIcon.
 * This component is RedoIcon, with `UNSAFE_fallbackIcon` set to "RedoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab22125c947bd831$var$RedoIcon = (props)=>/*#__PURE__*/ $ab22125c947bd831$var$_react.default.createElement($ab22125c947bd831$var$_redo.default, Object.assign({
        LEGACY_fallbackIcon: $ab22125c947bd831$var$_redo2.default
    }, props));
$ab22125c947bd831$var$RedoIcon.Name = 'RedoIconMigration';
var $ab22125c947bd831$var$_default = module.exports.default = $ab22125c947bd831$var$RedoIcon;

});
parcelRegister("51dEo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f579057b3cb3a0df31aba248715041d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a77a26e43f67a2e$var$_react = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a77a26e43f67a2e$var$_baseNew = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3a77a26e43f67a2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a77a26e43f67a2e$var$RedoIcon = (props)=>/*#__PURE__*/ $3a77a26e43f67a2e$var$_react.default.createElement($3a77a26e43f67a2e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 1 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$3a77a26e43f67a2e$var$RedoIcon.displayName = 'RedoIcon';
var $3a77a26e43f67a2e$var$_default = module.exports.default = $3a77a26e43f67a2e$var$RedoIcon;

});

parcelRegister("5Pf2J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01183743c30bdd8e$var$_react = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $01183743c30bdd8e$var$_redo = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("51dEo")));
function $01183743c30bdd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01183743c30bdd8e$var$RedoIcon = (props)=>/*#__PURE__*/ $01183743c30bdd8e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
    }, props, {
        newIcon: $01183743c30bdd8e$var$_redo.default
    }));
$01183743c30bdd8e$var$RedoIcon.displayName = 'RedoIcon';
var $01183743c30bdd8e$var$_default = module.exports.default = $01183743c30bdd8e$var$RedoIcon;

});


parcelRegister("9H08G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2818f986336a4a51aa47fe5286974737>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70e83ccc33b2569d$var$_react = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $70e83ccc33b2569d$var$_undo = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("7sLAO")));

var $70e83ccc33b2569d$var$_undo2 = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("80QYV")));
function $70e83ccc33b2569d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70e83ccc33b2569d$var$UndoIcon = (props)=>/*#__PURE__*/ $70e83ccc33b2569d$var$_react.default.createElement($70e83ccc33b2569d$var$_undo.default, Object.assign({
        LEGACY_fallbackIcon: $70e83ccc33b2569d$var$_undo2.default
    }, props));
$70e83ccc33b2569d$var$UndoIcon.Name = 'UndoIconMigration';
var $70e83ccc33b2569d$var$_default = module.exports.default = $70e83ccc33b2569d$var$UndoIcon;

});
parcelRegister("7sLAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56f010d97236ea23$var$_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $56f010d97236ea23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56f010d97236ea23$var$UndoIcon = (props)=>/*#__PURE__*/ $56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;

});

parcelRegister("80QYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d576be12f027bbc$var$_react = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5d576be12f027bbc$var$_undo = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("7sLAO")));
function $5d576be12f027bbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d576be12f027bbc$var$UndoIcon = (props)=>/*#__PURE__*/ $5d576be12f027bbc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props, {
        newIcon: $5d576be12f027bbc$var$_undo.default
    }));
$5d576be12f027bbc$var$UndoIcon.displayName = 'UndoIcon';
var $5d576be12f027bbc$var$_default = module.exports.default = $5d576be12f027bbc$var$UndoIcon;

});





parcelRegister("V5Jck", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => (parcelRequire("5qc2Z")).unsupportedContentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5qc2Z = parcelRequire("5qc2Z");

});
parcelRegister("5qc2Z", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentPlugin", () => $b0894ce66585f313$export$fae834324d89b92);

var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $j8AmE = parcelRequire("j8AmE");
var $5BVRS = parcelRequire("5BVRS");

var $5KWxh = parcelRequire("5KWxh");

var $iiXGq = parcelRequire("iiXGq");

var $gZGBX = parcelRequire("gZGBX");

var $51CLa = parcelRequire("51CLa");
const $b0894ce66585f313$var$pluginKey = new (0, $gZGBX.PluginKey)('unsupportedContentPlugin');
const $b0894ce66585f313$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
    return new (0, $5KWxh.SafePlugin)({
        key: $b0894ce66585f313$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $j8AmE.default).fromComponent((0, $iiXGq.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $5BVRS.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $51CLa.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $j8AmE.default).fromComponent((0, $iiXGq.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $5BVRS.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $51CLa.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
const $b0894ce66585f313$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $jxVez.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $lVmBd.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $5y0tR.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $bd7A9.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $d1d6m.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $6kr5W.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $b0894ce66585f313$var$createPlugin
                }
            ];
        }
    });

});
parcelRegister("51CLa", function(module, exports) {

$parcel$export(module.exports, "UnsupportedInlineNodeView", () => $331f4959d8d278db$export$b963567668795b80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9kpKZ = parcelRequire("9kpKZ");
const $331f4959d8d278db$export$b963567668795b80 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9kpKZ.default), props);
};

});



parcelRegister("kMiBI", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => (parcelRequire("bTGGC")).widthPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bTGGC = parcelRequire("bTGGC");

});
parcelRegister("bTGGC", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => $270b3b79fc31e80e$export$8cdf857cb01de6dc);

var $jEEXJ = parcelRequire("jEEXJ");

var $gmhCD = parcelRequire("gmhCD");

var $5t0XF = parcelRequire("5t0XF");

var $kmA2l = parcelRequire("kmA2l");

var $ggOPR = parcelRequire("ggOPR");
const $270b3b79fc31e80e$var$useResizeWidthObserverHook = (0, $jEEXJ.conditionalHooksFactory)(()=>(0, $gmhCD.editorExperiment)('platform_editor_stop_width_reflows', true, {
        exposure: true
    }), (0, $ggOPR.useResizeWidthObserver), (0, $ggOPR.useResizeWidthObserverLegacy));
const $270b3b79fc31e80e$export$8cdf857cb01de6dc = ()=>{
    return {
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $5t0XF.createPlugin)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $kmA2l.pluginKey).getState(editorState);
        },
        usePluginHook: $270b3b79fc31e80e$var$useResizeWidthObserverHook
    };
};

});
parcelRegister("5t0XF", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $459b9f5d8f6ef73b$export$ae829ec7b2625219);

var $5KWxh = parcelRequire("5KWxh");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $kmA2l = parcelRequire("kmA2l");
function $459b9f5d8f6ef73b$export$ae829ec7b2625219(dispatch) {
    return new (0, $5KWxh.SafePlugin)({
        key: (0, $kmA2l.pluginKey),
        state: {
            init: ()=>{
                if ((0, $gmhCD.editorExperiment)('platform_editor_stop_width_reflows', true)) return {
                    // Optimise for default laptop MDPI width - this will update with the resize observer
                    width: (0, $iHYdz.VIEWPORT_SIZES).laptopMDPI.width,
                    // Use the default width - if full width or small it will update with resize observer
                    lineLength: (0, $iHYdz.akEditorDefaultLayoutWidth)
                };
                else return {
                    width: document.body.offsetWidth
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $kmA2l.pluginKey));
                if (!meta) return pluginState;
                const newPluginState = (0, $gmhCD.editorExperiment)('platform_editor_stop_width_reflows', true) ? {
                    width: meta.width ?? pluginState?.width,
                    lineLength: meta.lineLength ?? pluginState?.lineLength
                } : {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $kmA2l.pluginKey), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("kmA2l", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $ff8b08c35ee6f5de$export$18d4026d1ea86bb1);

var $gZGBX = parcelRequire("gZGBX");
const $ff8b08c35ee6f5de$export$18d4026d1ea86bb1 = new (0, $gZGBX.PluginKey)('widthPlugin');

});


parcelRegister("ggOPR", function(module, exports) {

$parcel$export(module.exports, "useResizeWidthObserver", () => $d118631b559ea5d3$export$b0f894529c6bfe0a);
$parcel$export(module.exports, "useResizeWidthObserverLegacy", () => $d118631b559ea5d3$export$9a025523457e85c9);

var $5uXOq = parcelRequire("5uXOq");

var $kmA2l = parcelRequire("kmA2l");

var $5U0zH = parcelRequire("5U0zH");
const $d118631b559ea5d3$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $kmA2l.pluginKey), props);
        dispatch(tr);
    };
function $d118631b559ea5d3$export$b0f894529c6bfe0a({ editorView: editorView, containerElement: containerElement }) {
    (0, $5U0zH.useRefreshWidthOnTransition)(containerElement);
    (0, $5uXOq.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length < 1) return;
            const fullAreaSize = entries.find((entry)=>entry.target === containerElement);
            const editorViewDOMSize = entries.find((entry)=>entry.target === editorView.dom);
            const width = fullAreaSize?.borderBoxSize[0]?.inlineSize;
            const lineLength = editorViewDOMSize?.borderBoxSize[0]?.inlineSize;
            $d118631b559ea5d3$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        if (editorView.dom) resizeObserver.observe(editorView.dom);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
}
const $d118631b559ea5d3$export$9a025523457e85c9 = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $5U0zH.useRefreshWidthOnTransition)(containerElement);
    (0, $5uXOq.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $d118631b559ea5d3$export$33d12d97a81b0d33(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $d118631b559ea5d3$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});
parcelRegister("5U0zH", function(module, exports) {

$parcel$export(module.exports, "useRefreshWidthOnTransition", () => $2e70303078c4f6e0$export$b72edfd730e58e7c);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
// List of names for transition end events across browsers
const $2e70303078c4f6e0$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $2e70303078c4f6e0$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!containerElement) return;
        /**
		 * Update the plugin components once the transition
		 * to full width / default mode completes
		 */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $cBeZP.bindAll)(containerElement, $2e70303078c4f6e0$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};

});







parcelRegister("iNY3w", function(module, exports) {

$parcel$export(module.exports, "DueDateFieldTypeConfig", () => $c9f18c52a31bf116$export$1f36cc37f9d9ead0);

var $5uXOq = parcelRequire("5uXOq");

var $hyKRO = parcelRequire("hyKRO");

var $iY8FG = parcelRequire("iY8FG");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $c9f18c52a31bf116$var$DueDateFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY8FG.default), props);
const $c9f18c52a31bf116$export$1f36cc37f9d9ead0 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))),
    type: (0, $5fc53.DUE_DATE_TYPE),
    Component: $c9f18c52a31bf116$var$DueDateFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DateFieldPlaceholder), null),
    writer: (0, $kShoa.dateFieldWriter)
};

});

parcelRegister("jbGY4", function(module, exports) {

$parcel$export(module.exports, "GroupCustomFieldTypeConfig", () => $6b8eaafecaddddf0$export$fcafcf9905a0ab43);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $3Z98Z = parcelRequire("3Z98Z");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z98Z.default), props);
const $6b8eaafecaddddf0$export$fcafcf9905a0ab43 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.GROUP_CF_TYPE),
    Component: $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.singleGroupPickerFieldWriter)
};

});
parcelRegister("3Z98Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebb6e060acd861c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $d8h6M = parcelRequire("d8h6M");

const $4ebb6e060acd861c$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        "aria-labelledby": ariaLabelledBy,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $4ebb6e060acd861c$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $d8h6M.transformGroupDefaultValueToUserOption)
})($4ebb6e060acd861c$var$SingleGroupPickerField);

});
parcelRegister("9EuZf", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $378ea0219a6c1ff7$export$ddd4b90ea2d7a329);

var $gwIPs = parcelRequire("gwIPs");
const $378ea0219a6c1ff7$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $gwIPs.layers).modal)
        })
};

});

parcelRegister("5fnvk", function(module, exports) {

$parcel$export(module.exports, "default", () => $81263082e0845513$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $cr0SA = parcelRequire("cr0SA");

var $koVbs = parcelRequire("koVbs");

var $arYvt = parcelRequire("arYvt");

var $hSBXu = parcelRequire("hSBXu");

var $lGKF5 = parcelRequire("lGKF5");

var $3PgDR = parcelRequire("3PgDR");
const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const previousQuery = (0, $5uXOq.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $hSBXu.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
    const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $3PgDR.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $arYvt.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $lGKF5.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;

});
parcelRegister("arYvt", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $70d728bf86d0ecee$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $70d728bf86d0ecee$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $70d728bf86d0ecee$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $70d728bf86d0ecee$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $70d728bf86d0ecee$export$705009f1a414da46);
const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("hSBXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9613200b5cbe8cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");

var $arYvt = parcelRequire("arYvt");
const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $eusud.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $arYvt.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;

});

parcelRegister("lGKF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d585cea41a3a80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("3PgDR", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $2e61feb10eb63767$export$f204658c943efb85);
const $2e61feb10eb63767$export$f204658c943efb85 = {
    borderColor: "var(--ds-border-danger, #E2483D)"
};

});


parcelRegister("d8h6M", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $dab4f2debb035d9d$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $dab4f2debb035d9d$export$daeca2ffaa5d8b62);

var $arYvt = parcelRequire("arYvt");

const $dab4f2debb035d9d$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $dab4f2debb035d9d$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $b977eeb5f24a5299$export$31fd86f8f183952c)
    });

});
const $b977eeb5f24a5299$export$31fd86f8f183952c = 'singleGroupPickerFields';




parcelRegister("awO6U", function(module, exports) {

$parcel$export(module.exports, "LabelsCustomFieldTypeConfig", () => $337cc26aaa6435a9$export$c08ea7a9c6fbd5e0);

var $5uXOq = parcelRequire("5uXOq");

var $eKl4L = parcelRequire("eKl4L");

var $8GQyc = parcelRequire("8GQyc");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GQyc.default), props);
const $337cc26aaa6435a9$export$c08ea7a9c6fbd5e0 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))),
    type: (0, $5fc53.LABELS_CF_TYPE),
    Component: $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.labelsFieldWriter)
};

});
parcelRegister("8GQyc", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $34600c8cb7aa4373$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $34600c8cb7aa4373$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $800rQ = parcelRequire("800rQ");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $evGBv = parcelRequire("evGBv");

const $34600c8cb7aa4373$var$LabelsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $800rQ.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
const $34600c8cb7aa4373$export$f77bab10d748bb71 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateForgeLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);
var $34600c8cb7aa4373$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateLabelField),
    transformDefaultValue: (0, $evGBv.mapDataToLabelOptions)
})($34600c8cb7aa4373$var$LabelsField);

});
parcelRegister("800rQ", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $392f4ecadcf70f0f$export$23584166c0ffb901);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $lFKmC = parcelRequire("lFKmC");

var $7Jxgt = parcelRequire("7Jxgt");

var $bChGW = parcelRequire("bChGW");

var $42CjB = parcelRequire("42CjB");

var $5nRKm = parcelRequire("5nRKm");

var $bUmQV = parcelRequire("bUmQV");

var $k5uoT = parcelRequire("k5uoT");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $5fc53 = parcelRequire("5fc53");

var $1ZQPi = parcelRequire("1ZQPi");

var $7ldcY = parcelRequire("7ldcY");

var $lpRLe = parcelRequire("lpRLe");

var $ek97b = parcelRequire("ek97b");

var $jgJNO = parcelRequire("jgJNO");

var $6s1PB = parcelRequire("6s1PB");

var $dCm1o = parcelRequire("dCm1o");

var $2QTbq = parcelRequire("2QTbq");

var $l2SvC = parcelRequire("l2SvC");

var $e3wnO = parcelRequire("e3wnO");

var $l5gEe = parcelRequire("l5gEe");
const $392f4ecadcf70f0f$export$251bdbdbce9550ea = 300;
const $392f4ecadcf70f0f$var$multiValueStyles = {
    root: "_hn7lze3t _ujoyze3t",
    isVisualRefreshDisabled: "_2rkoiti9 _bfhk18uv _1vxp1b66 _1onpze3t _3lltze3t _k4bfze3t"
};
const $392f4ecadcf70f0f$var$multiValueLabelStyles = {
    root: "_1oqf3acm"
};
const $392f4ecadcf70f0f$var$multiValueRemoveStyles = {
    root: "_1tga113p _11lgglyw _1e22lcct _wb7e1iit _gy631fxt _13dibs82"
};
const $392f4ecadcf70f0f$var$labelsValueStyles = {
    multiValue: (base, { data: data })=>{
        // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
        const dataLabel = data.label;
        const { backgroundColor: backgroundColorMilestone1 } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(dataLabel));
        const isNewLabel = data.__isNew__;
        const newLabelColor = data.color ?? 'GREY';
        const oldLabelColor = data.color ?? (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(dataLabel);
        const { backgroundColor: backgroundColorMilestone2 } = (0, $ek97b.getColorMetadata)(isNewLabel ? newLabelColor : oldLabelColor);
        const backgroundColor = (0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? backgroundColorMilestone2 : backgroundColorMilestone1;
        return {
            ...base,
            border: `1px solid ${backgroundColor}`,
            '& > div > div > div': {
                paddingLeft: 0,
                paddingRight: 0
            },
            ...!(0, $dCm1o.isVisualRefreshEnabled)() ? {
                borderRadius: "var(--ds-border-radius-100, 4px)",
                backgroundColor: 'transparent',
                '& > div': {
                    paddingLeft: "var(--ds-space-050, 4px)",
                    paddingRight: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            } : {}
        };
    },
    multiValueLabel: (base)=>({
            ...base,
            '& > div > div': {
                borderColor: 'transparent'
            }
        })
};
const $392f4ecadcf70f0f$var$labelsRemoveIconStyles = {
    multiValueRemove: (base)=>({
            ...base,
            '& > div > span > svg': {
                transform: 'scale(1.5)',
                fill: 'none'
            },
            '& > div > span > svg > g > path': {
                d: 'path("m 2 10 l 4 -4 m 4 -4 L 6 6 m 0 0 L 2 2 m 4 4 l 4 4")',
                transform: 'translate(5px, 6px)',
                stroke: "var(--ds-text, #172B4D)",
                strokeWidth: '1.5'
            }
        })
};
const $392f4ecadcf70f0f$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $l2SvC.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $l5gEe.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $2QTbq.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $l5gEe.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $l5gEe.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $392f4ecadcf70f0f$export$251bdbdbce9550ea), []);
    const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $l5gEe.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $l5gEe.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $l5gEe.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const [selectedLabelForEdit, setSelectedLabelForEdit] = (0, $5uXOq.useState)();
    const [showColorPickerPopup, setShowColorPickerPopup] = (0, $5uXOq.useState)(false);
    const [showColorPickerPopupWhenCreated, setShowColorPickerPopupWhenCreated] = (0, $5uXOq.useState)(false);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((selectedLabels)=>{
        if (!selectedLabels) return;
        const allLabels = [
            ...cachedOptions ?? [],
            ...suggestions ?? []
        ];
        const selectedLabelsCount = selectedLabels.length;
        onChange?.(selectedLabels);
        const isNewLabel = !allLabels.some((option)=>{
            // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
            const optionLabel = option.label;
            return optionLabel === selectedLabels[selectedLabelsCount - 1].label;
        });
        if (isNewLabel) {
            const newLabel = {
                ...selectedLabels[selectedLabelsCount - 1]
            };
            newLabel.__isNew__ = true;
            setSelectedLabelForEdit(selectedLabels[selectedLabelsCount - 1]);
            setShowColorPickerPopupWhenCreated(true);
        }
    }, [
        cachedOptions,
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = isLoadingSuggestions;
    const onEditOption = (option)=>{
        setSelectedLabelForEdit(option);
        setShowColorPickerPopup(true);
    };
    const resetLabelsColorPickerState = ()=>{
        setSelectedLabelForEdit(undefined);
        setShowColorPickerPopup(false);
        setShowColorPickerPopupWhenCreated(false);
    };
    const submitLabelsUpdatedColor = (param)=>{
        if (!selectedLabelForEdit || !value) return;
        const updatedColoredValue = value && value.map((val)=>{
            const isNewLabel = val.__isNew__;
            return {
                ...val,
                ...isNewLabel ? {
                    color: param?.color
                } : {}
            };
        });
        onChange?.(updatedColoredValue);
    };
    const popupContent = ()=>{
        const isNewLabel = selectedLabelForEdit?.__isNew__;
        const newLabelColor = selectedLabelForEdit?.color ?? '';
        const oldLabelColor = selectedLabelForEdit?.color ?? (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(selectedLabelForEdit?.label?.toString());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ZQPi.LabelsColorPickerForm), {
            onCancel: ()=>{
                resetLabelsColorPickerState();
            },
            onSubmit: (param)=>{
                resetLabelsColorPickerState();
                submitLabelsUpdatedColor(param);
            },
            initialData: {
                name: selectedLabelForEdit?.label?.toString() ?? '',
                color: isNewLabel ? newLabelColor : oldLabelColor
            }
        });
    };
    const styles = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
            if (!(0, $dCm1o.isVisualRefreshEnabled)()) return {
                ...(0, $lElIo.defaultSelectStyles),
                ...$392f4ecadcf70f0f$var$labelsValueStyles,
                ...$392f4ecadcf70f0f$var$labelsRemoveIconStyles
            };
            return {
                ...(0, $lElIo.defaultSelectStyles),
                ...$392f4ecadcf70f0f$var$labelsValueStyles
            };
        }
        return 0, $lElIo.defaultSelectStyles;
    }, []);
    const labelsField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e3wnO.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: isDisabled,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        styles: styles,
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $l5gEe.default).placeholder),
        onInputChange: onQueryChange,
        onChange: (0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? handleOnChange : onChange,
        spacing: spacing,
        isLoading: isLoading,
        filterOption: filterOption,
        formatCreateLabel: getCreateLabel,
        ...!(0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) && (0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            formatOptionLabel: (option)=>$392f4ecadcf70f0f$var$RenderLabel(option, `(${formatMessage((0, $l5gEe.default).createNewItem)})`)
        } : {},
        ...(0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            components: {
                MultiValueContainer: (multiValueProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueContainer, {
                        ...multiValueProps,
                        xcss: (0, $DEWI6.cx)($392f4ecadcf70f0f$var$multiValueStyles.root, !(0, $dCm1o.isVisualRefreshEnabled)() && $392f4ecadcf70f0f$var$multiValueStyles.isVisualRefreshDisabled)
                    }),
                MultiValueLabel: (multiValueLabelProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueLabel, {
                        ...multiValueLabelProps,
                        xcss: $392f4ecadcf70f0f$var$multiValueLabelStyles.root
                    }),
                MultiValueRemove: (multiValueRemoveProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValueRemove, {
                        ...multiValueRemoveProps,
                        xcss: !(0, $dCm1o.isVisualRefreshEnabled)() && $392f4ecadcf70f0f$var$multiValueRemoveStyles.root
                    }),
                Option: (optionProps)=>{
                    if ((0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, optionProps, $392f4ecadcf70f0f$var$RenderLabel(optionProps.data, `(${formatMessage((0, $l5gEe.default).createNewItem)})`, onEditOption));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, optionProps);
                }
            }
        } : {},
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus
    });
    return (showColorPickerPopup || showColorPickerPopupWhenCreated) && (0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        zIndex: (0, $k5uoT.layers).modal(),
        isOpen: showColorPickerPopup || showColorPickerPopupWhenCreated,
        autoFocus: false,
        placement: "bottom-start",
        fallbackPlacements: [
            'bottom-end'
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                ...triggerProps,
                role: "menu"
            }, labelsField),
        popupComponent: $392f4ecadcf70f0f$var$PopupContainer,
        onClose: resetLabelsColorPickerState,
        content: popupContent,
        messageId: "issue-field-labels.ui.edit.popup.labels.popup",
        messageType: "transactional"
    }) : labelsField;
};
const $392f4ecadcf70f0f$var$RenderLabel = (option, createNewLabelString, onEditOption)=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    const optionLabel = option.label;
    if ((0, $6s1PB.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            name: optionLabel,
            color: "GREY"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            name: optionLabel,
            color: option.color ?? (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabel)
        }), $392f4ecadcf70f0f$var$RenderInlineEditButton(option, onEditOption));
    }
    if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) {
        const optionLabelWithoutNewLabel = optionLabel.slice(0, -createNewLabelString.length).trim();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
            name: optionLabel,
            color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabelWithoutNewLabel)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
        name: optionLabel,
        color: (0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(optionLabel)
    });
};
const $392f4ecadcf70f0f$var$RenderInlineEditButton = (option, onEditOption)=>{
    if (option.label) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        testId: `labels-field-edit.inline-edit-button-${option.label}`,
        isDisabled: option.isDisabled,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
        spacing: "compact",
        onClick: (event)=>{
            event.stopPropagation();
            onEditOption?.(option);
        },
        label: ""
    });
    return null;
};
const $392f4ecadcf70f0f$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    }));
var $392f4ecadcf70f0f$export$2e2bcd8739ae039 = $392f4ecadcf70f0f$export$23584166c0ffb901;

});
parcelRegister("6Vzc4", function(module, exports) {

$parcel$export(module.exports, "getFailedFetchSelectOptions", () => $9302f6c83ce60c04$export$6ed0d629c0656ce1);
$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9302f6c83ce60c04$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9302f6c83ce60c04$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9302f6c83ce60c04$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9302f6c83ce60c04$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9302f6c83ce60c04$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9302f6c83ce60c04$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $goAgE = parcelRequire("goAgE");
const $9302f6c83ce60c04$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: // @ts-expect-error ReactNode is not assignable to string (which is the only type in docs: https://atlassian.design/components/select/code). But it works
                    label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9302f6c83ce60c04$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const failedFetchMessage = (0, $goAgE.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage(failedFetchMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $goAgE.default).reloadIssueIssueTermRefresh : (0, $goAgE.default).reloadIssue))));
};
const $9302f6c83ce60c04$export$aa3357fb0ebcdb2b = (query)=>$9302f6c83ce60c04$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9302f6c83ce60c04$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9302f6c83ce60c04$export$df67068a00dece12 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9302f6c83ce60c04$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("goAgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a2287a5c23e167$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b7a2287a5c23e167$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
        "defaultMessage": "Try reloading"
    }
});

});


parcelRegister("3BhEA", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0eb6c4d40c779509$export$58bb91b619b113f6);

var $8QpSo = parcelRequire("8QpSo");

var $5JAlL = parcelRequire("5JAlL");
const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, $8QpSo.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5JAlL.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
    }));
const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("1ZQPi", function(module, exports) {

$parcel$export(module.exports, "LabelsColorPickerForm", () => $93f5367f098ecc24$export$db58e0ba069ba689);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9jL2Q = parcelRequire("9jL2Q");

var $lpRLe = parcelRequire("lpRLe");

var $1L3S5 = parcelRequire("1L3S5");

var $3cDpw = parcelRequire("3cDpw");
const $93f5367f098ecc24$export$db58e0ba069ba689 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onCancel: onCancel, onSubmit: onSubmit, initialData: initialData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { color: color, name: name } = initialData;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [currentColor, setCurrentColor] = (0, $5uXOq.useState)(!color ? (0, $1L3S5.GREY_META).name : color);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'LabelsColorPickerForm viewed');
    }, [
        createAnalyticsEvent
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'LabelsColorPickerFormSave');
        onSubmit && onSubmit({
            name: name,
            color: currentColor
        });
    }, [
        createAnalyticsEvent,
        onSubmit,
        name,
        currentColor
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        onCancel();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'LabelsColorPickerFormCancel');
    }, [
        onCancel,
        createAnalyticsEvent
    ]);
    const handleKeyDownEvent = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) handleCancel();
        if (event.key === 'Enter' || event.keyCode === 13) {
            handleSubmit();
            event.preventDefault();
        }
    }, [
        handleCancel,
        handleSubmit
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', handleKeyDownEvent, true);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDownEvent, true);
            };
        }
    }, [
        handleKeyDownEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $93f5367f098ecc24$var$formStyles,
            $93f5367f098ecc24$var$maxWidthStyles
        ],
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $93f5367f098ecc24$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $93f5367f098ecc24$var$colorPickerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9jL2Q.ColorPickerMenu), {
        onChangeColor: (newColor)=>{
            setCurrentColor(newColor);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'color clicked', 'LabelsFormColorPicker', {
                color: newColor
            });
        },
        color: currentColor,
        colorPaletteVariant: "new",
        colorCardVariant: "outline"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between",
        xcss: $93f5367f098ecc24$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $93f5367f098ecc24$var$previewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpRLe.OptionTag), {
        name: name,
        color: currentColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        spacing: "compact",
        testId: "option-color-picker.labels-color-picker.submit-button",
        onClick: handleSubmit
    }, formatMessage((0, $3cDpw.default).saveButton)))));
});
const $93f5367f098ecc24$var$formStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    display: 'block',
    padding: 'space.200',
    width: 'fit-content'
});
const $93f5367f098ecc24$var$maxWidthStyles = (0, $8CUq3.xcss)({
    maxWidth: '356px'
});
const $93f5367f098ecc24$var$colorPickerWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.150'
});
const $93f5367f098ecc24$var$formContentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
const $93f5367f098ecc24$var$previewStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $93f5367f098ecc24$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});
parcelRegister("9jL2Q", function(module, exports) {

$parcel$export(module.exports, "ColorPickerMenu", () => $4871f580bea1e373$export$4f039f014adbb6f0);

var $5uXOq = parcelRequire("5uXOq");

var $lGTQx = parcelRequire("lGTQx");
var $3zNHM = parcelRequire("3zNHM");

var $koVbs = parcelRequire("koVbs");

var $1L3S5 = parcelRequire("1L3S5");

var $ek97b = parcelRequire("ek97b");
const $4871f580bea1e373$export$4f039f014adbb6f0 = ({ color: color, onChangeColor: onChangeColor, colorPaletteVariant: colorPaletteVariant = 'old', colorCardVariant: colorCardVariant = 'fill' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const colorPalette = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const colorPaletteOld = (0, $1L3S5.OPTION_COLOR_THEMES).map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const handleChangeColor = (0, $5uXOq.useCallback)((e, newColor)=>{
        onChangeColor((0, $ek97b.getColorNameFromValue)(newColor));
        e.stopPropagation();
    }, [
        onChangeColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGTQx.default), {
        cols: colorPaletteVariant === 'old' ? colorPaletteOld.length / 5 : colorPalette.length,
        palette: colorPaletteVariant === 'old' ? colorPaletteOld : colorPalette,
        selectedColor: (0, $ek97b.getValueFromColorName)(color),
        onChange: handleChangeColor,
        mode: (0, $3zNHM.Compact),
        checkMarkColor: color.includes('LIGHT') ? (0, $1L3S5.CHECK_MARK_COLOR_LIGHT) : (0, $1L3S5.CHECK_MARK_COLOR_DARK),
        autoFocus: false,
        isFocusLockEnabled: false,
        isInsideMenu: false,
        variant: colorCardVariant
    });
};

});
parcelRegister("lGTQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e30770a4da4328$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kD00A = parcelRequire("kD00A");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");

const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $5uXOq.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
            case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
            case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $kD00A.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $kD00A.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
                        type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $cb25w.default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
const $c5e30770a4da4328$var$colorCardWrapperStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerStyles = null;
const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStyles = null;
const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = null;

});
parcelRegister("kD00A", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $e25de60b37efd75a$export$9484bbecc3c49a2e);
var $e25de60b37efd75a$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});

parcelRegister("l0sd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d681a23420d49946$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eJbwP = parcelRequire("eJbwP");

var $3bDjY = parcelRequire("3bDjY");



var $bWn3s = parcelRequire("bWn3s");
const $d681a23420d49946$var$ColorCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $5uXOq.useRef)(null);
    const isInitialFocus = (0, $5uXOq.useRef)(true);
    const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $bWn3s.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $bwpsq.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $bwpsq.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
const $d681a23420d49946$var$colorCardOptionTabbingStyles = null;
const $d681a23420d49946$var$colorCardOptionFocusedStyles = null;
const $d681a23420d49946$var$sharedColorContainerStyles = null;
const $d681a23420d49946$var$colorCardWrapperStyles = null;
const $d681a23420d49946$var$colorCardContentStyles = null;
const $d681a23420d49946$var$colorCardContentStylesOutline = null;

});
const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';


parcelRegister("5dAp2", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $38874a93fb14a10d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $38874a93fb14a10d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $k5uoT = parcelRequire("k5uoT");


var $8QpSo = parcelRequire("8QpSo");

var $kD00A = parcelRequire("kD00A");
const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, $k5uoT.gridSize)() / 2);
    return mode === (0, $kD00A.Mode).Standard ? width + (0, $k5uoT.gridSize)() : width;
};
const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});


parcelRegister("3zNHM", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $06f62cb25bd09d8d$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $06f62cb25bd09d8d$export$2e2bcd8739ae039);

var $3PpqK = parcelRequire("3PpqK");

var $kD00A = parcelRequire("kD00A");

var $lGTQx = parcelRequire("lGTQx");
const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);

});
parcelRegister("3PpqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f994db29f75e4622$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $b9dFI = parcelRequire("b9dFI");

var $1ErJq = parcelRequire("1ErJq");

var $jKrb6 = parcelRequire("jKrb6");


var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $5dAp2 = parcelRequire("5dAp2");

var $8RXs9 = parcelRequire("8RXs9");

var $VSDnB = parcelRequire("VSDnB");

var $7oXeG = parcelRequire("7oXeG");
const $f994db29f75e4622$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $f994db29f75e4622$var$packageName = "platform-pkg";
const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
        const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9dFI.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    ref: ref,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $jKrb6,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            ...(0, $VSDnB.fg)('one_event_rules_them_all_fg') && {
                onMenuOpen: this.props.onMenuOpen
            }
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $f994db29f75e4622$var$packageName,
                    packageVersion: $f994db29f75e4622$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, $8RXs9.default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, $994MI.default)({
    componentName: 'color-picker',
    packageName: $f994db29f75e4622$var$packageName,
    packageVersion: $f994db29f75e4622$var$packageVersion
})((0, $cb25w.default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
const $f994db29f75e4622$var$colorCardWrapperStyles = null;

});
parcelRegister("1ErJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $609735830782207d$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $VSDnB = parcelRequire("VSDnB");
const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $bwpsq.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $VSDnB.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $bwpsq.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
const $609735830782207d$var$sharedColorContainerStyles = null;
const $609735830782207d$var$smallColorContainerSize = null;
const $609735830782207d$var$defaultColorContainerSize = null;
const $609735830782207d$var$colorCardButtonStyles = null;
const $609735830782207d$var$colorCardButtonFocusedStyles = null;
const $609735830782207d$var$colorCardWrapperStyles = null;
const $609735830782207d$var$colorCardContentStyles = null;
const $609735830782207d$var$colorCardContentStylesOutline = null;
const $609735830782207d$var$smallColorCardContentSize = null;
const $609735830782207d$var$defaultColorCardContentSize = null;

});

parcelRegister("jKrb6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $b794a85d007e2dce$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $b794a85d007e2dce$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $b794a85d007e2dce$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $b794a85d007e2dce$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l0sd0 = parcelRequire("l0sd0");

var $5dAp2 = parcelRequire("5dAp2");


var $koVbs = parcelRequire("koVbs");

var $7oXeG = parcelRequire("7oXeG");
const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
const $b794a85d007e2dce$var$colorCardWrapperStyles = null;
const $b794a85d007e2dce$var$colorPaletteContainerStyles = null;

});
parcelRegister("7oXeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6da5a6d06680$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});




parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});


parcelRegister("lpRLe", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $7e21718d85b37a90$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ek97b = parcelRequire("ek97b");
const $7e21718d85b37a90$export$5991b62d89f5cc = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true }, ref)=>{
    const { backgroundColor: tagColor } = (0, $ek97b.getColorMetadata)(color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7e21718d85b37a90$var$tagWrapperStyles,
            isInteractive && $7e21718d85b37a90$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e21718d85b37a90$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
}));
const $7e21718d85b37a90$var$tagWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $7e21718d85b37a90$var$interactiveStyles = (0, $8CUq3.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e21718d85b37a90$var$StyledTagBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $7e21718d85b37a90$var$StyledTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7e21718d85b37a90$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3cDpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda2ba9e2f83147f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bda2ba9e2f83147f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    saveButton: {
        "id": "jira-option-color-picker.labels-color-picker.save-button",
        "defaultMessage": "Save \u23CE"
    }
});

});


parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("l2SvC", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $aed9af8029ae7a32$export$c5b80cd78ff71c5f);

var $5uXOq = parcelRequire("5uXOq");

var $6RCeq = parcelRequire("6RCeq");

var $eusud = parcelRequire("eusud");

var $8SCDp = parcelRequire("8SCDp");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");
const $aed9af8029ae7a32$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $eusud.performGetRequest)(url);
};
const $aed9af8029ae7a32$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $aed9af8029ae7a32$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $6RCeq.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestSuccessEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $5fc53.LABELS_TYPE)) (0, $8SCDp.fireSuggestionsRequestFailedEvent)((0, $5fc53.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("8SCDp", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $305439819cb2bcec$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $305439819cb2bcec$export$a31ac580130dee62);

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
const $305439819cb2bcec$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $6RCeq.default).now() - startTime
    };
    createAnalyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $305439819cb2bcec$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $305439819cb2bcec$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $305439819cb2bcec$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("e3wnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $35584119a49c4bd8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $biBfP = parcelRequire("biBfP");
const $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $35584119a49c4bd8$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $35584119a49c4bd8$export$53574ab050410077 = (0, $2OMDV.AnalyticsEventToProps)('select', $35584119a49c4bd8$var$analyticsProps)((0, $iOwNT.default));
const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, $biBfP.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $biBfP.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $biBfP.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $biBfP.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $biBfP.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $biBfP.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)((interactionType)=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt !== 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime,
                interactionType: interactionType
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)((interactionType)=>{
        endSession(interactionType);
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option created');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $biBfP.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option selected');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $biBfP.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $biBfP.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$53574ab050410077, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $35584119a49c4bd8$export$2e2bcd8739ae039 = $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("db8jg", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $6aa2f917648b2dec$export$c9e165da390f6283);

var $eb3tB = parcelRequire("eb3tB");

var $8QpSo = parcelRequire("8QpSo");

var $4Pf62 = parcelRequire("4Pf62");
const $6aa2f917648b2dec$export$fdd2c0ba94025c3c = (0, $8QpSo.default)(()=>{
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $6aa2f917648b2dec$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $6aa2f917648b2dec$export$fdd2c0ba94025c3c();
    const hash = (0, $eb3tB.sha256)(`${cloudId}_${attribute.trim()}`);
    return hash;
};

});
parcelRegister("eb3tB", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");


/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2024
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $6cAn5 === 'object' && $6cAn5.versions && $6cAn5.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("hq3wB"));
        var Buffer = (parcelRequire("hq3wB")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >>> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >>> 24 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 & 0xFF,
            h1 >>> 24 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 & 0xFF,
            h2 >>> 24 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 & 0xFF,
            h3 >>> 24 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 & 0xFF,
            h4 >>> 24 & 0xFF,
            h4 >>> 16 & 0xFF,
            h4 >>> 8 & 0xFF,
            h4 & 0xFF,
            h5 >>> 24 & 0xFF,
            h5 >>> 16 & 0xFF,
            h5 >>> 8 & 0xFF,
            h5 & 0xFF,
            h6 >>> 24 & 0xFF,
            h6 >>> 16 & 0xFF,
            h6 >>> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("biBfP", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $e31cfbdea683954a$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $e31cfbdea683954a$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $e31cfbdea683954a$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $e31cfbdea683954a$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $e31cfbdea683954a$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $e31cfbdea683954a$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $e31cfbdea683954a$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$e31cfbdea683954a$export$d05672fd1312a6d(value));
const $e31cfbdea683954a$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((group)=>group.options));
const $e31cfbdea683954a$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $e31cfbdea683954a$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("l5gEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8773284d2f300e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef8773284d2f300e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    }
});

});


parcelRegister("evGBv", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $df66270ab3f9af77$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $df66270ab3f9af77$export$f691a7c5b86be653);

const $df66270ab3f9af77$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name, color: color })=>({
            value: name,
            label: name,
            ...color ? {
                color: color.colorKey
            } : {}
        }));
const $df66270ab3f9af77$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $fbaea1aecc52fe2c$export$31fd86f8f183952c)
    });

});
const $fbaea1aecc52fe2c$export$31fd86f8f183952c = 'labelsFields';




parcelRegister("3ZQGw", function(module, exports) {

$parcel$export(module.exports, "LabelsFieldTypeConfig", () => $0e9a07e22e44fb24$export$e4c3d82c6a697032);

var $5uXOq = parcelRequire("5uXOq");

var $eKl4L = parcelRequire("eKl4L");

var $8GQyc = parcelRequire("8GQyc");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $0e9a07e22e44fb24$var$LabelsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GQyc.default), props);
const $0e9a07e22e44fb24$export$e4c3d82c6a697032 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKl4L))),
    type: (0, $5fc53.LABELS_TYPE),
    Component: $0e9a07e22e44fb24$var$LabelsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.labelsFieldWriter)
};

});

parcelRegister("kTnsH", function(module, exports) {

$parcel$export(module.exports, "MultiCheckboxesCustomFieldTypeConfig", () => $a666f3e6ce2ead81$export$29399cace92d6d05);

var $5uXOq = parcelRequire("5uXOq");

var $4xPlE = parcelRequire("4xPlE");

var $aqCUo = parcelRequire("aqCUo");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aqCUo.default), props);
const $a666f3e6ce2ead81$export$29399cace92d6d05 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
    type: (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    Component: $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.checkboxSelectFieldWriter)
};

});
parcelRegister("aqCUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e0b893bc2fc3f63$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $edQZ6 = parcelRequire("edQZ6");

var $hx8g7 = parcelRequire("hx8g7");

var $lfTZh = parcelRequire("lfTZh");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

const $0e0b893bc2fc3f63$var$CheckboxSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
    const options = (0, $hx8g7.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-checkbox-select-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edQZ6.AsyncCheckboxSelectEdit), {
        ...fieldProps,
        options: options,
        value: value,
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly
    })));
};
var $0e0b893bc2fc3f63$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCheckboxField),
    transformDefaultValue: (0, $hx8g7.mapDataToOptions)
})($0e0b893bc2fc3f63$var$CheckboxSelectField);

});
parcelRegister("edQZ6", function(module, exports) {

$parcel$export(module.exports, "AsyncCheckboxSelectEdit", () => $53d0db7977df62c9$export$48ad7b39ee5392c2);

var $kxZPA = parcelRequire("kxZPA");

const $53d0db7977df62c9$export$48ad7b39ee5392c2 = (0, $kxZPA.lazy)(()=>(parcelRequire("b86sY")).then((module)=>module.CheckboxSelectEdit), {
    moduleId: "./src/packages/issue/fields/checkbox-select/src/index.tsx"
});

});
parcelRegister("b86sY", function(module, exports) {

let $81a5752591ae16b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81a5752591ae16b2$var$load("kKbG0").then(()=>parcelRequire('7p86r'));

});




parcelRegister("g8kqC", function(module, exports) {

$parcel$export(module.exports, "MultiGroupCustomFieldTypeConfig", () => $f461df346d8eee00$export$62823f7adb904a12);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $5sz86 = parcelRequire("5sz86");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sz86.default), props);
const $f461df346d8eee00$export$62823f7adb904a12 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.MULTI_GROUP_CF_TYPE),
    Component: $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multipleGroupPickerFieldWriter)
};

});
parcelRegister("5sz86", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e92fcc13435d46$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9EuZf = parcelRequire("9EuZf");

var $5fnvk = parcelRequire("5fnvk");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $1IlAr = parcelRequire("1IlAr");

const $b0e92fcc13435d46$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fnvk.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        "aria-labelledby": ariaLabelledBy,
        ...getExtraProps()
    }));
};
var $b0e92fcc13435d46$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateGroupPickerField),
    transformDefaultValue: (0, $1IlAr.transformGroupDefaultValueToUserOption)
})($b0e92fcc13435d46$var$MultiGroupPickerField);

});
parcelRegister("1IlAr", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $d2f2135dd78f2505$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $d2f2135dd78f2505$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $arYvt = parcelRequire("arYvt");

const $d2f2135dd78f2505$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $arYvt.transformGroupToUserOption)(groupItem));
    return (0, $arYvt.transformGroupToUserOption)(group);
};
const $d2f2135dd78f2505$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $795be18a4b521940$export$31fd86f8f183952c)
    });

});
const $795be18a4b521940$export$31fd86f8f183952c = 'multipleGroupPickerFields';




parcelRegister("iHSUu", function(module, exports) {

$parcel$export(module.exports, "MultiSelectCustomFieldTypeConfig", () => $19289b6ae773b2f1$export$1203387d0e5999ed);

var $5uXOq = parcelRequire("5uXOq");

var $kqDoy = parcelRequire("kqDoy");

var $g2djo = parcelRequire("g2djo");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2djo.default), {
        ...props,
        defaultValue: undefined
    });
const $19289b6ae773b2f1$export$1203387d0e5999ed = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqDoy))),
    type: (0, $5fc53.MULTI_SELECT_CF_TYPE),
    Component: $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.multiSelectFieldWriter)
};

});
parcelRegister("kqDoy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3d7f6e098f10fcfa391b7a545c3a4282>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf4cb651ed8a915$var$_react = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf4cb651ed8a915$var$_baseNew = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf4cb651ed8a915$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxUnchecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf4cb651ed8a915$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ $edf4cb651ed8a915$var$_react.default.createElement($edf4cb651ed8a915$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$edf4cb651ed8a915$var$CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
var $edf4cb651ed8a915$var$_default = module.exports.default = $edf4cb651ed8a915$var$CheckboxUncheckedIcon;

});

parcelRegister("g2djo", function(module, exports) {

$parcel$export(module.exports, "default", () => $970d61a7c1588270$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d3RWa = parcelRequire("d3RWa");

const $970d61a7c1588270$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3RWa.default), {
        ...props,
        isMulti: true
    });
var $970d61a7c1588270$export$2e2bcd8739ae039 = $970d61a7c1588270$var$MultiSelectField;

});


parcelRegister("3owst", function(module, exports) {

$parcel$export(module.exports, "MultiUserCustomFieldTypeConfig", () => $114133be8a191ff4$export$e61985ad3f4b288f);

var $5uXOq = parcelRequire("5uXOq");

var $fptva = parcelRequire("fptva");

var $gARR3 = parcelRequire("gARR3");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $114133be8a191ff4$export$e61985ad3f4b288f = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fptva))),
    type: (0, $5fc53.MULTI_USER_CF_TYPE),
    Component: (0, $gARR3.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.multiUserPickerFieldWriter)
};

});
parcelRegister("gARR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06543e5a7cef326e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $06543e5a7cef326e$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $06543e5a7cef326e$export$2e2bcd8739ae039 = $06543e5a7cef326e$var$MultiUserPickerField;

});
parcelRegister("lzCWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a02b9e46792852c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dQLtU = parcelRequire("dQLtU");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $7C5S0 = parcelRequire("7C5S0");

var $5kDIl = parcelRequire("5kDIl");

const $a02b9e46792852c4$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $a02b9e46792852c4$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject, projectKey: projectKey } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dQLtU.default), {
        autoCompleteUrl: $a02b9e46792852c4$var$getAutoCompleteUrl(context, fieldId, // this is for fixing an issue that the custom user picker doesn't show the right user group in form when the project key is missing
        (0, $4R6GH.fg)('jira_forms_fix_user_picker_missing_project_key') ? projectKey || selectedProject?.projectKey : selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        onCloseMenuOnScroll: (0, $gLdtQ.closeMenuOnScroll),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    }));
};
var $a02b9e46792852c4$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateUserPickerField),
    transformDefaultValue: (0, $5kDIl.transformDefaultUserValues)
})($a02b9e46792852c4$var$UserPickerField);

});
parcelRegister("dQLtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d56a824ba419e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jOrdN = parcelRequire("jOrdN");

var $9EuZf = parcelRequire("9EuZf");
const $e4d56a824ba419e6$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $9EuZf.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOrdN.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $e4d56a824ba419e6$export$2e2bcd8739ae039 = $e4d56a824ba419e6$var$UserPickerEdit;

});
parcelRegister("jOrdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3563054ff092b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $cr0SA = parcelRequire("cr0SA");

var $eusud = parcelRequire("eusud");

var $koVbs = parcelRequire("koVbs");


var $duvPR = parcelRequire("duvPR");

var $khYiH = parcelRequire("khYiH");
const $9f3563054ff092b8$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $9f3563054ff092b8$export$251bdbdbce9550ea = 400;
const $9f3563054ff092b8$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $5uXOq.useState)(null);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [wasFocused, setWasFocused] = (0, $5uXOq.useState)(false);
    const [wasCleared, setWasCleared] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)([]);
    const [sessionId, setSessionId] = (0, $5uXOq.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $768a4f0fe483a263$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $9f3563054ff092b8$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $5uXOq.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $eusud.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $khYiH.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $khYiH.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        fetchSuggestionsProps,
        sessionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $768a4f0fe483a263$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $9f3563054ff092b8$var$stringContains(displayName, query) || $9f3563054ff092b8$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $duvPR.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabel: fieldProps['aria-label'],
        ariaLabelledBy: fieldProps['aria-labelledby'],
        closeMenuOnScroll: closeMenuOnScroll,
        menuPosition: menuPosition,
        ...controlProps
    });
};
var $9f3563054ff092b8$export$2e2bcd8739ae039 = $9f3563054ff092b8$var$UserPickerWrapper;

});
const $768a4f0fe483a263$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("duvPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("khYiH", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $5eec43efc9e4eafe$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $5eec43efc9e4eafe$export$ec325826d2bf6655);

var $jcw0u = parcelRequire("jcw0u");
const $5eec43efc9e4eafe$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $5eec43efc9e4eafe$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error,
            skipSentry: true,
            attributes: {
                autoCompleteResponseIsNull: autoCompleteResponse === null
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};

});






parcelRegister("dzSVK", function(module, exports) {

$parcel$export(module.exports, "NumberCustomFieldTypeConfig", () => $ba1f787e6f666f7e$export$9263307b5dc5bafe);

var $5uXOq = parcelRequire("5uXOq");

var $7WX1N = parcelRequire("7WX1N");

var $bo14T = parcelRequire("bo14T");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bo14T.default), props);
const $ba1f787e6f666f7e$export$9263307b5dc5bafe = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7WX1N))),
    type: (0, $5fc53.NUMBER_CF_TYPE),
    Component: $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.numberFieldWriter)
};

});
parcelRegister("7WX1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9031e33df964dc80cced247be7a52703>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c9bbce6cd34e80a$var$_react = $5c9bbce6cd34e80a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c9bbce6cd34e80a$var$_baseNew = $5c9bbce6cd34e80a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5c9bbce6cd34e80a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Hashtag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: topics in Atlas, tags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c9bbce6cd34e80a$var$HashtagIcon = (props)=>/*#__PURE__*/ $5c9bbce6cd34e80a$var$_react.default.createElement($5c9bbce6cd34e80a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.274 5 6.012.868l1.476.264L6.798 5h3.476l.738-4.132 1.476.264L11.798 5H15v1.5h-3.47l-.536 3H14V11h-3.274l-.738 4.132-1.476-.264.69-3.868H5.726l-.738 4.132-1.476-.264.69-3.868H1V9.5h3.47l.536-3H2V5zM6.53 6.5l-.536 3H9.47l.536-3z" clip-rule="evenodd"/>`
    }, props));
$5c9bbce6cd34e80a$var$HashtagIcon.displayName = 'HashtagIcon';
var $5c9bbce6cd34e80a$var$_default = module.exports.default = $5c9bbce6cd34e80a$var$HashtagIcon;

});

parcelRegister("bo14T", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dfdc9c56d4f0e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

var $kU4qk = parcelRequire("kU4qk");

const $69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $69dfdc9c56d4f0e9$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString),
    transformDefaultValue: (0, $kU4qk.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e);

});
parcelRegister("hMKLn", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $c59ad84f24b74144$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $c59ad84f24b74144$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $jGVMX = parcelRequire("jGVMX");

var $hpV4g = parcelRequire("hpV4g");

var $lrbT7 = parcelRequire("lrbT7");
const $c59ad84f24b74144$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $lrbT7.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $c59ad84f24b74144$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$c59ad84f24b74144$export$dd2171e2b7d3bc5b);

});
parcelRegister("lrbT7", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $0fe71c1efa633a57$export$3fedcbfe1c53d8f);
const $0fe71c1efa633a57$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});


parcelRegister("kU4qk", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $2648f8f88d1e9261$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $2648f8f88d1e9261$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $2648f8f88d1e9261$export$afe59f8094df7220);

const $2648f8f88d1e9261$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $2648f8f88d1e9261$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $358fca2fc5354374$export$31fd86f8f183952c)
    });
const $2648f8f88d1e9261$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $358fca2fc5354374$export$31fd86f8f183952c = 'numberFields';




parcelRegister("2prZd", function(module, exports) {

$parcel$export(module.exports, "ParentFieldTypeConfig", () => $2c89c4ecde62323b$export$dfc79382467975d5);

var $5uXOq = parcelRequire("5uXOq");

var $c0edv = parcelRequire("c0edv");

var $8mBES = parcelRequire("8mBES");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $2c89c4ecde62323b$var$ParentFieldTypeComponent = (props)=>{
    if (!props.issueTypeId || !props.canUserViewProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mBES.default), {
        ...props,
        selectedProject: {
            value: props.projectId
        },
        selectedIssueType: {
            value: props.issueTypeId
        },
        isFieldResponsive: true
    });
};
const $2c89c4ecde62323b$export$dfc79382467975d5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c0edv))),
    type: (0, $5fc53.PARENT_TYPE),
    Component: $2c89c4ecde62323b$var$ParentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("c0edv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1e5a4eb83a5a00b95d06a6a3097fd6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd0834c72dd821c$var$_react = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bd0834c72dd821c$var$_baseNew = $8bd0834c72dd821c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8bd0834c72dd821c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bd0834c72dd821c$var$FieldIcon = (props)=>/*#__PURE__*/ $8bd0834c72dd821c$var$_react.default.createElement($8bd0834c72dd821c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 3.5H0V2h6zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$8bd0834c72dd821c$var$FieldIcon.displayName = 'FieldIcon';
var $8bd0834c72dd821c$var$_default = module.exports.default = $8bd0834c72dd821c$var$FieldIcon;

});

parcelRegister("8mBES", function(module, exports) {

$parcel$export(module.exports, "default", () => $28698af5fbb25d8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c04PQ = parcelRequire("c04PQ");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $1iKBB = parcelRequire("1iKBB");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $bA6nL = parcelRequire("bA6nL");

var $eulr6 = parcelRequire("eulr6");

const $28698af5fbb25d8a$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /**
   * When creating a sub-task from the GIC modal, we:
   * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
   * - disable the parent field to prevent the user to change it
   *
   * This prevents the user to make a mistake or bump into potential edge cases.
   */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iKBB.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: issueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $c04PQ.isFedRamp)() ? issueKey : undefined,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28698af5fbb25d8a$var$fieldDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bA6nL.default).descriptionIssueTermRefresh : (0, $bA6nL.default).description))));
};
const $28698af5fbb25d8a$var$fieldDescriptionStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
var $28698af5fbb25d8a$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $eulr6.transformDefaultParentValue),
    validator: (0, $eulr6.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$28698af5fbb25d8a$export$96c87c0afbe06b37);

});
// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("1iKBB", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $b89ca9fa2a80ab1b$export$55c2cccecfd24751);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck react-select unsupported props

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $3BhEA = parcelRequire("3BhEA");

var $lElIo = parcelRequire("lElIo");

var $koeKL = parcelRequire("koeKL");

var $iVcsU = parcelRequire("iVcsU");

var $inRSh = parcelRequire("inRSh");

var $3orGF = parcelRequire("3orGF");

var $1sPJ0 = parcelRequire("1sPJ0");

var $6v0ju = parcelRequire("6v0ju");
const $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $b89ca9fa2a80ab1b$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy, onSearchParents: onSearchParents, showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $5uXOq.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $5uXOq.useState)(true);
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const lastQuery = (0, $5uXOq.useRef)('');
    const cloudId = (0, $koeKL.useCloudId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            onChange: (event)=>{
                setExcludeDone(!event.target.checked);
            },
            showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible
        }), [
        showDoneIssuesCheckboxVisible
    ]);
    const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sPJ0.default), {
            option: option
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option.label || `${option.key} ${option.fields.summary}`);
    }, []);
    const searchParents = (0, $5uXOq.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $6v0ju.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        let response;
        if (onSearchParents && (0, $4R6GH.fg)('issue_view_in_program_board')) response = await onSearchParents(query);
        else response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents,
        onSearchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(requestSuggestions, $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $5uXOq.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        if (!(0, $4R6GH.fg)('parent_field_candidates_filtered_out_fix_enabled')) return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
        return true;
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $3orGF.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $3orGF.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $3orGF.default).loading), [
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $5uXOq.useMemo)(()=>spacingProps, [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $iVcsU.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $3orGF.default).placeholder),
        components: {
            Menu: $inRSh.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing,
        "aria-label": formatMessage((0, $3orGF.default).placeholder),
        "aria-labelledby": ariaLabelledBy,
        ...(0, $4R6GH.fg)('issue_view_in_program_board') && {
            menuPlacement: 'auto'
        }
    });
};

});
parcelRegister("iVcsU", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $608100d8bb869e55$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $608100d8bb869e55$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $608100d8bb869e55$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $608100d8bb869e55$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $608100d8bb869e55$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $heWHN = parcelRequire("heWHN");

var $iHPnC = parcelRequire("iHPnC");
const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $heWHN.MAP_COLORS_TO_VALUE)[color];
const $608100d8bb869e55$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
    return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        }));
};
const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $608100d8bb869e55$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $608100d8bb869e55$var$ColorPatch = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $lD23V.default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsbdlk8 _1ul9dlk8 _4t3idlk8 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});


parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("inRSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f1b6faa7238bb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $drCen = parcelRequire("drCen");
const $bc8f1b6faa7238bb$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    // note: "isDefaultChecked" is used for VR tests only, therefore it is defaulted to false in production
    const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
    // default to true if showDoneIssuesCheckboxVisible is undefined
    const showDoneIssuesCheckboxVisible = props.selectProps?.componentsProps?.showDoneIssuesCheckboxVisible !== undefined && (0, $4R6GH.fg)('issue_view_in_program_board') ? props.selectProps.componentsProps.showDoneIssuesCheckboxVisible : true;
    const label = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drCen.default).checkboxLabelIssueTermRefresh : (0, $drCen.default).checkboxLabel);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, showDoneIssuesCheckboxVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        defaultChecked: isDefaultChecked,
        onKeyDown: onKeyDown,
        label: label
    })), children);
};
var $bc8f1b6faa7238bb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bc8f1b6faa7238bb$var$Menu;
const $bc8f1b6faa7238bb$var$CheckboxWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("drCen", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c6a6ed4bb83a84$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90c6a6ed4bb83a84$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    },
    checkboxLabelIssueTermRefresh: {
        "id": "issue-field-parent.edit.menu.checkbox-label-issue-term-refresh",
        "defaultMessage": "Show everything marked as done"
    }
});

});


parcelRegister("3orGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57b6631f3fbd470$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f57b6631f3fbd470$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1sPJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aae186893156b3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eJbwP = parcelRequire("eJbwP");

var $koVbs = parcelRequire("koVbs");

var $iVcsU = parcelRequire("iVcsU");

var $hVITp = parcelRequire("hVITp");
const $3aae186893156b3c$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Description, null, option.description) : null);
const $3aae186893156b3c$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $iVcsU.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
        spacing: "spacious",
        color: "var(--ds-text-success, #216E4E)",
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3aae186893156b3c$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, $3aae186893156b3c$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $hVITp.default).doneParentLabel), formatMessage((0, $hVITp.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, option.label), $3aae186893156b3c$var$renderOptionDescription(option)));
};
var $3aae186893156b3c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3aae186893156b3c$var$CustomOption;
const $3aae186893156b3c$var$IconWithColor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$DoneWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3aae186893156b3c$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz131l _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3aae186893156b3c$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hVITp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c6ab058a23c088$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3c6ab058a23c088$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("6v0ju", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $2703467b5174b086$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $2703467b5174b086$export$f995718992ca6c2f);

var $jcw0u = parcelRequire("jcw0u");

var $cWEsa = parcelRequire("cWEsa");

var $cAZGv = parcelRequire("cAZGv");

var $iVcsU = parcelRequire("iVcsU");
const $2703467b5174b086$export$cfeee2ee86ead336 = 'bento';
const $2703467b5174b086$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cAZGv.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $2703467b5174b086$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $cWEsa.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $iVcsU.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $2703467b5174b086$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("cWEsa", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $96b7190bd204920f$export$59a0f41a1d5dcee0);


var $jJZqs = parcelRequire("jJZqs");

var $d8JF2 = parcelRequire("d8JF2");

var $2t8So = parcelRequire("2t8So");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $96b7190bd204920f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $2t8So.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $d8JF2.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
parcelRegister("d8JF2", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $9b9ac42d3f1a3741$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5);

var $bItI4 = parcelRequire("bItI4");
const $9b9ac42d3f1a3741$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$9b9ac42d3f1a3741$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $bItI4.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("bItI4", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $a63b2f209c365c28$export$f63a6e3151b9dd82);
const $a63b2f209c365c28$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a63b2f209c365c28$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a63b2f209c365c28$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a63b2f209c365c28$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a63b2f209c365c28$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a63b2f209c365c28$var$issueType()}
      ${$a63b2f209c365c28$var$summary()}
      ${$a63b2f209c365c28$var$status()}
    }
  }
}`;
const $a63b2f209c365c28$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$a63b2f209c365c28$var$color()}
              ${$a63b2f209c365c28$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;

});


parcelRegister("2t8So", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07071af5f9e15eb$export$2e2bcd8739ae039);

var $d8JF2 = parcelRequire("d8JF2");

var $iBOrg = parcelRequire("iBOrg");
const $b07071af5f9e15eb$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$b07071af5f9e15eb$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $b07071af5f9e15eb$export$83bff8b82e36a9e9
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $d8JF2.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});

parcelRegister("k90nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $602ab0b685964cde$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");
class $602ab0b685964cde$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $602ab0b685964cde$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $jJZqs.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("1aPWY", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9711633f84674efa$export$3ceb62baab058c6b);


var $gULOk = parcelRequire("gULOk");

var $jJZqs = parcelRequire("jJZqs");

var $heWHN = parcelRequire("heWHN");
const $9711633f84674efa$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (statusField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $jJZqs.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
        const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("cAZGv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $e563dea4a8edeb6a$export$48a29a1313179c04);


var $jJZqs = parcelRequire("jJZqs");

var $78P89 = parcelRequire("78P89");

var $iveGN = parcelRequire("iveGN");

var $k90nh = parcelRequire("k90nh");

var $1aPWY = parcelRequire("1aPWY");
const $e563dea4a8edeb6a$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $iveGN.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $k90nh.default)(new Error(message), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $k90nh.default)(new (0, $jJZqs.default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $1aPWY.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("78P89", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $cf42cbd052db3ab7$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $cf42cbd052db3ab7$export$453f3d2e0fac3592);

var $eVi6b = parcelRequire("eVi6b");
const $cf42cbd052db3ab7$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $cf42cbd052db3ab7$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$cf42cbd052db3ab7$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $eVi6b.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("eVi6b", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $5f9b4891c9749af5$export$1dfd5c8a625d5960);
const $5f9b4891c9749af5$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $5f9b4891c9749af5$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $5f9b4891c9749af5$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $5f9b4891c9749af5$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $5f9b4891c9749af5$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$5f9b4891c9749af5$var$issueType()}
      ${$5f9b4891c9749af5$var$summary()}
      ${$5f9b4891c9749af5$var$status()}
    }
  }
}`;
const $5f9b4891c9749af5$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$5f9b4891c9749af5$var$color()}
                ${$5f9b4891c9749af5$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;

});


parcelRegister("iveGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9969b12a843159$export$2e2bcd8739ae039);

var $78P89 = parcelRequire("78P89");

var $iBOrg = parcelRequire("iBOrg");
const $4b9969b12a843159$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b9969b12a843159$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $4b9969b12a843159$export$1fd3b40492f4ef9f
    };
    const response = await (0, $iBOrg.getClient)('').query({
        query: (0, $78P89.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $78P89.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});




parcelRegister("bA6nL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53543067399a8c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b53543067399a8c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "issue-create-commons.parent-field.description",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create-commons.parent-field.description-issue-term-refresh",
        "defaultMessage": "Your work type hierarchy determines the work items you can select here."
    }
});

});

parcelRegister("eulr6", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $ca97e2610eb77570$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $ca97e2610eb77570$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $ca97e2610eb77570$export$15ec054c85ac7db1);

var $bGrWH = parcelRequire("bGrWH");

var $heWHN = parcelRequire("heWHN");
const $ca97e2610eb77570$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $heWHN.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $ca97e2610eb77570$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};
const $ca97e2610eb77570$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});



parcelRegister("eRVlU", function(module, exports) {

$parcel$export(module.exports, "PeopleCustomFieldType", () => $f83100d884a853ed$export$531787d3fa23885);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $gARR3 = parcelRequire("gARR3");

var $lfWSN = parcelRequire("lfWSN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $f83100d884a853ed$var$PeopleCustomFieldTypeComponent = (props)=>{
    if (props.schemaConfiguration.isMulti) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gARR3.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfWSN.default), props);
};
const $f83100d884a853ed$export$531787d3fa23885 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.PEOPLE_CF_TYPE),
    Component: $f83100d884a853ed$var$PeopleCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (id, value, fields)=>Array.isArray(value) ? (0, $kShoa.multiUserPickerFieldWriter)(id, value, fields) : (0, $kShoa.singleUserPickerFieldWriter)(id, value, fields)
};

});
parcelRegister("lfWSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbbb313a8b6153d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lzCWA = parcelRequire("lzCWA");
const $8dbbb313a8b6153d$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzCWA.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $8dbbb313a8b6153d$export$2e2bcd8739ae039 = $8dbbb313a8b6153d$var$SingleUserPickerField;

});


parcelRegister("cK31e", function(module, exports) {

$parcel$export(module.exports, "PriorityFieldTypeConfig", () => $73ea0385fc1a41bb$export$63f81e33b9847d28);

var $5uXOq = parcelRequire("5uXOq");

var $p8UKh = parcelRequire("p8UKh");

var $2QZDj = parcelRequire("2QZDj");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $73ea0385fc1a41bb$var$PriorityFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QZDj.default), props);
const $73ea0385fc1a41bb$export$63f81e33b9847d28 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($p8UKh))),
    type: (0, $5fc53.PRIORITY_TYPE),
    Component: $73ea0385fc1a41bb$var$PriorityFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.priorityFieldWriter)
};

});
parcelRegister("p8UKh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fef0f06859e49caedcc4f47894a77da7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04b94019459ee8f9$var$_react = $04b94019459ee8f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04b94019459ee8f9$var$_baseNew = $04b94019459ee8f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $04b94019459ee8f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHighest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for highest work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04b94019459ee8f9$var$PriorityHighestIcon = (props)=>/*#__PURE__*/ $04b94019459ee8f9$var$_react.default.createElement($04b94019459ee8f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 6.75-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 4.65 13.087 8zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 9.15l5.087 3.352z"/>`
    }, props));
$04b94019459ee8f9$var$PriorityHighestIcon.displayName = 'PriorityHighestIcon';
var $04b94019459ee8f9$var$_default = module.exports.default = $04b94019459ee8f9$var$PriorityHighestIcon;

});

parcelRegister("2QZDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a3848e499878f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qOqP = parcelRequire("4qOqP");

var $4IxfP = parcelRequire("4IxfP");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $hnBts = parcelRequire("hnBts");
const $b29a3848e499878f$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $4IxfP.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qOqP.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $b29a3848e499878f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validatePriorityField),
    transformDefaultValue: $hnBts.transformDefaultValue
})($b29a3848e499878f$var$PriorityField);

});
parcelRegister("4qOqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00acd3f7bdd60a4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");
const $00acd3f7bdd60a4f$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, inputId: inputId, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isClearable: isClearable = false, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, menuIsOpen: menuIsOpen, menuPortalTarget: menuPortalTarget, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, styles: styles, formatOptionLabel: formatOptionLabel = (0, $9UhzQ.formatOptionLabel), onCloseMenuOnScroll: onCloseMenuOnScroll } = props;
    const stylesMemoized = (0, $5uXOq.useMemo)(()=>{
        return {
            ...(0, $lElIo.defaultSelectStyles),
            ...styles
        };
    }, [
        styles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: inputId,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: stylesMemoized,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: formatOptionLabel,
        menuIsOpen: menuIsOpen,
        menuPortalTarget: menuPortalTarget,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        required: isRequired,
        isClearable: isClearable,
        isDisabled: isDisabled,
        isSearchable: isSearchable,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $00acd3f7bdd60a4f$export$2e2bcd8739ae039 = $00acd3f7bdd60a4f$var$PriorityEdit;

});
parcelRegister("9UhzQ", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $7c6c645af44efe7b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $7c6c645af44efe7b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
    }, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$Description, null, description)));
};
const $7c6c645af44efe7b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c6c645af44efe7b$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$FlexColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7c6c645af44efe7b$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hnBts", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $f6b5541ab69f5e0c$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $f6b5541ab69f5e0c$export$2c46dd13be598543);
const $f6b5541ab69f5e0c$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $f6b5541ab69f5e0c$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});



parcelRegister("9HQd3", function(module, exports) {

$parcel$export(module.exports, "RadioButtonsCustomFieldTypeConfig", () => $238501c66641cf61$export$2483417b1f9a587c);

var $5uXOq = parcelRequire("5uXOq");

var $4iV1e = parcelRequire("4iV1e");

var $evAhI = parcelRequire("evAhI");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evAhI.default), props);
const $238501c66641cf61$export$2483417b1f9a587c = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))),
    type: (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
    Component: $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.radioSelectFieldWriter)
};

});
parcelRegister("evAhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa82702cc29d68e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g2wOz = parcelRequire("g2wOz");

var $aSk8p = parcelRequire("aSk8p");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $glFZG = parcelRequire("glFZG");
const $dfa82702cc29d68e$var$RadioSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false }, isReadOnly: isReadOnly = false, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $aSk8p.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2wOz.default), {
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $dfa82702cc29d68e$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateRadioSelectField),
    transformDefaultValue: $glFZG.transformDefaultValue
})($dfa82702cc29d68e$var$RadioSelectField);

});
parcelRegister("g2wOz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1767240ecaf9413$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jE4Xj = parcelRequire("jE4Xj");

var $lElIo = parcelRequire("lElIo");
const $c1767240ecaf9413$var$RadioSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', isDisabled: isDisabled = false, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jE4Xj.default), {
        classNamePrefix: classNamePrefix,
        value: value,
        options: options,
        isDisabled: isDisabled,
        placeholder: placeholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: OptionType | null, action: ActionMeta<OptionType>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        onBlur: onBlur,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $c1767240ecaf9413$export$2e2bcd8739ae039 = $c1767240ecaf9413$var$RadioSelectEdit;

});
parcelRegister("jE4Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1de6c1d3b6d34f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $itpgN = parcelRequire("itpgN");
const $1c1de6c1d3b6d34f$var$RadioSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        ...props,
        isMulti: false,
        components: mergedComponents
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c1de6c1d3b6d34f$export$2e2bcd8739ae039 = $1c1de6c1d3b6d34f$var$RadioSelect;

});


parcelRegister("glFZG", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $bab8deb286f07f08$export$e2f4e5d31db527cc);
const $bab8deb286f07f08$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id
    });

});



parcelRegister("7lpSO", function(module, exports) {

$parcel$export(module.exports, "SelectCustomFieldTypeConfig", () => $a425e0c10378516d$export$8ed2c57b191fc5f5);

var $5uXOq = parcelRequire("5uXOq");

var $kqDoy = parcelRequire("kqDoy");

var $k4tyx = parcelRequire("k4tyx");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $a425e0c10378516d$var$SelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4tyx.default), {
        ...props,
        defaultValue: undefined
    });
const $a425e0c10378516d$export$8ed2c57b191fc5f5 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kqDoy))),
    type: (0, $5fc53.SELECT_CF_TYPE),
    Component: $a425e0c10378516d$var$SelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});

parcelRegister("chk7J", function(module, exports) {

$parcel$export(module.exports, "SprintFieldTypeConfig", () => $7cbcc31fd938100a$export$da0c478aebabb75b);

var $5uXOq = parcelRequire("5uXOq");

var $8mG85 = parcelRequire("8mG85");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $3Xb7y = parcelRequire("3Xb7y");

var $kShoa = parcelRequire("kShoa");
const $7cbcc31fd938100a$var$SprintFieldTypeComponent = (props)=>{
    const { projectKey: projectKey, canUserViewProject: canUserViewProject } = props;
    if (!projectKey || !canUserViewProject) return null;
    // This is the same URL as the default for `SprintField` - the only difference here is we
    // want to hardcode the options list to only show sprints from parent project instead of showing
    // sprints across all projects visible to the user
    const autoCompleteUrl = `/rest/greenhopper/1.0/sprint/picker?projectKey=${projectKey}&query=`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Xb7y.default), {
        ...props,
        autoCompleteUrl: autoCompleteUrl
    });
};
const $7cbcc31fd938100a$export$da0c478aebabb75b = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8mG85))),
    type: (0, $5fc53.SELECT_CF_TYPE),
    Component: $7cbcc31fd938100a$var$SprintFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};

});
parcelRegister("3Xb7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $50063478b6346348$export$2e2bcd8739ae039);

var $hpV4g = parcelRequire("hpV4g");

var $3pqs3 = parcelRequire("3pqs3");

var $aqMtW = parcelRequire("aqMtW");

var $6iZh4 = parcelRequire("6iZh4");
var $50063478b6346348$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aqMtW.transformDefaultSprintValue),
    validator: (0, $6iZh4.validateRequired),
    shouldRenderFieldMessage: false
})((0, $3pqs3.SprintField));

});
parcelRegister("3pqs3", function(module, exports) {

$parcel$export(module.exports, "SprintField", () => $83fe5b61920278eb$export$617303ef516d5a01);
$parcel$export(module.exports, "default", () => $83fe5b61920278eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $io7kF = parcelRequire("io7kF");

var $3spCR = parcelRequire("3spCR");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $ahEu3 = parcelRequire("ahEu3");

var $aqMtW = parcelRequire("aqMtW");

const $83fe5b61920278eb$export$617303ef516d5a01 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const renderSprintEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $io7kF.default), {
            fieldId: fieldId,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnMount: false,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false,
            getSuggestions: (0, $aqMtW.getSprintSuggestions),
            ...selectedProject?.projectKey ? {
                projectKey: selectedProject?.projectKey
            } : {},
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, renderSprintEdit()) : renderSprintEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), value && value.state === (0, $3spCR.ACTIVE_SPRINT_STATE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $83fe5b61920278eb$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning",
        testId: "issue-create-commons.ui.sprint-field.required-fields-message"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ahEu3.default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, $ahEu3.default).activeSprintSelectionWarningMessage))) : null);
};
var $83fe5b61920278eb$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    transformDefaultValue: (0, $aqMtW.transformDefaultSprintValue),
    shouldRenderFieldMessage: false
})($83fe5b61920278eb$export$617303ef516d5a01);
const $83fe5b61920278eb$var$messageContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("io7kF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42898dffd6db898$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6Vzc4 = parcelRequire("6Vzc4");

var $3BhEA = parcelRequire("3BhEA");

var $9UhzQ = parcelRequire("9UhzQ");

var $lElIo = parcelRequire("lElIo");

var $gcvId = parcelRequire("gcvId");

var $5fc53 = parcelRequire("5fc53");

var $249dD = parcelRequire("249dD");

var $bW9R0 = parcelRequire("bW9R0");

var $egtXp = parcelRequire("egtXp");

var $gxJKL = parcelRequire("gxJKL");

var $ckVH2 = parcelRequire("ckVH2");
const $e42898dffd6db898$export$251bdbdbce9550ea = 300;
const $e42898dffd6db898$var$SprintEdit = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $5fc53.SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy } = props;
    const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
    const lastQuery = (0, $5uXOq.useRef)('');
    const [restrictSprints, setRestrictSprint] = (0, $5uXOq.useState)((0, $egtXp.getCheckboxValueFromLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $bW9R0.useSprintSuggestions)({
        getSuggestions: getSuggestions
    });
    const onCheckboxClick = (0, $5uXOq.useCallback)(()=>{
        setRestrictSprint(!restrictSprints);
        (0, $egtXp.setCheckBoxValueInLocalStorage)((0, $egtXp.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
    }, [
        restrictSprints
    ]);
    const componentProps = (0, $5uXOq.useMemo)(()=>({
            isChecked: restrictSprints,
            onChange: onCheckboxClick,
            projectKey: projectKey
        }), [
        restrictSprints,
        projectKey,
        onCheckboxClick
    ]);
    const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const transformSuggestions = useTransformSuggestions || (0, $249dD.transformSuggestions);
            const response = transformSuggestions(results, formatMessage);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        useTransformSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Vzc4.FailedFetchOptionWrapper), null, formatMessage((0, $ckVH2.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            let response;
            if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
            else response = await getSprintSuggestions(autoCompleteUrl, query);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        autoCompleteUrl,
        restrictSprints,
        projectKey,
        getFailedFetchMessage,
        getSprintSuggestions,
        handleSuggestions
    ]);
    if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(fetchSuggestions, $e42898dffd6db898$export$251bdbdbce9550ea), [
        restrictSprints
    ]);
    const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $ckVH2.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $ckVH2.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $3BhEA.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        fetchSuggestions,
        onFocus,
        setIsLoadingSuggestions,
        suggestions
    ]);
    const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onValueChange = (0, $5uXOq.useCallback)((newValues)=>{
        // We're passing in suggestions for validation
        // e.g., if selected sprint is active and will affect the issue
        onChange && onChange(newValues, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    // Fetch the suggestions again if user toggles the checkbox
    (0, $5uXOq.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        restrictSprints,
        debouncedFetchSuggestions,
        setIsLoadingSuggestions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcvId.default), {
        inputId: inputId,
        isRequired: isRequired,
        isClearable: true,
        hideSelectedOptions: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: suggestions,
        value: value,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        componentsProps: projectKey ? componentProps : undefined,
        components: projectKey ? {
            Menu: $gxJKL.default
        } : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $ckVH2.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onValueChange,
        spacing: spacing,
        isLoading: isLoadingSuggestions,
        filterOption: filterOption,
        formatOptionLabel: (0, $9UhzQ.formatOptionLabel),
        validationState: isInvalid === true ? 'error' : null,
        isDisabled: isDisabled,
        openMenuOnFocus: openMenuOnFocus,
        "aria-labelledby": ariaLabelledBy
    });
};
var $e42898dffd6db898$export$2e2bcd8739ae039 = $e42898dffd6db898$var$SprintEdit;

});
parcelRegister("gcvId", function(module, exports) {

$parcel$export(module.exports, "default", () => $2132d0cd1f409256$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $7Jxgt = parcelRequire("7Jxgt");

var $iOwNT = parcelRequire("iOwNT");

var $6RCeq = parcelRequire("6RCeq");

var $koVbs = parcelRequire("koVbs");

var $db8jg = parcelRequire("db8jg");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8z9w3 = parcelRequire("8z9w3");

var $dKKqb = parcelRequire("dKKqb");
const $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $2132d0cd1f409256$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $2132d0cd1f409256$export$53574ab050410077 = (0, $2OMDV.AnalyticsEventToProps)('select', $2132d0cd1f409256$var$analyticsProps)((0, $iOwNT.default));
const $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '' } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasSessionStarted = (0, $5uXOq.useRef)(false);
    const sessionId = (0, $5uXOq.useRef)(customSessionId);
    const sessionStartedAt = (0, $5uXOq.useRef)(0);
    const endSessionRef = (0, $5uXOq.useRef)(undefined);
    const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
    const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flatOptions = (0, $5uXOq.useMemo)(()=>(0, $dKKqb.flattenOptions)(options), [
        options
    ]);
    const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? value : [];
        let filteredOptions = (0, $dKKqb.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $dKKqb.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            optionsLength: optionsLength,
            componentName: 'select',
            // TODO: update the lib's version after the bump
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $dKKqb.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $db8jg.memoizedHashString)(query),
            selectedOptions: (0, $dKKqb.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $dKKqb.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading
    ]);
    const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $7Jxgt.v4)();
        sessionStartedAt.current = (0, $6RCeq.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $5uXOq.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $6RCeq.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $5uXOq.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $dKKqb.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $dKKqb.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        onChange && onChange(selectedOptionOrOptions, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange
    ]);
    const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange && onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    const isValidNewOption = (0, $5uXOq.useCallback)(()=>!!canCreateNewItem, [
        canCreateNewItem
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSessionStarted.current) {
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            hasSessionStarted.current = true;
        }
    }, [
        createAnalyticsEvent,
        fireInputChangedEvent,
        startSession
    ]);
    (0, $5uXOq.useEffect)(()=>{
        endSessionRef.current = endSession;
    }, [
        endSession
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            endSessionRef.current && endSessionRef.current();
        }, // In order to avoid triggering this cleanup when the endSession callback is updated by adding a dependency to endSession here,
    // we call it via a ref instead
    []);
    const { isRequired: required, ...propsWithoutRequired } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2132d0cd1f409256$export$53574ab050410077, {
        ...propsWithoutRequired,
        required: isRequired,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics,
        isValidNewOption: isValidNewOption,
        label: ariaLabel || formatMessage((0, $8z9w3.default).ariaLabelForSelect)
    });
};
var $2132d0cd1f409256$export$2e2bcd8739ae039 = $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("8z9w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $283d0de21cddfa94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $283d0de21cddfa94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabelForSelect: {
        "id": "issue-field-select-with-analytics.ariaLabel",
        "defaultMessage": "Select Field"
    }
});

});

parcelRegister("dKKqb", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $52dde5a2f186bbcb$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $52dde5a2f186bbcb$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $52dde5a2f186bbcb$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $52dde5a2f186bbcb$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $52dde5a2f186bbcb$export$60d56ed3961c839c);

var $chc6P = parcelRequire("chc6P");

var $db8jg = parcelRequire("db8jg");
const $52dde5a2f186bbcb$export$d05672fd1312a6d = (val)=>(0, $db8jg.memoizedHashString)(val.toString()).toString();
const $52dde5a2f186bbcb$export$fde3d804891b8254 = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$52dde5a2f186bbcb$export$d05672fd1312a6d(value));
};
const $52dde5a2f186bbcb$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
            optionOrGroup
        ]));
const $52dde5a2f186bbcb$export$e2e167245697ed4e = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
};
const $52dde5a2f186bbcb$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("249dD", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $cfadc135289d0d3a$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $cfadc135289d0d3a$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $cfadc135289d0d3a$export$1d0ee4320c26fb60);

var $3spCR = parcelRequire("3spCR");

var $e7pk8 = parcelRequire("e7pk8");
const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
};
const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $3spCR.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
        state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3spCR.FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $e7pk8.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $e7pk8.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("e7pk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f3d56beb10e0cde$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});


parcelRegister("bW9R0", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $76a69867a9473261$export$16d0ab78a0b529dc);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
    maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
    maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
});
const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
    return (0, $eusud.performGetRequest)(queryString);
};
const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
    const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;


parcelRegister("egtXp", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $da54a1ad644b3ed6$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $da54a1ad644b3ed6$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $da54a1ad644b3ed6$export$1750bf12ee05e0ac);

var $ebyGx = parcelRequire("ebyGx");

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $da54a1ad644b3ed6$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $da54a1ad644b3ed6$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search).view || '';
const $da54a1ad644b3ed6$export$d5e150c1e3186bd1 = ()=>$da54a1ad644b3ed6$var$getViewMode().includes('planning');
const $da54a1ad644b3ed6$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $da54a1ad644b3ed6$export$b6ec857d138d143b = (key)=>{
    let value;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) value = $da54a1ad644b3ed6$var$localStorageProvider.get(key);
    else if (typeof window !== 'undefined') value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $da54a1ad644b3ed6$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $da54a1ad644b3ed6$var$localStorageProvider.set(key, value);
        else if (typeof window !== 'undefined') // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("gxJKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb901ddd959c90f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $ghRU5 = parcelRequire("ghRU5");

var $kacDU = parcelRequire("kacDU");
const $fb901ddd959c90f6$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $ghRU5.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kacDU.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$fb901ddd959c90f6$export$2e2bcd8739ae039 = $fb901ddd959c90f6$var$Menu;

});
parcelRegister("ghRU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7044cf08eb2bc7be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7044cf08eb2bc7be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("kacDU", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $38a94e57c20f776f$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $38a94e57c20f776f$export$eef12940a6696c78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckVH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe9503663e56e29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fe9503663e56e29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "issue-field-sprint.edit.placeholder",
        "defaultMessage": "Select sprint"
    },
    empty: {
        "id": "issue-field-sprint.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-sprint.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loading: {
        "id": "issue-field-sprint.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});


parcelRegister("ahEu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77c8f330a49e37f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e77c8f330a49e37f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeSprintSelectionWarningMessage: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
        "defaultMessage": "Creating this issue will affect the active sprint's scope"
    },
    activeSprintSelectionWarningMessageIssueTermRefresh: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
        "defaultMessage": "Creating this work item will affect the active sprint's scope"
    }
});

});

parcelRegister("aqMtW", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSprintValue", () => $02b747729b1ec287$export$94efa001ab93bfd1);
$parcel$export(module.exports, "mutateJiraSprintField", () => $02b747729b1ec287$export$38f8d6ec9f8dd490);
$parcel$export(module.exports, "getSprintSuggestions", () => $02b747729b1ec287$export$a5ccca5b51d5d670);

var $eusud = parcelRequire("eusud");
const $02b747729b1ec287$export$94efa001ab93bfd1 = (selectedSprints)=>{
    const sprint = selectedSprints[0];
    return sprint && {
        label: sprint.name,
        value: sprint.sprintId,
        state: sprint.state
    };
};
const $02b747729b1ec287$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
        sprintsField: {
            fieldId: fieldId,
            sprints: [
                {
                    sprintId: value.toString()
                }
            ]
        }
    });
const $02b747729b1ec287$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $02b747729b1ec287$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $eusud.performGetRequest)($02b747729b1ec287$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));

});




parcelRegister("j85Ze", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateCustomFieldTypeConfig", () => $bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3);

var $5uXOq = parcelRequire("5uXOq");

var $7WX1N = parcelRequire("7WX1N");

var $bo14T = parcelRequire("bo14T");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bo14T.default), props);
const $bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7WX1N))),
    type: (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
    Component: $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.numberFieldWriter)
};

});

parcelRegister("9TyvL", function(module, exports) {

$parcel$export(module.exports, "SummaryFieldTypeConfig", () => $3f14060b386f603e$export$ac5c271c33c3c6d7);

var $5uXOq = parcelRequire("5uXOq");

var $7nQJF = parcelRequire("7nQJF");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $3f14060b386f603e$export$ac5c271c33c3c6d7 = {
    type: (0, $5fc53.SUMMARY_TYPE),
    Component: (0, $7nQJF.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.textFieldWriter)
};

});
parcelRegister("7nQJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e43d0c98a72456c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $7e43d0c98a72456c$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "text",
        ...props
    });
var $7e43d0c98a72456c$export$2e2bcd8739ae039 = $7e43d0c98a72456c$var$TextField;

});


parcelRegister("j2R7K", function(module, exports) {

$parcel$export(module.exports, "TeamCustomFieldTypeConfig", () => $1b14f3049c72d53c$export$68615ecd9a5b878d);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $iPfC3 = parcelRequire("iPfC3");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iPfC3.default), props);
const $1b14f3049c72d53c$export$68615ecd9a5b878d = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.TEAM_CF_TYPE),
    Component: $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.teamFieldWriter)
};

});
parcelRegister("iPfC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cafe98c17438b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $eb5hX = parcelRequire("eb5hX");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $9K1c2 = parcelRequire("9K1c2");

const $35cafe98c17438b5$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eb5hX.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $35cafe98c17438b5$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateCustomTeamsField),
    transformDefaultValue: (0, $9K1c2.transformDefaultTeam)
})($35cafe98c17438b5$export$c3b8fa1b9560fb7e);

});
parcelRegister("eb5hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $762657ba3faad803$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $FtZX9 = parcelRequire("FtZX9");

var $blh8O = parcelRequire("blh8O");

var $b6swk = parcelRequire("b6swk");

var $ibWtm = parcelRequire("ibWtm");

var $jv74C = parcelRequire("jv74C");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6swk.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $762657ba3faad803$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibWtm.default), props);
const $762657ba3faad803$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
    const handleSearch = (0, $FtZX9.default)(async (query)=>(0, $jv74C.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, $blh8O.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $762657ba3faad803$var$MenuList,
            Option: $762657ba3faad803$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $lElIo.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $762657ba3faad803$export$2e2bcd8739ae039 = $762657ba3faad803$var$CustomTeamPickerEdit;

});
parcelRegister("blh8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $47204223650b9e34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47204223650b9e34$var$messages = (0, $7VHMR.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $47204223650b9e34$export$2e2bcd8739ae039 = $47204223650b9e34$var$messages;

});

parcelRegister("b6swk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d58b272b039ad0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $koVbs = parcelRequire("koVbs");

var $blh8O = parcelRequire("blh8O");
const $b7d58b272b039ad0$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$MenuFooterText, null, formatMessage((0, $blh8O.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$Container, null, formatMessage((0, $blh8O.default).menuHeader)), props.children, footer));
};
var $b7d58b272b039ad0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b7d58b272b039ad0$var$MenuListComponent;
const $b7d58b272b039ad0$var$MenuFooterText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz131l _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $b7d58b272b039ad0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ibWtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bc7e69d2cb0c6a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $7KPXo = parcelRequire("7KPXo");
const $82bc7e69d2cb0c6a$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl, label: label } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$Icon, {
            src: avatarUrl,
            alt: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $82bc7e69d2cb0c6a$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7KPXo.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionText, null, props.children))));
    }
    return null;
};
var $82bc7e69d2cb0c6a$export$2e2bcd8739ae039 = $82bc7e69d2cb0c6a$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82bc7e69d2cb0c6a$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahv2br _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$OptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $82bc7e69d2cb0c6a$var$boxStyle = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("7KPXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6eecaecb2670c4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $8SxRZ = parcelRequire("8SxRZ");
const $6f6eecaecb2670c4$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8SxRZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8SxRZ))
});
var $6f6eecaecb2670c4$export$2e2bcd8739ae039 = $6f6eecaecb2670c4$var$Illustration;
// for advanced use only
const $6f6eecaecb2670c4$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("8SxRZ", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("jv74C", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $dbbd6d0fcad033b6$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $dbbd6d0fcad033b6$export$a789e725ac68b08d);

var $eusud = parcelRequire("eusud");
const $dbbd6d0fcad033b6$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $dbbd6d0fcad033b6$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $dbbd6d0fcad033b6$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $eusud.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($dbbd6d0fcad033b6$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("9K1c2", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $e945ecd21dcd5234$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $e945ecd21dcd5234$export$d2d64eb763c850a1);

const $e945ecd21dcd5234$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $0a8c3ec56489edc2$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $e945ecd21dcd5234$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $0a8c3ec56489edc2$export$31fd86f8f183952c = 'teamFields';




parcelRegister("kfv7e", function(module, exports) {

$parcel$export(module.exports, "TeamsPlatformCustomFieldTypeConfig", () => $5b2998e95da8bc40$export$bd8e1979d863fc93);

var $5uXOq = parcelRequire("5uXOq");

var $c781K = parcelRequire("c781K");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $d9PPV = parcelRequire("d9PPV");

var $kShoa = parcelRequire("kShoa");
const $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9PPV.TeamField), {
        ...props,
        defaultValue: undefined
    });
const $5b2998e95da8bc40$export$bd8e1979d863fc93 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
    type: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
    Component: $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.singleUserPickerFieldWriter)
};

});
parcelRegister("d9PPV", function(module, exports) {

$parcel$export(module.exports, "TeamField", () => $4d064a61ca9e1968$export$6f6cb44144d37e0d);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $4kXb0 = parcelRequire("4kXb0");
const $4d064a61ca9e1968$var$CLICKED_KEY = 'clicked';
const $4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY = 'TEAM_FIELD_ONBOARDING_BANNER_DISMISSED';
const $4d064a61ca9e1968$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('team-field-onboarding');
const $4d064a61ca9e1968$export$6f6cb44144d37e0d = (props)=>{
    // We need to override the localstorage so we don't get any of the onboarding for the form
    $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$CLICKED_KEY, true);
    $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY, true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kXb0.default), props);
};

});
parcelRegister("4kXb0", function(module, exports) {

$parcel$export(module.exports, "AtlassianTeamsField", () => $2d376b3496c34d29$export$96c8ee98de63ec5b);
$parcel$export(module.exports, "default", () => $2d376b3496c34d29$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $b71gk = parcelRequire("b71gk");

var $8vFwj = parcelRequire("8vFwj");

var $4ajjx = parcelRequire("4ajjx");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $kErdU = parcelRequire("kErdU");

var $4R6GH = parcelRequire("4R6GH");

var $bGEod = parcelRequire("bGEod");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $icXkU = parcelRequire("icXkU");

const $2d376b3496c34d29$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $2d376b3496c34d29$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $2d376b3496c34d29$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $5uXOq.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
    const onCreate = (0, $5uXOq.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $8vFwj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGEod.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ajjx.AsyncTeamPickerEdit), {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $2d376b3496c34d29$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), (0, $4R6GH.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kErdU.JiraIssueCreateErrorBoundary), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $2d376b3496c34d29$var$stopFormPropagation
    }, createTeamDialog)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $2d376b3496c34d29$var$stopFormPropagation
    }, createTeamDialog)));
};
var $2d376b3496c34d29$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $icXkU.validateAtlassianTeamsField),
    transformDefaultValue: (0, $icXkU.transformDefaultAtlassianTeam)
})($2d376b3496c34d29$export$96c8ee98de63ec5b);

});
parcelRegister("4ajjx", function(module, exports) {

$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $81014c0bebd525f2$export$7db2ade8dff2be91);

var $5uXOq = parcelRequire("5uXOq");

var $1wbtX = parcelRequire("1wbtX");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kxZPA = parcelRequire("kxZPA");

var $9n6Ty = parcelRequire("9n6Ty");
const $81014c0bebd525f2$var$EMPTY_OBJECT = {};

const $81014c0bebd525f2$export$eaed616868423e8a = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("hgQ4J"))), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $81014c0bebd525f2$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9n6Ty.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $81014c0bebd525f2$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("9n6Ty", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $306b3712a4b90308$export$80ec8c2b96e9988);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $306b3712a4b90308$export$80ec8c2b96e9988 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hgQ4J"))).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("icXkU", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $9b9cb321960b72df$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $9b9cb321960b72df$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $9b9cb321960b72df$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $9b9cb321960b72df$export$8222f94513c7d2e6);

var $bGrWH = parcelRequire("bGrWH");

const $9b9cb321960b72df$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $9f942793bea6ba7a$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $9b9cb321960b72df$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $9b9cb321960b72df$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $9b9cb321960b72df$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $bGrWH.REQUIRED;
    }
    return undefined;
};

});
const $9f942793bea6ba7a$export$31fd86f8f183952c = 'atlassianTeamFields';





parcelRegister("9uVge", function(module, exports) {

$parcel$export(module.exports, "TextAreaCustomFieldTypeConfig", () => $62cfff7fda2456e7$export$a843cc77cac50059);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $9cNbb = parcelRequire("9cNbb");

var $5fc53 = parcelRequire("5fc53");


var $4R6GH = parcelRequire("4R6GH");

var $hDpqy = parcelRequire("hDpqy");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent = (props)=>{
    if (props.renderer && props.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) && (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDpqy.default), {
        ...props,
        defaultValue: undefined,
        fieldWrapperElement: null,
        mediaUploadContext: props.mediaUploadContexts.uploadContext
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cNbb.default), props);
};
const $62cfff7fda2456e7$export$a843cc77cac50059 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.TEXT_AREA_CF_TYPE),
    Component: $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DescriptionFieldPlaceholder), null),
    writer: (id, value, fields, renderer)=>{
        if (!(0, $4R6GH.fg)('forms_multiline_text_wiki_renderer')) return (0, $kShoa.textAreaFieldWriter)(id, value, fields);
        return renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) ? (0, $kShoa.descriptionFieldWriter)(id, value, fields) : (0, $kShoa.textAreaFieldWriter)(id, value, fields);
    }
};

});
parcelRegister("9cNbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfbc76c8b6a999d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e7njR = parcelRequire("e7njR");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $jGVMX = parcelRequire("jGVMX");

const $9bfbc76c8b6a999d$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7njR.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $9bfbc76c8b6a999d$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$9bfbc76c8b6a999d$var$TextAreaField);

});
parcelRegister("e7njR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac310125020056c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6LCpJ = parcelRequire("6LCpJ");
const $ac310125020056c3$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $ac310125020056c3$export$2e2bcd8739ae039 = $ac310125020056c3$var$TextAreaEdit;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});



const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';


parcelRegister("4I0dG", function(module, exports) {

$parcel$export(module.exports, "TextCustomFieldTypeConfig", () => $479801bf04725697$export$c0fb3f2e63d9c457);

var $5uXOq = parcelRequire("5uXOq");

var $5Hpaz = parcelRequire("5Hpaz");

var $7nQJF = parcelRequire("7nQJF");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $479801bf04725697$export$c0fb3f2e63d9c457 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Hpaz))),
    type: (0, $5fc53.TEXT_CF_TYPE),
    Component: (0, $7nQJF.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.textFieldWriter)
};

});

parcelRegister("eFzGt", function(module, exports) {

$parcel$export(module.exports, "UrlCustomFieldTypeConfig", () => $1f67de6720141602$export$ffd29c07a77eba88);

var $5uXOq = parcelRequire("5uXOq");

var $1f9bV = parcelRequire("1f9bV");

var $b3x8f = parcelRequire("b3x8f");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $1f67de6720141602$export$ffd29c07a77eba88 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))),
    type: (0, $5fc53.URL_CF_TYPE),
    Component: (0, $b3x8f.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.TextFieldPlaceholder), null),
    writer: (0, $kShoa.urlFieldWriter)
};

});
parcelRegister("b3x8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $097d081b3402af20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMKLn = parcelRequire("hMKLn");

const $097d081b3402af20$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMKLn.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $097d081b3402af20$export$2e2bcd8739ae039 = $097d081b3402af20$var$UrlField;

});


parcelRegister("5VWF9", function(module, exports) {

$parcel$export(module.exports, "UserCustomFieldTypeConfig", () => $236772e6b1d3a040$export$e4e5f327b24b40ce);

var $5uXOq = parcelRequire("5uXOq");

var $bdVbi = parcelRequire("bdVbi");

var $lfWSN = parcelRequire("lfWSN");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
const $236772e6b1d3a040$export$e4e5f327b24b40ce = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi))),
    type: (0, $5fc53.USER_CF_TYPE),
    Component: (0, $lfWSN.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.AssigneeFieldPlaceholder), null),
    writer: (0, $kShoa.singleUserPickerFieldWriter)
};

});

parcelRegister("1avQ5", function(module, exports) {

$parcel$export(module.exports, "VersionFieldTypeConfig", () => $8ec751d67ae1a8ea$export$db147413137ce6f2);
$parcel$export(module.exports, "MultiVersionsFieldTypeConfig", () => $8ec751d67ae1a8ea$export$2b457390d9f3d552);

var $5uXOq = parcelRequire("5uXOq");

var $2Ljwn = parcelRequire("2Ljwn");

var $k5vQX = parcelRequire("k5vQX");

var $aQNfA = parcelRequire("aQNfA");

var $5fc53 = parcelRequire("5fc53");

var $9gHYS = parcelRequire("9gHYS");

var $kShoa = parcelRequire("kShoa");
// The version field components expect `allowedValues` options to have a `status` enum field value
function $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(allowedValuesProp) {
    return allowedValuesProp.map(({ id: id, name: name, released: released, archived: archived })=>{
        let status = 'UNRELEASED';
        if (archived) status = 'ARCHIVED';
        else if (released) status = 'RELEASED';
        return {
            id: id,
            name: name,
            status: status
        };
    });
}
const $8ec751d67ae1a8ea$var$VersionFieldTypeComponent = (props)=>{
    const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQNfA.default), {
        ...props,
        allowedValues: allowedValues
    });
};
const $8ec751d67ae1a8ea$export$db147413137ce6f2 = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))),
    type: (0, $5fc53.VERSION_CF_TYPE),
    Component: $8ec751d67ae1a8ea$var$VersionFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
    writer: (0, $kShoa.selectFieldWriter)
};
const $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent = (props)=>{
    const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5vQX.default), {
        ...props,
        allowedValues: allowedValues
    });
};
const $8ec751d67ae1a8ea$export$2b457390d9f3d552 = (type)=>({
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))),
        type: type,
        Component: $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9gHYS.DropdownFieldPlaceholder), null),
        writer: (0, $kShoa.multiSelectFieldWriter)
    });

});
parcelRegister("k5vQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76983af27be6a3ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $cBHNh = parcelRequire("cBHNh");

var $34EcD = parcelRequire("34EcD");

const $76983af27be6a3ff$var$MultiVersionsField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const options = (0, $34EcD.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
    };
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: true,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly || isDisabled,
            autoFocus: autoFocus,
            placeholder: isDisabled ? formatMessage((0, $cBHNh.default).none) : '',
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $cBHNh.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $76983af27be6a3ff$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateMultiVersionsField),
    transformDefaultValue: (0, $34EcD.transformVersionExternalOptionstoVersionOptions),
    shouldRenderFieldMessage: false
})($76983af27be6a3ff$var$MultiVersionsField);

});
parcelRegister("hTBEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c89427d751fd8d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $dTQPF = parcelRequire("dTQPF");
const $87c89427d751fd8d$var$Versions = (props)=>{
    const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getIsClearable = ()=>{
        if (!isClearable) return false;
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: placeholder,
        options: (0, $dTQPF.getGroupedOptions)((0, $dTQPF.removeArchivedOptions)(options), formatMessage),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        fieldId: fieldId,
        isMulti: isMulti,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: (0, $lElIo.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(option: VersionOption | VersionOption[] | null) => void' is not assignable to type '(value: VersionOption | OptionsType<VersionOption> | null, action: ActionMeta<VersionOption>) => void'.
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isClearable: getIsClearable(),
        inputId: inputId,
        required: isRequired,
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $87c89427d751fd8d$export$2e2bcd8739ae039 = $87c89427d751fd8d$var$Versions;

});
parcelRegister("dTQPF", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalToVersion", () => $418fd006fc4a31c5$export$c1c38f7974aa8bed);
$parcel$export(module.exports, "removeArchivedOptions", () => $418fd006fc4a31c5$export$6f0b68b6e372a0e6);
$parcel$export(module.exports, "getGroupedOptions", () => $418fd006fc4a31c5$export$721c3d9226425f9c);
$parcel$export(module.exports, "getVersionsIds", () => $418fd006fc4a31c5$export$c96a1607e976ccc6);
$parcel$export(module.exports, "getVersionId", () => $418fd006fc4a31c5$export$d0a84488c5034e2b);

var $lCBBY = parcelRequire("lCBBY");
const $418fd006fc4a31c5$var$getStatusFromRestOption = (option)=>{
    if (option.released) return 'RELEASED';
    if (option.archived) return 'ARCHIVED';
    return 'UNRELEASED';
};
const $418fd006fc4a31c5$export$eb178ff2323a1ab3 = (option)=>({
        label: option.name,
        value: option.id,
        status: $418fd006fc4a31c5$var$getStatusFromRestOption(option)
    });
const $418fd006fc4a31c5$export$c1c38f7974aa8bed = (option)=>({
        label: option.name,
        value: option.id,
        status: option.status
    });
const $418fd006fc4a31c5$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
const $418fd006fc4a31c5$export$721c3d9226425f9c = (options, formatMessage)=>{
    const groupedOptions = [];
    // archived options are assumed to be filtered out already since we don't want to display them. Here, we are grouping according to 'status' being RELEASED or UNRELEASED
    if (options.length) {
        // the order of versions is decided from the first option since the API response follows the order
        const versionOrder = options.length && options[0].status === 'RELEASED' ? [
            'RELEASED',
            'UNRELEASED'
        ] : [
            'UNRELEASED',
            'RELEASED'
        ];
        // @ts-expect-error - TS2345 - Argument of type '(status: Status) => void' is not assignable to parameter of type '(value: string, index: number, array: string[]) => void'.
        versionOrder.forEach((status)=>{
            const statusOptions = options.filter((option)=>option.status === status);
            if (statusOptions.length) groupedOptions.push({
                options: statusOptions,
                label: status === 'RELEASED' ? formatMessage((0, $lCBBY.default).released) : formatMessage((0, $lCBBY.default).unreleased)
            });
        });
    }
    return groupedOptions;
};
const $418fd006fc4a31c5$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
            id: v.value
        }));
const $418fd006fc4a31c5$export$d0a84488c5034e2b = (selectedVersion)=>({
        id: selectedVersion.value
    });

});
parcelRegister("lCBBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958e5bb1549bd80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a958e5bb1549bd80$var$messages = (0, $7VHMR.defineMessages)({
    released: {
        "id": "issue-field-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "issue-field-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});
var $a958e5bb1549bd80$export$2e2bcd8739ae039 = $a958e5bb1549bd80$var$messages;

});



parcelRegister("cBHNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40c0e93e07915fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b40c0e93e07915fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.multi-versions-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.multi-versions-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("34EcD", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $f99feaf445ed0ec0$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateMultiVersionsField", () => $f99feaf445ed0ec0$export$6999207a9642bd09);

var $dTQPF = parcelRequire("dTQPF");

const $f99feaf445ed0ec0$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $f99feaf445ed0ec0$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $a7d2b97eb2e0b950$export$31fd86f8f183952c),
        versions: selectedVersions.map(({ value: value })=>({
                versionId: value
            }))
    });

});
const $a7d2b97eb2e0b950$export$31fd86f8f183952c = 'multipleVersionPickerFields';



parcelRegister("aQNfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04647b01be2b83f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hTBEr = parcelRequire("hTBEr");

var $dTQPF = parcelRequire("dTQPF");

var $45JN1 = parcelRequire("45JN1");

var $7C5S0 = parcelRequire("7C5S0");

var $hpV4g = parcelRequire("hpV4g");

var $gLdtQ = parcelRequire("gLdtQ");

var $jGVMX = parcelRequire("jGVMX");

var $jrGSc = parcelRequire("jrGSc");

var $1AaWN = parcelRequire("1AaWN");

const $d04647b01be2b83f$var$SingleVersionField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $gLdtQ.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
    };
    const options = (0, $1AaWN.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTBEr.default), {
            options: options,
            value: value,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: false,
            isDisabled: isDisabled,
            placeholder: isDisabled ? formatMessage((0, $jrGSc.default).none) : '',
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7C5S0.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jrGSc.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $45JN1.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $d04647b01be2b83f$export$2e2bcd8739ae039 = (0, $hpV4g.withFormField)({
    validator: (0, $jGVMX.validateSingleVersionField),
    transformDefaultValue: (0, $dTQPF.transformVersionExternalToVersion),
    shouldRenderFieldMessage: false
})($d04647b01be2b83f$var$SingleVersionField);

});
parcelRegister("jrGSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5396ea8e93f1b004$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5396ea8e93f1b004$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "issue-create-commons.single-version-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.single-version-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("1AaWN", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $79dd8b3734a0e456$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateSingleVersionField", () => $79dd8b3734a0e456$export$57ed62196c76c8b6);

var $dTQPF = parcelRequire("dTQPF");

const $79dd8b3734a0e456$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dTQPF.transformVersionExternalToVersion)(option));
const $79dd8b3734a0e456$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $703505cc37235a2c$export$31fd86f8f183952c),
        version: {
            versionId: value
        }
    });

});
const $703505cc37235a2c$export$31fd86f8f183952c = 'singleVersionPickerFields';





const $da56d43fdbe95df7$export$a5614f895fe1c5d2 = 'FORM_NOT_FOUND';
const $da56d43fdbe95df7$export$afa01ec4f7c760a0 = 'PROJECT_NOT_FOUND';


parcelRegister("45NOA", function(module, exports) {

$parcel$export(module.exports, "filterFieldsMeta", () => $e161d853a36b3724$export$6a17577fedf4efeb);
$parcel$export(module.exports, "transformFieldsMeta", () => $e161d853a36b3724$export$613acfe083d57f99);

var $dPSWJ = parcelRequire("dPSWJ");

var $5fc53 = parcelRequire("5fc53");
const $e161d853a36b3724$export$6a17577fedf4efeb = (fieldMeta)=>{
    // remove specific field property from fieldMeta
    const { issuetype: issuetype, project: project, reporter: reporter, ...otherFieldMeta } = fieldMeta;
    return otherFieldMeta;
};
const $e161d853a36b3724$export$5647ab885112c565 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $e161d853a36b3724$var$isCascadingField = (fieldMeta)=>fieldMeta.schema?.custom === $e161d853a36b3724$export$5647ab885112c565;
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type.
const $e161d853a36b3724$var$transformCascadingFieldChildValue = ({ id: id, value: value })=>({
        id: id,
        value: value,
        __typename: 'JiraCascadingOptions'
    });
const $e161d853a36b3724$export$8e0c8a960f1af96 = ({ id: id, value: value, children: children = [] })=>({
        parentOptionValue: {
            id: id,
            value: value,
            __typename: 'JiraOption'
        },
        childOptionValues: children.map($e161d853a36b3724$var$transformCascadingFieldChildValue)
    });
// https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-groups/#api-rest-api-3-groups-picker-get
const $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT = '/rest/api/3/groups/picker?query=';
const $e161d853a36b3724$var$isGroupField = (fieldMeta)=>fieldMeta.schema?.custom === (0, $5fc53.GROUP_CF_TYPE) || fieldMeta.schema?.custom === (0, $5fc53.MULTI_GROUP_CF_TYPE);
const $e161d853a36b3724$var$transformGroupField = (fieldMeta)=>({
        ...fieldMeta,
        autoCompleteUrl: $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT
    });
const $e161d853a36b3724$export$613acfe083d57f99 = (fieldsMeta)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(fieldsMeta, (field)=>{
        // An autocomplete URL is not included in field meta data for Single or Multi group picker fields.
        // For now, manually include the autocomplete URL for these fields.
        if ($e161d853a36b3724$var$isGroupField(field)) return $e161d853a36b3724$var$transformGroupField(field);
        if (!$e161d853a36b3724$var$isCascadingField(field)) return field;
        const { allowedValues: allowedValues = [], ...rest } = field;
        return {
            allowedValues: allowedValues.filter((value)=>value != null).map($e161d853a36b3724$export$8e0c8a960f1af96),
            ...rest
        };
    });

});


parcelRegister("5FLxe", function(module, exports) {

$parcel$export(module.exports, "useFormById", () => $fb77ed67ab7c7c60$export$ac7a76dbf4149182);
$parcel$export(module.exports, "useGetFormWithFieldDataByFormId", () => $fb77ed67ab7c7c60$export$7c42f44d9574ee82);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8qFWq = parcelRequire("8qFWq");

var $0557y = parcelRequire("0557y");
const $fb77ed67ab7c7c60$export$ac7a76dbf4149182 = (formId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $5tTFS.useLazyQuery)((0, $8qFWq.JIRA_BUSINESS_FORM_BY_ID));
    (0, $5uXOq.useEffect)(()=>{
        if (formId != null) {
            (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            const QUERY_NAME = 'JiraBusinessFormById';
            fetch({
                variables: {
                    formId: formId,
                    isConditionalFieldsEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_'),
                    isPublicFormsEnabled: (0, $4R6GH.fg)('jira-forms-public-access')
                },
                // @ts-expect-error - TS2345 - Argument of type '{ variables: { formId: string; }; onError: (apolloError: any) => void; onCompleted: () => void; }' is not assignable to parameter of type 'QueryLazyOptions<JiraBusinessFormByIdVariables>'. | TS7006 - Parameter 'apolloError' implicitly has an 'any' type.
                onError: (apolloError)=>{
                    if ((0, $4R6GH.fg)('jira_forms_filter_4xx_error')) {
                        const { graphQLErrors: graphQLErrors } = apolloError;
                        const isValidError = (0, $0557y.isValidErrorForLogging)(graphQLErrors ?? []);
                        if (isValidError) (0, $jcw0u.default)({
                            meta: {
                                id: QUERY_NAME,
                                packageName: 'jiraBusinessForm',
                                teamName: 'jira-werewolves'
                            },
                            error: apolloError,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    } else (0, $jcw0u.default)({
                        meta: {
                            id: QUERY_NAME,
                            packageName: 'jiraBusinessForm',
                            teamName: 'jira-werewolves'
                        },
                        error: apolloError,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                },
                onCompleted: ()=>{
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
                    (0, $gN11a.markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                }
            });
        }
    }, [
        createAnalyticsEvent,
        fetch,
        formId
    ]);
    const form = (0, $5uXOq.useMemo)(()=>(0, $0557y.transformJiraBusinessForm)({
            data: data
        }), [
        data
    ]);
    return {
        form: form,
        loading: loading,
        error: error
    };
};
const $fb77ed67ab7c7c60$export$7c42f44d9574ee82 = (formId)=>{
    const QUERY_NAME = 'JiraBusinessFormWithFieldDataByFormId';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
    }, []);
    const { data: data, loading: loading, error: error } = (0, $5tTFS.useQuery)((0, $8qFWq.JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID), {
        /**
		 * Forms currently has no requirement to utilize a cache, however if
		 * this policy is changed, be aware that you may need to make other changes
		 * to ensure that GQL unions work as expected and/or the cache doesn't
		 * collide with other features.
		 * See: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/45683/overview?commentId=2977330
		 */ fetchPolicy: 'no-cache',
        variables: {
            formId: formId,
            isConditionalFieldsEnabled: (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_'),
            isPublicFormsEnabled: (0, $4R6GH.fg)('jira-forms-public-access')
        },
        onError: (apolloError)=>{
            if ((0, $4R6GH.fg)('jira_forms_filter_4xx_error')) {
                const { graphQLErrors: graphQLErrors } = apolloError;
                const isValidError = (0, $0557y.isValidErrorForLogging)(graphQLErrors ?? []);
                if (isValidError) (0, $jcw0u.default)({
                    meta: {
                        id: QUERY_NAME,
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else (0, $jcw0u.default)({
                meta: {
                    id: QUERY_NAME,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        },
        onCompleted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    });
    return {
        data: (0, $0557y.transformFormDataWithFieldData)({
            data: data
        }),
        loading: loading,
        error: error
    };
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("8qFWq", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FORM_BY_ID", () => $a583d3b87ccf6299$export$46b3396662c77cec);
$parcel$export(module.exports, "JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID", () => $a583d3b87ccf6299$export$30c35ae67d1502b);

var $5cllN = parcelRequire("5cllN");

var $cRgoL = parcelRequire("cRgoL");
const $a583d3b87ccf6299$export$46b3396662c77cec = (0, $5cllN.default)`
  query JiraBusinessFormById($formId: ID!, $isConditionalFieldsEnabled: Boolean!, $isPublicFormsEnabled: Boolean!) {
    jiraBusinessForm(formId: $formId) {
      ...FormBuilderConfigurationFragment
    }
  }

  ${(0, $cRgoL.FORM_BUILDER_CONFIGURATION_FRAGMENT)}
`;
const $a583d3b87ccf6299$export$30c35ae67d1502b = (0, $5cllN.default)`
  query JiraBusinessFormWithFieldDataByFormId(
		$formId: ID!,
		$isConditionalFieldsEnabled: Boolean!
    $isPublicFormsEnabled: Boolean = false
	) {
    jiraBusinessForm(formId: $formId) {
      formId
      uuid @include(if: $isPublicFormsEnabled)
      projectId
      issueType {
        name
        issueTypeId
      }
      title
      description
      bannerColor
      enabled
      accessLevel
      fields {
        fieldId
        alias
        description
        isRequired
				parentCondition @include(if: $isConditionalFieldsEnabled) {
					...FieldParentConditionFragment
				}
        field {
          name
          type
          ... on GenericIssueField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraIssueFieldConfiguration {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraRichTextField {
            renderer
          }
        }
      }
    }
  }

	${(0, $cRgoL.FIELD_PARENT_CONDITION_FRAGMENT)}
`;

});
parcelRegister("cRgoL", function(module, exports) {

$parcel$export(module.exports, "FORM_BUILDER_CONFIGURATION_FRAGMENT", () => $e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c);
$parcel$export(module.exports, "FORM_CONFIGURATION_FOR_DIRECTORY", () => $e4d2e67206dcc3bb$export$e89d36bee87f0323);
$parcel$export(module.exports, "MUTATION_ERROR_FRAGMENT", () => $e4d2e67206dcc3bb$export$25fa4c03959b6e86);
$parcel$export(module.exports, "FIELD_PARENT_CONDITION_FRAGMENT", () => $e4d2e67206dcc3bb$export$4e44bfa60653a6f1);

var $5cllN = parcelRequire("5cllN");
const $e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c = (0, $5cllN.default)`
 fragment FormBuilderConfigurationFragment on JiraBusinessFormConfiguration {
    id
    uuid @include(if: $isPublicFormsEnabled)
    formId
    projectId
    title
    description
    bannerColor
    enabled
    isSubmittableByAllLoggedInUsers
    publicFormsEnabled @include(if: $isPublicFormsEnabled)
    accessLevel
    configurationErrors @include(if: $isPublicFormsEnabled)
    defaultReporter @include(if: $isPublicFormsEnabled) {
      accountId
      name
      picture
    }
    fields {
      id
      fieldId
      alias
      description
      isRequired
      parentCondition @include(if: $isConditionalFieldsEnabled) {
        id
      }
      conditions @include(if: $isConditionalFieldsEnabled) {
        __typename
        id
        ... on JiraFormSelectCondition {
          fieldOptionIds
          operator
        }
      }
      field @include(if: $isConditionalFieldsEnabled) {
        __typename
        id
		... on JiraSingleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraMultipleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraRadioSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraCheckboxesField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraPriorityField {
			priorities {
				edges {
					node {
						id
						priorityId
						name
						iconUrl
					}
				}
			}
		}
      }
    }
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
 }
`;
const $e4d2e67206dcc3bb$export$e89d36bee87f0323 = (0, $5cllN.default)`
  fragment FormConfigurationFragmentForDirectory on JiraBusinessFormConfiguration {
    id
    uuid @include(if: $isPublicFormsEnabled)
    formId
    title
    description
    bannerColor
    enabled
    updated
    accessLevel
    issueType {
      issueTypeId
      name
      avatarId
      avatar {
        medium
      }
    }
    updateAuthor {
      name
      accountId
    }
    errors
  }
`;
const $e4d2e67206dcc3bb$export$25fa4c03959b6e86 = (0, $5cllN.default)`
  fragment MutationErrorFragment on MutationError {
    message
    extensions {
      statusCode
      errorType
    }
  }
`;
const $e4d2e67206dcc3bb$export$4e44bfa60653a6f1 = (0, $5cllN.default)`
	fragment FieldParentConditionFragment on JiraFormFieldCondition {
		__typename
		id
		... on JiraFormSelectCondition {
			fieldOptionIds
			operator
		}
		parentField {
			id
			fieldId
			field {
				__typename
				id
			}
		}
	}
`;

});


parcelRegister("0557y", function(module, exports) {

$parcel$export(module.exports, "transformJiraBusinessForm", () => $b6818a16bbb72cb8$export$c07aa36a491f7398);
$parcel$export(module.exports, "transformFormDataWithFieldData", () => $b6818a16bbb72cb8$export$9488a647bac5a6d6);
$parcel$export(module.exports, "isFormNotFoundError", () => $b6818a16bbb72cb8$export$1227e121b71c2a43);
$parcel$export(module.exports, "isProjectNotFoundError", () => $b6818a16bbb72cb8$export$4084ebe6a1fddf86);
$parcel$export(module.exports, "formFieldByIdMatcher", () => $b6818a16bbb72cb8$export$a88a707fc50ff4c2);
$parcel$export(module.exports, "availableFieldByIdMatcher", () => $b6818a16bbb72cb8$export$bd8ddc5cdda736ac);
$parcel$export(module.exports, "isValidErrorForLogging", () => $b6818a16bbb72cb8$export$97ac389c31f7ef53);

var $4R6GH = parcelRequire("4R6GH");

var $7wwVP = parcelRequire("7wwVP");

var $f7GQf = parcelRequire("f7GQf");
const $b6818a16bbb72cb8$export$4dee7f5ded2c202d = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $f7GQf.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $b6818a16bbb72cb8$export$47e6f860e5c51292 = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $f7GQf.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $b6818a16bbb72cb8$export$c07aa36a491f7398 = ({ data: data })=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    // the mapping from GraphQL type to FE type
    // mainly affects the `fields` only
    // this is done to remove the `undefined` from the fields array so it will be easier to consume in the UI layer
    const form = {
        id: jiraBusinessForm.id,
        ...(0, $4R6GH.fg)('jira-forms-public-access') && {
            uuid: jiraBusinessForm.uuid
        },
        formId: jiraBusinessForm.formId,
        projectId: jiraBusinessForm.projectId,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        isSubmittableByAllLoggedInUsers: jiraBusinessForm.isSubmittableByAllLoggedInUsers,
        ...(0, $4R6GH.fg)('jira-forms-public-access') && {
            publicFormsEnabled: jiraBusinessForm.publicFormsEnabled
        },
        issueType: jiraBusinessForm.issueType ? {
            id: jiraBusinessForm.issueType.issueTypeId ?? '',
            name: jiraBusinessForm.issueType.name ?? '',
            avatarId: jiraBusinessForm.issueType.avatarId ?? null,
            avatarUrl: jiraBusinessForm.issueType.avatar?.medium ?? null,
            isDefault: false,
            subtask: jiraBusinessForm.issueType.type === 'SUB_TASK',
            hierarchyLevel: jiraBusinessForm.issueType.hierarchy?.level ?? 0
        } : null,
        fields: jiraBusinessForm.fields?.filter(Boolean).map((f)=>({
                id: f.id,
                fieldId: f.fieldId,
                alias: f.alias ?? undefined,
                isRequiredByForm: !!f.isRequired,
                description: f.description ?? undefined,
                ...(0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && {
                    conditions: f.conditions?.concat(),
                    parentCondition: f.parentCondition,
                    field: f.field
                }
            })).filter($b6818a16bbb72cb8$export$4dee7f5ded2c202d) ?? null,
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $7wwVP.FormAccessLevelTypes).LIMITED,
        ...jiraBusinessForm.defaultReporter && (0, $4R6GH.fg)('jira-forms-default-reporter-enabled') && {
            defaultReporter: {
                id: jiraBusinessForm.defaultReporter.accountId,
                name: jiraBusinessForm.defaultReporter.name,
                avatarUrl: jiraBusinessForm.defaultReporter.picture
            }
        },
        ...(0, $4R6GH.fg)('jira-forms-configuration-errors-enabled') && {
            configurationErrors: // Due to the inability to import the generated enum (JiraFormConfigurationErrorType) from gira.d.ts, we need to assert
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            jiraBusinessForm.configurationErrors
        }
    };
    return form;
};
const $b6818a16bbb72cb8$export$9488a647bac5a6d6 = ({ data: data })=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    return {
        formId: jiraBusinessForm.formId,
        uuid: jiraBusinessForm.uuid,
        projectId: jiraBusinessForm.projectId,
        issueType: jiraBusinessForm.issueType ? {
            name: jiraBusinessForm.issueType.name || '',
            id: jiraBusinessForm.issueType.issueTypeId ?? ''
        } : null,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        fields: jiraBusinessForm.fields?.filter(Boolean).filter((f)=>'fieldConfig' in f.field).map((f)=>{
            const fieldIsRequiredByIssueConfig = 'fieldConfig' in f.field && Boolean(f.field.fieldConfig?.isRequired);
            const fieldIsRequiredByFormConfig = !!f.isRequired;
            return {
                fieldId: f.fieldId,
                alias: f.alias,
                name: f.field.name,
                isRequired: fieldIsRequiredByIssueConfig,
                isRequiredByForm: fieldIsRequiredByFormConfig,
                description: f.description ?? undefined,
                type: f.field.type,
                ...(0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && {
                    parentCondition: f.parentCondition
                },
                ...(0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') && {
                    // @ts-expect-error - TS2339: Property 'renderer' does not exist on type 'JiraBusinessFormWithFieldDataByFormId_jiraBusinessForm_fields_field'.
                    renderer: f.field.renderer ?? undefined
                }
            };
        }).filter($b6818a16bbb72cb8$export$47e6f860e5c51292) ?? [],
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $7wwVP.FormAccessLevelTypes).LIMITED
    };
};
const $b6818a16bbb72cb8$export$1227e121b71c2a43 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, $f7GQf.FORM_NOT_FOUND_ERROR);
const $b6818a16bbb72cb8$export$4084ebe6a1fddf86 = (error)=>{
    if (!error.graphQLErrors || error.graphQLErrors.length === 0) return false;
    return error.graphQLErrors[0]?.extensions?.errorType === (0, $f7GQf.PROJECT_NOT_FOUND_ERROR);
};
const $b6818a16bbb72cb8$export$a88a707fc50ff4c2 = (fieldId)=>(field)=>field.fieldId === fieldId;
const $b6818a16bbb72cb8$export$bd8ddc5cdda736ac = (fieldId)=>(field)=>field.fieldId === fieldId;
const $b6818a16bbb72cb8$export$97ac389c31f7ef53 = (errors)=>{
    if (errors.length === 0) return false;
    const firstError = errors[0];
    const statusCode = firstError?.extensions?.statusCode ?? 0;
    const isValidError = statusCode < 400 || statusCode >= 500;
    return isValidError;
};

});
parcelRegister("f7GQf", function(module, exports) {

$parcel$export(module.exports, "IGNORE_FIELD_IDS", () => $5c143e6311b821dd$export$18705e0cb6bd7398);
$parcel$export(module.exports, "FORM_NOT_FOUND_ERROR", () => $5c143e6311b821dd$export$a5614f895fe1c5d2);
$parcel$export(module.exports, "PROJECT_NOT_FOUND_ERROR", () => $5c143e6311b821dd$export$afa01ec4f7c760a0);

var $5fc53 = parcelRequire("5fc53");
const $5c143e6311b821dd$export$18705e0cb6bd7398 = [
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.ISSUE_TYPE)
];
const $5c143e6311b821dd$export$a5614f895fe1c5d2 = 'FORM_NOT_FOUND';
const $5c143e6311b821dd$export$afa01ec4f7c760a0 = 'PROJECT_NOT_FOUND';

});



parcelRegister("jujEW", function(module, exports) {

$parcel$export(module.exports, "useGetFormWithFieldDataByFormUuid", () => $f3cb731a6b352e8d$export$51688099674fae4a);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lhPzZ = parcelRequire("lhPzZ");

var $aFxfC = parcelRequire("aFxfC");
const $f3cb731a6b352e8d$export$51688099674fae4a = (formUuid)=>{
    const QUERY_NAME = 'JiraBusinessFormWithFieldDataByFormUuid';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $gN11a.markViewMetric)('form-submit-public', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
    }, []);
    const { data: data, loading: loading, error: error } = (0, $5tTFS.useQuery)((0, $lhPzZ.JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_UUID), {
        /**
		 * Forms currently has no requirement to utilize a cache, however if
		 * this policy is changed, be aware that you may need to make other changes
		 * to ensure that GQL unions work as expected and/or the cache doesn't
		 * collide with other features.
		 * See: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/45683/overview?commentId=2977330
		 */ fetchPolicy: 'no-cache',
        variables: {
            publicFormUuid: formUuid
        },
        onError: (apolloError)=>{
            const analyticsError = apolloError;
            const skipSentry = (0, $aFxfC.isFormNotFoundError)(analyticsError) || (0, $aFxfC.isProjectNotFoundError)(analyticsError);
            if (skipSentry) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsError.skipSentry = true;
            (0, $jcw0u.default)({
                meta: {
                    id: QUERY_NAME,
                    packageName: 'jiraBusinessPublicForm',
                    teamName: 'jira-werewolves'
                },
                error: analyticsError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        },
        onCompleted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
            (0, $gN11a.markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    });
    return {
        data: (0, $aFxfC.transformPublicFormDataWithFieldData)({
            data: data
        }),
        loading: loading,
        error: error
    };
};

});
parcelRegister("lhPzZ", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_UUID", () => $bb10c02279468e42$export$6651e013eccac679);

var $5cllN = parcelRequire("5cllN");

var $cRgoL = parcelRequire("cRgoL");
const $bb10c02279468e42$export$6651e013eccac679 = (0, $5cllN.default)`
  query JiraBusinessFormWithFieldDataByFormUuid($publicFormUuid: ID!) {
    jiraFormForPublicSubmission(publicFormUuid: $publicFormUuid) {
      formId
      uuid
      projectId
      title
      description
      bannerColor
      enabled
      emailRequired
      fields {
        fieldId
        alias
        description
        isRequired
        parentCondition {
          ...FieldParentConditionFragment
        }
        field {
          __typename
          name
          type
          ... on GenericIssueField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraIssueFieldConfiguration {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraRichTextField {
            renderer
          }
          ... on JiraSingleSelectField {
            fieldOptions {
              edges {
                node {
                  value
                  optionId
                }
              }
            }
            fieldOption {
              value
              optionId
            }
            fieldConfig {
              isRequired
              __typename
            }
            __typename
          }
          ... on JiraMultipleSelectField {
            fieldOptions {
              edges {
                node {
                  value
                  optionId
                }
              }
            }
            selectedValues {
              edges {
                node {
                  id
                  selectableLabel
                  selectableUrl
                  selectableGroupKey
                }
              }
            }
            fieldConfig {
              isRequired
            }
            __typename
          }
          ... on JiraCascadingSelectField {
            cascadingOption {
              childOptionValue {
                value
                optionId
              }
            }
            cascadingOptions {
              edges {
                node {
                  parentOptionValue {
                    value
                    optionId
                  }
                  childOptionValues {
                    value
                    optionId
                  }
                }
              }
            }
            fieldConfig {
              isRequired
            }
            __typename
          }
          ... on JiraRadioSelectField {
            fieldOptions {
              edges {
                node {
                  value
                  optionId
                }
              }
            }
            selectedOption {
              value
              optionId
            }
          }
          ... on JiraPriorityField {
            priorities {
              edges {
                node {
                  name
                  priorityId
                  iconUrl
                  color
                  sequence
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldOptions {
              edges {
                node {
                  value
                  optionId
                }
              }
            }
          }
          ... on JiraUrlField {
            uri
          }
        }
      }
    }
  }

	${(0, $cRgoL.FIELD_PARENT_CONDITION_FRAGMENT)}
`;

});


parcelRegister("8feUl", function(module, exports) {

$parcel$export(module.exports, "getFormValidationData", () => $c8efa796b9edd3e8$export$1b92201c43ea8a87);

var $fOgCm = parcelRequire("fOgCm");
const $c8efa796b9edd3e8$export$1b92201c43ea8a87 = ({ formData: formData, fieldMetaData: fieldMetaData, projectType: projectType })=>{
    if (!formData || !fieldMetaData) return null;
    // required fields in form that are also required in the issue type
    const formRequiredFields = formData.fields.filter((f)=>f.isRequired && !!fieldMetaData[f.fieldId]);
    // required fields in project
    const requiredFieldIds = Object.keys(fieldMetaData).filter((fieldId)=>fieldMetaData[fieldId].required);
    const formContainsAllRequiredFields = formRequiredFields.length === requiredFieldIds.length;
    const isAllRequiredFieldsSupported = requiredFieldIds.every((f)=>{
        const fieldType = fieldMetaData[f].schema?.custom || fieldMetaData[f].schema?.system;
        if (!fieldType) return false;
        return (0, $fOgCm.isFieldTypeSupported)(fieldType, projectType);
    });
    const fieldsRequiredByForm = formData.fields.filter((f)=>f.isRequiredByForm && !!fieldMetaData[f.fieldId]);
    const hasProjectScopedRequiredFields = fieldsRequiredByForm.some(({ type: fieldType })=>{
        if (!fieldType) return false;
        return (0, $fOgCm.isProjectScopedFieldType)(fieldType);
    });
    return {
        isFormSubmissionValid: formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasMissingSupportedRequiredFields: !formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasUnsupportedRequiredFields: !isAllRequiredFieldsSupported,
        hasProjectScopedRequiredFields: hasProjectScopedRequiredFields
    };
};

});


parcelRegister("lJBp3", function(module, exports) {

$parcel$export(module.exports, "isPublicFormsExperimentEnabledNoExp", () => $25f30b74a35bb792$export$a276dc0bf39931ab);
$parcel$export(module.exports, "usePublicFormsEnabledAnalyticsAttrs", () => $25f30b74a35bb792$export$2bbf8e604f37f9b7);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $25f30b74a35bb792$export$a276dc0bf39931ab = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_forms_public_access_experiment');
    return config.get('isEnabled', false);
};
const $25f30b74a35bb792$export$2bbf8e604f37f9b7 = (isBuilder = false)=>(0, $5uXOq.useMemo)(()=>({
            isPublicFormsEnabled: isBuilder ? $25f30b74a35bb792$export$a276dc0bf39931ab() : (0, $4R6GH.fg)('jira-forms-public-access'),
            isPublicFormsExperimentEnabled: $25f30b74a35bb792$export$a276dc0bf39931ab(),
            isPublicFormsGateEnabled: (0, $4R6GH.fg)('jira-forms-public-access')
        }), [
        isBuilder
    ]);

});


parcelRegister("hmRfM", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionRoot", () => $5045058046d328b0$export$4ae1a0970466e244);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MHKc7 = parcelRequire("MHKc7");

var $fNobW = parcelRequire("fNobW");

var $eiOkd = parcelRequire("eiOkd");

var $e21nk = parcelRequire("e21nk");

var $cm8b5 = parcelRequire("cm8b5");

var $8HvEs = parcelRequire("8HvEs");

var $7Wnap = parcelRequire("7Wnap");

var $7yduy = parcelRequire("7yduy");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $l8ruj = parcelRequire("l8ruj");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $cZpsT = parcelRequire("cZpsT");

var $iEEXl = parcelRequire("iEEXl");

var $7wwVP = parcelRequire("7wwVP");

var $j3cMm = parcelRequire("j3cMm");

var $6czoq = parcelRequire("6czoq");

var $aCsR5 = parcelRequire("aCsR5");

var $lJBp3 = parcelRequire("lJBp3");

var $lvFc8 = parcelRequire("lvFc8");

var $fOgCm = parcelRequire("fOgCm");

var $b668c = parcelRequire("b668c");

var $g2iZ7 = parcelRequire("g2iZ7");

var $djHla = parcelRequire("djHla");

var $fbFvx = parcelRequire("fbFvx");


var $7YlSK = parcelRequire("7YlSK");

var $f9uY0 = parcelRequire("f9uY0");

var $b8mPJ = parcelRequire("b8mPJ");
const $5045058046d328b0$var$FormContent = /*#__PURE__*/ (0, $5uXOq.memo)(({ formSubmissionLoading: formSubmissionLoading, formSubmissionData: formSubmissionData, formSubmissionError: formSubmissionError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const accessLevel = formSubmissionData?.formWithFieldData?.accessLevel;
    const canCreateIssues = Boolean(project?.permissions.createIssues) || accessLevel === (0, $7wwVP.FormAccessLevelTypes).OPEN || accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access');
    const hasError = formSubmissionError !== undefined; // if form's issue type has been deleted
    if (accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC && !formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.IssueTypeDeletedView), null);
     // if form's issue type has been disassociated from the project
    if (accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC && !formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData.fieldMetaData && canCreateIssues && formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.IssueTypeNotAssociatedView), {
        issueTypeName: formSubmissionData?.formWithFieldData?.issueType?.name ?? ''
    });
     // if user has no permission to create issues
    if (!canCreateIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.NoPermissionView), null);
     // if issue cannot be created because there are missing supported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasMissingSupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormMissingSupportedRequiredFieldsView), null);
     // if issue cannot be created because there are missing unsupported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasUnsupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormContainsUnsupportedRequiredFieldsView), null);
    if (accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC || !(0, $4R6GH.fg)('jira-forms-public-access')) {
        const canViewIssues = Boolean(project?.permissions.viewIssues); // if issue cannot be created because there are project-scoped required fields and the user does not have permission to view them
        const noPermissionToViewProjectScopedRequiredFields = formSubmissionData?.formSubmissionValidationData?.hasProjectScopedRequiredFields && !canViewIssues;
        if (noPermissionToViewProjectScopedRequiredFields) {
            const projectScopedRequiredFields = formSubmissionData?.formWithFieldData?.fields.filter((f)=>f.isRequiredByForm && (0, $fOgCm.isProjectScopedFieldType)(f.type)).map((f)=>f.type) ?? [];
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'formUnavailable viewed', {
                error: 'noPermissionToViewProjectScopedRequiredFields',
                projectScopedRequiredFields: projectScopedRequiredFields
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.NoProjectAccessView), null);
        }
    } // generic screen for any other kind of error
    if (hasError || formSubmissionData == null || formSubmissionData.formWithFieldData == null || formSubmissionData.fieldMetaData == null || formSubmissionData?.formWithFieldData?.enabled === false || formSubmissionData?.formSubmissionValidationData?.isFormSubmissionValid === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.FormUnavailableView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $djHla.MediaPermissionsPreloader), {
        projectId: String(formSubmissionData.formWithFieldData.projectId),
        formId: formSubmissionData.formWithFieldData.formId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f9uY0.FillInView), null));
});
const $5045058046d328b0$var$styles = {
    container: "_2rkoglpi _ca0qxy5q _n3tdxy5q _19bvxy5q _u5f3xy5q _2hwx1wug _18u01wug _16qszucj _p12f7a86 _1bsb1osq"
};
const $5045058046d328b0$export$2f8578dc462e47a9 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { featureView: featureView } = (0, $b668c.useJWMFormsFeatures)();
    const { data: formSubmissionData, loading: formSubmissionLoading, error: formSubmissionError } = (0, $g2iZ7.useFormSubmission)();
    const pageHeading = formatMessage((0, $b8mPJ.default).pageHeading);
    const hasError = formSubmissionError !== undefined;
    const loading = formSubmissionLoading;
    const experienceTrackerAttributes = {
        ...(0, $lvFc8.useConditionalFieldLogicAnalyticsAttrs)(),
        ...(0, $lJBp3.usePublicFormsEnabledAnalyticsAttrs)()
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "form-submission"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "form-submission",
        hold: loading
    }), !loading && (0, $4R6GH.fg)('jira_move_fire_screen_analytics_to_form_submission') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            usedFieldsCount: formSubmissionData?.formWithFieldData?.fields?.length ?? undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e21nk.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCsR5.FormBackground), {
        bannerColor: formSubmissionData?.formWithFieldData?.bannerColor,
        showPoweredByJiraFooter: (0, $4R6GH.fg)('jira-forms-public-access')
    }, (0, $4R6GH.fg)('jira-forms-public-access') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $5045058046d328b0$var$styles.container,
        backgroundColor: "elevation.surface.raised"
    }, !hasError && loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$Placeholder, {
        id: "form-content",
        "data-testid": "business-form.ui.form-submission.place-holder"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$FormContent, {
        formSubmissionLoading: formSubmissionLoading,
        formSubmissionData: formSubmissionData,
        formSubmissionError: formSubmissionError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: formSubmissionData?.formWithFieldData?.accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iEEXl.VIEW_FORM_PUBLIC_SUBMISSION_EXPERIENCE) : (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        attributes: experienceTrackerAttributes
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3cMm.Card), {
        minHeight: (0, $410f34228866ee1a$export$aa78f5e84beba3ce)
    }, !hasError && loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$Placeholder, {
        id: "form-content",
        "data-testid": "business-form.ui.form-submission.place-holder"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$FormContent, {
        formSubmissionLoading: formSubmissionLoading,
        formSubmissionData: formSubmissionData,
        formSubmissionError: formSubmissionError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $iEEXl.VIEW_FORM_SUBMISSION_EXPERIENCE),
        attributes: experienceTrackerAttributes
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HvEs.PerformanceAnalytics), {
        view: featureView,
        loading: loading
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yduy.JWMSpaStatePageReady), null));
});
const $5045058046d328b0$export$4ae1a0970466e244 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { data: formSubmissionData, formId: formId } = (0, $g2iZ7.useFormSubmission)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const formAnalyticAttributes = (0, $5uXOq.useMemo)(()=>({
            accessLevel: formSubmissionData?.formWithFieldData?.accessLevel?.toString(),
            isOutsideUser: !project || !project?.permissions.createIssues,
            formId: formId,
            isLoggedIn: (0, $4R6GH.fg)('jira-forms-public-access') ? !isAnonymous : undefined
        }), [
        formSubmissionData,
        project,
        formId,
        isAnonymous
    ]);
    const { shouldRedirectToPublicFormSubmission: shouldRedirectToPublicFormSubmission, redirectToPublicFormSubmission: redirectToPublicFormSubmission } = (0, $fbFvx.useRedirectToPublicFormSubmission)();
    if (shouldRedirectToPublicFormSubmission()) redirectToPublicFormSubmission();
    let shouldShowContactAdminBanner = false;
    if (formSubmissionData?.formWithFieldData?.accessLevel !== (0, $7wwVP.FormAccessLevelTypes).PUBLIC || !(0, $4R6GH.fg)('jira-forms-public-access')) {
        const canCreateOrModifyForm = Boolean(project?.permissions.administerProject);
        shouldShowContactAdminBanner = !canCreateOrModifyForm && query[(0, $iEEXl.URL_PARAMS).FROM] === (0, $iEEXl.URL_PARAMS).DIRECTORY;
    }
    const analyticsAttributes = {
        ...(0, $lvFc8.useConditionalFieldLogicAnalyticsAttrs)(),
        ...(0, $lJBp3.usePublicFormsEnabledAnalyticsAttrs)(),
        ...formAnalyticAttributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "form-submission-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "businessFormSubmission",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: analyticsAttributes
    }, shouldShowContactAdminBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YlSK.ContactAdminBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiOkd.default), {
        shouldAddPadding: false,
        withOverflow: !(0, $4R6GH.fg)('jira-forms-public-access')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$export$2f8578dc462e47a9, null)), !(0, $4R6GH.fg)('jira_move_fire_screen_analytics_to_form_submission') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5045058046d328b0$var$Placeholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ip3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eiOkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98d0f47ed36cd9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");


var $bUSNl = parcelRequire("bUSNl");

var $lLfAu = parcelRequire("lLfAu");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLfAu.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b98d0f47ed36cd9a$var$contentWrapperStyles,
            isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98d0f47ed36cd9a$var$ThemedContainer, {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $6cG4N.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b98d0f47ed36cd9a$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _vchhusvi _1e0c1txw _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syazfrbu",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $jnA4H = parcelRequire("jnA4H");

const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$b3747bec68e731a9 = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        let minWidth;
        const sidebarWidthFromStore = (0, $jnA4H.getSidebarWidthFromStore)(state);
        if ((0, $4R6GH.fg)('fix_reply_editor_width')) minWidth = Math.min(sidebarWidthFromStore, (0, $55f230b510f63572$export$77e787f7c2e430e5));
        else minWidth = Math.min(sidebarWidthFromStore, $39fc2da09b28cabf$export$b3747bec68e731a9());
        const newWidth = Math.max(width, minWidth);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set((0, $55f230b510f63572$export$86880b4b2e1a2384), newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: null,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);
$parcel$export(module.exports, "getSidebarWidthFromStore", () => $301038d04a64b539$export$ff9cb331cac6c6b5);

var $bSSG7 = parcelRequire("bSSG7");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');
const $301038d04a64b539$export$ff9cb331cac6c6b5 = (store)=>{
    if (store.sidebarWidth) return store.sidebarWidth;
    if ((0, $4R6GH.fg)('fix_reply_editor_width')) return 0, $55f230b510f63572$export$77e787f7c2e430e5;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
};

});
const $55f230b510f63572$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $55f230b510f63572$export$2146fa818259227f = 360;
const $55f230b510f63572$export$b16f75f2e0c3c029 = 435;
const $55f230b510f63572$export$77e787f7c2e430e5 = 463;



parcelRegister("lLfAu", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $1dbab6fa0f2d1b51$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lmBAt = parcelRequire("lmBAt");

var $getxR = parcelRequire("getxR");

var $He4jn = parcelRequire("He4jn");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");

var $eHSp3 = parcelRequire("eHSp3");
const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1dbab6fa0f2d1b51$var$sidebarStyles,
            /* styles now for all project theming. remove || 'business' condition on nav4 has been fully rolled out and jira_theming_milestone_1 has been cleaned up */ (theme === 'business' || theme && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && $1dbab6fa0f2d1b51$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
};
const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $getxR.useSidebarQueryParams)();
    const [store, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { content: content } = store;
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $He4jn.useResizer)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.SidebarContent), null, content)));
};
const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("getxR", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $7ddee5a34b903b90$export$34adbeffbeceba68);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3hGWp = parcelRequire("3hGWp");

var $bUSNl = parcelRequire("bUSNl");
const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $bUSNl.useSidebar)();
    const sidebarQueryParams = (0, $bUSNl.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $1XJ20.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $5uXOq.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $5uXOq.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $5uXOq.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM]) // sidebar is not open, exit
            return;
            if (queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("He4jn", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $80d7a99fb39f1e91$export$faede3f1542958fc);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");
const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
    const [store, { setSidebarWidth: setSidebarWidth }] = (0, $bUSNl.useSidebar)();
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const startRef = (0, $5uXOq.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $5uXOq.useRef)(0);
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousemove', onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("eHSp3", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $71d20039839e60ab$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $71d20039839e60ab$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $71d20039839e60ab$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $71d20039839e60ab$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _ogwtu2gc _6tinidpf _1cezu2gc _m3zkidpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _16r2glyw _qc5othzt _aetrb3bt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _gcm11p6i _4tpu1p6i",
            __cmplp.className
        ])
    });
});

});



parcelRegister("e21nk", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $aa5670652f17dfc4$export$416064ba09d98e69);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $54qG5 = parcelRequire("54qG5");
const $aa5670652f17dfc4$export$416064ba09d98e69 = /*#__PURE__*/ (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("54qG5", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $a71d927d8f07dfcc$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $a71d927d8f07dfcc$export$ff2574b00bc1c100);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $a71d927d8f07dfcc$var$BusinessEntityContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});


parcelRegister("8HvEs", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $0eced7986dcab954$export$ec3c3b39c046a620);

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");


var $2nbdU = parcelRequire("2nbdU");

var $3vR0I = parcelRequire("3vR0I");

var $7Wnap = parcelRequire("7Wnap");
const $0eced7986dcab954$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $5uXOq.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "performance-analytics-loading"
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vR0I.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2nbdU.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("2nbdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $551da07557368f71$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
const $551da07557368f71$export$46962be62755f053 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const samplingCount = (0, $5uXOq.useRef)(0);
    const frames = (0, $5uXOq.useRef)(0);
    const rafId = (0, $5uXOq.useRef)(null);
    const start = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $8zOmE.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;


parcelRegister("3vR0I", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $43e497a79074b7d0$export$70b569bf2edd0b7f);

var $5uXOq = parcelRequire("5uXOq");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("7Wnap", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $4c177752bab6a832$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $4c177752bab6a832$export$66b33c055cbb625e);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");


var $gN11a = parcelRequire("gN11a");
const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
    return null;
};
const $4c177752bab6a832$export$66b33c055cbb625e = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
    const metric = (0, $gN11a.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("7yduy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $150b436063f0aaae$export$d54524c142a057f);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");
const $150b436063f0aaae$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let id = window.requestAnimationFrame(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null);
};

});

parcelRegister("j3cMm", function(module, exports) {

$parcel$export(module.exports, "Card", () => $da92e917e9b85f56$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $da92e917e9b85f56$export$c75a6d3667a4a2e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _bfhkhp5a _otyru2gc _ca0qutpp _u5f3xy5q _n3tdutpp _19bvxy5q _16qszucj",
            __cmplp.className
        ])
    });
});
const $da92e917e9b85f56$var$StyledCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $da92e917e9b85f56$export$c75a6d3667a4a2e7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_brev0o": (0, $lD23V.default)(__cmplp.minHeight, "px"),
            "--_1upm8ip": (0, $lD23V.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.minHeight !== null ? "_1tke1rgx" : "_1tke1wug",
            __cmplp.maxHeight !== null ? "_c71l1w9o" : "_c71l1wug",
            __cmplp.className
        ])
    });
});
const $da92e917e9b85f56$export$60332b2344f7fe41 = $da92e917e9b85f56$var$StyledCard;

});

parcelRegister("aCsR5", function(module, exports) {

$parcel$export(module.exports, "FormBackground", () => $4c9d8229fbc4b0b5$export$e13fb218ba50bebd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cSD7y = parcelRequire("cSD7y");

var $3NYLB = parcelRequire("3NYLB");

var $oM98Q = parcelRequire("oM98Q");
const $4c9d8229fbc4b0b5$var$FormBackgroundOld = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, bannerColor: bannerColor, header: header })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$Background, {
        bannerColor: (0, $3NYLB.getDesignTokenBannerColor)(bannerColor)
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$ContentWrapper, null, children)));
const $4c9d8229fbc4b0b5$var$FormBackgroundNew = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, bannerColor: bannerColor, showPoweredByJiraFooter: showPoweredByJiraFooter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            background: `linear-gradient(to bottom, ${(0, $3NYLB.getDesignTokenBannerColor)(bannerColor) || "var(--ds-background-neutral-hovered, #091E4224)"} 30%, transparent 30%)`
        },
        xcss: $4c9d8229fbc4b0b5$var$backgroundStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4c9d8229fbc4b0b5$var$contentWrapperStyles
    }, children), showPoweredByJiraFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oM98Q.PoweredByJiraFooter), null)));
const $4c9d8229fbc4b0b5$export$e13fb218ba50bebd = (0, $cSD7y.componentWithFG)('jira-forms-public-access', $4c9d8229fbc4b0b5$var$FormBackgroundNew, $4c9d8229fbc4b0b5$var$FormBackgroundOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9d8229fbc4b0b5$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerColor: bannerColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1yndzv5": (0, $lD23V.default)(`linear-gradient(to bottom, ${__cmplp.bannerColor || "var(--ds-background-neutral-hovered, #091E4224)"} 30%, transparent 30%)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7nlav _qmxj1n9t _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4c9d8229fbc4b0b5$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbufrr _19pk1ejb _2hwx1wug _otyr1ejb _18u01wug",
            __cmplp.className
        ])
    });
});
const $4c9d8229fbc4b0b5$var$backgroundStyles = (0, $8CUq3.xcss)({
    backgroundAttachment: 'fixed',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
});
const $4c9d8229fbc4b0b5$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    flex: '1',
    width: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.300',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});

});
parcelRegister("3NYLB", function(module, exports) {

$parcel$export(module.exports, "getRandomBannerColor", () => $8d0eb4c1d86abc14$export$aefdd89adb2344b3);
$parcel$export(module.exports, "getDesignTokenBannerColor", () => $8d0eb4c1d86abc14$export$c3fba1eee1434e93);

const $8d0eb4c1d86abc14$var$FORM_COLORS = [
    (0, $829f609a65d26a98$export$60847d42f9da92a6),
    (0, $829f609a65d26a98$export$5aae31392d72caaa),
    (0, $829f609a65d26a98$export$747d86715d4175de),
    (0, $829f609a65d26a98$export$215b7063051591f1),
    (0, $829f609a65d26a98$export$69cb3ca10c1e330e),
    (0, $829f609a65d26a98$export$a7175d4e9206bc80)
];
const $8d0eb4c1d86abc14$export$993a5daeae2a3b3d = (index)=>$8d0eb4c1d86abc14$var$FORM_COLORS[index];
const $8d0eb4c1d86abc14$export$aefdd89adb2344b3 = ()=>$8d0eb4c1d86abc14$var$FORM_COLORS[Math.floor(Math.random() * $8d0eb4c1d86abc14$var$FORM_COLORS.length)];
const $8d0eb4c1d86abc14$export$c3fba1eee1434e93 = (colorCode)=>{
    switch(colorCode){
        case 0, $829f609a65d26a98$export$60847d42f9da92a6:
            return "var(--ds-background-accent-red-subtle, #F87168)";
        case 0, $829f609a65d26a98$export$5aae31392d72caaa:
            return "var(--ds-background-accent-yellow-subtle, #F5CD47)";
        case 0, $829f609a65d26a98$export$747d86715d4175de:
            return "var(--ds-background-accent-green-subtle, #4BCE97)";
        case 0, $829f609a65d26a98$export$69cb3ca10c1e330e:
            return "var(--ds-background-accent-teal-subtle, #6CC3E0)";
        case 0, $829f609a65d26a98$export$a7175d4e9206bc80:
            return "var(--ds-background-accent-purple-subtle, #9F8FEF)";
        case 0, $829f609a65d26a98$export$215b7063051591f1:
        default:
            return "var(--ds-background-accent-blue-subtle, #579DFF)";
    }
};

});

parcelRegister("oM98Q", function(module, exports) {

$parcel$export(module.exports, "PoweredByJiraFooter", () => $f25881d309a0893e$export$2bfdbb52779c2de7);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $29YN9 = parcelRequire("29YN9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iuZST = parcelRequire("iuZST");
const $f25881d309a0893e$var$WAC_LINK = 'https://www.atlassian.com/software/jira?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management%7CO:cloudpmm-jwm%7CF:discovery%7CE:cloud%7CX:expand%7C';
const $f25881d309a0893e$export$2bfdbb52779c2de7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleJiraLinkClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        xcss: $f25881d309a0893e$var$footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        weight: "medium"
    }, formatMessage((0, $iuZST.messages).footer, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                href: $f25881d309a0893e$var$WAC_LINK,
                target: "_blank",
                onClick: handleJiraLinkClick,
                xcss: $f25881d309a0893e$var$anchorStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $f25881d309a0893e$var$iconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29YN9.JiraIcon), {
                size: "small",
                appearance: "brand"
            })), chunks)
    })));
};
const $f25881d309a0893e$var$footerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 'space.500'
});
const $f25881d309a0893e$var$anchorStyles = (0, $8CUq3.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $f25881d309a0893e$var$iconStyles = (0, $8CUq3.xcss)({
    verticalAlign: 'middle',
    display: 'inline'
});

});
parcelRegister("iuZST", function(module, exports) {

$parcel$export(module.exports, "messages", () => $03cca4281d1e8065$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $03cca4281d1e8065$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    footer: {
        "id": "business-form.common.form-background.powered-by-jira-footer.footer",
        "defaultMessage": "Powered by <link>Jira</link>"
    }
});

});



parcelRegister("b668c", function(module, exports) {

$parcel$export(module.exports, "useJWMFormsFeatures", () => $16b8c1742dea6da5$export$761e4daa424a5fb7);
$parcel$export(module.exports, "default", () => $16b8c1742dea6da5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $16b8c1742dea6da5$var$defaultFeaturesContext = {
    featureView: 'form-submit',
    shouldHidePoweredBy: false
};
const $16b8c1742dea6da5$var$JWMFormsFeaturesContext = /*#__PURE__*/ (0, $5uXOq.createContext)($16b8c1742dea6da5$var$defaultFeaturesContext);
const $16b8c1742dea6da5$export$761e4daa424a5fb7 = ()=>(0, $5uXOq.useContext)($16b8c1742dea6da5$var$JWMFormsFeaturesContext);
var $16b8c1742dea6da5$export$2e2bcd8739ae039 = $16b8c1742dea6da5$var$JWMFormsFeaturesContext;

});

parcelRegister("djHla", function(module, exports) {

$parcel$export(module.exports, "MediaPermissionsPreloader", () => $d53363cdf9dab000$export$1ea28abf1046610e);
$parcel$export(module.exports, "useMediaPermissions", () => $d53363cdf9dab000$export$270452b93e9d2c99);

var $5uXOq = parcelRequire("5uXOq");

var $6dxIs = parcelRequire("6dxIs");

var $dJTwj = parcelRequire("dJTwj");
const $d53363cdf9dab000$export$1ea28abf1046610e = ({ projectId: projectId, formId: formId })=>{
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $6dxIs.useUploadPermissions)();
    const [, { updateStore: updateStore }] = (0, $dJTwj.useMediaPermissionsStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId) fetchUploadPermissions(projectId, formId);
    }, [
        projectId,
        fetchUploadPermissions,
        formId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStore({
            mediaUploadPermissions: uploadPermissions,
            mediaUploadPermissionStatus: uploadPermissionStatus
        });
    }, [
        updateStore,
        uploadPermissionStatus,
        uploadPermissions
    ]);
    return null;
};
const $d53363cdf9dab000$export$270452b93e9d2c99 = ()=>{
    const [{ mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus }] = (0, $dJTwj.useMediaPermissionsStore)();
    const isUploadPermissionReady = mediaUploadPermissionStatus === 'COMPLETED' && mediaUploadPermissions !== null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        mediaUploadPermissions: mediaUploadPermissions,
        mediaUploadPermissionStatus: mediaUploadPermissionStatus,
        mediaContext: {
            viewContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            uploadContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            userAuth: null
        }
    };
};

});
parcelRegister("6dxIs", function(module, exports) {

$parcel$export(module.exports, "useUploadPermissions", () => $d55c0017318f0800$export$9fc4bf889c7dbfba);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jpsyn = parcelRequire("jpsyn");
const $d55c0017318f0800$var$QUERY_ID = 'formSubmissionMediaPermissions';
const $d55c0017318f0800$export$9fc4bf889c7dbfba = (isDescriptionField)=>{
    const [uploadPermissionStatus, setUploadPermissionStatus] = (0, $5uXOq.useState)('NOT_STARTED');
    const [uploadPermissions, setUploadPermissions] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetchUploadPermissions = (0, $5uXOq.useCallback)(async (projectId, formId)=>{
        setUploadPermissionStatus('LOADING');
        try {
            const url = (0, $jpsyn.getMediaUploadPermissionUrl)(formId, Boolean(isDescriptionField));
            const uploadResponse = await (0, $eusud.performGetRequest)(url);
            setUploadPermissions({
                clientId: uploadResponse.clientId,
                serviceHost: uploadResponse.endpointUrl,
                token: uploadResponse.token,
                tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                collection: uploadResponse.targetCollection,
                tokenIssueTimestamp: Date.now() - 10000
            });
            setUploadPermissionStatus('COMPLETED');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setUploadPermissionStatus('COMPLETED');
            if (err.statusCode === 403) // user does not have media permission
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${$d55c0017318f0800$var$QUERY_ID} forbidden`);
            else (0, $jcw0u.default)({
                meta: {
                    id: $d55c0017318f0800$var$QUERY_ID,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    statusCode: err.statusCode
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        isDescriptionField
    ]);
    return {
        uploadPermissions: uploadPermissions,
        fetchUploadPermissions: fetchUploadPermissions,
        uploadPermissionStatus: uploadPermissionStatus
    };
};

});
parcelRegister("jpsyn", function(module, exports) {

$parcel$export(module.exports, "getMediaUploadPermissionUrl", () => $d10e4390e86d9aea$export$9f4e6a02a32c7984);
$parcel$export(module.exports, "getFormAttachmentUploadUrl", () => $d10e4390e86d9aea$export$b80950102aaa651d);
const $d10e4390e86d9aea$export$9f4e6a02a32c7984 = (formId, returnCreateIssueAdf)=>`/rest/api/2/attachment/upload/form/${formId}/credentials?returnCreateIssueAdf=${returnCreateIssueAdf}`;
const $d10e4390e86d9aea$export$b80950102aaa651d = (formId)=>`/rest/api/2/attachment/upload/form/${formId}`;

});


parcelRegister("dJTwj", function(module, exports) {

$parcel$export(module.exports, "useMediaPermissionsStore", () => $91f5295abbefbb95$export$9c03e2ed7cceacd6);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $91f5295abbefbb95$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $91f5295abbefbb95$var$MediaPermissionsStore = (0, $iXqE5.createStore)({
    initialState: {
        mediaUploadPermissions: null,
        mediaUploadPermissionStatus: 'NOT_STARTED'
    },
    actions: $91f5295abbefbb95$var$actions,
    name: 'JWMMediaPermissions'
});
const $91f5295abbefbb95$export$9c03e2ed7cceacd6 = (0, $3sQ5x.createHook)($91f5295abbefbb95$var$MediaPermissionsStore);

});


parcelRegister("fbFvx", function(module, exports) {

$parcel$export(module.exports, "useRouteForm", () => $fe38199bc79ec9b6$export$403b6710c1ff0852);
$parcel$export(module.exports, "useRedirectToPublicFormSubmission", () => $fe38199bc79ec9b6$export$2fc4be59ef67948f);

var $lODMY = parcelRequire("lODMY");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $1Fd2h = parcelRequire("1Fd2h");

var $5VxfF = parcelRequire("5VxfF");

var $lHSmT = parcelRequire("lHSmT");

var $l2N2a = parcelRequire("l2N2a");

var $4R6GH = parcelRequire("4R6GH");

var $90yGq = parcelRequire("90yGq");

var $5FLxe = parcelRequire("5FLxe");

var $7wwVP = parcelRequire("7wwVP");

var $g2iZ7 = parcelRequire("g2iZ7");

var $fgBiV = parcelRequire("fgBiV");
const $fe38199bc79ec9b6$export$403b6710c1ff0852 = ()=>{
    const [{ match: { params: { formId: formId } } }] = (0, $doZTA.useRouter)();
    return (0, $5FLxe.useFormById)(formId);
};
const $fe38199bc79ec9b6$export$2fc4be59ef67948f = ()=>{
    const { data: project } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const useRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
    const route = useRoute();
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const accountId = (0, $90yGq.useAccountId)();
    const { data: formSubmissionData } = (0, $g2iZ7.useFormSubmission)();
    return {
        shouldRedirectToPublicFormSubmission: ()=>{
            const isPublicForm = formSubmissionData?.formWithFieldData?.accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC;
            const isUserLoggedIn = Boolean(accountId);
            const isFormSubmitRoute = [
                (0, $1Fd2h.softwareFormSubmitClassicRoute).name,
                (0, $5VxfF.classicBusinessProjectFormSubmitRoute).name,
                (0, $lHSmT.softwareFormSubmitRoute).name
            ].includes(route.name);
            return isPublicForm && isUserLoggedIn && isFormSubmitRoute && (0, $4R6GH.fg)('jira-forms-public-access');
        },
        redirectToPublicFormSubmission: ()=>{
            if ((0, $4R6GH.fg)('jira-forms-public-access')) {
                const formSubmitUrl = (0, $fgBiV.getFormSubmitUrl)(project?.type ?? '', project?.isSimplified ?? false, project?.key ?? '', formSubmissionData?.formWithFieldData?.uuid ?? '', true);
                replace(`${formSubmitUrl}`);
            }
        }
    };
};

});
parcelRegister("fgBiV", function(module, exports) {

$parcel$export(module.exports, "getFormUrl", () => $0bcacd4212634771$export$74acd4985a6ac6c3);
$parcel$export(module.exports, "getFormBuilderUrl", () => $0bcacd4212634771$export$1a0bdbdcca54ab65);
$parcel$export(module.exports, "getFormSubmitUrl", () => $0bcacd4212634771$export$717c3030158f3660);
$parcel$export(module.exports, "getUpdateFieldConfigLink", () => $0bcacd4212634771$export$e93693b1c9a28c1c);
$parcel$export(module.exports, "getListViewFormFilteredUrl", () => $0bcacd4212634771$export$29b6a1ad502393ea);

var $4R6GH = parcelRequire("4R6GH");

var $iEEXl = parcelRequire("iEEXl");

var $fOgCm = parcelRequire("fOgCm");
const $0bcacd4212634771$export$36e24695f02d4503 = (projectType, isSimplified)=>{
    if (projectType === 'software') {
        if (isSimplified) return 0, $iEEXl.SOFTWARE_TMP_PREFIX;
        return 0, $iEEXl.SOFTWARE_CMP_PREFIX;
    }
    return 0, $iEEXl.BUSINESS_PREFIX;
};
const $0bcacd4212634771$export$74acd4985a6ac6c3 = (projectType, isSimplified, projectKey)=>{
    return `${$0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified)}/projects/${projectKey}/form`;
};
const $0bcacd4212634771$export$1a0bdbdcca54ab65 = (projectType, isSimplified, projectKey, formId)=>{
    return `${$0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified)}/projects/${projectKey}/form/${formId}/builder`;
};
const $0bcacd4212634771$export$717c3030158f3660 = (projectType, isSimplified, projectKey, formId, isPublic)=>{
    if (isPublic && (0, $4R6GH.fg)('jira-forms-public-access')) return `${$0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified)}/form/${formId}`;
    return `${$0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified)}/projects/${projectKey}/form/${formId}`;
};
const $0bcacd4212634771$export$e93693b1c9a28c1c = (projectType, isSimplified, isTeamManaged, projectKey, issueTypeId)=>{
    const prefix = $0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified);
    if (isTeamManaged) return projectKey && issueTypeId ? `${prefix}/projects/${projectKey}/settings/issuetypes/${issueTypeId}` : undefined;
    return projectKey ? `/plugins/servlet/project-config/${projectKey}/fields` : undefined;
};
const $0bcacd4212634771$export$29b6a1ad502393ea = (projectType, isSimplified, projectKey, formId)=>`${$0bcacd4212634771$export$36e24695f02d4503(projectType, isSimplified)}/projects/${projectKey}/list?filter=labels%3D"${(0, $fOgCm.getUniqueFormLabel)((0, $4R6GH.fg)('jsw_forms_rollout') ? (0, $fOgCm.getFormLabelPrefix)(projectType) : (0, $fOgCm.FORM_LABEL), formId)}"`;

});


const $410f34228866ee1a$export$aa78f5e84beba3ce = 240;

parcelRegister("7YlSK", function(module, exports) {

$parcel$export(module.exports, "ContactAdminBanner", () => $de37af4b546c3e70$export$a50845fcec7cb9ff);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $lkmWu = parcelRequire("lkmWu");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $aLvPW = parcelRequire("aLvPW");
const $de37af4b546c3e70$var$ContactYourAdminLink = ({ children: children })=>(0, $4R6GH.fg)('replace-anchor-with-link__jira-werewolves') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "/jira/contact-administrator"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "/jira/contact-administrator"
    }, children);
const $de37af4b546c3e70$export$a50845fcec7cb9ff = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(true);
    const handleDismissClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $de37af4b546c3e70$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
        testId: "business-form.ui.form-submission.contact-admin-banner.banner",
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: $de37af4b546c3e70$var$ContactYourAdminLink
        },
        message: formatMessage((0, $aLvPW.default).needToEdit, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $de37af4b546c3e70$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        label: "dismiss",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $aLvPW.default).dismiss),
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        onClick: handleDismissClick
    })));
};
const $de37af4b546c3e70$var$bannerContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $de37af4b546c3e70$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});

});
parcelRegister("aLvPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe90aa245dc4244$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8fe90aa245dc4244$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    needToEdit: {
        "id": "business-form.form-submission.contact-admin-banner.need-to-edit",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to edit this form."
    },
    dismiss: {
        "id": "business-form.form-submission.contact-admin-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("f9uY0", function(module, exports) {

$parcel$export(module.exports, "FillInView", () => $35a47656ff93b9c5$export$32d78bb31929ae49);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $efXp3 = parcelRequire("efXp3");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $467lJ = parcelRequire("467lJ");
var $LJaTB = parcelRequire("LJaTB");
var $pa9q9 = parcelRequire("pa9q9");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $l2N2a = parcelRequire("l2N2a");

var $cZpsT = parcelRequire("cZpsT");

var $iEEXl = parcelRequire("iEEXl");

var $co4Oy = parcelRequire("co4Oy");

var $6czoq = parcelRequire("6czoq");

var $icLsg = parcelRequire("icLsg");

var $fOgCm = parcelRequire("fOgCm");

var $b668c = parcelRequire("b668c");

var $g2iZ7 = parcelRequire("g2iZ7");

var $djHla = parcelRequire("djHla");

var $kMDCx = parcelRequire("kMDCx");

var $9mCh4 = parcelRequire("9mCh4");

var $6dxIs = parcelRequire("6dxIs");

var $jpsyn = parcelRequire("jpsyn");

var $7wwVP = parcelRequire("7wwVP");

var $c4qDm = parcelRequire("c4qDm");

var $icFsv = parcelRequire("icFsv");

var $6Ti3X = parcelRequire("6Ti3X");

var $jfugj = parcelRequire("jfugj");

var $eMB94 = parcelRequire("eMB94");

var $aWehJ = parcelRequire("aWehJ");
const $35a47656ff93b9c5$var$submissionErrorFlag = (errorMessage)=>{
    if (errorMessage === (0, $iEEXl.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR) return {
        type: 'error',
        title: (0, $icFsv.default).submissionErrorFlag,
        description: (0, $icFsv.default).submissionAttachmentErrorContent,
        testId: 'business-form.ui.form-submission.fill-in-view.form-attachment-error-flag',
        messageId: 'business-form.ui.form-submission.fill-in-view.flag.error.error.form-attachment-error-flag',
        messageType: 'transactional'
    };
    return {
        type: 'error',
        title: (0, $icFsv.default).submissionErrorFlag,
        description: errorMessage,
        testId: 'business-form.ui.form-submission.fill-in-view.error-flag',
        messageId: 'business-form.ui.form-submission.fill-in-view.flag.error',
        messageType: 'transactional'
    };
};
const $35a47656ff93b9c5$var$interactions = [
    'scroll',
    'click',
    'focus',
    'keydown'
];
const $35a47656ff93b9c5$var$hasInitialInteractionCapture = true;
const $35a47656ff93b9c5$export$32d78bb31929ae49 = ()=>{
    const [uploading, setUploading] = (0, $5uXOq.useState)(false);
    const [shouldRenderExtraFields, setShouldRenderExtraFields] = (0, $5uXOq.useState)(false);
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
    const [recaptcha, setRecaptcha] = (0, $5uXOq.useState)();
    const [checkboxRecaptchaToken, setCheckboxRecaptchaToken] = (0, $5uXOq.useState)();
    const [isCheckboxRecaptchaNotVerifiedOnSubmit, setIsCheckboxRecaptchaNotVerifiedOnSubmit] = (0, $5uXOq.useState)(false);
    const [isInvisibleRecaptchaFailed, setIsInvisibleRecaptchaFailed] = (0, $5uXOq.useState)(false);
    const [isRecaptchaError, setIsRecaptchaError] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: formSubmissionData, formId: formId } = (0, $g2iZ7.useFormSubmission)();
    const { data: projectData } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const { shouldHidePoweredBy: shouldHidePoweredBy } = (0, $b668c.useJWMFormsFeatures)();
    const { formWithFieldData: formWithFieldData, fieldMetaData: fieldMetaData } = formSubmissionData ?? {};
    const { description: description, projectId: projectId, accessLevel: accessLevel, issueType: issueType } = formWithFieldData ?? {};
    const emailRequired = formWithFieldData && 'emailRequired' in formWithFieldData ? formWithFieldData.emailRequired : undefined;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isPublicForm = (0, $4R6GH.fg)('jira-forms-public-access') && accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC;
    // This is for description field
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $6dxIs.useUploadPermissions)(true);
    const { mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus, mediaContext: mediaContext } = (0, $djHla.useMediaPermissions)();
    const isUploadPermissionNotReady = (!(0, $4R6GH.fg)('fix_attachments_for_description_on_forms') || !isPublicForm) && (uploadPermissionStatus !== 'COMPLETED' || mediaUploadPermissionStatus !== 'COMPLETED');
    const parsedDescription = (0, $5uXOq.useMemo)(()=>{
        if (description === undefined || description === '') return undefined;
        try {
            return JSON.parse(description);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'failed to parse form description in form submission');
            // ignore description from backend if it's not a valid JSON format
            return undefined;
        }
    }, [
        description
    ]);
    const analyticAttributes = (0, $5uXOq.useMemo)(()=>({
            accessLevel: accessLevel?.toString(),
            isOutsideUser: !projectData || !projectData?.permissions.createIssues,
            formId: formId,
            isLoggedIn: (0, $4R6GH.fg)('jira-forms-public-access') ? !isAnonymous : undefined
        }), [
        accessLevel,
        projectData,
        formId,
        isAnonymous
    ]);
    const handleCreateIssueOnComplete = (0, $5uXOq.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    const handleOnRecaptchaLowScoreError = (0, $5uXOq.useCallback)(()=>{
        if (isInvisibleRecaptchaFailed) // for checkbox recaptcha low score case
        // if invisible recaptcha has previously failed, this means checkbox recaptcha has also failed, thus prompt user to refresh.
        showFlag((0, $467lJ.default).genericError());
        else // for invisible recaptcha low score case
        // if invisible recaptcha has not failed, use this to trigger checkbox flow.
        setIsInvisibleRecaptchaFailed(true);
    }, [
        setIsInvisibleRecaptchaFailed,
        isInvisibleRecaptchaFailed,
        showFlag
    ]);
    const handleResetClick = (0, $5uXOq.useCallback)(()=>{
        setIsVisible(true);
    }, [
        setIsVisible
    ]);
    const renderExtraFields = (0, $5uXOq.useCallback)(()=>{
        setShouldRenderExtraFields(true);
        if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
    }, []);
    const setRef = (0, $jfugj.useIntersectionObserver)(renderExtraFields);
    const setIntersectionRef = (0, $5uXOq.useCallback)((element)=>setRef(element), [
        setRef
    ]);
    const { create: create, data: createIssueData, error: createIssueError, errorMessage: errorMessage, loading: createIssueLoading } = (0, $kMDCx.useCreateIssue)(formSubmissionData?.formWithFieldData, handleCreateIssueOnComplete, handleOnRecaptchaLowScoreError, projectData?.type, (0, $4R6GH.fg)('jira-forms-public-access') ? analyticAttributes : undefined);
    const handleInternalFormSubmitClick = (0, $5uXOq.useCallback)(async (formData)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
        await create(formData, '', undefined);
    }, [
        create,
        createAnalyticsEvent,
        analyticAttributes
    ]);
    const handlePublicFormSubmitClick = (0, $5uXOq.useCallback)(async (formData)=>{
        if (isInvisibleRecaptchaFailed) {
            if (checkboxRecaptchaToken) {
                await create(formData, checkboxRecaptchaToken, (0, $9mCh4.JiraCreateIssueByPublicFormRecaptchaType).V2_CHECKBOX);
                setIsInvisibleRecaptchaFailed(false);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
            } else // no checkbox token available, either challenge not completed yet, or challenge expired.
            setIsCheckboxRecaptchaNotVerifiedOnSubmit(true);
            return;
        }
        const recaptchaToken = await recaptcha?.getToken?.();
        // In public form, do not submit form if recaptcha token is not available
        setIsRecaptchaError(false);
        if (recaptchaToken) {
            await create(formData, recaptchaToken, (0, $9mCh4.JiraCreateIssueByPublicFormRecaptchaType).V3_SCORE);
            // if recaptcha fails due to user being detected as a bot, try again with checkbox
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
        } else setIsRecaptchaError(true);
    }, [
        create,
        createAnalyticsEvent,
        analyticAttributes,
        recaptcha,
        checkboxRecaptchaToken,
        isInvisibleRecaptchaFailed
    ]);
    const renderFields = (0, $5uXOq.useCallback)((fields)=>{
        const renderedFields = fields.map((f)=>{
            // If the field no longer exists, do not render it.
            if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
            const fieldConfig = (0, $fOgCm.getFieldTypeConfig)(f.type, projectData?.type);
            if (!fieldConfig) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                    type: f.type
                });
                return null;
            }
            const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues = [], defaultFieldValue: defaultFieldValue, schema: schema } = fieldMetaData[f.fieldId];
            /**
       * autoCompleteUrls contains origin/host.
       * In storybook, we want these to point to our proxy.
       */ let completeUrl = autoCompleteUrl;
            if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
                const url = new URL(autoCompleteUrl);
                completeUrl = `${url.pathname}${url.search}`;
            }
            const isFieldRequired = f.isRequired || !!f.isRequiredByForm;
            const fieldDescription = f.description;
            const field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(fieldConfig.Component, {
                key: f.fieldId,
                fieldName: typeof f.alias === 'string' && f.alias.length > 0 ? f.alias : f.name,
                fieldId: f.fieldId,
                isRequired: isFieldRequired,
                description: fieldDescription,
                autoCompleteUrl: completeUrl,
                allowedValues: allowedValues,
                mediaUploadContexts: {
                    uploadContext: uploadPermissions,
                    attachmentUploadContext: mediaUploadPermissions
                },
                projectId: String(projectId),
                issueTypeId: issueType?.id,
                projectKey: projectData?.key,
                onInProgressChange: setUploading,
                defaultValue: defaultFieldValue,
                attachmentCustomUploadURL: (0, $jpsyn.getFormAttachmentUploadUrl)(formId),
                canUserViewProject: Boolean(projectData?.permissions?.viewIssues),
                schemaConfiguration: schema?.configuration,
                renderer: (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') ? f.renderer : undefined,
                accessLevel: (0, $4R6GH.fg)('jira-forms-public-access') ? accessLevel : undefined
            });
            return f.parentCondition && (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4qDm.default), {
                key: `${f.parentCondition.id}:${f.fieldId}`,
                condition: f.parentCondition
            }, field) : field;
        });
        return renderedFields;
    }, [
        fieldMetaData,
        projectData?.type,
        projectData?.key,
        projectData?.permissions?.viewIssues,
        uploadPermissions,
        mediaUploadPermissions,
        projectId,
        issueType?.id,
        formId,
        createAnalyticsEvent,
        accessLevel
    ]);
    const getErrorFlag = (0, $5uXOq.useCallback)(()=>errorMessage !== null && typeof errorMessage === 'string' ? $35a47656ff93b9c5$var$submissionErrorFlag(errorMessage) : (0, $467lJ.default).genericError(), [
        errorMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.addEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
        return ()=>{
            if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (typeof projectId === 'number' && (!(0, $4R6GH.fg)('fix_attachments_for_description_on_forms') || !isPublicForm)) fetchUploadPermissions(String(projectId), formId);
    }, [
        fetchUploadPermissions,
        formId,
        projectId,
        isPublicForm
    ]);
    if (createIssueData?.success && !isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.success-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6czoq.SuccessView), {
        shouldHidePoweredBy: shouldHidePoweredBy,
        onSubmitAnotherFormClick: handleResetClick,
        analyticAttributes: analyticAttributes,
        ...(0, $4R6GH.fg)('jira-forms-public-access') && {
            issueKey: createIssueData?.issueKey
        }
    }));
    if (!formSubmissionData || !formWithFieldData || !fieldMetaData || isUploadPermissionNotReady) return null;
    // only render the first 15 fields for performance reasons
    // remaining fields will be rendered once the user interacts with the page
    const cloneInitialFields = [
        ...formWithFieldData.fields
    ];
    const initialFields = cloneInitialFields.splice(0, 15);
    const shouldRenderAdditionalFields = cloneInitialFields.length > 0 && shouldRenderExtraFields;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "form",
        objectId: formId,
        containerType: "project",
        containerId: String(projectId),
        attributes: {
            ...(0, $jfugj.generateFieldAnalytics)(formWithFieldData.fields),
            ...analyticAttributes
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "formSubmission viewed",
        attributes: analyticAttributes
    }), (0, $4R6GH.fg)('jira-forms-public-access') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, projectData?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $35a47656ff93b9c5$var$projectNameStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "small",
        src: projectData?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtle",
        weight: "semibold"
    }, projectData.name))), !projectData?.name && !isPublicForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $35a47656ff93b9c5$var$projectNamePlaceholderStyles
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, projectData?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$ProjectNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "small",
        src: projectData?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        color: "color.text.subtle",
        weight: "semibold"
    }, projectData?.name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $35a47656ff93b9c5$var$projectNamePlaceholderStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formWithFieldData.title,
        position: (0, $4R6GH.fg)('jira-forms-public-access') ? 'bottom-start' : 'right'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $icLsg.TitleWrapperTruncated), null, formWithFieldData.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$DescriptionWrapper, {
        "data-testid": "business-form.ui.form-submission.fill-in-view.description"
    }, parsedDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "description-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $co4Oy.default), {
        document: parsedDescription,
        mediaContext: mediaContext,
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true
        },
        // eslint-disable-next-line jira/deprecations/no-base-url
        baseUrl: ""
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        isDisabled: createIssueLoading || createIssueData?.success && !isVisible,
        onSubmit: isPublicForm ? handlePublicFormSubmitClick : handleInternalFormSubmitClick
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            name: "submit form",
            noValidate: true,
            "data-test-id": "business-form.ui.form-submission.fill-in-view.form"
        }, (0, $4R6GH.fg)('jira-forms-public-access') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWehJ.Fields), {
            fields: shouldRenderExtraFields ? formWithFieldData.fields : formWithFieldData.fields.slice(0, 15),
            setUploading: setUploading,
            showEmailField: isPublicForm && emailRequired,
            ...(0, $4R6GH.fg)('fix_attachments_for_description_on_forms') && {
                uploadPermissions: uploadPermissions
            }
        }), !(0, $4R6GH.fg)('jira-forms-public-access') && renderFields(initialFields), shouldRenderAdditionalFields && !(0, $4R6GH.fg)('jira-forms-public-access') && renderFields(cloneInitialFields), !shouldRenderAdditionalFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            ref: setIntersectionRef
        }), (shouldRenderAdditionalFields || formWithFieldData.fields.length <= 15) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMB94.Footer), {
            isPublicForm: isPublicForm,
            createIssueLoading: createIssueLoading,
            uploading: uploading,
            onRecaptchaChange: setRecaptcha,
            onCheckboxRecaptchaVerify: (recaptchaToken)=>{
                setCheckboxRecaptchaToken(recaptchaToken);
                setIsCheckboxRecaptchaNotVerifiedOnSubmit(false);
            },
            onCheckboxRecaptchaExpire: ()=>setCheckboxRecaptchaToken(null),
            shouldShowCheckboxRecaptcha: isInvisibleRecaptchaFailed,
            checkboxRecaptchaNotVerified: isCheckboxRecaptchaNotVerifiedOnSubmit
        }), (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Ti3X.default), null))), (createIssueError || isRecaptchaError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: getErrorFlag()
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35a47656ff93b9c5$var$ProjectNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});
const $35a47656ff93b9c5$var$projectNameStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $35a47656ff93b9c5$var$projectNamePlaceholderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35a47656ff93b9c5$var$DescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description,
        messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description,
        messageId: 'flags.ui.configurations.errors.server-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


parcelRegister("co4Oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2436649549ab9cdd$export$2e2bcd8739ae039);

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2436649549ab9cdd$var$AsyncDescriptionReadView = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cAoQN")), {
    ssr: false,
    moduleId: "./src/packages/business/form/src/common/ui/description-read/main.tsx"
});
var $2436649549ab9cdd$export$2e2bcd8739ae039 = $2436649549ab9cdd$var$AsyncDescriptionReadView;

});
parcelRegister("cAoQN", function(module, exports) {

let $929c1fa0306b6f46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $929c1fa0306b6f46$var$load("1qOg7").then(()=>parcelRequire('bFrp8'));

});


parcelRegister("icLsg", function(module, exports) {

$parcel$export(module.exports, "TitleWrapper", () => $e2b5765917c57fb2$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleWrapperTruncated", () => $e2b5765917c57fb2$export$179667894b01611b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e2b5765917c57fb2$export$585a3b23e887288b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _19pkidpf _6id51kw7 _fh0l1f4h _o8b6idpf _1ols1kw7",
            __cmplp.className
        ])
    });
});
const $e2b5765917c57fb2$export$179667894b01611b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $e2b5765917c57fb2$export$585a3b23e887288b, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kMDCx", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $b6e087ee0849b727$export$8af2d18142c8506c);

var $5tTFS = parcelRequire("5tTFS");

var $cm8b5 = parcelRequire("cm8b5");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iEEXl = parcelRequire("iEEXl");

var $gak61 = parcelRequire("gak61");

var $lvFc8 = parcelRequire("lvFc8");

var $7wwVP = parcelRequire("7wwVP");

var $lJBp3 = parcelRequire("lJBp3");


var $kgZWx = parcelRequire("kgZWx");

var $qPGip = parcelRequire("qPGip");
const $b6e087ee0849b727$var$QUERY_NAME = 'CreateJiraBusinessIssueForm';
const $b6e087ee0849b727$var$CREATE_PUBLIC_QUERY_NAME = 'CreateJiraIssueByPublicForm';
const $b6e087ee0849b727$var$logMissing = (name)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), `"${name}" was unexpectedly null or undefined for form submission`);
};
const $b6e087ee0849b727$export$8af2d18142c8506c = (formWithFieldData, onComplete, onLowRecaptchaScore, // TODO: Remove on cleanup of fix_forms_issue_create_labelling_issue
projectTypeOld = (0, $2vSU6.CORE_PROJECT), analyticAttributes = {})=>{
    const isPublic = formWithFieldData?.accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC;
    const emailRequired = formWithFieldData && 'emailRequired' in formWithFieldData ? formWithFieldData.emailRequired : undefined;
    const startExperience = (0, $cm8b5.useExperienceStart)(isPublic && (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iEEXl.SUBMIT_PUBLIC_FORM_EXPERIENCE) : (0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(isPublic && (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iEEXl.SUBMIT_PUBLIC_FORM_EXPERIENCE) : (0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const markExperienceFailed = (0, $cm8b5.useExperienceFail)(isPublic && (0, $4R6GH.fg)('jira-forms-public-access') ? (0, $iEEXl.SUBMIT_PUBLIC_FORM_EXPERIENCE) : (0, $iEEXl.SUBMIT_FORM_EXPERIENCE));
    const projectType = (0, $4R6GH.fg)('fix_forms_issue_create_labelling_issue') ? (0, $gak61.useProjectType)() : projectTypeOld;
    const experienceAnalyticsAttributes = {
        ...(0, $lvFc8.useConditionalFieldLogicAnalyticsAttrs)(),
        ...(0, $lJBp3.usePublicFormsEnabledAnalyticsAttrs)()
    };
    const doFireErrorAnalytics = (error)=>{
        if ((0, $4R6GH.fg)('jira-forms-public-access')) (0, $jcw0u.default)({
            meta: {
                id: isPublic ? $b6e087ee0849b727$var$CREATE_PUBLIC_QUERY_NAME : $b6e087ee0849b727$var$QUERY_NAME,
                packageName: 'jiraBusinessForm',
                teamName: 'jira-werewolves'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: Array.isArray(error) && error.length > 0 ? error[0] : error,
            sendToPrivacyUnsafeSplunk: true
        });
        else (0, $jcw0u.default)({
            meta: {
                id: $b6e087ee0849b727$var$QUERY_NAME,
                packageName: 'jiraBusinessForm',
                teamName: 'jira-werewolves'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: Array.isArray(error) && error.length > 0 ? error[0] : error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleEventAnalytics = (issueIdentifier)=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', {
            ...issueIdentifier,
            ...analyticAttributes
        });
    };
    const [createIssue, { data: data, loading: loading, error: error }] = (0, $5tTFS.useMutation)((0, $kgZWx.FORM_CREATE_ISSUE_MUTATION), {
        onError: (apolloError)=>{
            doFireErrorAnalytics(apolloError);
            markExperienceFailed('create issue service - mutation onError', apolloError, experienceAnalyticsAttributes);
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
        },
        onCompleted: (responseData)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$b6e087ee0849b727$var$QUERY_NAME} succeeded`, {});
            if (responseData.createJiraBusinessIssueByForm?.errors) {
                const errors = responseData.createJiraBusinessIssueByForm.errors.map((e)=>new (0, $eCBf9.MutationError)(e)).filter((e)=>e.message !== (0, $iEEXl.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$b46f0126077d6b7c) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$d65db43b48ab539f) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$e8b6f1ad2ff52ae6) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$817a1a90e436f838) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$261f5d4afe06fdea) && (e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$9de493bcd9b1d977) || e.extensions?.statusCode !== 400));
                if (errors.length > 0) {
                    doFireErrorAnalytics(errors);
                    const mutationError = errors.find((e)=>e.message);
                    if (mutationError) markExperienceFailed('Create issue service mutation failed', new (0, $eCBf9.MutationError)(mutationError), {
                        errorType: mutationError.extensions?.errorType || '',
                        statusCode: mutationError.extensions?.statusCode || '',
                        ...experienceAnalyticsAttributes
                    });
                }
                return;
            }
            if (responseData.createJiraBusinessIssueByForm?.item?.issueId) {
                if ((0, $4R6GH.fg)('jira-forms-public-access')) handleEventAnalytics({
                    issueId: String(responseData.createJiraBusinessIssueByForm.item.issueId)
                });
                else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(responseData.createJiraBusinessIssueByForm.item.issueId));
                onComplete?.();
            }
            markExperienceSuccess(experienceAnalyticsAttributes);
        }
    });
    const [createIssuePublic, { data: createIssuePublicData, loading: createIssuePublicLoading, error: createIssuePublicError }] = (0, $5tTFS.useMutation)((0, $kgZWx.FORM_CREATE_ISSUE_PUBLIC_MUTATION), {
        onError: (apolloError)=>{
            doFireErrorAnalytics(apolloError);
            markExperienceFailed('create issue (public) service - mutation onError', apolloError, experienceAnalyticsAttributes);
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using public form');
        },
        onCompleted: (responseData)=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$b6e087ee0849b727$var$CREATE_PUBLIC_QUERY_NAME} succeeded`, {});
            const mutationErrors = responseData.jira?.createJiraIssueByPublicForm?.errors;
            if (mutationErrors && mutationErrors.length > 0) {
                const errors = mutationErrors.map((e)=>new (0, $eCBf9.MutationError)(e)).filter((e)=>e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$b46f0126077d6b7c) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$d65db43b48ab539f) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$e8b6f1ad2ff52ae6) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$817a1a90e436f838) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$dc32d653583bfb62) && (e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$9de493bcd9b1d977) || e.extensions?.statusCode !== 400) && ((0, $4R6GH.fg)('public_form_filter_out_recaptcha_browser_error') ? !e.message.includes((0, $b2058fd633cf6c26$export$45315821249673)) : true));
                if (errors.length > 0) {
                    if (errors.some((e)=>e.extensions?.errorType === (0, $b2058fd633cf6c26$export$84fb071c240152c9)) && onLowRecaptchaScore) {
                        onLowRecaptchaScore();
                        return;
                    }
                    doFireErrorAnalytics(errors);
                    const mutationError = errors.find((e)=>e.message);
                    if (mutationError) markExperienceFailed('Create issue (public) service mutation failed', new (0, $eCBf9.MutationError)(mutationError), {
                        errorType: mutationError.extensions?.errorType || '',
                        statusCode: mutationError.extensions?.statusCode || '',
                        ...experienceAnalyticsAttributes
                    });
                }
                return;
            }
            handleEventAnalytics({
                issueKey: responseData.jira?.createJiraIssueByPublicForm?.issueKey ?? undefined
            });
            if (responseData.jira?.createJiraIssueByPublicForm?.success) onComplete?.();
            markExperienceSuccess(experienceAnalyticsAttributes);
        }
    });
    /**
	 * This function will create an issue with specified fields
	 * It will always resolve the promise even if there are any errors (apollo error, bad request)
	 * To know whether it's successful or not, use the `data` and `error` prop returned by the hook
	 */ const create = async (formInputData)=>{
        const projectId = formWithFieldData?.projectId;
        const issueTypeId = formWithFieldData?.issueType?.id;
        const formId = formWithFieldData?.formId;
        startExperience();
        if (typeof formInputData !== 'object') {
            $b6e087ee0849b727$var$logMissing('formInputData');
            return;
        }
        if (typeof formWithFieldData !== 'object') {
            $b6e087ee0849b727$var$logMissing('formWithFieldData');
            return;
        }
        if (typeof projectId !== 'number') {
            $b6e087ee0849b727$var$logMissing('projectId');
            return;
        }
        if (typeof issueTypeId !== 'string') {
            $b6e087ee0849b727$var$logMissing('issueTypeId');
            return;
        }
        if (typeof formId !== 'string') {
            $b6e087ee0849b727$var$logMissing('formId');
            return;
        }
        const fields = (0, $4R6GH.fg)('jsw_forms_rollout') ? (0, $qPGip.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData,
            projectType: projectType
        }) : (0, $qPGip.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData
        });
        await createIssue({
            variables: {
                input: {
                    formId: formId,
                    fields: fields
                },
                includeIssueKeyEnabled: (0, $4R6GH.fg)('allow-non-public-form-submissions-to-view-request')
            },
            // @ts-expect-error - TS2345 - Argument of type '{ variables: { input: { projectId: string; issueType: string; fields: JiraIssueFieldsInput; }; }; onError: () => void; }' is not assignable to parameter of type 'MutationFunctionOptions<CreateJiraBusinessIssueForm, CreateJiraBusinessIssueFormVariables>'.
            // onError is needed to make sure the Promise always resolve instead of throwing Promise rejected error
            onError: ()=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
            }
        });
    };
    const createForPublicForm = async (formInputData, recaptchaToken, recaptchaType)=>{
        startExperience();
        if (typeof formWithFieldData !== 'object') {
            $b6e087ee0849b727$var$logMissing('formWithFieldData');
            return;
        }
        if (!formWithFieldData.uuid) {
            $b6e087ee0849b727$var$logMissing('uuid');
            return;
        }
        const formUuid = formWithFieldData.uuid;
        const fields = (0, $qPGip.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData,
            projectType: projectType
        });
        await createIssuePublic({
            variables: {
                input: {
                    uuid: formUuid,
                    fields: fields
                },
                // The email field in the CreateJiraIssueByPublicForm mutation is non-nullable, so we have to send an empty string.
                // In any case, it's not processed by the BE when emailRequired is set to false.
                email: emailRequired ? formInputData.email ?? null : '',
                recaptchaToken: recaptchaToken,
                recaptchaType: recaptchaType
            },
            // @ts-expect-error - TS2345 - Argument of type '{ variables: { input: { projectId: string; issueType: string; fields: JiraIssueFieldsInput; }; }; onError: () => void; }' is not assignable to parameter of type 'MutationFunctionOptions<CreateJiraBusinessIssueForm, CreateJiraBusinessIssueFormVariables>'.
            // onError is needed to make sure the Promise always resolve instead of throwing Promise rejected error
            onError: ()=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $iEEXl.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
            }
        });
    };
    if (isPublic) {
        const mutationBadRequestError = createIssuePublicData?.jira?.createJiraIssueByPublicForm?.errors?.map((e)=>new (0, $eCBf9.MutationError)(e))?.filter((e)=>e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$84fb071c240152c9)) // to suppress LOW_RECAPTCHA_SCORE error to prevent a flag as a sectionMessage will already be shown
        ?.find((e)=>e.message);
        return {
            error: // if there are any errors from Apollo, surface that first
            // otherwise if there are errors from bad request, use that
            createIssuePublicError || mutationBadRequestError,
            errorMessage: mutationBadRequestError ? (0, $qPGip.transformErrorMessage)(mutationBadRequestError, formWithFieldData) : null,
            data: (0, $qPGip.transformPublicCreateResult)(createIssuePublicData),
            loading: createIssuePublicLoading,
            create: createForPublicForm
        };
    }
    // find error that has message
    const mutationBadRequestError = data?.createJiraBusinessIssueByForm?.errors?.map((e)=>new (0, $eCBf9.MutationError)(e))?.find((e)=>e.message);
    return {
        error: // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error || mutationBadRequestError,
        errorMessage: mutationBadRequestError ? (0, $qPGip.transformErrorMessage)(mutationBadRequestError, formWithFieldData) : null,
        data: (0, $qPGip.transformResult)(data),
        loading: loading,
        create: create
    };
};

});
const $b2058fd633cf6c26$export$b46f0126077d6b7c = 'REQUIRED_FIELD_MISSING';
const $b2058fd633cf6c26$export$d65db43b48ab539f = 'FIELD_VALIDATION_FAILED';
const $b2058fd633cf6c26$export$e8b6f1ad2ff52ae6 = 'FORM_NOT_FOUND';
const $b2058fd633cf6c26$export$9de493bcd9b1d977 = 'BAD_REQUEST';
const $b2058fd633cf6c26$export$817a1a90e436f838 = 'PROJECT_NOT_FOUND';
const $b2058fd633cf6c26$export$261f5d4afe06fdea = 'VIEW_PROJECT_PERMISSION_ERROR';
const $b2058fd633cf6c26$export$dc32d653583bfb62 = 'INVALID_EMAIL';
const $b2058fd633cf6c26$export$84fb071c240152c9 = 'RETRY_RECAPTCHA';
const $b2058fd633cf6c26$export$45315821249673 = 'BROWSER_ERROR';

parcelRegister("kgZWx", function(module, exports) {

$parcel$export(module.exports, "FORM_CREATE_ISSUE_MUTATION", () => $aa968c869903eefe$export$8421abc4fb1c6a51);
$parcel$export(module.exports, "FORM_CREATE_ISSUE_PUBLIC_MUTATION", () => $aa968c869903eefe$export$5ca990db6a969342);

var $5cllN = parcelRequire("5cllN");
const $aa968c869903eefe$export$8421abc4fb1c6a51 = (0, $5cllN.default)`
mutation CreateJiraBusinessIssueByForm($input: JwmFormCreateIssueInput!, $includeIssueKeyEnabled: Boolean!) {
  createJiraBusinessIssueByForm(input: $input) {
    item {
      id
      issueId
    }
		issue @include(if: $includeIssueKeyEnabled) {
			key
		}
    success
    errors {
      message
      extensions {
        ... on FieldValidationMutationErrorExtension {
          statusCode
          errorType
          fieldId
        }
        ... on GenericMutationErrorExtension {
          statusCode
          errorType
        }
      }
    }
  }
}
`;
const $aa968c869903eefe$export$5ca990db6a969342 = (0, $5cllN.default)`
mutation CreateJiraIssueByPublicForm($input: JiraCreateIssueByPublicFormInput!, $email: String!, $recaptchaToken: String!, $recaptchaType: JiraCreateIssueByPublicFormRecaptchaType) {
    jira {
        createJiraIssueByPublicForm(input: $input, email: $email, recaptchaToken: $recaptchaToken, recaptchaType: $recaptchaType) {
            issueKey
            success
            errors {
                message
                extensions {
                    ... on FieldValidationMutationErrorExtension {
                        statusCode
                        errorType
                        fieldId
                    }
                    ... on GenericMutationErrorExtension {
                        statusCode
                        errorType
                    }
                }
            }
        }
    }
}
`;

});

parcelRegister("qPGip", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformPublicCreateResult", () => $aa4cd5c41c12e7b8$export$2adadf1da65e5cd6);
$parcel$export(module.exports, "transformFormData", () => $aa4cd5c41c12e7b8$export$d1360584b6d92fb7);
$parcel$export(module.exports, "transformErrorMessage", () => $aa4cd5c41c12e7b8$export$d7c77df21c828876);

var $4Xk2W = parcelRequire("4Xk2W");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fOgCm = parcelRequire("fOgCm");

var $kShoa = parcelRequire("kShoa");

var $7wwVP = parcelRequire("7wwVP");
const $aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03 = (data)=>{
    if (!data) return data;
    const issueId = data.createJiraBusinessIssueByForm?.item?.issueId;
    const isIssueIdValid = typeof issueId === 'number';
    const isCreateJiraBusinessIssueSuccessValid = typeof data.createJiraBusinessIssueByForm?.success === 'boolean';
    if (!isIssueIdValid || !isCreateJiraBusinessIssueSuccessValid) (0, $jcw0u.default)({
        meta: {
            id: 'transformFormSubmissionResult',
            packageName: 'jiraBusinessForm',
            teamName: 'jira-werewolves'
        },
        attributes: {
            message: 'Some fields from form submission were not returned properly',
            isIssueIdValid: isIssueIdValid,
            isCreateJiraBusinessIssueSuccessValid: isCreateJiraBusinessIssueSuccessValid
        },
        sendToPrivacyUnsafeSplunk: true
    });
    if (typeof data.createJiraBusinessIssueByForm?.success !== 'boolean') return undefined;
    const issueKeyField = data.createJiraBusinessIssueByForm?.issue?.key ?? null;
    return {
        success: data.createJiraBusinessIssueByForm.success,
        issueId: issueId,
        issueKey: issueKeyField && (0, $4R6GH.fg)('allow-non-public-form-submissions-to-view-request') ? issueKeyField : null
    };
};
const $aa4cd5c41c12e7b8$export$2adadf1da65e5cd6 = (data)=>{
    if (!data) return data;
    const { issueKey: issueKey, success: success } = data.jira?.createJiraIssueByPublicForm ?? {};
    const isIssueKeyValid = typeof issueKey === 'string' || issueKey === null;
    const isCreateSuccessValid = typeof success === 'boolean';
    if (!isIssueKeyValid || !isCreateSuccessValid) (0, $jcw0u.default)({
        meta: {
            id: 'transformPublicFormSubmissionResult',
            packageName: 'jiraBusinessForm',
            teamName: 'jira-werewolves'
        },
        attributes: {
            message: 'Some fields from public form submission were not returned properly',
            isIssueKeyValid: isIssueKeyValid,
            isCreateSuccessValid: isCreateSuccessValid
        },
        sendToPrivacyUnsafeSplunk: true
    });
    if (!isCreateSuccessValid) return undefined;
    return {
        success: success,
        issueKey: issueKey
    };
};
const $aa4cd5c41c12e7b8$export$d1360584b6d92fb7 = ({ formInputData: formInputData, formWithFieldData: formWithFieldData, projectType: projectType })=>{
    const formFieldsById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(formWithFieldData.fields, (f)=>f.fieldId);
    const fields = {
        users: [],
        labels: [],
        versions: [],
        stringFields: [],
        adfFields: [],
        multipleSelectFields: [],
        singleGroupPickerFields: [],
        multipleGroupPickerFields: [],
        multipleSelectUserPickerFields: []
    };
    Object.entries(formInputData).forEach(([key, value])=>{
        if (value === undefined || value === null) return;
        const fieldData = formFieldsById[key];
        if (!fieldData) return;
        const { type: type, renderer: renderer } = fieldData;
        const fieldConfig = (0, $fOgCm.getFieldTypeConfig)(type, projectType);
        if (!fieldConfig) {
            if ((0, $4R6GH.fg)('jira-forms-public-access')) (0, $jcw0u.default)({
                meta: {
                    id: 'transformFormSubmissionResult',
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    message: `"${type}" was unexpectedly missing in form config in ${formWithFieldData.accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC ? 'public form' : 'form'} submission`
                },
                sendToPrivacyUnsafeSplunk: true
            });
            else (0, $jcw0u.default)({
                meta: {
                    id: 'transformFormSubmissionResult',
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    message: `"${type}" was unexpectedly missing in form config in form submission`
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        fieldConfig.writer(key, value, fields, renderer);
    });
    if (formWithFieldData.accessLevel === (0, $7wwVP.FormAccessLevelTypes).PUBLIC && (0, $4R6GH.fg)('jira-forms-public-access')) return fields;
    // If a label doesn't exist, add it.
    const labelsField = fields.labels.find((f)=>f.fieldId === 'labels');
    const formLabelPrefix = (0, $4R6GH.fg)('jsw_forms_rollout') ? (0, $fOgCm.getFormLabelPrefix)(projectType) : (0, $fOgCm.FORM_LABEL);
    const uniqueFormLabel = (0, $fOgCm.getUniqueFormLabel)(formLabelPrefix, formWithFieldData.formId);
    // NOTE: We don't want this check to fire exposure - that should happen in the form directory view
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm_business_forms_issue_view');
    if (labelsField) {
        if (!labelsField.values.values.includes(formLabelPrefix)) labelsField.values.values.push(formLabelPrefix);
        if (expConfig.get('isFormsIssueViewEnabled', false)) {
            if (!labelsField.values.values.includes(uniqueFormLabel)) labelsField.values.values.push(uniqueFormLabel);
        }
    } else {
        const labelsToAdd = [
            formLabelPrefix
        ];
        if (expConfig.get('isFormsIssueViewEnabled', false)) labelsToAdd.push(uniqueFormLabel);
        fields.labels.push((0, $kShoa.toLabelsField)('labels', labelsToAdd));
    }
    return fields;
};
const $aa4cd5c41c12e7b8$export$d7c77df21c828876 = (err, formWithFieldData)=>{
    const fieldWithError = formWithFieldData?.fields?.find((field)=>field.fieldId === err?.extensions?.fieldId);
    const errorMessage = fieldWithError?.alias ? err?.message.replace(fieldWithError.name, fieldWithError.alias) : err?.message;
    return errorMessage;
};

});


parcelRegister("9mCh4", function(module, exports) {

$parcel$export(module.exports, "JiraCreateIssueByPublicFormRecaptchaType", () => $84afd23deac985a4$export$5264ab23b966ccae);
var $84afd23deac985a4$export$5264ab23b966ccae = /*#__PURE__*/ function(JiraCreateIssueByPublicFormRecaptchaType) {
    JiraCreateIssueByPublicFormRecaptchaType["V2_CHECKBOX"] = "V2_CHECKBOX";
    JiraCreateIssueByPublicFormRecaptchaType["V3_SCORE"] = "V3_SCORE";
    return JiraCreateIssueByPublicFormRecaptchaType;
}({});

});

parcelRegister("c4qDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $70398421e931218a$export$2e2bcd8739ae039);

var $9fDOt = parcelRequire("9fDOt");
const $70398421e931218a$var$Condition = ({ condition: condition, children: children })=>{
    const isValid = (0, $9fDOt.useConditionValidator)(condition);
    return isValid ? children : null;
};
var $70398421e931218a$export$2e2bcd8739ae039 = $70398421e931218a$var$Condition;

});
parcelRegister("9fDOt", function(module, exports) {

$parcel$export(module.exports, "useConditionValidator", () => $8cb5eb768c39cd03$export$17591b2856d3d1a3);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $homE5 = parcelRequire("homE5");

var $3SFJ0 = parcelRequire("3SFJ0");
const $8cb5eb768c39cd03$export$be08e95e749ed486 = (condition)=>{
    if (condition.__typename === 'JiraFormSelectCondition') return (0, $3SFJ0.makeSelectConditionValidator)(condition);
    return null;
};
const $8cb5eb768c39cd03$export$17591b2856d3d1a3 = (condition)=>{
    const formState = (0, $bUa6y.useFormState)({
        values: true
    });
    const validator = (0, $5uXOq.useMemo)(()=>$8cb5eb768c39cd03$export$be08e95e749ed486(condition), [
        condition
    ]);
    if (!validator || !formState?.values || (0, $homE5.isConditionEmpty)(condition)) return true;
    const fieldValue = formState.values[condition.parentField.fieldId];
    // User has not input anything yet
    if (fieldValue === undefined) return false;
    return validator(fieldValue);
};

});
parcelRegister("homE5", function(module, exports) {

$parcel$export(module.exports, "isConditionEmpty", () => $34bc0c87da3a6fce$export$a864e35e15f2d639);
/* eslint-disable camelcase */ const $34bc0c87da3a6fce$export$a864e35e15f2d639 = (condition)=>{
    if (condition.__typename === 'JiraFormSelectCondition') return !condition.fieldOptionIds?.length;
    return true;
};

});

parcelRegister("3SFJ0", function(module, exports) {

$parcel$export(module.exports, "makeSelectConditionValidator", () => $e775093f07257699$export$8c83f6839a9dfd3);
const $e775093f07257699$export$26db3529e2ea773b = (possibleSelectOption)=>{
    return 'value' in possibleSelectOption && (typeof possibleSelectOption.value === 'undefined' || typeof possibleSelectOption.value === 'string');
};
const $e775093f07257699$export$4be42473522c84f6 = (possibleSelectOptionArray)=>{
    if (!Array.isArray(possibleSelectOptionArray)) return false;
    // Confirm that each of the selected values conforms to the expected shape
    if (possibleSelectOptionArray.length) return possibleSelectOptionArray.every($e775093f07257699$export$26db3529e2ea773b);
    // When empty we assume the array is valid until proven otherwise
    return true;
};
const $e775093f07257699$export$8c83f6839a9dfd3 = (condition)=>{
    const { fieldOptionIds: fieldOptionIds, operator: operator } = condition;
    return (fieldValue)=>{
        if (!fieldOptionIds?.length) return true;
        // Value will be null when user clears
        // the input of a single-select field
        if (fieldValue === null) return false;
        if ($e775093f07257699$export$26db3529e2ea773b(fieldValue)) return fieldOptionIds.includes(fieldValue.value);
        if ($e775093f07257699$export$4be42473522c84f6(fieldValue)) return operator === 'ALL' ? fieldOptionIds.every((id)=>fieldValue.find(({ value: value })=>value === id)) : fieldOptionIds.some((id)=>fieldValue.find(({ value: value })=>value === id));
        // Default to true if the shape of the given
        // field value is non-conforming
        return true;
    };
};

});



parcelRegister("icFsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40c930e967a388f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f40c930e967a388f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submissionErrorFlag: {
        "id": "business-form.form-submission.fill-in-view.submission-error-flag",
        "defaultMessage": "Something's gone wrong"
    },
    submissionAttachmentErrorContent: {
        "id": "business-form.form-submission.fill-in-view.submission-attachment-error-content",
        "defaultMessage": "Attachment upload failed. Make sure the file format and size are correct, and check your internet connection before trying again."
    }
});

});

parcelRegister("6Ti3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $59de8f2d041a296c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $bUa6y = parcelRequire("bUa6y");

var $fraBZ = parcelRequire("fraBZ");

var $koVbs = parcelRequire("koVbs");

var $ea1JH = parcelRequire("ea1JH");
const $59de8f2d041a296c$var$useMessageCreator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((prevValues, newValues)=>{
        if (!prevValues || !newValues) return '';
        // Then number of keys in form values is a proxy for number of
        // fields on the form
        const fieldCountDiff = Object.keys(prevValues).length - Object.keys(newValues).length;
        if (fieldCountDiff === 0) return '';
        return fieldCountDiff < 0 ? formatMessage((0, $ea1JH.default).fieldsAdded, {
            fieldCount: Math.abs(fieldCountDiff)
        }) : formatMessage((0, $ea1JH.default).fieldsRemoved, {
            fieldCount: Math.abs(fieldCountDiff)
        });
    }, [
        formatMessage
    ]);
};
/**
 * Creates screenreader announcements to notify users
 * when fields are added or removed from a form. This
 * occurs as field values change and conditions are met
 * or unmet.
 */ const $59de8f2d041a296c$var$ScreenreaderAnnouncer = ()=>{
    const formState = (0, $bUa6y.useFormState)({
        values: true
    });
    const prevValues = (0, $5uXOq.useRef)();
    const [message, setMessage] = (0, $5uXOq.useState)('');
    const getMessage = $59de8f2d041a296c$var$useMessageCreator();
    /**
   * When multiple fields are added or removed from a form after
   * a single form update, multiple state updates might be triggered
   * via useFormState. In order to capture all of these updates as
   * unified message, we need to debounce the update of the message.
   *
   * Without this, for example, instead of:
   * 	Updated message: "4 fields have been removed below"
   * We might end up with:
   * 	Updated message 1: "2 fields have been removed below"
   *  Updated message 2: "2 fields have been removed below"
   */ const debouncedUpdateMessage = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newValues)=>{
            const newMessage = getMessage(prevValues.current, newValues);
            prevValues.current = newValues;
            setMessage(newMessage);
        }, 200), [
        getMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        debouncedUpdateMessage(formState?.values);
    }, [
        debouncedUpdateMessage,
        formState?.values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: message
    });
};
var $59de8f2d041a296c$export$2e2bcd8739ae039 = $59de8f2d041a296c$var$ScreenreaderAnnouncer;

});
parcelRegister("ea1JH", function(module, exports) {

$parcel$export(module.exports, "default", () => $38c1ce986f69f095$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $38c1ce986f69f095$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldsRemoved: {
        "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-removed",
        "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been removed below}\n\t\t\tother {# form fields have been removed below}\n\t\t}"
    },
    fieldsAdded: {
        "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-added",
        "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been added below}\n\t\t\tother {# form fields have been added below}\n\t\t}"
    }
});

});


parcelRegister("jfugj", function(module, exports) {

$parcel$export(module.exports, "generateFieldAnalytics", () => $f80bb0d21b4f5357$export$9c1a0599c1937c10);
$parcel$export(module.exports, "useIntersectionObserver", () => $f80bb0d21b4f5357$export$a7395f9832c00176);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");
const $f80bb0d21b4f5357$export$9c1a0599c1937c10 = (fields)=>{
    const fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(fields.map((field)=>field.type.replace('com.atlassian.jira.plugin.system.customfieldtypes:', '')));
    const customFieldCount = fields.filter((field)=>field.fieldId.startsWith('customfield_')).length;
    const fieldCount = fields.length;
    return {
        fieldIds: fieldIds,
        customFieldCount: customFieldCount,
        fieldCount: fieldCount
    };
};
const $f80bb0d21b4f5357$export$a7395f9832c00176 = (onIntersection)=>{
    const [ref, setRef] = (0, $5uXOq.useState)(null);
    const handleObserver = (0, $5uXOq.useCallback)((entries)=>{
        entries.forEach(({ isIntersecting: isIntersecting })=>{
            if (isIntersecting) onIntersection();
        });
    }, [
        onIntersection
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref || typeof window === 'undefined' || typeof window !== 'undefined' && !window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver(handleObserver, {
            root: null,
            rootMargin: '20px',
            threshold: 0
        });
        if (ref) observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        onIntersection,
        handleObserver
    ]);
    return setRef;
};

});

parcelRegister("eMB94", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $2243729328d8a152$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $8jRgk = parcelRequire("8jRgk");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $cSD7y = parcelRequire("cSD7y");

var $luvaQ = parcelRequire("luvaQ");

var $aB7Ox = parcelRequire("aB7Ox");

var $ir6EK = parcelRequire("ir6EK");

var $633YG = parcelRequire("633YG");
const $2243729328d8a152$var$FormFooterOld = (props)=>{
    const { createIssueLoading: createIssueLoading, uploading: uploading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        testId: "business-form.ui.form-submission.fill-in-view.footer.loading-button",
        type: "submit",
        appearance: "primary",
        isLoading: createIssueLoading || uploading,
        interactionName: "business-form-submission-submit"
    }, formatMessage((0, $633YG.default).submitButton)));
};
const $2243729328d8a152$var$FormFooterNew = (props)=>{
    const { isPublicForm: isPublicForm, createIssueLoading: createIssueLoading, uploading: uploading, onRecaptchaChange: onRecaptchaChange, shouldShowCheckboxRecaptcha: shouldShowCheckboxRecaptcha, onCheckboxRecaptchaVerify: onCheckboxRecaptchaVerify, onCheckboxRecaptchaExpire: onCheckboxRecaptchaExpire, checkboxRecaptchaNotVerified: checkboxRecaptchaNotVerified } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, isPublicForm && shouldShowCheckboxRecaptcha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2243729328d8a152$var$recaptchaCheckboxStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aB7Ox.PublicFormCheckboxRecaptcha), {
        onCheckboxRecaptchaVerify: onCheckboxRecaptchaVerify,
        onCheckboxRecaptchaExpire: onCheckboxRecaptchaExpire,
        hasVerificationError: checkboxRecaptchaNotVerified
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2243729328d8a152$var$submitButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        testId: "business-form.ui.form-submission.fill-in-view.footer.loading-button",
        type: "submit",
        appearance: "primary",
        isLoading: createIssueLoading || uploading,
        interactionName: "business-form-submission-submit"
    }, formatMessage((0, $633YG.default).submitButton))), isPublicForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aB7Ox.PublicFormRecaptcha), {
        onChange: onRecaptchaChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luvaQ.PublicFormPrivacyPolicyFooter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir6EK.PublicFormAntiAbuseFooter), null)));
};
const $2243729328d8a152$export$a06f1c675e846f6f = (0, $cSD7y.componentWithFG)('jira-forms-public-access', $2243729328d8a152$var$FormFooterNew, $2243729328d8a152$var$FormFooterOld);
const $2243729328d8a152$var$submitButtonStyle = (0, $8CUq3.xcss)({
    alignSelf: 'flex-end',
    marginTop: 'space.200'
});
const $2243729328d8a152$var$recaptchaCheckboxStyle = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("luvaQ", function(module, exports) {

$parcel$export(module.exports, "PublicFormPrivacyPolicyFooter", () => $1ac8c170d5dd5661$export$a53ab96977f40285);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $41j30 = parcelRequire("41j30");

var $koVbs = parcelRequire("koVbs");

var $7UxRb = parcelRequire("7UxRb");
const $1ac8c170d5dd5661$var$LinkToSubmitFormCustomerAgreement = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": props.description
    }, props.children);
const $1ac8c170d5dd5661$var$LinkToSubmitFormPrivacyPolicy = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": props.description
    }, props.children);
const $1ac8c170d5dd5661$export$a53ab96977f40285 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerContent = formatMessage((0, $7UxRb.default).publicFormPrivacyFooter, {
        a: (customerAgreement)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ac8c170d5dd5661$var$LinkToSubmitFormCustomerAgreement, {
                description: formatMessage((0, $7UxRb.default).anchorArialLabel)
            }, customerAgreement),
        b: (privacyPolicy)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ac8c170d5dd5661$var$LinkToSubmitFormPrivacyPolicy, {
                description: formatMessage((0, $7UxRb.default).anchorArialLabel)
            }, privacyPolicy)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1ac8c170d5dd5661$var$privacyPolicyFooterStyle,
        "data-testId": "business-form.ui.form-submission.fill-in-view.public-form-privacy-policy-footer"
    }, footerContent);
};
const $1ac8c170d5dd5661$var$privacyPolicyFooterStyle = (0, $8CUq3.xcss)({
    width: '100%',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    flex: 1
});

});
parcelRegister("7UxRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a0dd21f5055864$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97a0dd21f5055864$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publicFormPrivacyFooter: {
        "id": "business-form.form-submission.fill-in-view.public-form-privacy-footer",
        "defaultMessage": "By submitting, you agree that your use is governed by the <a>Atlassian Customer Agreement</a> and acknowledge the Atlassian <b>Privacy Policy</b>."
    },
    anchorArialLabel: {
        "id": "business-form.form-submission.fill-in-view.public-form-privacy-footer.anchor-arial-label",
        "defaultMessage": "Atlassian Submit Form Privacy Policy"
    }
});

});


parcelRegister("aB7Ox", function(module, exports) {

$parcel$export(module.exports, "PublicFormRecaptcha", () => $a910079433ce6f07$export$54d18512d6194d87);
$parcel$export(module.exports, "PublicFormCheckboxRecaptcha", () => $a910079433ce6f07$export$bdb625cf9453f268);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $qfj8c = parcelRequire("qfj8c");

var $92Z2l = parcelRequire("92Z2l");

var $bRP7i = parcelRequire("bRP7i");
var $3luXJ = parcelRequire("3luXJ");

var $cXoTB = parcelRequire("cXoTB");

var $2tT7R = parcelRequire("2tT7R");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8t9fW = parcelRequire("8t9fW");

const $a910079433ce6f07$export$54d18512d6194d87 = ({ onChange: onChange })=>{
    const environment = (0, $2tT7R.useEnvironment)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason, isRecaptchaLoaded: isRecaptchaLoaded } = (0, $3luXJ.useInvisibleRecaptcha)({
        siteKey: environment === 'prod' ? (0, $4f7fc0dac40bc5dd$export$efa2d175feb8e7f6) : (0, $4f7fc0dac40bc5dd$export$44cfca04df4dff23),
        displayBadge: false,
        analyticsChannel: 'jira',
        analyticsSource: (0, $4f7fc0dac40bc5dd$export$f49097b0e4b6fc5d)
    });
    (0, $5uXOq.useEffect)(()=>{
        // the google recaptcha package fails to load
        if (!isRecaptchaLoaded && recaptchaLoadErrorReason) {
            showFlag({
                messageId: 'business-form.ui.form-submission.fill-in-view.public-form-recaptcha.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: (0, $8t9fW.default).recaptchaErrorFlagTitle,
                description: (0, $8t9fW.default).recaptchaErrorFlagContent,
                isAutoDismiss: true
            });
            onChange({
                loadStatus: 'fail',
                getToken: null
            });
        }
        // the google recaptcha package loads successfully
        if (isRecaptchaLoaded && !recaptchaLoadErrorReason) onChange({
            loadStatus: 'success',
            getToken: ()=>getRecaptchaToken((0, $4f7fc0dac40bc5dd$export$dc3f4dd7ef0bfa32)).catch(()=>{
                    // recaptcha token fails to generate
                    showFlag({
                        messageId: 'business-form.ui.form-submission.fill-in-view.public-form-recaptcha.show-flag.error.1',
                        messageType: 'transactional',
                        type: 'error',
                        title: (0, $8t9fW.default).recaptchaErrorFlagTitle,
                        description: (0, $8t9fW.default).recaptchaErrorFlagContent,
                        isAutoDismiss: true
                    });
                })
        });
    }, [
        onChange,
        isRecaptchaLoaded,
        getRecaptchaToken,
        recaptchaLoadErrorReason,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a910079433ce6f07$var$recaptchaFooterStyles,
        testId: "business-form.ui.form-submission.fill-in-view.public-form-recaptcha.public-form-recaptcha"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRP7i.default), null));
};
const $a910079433ce6f07$export$bdb625cf9453f268 = ({ onCheckboxRecaptchaVerify: onCheckboxRecaptchaVerify, onCheckboxRecaptchaExpire: onCheckboxRecaptchaExpire, hasVerificationError: hasVerificationError })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const callbacks = (0, $5uXOq.useMemo)(()=>({
            onVerify: onCheckboxRecaptchaVerify,
            onLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onError: ()=>showFlag({
                    messageId: 'business-form.ui.form-submission.fill-in-view.public-form-recaptcha.show-flag.error.2',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $8t9fW.default).recaptchaCheckboxErrorFlagTitle,
                    description: (0, $8t9fW.default).recaptchaCheckboxErrorFlagContent,
                    isAutoDismiss: true
                }),
            onExpire: onCheckboxRecaptchaExpire,
            onRender: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onScriptError: ()=>showFlag({
                    messageId: 'business-form.ui.form-submission.fill-in-view.public-form-recaptcha.show-flag.error.3',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $8t9fW.default).recaptchaCheckboxErrorFlagTitle,
                    description: (0, $8t9fW.default).recaptchaCheckboxErrorFlagContent,
                    isAutoDismiss: true
                })
        }), [
        onCheckboxRecaptchaVerify,
        onCheckboxRecaptchaExpire,
        showFlag
    ]);
    const { recaptchaComponent: recaptchaComponent } = (0, $cXoTB.default)({
        sitekey: environment === 'prod' ? (0, $4f7fc0dac40bc5dd$export$147a814f0beec57e) : (0, $4f7fc0dac40bc5dd$export$8305a8d25bb8db43)
    }, callbacks);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, formatMessage((0, $8t9fW.default).checkboxRecaptchaSectionMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $a910079433ce6f07$var$recaptchaCheckboxStyle,
            hasVerificationError && $a910079433ce6f07$var$recaptchaCheckboxErrorStyle
        ],
        testId: "business-form.ui.form-submission.fill-in-view.public-form-recaptcha.public-form-checkbox-recaptcha"
    }, recaptchaComponent), hasVerificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $8t9fW.default).checkboxRecaptchaHasVerificationErrorMessage)));
};
const $a910079433ce6f07$var$recaptchaCheckboxStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignSelf: 'flex-start'
});
const $a910079433ce6f07$var$recaptchaCheckboxErrorStyle = (0, $8CUq3.xcss)({
    borderColor: 'color.border.danger',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'border.radius.100'
});
const $a910079433ce6f07$var$recaptchaFooterStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("bRP7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $730521d2a941a4bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $e4yMr = parcelRequire("e4yMr");

var $gGlbH = parcelRequire("gGlbH");

var $bJNOA = parcelRequire("bJNOA");
const $730521d2a941a4bd$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gGlbH.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bJNOA.default).termsAndPolicy,
            tagName: tagName,
            values: {
                privacyPolicy: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bJNOA.default).privacyPolicy
                    })
                }),
                termsOfService: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bJNOA.default).termsOfService
                    })
                })
            }
        })
    });
var $730521d2a941a4bd$export$2e2bcd8739ae039 = $730521d2a941a4bd$var$RecaptchaTermsAndPolicy;

});
parcelRegister("gGlbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4048fb6427e6a3bc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $24KH4 = parcelRequire("24KH4");
const $4048fb6427e6a3bc$var$IntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const { messages: messages } = (0, $24KH4.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        messages: messages,
        locale: locale,
        children: children
    }, locale);
};
var $4048fb6427e6a3bc$export$2e2bcd8739ae039 = $4048fb6427e6a3bc$var$IntlProvider;

});
parcelRegister("24KH4", function(module, exports) {

$parcel$export(module.exports, "useFetchMessagesByLocale", () => $ccf6d059612ab0c7$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $5uXOq = parcelRequire("5uXOq");

























function $ccf6d059612ab0c7$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("3p0kl"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("aY5zs"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("dXtyw"));
        case 'en-GB':
            return (parcelRequire("g73FE"));
        case 'en-US':
        case 'en':
            return (parcelRequire("1263X"));
        case 'en-ZZ':
            return (parcelRequire("2RmHv"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("ln28i"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("39Eg3"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("jNuJU"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("bwTxU"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("7lgkV"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("kwglO"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("h4v96"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("dyX5j"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("lUOhS"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("bOK6p"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("1M95r"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("30uHe"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("jW13l"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("b8qkb"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("eYaUv"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("591FK"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("65JDF"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("5nNxI"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("lAkT8"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $ccf6d059612ab0c7$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $5uXOq.useState)({});
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                const module = await $ccf6d059612ab0c7$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages
    };
}

});
parcelRegister("3p0kl", function(module, exports) {

let $27a3f5d8051145a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27a3f5d8051145a9$var$load("cRvrW").then(()=>parcelRequire('fjLck'));

});

parcelRegister("aY5zs", function(module, exports) {

let $7fc3d441b3bfbee2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7fc3d441b3bfbee2$var$load("6mTOp").then(()=>parcelRequire('9ymKp'));

});

parcelRegister("dXtyw", function(module, exports) {

let $a297b638d0aa5a0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a297b638d0aa5a0d$var$load("5iUgO").then(()=>parcelRequire('eL5Or'));

});

parcelRegister("g73FE", function(module, exports) {

let $bbb025b8f62426f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bbb025b8f62426f9$var$load("8OkIZ").then(()=>parcelRequire('1Sv3T'));

});

parcelRegister("1263X", function(module, exports) {

let $0c0aae4cd399d9a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c0aae4cd399d9a6$var$load("bZGVM").then(()=>parcelRequire('htGCb'));

});

parcelRegister("2RmHv", function(module, exports) {

let $215223e51066fd76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $215223e51066fd76$var$load("dBH64").then(()=>parcelRequire('aUZ4r'));

});

parcelRegister("ln28i", function(module, exports) {

let $f8ed667728e52c36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8ed667728e52c36$var$load("iDY17").then(()=>parcelRequire('cKEZ7'));

});

parcelRegister("39Eg3", function(module, exports) {

let $24c170bd20f54ad2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $24c170bd20f54ad2$var$load("dvhGZ").then(()=>parcelRequire('CVhck'));

});

parcelRegister("jNuJU", function(module, exports) {

let $e69a701ff231acfe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e69a701ff231acfe$var$load("lpMXH").then(()=>parcelRequire('29mfh'));

});

parcelRegister("bwTxU", function(module, exports) {

let $864dc51c2f514b0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $864dc51c2f514b0d$var$load("hZfZJ").then(()=>parcelRequire('5bpoy'));

});

parcelRegister("7lgkV", function(module, exports) {

let $55872aad440ddb2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55872aad440ddb2f$var$load("4NXIw").then(()=>parcelRequire('hTLmg'));

});

parcelRegister("kwglO", function(module, exports) {

let $ef037abda9d99199$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef037abda9d99199$var$load("dodQ9").then(()=>parcelRequire('jK0tf'));

});

parcelRegister("h4v96", function(module, exports) {

let $c6daf8511771909a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c6daf8511771909a$var$load("b6B6F").then(()=>parcelRequire('2FRRj'));

});

parcelRegister("dyX5j", function(module, exports) {

let $9dfc4852fed10d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9dfc4852fed10d60$var$load("a9YcI").then(()=>parcelRequire('1f61U'));

});

parcelRegister("lUOhS", function(module, exports) {

let $ff45d5eecb4fa514$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff45d5eecb4fa514$var$load("bKixw").then(()=>parcelRequire('6g2r3'));

});

parcelRegister("bOK6p", function(module, exports) {

let $89a82030a729e657$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89a82030a729e657$var$load("lT9FT").then(()=>parcelRequire('cqCj3'));

});

parcelRegister("1M95r", function(module, exports) {

let $14b15292a2ef591a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14b15292a2ef591a$var$load("WLxru").then(()=>parcelRequire('l3IeQ'));

});

parcelRegister("30uHe", function(module, exports) {

let $23092ed8b03875a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23092ed8b03875a2$var$load("7VyVS").then(()=>parcelRequire('4nuwM'));

});

parcelRegister("jW13l", function(module, exports) {

let $e83440300bb10fcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e83440300bb10fcf$var$load("7oEYd").then(()=>parcelRequire('7V4xb'));

});

parcelRegister("b8qkb", function(module, exports) {

let $81b4dc954e56d789$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81b4dc954e56d789$var$load("8itsJ").then(()=>parcelRequire('LnaRi'));

});

parcelRegister("eYaUv", function(module, exports) {

let $ae5f21dce14be7be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae5f21dce14be7be$var$load("1D7d8").then(()=>parcelRequire('6V7VR'));

});

parcelRegister("591FK", function(module, exports) {

let $3bef171558ae7c2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3bef171558ae7c2c$var$load("lOBIc").then(()=>parcelRequire('dfsSU'));

});

parcelRegister("65JDF", function(module, exports) {

let $46f69ca46907f6d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $46f69ca46907f6d0$var$load("lOkkf").then(()=>parcelRequire('2AT3N'));

});

parcelRegister("5nNxI", function(module, exports) {

let $3eb587ea41c68e4d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3eb587ea41c68e4d$var$load("7RJNA").then(()=>parcelRequire('hPWmW'));

});

parcelRegister("lAkT8", function(module, exports) {

let $fb6d29c2c70e5b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb6d29c2c70e5b8b$var$load("hzxqv").then(()=>parcelRequire('3dWFS'));

});



parcelRegister("bJNOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $793295bcb5663181$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $793295bcb5663181$var$messages = (0, $7VHMR.defineMessages)({
    termsAndPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.text',
        description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
        defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
    },
    privacyPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
        description: 'Privacy Policy link text',
        defaultMessage: 'Privacy Policy'
    },
    termsOfService: {
        id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
        description: 'Terms of Service link text',
        defaultMessage: 'Terms of Service'
    }
});
var $793295bcb5663181$export$2e2bcd8739ae039 = $793295bcb5663181$var$messages;

});


parcelRegister("3luXJ", function(module, exports) {

$parcel$export(module.exports, "useInvisibleRecaptcha", () => $76fe270fae3c03bc$export$9a22eec761fce66);

var $5uXOq = parcelRequire("5uXOq");

var $jnYKE = parcelRequire("jnYKE");

var $2OPI3 = parcelRequire("2OPI3");
const $76fe270fae3c03bc$export$9a22eec761fce66 = ({ siteKey: siteKey, displayBadge: displayBadge = true, analyticsChannel: analyticsChannel, analyticsSource: analyticsSource })=>{
    const triggerEvent = (0, $jnYKE.useAnalytics)(analyticsChannel, analyticsSource);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = (0, $5uXOq.useState)(false);
    const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const initRecaptcha = async ()=>{
            try {
                await (0, $2OPI3.loadRecaptcha)(siteKey);
                if (!displayBadge) (0, $2OPI3.hideRecaptchaBadge)(siteKey);
                triggerEvent((0, $jnYKE.recaptchaLoaded));
                if (isMounted) {
                    setIsRecaptchaLoaded(true);
                    setRecaptchaLoadErrorReason(undefined);
                }
            } catch (err) {
                const errorMessage = String(err);
                triggerEvent((0, $jnYKE.recaptchaLoadFailed), errorMessage);
                if (isMounted) setRecaptchaLoadErrorReason(errorMessage);
            }
        };
        initRecaptcha();
        return ()=>{
            (0, $2OPI3.unloadRecaptcha)(siteKey);
            setRecaptchaLoadErrorReason(undefined);
            isMounted = false;
        };
    }, [
        displayBadge,
        siteKey,
        triggerEvent
    ]);
    const getRecaptchaToken = (0, $5uXOq.useCallback)(async (action)=>{
        try {
            if (!isRecaptchaLoaded || !window?.grecaptcha?.enterprise?.execute) throw new (0, $2OPI3.RecaptchaError)('Execute function not ready');
            return await window.grecaptcha.enterprise.execute(siteKey, {
                action: action
            });
        } catch (err) {
            triggerEvent((0, $jnYKE.recaptchaExecuteFailed), String(err));
            throw err;
        }
    }, [
        isRecaptchaLoaded,
        siteKey,
        triggerEvent
    ]);
    return {
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken,
        recaptchaLoadErrorReason: recaptchaLoadErrorReason
    };
};

});
parcelRegister("jnYKE", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $087683ecb2ff8f16$export$e955abb82869dc84);
$parcel$export(module.exports, "recaptchaLoaded", () => $087683ecb2ff8f16$export$b97b16bc7fe47920);
$parcel$export(module.exports, "recaptchaLoadFailed", () => $087683ecb2ff8f16$export$3a46331396e3fda);
$parcel$export(module.exports, "recaptchaExecuteFailed", () => $087683ecb2ff8f16$export$ea782407790eb26c);

var $5uXOq = parcelRequire("5uXOq");


var $gB4mS = parcelRequire("gB4mS");
var $2NMNM = parcelRequire("2NMNM");
const $087683ecb2ff8f16$var$ACTION_SUBJECT = 'recaptcha';
const $087683ecb2ff8f16$export$e955abb82869dc84 = (channel, source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const triggerEvent = (0, $5uXOq.useCallback)((eventFactory, ...args)=>{
        const analyticsEvent = {
            source: source,
            ...eventFactory(...args)
        };
        (0, $gB4mS.default)(channel)(analyticsEvent)(createAnalyticsEvent);
    }, [
        source,
        channel,
        createAnalyticsEvent
    ]);
    return triggerEvent;
};
const $087683ecb2ff8f16$export$b97b16bc7fe47920 = ()=>({
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        actionSubject: $087683ecb2ff8f16$var$ACTION_SUBJECT,
        action: 'loaded'
    });
const $087683ecb2ff8f16$export$3a46331396e3fda = (errorMessage)=>({
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        actionSubject: $087683ecb2ff8f16$var$ACTION_SUBJECT,
        actionSubjectId: 'load',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
const $087683ecb2ff8f16$export$ea782407790eb26c = (errorMessage)=>({
        eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
        actionSubject: $087683ecb2ff8f16$var$ACTION_SUBJECT,
        actionSubjectId: 'execute',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });

});

parcelRegister("2OPI3", function(module, exports) {

$parcel$export(module.exports, "loadRecaptcha", () => $676f7357fd64d949$export$29933d84054794ee);
$parcel$export(module.exports, "unloadRecaptcha", () => $676f7357fd64d949$export$cfad80fecff3cb16);
$parcel$export(module.exports, "hideRecaptchaBadge", () => $676f7357fd64d949$export$924e44702e93d253);
$parcel$export(module.exports, "RecaptchaError", () => $676f7357fd64d949$export$e037dc82f45cc746);
const $676f7357fd64d949$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
const $676f7357fd64d949$export$b8e8ecca99719d00 = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const $676f7357fd64d949$var$RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
const $676f7357fd64d949$export$29933d84054794ee = (siteKey)=>new Promise((resolve, reject)=>{
        if ($676f7357fd64d949$var$isRecaptchaLoaded(siteKey)) {
            resolve();
            return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.src = `${$676f7357fd64d949$export$b8e8ecca99719d00}?render=${siteKey}`;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.id = siteKey;
        scriptElement.onload = ()=>{
            if (!window?.grecaptcha?.enterprise) reject($676f7357fd64d949$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
            else window.grecaptcha.enterprise.ready(resolve);
        };
        scriptElement.onerror = (error)=>{
            reject(typeof error === 'string' ? error : error.message ?? $676f7357fd64d949$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
        };
        document.body.appendChild(scriptElement);
    });
const $676f7357fd64d949$var$isRecaptchaLoaded = (siteKey)=>Boolean(document.getElementById(siteKey));
const $676f7357fd64d949$export$cfad80fecff3cb16 = (siteKey)=>{
    $676f7357fd64d949$var$removeRecaptchaScriptElement(siteKey);
    $676f7357fd64d949$var$removeRecaptchaBadgeStyleElement(siteKey);
    $676f7357fd64d949$var$removeRecaptchaBadge();
};
const $676f7357fd64d949$export$924e44702e93d253 = (siteKey)=>{
    const id = `${siteKey}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = `${siteKey}-styles`;
    styleElement.innerText = `${$676f7357fd64d949$var$RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
    document.head.appendChild(styleElement);
};
const $676f7357fd64d949$var$removeRecaptchaScriptElement = (siteKey)=>{
    const scriptElement = document.getElementById(siteKey);
    if (scriptElement) scriptElement.remove();
};
const $676f7357fd64d949$var$removeRecaptchaBadgeStyleElement = (siteKey)=>{
    const styleElement = document.getElementById(`${siteKey}-styles`);
    if (styleElement) styleElement.remove();
};
const $676f7357fd64d949$var$removeRecaptchaBadge = ()=>{
    const badgeElements = document.querySelectorAll($676f7357fd64d949$var$RECAPTCHA_BADGE_SELECTOR);
    // @ts-ignore "TS2488: Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator." occurs within Jira due to missing DOM.Iterable. We've dropped IE support so we shouldn't need it.
    for (const el of badgeElements)el.remove();
};
class $676f7357fd64d949$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $676f7357fd64d949$export$e037dc82f45cc746.prototype);
    }
}

});


parcelRegister("cXoTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbb58b4054544c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $chkrn = parcelRequire("chkrn");
const $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_PATH = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
const $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_REGEX = /(http|https):\/\/(www)?.+\/recaptcha/;
const $3bbb58b4054544c2$var$useCheckboxRecaptcha = (config, callbacks)=>{
    const [instanceId, updateInstanceId] = (0, $5uXOq.useState)(null);
    const [token, updateToken] = (0, $5uXOq.useState)(null);
    const callbacksRef = (0, $5uXOq.useRef)(callbacks);
    const configRef = (0, $5uXOq.useRef)(config);
    const onVerifyWrapper = (0, $5uXOq.useCallback)((newToken)=>{
        updateToken(newToken);
        if (callbacksRef.current.onVerify) callbacksRef.current.onVerify(newToken);
    }, []);
    const callBackRef = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
    async (node)=>{
        if (!node || false) return;
        try {
            const sriptLoaded = await (0, $chkrn.injectScript)(`${$3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_PATH}`, $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_REGEX);
            if (sriptLoaded && callbacksRef.current.onLoad) callbacksRef.current.onLoad();
            const newInstanceId = (0, $chkrn.getRecaptchaMethods)().render(node, {
                callback: onVerifyWrapper,
                'expired-callback': callbacksRef.current.onExpire,
                'error-callback': callbacksRef.current.onError,
                ...configRef.current
            });
            updateInstanceId(newInstanceId);
            if (callbacksRef.current.onRender) callbacksRef.current.onRender();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (callbacksRef.current.onScriptError) callbacksRef.current.onScriptError(error instanceof Error ? error : undefined);
        }
    }, [
        onVerifyWrapper
    ]);
    const recaptchaComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: callBackRef
        }), [
        callBackRef
    ]);
    const reset = (0, $5uXOq.useCallback)(()=>{
        if (instanceId !== null) {
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number | undefined'.
            (0, $chkrn.getRecaptchaMethods)().reset(instanceId);
            updateToken(null);
        }
    }, [
        instanceId
    ]);
    const getResponse = (0, $5uXOq.useCallback)(()=>{
        if (instanceId !== null) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number | undefined'.
        return (0, $chkrn.getRecaptchaMethods)().getResponse(instanceId);
        return '';
    }, [
        instanceId
    ]);
    return {
        recaptchaComponent: recaptchaComponent,
        reset: reset,
        token: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | null'.
        token,
        getResponse: getResponse
    };
};
var $3bbb58b4054544c2$export$2e2bcd8739ae039 = $3bbb58b4054544c2$var$useCheckboxRecaptcha;

});
parcelRegister("chkrn", function(module, exports) {

$parcel$export(module.exports, "getRecaptchaMethods", () => $112d644f96003f09$export$3bfe7d4134a81119);
$parcel$export(module.exports, "injectScript", () => $112d644f96003f09$export$99edb48b31c60fa0);
const $112d644f96003f09$export$3bfe7d4134a81119 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    window.grecaptcha.enterprise;
const $112d644f96003f09$export$52a8d9f3967f8d4b = (regex)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.scripts).some((script)=>regex.test(script.src));
const $112d644f96003f09$export$99edb48b31c60fa0 = (scriptSrc, regexPattern)=>new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // if script is already added in html donot add again
        if ($112d644f96003f09$export$52a8d9f3967f8d4b(regexPattern)) {
            resolve(false);
            return;
        }
        // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = scriptSrc;
        script.addEventListener('load', ()=>{
            $112d644f96003f09$export$3bfe7d4134a81119().ready(()=>{
                resolve(true);
            });
        });
        // @ts-expect-error - TS2769 - No overload matches this call.
        script.addEventListener('error', (error)=>{
            reject(error);
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head.appendChild(script);
    });

});


parcelRegister("8t9fW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23b05dc7e17147c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d23b05dc7e17147c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recaptchaErrorFlagTitle: {
        "id": "business-form.form-submission.fill-in-view.recaptcha-error-flag-title",
        "defaultMessage": "reCAPTCHA token attempt failed"
    },
    recaptchaErrorFlagContent: {
        "id": "business-form.form-submission.fill-in-view.recaptcha-error-flag-content",
        "defaultMessage": "Please refresh page and try again"
    },
    recaptchaCheckboxErrorFlagTitle: {
        "id": "business-form.form-submission.fill-in-view.recaptcha-checkbox-error-flag-title",
        "defaultMessage": "reCAPTCHA checkbox failed to load"
    },
    recaptchaCheckboxErrorFlagContent: {
        "id": "business-form.form-submission.fill-in-view.recaptcha-checkbox-error-flag-content",
        "defaultMessage": "Please refresh page and try again"
    },
    checkboxRecaptchaSectionMessage: {
        "id": "business-form.form-submission.fill-in-view.checkbox-recaptcha.section-message",
        "defaultMessage": "We'd like to make sure it's really you submitting this. Confirm you're not a robot."
    },
    checkboxRecaptchaHasVerificationErrorMessage: {
        "id": "business-form.form-submission.fill-in-view.checkbox-recaptcha.section-message-not-verified-error",
        "defaultMessage": "Confirm you're not a robot."
    }
});

});

const $4f7fc0dac40bc5dd$export$efa2d175feb8e7f6 = '6Lf5ldQqAAAAAInwi53M6IH4uzy5kaz2PdCXCqvE';
const $4f7fc0dac40bc5dd$export$44cfca04df4dff23 = '6LcihdQqAAAAAK7LAvWhysMV6yXTUmyJ819CtflJ';
const $4f7fc0dac40bc5dd$export$f49097b0e4b6fc5d = 'publicFormRecaptchaLoad';
const $4f7fc0dac40bc5dd$export$dc3f4dd7ef0bfa32 = 'public_form_submission';
const $4f7fc0dac40bc5dd$export$147a814f0beec57e = '6LeD1gQrAAAAAKl6iGAFzVkxXc28FOg8WVVp6CtO';
const $4f7fc0dac40bc5dd$export$8305a8d25bb8db43 = '6Lek1QQrAAAAAGYUb426jBSJbsQLQT1eaXhiEFq7';


parcelRegister("ir6EK", function(module, exports) {

$parcel$export(module.exports, "PublicFormAntiAbuseFooter", () => $83ccc7c63253ff85$export$45409a3f7a40137);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1xFgp = parcelRequire("1xFgp");
const $83ccc7c63253ff85$var$MailToReporter = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "mailto:abuse@atlassian.com",
        target: "_blank"
    }, props.children);
const $83ccc7c63253ff85$export$45409a3f7a40137 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerContent = formatMessage((0, $1xFgp.default).content, {
        a: (mailTo)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83ccc7c63253ff85$var$MailToReporter, null, mailTo)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $83ccc7c63253ff85$var$antiAbuseFooterStyle,
        "data-testId": "business-form.ui.form-submission.fill-in-view.public-form-anti-abuse-footer"
    }, footerContent);
};
const $83ccc7c63253ff85$var$antiAbuseFooterStyle = (0, $8CUq3.xcss)({
    width: '100%',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    flex: 1
});

});
parcelRegister("1xFgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5f6aa68028f12e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5f6aa68028f12e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    content: {
        "id": "business-form.form-submission.fill-in-view.public-form-anti-abuse-footer.content",
        "defaultMessage": "This form was created inside Atlassian. Does this form look suspicious? <a>Report</a>"
    }
});

});


parcelRegister("633YG", function(module, exports) {

$parcel$export(module.exports, "default", () => $638b674d4ce84ae0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $638b674d4ce84ae0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submitButton: {
        "id": "business-form.form-submission.fill-in-view.submit-button",
        "defaultMessage": "Submit"
    }
});

});


parcelRegister("aWehJ", function(module, exports) {

$parcel$export(module.exports, "Fields", () => $7c9be63c39d72d85$export$833b3e5a19fb8939);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $l2N2a = parcelRequire("l2N2a");

var $7nQJF = parcelRequire("7nQJF");

var $g2iZ7 = parcelRequire("g2iZ7");

var $fOgCm = parcelRequire("fOgCm");

var $6dxIs = parcelRequire("6dxIs");

var $djHla = parcelRequire("djHla");

var $jpsyn = parcelRequire("jpsyn");

var $c4qDm = parcelRequire("c4qDm");
const $7c9be63c39d72d85$export$833b3e5a19fb8939 = ({ fields: fields, showEmailField: showEmailField, setUploading: setUploading, uploadPermissions: uploadPermissions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectData } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const { data: formSubmissionData, formId: formId } = (0, $g2iZ7.useFormSubmission)();
    const { formWithFieldData: formWithFieldData, fieldMetaData: fieldMetaData } = formSubmissionData ?? {};
    const { projectId: projectId, accessLevel: accessLevel, issueType: issueType } = formWithFieldData ?? {};
    const { uploadPermissions: uploadPermissionsOld } = (0, $6dxIs.useUploadPermissions)(true);
    const { mediaUploadPermissions: mediaUploadPermissions } = (0, $djHla.useMediaPermissions)();
    const renderedFields = fields.map((f)=>{
        // If the field no longer exists, do not render it.
        if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
        const fieldConfig = (0, $fOgCm.getFieldTypeConfig)(f.type, projectData?.type);
        if (!fieldConfig) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                type: f.type
            });
            return null;
        }
        const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues = [], defaultFieldValue: defaultFieldValue, schema: schema } = fieldMetaData[f.fieldId];
        /**
		 * autoCompleteUrls contains origin/host.
		 * In storybook, we want these to point to our proxy.
		 */ let completeUrl = autoCompleteUrl;
        if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
            const url = new URL(autoCompleteUrl);
            completeUrl = `${url.pathname}${url.search}`;
        }
        const isFieldRequired = f.isRequired || !!f.isRequiredByForm;
        const fieldDescription = f.description;
        const field = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(fieldConfig.Component, {
            key: f.fieldId,
            fieldName: typeof f.alias === 'string' && f.alias.length > 0 ? f.alias : f.name,
            fieldId: f.fieldId,
            isRequired: isFieldRequired,
            description: fieldDescription,
            autoCompleteUrl: completeUrl,
            allowedValues: allowedValues,
            mediaUploadContexts: {
                uploadContext: uploadPermissions && (0, $4R6GH.fg)('fix_attachments_for_description_on_forms') ? uploadPermissions : uploadPermissionsOld,
                attachmentUploadContext: mediaUploadPermissions
            },
            projectId: String(projectId),
            issueTypeId: issueType?.id,
            projectKey: projectData?.key,
            onInProgressChange: setUploading,
            defaultValue: defaultFieldValue,
            attachmentCustomUploadURL: (0, $jpsyn.getFormAttachmentUploadUrl)(formId),
            canUserViewProject: Boolean(projectData?.permissions?.viewIssues),
            schemaConfiguration: schema?.configuration,
            renderer: (0, $4R6GH.fg)('forms_multiline_text_wiki_renderer') ? f.renderer : undefined,
            accessLevel: accessLevel,
            isFieldResponsive: true
        });
        return f.parentCondition && (0, $4R6GH.fg)('jira_forms_conditional_field_logic_gate_') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4qDm.default), {
            key: `${f.parentCondition.id}:${f.fieldId}`,
            condition: f.parentCondition
        }, field) : field;
    });
    if (showEmailField) renderedFields.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nQJF.default), {
        key: "email",
        fieldId: "email",
        fieldName: "Email",
        isRequired: true
    }));
    return renderedFields;
};

});


parcelRegister("b8mPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d009e2d1a73fd0a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d009e2d1a73fd0a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageHeading: {
        "id": "business-form.form-submission.page-heading",
        "defaultMessage": "Form submission"
    }
});

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});




//# sourceMappingURL=async-software-form-submit-entrypoint.1ba7fa92.js.map
